var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// temp_stylePlugin:src/graphs/lineGraph.scss
var init_lineGraph = __esm({
  "temp_stylePlugin:src/graphs/lineGraph.scss"() {
  }
});

// stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/lineGraph.scss
var lineGraph_exports = {};
var init_lineGraph2 = __esm({
  "stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/lineGraph.scss"() {
    init_lineGraph();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js
function ascending(a4, b) {
  return a4 == null || b == null ? NaN : a4 < b ? -1 : a4 > b ? 1 : a4 >= b ? 0 : NaN;
}
var init_ascending = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js
function descending(a4, b) {
  return a4 == null || b == null ? NaN : b < a4 ? -1 : b > a4 ? 1 : b >= a4 ? 0 : NaN;
}
var init_descending = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js
function bisector(f2) {
  let compare1, compare2, delta;
  if (f2.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x4) => ascending(f2(d), x4);
    delta = (d, x4) => f2(d) - x4;
  } else {
    compare1 = f2 === ascending || f2 === descending ? f2 : zero;
    compare2 = f2;
    delta = f2;
  }
  function left2(a4, x4, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x4, x4) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x4) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right2(a4, x4, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x4, x4) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x4) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center2(a4, x4, lo = 0, hi = a4.length) {
    const i = left2(a4, x4, lo, hi - 1);
    return i > lo && delta(a4[i - 1], x4) > -delta(a4[i], x4) ? i - 1 : i;
  }
  return { left: left2, center: center2, right: right2 };
}
function zero() {
  return 0;
}
var init_bisector = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js"() {
    init_ascending();
    init_descending();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js
function number(x4) {
  return x4 === null ? NaN : +x4;
}
function* numbers(values, valueof) {
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
var init_number = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js
var ascendingBisect, bisectRight, bisectLeft, bisectCenter, bisect_default;
var init_bisect = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js"() {
    init_ascending();
    init_bisector();
    init_number();
    ascendingBisect = bisector(ascending);
    bisectRight = ascendingBisect.right;
    bisectLeft = ascendingBisect.left;
    bisectCenter = bisector(number).center;
    bisect_default = bisectRight;
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/blur.js
function blur(values, r) {
  if (!((r = +r) >= 0)) throw new RangeError("invalid r");
  let length3 = values.length;
  if (!((length3 = Math.floor(length3)) >= 0)) throw new RangeError("invalid length");
  if (!length3 || !r) return values;
  const blur3 = blurf(r);
  const temp = values.slice();
  blur3(values, temp, 0, length3, 1);
  blur3(temp, values, 0, length3, 1);
  blur3(values, temp, 0, length3, 1);
  return values;
}
function Blur2(blur3) {
  return function(data, rx, ry = rx) {
    if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
    if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
    let { data: values, width, height } = data;
    if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
    if (!((height = Math.floor(height !== void 0 ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
    if (!width || !height || !rx && !ry) return data;
    const blurx = rx && blur3(rx);
    const blury = ry && blur3(ry);
    const temp = values.slice();
    if (blurx && blury) {
      blurh(blurx, temp, values, width, height);
      blurh(blurx, values, temp, width, height);
      blurh(blurx, temp, values, width, height);
      blurv(blury, values, temp, width, height);
      blurv(blury, temp, values, width, height);
      blurv(blury, values, temp, width, height);
    } else if (blurx) {
      blurh(blurx, values, temp, width, height);
      blurh(blurx, temp, values, width, height);
      blurh(blurx, values, temp, width, height);
    } else if (blury) {
      blurv(blury, values, temp, width, height);
      blurv(blury, temp, values, width, height);
      blurv(blury, values, temp, width, height);
    }
    return data;
  };
}
function blurh(blur3, T, S, w, h) {
  for (let y4 = 0, n = w * h; y4 < n; ) {
    blur3(T, S, y4, y4 += w, 1);
  }
}
function blurv(blur3, T, S, w, h) {
  for (let x4 = 0, n = w * h; x4 < w; ++x4) {
    blur3(T, S, x4, x4 + n, w);
  }
}
function blurfImage(radius) {
  const blur3 = blurf(radius);
  return (T, S, start2, stop, step) => {
    start2 <<= 2, stop <<= 2, step <<= 2;
    blur3(T, S, start2 + 0, stop + 0, step);
    blur3(T, S, start2 + 1, stop + 1, step);
    blur3(T, S, start2 + 2, stop + 2, step);
    blur3(T, S, start2 + 3, stop + 3, step);
  };
}
function blurf(radius) {
  const radius0 = Math.floor(radius);
  if (radius0 === radius) return bluri(radius);
  const t = radius - radius0;
  const w = 2 * radius + 1;
  return (T, S, start2, stop, step) => {
    if (!((stop -= step) >= start2)) return;
    let sum4 = radius0 * S[start2];
    const s0 = step * radius0;
    const s1 = s0 + step;
    for (let i = start2, j = start2 + s0; i < j; i += step) {
      sum4 += S[Math.min(stop, i)];
    }
    for (let i = start2, j = stop; i <= j; i += step) {
      sum4 += S[Math.min(stop, i + s0)];
      T[i] = (sum4 + t * (S[Math.max(start2, i - s1)] + S[Math.min(stop, i + s1)])) / w;
      sum4 -= S[Math.max(start2, i - s0)];
    }
  };
}
function bluri(radius) {
  const w = 2 * radius + 1;
  return (T, S, start2, stop, step) => {
    if (!((stop -= step) >= start2)) return;
    let sum4 = radius * S[start2];
    const s2 = step * radius;
    for (let i = start2, j = start2 + s2; i < j; i += step) {
      sum4 += S[Math.min(stop, i)];
    }
    for (let i = start2, j = stop; i <= j; i += step) {
      sum4 += S[Math.min(stop, i + s2)];
      T[i] = sum4 / w;
      sum4 -= S[Math.max(start2, i - s2)];
    }
  };
}
var blur2, blurImage;
var init_blur = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/blur.js"() {
    blur2 = Blur2(blurf);
    blurImage = Blur2(blurfImage);
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/count.js
function count(values, valueof) {
  let count3 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count3;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (value = +value) >= value) {
        ++count3;
      }
    }
  }
  return count3;
}
var init_count = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/count.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/cross.js
function length(array4) {
  return array4.length | 0;
}
function empty(length3) {
  return !(length3 > 0);
}
function arrayify(values) {
  return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce2) {
  return (values) => reduce2(...values);
}
function cross(...values) {
  const reduce2 = typeof values[values.length - 1] === "function" && reducer(values.pop());
  values = values.map(arrayify);
  const lengths = values.map(length);
  const j = values.length - 1;
  const index3 = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty)) return product;
  while (true) {
    product.push(index3.map((j2, i2) => values[i2][j2]));
    let i = j;
    while (++index3[i] === lengths[i]) {
      if (i === 0) return reduce2 ? product.map(reduce2) : product;
      index3[i--] = 0;
    }
  }
}
var init_cross = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/cross.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/cumsum.js
function cumsum(values, valueof) {
  var sum4 = 0, index3 = 0;
  return Float64Array.from(values, valueof === void 0 ? (v2) => sum4 += +v2 || 0 : (v2) => sum4 += +valueof(v2, index3++, values) || 0);
}
var init_cumsum = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/cumsum.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/variance.js
function variance(values, valueof) {
  let count3 = 0;
  let delta;
  let mean2 = 0;
  let sum4 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean2;
        mean2 += delta / ++count3;
        sum4 += delta * (value - mean2);
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (value = +value) >= value) {
        delta = value - mean2;
        mean2 += delta / ++count3;
        sum4 += delta * (value - mean2);
      }
    }
  }
  if (count3 > 1) return sum4 / (count3 - 1);
}
var init_variance = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/variance.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/deviation.js
function deviation(values, valueof) {
  const v2 = variance(values, valueof);
  return v2 ? Math.sqrt(v2) : v2;
}
var init_deviation = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/deviation.js"() {
    init_variance();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/extent.js
function extent(values, valueof) {
  let min4;
  let max5;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null) {
        if (min4 === void 0) {
          if (value >= value) min4 = max5 = value;
        } else {
          if (min4 > value) min4 = value;
          if (max5 < value) max5 = value;
        }
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null) {
        if (min4 === void 0) {
          if (value >= value) min4 = max5 = value;
        } else {
          if (min4 > value) min4 = value;
          if (max5 < value) max5 = value;
        }
      }
    }
  }
  return [min4, max5];
}
var init_extent = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/extent.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/fsum.js
function fsum(values, valueof) {
  const adder = new Adder();
  if (valueof === void 0) {
    for (let value of values) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index3, values)) {
        adder.add(value);
      }
    }
  }
  return +adder;
}
function fcumsum(values, valueof) {
  const adder = new Adder();
  let index3 = -1;
  return Float64Array.from(
    values,
    valueof === void 0 ? (v2) => adder.add(+v2 || 0) : (v2) => adder.add(+valueof(v2, ++index3, values) || 0)
  );
}
var Adder;
var init_fsum = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/fsum.js"() {
    Adder = class {
      constructor() {
        this._partials = new Float64Array(32);
        this._n = 0;
      }
      add(x4) {
        const p = this._partials;
        let i = 0;
        for (let j = 0; j < this._n && j < 32; j++) {
          const y4 = p[j], hi = x4 + y4, lo = Math.abs(x4) < Math.abs(y4) ? x4 - (hi - y4) : y4 - (hi - x4);
          if (lo) p[i++] = lo;
          x4 = hi;
        }
        p[i] = x4;
        this._n = i + 1;
        return this;
      }
      valueOf() {
        const p = this._partials;
        let n = this._n, x4, y4, lo, hi = 0;
        if (n > 0) {
          hi = p[--n];
          while (n > 0) {
            x4 = hi;
            y4 = p[--n];
            hi = x4 + y4;
            lo = y4 - (hi - x4);
            if (lo) break;
          }
          if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
            y4 = lo * 2;
            x4 = hi + y4;
            if (y4 == x4 - hi) hi = x4;
          }
        }
        return hi;
      }
    };
  }
});

// ../node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
var InternMap, InternSet;
var init_src = __esm({
  "../node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js"() {
    InternMap = class extends Map {
      constructor(entries, key = keyof) {
        super();
        Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
        if (entries != null) for (const [key2, value] of entries) this.set(key2, value);
      }
      get(key) {
        return super.get(intern_get(this, key));
      }
      has(key) {
        return super.has(intern_get(this, key));
      }
      set(key, value) {
        return super.set(intern_set(this, key), value);
      }
      delete(key) {
        return super.delete(intern_delete(this, key));
      }
    };
    InternSet = class extends Set {
      constructor(values, key = keyof) {
        super();
        Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
        if (values != null) for (const value of values) this.add(value);
      }
      has(value) {
        return super.has(intern_get(this, value));
      }
      add(value) {
        return super.add(intern_set(this, value));
      }
      delete(value) {
        return super.delete(intern_delete(this, value));
      }
    };
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/identity.js
function identity(x4) {
  return x4;
}
var init_identity = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/identity.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/group.js
function group(values, ...keys) {
  return nest(values, identity, identity, keys);
}
function groups(values, ...keys) {
  return nest(values, Array.from, identity, keys);
}
function flatten(groups2, keys) {
  for (let i = 1, n = keys.length; i < n; ++i) {
    groups2 = groups2.flatMap((g) => g.pop().map(([key, value]) => [...g, key, value]));
  }
  return groups2;
}
function flatGroup(values, ...keys) {
  return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce2, ...keys) {
  return flatten(rollups(values, reduce2, ...keys), keys);
}
function rollup(values, reduce2, ...keys) {
  return nest(values, identity, reduce2, keys);
}
function rollups(values, reduce2, ...keys) {
  return nest(values, Array.from, reduce2, keys);
}
function index(values, ...keys) {
  return nest(values, identity, unique, keys);
}
function indexes(values, ...keys) {
  return nest(values, Array.from, unique, keys);
}
function unique(values) {
  if (values.length !== 1) throw new Error("duplicate key");
  return values[0];
}
function nest(values, map4, reduce2, keys) {
  return (function regroup(values2, i) {
    if (i >= keys.length) return reduce2(values2);
    const groups2 = new InternMap();
    const keyof2 = keys[i++];
    let index3 = -1;
    for (const value of values2) {
      const key = keyof2(value, ++index3, values2);
      const group2 = groups2.get(key);
      if (group2) group2.push(value);
      else groups2.set(key, [value]);
    }
    for (const [key, values3] of groups2) {
      groups2.set(key, regroup(values3, i));
    }
    return map4(groups2);
  })(values, 0);
}
var init_group = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/group.js"() {
    init_src();
    init_identity();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/permute.js
function permute(source, keys) {
  return Array.from(keys, (key) => source[key]);
}
var init_permute = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/permute.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/sort.js
function sort(values, ...F) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);
  let [f2] = F;
  if (f2 && f2.length !== 2 || F.length > 1) {
    const index3 = Uint32Array.from(values, (d, i) => i);
    if (F.length > 1) {
      F = F.map((f3) => values.map(f3));
      index3.sort((i, j) => {
        for (const f3 of F) {
          const c6 = ascendingDefined(f3[i], f3[j]);
          if (c6) return c6;
        }
      });
    } else {
      f2 = values.map(f2);
      index3.sort((i, j) => ascendingDefined(f2[i], f2[j]));
    }
    return permute(values, index3);
  }
  return values.sort(compareDefined(f2));
}
function compareDefined(compare = ascending) {
  if (compare === ascending) return ascendingDefined;
  if (typeof compare !== "function") throw new TypeError("compare is not a function");
  return (a4, b) => {
    const x4 = compare(a4, b);
    if (x4 || x4 === 0) return x4;
    return (compare(b, b) === 0) - (compare(a4, a4) === 0);
  };
}
function ascendingDefined(a4, b) {
  return (a4 == null || !(a4 >= a4)) - (b == null || !(b >= b)) || (a4 < b ? -1 : a4 > b ? 1 : 0);
}
var init_sort = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/sort.js"() {
    init_ascending();
    init_permute();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/groupSort.js
function groupSort(values, reduce2, key) {
  return (reduce2.length !== 2 ? sort(rollup(values, reduce2, key), (([ak, av], [bk, bv]) => ascending(av, bv) || ascending(ak, bk))) : sort(group(values, key), (([ak, av], [bk, bv]) => reduce2(av, bv) || ascending(ak, bk)))).map(([key2]) => key2);
}
var init_groupSort = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/groupSort.js"() {
    init_ascending();
    init_group();
    init_sort();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/array.js
var array, slice, map;
var init_array = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/array.js"() {
    array = Array.prototype;
    slice = array.slice;
    map = array.map;
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/constant.js
function constant(x4) {
  return () => x4;
}
var init_constant = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js
function tickSpec(start2, stop, count3) {
  const step = (stop - start2) / Math.max(0, count3), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc2;
  if (power < 0) {
    inc2 = Math.pow(10, -power) / factor;
    i1 = Math.round(start2 * inc2);
    i2 = Math.round(stop * inc2);
    if (i1 / inc2 < start2) ++i1;
    if (i2 / inc2 > stop) --i2;
    inc2 = -inc2;
  } else {
    inc2 = Math.pow(10, power) * factor;
    i1 = Math.round(start2 / inc2);
    i2 = Math.round(stop / inc2);
    if (i1 * inc2 < start2) ++i1;
    if (i2 * inc2 > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count3 && count3 < 2) return tickSpec(start2, stop, count3 * 2);
  return [i1, i2, inc2];
}
function ticks(start2, stop, count3) {
  stop = +stop, start2 = +start2, count3 = +count3;
  if (!(count3 > 0)) return [];
  if (start2 === stop) return [start2];
  const reverse2 = stop < start2, [i1, i2, inc2] = reverse2 ? tickSpec(stop, start2, count3) : tickSpec(start2, stop, count3);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1, ticks2 = new Array(n);
  if (reverse2) {
    if (inc2 < 0) for (let i = 0; i < n; ++i) ticks2[i] = (i2 - i) / -inc2;
    else for (let i = 0; i < n; ++i) ticks2[i] = (i2 - i) * inc2;
  } else {
    if (inc2 < 0) for (let i = 0; i < n; ++i) ticks2[i] = (i1 + i) / -inc2;
    else for (let i = 0; i < n; ++i) ticks2[i] = (i1 + i) * inc2;
  }
  return ticks2;
}
function tickIncrement(start2, stop, count3) {
  stop = +stop, start2 = +start2, count3 = +count3;
  return tickSpec(start2, stop, count3)[2];
}
function tickStep(start2, stop, count3) {
  stop = +stop, start2 = +start2, count3 = +count3;
  const reverse2 = stop < start2, inc2 = reverse2 ? tickIncrement(stop, start2, count3) : tickIncrement(start2, stop, count3);
  return (reverse2 ? -1 : 1) * (inc2 < 0 ? 1 / -inc2 : inc2);
}
var e10, e5, e2;
var init_ticks = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js"() {
    e10 = Math.sqrt(50);
    e5 = Math.sqrt(10);
    e2 = Math.sqrt(2);
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/nice.js
function nice(start2, stop, count3) {
  let prestep;
  while (true) {
    const step = tickIncrement(start2, stop, count3);
    if (step === prestep || step === 0 || !isFinite(step)) {
      return [start2, stop];
    } else if (step > 0) {
      start2 = Math.floor(start2 / step) * step;
      stop = Math.ceil(stop / step) * step;
    } else if (step < 0) {
      start2 = Math.ceil(start2 * step) / step;
      stop = Math.floor(stop * step) / step;
    }
    prestep = step;
  }
}
var init_nice = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/nice.js"() {
    init_ticks();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/sturges.js
function thresholdSturges(values) {
  return Math.max(1, Math.ceil(Math.log(count(values)) / Math.LN2) + 1);
}
var init_sturges = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/sturges.js"() {
    init_count();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bin.js
function bin() {
  var value = identity, domain = extent, threshold2 = thresholdSturges;
  function histogram(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    var i, n = data.length, x4, step, values = new Array(n);
    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }
    var xz = domain(values), x06 = xz[0], x12 = xz[1], tz = threshold2(values, x06, x12);
    if (!Array.isArray(tz)) {
      const max5 = x12, tn = +tz;
      if (domain === extent) [x06, x12] = nice(x06, x12, tn);
      tz = ticks(x06, x12, tn);
      if (tz[0] <= x06) step = tickIncrement(x06, x12, tn);
      if (tz[tz.length - 1] >= x12) {
        if (max5 >= x12 && domain === extent) {
          const step2 = tickIncrement(x06, x12, tn);
          if (isFinite(step2)) {
            if (step2 > 0) {
              x12 = (Math.floor(x12 / step2) + 1) * step2;
            } else if (step2 < 0) {
              x12 = (Math.ceil(x12 * -step2) + 1) / -step2;
            }
          }
        } else {
          tz.pop();
        }
      }
    }
    var m3 = tz.length, a4 = 0, b = m3;
    while (tz[a4] <= x06) ++a4;
    while (tz[b - 1] > x12) --b;
    if (a4 || b < m3) tz = tz.slice(a4, b), m3 = b - a4;
    var bins = new Array(m3 + 1), bin2;
    for (i = 0; i <= m3; ++i) {
      bin2 = bins[i] = [];
      bin2.x0 = i > 0 ? tz[i - 1] : x06;
      bin2.x1 = i < m3 ? tz[i] : x12;
    }
    if (isFinite(step)) {
      if (step > 0) {
        for (i = 0; i < n; ++i) {
          if ((x4 = values[i]) != null && x06 <= x4 && x4 <= x12) {
            bins[Math.min(m3, Math.floor((x4 - x06) / step))].push(data[i]);
          }
        }
      } else if (step < 0) {
        for (i = 0; i < n; ++i) {
          if ((x4 = values[i]) != null && x06 <= x4 && x4 <= x12) {
            const j = Math.floor((x06 - x4) * step);
            bins[Math.min(m3, j + (tz[j] <= x4))].push(data[i]);
          }
        }
      }
    } else {
      for (i = 0; i < n; ++i) {
        if ((x4 = values[i]) != null && x06 <= x4 && x4 <= x12) {
          bins[bisect_default(tz, x4, 0, m3)].push(data[i]);
        }
      }
    }
    return bins;
  }
  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };
  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };
  histogram.thresholds = function(_) {
    return arguments.length ? (threshold2 = typeof _ === "function" ? _ : constant(Array.isArray(_) ? slice.call(_) : _), histogram) : threshold2;
  };
  return histogram;
}
var init_bin = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bin.js"() {
    init_array();
    init_bisect();
    init_constant();
    init_extent();
    init_identity();
    init_nice();
    init_ticks();
    init_sturges();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/max.js
function max(values, valueof) {
  let max5;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (max5 < value || max5 === void 0 && value >= value)) {
        max5 = value;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (max5 < value || max5 === void 0 && value >= value)) {
        max5 = value;
      }
    }
  }
  return max5;
}
var init_max = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/max.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/maxIndex.js
function maxIndex(values, valueof) {
  let max5;
  let maxIndex2 = -1;
  let index3 = -1;
  if (valueof === void 0) {
    for (const value of values) {
      ++index3;
      if (value != null && (max5 < value || max5 === void 0 && value >= value)) {
        max5 = value, maxIndex2 = index3;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (max5 < value || max5 === void 0 && value >= value)) {
        max5 = value, maxIndex2 = index3;
      }
    }
  }
  return maxIndex2;
}
var init_maxIndex = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/maxIndex.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/min.js
function min(values, valueof) {
  let min4;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (min4 > value || min4 === void 0 && value >= value)) {
        min4 = value;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (min4 > value || min4 === void 0 && value >= value)) {
        min4 = value;
      }
    }
  }
  return min4;
}
var init_min = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/min.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/minIndex.js
function minIndex(values, valueof) {
  let min4;
  let minIndex2 = -1;
  let index3 = -1;
  if (valueof === void 0) {
    for (const value of values) {
      ++index3;
      if (value != null && (min4 > value || min4 === void 0 && value >= value)) {
        min4 = value, minIndex2 = index3;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (min4 > value || min4 === void 0 && value >= value)) {
        min4 = value, minIndex2 = index3;
      }
    }
  }
  return minIndex2;
}
var init_minIndex = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/minIndex.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quickselect.js
function quickselect(array4, k2, left2 = 0, right2 = Infinity, compare) {
  k2 = Math.floor(k2);
  left2 = Math.floor(Math.max(0, left2));
  right2 = Math.floor(Math.min(array4.length - 1, right2));
  if (!(left2 <= k2 && k2 <= right2)) return array4;
  compare = compare === void 0 ? ascendingDefined : compareDefined(compare);
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n = right2 - left2 + 1;
      const m3 = k2 - left2 + 1;
      const z = Math.log(n);
      const s2 = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s2 * (n - s2) / n) * (m3 - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k2 - m3 * s2 / n + sd));
      const newRight = Math.min(right2, Math.floor(k2 + (n - m3) * s2 / n + sd));
      quickselect(array4, k2, newLeft, newRight, compare);
    }
    const t = array4[k2];
    let i = left2;
    let j = right2;
    swap(array4, left2, k2);
    if (compare(array4[right2], t) > 0) swap(array4, left2, right2);
    while (i < j) {
      swap(array4, i, j), ++i, --j;
      while (compare(array4[i], t) < 0) ++i;
      while (compare(array4[j], t) > 0) --j;
    }
    if (compare(array4[left2], t) === 0) swap(array4, left2, j);
    else ++j, swap(array4, j, right2);
    if (j <= k2) left2 = j + 1;
    if (k2 <= j) right2 = j - 1;
  }
  return array4;
}
function swap(array4, i, j) {
  const t = array4[i];
  array4[i] = array4[j];
  array4[j] = t;
}
var init_quickselect = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quickselect.js"() {
    init_sort();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/greatest.js
function greatest(values, compare = ascending) {
  let max5;
  let defined = false;
  if (compare.length === 1) {
    let maxValue;
    for (const element of values) {
      const value = compare(element);
      if (defined ? ascending(value, maxValue) > 0 : ascending(value, value) === 0) {
        max5 = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, max5) > 0 : compare(value, value) === 0) {
        max5 = value;
        defined = true;
      }
    }
  }
  return max5;
}
var init_greatest = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/greatest.js"() {
    init_ascending();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quantile.js
function quantile(values, p, valueof) {
  values = Float64Array.from(numbers(values, valueof));
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return min(values);
  if (p >= 1) return max(values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = number) {
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = number) {
  if (isNaN(p = +p)) return;
  numbers2 = Float64Array.from(values, (_, i2) => number(valueof(values[i2], i2, values)));
  if (p <= 0) return minIndex(numbers2);
  if (p >= 1) return maxIndex(numbers2);
  var numbers2, index3 = Uint32Array.from(values, (_, i2) => i2), j = numbers2.length - 1, i = Math.floor(j * p);
  quickselect(index3, i, 0, j, (i2, j2) => ascendingDefined(numbers2[i2], numbers2[j2]));
  i = greatest(index3.subarray(0, i + 1), (i2) => numbers2[i2]);
  return i >= 0 ? i : -1;
}
var init_quantile = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quantile.js"() {
    init_max();
    init_maxIndex();
    init_min();
    init_minIndex();
    init_quickselect();
    init_number();
    init_sort();
    init_greatest();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/freedmanDiaconis.js
function thresholdFreedmanDiaconis(values, min4, max5) {
  const c6 = count(values), d = quantile(values, 0.75) - quantile(values, 0.25);
  return c6 && d ? Math.ceil((max5 - min4) / (2 * d * Math.pow(c6, -1 / 3))) : 1;
}
var init_freedmanDiaconis = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/freedmanDiaconis.js"() {
    init_count();
    init_quantile();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/scott.js
function thresholdScott(values, min4, max5) {
  const c6 = count(values), d = deviation(values);
  return c6 && d ? Math.ceil((max5 - min4) * Math.cbrt(c6) / (3.49 * d)) : 1;
}
var init_scott = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/threshold/scott.js"() {
    init_count();
    init_deviation();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/mean.js
function mean(values, valueof) {
  let count3 = 0;
  let sum4 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count3, sum4 += value;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && (value = +value) >= value) {
        ++count3, sum4 += value;
      }
    }
  }
  if (count3) return sum4 / count3;
}
var init_mean = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/mean.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/median.js
function median(values, valueof) {
  return quantile(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
  return quantileIndex(values, 0.5, valueof);
}
var init_median = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/median.js"() {
    init_quantile();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/merge.js
function* flatten2(arrays) {
  for (const array4 of arrays) {
    yield* array4;
  }
}
function merge(arrays) {
  return Array.from(flatten2(arrays));
}
var init_merge = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/merge.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/mode.js
function mode(values, valueof) {
  const counts = new InternMap();
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && value >= value) {
        counts.set(value, (counts.get(value) || 0) + 1);
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index3, values)) != null && value >= value) {
        counts.set(value, (counts.get(value) || 0) + 1);
      }
    }
  }
  let modeValue;
  let modeCount = 0;
  for (const [value, count3] of counts) {
    if (count3 > modeCount) {
      modeCount = count3;
      modeValue = value;
    }
  }
  return modeValue;
}
var init_mode = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/mode.js"() {
    init_src();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/pairs.js
function pairs(values, pairof = pair) {
  const pairs2 = [];
  let previous;
  let first = false;
  for (const value of values) {
    if (first) pairs2.push(pairof(previous, value));
    previous = value;
    first = true;
  }
  return pairs2;
}
function pair(a4, b) {
  return [a4, b];
}
var init_pairs = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/pairs.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function range(start2, stop, step) {
  start2 = +start2, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n < 3 ? 1 : +step;
  var i = -1, n = Math.max(0, Math.ceil((stop - start2) / step)) | 0, range4 = new Array(n);
  while (++i < n) {
    range4[i] = start2 + i * step;
  }
  return range4;
}
var init_range = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/rank.js
function rank(values, valueof = ascending) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  let V = Array.from(values);
  const R = new Float64Array(V.length);
  if (valueof.length !== 2) V = V.map(valueof), valueof = ascending;
  const compareIndex = (i, j) => valueof(V[i], V[j]);
  let k2, r;
  values = Uint32Array.from(V, (_, i) => i);
  values.sort(valueof === ascending ? (i, j) => ascendingDefined(V[i], V[j]) : compareDefined(compareIndex));
  values.forEach((j, i) => {
    const c6 = compareIndex(j, k2 === void 0 ? j : k2);
    if (c6 >= 0) {
      if (k2 === void 0 || c6 > 0) k2 = j, r = i;
      R[j] = r;
    } else {
      R[j] = NaN;
    }
  });
  return R;
}
var init_rank = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/rank.js"() {
    init_ascending();
    init_sort();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/least.js
function least(values, compare = ascending) {
  let min4;
  let defined = false;
  if (compare.length === 1) {
    let minValue;
    for (const element of values) {
      const value = compare(element);
      if (defined ? ascending(value, minValue) < 0 : ascending(value, value) === 0) {
        min4 = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, min4) < 0 : compare(value, value) === 0) {
        min4 = value;
        defined = true;
      }
    }
  }
  return min4;
}
var init_least = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/least.js"() {
    init_ascending();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/leastIndex.js
function leastIndex(values, compare = ascending) {
  if (compare.length === 1) return minIndex(values, compare);
  let minValue;
  let min4 = -1;
  let index3 = -1;
  for (const value of values) {
    ++index3;
    if (min4 < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
      minValue = value;
      min4 = index3;
    }
  }
  return min4;
}
var init_leastIndex = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/leastIndex.js"() {
    init_ascending();
    init_minIndex();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/greatestIndex.js
function greatestIndex(values, compare = ascending) {
  if (compare.length === 1) return maxIndex(values, compare);
  let maxValue;
  let max5 = -1;
  let index3 = -1;
  for (const value of values) {
    ++index3;
    if (max5 < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
      maxValue = value;
      max5 = index3;
    }
  }
  return max5;
}
var init_greatestIndex = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/greatestIndex.js"() {
    init_ascending();
    init_maxIndex();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/scan.js
function scan(values, compare) {
  const index3 = leastIndex(values, compare);
  return index3 < 0 ? void 0 : index3;
}
var init_scan = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/scan.js"() {
    init_leastIndex();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/shuffle.js
function shuffler(random) {
  return function shuffle2(array4, i0 = 0, i1 = array4.length) {
    let m3 = i1 - (i0 = +i0);
    while (m3) {
      const i = random() * m3-- | 0, t = array4[m3 + i0];
      array4[m3 + i0] = array4[i + i0];
      array4[i + i0] = t;
    }
    return array4;
  };
}
var shuffle_default;
var init_shuffle = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/shuffle.js"() {
    shuffle_default = shuffler(Math.random);
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/sum.js
function sum(values, valueof) {
  let sum4 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value = +value) {
        sum4 += value;
      }
    }
  } else {
    let index3 = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index3, values)) {
        sum4 += value;
      }
    }
  }
  return sum4;
}
var init_sum = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/sum.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/transpose.js
function transpose(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m3 = min(matrix, length2), transpose2 = new Array(m3); ++i < m3; ) {
    for (var j = -1, n, row = transpose2[i] = new Array(n); ++j < n; ) {
      row[j] = matrix[j][i];
    }
  }
  return transpose2;
}
function length2(d) {
  return d.length;
}
var init_transpose = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/transpose.js"() {
    init_min();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/zip.js
function zip() {
  return transpose(arguments);
}
var init_zip = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/zip.js"() {
    init_transpose();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/every.js
function every(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index3 = -1;
  for (const value of values) {
    if (!test(value, ++index3, values)) {
      return false;
    }
  }
  return true;
}
var init_every = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/every.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/some.js
function some(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index3 = -1;
  for (const value of values) {
    if (test(value, ++index3, values)) {
      return true;
    }
  }
  return false;
}
var init_some = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/some.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/filter.js
function filter(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  const array4 = [];
  let index3 = -1;
  for (const value of values) {
    if (test(value, ++index3, values)) {
      array4.push(value);
    }
  }
  return array4;
}
var init_filter = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/filter.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/map.js
function map2(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index3) => mapper(value, index3, values));
}
var init_map = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/map.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/reduce.js
function reduce(values, reducer2, value) {
  if (typeof reducer2 !== "function") throw new TypeError("reducer is not a function");
  const iterator = values[Symbol.iterator]();
  let done, next, index3 = -1;
  if (arguments.length < 3) {
    ({ done, value } = iterator.next());
    if (done) return;
    ++index3;
  }
  while ({ done, value: next } = iterator.next(), !done) {
    value = reducer2(value, next, ++index3, values);
  }
  return value;
}
var init_reduce = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/reduce.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/reverse.js
function reverse(values) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  return Array.from(values).reverse();
}
var init_reverse = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/reverse.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/difference.js
function difference(values, ...others) {
  values = new InternSet(values);
  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }
  return values;
}
var init_difference = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/difference.js"() {
    init_src();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/disjoint.js
function disjoint(values, other) {
  const iterator = other[Symbol.iterator](), set4 = new InternSet();
  for (const v2 of values) {
    if (set4.has(v2)) return false;
    let value, done;
    while ({ value, done } = iterator.next()) {
      if (done) break;
      if (Object.is(v2, value)) return false;
      set4.add(value);
    }
  }
  return true;
}
var init_disjoint = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/disjoint.js"() {
    init_src();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/intersection.js
function intersection(values, ...others) {
  values = new InternSet(values);
  others = others.map(set);
  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }
  return values;
}
function set(values) {
  return values instanceof InternSet ? values : new InternSet(values);
}
var init_intersection = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/intersection.js"() {
    init_src();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/superset.js
function superset(values, other) {
  const iterator = values[Symbol.iterator](), set4 = /* @__PURE__ */ new Set();
  for (const o of other) {
    const io = intern(o);
    if (set4.has(io)) continue;
    let value, done;
    while ({ value, done } = iterator.next()) {
      if (done) return false;
      const ivalue = intern(value);
      set4.add(ivalue);
      if (Object.is(io, ivalue)) break;
    }
  }
  return true;
}
function intern(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
var init_superset = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/superset.js"() {
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/subset.js
function subset(values, other) {
  return superset(other, values);
}
var init_subset = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/subset.js"() {
    init_superset();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/union.js
function union(...others) {
  const set4 = new InternSet();
  for (const other of others) {
    for (const o of other) {
      set4.add(o);
    }
  }
  return set4;
}
var init_union = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/union.js"() {
    init_src();
  }
});

// ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/index.js
var init_src2 = __esm({
  "../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/index.js"() {
    init_bisect();
    init_ascending();
    init_bisector();
    init_blur();
    init_count();
    init_cross();
    init_cumsum();
    init_descending();
    init_deviation();
    init_extent();
    init_fsum();
    init_group();
    init_groupSort();
    init_bin();
    init_freedmanDiaconis();
    init_scott();
    init_sturges();
    init_max();
    init_maxIndex();
    init_mean();
    init_median();
    init_merge();
    init_min();
    init_minIndex();
    init_mode();
    init_nice();
    init_pairs();
    init_permute();
    init_quantile();
    init_quickselect();
    init_range();
    init_rank();
    init_least();
    init_leastIndex();
    init_greatest();
    init_greatestIndex();
    init_scan();
    init_shuffle();
    init_sum();
    init_ticks();
    init_transpose();
    init_variance();
    init_zip();
    init_every();
    init_some();
    init_filter();
    init_map();
    init_reduce();
    init_reverse();
    init_sort();
    init_difference();
    init_disjoint();
    init_intersection();
    init_subset();
    init_superset();
    init_union();
    init_src();
  }
});

// ../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/identity.js
function identity_default(x4) {
  return x4;
}
var init_identity2 = __esm({
  "../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/identity.js"() {
  }
});

// ../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/axis.js
function translateX(x4) {
  return "translate(" + x4 + ",0)";
}
function translateY(y4) {
  return "translate(0," + y4 + ")";
}
function number2(scale2) {
  return (d) => +scale2(d);
}
function center(scale2, offset) {
  offset = Math.max(0, scale2.bandwidth() - offset * 2) / 2;
  if (scale2.round()) offset = Math.round(offset);
  return (d) => +scale2(d) + offset;
}
function entering() {
  return !this.__axis;
}
function axis(orient, scale2) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k2 = orient === top || orient === left ? -1 : 1, x4 = orient === left || orient === right ? "x" : "y", transform2 = orient === top || orient === bottom ? translateX : translateY;
  function axis2(context) {
    var values = tickValues == null ? scale2.ticks ? scale2.ticks.apply(scale2, tickArguments) : scale2.domain() : tickValues, format2 = tickFormat2 == null ? scale2.tickFormat ? scale2.tickFormat.apply(scale2, tickArguments) : identity_default : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range4 = scale2.range(), range0 = +range4[0] + offset, range1 = +range4[range4.length - 1] + offset, position = (scale2.bandwidth ? center : number2)(scale2.copy(), offset), selection2 = context.selection ? context.selection() : context, path2 = selection2.selectAll(".domain").data([null]), tick = selection2.selectAll(".tick").data(values, scale2).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
    path2 = path2.merge(path2.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x4 + "2", k2 * tickSizeInner));
    text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x4, k2 * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
    if (context !== selection2) {
      path2 = path2.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d) {
        return isFinite(d = position(d)) ? transform2(d + offset) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon).attr("transform", function(d) {
        var p = this.parentNode.__axis;
        return transform2((p && isFinite(p = p(d)) ? p : position(d)) + offset);
      });
    }
    tickExit.remove();
    path2.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k2 * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k2 * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k2 * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k2 * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d) {
      return transform2(position(d) + offset);
    });
    line.attr(x4 + "2", k2 * tickSizeInner);
    text.attr(x4, k2 * spacing).text(format2);
    selection2.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection2.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_) {
    return arguments.length ? (scale2 = _, axis2) : scale2;
  };
  axis2.ticks = function() {
    return tickArguments = Array.from(arguments), axis2;
  };
  axis2.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_) {
    return arguments.length ? (tickFormat2 = _, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis2) : tickPadding;
  };
  axis2.offset = function(_) {
    return arguments.length ? (offset = +_, axis2) : offset;
  };
  return axis2;
}
function axisTop(scale2) {
  return axis(top, scale2);
}
function axisRight(scale2) {
  return axis(right, scale2);
}
function axisBottom(scale2) {
  return axis(bottom, scale2);
}
function axisLeft(scale2) {
  return axis(left, scale2);
}
var top, right, bottom, left, epsilon;
var init_axis = __esm({
  "../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/axis.js"() {
    init_identity2();
    top = 1;
    right = 2;
    bottom = 3;
    left = 4;
    epsilon = 1e-6;
  }
});

// ../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/index.js
var init_src3 = __esm({
  "../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/index.js"() {
    init_axis();
  }
});

// ../node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/dispatch.js
function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}
function Dispatch(_) {
  this._ = _;
}
function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return { type: t, name };
  });
}
function get(type2, name) {
  for (var i = 0, n = type2.length, c6; i < n; ++i) {
    if ((c6 = type2[i]).name === name) {
      return c6.value;
    }
  }
}
function set2(type2, name, callback) {
  for (var i = 0, n = type2.length; i < n; ++i) {
    if (type2[i].name === name) {
      type2[i] = noop, type2 = type2.slice(0, i).concat(type2.slice(i + 1));
      break;
    }
  }
  if (callback != null) type2.push({ name, value: callback });
  return type2;
}
var noop, dispatch_default;
var init_dispatch = __esm({
  "../node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/dispatch.js"() {
    noop = { value: () => {
    } };
    Dispatch.prototype = dispatch.prototype = {
      constructor: Dispatch,
      on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        if (arguments.length < 2) {
          while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
          return;
        }
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while (++i < n) {
          if (t = (typename = T[i]).type) _[t] = set2(_[t], typename.name, callback);
          else if (callback == null) for (t in _) _[t] = set2(_[t], typename.name, null);
        }
        return this;
      },
      copy: function() {
        var copy3 = {}, _ = this._;
        for (var t in _) copy3[t] = _[t].slice();
        return new Dispatch(copy3);
      },
      call: function(type2, that) {
        if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
        for (t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
      },
      apply: function(type2, that, args) {
        if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
        for (var t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
      }
    };
    dispatch_default = dispatch;
  }
});

// ../node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/index.js
var init_src4 = __esm({
  "../node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/index.js"() {
    init_dispatch();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespaces.js
var xhtml, namespaces_default;
var init_namespaces = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespaces.js"() {
    xhtml = "http://www.w3.org/1999/xhtml";
    namespaces_default = {
      svg: "http://www.w3.org/2000/svg",
      xhtml,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespace.js
function namespace_default(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces_default.hasOwnProperty(prefix) ? { space: namespaces_default[prefix], local: name } : name;
}
var init_namespace = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespace.js"() {
    init_namespaces();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/creator.js
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator_default(name) {
  var fullname = namespace_default(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
var init_creator = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/creator.js"() {
    init_namespace();
    init_namespaces();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selector.js
function none() {
}
function selector_default(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}
var init_selector = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selector.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/select.js
function select_default(select) {
  if (typeof select !== "function") select = selector_default(select);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = new Array(m3), j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group2[i]) && (subnode = select.call(node, node.__data__, i, group2))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
var init_select = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/select.js"() {
    init_selection();
    init_selector();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/array.js
function array2(x4) {
  return x4 == null ? [] : Array.isArray(x4) ? x4 : Array.from(x4);
}
var init_array2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/array.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectorAll.js
function empty2() {
  return [];
}
function selectorAll_default(selector) {
  return selector == null ? empty2 : function() {
    return this.querySelectorAll(selector);
  };
}
var init_selectorAll = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectorAll.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectAll.js
function arrayAll(select) {
  return function() {
    return array2(select.apply(this, arguments));
  };
}
function selectAll_default(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = selectorAll_default(select);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = [], parents = [], j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, node, i = 0; i < n; ++i) {
      if (node = group2[i]) {
        subgroups.push(select.call(node, node.__data__, i, group2));
        parents.push(node);
      }
    }
  }
  return new Selection(subgroups, parents);
}
var init_selectAll = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectAll.js"() {
    init_selection();
    init_array2();
    init_selectorAll();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/matcher.js
function matcher_default(selector) {
  return function() {
    return this.matches(selector);
  };
}
function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}
var init_matcher = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/matcher.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChild.js
function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selectChild_default(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}
var find;
var init_selectChild = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChild.js"() {
    init_matcher();
    find = Array.prototype.find;
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChildren.js
function children() {
  return Array.from(this.children);
}
function childrenFilter(match) {
  return function() {
    return filter2.call(this.children, match);
  };
}
function selectChildren_default(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}
var filter2;
var init_selectChildren = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChildren.js"() {
    init_matcher();
    filter2 = Array.prototype.filter;
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/filter.js
function filter_default(match) {
  if (typeof match !== "function") match = matcher_default(match);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = new Array(m3), j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group2[i]) && match.call(node, node.__data__, i, group2)) {
        subgroup.push(node);
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
var init_filter2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/filter.js"() {
    init_selection();
    init_matcher();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sparse.js
function sparse_default(update) {
  return new Array(update.length);
}
var init_sparse = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sparse.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/enter.js
function enter_default() {
  return new Selection(this._enter || this._groups.map(sparse_default), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
var init_enter = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/enter.js"() {
    init_sparse();
    init_selection();
    EnterNode.prototype = {
      constructor: EnterNode,
      appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
      },
      insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
      },
      querySelector: function(selector) {
        return this._parent.querySelector(selector);
      },
      querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/constant.js
function constant_default(x4) {
  return function() {
    return x4;
  };
}
var init_constant2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/data.js
function bindIndex(parent, group2, enter, update, exit, data) {
  var i = 0, node, groupLength = group2.length, dataLength = data.length;
  for (; i < dataLength; ++i) {
    if (node = group2[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node = group2[i]) {
      exit[i] = node;
    }
  }
}
function bindKey(parent, group2, enter, update, exit, data, key) {
  var i, node, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group2.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node = group2[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group2) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node = group2[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
      exit[i] = node;
    }
  }
}
function datum(node) {
  return node.__data__;
}
function data_default(value, key) {
  if (!arguments.length) return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value !== "function") value = constant_default(value);
  for (var m3 = groups2.length, update = new Array(m3), enter = new Array(m3), exit = new Array(m3), j = 0; j < m3; ++j) {
    var parent = parents[j], group2 = groups2[j], groupLength = group2.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind(parent, group2, enterGroup, updateGroup, exitGroup, data, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength) ;
        previous._next = next || null;
      }
    }
  }
  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function arraylike(data) {
  return typeof data === "object" && "length" in data ? data : Array.from(data);
}
var init_data = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/data.js"() {
    init_selection();
    init_enter();
    init_constant2();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/exit.js
function exit_default() {
  return new Selection(this._exit || this._groups.map(sparse_default), this._parents);
}
var init_exit = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/exit.js"() {
    init_sparse();
    init_selection();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/join.js
function join_default(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  if (typeof onenter === "function") {
    enter = onenter(enter);
    if (enter) enter = enter.selection();
  } else {
    enter = enter.append(onenter + "");
  }
  if (onupdate != null) {
    update = onupdate(update);
    if (update) update = update.selection();
  }
  if (onexit == null) exit.remove();
  else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
var init_join = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/join.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/merge.js
function merge_default(context) {
  var selection2 = context.selection ? context.selection() : context;
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m3 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m3; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge2[i] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection(merges, this._parents);
}
var init_merge2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/merge.js"() {
    init_selection();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/order.js
function order_default() {
  for (var groups2 = this._groups, j = -1, m3 = groups2.length; ++j < m3; ) {
    for (var group2 = groups2[j], i = group2.length - 1, next = group2[i], node; --i >= 0; ) {
      if (node = group2[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }
  return this;
}
var init_order = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/order.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sort.js
function sort_default(compare) {
  if (!compare) compare = ascending2;
  function compareNode(a4, b) {
    return a4 && b ? compare(a4.__data__, b.__data__) : !a4 - !b;
  }
  for (var groups2 = this._groups, m3 = groups2.length, sortgroups = new Array(m3), j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group2[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection(sortgroups, this._parents).order();
}
function ascending2(a4, b) {
  return a4 < b ? -1 : a4 > b ? 1 : a4 >= b ? 0 : NaN;
}
var init_sort2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sort.js"() {
    init_selection();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/call.js
function call_default() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
var init_call = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/call.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/nodes.js
function nodes_default() {
  return Array.from(this);
}
var init_nodes = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/nodes.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/node.js
function node_default() {
  for (var groups2 = this._groups, j = 0, m3 = groups2.length; j < m3; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length; i < n; ++i) {
      var node = group2[i];
      if (node) return node;
    }
  }
  return null;
}
var init_node = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/node.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/size.js
function size_default() {
  let size = 0;
  for (const node of this) ++size;
  return size;
}
var init_size = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/size.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/empty.js
function empty_default() {
  return !this.node();
}
var init_empty = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/empty.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/each.js
function each_default(callback) {
  for (var groups2 = this._groups, j = 0, m3 = groups2.length; j < m3; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node; i < n; ++i) {
      if (node = group2[i]) callback.call(node, node.__data__, i, group2);
    }
  }
  return this;
}
var init_each = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/each.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/attr.js
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.removeAttribute(name);
    else this.setAttribute(name, v2);
  };
}
function attrFunctionNS(fullname, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v2);
  };
}
function attr_default(name, value) {
  var fullname = namespace_default(name);
  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
}
var init_attr = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/attr.js"() {
    init_namespace();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/window.js
function window_default(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}
var init_window = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/window.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/style.js
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction(name, value, priority) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v2, priority);
  };
}
function style_default(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node, name) {
  return node.style.getPropertyValue(name) || window_default(node).getComputedStyle(node, null).getPropertyValue(name);
}
var init_style = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/style.js"() {
    init_window();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null) delete this[name];
    else this[name] = v2;
  };
}
function property_default(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
var init_property = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/property.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}
function classList(node) {
  return node.classList || new ClassList(node);
}
function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}
function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}
function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function classed_default(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}
var init_classed = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/classed.js"() {
    ClassList.prototype = {
      add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
          this._names.push(name);
          this._node.setAttribute("class", this._names.join(" "));
        }
      },
      remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
          this._names.splice(i, 1);
          this._node.setAttribute("class", this._names.join(" "));
        }
      },
      contains: function(name) {
        return this._names.indexOf(name) >= 0;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.textContent = v2 == null ? "" : v2;
  };
}
function text_default(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
}
var init_text = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/text.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.innerHTML = v2 == null ? "" : v2;
  };
}
function html_default(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
var init_html = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/html.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/raise.js
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}
function raise_default() {
  return this.each(raise);
}
var init_raise = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/raise.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function lower_default() {
  return this.each(lower);
}
var init_lower = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/lower.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/append.js
function append_default(name) {
  var create2 = typeof name === "function" ? name : creator_default(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}
var init_append = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/append.js"() {
    init_creator();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/insert.js
function constantNull() {
  return null;
}
function insert_default(name, before) {
  var create2 = typeof name === "function" ? name : creator_default(name), select = before == null ? constantNull : typeof before === "function" ? before : selector_default(before);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select.apply(this, arguments) || null);
  });
}
var init_insert = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/insert.js"() {
    init_creator();
    init_selector();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}
function remove_default() {
  return this.each(remove);
}
var init_remove = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/remove.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/clone.js
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function clone_default(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
var init_clone = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/clone.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/datum.js
function datum_default(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
var init_datum = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/datum.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/on.js
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames2(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return { type: t, name };
  });
}
function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m3 = on.length, o; j < m3; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}
function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m3 = on.length; j < m3; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = { type: typename.type, name: typename.name, value, listener, options };
    if (!on) this.__on = [o];
    else on.push(o);
  };
}
function on_default(typename, value, options) {
  var typenames = parseTypenames2(typename + ""), i, n = typenames.length, t;
  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m3 = on.length, o; j < m3; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }
  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
}
var init_on = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/on.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/dispatch.js
function dispatchEvent(node, type2, params) {
  var window2 = window_default(node), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type2, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params) event.initEvent(type2, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type2, false, false);
  }
  node.dispatchEvent(event);
}
function dispatchConstant(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params);
  };
}
function dispatchFunction(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params.apply(this, arguments));
  };
}
function dispatch_default2(type2, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type2, params));
}
var init_dispatch2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/dispatch.js"() {
    init_window();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/iterator.js
function* iterator_default() {
  for (var groups2 = this._groups, j = 0, m3 = groups2.length; j < m3; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node; i < n; ++i) {
      if (node = group2[i]) yield node;
    }
  }
}
var init_iterator = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/iterator.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/index.js
function Selection(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection() {
  return new Selection([[document.documentElement]], root);
}
function selection_selection() {
  return this;
}
var root, selection_default;
var init_selection = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/index.js"() {
    init_select();
    init_selectAll();
    init_selectChild();
    init_selectChildren();
    init_filter2();
    init_data();
    init_enter();
    init_exit();
    init_join();
    init_merge2();
    init_order();
    init_sort2();
    init_call();
    init_nodes();
    init_node();
    init_size();
    init_empty();
    init_each();
    init_attr();
    init_style();
    init_property();
    init_classed();
    init_text();
    init_html();
    init_raise();
    init_lower();
    init_append();
    init_insert();
    init_remove();
    init_clone();
    init_datum();
    init_on();
    init_dispatch2();
    init_iterator();
    root = [null];
    Selection.prototype = selection.prototype = {
      constructor: Selection,
      select: select_default,
      selectAll: selectAll_default,
      selectChild: selectChild_default,
      selectChildren: selectChildren_default,
      filter: filter_default,
      data: data_default,
      enter: enter_default,
      exit: exit_default,
      join: join_default,
      merge: merge_default,
      selection: selection_selection,
      order: order_default,
      sort: sort_default,
      call: call_default,
      nodes: nodes_default,
      node: node_default,
      size: size_default,
      empty: empty_default,
      each: each_default,
      attr: attr_default,
      style: style_default,
      property: property_default,
      classed: classed_default,
      text: text_default,
      html: html_default,
      raise: raise_default,
      lower: lower_default,
      append: append_default,
      insert: insert_default,
      remove: remove_default,
      clone: clone_default,
      datum: datum_default,
      on: on_default,
      dispatch: dispatch_default2,
      [Symbol.iterator]: iterator_default
    };
    selection_default = selection;
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/select.js
function select_default2(selector) {
  return typeof selector === "string" ? new Selection([[document.querySelector(selector)]], [document.documentElement]) : new Selection([[selector]], root);
}
var init_select2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/select.js"() {
    init_selection();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/create.js
function create_default(name) {
  return select_default2(creator_default(name).call(document.documentElement));
}
var init_create = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/create.js"() {
    init_creator();
    init_select2();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/local.js
function local() {
  return new Local();
}
function Local() {
  this._ = "@" + (++nextId).toString(36);
}
var nextId;
var init_local = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/local.js"() {
    nextId = 0;
    Local.prototype = local.prototype = {
      constructor: Local,
      get: function(node) {
        var id2 = this._;
        while (!(id2 in node)) if (!(node = node.parentNode)) return;
        return node[id2];
      },
      set: function(node, value) {
        return node[this._] = value;
      },
      remove: function(node) {
        return this._ in node && delete node[this._];
      },
      toString: function() {
        return this._;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/sourceEvent.js
function sourceEvent_default(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
}
var init_sourceEvent = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/sourceEvent.js"() {
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/pointer.js
function pointer_default(event, node) {
  event = sourceEvent_default(event);
  if (node === void 0) node = event.currentTarget;
  if (node) {
    var svg2 = node.ownerSVGElement || node;
    if (svg2.createSVGPoint) {
      var point6 = svg2.createSVGPoint();
      point6.x = event.clientX, point6.y = event.clientY;
      point6 = point6.matrixTransform(node.getScreenCTM().inverse());
      return [point6.x, point6.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
var init_pointer = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/pointer.js"() {
    init_sourceEvent();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/pointers.js
function pointers_default(events, node) {
  if (events.target) {
    events = sourceEvent_default(events);
    if (node === void 0) node = events.currentTarget;
    events = events.touches || [events];
  }
  return Array.from(events, (event) => pointer_default(event, node));
}
var init_pointers = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/pointers.js"() {
    init_pointer();
    init_sourceEvent();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectAll.js
function selectAll_default2(selector) {
  return typeof selector === "string" ? new Selection([document.querySelectorAll(selector)], [document.documentElement]) : new Selection([array2(selector)], root);
}
var init_selectAll2 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectAll.js"() {
    init_array2();
    init_selection();
  }
});

// ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/index.js
var init_src5 = __esm({
  "../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/index.js"() {
    init_create();
    init_creator();
    init_local();
    init_matcher();
    init_namespace();
    init_namespaces();
    init_pointer();
    init_pointers();
    init_select2();
    init_selectAll2();
    init_selection();
    init_selector();
    init_selectorAll();
    init_style();
    init_window();
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/noevent.js
function nopropagation(event) {
  event.stopImmediatePropagation();
}
function noevent_default(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var nonpassive, nonpassivecapture;
var init_noevent = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/noevent.js"() {
    nonpassive = { passive: false };
    nonpassivecapture = { capture: true, passive: false };
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/nodrag.js
function nodrag_default(view) {
  var root3 = view.document.documentElement, selection2 = select_default2(view).on("dragstart.drag", noevent_default, nonpassivecapture);
  if ("onselectstart" in root3) {
    selection2.on("selectstart.drag", noevent_default, nonpassivecapture);
  } else {
    root3.__noselect = root3.style.MozUserSelect;
    root3.style.MozUserSelect = "none";
  }
}
function yesdrag(view, noclick) {
  var root3 = view.document.documentElement, selection2 = select_default2(view).on("dragstart.drag", null);
  if (noclick) {
    selection2.on("click.drag", noevent_default, nonpassivecapture);
    setTimeout(function() {
      selection2.on("click.drag", null);
    }, 0);
  }
  if ("onselectstart" in root3) {
    selection2.on("selectstart.drag", null);
  } else {
    root3.style.MozUserSelect = root3.__noselect;
    delete root3.__noselect;
  }
}
var init_nodrag = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/nodrag.js"() {
    init_src5();
    init_noevent();
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/constant.js
var constant_default2;
var init_constant3 = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/constant.js"() {
    constant_default2 = (x4) => () => x4;
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/event.js
function DragEvent(type2, {
  sourceEvent,
  subject,
  target,
  identifier,
  active,
  x: x4,
  y: y4,
  dx,
  dy,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent, enumerable: true, configurable: true },
    subject: { value: subject, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    identifier: { value: identifier, enumerable: true, configurable: true },
    active: { value: active, enumerable: true, configurable: true },
    x: { value: x4, enumerable: true, configurable: true },
    y: { value: y4, enumerable: true, configurable: true },
    dx: { value: dx, enumerable: true, configurable: true },
    dy: { value: dy, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
var init_event = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/event.js"() {
    DragEvent.prototype.on = function() {
      var value = this._.on.apply(this._, arguments);
      return value === this._ ? this : value;
    };
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/drag.js
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}
function defaultContainer() {
  return this.parentNode;
}
function defaultSubject(event, d) {
  return d == null ? { x: event.x, y: event.y } : d;
}
function defaultTouchable() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function drag_default() {
  var filter3 = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = dispatch_default("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
  function drag(selection2) {
    selection2.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, nonpassive).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function mousedowned(event, d) {
    if (touchending || !filter3.call(this, event, d)) return;
    var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
    if (!gesture) return;
    select_default2(event.view).on("mousemove.drag", mousemoved, nonpassivecapture).on("mouseup.drag", mouseupped, nonpassivecapture);
    nodrag_default(event.view);
    nopropagation(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }
  function mousemoved(event) {
    noevent_default(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }
  function mouseupped(event) {
    select_default2(event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(event.view, mousemoving);
    noevent_default(event);
    gestures.mouse("end", event);
  }
  function touchstarted(event, d) {
    if (!filter3.call(this, event, d)) return;
    var touches = event.changedTouches, c6 = container.call(this, event, d), n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(this, c6, event, d, touches[i].identifier, touches[i])) {
        nopropagation(event);
        gesture("start", event, touches[i]);
      }
    }
  }
  function touchmoved(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent_default(event);
        gesture("drag", event, touches[i]);
      }
    }
  }
  function touchended(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, 500);
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation(event);
        gesture("end", event, touches[i]);
      }
    }
  }
  function beforestart(that, container2, event, d, identifier, touch) {
    var dispatch2 = listeners.copy(), p = pointer_default(touch || event, container2), dx, dy, s2;
    if ((s2 = subject.call(that, new DragEvent("beforestart", {
      sourceEvent: event,
      target: drag,
      identifier,
      active,
      x: p[0],
      y: p[1],
      dx: 0,
      dy: 0,
      dispatch: dispatch2
    }), d)) == null) return;
    dx = s2.x - p[0] || 0;
    dy = s2.y - p[1] || 0;
    return function gesture(type2, event2, touch2) {
      var p02 = p, n;
      switch (type2) {
        case "start":
          gestures[identifier] = gesture, n = active++;
          break;
        case "end":
          delete gestures[identifier], --active;
        // falls through
        case "drag":
          p = pointer_default(touch2 || event2, container2), n = active;
          break;
      }
      dispatch2.call(
        type2,
        that,
        new DragEvent(type2, {
          sourceEvent: event2,
          subject: s2,
          target: drag,
          identifier,
          active: n,
          x: p[0] + dx,
          y: p[1] + dy,
          dx: p[0] - p02[0],
          dy: p[1] - p02[1],
          dispatch: dispatch2
        }),
        d
      );
    };
  }
  drag.filter = function(_) {
    return arguments.length ? (filter3 = typeof _ === "function" ? _ : constant_default2(!!_), drag) : filter3;
  };
  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant_default2(_), drag) : container;
  };
  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant_default2(_), drag) : subject;
  };
  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant_default2(!!_), drag) : touchable;
  };
  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };
  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };
  return drag;
}
var init_drag = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/drag.js"() {
    init_src4();
    init_src5();
    init_nodrag();
    init_noevent();
    init_constant3();
    init_event();
  }
});

// ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/index.js
var init_src6 = __esm({
  "../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/index.js"() {
    init_drag();
    init_nodrag();
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js
function define_default(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}
var init_define = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js"() {
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js
function Color() {
}
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m3, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m3 = reHex.exec(format2)) ? (l = m3[1].length, m3 = parseInt(m3[1], 16), l === 6 ? rgbn(m3) : l === 3 ? new Rgb(m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, (m3 & 15) << 4 | m3 & 15, 1) : l === 8 ? rgba(m3 >> 24 & 255, m3 >> 16 & 255, m3 >> 8 & 255, (m3 & 255) / 255) : l === 4 ? rgba(m3 >> 12 & 15 | m3 >> 8 & 240, m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, ((m3 & 15) << 4 | m3 & 15) / 255) : null) : (m3 = reRgbInteger.exec(format2)) ? new Rgb(m3[1], m3[2], m3[3], 1) : (m3 = reRgbPercent.exec(format2)) ? new Rgb(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, 1) : (m3 = reRgbaInteger.exec(format2)) ? rgba(m3[1], m3[2], m3[3], m3[4]) : (m3 = reRgbaPercent.exec(format2)) ? rgba(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, m3[4]) : (m3 = reHslPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, 1) : (m3 = reHslaPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, m3[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r, g, b, a4) {
  if (a4 <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a4);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a4 = clampa(this.opacity);
  return `${a4 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a4 === 1 ? ")" : `, ${a4})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s2, l, a4) {
  if (a4 <= 0) h = s2 = l = NaN;
  else if (l <= 0 || l >= 1) h = s2 = NaN;
  else if (s2 <= 0) h = NaN;
  return new Hsl(h, s2, l, a4);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255, g = o.g / 255, b = o.b / 255, min4 = Math.min(r, g, b), max5 = Math.max(r, g, b), h = NaN, s2 = max5 - min4, l = (max5 + min4) / 2;
  if (s2) {
    if (r === max5) h = (g - b) / s2 + (g < b) * 6;
    else if (g === max5) h = (b - r) / s2 + 2;
    else h = (r - g) / s2 + 4;
    s2 /= l < 0.5 ? max5 + min4 : 2 - max5 - min4;
    h *= 60;
  } else {
    s2 = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s2, l, o.opacity);
}
function hsl(h, s2, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s2, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s2, l, opacity) {
  this.h = +h;
  this.s = +s2;
  this.l = +l;
  this.opacity = +opacity;
}
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h, m1, m22) {
  return (h < 60 ? m1 + (m22 - m1) * h / 60 : h < 180 ? m22 : h < 240 ? m1 + (m22 - m1) * (240 - h) / 60 : m1) * 255;
}
var darker, brighter, reI, reN, reP, reHex, reRgbInteger, reRgbPercent, reRgbaInteger, reRgbaPercent, reHslPercent, reHslaPercent, named;
var init_color = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js"() {
    init_define();
    darker = 0.7;
    brighter = 1 / darker;
    reI = "\\s*([+-]?\\d+)\\s*";
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*";
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
    reHex = /^#([0-9a-f]{3,8})$/;
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`);
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`);
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`);
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`);
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`);
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
    named = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };
    define_default(Color, color, {
      copy(channels) {
        return Object.assign(new this.constructor(), this, channels);
      },
      displayable() {
        return this.rgb().displayable();
      },
      hex: color_formatHex,
      // Deprecated! Use color.formatHex.
      formatHex: color_formatHex,
      formatHex8: color_formatHex8,
      formatHsl: color_formatHsl,
      formatRgb: color_formatRgb,
      toString: color_formatRgb
    });
    define_default(Rgb, rgb, extend(Color, {
      brighter(k2) {
        k2 = k2 == null ? brighter : Math.pow(brighter, k2);
        return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
      },
      darker(k2) {
        k2 = k2 == null ? darker : Math.pow(darker, k2);
        return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
      },
      rgb() {
        return this;
      },
      clamp() {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
      },
      displayable() {
        return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
      },
      hex: rgb_formatHex,
      // Deprecated! Use color.formatHex.
      formatHex: rgb_formatHex,
      formatHex8: rgb_formatHex8,
      formatRgb: rgb_formatRgb,
      toString: rgb_formatRgb
    }));
    define_default(Hsl, hsl, extend(Color, {
      brighter(k2) {
        k2 = k2 == null ? brighter : Math.pow(brighter, k2);
        return new Hsl(this.h, this.s, this.l * k2, this.opacity);
      },
      darker(k2) {
        k2 = k2 == null ? darker : Math.pow(darker, k2);
        return new Hsl(this.h, this.s, this.l * k2, this.opacity);
      },
      rgb() {
        var h = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m22 = l + (l < 0.5 ? l : 1 - l) * s2, m1 = 2 * l - m22;
        return new Rgb(
          hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m22),
          hsl2rgb(h, m1, m22),
          hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m22),
          this.opacity
        );
      },
      clamp() {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
      },
      displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
      },
      formatHsl() {
        const a4 = clampa(this.opacity);
        return `${a4 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a4 === 1 ? ")" : `, ${a4})`}`;
      }
    }));
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/math.js
var radians, degrees;
var init_math = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/math.js"() {
    radians = Math.PI / 180;
    degrees = 180 / Math.PI;
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/lab.js
function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y4 = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x4, z;
  if (r === g && g === b) x4 = z = y4;
  else {
    x4 = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y4 - 16, 500 * (x4 - y4), 200 * (y4 - z), o.opacity);
}
function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a4, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a4, b, opacity == null ? 1 : opacity);
}
function Lab(l, a4, b, opacity) {
  this.l = +l;
  this.a = +a4;
  this.b = +b;
  this.opacity = +opacity;
}
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x4) {
  return 255 * (x4 <= 31308e-7 ? 12.92 * x4 : 1.055 * Math.pow(x4, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x4) {
  return (x4 /= 255) <= 0.04045 ? x4 / 12.92 : Math.pow((x4 + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * degrees;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c6, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c6, l, opacity == null ? 1 : opacity);
}
function hcl(h, c6, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c6, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c6, l, opacity) {
  this.h = +h;
  this.c = +c6;
  this.l = +l;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * radians;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
var K, Xn, Yn, Zn, t0, t1, t2, t3;
var init_lab = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/lab.js"() {
    init_define();
    init_color();
    init_math();
    K = 18;
    Xn = 0.96422;
    Yn = 1;
    Zn = 0.82521;
    t0 = 4 / 29;
    t1 = 6 / 29;
    t2 = 3 * t1 * t1;
    t3 = t1 * t1 * t1;
    define_default(Lab, lab, extend(Color, {
      brighter(k2) {
        return new Lab(this.l + K * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
      },
      darker(k2) {
        return new Lab(this.l - K * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
      },
      rgb() {
        var y4 = (this.l + 16) / 116, x4 = isNaN(this.a) ? y4 : y4 + this.a / 500, z = isNaN(this.b) ? y4 : y4 - this.b / 200;
        x4 = Xn * lab2xyz(x4);
        y4 = Yn * lab2xyz(y4);
        z = Zn * lab2xyz(z);
        return new Rgb(
          lrgb2rgb(3.1338561 * x4 - 1.6168667 * y4 - 0.4906146 * z),
          lrgb2rgb(-0.9787684 * x4 + 1.9161415 * y4 + 0.033454 * z),
          lrgb2rgb(0.0719453 * x4 - 0.2289914 * y4 + 1.4052427 * z),
          this.opacity
        );
      }
    }));
    define_default(Hcl, hcl, extend(Color, {
      brighter(k2) {
        return new Hcl(this.h, this.c, this.l + K * (k2 == null ? 1 : k2), this.opacity);
      },
      darker(k2) {
        return new Hcl(this.h, this.c, this.l - K * (k2 == null ? 1 : k2), this.opacity);
      },
      rgb() {
        return hcl2lab(this).rgb();
      }
    }));
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/cubehelix.js
function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k2 = (E * (g - l) - C * bl) / D, s2 = Math.sqrt(k2 * k2 + bl * bl) / (E * l * (1 - l)), h = s2 ? Math.atan2(k2, bl) * degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s2, l, o.opacity);
}
function cubehelix(h, s2, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s2, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s2, l, opacity) {
  this.h = +h;
  this.s = +s2;
  this.l = +l;
  this.opacity = +opacity;
}
var A, B, C, D, E, ED, EB, BC_DA;
var init_cubehelix = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/cubehelix.js"() {
    init_define();
    init_color();
    init_math();
    A = -0.14861;
    B = 1.78277;
    C = -0.29227;
    D = -0.90649;
    E = 1.97294;
    ED = E * D;
    EB = E * B;
    BC_DA = B * C - D * A;
    define_default(Cubehelix, cubehelix, extend(Color, {
      brighter(k2) {
        k2 = k2 == null ? brighter : Math.pow(brighter, k2);
        return new Cubehelix(this.h, this.s, this.l * k2, this.opacity);
      },
      darker(k2) {
        k2 = k2 == null ? darker : Math.pow(darker, k2);
        return new Cubehelix(this.h, this.s, this.l * k2, this.opacity);
      },
      rgb() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * radians, l = +this.l, a4 = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh2 = Math.cos(h), sinh2 = Math.sin(h);
        return new Rgb(
          255 * (l + a4 * (A * cosh2 + B * sinh2)),
          255 * (l + a4 * (C * cosh2 + D * sinh2)),
          255 * (l + a4 * (E * cosh2)),
          this.opacity
        );
      }
    }));
  }
});

// ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/index.js
var init_src7 = __esm({
  "../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/index.js"() {
    init_color();
    init_lab();
    init_cubehelix();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/basis.js
function basis(t13, v0, v12, v2, v32) {
  var t22 = t13 * t13, t32 = t22 * t13;
  return ((1 - 3 * t13 + 3 * t22 - t32) * v0 + (4 - 6 * t22 + 3 * t32) * v12 + (1 + 3 * t13 + 3 * t22 - 3 * t32) * v2 + t32 * v32) / 6;
}
function basis_default(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v12 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v12 - v2, v32 = i < n - 1 ? values[i + 2] : 2 * v2 - v12;
    return basis((t - i / n) * n, v0, v12, v2, v32);
  };
}
var init_basis = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/basis.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/basisClosed.js
function basisClosed_default(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v12 = values[i % n], v2 = values[(i + 1) % n], v32 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v12, v2, v32);
  };
}
var init_basisClosed = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/basisClosed.js"() {
    init_basis();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js
var constant_default3;
var init_constant4 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js"() {
    constant_default3 = (x4) => () => x4;
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js
function linear(a4, d) {
  return function(t) {
    return a4 + t * d;
  };
}
function exponential(a4, b, y4) {
  return a4 = Math.pow(a4, y4), b = Math.pow(b, y4) - a4, y4 = 1 / y4, function(t) {
    return Math.pow(a4 + t * b, y4);
  };
}
function hue(a4, b) {
  var d = b - a4;
  return d ? linear(a4, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant_default3(isNaN(a4) ? b : a4);
}
function gamma(y4) {
  return (y4 = +y4) === 1 ? nogamma : function(a4, b) {
    return b - a4 ? exponential(a4, b, y4) : constant_default3(isNaN(a4) ? b : a4);
  };
}
function nogamma(a4, b) {
  var d = b - a4;
  return d ? linear(a4, d) : constant_default3(isNaN(a4) ? b : a4);
}
var init_color2 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js"() {
    init_constant4();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js
function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color2;
    for (i = 0; i < n; ++i) {
      color2 = rgb(colors[i]);
      r[i] = color2.r || 0;
      g[i] = color2.g || 0;
      b[i] = color2.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color2.opacity = 1;
    return function(t) {
      color2.r = r(t);
      color2.g = g(t);
      color2.b = b(t);
      return color2 + "";
    };
  };
}
var rgb_default, rgbBasis, rgbBasisClosed;
var init_rgb = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js"() {
    init_src7();
    init_basis();
    init_basisClosed();
    init_color2();
    rgb_default = (function rgbGamma(y4) {
      var color2 = gamma(y4);
      function rgb2(start2, end) {
        var r = color2((start2 = rgb(start2)).r, (end = rgb(end)).r), g = color2(start2.g, end.g), b = color2(start2.b, end.b), opacity = nogamma(start2.opacity, end.opacity);
        return function(t) {
          start2.r = r(t);
          start2.g = g(t);
          start2.b = b(t);
          start2.opacity = opacity(t);
          return start2 + "";
        };
      }
      rgb2.gamma = rgbGamma;
      return rgb2;
    })(1);
    rgbBasis = rgbSpline(basis_default);
    rgbBasisClosed = rgbSpline(basisClosed_default);
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js
function numberArray_default(a4, b) {
  if (!b) b = [];
  var n = a4 ? Math.min(b.length, a4.length) : 0, c6 = b.slice(), i;
  return function(t) {
    for (i = 0; i < n; ++i) c6[i] = a4[i] * (1 - t) + b[i] * t;
    return c6;
  };
}
function isNumberArray(x4) {
  return ArrayBuffer.isView(x4) && !(x4 instanceof DataView);
}
var init_numberArray = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js
function array_default(a4, b) {
  return (isNumberArray(b) ? numberArray_default : genericArray)(a4, b);
}
function genericArray(a4, b) {
  var nb = b ? b.length : 0, na = a4 ? Math.min(nb, a4.length) : 0, x4 = new Array(na), c6 = new Array(nb), i;
  for (i = 0; i < na; ++i) x4[i] = value_default(a4[i], b[i]);
  for (; i < nb; ++i) c6[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i) c6[i] = x4[i](t);
    return c6;
  };
}
var init_array3 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js"() {
    init_value();
    init_numberArray();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js
function date_default(a4, b) {
  var d = /* @__PURE__ */ new Date();
  return a4 = +a4, b = +b, function(t) {
    return d.setTime(a4 * (1 - t) + b * t), d;
  };
}
var init_date = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js
function number_default(a4, b) {
  return a4 = +a4, b = +b, function(t) {
    return a4 * (1 - t) + b * t;
  };
}
var init_number2 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js
function object_default(a4, b) {
  var i = {}, c6 = {}, k2;
  if (a4 === null || typeof a4 !== "object") a4 = {};
  if (b === null || typeof b !== "object") b = {};
  for (k2 in b) {
    if (k2 in a4) {
      i[k2] = value_default(a4[k2], b[k2]);
    } else {
      c6[k2] = b[k2];
    }
  }
  return function(t) {
    for (k2 in i) c6[k2] = i[k2](t);
    return c6;
  };
}
var init_object = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js"() {
    init_value();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js
function zero2(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function string_default(a4, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q = [];
  a4 = a4 + "", b = b + "";
  while ((am = reA.exec(a4)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s2[i]) s2[i] += bs;
      else s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i]) s2[i] += bm;
      else s2[++i] = bm;
    } else {
      s2[++i] = null;
      q.push({ i, x: number_default(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s2[i]) s2[i] += bs;
    else s2[++i] = bs;
  }
  return s2.length < 2 ? q[0] ? one(q[0].x) : zero2(b) : (b = q.length, function(t) {
    for (var i2 = 0, o; i2 < b; ++i2) s2[(o = q[i2]).i] = o.x(t);
    return s2.join("");
  });
}
var reA, reB;
var init_string = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js"() {
    init_number2();
    reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
    reB = new RegExp(reA.source, "g");
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js
function value_default(a4, b) {
  var t = typeof b, c6;
  return b == null || t === "boolean" ? constant_default3(b) : (t === "number" ? number_default : t === "string" ? (c6 = color(b)) ? (b = c6, rgb_default) : string_default : b instanceof color ? rgb_default : b instanceof Date ? date_default : isNumberArray(b) ? numberArray_default : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object_default : number_default)(a4, b);
}
var init_value = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js"() {
    init_src7();
    init_rgb();
    init_array3();
    init_date();
    init_number2();
    init_object();
    init_string();
    init_constant4();
    init_numberArray();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/discrete.js
function discrete_default(range4) {
  var n = range4.length;
  return function(t) {
    return range4[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}
var init_discrete = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/discrete.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hue.js
function hue_default(a4, b) {
  var i = hue(+a4, +b);
  return function(t) {
    var x4 = i(t);
    return x4 - 360 * Math.floor(x4 / 360);
  };
}
var init_hue = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hue.js"() {
    init_color2();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js
function round_default(a4, b) {
  return a4 = +a4, b = +b, function(t) {
    return Math.round(a4 * (1 - t) + b * t);
  };
}
var init_round = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/decompose.js
function decompose_default(a4, b, c6, d, e, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a4 * a4 + b * b)) a4 /= scaleX, b /= scaleX;
  if (skewX = a4 * c6 + b * d) c6 -= a4 * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c6 * c6 + d * d)) c6 /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a4 * d < b * c6) a4 = -a4, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f2,
    rotate: Math.atan2(b, a4) * degrees2,
    skewX: Math.atan(skewX) * degrees2,
    scaleX,
    scaleY
  };
}
var degrees2, identity2;
var init_decompose = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/decompose.js"() {
    degrees2 = 180 / Math.PI;
    identity2 = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/parse.js
function parseCss(value) {
  const m3 = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m3.isIdentity ? identity2 : decompose_default(m3.a, m3.b, m3.c, m3.d, m3.e, m3.f);
}
function parseSvg(value) {
  if (value == null) return identity2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity2;
  value = value.matrix;
  return decompose_default(value.a, value.b, value.c, value.d, value.e, value.f);
}
var svgNode;
var init_parse = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/parse.js"() {
    init_decompose();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/index.js
function interpolateTransform(parse2, pxComma, pxParen, degParen) {
  function pop(s2) {
    return s2.length ? s2.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s2, q) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push("translate(", null, pxComma, null, pxParen);
      q.push({ i: i - 4, x: number_default(xa, xb) }, { i: i - 2, x: number_default(ya, yb) });
    } else if (xb || yb) {
      s2.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a4, b, s2, q) {
    if (a4 !== b) {
      if (a4 - b > 180) b += 360;
      else if (b - a4 > 180) a4 += 360;
      q.push({ i: s2.push(pop(s2) + "rotate(", null, degParen) - 2, x: number_default(a4, b) });
    } else if (b) {
      s2.push(pop(s2) + "rotate(" + b + degParen);
    }
  }
  function skewX(a4, b, s2, q) {
    if (a4 !== b) {
      q.push({ i: s2.push(pop(s2) + "skewX(", null, degParen) - 2, x: number_default(a4, b) });
    } else if (b) {
      s2.push(pop(s2) + "skewX(" + b + degParen);
    }
  }
  function scale2(xa, ya, xb, yb, s2, q) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push(pop(s2) + "scale(", null, ",", null, ")");
      q.push({ i: i - 4, x: number_default(xa, xb) }, { i: i - 2, x: number_default(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s2.push(pop(s2) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a4, b) {
    var s2 = [], q = [];
    a4 = parse2(a4), b = parse2(b);
    translate(a4.translateX, a4.translateY, b.translateX, b.translateY, s2, q);
    rotate(a4.rotate, b.rotate, s2, q);
    skewX(a4.skewX, b.skewX, s2, q);
    scale2(a4.scaleX, a4.scaleY, b.scaleX, b.scaleY, s2, q);
    a4 = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s2[(o = q[i]).i] = o.x(t);
      return s2.join("");
    };
  };
}
var interpolateTransformCss, interpolateTransformSvg;
var init_transform = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/index.js"() {
    init_number2();
    init_parse();
    interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
    interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/zoom.js
function cosh(x4) {
  return ((x4 = Math.exp(x4)) + 1 / x4) / 2;
}
function sinh(x4) {
  return ((x4 = Math.exp(x4)) - 1 / x4) / 2;
}
function tanh(x4) {
  return ((x4 = Math.exp(2 * x4)) - 1) / (x4 + 1);
}
var epsilon2, zoom_default;
var init_zoom = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/zoom.js"() {
    epsilon2 = 1e-12;
    zoom_default = (function zoomRho(rho, rho2, rho4) {
      function zoom(p02, p1) {
        var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        if (d2 < epsilon2) {
          S = Math.log(w1 / w0) / rho;
          i = function(t) {
            return [
              ux0 + t * dx,
              uy0 + t * dy,
              w0 * Math.exp(rho * t * S)
            ];
          };
        } else {
          var d1 = Math.sqrt(d2), b02 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b12 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b02 * b02 + 1) - b02), r1 = Math.log(Math.sqrt(b12 * b12 + 1) - b12);
          S = (r1 - r0) / rho;
          i = function(t) {
            var s2 = t * S, coshr0 = cosh(r0), u4 = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s2 + r0) - sinh(r0));
            return [
              ux0 + u4 * dx,
              uy0 + u4 * dy,
              w0 * coshr0 / cosh(rho * s2 + r0)
            ];
          };
        }
        i.duration = S * 1e3 * rho / Math.SQRT2;
        return i;
      }
      zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
      };
      return zoom;
    })(Math.SQRT2, 2, 4);
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hsl.js
function hsl2(hue2) {
  return function(start2, end) {
    var h = hue2((start2 = hsl(start2)).h, (end = hsl(end)).h), s2 = nogamma(start2.s, end.s), l = nogamma(start2.l, end.l), opacity = nogamma(start2.opacity, end.opacity);
    return function(t) {
      start2.h = h(t);
      start2.s = s2(t);
      start2.l = l(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  };
}
var hsl_default, hslLong;
var init_hsl = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hsl.js"() {
    init_src7();
    init_color2();
    hsl_default = hsl2(hue);
    hslLong = hsl2(nogamma);
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/lab.js
function lab2(start2, end) {
  var l = nogamma((start2 = lab(start2)).l, (end = lab(end)).l), a4 = nogamma(start2.a, end.a), b = nogamma(start2.b, end.b), opacity = nogamma(start2.opacity, end.opacity);
  return function(t) {
    start2.l = l(t);
    start2.a = a4(t);
    start2.b = b(t);
    start2.opacity = opacity(t);
    return start2 + "";
  };
}
var init_lab2 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/lab.js"() {
    init_src7();
    init_color2();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hcl.js
function hcl2(hue2) {
  return function(start2, end) {
    var h = hue2((start2 = hcl(start2)).h, (end = hcl(end)).h), c6 = nogamma(start2.c, end.c), l = nogamma(start2.l, end.l), opacity = nogamma(start2.opacity, end.opacity);
    return function(t) {
      start2.h = h(t);
      start2.c = c6(t);
      start2.l = l(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  };
}
var hcl_default, hclLong;
var init_hcl = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/hcl.js"() {
    init_src7();
    init_color2();
    hcl_default = hcl2(hue);
    hclLong = hcl2(nogamma);
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/cubehelix.js
function cubehelix2(hue2) {
  return (function cubehelixGamma(y4) {
    y4 = +y4;
    function cubehelix3(start2, end) {
      var h = hue2((start2 = cubehelix(start2)).h, (end = cubehelix(end)).h), s2 = nogamma(start2.s, end.s), l = nogamma(start2.l, end.l), opacity = nogamma(start2.opacity, end.opacity);
      return function(t) {
        start2.h = h(t);
        start2.s = s2(t);
        start2.l = l(Math.pow(t, y4));
        start2.opacity = opacity(t);
        return start2 + "";
      };
    }
    cubehelix3.gamma = cubehelixGamma;
    return cubehelix3;
  })(1);
}
var cubehelix_default, cubehelixLong;
var init_cubehelix2 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/cubehelix.js"() {
    init_src7();
    init_color2();
    cubehelix_default = cubehelix2(hue);
    cubehelixLong = cubehelix2(nogamma);
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/piecewise.js
function piecewise(interpolate, values) {
  if (values === void 0) values = interpolate, interpolate = value_default;
  var i = 0, n = values.length - 1, v2 = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v2, v2 = values[++i]);
  return function(t) {
    var i2 = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i2](t - i2);
  };
}
var init_piecewise = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/piecewise.js"() {
    init_value();
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/quantize.js
function quantize_default(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}
var init_quantize = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/quantize.js"() {
  }
});

// ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/index.js
var init_src8 = __esm({
  "../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/index.js"() {
    init_value();
    init_array3();
    init_basis();
    init_basisClosed();
    init_date();
    init_discrete();
    init_hue();
    init_number2();
    init_numberArray();
    init_object();
    init_round();
    init_string();
    init_transform();
    init_zoom();
    init_rgb();
    init_hsl();
    init_lab2();
    init_hcl();
    init_cubehelix2();
    init_piecewise();
    init_quantize();
  }
});

// ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timer.js
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
function timer(callback, delay, time2) {
  var t = new Timer();
  t.restart(callback, delay, time2);
  return t;
}
function timerFlush() {
  now();
  ++frame;
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(void 0, e);
    t = t._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t03, t13 = taskHead, t22, time2 = Infinity;
  while (t13) {
    if (t13._call) {
      if (time2 > t13._time) time2 = t13._time;
      t03 = t13, t13 = t13._next;
    } else {
      t22 = t13._next, t13._next = null;
      t13 = t03 ? t03._next = t22 : taskHead = t22;
    }
  }
  taskTail = t03;
  sleep(time2);
}
function sleep(time2) {
  if (frame) return;
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time2 - clockNow;
  if (delay > 24) {
    if (time2 < Infinity) timeout = setTimeout(wake, time2 - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
var frame, timeout, interval, pokeDelay, taskHead, taskTail, clockLast, clockNow, clockSkew, clock, setFrame;
var init_timer = __esm({
  "../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timer.js"() {
    frame = 0;
    timeout = 0;
    interval = 0;
    pokeDelay = 1e3;
    clockLast = 0;
    clockNow = 0;
    clockSkew = 0;
    clock = typeof performance === "object" && performance.now ? performance : Date;
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
      setTimeout(f2, 17);
    };
    Timer.prototype = timer.prototype = {
      constructor: Timer,
      restart: function(callback, delay, time2) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time2 = (time2 == null ? now() : +time2) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
          if (taskTail) taskTail._next = this;
          else taskHead = this;
          taskTail = this;
        }
        this._call = callback;
        this._time = time2;
        sleep();
      },
      stop: function() {
        if (this._call) {
          this._call = null;
          this._time = Infinity;
          sleep();
        }
      }
    };
  }
});

// ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timeout.js
function timeout_default(callback, delay, time2) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t;
}
var init_timeout = __esm({
  "../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timeout.js"() {
    init_timer();
  }
});

// ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/interval.js
function interval_default(callback, delay, time2) {
  var t = new Timer(), total = delay;
  if (delay == null) return t.restart(callback, delay, time2), t;
  t._restart = t.restart;
  t.restart = function(callback2, delay2, time3) {
    delay2 = +delay2, time3 = time3 == null ? now() : +time3;
    t._restart(function tick(elapsed) {
      elapsed += total;
      t._restart(tick, total += delay2, time3);
      callback2(elapsed);
    }, delay2, time3);
  };
  t.restart(callback, delay, time2);
  return t;
}
var init_interval = __esm({
  "../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/interval.js"() {
    init_timer();
  }
});

// ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/index.js
var init_src9 = __esm({
  "../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/index.js"() {
    init_timer();
    init_timeout();
    init_interval();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/schedule.js
function schedule_default(node, name, id2, index3, group2, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id2 in schedules) return;
  create(node, id2, {
    name,
    index: index3,
    // For context during callback.
    group: group2,
    // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}
function init(node, id2) {
  var schedule = get2(node, id2);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}
function set3(node, id2) {
  var schedule = get2(node, id2);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}
function get2(node, id2) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id2])) throw new Error("transition not found");
  return schedule;
}
function create(node, id2, self2) {
  var schedules = node.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer(schedule, 0, self2.time);
  function schedule(elapsed) {
    self2.state = SCHEDULED;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed) start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self2.state !== SCHEDULED) return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name) continue;
      if (o.state === STARTED) return timeout_default(start2);
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout_default(function() {
      if (self2.state === STARTED) {
        self2.state = RUNNING;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING;
    self2.on.call("start", node, node.__data__, self2.index, self2.group);
    if (self2.state !== STARTING) return;
    self2.state = STARTED;
    tween = new Array(n = self2.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self2.tween[i].value.call(node, node.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node, t);
    }
    if (self2.state === ENDING) {
      self2.on.call("end", node, node.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules) return;
    delete node.__transition;
  }
}
var emptyOn, emptyTween, CREATED, SCHEDULED, STARTING, STARTED, RUNNING, ENDING, ENDED;
var init_schedule = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/schedule.js"() {
    init_src4();
    init_src9();
    emptyOn = dispatch_default("start", "end", "cancel", "interrupt");
    emptyTween = [];
    CREATED = 0;
    SCHEDULED = 1;
    STARTING = 2;
    STARTED = 3;
    RUNNING = 4;
    ENDING = 5;
    ENDED = 6;
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/interrupt.js
function interrupt_default(node, name) {
  var schedules = node.__transition, schedule, active, empty4 = true, i;
  if (!schedules) return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) {
      empty4 = false;
      continue;
    }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }
  if (empty4) delete node.__transition;
}
var init_interrupt = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/interrupt.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/interrupt.js
function interrupt_default2(name) {
  return this.each(function() {
    interrupt_default(this, name);
  });
}
var init_interrupt2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/interrupt.js"() {
    init_interrupt();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/tween.js
function tweenRemove(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule = set3(this, id2), tween = schedule.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule.tween = tween1;
  };
}
function tweenFunction(id2, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error();
  return function() {
    var schedule = set3(this, id2), tween = schedule.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = { name, value }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }
    schedule.tween = tween1;
  };
}
function tween_default(name, value) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get2(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value == null ? tweenRemove : tweenFunction)(id2, name, value));
}
function tweenValue(transition2, name, value) {
  var id2 = transition2._id;
  transition2.each(function() {
    var schedule = set3(this, id2);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });
  return function(node) {
    return get2(node, id2).value[name];
  };
}
var init_tween = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/tween.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/interpolate.js
function interpolate_default(a4, b) {
  var c6;
  return (typeof b === "number" ? number_default : b instanceof color ? rgb_default : (c6 = color(b)) ? (b = c6, rgb_default) : string_default)(a4, b);
}
var init_interpolate = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/interpolate.js"() {
    init_src7();
    init_src8();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attr.js
function attrRemove2(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS2(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant2(name, interpolate, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}
function attrConstantNS2(fullname, interpolate, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}
function attrFunction2(name, interpolate, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}
function attrFunctionNS2(fullname, interpolate, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}
function attr_default2(name, value) {
  var fullname = namespace_default(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate_default;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS2 : attrFunction2)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS2 : attrRemove2)(fullname) : (fullname.local ? attrConstantNS2 : attrConstant2)(fullname, i, value));
}
var init_attr2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attr.js"() {
    init_src8();
    init_src5();
    init_tween();
    init_interpolate();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attrTween.js
function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS(fullname, value) {
  var t03, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t03 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t03;
  }
  tween._value = value;
  return tween;
}
function attrTween(name, value) {
  var t03, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t03 = (i0 = i) && attrInterpolate(name, i);
    return t03;
  }
  tween._value = value;
  return tween;
}
function attrTween_default(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  var fullname = namespace_default(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}
var init_attrTween = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attrTween.js"() {
    init_src5();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/delay.js
function delayFunction(id2, value) {
  return function() {
    init(this, id2).delay = +value.apply(this, arguments);
  };
}
function delayConstant(id2, value) {
  return value = +value, function() {
    init(this, id2).delay = value;
  };
}
function delay_default(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id2, value)) : get2(this.node(), id2).delay;
}
var init_delay = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/delay.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/duration.js
function durationFunction(id2, value) {
  return function() {
    set3(this, id2).duration = +value.apply(this, arguments);
  };
}
function durationConstant(id2, value) {
  return value = +value, function() {
    set3(this, id2).duration = value;
  };
}
function duration_default(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id2, value)) : get2(this.node(), id2).duration;
}
var init_duration = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/duration.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/ease.js
function easeConstant(id2, value) {
  if (typeof value !== "function") throw new Error();
  return function() {
    set3(this, id2).ease = value;
  };
}
function ease_default(value) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant(id2, value)) : get2(this.node(), id2).ease;
}
var init_ease = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/ease.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/easeVarying.js
function easeVarying(id2, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (typeof v2 !== "function") throw new Error();
    set3(this, id2).ease = v2;
  };
}
function easeVarying_default(value) {
  if (typeof value !== "function") throw new Error();
  return this.each(easeVarying(this._id, value));
}
var init_easeVarying = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/easeVarying.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/filter.js
function filter_default2(match) {
  if (typeof match !== "function") match = matcher_default(match);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = new Array(m3), j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group2[i]) && match.call(node, node.__data__, i, group2)) {
        subgroup.push(node);
      }
    }
  }
  return new Transition(subgroups, this._parents, this._name, this._id);
}
var init_filter3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/filter.js"() {
    init_src5();
    init_transition2();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/merge.js
function merge_default2(transition2) {
  if (transition2._id !== this._id) throw new Error();
  for (var groups0 = this._groups, groups1 = transition2._groups, m0 = groups0.length, m1 = groups1.length, m3 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m3; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge2[i] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition(merges, this._parents, this._name, this._id);
}
var init_merge3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/merge.js"() {
    init_transition2();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/on.js
function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction(id2, name, listener) {
  var on0, on1, sit = start(name) ? init : set3;
  return function() {
    var schedule = sit(this, id2), on = schedule.on;
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
    schedule.on = on1;
  };
}
function on_default2(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get2(this.node(), id2).on.on(name) : this.each(onFunction(id2, name, listener));
}
var init_on2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/on.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/remove.js
function removeFunction(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id2) return;
    if (parent) parent.removeChild(this);
  };
}
function remove_default2() {
  return this.on("end.remove", removeFunction(this._id));
}
var init_remove2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/remove.js"() {
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/select.js
function select_default3(select) {
  var name = this._name, id2 = this._id;
  if (typeof select !== "function") select = selector_default(select);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = new Array(m3), j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group2[i]) && (subnode = select.call(node, node.__data__, i, group2))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule_default(subgroup[i], name, id2, i, subgroup, get2(node, id2));
      }
    }
  }
  return new Transition(subgroups, this._parents, name, id2);
}
var init_select3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/select.js"() {
    init_src5();
    init_transition2();
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selectAll.js
function selectAll_default3(select) {
  var name = this._name, id2 = this._id;
  if (typeof select !== "function") select = selectorAll_default(select);
  for (var groups2 = this._groups, m3 = groups2.length, subgroups = [], parents = [], j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, node, i = 0; i < n; ++i) {
      if (node = group2[i]) {
        for (var children2 = select.call(node, node.__data__, i, group2), child, inherit2 = get2(node, id2), k2 = 0, l = children2.length; k2 < l; ++k2) {
          if (child = children2[k2]) {
            schedule_default(child, name, id2, k2, children2, inherit2);
          }
        }
        subgroups.push(children2);
        parents.push(node);
      }
    }
  }
  return new Transition(subgroups, parents, name, id2);
}
var init_selectAll3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selectAll.js"() {
    init_src5();
    init_transition2();
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selection.js
function selection_default2() {
  return new Selection2(this._groups, this._parents);
}
var Selection2;
var init_selection2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selection.js"() {
    init_src5();
    Selection2 = selection_default.prototype.constructor;
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/style.js
function styleNull(name, interpolate) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}
function styleRemove2(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant2(name, interpolate, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}
function styleFunction2(name, interpolate, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}
function styleMaybeRemove(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove2;
  return function() {
    var schedule = set3(this, id2), on = schedule.on, listener = schedule.value[key] == null ? remove2 || (remove2 = styleRemove2(name)) : void 0;
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule.on = on1;
  };
}
function style_default2(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate_default;
  return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove2(name)) : typeof value === "function" ? this.styleTween(name, styleFunction2(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant2(name, i, value), priority).on("end.style." + name, null);
}
var init_style2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/style.js"() {
    init_src8();
    init_src5();
    init_schedule();
    init_tween();
    init_interpolate();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/styleTween.js
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}
function styleTween_default(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}
var init_styleTween = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/styleTween.js"() {
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/text.js
function textConstant2(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction2(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function text_default2(value) {
  return this.tween("text", typeof value === "function" ? textFunction2(tweenValue(this, "text", value)) : textConstant2(value == null ? "" : value + ""));
}
var init_text2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/text.js"() {
    init_tween();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/textTween.js
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween(value) {
  var t03, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t03 = (i0 = i) && textInterpolate(i);
    return t03;
  }
  tween._value = value;
  return tween;
}
function textTween_default(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, textTween(value));
}
var init_textTween = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/textTween.js"() {
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/transition.js
function transition_default() {
  var name = this._name, id0 = this._id, id1 = newId();
  for (var groups2 = this._groups, m3 = groups2.length, j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, node, i = 0; i < n; ++i) {
      if (node = group2[i]) {
        var inherit2 = get2(node, id0);
        schedule_default(node, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition(groups2, this._parents, name, id1);
}
var init_transition = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/transition.js"() {
    init_transition2();
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/end.js
function end_default() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = { value: reject }, end = { value: function() {
      if (--size === 0) resolve();
    } };
    that.each(function() {
      var schedule = set3(this, id2), on = schedule.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }
      schedule.on = on1;
    });
    if (size === 0) resolve();
  });
}
var init_end = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/end.js"() {
    init_schedule();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/index.js
function Transition(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function transition(name) {
  return selection_default().transition(name);
}
function newId() {
  return ++id;
}
var id, selection_prototype;
var init_transition2 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/index.js"() {
    init_src5();
    init_attr2();
    init_attrTween();
    init_delay();
    init_duration();
    init_ease();
    init_easeVarying();
    init_filter3();
    init_merge3();
    init_on2();
    init_remove2();
    init_select3();
    init_selectAll3();
    init_selection2();
    init_style2();
    init_styleTween();
    init_text2();
    init_textTween();
    init_transition();
    init_tween();
    init_end();
    id = 0;
    selection_prototype = selection_default.prototype;
    Transition.prototype = transition.prototype = {
      constructor: Transition,
      select: select_default3,
      selectAll: selectAll_default3,
      selectChild: selection_prototype.selectChild,
      selectChildren: selection_prototype.selectChildren,
      filter: filter_default2,
      merge: merge_default2,
      selection: selection_default2,
      transition: transition_default,
      call: selection_prototype.call,
      nodes: selection_prototype.nodes,
      node: selection_prototype.node,
      size: selection_prototype.size,
      empty: selection_prototype.empty,
      each: selection_prototype.each,
      on: on_default2,
      attr: attr_default2,
      attrTween: attrTween_default,
      style: style_default2,
      styleTween: styleTween_default,
      text: text_default2,
      textTween: textTween_default,
      remove: remove_default2,
      tween: tween_default,
      delay: delay_default,
      duration: duration_default,
      ease: ease_default,
      easeVarying: easeVarying_default,
      end: end_default,
      [Symbol.iterator]: selection_prototype[Symbol.iterator]
    };
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/linear.js
var linear2;
var init_linear = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/linear.js"() {
    linear2 = (t) => +t;
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/quad.js
function quadIn(t) {
  return t * t;
}
function quadOut(t) {
  return t * (2 - t);
}
function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}
var init_quad = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/quad.js"() {
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/cubic.js
function cubicIn(t) {
  return t * t * t;
}
function cubicOut(t) {
  return --t * t * t + 1;
}
function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var init_cubic = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/cubic.js"() {
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/poly.js
var exponent, polyIn, polyOut, polyInOut;
var init_poly = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/poly.js"() {
    exponent = 3;
    polyIn = (function custom(e) {
      e = +e;
      function polyIn2(t) {
        return Math.pow(t, e);
      }
      polyIn2.exponent = custom;
      return polyIn2;
    })(exponent);
    polyOut = (function custom2(e) {
      e = +e;
      function polyOut2(t) {
        return 1 - Math.pow(1 - t, e);
      }
      polyOut2.exponent = custom2;
      return polyOut2;
    })(exponent);
    polyInOut = (function custom3(e) {
      e = +e;
      function polyInOut2(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
      }
      polyInOut2.exponent = custom3;
      return polyInOut2;
    })(exponent);
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/sin.js
function sinIn(t) {
  return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
  return Math.sin(t * halfPi);
}
function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}
var pi, halfPi;
var init_sin = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/sin.js"() {
    pi = Math.PI;
    halfPi = pi / 2;
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/math.js
function tpmt(x4) {
  return (Math.pow(2, -10 * x4) - 9765625e-10) * 1.0009775171065494;
}
var init_math2 = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/math.js"() {
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/exp.js
function expIn(t) {
  return tpmt(1 - +t);
}
function expOut(t) {
  return 1 - tpmt(t);
}
function expInOut(t) {
  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
}
var init_exp = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/exp.js"() {
    init_math2();
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/circle.js
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}
var init_circle = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/circle.js"() {
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/bounce.js
function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}
var b1, b2, b3, b4, b5, b6, b7, b8, b9, b0;
var init_bounce = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/bounce.js"() {
    b1 = 4 / 11;
    b2 = 6 / 11;
    b3 = 8 / 11;
    b4 = 3 / 4;
    b5 = 9 / 11;
    b6 = 10 / 11;
    b7 = 15 / 16;
    b8 = 21 / 22;
    b9 = 63 / 64;
    b0 = 1 / b1 / b1;
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/back.js
var overshoot, backIn, backOut, backInOut;
var init_back = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/back.js"() {
    overshoot = 1.70158;
    backIn = (function custom4(s2) {
      s2 = +s2;
      function backIn2(t) {
        return (t = +t) * t * (s2 * (t - 1) + t);
      }
      backIn2.overshoot = custom4;
      return backIn2;
    })(overshoot);
    backOut = (function custom5(s2) {
      s2 = +s2;
      function backOut2(t) {
        return --t * t * ((t + 1) * s2 + t) + 1;
      }
      backOut2.overshoot = custom5;
      return backOut2;
    })(overshoot);
    backInOut = (function custom6(s2) {
      s2 = +s2;
      function backInOut2(t) {
        return ((t *= 2) < 1 ? t * t * ((s2 + 1) * t - s2) : (t -= 2) * t * ((s2 + 1) * t + s2) + 2) / 2;
      }
      backInOut2.overshoot = custom6;
      return backInOut2;
    })(overshoot);
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/elastic.js
var tau, amplitude, period, elasticIn, elasticOut, elasticInOut;
var init_elastic = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/elastic.js"() {
    init_math2();
    tau = 2 * Math.PI;
    amplitude = 1;
    period = 0.3;
    elasticIn = (function custom7(a4, p) {
      var s2 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau);
      function elasticIn2(t) {
        return a4 * tpmt(- --t) * Math.sin((s2 - t) / p);
      }
      elasticIn2.amplitude = function(a5) {
        return custom7(a5, p * tau);
      };
      elasticIn2.period = function(p2) {
        return custom7(a4, p2);
      };
      return elasticIn2;
    })(amplitude, period);
    elasticOut = (function custom8(a4, p) {
      var s2 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau);
      function elasticOut2(t) {
        return 1 - a4 * tpmt(t = +t) * Math.sin((t + s2) / p);
      }
      elasticOut2.amplitude = function(a5) {
        return custom8(a5, p * tau);
      };
      elasticOut2.period = function(p2) {
        return custom8(a4, p2);
      };
      return elasticOut2;
    })(amplitude, period);
    elasticInOut = (function custom9(a4, p) {
      var s2 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau);
      function elasticInOut2(t) {
        return ((t = t * 2 - 1) < 0 ? a4 * tpmt(-t) * Math.sin((s2 - t) / p) : 2 - a4 * tpmt(t) * Math.sin((s2 + t) / p)) / 2;
      }
      elasticInOut2.amplitude = function(a5) {
        return custom9(a5, p * tau);
      };
      elasticInOut2.period = function(p2) {
        return custom9(a4, p2);
      };
      return elasticInOut2;
    })(amplitude, period);
  }
});

// ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/index.js
var init_src10 = __esm({
  "../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/index.js"() {
    init_linear();
    init_quad();
    init_cubic();
    init_poly();
    init_sin();
    init_exp();
    init_circle();
    init_bounce();
    init_back();
    init_elastic();
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/transition.js
function inherit(node, id2) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id2])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function transition_default2(name) {
  var id2, timing;
  if (name instanceof Transition) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m3 = groups2.length, j = 0; j < m3; ++j) {
    for (var group2 = groups2[j], n = group2.length, node, i = 0; i < n; ++i) {
      if (node = group2[i]) {
        schedule_default(node, name, id2, i, group2, timing || inherit(node, id2));
      }
    }
  }
  return new Transition(groups2, this._parents, name, id2);
}
var defaultTiming;
var init_transition3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/transition.js"() {
    init_transition2();
    init_schedule();
    init_src10();
    init_src9();
    defaultTiming = {
      time: null,
      // Set on use.
      delay: 0,
      duration: 250,
      ease: cubicInOut
    };
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/index.js
var init_selection3 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/index.js"() {
    init_src5();
    init_interrupt2();
    init_transition3();
    selection_default.prototype.interrupt = interrupt_default2;
    selection_default.prototype.transition = transition_default2;
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/active.js
function active_default(node, name) {
  var schedules = node.__transition, schedule, i;
  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root2, name, +i);
      }
    }
  }
  return null;
}
var root2;
var init_active = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/active.js"() {
    init_transition2();
    init_schedule();
    root2 = [null];
  }
});

// ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/index.js
var init_src11 = __esm({
  "../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/index.js"() {
    init_selection3();
    init_transition2();
    init_active();
    init_interrupt();
  }
});

// ../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/constant.js
var constant_default4;
var init_constant5 = __esm({
  "../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/constant.js"() {
    constant_default4 = (x4) => () => x4;
  }
});

// ../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/event.js
function BrushEvent(type2, {
  sourceEvent,
  target,
  selection: selection2,
  mode: mode2,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    selection: { value: selection2, enumerable: true, configurable: true },
    mode: { value: mode2, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
var init_event2 = __esm({
  "../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/event.js"() {
  }
});

// ../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/noevent.js
function nopropagation2(event) {
  event.stopImmediatePropagation();
}
function noevent_default2(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var init_noevent2 = __esm({
  "../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/noevent.js"() {
  }
});

// ../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/brush.js
function number1(e) {
  return [+e[0], +e[1]];
}
function number22(e) {
  return [number1(e[0]), number1(e[1])];
}
function type(t) {
  return { type: t };
}
function defaultFilter2(event) {
  return !event.ctrlKey && !event.button;
}
function defaultExtent() {
  var svg2 = this.ownerSVGElement || this;
  if (svg2.hasAttribute("viewBox")) {
    svg2 = svg2.viewBox.baseVal;
    return [[svg2.x, svg2.y], [svg2.x + svg2.width, svg2.y + svg2.height]];
  }
  return [[0, 0], [svg2.width.baseVal.value, svg2.height.baseVal.value]];
}
function defaultTouchable2() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function local2(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}
function empty3(extent2) {
  return extent2[0][0] === extent2[1][0] || extent2[0][1] === extent2[1][1];
}
function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}
function brushX() {
  return brush(X);
}
function brushY() {
  return brush(Y);
}
function brush_default() {
  return brush(XY);
}
function brush(dim) {
  var extent2 = defaultExtent, filter3 = defaultFilter2, touchable = defaultTouchable2, keys = true, listeners = dispatch_default("start", "brush", "end"), handleSize = 6, touchending;
  function brush2(group2) {
    var overlay = group2.property("__brush", initialize).selectAll(".overlay").data([type("overlay")]);
    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
      var extent3 = local2(this).extent;
      select_default2(this).attr("x", extent3[0][0]).attr("y", extent3[0][1]).attr("width", extent3[1][0] - extent3[0][0]).attr("height", extent3[1][1] - extent3[0][1]);
    });
    group2.selectAll(".selection").data([type("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var handle = group2.selectAll(".handle").data(dim.handles, function(d) {
      return d.type;
    });
    handle.exit().remove();
    handle.enter().append("rect").attr("class", function(d) {
      return "handle handle--" + d.type;
    }).attr("cursor", function(d) {
      return cursors[d.type];
    });
    group2.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  brush2.move = function(group2, selection2, event) {
    if (group2.tween) {
      group2.on("start.brush", function(event2) {
        emitter(this, arguments).beforestart().start(event2);
      }).on("interrupt.brush end.brush", function(event2) {
        emitter(this, arguments).end(event2);
      }).tween("brush", function() {
        var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(this, arguments) : selection2, state.extent), i = value_default(selection0, selection1);
        function tween(t) {
          state.selection = t === 1 && selection1 === null ? null : i(t);
          redraw.call(that);
          emit.brush();
        }
        return selection0 !== null && selection1 !== null ? tween : tween(1);
      });
    } else {
      group2.each(function() {
        var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(that, args) : selection2, state.extent), emit = emitter(that, args).beforestart();
        interrupt_default(that);
        state.selection = selection1 === null ? null : selection1;
        redraw.call(that);
        emit.start(event).brush(event).end(event);
      });
    }
  };
  brush2.clear = function(group2, event) {
    brush2.move(group2, null, event);
  };
  function redraw() {
    var group2 = select_default2(this), selection2 = local2(this).selection;
    if (selection2) {
      group2.selectAll(".selection").style("display", null).attr("x", selection2[0][0]).attr("y", selection2[0][1]).attr("width", selection2[1][0] - selection2[0][0]).attr("height", selection2[1][1] - selection2[0][1]);
      group2.selectAll(".handle").style("display", null).attr("x", function(d) {
        return d.type[d.type.length - 1] === "e" ? selection2[1][0] - handleSize / 2 : selection2[0][0] - handleSize / 2;
      }).attr("y", function(d) {
        return d.type[0] === "s" ? selection2[1][1] - handleSize / 2 : selection2[0][1] - handleSize / 2;
      }).attr("width", function(d) {
        return d.type === "n" || d.type === "s" ? selection2[1][0] - selection2[0][0] + handleSize : handleSize;
      }).attr("height", function(d) {
        return d.type === "e" || d.type === "w" ? selection2[1][1] - selection2[0][1] + handleSize : handleSize;
      });
    } else {
      group2.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
  }
  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }
  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }
  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode2) {
      if (this.starting) this.starting = false, this.emit("start", event, mode2);
      else this.emit("brush", event);
      return this;
    },
    brush: function(event, mode2) {
      this.emit("brush", event, mode2);
      return this;
    },
    end: function(event, mode2) {
      if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode2);
      return this;
    },
    emit: function(type2, event, mode2) {
      var d = select_default2(this.that).datum();
      listeners.call(
        type2,
        this.that,
        new BrushEvent(type2, {
          sourceEvent: event,
          target: brush2,
          selection: dim.output(this.state.selection),
          mode: mode2,
          dispatch: listeners
        }),
        d
      );
    }
  };
  function started(event) {
    if (touchending && !event.touches) return;
    if (!filter3.apply(this, arguments)) return;
    var that = this, type2 = event.target.__data__.type, mode2 = (keys && event.metaKey ? type2 = "overlay" : type2) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type2], signY = dim === X ? null : signsY[type2], state = local2(that), extent3 = state.extent, selection2 = state.selection, W = extent3[0][0], w0, w1, N = extent3[0][1], n0, n1, E2 = extent3[1][0], e0, e1, S = extent3[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [event], (t) => {
      const i = t.identifier;
      t = pointer_default(t, that);
      t.point0 = t.slice();
      t.identifier = i;
      return t;
    });
    interrupt_default(that);
    var emit = emitter(that, arguments, true).beforestart();
    if (type2 === "overlay") {
      if (selection2) moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection2 = [[
        w0 = dim === Y ? W : min2(pts[0][0], pts[1][0]),
        n0 = dim === X ? N : min2(pts[0][1], pts[1][1])
      ], [
        e0 = dim === Y ? E2 : max2(pts[0][0], pts[1][0]),
        s0 = dim === X ? S : max2(pts[0][1], pts[1][1])
      ]];
      if (points.length > 1) move(event);
    } else {
      w0 = selection2[0][0];
      n0 = selection2[0][1];
      e0 = selection2[1][0];
      s0 = selection2[1][1];
    }
    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;
    var group2 = select_default2(that).attr("pointer-events", "none");
    var overlay = group2.selectAll(".overlay").attr("cursor", cursors[type2]);
    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select_default2(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
      if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
      nodrag_default(event.view);
    }
    redraw.call(that);
    emit.start(event, mode2.name);
    function moved(event2) {
      for (const p of event2.changedTouches || [event2]) {
        for (const d of points)
          if (d.identifier === p.identifier) d.cur = pointer_default(p, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point6 = points[0];
        if (abs(point6.cur[0] - point6[0]) > abs(point6.cur[1] - point6[1]))
          lockY = true;
        else
          lockX = true;
      }
      for (const point6 of points)
        if (point6.cur) point6[0] = point6.cur[0], point6[1] = point6.cur[1];
      moving = true;
      noevent_default2(event2);
      move(event2);
    }
    function move(event2) {
      const point6 = points[0], point0 = point6.point0;
      var t;
      dx = point6[0] - point0[0];
      dy = point6[1] - point0[1];
      switch (mode2) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = max2(W - w0, min2(E2 - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = max2(N - n0, min2(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX) w1 = max2(W, min2(E2, points[0][0])), e1 = max2(W, min2(E2, points[1][0])), signX = 1;
            if (signY) n1 = max2(N, min2(S, points[0][1])), s1 = max2(N, min2(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0) dx = max2(W - w0, min2(E2 - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0) dx = max2(W - e0, min2(E2 - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0) dy = max2(N - n0, min2(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0) dy = max2(N - s0, min2(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = max2(W, min2(E2, w0 - dx * signX)), e1 = max2(W, min2(E2, e0 + dx * signX));
          if (signY) n1 = max2(N, min2(S, n0 - dy * signY)), s1 = max2(N, min2(S, s0 + dy * signY));
          break;
        }
      }
      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type2 in flipX) overlay.attr("cursor", cursors[type2 = flipX[type2]]);
      }
      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type2 in flipY) overlay.attr("cursor", cursors[type2 = flipY[type2]]);
      }
      if (state.selection) selection2 = state.selection;
      if (lockX) w1 = selection2[0][0], e1 = selection2[1][0];
      if (lockY) n1 = selection2[0][1], s1 = selection2[1][1];
      if (selection2[0][0] !== w1 || selection2[0][1] !== n1 || selection2[1][0] !== e1 || selection2[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event2, mode2.name);
      }
    }
    function ended(event2) {
      nopropagation2(event2);
      if (event2.touches) {
        if (event2.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
          touchending = null;
        }, 500);
      } else {
        yesdrag(event2.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group2.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection2 = state.selection;
      if (empty3(selection2)) state.selection = null, redraw.call(that);
      emit.end(event2, mode2.name);
    }
    function keydowned(event2) {
      switch (event2.keyCode) {
        case 16: {
          shifting = signX && signY;
          break;
        }
        case 18: {
          if (mode2 === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode2 = MODE_CENTER;
            move(event2);
          }
          break;
        }
        case 32: {
          if (mode2 === MODE_HANDLE || mode2 === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx;
            else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy;
            else if (signY > 0) n0 = n1 - dy;
            mode2 = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move(event2);
          }
          break;
        }
        default:
          return;
      }
      noevent_default2(event2);
    }
    function keyupped(event2) {
      switch (event2.keyCode) {
        case 16: {
          if (shifting) {
            lockX = lockY = shifting = false;
            move(event2);
          }
          break;
        }
        case 18: {
          if (mode2 === MODE_CENTER) {
            if (signX < 0) e0 = e1;
            else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1;
            else if (signY > 0) n0 = n1;
            mode2 = MODE_HANDLE;
            move(event2);
          }
          break;
        }
        case 32: {
          if (mode2 === MODE_SPACE) {
            if (event2.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode2 = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1;
              else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1;
              else if (signY > 0) n0 = n1;
              mode2 = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type2]);
            move(event2);
          }
          break;
        }
        default:
          return;
      }
      noevent_default2(event2);
    }
  }
  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }
  function touchended(event) {
    emitter(this, arguments).ended(event);
  }
  function initialize() {
    var state = this.__brush || { selection: null };
    state.extent = number22(extent2.apply(this, arguments));
    state.dim = dim;
    return state;
  }
  brush2.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant_default4(number22(_)), brush2) : extent2;
  };
  brush2.filter = function(_) {
    return arguments.length ? (filter3 = typeof _ === "function" ? _ : constant_default4(!!_), brush2) : filter3;
  };
  brush2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant_default4(!!_), brush2) : touchable;
  };
  brush2.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush2) : handleSize;
  };
  brush2.keyModifiers = function(_) {
    return arguments.length ? (keys = !!_, brush2) : keys;
  };
  brush2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush2 : value;
  };
  return brush2;
}
var MODE_DRAG, MODE_SPACE, MODE_HANDLE, MODE_CENTER, abs, max2, min2, X, Y, XY, cursors, flipX, flipY, signsX, signsY;
var init_brush = __esm({
  "../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/brush.js"() {
    init_src4();
    init_src6();
    init_src8();
    init_src5();
    init_src11();
    init_constant5();
    init_event2();
    init_noevent2();
    MODE_DRAG = { name: "drag" };
    MODE_SPACE = { name: "space" };
    MODE_HANDLE = { name: "handle" };
    MODE_CENTER = { name: "center" };
    ({ abs, max: max2, min: min2 } = Math);
    X = {
      name: "x",
      handles: ["w", "e"].map(type),
      input: function(x4, e) {
        return x4 == null ? null : [[+x4[0], e[0][1]], [+x4[1], e[1][1]]];
      },
      output: function(xy) {
        return xy && [xy[0][0], xy[1][0]];
      }
    };
    Y = {
      name: "y",
      handles: ["n", "s"].map(type),
      input: function(y4, e) {
        return y4 == null ? null : [[e[0][0], +y4[0]], [e[1][0], +y4[1]]];
      },
      output: function(xy) {
        return xy && [xy[0][1], xy[1][1]];
      }
    };
    XY = {
      name: "xy",
      handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type),
      input: function(xy) {
        return xy == null ? null : number22(xy);
      },
      output: function(xy) {
        return xy;
      }
    };
    cursors = {
      overlay: "crosshair",
      selection: "move",
      n: "ns-resize",
      e: "ew-resize",
      s: "ns-resize",
      w: "ew-resize",
      nw: "nwse-resize",
      ne: "nesw-resize",
      se: "nwse-resize",
      sw: "nesw-resize"
    };
    flipX = {
      e: "w",
      w: "e",
      nw: "ne",
      ne: "nw",
      se: "sw",
      sw: "se"
    };
    flipY = {
      n: "s",
      s: "n",
      nw: "sw",
      ne: "se",
      se: "ne",
      sw: "nw"
    };
    signsX = {
      overlay: 1,
      selection: 1,
      n: null,
      e: 1,
      s: null,
      w: -1,
      nw: -1,
      ne: 1,
      se: 1,
      sw: -1
    };
    signsY = {
      overlay: 1,
      selection: 1,
      n: -1,
      e: null,
      s: 1,
      w: null,
      nw: -1,
      ne: -1,
      se: 1,
      sw: 1
    };
  }
});

// ../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/index.js
var init_src12 = __esm({
  "../node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/index.js"() {
    init_brush();
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/math.js
var abs2, cos, sin, pi2, halfPi2, tau2, max3, epsilon3;
var init_math3 = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/math.js"() {
    abs2 = Math.abs;
    cos = Math.cos;
    sin = Math.sin;
    pi2 = Math.PI;
    halfPi2 = pi2 / 2;
    tau2 = pi2 * 2;
    max3 = Math.max;
    epsilon3 = 1e-12;
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/chord.js
function range2(i, j) {
  return Array.from({ length: j - i }, (_, k2) => i + k2);
}
function compareValue(compare) {
  return function(a4, b) {
    return compare(
      a4.source.value + a4.target.value,
      b.source.value + b.target.value
    );
  };
}
function chord_default() {
  return chord(false, false);
}
function chordTranspose() {
  return chord(false, true);
}
function chordDirected() {
  return chord(true, false);
}
function chord(directed, transpose2) {
  var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
  function chord2(matrix) {
    var n = matrix.length, groupSums = new Array(n), groupIndex = range2(0, n), chords = new Array(n * n), groups2 = new Array(n), k2 = 0, dx;
    matrix = Float64Array.from({ length: n * n }, transpose2 ? (_, i) => matrix[i % n][i / n | 0] : (_, i) => matrix[i / n | 0][i % n]);
    for (let i = 0; i < n; ++i) {
      let x4 = 0;
      for (let j = 0; j < n; ++j) x4 += matrix[i * n + j] + directed * matrix[j * n + i];
      k2 += groupSums[i] = x4;
    }
    k2 = max3(0, tau2 - padAngle * n) / k2;
    dx = k2 ? padAngle : tau2 / n;
    {
      let x4 = 0;
      if (sortGroups) groupIndex.sort((a4, b) => sortGroups(groupSums[a4], groupSums[b]));
      for (const i of groupIndex) {
        const x06 = x4;
        if (directed) {
          const subgroupIndex = range2(~n + 1, n).filter((j) => j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
          if (sortSubgroups) subgroupIndex.sort((a4, b) => sortSubgroups(a4 < 0 ? -matrix[~a4 * n + i] : matrix[i * n + a4], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
          for (const j of subgroupIndex) {
            if (j < 0) {
              const chord3 = chords[~j * n + i] || (chords[~j * n + i] = { source: null, target: null });
              chord3.target = { index: i, startAngle: x4, endAngle: x4 += matrix[~j * n + i] * k2, value: matrix[~j * n + i] };
            } else {
              const chord3 = chords[i * n + j] || (chords[i * n + j] = { source: null, target: null });
              chord3.source = { index: i, startAngle: x4, endAngle: x4 += matrix[i * n + j] * k2, value: matrix[i * n + j] };
            }
          }
          groups2[i] = { index: i, startAngle: x06, endAngle: x4, value: groupSums[i] };
        } else {
          const subgroupIndex = range2(0, n).filter((j) => matrix[i * n + j] || matrix[j * n + i]);
          if (sortSubgroups) subgroupIndex.sort((a4, b) => sortSubgroups(matrix[i * n + a4], matrix[i * n + b]));
          for (const j of subgroupIndex) {
            let chord3;
            if (i < j) {
              chord3 = chords[i * n + j] || (chords[i * n + j] = { source: null, target: null });
              chord3.source = { index: i, startAngle: x4, endAngle: x4 += matrix[i * n + j] * k2, value: matrix[i * n + j] };
            } else {
              chord3 = chords[j * n + i] || (chords[j * n + i] = { source: null, target: null });
              chord3.target = { index: i, startAngle: x4, endAngle: x4 += matrix[i * n + j] * k2, value: matrix[i * n + j] };
              if (i === j) chord3.source = chord3.target;
            }
            if (chord3.source && chord3.target && chord3.source.value < chord3.target.value) {
              const source = chord3.source;
              chord3.source = chord3.target;
              chord3.target = source;
            }
          }
          groups2[i] = { index: i, startAngle: x06, endAngle: x4, value: groupSums[i] };
        }
        x4 += dx;
      }
    }
    chords = Object.values(chords);
    chords.groups = groups2;
    return sortChords ? chords.sort(sortChords) : chords;
  }
  chord2.padAngle = function(_) {
    return arguments.length ? (padAngle = max3(0, _), chord2) : padAngle;
  };
  chord2.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord2) : sortGroups;
  };
  chord2.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord2) : sortSubgroups;
  };
  chord2.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord2) : sortChords && sortChords._;
  };
  return chord2;
}
var init_chord = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/chord.js"() {
    init_math3();
  }
});

// ../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js
function append(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d > 15) return append;
  const k2 = 10 ** d;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k2) / k2 + strings[i];
    }
  };
}
function path() {
  return new Path();
}
function pathRound(digits = 3) {
  return new Path(+digits);
}
var pi3, tau3, epsilon4, tauEpsilon, Path;
var init_path = __esm({
  "../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js"() {
    pi3 = Math.PI;
    tau3 = 2 * pi3;
    epsilon4 = 1e-6;
    tauEpsilon = tau3 - epsilon4;
    Path = class {
      constructor(digits) {
        this._x0 = this._y0 = // start of current subpath
        this._x1 = this._y1 = null;
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
      }
      moveTo(x4, y4) {
        this._append`M${this._x0 = this._x1 = +x4},${this._y0 = this._y1 = +y4}`;
      }
      closePath() {
        if (this._x1 !== null) {
          this._x1 = this._x0, this._y1 = this._y0;
          this._append`Z`;
        }
      }
      lineTo(x4, y4) {
        this._append`L${this._x1 = +x4},${this._y1 = +y4}`;
      }
      quadraticCurveTo(x12, y12, x4, y4) {
        this._append`Q${+x12},${+y12},${this._x1 = +x4},${this._y1 = +y4}`;
      }
      bezierCurveTo(x12, y12, x22, y22, x4, y4) {
        this._append`C${+x12},${+y12},${+x22},${+y22},${this._x1 = +x4},${this._y1 = +y4}`;
      }
      arcTo(x12, y12, x22, y22, r) {
        x12 = +x12, y12 = +y12, x22 = +x22, y22 = +y22, r = +r;
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x06 = this._x1, y06 = this._y1, x21 = x22 - x12, y21 = y22 - y12, x01 = x06 - x12, y01 = y06 - y12, l01_2 = x01 * x01 + y01 * y01;
        if (this._x1 === null) {
          this._append`M${this._x1 = x12},${this._y1 = y12}`;
        } else if (!(l01_2 > epsilon4)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon4) || !r) {
          this._append`L${this._x1 = x12},${this._y1 = y12}`;
        } else {
          let x20 = x22 - x06, y20 = y22 - y06, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi3 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
          if (Math.abs(t01 - 1) > epsilon4) {
            this._append`L${x12 + t01 * x01},${y12 + t01 * y01}`;
          }
          this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x12 + t21 * x21},${this._y1 = y12 + t21 * y21}`;
        }
      }
      arc(x4, y4, r, a0, a1, ccw) {
        x4 = +x4, y4 = +y4, r = +r, ccw = !!ccw;
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x06 = x4 + dx, y06 = y4 + dy, cw = 1 ^ ccw, da2 = ccw ? a0 - a1 : a1 - a0;
        if (this._x1 === null) {
          this._append`M${x06},${y06}`;
        } else if (Math.abs(this._x1 - x06) > epsilon4 || Math.abs(this._y1 - y06) > epsilon4) {
          this._append`L${x06},${y06}`;
        }
        if (!r) return;
        if (da2 < 0) da2 = da2 % tau3 + tau3;
        if (da2 > tauEpsilon) {
          this._append`A${r},${r},0,1,${cw},${x4 - dx},${y4 - dy}A${r},${r},0,1,${cw},${this._x1 = x06},${this._y1 = y06}`;
        } else if (da2 > epsilon4) {
          this._append`A${r},${r},0,${+(da2 >= pi3)},${cw},${this._x1 = x4 + r * Math.cos(a1)},${this._y1 = y4 + r * Math.sin(a1)}`;
        }
      }
      rect(x4, y4, w, h) {
        this._append`M${this._x0 = this._x1 = +x4},${this._y0 = this._y1 = +y4}h${w = +w}v${+h}h${-w}Z`;
      }
      toString() {
        return this._;
      }
    };
    path.prototype = Path.prototype;
  }
});

// ../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/index.js
var init_src13 = __esm({
  "../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/index.js"() {
    init_path();
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/array.js
var slice2;
var init_array4 = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/array.js"() {
    slice2 = Array.prototype.slice;
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/constant.js
function constant_default5(x4) {
  return function() {
    return x4;
  };
}
var init_constant6 = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/ribbon.js
function defaultSource(d) {
  return d.source;
}
function defaultTarget(d) {
  return d.target;
}
function defaultRadius(d) {
  return d.radius;
}
function defaultStartAngle(d) {
  return d.startAngle;
}
function defaultEndAngle(d) {
  return d.endAngle;
}
function defaultPadAngle() {
  return 0;
}
function defaultArrowheadRadius() {
  return 10;
}
function ribbon(headRadius) {
  var source = defaultSource, target = defaultTarget, sourceRadius = defaultRadius, targetRadius = defaultRadius, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
  function ribbon2() {
    var buffer, s2 = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s2, argv)), sa0 = startAngle.apply(this, argv) - halfPi2, sa1 = endAngle.apply(this, argv) - halfPi2, tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - halfPi2, ta1 = endAngle.apply(this, argv) - halfPi2;
    if (!context) context = buffer = path();
    if (ap > epsilon3) {
      if (abs2(sa1 - sa0) > ap * 2 + epsilon3) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
      else sa0 = sa1 = (sa0 + sa1) / 2;
      if (abs2(ta1 - ta0) > ap * 2 + epsilon3) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
      else ta0 = ta1 = (ta0 + ta1) / 2;
    }
    context.moveTo(sr * cos(sa0), sr * sin(sa0));
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) {
      if (headRadius) {
        var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
        context.quadraticCurveTo(0, 0, tr2 * cos(ta0), tr2 * sin(ta0));
        context.lineTo(tr * cos(ta2), tr * sin(ta2));
        context.lineTo(tr2 * cos(ta1), tr2 * sin(ta1));
      } else {
        context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
        context.arc(0, 0, tr, ta0, ta1);
      }
    }
    context.quadraticCurveTo(0, 0, sr * cos(sa0), sr * sin(sa0));
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  if (headRadius) ribbon2.headRadius = function(_) {
    return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : headRadius;
  };
  ribbon2.radius = function(_) {
    return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : sourceRadius;
  };
  ribbon2.sourceRadius = function(_) {
    return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : sourceRadius;
  };
  ribbon2.targetRadius = function(_) {
    return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : targetRadius;
  };
  ribbon2.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : startAngle;
  };
  ribbon2.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : endAngle;
  };
  ribbon2.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant_default5(+_), ribbon2) : padAngle;
  };
  ribbon2.source = function(_) {
    return arguments.length ? (source = _, ribbon2) : source;
  };
  ribbon2.target = function(_) {
    return arguments.length ? (target = _, ribbon2) : target;
  };
  ribbon2.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, ribbon2) : context;
  };
  return ribbon2;
}
function ribbon_default() {
  return ribbon();
}
function ribbonArrow() {
  return ribbon(defaultArrowheadRadius);
}
var init_ribbon = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/ribbon.js"() {
    init_src13();
    init_array4();
    init_constant6();
    init_math3();
  }
});

// ../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/index.js
var init_src14 = __esm({
  "../node_modules/.pnpm/d3-chord@3.0.1/node_modules/d3-chord/src/index.js"() {
    init_chord();
    init_ribbon();
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/array.js
var array3, slice3;
var init_array5 = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/array.js"() {
    array3 = Array.prototype;
    slice3 = array3.slice;
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/ascending.js
function ascending_default(a4, b) {
  return a4 - b;
}
var init_ascending2 = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/ascending.js"() {
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/area.js
function area_default(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
}
var init_area = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/area.js"() {
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/constant.js
var constant_default6;
var init_constant7 = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/constant.js"() {
    constant_default6 = (x4) => () => x4;
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/contains.js
function contains_default(ring, hole) {
  var i = -1, n = hole.length, c6;
  while (++i < n) if (c6 = ringContains(ring, hole[i])) return c6;
  return 0;
}
function ringContains(ring, point6) {
  var x4 = point6[0], y4 = point6[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi6 = ring[i], xi = pi6[0], yi = pi6[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi6, pj, point6)) return 0;
    if (yi > y4 !== yj > y4 && x4 < (xj - xi) * (y4 - yi) / (yj - yi) + xi) contains = -contains;
  }
  return contains;
}
function segmentContains(a4, b, c6) {
  var i;
  return collinear(a4, b, c6) && within(a4[i = +(a4[0] === b[0])], c6[i], b[i]);
}
function collinear(a4, b, c6) {
  return (b[0] - a4[0]) * (c6[1] - a4[1]) === (c6[0] - a4[0]) * (b[1] - a4[1]);
}
function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}
var init_contains = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/contains.js"() {
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/noop.js
function noop_default() {
}
var init_noop = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/noop.js"() {
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/contours.js
function contours_default() {
  var dx = 1, dy = 1, threshold2 = thresholdSturges, smooth = smoothLinear;
  function contours(values) {
    var tz = threshold2(values);
    if (!Array.isArray(tz)) {
      const e = extent(values, finite);
      tz = ticks(...nice(e[0], e[1], tz), tz);
      while (tz[tz.length - 1] >= e[1]) tz.pop();
      while (tz[1] < e[0]) tz.shift();
    } else {
      tz = tz.slice().sort(ascending_default);
    }
    return tz.map((value) => contour(values, value));
  }
  function contour(values, value) {
    const v2 = value == null ? NaN : +value;
    if (isNaN(v2)) throw new Error(`invalid value: ${value}`);
    var polygons = [], holes = [];
    isorings(values, v2, function(ring) {
      smooth(ring, values, v2);
      if (area_default(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });
    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (contains_default((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });
    return {
      type: "MultiPolygon",
      value,
      coordinates: polygons
    };
  }
  function isorings(values, value, callback) {
    var fragmentByStart = new Array(), fragmentByEnd = new Array(), x4, y4, t03, t13, t22, t32;
    x4 = y4 = -1;
    t13 = above(values[0], value);
    cases[t13 << 1].forEach(stitch);
    while (++x4 < dx - 1) {
      t03 = t13, t13 = above(values[x4 + 1], value);
      cases[t03 | t13 << 1].forEach(stitch);
    }
    cases[t13 << 0].forEach(stitch);
    while (++y4 < dy - 1) {
      x4 = -1;
      t13 = above(values[y4 * dx + dx], value);
      t22 = above(values[y4 * dx], value);
      cases[t13 << 1 | t22 << 2].forEach(stitch);
      while (++x4 < dx - 1) {
        t03 = t13, t13 = above(values[y4 * dx + dx + x4 + 1], value);
        t32 = t22, t22 = above(values[y4 * dx + x4 + 1], value);
        cases[t03 | t13 << 1 | t22 << 2 | t32 << 3].forEach(stitch);
      }
      cases[t13 | t22 << 3].forEach(stitch);
    }
    x4 = -1;
    t22 = values[y4 * dx] >= value;
    cases[t22 << 2].forEach(stitch);
    while (++x4 < dx - 1) {
      t32 = t22, t22 = above(values[y4 * dx + x4 + 1], value);
      cases[t22 << 2 | t32 << 3].forEach(stitch);
    }
    cases[t22 << 3].forEach(stitch);
    function stitch(line) {
      var start2 = [line[0][0] + x4, line[0][1] + y4], end = [line[1][0] + x4, line[1][1] + y4], startIndex = index3(start2), endIndex = index3(end), f2, g;
      if (f2 = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f2.end];
          delete fragmentByStart[g.start];
          if (f2 === g) {
            f2.ring.push(end);
            callback(f2.ring);
          } else {
            fragmentByStart[f2.start] = fragmentByEnd[g.end] = { start: f2.start, end: g.end, ring: f2.ring.concat(g.ring) };
          }
        } else {
          delete fragmentByEnd[f2.end];
          f2.ring.push(end);
          fragmentByEnd[f2.end = endIndex] = f2;
        }
      } else if (f2 = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f2.start];
          delete fragmentByEnd[g.end];
          if (f2 === g) {
            f2.ring.push(end);
            callback(f2.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f2.end] = { start: g.start, end: f2.end, ring: g.ring.concat(f2.ring) };
          }
        } else {
          delete fragmentByStart[f2.start];
          f2.ring.unshift(start2);
          fragmentByStart[f2.start = startIndex] = f2;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = { start: startIndex, end: endIndex, ring: [start2, end] };
      }
    }
  }
  function index3(point6) {
    return point6[0] * 2 + point6[1] * (dx + 1) * 4;
  }
  function smoothLinear(ring, values, value) {
    ring.forEach(function(point6) {
      var x4 = point6[0], y4 = point6[1], xt = x4 | 0, yt = y4 | 0, v12 = valid(values[yt * dx + xt]);
      if (x4 > 0 && x4 < dx && xt === x4) {
        point6[0] = smooth1(x4, valid(values[yt * dx + xt - 1]), v12, value);
      }
      if (y4 > 0 && y4 < dy && yt === y4) {
        point6[1] = smooth1(y4, valid(values[(yt - 1) * dx + xt]), v12, value);
      }
    });
  }
  contours.contour = contour;
  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
    if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };
  contours.thresholds = function(_) {
    return arguments.length ? (threshold2 = typeof _ === "function" ? _ : Array.isArray(_) ? constant_default6(slice3.call(_)) : constant_default6(_), contours) : threshold2;
  };
  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : noop_default, contours) : smooth === smoothLinear;
  };
  return contours;
}
function finite(x4) {
  return isFinite(x4) ? x4 : NaN;
}
function above(x4, value) {
  return x4 == null ? false : +x4 >= value;
}
function valid(v2) {
  return v2 == null || isNaN(v2 = +v2) ? -Infinity : v2;
}
function smooth1(x4, v0, v12, value) {
  const a4 = value - v0;
  const b = v12 - v0;
  const d = isFinite(a4) || isFinite(b) ? a4 / b : Math.sign(a4) / Math.sign(b);
  return isNaN(d) ? x4 : x4 + d - 0.5;
}
var cases;
var init_contours = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/contours.js"() {
    init_src2();
    init_array5();
    init_ascending2();
    init_area();
    init_constant7();
    init_contains();
    init_noop();
    cases = [
      [],
      [[[1, 1.5], [0.5, 1]]],
      [[[1.5, 1], [1, 1.5]]],
      [[[1.5, 1], [0.5, 1]]],
      [[[1, 0.5], [1.5, 1]]],
      [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]],
      [[[1, 0.5], [1, 1.5]]],
      [[[1, 0.5], [0.5, 1]]],
      [[[0.5, 1], [1, 0.5]]],
      [[[1, 1.5], [1, 0.5]]],
      [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]],
      [[[1.5, 1], [1, 0.5]]],
      [[[0.5, 1], [1.5, 1]]],
      [[[1, 1.5], [1.5, 1]]],
      [[[0.5, 1], [1, 1.5]]],
      []
    ];
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/density.js
function defaultX(d) {
  return d[0];
}
function defaultY(d) {
  return d[1];
}
function defaultWeight() {
  return 1;
}
function density_default() {
  var x4 = defaultX, y4 = defaultY, weight = defaultWeight, dx = 960, dy = 500, r = 20, k2 = 2, o = r * 3, n = dx + o * 2 >> k2, m3 = dy + o * 2 >> k2, threshold2 = constant_default6(20);
  function grid(data) {
    var values = new Float32Array(n * m3), pow2k = Math.pow(2, -k2), i = -1;
    for (const d of data) {
      var xi = (x4(d, ++i, data) + o) * pow2k, yi = (y4(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
      if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m3) {
        var x06 = Math.floor(xi), y06 = Math.floor(yi), xt = xi - x06 - 0.5, yt = yi - y06 - 0.5;
        values[x06 + y06 * n] += (1 - xt) * (1 - yt) * wi;
        values[x06 + 1 + y06 * n] += xt * (1 - yt) * wi;
        values[x06 + 1 + (y06 + 1) * n] += xt * yt * wi;
        values[x06 + (y06 + 1) * n] += (1 - xt) * yt * wi;
      }
    }
    blur2({ data: values, width: n, height: m3 }, r * pow2k);
    return values;
  }
  function density(data) {
    var values = grid(data), tz = threshold2(values), pow4k = Math.pow(2, 2 * k2);
    if (!Array.isArray(tz)) {
      tz = ticks(Number.MIN_VALUE, max(values) / pow4k, tz);
    }
    return contours_default().size([n, m3]).thresholds(tz.map((d) => d * pow4k))(values).map((c6, i) => (c6.value = +tz[i], transform2(c6)));
  }
  density.contours = function(data) {
    var values = grid(data), contours = contours_default().size([n, m3]), pow4k = Math.pow(2, 2 * k2), contour = (value) => {
      value = +value;
      var c6 = transform2(contours.contour(values, value * pow4k));
      c6.value = value;
      return c6;
    };
    Object.defineProperty(contour, "max", { get: () => max(values) / pow4k });
    return contour;
  };
  function transform2(geometry) {
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }
  function transformPolygon(coordinates2) {
    coordinates2.forEach(transformRing);
  }
  function transformRing(coordinates2) {
    coordinates2.forEach(transformPoint);
  }
  function transformPoint(coordinates2) {
    coordinates2[0] = coordinates2[0] * Math.pow(2, k2) - o;
    coordinates2[1] = coordinates2[1] * Math.pow(2, k2) - o;
  }
  function resize() {
    o = r * 3;
    n = dx + o * 2 >> k2;
    m3 = dy + o * 2 >> k2;
    return density;
  }
  density.x = function(_) {
    return arguments.length ? (x4 = typeof _ === "function" ? _ : constant_default6(+_), density) : x4;
  };
  density.y = function(_) {
    return arguments.length ? (y4 = typeof _ === "function" ? _ : constant_default6(+_), density) : y4;
  };
  density.weight = function(_) {
    return arguments.length ? (weight = typeof _ === "function" ? _ : constant_default6(+_), density) : weight;
  };
  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = +_[0], _1 = +_[1];
    if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };
  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k2;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k2 = Math.floor(Math.log(_) / Math.LN2), resize();
  };
  density.thresholds = function(_) {
    return arguments.length ? (threshold2 = typeof _ === "function" ? _ : Array.isArray(_) ? constant_default6(slice3.call(_)) : constant_default6(_), density) : threshold2;
  };
  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
  };
  return density;
}
var init_density = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/density.js"() {
    init_src2();
    init_array5();
    init_constant7();
    init_contours();
  }
});

// ../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/index.js
var init_src15 = __esm({
  "../node_modules/.pnpm/d3-contour@4.0.2/node_modules/d3-contour/src/index.js"() {
    init_contours();
    init_density();
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/util.js
function sum2(elen, e, flen, f2, h) {
  let Q, Qnew, hh, bvirt;
  let enow = e[0];
  let fnow = f2[0];
  let eindex = 0;
  let findex = 0;
  if (fnow > enow === fnow > -enow) {
    Q = enow;
    enow = e[++eindex];
  } else {
    Q = fnow;
    fnow = f2[++findex];
  }
  let hindex = 0;
  if (eindex < elen && findex < flen) {
    if (fnow > enow === fnow > -enow) {
      Qnew = enow + Q;
      hh = Q - (Qnew - enow);
      enow = e[++eindex];
    } else {
      Qnew = fnow + Q;
      hh = Q - (Qnew - fnow);
      fnow = f2[++findex];
    }
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
    while (eindex < elen && findex < flen) {
      if (fnow > enow === fnow > -enow) {
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
      } else {
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f2[++findex];
      }
      Q = Qnew;
      if (hh !== 0) {
        h[hindex++] = hh;
      }
    }
  }
  while (eindex < elen) {
    Qnew = Q + enow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (enow - bvirt);
    enow = e[++eindex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  while (findex < flen) {
    Qnew = Q + fnow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
    fnow = f2[++findex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  if (Q !== 0 || hindex === 0) {
    h[hindex++] = Q;
  }
  return hindex;
}
function estimate(elen, e) {
  let Q = e[0];
  for (let i = 1; i < elen; i++) Q += e[i];
  return Q;
}
function vec(n) {
  return new Float64Array(n);
}
var epsilon5, splitter, resulterrbound;
var init_util = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/util.js"() {
    epsilon5 = 11102230246251565e-32;
    splitter = 134217729;
    resulterrbound = (3 + 8 * epsilon5) * epsilon5;
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/orient2d.js
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
  let acxtail, acytail, bcxtail, bcytail;
  let bvirt, c6, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t13, t03, u32;
  const acx = ax - cx;
  const bcx = bx - cx;
  const acy = ay - cy;
  const bcy = by - cy;
  s1 = acx * bcy;
  c6 = splitter * acx;
  ahi = c6 - (c6 - acx);
  alo = acx - ahi;
  c6 = splitter * bcy;
  bhi = c6 - (c6 - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t13 = acy * bcx;
  c6 = splitter * acy;
  ahi = c6 - (c6 - acy);
  alo = acy - ahi;
  c6 = splitter * bcx;
  bhi = c6 - (c6 - bcx);
  blo = bcx - bhi;
  t03 = alo * blo - (t13 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t03;
  bvirt = s0 - _i;
  B2[0] = s0 - (_i + bvirt) + (bvirt - t03);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t13;
  bvirt = _0 - _i;
  B2[1] = _0 - (_i + bvirt) + (bvirt - t13);
  u32 = _j + _i;
  bvirt = u32 - _j;
  B2[2] = _j - (u32 - bvirt) + (_i - bvirt);
  B2[3] = u32;
  let det = estimate(4, B2);
  let errbound = ccwerrboundB * detsum;
  if (det >= errbound || -det >= errbound) {
    return det;
  }
  bvirt = ax - acx;
  acxtail = ax - (acx + bvirt) + (bvirt - cx);
  bvirt = bx - bcx;
  bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
  bvirt = ay - acy;
  acytail = ay - (acy + bvirt) + (bvirt - cy);
  bvirt = by - bcy;
  bcytail = by - (bcy + bvirt) + (bvirt - cy);
  if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
    return det;
  }
  errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
  det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
  if (det >= errbound || -det >= errbound) return det;
  s1 = acxtail * bcy;
  c6 = splitter * acxtail;
  ahi = c6 - (c6 - acxtail);
  alo = acxtail - ahi;
  c6 = splitter * bcy;
  bhi = c6 - (c6 - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t13 = acytail * bcx;
  c6 = splitter * acytail;
  ahi = c6 - (c6 - acytail);
  alo = acytail - ahi;
  c6 = splitter * bcx;
  bhi = c6 - (c6 - bcx);
  blo = bcx - bhi;
  t03 = alo * blo - (t13 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t03;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t03);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t13;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t13);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const C1len = sum2(4, B2, 4, u, C1);
  s1 = acx * bcytail;
  c6 = splitter * acx;
  ahi = c6 - (c6 - acx);
  alo = acx - ahi;
  c6 = splitter * bcytail;
  bhi = c6 - (c6 - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t13 = acy * bcxtail;
  c6 = splitter * acy;
  ahi = c6 - (c6 - acy);
  alo = acy - ahi;
  c6 = splitter * bcxtail;
  bhi = c6 - (c6 - bcxtail);
  blo = bcxtail - bhi;
  t03 = alo * blo - (t13 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t03;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t03);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t13;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t13);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const C2len = sum2(C1len, C1, 4, u, C2);
  s1 = acxtail * bcytail;
  c6 = splitter * acxtail;
  ahi = c6 - (c6 - acxtail);
  alo = acxtail - ahi;
  c6 = splitter * bcytail;
  bhi = c6 - (c6 - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t13 = acytail * bcxtail;
  c6 = splitter * acytail;
  ahi = c6 - (c6 - acytail);
  alo = acytail - ahi;
  c6 = splitter * bcxtail;
  bhi = c6 - (c6 - bcxtail);
  blo = bcxtail - bhi;
  t03 = alo * blo - (t13 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t03;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t03);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t13;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t13);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const Dlen = sum2(C2len, C2, 4, u, D2);
  return D2[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
  const detleft = (ay - cy) * (bx - cx);
  const detright = (ax - cx) * (by - cy);
  const det = detleft - detright;
  const detsum = Math.abs(detleft + detright);
  if (Math.abs(det) >= ccwerrboundA * detsum) return det;
  return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
var ccwerrboundA, ccwerrboundB, ccwerrboundC, B2, C1, C2, D2, u;
var init_orient2d = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/orient2d.js"() {
    init_util();
    ccwerrboundA = (3 + 16 * epsilon5) * epsilon5;
    ccwerrboundB = (2 + 12 * epsilon5) * epsilon5;
    ccwerrboundC = (9 + 64 * epsilon5) * epsilon5 * epsilon5;
    B2 = vec(4);
    C1 = vec(8);
    C2 = vec(12);
    D2 = vec(16);
    u = vec(4);
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/orient3d.js
var o3derrboundA, o3derrboundB, o3derrboundC, bc, ca, ab, at_b, at_c, bt_c, bt_a, ct_a, ct_b, bct, cat, abt, u2, _8, _8b, _16, _12, fin, fin2;
var init_orient3d = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/orient3d.js"() {
    init_util();
    o3derrboundA = (7 + 56 * epsilon5) * epsilon5;
    o3derrboundB = (3 + 28 * epsilon5) * epsilon5;
    o3derrboundC = (26 + 288 * epsilon5) * epsilon5 * epsilon5;
    bc = vec(4);
    ca = vec(4);
    ab = vec(4);
    at_b = vec(4);
    at_c = vec(4);
    bt_c = vec(4);
    bt_a = vec(4);
    ct_a = vec(4);
    ct_b = vec(4);
    bct = vec(8);
    cat = vec(8);
    abt = vec(8);
    u2 = vec(4);
    _8 = vec(8);
    _8b = vec(8);
    _16 = vec(16);
    _12 = vec(12);
    fin = vec(192);
    fin2 = vec(192);
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/incircle.js
var iccerrboundA, iccerrboundB, iccerrboundC, bc2, ca2, ab2, aa, bb, cc, u3, v, axtbc, aytbc, bxtca, bytca, cxtab, cytab, abt2, bct2, cat2, abtt, bctt, catt, _82, _162, _16b, _16c, _32, _32b, _48, _64, fin3, fin22;
var init_incircle = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/incircle.js"() {
    init_util();
    iccerrboundA = (10 + 96 * epsilon5) * epsilon5;
    iccerrboundB = (4 + 48 * epsilon5) * epsilon5;
    iccerrboundC = (44 + 576 * epsilon5) * epsilon5 * epsilon5;
    bc2 = vec(4);
    ca2 = vec(4);
    ab2 = vec(4);
    aa = vec(4);
    bb = vec(4);
    cc = vec(4);
    u3 = vec(4);
    v = vec(4);
    axtbc = vec(8);
    aytbc = vec(8);
    bxtca = vec(8);
    bytca = vec(8);
    cxtab = vec(8);
    cytab = vec(8);
    abt2 = vec(8);
    bct2 = vec(8);
    cat2 = vec(8);
    abtt = vec(4);
    bctt = vec(4);
    catt = vec(4);
    _82 = vec(8);
    _162 = vec(16);
    _16b = vec(16);
    _16c = vec(16);
    _32 = vec(32);
    _32b = vec(32);
    _48 = vec(48);
    _64 = vec(64);
    fin3 = vec(1152);
    fin22 = vec(1152);
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/insphere.js
var isperrboundA, isperrboundB, isperrboundC, ab3, bc3, cd, de, ea, ac, bd, ce, da, eb, abc, bcd, cde, dea, eab, abd, bce, cda, deb, eac, adet, bdet, cdet, ddet, edet, abdet, cddet, cdedet, deter, _83, _8b2, _8c, _163, _24, _482, _48b, _96, _192, _384x, _384y, _384z, _768, xdet, ydet, zdet, fin4;
var init_insphere = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/esm/insphere.js"() {
    init_util();
    isperrboundA = (16 + 224 * epsilon5) * epsilon5;
    isperrboundB = (5 + 72 * epsilon5) * epsilon5;
    isperrboundC = (71 + 1408 * epsilon5) * epsilon5 * epsilon5;
    ab3 = vec(4);
    bc3 = vec(4);
    cd = vec(4);
    de = vec(4);
    ea = vec(4);
    ac = vec(4);
    bd = vec(4);
    ce = vec(4);
    da = vec(4);
    eb = vec(4);
    abc = vec(24);
    bcd = vec(24);
    cde = vec(24);
    dea = vec(24);
    eab = vec(24);
    abd = vec(24);
    bce = vec(24);
    cda = vec(24);
    deb = vec(24);
    eac = vec(24);
    adet = vec(1152);
    bdet = vec(1152);
    cdet = vec(1152);
    ddet = vec(1152);
    edet = vec(1152);
    abdet = vec(2304);
    cddet = vec(2304);
    cdedet = vec(3456);
    deter = vec(5760);
    _83 = vec(8);
    _8b2 = vec(8);
    _8c = vec(8);
    _163 = vec(16);
    _24 = vec(24);
    _482 = vec(48);
    _48b = vec(48);
    _96 = vec(96);
    _192 = vec(192);
    _384x = vec(384);
    _384y = vec(384);
    _384z = vec(384);
    _768 = vec(768);
    xdet = vec(96);
    ydet = vec(96);
    zdet = vec(96);
    fin4 = vec(1152);
  }
});

// ../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/index.js
var init_robust_predicates = __esm({
  "../node_modules/.pnpm/robust-predicates@3.0.3/node_modules/robust-predicates/index.js"() {
    init_orient2d();
    init_orient3d();
    init_incircle();
    init_insphere();
  }
});

// ../node_modules/.pnpm/delaunator@5.1.0/node_modules/delaunator/index.js
function pseudoAngle(dx, dy) {
  const p = dx / (Math.abs(dx) + Math.abs(dy));
  return (dy > 0 ? 3 - p : 1 + p) / 4;
}
function dist(ax, ay, bx, by) {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
  const dx = ax - px;
  const dy = ay - py;
  const ex = bx - px;
  const ey = by - py;
  const fx = cx - px;
  const fy = cy - py;
  const ap = dx * dx + dy * dy;
  const bp = ex * ex + ey * ey;
  const cp = fx * fx + fy * fy;
  return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d = 0.5 / (dx * ey - dy * ex);
  const x4 = (ey * bl - dy * cl) * d;
  const y4 = (dx * cl - ex * bl) * d;
  return x4 * x4 + y4 * y4;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d = 0.5 / (dx * ey - dy * ex);
  const x4 = ax + (ey * bl - dy * cl) * d;
  const y4 = ay + (dx * cl - ex * bl) * d;
  return { x: x4, y: y4 };
}
function quicksort(ids, dists, left2, right2) {
  if (right2 - left2 <= 20) {
    for (let i = left2 + 1; i <= right2; i++) {
      const temp = ids[i];
      const tempDist = dists[temp];
      let j = i - 1;
      while (j >= left2 && dists[ids[j]] > tempDist) ids[j + 1] = ids[j--];
      ids[j + 1] = temp;
    }
  } else {
    const median2 = left2 + right2 >> 1;
    let i = left2 + 1;
    let j = right2;
    swap2(ids, median2, i);
    if (dists[ids[left2]] > dists[ids[right2]]) swap2(ids, left2, right2);
    if (dists[ids[i]] > dists[ids[right2]]) swap2(ids, i, right2);
    if (dists[ids[left2]] > dists[ids[i]]) swap2(ids, left2, i);
    const temp = ids[i];
    const tempDist = dists[temp];
    while (true) {
      do
        i++;
      while (dists[ids[i]] < tempDist);
      do
        j--;
      while (dists[ids[j]] > tempDist);
      if (j < i) break;
      swap2(ids, i, j);
    }
    ids[left2 + 1] = ids[j];
    ids[j] = temp;
    if (right2 - i + 1 >= j - left2) {
      quicksort(ids, dists, i, right2);
      quicksort(ids, dists, left2, j - 1);
    } else {
      quicksort(ids, dists, left2, j - 1);
      quicksort(ids, dists, i, right2);
    }
  }
}
function swap2(arr, i, j) {
  const tmp = arr[i];
  arr[i] = arr[j];
  arr[j] = tmp;
}
function defaultGetX(p) {
  return p[0];
}
function defaultGetY(p) {
  return p[1];
}
var EPSILON, EDGE_STACK, Delaunator;
var init_delaunator = __esm({
  "../node_modules/.pnpm/delaunator@5.1.0/node_modules/delaunator/index.js"() {
    init_robust_predicates();
    EPSILON = Math.pow(2, -52);
    EDGE_STACK = new Uint32Array(512);
    Delaunator = class _Delaunator {
      /**
       * Constructs a delaunay triangulation object given an array of points (`[x, y]` by default).
       * `getX` and `getY` are optional functions of the form `(point) => value` for custom point formats.
       *
       * @template P
       * @param {P[]} points
       * @param {(p: P) => number} [getX]
       * @param {(p: P) => number} [getY]
       */
      // @ts-expect-error TS2322
      static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for (let i = 0; i < n; i++) {
          const p = points[i];
          coords[2 * i] = getX(p);
          coords[2 * i + 1] = getY(p);
        }
        return new _Delaunator(coords);
      }
      /**
       * Constructs a delaunay triangulation object given an array of point coordinates of the form:
       * `[x0, y0, x1, y1, ...]` (use a typed array for best performance). Duplicate points are skipped.
       *
       * @param {T} coords
       */
      constructor(coords) {
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n);
        this._hullNext = new Uint32Array(n);
        this._hullTri = new Uint32Array(n);
        this._hullHash = new Int32Array(this._hashSize);
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.trianglesLen = 0;
        this._cx = 0;
        this._cy = 0;
        this._hullStart = 0;
        this.hull = this._triangles;
        this.triangles = this._triangles;
        this.halfedges = this._halfedges;
        this.update();
      }
      /**
       * Updates the triangulation if you modified `delaunay.coords` values in place, avoiding expensive memory allocations.
       * Useful for iterative relaxation algorithms such as Lloyd's.
       */
      update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY2 = -Infinity;
        for (let i = 0; i < n; i++) {
          const x4 = coords[2 * i];
          const y4 = coords[2 * i + 1];
          if (x4 < minX) minX = x4;
          if (y4 < minY) minY = y4;
          if (x4 > maxX) maxX = x4;
          if (y4 > maxY2) maxY2 = y4;
          this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY2) / 2;
        let i0 = 0, i1 = 0, i2 = 0;
        for (let i = 0, minDist = Infinity; i < n; i++) {
          const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
          if (d < minDist) {
            i0 = i;
            minDist = d;
          }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        for (let i = 0, minDist = Infinity; i < n; i++) {
          if (i === i0) continue;
          const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
          if (d < minDist && d > 0) {
            i1 = i;
            minDist = d;
          }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        for (let i = 0; i < n; i++) {
          if (i === i0 || i === i1) continue;
          const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
          if (r < minRadius) {
            i2 = i;
            minRadius = r;
          }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
          for (let i = 0; i < n; i++) {
            this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
          }
          quicksort(this._ids, this._dists, 0, n - 1);
          const hull = new Uint32Array(n);
          let j = 0;
          for (let i = 0, d0 = -Infinity; i < n; i++) {
            const id2 = this._ids[i];
            const d = this._dists[id2];
            if (d > d0) {
              hull[j++] = id2;
              d0 = d;
            }
          }
          this.hull = hull.subarray(0, j);
          this.triangles = new Uint32Array(0);
          this.halfedges = new Int32Array(0);
          return;
        }
        if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
          const i = i1;
          const x4 = i1x;
          const y4 = i1y;
          i1 = i2;
          i1x = i2x;
          i1y = i2y;
          i2 = i;
          i2x = x4;
          i2y = y4;
        }
        const center2 = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center2.x;
        this._cy = center2.y;
        for (let i = 0; i < n; i++) {
          this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center2.x, center2.y);
        }
        quicksort(this._ids, this._dists, 0, n - 1);
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for (let k2 = 0, xp = 0, yp = 0; k2 < this._ids.length; k2++) {
          const i = this._ids[k2];
          const x4 = coords[2 * i];
          const y4 = coords[2 * i + 1];
          if (k2 > 0 && Math.abs(x4 - xp) <= EPSILON && Math.abs(y4 - yp) <= EPSILON) continue;
          xp = x4;
          yp = y4;
          if (i === i0 || i === i1 || i === i2) continue;
          let start2 = 0;
          for (let j = 0, key = this._hashKey(x4, y4); j < this._hashSize; j++) {
            start2 = hullHash[(key + j) % this._hashSize];
            if (start2 !== -1 && start2 !== hullNext[start2]) break;
          }
          start2 = hullPrev[start2];
          let e = start2, q;
          while (q = hullNext[e], orient2d(x4, y4, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0) {
            e = q;
            if (e === start2) {
              e = -1;
              break;
            }
          }
          if (e === -1) continue;
          let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
          hullTri[i] = this._legalize(t + 2);
          hullTri[e] = t;
          hullSize++;
          let n2 = hullNext[e];
          while (q = hullNext[n2], orient2d(x4, y4, coords[2 * n2], coords[2 * n2 + 1], coords[2 * q], coords[2 * q + 1]) < 0) {
            t = this._addTriangle(n2, i, q, hullTri[i], -1, hullTri[n2]);
            hullTri[i] = this._legalize(t + 2);
            hullNext[n2] = n2;
            hullSize--;
            n2 = q;
          }
          if (e === start2) {
            while (q = hullPrev[e], orient2d(x4, y4, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0) {
              t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
              this._legalize(t + 2);
              hullTri[q] = t;
              hullNext[e] = e;
              hullSize--;
              e = q;
            }
          }
          this._hullStart = hullPrev[i] = e;
          hullNext[e] = hullPrev[n2] = i;
          hullNext[i] = n2;
          hullHash[this._hashKey(x4, y4)] = i;
          hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for (let i = 0, e = this._hullStart; i < hullSize; i++) {
          this.hull[i] = e;
          e = hullNext[e];
        }
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
      }
      /**
       * Calculate an angle-based key for the edge hash used for advancing convex hull.
       *
       * @param {number} x
       * @param {number} y
       * @private
       */
      _hashKey(x4, y4) {
        return Math.floor(pseudoAngle(x4 - this._cx, y4 - this._cy) * this._hashSize) % this._hashSize;
      }
      /**
       * Flip an edge in a pair of triangles if it doesn't satisfy the Delaunay condition.
       *
       * @param {number} a
       * @private
       */
      _legalize(a4) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        while (true) {
          const b = halfedges[a4];
          const a0 = a4 - a4 % 3;
          ar = a0 + (a4 + 2) % 3;
          if (b === -1) {
            if (i === 0) break;
            a4 = EDGE_STACK[--i];
            continue;
          }
          const b02 = b - b % 3;
          const al = a0 + (a4 + 1) % 3;
          const bl = b02 + (b + 2) % 3;
          const p02 = triangles[ar];
          const pr = triangles[a4];
          const pl = triangles[al];
          const p1 = triangles[bl];
          const illegal = inCircle(
            coords[2 * p02],
            coords[2 * p02 + 1],
            coords[2 * pr],
            coords[2 * pr + 1],
            coords[2 * pl],
            coords[2 * pl + 1],
            coords[2 * p1],
            coords[2 * p1 + 1]
          );
          if (illegal) {
            triangles[a4] = p1;
            triangles[b] = p02;
            const hbl = halfedges[bl];
            if (hbl === -1) {
              let e = this._hullStart;
              do {
                if (this._hullTri[e] === bl) {
                  this._hullTri[e] = a4;
                  break;
                }
                e = this._hullPrev[e];
              } while (e !== this._hullStart);
            }
            this._link(a4, hbl);
            this._link(b, halfedges[ar]);
            this._link(ar, bl);
            const br = b02 + (b + 1) % 3;
            if (i < EDGE_STACK.length) {
              EDGE_STACK[i++] = br;
            }
          } else {
            if (i === 0) break;
            a4 = EDGE_STACK[--i];
          }
        }
        return ar;
      }
      /**
       * Link two half-edges to each other.
       * @param {number} a
       * @param {number} b
       * @private
       */
      _link(a4, b) {
        this._halfedges[a4] = b;
        if (b !== -1) this._halfedges[b] = a4;
      }
      /**
       * Add a new triangle given vertex indices and adjacent half-edge ids.
       *
       * @param {number} i0
       * @param {number} i1
       * @param {number} i2
       * @param {number} a
       * @param {number} b
       * @param {number} c
       * @private
       */
      _addTriangle(i0, i1, i2, a4, b, c6) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a4);
        this._link(t + 1, b);
        this._link(t + 2, c6);
        this.trianglesLen += 3;
        return t;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/path.js
var epsilon6, Path2;
var init_path2 = __esm({
  "../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/path.js"() {
    epsilon6 = 1e-6;
    Path2 = class {
      constructor() {
        this._x0 = this._y0 = // start of current subpath
        this._x1 = this._y1 = null;
        this._ = "";
      }
      moveTo(x4, y4) {
        this._ += `M${this._x0 = this._x1 = +x4},${this._y0 = this._y1 = +y4}`;
      }
      closePath() {
        if (this._x1 !== null) {
          this._x1 = this._x0, this._y1 = this._y0;
          this._ += "Z";
        }
      }
      lineTo(x4, y4) {
        this._ += `L${this._x1 = +x4},${this._y1 = +y4}`;
      }
      arc(x4, y4, r) {
        x4 = +x4, y4 = +y4, r = +r;
        const x06 = x4 + r;
        const y06 = y4;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x06},${y06}`;
        else if (Math.abs(this._x1 - x06) > epsilon6 || Math.abs(this._y1 - y06) > epsilon6) this._ += "L" + x06 + "," + y06;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x4 - r},${y4}A${r},${r},0,1,1,${this._x1 = x06},${this._y1 = y06}`;
      }
      rect(x4, y4, w, h) {
        this._ += `M${this._x0 = this._x1 = +x4},${this._y0 = this._y1 = +y4}h${+w}v${+h}h${-w}Z`;
      }
      value() {
        return this._ || null;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/polygon.js
var Polygon;
var init_polygon = __esm({
  "../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/polygon.js"() {
    Polygon = class {
      constructor() {
        this._ = [];
      }
      moveTo(x4, y4) {
        this._.push([x4, y4]);
      }
      closePath() {
        this._.push(this._[0].slice());
      }
      lineTo(x4, y4) {
        this._.push([x4, y4]);
      }
      value() {
        return this._.length ? this._ : null;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/voronoi.js
var Voronoi;
var init_voronoi = __esm({
  "../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/voronoi.js"() {
    init_path2();
    init_polygon();
    Voronoi = class {
      constructor(delaunay, [xmin, ymin, xmax, ymax] = [0, 0, 960, 500]) {
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
      }
      update() {
        this.delaunay.update();
        this._init();
        return this;
      }
      _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by;
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for (let i = 0, j = 0, n = triangles.length, x4, y4; i < n; i += 3, j += 2) {
          const t13 = triangles[i] * 2;
          const t22 = triangles[i + 1] * 2;
          const t32 = triangles[i + 2] * 2;
          const x13 = points[t13];
          const y13 = points[t13 + 1];
          const x22 = points[t22];
          const y22 = points[t22 + 1];
          const x32 = points[t32];
          const y32 = points[t32 + 1];
          const dx = x22 - x13;
          const dy = y22 - y13;
          const ex = x32 - x13;
          const ey = y32 - y13;
          const ab4 = (dx * ey - dy * ex) * 2;
          if (Math.abs(ab4) < 1e-9) {
            if (bx === void 0) {
              bx = by = 0;
              for (const i2 of hull) bx += points[i2 * 2], by += points[i2 * 2 + 1];
              bx /= hull.length, by /= hull.length;
            }
            const a4 = 1e9 * Math.sign((bx - x13) * ey - (by - y13) * ex);
            x4 = (x13 + x32) / 2 - a4 * ey;
            y4 = (y13 + y32) / 2 + a4 * ex;
          } else {
            const d = 1 / ab4;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            x4 = x13 + (ey * bl - dy * cl) * d;
            y4 = y13 + (dx * cl - ex * bl) * d;
          }
          circumcenters[j] = x4;
          circumcenters[j + 1] = y4;
        }
        let h = hull[hull.length - 1];
        let p02, p1 = h * 4;
        let x06, x12 = points[2 * h];
        let y06, y12 = points[2 * h + 1];
        vectors.fill(0);
        for (let i = 0; i < hull.length; ++i) {
          h = hull[i];
          p02 = p1, x06 = x12, y06 = y12;
          p1 = h * 4, x12 = points[2 * h], y12 = points[2 * h + 1];
          vectors[p02 + 2] = vectors[p1] = y06 - y12;
          vectors[p02 + 3] = vectors[p1 + 1] = x12 - x06;
        }
      }
      render(context) {
        const buffer = context == null ? context = new Path2() : void 0;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for (let i = 0, n = halfedges.length; i < n; ++i) {
          const j = halfedges[i];
          if (j < i) continue;
          const ti = Math.floor(i / 3) * 2;
          const tj = Math.floor(j / 3) * 2;
          const xi = circumcenters[ti];
          const yi = circumcenters[ti + 1];
          const xj = circumcenters[tj];
          const yj = circumcenters[tj + 1];
          this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for (let i = 0; i < hull.length; ++i) {
          h0 = h1, h1 = hull[i];
          const t = Math.floor(inedges[h1] / 3) * 2;
          const x4 = circumcenters[t];
          const y4 = circumcenters[t + 1];
          const v2 = h0 * 4;
          const p = this._project(x4, y4, vectors[v2 + 2], vectors[v2 + 3]);
          if (p) this._renderSegment(x4, y4, p[0], p[1], context);
        }
        return buffer && buffer.value();
      }
      renderBounds(context) {
        const buffer = context == null ? context = new Path2() : void 0;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
      }
      renderCell(i, context) {
        const buffer = context == null ? context = new Path2() : void 0;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while (points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1) n -= 2;
        for (let i2 = 2; i2 < n; i2 += 2) {
          if (points[i2] !== points[i2 - 2] || points[i2 + 1] !== points[i2 - 1])
            context.lineTo(points[i2], points[i2 + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
      }
      *cellPolygons() {
        const { delaunay: { points } } = this;
        for (let i = 0, n = points.length / 2; i < n; ++i) {
          const cell = this.cellPolygon(i);
          if (cell) cell.index = i, yield cell;
        }
      }
      cellPolygon(i) {
        const polygon = new Polygon();
        this.renderCell(i, polygon);
        return polygon.value();
      }
      _renderSegment(x06, y06, x12, y12, context) {
        let S;
        const c0 = this._regioncode(x06, y06);
        const c1 = this._regioncode(x12, y12);
        if (c0 === 0 && c1 === 0) {
          context.moveTo(x06, y06);
          context.lineTo(x12, y12);
        } else if (S = this._clipSegment(x06, y06, x12, y12, c0, c1)) {
          context.moveTo(S[0], S[1]);
          context.lineTo(S[2], S[3]);
        }
      }
      contains(i, x4, y4) {
        if ((x4 = +x4, x4 !== x4) || (y4 = +y4, y4 !== y4)) return false;
        return this.delaunay._step(i, x4, y4) === i;
      }
      *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)) {
          const cj = this._clip(j);
          if (cj) loop: for (let ai = 0, li = ci.length; ai < li; ai += 2) {
            for (let aj = 0, lj = cj.length; aj < lj; aj += 2) {
              if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                yield j;
                break loop;
              }
            }
          }
        }
      }
      _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null;
        const points = [];
        let e = e0;
        do {
          const t = Math.floor(e / 3);
          points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
          e = e % 3 === 2 ? e - 2 : e + 1;
          if (triangles[e] !== i) break;
          e = halfedges[e];
        } while (e !== e0 && e !== -1);
        return points;
      }
      _clip(i) {
        if (i === 0 && this.delaunay.hull.length === 1) {
          return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
        }
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v2 = i * 4;
        return this._simplify(V[v2] || V[v2 + 1] ? this._clipInfinite(i, points, V[v2], V[v2 + 1], V[v2 + 2], V[v2 + 3]) : this._clipFinite(i, points));
      }
      _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x06, y06, x12 = points[n - 2], y12 = points[n - 1];
        let c0, c1 = this._regioncode(x12, y12);
        let e0, e1 = 0;
        for (let j = 0; j < n; j += 2) {
          x06 = x12, y06 = y12, x12 = points[j], y12 = points[j + 1];
          c0 = c1, c1 = this._regioncode(x12, y12);
          if (c0 === 0 && c1 === 0) {
            e0 = e1, e1 = 0;
            if (P) P.push(x12, y12);
            else P = [x12, y12];
          } else {
            let S, sx0, sy0, sx1, sy1;
            if (c0 === 0) {
              if ((S = this._clipSegment(x06, y06, x12, y12, c0, c1)) === null) continue;
              [sx0, sy0, sx1, sy1] = S;
            } else {
              if ((S = this._clipSegment(x12, y12, x06, y06, c1, c0)) === null) continue;
              [sx1, sy1, sx0, sy0] = S;
              e0 = e1, e1 = this._edgecode(sx0, sy0);
              if (e0 && e1) this._edge(i, e0, e1, P, P.length);
              if (P) P.push(sx0, sy0);
              else P = [sx0, sy0];
            }
            e0 = e1, e1 = this._edgecode(sx1, sy1);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            if (P) P.push(sx1, sy1);
            else P = [sx1, sy1];
          }
        }
        if (P) {
          e0 = e1, e1 = this._edgecode(P[0], P[1]);
          if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
          return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
        }
        return P;
      }
      _clipSegment(x06, y06, x12, y12, c0, c1) {
        const flip = c0 < c1;
        if (flip) [x06, y06, x12, y12, c0, c1] = [x12, y12, x06, y06, c1, c0];
        while (true) {
          if (c0 === 0 && c1 === 0) return flip ? [x12, y12, x06, y06] : [x06, y06, x12, y12];
          if (c0 & c1) return null;
          let x4, y4, c6 = c0 || c1;
          if (c6 & 8) x4 = x06 + (x12 - x06) * (this.ymax - y06) / (y12 - y06), y4 = this.ymax;
          else if (c6 & 4) x4 = x06 + (x12 - x06) * (this.ymin - y06) / (y12 - y06), y4 = this.ymin;
          else if (c6 & 2) y4 = y06 + (y12 - y06) * (this.xmax - x06) / (x12 - x06), x4 = this.xmax;
          else y4 = y06 + (y12 - y06) * (this.xmin - x06) / (x12 - x06), x4 = this.xmin;
          if (c0) x06 = x4, y06 = y4, c0 = this._regioncode(x06, y06);
          else x12 = x4, y12 = y4, c1 = this._regioncode(x12, y12);
        }
      }
      _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) {
          for (let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2) {
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
          }
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
          P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
        }
        return P;
      }
      _edge(i, e0, e1, P, j) {
        while (e0 !== e1) {
          let x4, y4;
          switch (e0) {
            case 5:
              e0 = 4;
              continue;
            // top-left
            case 4:
              e0 = 6, x4 = this.xmax, y4 = this.ymin;
              break;
            // top
            case 6:
              e0 = 2;
              continue;
            // top-right
            case 2:
              e0 = 10, x4 = this.xmax, y4 = this.ymax;
              break;
            // right
            case 10:
              e0 = 8;
              continue;
            // bottom-right
            case 8:
              e0 = 9, x4 = this.xmin, y4 = this.ymax;
              break;
            // bottom
            case 9:
              e0 = 1;
              continue;
            // bottom-left
            case 1:
              e0 = 5, x4 = this.xmin, y4 = this.ymin;
              break;
          }
          if ((P[j] !== x4 || P[j + 1] !== y4) && this.contains(i, x4, y4)) {
            P.splice(j, 0, x4, y4), j += 2;
          }
        }
        return j;
      }
      _project(x06, y06, vx, vy) {
        let t = Infinity, c6, x4, y4;
        if (vy < 0) {
          if (y06 <= this.ymin) return null;
          if ((c6 = (this.ymin - y06) / vy) < t) y4 = this.ymin, x4 = x06 + (t = c6) * vx;
        } else if (vy > 0) {
          if (y06 >= this.ymax) return null;
          if ((c6 = (this.ymax - y06) / vy) < t) y4 = this.ymax, x4 = x06 + (t = c6) * vx;
        }
        if (vx > 0) {
          if (x06 >= this.xmax) return null;
          if ((c6 = (this.xmax - x06) / vx) < t) x4 = this.xmax, y4 = y06 + (t = c6) * vy;
        } else if (vx < 0) {
          if (x06 <= this.xmin) return null;
          if ((c6 = (this.xmin - x06) / vx) < t) x4 = this.xmin, y4 = y06 + (t = c6) * vy;
        }
        return [x4, y4];
      }
      _edgecode(x4, y4) {
        return (x4 === this.xmin ? 1 : x4 === this.xmax ? 2 : 0) | (y4 === this.ymin ? 4 : y4 === this.ymax ? 8 : 0);
      }
      _regioncode(x4, y4) {
        return (x4 < this.xmin ? 1 : x4 > this.xmax ? 2 : 0) | (y4 < this.ymin ? 4 : y4 > this.ymax ? 8 : 0);
      }
      _simplify(P) {
        if (P && P.length > 4) {
          for (let i = 0; i < P.length; i += 2) {
            const j = (i + 2) % P.length, k2 = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k2] || P[i + 1] === P[j + 1] && P[j + 1] === P[k2 + 1]) {
              P.splice(j, 2), i -= 2;
            }
          }
          if (!P.length) P = null;
        }
        return P;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/delaunay.js
function pointX(p) {
  return p[0];
}
function pointY(p) {
  return p[1];
}
function collinear2(d) {
  const { triangles, coords } = d;
  for (let i = 0; i < triangles.length; i += 3) {
    const a4 = 2 * triangles[i], b = 2 * triangles[i + 1], c6 = 2 * triangles[i + 2], cross2 = (coords[c6] - coords[a4]) * (coords[b + 1] - coords[a4 + 1]) - (coords[b] - coords[a4]) * (coords[c6 + 1] - coords[a4 + 1]);
    if (cross2 > 1e-10) return false;
  }
  return true;
}
function jitter(x4, y4, r) {
  return [x4 + Math.sin(x4 + y4) * r, y4 + Math.cos(x4 - y4) * r];
}
function flatArray(points, fx, fy, that) {
  const n = points.length;
  const array4 = new Float64Array(n * 2);
  for (let i = 0; i < n; ++i) {
    const p = points[i];
    array4[i * 2] = fx.call(that, p, i, points);
    array4[i * 2 + 1] = fy.call(that, p, i, points);
  }
  return array4;
}
function* flatIterable(points, fx, fy, that) {
  let i = 0;
  for (const p of points) {
    yield fx.call(that, p, i, points);
    yield fy.call(that, p, i, points);
    ++i;
  }
}
var tau4, pow, Delaunay;
var init_delaunay = __esm({
  "../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/delaunay.js"() {
    init_delaunator();
    init_path2();
    init_polygon();
    init_voronoi();
    tau4 = 2 * Math.PI;
    pow = Math.pow;
    Delaunay = class _Delaunay {
      static from(points, fx = pointX, fy = pointY, that) {
        return new _Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
      }
      constructor(points) {
        this._delaunator = new Delaunator(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
      }
      update() {
        this._delaunator.update();
        this._init();
        return this;
      }
      _init() {
        const d = this._delaunator, points = this.points;
        if (d.hull && d.hull.length > 2 && collinear2(d)) {
          this.collinear = Int32Array.from({ length: points.length / 2 }, (_, i) => i).sort((i, j) => points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]);
          const e = this.collinear[0], f2 = this.collinear[this.collinear.length - 1], bounds = [points[2 * e], points[2 * e + 1], points[2 * f2], points[2 * f2 + 1]], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
          for (let i = 0, n = points.length / 2; i < n; ++i) {
            const p = jitter(points[2 * i], points[2 * i + 1], r);
            points[2 * i] = p[0];
            points[2 * i + 1] = p[1];
          }
          this._delaunator = new Delaunator(points);
        } else {
          delete this.collinear;
        }
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        for (let e = 0, n = halfedges.length; e < n; ++e) {
          const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
          if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for (let i = 0, n = hull.length; i < n; ++i) {
          hullIndex[hull[i]] = i;
        }
        if (hull.length <= 2 && hull.length > 0) {
          this.triangles = new Int32Array(3).fill(-1);
          this.halfedges = new Int32Array(3).fill(-1);
          this.triangles[0] = hull[0];
          inedges[hull[0]] = 1;
          if (hull.length === 2) {
            inedges[hull[1]] = 0;
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
          }
        }
      }
      voronoi(bounds) {
        return new Voronoi(this, bounds);
      }
      *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear: collinear3 } = this;
        if (collinear3) {
          const l = collinear3.indexOf(i);
          if (l > 0) yield collinear3[l - 1];
          if (l < collinear3.length - 1) yield collinear3[l + 1];
          return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return;
        let e = e0, p02 = -1;
        do {
          yield p02 = triangles[e];
          e = e % 3 === 2 ? e - 2 : e + 1;
          if (triangles[e] !== i) return;
          e = halfedges[e];
          if (e === -1) {
            const p = hull[(_hullIndex[i] + 1) % hull.length];
            if (p !== p02) yield p;
            return;
          }
        } while (e !== e0);
      }
      find(x4, y4, i = 0) {
        if ((x4 = +x4, x4 !== x4) || (y4 = +y4, y4 !== y4)) return -1;
        const i0 = i;
        let c6;
        while ((c6 = this._step(i, x4, y4)) >= 0 && c6 !== i && c6 !== i0) i = c6;
        return c6;
      }
      _step(i, x4, y4) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c6 = i;
        let dc = pow(x4 - points[i * 2], 2) + pow(y4 - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
          let t = triangles[e];
          const dt = pow(x4 - points[t * 2], 2) + pow(y4 - points[t * 2 + 1], 2);
          if (dt < dc) dc = dt, c6 = t;
          e = e % 3 === 2 ? e - 2 : e + 1;
          if (triangles[e] !== i) break;
          e = halfedges[e];
          if (e === -1) {
            e = hull[(_hullIndex[i] + 1) % hull.length];
            if (e !== t) {
              if (pow(x4 - points[e * 2], 2) + pow(y4 - points[e * 2 + 1], 2) < dc) return e;
            }
            break;
          }
        } while (e !== e0);
        return c6;
      }
      render(context) {
        const buffer = context == null ? context = new Path2() : void 0;
        const { points, halfedges, triangles } = this;
        for (let i = 0, n = halfedges.length; i < n; ++i) {
          const j = halfedges[i];
          if (j < i) continue;
          const ti = triangles[i] * 2;
          const tj = triangles[j] * 2;
          context.moveTo(points[ti], points[ti + 1]);
          context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
      }
      renderPoints(context, r) {
        if (r === void 0 && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == void 0 ? 2 : +r;
        const buffer = context == null ? context = new Path2() : void 0;
        const { points } = this;
        for (let i = 0, n = points.length; i < n; i += 2) {
          const x4 = points[i], y4 = points[i + 1];
          context.moveTo(x4 + r, y4);
          context.arc(x4, y4, r, 0, tau4);
        }
        return buffer && buffer.value();
      }
      renderHull(context) {
        const buffer = context == null ? context = new Path2() : void 0;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for (let i = 1; i < n; ++i) {
          const h2 = 2 * hull[i];
          context.lineTo(points[h2], points[h2 + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
      }
      hullPolygon() {
        const polygon = new Polygon();
        this.renderHull(polygon);
        return polygon.value();
      }
      renderTriangle(i, context) {
        const buffer = context == null ? context = new Path2() : void 0;
        const { points, triangles } = this;
        const t03 = triangles[i *= 3] * 2;
        const t13 = triangles[i + 1] * 2;
        const t22 = triangles[i + 2] * 2;
        context.moveTo(points[t03], points[t03 + 1]);
        context.lineTo(points[t13], points[t13 + 1]);
        context.lineTo(points[t22], points[t22 + 1]);
        context.closePath();
        return buffer && buffer.value();
      }
      *trianglePolygons() {
        const { triangles } = this;
        for (let i = 0, n = triangles.length / 3; i < n; ++i) {
          yield this.trianglePolygon(i);
        }
      }
      trianglePolygon(i) {
        const polygon = new Polygon();
        this.renderTriangle(i, polygon);
        return polygon.value();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/index.js
var init_src16 = __esm({
  "../node_modules/.pnpm/d3-delaunay@6.0.4/node_modules/d3-delaunay/src/index.js"() {
    init_delaunay();
    init_voronoi();
  }
});

// ../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/dsv.js
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter(columns, f2) {
  var object2 = objectConverter(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad(value, width) {
  var s2 = value + "", length3 = s2.length;
  return length3 < width ? new Array(width - length3 + 1).join(0) + s2 : s2;
}
function formatYear(year) {
  return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date2) {
  var hours = date2.getUTCHours(), minutes = date2.getUTCMinutes(), seconds2 = date2.getUTCSeconds(), milliseconds2 = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear(date2.getUTCFullYear(), 4) + "-" + pad(date2.getUTCMonth() + 1, 2) + "-" + pad(date2.getUTCDate(), 2) + (milliseconds2 ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds2, 2) + "." + pad(milliseconds2, 3) + "Z" : seconds2 ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds2, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}
function dsv_default(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse2(text, f2) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter(row, f2) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text, f2) {
    var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;
    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;
      var i, j = I, c6;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE) ;
        if ((i = I) >= N) eof = true;
        else if ((c6 = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c6 === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE) ++I;
        }
        return text.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c6 = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c6 === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE) ++I;
        } else if (c6 !== DELIMITER) continue;
        return text.slice(j, i);
      }
      return eof = true, text.slice(j, N);
    }
    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f2 && (row = f2(row, n++)) == null) continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var EOL, EOF, QUOTE, NEWLINE, RETURN;
var init_dsv = __esm({
  "../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/dsv.js"() {
    EOL = {};
    EOF = {};
    QUOTE = 34;
    NEWLINE = 10;
    RETURN = 13;
  }
});

// ../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/csv.js
var csv, csvParse, csvParseRows, csvFormat, csvFormatBody, csvFormatRows, csvFormatRow, csvFormatValue;
var init_csv = __esm({
  "../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/csv.js"() {
    init_dsv();
    csv = dsv_default(",");
    csvParse = csv.parse;
    csvParseRows = csv.parseRows;
    csvFormat = csv.format;
    csvFormatBody = csv.formatBody;
    csvFormatRows = csv.formatRows;
    csvFormatRow = csv.formatRow;
    csvFormatValue = csv.formatValue;
  }
});

// ../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/tsv.js
var tsv, tsvParse, tsvParseRows, tsvFormat, tsvFormatBody, tsvFormatRows, tsvFormatRow, tsvFormatValue;
var init_tsv = __esm({
  "../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/tsv.js"() {
    init_dsv();
    tsv = dsv_default("	");
    tsvParse = tsv.parse;
    tsvParseRows = tsv.parseRows;
    tsvFormat = tsv.format;
    tsvFormatBody = tsv.formatBody;
    tsvFormatRows = tsv.formatRows;
    tsvFormatRow = tsv.formatRow;
    tsvFormatValue = tsv.formatValue;
  }
});

// ../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/autoType.js
function autoType(object2) {
  for (var key in object2) {
    var value = object2[key].trim(), number5, m3;
    if (!value) value = null;
    else if (value === "true") value = true;
    else if (value === "false") value = false;
    else if (value === "NaN") value = NaN;
    else if (!isNaN(number5 = +value)) value = number5;
    else if (m3 = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m3[4] && !m3[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    } else continue;
    object2[key] = value;
  }
  return object2;
}
var fixtz;
var init_autoType = __esm({
  "../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/autoType.js"() {
    fixtz = (/* @__PURE__ */ new Date("2019-01-01T00:00")).getHours() || (/* @__PURE__ */ new Date("2019-07-01T00:00")).getHours();
  }
});

// ../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/index.js
var init_src17 = __esm({
  "../node_modules/.pnpm/d3-dsv@3.0.1/node_modules/d3-dsv/src/index.js"() {
    init_dsv();
    init_csv();
    init_tsv();
    init_autoType();
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/blob.js
function responseBlob(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.blob();
}
function blob_default(input, init2) {
  return fetch(input, init2).then(responseBlob);
}
var init_blob = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/blob.js"() {
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/buffer.js
function responseArrayBuffer(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}
function buffer_default(input, init2) {
  return fetch(input, init2).then(responseArrayBuffer);
}
var init_buffer = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/buffer.js"() {
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/text.js
function responseText(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.text();
}
function text_default3(input, init2) {
  return fetch(input, init2).then(responseText);
}
var init_text3 = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/text.js"() {
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/dsv.js
function dsvParse(parse2) {
  return function(input, init2, row) {
    if (arguments.length === 2 && typeof init2 === "function") row = init2, init2 = void 0;
    return text_default3(input, init2).then(function(response) {
      return parse2(response, row);
    });
  };
}
function dsv(delimiter, input, init2, row) {
  if (arguments.length === 3 && typeof init2 === "function") row = init2, init2 = void 0;
  var format2 = dsv_default(delimiter);
  return text_default3(input, init2).then(function(response) {
    return format2.parse(response, row);
  });
}
var csv2, tsv2;
var init_dsv2 = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/dsv.js"() {
    init_src17();
    init_text3();
    csv2 = dsvParse(csvParse);
    tsv2 = dsvParse(tsvParse);
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/image.js
function image_default(input, init2) {
  return new Promise(function(resolve, reject) {
    var image = new Image();
    for (var key in init2) image[key] = init2[key];
    image.onerror = reject;
    image.onload = function() {
      resolve(image);
    };
    image.src = input;
  });
}
var init_image = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/image.js"() {
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/json.js
function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  if (response.status === 204 || response.status === 205) return;
  return response.json();
}
function json_default(input, init2) {
  return fetch(input, init2).then(responseJson);
}
var init_json = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/json.js"() {
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/xml.js
function parser(type2) {
  return (input, init2) => text_default3(input, init2).then((text) => new DOMParser().parseFromString(text, type2));
}
var xml_default, html, svg;
var init_xml = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/xml.js"() {
    init_text3();
    xml_default = parser("application/xml");
    html = parser("text/html");
    svg = parser("image/svg+xml");
  }
});

// ../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/index.js
var init_src18 = __esm({
  "../node_modules/.pnpm/d3-fetch@3.0.1/node_modules/d3-fetch/src/index.js"() {
    init_blob();
    init_buffer();
    init_dsv2();
    init_image();
    init_json();
    init_text3();
    init_xml();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/center.js
function center_default(x4, y4) {
  var nodes, strength = 1;
  if (x4 == null) x4 = 0;
  if (y4 == null) y4 = 0;
  function force() {
    var i, n = nodes.length, node, sx = 0, sy = 0;
    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }
    for (sx = (sx / n - x4) * strength, sy = (sy / n - y4) * strength, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }
  force.initialize = function(_) {
    nodes = _;
  };
  force.x = function(_) {
    return arguments.length ? (x4 = +_, force) : x4;
  };
  force.y = function(_) {
    return arguments.length ? (y4 = +_, force) : y4;
  };
  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };
  return force;
}
var init_center = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/center.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/add.js
function add_default(d) {
  const x4 = +this._x.call(null, d), y4 = +this._y.call(null, d);
  return add(this.cover(x4, y4), x4, y4, d);
}
function add(tree, x4, y4, d) {
  if (isNaN(x4) || isNaN(y4)) return tree;
  var parent, node = tree._root, leaf = { data: d }, x06 = tree._x0, y06 = tree._y0, x12 = tree._x1, y12 = tree._y1, xm, ym, xp, yp, right2, bottom2, i, j;
  if (!node) return tree._root = leaf, tree;
  while (node.length) {
    if (right2 = x4 >= (xm = (x06 + x12) / 2)) x06 = xm;
    else x12 = xm;
    if (bottom2 = y4 >= (ym = (y06 + y12) / 2)) y06 = ym;
    else y12 = ym;
    if (parent = node, !(node = node[i = bottom2 << 1 | right2])) return parent[i] = leaf, tree;
  }
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x4 === xp && y4 === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right2 = x4 >= (xm = (x06 + x12) / 2)) x06 = xm;
    else x12 = xm;
    if (bottom2 = y4 >= (ym = (y06 + y12) / 2)) y06 = ym;
    else y12 = ym;
  } while ((i = bottom2 << 1 | right2) === (j = (yp >= ym) << 1 | xp >= xm));
  return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
  var d, i, n = data.length, x4, y4, xz = new Array(n), yz = new Array(n), x06 = Infinity, y06 = Infinity, x12 = -Infinity, y12 = -Infinity;
  for (i = 0; i < n; ++i) {
    if (isNaN(x4 = +this._x.call(null, d = data[i])) || isNaN(y4 = +this._y.call(null, d))) continue;
    xz[i] = x4;
    yz[i] = y4;
    if (x4 < x06) x06 = x4;
    if (x4 > x12) x12 = x4;
    if (y4 < y06) y06 = y4;
    if (y4 > y12) y12 = y4;
  }
  if (x06 > x12 || y06 > y12) return this;
  this.cover(x06, y06).cover(x12, y12);
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }
  return this;
}
var init_add = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/add.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/cover.js
function cover_default(x4, y4) {
  if (isNaN(x4 = +x4) || isNaN(y4 = +y4)) return this;
  var x06 = this._x0, y06 = this._y0, x12 = this._x1, y12 = this._y1;
  if (isNaN(x06)) {
    x12 = (x06 = Math.floor(x4)) + 1;
    y12 = (y06 = Math.floor(y4)) + 1;
  } else {
    var z = x12 - x06 || 1, node = this._root, parent, i;
    while (x06 > x4 || x4 >= x12 || y06 > y4 || y4 >= y12) {
      i = (y4 < y06) << 1 | x4 < x06;
      parent = new Array(4), parent[i] = node, node = parent, z *= 2;
      switch (i) {
        case 0:
          x12 = x06 + z, y12 = y06 + z;
          break;
        case 1:
          x06 = x12 - z, y12 = y06 + z;
          break;
        case 2:
          x12 = x06 + z, y06 = y12 - z;
          break;
        case 3:
          x06 = x12 - z, y06 = y12 - z;
          break;
      }
    }
    if (this._root && this._root.length) this._root = node;
  }
  this._x0 = x06;
  this._y0 = y06;
  this._x1 = x12;
  this._y1 = y12;
  return this;
}
var init_cover = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/cover.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/data.js
function data_default2() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do
      data.push(node.data);
    while (node = node.next);
  });
  return data;
}
var init_data2 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/data.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/extent.js
function extent_default(_) {
  return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
var init_extent2 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/extent.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/quad.js
function quad_default(node, x06, y06, x12, y12) {
  this.node = node;
  this.x0 = x06;
  this.y0 = y06;
  this.x1 = x12;
  this.y1 = y12;
}
var init_quad2 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/quad.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/find.js
function find_default(x4, y4, radius) {
  var data, x06 = this._x0, y06 = this._y0, x12, y12, x22, y22, x32 = this._x1, y32 = this._y1, quads = [], node = this._root, q, i;
  if (node) quads.push(new quad_default(node, x06, y06, x32, y32));
  if (radius == null) radius = Infinity;
  else {
    x06 = x4 - radius, y06 = y4 - radius;
    x32 = x4 + radius, y32 = y4 + radius;
    radius *= radius;
  }
  while (q = quads.pop()) {
    if (!(node = q.node) || (x12 = q.x0) > x32 || (y12 = q.y0) > y32 || (x22 = q.x1) < x06 || (y22 = q.y1) < y06) continue;
    if (node.length) {
      var xm = (x12 + x22) / 2, ym = (y12 + y22) / 2;
      quads.push(
        new quad_default(node[3], xm, ym, x22, y22),
        new quad_default(node[2], x12, ym, xm, y22),
        new quad_default(node[1], xm, y12, x22, ym),
        new quad_default(node[0], x12, y12, xm, ym)
      );
      if (i = (y4 >= ym) << 1 | x4 >= xm) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    } else {
      var dx = x4 - +this._x.call(null, node.data), dy = y4 - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x06 = x4 - d, y06 = y4 - d;
        x32 = x4 + d, y32 = y4 + d;
        data = node.data;
      }
    }
  }
  return data;
}
var init_find = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/find.js"() {
    init_quad2();
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/remove.js
function remove_default3(d) {
  if (isNaN(x4 = +this._x.call(null, d)) || isNaN(y4 = +this._y.call(null, d))) return this;
  var parent, node = this._root, retainer, previous, next, x06 = this._x0, y06 = this._y0, x12 = this._x1, y12 = this._y1, x4, y4, xm, ym, right2, bottom2, i, j;
  if (!node) return this;
  if (node.length) while (true) {
    if (right2 = x4 >= (xm = (x06 + x12) / 2)) x06 = xm;
    else x12 = xm;
    if (bottom2 = y4 >= (ym = (y06 + y12) / 2)) y06 = ym;
    else y12 = ym;
    if (!(parent = node, node = node[i = bottom2 << 1 | right2])) return this;
    if (!node.length) break;
    if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
  }
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;
  if (previous) return next ? previous.next = next : delete previous.next, this;
  if (!parent) return this._root = next, this;
  next ? parent[i] = next : delete parent[i];
  if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }
  return this;
}
function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}
var init_remove3 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/remove.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/root.js
function root_default() {
  return this._root;
}
var init_root = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/root.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/size.js
function size_default2() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do
      ++size;
    while (node = node.next);
  });
  return size;
}
var init_size2 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/size.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/visit.js
function visit_default(callback) {
  var quads = [], q, node = this._root, child, x06, y06, x12, y12;
  if (node) quads.push(new quad_default(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x06 = q.x0, y06 = q.y0, x12 = q.x1, y12 = q.y1) && node.length) {
      var xm = (x06 + x12) / 2, ym = (y06 + y12) / 2;
      if (child = node[3]) quads.push(new quad_default(child, xm, ym, x12, y12));
      if (child = node[2]) quads.push(new quad_default(child, x06, ym, xm, y12));
      if (child = node[1]) quads.push(new quad_default(child, xm, y06, x12, ym));
      if (child = node[0]) quads.push(new quad_default(child, x06, y06, xm, ym));
    }
  }
  return this;
}
var init_visit = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/visit.js"() {
    init_quad2();
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/visitAfter.js
function visitAfter_default(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new quad_default(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x06 = q.x0, y06 = q.y0, x12 = q.x1, y12 = q.y1, xm = (x06 + x12) / 2, ym = (y06 + y12) / 2;
      if (child = node[0]) quads.push(new quad_default(child, x06, y06, xm, ym));
      if (child = node[1]) quads.push(new quad_default(child, xm, y06, x12, ym));
      if (child = node[2]) quads.push(new quad_default(child, x06, ym, xm, y12));
      if (child = node[3]) quads.push(new quad_default(child, xm, ym, x12, y12));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}
var init_visitAfter = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/visitAfter.js"() {
    init_quad2();
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/x.js
function defaultX2(d) {
  return d[0];
}
function x_default(_) {
  return arguments.length ? (this._x = _, this) : this._x;
}
var init_x = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/x.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/y.js
function defaultY2(d) {
  return d[1];
}
function y_default(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}
var init_y = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/y.js"() {
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/quadtree.js
function quadtree(nodes, x4, y4) {
  var tree = new Quadtree(x4 == null ? defaultX2 : x4, y4 == null ? defaultY2 : y4, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x4, y4, x06, y06, x12, y12) {
  this._x = x4;
  this._y = y4;
  this._x0 = x06;
  this._y0 = y06;
  this._x1 = x12;
  this._y1 = y12;
  this._root = void 0;
}
function leaf_copy(leaf) {
  var copy3 = { data: leaf.data }, next = copy3;
  while (leaf = leaf.next) next = next.next = { data: leaf.data };
  return copy3;
}
var treeProto;
var init_quadtree = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/quadtree.js"() {
    init_add();
    init_cover();
    init_data2();
    init_extent2();
    init_find();
    init_remove3();
    init_root();
    init_size2();
    init_visit();
    init_visitAfter();
    init_x();
    init_y();
    treeProto = quadtree.prototype = Quadtree.prototype;
    treeProto.copy = function() {
      var copy3 = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
      if (!node) return copy3;
      if (!node.length) return copy3._root = leaf_copy(node), copy3;
      nodes = [{ source: node, target: copy3._root = new Array(4) }];
      while (node = nodes.pop()) {
        for (var i = 0; i < 4; ++i) {
          if (child = node.source[i]) {
            if (child.length) nodes.push({ source: child, target: node.target[i] = new Array(4) });
            else node.target[i] = leaf_copy(child);
          }
        }
      }
      return copy3;
    };
    treeProto.add = add_default;
    treeProto.addAll = addAll;
    treeProto.cover = cover_default;
    treeProto.data = data_default2;
    treeProto.extent = extent_default;
    treeProto.find = find_default;
    treeProto.remove = remove_default3;
    treeProto.removeAll = removeAll;
    treeProto.root = root_default;
    treeProto.size = size_default2;
    treeProto.visit = visit_default;
    treeProto.visitAfter = visitAfter_default;
    treeProto.x = x_default;
    treeProto.y = y_default;
  }
});

// ../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/index.js
var init_src19 = __esm({
  "../node_modules/.pnpm/d3-quadtree@3.0.1/node_modules/d3-quadtree/src/index.js"() {
    init_quadtree();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/constant.js
function constant_default7(x4) {
  return function() {
    return x4;
  };
}
var init_constant8 = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/jiggle.js
function jiggle_default(random) {
  return (random() - 0.5) * 1e-6;
}
var init_jiggle = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/jiggle.js"() {
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/collide.js
function x(d) {
  return d.x + d.vx;
}
function y(d) {
  return d.y + d.vy;
}
function collide_default(radius) {
  var nodes, radii, random, strength = 1, iterations2 = 1;
  if (typeof radius !== "function") radius = constant_default7(radius == null ? 1 : +radius);
  function force() {
    var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
    for (var k2 = 0; k2 < iterations2; ++k2) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }
    function apply(quad, x06, y06, x12, y12) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x4 = xi - data.x - data.vx, y4 = yi - data.y - data.vy, l = x4 * x4 + y4 * y4;
          if (l < r * r) {
            if (x4 === 0) x4 = jiggle_default(random), l += x4 * x4;
            if (y4 === 0) y4 = jiggle_default(random), l += y4 * y4;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x4 *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y4 *= l) * r;
            data.vx -= x4 * (r = 1 - r);
            data.vy -= y4 * r;
          }
        }
        return;
      }
      return x06 > xi + r || x12 < xi - r || y06 > yi + r || y12 < yi - r;
    }
  }
  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.iterations = function(_) {
    return arguments.length ? (iterations2 = +_, force) : iterations2;
  };
  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };
  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : radius;
  };
  return force;
}
var init_collide = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/collide.js"() {
    init_src19();
    init_constant8();
    init_jiggle();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/link.js
function index2(d) {
  return d.index;
}
function find2(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("node not found: " + nodeId);
  return node;
}
function link_default(links) {
  var id2 = index2, strength = defaultStrength, strengths, distance = constant_default7(30), distances, nodes, count3, bias, random, iterations2 = 1;
  if (links == null) links = [];
  function defaultStrength(link3) {
    return 1 / Math.min(count3[link3.source.index], count3[link3.target.index]);
  }
  function force(alpha) {
    for (var k2 = 0, n = links.length; k2 < iterations2; ++k2) {
      for (var i = 0, link3, source, target, x4, y4, l, b; i < n; ++i) {
        link3 = links[i], source = link3.source, target = link3.target;
        x4 = target.x + target.vx - source.x - source.vx || jiggle_default(random);
        y4 = target.y + target.vy - source.y - source.vy || jiggle_default(random);
        l = Math.sqrt(x4 * x4 + y4 * y4);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x4 *= l, y4 *= l;
        target.vx -= x4 * (b = bias[i]);
        target.vy -= y4 * b;
        source.vx += x4 * (b = 1 - b);
        source.vy += y4 * b;
      }
    }
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, m3 = links.length, nodeById = new Map(nodes.map((d, i2) => [id2(d, i2, nodes), d])), link3;
    for (i = 0, count3 = new Array(n); i < m3; ++i) {
      link3 = links[i], link3.index = i;
      if (typeof link3.source !== "object") link3.source = find2(nodeById, link3.source);
      if (typeof link3.target !== "object") link3.target = find2(nodeById, link3.target);
      count3[link3.source.index] = (count3[link3.source.index] || 0) + 1;
      count3[link3.target.index] = (count3[link3.target.index] || 0) + 1;
    }
    for (i = 0, bias = new Array(m3); i < m3; ++i) {
      link3 = links[i], bias[i] = count3[link3.source.index] / (count3[link3.source.index] + count3[link3.target.index]);
    }
    strengths = new Array(m3), initializeStrength();
    distances = new Array(m3), initializeDistance();
  }
  function initializeStrength() {
    if (!nodes) return;
    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }
  function initializeDistance() {
    if (!nodes) return;
    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };
  force.id = function(_) {
    return arguments.length ? (id2 = _, force) : id2;
  };
  force.iterations = function(_) {
    return arguments.length ? (iterations2 = +_, force) : iterations2;
  };
  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant_default7(+_), initializeStrength(), force) : strength;
  };
  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant_default7(+_), initializeDistance(), force) : distance;
  };
  return force;
}
var init_link = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/link.js"() {
    init_constant8();
    init_jiggle();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/lcg.js
function lcg_default() {
  let s2 = 1;
  return () => (s2 = (a * s2 + c) % m) / m;
}
var a, c, m;
var init_lcg = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/lcg.js"() {
    a = 1664525;
    c = 1013904223;
    m = 4294967296;
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/simulation.js
function x2(d) {
  return d.x;
}
function y2(d) {
  return d.y;
}
function simulation_default(nodes) {
  var simulation, alpha = 1, alphaMin = 1e-3, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = /* @__PURE__ */ new Map(), stepper = timer(step), event = dispatch_default("tick", "end"), random = lcg_default();
  if (nodes == null) nodes = [];
  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }
  function tick(iterations2) {
    var i, n = nodes.length, node;
    if (iterations2 === void 0) iterations2 = 1;
    for (var k2 = 0; k2 < iterations2; ++k2) {
      alpha += (alphaTarget - alpha) * alphaDecay;
      forces.forEach(function(force) {
        force(alpha);
      });
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;
        else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;
        else node.y = node.fy, node.vy = 0;
      }
    }
    return simulation;
  }
  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i), angle2 = i * initialAngle;
        node.x = radius * Math.cos(angle2);
        node.y = radius * Math.sin(angle2);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }
  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes, random);
    return force;
  }
  initializeNodes();
  return simulation = {
    tick,
    restart: function() {
      return stepper.restart(step), simulation;
    },
    stop: function() {
      return stepper.stop(), simulation;
    },
    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
    },
    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },
    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },
    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },
    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },
    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },
    randomSource: function(_) {
      return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
    },
    force: function(name, _) {
      return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
    },
    find: function(x4, y4, radius) {
      var i = 0, n = nodes.length, dx, dy, d2, node, closest;
      if (radius == null) radius = Infinity;
      else radius *= radius;
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x4 - node.x;
        dy = y4 - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }
      return closest;
    },
    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
}
var initialRadius, initialAngle;
var init_simulation = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/simulation.js"() {
    init_src4();
    init_src9();
    init_lcg();
    initialRadius = 10;
    initialAngle = Math.PI * (3 - Math.sqrt(5));
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/manyBody.js
function manyBody_default() {
  var nodes, node, random, alpha, strength = constant_default7(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x2, y2).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node2;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node2 = nodes[i], strengths[node2.index] = +strength(node2, i, nodes);
  }
  function accumulate(quad) {
    var strength2 = 0, q, c6, weight = 0, x4, y4, i;
    if (quad.length) {
      for (x4 = y4 = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c6 = Math.abs(q.value))) {
          strength2 += q.value, weight += c6, x4 += c6 * q.x, y4 += c6 * q.y;
        }
      }
      quad.x = x4 / weight;
      quad.y = y4 / weight;
    } else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do
        strength2 += strengths[q.data.index];
      while (q = q.next);
    }
    quad.value = strength2;
  }
  function apply(quad, x12, _, x22) {
    if (!quad.value) return true;
    var x4 = quad.x - node.x, y4 = quad.y - node.y, w = x22 - x12, l = x4 * x4 + y4 * y4;
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x4 === 0) x4 = jiggle_default(random), l += x4 * x4;
        if (y4 === 0) y4 = jiggle_default(random), l += y4 * y4;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x4 * quad.value * alpha / l;
        node.vy += y4 * quad.value * alpha / l;
      }
      return true;
    } else if (quad.length || l >= distanceMax2) return;
    if (quad.data !== node || quad.next) {
      if (x4 === 0) x4 = jiggle_default(random), l += x4 * x4;
      if (y4 === 0) y4 = jiggle_default(random), l += y4 * y4;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }
    do
      if (quad.data !== node) {
        w = strengths[quad.data.index] * alpha / l;
        node.vx += x4 * w;
        node.vy += y4 * w;
      }
    while (quad = quad.next);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : strength;
  };
  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };
  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };
  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };
  return force;
}
var init_manyBody = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/manyBody.js"() {
    init_src19();
    init_constant8();
    init_jiggle();
    init_simulation();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/radial.js
function radial_default(radius, x4, y4) {
  var nodes, strength = constant_default7(0.1), strengths, radiuses;
  if (typeof radius !== "function") radius = constant_default7(+radius);
  if (x4 == null) x4 = 0;
  if (y4 == null) y4 = 0;
  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i], dx = node.x - x4 || 1e-6, dy = node.y - y4 || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k2 = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k2;
      node.vy += dy * k2;
    }
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_) {
    nodes = _, initialize();
  };
  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : strength;
  };
  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : radius;
  };
  force.x = function(_) {
    return arguments.length ? (x4 = +_, force) : x4;
  };
  force.y = function(_) {
    return arguments.length ? (y4 = +_, force) : y4;
  };
  return force;
}
var init_radial = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/radial.js"() {
    init_constant8();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/x.js
function x_default2(x4) {
  var strength = constant_default7(0.1), nodes, strengths, xz;
  if (typeof x4 !== "function") x4 = constant_default7(x4 == null ? 0 : +x4);
  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x4(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_) {
    nodes = _;
    initialize();
  };
  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : strength;
  };
  force.x = function(_) {
    return arguments.length ? (x4 = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : x4;
  };
  return force;
}
var init_x2 = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/x.js"() {
    init_constant8();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/y.js
function y_default2(y4) {
  var strength = constant_default7(0.1), nodes, strengths, yz;
  if (typeof y4 !== "function") y4 = constant_default7(y4 == null ? 0 : +y4);
  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }
  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y4(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_) {
    nodes = _;
    initialize();
  };
  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : strength;
  };
  force.y = function(_) {
    return arguments.length ? (y4 = typeof _ === "function" ? _ : constant_default7(+_), initialize(), force) : y4;
  };
  return force;
}
var init_y2 = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/y.js"() {
    init_constant8();
  }
});

// ../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/index.js
var init_src20 = __esm({
  "../node_modules/.pnpm/d3-force@3.0.0/node_modules/d3-force/src/index.js"() {
    init_center();
    init_collide();
    init_link();
    init_manyBody();
    init_radial();
    init_simulation();
    init_x2();
    init_y2();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatDecimal.js
function formatDecimal_default(x4) {
  return Math.abs(x4 = Math.round(x4)) >= 1e21 ? x4.toLocaleString("en").replace(/,/g, "") : x4.toString(10);
}
function formatDecimalParts(x4, p) {
  if (!isFinite(x4) || x4 === 0) return null;
  var i = (x4 = p ? x4.toExponential(p - 1) : x4.toExponential()).indexOf("e"), coefficient = x4.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x4.slice(i + 1)
  ];
}
var init_formatDecimal = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatDecimal.js"() {
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/exponent.js
function exponent_default(x4) {
  return x4 = formatDecimalParts(Math.abs(x4)), x4 ? x4[1] : NaN;
}
var init_exponent = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/exponent.js"() {
    init_formatDecimal();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatGroup.js
function formatGroup_default(grouping, thousands) {
  return function(value, width) {
    var i = value.length, t = [], j = 0, g = grouping[0], length3 = 0;
    while (i > 0 && g > 0) {
      if (length3 + g + 1 > width) g = Math.max(1, width - length3);
      t.push(value.substring(i -= g, i + g));
      if ((length3 += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
var init_formatGroup = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatGroup.js"() {
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatNumerals.js
function formatNumerals_default(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var init_formatNumerals = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatNumerals.js"() {
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatSpecifier.js
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
var re;
var init_formatSpecifier = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatSpecifier.js"() {
    re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
    formatSpecifier.prototype = FormatSpecifier.prototype;
    FormatSpecifier.prototype.toString = function() {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
    };
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTrim.js
function formatTrim_default(s2) {
  out: for (var n = s2.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s2[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s2[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}
var init_formatTrim = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTrim.js"() {
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatPrefixAuto.js
function formatPrefixAuto_default(x4, p) {
  var d = formatDecimalParts(x4, p);
  if (!d) return prefixExponent = void 0, x4.toPrecision(p);
  var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x4, Math.max(0, p + i - 1))[0];
}
var prefixExponent;
var init_formatPrefixAuto = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatPrefixAuto.js"() {
    init_formatDecimal();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatRounded.js
function formatRounded_default(x4, p) {
  var d = formatDecimalParts(x4, p);
  if (!d) return x4 + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var init_formatRounded = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatRounded.js"() {
    init_formatDecimal();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTypes.js
var formatTypes_default;
var init_formatTypes = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTypes.js"() {
    init_formatDecimal();
    init_formatPrefixAuto();
    init_formatRounded();
    formatTypes_default = {
      "%": (x4, p) => (x4 * 100).toFixed(p),
      "b": (x4) => Math.round(x4).toString(2),
      "c": (x4) => x4 + "",
      "d": formatDecimal_default,
      "e": (x4, p) => x4.toExponential(p),
      "f": (x4, p) => x4.toFixed(p),
      "g": (x4, p) => x4.toPrecision(p),
      "o": (x4) => Math.round(x4).toString(8),
      "p": (x4, p) => formatRounded_default(x4 * 100, p),
      "r": formatRounded_default,
      "s": formatPrefixAuto_default,
      "X": (x4) => Math.round(x4).toString(16).toUpperCase(),
      "x": (x4) => Math.round(x4).toString(16)
    };
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/identity.js
function identity_default2(x4) {
  return x4;
}
var init_identity3 = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/identity.js"() {
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/locale.js
function locale_default(locale3) {
  var group2 = locale3.grouping === void 0 || locale3.thousands === void 0 ? identity_default2 : formatGroup_default(map3.call(locale3.grouping, Number), locale3.thousands + ""), currencyPrefix = locale3.currency === void 0 ? "" : locale3.currency[0] + "", currencySuffix = locale3.currency === void 0 ? "" : locale3.currency[1] + "", decimal = locale3.decimal === void 0 ? "." : locale3.decimal + "", numerals = locale3.numerals === void 0 ? identity_default2 : formatNumerals_default(map3.call(locale3.numerals, String)), percent = locale3.percent === void 0 ? "%" : locale3.percent + "", minus = locale3.minus === void 0 ? "\u2212" : locale3.minus + "", nan = locale3.nan === void 0 ? "NaN" : locale3.nan + "";
  function newFormat(specifier, options) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign3 = specifier.sign, symbol = specifier.symbol, zero3 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type2 = specifier.type;
    if (type2 === "n") comma = true, type2 = "g";
    else if (!formatTypes_default[type2]) precision === void 0 && (precision = 12), trim = true, type2 = "g";
    if (zero3 || fill === "0" && align === "=") zero3 = true, fill = "0", align = "=";
    var prefix = (options && options.prefix !== void 0 ? options.prefix : "") + (symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : ""), suffix = (symbol === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "") + (options && options.suffix !== void 0 ? options.suffix : "");
    var formatType = formatTypes_default[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix, valueSuffix = suffix, i, n, c6;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim_default(value);
        if (valueNegative && +value === 0 && sign3 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign3 === "(" ? sign3 : minus : sign3 === "-" || sign3 === "(" ? "" : sign3) + valuePrefix;
        valueSuffix = (type2 === "s" && !isNaN(value) && prefixExponent !== void 0 ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign3 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c6 = value.charCodeAt(i), 48 > c6 || c6 > 57) {
              valueSuffix = (c6 === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero3) value = group2(value, Infinity);
      var length3 = valuePrefix.length + value.length + valueSuffix.length, padding = length3 < width ? new Array(width - length3 + 1).join(fill) : "";
      if (comma && zero3) value = group2(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length3 = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length3);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var e = Math.max(-8, Math.min(8, Math.floor(exponent_default(value) / 3))) * 3, k2 = Math.pow(10, -e), f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier), { suffix: prefixes[8 + e / 3] });
    return function(value2) {
      return f2(k2 * value2);
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var map3, prefixes;
var init_locale = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/locale.js"() {
    init_exponent();
    init_formatGroup();
    init_formatNumerals();
    init_formatSpecifier();
    init_formatTrim();
    init_formatTypes();
    init_formatPrefixAuto();
    init_identity3();
    map3 = Array.prototype.map;
    prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/defaultLocale.js
function defaultLocale(definition) {
  locale = locale_default(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
var locale, format, formatPrefix;
var init_defaultLocale = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/defaultLocale.js"() {
    init_locale();
    defaultLocale({
      thousands: ",",
      grouping: [3],
      currency: ["$", ""]
    });
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionFixed.js
function precisionFixed_default(step) {
  return Math.max(0, -exponent_default(Math.abs(step)));
}
var init_precisionFixed = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionFixed.js"() {
    init_exponent();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionPrefix.js
function precisionPrefix_default(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent_default(value) / 3))) * 3 - exponent_default(Math.abs(step)));
}
var init_precisionPrefix = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionPrefix.js"() {
    init_exponent();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionRound.js
function precisionRound_default(step, max5) {
  step = Math.abs(step), max5 = Math.abs(max5) - step;
  return Math.max(0, exponent_default(max5) - exponent_default(step)) + 1;
}
var init_precisionRound = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionRound.js"() {
    init_exponent();
  }
});

// ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/index.js
var init_src21 = __esm({
  "../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/index.js"() {
    init_defaultLocale();
    init_locale();
    init_formatSpecifier();
    init_precisionFixed();
    init_precisionPrefix();
    init_precisionRound();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/math.js
function acos(x4) {
  return x4 > 1 ? 0 : x4 < -1 ? pi4 : Math.acos(x4);
}
function asin(x4) {
  return x4 > 1 ? halfPi3 : x4 < -1 ? -halfPi3 : Math.asin(x4);
}
function haversin(x4) {
  return (x4 = sin2(x4 / 2)) * x4;
}
var epsilon7, epsilon22, pi4, halfPi3, quarterPi, tau5, degrees3, radians2, abs3, atan, atan2, cos2, ceil, exp, hypot, log, pow2, sin2, sign, sqrt, tan;
var init_math4 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/math.js"() {
    epsilon7 = 1e-6;
    epsilon22 = 1e-12;
    pi4 = Math.PI;
    halfPi3 = pi4 / 2;
    quarterPi = pi4 / 4;
    tau5 = pi4 * 2;
    degrees3 = 180 / pi4;
    radians2 = pi4 / 180;
    abs3 = Math.abs;
    atan = Math.atan;
    atan2 = Math.atan2;
    cos2 = Math.cos;
    ceil = Math.ceil;
    exp = Math.exp;
    hypot = Math.hypot;
    log = Math.log;
    pow2 = Math.pow;
    sin2 = Math.sin;
    sign = Math.sign || function(x4) {
      return x4 > 0 ? 1 : x4 < 0 ? -1 : 0;
    };
    sqrt = Math.sqrt;
    tan = Math.tan;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/noop.js
function noop2() {
}
var init_noop2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/noop.js"() {
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/stream.js
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
function streamLine(coordinates2, stream, closed) {
  var i = -1, n = coordinates2.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates2[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates2, stream) {
  var i = -1, n = coordinates2.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates2[i], stream, 1);
  stream.polygonEnd();
}
function stream_default(object2, stream) {
  if (object2 && streamObjectType.hasOwnProperty(object2.type)) {
    streamObjectType[object2.type](object2, stream);
  } else {
    streamGeometry(object2, stream);
  }
}
var streamObjectType, streamGeometryType;
var init_stream = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/stream.js"() {
    streamObjectType = {
      Feature: function(object2, stream) {
        streamGeometry(object2.geometry, stream);
      },
      FeatureCollection: function(object2, stream) {
        var features = object2.features, i = -1, n = features.length;
        while (++i < n) streamGeometry(features[i].geometry, stream);
      }
    };
    streamGeometryType = {
      Sphere: function(object2, stream) {
        stream.sphere();
      },
      Point: function(object2, stream) {
        object2 = object2.coordinates;
        stream.point(object2[0], object2[1], object2[2]);
      },
      MultiPoint: function(object2, stream) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) object2 = coordinates2[i], stream.point(object2[0], object2[1], object2[2]);
      },
      LineString: function(object2, stream) {
        streamLine(object2.coordinates, stream, 0);
      },
      MultiLineString: function(object2, stream) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) streamLine(coordinates2[i], stream, 0);
      },
      Polygon: function(object2, stream) {
        streamPolygon(object2.coordinates, stream);
      },
      MultiPolygon: function(object2, stream) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) streamPolygon(coordinates2[i], stream);
      },
      GeometryCollection: function(object2, stream) {
        var geometries = object2.geometries, i = -1, n = geometries.length;
        while (++i < n) streamGeometry(geometries[i], stream);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/area.js
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaRingEnd() {
  areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi2) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi2;
  lambda *= radians2, phi2 *= radians2;
  lambda0 = lambda, cosPhi0 = cos2(phi2 = phi2 / 2 + quarterPi), sinPhi0 = sin2(phi2);
}
function areaPoint(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  phi2 = phi2 / 2 + quarterPi;
  var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos2(phi2), sinPhi = sin2(phi2), k2 = sinPhi0 * sinPhi, u4 = cosPhi0 * cosPhi + k2 * cos2(adLambda), v2 = k2 * sdLambda * sin2(adLambda);
  areaRingSum.add(atan2(v2, u4));
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}
function area_default2(object2) {
  areaSum = new Adder();
  stream_default(object2, areaStream);
  return areaSum * 2;
}
var areaRingSum, areaSum, lambda00, phi00, lambda0, cosPhi0, sinPhi0, areaStream;
var init_area2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/area.js"() {
    init_src2();
    init_math4();
    init_noop2();
    init_stream();
    areaRingSum = new Adder();
    areaSum = new Adder();
    areaStream = {
      point: noop2,
      lineStart: noop2,
      lineEnd: noop2,
      polygonStart: function() {
        areaRingSum = new Adder();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
      },
      polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? tau5 + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = noop2;
      },
      sphere: function() {
        areaSum.add(tau5);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/cartesian.js
function spherical(cartesian2) {
  return [atan2(cartesian2[1], cartesian2[0]), asin(cartesian2[2])];
}
function cartesian(spherical2) {
  var lambda = spherical2[0], phi2 = spherical2[1], cosPhi = cos2(phi2);
  return [cosPhi * cos2(lambda), cosPhi * sin2(lambda), sin2(phi2)];
}
function cartesianDot(a4, b) {
  return a4[0] * b[0] + a4[1] * b[1] + a4[2] * b[2];
}
function cartesianCross(a4, b) {
  return [a4[1] * b[2] - a4[2] * b[1], a4[2] * b[0] - a4[0] * b[2], a4[0] * b[1] - a4[1] * b[0]];
}
function cartesianAddInPlace(a4, b) {
  a4[0] += b[0], a4[1] += b[1], a4[2] += b[2];
}
function cartesianScale(vector, k2) {
  return [vector[0] * k2, vector[1] * k2, vector[2] * k2];
}
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}
var init_cartesian = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/cartesian.js"() {
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/bounds.js
function boundsPoint(lambda, phi2) {
  ranges.push(range3 = [lambda02 = lambda, lambda1 = lambda]);
  if (phi2 < phi0) phi0 = phi2;
  if (phi2 > phi1) phi1 = phi2;
}
function linePoint(lambda, phi2) {
  var p = cartesian([lambda * radians2, phi2 * radians2]);
  if (p0) {
    var normal = cartesianCross(p0, p), equatorial = [normal[1], -normal[0], 0], inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2, sign3 = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees3 * sign3, phii, antimeridian = abs3(delta) > 180;
    if (antimeridian ^ (sign3 * lambda2 < lambdai && lambdai < sign3 * lambda)) {
      phii = inflection[1] * degrees3;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign3 * lambda2 < lambdai && lambdai < sign3 * lambda)) {
      phii = -inflection[1] * degrees3;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi2 < phi0) phi0 = phi2;
      if (phi2 > phi1) phi1 = phi2;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda02, lambda) > angle(lambda02, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda02, lambda1)) lambda02 = lambda;
      }
    } else {
      if (lambda1 >= lambda02) {
        if (lambda < lambda02) lambda02 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda02, lambda) > angle(lambda02, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda02, lambda1)) lambda02 = lambda;
        }
      }
    }
  } else {
    ranges.push(range3 = [lambda02 = lambda, lambda1 = lambda]);
  }
  if (phi2 < phi0) phi0 = phi2;
  if (phi2 > phi1) phi1 = phi2;
  p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
  boundsStream.point = linePoint;
}
function boundsLineEnd() {
  range3[0] = lambda02, range3[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}
function boundsRingPoint(lambda, phi2) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs3(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda002 = lambda, phi002 = phi2;
  }
  areaStream.point(lambda, phi2);
  linePoint(lambda, phi2);
}
function boundsRingStart() {
  areaStream.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda002, phi002);
  areaStream.lineEnd();
  if (abs3(deltaSum) > epsilon7) lambda02 = -(lambda1 = 180);
  range3[0] = lambda02, range3[1] = lambda1;
  p0 = null;
}
function angle(lambda04, lambda12) {
  return (lambda12 -= lambda04) < 0 ? lambda12 + 360 : lambda12;
}
function rangeCompare(a4, b) {
  return a4[0] - b[0];
}
function rangeContains(range4, x4) {
  return range4[0] <= range4[1] ? range4[0] <= x4 && x4 <= range4[1] : x4 < range4[0] || range4[1] < x4;
}
function bounds_default(feature) {
  var i, n, a4, b, merged, deltaMax, delta;
  phi1 = lambda1 = -(lambda02 = phi0 = Infinity);
  ranges = [];
  stream_default(feature, boundsStream);
  if (n = ranges.length) {
    ranges.sort(rangeCompare);
    for (i = 1, a4 = ranges[0], merged = [a4]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a4, b[0]) || rangeContains(a4, b[1])) {
        if (angle(a4[0], b[1]) > angle(a4[0], a4[1])) a4[1] = b[1];
        if (angle(b[0], a4[1]) > angle(a4[0], a4[1])) a4[0] = b[0];
      } else {
        merged.push(a4 = b);
      }
    }
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a4 = merged[n]; i <= n; a4 = b, ++i) {
      b = merged[i];
      if ((delta = angle(a4[1], b[0])) > deltaMax) deltaMax = delta, lambda02 = b[0], lambda1 = a4[1];
    }
  }
  ranges = range3 = null;
  return lambda02 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda02, phi0], [lambda1, phi1]];
}
var lambda02, phi0, lambda1, phi1, lambda2, lambda002, phi002, p0, deltaSum, ranges, range3, boundsStream;
var init_bounds = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/bounds.js"() {
    init_src2();
    init_area2();
    init_cartesian();
    init_math4();
    init_stream();
    boundsStream = {
      point: boundsPoint,
      lineStart: boundsLineStart,
      lineEnd: boundsLineEnd,
      polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new Adder();
        areaStream.polygonStart();
      },
      polygonEnd: function() {
        areaStream.polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if (areaRingSum < 0) lambda02 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > epsilon7) phi1 = 90;
        else if (deltaSum < -epsilon7) phi0 = -90;
        range3[0] = lambda02, range3[1] = lambda1;
      },
      sphere: function() {
        lambda02 = -(lambda1 = 180), phi0 = -(phi1 = 90);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/centroid.js
function centroidPoint(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  var cosPhi = cos2(phi2);
  centroidPointCartesian(cosPhi * cos2(lambda), cosPhi * sin2(lambda), sin2(phi2));
}
function centroidPointCartesian(x4, y4, z) {
  ++W0;
  X0 += (x4 - X0) / W0;
  Y0 += (y4 - Y0) / W0;
  Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  var cosPhi = cos2(phi2);
  x0 = cosPhi * cos2(lambda);
  y0 = cosPhi * sin2(lambda);
  z0 = sin2(phi2);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  var cosPhi = cos2(phi2), x4 = cosPhi * cos2(lambda), y4 = cosPhi * sin2(lambda), z = sin2(phi2), w = atan2(sqrt((w = y0 * z - z0 * y4) * w + (w = z0 * x4 - x0 * z) * w + (w = x0 * y4 - y0 * x4) * w), x0 * x4 + y0 * y4 + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x4));
  Y1 += w * (y0 + (y0 = y4));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
  centroidRingPoint(lambda003, phi003);
  centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi2) {
  lambda003 = lambda, phi003 = phi2;
  lambda *= radians2, phi2 *= radians2;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos2(phi2);
  x0 = cosPhi * cos2(lambda);
  y0 = cosPhi * sin2(lambda);
  z0 = sin2(phi2);
  centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  var cosPhi = cos2(phi2), x4 = cosPhi * cos2(lambda), y4 = cosPhi * sin2(lambda), z = sin2(phi2), cx = y0 * z - z0 * y4, cy = z0 * x4 - x0 * z, cz = x0 * y4 - y0 * x4, m3 = hypot(cx, cy, cz), w = asin(m3), v2 = m3 && -w / m3;
  X2.add(v2 * cx);
  Y2.add(v2 * cy);
  Z2.add(v2 * cz);
  W1 += w;
  X1 += w * (x0 + (x0 = x4));
  Y1 += w * (y0 + (y0 = y4));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}
function centroid_default(object2) {
  W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
  X2 = new Adder();
  Y2 = new Adder();
  Z2 = new Adder();
  stream_default(object2, centroidStream);
  var x4 = +X2, y4 = +Y2, z = +Z2, m3 = hypot(x4, y4, z);
  if (m3 < epsilon22) {
    x4 = X1, y4 = Y1, z = Z1;
    if (W1 < epsilon7) x4 = X0, y4 = Y0, z = Z0;
    m3 = hypot(x4, y4, z);
    if (m3 < epsilon22) return [NaN, NaN];
  }
  return [atan2(y4, x4) * degrees3, asin(z / m3) * degrees3];
}
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda003, phi003, x0, y0, z0, centroidStream;
var init_centroid = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/centroid.js"() {
    init_src2();
    init_math4();
    init_noop2();
    init_stream();
    centroidStream = {
      sphere: noop2,
      point: centroidPoint,
      lineStart: centroidLineStart,
      lineEnd: centroidLineEnd,
      polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
      },
      polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/constant.js
function constant_default8(x4) {
  return function() {
    return x4;
  };
}
var init_constant9 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/compose.js
function compose_default(a4, b) {
  function compose(x4, y4) {
    return x4 = a4(x4, y4), b(x4[0], x4[1]);
  }
  if (a4.invert && b.invert) compose.invert = function(x4, y4) {
    return x4 = b.invert(x4, y4), x4 && a4.invert(x4[0], x4[1]);
  };
  return compose;
}
var init_compose = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/compose.js"() {
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/rotation.js
function rotationIdentity(lambda, phi2) {
  if (abs3(lambda) > pi4) lambda -= Math.round(lambda / tau5) * tau5;
  return [lambda, phi2];
}
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau5) ? deltaPhi || deltaGamma ? compose_default(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi2) {
    lambda += deltaLambda;
    if (abs3(lambda) > pi4) lambda -= Math.round(lambda / tau5) * tau5;
    return [lambda, phi2];
  };
}
function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos2(deltaPhi), sinDeltaPhi = sin2(deltaPhi), cosDeltaGamma = cos2(deltaGamma), sinDeltaGamma = sin2(deltaGamma);
  function rotation(lambda, phi2) {
    var cosPhi = cos2(phi2), x4 = cos2(lambda) * cosPhi, y4 = sin2(lambda) * cosPhi, z = sin2(phi2), k2 = z * cosDeltaPhi + x4 * sinDeltaPhi;
    return [
      atan2(y4 * cosDeltaGamma - k2 * sinDeltaGamma, x4 * cosDeltaPhi - z * sinDeltaPhi),
      asin(k2 * cosDeltaGamma + y4 * sinDeltaGamma)
    ];
  }
  rotation.invert = function(lambda, phi2) {
    var cosPhi = cos2(phi2), x4 = cos2(lambda) * cosPhi, y4 = sin2(lambda) * cosPhi, z = sin2(phi2), k2 = z * cosDeltaGamma - y4 * sinDeltaGamma;
    return [
      atan2(y4 * cosDeltaGamma + z * sinDeltaGamma, x4 * cosDeltaPhi + k2 * sinDeltaPhi),
      asin(k2 * cosDeltaPhi - x4 * sinDeltaPhi)
    ];
  };
  return rotation;
}
function rotation_default(rotate) {
  rotate = rotateRadians(rotate[0] * radians2, rotate[1] * radians2, rotate.length > 2 ? rotate[2] * radians2 : 0);
  function forward(coordinates2) {
    coordinates2 = rotate(coordinates2[0] * radians2, coordinates2[1] * radians2);
    return coordinates2[0] *= degrees3, coordinates2[1] *= degrees3, coordinates2;
  }
  forward.invert = function(coordinates2) {
    coordinates2 = rotate.invert(coordinates2[0] * radians2, coordinates2[1] * radians2);
    return coordinates2[0] *= degrees3, coordinates2[1] *= degrees3, coordinates2;
  };
  return forward;
}
var init_rotation = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/rotation.js"() {
    init_compose();
    init_math4();
    rotationIdentity.invert = rotationIdentity;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/circle.js
function circleStream(stream, radius, delta, direction, t03, t13) {
  if (!delta) return;
  var cosRadius = cos2(radius), sinRadius = sin2(radius), step = direction * delta;
  if (t03 == null) {
    t03 = radius + direction * tau5;
    t13 = radius - step / 2;
  } else {
    t03 = circleRadius(cosRadius, t03);
    t13 = circleRadius(cosRadius, t13);
    if (direction > 0 ? t03 < t13 : t03 > t13) t03 += direction * tau5;
  }
  for (var point6, t = t03; direction > 0 ? t > t13 : t < t13; t -= step) {
    point6 = spherical([cosRadius, -sinRadius * cos2(t), -sinRadius * sin2(t)]);
    stream.point(point6[0], point6[1]);
  }
}
function circleRadius(cosRadius, point6) {
  point6 = cartesian(point6), point6[0] -= cosRadius;
  cartesianNormalizeInPlace(point6);
  var radius = acos(-point6[1]);
  return ((-point6[2] < 0 ? -radius : radius) + tau5 - epsilon7) % tau5;
}
function circle_default() {
  var center2 = constant_default8([0, 0]), radius = constant_default8(90), precision = constant_default8(2), ring, rotate, stream = { point: point6 };
  function point6(x4, y4) {
    ring.push(x4 = rotate(x4, y4));
    x4[0] *= degrees3, x4[1] *= degrees3;
  }
  function circle() {
    var c6 = center2.apply(this, arguments), r = radius.apply(this, arguments) * radians2, p = precision.apply(this, arguments) * radians2;
    ring = [];
    rotate = rotateRadians(-c6[0] * radians2, -c6[1] * radians2, 0).invert;
    circleStream(stream, r, p, 1);
    c6 = { type: "Polygon", coordinates: [ring] };
    ring = rotate = null;
    return c6;
  }
  circle.center = function(_) {
    return arguments.length ? (center2 = typeof _ === "function" ? _ : constant_default8([+_[0], +_[1]]), circle) : center2;
  };
  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant_default8(+_), circle) : radius;
  };
  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant_default8(+_), circle) : precision;
  };
  return circle;
}
var init_circle2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/circle.js"() {
    init_cartesian();
    init_constant9();
    init_math4();
    init_rotation();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/buffer.js
function buffer_default2() {
  var lines = [], line;
  return {
    point: function(x4, y4, m3) {
      line.push([x4, y4, m3]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop2,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}
var init_buffer2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/buffer.js"() {
    init_noop2();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/pointEqual.js
function pointEqual_default(a4, b) {
  return abs3(a4[0] - b[0]) < epsilon7 && abs3(a4[1] - b[1]) < epsilon7;
}
var init_pointEqual = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/pointEqual.js"() {
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/rejoin.js
function Intersection(point6, points, other, entry) {
  this.x = point6;
  this.z = points;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function rejoin_default(segments, compareIntersection2, startInside, interpolate, stream) {
  var subject = [], clip = [], i, n;
  segments.forEach(function(segment) {
    if ((n2 = segment.length - 1) <= 0) return;
    var n2, p02 = segment[0], p1 = segment[n2], x4;
    if (pointEqual_default(p02, p1)) {
      if (!p02[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n2; ++i) stream.point((p02 = segment[i])[0], p02[1]);
        stream.lineEnd();
        return;
      }
      p1[0] += 2 * epsilon7;
    }
    subject.push(x4 = new Intersection(p02, segment, null, true));
    clip.push(x4.o = new Intersection(p02, null, x4, false));
    subject.push(x4 = new Intersection(p1, segment, null, false));
    clip.push(x4.o = new Intersection(p1, null, x4, true));
  });
  if (!subject.length) return;
  clip.sort(compareIntersection2);
  link(subject);
  link(clip);
  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }
  var start2 = subject[0], points, point6;
  while (1) {
    var current = start2, isSubject = true;
    while (current.v) if ((current = current.n) === start2) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point6 = points[i])[0], point6[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point6 = points[i])[0], point6[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link(array4) {
  if (!(n = array4.length)) return;
  var n, i = 0, a4 = array4[0], b;
  while (++i < n) {
    a4.n = b = array4[i];
    b.p = a4;
    a4 = b;
  }
  a4.n = b = array4[0];
  b.p = a4;
}
var init_rejoin = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/rejoin.js"() {
    init_pointEqual();
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/polygonContains.js
function longitude(point6) {
  return abs3(point6[0]) <= pi4 ? point6[0] : sign(point6[0]) * ((abs3(point6[0]) + pi4) % tau5 - pi4);
}
function polygonContains_default(polygon, point6) {
  var lambda = longitude(point6), phi2 = point6[1], sinPhi = sin2(phi2), normal = [sin2(lambda), -cos2(lambda), 0], angle2 = 0, winding = 0;
  var sum4 = new Adder();
  if (sinPhi === 1) phi2 = halfPi3 + epsilon7;
  else if (sinPhi === -1) phi2 = -halfPi3 - epsilon7;
  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m3 = (ring = polygon[i]).length)) continue;
    var ring, m3, point0 = ring[m3 - 1], lambda04 = longitude(point0), phi02 = point0[1] / 2 + quarterPi, sinPhi03 = sin2(phi02), cosPhi03 = cos2(phi02);
    for (var j = 0; j < m3; ++j, lambda04 = lambda12, sinPhi03 = sinPhi1, cosPhi03 = cosPhi1, point0 = point1) {
      var point1 = ring[j], lambda12 = longitude(point1), phi12 = point1[1] / 2 + quarterPi, sinPhi1 = sin2(phi12), cosPhi1 = cos2(phi12), delta = lambda12 - lambda04, sign3 = delta >= 0 ? 1 : -1, absDelta = sign3 * delta, antimeridian = absDelta > pi4, k2 = sinPhi03 * sinPhi1;
      sum4.add(atan2(k2 * sign3 * sin2(absDelta), cosPhi03 * cosPhi1 + k2 * cos2(absDelta)));
      angle2 += antimeridian ? delta + sign3 * tau5 : delta;
      if (antimeridian ^ lambda04 >= lambda ^ lambda12 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection2 = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection2);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection2[2]);
        if (phi2 > phiArc || phi2 === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle2 < -epsilon7 || angle2 < epsilon7 && sum4 < -epsilon22) ^ winding & 1;
}
var init_polygonContains = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/polygonContains.js"() {
    init_src2();
    init_cartesian();
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/index.js
function clip_default(pointVisible, clipLine, interpolate, start2) {
  return function(sink) {
    var line = clipLine(sink), ringBuffer = buffer_default2(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
    var clip = {
      point: point6,
      lineStart,
      lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point6;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains_default(polygon, start2);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          rejoin_default(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point6(lambda, phi2) {
      if (pointVisible(lambda, phi2)) sink.point(lambda, phi2);
    }
    function pointLine(lambda, phi2) {
      line.point(lambda, phi2);
    }
    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip.point = point6;
      line.lineEnd();
    }
    function pointRing(lambda, phi2) {
      ring.push([lambda, phi2]);
      ringSink.point(lambda, phi2);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m3, segment, point7;
      ring.pop();
      polygon.push(ring);
      ring = null;
      if (!n) return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m3 = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m3; ++i) sink.point((point7 = segment[i])[0], point7[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a4, b) {
  return ((a4 = a4.x)[0] < 0 ? a4[1] - halfPi3 - epsilon7 : halfPi3 - a4[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi3 - epsilon7 : halfPi3 - b[1]);
}
var init_clip = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/index.js"() {
    init_buffer2();
    init_rejoin();
    init_math4();
    init_polygonContains();
    init_src2();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/antimeridian.js
function clipAntimeridianLine(stream) {
  var lambda04 = NaN, phi02 = NaN, sign0 = NaN, clean;
  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda12, phi12) {
      var sign1 = lambda12 > 0 ? pi4 : -pi4, delta = abs3(lambda12 - lambda04);
      if (abs3(delta - pi4) < epsilon7) {
        stream.point(lambda04, phi02 = (phi02 + phi12) / 2 > 0 ? halfPi3 : -halfPi3);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        stream.point(lambda12, phi02);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi4) {
        if (abs3(lambda04 - sign0) < epsilon7) lambda04 -= sign0 * epsilon7;
        if (abs3(lambda12 - sign1) < epsilon7) lambda12 -= sign1 * epsilon7;
        phi02 = clipAntimeridianIntersect(lambda04, phi02, lambda12, phi12);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        clean = 0;
      }
      stream.point(lambda04 = lambda12, phi02 = phi12);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda04 = phi02 = NaN;
    },
    clean: function() {
      return 2 - clean;
    }
  };
}
function clipAntimeridianIntersect(lambda04, phi02, lambda12, phi12) {
  var cosPhi03, cosPhi1, sinLambda0Lambda1 = sin2(lambda04 - lambda12);
  return abs3(sinLambda0Lambda1) > epsilon7 ? atan((sin2(phi02) * (cosPhi1 = cos2(phi12)) * sin2(lambda12) - sin2(phi12) * (cosPhi03 = cos2(phi02)) * sin2(lambda04)) / (cosPhi03 * cosPhi1 * sinLambda0Lambda1)) : (phi02 + phi12) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi2;
  if (from == null) {
    phi2 = direction * halfPi3;
    stream.point(-pi4, phi2);
    stream.point(0, phi2);
    stream.point(pi4, phi2);
    stream.point(pi4, 0);
    stream.point(pi4, -phi2);
    stream.point(0, -phi2);
    stream.point(-pi4, -phi2);
    stream.point(-pi4, 0);
    stream.point(-pi4, phi2);
  } else if (abs3(from[0] - to[0]) > epsilon7) {
    var lambda = from[0] < to[0] ? pi4 : -pi4;
    phi2 = direction * lambda / 2;
    stream.point(-lambda, phi2);
    stream.point(0, phi2);
    stream.point(lambda, phi2);
  } else {
    stream.point(to[0], to[1]);
  }
}
var antimeridian_default;
var init_antimeridian = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/antimeridian.js"() {
    init_clip();
    init_math4();
    antimeridian_default = clip_default(
      function() {
        return true;
      },
      clipAntimeridianLine,
      clipAntimeridianInterpolate,
      [-pi4, -halfPi3]
    );
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/circle.js
function circle_default2(radius) {
  var cr = cos2(radius), delta = 2 * radians2, smallRadius = cr > 0, notHemisphere = abs3(cr) > epsilon7;
  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }
  function visible(lambda, phi2) {
    return cos2(lambda) * cos2(phi2) > cr;
  }
  function clipLine(stream) {
    var point0, c0, v0, v00, clean;
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi2) {
        var point1 = [lambda, phi2], point22, v2 = visible(lambda, phi2), c6 = smallRadius ? v2 ? 0 : code(lambda, phi2) : v2 ? code(lambda + (lambda < 0 ? pi4 : -pi4), phi2) : 0;
        if (!point0 && (v00 = v0 = v2)) stream.lineStart();
        if (v2 !== v0) {
          point22 = intersect2(point0, point1);
          if (!point22 || pointEqual_default(point0, point22) || pointEqual_default(point1, point22))
            point1[2] = 1;
        }
        if (v2 !== v0) {
          clean = 0;
          if (v2) {
            stream.lineStart();
            point22 = intersect2(point1, point0);
            stream.point(point22[0], point22[1]);
          } else {
            point22 = intersect2(point0, point1);
            stream.point(point22[0], point22[1], 2);
            stream.lineEnd();
          }
          point0 = point22;
        } else if (notHemisphere && point0 && smallRadius ^ v2) {
          var t;
          if (!(c6 & c0) && (t = intersect2(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v2 && (!point0 || !pointEqual_default(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v2, c0 = c6;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect2(a4, b, two) {
    var pa = cartesian(a4), pb = cartesian(b);
    var n1 = [1, 0, 0], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
    if (!determinant) return !two && a4;
    var c1 = cr * n2n2 / determinant, c22 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A5 = cartesianScale(n1, c1), B3 = cartesianScale(n2, c22);
    cartesianAddInPlace(A5, B3);
    var u4 = n1xn2, w = cartesianDot(A5, u4), uu = cartesianDot(u4, u4), t22 = w * w - uu * (cartesianDot(A5, A5) - 1);
    if (t22 < 0) return;
    var t = sqrt(t22), q = cartesianScale(u4, (-w - t) / uu);
    cartesianAddInPlace(q, A5);
    q = spherical(q);
    if (!two) return q;
    var lambda04 = a4[0], lambda12 = b[0], phi02 = a4[1], phi12 = b[1], z;
    if (lambda12 < lambda04) z = lambda04, lambda04 = lambda12, lambda12 = z;
    var delta2 = lambda12 - lambda04, polar = abs3(delta2 - pi4) < epsilon7, meridian = polar || delta2 < epsilon7;
    if (!polar && phi12 < phi02) z = phi02, phi02 = phi12, phi12 = z;
    if (meridian ? polar ? phi02 + phi12 > 0 ^ q[1] < (abs3(q[0] - lambda04) < epsilon7 ? phi02 : phi12) : phi02 <= q[1] && q[1] <= phi12 : delta2 > pi4 ^ (lambda04 <= q[0] && q[0] <= lambda12)) {
      var q1 = cartesianScale(u4, (-w + t) / uu);
      cartesianAddInPlace(q1, A5);
      return [q, spherical(q1)];
    }
  }
  function code(lambda, phi2) {
    var r = smallRadius ? radius : pi4 - radius, code2 = 0;
    if (lambda < -r) code2 |= 1;
    else if (lambda > r) code2 |= 2;
    if (phi2 < -r) code2 |= 4;
    else if (phi2 > r) code2 |= 8;
    return code2;
  }
  return clip_default(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi4, radius - pi4]);
}
var init_circle3 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/circle.js"() {
    init_cartesian();
    init_circle2();
    init_math4();
    init_pointEqual();
    init_clip();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/line.js
function line_default(a4, b, x06, y06, x12, y12) {
  var ax = a4[0], ay = a4[1], bx = b[0], by = b[1], t03 = 0, t13 = 1, dx = bx - ax, dy = by - ay, r;
  r = x06 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t03) return;
    if (r < t13) t13 = r;
  } else if (dx > 0) {
    if (r > t13) return;
    if (r > t03) t03 = r;
  }
  r = x12 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t13) return;
    if (r > t03) t03 = r;
  } else if (dx > 0) {
    if (r < t03) return;
    if (r < t13) t13 = r;
  }
  r = y06 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t03) return;
    if (r < t13) t13 = r;
  } else if (dy > 0) {
    if (r > t13) return;
    if (r > t03) t03 = r;
  }
  r = y12 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t13) return;
    if (r > t03) t03 = r;
  } else if (dy > 0) {
    if (r < t03) return;
    if (r < t13) t13 = r;
  }
  if (t03 > 0) a4[0] = ax + t03 * dx, a4[1] = ay + t03 * dy;
  if (t13 < 1) b[0] = ax + t13 * dx, b[1] = ay + t13 * dy;
  return true;
}
var init_line = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/line.js"() {
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/rectangle.js
function clipRectangle(x06, y06, x12, y12) {
  function visible(x4, y4) {
    return x06 <= x4 && x4 <= x12 && y06 <= y4 && y4 <= y12;
  }
  function interpolate(from, to, direction, stream) {
    var a4 = 0, a1 = 0;
    if (from == null || (a4 = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do
        stream.point(a4 === 0 || a4 === 3 ? x06 : x12, a4 > 1 ? y12 : y06);
      while ((a4 = (a4 + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p, direction) {
    return abs3(p[0] - x06) < epsilon7 ? direction > 0 ? 0 : 3 : abs3(p[0] - x12) < epsilon7 ? direction > 0 ? 2 : 1 : abs3(p[1] - y06) < epsilon7 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection2(a4, b) {
    return comparePoint(a4.x, b.x);
  }
  function comparePoint(a4, b) {
    var ca3 = corner(a4, 1), cb = corner(b, 1);
    return ca3 !== cb ? ca3 - cb : ca3 === 0 ? b[1] - a4[1] : ca3 === 1 ? a4[0] - b[0] : ca3 === 2 ? a4[1] - b[1] : b[0] - a4[0];
  }
  return function(stream) {
    var activeStream = stream, bufferStream = buffer_default2(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
    var clipStream = {
      point: point6,
      lineStart,
      lineEnd,
      polygonStart,
      polygonEnd
    };
    function point6(x4, y4) {
      if (visible(x4, y4)) activeStream.point(x4, y4);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring2 = polygon[i], j = 1, m3 = ring2.length, point7 = ring2[0], a0, a1, b02 = point7[0], b12 = point7[1]; j < m3; ++j) {
          a0 = b02, a1 = b12, point7 = ring2[j], b02 = point7[0], b12 = point7[1];
          if (a1 <= y12) {
            if (b12 > y12 && (b02 - a0) * (y12 - a1) > (b12 - a1) * (x06 - a0)) ++winding;
          } else {
            if (b12 <= y12 && (b02 - a0) * (y12 - a1) < (b12 - a1) * (x06 - a0)) --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = merge(segments)).length;
      if (cleanInside || visible2) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible2) {
          rejoin_default(segments, compareIntersection2, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint2;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint2(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point6;
      if (v_) activeStream.lineEnd();
    }
    function linePoint2(x4, y4) {
      var v2 = visible(x4, y4);
      if (polygon) ring.push([x4, y4]);
      if (first) {
        x__ = x4, y__ = y4, v__ = v2;
        first = false;
        if (v2) {
          activeStream.lineStart();
          activeStream.point(x4, y4);
        }
      } else {
        if (v2 && v_) activeStream.point(x4, y4);
        else {
          var a4 = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b = [x4 = Math.max(clipMin, Math.min(clipMax, x4)), y4 = Math.max(clipMin, Math.min(clipMax, y4))];
          if (line_default(a4, b, x06, y06, x12, y12)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a4[0], a4[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v2) activeStream.lineEnd();
            clean = false;
          } else if (v2) {
            activeStream.lineStart();
            activeStream.point(x4, y4);
            clean = false;
          }
        }
      }
      x_ = x4, y_ = y4, v_ = v2;
    }
    return clipStream;
  };
}
var clipMax, clipMin;
var init_rectangle = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/rectangle.js"() {
    init_math4();
    init_buffer2();
    init_line();
    init_rejoin();
    init_src2();
    clipMax = 1e9;
    clipMin = -clipMax;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/extent.js
function extent_default2() {
  var x06 = 0, y06 = 0, x12 = 960, y12 = 500, cache, cacheStream, clip;
  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipRectangle(x06, y06, x12, y12)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x06 = +_[0][0], y06 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1], cache = cacheStream = null, clip) : [[x06, y06], [x12, y12]];
    }
  };
}
var init_extent3 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/clip/extent.js"() {
    init_rectangle();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/length.js
function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop2;
}
function lengthPointFirst(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  lambda03 = lambda, sinPhi02 = sin2(phi2), cosPhi02 = cos2(phi2);
  lengthStream.point = lengthPoint;
}
function lengthPoint(lambda, phi2) {
  lambda *= radians2, phi2 *= radians2;
  var sinPhi = sin2(phi2), cosPhi = cos2(phi2), delta = abs3(lambda - lambda03), cosDelta = cos2(delta), sinDelta = sin2(delta), x4 = cosPhi * sinDelta, y4 = cosPhi02 * sinPhi - sinPhi02 * cosPhi * cosDelta, z = sinPhi02 * sinPhi + cosPhi02 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x4 * x4 + y4 * y4), z));
  lambda03 = lambda, sinPhi02 = sinPhi, cosPhi02 = cosPhi;
}
function length_default(object2) {
  lengthSum = new Adder();
  stream_default(object2, lengthStream);
  return +lengthSum;
}
var lengthSum, lambda03, sinPhi02, cosPhi02, lengthStream;
var init_length = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/length.js"() {
    init_src2();
    init_math4();
    init_noop2();
    init_stream();
    lengthStream = {
      sphere: noop2,
      point: noop2,
      lineStart: lengthLineStart,
      lineEnd: noop2,
      polygonStart: noop2,
      polygonEnd: noop2
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/distance.js
function distance_default(a4, b) {
  coordinates[0] = a4;
  coordinates[1] = b;
  return length_default(object);
}
var coordinates, object;
var init_distance = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/distance.js"() {
    init_length();
    coordinates = [null, null];
    object = { type: "LineString", coordinates };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/contains.js
function containsGeometry(geometry, point6) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point6) : false;
}
function containsPoint(coordinates2, point6) {
  return distance_default(coordinates2, point6) === 0;
}
function containsLine(coordinates2, point6) {
  var ao, bo, ab4;
  for (var i = 0, n = coordinates2.length; i < n; i++) {
    bo = distance_default(coordinates2[i], point6);
    if (bo === 0) return true;
    if (i > 0) {
      ab4 = distance_default(coordinates2[i], coordinates2[i - 1]);
      if (ab4 > 0 && ao <= ab4 && bo <= ab4 && (ao + bo - ab4) * (1 - Math.pow((ao - bo) / ab4, 2)) < epsilon22 * ab4)
        return true;
    }
    ao = bo;
  }
  return false;
}
function containsPolygon(coordinates2, point6) {
  return !!polygonContains_default(coordinates2.map(ringRadians), pointRadians(point6));
}
function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point6) {
  return [point6[0] * radians2, point6[1] * radians2];
}
function contains_default2(object2, point6) {
  return (object2 && containsObjectType.hasOwnProperty(object2.type) ? containsObjectType[object2.type] : containsGeometry)(object2, point6);
}
var containsObjectType, containsGeometryType;
var init_contains2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/contains.js"() {
    init_polygonContains();
    init_distance();
    init_math4();
    containsObjectType = {
      Feature: function(object2, point6) {
        return containsGeometry(object2.geometry, point6);
      },
      FeatureCollection: function(object2, point6) {
        var features = object2.features, i = -1, n = features.length;
        while (++i < n) if (containsGeometry(features[i].geometry, point6)) return true;
        return false;
      }
    };
    containsGeometryType = {
      Sphere: function() {
        return true;
      },
      Point: function(object2, point6) {
        return containsPoint(object2.coordinates, point6);
      },
      MultiPoint: function(object2, point6) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) if (containsPoint(coordinates2[i], point6)) return true;
        return false;
      },
      LineString: function(object2, point6) {
        return containsLine(object2.coordinates, point6);
      },
      MultiLineString: function(object2, point6) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) if (containsLine(coordinates2[i], point6)) return true;
        return false;
      },
      Polygon: function(object2, point6) {
        return containsPolygon(object2.coordinates, point6);
      },
      MultiPolygon: function(object2, point6) {
        var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
        while (++i < n) if (containsPolygon(coordinates2[i], point6)) return true;
        return false;
      },
      GeometryCollection: function(object2, point6) {
        var geometries = object2.geometries, i = -1, n = geometries.length;
        while (++i < n) if (containsGeometry(geometries[i], point6)) return true;
        return false;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/graticule.js
function graticuleX(y06, y12, dy) {
  var y4 = range(y06, y12 - epsilon7, dy).concat(y12);
  return function(x4) {
    return y4.map(function(y5) {
      return [x4, y5];
    });
  };
}
function graticuleY(x06, x12, dx) {
  var x4 = range(x06, x12 - epsilon7, dx).concat(x12);
  return function(y4) {
    return x4.map(function(x5) {
      return [x5, y4];
    });
  };
}
function graticule() {
  var x12, x06, X13, X03, y12, y06, Y13, Y03, dx = 10, dy = dx, DX = 90, DY = 360, x4, y4, X3, Y3, precision = 2.5;
  function graticule2() {
    return { type: "MultiLineString", coordinates: lines() };
  }
  function lines() {
    return range(ceil(X03 / DX) * DX, X13, DX).map(X3).concat(range(ceil(Y03 / DY) * DY, Y13, DY).map(Y3)).concat(range(ceil(x06 / dx) * dx, x12, dx).filter(function(x5) {
      return abs3(x5 % DX) > epsilon7;
    }).map(x4)).concat(range(ceil(y06 / dy) * dy, y12, dy).filter(function(y5) {
      return abs3(y5 % DY) > epsilon7;
    }).map(y4));
  }
  graticule2.lines = function() {
    return lines().map(function(coordinates2) {
      return { type: "LineString", coordinates: coordinates2 };
    });
  };
  graticule2.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X3(X03).concat(
          Y3(Y13).slice(1),
          X3(X13).reverse().slice(1),
          Y3(Y03).reverse().slice(1)
        )
      ]
    };
  };
  graticule2.extent = function(_) {
    if (!arguments.length) return graticule2.extentMinor();
    return graticule2.extentMajor(_).extentMinor(_);
  };
  graticule2.extentMajor = function(_) {
    if (!arguments.length) return [[X03, Y03], [X13, Y13]];
    X03 = +_[0][0], X13 = +_[1][0];
    Y03 = +_[0][1], Y13 = +_[1][1];
    if (X03 > X13) _ = X03, X03 = X13, X13 = _;
    if (Y03 > Y13) _ = Y03, Y03 = Y13, Y13 = _;
    return graticule2.precision(precision);
  };
  graticule2.extentMinor = function(_) {
    if (!arguments.length) return [[x06, y06], [x12, y12]];
    x06 = +_[0][0], x12 = +_[1][0];
    y06 = +_[0][1], y12 = +_[1][1];
    if (x06 > x12) _ = x06, x06 = x12, x12 = _;
    if (y06 > y12) _ = y06, y06 = y12, y12 = _;
    return graticule2.precision(precision);
  };
  graticule2.step = function(_) {
    if (!arguments.length) return graticule2.stepMinor();
    return graticule2.stepMajor(_).stepMinor(_);
  };
  graticule2.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule2;
  };
  graticule2.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule2;
  };
  graticule2.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x4 = graticuleX(y06, y12, 90);
    y4 = graticuleY(x06, x12, precision);
    X3 = graticuleX(Y03, Y13, 90);
    Y3 = graticuleY(X03, X13, precision);
    return graticule2;
  };
  return graticule2.extentMajor([[-180, -90 + epsilon7], [180, 90 - epsilon7]]).extentMinor([[-180, -80 - epsilon7], [180, 80 + epsilon7]]);
}
function graticule10() {
  return graticule()();
}
var init_graticule = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/graticule.js"() {
    init_src2();
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/interpolate.js
function interpolate_default2(a4, b) {
  var x06 = a4[0] * radians2, y06 = a4[1] * radians2, x12 = b[0] * radians2, y12 = b[1] * radians2, cy0 = cos2(y06), sy0 = sin2(y06), cy1 = cos2(y12), sy1 = sin2(y12), kx0 = cy0 * cos2(x06), ky0 = cy0 * sin2(x06), kx1 = cy1 * cos2(x12), ky1 = cy1 * sin2(x12), d = 2 * asin(sqrt(haversin(y12 - y06) + cy0 * cy1 * haversin(x12 - x06))), k2 = sin2(d);
  var interpolate = d ? function(t) {
    var B3 = sin2(t *= d) / k2, A5 = sin2(d - t) / k2, x4 = A5 * kx0 + B3 * kx1, y4 = A5 * ky0 + B3 * ky1, z = A5 * sy0 + B3 * sy1;
    return [
      atan2(y4, x4) * degrees3,
      atan2(z, sqrt(x4 * x4 + y4 * y4)) * degrees3
    ];
  } : function() {
    return [x06 * degrees3, y06 * degrees3];
  };
  interpolate.distance = d;
  return interpolate;
}
var init_interpolate2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/interpolate.js"() {
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/identity.js
var identity_default3;
var init_identity4 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/identity.js"() {
    identity_default3 = (x4) => x4;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/area.js
function areaRingStart2() {
  areaStream2.point = areaPointFirst2;
}
function areaPointFirst2(x4, y4) {
  areaStream2.point = areaPoint2;
  x00 = x02 = x4, y00 = y02 = y4;
}
function areaPoint2(x4, y4) {
  areaRingSum2.add(y02 * x4 - x02 * y4);
  x02 = x4, y02 = y4;
}
function areaRingEnd2() {
  areaPoint2(x00, y00);
}
var areaSum2, areaRingSum2, x00, y00, x02, y02, areaStream2, area_default3;
var init_area3 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/area.js"() {
    init_src2();
    init_math4();
    init_noop2();
    areaSum2 = new Adder();
    areaRingSum2 = new Adder();
    areaStream2 = {
      point: noop2,
      lineStart: noop2,
      lineEnd: noop2,
      polygonStart: function() {
        areaStream2.lineStart = areaRingStart2;
        areaStream2.lineEnd = areaRingEnd2;
      },
      polygonEnd: function() {
        areaStream2.lineStart = areaStream2.lineEnd = areaStream2.point = noop2;
        areaSum2.add(abs3(areaRingSum2));
        areaRingSum2 = new Adder();
      },
      result: function() {
        var area = areaSum2 / 2;
        areaSum2 = new Adder();
        return area;
      }
    };
    area_default3 = areaStream2;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/bounds.js
function boundsPoint2(x4, y4) {
  if (x4 < x03) x03 = x4;
  if (x4 > x1) x1 = x4;
  if (y4 < y03) y03 = y4;
  if (y4 > y1) y1 = y4;
}
var x03, y03, x1, y1, boundsStream2, bounds_default2;
var init_bounds2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/bounds.js"() {
    init_noop2();
    x03 = Infinity;
    y03 = x03;
    x1 = -x03;
    y1 = x1;
    boundsStream2 = {
      point: boundsPoint2,
      lineStart: noop2,
      lineEnd: noop2,
      polygonStart: noop2,
      polygonEnd: noop2,
      result: function() {
        var bounds = [[x03, y03], [x1, y1]];
        x1 = y1 = -(y03 = x03 = Infinity);
        return bounds;
      }
    };
    bounds_default2 = boundsStream2;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/centroid.js
function centroidPoint2(x4, y4) {
  X02 += x4;
  Y02 += y4;
  ++Z02;
}
function centroidLineStart2() {
  centroidStream2.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x4, y4) {
  centroidStream2.point = centroidPointLine;
  centroidPoint2(x04 = x4, y04 = y4);
}
function centroidPointLine(x4, y4) {
  var dx = x4 - x04, dy = y4 - y04, z = sqrt(dx * dx + dy * dy);
  X12 += z * (x04 + x4) / 2;
  Y12 += z * (y04 + y4) / 2;
  Z12 += z;
  centroidPoint2(x04 = x4, y04 = y4);
}
function centroidLineEnd2() {
  centroidStream2.point = centroidPoint2;
}
function centroidRingStart2() {
  centroidStream2.point = centroidPointFirstRing;
}
function centroidRingEnd2() {
  centroidPointRing(x002, y002);
}
function centroidPointFirstRing(x4, y4) {
  centroidStream2.point = centroidPointRing;
  centroidPoint2(x002 = x04 = x4, y002 = y04 = y4);
}
function centroidPointRing(x4, y4) {
  var dx = x4 - x04, dy = y4 - y04, z = sqrt(dx * dx + dy * dy);
  X12 += z * (x04 + x4) / 2;
  Y12 += z * (y04 + y4) / 2;
  Z12 += z;
  z = y04 * x4 - x04 * y4;
  X22 += z * (x04 + x4);
  Y22 += z * (y04 + y4);
  Z22 += z * 3;
  centroidPoint2(x04 = x4, y04 = y4);
}
var X02, Y02, Z02, X12, Y12, Z12, X22, Y22, Z22, x002, y002, x04, y04, centroidStream2, centroid_default2;
var init_centroid2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/centroid.js"() {
    init_math4();
    X02 = 0;
    Y02 = 0;
    Z02 = 0;
    X12 = 0;
    Y12 = 0;
    Z12 = 0;
    X22 = 0;
    Y22 = 0;
    Z22 = 0;
    centroidStream2 = {
      point: centroidPoint2,
      lineStart: centroidLineStart2,
      lineEnd: centroidLineEnd2,
      polygonStart: function() {
        centroidStream2.lineStart = centroidRingStart2;
        centroidStream2.lineEnd = centroidRingEnd2;
      },
      polygonEnd: function() {
        centroidStream2.point = centroidPoint2;
        centroidStream2.lineStart = centroidLineStart2;
        centroidStream2.lineEnd = centroidLineEnd2;
      },
      result: function() {
        var centroid = Z22 ? [X22 / Z22, Y22 / Z22] : Z12 ? [X12 / Z12, Y12 / Z12] : Z02 ? [X02 / Z02, Y02 / Z02] : [NaN, NaN];
        X02 = Y02 = Z02 = X12 = Y12 = Z12 = X22 = Y22 = Z22 = 0;
        return centroid;
      }
    };
    centroid_default2 = centroidStream2;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/context.js
function PathContext(context) {
  this._context = context;
}
var init_context = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/context.js"() {
    init_math4();
    init_noop2();
    PathContext.prototype = {
      _radius: 4.5,
      pointRadius: function(_) {
        return this._radius = _, this;
      },
      polygonStart: function() {
        this._line = 0;
      },
      polygonEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._point = 0;
      },
      lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
      },
      point: function(x4, y4) {
        switch (this._point) {
          case 0: {
            this._context.moveTo(x4, y4);
            this._point = 1;
            break;
          }
          case 1: {
            this._context.lineTo(x4, y4);
            break;
          }
          default: {
            this._context.moveTo(x4 + this._radius, y4);
            this._context.arc(x4, y4, this._radius, 0, tau5);
            break;
          }
        }
      },
      result: noop2
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/measure.js
function lengthPointFirst2(x4, y4) {
  lengthStream2.point = lengthPoint2;
  x003 = x05 = x4, y003 = y05 = y4;
}
function lengthPoint2(x4, y4) {
  x05 -= x4, y05 -= y4;
  lengthSum2.add(sqrt(x05 * x05 + y05 * y05));
  x05 = x4, y05 = y4;
}
var lengthSum2, lengthRing, x003, y003, x05, y05, lengthStream2, measure_default;
var init_measure = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/measure.js"() {
    init_src2();
    init_math4();
    init_noop2();
    lengthSum2 = new Adder();
    lengthStream2 = {
      point: noop2,
      lineStart: function() {
        lengthStream2.point = lengthPointFirst2;
      },
      lineEnd: function() {
        if (lengthRing) lengthPoint2(x003, y003);
        lengthStream2.point = noop2;
      },
      polygonStart: function() {
        lengthRing = true;
      },
      polygonEnd: function() {
        lengthRing = null;
      },
      result: function() {
        var length3 = +lengthSum2;
        lengthSum2 = new Adder();
        return length3;
      }
    };
    measure_default = lengthStream2;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/string.js
function append2(strings) {
  let i = 1;
  this._ += strings[0];
  for (const j = strings.length; i < j; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound2(digits) {
  const d = Math.floor(digits);
  if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
  if (d > 15) return append2;
  if (d !== cacheDigits) {
    const k2 = 10 ** d;
    cacheDigits = d;
    cacheAppend = function append3(strings) {
      let i = 1;
      this._ += strings[0];
      for (const j = strings.length; i < j; ++i) {
        this._ += Math.round(arguments[i] * k2) / k2 + strings[i];
      }
    };
  }
  return cacheAppend;
}
var cacheDigits, cacheAppend, cacheRadius, cacheCircle, PathString;
var init_string2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/string.js"() {
    PathString = class {
      constructor(digits) {
        this._append = digits == null ? append2 : appendRound2(digits);
        this._radius = 4.5;
        this._ = "";
      }
      pointRadius(_) {
        this._radius = +_;
        return this;
      }
      polygonStart() {
        this._line = 0;
      }
      polygonEnd() {
        this._line = NaN;
      }
      lineStart() {
        this._point = 0;
      }
      lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
      }
      point(x4, y4) {
        switch (this._point) {
          case 0: {
            this._append`M${x4},${y4}`;
            this._point = 1;
            break;
          }
          case 1: {
            this._append`L${x4},${y4}`;
            break;
          }
          default: {
            this._append`M${x4},${y4}`;
            if (this._radius !== cacheRadius || this._append !== cacheAppend) {
              const r = this._radius;
              const s2 = this._;
              this._ = "";
              this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
              cacheRadius = r;
              cacheAppend = this._append;
              cacheCircle = this._;
              this._ = s2;
            }
            this._ += cacheCircle;
            break;
          }
        }
      }
      result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/index.js
function path_default(projection2, context) {
  let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
  function path2(object2) {
    if (object2) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      stream_default(object2, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path2.area = function(object2) {
    stream_default(object2, projectionStream(area_default3));
    return area_default3.result();
  };
  path2.measure = function(object2) {
    stream_default(object2, projectionStream(measure_default));
    return measure_default.result();
  };
  path2.bounds = function(object2) {
    stream_default(object2, projectionStream(bounds_default2));
    return bounds_default2.result();
  };
  path2.centroid = function(object2) {
    stream_default(object2, projectionStream(centroid_default2));
    return centroid_default2.result();
  };
  path2.projection = function(_) {
    if (!arguments.length) return projection2;
    projectionStream = _ == null ? (projection2 = null, identity_default3) : (projection2 = _).stream;
    return path2;
  };
  path2.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString(digits)) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path2;
  };
  path2.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path2;
  };
  path2.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) digits = null;
    else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    if (context === null) contextStream = new PathString(digits);
    return path2;
  };
  return path2.projection(projection2).digits(digits).context(context);
}
var init_path3 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/path/index.js"() {
    init_identity4();
    init_stream();
    init_area3();
    init_bounds2();
    init_centroid2();
    init_context();
    init_measure();
    init_string2();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/transform.js
function transform_default(methods) {
  return {
    stream: transformer(methods)
  };
}
function transformer(methods) {
  return function(stream) {
    var s2 = new TransformStream();
    for (var key in methods) s2[key] = methods[key];
    s2.stream = stream;
    return s2;
  };
}
function TransformStream() {
}
var init_transform2 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/transform.js"() {
    TransformStream.prototype = {
      constructor: TransformStream,
      point: function(x4, y4) {
        this.stream.point(x4, y4);
      },
      sphere: function() {
        this.stream.sphere();
      },
      lineStart: function() {
        this.stream.lineStart();
      },
      lineEnd: function() {
        this.stream.lineEnd();
      },
      polygonStart: function() {
        this.stream.polygonStart();
      },
      polygonEnd: function() {
        this.stream.polygonEnd();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/fit.js
function fit(projection2, fitBounds, object2) {
  var clip = projection2.clipExtent && projection2.clipExtent();
  projection2.scale(150).translate([0, 0]);
  if (clip != null) projection2.clipExtent(null);
  stream_default(object2, projection2.stream(bounds_default2));
  fitBounds(bounds_default2.result());
  if (clip != null) projection2.clipExtent(clip);
  return projection2;
}
function fitExtent(projection2, extent2, object2) {
  return fit(projection2, function(b) {
    var w = extent2[1][0] - extent2[0][0], h = extent2[1][1] - extent2[0][1], k2 = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x4 = +extent2[0][0] + (w - k2 * (b[1][0] + b[0][0])) / 2, y4 = +extent2[0][1] + (h - k2 * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k2).translate([x4, y4]);
  }, object2);
}
function fitSize(projection2, size, object2) {
  return fitExtent(projection2, [[0, 0], size], object2);
}
function fitWidth(projection2, width, object2) {
  return fit(projection2, function(b) {
    var w = +width, k2 = w / (b[1][0] - b[0][0]), x4 = (w - k2 * (b[1][0] + b[0][0])) / 2, y4 = -k2 * b[0][1];
    projection2.scale(150 * k2).translate([x4, y4]);
  }, object2);
}
function fitHeight(projection2, height, object2) {
  return fit(projection2, function(b) {
    var h = +height, k2 = h / (b[1][1] - b[0][1]), x4 = -k2 * b[0][0], y4 = (h - k2 * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k2).translate([x4, y4]);
  }, object2);
}
var init_fit = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/fit.js"() {
    init_stream();
    init_bounds2();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/resample.js
function resample_default(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer({
    point: function(x4, y4) {
      x4 = project(x4, y4);
      this.stream.point(x4[0], x4[1]);
    }
  });
}
function resample(project, delta2) {
  function resampleLineTo(x06, y06, lambda04, a0, b02, c0, x12, y12, lambda12, a1, b12, c1, depth, stream) {
    var dx = x12 - x06, dy = y12 - y06, d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a4 = a0 + a1, b = b02 + b12, c6 = c0 + c1, m3 = sqrt(a4 * a4 + b * b + c6 * c6), phi2 = asin(c6 /= m3), lambda22 = abs3(abs3(c6) - 1) < epsilon7 || abs3(lambda04 - lambda12) < epsilon7 ? (lambda04 + lambda12) / 2 : atan2(b, a4), p = project(lambda22, phi2), x22 = p[0], y22 = p[1], dx2 = x22 - x06, dy2 = y22 - y06, dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs3((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b02 * b12 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x06, y06, lambda04, a0, b02, c0, x22, y22, lambda22, a4 /= m3, b /= m3, c6, depth, stream);
        stream.point(x22, y22);
        resampleLineTo(x22, y22, lambda22, a4, b, c6, x12, y12, lambda12, a1, b12, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda004, x004, y004, a00, b00, c00, lambda04, x06, y06, a0, b02, c0;
    var resampleStream = {
      point: point6,
      lineStart,
      lineEnd,
      polygonStart: function() {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function() {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point6(x4, y4) {
      x4 = project(x4, y4);
      stream.point(x4[0], x4[1]);
    }
    function lineStart() {
      x06 = NaN;
      resampleStream.point = linePoint2;
      stream.lineStart();
    }
    function linePoint2(lambda, phi2) {
      var c6 = cartesian([lambda, phi2]), p = project(lambda, phi2);
      resampleLineTo(x06, y06, lambda04, a0, b02, c0, x06 = p[0], y06 = p[1], lambda04 = lambda, a0 = c6[0], b02 = c6[1], c0 = c6[2], maxDepth, stream);
      stream.point(x06, y06);
    }
    function lineEnd() {
      resampleStream.point = point6;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi2) {
      linePoint2(lambda004 = lambda, phi2), x004 = x06, y004 = y06, a00 = a0, b00 = b02, c00 = c0;
      resampleStream.point = linePoint2;
    }
    function ringEnd() {
      resampleLineTo(x06, y06, lambda04, a0, b02, c0, x004, y004, lambda004, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}
var maxDepth, cosMinDistance;
var init_resample = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/resample.js"() {
    init_cartesian();
    init_math4();
    init_transform2();
    maxDepth = 16;
    cosMinDistance = cos2(30 * radians2);
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/index.js
function transformRotate(rotate) {
  return transformer({
    point: function(x4, y4) {
      var r = rotate(x4, y4);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function scaleTranslate(k2, dx, dy, sx, sy) {
  function transform2(x4, y4) {
    x4 *= sx;
    y4 *= sy;
    return [dx + k2 * x4, dy - k2 * y4];
  }
  transform2.invert = function(x4, y4) {
    return [(x4 - dx) / k2 * sx, (dy - y4) / k2 * sy];
  };
  return transform2;
}
function scaleTranslateRotate(k2, dx, dy, sx, sy, alpha) {
  if (!alpha) return scaleTranslate(k2, dx, dy, sx, sy);
  var cosAlpha = cos2(alpha), sinAlpha = sin2(alpha), a4 = cosAlpha * k2, b = sinAlpha * k2, ai = cosAlpha / k2, bi = sinAlpha / k2, ci = (sinAlpha * dy - cosAlpha * dx) / k2, fi = (sinAlpha * dx + cosAlpha * dy) / k2;
  function transform2(x4, y4) {
    x4 *= sx;
    y4 *= sy;
    return [a4 * x4 - b * y4 + dx, dy - b * x4 - a4 * y4];
  }
  transform2.invert = function(x4, y4) {
    return [sx * (ai * x4 - bi * y4 + ci), sy * (fi - bi * x4 - ai * y4)];
  };
  return transform2;
}
function projection(project) {
  return projectionMutator(function() {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project, k2 = 150, x4 = 480, y4 = 250, lambda = 0, phi2 = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = antimeridian_default, x06 = null, y06, x12, y12, postclip = identity_default3, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
  function projection2(point6) {
    return projectRotateTransform(point6[0] * radians2, point6[1] * radians2);
  }
  function invert(point6) {
    point6 = projectRotateTransform.invert(point6[0], point6[1]);
    return point6 && [point6[0] * degrees3, point6[1] * degrees3];
  }
  projection2.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection2.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = void 0, reset()) : preclip;
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x06 = y06 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? circle_default2(theta = _ * radians2) : (theta = null, antimeridian_default), reset()) : theta * degrees3;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x06 = y06 = x12 = y12 = null, identity_default3) : clipRectangle(x06 = +_[0][0], y06 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset()) : x06 == null ? null : [[x06, y06], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k2 = +_, recenter()) : k2;
  };
  projection2.translate = function(_) {
    return arguments.length ? (x4 = +_[0], y4 = +_[1], recenter()) : [x4, y4];
  };
  projection2.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians2, phi2 = _[1] % 360 * radians2, recenter()) : [lambda * degrees3, phi2 * degrees3];
  };
  projection2.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians2, deltaPhi = _[1] % 360 * radians2, deltaGamma = _.length > 2 ? _[2] % 360 * radians2 : 0, recenter()) : [deltaLambda * degrees3, deltaPhi * degrees3, deltaGamma * degrees3];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians2, recenter()) : alpha * degrees3;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };
  projection2.precision = function(_) {
    return arguments.length ? (projectResample = resample_default(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height, object2) {
    return fitHeight(projection2, height, object2);
  };
  function recenter() {
    var center2 = scaleTranslateRotate(k2, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi2)), transform2 = scaleTranslateRotate(k2, x4 - center2[0], y4 - center2[1], sx, sy, alpha);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose_default(project, transform2);
    projectRotateTransform = compose_default(rotate, projectTransform);
    projectResample = resample_default(projectTransform, delta2);
    return reset();
  }
  function reset() {
    cache = cacheStream = null;
    return projection2;
  }
  return function() {
    project = projectAt.apply(this, arguments);
    projection2.invert = project.invert && invert;
    return recenter();
  };
}
var transformRadians;
var init_projection = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/index.js"() {
    init_antimeridian();
    init_circle3();
    init_rectangle();
    init_compose();
    init_identity4();
    init_math4();
    init_rotation();
    init_transform2();
    init_fit();
    init_resample();
    transformRadians = transformer({
      point: function(x4, y4) {
        this.stream.point(x4 * radians2, y4 * radians2);
      }
    });
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conic.js
function conicProjection(projectAt) {
  var phi02 = 0, phi12 = pi4 / 3, m3 = projectionMutator(projectAt), p = m3(phi02, phi12);
  p.parallels = function(_) {
    return arguments.length ? m3(phi02 = _[0] * radians2, phi12 = _[1] * radians2) : [phi02 * degrees3, phi12 * degrees3];
  };
  return p;
}
var init_conic = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conic.js"() {
    init_math4();
    init_projection();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/cylindricalEqualArea.js
function cylindricalEqualAreaRaw(phi02) {
  var cosPhi03 = cos2(phi02);
  function forward(lambda, phi2) {
    return [lambda * cosPhi03, sin2(phi2) / cosPhi03];
  }
  forward.invert = function(x4, y4) {
    return [x4 / cosPhi03, asin(y4 * cosPhi03)];
  };
  return forward;
}
var init_cylindricalEqualArea = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/cylindricalEqualArea.js"() {
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicEqualArea.js
function conicEqualAreaRaw(y06, y12) {
  var sy0 = sin2(y06), n = (sy0 + sin2(y12)) / 2;
  if (abs3(n) < epsilon7) return cylindricalEqualAreaRaw(y06);
  var c6 = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c6) / n;
  function project(x4, y4) {
    var r = sqrt(c6 - 2 * n * sin2(y4)) / n;
    return [r * sin2(x4 *= n), r0 - r * cos2(x4)];
  }
  project.invert = function(x4, y4) {
    var r0y = r0 - y4, l = atan2(x4, abs3(r0y)) * sign(r0y);
    if (r0y * n < 0)
      l -= pi4 * sign(x4) * sign(r0y);
    return [l / n, asin((c6 - (x4 * x4 + r0y * r0y) * n * n) / (2 * n))];
  };
  return project;
}
function conicEqualArea_default() {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}
var init_conicEqualArea = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicEqualArea.js"() {
    init_math4();
    init_conic();
    init_cylindricalEqualArea();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/albers.js
function albers_default() {
  return conicEqualArea_default().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
var init_albers = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/albers.js"() {
    init_conicEqualArea();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/albersUsa.js
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x4, y4) {
      var i = -1;
      while (++i < n) streams[i].point(x4, y4);
    },
    sphere: function() {
      var i = -1;
      while (++i < n) streams[i].sphere();
    },
    lineStart: function() {
      var i = -1;
      while (++i < n) streams[i].lineStart();
    },
    lineEnd: function() {
      var i = -1;
      while (++i < n) streams[i].lineEnd();
    },
    polygonStart: function() {
      var i = -1;
      while (++i < n) streams[i].polygonStart();
    },
    polygonEnd: function() {
      var i = -1;
      while (++i < n) streams[i].polygonEnd();
    }
  };
}
function albersUsa_default() {
  var cache, cacheStream, lower48 = albers_default(), lower48Point, alaska = conicEqualArea_default().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, hawaii = conicEqualArea_default().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, point6, pointStream = { point: function(x4, y4) {
    point6 = [x4, y4];
  } };
  function albersUsa(coordinates2) {
    var x4 = coordinates2[0], y4 = coordinates2[1];
    return point6 = null, (lower48Point.point(x4, y4), point6) || (alaskaPoint.point(x4, y4), point6) || (hawaiiPoint.point(x4, y4), point6);
  }
  albersUsa.invert = function(coordinates2) {
    var k2 = lower48.scale(), t = lower48.translate(), x4 = (coordinates2[0] - t[0]) / k2, y4 = (coordinates2[1] - t[1]) / k2;
    return (y4 >= 0.12 && y4 < 0.234 && x4 >= -0.425 && x4 < -0.214 ? alaska : y4 >= 0.166 && y4 < 0.234 && x4 >= -0.214 && x4 < -0.115 ? hawaii : lower48).invert(coordinates2);
  };
  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };
  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };
  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k2 = lower48.scale(), x4 = +_[0], y4 = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x4 - 0.455 * k2, y4 - 0.238 * k2], [x4 + 0.455 * k2, y4 + 0.238 * k2]]).stream(pointStream);
    alaskaPoint = alaska.translate([x4 - 0.307 * k2, y4 + 0.201 * k2]).clipExtent([[x4 - 0.425 * k2 + epsilon7, y4 + 0.12 * k2 + epsilon7], [x4 - 0.214 * k2 - epsilon7, y4 + 0.234 * k2 - epsilon7]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x4 - 0.205 * k2, y4 + 0.212 * k2]).clipExtent([[x4 - 0.214 * k2 + epsilon7, y4 + 0.166 * k2 + epsilon7], [x4 - 0.115 * k2 - epsilon7, y4 + 0.234 * k2 - epsilon7]]).stream(pointStream);
    return reset();
  };
  albersUsa.fitExtent = function(extent2, object2) {
    return fitExtent(albersUsa, extent2, object2);
  };
  albersUsa.fitSize = function(size, object2) {
    return fitSize(albersUsa, size, object2);
  };
  albersUsa.fitWidth = function(width, object2) {
    return fitWidth(albersUsa, width, object2);
  };
  albersUsa.fitHeight = function(height, object2) {
    return fitHeight(albersUsa, height, object2);
  };
  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }
  return albersUsa.scale(1070);
}
var init_albersUsa = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/albersUsa.js"() {
    init_math4();
    init_albers();
    init_conicEqualArea();
    init_fit();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthal.js
function azimuthalRaw(scale2) {
  return function(x4, y4) {
    var cx = cos2(x4), cy = cos2(y4), k2 = scale2(cx * cy);
    if (k2 === Infinity) return [2, 0];
    return [
      k2 * cy * sin2(x4),
      k2 * sin2(y4)
    ];
  };
}
function azimuthalInvert(angle2) {
  return function(x4, y4) {
    var z = sqrt(x4 * x4 + y4 * y4), c6 = angle2(z), sc = sin2(c6), cc2 = cos2(c6);
    return [
      atan2(x4 * sc, z * cc2),
      asin(z && y4 * sc / z)
    ];
  };
}
var init_azimuthal = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthal.js"() {
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthalEqualArea.js
function azimuthalEqualArea_default() {
  return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}
var azimuthalEqualAreaRaw;
var init_azimuthalEqualArea = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthalEqualArea.js"() {
    init_math4();
    init_azimuthal();
    init_projection();
    azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
      return sqrt(2 / (1 + cxcy));
    });
    azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
      return 2 * asin(z / 2);
    });
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthalEquidistant.js
function azimuthalEquidistant_default() {
  return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
var azimuthalEquidistantRaw;
var init_azimuthalEquidistant = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/azimuthalEquidistant.js"() {
    init_math4();
    init_azimuthal();
    init_projection();
    azimuthalEquidistantRaw = azimuthalRaw(function(c6) {
      return (c6 = acos(c6)) && c6 / sin2(c6);
    });
    azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
      return z;
    });
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/mercator.js
function mercatorRaw(lambda, phi2) {
  return [lambda, log(tan((halfPi3 + phi2) / 2))];
}
function mercator_default() {
  return mercatorProjection(mercatorRaw).scale(961 / tau5);
}
function mercatorProjection(project) {
  var m3 = projection(project), center2 = m3.center, scale2 = m3.scale, translate = m3.translate, clipExtent = m3.clipExtent, x06 = null, y06, x12, y12;
  m3.scale = function(_) {
    return arguments.length ? (scale2(_), reclip()) : scale2();
  };
  m3.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };
  m3.center = function(_) {
    return arguments.length ? (center2(_), reclip()) : center2();
  };
  m3.clipExtent = function(_) {
    return arguments.length ? (_ == null ? x06 = y06 = x12 = y12 = null : (x06 = +_[0][0], y06 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reclip()) : x06 == null ? null : [[x06, y06], [x12, y12]];
  };
  function reclip() {
    var k2 = pi4 * scale2(), t = m3(rotation_default(m3.rotate()).invert([0, 0]));
    return clipExtent(x06 == null ? [[t[0] - k2, t[1] - k2], [t[0] + k2, t[1] + k2]] : project === mercatorRaw ? [[Math.max(t[0] - k2, x06), y06], [Math.min(t[0] + k2, x12), y12]] : [[x06, Math.max(t[1] - k2, y06)], [x12, Math.min(t[1] + k2, y12)]]);
  }
  return reclip();
}
var init_mercator = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/mercator.js"() {
    init_math4();
    init_rotation();
    init_projection();
    mercatorRaw.invert = function(x4, y4) {
      return [x4, 2 * atan(exp(y4)) - halfPi3];
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicConformal.js
function tany(y4) {
  return tan((halfPi3 + y4) / 2);
}
function conicConformalRaw(y06, y12) {
  var cy0 = cos2(y06), n = y06 === y12 ? sin2(y06) : log(cy0 / cos2(y12)) / log(tany(y12) / tany(y06)), f2 = cy0 * pow2(tany(y06), n) / n;
  if (!n) return mercatorRaw;
  function project(x4, y4) {
    if (f2 > 0) {
      if (y4 < -halfPi3 + epsilon7) y4 = -halfPi3 + epsilon7;
    } else {
      if (y4 > halfPi3 - epsilon7) y4 = halfPi3 - epsilon7;
    }
    var r = f2 / pow2(tany(y4), n);
    return [r * sin2(n * x4), f2 - r * cos2(n * x4)];
  }
  project.invert = function(x4, y4) {
    var fy = f2 - y4, r = sign(n) * sqrt(x4 * x4 + fy * fy), l = atan2(x4, abs3(fy)) * sign(fy);
    if (fy * n < 0)
      l -= pi4 * sign(x4) * sign(fy);
    return [l / n, 2 * atan(pow2(f2 / r, 1 / n)) - halfPi3];
  };
  return project;
}
function conicConformal_default() {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}
var init_conicConformal = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicConformal.js"() {
    init_math4();
    init_conic();
    init_mercator();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/equirectangular.js
function equirectangularRaw(lambda, phi2) {
  return [lambda, phi2];
}
function equirectangular_default() {
  return projection(equirectangularRaw).scale(152.63);
}
var init_equirectangular = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/equirectangular.js"() {
    init_projection();
    equirectangularRaw.invert = equirectangularRaw;
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicEquidistant.js
function conicEquidistantRaw(y06, y12) {
  var cy0 = cos2(y06), n = y06 === y12 ? sin2(y06) : (cy0 - cos2(y12)) / (y12 - y06), g = cy0 / n + y06;
  if (abs3(n) < epsilon7) return equirectangularRaw;
  function project(x4, y4) {
    var gy = g - y4, nx = n * x4;
    return [gy * sin2(nx), g - gy * cos2(nx)];
  }
  project.invert = function(x4, y4) {
    var gy = g - y4, l = atan2(x4, abs3(gy)) * sign(gy);
    if (gy * n < 0)
      l -= pi4 * sign(x4) * sign(gy);
    return [l / n, g - sign(n) * sqrt(x4 * x4 + gy * gy)];
  };
  return project;
}
function conicEquidistant_default() {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}
var init_conicEquidistant = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/conicEquidistant.js"() {
    init_math4();
    init_conic();
    init_equirectangular();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/equalEarth.js
function equalEarthRaw(lambda, phi2) {
  var l = asin(M * sin2(phi2)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * cos2(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}
function equalEarth_default() {
  return projection(equalEarthRaw).scale(177.158);
}
var A1, A2, A3, A4, M, iterations;
var init_equalEarth = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/equalEarth.js"() {
    init_projection();
    init_math4();
    A1 = 1.340264;
    A2 = -0.081106;
    A3 = 893e-6;
    A4 = 3796e-6;
    M = sqrt(3) / 2;
    iterations = 12;
    equalEarthRaw.invert = function(x4, y4) {
      var l = y4, l2 = l * l, l6 = l2 * l2 * l2;
      for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y4;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if (abs3(delta) < epsilon22) break;
      }
      return [
        M * x4 * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos2(l),
        asin(sin2(l) / M)
      ];
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/gnomonic.js
function gnomonicRaw(x4, y4) {
  var cy = cos2(y4), k2 = cos2(x4) * cy;
  return [cy * sin2(x4) / k2, sin2(y4) / k2];
}
function gnomonic_default() {
  return projection(gnomonicRaw).scale(144.049).clipAngle(60);
}
var init_gnomonic = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/gnomonic.js"() {
    init_math4();
    init_azimuthal();
    init_projection();
    gnomonicRaw.invert = azimuthalInvert(atan);
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/identity.js
function identity_default4() {
  var k2 = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca3, sa, x06 = null, y06, x12, y12, kx2 = 1, ky2 = 1, transform2 = transformer({
    point: function(x4, y4) {
      var p = projection2([x4, y4]);
      this.stream.point(p[0], p[1]);
    }
  }), postclip = identity_default3, cache, cacheStream;
  function reset() {
    kx2 = k2 * sx;
    ky2 = k2 * sy;
    cache = cacheStream = null;
    return projection2;
  }
  function projection2(p) {
    var x4 = p[0] * kx2, y4 = p[1] * ky2;
    if (alpha) {
      var t = y4 * ca3 - x4 * sa;
      x4 = x4 * ca3 + y4 * sa;
      y4 = t;
    }
    return [x4 + tx, y4 + ty];
  }
  projection2.invert = function(p) {
    var x4 = p[0] - tx, y4 = p[1] - ty;
    if (alpha) {
      var t = y4 * ca3 + x4 * sa;
      x4 = x4 * ca3 - y4 * sa;
      y4 = t;
    }
    return [x4 / kx2, y4 / ky2];
  };
  projection2.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transform2(postclip(cacheStream = stream));
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x06 = y06 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x06 = y06 = x12 = y12 = null, identity_default3) : clipRectangle(x06 = +_[0][0], y06 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset()) : x06 == null ? null : [[x06, y06], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k2 = +_, reset()) : k2;
  };
  projection2.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians2, sa = sin2(alpha), ca3 = cos2(alpha), reset()) : alpha * degrees3;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height, object2) {
    return fitHeight(projection2, height, object2);
  };
  return projection2;
}
var init_identity5 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/identity.js"() {
    init_rectangle();
    init_identity4();
    init_transform2();
    init_fit();
    init_math4();
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/naturalEarth1.js
function naturalEarth1Raw(lambda, phi2) {
  var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
  return [
    lambda * (0.8707 - 0.131979 * phi22 + phi4 * (-0.013791 + phi4 * (3971e-6 * phi22 - 1529e-6 * phi4))),
    phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4)))
  ];
}
function naturalEarth1_default() {
  return projection(naturalEarth1Raw).scale(175.295);
}
var init_naturalEarth1 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/naturalEarth1.js"() {
    init_projection();
    init_math4();
    naturalEarth1Raw.invert = function(x4, y4) {
      var phi2 = y4, i = 25, delta;
      do {
        var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
        phi2 -= delta = (phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4))) - y4) / (1.007226 + phi22 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi22 - 5916e-6 * 11 * phi4)));
      } while (abs3(delta) > epsilon7 && --i > 0);
      return [
        x4 / (0.8707 + (phi22 = phi2 * phi2) * (-0.131979 + phi22 * (-0.013791 + phi22 * phi22 * phi22 * (3971e-6 - 1529e-6 * phi22)))),
        phi2
      ];
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/orthographic.js
function orthographicRaw(x4, y4) {
  return [cos2(y4) * sin2(x4), sin2(y4)];
}
function orthographic_default() {
  return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon7);
}
var init_orthographic = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/orthographic.js"() {
    init_math4();
    init_azimuthal();
    init_projection();
    orthographicRaw.invert = azimuthalInvert(asin);
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/stereographic.js
function stereographicRaw(x4, y4) {
  var cy = cos2(y4), k2 = 1 + cos2(x4) * cy;
  return [cy * sin2(x4) / k2, sin2(y4) / k2];
}
function stereographic_default() {
  return projection(stereographicRaw).scale(250).clipAngle(142);
}
var init_stereographic = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/stereographic.js"() {
    init_math4();
    init_azimuthal();
    init_projection();
    stereographicRaw.invert = azimuthalInvert(function(z) {
      return 2 * atan(z);
    });
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/transverseMercator.js
function transverseMercatorRaw(lambda, phi2) {
  return [log(tan((halfPi3 + phi2) / 2)), -lambda];
}
function transverseMercator_default() {
  var m3 = mercatorProjection(transverseMercatorRaw), center2 = m3.center, rotate = m3.rotate;
  m3.center = function(_) {
    return arguments.length ? center2([-_[1], _[0]]) : (_ = center2(), [_[1], -_[0]]);
  };
  m3.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };
  return rotate([0, 0, 90]).scale(159.155);
}
var init_transverseMercator = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/projection/transverseMercator.js"() {
    init_math4();
    init_mercator();
    transverseMercatorRaw.invert = function(x4, y4) {
      return [-y4, 2 * atan(exp(x4)) - halfPi3];
    };
  }
});

// ../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/index.js
var init_src22 = __esm({
  "../node_modules/.pnpm/d3-geo@3.1.1/node_modules/d3-geo/src/index.js"() {
    init_area2();
    init_bounds();
    init_centroid();
    init_circle2();
    init_antimeridian();
    init_circle3();
    init_extent3();
    init_rectangle();
    init_contains2();
    init_distance();
    init_graticule();
    init_interpolate2();
    init_length();
    init_path3();
    init_albers();
    init_albersUsa();
    init_azimuthalEqualArea();
    init_azimuthalEquidistant();
    init_conicConformal();
    init_conicEqualArea();
    init_conicEquidistant();
    init_equalEarth();
    init_equirectangular();
    init_gnomonic();
    init_identity5();
    init_projection();
    init_mercator();
    init_naturalEarth1();
    init_orthographic();
    init_stereographic();
    init_transverseMercator();
    init_rotation();
    init_stream();
    init_transform2();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/cluster.js
function defaultSeparation(a4, b) {
  return a4.parent === b.parent ? 1 : 2;
}
function meanX(children2) {
  return children2.reduce(meanXReduce, 0) / children2.length;
}
function meanXReduce(x4, c6) {
  return x4 + c6.x;
}
function maxY(children2) {
  return 1 + children2.reduce(maxYReduce, 0);
}
function maxYReduce(y4, c6) {
  return Math.max(y4, c6.y);
}
function leafLeft(node) {
  var children2;
  while (children2 = node.children) node = children2[0];
  return node;
}
function leafRight(node) {
  var children2;
  while (children2 = node.children) node = children2[children2.length - 1];
  return node;
}
function cluster_default() {
  var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
  function cluster(root3) {
    var previousNode, x4 = 0;
    root3.eachAfter(function(node) {
      var children2 = node.children;
      if (children2) {
        node.x = meanX(children2);
        node.y = maxY(children2);
      } else {
        node.x = previousNode ? x4 += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });
    var left2 = leafLeft(root3), right2 = leafRight(root3), x06 = left2.x - separation(left2, right2) / 2, x12 = right2.x + separation(right2, left2) / 2;
    return root3.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root3.x) * dx;
      node.y = (root3.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x06) / (x12 - x06) * dx;
      node.y = (1 - (root3.y ? node.y / root3.y : 1)) * dy;
    });
  }
  cluster.separation = function(x4) {
    return arguments.length ? (separation = x4, cluster) : separation;
  };
  cluster.size = function(x4) {
    return arguments.length ? (nodeSize = false, dx = +x4[0], dy = +x4[1], cluster) : nodeSize ? null : [dx, dy];
  };
  cluster.nodeSize = function(x4) {
    return arguments.length ? (nodeSize = true, dx = +x4[0], dy = +x4[1], cluster) : nodeSize ? [dx, dy] : null;
  };
  return cluster;
}
var init_cluster = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/cluster.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/count.js
function count2(node) {
  var sum4 = 0, children2 = node.children, i = children2 && children2.length;
  if (!i) sum4 = 1;
  else while (--i >= 0) sum4 += children2[i].value;
  node.value = sum4;
}
function count_default() {
  return this.eachAfter(count2);
}
var init_count2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/count.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/each.js
function each_default2(callback, that) {
  let index3 = -1;
  for (const node of this) {
    callback.call(that, node, ++index3, this);
  }
  return this;
}
var init_each2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/each.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachBefore.js
function eachBefore_default(callback, that) {
  var node = this, nodes = [node], children2, i, index3 = -1;
  while (node = nodes.pop()) {
    callback.call(that, node, ++index3, this);
    if (children2 = node.children) {
      for (i = children2.length - 1; i >= 0; --i) {
        nodes.push(children2[i]);
      }
    }
  }
  return this;
}
var init_eachBefore = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachBefore.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachAfter.js
function eachAfter_default(callback, that) {
  var node = this, nodes = [node], next = [], children2, i, n, index3 = -1;
  while (node = nodes.pop()) {
    next.push(node);
    if (children2 = node.children) {
      for (i = 0, n = children2.length; i < n; ++i) {
        nodes.push(children2[i]);
      }
    }
  }
  while (node = next.pop()) {
    callback.call(that, node, ++index3, this);
  }
  return this;
}
var init_eachAfter = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachAfter.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/find.js
function find_default2(callback, that) {
  let index3 = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index3, this)) {
      return node;
    }
  }
}
var init_find2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/find.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sum.js
function sum_default(value) {
  return this.eachAfter(function(node) {
    var sum4 = +value(node.data) || 0, children2 = node.children, i = children2 && children2.length;
    while (--i >= 0) sum4 += children2[i].value;
    node.value = sum4;
  });
}
var init_sum2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sum.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sort.js
function sort_default2(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}
var init_sort3 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sort.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/path.js
function path_default2(end) {
  var start2 = this, ancestor = leastCommonAncestor(start2, end), nodes = [start2];
  while (start2 !== ancestor) {
    start2 = start2.parent;
    nodes.push(start2);
  }
  var k2 = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k2, 0, end);
    end = end.parent;
  }
  return nodes;
}
function leastCommonAncestor(a4, b) {
  if (a4 === b) return a4;
  var aNodes = a4.ancestors(), bNodes = b.ancestors(), c6 = null;
  a4 = aNodes.pop();
  b = bNodes.pop();
  while (a4 === b) {
    c6 = a4;
    a4 = aNodes.pop();
    b = bNodes.pop();
  }
  return c6;
}
var init_path4 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/path.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/ancestors.js
function ancestors_default() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}
var init_ancestors = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/ancestors.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/descendants.js
function descendants_default() {
  return Array.from(this);
}
var init_descendants = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/descendants.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/leaves.js
function leaves_default() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}
var init_leaves = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/leaves.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/links.js
function links_default() {
  var root3 = this, links = [];
  root3.each(function(node) {
    if (node !== root3) {
      links.push({ source: node.parent, target: node });
    }
  });
  return links;
}
var init_links = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/links.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/iterator.js
function* iterator_default2() {
  var node = this, current, next = [node], children2, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      yield node;
      if (children2 = node.children) {
        for (i = 0, n = children2.length; i < n; ++i) {
          next.push(children2[i]);
        }
      }
    }
  } while (next.length);
}
var init_iterator2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/iterator.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/index.js
function hierarchy(data, children2) {
  if (data instanceof Map) {
    data = [void 0, data];
    if (children2 === void 0) children2 = mapChildren;
  } else if (children2 === void 0) {
    children2 = objectChildren;
  }
  var root3 = new Node(data), node, nodes = [root3], child, childs, i, n;
  while (node = nodes.pop()) {
    if ((childs = children2(node.data)) && (n = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }
  return root3.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
  return d.children;
}
function mapChildren(d) {
  return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
  if (node.data.value !== void 0) node.value = node.data.value;
  node.data = node.data.data;
}
function computeHeight(node) {
  var height = 0;
  do
    node.height = height;
  while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}
var init_hierarchy = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/index.js"() {
    init_count2();
    init_each2();
    init_eachBefore();
    init_eachAfter();
    init_find2();
    init_sum2();
    init_sort3();
    init_path4();
    init_ancestors();
    init_descendants();
    init_leaves();
    init_links();
    init_iterator2();
    Node.prototype = hierarchy.prototype = {
      constructor: Node,
      count: count_default,
      each: each_default2,
      eachAfter: eachAfter_default,
      eachBefore: eachBefore_default,
      find: find_default2,
      sum: sum_default,
      sort: sort_default2,
      path: path_default2,
      ancestors: ancestors_default,
      descendants: descendants_default,
      leaves: leaves_default,
      links: links_default,
      copy: node_copy,
      [Symbol.iterator]: iterator_default2
    };
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/accessors.js
function optional(f2) {
  return f2 == null ? null : required(f2);
}
function required(f2) {
  if (typeof f2 !== "function") throw new Error();
  return f2;
}
var init_accessors = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/accessors.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/constant.js
function constantZero() {
  return 0;
}
function constant_default9(x4) {
  return function() {
    return x4;
  };
}
var init_constant10 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/lcg.js
function lcg_default2() {
  let s2 = 1;
  return () => (s2 = (a2 * s2 + c2) % m2) / m2;
}
var a2, c2, m2;
var init_lcg2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/lcg.js"() {
    a2 = 1664525;
    c2 = 1013904223;
    m2 = 4294967296;
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/array.js
function array_default2(x4) {
  return typeof x4 === "object" && "length" in x4 ? x4 : Array.from(x4);
}
function shuffle(array4, random) {
  let m3 = array4.length, t, i;
  while (m3) {
    i = random() * m3-- | 0;
    t = array4[m3];
    array4[m3] = array4[i];
    array4[i] = t;
  }
  return array4;
}
var init_array6 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/array.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/enclose.js
function enclose_default(circles) {
  return packEncloseRandom(circles, lcg_default2());
}
function packEncloseRandom(circles, random) {
  var i = 0, n = (circles = shuffle(Array.from(circles), random)).length, B3 = [], p, e;
  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B3 = extendBasis(B3, p)), i = 0;
  }
  return e;
}
function extendBasis(B3, p) {
  var i, j;
  if (enclosesWeakAll(p, B3)) return [p];
  for (i = 0; i < B3.length; ++i) {
    if (enclosesNot(p, B3[i]) && enclosesWeakAll(encloseBasis2(B3[i], p), B3)) {
      return [B3[i], p];
    }
  }
  for (i = 0; i < B3.length - 1; ++i) {
    for (j = i + 1; j < B3.length; ++j) {
      if (enclosesNot(encloseBasis2(B3[i], B3[j]), p) && enclosesNot(encloseBasis2(B3[i], p), B3[j]) && enclosesNot(encloseBasis2(B3[j], p), B3[i]) && enclosesWeakAll(encloseBasis3(B3[i], B3[j], p), B3)) {
        return [B3[i], B3[j], p];
      }
    }
  }
  throw new Error();
}
function enclosesNot(a4, b) {
  var dr = a4.r - b.r, dx = b.x - a4.x, dy = b.y - a4.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a4, b) {
  var dr = a4.r - b.r + Math.max(a4.r, b.r, 1) * 1e-9, dx = b.x - a4.x, dy = b.y - a4.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a4, B3) {
  for (var i = 0; i < B3.length; ++i) {
    if (!enclosesWeak(a4, B3[i])) {
      return false;
    }
  }
  return true;
}
function encloseBasis(B3) {
  switch (B3.length) {
    case 1:
      return encloseBasis1(B3[0]);
    case 2:
      return encloseBasis2(B3[0], B3[1]);
    case 3:
      return encloseBasis3(B3[0], B3[1], B3[2]);
  }
}
function encloseBasis1(a4) {
  return {
    x: a4.x,
    y: a4.y,
    r: a4.r
  };
}
function encloseBasis2(a4, b) {
  var x12 = a4.x, y12 = a4.y, r1 = a4.r, x22 = b.x, y22 = b.y, r2 = b.r, x21 = x22 - x12, y21 = y22 - y12, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x12 + x22 + x21 / l * r21) / 2,
    y: (y12 + y22 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}
function encloseBasis3(a4, b, c6) {
  var x12 = a4.x, y12 = a4.y, r1 = a4.r, x22 = b.x, y22 = b.y, r2 = b.r, x32 = c6.x, y32 = c6.y, r3 = c6.r, a22 = x12 - x22, a32 = x12 - x32, b22 = y12 - y22, b32 = y12 - y32, c22 = r2 - r1, c32 = r3 - r1, d1 = x12 * x12 + y12 * y12 - r1 * r1, d2 = d1 - x22 * x22 - y22 * y22 + r2 * r2, d3 = d1 - x32 * x32 - y32 * y32 + r3 * r3, ab4 = a32 * b22 - a22 * b32, xa = (b22 * d3 - b32 * d2) / (ab4 * 2) - x12, xb = (b32 * c22 - b22 * c32) / ab4, ya = (a32 * d2 - a22 * d3) / (ab4 * 2) - y12, yb = (a22 * c32 - a32 * c22) / ab4, A5 = xb * xb + yb * yb - 1, B3 = 2 * (r1 + xa * xb + ya * yb), C3 = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A5) > 1e-6 ? (B3 + Math.sqrt(B3 * B3 - 4 * A5 * C3)) / (2 * A5) : C3 / B3);
  return {
    x: x12 + xa + xb * r,
    y: y12 + ya + yb * r,
    r
  };
}
var init_enclose = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/enclose.js"() {
    init_array6();
    init_lcg2();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/siblings.js
function place(b, a4, c6) {
  var dx = b.x - a4.x, x4, a22, dy = b.y - a4.y, y4, b22, d2 = dx * dx + dy * dy;
  if (d2) {
    a22 = a4.r + c6.r, a22 *= a22;
    b22 = b.r + c6.r, b22 *= b22;
    if (a22 > b22) {
      x4 = (d2 + b22 - a22) / (2 * d2);
      y4 = Math.sqrt(Math.max(0, b22 / d2 - x4 * x4));
      c6.x = b.x - x4 * dx - y4 * dy;
      c6.y = b.y - x4 * dy + y4 * dx;
    } else {
      x4 = (d2 + a22 - b22) / (2 * d2);
      y4 = Math.sqrt(Math.max(0, a22 / d2 - x4 * x4));
      c6.x = a4.x + x4 * dx - y4 * dy;
      c6.y = a4.y + x4 * dy + y4 * dx;
    }
  } else {
    c6.x = a4.x + c6.r;
    c6.y = a4.y;
  }
}
function intersects(a4, b) {
  var dr = a4.r + b.r - 1e-6, dx = b.x - a4.x, dy = b.y - a4.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
  var a4 = node._, b = node.next._, ab4 = a4.r + b.r, dx = (a4.x * b.r + b.x * a4.r) / ab4, dy = (a4.y * b.r + b.y * a4.r) / ab4;
  return dx * dx + dy * dy;
}
function Node2(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}
function packSiblingsRandom(circles, random) {
  if (!(n = (circles = array_default2(circles)).length)) return 0;
  var a4, b, c6, n, aa2, ca3, i, j, k2, sj, sk;
  a4 = circles[0], a4.x = 0, a4.y = 0;
  if (!(n > 1)) return a4.r;
  b = circles[1], a4.x = -b.r, b.x = a4.r, b.y = 0;
  if (!(n > 2)) return a4.r + b.r;
  place(b, a4, c6 = circles[2]);
  a4 = new Node2(a4), b = new Node2(b), c6 = new Node2(c6);
  a4.next = c6.previous = b;
  b.next = a4.previous = c6;
  c6.next = b.previous = a4;
  pack: for (i = 3; i < n; ++i) {
    place(a4._, b._, c6 = circles[i]), c6 = new Node2(c6);
    j = b.next, k2 = a4.previous, sj = b._.r, sk = a4._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c6._)) {
          b = j, a4.next = b, b.previous = a4, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k2._, c6._)) {
          a4 = k2, a4.next = b, b.previous = a4, --i;
          continue pack;
        }
        sk += k2._.r, k2 = k2.previous;
      }
    } while (j !== k2.next);
    c6.previous = a4, c6.next = b, a4.next = b.previous = b = c6;
    aa2 = score(a4);
    while ((c6 = c6.next) !== b) {
      if ((ca3 = score(c6)) < aa2) {
        a4 = c6, aa2 = ca3;
      }
    }
    b = a4.next;
  }
  a4 = [b._], c6 = b;
  while ((c6 = c6.next) !== b) a4.push(c6._);
  c6 = packEncloseRandom(a4, random);
  for (i = 0; i < n; ++i) a4 = circles[i], a4.x -= c6.x, a4.y -= c6.y;
  return c6.r;
}
function siblings_default(circles) {
  packSiblingsRandom(circles, lcg_default2());
  return circles;
}
var init_siblings = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/siblings.js"() {
    init_array6();
    init_lcg2();
    init_enclose();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/index.js
function defaultRadius2(d) {
  return Math.sqrt(d.value);
}
function pack_default() {
  var radius = null, dx = 1, dy = 1, padding = constantZero;
  function pack(root3) {
    const random = lcg_default2();
    root3.x = dx / 2, root3.y = dy / 2;
    if (radius) {
      root3.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
    } else {
      root3.eachBefore(radiusLeaf(defaultRadius2)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root3.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root3.r)));
    }
    return root3;
  }
  pack.radius = function(x4) {
    return arguments.length ? (radius = optional(x4), pack) : radius;
  };
  pack.size = function(x4) {
    return arguments.length ? (dx = +x4[0], dy = +x4[1], pack) : [dx, dy];
  };
  pack.padding = function(x4) {
    return arguments.length ? (padding = typeof x4 === "function" ? x4 : constant_default9(+x4), pack) : padding;
  };
  return pack;
}
function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}
function packChildrenRandom(padding, k2, random) {
  return function(node) {
    if (children2 = node.children) {
      var children2, i, n = children2.length, r = padding(node) * k2 || 0, e;
      if (r) for (i = 0; i < n; ++i) children2[i].r += r;
      e = packSiblingsRandom(children2, random);
      if (r) for (i = 0; i < n; ++i) children2[i].r -= r;
      node.r = e + r;
    }
  };
}
function translateChild(k2) {
  return function(node) {
    var parent = node.parent;
    node.r *= k2;
    if (parent) {
      node.x = parent.x + k2 * node.x;
      node.y = parent.y + k2 * node.y;
    }
  };
}
var init_pack = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/pack/index.js"() {
    init_accessors();
    init_constant10();
    init_lcg2();
    init_siblings();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/round.js
function round_default2(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}
var init_round2 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/round.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/dice.js
function dice_default(parent, x06, y06, x12, y12) {
  var nodes = parent.children, node, i = -1, n = nodes.length, k2 = parent.value && (x12 - x06) / parent.value;
  while (++i < n) {
    node = nodes[i], node.y0 = y06, node.y1 = y12;
    node.x0 = x06, node.x1 = x06 += node.value * k2;
  }
}
var init_dice = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/dice.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/partition.js
function partition_default() {
  var dx = 1, dy = 1, padding = 0, round = false;
  function partition(root3) {
    var n = root3.height + 1;
    root3.x0 = root3.y0 = padding;
    root3.x1 = dx;
    root3.y1 = dy / n;
    root3.eachBefore(positionNode(dy, n));
    if (round) root3.eachBefore(round_default2);
    return root3;
  }
  function positionNode(dy2, n) {
    return function(node) {
      if (node.children) {
        dice_default(node, node.x0, dy2 * (node.depth + 1) / n, node.x1, dy2 * (node.depth + 2) / n);
      }
      var x06 = node.x0, y06 = node.y0, x12 = node.x1 - padding, y12 = node.y1 - padding;
      if (x12 < x06) x06 = x12 = (x06 + x12) / 2;
      if (y12 < y06) y06 = y12 = (y06 + y12) / 2;
      node.x0 = x06;
      node.y0 = y06;
      node.x1 = x12;
      node.y1 = y12;
    };
  }
  partition.round = function(x4) {
    return arguments.length ? (round = !!x4, partition) : round;
  };
  partition.size = function(x4) {
    return arguments.length ? (dx = +x4[0], dy = +x4[1], partition) : [dx, dy];
  };
  partition.padding = function(x4) {
    return arguments.length ? (padding = +x4, partition) : padding;
  };
  return partition;
}
var init_partition = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/partition.js"() {
    init_round2();
    init_dice();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/stratify.js
function defaultId(d) {
  return d.id;
}
function defaultParentId(d) {
  return d.parentId;
}
function stratify_default() {
  var id2 = defaultId, parentId = defaultParentId, path2;
  function stratify(data) {
    var nodes = Array.from(data), currentId = id2, currentParentId = parentId, n, d, i, root3, parent, node, nodeId, nodeKey, nodeByKey = /* @__PURE__ */ new Map();
    if (path2 != null) {
      const I = nodes.map((d2, i2) => normalize(path2(d2, i2, data)));
      const P = I.map(parentof);
      const S = new Set(I).add("");
      for (const i2 of P) {
        if (!S.has(i2)) {
          S.add(i2);
          I.push(i2);
          P.push(parentof(i2));
          nodes.push(imputed);
        }
      }
      currentId = (_, i2) => I[i2];
      currentParentId = (_, i2) => P[i2];
    }
    for (i = 0, n = nodes.length; i < n; ++i) {
      d = nodes[i], node = nodes[i] = new Node(d);
      if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }
      if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }
    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      } else {
        if (root3) throw new Error("multiple roots");
        root3 = node;
      }
    }
    if (!root3) throw new Error("no root");
    if (path2 != null) {
      while (root3.data === imputed && root3.children.length === 1) {
        root3 = root3.children[0], --n;
      }
      for (let i2 = nodes.length - 1; i2 >= 0; --i2) {
        node = nodes[i2];
        if (node.data !== imputed) break;
        node.data = null;
      }
    }
    root3.parent = preroot;
    root3.eachBefore(function(node2) {
      node2.depth = node2.parent.depth + 1;
      --n;
    }).eachBefore(computeHeight);
    root3.parent = null;
    if (n > 0) throw new Error("cycle");
    return root3;
  }
  stratify.id = function(x4) {
    return arguments.length ? (id2 = optional(x4), stratify) : id2;
  };
  stratify.parentId = function(x4) {
    return arguments.length ? (parentId = optional(x4), stratify) : parentId;
  };
  stratify.path = function(x4) {
    return arguments.length ? (path2 = optional(x4), stratify) : path2;
  };
  return stratify;
}
function normalize(path2) {
  path2 = `${path2}`;
  let i = path2.length;
  if (slash(path2, i - 1) && !slash(path2, i - 2)) path2 = path2.slice(0, -1);
  return path2[0] === "/" ? path2 : `/${path2}`;
}
function parentof(path2) {
  let i = path2.length;
  if (i < 2) return "";
  while (--i > 1) if (slash(path2, i)) break;
  return path2.slice(0, i);
}
function slash(path2, i) {
  if (path2[i] === "/") {
    let k2 = 0;
    while (i > 0 && path2[--i] === "\\") ++k2;
    if ((k2 & 1) === 0) return true;
  }
  return false;
}
var preroot, ambiguous, imputed;
var init_stratify = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/stratify.js"() {
    init_accessors();
    init_hierarchy();
    preroot = { depth: -1 };
    ambiguous = {};
    imputed = {};
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/tree.js
function defaultSeparation2(a4, b) {
  return a4.parent === b.parent ? 1 : 2;
}
function nextLeft(v2) {
  var children2 = v2.children;
  return children2 ? children2[0] : v2.t;
}
function nextRight(v2) {
  var children2 = v2.children;
  return children2 ? children2[children2.length - 1] : v2.t;
}
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}
function executeShifts(v2) {
  var shift = 0, change = 0, children2 = v2.children, i = children2.length, w;
  while (--i >= 0) {
    w = children2[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}
function nextAncestor(vim, v2, ancestor) {
  return vim.a.parent === v2.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null;
  this.a = this;
  this.z = 0;
  this.m = 0;
  this.c = 0;
  this.s = 0;
  this.t = null;
  this.i = i;
}
function treeRoot(root3) {
  var tree = new TreeNode(root3, 0), node, nodes = [tree], child, children2, i, n;
  while (node = nodes.pop()) {
    if (children2 = node._.children) {
      node.children = new Array(n = children2.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children2[i], i));
        child.parent = node;
      }
    }
  }
  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}
function tree_default() {
  var separation = defaultSeparation2, dx = 1, dy = 1, nodeSize = null;
  function tree(root3) {
    var t = treeRoot(root3);
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);
    if (nodeSize) root3.eachBefore(sizeNode);
    else {
      var left2 = root3, right2 = root3, bottom2 = root3;
      root3.eachBefore(function(node) {
        if (node.x < left2.x) left2 = node;
        if (node.x > right2.x) right2 = node;
        if (node.depth > bottom2.depth) bottom2 = node;
      });
      var s2 = left2 === right2 ? 1 : separation(left2, right2) / 2, tx = s2 - left2.x, kx2 = dx / (right2.x + s2 + tx), ky2 = dy / (bottom2.depth || 1);
      root3.eachBefore(function(node) {
        node.x = (node.x + tx) * kx2;
        node.y = node.depth * ky2;
      });
    }
    return root3;
  }
  function firstWalk(v2) {
    var children2 = v2.children, siblings = v2.parent.children, w = v2.i ? siblings[v2.i - 1] : null;
    if (children2) {
      executeShifts(v2);
      var midpoint = (children2[0].z + children2[children2.length - 1].z) / 2;
      if (w) {
        v2.z = w.z + separation(v2._, w._);
        v2.m = v2.z - midpoint;
      } else {
        v2.z = midpoint;
      }
    } else if (w) {
      v2.z = w.z + separation(v2._, w._);
    }
    v2.parent.A = apportion(v2, w, v2.parent.A || siblings[0]);
  }
  function secondWalk(v2) {
    v2._.x = v2.z + v2.parent.m;
    v2.m += v2.parent.m;
  }
  function apportion(v2, w, ancestor) {
    if (w) {
      var vip = v2, vop = v2, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v2;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v2, ancestor), v2, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v2;
      }
    }
    return ancestor;
  }
  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }
  tree.separation = function(x4) {
    return arguments.length ? (separation = x4, tree) : separation;
  };
  tree.size = function(x4) {
    return arguments.length ? (nodeSize = false, dx = +x4[0], dy = +x4[1], tree) : nodeSize ? null : [dx, dy];
  };
  tree.nodeSize = function(x4) {
    return arguments.length ? (nodeSize = true, dx = +x4[0], dy = +x4[1], tree) : nodeSize ? [dx, dy] : null;
  };
  return tree;
}
var init_tree = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/tree.js"() {
    init_hierarchy();
    TreeNode.prototype = Object.create(Node.prototype);
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/slice.js
function slice_default(parent, x06, y06, x12, y12) {
  var nodes = parent.children, node, i = -1, n = nodes.length, k2 = parent.value && (y12 - y06) / parent.value;
  while (++i < n) {
    node = nodes[i], node.x0 = x06, node.x1 = x12;
    node.y0 = y06, node.y1 = y06 += node.value * k2;
  }
}
var init_slice = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/slice.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/squarify.js
function squarifyRatio(ratio, parent, x06, y06, x12, y12) {
  var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
  while (i0 < n) {
    dx = x12 - x06, dy = y12 - y06;
    do
      sumValue = nodes[i1++].value;
    while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice) dice_default(row, x06, y06, x12, value ? y06 += dy * sumValue / value : y12);
    else slice_default(row, x06, y06, value ? x06 += dx * sumValue / value : x12, y12);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
var phi, squarify_default;
var init_squarify = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/squarify.js"() {
    init_dice();
    init_slice();
    phi = (1 + Math.sqrt(5)) / 2;
    squarify_default = (function custom10(ratio) {
      function squarify(parent, x06, y06, x12, y12) {
        squarifyRatio(ratio, parent, x06, y06, x12, y12);
      }
      squarify.ratio = function(x4) {
        return custom10((x4 = +x4) > 1 ? x4 : 1);
      };
      return squarify;
    })(phi);
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/index.js
function treemap_default() {
  var tile = squarify_default, round = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
  function treemap(root3) {
    root3.x0 = root3.y0 = 0;
    root3.x1 = dx;
    root3.y1 = dy;
    root3.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root3.eachBefore(round_default2);
    return root3;
  }
  function positionNode(node) {
    var p = paddingStack[node.depth], x06 = node.x0 + p, y06 = node.y0 + p, x12 = node.x1 - p, y12 = node.y1 - p;
    if (x12 < x06) x06 = x12 = (x06 + x12) / 2;
    if (y12 < y06) y06 = y12 = (y06 + y12) / 2;
    node.x0 = x06;
    node.y0 = y06;
    node.x1 = x12;
    node.y1 = y12;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x06 += paddingLeft(node) - p;
      y06 += paddingTop(node) - p;
      x12 -= paddingRight(node) - p;
      y12 -= paddingBottom(node) - p;
      if (x12 < x06) x06 = x12 = (x06 + x12) / 2;
      if (y12 < y06) y06 = y12 = (y06 + y12) / 2;
      tile(node, x06, y06, x12, y12);
    }
  }
  treemap.round = function(x4) {
    return arguments.length ? (round = !!x4, treemap) : round;
  };
  treemap.size = function(x4) {
    return arguments.length ? (dx = +x4[0], dy = +x4[1], treemap) : [dx, dy];
  };
  treemap.tile = function(x4) {
    return arguments.length ? (tile = required(x4), treemap) : tile;
  };
  treemap.padding = function(x4) {
    return arguments.length ? treemap.paddingInner(x4).paddingOuter(x4) : treemap.paddingInner();
  };
  treemap.paddingInner = function(x4) {
    return arguments.length ? (paddingInner = typeof x4 === "function" ? x4 : constant_default9(+x4), treemap) : paddingInner;
  };
  treemap.paddingOuter = function(x4) {
    return arguments.length ? treemap.paddingTop(x4).paddingRight(x4).paddingBottom(x4).paddingLeft(x4) : treemap.paddingTop();
  };
  treemap.paddingTop = function(x4) {
    return arguments.length ? (paddingTop = typeof x4 === "function" ? x4 : constant_default9(+x4), treemap) : paddingTop;
  };
  treemap.paddingRight = function(x4) {
    return arguments.length ? (paddingRight = typeof x4 === "function" ? x4 : constant_default9(+x4), treemap) : paddingRight;
  };
  treemap.paddingBottom = function(x4) {
    return arguments.length ? (paddingBottom = typeof x4 === "function" ? x4 : constant_default9(+x4), treemap) : paddingBottom;
  };
  treemap.paddingLeft = function(x4) {
    return arguments.length ? (paddingLeft = typeof x4 === "function" ? x4 : constant_default9(+x4), treemap) : paddingLeft;
  };
  return treemap;
}
var init_treemap = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/index.js"() {
    init_round2();
    init_squarify();
    init_accessors();
    init_constant10();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/binary.js
function binary_default(parent, x06, y06, x12, y12) {
  var nodes = parent.children, i, n = nodes.length, sum4, sums = new Array(n + 1);
  for (sums[0] = sum4 = i = 0; i < n; ++i) {
    sums[i + 1] = sum4 += nodes[i].value;
  }
  partition(0, n, parent.value, x06, y06, x12, y12);
  function partition(i2, j, value, x07, y07, x13, y13) {
    if (i2 >= j - 1) {
      var node = nodes[i2];
      node.x0 = x07, node.y0 = y07;
      node.x1 = x13, node.y1 = y13;
      return;
    }
    var valueOffset = sums[i2], valueTarget = value / 2 + valueOffset, k2 = i2 + 1, hi = j - 1;
    while (k2 < hi) {
      var mid = k2 + hi >>> 1;
      if (sums[mid] < valueTarget) k2 = mid + 1;
      else hi = mid;
    }
    if (valueTarget - sums[k2 - 1] < sums[k2] - valueTarget && i2 + 1 < k2) --k2;
    var valueLeft = sums[k2] - valueOffset, valueRight = value - valueLeft;
    if (x13 - x07 > y13 - y07) {
      var xk = value ? (x07 * valueRight + x13 * valueLeft) / value : x13;
      partition(i2, k2, valueLeft, x07, y07, xk, y13);
      partition(k2, j, valueRight, xk, y07, x13, y13);
    } else {
      var yk = value ? (y07 * valueRight + y13 * valueLeft) / value : y13;
      partition(i2, k2, valueLeft, x07, y07, x13, yk);
      partition(k2, j, valueRight, x07, yk, x13, y13);
    }
  }
}
var init_binary = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/binary.js"() {
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/sliceDice.js
function sliceDice_default(parent, x06, y06, x12, y12) {
  (parent.depth & 1 ? slice_default : dice_default)(parent, x06, y06, x12, y12);
}
var init_sliceDice = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/sliceDice.js"() {
    init_dice();
    init_slice();
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/resquarify.js
var resquarify_default;
var init_resquarify = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/resquarify.js"() {
    init_dice();
    init_slice();
    init_squarify();
    resquarify_default = (function custom11(ratio) {
      function resquarify(parent, x06, y06, x12, y12) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
          var rows, row, nodes, i, j = -1, n, m3 = rows.length, value = parent.value;
          while (++j < m3) {
            row = rows[j], nodes = row.children;
            for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
            if (row.dice) dice_default(row, x06, y06, x12, value ? y06 += (y12 - y06) * row.value / value : y12);
            else slice_default(row, x06, y06, value ? x06 += (x12 - x06) * row.value / value : x12, y12);
            value -= row.value;
          }
        } else {
          parent._squarify = rows = squarifyRatio(ratio, parent, x06, y06, x12, y12);
          rows.ratio = ratio;
        }
      }
      resquarify.ratio = function(x4) {
        return custom11((x4 = +x4) > 1 ? x4 : 1);
      };
      return resquarify;
    })(phi);
  }
});

// ../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/index.js
var init_src23 = __esm({
  "../node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/index.js"() {
    init_cluster();
    init_hierarchy();
    init_pack();
    init_siblings();
    init_enclose();
    init_partition();
    init_stratify();
    init_tree();
    init_treemap();
    init_binary();
    init_dice();
    init_slice();
    init_sliceDice();
    init_squarify();
    init_resquarify();
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/area.js
function area_default4(polygon) {
  var i = -1, n = polygon.length, a4, b = polygon[n - 1], area = 0;
  while (++i < n) {
    a4 = b;
    b = polygon[i];
    area += a4[1] * b[0] - a4[0] * b[1];
  }
  return area / 2;
}
var init_area4 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/area.js"() {
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/centroid.js
function centroid_default3(polygon) {
  var i = -1, n = polygon.length, x4 = 0, y4 = 0, a4, b = polygon[n - 1], c6, k2 = 0;
  while (++i < n) {
    a4 = b;
    b = polygon[i];
    k2 += c6 = a4[0] * b[1] - b[0] * a4[1];
    x4 += (a4[0] + b[0]) * c6;
    y4 += (a4[1] + b[1]) * c6;
  }
  return k2 *= 3, [x4 / k2, y4 / k2];
}
var init_centroid3 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/centroid.js"() {
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/cross.js
function cross_default(a4, b, c6) {
  return (b[0] - a4[0]) * (c6[1] - a4[1]) - (b[1] - a4[1]) * (c6[0] - a4[0]);
}
var init_cross2 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/cross.js"() {
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/hull.js
function lexicographicOrder(a4, b) {
  return a4[0] - b[0] || a4[1] - b[1];
}
function computeUpperHullIndexes(points) {
  const n = points.length, indexes2 = [0, 1];
  let size = 2, i;
  for (i = 2; i < n; ++i) {
    while (size > 1 && cross_default(points[indexes2[size - 2]], points[indexes2[size - 1]], points[i]) <= 0) --size;
    indexes2[size++] = i;
  }
  return indexes2.slice(0, size);
}
function hull_default(points) {
  if ((n = points.length) < 3) return null;
  var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
  var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
  var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
  return hull;
}
var init_hull = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/hull.js"() {
    init_cross2();
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/contains.js
function contains_default3(polygon, point6) {
  var n = polygon.length, p = polygon[n - 1], x4 = point6[0], y4 = point6[1], x06 = p[0], y06 = p[1], x12, y12, inside = false;
  for (var i = 0; i < n; ++i) {
    p = polygon[i], x12 = p[0], y12 = p[1];
    if (y12 > y4 !== y06 > y4 && x4 < (x06 - x12) * (y4 - y12) / (y06 - y12) + x12) inside = !inside;
    x06 = x12, y06 = y12;
  }
  return inside;
}
var init_contains3 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/contains.js"() {
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/length.js
function length_default2(polygon) {
  var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.hypot(xa, ya);
  }
  return perimeter;
}
var init_length2 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/length.js"() {
  }
});

// ../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/index.js
var init_src24 = __esm({
  "../node_modules/.pnpm/d3-polygon@3.0.1/node_modules/d3-polygon/src/index.js"() {
    init_area4();
    init_centroid3();
    init_hull();
    init_contains3();
    init_length2();
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/defaultSource.js
var defaultSource_default;
var init_defaultSource = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/defaultSource.js"() {
    defaultSource_default = Math.random;
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/uniform.js
var uniform_default;
var init_uniform = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/uniform.js"() {
    init_defaultSource();
    uniform_default = (function sourceRandomUniform(source) {
      function randomUniform(min4, max5) {
        min4 = min4 == null ? 0 : +min4;
        max5 = max5 == null ? 1 : +max5;
        if (arguments.length === 1) max5 = min4, min4 = 0;
        else max5 -= min4;
        return function() {
          return source() * max5 + min4;
        };
      }
      randomUniform.source = sourceRandomUniform;
      return randomUniform;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/int.js
var int_default;
var init_int = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/int.js"() {
    init_defaultSource();
    int_default = (function sourceRandomInt(source) {
      function randomInt(min4, max5) {
        if (arguments.length < 2) max5 = min4, min4 = 0;
        min4 = Math.floor(min4);
        max5 = Math.floor(max5) - min4;
        return function() {
          return Math.floor(source() * max5 + min4);
        };
      }
      randomInt.source = sourceRandomInt;
      return randomInt;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/normal.js
var normal_default;
var init_normal = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/normal.js"() {
    init_defaultSource();
    normal_default = (function sourceRandomNormal(source) {
      function randomNormal(mu, sigma) {
        var x4, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
          var y4;
          if (x4 != null) y4 = x4, x4 = null;
          else do {
            x4 = source() * 2 - 1;
            y4 = source() * 2 - 1;
            r = x4 * x4 + y4 * y4;
          } while (!r || r > 1);
          return mu + sigma * y4 * Math.sqrt(-2 * Math.log(r) / r);
        };
      }
      randomNormal.source = sourceRandomNormal;
      return randomNormal;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/logNormal.js
var logNormal_default;
var init_logNormal = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/logNormal.js"() {
    init_defaultSource();
    init_normal();
    logNormal_default = (function sourceRandomLogNormal(source) {
      var N = normal_default.source(source);
      function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
          return Math.exp(randomNormal());
        };
      }
      randomLogNormal.source = sourceRandomLogNormal;
      return randomLogNormal;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/irwinHall.js
var irwinHall_default;
var init_irwinHall = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/irwinHall.js"() {
    init_defaultSource();
    irwinHall_default = (function sourceRandomIrwinHall(source) {
      function randomIrwinHall(n) {
        if ((n = +n) <= 0) return () => 0;
        return function() {
          for (var sum4 = 0, i = n; i > 1; --i) sum4 += source();
          return sum4 + i * source();
        };
      }
      randomIrwinHall.source = sourceRandomIrwinHall;
      return randomIrwinHall;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/bates.js
var bates_default;
var init_bates = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/bates.js"() {
    init_defaultSource();
    init_irwinHall();
    bates_default = (function sourceRandomBates(source) {
      var I = irwinHall_default.source(source);
      function randomBates(n) {
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
          return randomIrwinHall() / n;
        };
      }
      randomBates.source = sourceRandomBates;
      return randomBates;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/exponential.js
var exponential_default;
var init_exponential = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/exponential.js"() {
    init_defaultSource();
    exponential_default = (function sourceRandomExponential(source) {
      function randomExponential(lambda) {
        return function() {
          return -Math.log1p(-source()) / lambda;
        };
      }
      randomExponential.source = sourceRandomExponential;
      return randomExponential;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/pareto.js
var pareto_default;
var init_pareto = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/pareto.js"() {
    init_defaultSource();
    pareto_default = (function sourceRandomPareto(source) {
      function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
          return Math.pow(1 - source(), alpha);
        };
      }
      randomPareto.source = sourceRandomPareto;
      return randomPareto;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/bernoulli.js
var bernoulli_default;
var init_bernoulli = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/bernoulli.js"() {
    init_defaultSource();
    bernoulli_default = (function sourceRandomBernoulli(source) {
      function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
          return Math.floor(source() + p);
        };
      }
      randomBernoulli.source = sourceRandomBernoulli;
      return randomBernoulli;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/geometric.js
var geometric_default;
var init_geometric = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/geometric.js"() {
    init_defaultSource();
    geometric_default = (function sourceRandomGeometric(source) {
      function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return () => Infinity;
        if (p === 1) return () => 1;
        p = Math.log1p(-p);
        return function() {
          return 1 + Math.floor(Math.log1p(-source()) / p);
        };
      }
      randomGeometric.source = sourceRandomGeometric;
      return randomGeometric;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/gamma.js
var gamma_default;
var init_gamma = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/gamma.js"() {
    init_defaultSource();
    init_normal();
    gamma_default = (function sourceRandomGamma(source) {
      var randomNormal = normal_default.source(source)();
      function randomGamma(k2, theta) {
        if ((k2 = +k2) < 0) throw new RangeError("invalid k");
        if (k2 === 0) return () => 0;
        theta = theta == null ? 1 : +theta;
        if (k2 === 1) return () => -Math.log1p(-source()) * theta;
        var d = (k2 < 1 ? k2 + 1 : k2) - 1 / 3, c6 = 1 / (3 * Math.sqrt(d)), multiplier = k2 < 1 ? () => Math.pow(source(), 1 / k2) : () => 1;
        return function() {
          do {
            do {
              var x4 = randomNormal(), v2 = 1 + c6 * x4;
            } while (v2 <= 0);
            v2 *= v2 * v2;
            var u4 = 1 - source();
          } while (u4 >= 1 - 0.0331 * x4 * x4 * x4 * x4 && Math.log(u4) >= 0.5 * x4 * x4 + d * (1 - v2 + Math.log(v2)));
          return d * v2 * multiplier() * theta;
        };
      }
      randomGamma.source = sourceRandomGamma;
      return randomGamma;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/beta.js
var beta_default;
var init_beta = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/beta.js"() {
    init_defaultSource();
    init_gamma();
    beta_default = (function sourceRandomBeta(source) {
      var G = gamma_default.source(source);
      function randomBeta(alpha, beta) {
        var X3 = G(alpha), Y3 = G(beta);
        return function() {
          var x4 = X3();
          return x4 === 0 ? 0 : x4 / (x4 + Y3());
        };
      }
      randomBeta.source = sourceRandomBeta;
      return randomBeta;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/binomial.js
var binomial_default;
var init_binomial = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/binomial.js"() {
    init_defaultSource();
    init_beta();
    init_geometric();
    binomial_default = (function sourceRandomBinomial(source) {
      var G = geometric_default.source(source), B3 = beta_default.source(source);
      function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return () => n;
        if (p <= 0) return () => 0;
        return function() {
          var acc = 0, nn = n, pp = p;
          while (nn * pp > 16 && nn * (1 - pp) > 16) {
            var i = Math.floor((nn + 1) * pp), y4 = B3(i, nn - i + 1)();
            if (y4 <= pp) {
              acc += i;
              nn -= i;
              pp = (pp - y4) / (1 - y4);
            } else {
              nn = i - 1;
              pp /= y4;
            }
          }
          var sign3 = pp < 0.5, pFinal = sign3 ? pp : 1 - pp, g = G(pFinal);
          for (var s2 = g(), k2 = 0; s2 <= nn; ++k2) s2 += g();
          return acc + (sign3 ? k2 : nn - k2);
        };
      }
      randomBinomial.source = sourceRandomBinomial;
      return randomBinomial;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/weibull.js
var weibull_default;
var init_weibull = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/weibull.js"() {
    init_defaultSource();
    weibull_default = (function sourceRandomWeibull(source) {
      function randomWeibull(k2, a4, b) {
        var outerFunc;
        if ((k2 = +k2) === 0) {
          outerFunc = (x4) => -Math.log(x4);
        } else {
          k2 = 1 / k2;
          outerFunc = (x4) => Math.pow(x4, k2);
        }
        a4 = a4 == null ? 0 : +a4;
        b = b == null ? 1 : +b;
        return function() {
          return a4 + b * outerFunc(-Math.log1p(-source()));
        };
      }
      randomWeibull.source = sourceRandomWeibull;
      return randomWeibull;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/cauchy.js
var cauchy_default;
var init_cauchy = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/cauchy.js"() {
    init_defaultSource();
    cauchy_default = (function sourceRandomCauchy(source) {
      function randomCauchy(a4, b) {
        a4 = a4 == null ? 0 : +a4;
        b = b == null ? 1 : +b;
        return function() {
          return a4 + b * Math.tan(Math.PI * source());
        };
      }
      randomCauchy.source = sourceRandomCauchy;
      return randomCauchy;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/logistic.js
var logistic_default;
var init_logistic = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/logistic.js"() {
    init_defaultSource();
    logistic_default = (function sourceRandomLogistic(source) {
      function randomLogistic(a4, b) {
        a4 = a4 == null ? 0 : +a4;
        b = b == null ? 1 : +b;
        return function() {
          var u4 = source();
          return a4 + b * Math.log(u4 / (1 - u4));
        };
      }
      randomLogistic.source = sourceRandomLogistic;
      return randomLogistic;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/poisson.js
var poisson_default;
var init_poisson = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/poisson.js"() {
    init_defaultSource();
    init_binomial();
    init_gamma();
    poisson_default = (function sourceRandomPoisson(source) {
      var G = gamma_default.source(source), B3 = binomial_default.source(source);
      function randomPoisson(lambda) {
        return function() {
          var acc = 0, l = lambda;
          while (l > 16) {
            var n = Math.floor(0.875 * l), t = G(n)();
            if (t > l) return acc + B3(n - 1, l / t)();
            acc += n;
            l -= t;
          }
          for (var s2 = -Math.log1p(-source()), k2 = 0; s2 <= l; ++k2) s2 -= Math.log1p(-source());
          return acc + k2;
        };
      }
      randomPoisson.source = sourceRandomPoisson;
      return randomPoisson;
    })(defaultSource_default);
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/lcg.js
function lcg(seed = Math.random()) {
  let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
  return () => (state = mul * state + inc | 0, eps * (state >>> 0));
}
var mul, inc, eps;
var init_lcg3 = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/lcg.js"() {
    mul = 1664525;
    inc = 1013904223;
    eps = 1 / 4294967296;
  }
});

// ../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/index.js
var init_src25 = __esm({
  "../node_modules/.pnpm/d3-random@3.0.1/node_modules/d3-random/src/index.js"() {
    init_uniform();
    init_int();
    init_normal();
    init_logNormal();
    init_bates();
    init_irwinHall();
    init_exponential();
    init_pareto();
    init_bernoulli();
    init_geometric();
    init_binomial();
    init_gamma();
    init_beta();
    init_weibull();
    init_cauchy();
    init_logistic();
    init_poisson();
    init_lcg3();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js
function initRange(domain, range4) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range4).domain(domain);
      break;
  }
  return this;
}
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}
var init_init = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js
function ordinal() {
  var index3 = new InternMap(), domain = [], range4 = [], unknown = implicit;
  function scale2(d) {
    let i = index3.get(d);
    if (i === void 0) {
      if (unknown !== implicit) return unknown;
      index3.set(d, i = domain.push(d) - 1);
    }
    return range4[i % range4.length];
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index3 = new InternMap();
    for (const value of _) {
      if (index3.has(value)) continue;
      index3.set(value, domain.push(value) - 1);
    }
    return scale2;
  };
  scale2.range = function(_) {
    return arguments.length ? (range4 = Array.from(_), scale2) : range4.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return ordinal(domain, range4).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return scale2;
}
var implicit;
var init_ordinal = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js"() {
    init_src2();
    init_init();
    implicit = /* @__PURE__ */ Symbol("implicit");
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js
function band() {
  var scale2 = ordinal().unknown(void 0), domain = scale2.domain, ordinalRange = scale2.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale2.unknown;
  function rescale() {
    var n = domain().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop = reverse2 ? r0 : r1;
    step = (stop - start2) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start2 += (stop - start2 - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values = range(n).map(function(i) {
      return start2 + step * i;
    });
    return ordinalRange(reverse2 ? values.reverse() : values);
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale2.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };
  scale2.bandwidth = function() {
    return bandwidth;
  };
  scale2.step = function() {
    return step;
  };
  scale2.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };
  scale2.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale2.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale2.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale2.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale2.copy = function() {
    return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale2) {
  var copy3 = scale2.copy;
  scale2.padding = scale2.paddingOuter;
  delete scale2.paddingInner;
  delete scale2.paddingOuter;
  scale2.copy = function() {
    return pointish(copy3());
  };
  return scale2;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
var init_band = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js"() {
    init_src2();
    init_init();
    init_ordinal();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js
function constants(x4) {
  return function() {
    return x4;
  };
}
var init_constant11 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js
function number3(x4) {
  return +x4;
}
var init_number3 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js
function identity3(x4) {
  return x4;
}
function normalize2(a4, b) {
  return (b -= a4 = +a4) ? function(x4) {
    return (x4 - a4) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a4, b) {
  var t;
  if (a4 > b) t = a4, a4 = b, b = t;
  return function(x4) {
    return Math.max(a4, Math.min(b, x4));
  };
}
function bimap(domain, range4, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range4[0], r1 = range4[1];
  if (d1 < d0) d0 = normalize2(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize2(d0, d1), r0 = interpolate(r0, r1);
  return function(x4) {
    return r0(d0(x4));
  };
}
function polymap(domain, range4, interpolate) {
  var j = Math.min(domain.length, range4.length) - 1, d = new Array(j), r = new Array(j), i = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range4 = range4.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize2(domain[i], domain[i + 1]);
    r[i] = interpolate(range4[i], range4[i + 1]);
  }
  return function(x4) {
    var i2 = bisect_default(domain, x4, 1, j) - 1;
    return r[i2](d[i2](x4));
  };
}
function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer2() {
  var domain = unit, range4 = unit, interpolate = value_default, transform2, untransform, unknown, clamp = identity3, piecewise2, output, input;
  function rescale() {
    var n = Math.min(domain.length, range4.length);
    if (clamp !== identity3) clamp = clamper(domain[0], domain[n - 1]);
    piecewise2 = n > 2 ? polymap : bimap;
    output = input = null;
    return scale2;
  }
  function scale2(x4) {
    return x4 == null || isNaN(x4 = +x4) ? unknown : (output || (output = piecewise2(domain.map(transform2), range4, interpolate)))(transform2(clamp(x4)));
  }
  scale2.invert = function(y4) {
    return clamp(untransform((input || (input = piecewise2(range4, domain.map(transform2), number_default)))(y4)));
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number3), rescale()) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range4 = Array.from(_), rescale()) : range4.slice();
  };
  scale2.rangeRound = function(_) {
    return range4 = Array.from(_), interpolate = round_default, rescale();
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity3, rescale()) : clamp !== identity3;
  };
  scale2.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t, u4) {
    transform2 = t, untransform = u4;
    return rescale();
  };
}
function continuous() {
  return transformer2()(identity3, identity3);
}
var unit;
var init_continuous = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js"() {
    init_src2();
    init_src8();
    init_constant11();
    init_number3();
    unit = [0, 1];
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/tickFormat.js
function tickFormat(start2, stop, count3, specifier) {
  var step = tickStep(start2, stop, count3), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix_default(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound_default(step, Math.max(Math.abs(start2), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed_default(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
var init_tickFormat = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/tickFormat.js"() {
    init_src2();
    init_src21();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/linear.js
function linearish(scale2) {
  var domain = scale2.domain;
  scale2.ticks = function(count3) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count3 == null ? 10 : count3);
  };
  scale2.tickFormat = function(count3, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count3 == null ? 10 : count3, specifier);
  };
  scale2.nice = function(count3) {
    if (count3 == null) count3 = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start2 = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start2) {
      step = start2, start2 = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start2, stop, count3);
      if (step === prestep) {
        d[i0] = start2;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start2 = Math.floor(start2 / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start2 = Math.ceil(start2 * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale2;
  };
  return scale2;
}
function linear3() {
  var scale2 = continuous();
  scale2.copy = function() {
    return copy(scale2, linear3());
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}
var init_linear2 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/linear.js"() {
    init_src2();
    init_continuous();
    init_init();
    init_tickFormat();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/identity.js
function identity4(domain) {
  var unknown;
  function scale2(x4) {
    return x4 == null || isNaN(x4 = +x4) ? unknown : x4;
  }
  scale2.invert = scale2;
  scale2.domain = scale2.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number3), scale2) : domain.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return identity4(domain).unknown(unknown);
  };
  domain = arguments.length ? Array.from(domain, number3) : [0, 1];
  return linearish(scale2);
}
var init_identity6 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/identity.js"() {
    init_linear2();
    init_number3();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/nice.js
function nice2(domain, interval2) {
  domain = domain.slice();
  var i0 = 0, i1 = domain.length - 1, x06 = domain[i0], x12 = domain[i1], t;
  if (x12 < x06) {
    t = i0, i0 = i1, i1 = t;
    t = x06, x06 = x12, x12 = t;
  }
  domain[i0] = interval2.floor(x06);
  domain[i1] = interval2.ceil(x12);
  return domain;
}
var init_nice2 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/nice.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/log.js
function transformLog(x4) {
  return Math.log(x4);
}
function transformExp(x4) {
  return Math.exp(x4);
}
function transformLogn(x4) {
  return -Math.log(-x4);
}
function transformExpn(x4) {
  return -Math.exp(-x4);
}
function pow10(x4) {
  return isFinite(x4) ? +("1e" + x4) : x4 < 0 ? 0 : x4;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x4) => Math.pow(base, x4);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x4) => Math.log(x4) / base);
}
function reflect(f2) {
  return (x4, k2) => -f2(-x4, k2);
}
function loggish(transform2) {
  const scale2 = transform2(transformLog, transformExp);
  const domain = scale2.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform2(transformLogn, transformExpn);
    } else {
      transform2(transformLog, transformExp);
    }
    return scale2;
  }
  scale2.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.ticks = (count3) => {
    const d = domain();
    let u4 = d[0];
    let v2 = d[d.length - 1];
    const r = v2 < u4;
    if (r) [u4, v2] = [v2, u4];
    let i = logs(u4);
    let j = logs(v2);
    let k2;
    let t;
    const n = count3 == null ? 10 : +count3;
    let z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u4 > 0) for (; i <= j; ++i) {
        for (k2 = 1; k2 < base; ++k2) {
          t = i < 0 ? k2 / pows(-i) : k2 * pows(i);
          if (t < u4) continue;
          if (t > v2) break;
          z.push(t);
        }
      }
      else for (; i <= j; ++i) {
        for (k2 = base - 1; k2 >= 1; --k2) {
          t = i > 0 ? k2 / pows(-i) : k2 * pows(i);
          if (t < u4) continue;
          if (t > v2) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u4, v2, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r ? z.reverse() : z;
  };
  scale2.tickFormat = (count3, specifier) => {
    if (count3 == null) count3 = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format(specifier);
    }
    if (count3 === Infinity) return specifier;
    const k2 = Math.max(1, base * count3 / scale2.ticks().length);
    return (d) => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k2 ? specifier(d) : "";
    };
  };
  scale2.nice = () => {
    return domain(nice2(domain(), {
      floor: (x4) => pows(Math.floor(logs(x4))),
      ceil: (x4) => pows(Math.ceil(logs(x4)))
    }));
  };
  return scale2;
}
function log2() {
  const scale2 = loggish(transformer2()).domain([1, 10]);
  scale2.copy = () => copy(scale2, log2()).base(scale2.base());
  initRange.apply(scale2, arguments);
  return scale2;
}
var init_log = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/log.js"() {
    init_src2();
    init_src21();
    init_nice2();
    init_continuous();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/symlog.js
function transformSymlog(c6) {
  return function(x4) {
    return Math.sign(x4) * Math.log1p(Math.abs(x4 / c6));
  };
}
function transformSymexp(c6) {
  return function(x4) {
    return Math.sign(x4) * Math.expm1(Math.abs(x4)) * c6;
  };
}
function symlogish(transform2) {
  var c6 = 1, scale2 = transform2(transformSymlog(c6), transformSymexp(c6));
  scale2.constant = function(_) {
    return arguments.length ? transform2(transformSymlog(c6 = +_), transformSymexp(c6)) : c6;
  };
  return linearish(scale2);
}
function symlog() {
  var scale2 = symlogish(transformer2());
  scale2.copy = function() {
    return copy(scale2, symlog()).constant(scale2.constant());
  };
  return initRange.apply(scale2, arguments);
}
var init_symlog = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/symlog.js"() {
    init_linear2();
    init_continuous();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/pow.js
function transformPow(exponent2) {
  return function(x4) {
    return x4 < 0 ? -Math.pow(-x4, exponent2) : Math.pow(x4, exponent2);
  };
}
function transformSqrt(x4) {
  return x4 < 0 ? -Math.sqrt(-x4) : Math.sqrt(x4);
}
function transformSquare(x4) {
  return x4 < 0 ? -x4 * x4 : x4 * x4;
}
function powish(transform2) {
  var scale2 = transform2(identity3, identity3), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform2(identity3, identity3) : exponent2 === 0.5 ? transform2(transformSqrt, transformSquare) : transform2(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale2.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  };
  return linearish(scale2);
}
function pow3() {
  var scale2 = powish(transformer2());
  scale2.copy = function() {
    return copy(scale2, pow3()).exponent(scale2.exponent());
  };
  initRange.apply(scale2, arguments);
  return scale2;
}
function sqrt2() {
  return pow3.apply(null, arguments).exponent(0.5);
}
var init_pow = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/pow.js"() {
    init_linear2();
    init_continuous();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/radial.js
function square(x4) {
  return Math.sign(x4) * x4 * x4;
}
function unsquare(x4) {
  return Math.sign(x4) * Math.sqrt(Math.abs(x4));
}
function radial() {
  var squared = continuous(), range4 = [0, 1], round = false, unknown;
  function scale2(x4) {
    var y4 = unsquare(squared(x4));
    return isNaN(y4) ? unknown : round ? Math.round(y4) : y4;
  }
  scale2.invert = function(y4) {
    return squared.invert(square(y4));
  };
  scale2.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale2) : squared.domain();
  };
  scale2.range = function(_) {
    return arguments.length ? (squared.range((range4 = Array.from(_, number3)).map(square)), scale2) : range4.slice();
  };
  scale2.rangeRound = function(_) {
    return scale2.range(_).round(true);
  };
  scale2.round = function(_) {
    return arguments.length ? (round = !!_, scale2) : round;
  };
  scale2.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale2) : squared.clamp();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return radial(squared.domain(), range4).round(round).clamp(squared.clamp()).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}
var init_radial2 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/radial.js"() {
    init_continuous();
    init_init();
    init_linear2();
    init_number3();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantile.js
function quantile2() {
  var domain = [], range4 = [], thresholds = [], unknown;
  function rescale() {
    var i = 0, n = Math.max(1, range4.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);
    return scale2;
  }
  function scale2(x4) {
    return x4 == null || isNaN(x4 = +x4) ? unknown : range4[bisect_default(thresholds, x4)];
  }
  scale2.invertExtent = function(y4) {
    var i = range4.indexOf(y4);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };
  scale2.range = function(_) {
    return arguments.length ? (range4 = Array.from(_), rescale()) : range4.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.quantiles = function() {
    return thresholds.slice();
  };
  scale2.copy = function() {
    return quantile2().domain(domain).range(range4).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}
var init_quantile2 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantile.js"() {
    init_src2();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantize.js
function quantize() {
  var x06 = 0, x12 = 1, n = 1, domain = [0.5], range4 = [0, 1], unknown;
  function scale2(x4) {
    return x4 != null && x4 <= x4 ? range4[bisect_default(domain, x4, 0, n)] : unknown;
  }
  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x12 - (i - n) * x06) / (n + 1);
    return scale2;
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x06, x12] = _, x06 = +x06, x12 = +x12, rescale()) : [x06, x12];
  };
  scale2.range = function(_) {
    return arguments.length ? (n = (range4 = Array.from(_)).length - 1, rescale()) : range4.slice();
  };
  scale2.invertExtent = function(y4) {
    var i = range4.indexOf(y4);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x06, domain[0]] : i >= n ? [domain[n - 1], x12] : [domain[i - 1], domain[i]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : scale2;
  };
  scale2.thresholds = function() {
    return domain.slice();
  };
  scale2.copy = function() {
    return quantize().domain([x06, x12]).range(range4).unknown(unknown);
  };
  return initRange.apply(linearish(scale2), arguments);
}
var init_quantize2 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantize.js"() {
    init_src2();
    init_linear2();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/threshold.js
function threshold() {
  var domain = [0.5], range4 = [0, 1], unknown, n = 1;
  function scale2(x4) {
    return x4 != null && x4 <= x4 ? range4[bisect_default(domain, x4, 0, n)] : unknown;
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range4.length - 1), scale2) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range4 = Array.from(_), n = Math.min(domain.length, range4.length - 1), scale2) : range4.slice();
  };
  scale2.invertExtent = function(y4) {
    var i = range4.indexOf(y4);
    return [domain[i - 1], domain[i]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return threshold().domain(domain).range(range4).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}
var init_threshold = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/threshold.js"() {
    init_src2();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/interval.js
function timeInterval(floori, offseti, count3, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval2.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval2.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = (date2) => {
    const d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = (date2, step) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2;
  };
  interval2.range = (start2, stop, step) => {
    const range4 = [];
    start2 = interval2.ceil(start2);
    step = step == null ? 1 : Math.floor(step);
    if (!(start2 < stop) || !(step > 0)) return range4;
    let previous;
    do
      range4.push(previous = /* @__PURE__ */ new Date(+start2)), offseti(start2, step), floori(start2);
    while (previous < start2 && start2 < stop);
    return range4;
  };
  interval2.filter = (test) => {
    return timeInterval((date2) => {
      if (date2 >= date2) while (floori(date2), !test(date2)) date2.setTime(date2 - 1);
    }, (date2, step) => {
      if (date2 >= date2) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date2, -1), !test(date2)) {
          }
        }
        else while (--step >= 0) {
          while (offseti(date2, 1), !test(date2)) {
          }
        }
      }
    });
  };
  if (count3) {
    interval2.count = (start2, end) => {
      t02.setTime(+start2), t12.setTime(+end);
      floori(t02), floori(t12);
      return Math.floor(count3(t02, t12));
    };
    interval2.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval2 : interval2.filter(field ? (d) => field(d) % step === 0 : (d) => interval2.count(0, d) % step === 0);
    };
  }
  return interval2;
}
var t02, t12;
var init_interval2 = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/interval.js"() {
    t02 = /* @__PURE__ */ new Date();
    t12 = /* @__PURE__ */ new Date();
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/millisecond.js
var millisecond, milliseconds;
var init_millisecond = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/millisecond.js"() {
    init_interval2();
    millisecond = timeInterval(() => {
    }, (date2, step) => {
      date2.setTime(+date2 + step);
    }, (start2, end) => {
      return end - start2;
    });
    millisecond.every = (k2) => {
      k2 = Math.floor(k2);
      if (!isFinite(k2) || !(k2 > 0)) return null;
      if (!(k2 > 1)) return millisecond;
      return timeInterval((date2) => {
        date2.setTime(Math.floor(date2 / k2) * k2);
      }, (date2, step) => {
        date2.setTime(+date2 + step * k2);
      }, (start2, end) => {
        return (end - start2) / k2;
      });
    };
    milliseconds = millisecond.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/duration.js
var durationSecond, durationMinute, durationHour, durationDay, durationWeek, durationMonth, durationYear;
var init_duration2 = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/duration.js"() {
    durationSecond = 1e3;
    durationMinute = durationSecond * 60;
    durationHour = durationMinute * 60;
    durationDay = durationHour * 24;
    durationWeek = durationDay * 7;
    durationMonth = durationDay * 30;
    durationYear = durationDay * 365;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/second.js
var second, seconds;
var init_second = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/second.js"() {
    init_interval2();
    init_duration2();
    second = timeInterval((date2) => {
      date2.setTime(date2 - date2.getMilliseconds());
    }, (date2, step) => {
      date2.setTime(+date2 + step * durationSecond);
    }, (start2, end) => {
      return (end - start2) / durationSecond;
    }, (date2) => {
      return date2.getUTCSeconds();
    });
    seconds = second.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/minute.js
var timeMinute, timeMinutes, utcMinute, utcMinutes;
var init_minute = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/minute.js"() {
    init_interval2();
    init_duration2();
    timeMinute = timeInterval((date2) => {
      date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
    }, (date2, step) => {
      date2.setTime(+date2 + step * durationMinute);
    }, (start2, end) => {
      return (end - start2) / durationMinute;
    }, (date2) => {
      return date2.getMinutes();
    });
    timeMinutes = timeMinute.range;
    utcMinute = timeInterval((date2) => {
      date2.setUTCSeconds(0, 0);
    }, (date2, step) => {
      date2.setTime(+date2 + step * durationMinute);
    }, (start2, end) => {
      return (end - start2) / durationMinute;
    }, (date2) => {
      return date2.getUTCMinutes();
    });
    utcMinutes = utcMinute.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/hour.js
var timeHour, timeHours, utcHour, utcHours;
var init_hour = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/hour.js"() {
    init_interval2();
    init_duration2();
    timeHour = timeInterval((date2) => {
      date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
    }, (date2, step) => {
      date2.setTime(+date2 + step * durationHour);
    }, (start2, end) => {
      return (end - start2) / durationHour;
    }, (date2) => {
      return date2.getHours();
    });
    timeHours = timeHour.range;
    utcHour = timeInterval((date2) => {
      date2.setUTCMinutes(0, 0, 0);
    }, (date2, step) => {
      date2.setTime(+date2 + step * durationHour);
    }, (start2, end) => {
      return (end - start2) / durationHour;
    }, (date2) => {
      return date2.getUTCHours();
    });
    utcHours = utcHour.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/day.js
var timeDay, timeDays, utcDay, utcDays, unixDay, unixDays;
var init_day = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/day.js"() {
    init_interval2();
    init_duration2();
    timeDay = timeInterval(
      (date2) => date2.setHours(0, 0, 0, 0),
      (date2, step) => date2.setDate(date2.getDate() + step),
      (start2, end) => (end - start2 - (end.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationDay,
      (date2) => date2.getDate() - 1
    );
    timeDays = timeDay.range;
    utcDay = timeInterval((date2) => {
      date2.setUTCHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setUTCDate(date2.getUTCDate() + step);
    }, (start2, end) => {
      return (end - start2) / durationDay;
    }, (date2) => {
      return date2.getUTCDate() - 1;
    });
    utcDays = utcDay.range;
    unixDay = timeInterval((date2) => {
      date2.setUTCHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setUTCDate(date2.getUTCDate() + step);
    }, (start2, end) => {
      return (end - start2) / durationDay;
    }, (date2) => {
      return Math.floor(date2 / durationDay);
    });
    unixDays = unixDay.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/week.js
function timeWeekday(i) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start2, end) => {
    return (end - start2 - (end.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
function utcWeekday(i) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start2, end) => {
    return (end - start2) / durationWeek;
  });
}
var timeSunday, timeMonday, timeTuesday, timeWednesday, timeThursday, timeFriday, timeSaturday, timeSundays, timeMondays, timeTuesdays, timeWednesdays, timeThursdays, timeFridays, timeSaturdays, utcSunday, utcMonday, utcTuesday, utcWednesday, utcThursday, utcFriday, utcSaturday, utcSundays, utcMondays, utcTuesdays, utcWednesdays, utcThursdays, utcFridays, utcSaturdays;
var init_week = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/week.js"() {
    init_interval2();
    init_duration2();
    timeSunday = timeWeekday(0);
    timeMonday = timeWeekday(1);
    timeTuesday = timeWeekday(2);
    timeWednesday = timeWeekday(3);
    timeThursday = timeWeekday(4);
    timeFriday = timeWeekday(5);
    timeSaturday = timeWeekday(6);
    timeSundays = timeSunday.range;
    timeMondays = timeMonday.range;
    timeTuesdays = timeTuesday.range;
    timeWednesdays = timeWednesday.range;
    timeThursdays = timeThursday.range;
    timeFridays = timeFriday.range;
    timeSaturdays = timeSaturday.range;
    utcSunday = utcWeekday(0);
    utcMonday = utcWeekday(1);
    utcTuesday = utcWeekday(2);
    utcWednesday = utcWeekday(3);
    utcThursday = utcWeekday(4);
    utcFriday = utcWeekday(5);
    utcSaturday = utcWeekday(6);
    utcSundays = utcSunday.range;
    utcMondays = utcMonday.range;
    utcTuesdays = utcTuesday.range;
    utcWednesdays = utcWednesday.range;
    utcThursdays = utcThursday.range;
    utcFridays = utcFriday.range;
    utcSaturdays = utcSaturday.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/month.js
var timeMonth, timeMonths, utcMonth, utcMonths;
var init_month = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/month.js"() {
    init_interval2();
    timeMonth = timeInterval((date2) => {
      date2.setDate(1);
      date2.setHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setMonth(date2.getMonth() + step);
    }, (start2, end) => {
      return end.getMonth() - start2.getMonth() + (end.getFullYear() - start2.getFullYear()) * 12;
    }, (date2) => {
      return date2.getMonth();
    });
    timeMonths = timeMonth.range;
    utcMonth = timeInterval((date2) => {
      date2.setUTCDate(1);
      date2.setUTCHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setUTCMonth(date2.getUTCMonth() + step);
    }, (start2, end) => {
      return end.getUTCMonth() - start2.getUTCMonth() + (end.getUTCFullYear() - start2.getUTCFullYear()) * 12;
    }, (date2) => {
      return date2.getUTCMonth();
    });
    utcMonths = utcMonth.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/year.js
var timeYear, timeYears, utcYear, utcYears;
var init_year = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/year.js"() {
    init_interval2();
    timeYear = timeInterval((date2) => {
      date2.setMonth(0, 1);
      date2.setHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setFullYear(date2.getFullYear() + step);
    }, (start2, end) => {
      return end.getFullYear() - start2.getFullYear();
    }, (date2) => {
      return date2.getFullYear();
    });
    timeYear.every = (k2) => {
      return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
        date2.setFullYear(Math.floor(date2.getFullYear() / k2) * k2);
        date2.setMonth(0, 1);
        date2.setHours(0, 0, 0, 0);
      }, (date2, step) => {
        date2.setFullYear(date2.getFullYear() + step * k2);
      });
    };
    timeYears = timeYear.range;
    utcYear = timeInterval((date2) => {
      date2.setUTCMonth(0, 1);
      date2.setUTCHours(0, 0, 0, 0);
    }, (date2, step) => {
      date2.setUTCFullYear(date2.getUTCFullYear() + step);
    }, (start2, end) => {
      return end.getUTCFullYear() - start2.getUTCFullYear();
    }, (date2) => {
      return date2.getUTCFullYear();
    });
    utcYear.every = (k2) => {
      return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
        date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k2) * k2);
        date2.setUTCMonth(0, 1);
        date2.setUTCHours(0, 0, 0, 0);
      }, (date2, step) => {
        date2.setUTCFullYear(date2.getUTCFullYear() + step * k2);
      });
    };
    utcYears = utcYear.range;
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/ticks.js
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear]
  ];
  function ticks2(start2, stop, count3) {
    const reverse2 = stop < start2;
    if (reverse2) [start2, stop] = [stop, start2];
    const interval2 = count3 && typeof count3.range === "function" ? count3 : tickInterval(start2, stop, count3);
    const ticks3 = interval2 ? interval2.range(start2, +stop + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop, count3) {
    const target = Math.abs(stop - start2) / count3;
    const i = bisector(([, , step2]) => step2).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start2 / durationYear, stop / durationYear, count3));
    if (i === 0) return millisecond.every(Math.max(tickStep(start2, stop, count3), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }
  return [ticks2, tickInterval];
}
var utcTicks, utcTickInterval, timeTicks, timeTickInterval;
var init_ticks2 = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/ticks.js"() {
    init_src2();
    init_duration2();
    init_millisecond();
    init_second();
    init_minute();
    init_hour();
    init_day();
    init_week();
    init_month();
    init_year();
    [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
    [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
  }
});

// ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/index.js
var init_src26 = __esm({
  "../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/index.js"() {
    init_interval2();
    init_millisecond();
    init_second();
    init_minute();
    init_hour();
    init_day();
    init_week();
    init_month();
    init_year();
    init_ticks2();
  }
});

// ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/locale.js
function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date2.setFullYear(d.y);
    return date2;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date2.setUTCFullYear(d.y);
    return date2;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y4, m3, d) {
  return { y: y4, m: m3, d, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale3) {
  var locale_dateTime = locale3.dateTime, locale_date = locale3.date, locale_time = locale3.time, locale_periods = locale3.periods, locale_weekdays = locale3.days, locale_shortWeekdays = locale3.shortDays, locale_months = locale3.months, locale_shortMonths = locale3.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear2,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string = [], i = -1, j = 0, n = specifier.length, c6, pad3, format2;
      if (!(date2 instanceof Date)) date2 = /* @__PURE__ */ new Date(+date2);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad3 = pads[c6 = specifier.charAt(++i)]) != null) c6 = specifier.charAt(++i);
          else pad3 = c6 === "e" ? " " : "0";
          if (format2 = formats2[c6]) c6 = format2(date2, pad3);
          string.push(c6);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
      if (i != string.length) return null;
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
      if (Z && !("Z" in d)) d.Z = 0;
      if ("p" in d) d.H = d.H % 12 + d.p * 12;
      if (d.m === void 0) d.m = "q" in d ? d.q : 0;
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0, n = specifier.length, m3 = string.length, c6, parse2;
    while (i < n) {
      if (j >= m3) return -1;
      c6 = specifier.charCodeAt(i++);
      if (c6 === 37) {
        c6 = specifier.charAt(i++);
        parse2 = parses[c6 in pads ? specifier.charAt(i++) : c6];
        if (!parse2 || (j = parse2(d, string, j)) < 0) return -1;
      } else if (c6 != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() {
        return specifier;
      };
      return p;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() {
        return specifier;
      };
      return p;
    }
  };
}
function pad2(value, fill, width) {
  var sign3 = value < 0 ? "-" : "", string = (sign3 ? -value : value) + "", length3 = string.length;
  return sign3 + (length3 < width ? new Array(width - length3 + 1).join(fill) + string : string);
}
function requote(s2) {
  return s2.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad2(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad2(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad2(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad2(1 + timeDay.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad2(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad2(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad2(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad2(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad2(timeSunday.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad2(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad2(timeMonday.count(timeYear(d) - 1, d), p, 2);
}
function formatYear2(d, p) {
  return pad2(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad2(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad2(d.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad2(d.getFullYear() % 1e4, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad2(z / 60 | 0, "0", 2) + pad2(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad2(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad2(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad2(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad2(1 + utcDay.count(utcYear(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad2(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad2(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad2(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad2(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad2(utcSunday.count(utcYear(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad2(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad2(utcMonday.count(utcYear(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1e3);
}
var pads, numberRe, percentRe, requoteRe;
var init_locale2 = __esm({
  "../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/locale.js"() {
    init_src26();
    pads = { "-": "", "_": " ", "0": "0" };
    numberRe = /^\s*\d+/;
    percentRe = /^%/;
    requoteRe = /[\\^$*+?|[\]().{}]/g;
  }
});

// ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/defaultLocale.js
function defaultLocale2(definition) {
  locale2 = formatLocale(definition);
  timeFormat = locale2.format;
  timeParse = locale2.parse;
  utcFormat = locale2.utcFormat;
  utcParse = locale2.utcParse;
  return locale2;
}
var locale2, timeFormat, timeParse, utcFormat, utcParse;
var init_defaultLocale2 = __esm({
  "../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/defaultLocale.js"() {
    init_locale2();
    defaultLocale2({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    });
  }
});

// ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/isoFormat.js
function formatIsoNative(date2) {
  return date2.toISOString();
}
var isoSpecifier, formatIso, isoFormat_default;
var init_isoFormat = __esm({
  "../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/isoFormat.js"() {
    init_defaultLocale2();
    isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
    formatIso = Date.prototype.toISOString ? formatIsoNative : utcFormat(isoSpecifier);
    isoFormat_default = formatIso;
  }
});

// ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/isoParse.js
function parseIsoNative(string) {
  var date2 = new Date(string);
  return isNaN(date2) ? null : date2;
}
var parseIso, isoParse_default;
var init_isoParse = __esm({
  "../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/isoParse.js"() {
    init_isoFormat();
    init_defaultLocale2();
    parseIso = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : utcParse(isoSpecifier);
    isoParse_default = parseIso;
  }
});

// ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/index.js
var init_src27 = __esm({
  "../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/index.js"() {
    init_defaultLocale2();
    init_locale2();
    init_isoFormat();
    init_isoParse();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/time.js
function date(t) {
  return new Date(t);
}
function number4(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale2 = continuous(), invert = scale2.invert, domain = scale2.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear3 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear3)(date2);
  }
  scale2.invert = function(y4) {
    return new Date(invert(y4));
  };
  scale2.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number4)) : domain().map(date);
  };
  scale2.ticks = function(interval2) {
    var d = domain();
    return ticks2(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
  };
  scale2.tickFormat = function(count3, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale2.nice = function(interval2) {
    var d = domain();
    if (!interval2 || typeof interval2.range !== "function") interval2 = tickInterval(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain(nice2(d, interval2)) : scale2;
  };
  scale2.copy = function() {
    return copy(scale2, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale2;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
var init_time = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/time.js"() {
    init_src26();
    init_src27();
    init_continuous();
    init_init();
    init_nice2();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/utcTime.js
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
var init_utcTime = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/utcTime.js"() {
    init_src26();
    init_src27();
    init_time();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequential.js
function transformer3() {
  var x06 = 0, x12 = 1, t03, t13, k10, transform2, interpolator = identity3, clamp = false, unknown;
  function scale2(x4) {
    return x4 == null || isNaN(x4 = +x4) ? unknown : interpolator(k10 === 0 ? 0.5 : (x4 = (transform2(x4) - t03) * k10, clamp ? Math.max(0, Math.min(1, x4)) : x4));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x06, x12] = _, t03 = transform2(x06 = +x06), t13 = transform2(x12 = +x12), k10 = t03 === t13 ? 0 : 1 / (t13 - t03), scale2) : [x06, x12];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale2) : clamp;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range4(interpolate) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale2) : [interpolator(0), interpolator(1)];
    };
  }
  scale2.range = range4(value_default);
  scale2.rangeRound = range4(round_default);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t) {
    transform2 = t, t03 = t(x06), t13 = t(x12), k10 = t03 === t13 ? 0 : 1 / (t13 - t03);
    return scale2;
  };
}
function copy2(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale2 = linearish(transformer3()(identity3));
  scale2.copy = function() {
    return copy2(scale2, sequential());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialLog() {
  var scale2 = loggish(transformer3()).domain([1, 10]);
  scale2.copy = function() {
    return copy2(scale2, sequentialLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSymlog() {
  var scale2 = symlogish(transformer3());
  scale2.copy = function() {
    return copy2(scale2, sequentialSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialPow() {
  var scale2 = powish(transformer3());
  scale2.copy = function() {
    return copy2(scale2, sequentialPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
var init_sequential = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequential.js"() {
    init_src8();
    init_continuous();
    init_init();
    init_linear2();
    init_log();
    init_symlog();
    init_pow();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequentialQuantile.js
function sequentialQuantile() {
  var domain = [], interpolator = identity3;
  function scale2(x4) {
    if (x4 != null && !isNaN(x4 = +x4)) return interpolator((bisect_default(domain, x4, 1) - 1) / (domain.length - 1));
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return scale2;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  scale2.range = function() {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };
  scale2.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (_, i) => quantile(domain, i / n));
  };
  scale2.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };
  return initInterpolator.apply(scale2, arguments);
}
var init_sequentialQuantile = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequentialQuantile.js"() {
    init_src2();
    init_continuous();
    init_init();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/diverging.js
function transformer4() {
  var x06 = 0, x12 = 0.5, x22 = 1, s2 = 1, t03, t13, t22, k10, k21, interpolator = identity3, transform2, clamp = false, unknown;
  function scale2(x4) {
    return isNaN(x4 = +x4) ? unknown : (x4 = 0.5 + ((x4 = +transform2(x4)) - t13) * (s2 * x4 < s2 * t13 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x4)) : x4));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x06, x12, x22] = _, t03 = transform2(x06 = +x06), t13 = transform2(x12 = +x12), t22 = transform2(x22 = +x22), k10 = t03 === t13 ? 0 : 0.5 / (t13 - t03), k21 = t13 === t22 ? 0 : 0.5 / (t22 - t13), s2 = t13 < t03 ? -1 : 1, scale2) : [x06, x12, x22];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale2) : clamp;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range4(interpolate) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [r0, r1, r2]), scale2) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale2.range = range4(value_default);
  scale2.rangeRound = range4(round_default);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t) {
    transform2 = t, t03 = t(x06), t13 = t(x12), t22 = t(x22), k10 = t03 === t13 ? 0 : 0.5 / (t13 - t03), k21 = t13 === t22 ? 0 : 0.5 / (t22 - t13), s2 = t13 < t03 ? -1 : 1;
    return scale2;
  };
}
function diverging() {
  var scale2 = linearish(transformer4()(identity3));
  scale2.copy = function() {
    return copy2(scale2, diverging());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingLog() {
  var scale2 = loggish(transformer4()).domain([0.1, 1, 10]);
  scale2.copy = function() {
    return copy2(scale2, divergingLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSymlog() {
  var scale2 = symlogish(transformer4());
  scale2.copy = function() {
    return copy2(scale2, divergingSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingPow() {
  var scale2 = powish(transformer4());
  scale2.copy = function() {
    return copy2(scale2, divergingPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
var init_diverging = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/diverging.js"() {
    init_src8();
    init_continuous();
    init_init();
    init_linear2();
    init_log();
    init_sequential();
    init_symlog();
    init_pow();
  }
});

// ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/index.js
var init_src28 = __esm({
  "../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/index.js"() {
    init_band();
    init_identity6();
    init_linear2();
    init_log();
    init_symlog();
    init_ordinal();
    init_pow();
    init_radial2();
    init_quantile2();
    init_quantize2();
    init_threshold();
    init_time();
    init_utcTime();
    init_sequential();
    init_sequentialQuantile();
    init_diverging();
    init_tickFormat();
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/colors.js
function colors_default(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}
var init_colors = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/colors.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/category10.js
var category10_default;
var init_category10 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/category10.js"() {
    init_colors();
    category10_default = colors_default("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Accent.js
var Accent_default;
var init_Accent = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Accent.js"() {
    init_colors();
    Accent_default = colors_default("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Dark2.js
var Dark2_default;
var init_Dark2 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Dark2.js"() {
    init_colors();
    Dark2_default = colors_default("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/observable10.js
var observable10_default;
var init_observable10 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/observable10.js"() {
    init_colors();
    observable10_default = colors_default("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Paired.js
var Paired_default;
var init_Paired = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Paired.js"() {
    init_colors();
    Paired_default = colors_default("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Pastel1.js
var Pastel1_default;
var init_Pastel1 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Pastel1.js"() {
    init_colors();
    Pastel1_default = colors_default("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Pastel2.js
var Pastel2_default;
var init_Pastel2 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Pastel2.js"() {
    init_colors();
    Pastel2_default = colors_default("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set1.js
var Set1_default;
var init_Set1 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set1.js"() {
    init_colors();
    Set1_default = colors_default("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set2.js
var Set2_default;
var init_Set2 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set2.js"() {
    init_colors();
    Set2_default = colors_default("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set3.js
var Set3_default;
var init_Set3 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Set3.js"() {
    init_colors();
    Set3_default = colors_default("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Tableau10.js
var Tableau10_default;
var init_Tableau10 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/categorical/Tableau10.js"() {
    init_colors();
    Tableau10_default = colors_default("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/ramp.js
var ramp_default;
var init_ramp = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/ramp.js"() {
    init_src8();
    ramp_default = (scheme28) => rgbBasis(scheme28[scheme28.length - 1]);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/BrBG.js
var scheme, BrBG_default;
var init_BrBG = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/BrBG.js"() {
    init_colors();
    init_ramp();
    scheme = new Array(3).concat(
      "d8b365f5f5f55ab4ac",
      "a6611adfc27d80cdc1018571",
      "a6611adfc27df5f5f580cdc1018571",
      "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
      "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
      "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
      "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
      "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
      "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
    ).map(colors_default);
    BrBG_default = ramp_default(scheme);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PRGn.js
var scheme2, PRGn_default;
var init_PRGn = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PRGn.js"() {
    init_colors();
    init_ramp();
    scheme2 = new Array(3).concat(
      "af8dc3f7f7f77fbf7b",
      "7b3294c2a5cfa6dba0008837",
      "7b3294c2a5cff7f7f7a6dba0008837",
      "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
      "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
      "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
      "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
      "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
      "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
    ).map(colors_default);
    PRGn_default = ramp_default(scheme2);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PiYG.js
var scheme3, PiYG_default;
var init_PiYG = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PiYG.js"() {
    init_colors();
    init_ramp();
    scheme3 = new Array(3).concat(
      "e9a3c9f7f7f7a1d76a",
      "d01c8bf1b6dab8e1864dac26",
      "d01c8bf1b6daf7f7f7b8e1864dac26",
      "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
      "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
      "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
      "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
      "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
      "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
    ).map(colors_default);
    PiYG_default = ramp_default(scheme3);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PuOr.js
var scheme4, PuOr_default;
var init_PuOr = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/PuOr.js"() {
    init_colors();
    init_ramp();
    scheme4 = new Array(3).concat(
      "998ec3f7f7f7f1a340",
      "5e3c99b2abd2fdb863e66101",
      "5e3c99b2abd2f7f7f7fdb863e66101",
      "542788998ec3d8daebfee0b6f1a340b35806",
      "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
      "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
      "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
      "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
      "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
    ).map(colors_default);
    PuOr_default = ramp_default(scheme4);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdBu.js
var scheme5, RdBu_default;
var init_RdBu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdBu.js"() {
    init_colors();
    init_ramp();
    scheme5 = new Array(3).concat(
      "ef8a62f7f7f767a9cf",
      "ca0020f4a58292c5de0571b0",
      "ca0020f4a582f7f7f792c5de0571b0",
      "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
      "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
      "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
      "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
      "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
      "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
    ).map(colors_default);
    RdBu_default = ramp_default(scheme5);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdGy.js
var scheme6, RdGy_default;
var init_RdGy = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdGy.js"() {
    init_colors();
    init_ramp();
    scheme6 = new Array(3).concat(
      "ef8a62ffffff999999",
      "ca0020f4a582bababa404040",
      "ca0020f4a582ffffffbababa404040",
      "b2182bef8a62fddbc7e0e0e09999994d4d4d",
      "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
      "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
      "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
      "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
      "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
    ).map(colors_default);
    RdGy_default = ramp_default(scheme6);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js
var scheme7, RdYlBu_default;
var init_RdYlBu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js"() {
    init_colors();
    init_ramp();
    scheme7 = new Array(3).concat(
      "fc8d59ffffbf91bfdb",
      "d7191cfdae61abd9e92c7bb6",
      "d7191cfdae61ffffbfabd9e92c7bb6",
      "d73027fc8d59fee090e0f3f891bfdb4575b4",
      "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
      "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
      "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
      "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
      "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
    ).map(colors_default);
    RdYlBu_default = ramp_default(scheme7);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js
var scheme8, RdYlGn_default;
var init_RdYlGn = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js"() {
    init_colors();
    init_ramp();
    scheme8 = new Array(3).concat(
      "fc8d59ffffbf91cf60",
      "d7191cfdae61a6d96a1a9641",
      "d7191cfdae61ffffbfa6d96a1a9641",
      "d73027fc8d59fee08bd9ef8b91cf601a9850",
      "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
      "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
      "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
      "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
      "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
    ).map(colors_default);
    RdYlGn_default = ramp_default(scheme8);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/Spectral.js
var scheme9, Spectral_default;
var init_Spectral = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/diverging/Spectral.js"() {
    init_colors();
    init_ramp();
    scheme9 = new Array(3).concat(
      "fc8d59ffffbf99d594",
      "d7191cfdae61abdda42b83ba",
      "d7191cfdae61ffffbfabdda42b83ba",
      "d53e4ffc8d59fee08be6f59899d5943288bd",
      "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
      "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
      "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
      "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
      "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
    ).map(colors_default);
    Spectral_default = ramp_default(scheme9);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js
var scheme10, BuGn_default;
var init_BuGn = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js"() {
    init_colors();
    init_ramp();
    scheme10 = new Array(3).concat(
      "e5f5f999d8c92ca25f",
      "edf8fbb2e2e266c2a4238b45",
      "edf8fbb2e2e266c2a42ca25f006d2c",
      "edf8fbccece699d8c966c2a42ca25f006d2c",
      "edf8fbccece699d8c966c2a441ae76238b45005824",
      "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
      "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
    ).map(colors_default);
    BuGn_default = ramp_default(scheme10);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js
var scheme11, BuPu_default;
var init_BuPu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js"() {
    init_colors();
    init_ramp();
    scheme11 = new Array(3).concat(
      "e0ecf49ebcda8856a7",
      "edf8fbb3cde38c96c688419d",
      "edf8fbb3cde38c96c68856a7810f7c",
      "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
      "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
      "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
      "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
    ).map(colors_default);
    BuPu_default = ramp_default(scheme11);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js
var scheme12, GnBu_default;
var init_GnBu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js"() {
    init_colors();
    init_ramp();
    scheme12 = new Array(3).concat(
      "e0f3dba8ddb543a2ca",
      "f0f9e8bae4bc7bccc42b8cbe",
      "f0f9e8bae4bc7bccc443a2ca0868ac",
      "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
      "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
      "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
      "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
    ).map(colors_default);
    GnBu_default = ramp_default(scheme12);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js
var scheme13, OrRd_default;
var init_OrRd = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js"() {
    init_colors();
    init_ramp();
    scheme13 = new Array(3).concat(
      "fee8c8fdbb84e34a33",
      "fef0d9fdcc8afc8d59d7301f",
      "fef0d9fdcc8afc8d59e34a33b30000",
      "fef0d9fdd49efdbb84fc8d59e34a33b30000",
      "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
      "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
      "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
    ).map(colors_default);
    OrRd_default = ramp_default(scheme13);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js
var scheme14, PuBuGn_default;
var init_PuBuGn = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js"() {
    init_colors();
    init_ramp();
    scheme14 = new Array(3).concat(
      "ece2f0a6bddb1c9099",
      "f6eff7bdc9e167a9cf02818a",
      "f6eff7bdc9e167a9cf1c9099016c59",
      "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
      "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
      "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
      "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
    ).map(colors_default);
    PuBuGn_default = ramp_default(scheme14);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js
var scheme15, PuBu_default;
var init_PuBu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js"() {
    init_colors();
    init_ramp();
    scheme15 = new Array(3).concat(
      "ece7f2a6bddb2b8cbe",
      "f1eef6bdc9e174a9cf0570b0",
      "f1eef6bdc9e174a9cf2b8cbe045a8d",
      "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
      "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
      "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
      "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
    ).map(colors_default);
    PuBu_default = ramp_default(scheme15);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js
var scheme16, PuRd_default;
var init_PuRd = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js"() {
    init_colors();
    init_ramp();
    scheme16 = new Array(3).concat(
      "e7e1efc994c7dd1c77",
      "f1eef6d7b5d8df65b0ce1256",
      "f1eef6d7b5d8df65b0dd1c77980043",
      "f1eef6d4b9dac994c7df65b0dd1c77980043",
      "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
      "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
      "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
    ).map(colors_default);
    PuRd_default = ramp_default(scheme16);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js
var scheme17, RdPu_default;
var init_RdPu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js"() {
    init_colors();
    init_ramp();
    scheme17 = new Array(3).concat(
      "fde0ddfa9fb5c51b8a",
      "feebe2fbb4b9f768a1ae017e",
      "feebe2fbb4b9f768a1c51b8a7a0177",
      "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
      "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
      "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
      "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
    ).map(colors_default);
    RdPu_default = ramp_default(scheme17);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js
var scheme18, YlGnBu_default;
var init_YlGnBu = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js"() {
    init_colors();
    init_ramp();
    scheme18 = new Array(3).concat(
      "edf8b17fcdbb2c7fb8",
      "ffffcca1dab441b6c4225ea8",
      "ffffcca1dab441b6c42c7fb8253494",
      "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
      "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
      "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
      "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
    ).map(colors_default);
    YlGnBu_default = ramp_default(scheme18);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js
var scheme19, YlGn_default;
var init_YlGn = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js"() {
    init_colors();
    init_ramp();
    scheme19 = new Array(3).concat(
      "f7fcb9addd8e31a354",
      "ffffccc2e69978c679238443",
      "ffffccc2e69978c67931a354006837",
      "ffffccd9f0a3addd8e78c67931a354006837",
      "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
      "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
      "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
    ).map(colors_default);
    YlGn_default = ramp_default(scheme19);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js
var scheme20, YlOrBr_default;
var init_YlOrBr = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js"() {
    init_colors();
    init_ramp();
    scheme20 = new Array(3).concat(
      "fff7bcfec44fd95f0e",
      "ffffd4fed98efe9929cc4c02",
      "ffffd4fed98efe9929d95f0e993404",
      "ffffd4fee391fec44ffe9929d95f0e993404",
      "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
      "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
      "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
    ).map(colors_default);
    YlOrBr_default = ramp_default(scheme20);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js
var scheme21, YlOrRd_default;
var init_YlOrRd = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js"() {
    init_colors();
    init_ramp();
    scheme21 = new Array(3).concat(
      "ffeda0feb24cf03b20",
      "ffffb2fecc5cfd8d3ce31a1c",
      "ffffb2fecc5cfd8d3cf03b20bd0026",
      "ffffb2fed976feb24cfd8d3cf03b20bd0026",
      "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
      "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
      "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
    ).map(colors_default);
    YlOrRd_default = ramp_default(scheme21);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Blues.js
var scheme22, Blues_default;
var init_Blues = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Blues.js"() {
    init_colors();
    init_ramp();
    scheme22 = new Array(3).concat(
      "deebf79ecae13182bd",
      "eff3ffbdd7e76baed62171b5",
      "eff3ffbdd7e76baed63182bd08519c",
      "eff3ffc6dbef9ecae16baed63182bd08519c",
      "eff3ffc6dbef9ecae16baed64292c62171b5084594",
      "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
      "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
    ).map(colors_default);
    Blues_default = ramp_default(scheme22);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Greens.js
var scheme23, Greens_default;
var init_Greens = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Greens.js"() {
    init_colors();
    init_ramp();
    scheme23 = new Array(3).concat(
      "e5f5e0a1d99b31a354",
      "edf8e9bae4b374c476238b45",
      "edf8e9bae4b374c47631a354006d2c",
      "edf8e9c7e9c0a1d99b74c47631a354006d2c",
      "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
      "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
      "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
    ).map(colors_default);
    Greens_default = ramp_default(scheme23);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Greys.js
var scheme24, Greys_default;
var init_Greys = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Greys.js"() {
    init_colors();
    init_ramp();
    scheme24 = new Array(3).concat(
      "f0f0f0bdbdbd636363",
      "f7f7f7cccccc969696525252",
      "f7f7f7cccccc969696636363252525",
      "f7f7f7d9d9d9bdbdbd969696636363252525",
      "f7f7f7d9d9d9bdbdbd969696737373525252252525",
      "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
      "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
    ).map(colors_default);
    Greys_default = ramp_default(scheme24);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Purples.js
var scheme25, Purples_default;
var init_Purples = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Purples.js"() {
    init_colors();
    init_ramp();
    scheme25 = new Array(3).concat(
      "efedf5bcbddc756bb1",
      "f2f0f7cbc9e29e9ac86a51a3",
      "f2f0f7cbc9e29e9ac8756bb154278f",
      "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
      "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
      "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
      "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
    ).map(colors_default);
    Purples_default = ramp_default(scheme25);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Reds.js
var scheme26, Reds_default;
var init_Reds = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Reds.js"() {
    init_colors();
    init_ramp();
    scheme26 = new Array(3).concat(
      "fee0d2fc9272de2d26",
      "fee5d9fcae91fb6a4acb181d",
      "fee5d9fcae91fb6a4ade2d26a50f15",
      "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
      "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
      "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
      "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
    ).map(colors_default);
    Reds_default = ramp_default(scheme26);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js
var scheme27, Oranges_default;
var init_Oranges = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js"() {
    init_colors();
    init_ramp();
    scheme27 = new Array(3).concat(
      "fee6cefdae6be6550d",
      "feeddefdbe85fd8d3cd94701",
      "feeddefdbe85fd8d3ce6550da63603",
      "feeddefdd0a2fdae6bfd8d3ce6550da63603",
      "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
      "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
      "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
    ).map(colors_default);
    Oranges_default = ramp_default(scheme27);
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/cividis.js
function cividis_default(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}
var init_cividis = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/cividis.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js
var cubehelix_default2;
var init_cubehelix3 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js"() {
    init_src7();
    init_src8();
    cubehelix_default2 = cubehelixLong(cubehelix(300, 0.5, 0), cubehelix(-240, 0.5, 1));
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js
function rainbow_default(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c3.h = 360 * t - 100;
  c3.s = 1.5 - 1.5 * ts;
  c3.l = 0.8 - 0.9 * ts;
  return c3 + "";
}
var warm, cool, c3;
var init_rainbow = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js"() {
    init_src7();
    init_src8();
    warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.5, 0.8));
    cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.5, 0.8));
    c3 = cubehelix();
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js
function sinebow_default(t) {
  var x4;
  t = (0.5 - t) * Math.PI;
  c4.r = 255 * (x4 = Math.sin(t)) * x4;
  c4.g = 255 * (x4 = Math.sin(t + pi_1_3)) * x4;
  c4.b = 255 * (x4 = Math.sin(t + pi_2_3)) * x4;
  return c4 + "";
}
var c4, pi_1_3, pi_2_3;
var init_sinebow = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js"() {
    init_src7();
    c4 = rgb();
    pi_1_3 = Math.PI / 3;
    pi_2_3 = Math.PI * 2 / 3;
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/turbo.js
function turbo_default(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}
var init_turbo = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/turbo.js"() {
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js
function ramp(range4) {
  var n = range4.length;
  return function(t) {
    return range4[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}
var viridis_default, magma, inferno, plasma;
var init_viridis = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js"() {
    init_colors();
    viridis_default = ramp(colors_default("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
    magma = ramp(colors_default("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
    inferno = ramp(colors_default("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
    plasma = ramp(colors_default("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
  }
});

// ../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/index.js
var init_src29 = __esm({
  "../node_modules/.pnpm/d3-scale-chromatic@3.1.0/node_modules/d3-scale-chromatic/src/index.js"() {
    init_category10();
    init_Accent();
    init_Dark2();
    init_observable10();
    init_Paired();
    init_Pastel1();
    init_Pastel2();
    init_Set1();
    init_Set2();
    init_Set3();
    init_Tableau10();
    init_BrBG();
    init_PRGn();
    init_PiYG();
    init_PuOr();
    init_RdBu();
    init_RdGy();
    init_RdYlBu();
    init_RdYlGn();
    init_Spectral();
    init_BuGn();
    init_BuPu();
    init_GnBu();
    init_OrRd();
    init_PuBuGn();
    init_PuBu();
    init_PuRd();
    init_RdPu();
    init_YlGnBu();
    init_YlGn();
    init_YlOrBr();
    init_YlOrRd();
    init_Blues();
    init_Greens();
    init_Greys();
    init_Purples();
    init_Reds();
    init_Oranges();
    init_cividis();
    init_cubehelix3();
    init_rainbow();
    init_sinebow();
    init_turbo();
    init_viridis();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js
function constant_default10(x4) {
  return function constant2() {
    return x4;
  };
}
var init_constant12 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js
function acos2(x4) {
  return x4 > 1 ? 0 : x4 < -1 ? pi5 : Math.acos(x4);
}
function asin2(x4) {
  return x4 >= 1 ? halfPi4 : x4 <= -1 ? -halfPi4 : Math.asin(x4);
}
var abs4, atan22, cos3, max4, min3, sin3, sqrt3, epsilon8, pi5, halfPi4, tau6;
var init_math5 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js"() {
    abs4 = Math.abs;
    atan22 = Math.atan2;
    cos3 = Math.cos;
    max4 = Math.max;
    min3 = Math.min;
    sin3 = Math.sin;
    sqrt3 = Math.sqrt;
    epsilon8 = 1e-12;
    pi5 = Math.PI;
    halfPi4 = pi5 / 2;
    tau6 = 2 * pi5;
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path(digits);
}
var init_path5 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js"() {
    init_src13();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/arc.js
function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle;
}
function intersect(x06, y06, x12, y12, x22, y22, x32, y32) {
  var x10 = x12 - x06, y10 = y12 - y06, x322 = x32 - x22, y322 = y32 - y22, t = y322 * x10 - x322 * y10;
  if (t * t < epsilon8) return;
  t = (x322 * (y06 - y22) - y322 * (x06 - x22)) / t;
  return [x06 + t * x10, y06 + t * y10];
}
function cornerTangents(x06, y06, x12, y12, r1, rc, cw) {
  var x01 = x06 - x12, y01 = y06 - y12, lo = (cw ? rc : -rc) / sqrt3(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x06 + ox, y11 = y06 + oy, x10 = x12 + ox, y10 = y12 + oy, x004 = (x11 + x10) / 2, y004 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D3 = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt3(max4(0, r * r * d2 - D3 * D3)), cx0 = (D3 * dy - dx * d) / d2, cy0 = (-D3 * dx - dy * d) / d2, cx1 = (D3 * dy + dx * d) / d2, cy1 = (-D3 * dx + dy * d) / d2, dx0 = cx0 - x004, dy0 = cy0 - y004, dx1 = cx1 - x004, dy1 = cy1 - y004;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc_default() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant_default10(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path2 = withPath(arc);
  function arc() {
    var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi4, a1 = endAngle.apply(this, arguments) - halfPi4, da2 = abs4(a1 - a0), cw = a1 > a0;
    if (!context) context = buffer = path2();
    if (r1 < r0) r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon8)) context.moveTo(0, 0);
    else if (da2 > tau6 - epsilon8) {
      context.moveTo(r1 * cos3(a0), r1 * sin3(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon8) {
        context.moveTo(r0 * cos3(a1), r0 * sin3(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da2, da1 = da2, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon8 && (padRadius ? +padRadius.apply(this, arguments) : sqrt3(r0 * r0 + r1 * r1)), rc = min3(abs4(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t03, t13;
      if (rp > epsilon8) {
        var p02 = asin2(rp / r0 * sin3(ap)), p1 = asin2(rp / r1 * sin3(ap));
        if ((da0 -= p02 * 2) > epsilon8) p02 *= cw ? 1 : -1, a00 += p02, a10 -= p02;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon8) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos3(a01), y01 = r1 * sin3(a01), x10 = r0 * cos3(a10), y10 = r0 * sin3(a10);
      if (rc > epsilon8) {
        var x11 = r1 * cos3(a11), y11 = r1 * sin3(a11), x004 = r0 * cos3(a00), y004 = r0 * sin3(a00), oc;
        if (da2 < pi5) {
          if (oc = intersect(x01, y01, x004, y004, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin3(acos2((ax * bx + ay * by) / (sqrt3(ax * ax + ay * ay) * sqrt3(bx * bx + by * by))) / 2), lc = sqrt3(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min3(rc, (r0 - lc) / (kc - 1));
            rc1 = min3(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon8)) context.moveTo(x01, y01);
      else if (rc1 > epsilon8) {
        t03 = cornerTangents(x004, y004, x01, y01, r1, rc1, cw);
        t13 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t03.cx + t03.x01, t03.cy + t03.y01);
        if (rc1 < rc) context.arc(t03.cx, t03.cy, rc1, atan22(t03.y01, t03.x01), atan22(t13.y01, t13.x01), !cw);
        else {
          context.arc(t03.cx, t03.cy, rc1, atan22(t03.y01, t03.x01), atan22(t03.y11, t03.x11), !cw);
          context.arc(0, 0, r1, atan22(t03.cy + t03.y11, t03.cx + t03.x11), atan22(t13.cy + t13.y11, t13.cx + t13.x11), !cw);
          context.arc(t13.cx, t13.cy, rc1, atan22(t13.y11, t13.x11), atan22(t13.y01, t13.x01), !cw);
        }
      } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon8) || !(da0 > epsilon8)) context.lineTo(x10, y10);
      else if (rc0 > epsilon8) {
        t03 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t13 = cornerTangents(x01, y01, x004, y004, r0, -rc0, cw);
        context.lineTo(t03.cx + t03.x01, t03.cy + t03.y01);
        if (rc0 < rc) context.arc(t03.cx, t03.cy, rc0, atan22(t03.y01, t03.x01), atan22(t13.y01, t13.x01), !cw);
        else {
          context.arc(t03.cx, t03.cy, rc0, atan22(t03.y01, t03.x01), atan22(t03.y11, t03.x11), !cw);
          context.arc(0, 0, r0, atan22(t03.cy + t03.y11, t03.cx + t03.x11), atan22(t13.cy + t13.y11, t13.cx + t13.x11), cw);
          context.arc(t13.cx, t13.cy, rc0, atan22(t13.y11, t13.x11), atan22(t13.y01, t13.x01), !cw);
        }
      } else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a4 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi5 / 2;
    return [cos3(a4) * r, sin3(a4) * r];
  };
  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant_default10(+_), arc) : innerRadius;
  };
  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant_default10(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant_default10(+_), arc) : cornerRadius;
  };
  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant_default10(+_), arc) : padRadius;
  };
  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant_default10(+_), arc) : startAngle;
  };
  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant_default10(+_), arc) : endAngle;
  };
  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant_default10(+_), arc) : padAngle;
  };
  arc.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };
  return arc;
}
var init_arc = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/arc.js"() {
    init_constant12();
    init_math5();
    init_path5();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/array.js
function array_default3(x4) {
  return typeof x4 === "object" && "length" in x4 ? x4 : Array.from(x4);
}
var slice4;
var init_array7 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/array.js"() {
    slice4 = Array.prototype.slice;
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}
function linear_default(context) {
  return new Linear(context);
}
var init_linear3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linear.js"() {
    Linear.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._point = 0;
      },
      lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
          // falls through
          default:
            this._context.lineTo(x4, y4);
            break;
        }
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/point.js
function x3(p) {
  return p[0];
}
function y3(p) {
  return p[1];
}
var init_point = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/point.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/line.js
function line_default2(x4, y4) {
  var defined = constant_default10(true), context = null, curve = linear_default, output = null, path2 = withPath(line);
  x4 = typeof x4 === "function" ? x4 : x4 === void 0 ? x3 : constant_default10(x4);
  y4 = typeof y4 === "function" ? y4 : y4 === void 0 ? y3 : constant_default10(y4);
  function line(data) {
    var i, n = (data = array_default3(data)).length, d, defined0 = false, buffer;
    if (context == null) output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x4(d, i, data), +y4(d, i, data));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line.x = function(_) {
    return arguments.length ? (x4 = typeof _ === "function" ? _ : constant_default10(+_), line) : x4;
  };
  line.y = function(_) {
    return arguments.length ? (y4 = typeof _ === "function" ? _ : constant_default10(+_), line) : y4;
  };
  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant_default10(!!_), line) : defined;
  };
  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };
  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };
  return line;
}
var init_line2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/line.js"() {
    init_array7();
    init_constant12();
    init_linear3();
    init_path5();
    init_point();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/area.js
function area_default5(x06, y06, y12) {
  var x12 = null, defined = constant_default10(true), context = null, curve = linear_default, output = null, path2 = withPath(area);
  x06 = typeof x06 === "function" ? x06 : x06 === void 0 ? x3 : constant_default10(+x06);
  y06 = typeof y06 === "function" ? y06 : y06 === void 0 ? constant_default10(0) : constant_default10(+y06);
  y12 = typeof y12 === "function" ? y12 : y12 === void 0 ? y3 : constant_default10(+y12);
  function area(data) {
    var i, j, k2, n = (data = array_default3(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
    if (context == null) output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i - 1; k2 >= j; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x06(d, i, data), y0z[i] = +y06(d, i, data);
        output.point(x12 ? +x12(d, i, data) : x0z[i], y12 ? +y12(d, i, data) : y0z[i]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return line_default2().defined(defined).curve(curve).context(context);
  }
  area.x = function(_) {
    return arguments.length ? (x06 = typeof _ === "function" ? _ : constant_default10(+_), x12 = null, area) : x06;
  };
  area.x0 = function(_) {
    return arguments.length ? (x06 = typeof _ === "function" ? _ : constant_default10(+_), area) : x06;
  };
  area.x1 = function(_) {
    return arguments.length ? (x12 = _ == null ? null : typeof _ === "function" ? _ : constant_default10(+_), area) : x12;
  };
  area.y = function(_) {
    return arguments.length ? (y06 = typeof _ === "function" ? _ : constant_default10(+_), y12 = null, area) : y06;
  };
  area.y0 = function(_) {
    return arguments.length ? (y06 = typeof _ === "function" ? _ : constant_default10(+_), area) : y06;
  };
  area.y1 = function(_) {
    return arguments.length ? (y12 = _ == null ? null : typeof _ === "function" ? _ : constant_default10(+_), area) : y12;
  };
  area.lineX0 = area.lineY0 = function() {
    return arealine().x(x06).y(y06);
  };
  area.lineY1 = function() {
    return arealine().x(x06).y(y12);
  };
  area.lineX1 = function() {
    return arealine().x(x12).y(y06);
  };
  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant_default10(!!_), area) : defined;
  };
  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}
var init_area5 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/area.js"() {
    init_array7();
    init_constant12();
    init_linear3();
    init_line2();
    init_path5();
    init_point();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/descending.js
function descending_default(a4, b) {
  return b < a4 ? -1 : b > a4 ? 1 : b >= a4 ? 0 : NaN;
}
var init_descending2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/descending.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/identity.js
function identity_default5(d) {
  return d;
}
var init_identity7 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/identity.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pie.js
function pie_default() {
  var value = identity_default5, sortValues = descending_default, sort2 = null, startAngle = constant_default10(0), endAngle = constant_default10(tau6), padAngle = constant_default10(0);
  function pie(data) {
    var i, n = (data = array_default3(data)).length, j, k2, sum4 = 0, index3 = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da2 = Math.min(tau6, Math.max(-tau6, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da2) / n, padAngle.apply(this, arguments)), pa = p * (da2 < 0 ? -1 : 1), v2;
    for (i = 0; i < n; ++i) {
      if ((v2 = arcs[index3[i] = i] = +value(data[i], i, data)) > 0) {
        sum4 += v2;
      }
    }
    if (sortValues != null) index3.sort(function(i2, j2) {
      return sortValues(arcs[i2], arcs[j2]);
    });
    else if (sort2 != null) index3.sort(function(i2, j2) {
      return sort2(data[i2], data[j2]);
    });
    for (i = 0, k2 = sum4 ? (da2 - n * pa) / sum4 : 0; i < n; ++i, a0 = a1) {
      j = index3[i], v2 = arcs[j], a1 = a0 + (v2 > 0 ? v2 * k2 : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v2,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }
    return arcs;
  }
  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant_default10(+_), pie) : value;
  };
  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort2 = null, pie) : sortValues;
  };
  pie.sort = function(_) {
    return arguments.length ? (sort2 = _, sortValues = null, pie) : sort2;
  };
  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant_default10(+_), pie) : startAngle;
  };
  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant_default10(+_), pie) : endAngle;
  };
  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant_default10(+_), pie) : padAngle;
  };
  return pie;
}
var init_pie = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pie.js"() {
    init_array7();
    init_constant12();
    init_descending2();
    init_identity7();
    init_math5();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/radial.js
function Radial(curve) {
  this._curve = curve;
}
function curveRadial(curve) {
  function radial2(context) {
    return new Radial(curve(context));
  }
  radial2._curve = curve;
  return radial2;
}
var curveRadialLinear;
var init_radial3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/radial.js"() {
    init_linear3();
    curveRadialLinear = curveRadial(linear_default);
    Radial.prototype = {
      areaStart: function() {
        this._curve.areaStart();
      },
      areaEnd: function() {
        this._curve.areaEnd();
      },
      lineStart: function() {
        this._curve.lineStart();
      },
      lineEnd: function() {
        this._curve.lineEnd();
      },
      point: function(a4, r) {
        this._curve.point(r * Math.sin(a4), r * -Math.cos(a4));
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/lineRadial.js
function lineRadial(l) {
  var c6 = l.curve;
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  l.curve = function(_) {
    return arguments.length ? c6(curveRadial(_)) : c6()._curve;
  };
  return l;
}
function lineRadial_default() {
  return lineRadial(line_default2().curve(curveRadialLinear));
}
var init_lineRadial = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/lineRadial.js"() {
    init_radial3();
    init_line2();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/areaRadial.js
function areaRadial_default() {
  var a4 = area_default5().curve(curveRadialLinear), c6 = a4.curve, x06 = a4.lineX0, x12 = a4.lineX1, y06 = a4.lineY0, y12 = a4.lineY1;
  a4.angle = a4.x, delete a4.x;
  a4.startAngle = a4.x0, delete a4.x0;
  a4.endAngle = a4.x1, delete a4.x1;
  a4.radius = a4.y, delete a4.y;
  a4.innerRadius = a4.y0, delete a4.y0;
  a4.outerRadius = a4.y1, delete a4.y1;
  a4.lineStartAngle = function() {
    return lineRadial(x06());
  }, delete a4.lineX0;
  a4.lineEndAngle = function() {
    return lineRadial(x12());
  }, delete a4.lineX1;
  a4.lineInnerRadius = function() {
    return lineRadial(y06());
  }, delete a4.lineY0;
  a4.lineOuterRadius = function() {
    return lineRadial(y12());
  }, delete a4.lineY1;
  a4.curve = function(_) {
    return arguments.length ? c6(curveRadial(_)) : c6()._curve;
  };
  return a4;
}
var init_areaRadial = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/areaRadial.js"() {
    init_radial3();
    init_area5();
    init_lineRadial();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pointRadial.js
function pointRadial_default(x4, y4) {
  return [(y4 = +y4) * Math.cos(x4 -= Math.PI / 2), y4 * Math.sin(x4)];
}
var init_pointRadial = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pointRadial.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/bump.js
function bumpX(context) {
  return new Bump(context, true);
}
function bumpY(context) {
  return new Bump(context, false);
}
function bumpRadial(context) {
  return new BumpRadial(context);
}
var Bump, BumpRadial;
var init_bump = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/bump.js"() {
    init_pointRadial();
    Bump = class {
      constructor(context, x4) {
        this._context = context;
        this._x = x4;
      }
      areaStart() {
        this._line = 0;
      }
      areaEnd() {
        this._line = NaN;
      }
      lineStart() {
        this._point = 0;
      }
      lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      }
      point(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0: {
            this._point = 1;
            if (this._line) this._context.lineTo(x4, y4);
            else this._context.moveTo(x4, y4);
            break;
          }
          case 1:
            this._point = 2;
          // falls through
          default: {
            if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x4) / 2, this._y0, this._x0, y4, x4, y4);
            else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y4) / 2, x4, this._y0, x4, y4);
            break;
          }
        }
        this._x0 = x4, this._y0 = y4;
      }
    };
    BumpRadial = class {
      constructor(context) {
        this._context = context;
      }
      lineStart() {
        this._point = 0;
      }
      lineEnd() {
      }
      point(x4, y4) {
        x4 = +x4, y4 = +y4;
        if (this._point === 0) {
          this._point = 1;
        } else {
          const p02 = pointRadial_default(this._x0, this._y0);
          const p1 = pointRadial_default(this._x0, this._y0 = (this._y0 + y4) / 2);
          const p2 = pointRadial_default(x4, this._y0);
          const p3 = pointRadial_default(x4, y4);
          this._context.moveTo(...p02);
          this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x4, this._y0 = y4;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/link.js
function linkSource(d) {
  return d.source;
}
function linkTarget(d) {
  return d.target;
}
function link2(curve) {
  let source = linkSource, target = linkTarget, x4 = x3, y4 = y3, context = null, output = null, path2 = withPath(link3);
  function link3() {
    let buffer;
    const argv = slice4.call(arguments);
    const s2 = source.apply(this, argv);
    const t = target.apply(this, argv);
    if (context == null) output = curve(buffer = path2());
    output.lineStart();
    argv[0] = s2, output.point(+x4.apply(this, argv), +y4.apply(this, argv));
    argv[0] = t, output.point(+x4.apply(this, argv), +y4.apply(this, argv));
    output.lineEnd();
    if (buffer) return output = null, buffer + "" || null;
  }
  link3.source = function(_) {
    return arguments.length ? (source = _, link3) : source;
  };
  link3.target = function(_) {
    return arguments.length ? (target = _, link3) : target;
  };
  link3.x = function(_) {
    return arguments.length ? (x4 = typeof _ === "function" ? _ : constant_default10(+_), link3) : x4;
  };
  link3.y = function(_) {
    return arguments.length ? (y4 = typeof _ === "function" ? _ : constant_default10(+_), link3) : y4;
  };
  link3.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link3) : context;
  };
  return link3;
}
function linkHorizontal() {
  return link2(bumpX);
}
function linkVertical() {
  return link2(bumpY);
}
function linkRadial() {
  const l = link2(bumpRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}
var init_link2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/link.js"() {
    init_array7();
    init_constant12();
    init_bump();
    init_path5();
    init_point();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/asterisk.js
var sqrt32, asterisk_default;
var init_asterisk = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/asterisk.js"() {
    init_math5();
    sqrt32 = sqrt3(3);
    asterisk_default = {
      draw(context, size) {
        const r = sqrt3(size + min3(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u4 = t * sqrt32;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u4, -t);
        context.lineTo(u4, t);
        context.moveTo(-u4, t);
        context.lineTo(u4, -t);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/circle.js
var circle_default3;
var init_circle4 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/circle.js"() {
    init_math5();
    circle_default3 = {
      draw(context, size) {
        const r = sqrt3(size / pi5);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, tau6);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/cross.js
var cross_default2;
var init_cross3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/cross.js"() {
    init_math5();
    cross_default2 = {
      draw(context, size) {
        const r = sqrt3(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/diamond.js
var tan30, tan30_2, diamond_default;
var init_diamond = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/diamond.js"() {
    init_math5();
    tan30 = sqrt3(1 / 3);
    tan30_2 = tan30 * 2;
    diamond_default = {
      draw(context, size) {
        const y4 = sqrt3(size / tan30_2);
        const x4 = y4 * tan30;
        context.moveTo(0, -y4);
        context.lineTo(x4, 0);
        context.lineTo(0, y4);
        context.lineTo(-x4, 0);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/diamond2.js
var diamond2_default;
var init_diamond2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/diamond2.js"() {
    init_math5();
    diamond2_default = {
      draw(context, size) {
        const r = sqrt3(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/plus.js
var plus_default;
var init_plus = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/plus.js"() {
    init_math5();
    plus_default = {
      draw(context, size) {
        const r = sqrt3(size - min3(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/square.js
var square_default;
var init_square = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/square.js"() {
    init_math5();
    square_default = {
      draw(context, size) {
        const w = sqrt3(size);
        const x4 = -w / 2;
        context.rect(x4, x4, w, w);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/square2.js
var square2_default;
var init_square2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/square2.js"() {
    init_math5();
    square2_default = {
      draw(context, size) {
        const r = sqrt3(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/star.js
var ka, kr, kx, ky, star_default;
var init_star = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/star.js"() {
    init_math5();
    ka = 0.8908130915292852;
    kr = sin3(pi5 / 10) / sin3(7 * pi5 / 10);
    kx = sin3(tau6 / 10) * kr;
    ky = -cos3(tau6 / 10) * kr;
    star_default = {
      draw(context, size) {
        const r = sqrt3(size * ka);
        const x4 = kx * r;
        const y4 = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x4, y4);
        for (let i = 1; i < 5; ++i) {
          const a4 = tau6 * i / 5;
          const c6 = cos3(a4);
          const s2 = sin3(a4);
          context.lineTo(s2 * r, -c6 * r);
          context.lineTo(c6 * x4 - s2 * y4, s2 * x4 + c6 * y4);
        }
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/triangle.js
var sqrt33, triangle_default;
var init_triangle = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/triangle.js"() {
    init_math5();
    sqrt33 = sqrt3(3);
    triangle_default = {
      draw(context, size) {
        const y4 = -sqrt3(size / (sqrt33 * 3));
        context.moveTo(0, y4 * 2);
        context.lineTo(-sqrt33 * y4, -y4);
        context.lineTo(sqrt33 * y4, -y4);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/triangle2.js
var sqrt34, triangle2_default;
var init_triangle2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/triangle2.js"() {
    init_math5();
    sqrt34 = sqrt3(3);
    triangle2_default = {
      draw(context, size) {
        const s2 = sqrt3(size) * 0.6824;
        const t = s2 / 2;
        const u4 = s2 * sqrt34 / 2;
        context.moveTo(0, -s2);
        context.lineTo(u4, t);
        context.lineTo(-u4, t);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/wye.js
var c5, s, k, a3, wye_default;
var init_wye = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/wye.js"() {
    init_math5();
    c5 = -0.5;
    s = sqrt3(3) / 2;
    k = 1 / sqrt3(12);
    a3 = (k / 2 + 1) * 3;
    wye_default = {
      draw(context, size) {
        const r = sqrt3(size / a3);
        const x06 = r / 2, y06 = r * k;
        const x12 = x06, y12 = r * k + r;
        const x22 = -x12, y22 = y12;
        context.moveTo(x06, y06);
        context.lineTo(x12, y12);
        context.lineTo(x22, y22);
        context.lineTo(c5 * x06 - s * y06, s * x06 + c5 * y06);
        context.lineTo(c5 * x12 - s * y12, s * x12 + c5 * y12);
        context.lineTo(c5 * x22 - s * y22, s * x22 + c5 * y22);
        context.lineTo(c5 * x06 + s * y06, c5 * y06 - s * x06);
        context.lineTo(c5 * x12 + s * y12, c5 * y12 - s * x12);
        context.lineTo(c5 * x22 + s * y22, c5 * y22 - s * x22);
        context.closePath();
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/times.js
var times_default;
var init_times = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/times.js"() {
    init_math5();
    times_default = {
      draw(context, size) {
        const r = sqrt3(size - min3(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol.js
function Symbol2(type2, size) {
  let context = null, path2 = withPath(symbol);
  type2 = typeof type2 === "function" ? type2 : constant_default10(type2 || circle_default3);
  size = typeof size === "function" ? size : constant_default10(size === void 0 ? 64 : +size);
  function symbol() {
    let buffer;
    if (!context) context = buffer = path2();
    type2.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }
  symbol.type = function(_) {
    return arguments.length ? (type2 = typeof _ === "function" ? _ : constant_default10(_), symbol) : type2;
  };
  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant_default10(+_), symbol) : size;
  };
  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };
  return symbol;
}
var symbolsFill, symbolsStroke;
var init_symbol = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol.js"() {
    init_constant12();
    init_path5();
    init_asterisk();
    init_circle4();
    init_cross3();
    init_diamond();
    init_diamond2();
    init_plus();
    init_square();
    init_square2();
    init_star();
    init_triangle();
    init_triangle2();
    init_wye();
    init_times();
    symbolsFill = [
      circle_default3,
      cross_default2,
      diamond_default,
      square_default,
      star_default,
      triangle_default,
      wye_default
    ];
    symbolsStroke = [
      circle_default3,
      plus_default,
      times_default,
      triangle2_default,
      asterisk_default,
      square2_default,
      diamond2_default
    ];
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/noop.js
function noop_default2() {
}
var init_noop3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/noop.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basis.js
function point2(that, x4, y4) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x4) / 6,
    (that._y0 + 4 * that._y1 + y4) / 6
  );
}
function Basis(context) {
  this._context = context;
}
function basis_default2(context) {
  return new Basis(context);
}
var init_basis2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basis.js"() {
    Basis.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 3:
            point2(this, this._x1, this._y1);
          // falls through
          case 2:
            this._context.lineTo(this._x1, this._y1);
            break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
            this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
          // falls through
          default:
            point2(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = x4;
        this._y0 = this._y1, this._y1 = y4;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisClosed.js
function BasisClosed(context) {
  this._context = context;
}
function basisClosed_default2(context) {
  return new BasisClosed(context);
}
var init_basisClosed2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisClosed.js"() {
    init_noop3();
    init_basis2();
    BasisClosed.prototype = {
      areaStart: noop_default2,
      areaEnd: noop_default2,
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 1: {
            this._context.moveTo(this._x2, this._y2);
            this._context.closePath();
            break;
          }
          case 2: {
            this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
            this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
            this._context.closePath();
            break;
          }
          case 3: {
            this.point(this._x2, this._y2);
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            break;
          }
        }
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._x2 = x4, this._y2 = y4;
            break;
          case 1:
            this._point = 2;
            this._x3 = x4, this._y3 = y4;
            break;
          case 2:
            this._point = 3;
            this._x4 = x4, this._y4 = y4;
            this._context.moveTo((this._x0 + 4 * this._x1 + x4) / 6, (this._y0 + 4 * this._y1 + y4) / 6);
            break;
          default:
            point2(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = x4;
        this._y0 = this._y1, this._y1 = y4;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisOpen.js
function BasisOpen(context) {
  this._context = context;
}
function basisOpen_default(context) {
  return new BasisOpen(context);
}
var init_basisOpen = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisOpen.js"() {
    init_basis2();
    BasisOpen.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
            var x06 = (this._x0 + 4 * this._x1 + x4) / 6, y06 = (this._y0 + 4 * this._y1 + y4) / 6;
            this._line ? this._context.lineTo(x06, y06) : this._context.moveTo(x06, y06);
            break;
          case 3:
            this._point = 4;
          // falls through
          default:
            point2(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = x4;
        this._y0 = this._y1, this._y1 = y4;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/bundle.js
function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}
var bundle_default;
var init_bundle = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/bundle.js"() {
    init_basis2();
    Bundle.prototype = {
      lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
      },
      lineEnd: function() {
        var x4 = this._x, y4 = this._y, j = x4.length - 1;
        if (j > 0) {
          var x06 = x4[0], y06 = y4[0], dx = x4[j] - x06, dy = y4[j] - y06, i = -1, t;
          while (++i <= j) {
            t = i / j;
            this._basis.point(
              this._beta * x4[i] + (1 - this._beta) * (x06 + t * dx),
              this._beta * y4[i] + (1 - this._beta) * (y06 + t * dy)
            );
          }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
      },
      point: function(x4, y4) {
        this._x.push(+x4);
        this._y.push(+y4);
      }
    };
    bundle_default = (function custom12(beta) {
      function bundle(context) {
        return beta === 1 ? new Basis(context) : new Bundle(context, beta);
      }
      bundle.beta = function(beta2) {
        return custom12(+beta2);
      };
      return bundle;
    })(0.85);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinal.js
function point3(that, x4, y4) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x4),
    that._y2 + that._k * (that._y1 - y4),
    that._x2,
    that._y2
  );
}
function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
var cardinal_default;
var init_cardinal = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinal.js"() {
    Cardinal.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);
            break;
          case 3:
            point3(this, this._x1, this._y1);
            break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
            this._x1 = x4, this._y1 = y4;
            break;
          case 2:
            this._point = 3;
          // falls through
          default:
            point3(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    cardinal_default = (function custom13(tension) {
      function cardinal(context) {
        return new Cardinal(context, tension);
      }
      cardinal.tension = function(tension2) {
        return custom13(+tension2);
      };
      return cardinal;
    })(0);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinalClosed.js
function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
var cardinalClosed_default;
var init_cardinalClosed = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinalClosed.js"() {
    init_noop3();
    init_cardinal();
    CardinalClosed.prototype = {
      areaStart: noop_default2,
      areaEnd: noop_default2,
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 1: {
            this._context.moveTo(this._x3, this._y3);
            this._context.closePath();
            break;
          }
          case 2: {
            this._context.lineTo(this._x3, this._y3);
            this._context.closePath();
            break;
          }
          case 3: {
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            this.point(this._x5, this._y5);
            break;
          }
        }
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._x3 = x4, this._y3 = y4;
            break;
          case 1:
            this._point = 2;
            this._context.moveTo(this._x4 = x4, this._y4 = y4);
            break;
          case 2:
            this._point = 3;
            this._x5 = x4, this._y5 = y4;
            break;
          default:
            point3(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    cardinalClosed_default = (function custom14(tension) {
      function cardinal(context) {
        return new CardinalClosed(context, tension);
      }
      cardinal.tension = function(tension2) {
        return custom14(+tension2);
      };
      return cardinal;
    })(0);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinalOpen.js
function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
var cardinalOpen_default;
var init_cardinalOpen = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/cardinalOpen.js"() {
    init_cardinal();
    CardinalOpen.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
            this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;
          case 3:
            this._point = 4;
          // falls through
          default:
            point3(this, x4, y4);
            break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    cardinalOpen_default = (function custom15(tension) {
      function cardinal(context) {
        return new CardinalOpen(context, tension);
      }
      cardinal.tension = function(tension2) {
        return custom15(+tension2);
      };
      return cardinal;
    })(0);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRom.js
function point4(that, x4, y4) {
  var x12 = that._x1, y12 = that._y1, x22 = that._x2, y22 = that._y2;
  if (that._l01_a > epsilon8) {
    var a4 = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x12 = (x12 * a4 - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y12 = (y12 * a4 - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }
  if (that._l23_a > epsilon8) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m3 = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x22 = (x22 * b + that._x1 * that._l23_2a - x4 * that._l12_2a) / m3;
    y22 = (y22 * b + that._y1 * that._l23_2a - y4 * that._l12_2a) / m3;
  }
  that._context.bezierCurveTo(x12, y12, x22, y22, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
var catmullRom_default;
var init_catmullRom = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRom.js"() {
    init_math5();
    init_cardinal();
    CatmullRom.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);
            break;
          case 3:
            this.point(this._x2, this._y2);
            break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        if (this._point) {
          var x23 = this._x2 - x4, y23 = this._y2 - y4;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
          // falls through
          default:
            point4(this, x4, y4);
            break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    catmullRom_default = (function custom16(alpha) {
      function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
      }
      catmullRom.alpha = function(alpha2) {
        return custom16(+alpha2);
      };
      return catmullRom;
    })(0.5);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRomClosed.js
function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
var catmullRomClosed_default;
var init_catmullRomClosed = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRomClosed.js"() {
    init_cardinalClosed();
    init_noop3();
    init_catmullRom();
    CatmullRomClosed.prototype = {
      areaStart: noop_default2,
      areaEnd: noop_default2,
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 1: {
            this._context.moveTo(this._x3, this._y3);
            this._context.closePath();
            break;
          }
          case 2: {
            this._context.lineTo(this._x3, this._y3);
            this._context.closePath();
            break;
          }
          case 3: {
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            this.point(this._x5, this._y5);
            break;
          }
        }
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        if (this._point) {
          var x23 = this._x2 - x4, y23 = this._y2 - y4;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch (this._point) {
          case 0:
            this._point = 1;
            this._x3 = x4, this._y3 = y4;
            break;
          case 1:
            this._point = 2;
            this._context.moveTo(this._x4 = x4, this._y4 = y4);
            break;
          case 2:
            this._point = 3;
            this._x5 = x4, this._y5 = y4;
            break;
          default:
            point4(this, x4, y4);
            break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    catmullRomClosed_default = (function custom17(alpha) {
      function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
      }
      catmullRom.alpha = function(alpha2) {
        return custom17(+alpha2);
      };
      return catmullRom;
    })(0.5);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRomOpen.js
function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
var catmullRomOpen_default;
var init_catmullRomOpen = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/catmullRomOpen.js"() {
    init_cardinalOpen();
    init_catmullRom();
    CatmullRomOpen.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        if (this._point) {
          var x23 = this._x2 - x4, y23 = this._y2 - y4;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch (this._point) {
          case 0:
            this._point = 1;
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
            this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;
          case 3:
            this._point = 4;
          // falls through
          default:
            point4(this, x4, y4);
            break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x4;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
      }
    };
    catmullRomOpen_default = (function custom18(alpha) {
      function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
      }
      catmullRom.alpha = function(alpha2) {
        return custom18(+alpha2);
      };
      return catmullRom;
    })(0.5);
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linearClosed.js
function LinearClosed(context) {
  this._context = context;
}
function linearClosed_default(context) {
  return new LinearClosed(context);
}
var init_linearClosed = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linearClosed.js"() {
    init_noop3();
    LinearClosed.prototype = {
      areaStart: noop_default2,
      areaEnd: noop_default2,
      lineStart: function() {
        this._point = 0;
      },
      lineEnd: function() {
        if (this._point) this._context.closePath();
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        if (this._point) this._context.lineTo(x4, y4);
        else this._point = 1, this._context.moveTo(x4, y4);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/monotone.js
function sign2(x4) {
  return x4 < 0 ? -1 : 1;
}
function slope3(that, x22, y22) {
  var h0 = that._x1 - that._x0, h1 = x22 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y22 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign2(s0) + sign2(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
function point5(that, t03, t13) {
  var x06 = that._x0, y06 = that._y0, x12 = that._x1, y12 = that._y1, dx = (x12 - x06) / 3;
  that._context.bezierCurveTo(x06 + dx, y06 + dx * t03, x12 - dx, y12 - dx * t13, x12, y12);
}
function MonotoneX(context) {
  this._context = context;
}
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
function ReflectContext(context) {
  this._context = context;
}
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
var init_monotone = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/monotone.js"() {
    MonotoneX.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x1, this._y1);
            break;
          case 3:
            point5(this, this._t0, slope2(this, this._t0));
            break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        var t13 = NaN;
        x4 = +x4, y4 = +y4;
        if (x4 === this._x1 && y4 === this._y1) return;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3;
            point5(this, slope2(this, t13 = slope3(this, x4, y4)), t13);
            break;
          default:
            point5(this, this._t0, t13 = slope3(this, x4, y4));
            break;
        }
        this._x0 = this._x1, this._x1 = x4;
        this._y0 = this._y1, this._y1 = y4;
        this._t0 = t13;
      }
    };
    (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x4, y4) {
      MonotoneX.prototype.point.call(this, y4, x4);
    };
    ReflectContext.prototype = {
      moveTo: function(x4, y4) {
        this._context.moveTo(y4, x4);
      },
      closePath: function() {
        this._context.closePath();
      },
      lineTo: function(x4, y4) {
        this._context.lineTo(y4, x4);
      },
      bezierCurveTo: function(x12, y12, x22, y22, x4, y4) {
        this._context.bezierCurveTo(y12, x12, y22, x22, y4, x4);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/natural.js
function Natural(context) {
  this._context = context;
}
function controlPoints(x4) {
  var i, n = x4.length - 1, m3, a4 = new Array(n), b = new Array(n), r = new Array(n);
  a4[0] = 0, b[0] = 2, r[0] = x4[0] + 2 * x4[1];
  for (i = 1; i < n - 1; ++i) a4[i] = 1, b[i] = 4, r[i] = 4 * x4[i] + 2 * x4[i + 1];
  a4[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x4[n - 1] + x4[n];
  for (i = 1; i < n; ++i) m3 = a4[i] / b[i - 1], b[i] -= m3, r[i] -= m3 * r[i - 1];
  a4[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a4[i] = (r[i] - a4[i + 1]) / b[i];
  b[n - 1] = (x4[n] + a4[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x4[i + 1] - a4[i + 1];
  return [a4, b];
}
function natural_default(context) {
  return new Natural(context);
}
var init_natural = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/natural.js"() {
    Natural.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x = [];
        this._y = [];
      },
      lineEnd: function() {
        var x4 = this._x, y4 = this._y, n = x4.length;
        if (n) {
          this._line ? this._context.lineTo(x4[0], y4[0]) : this._context.moveTo(x4[0], y4[0]);
          if (n === 2) {
            this._context.lineTo(x4[1], y4[1]);
          } else {
            var px = controlPoints(x4), py = controlPoints(y4);
            for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
              this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x4[i1], y4[i1]);
            }
          }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
      },
      point: function(x4, y4) {
        this._x.push(+x4);
        this._y.push(+y4);
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
  this._context = context;
  this._t = t;
}
function step_default(context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}
var init_step = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/step.js"() {
    Step.prototype = {
      areaStart: function() {
        this._line = 0;
      },
      areaEnd: function() {
        this._line = NaN;
      },
      lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
      },
      lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
      },
      point: function(x4, y4) {
        x4 = +x4, y4 = +y4;
        switch (this._point) {
          case 0:
            this._point = 1;
            this._line ? this._context.lineTo(x4, y4) : this._context.moveTo(x4, y4);
            break;
          case 1:
            this._point = 2;
          // falls through
          default: {
            if (this._t <= 0) {
              this._context.lineTo(this._x, y4);
              this._context.lineTo(x4, y4);
            } else {
              var x12 = this._x * (1 - this._t) + x4 * this._t;
              this._context.lineTo(x12, this._y);
              this._context.lineTo(x12, y4);
            }
            break;
          }
        }
        this._x = x4, this._y = y4;
      }
    };
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/none.js
function none_default(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m3 = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m3; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
var init_none = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/none.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/none.js
function none_default2(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}
var init_none2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/none.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/stack.js
function stackValue(d, key) {
  return d[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function stack_default() {
  var keys = constant_default10([]), order = none_default2, offset = none_default, value = stackValue;
  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }
    for (i = 0, oz = array_default3(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }
    offset(sz, oz);
    return sz;
  }
  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant_default10(Array.from(_)), stack) : keys;
  };
  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant_default10(+_), stack) : value;
  };
  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none_default2 : typeof _ === "function" ? _ : constant_default10(Array.from(_)), stack) : order;
  };
  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none_default : _, stack) : offset;
  };
  return stack;
}
var init_stack = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/stack.js"() {
    init_array7();
    init_constant12();
    init_none();
    init_none2();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/expand.js
function expand_default(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m3 = series[0].length, y4; j < m3; ++j) {
    for (y4 = i = 0; i < n; ++i) y4 += series[i][j][1] || 0;
    if (y4) for (i = 0; i < n; ++i) series[i][j][1] /= y4;
  }
  none_default(series, order);
}
var init_expand = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/expand.js"() {
    init_none();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/diverging.js
function diverging_default(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m3 = series[order[0]].length; j < m3; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}
var init_diverging2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/diverging.js"() {
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/silhouette.js
function silhouette_default(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m3 = s0.length; j < m3; ++j) {
    for (var i = 0, y4 = 0; i < n; ++i) y4 += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y4 / 2;
  }
  none_default(series, order);
}
var init_silhouette = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/silhouette.js"() {
    init_none();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/wiggle.js
function wiggle_default(series, order) {
  if (!((n = series.length) > 0) || !((m3 = (s0 = series[order[0]]).length) > 0)) return;
  for (var y4 = 0, j = 1, s0, m3, n; j < m3; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
      for (var k2 = 0; k2 < i; ++k2) {
        var sk = series[order[k2]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y4;
    if (s1) y4 -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y4;
  none_default(series, order);
}
var init_wiggle = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/wiggle.js"() {
    init_none();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/appearance.js
function appearance_default(series) {
  var peaks = series.map(peak);
  return none_default2(series).sort(function(a4, b) {
    return peaks[a4] - peaks[b];
  });
}
function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}
var init_appearance = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/appearance.js"() {
    init_none2();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/ascending.js
function ascending_default2(series) {
  var sums = series.map(sum3);
  return none_default2(series).sort(function(a4, b) {
    return sums[a4] - sums[b];
  });
}
function sum3(series) {
  var s2 = 0, i = -1, n = series.length, v2;
  while (++i < n) if (v2 = +series[i][1]) s2 += v2;
  return s2;
}
var init_ascending3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/ascending.js"() {
    init_none2();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/descending.js
function descending_default2(series) {
  return ascending_default2(series).reverse();
}
var init_descending3 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/descending.js"() {
    init_ascending3();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/insideOut.js
function insideOut_default(series) {
  var n = series.length, i, j, sums = series.map(sum3), order = appearance_default(series), top2 = 0, bottom2 = 0, tops = [], bottoms = [];
  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top2 < bottom2) {
      top2 += sums[j];
      tops.push(j);
    } else {
      bottom2 += sums[j];
      bottoms.push(j);
    }
  }
  return bottoms.reverse().concat(tops);
}
var init_insideOut = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/insideOut.js"() {
    init_appearance();
    init_ascending3();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/reverse.js
function reverse_default(series) {
  return none_default2(series).reverse();
}
var init_reverse2 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/reverse.js"() {
    init_none2();
  }
});

// ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/index.js
var init_src30 = __esm({
  "../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/index.js"() {
    init_arc();
    init_area5();
    init_line2();
    init_pie();
    init_areaRadial();
    init_lineRadial();
    init_pointRadial();
    init_link2();
    init_symbol();
    init_asterisk();
    init_circle4();
    init_cross3();
    init_diamond();
    init_diamond2();
    init_plus();
    init_square();
    init_square2();
    init_star();
    init_triangle();
    init_triangle2();
    init_wye();
    init_times();
    init_basisClosed2();
    init_basisOpen();
    init_basis2();
    init_bump();
    init_bundle();
    init_cardinalClosed();
    init_cardinalOpen();
    init_cardinal();
    init_catmullRomClosed();
    init_catmullRomOpen();
    init_catmullRom();
    init_linearClosed();
    init_linear3();
    init_monotone();
    init_natural();
    init_step();
    init_stack();
    init_expand();
    init_diverging2();
    init_none();
    init_silhouette();
    init_wiggle();
    init_appearance();
    init_ascending3();
    init_descending3();
    init_insideOut();
    init_none2();
    init_reverse2();
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/constant.js
var constant_default11;
var init_constant13 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/constant.js"() {
    constant_default11 = (x4) => () => x4;
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/event.js
function ZoomEvent(type2, {
  sourceEvent,
  target,
  transform: transform2,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    transform: { value: transform2, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
var init_event3 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/event.js"() {
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/transform.js
function Transform(k2, x4, y4) {
  this.k = k2;
  this.x = x4;
  this.y = y4;
}
function transform(node) {
  while (!node.__zoom) if (!(node = node.parentNode)) return identity5;
  return node.__zoom;
}
var identity5;
var init_transform3 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/transform.js"() {
    Transform.prototype = {
      constructor: Transform,
      scale: function(k2) {
        return k2 === 1 ? this : new Transform(this.k * k2, this.x, this.y);
      },
      translate: function(x4, y4) {
        return x4 === 0 & y4 === 0 ? this : new Transform(this.k, this.x + this.k * x4, this.y + this.k * y4);
      },
      apply: function(point6) {
        return [point6[0] * this.k + this.x, point6[1] * this.k + this.y];
      },
      applyX: function(x4) {
        return x4 * this.k + this.x;
      },
      applyY: function(y4) {
        return y4 * this.k + this.y;
      },
      invert: function(location) {
        return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
      },
      invertX: function(x4) {
        return (x4 - this.x) / this.k;
      },
      invertY: function(y4) {
        return (y4 - this.y) / this.k;
      },
      rescaleX: function(x4) {
        return x4.copy().domain(x4.range().map(this.invertX, this).map(x4.invert, x4));
      },
      rescaleY: function(y4) {
        return y4.copy().domain(y4.range().map(this.invertY, this).map(y4.invert, y4));
      },
      toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
      }
    };
    identity5 = new Transform(1, 0, 0);
    transform.prototype = Transform.prototype;
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/noevent.js
function nopropagation3(event) {
  event.stopImmediatePropagation();
}
function noevent_default3(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var init_noevent3 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/noevent.js"() {
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/zoom.js
function defaultFilter3(event) {
  return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function defaultExtent2() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}
function defaultTransform() {
  return this.__zoom || identity5;
}
function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 2e-3) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable3() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform2, extent2, translateExtent) {
  var dx0 = transform2.invertX(extent2[0][0]) - translateExtent[0][0], dx1 = transform2.invertX(extent2[1][0]) - translateExtent[1][0], dy0 = transform2.invertY(extent2[0][1]) - translateExtent[0][1], dy1 = transform2.invertY(extent2[1][1]) - translateExtent[1][1];
  return transform2.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}
function zoom_default2() {
  var filter3 = defaultFilter3, extent2 = defaultExtent2, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable3, scaleExtent = [0, Infinity], translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]], duration = 250, interpolate = zoom_default, listeners = dispatch_default("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
  function zoom(selection2) {
    selection2.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, { passive: false }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  zoom.transform = function(collection, transform2, point6, event) {
    var selection2 = collection.selection ? collection.selection() : collection;
    selection2.property("__zoom", defaultTransform);
    if (collection !== selection2) {
      schedule(collection, transform2, point6, event);
    } else {
      selection2.interrupt().each(function() {
        gesture(this, arguments).event(event).start().zoom(null, typeof transform2 === "function" ? transform2.apply(this, arguments) : transform2).end();
      });
    }
  };
  zoom.scaleBy = function(selection2, k2, p, event) {
    zoom.scaleTo(selection2, function() {
      var k0 = this.__zoom.k, k1 = typeof k2 === "function" ? k2.apply(this, arguments) : k2;
      return k0 * k1;
    }, p, event);
  };
  zoom.scaleTo = function(selection2, k2, p, event) {
    zoom.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t03 = this.__zoom, p02 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t03.invert(p02), k1 = typeof k2 === "function" ? k2.apply(this, arguments) : k2;
      return constrain(translate(scale2(t03, k1), p02, p1), e, translateExtent);
    }, p, event);
  };
  zoom.translateBy = function(selection2, x4, y4, event) {
    zoom.transform(selection2, function() {
      return constrain(this.__zoom.translate(
        typeof x4 === "function" ? x4.apply(this, arguments) : x4,
        typeof y4 === "function" ? y4.apply(this, arguments) : y4
      ), extent2.apply(this, arguments), translateExtent);
    }, null, event);
  };
  zoom.translateTo = function(selection2, x4, y4, p, event) {
    zoom.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t = this.__zoom, p02 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity5.translate(p02[0], p02[1]).scale(t.k).translate(
        typeof x4 === "function" ? -x4.apply(this, arguments) : -x4,
        typeof y4 === "function" ? -y4.apply(this, arguments) : -y4
      ), e, translateExtent);
    }, p, event);
  };
  function scale2(transform2, k2) {
    k2 = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k2));
    return k2 === transform2.k ? transform2 : new Transform(k2, transform2.x, transform2.y);
  }
  function translate(transform2, p02, p1) {
    var x4 = p02[0] - p1[0] * transform2.k, y4 = p02[1] - p1[1] * transform2.k;
    return x4 === transform2.x && y4 === transform2.y ? transform2 : new Transform(transform2.k, x4, y4);
  }
  function centroid(extent3) {
    return [(+extent3[0][0] + +extent3[1][0]) / 2, (+extent3[0][1] + +extent3[1][1]) / 2];
  }
  function schedule(transition2, transform2, point6, event) {
    transition2.on("start.zoom", function() {
      gesture(this, arguments).event(event).start();
    }).on("interrupt.zoom end.zoom", function() {
      gesture(this, arguments).event(event).end();
    }).tween("zoom", function() {
      var that = this, args = arguments, g = gesture(that, args).event(event), e = extent2.apply(that, args), p = point6 == null ? centroid(e) : typeof point6 === "function" ? point6.apply(that, args) : point6, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a4 = that.__zoom, b = typeof transform2 === "function" ? transform2.apply(that, args) : transform2, i = interpolate(a4.invert(p).concat(w / a4.k), b.invert(p).concat(w / b.k));
      return function(t) {
        if (t === 1) t = b;
        else {
          var l = i(t), k2 = w / l[2];
          t = new Transform(k2, p[0] - l[0] * k2, p[1] - l[1] * k2);
        }
        g.zoom(null, t);
      };
    });
  }
  function gesture(that, args, clean) {
    return !clean && that.__zooming || new Gesture(that, args);
  }
  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent2.apply(that, args);
    this.taps = 0;
  }
  Gesture.prototype = {
    event: function(event) {
      if (event) this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform2) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform2.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform2.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform2.invert(this.touch1[0]);
      this.that.__zoom = transform2;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type2) {
      var d = select_default2(this.that).datum();
      listeners.call(
        type2,
        this.that,
        new ZoomEvent(type2, {
          sourceEvent: this.sourceEvent,
          target: zoom,
          type: type2,
          transform: this.that.__zoom,
          dispatch: listeners
        }),
        d
      );
    }
  };
  function wheeled(event, ...args) {
    if (!filter3.apply(this, arguments)) return;
    var g = gesture(this, args).event(event), t = this.__zoom, k2 = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer_default(event);
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    } else if (t.k === k2) return;
    else {
      g.mouse = [p, t.invert(p)];
      interrupt_default(this);
      g.start();
    }
    noevent_default3(event);
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale2(t, k2), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }
  function mousedowned(event, ...args) {
    if (touchending || !filter3.apply(this, arguments)) return;
    var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v2 = select_default2(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer_default(event, currentTarget), x06 = event.clientX, y06 = event.clientY;
    nodrag_default(event.view);
    nopropagation3(event);
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt_default(this);
    g.start();
    function mousemoved(event2) {
      noevent_default3(event2);
      if (!g.moved) {
        var dx = event2.clientX - x06, dy = event2.clientY - y06;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.event(event2).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer_default(event2, currentTarget), g.mouse[1]), g.extent, translateExtent));
    }
    function mouseupped(event2) {
      v2.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(event2.view, g.moved);
      noevent_default3(event2);
      g.event(event2).end();
    }
  }
  function dblclicked(event, ...args) {
    if (!filter3.apply(this, arguments)) return;
    var t03 = this.__zoom, p02 = pointer_default(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t03.invert(p02), k1 = t03.k * (event.shiftKey ? 0.5 : 2), t13 = constrain(translate(scale2(t03, k1), p02, p1), extent2.apply(this, args), translateExtent);
    noevent_default3(event);
    if (duration > 0) select_default2(this).transition().duration(duration).call(schedule, t13, p02, event);
    else select_default2(this).call(zoom.transform, t13, p02, event);
  }
  function touchstarted(event, ...args) {
    if (!filter3.apply(this, arguments)) return;
    var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
    nopropagation3(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer_default(t, this);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
    }
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    if (started) {
      if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
        touchstarting = null;
      }, touchDelay);
      interrupt_default(this);
      g.start();
    }
  }
  function touchmoved(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
    noevent_default3(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer_default(t, this);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p02 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p02[0]) * dp + (dp = p1[1] - p02[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale2(t, Math.sqrt(dp / dl));
      p = [(p02[0] + p1[0]) / 2, (p02[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }
  function touchended(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
    nopropagation3(event);
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      if (g.taps === 2) {
        t = pointer_default(t, this);
        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
          var p = select_default2(this).on("dblclick.zoom");
          if (p) p.apply(this, arguments);
        }
      }
    }
  }
  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant_default11(+_), zoom) : wheelDelta;
  };
  zoom.filter = function(_) {
    return arguments.length ? (filter3 = typeof _ === "function" ? _ : constant_default11(!!_), zoom) : filter3;
  };
  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant_default11(!!_), zoom) : touchable;
  };
  zoom.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant_default11([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent2;
  };
  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };
  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };
  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };
  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };
  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };
  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };
  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };
  zoom.tapDistance = function(_) {
    return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
  };
  return zoom;
}
var init_zoom2 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/zoom.js"() {
    init_src4();
    init_src6();
    init_src8();
    init_src5();
    init_src11();
    init_constant13();
    init_event3();
    init_transform3();
    init_noevent3();
  }
});

// ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/index.js
var init_src31 = __esm({
  "../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/index.js"() {
    init_zoom2();
    init_transform3();
  }
});

// ../node_modules/.pnpm/d3@7.9.0/node_modules/d3/src/index.js
var src_exports = {};
__export(src_exports, {
  Adder: () => Adder,
  Delaunay: () => Delaunay,
  FormatSpecifier: () => FormatSpecifier,
  InternMap: () => InternMap,
  InternSet: () => InternSet,
  Node: () => Node,
  Path: () => Path,
  Voronoi: () => Voronoi,
  ZoomTransform: () => Transform,
  active: () => active_default,
  arc: () => arc_default,
  area: () => area_default5,
  areaRadial: () => areaRadial_default,
  ascending: () => ascending,
  autoType: () => autoType,
  axisBottom: () => axisBottom,
  axisLeft: () => axisLeft,
  axisRight: () => axisRight,
  axisTop: () => axisTop,
  bin: () => bin,
  bisect: () => bisect_default,
  bisectCenter: () => bisectCenter,
  bisectLeft: () => bisectLeft,
  bisectRight: () => bisectRight,
  bisector: () => bisector,
  blob: () => blob_default,
  blur: () => blur,
  blur2: () => blur2,
  blurImage: () => blurImage,
  brush: () => brush_default,
  brushSelection: () => brushSelection,
  brushX: () => brushX,
  brushY: () => brushY,
  buffer: () => buffer_default,
  chord: () => chord_default,
  chordDirected: () => chordDirected,
  chordTranspose: () => chordTranspose,
  cluster: () => cluster_default,
  color: () => color,
  contourDensity: () => density_default,
  contours: () => contours_default,
  count: () => count,
  create: () => create_default,
  creator: () => creator_default,
  cross: () => cross,
  csv: () => csv2,
  csvFormat: () => csvFormat,
  csvFormatBody: () => csvFormatBody,
  csvFormatRow: () => csvFormatRow,
  csvFormatRows: () => csvFormatRows,
  csvFormatValue: () => csvFormatValue,
  csvParse: () => csvParse,
  csvParseRows: () => csvParseRows,
  cubehelix: () => cubehelix,
  cumsum: () => cumsum,
  curveBasis: () => basis_default2,
  curveBasisClosed: () => basisClosed_default2,
  curveBasisOpen: () => basisOpen_default,
  curveBumpX: () => bumpX,
  curveBumpY: () => bumpY,
  curveBundle: () => bundle_default,
  curveCardinal: () => cardinal_default,
  curveCardinalClosed: () => cardinalClosed_default,
  curveCardinalOpen: () => cardinalOpen_default,
  curveCatmullRom: () => catmullRom_default,
  curveCatmullRomClosed: () => catmullRomClosed_default,
  curveCatmullRomOpen: () => catmullRomOpen_default,
  curveLinear: () => linear_default,
  curveLinearClosed: () => linearClosed_default,
  curveMonotoneX: () => monotoneX,
  curveMonotoneY: () => monotoneY,
  curveNatural: () => natural_default,
  curveStep: () => step_default,
  curveStepAfter: () => stepAfter,
  curveStepBefore: () => stepBefore,
  descending: () => descending,
  deviation: () => deviation,
  difference: () => difference,
  disjoint: () => disjoint,
  dispatch: () => dispatch_default,
  drag: () => drag_default,
  dragDisable: () => nodrag_default,
  dragEnable: () => yesdrag,
  dsv: () => dsv,
  dsvFormat: () => dsv_default,
  easeBack: () => backInOut,
  easeBackIn: () => backIn,
  easeBackInOut: () => backInOut,
  easeBackOut: () => backOut,
  easeBounce: () => bounceOut,
  easeBounceIn: () => bounceIn,
  easeBounceInOut: () => bounceInOut,
  easeBounceOut: () => bounceOut,
  easeCircle: () => circleInOut,
  easeCircleIn: () => circleIn,
  easeCircleInOut: () => circleInOut,
  easeCircleOut: () => circleOut,
  easeCubic: () => cubicInOut,
  easeCubicIn: () => cubicIn,
  easeCubicInOut: () => cubicInOut,
  easeCubicOut: () => cubicOut,
  easeElastic: () => elasticOut,
  easeElasticIn: () => elasticIn,
  easeElasticInOut: () => elasticInOut,
  easeElasticOut: () => elasticOut,
  easeExp: () => expInOut,
  easeExpIn: () => expIn,
  easeExpInOut: () => expInOut,
  easeExpOut: () => expOut,
  easeLinear: () => linear2,
  easePoly: () => polyInOut,
  easePolyIn: () => polyIn,
  easePolyInOut: () => polyInOut,
  easePolyOut: () => polyOut,
  easeQuad: () => quadInOut,
  easeQuadIn: () => quadIn,
  easeQuadInOut: () => quadInOut,
  easeQuadOut: () => quadOut,
  easeSin: () => sinInOut,
  easeSinIn: () => sinIn,
  easeSinInOut: () => sinInOut,
  easeSinOut: () => sinOut,
  every: () => every,
  extent: () => extent,
  fcumsum: () => fcumsum,
  filter: () => filter,
  flatGroup: () => flatGroup,
  flatRollup: () => flatRollup,
  forceCenter: () => center_default,
  forceCollide: () => collide_default,
  forceLink: () => link_default,
  forceManyBody: () => manyBody_default,
  forceRadial: () => radial_default,
  forceSimulation: () => simulation_default,
  forceX: () => x_default2,
  forceY: () => y_default2,
  format: () => format,
  formatDefaultLocale: () => defaultLocale,
  formatLocale: () => locale_default,
  formatPrefix: () => formatPrefix,
  formatSpecifier: () => formatSpecifier,
  fsum: () => fsum,
  geoAlbers: () => albers_default,
  geoAlbersUsa: () => albersUsa_default,
  geoArea: () => area_default2,
  geoAzimuthalEqualArea: () => azimuthalEqualArea_default,
  geoAzimuthalEqualAreaRaw: () => azimuthalEqualAreaRaw,
  geoAzimuthalEquidistant: () => azimuthalEquidistant_default,
  geoAzimuthalEquidistantRaw: () => azimuthalEquidistantRaw,
  geoBounds: () => bounds_default,
  geoCentroid: () => centroid_default,
  geoCircle: () => circle_default,
  geoClipAntimeridian: () => antimeridian_default,
  geoClipCircle: () => circle_default2,
  geoClipExtent: () => extent_default2,
  geoClipRectangle: () => clipRectangle,
  geoConicConformal: () => conicConformal_default,
  geoConicConformalRaw: () => conicConformalRaw,
  geoConicEqualArea: () => conicEqualArea_default,
  geoConicEqualAreaRaw: () => conicEqualAreaRaw,
  geoConicEquidistant: () => conicEquidistant_default,
  geoConicEquidistantRaw: () => conicEquidistantRaw,
  geoContains: () => contains_default2,
  geoDistance: () => distance_default,
  geoEqualEarth: () => equalEarth_default,
  geoEqualEarthRaw: () => equalEarthRaw,
  geoEquirectangular: () => equirectangular_default,
  geoEquirectangularRaw: () => equirectangularRaw,
  geoGnomonic: () => gnomonic_default,
  geoGnomonicRaw: () => gnomonicRaw,
  geoGraticule: () => graticule,
  geoGraticule10: () => graticule10,
  geoIdentity: () => identity_default4,
  geoInterpolate: () => interpolate_default2,
  geoLength: () => length_default,
  geoMercator: () => mercator_default,
  geoMercatorRaw: () => mercatorRaw,
  geoNaturalEarth1: () => naturalEarth1_default,
  geoNaturalEarth1Raw: () => naturalEarth1Raw,
  geoOrthographic: () => orthographic_default,
  geoOrthographicRaw: () => orthographicRaw,
  geoPath: () => path_default,
  geoProjection: () => projection,
  geoProjectionMutator: () => projectionMutator,
  geoRotation: () => rotation_default,
  geoStereographic: () => stereographic_default,
  geoStereographicRaw: () => stereographicRaw,
  geoStream: () => stream_default,
  geoTransform: () => transform_default,
  geoTransverseMercator: () => transverseMercator_default,
  geoTransverseMercatorRaw: () => transverseMercatorRaw,
  gray: () => gray,
  greatest: () => greatest,
  greatestIndex: () => greatestIndex,
  group: () => group,
  groupSort: () => groupSort,
  groups: () => groups,
  hcl: () => hcl,
  hierarchy: () => hierarchy,
  histogram: () => bin,
  hsl: () => hsl,
  html: () => html,
  image: () => image_default,
  index: () => index,
  indexes: () => indexes,
  interpolate: () => value_default,
  interpolateArray: () => array_default,
  interpolateBasis: () => basis_default,
  interpolateBasisClosed: () => basisClosed_default,
  interpolateBlues: () => Blues_default,
  interpolateBrBG: () => BrBG_default,
  interpolateBuGn: () => BuGn_default,
  interpolateBuPu: () => BuPu_default,
  interpolateCividis: () => cividis_default,
  interpolateCool: () => cool,
  interpolateCubehelix: () => cubehelix_default,
  interpolateCubehelixDefault: () => cubehelix_default2,
  interpolateCubehelixLong: () => cubehelixLong,
  interpolateDate: () => date_default,
  interpolateDiscrete: () => discrete_default,
  interpolateGnBu: () => GnBu_default,
  interpolateGreens: () => Greens_default,
  interpolateGreys: () => Greys_default,
  interpolateHcl: () => hcl_default,
  interpolateHclLong: () => hclLong,
  interpolateHsl: () => hsl_default,
  interpolateHslLong: () => hslLong,
  interpolateHue: () => hue_default,
  interpolateInferno: () => inferno,
  interpolateLab: () => lab2,
  interpolateMagma: () => magma,
  interpolateNumber: () => number_default,
  interpolateNumberArray: () => numberArray_default,
  interpolateObject: () => object_default,
  interpolateOrRd: () => OrRd_default,
  interpolateOranges: () => Oranges_default,
  interpolatePRGn: () => PRGn_default,
  interpolatePiYG: () => PiYG_default,
  interpolatePlasma: () => plasma,
  interpolatePuBu: () => PuBu_default,
  interpolatePuBuGn: () => PuBuGn_default,
  interpolatePuOr: () => PuOr_default,
  interpolatePuRd: () => PuRd_default,
  interpolatePurples: () => Purples_default,
  interpolateRainbow: () => rainbow_default,
  interpolateRdBu: () => RdBu_default,
  interpolateRdGy: () => RdGy_default,
  interpolateRdPu: () => RdPu_default,
  interpolateRdYlBu: () => RdYlBu_default,
  interpolateRdYlGn: () => RdYlGn_default,
  interpolateReds: () => Reds_default,
  interpolateRgb: () => rgb_default,
  interpolateRgbBasis: () => rgbBasis,
  interpolateRgbBasisClosed: () => rgbBasisClosed,
  interpolateRound: () => round_default,
  interpolateSinebow: () => sinebow_default,
  interpolateSpectral: () => Spectral_default,
  interpolateString: () => string_default,
  interpolateTransformCss: () => interpolateTransformCss,
  interpolateTransformSvg: () => interpolateTransformSvg,
  interpolateTurbo: () => turbo_default,
  interpolateViridis: () => viridis_default,
  interpolateWarm: () => warm,
  interpolateYlGn: () => YlGn_default,
  interpolateYlGnBu: () => YlGnBu_default,
  interpolateYlOrBr: () => YlOrBr_default,
  interpolateYlOrRd: () => YlOrRd_default,
  interpolateZoom: () => zoom_default,
  interrupt: () => interrupt_default,
  intersection: () => intersection,
  interval: () => interval_default,
  isoFormat: () => isoFormat_default,
  isoParse: () => isoParse_default,
  json: () => json_default,
  lab: () => lab,
  lch: () => lch,
  least: () => least,
  leastIndex: () => leastIndex,
  line: () => line_default2,
  lineRadial: () => lineRadial_default,
  link: () => link2,
  linkHorizontal: () => linkHorizontal,
  linkRadial: () => linkRadial,
  linkVertical: () => linkVertical,
  local: () => local,
  map: () => map2,
  matcher: () => matcher_default,
  max: () => max,
  maxIndex: () => maxIndex,
  mean: () => mean,
  median: () => median,
  medianIndex: () => medianIndex,
  merge: () => merge,
  min: () => min,
  minIndex: () => minIndex,
  mode: () => mode,
  namespace: () => namespace_default,
  namespaces: () => namespaces_default,
  nice: () => nice,
  now: () => now,
  pack: () => pack_default,
  packEnclose: () => enclose_default,
  packSiblings: () => siblings_default,
  pairs: () => pairs,
  partition: () => partition_default,
  path: () => path,
  pathRound: () => pathRound,
  permute: () => permute,
  pie: () => pie_default,
  piecewise: () => piecewise,
  pointRadial: () => pointRadial_default,
  pointer: () => pointer_default,
  pointers: () => pointers_default,
  polygonArea: () => area_default4,
  polygonCentroid: () => centroid_default3,
  polygonContains: () => contains_default3,
  polygonHull: () => hull_default,
  polygonLength: () => length_default2,
  precisionFixed: () => precisionFixed_default,
  precisionPrefix: () => precisionPrefix_default,
  precisionRound: () => precisionRound_default,
  quadtree: () => quadtree,
  quantile: () => quantile,
  quantileIndex: () => quantileIndex,
  quantileSorted: () => quantileSorted,
  quantize: () => quantize_default,
  quickselect: () => quickselect,
  radialArea: () => areaRadial_default,
  radialLine: () => lineRadial_default,
  randomBates: () => bates_default,
  randomBernoulli: () => bernoulli_default,
  randomBeta: () => beta_default,
  randomBinomial: () => binomial_default,
  randomCauchy: () => cauchy_default,
  randomExponential: () => exponential_default,
  randomGamma: () => gamma_default,
  randomGeometric: () => geometric_default,
  randomInt: () => int_default,
  randomIrwinHall: () => irwinHall_default,
  randomLcg: () => lcg,
  randomLogNormal: () => logNormal_default,
  randomLogistic: () => logistic_default,
  randomNormal: () => normal_default,
  randomPareto: () => pareto_default,
  randomPoisson: () => poisson_default,
  randomUniform: () => uniform_default,
  randomWeibull: () => weibull_default,
  range: () => range,
  rank: () => rank,
  reduce: () => reduce,
  reverse: () => reverse,
  rgb: () => rgb,
  ribbon: () => ribbon_default,
  ribbonArrow: () => ribbonArrow,
  rollup: () => rollup,
  rollups: () => rollups,
  scaleBand: () => band,
  scaleDiverging: () => diverging,
  scaleDivergingLog: () => divergingLog,
  scaleDivergingPow: () => divergingPow,
  scaleDivergingSqrt: () => divergingSqrt,
  scaleDivergingSymlog: () => divergingSymlog,
  scaleIdentity: () => identity4,
  scaleImplicit: () => implicit,
  scaleLinear: () => linear3,
  scaleLog: () => log2,
  scaleOrdinal: () => ordinal,
  scalePoint: () => point,
  scalePow: () => pow3,
  scaleQuantile: () => quantile2,
  scaleQuantize: () => quantize,
  scaleRadial: () => radial,
  scaleSequential: () => sequential,
  scaleSequentialLog: () => sequentialLog,
  scaleSequentialPow: () => sequentialPow,
  scaleSequentialQuantile: () => sequentialQuantile,
  scaleSequentialSqrt: () => sequentialSqrt,
  scaleSequentialSymlog: () => sequentialSymlog,
  scaleSqrt: () => sqrt2,
  scaleSymlog: () => symlog,
  scaleThreshold: () => threshold,
  scaleTime: () => time,
  scaleUtc: () => utcTime,
  scan: () => scan,
  schemeAccent: () => Accent_default,
  schemeBlues: () => scheme22,
  schemeBrBG: () => scheme,
  schemeBuGn: () => scheme10,
  schemeBuPu: () => scheme11,
  schemeCategory10: () => category10_default,
  schemeDark2: () => Dark2_default,
  schemeGnBu: () => scheme12,
  schemeGreens: () => scheme23,
  schemeGreys: () => scheme24,
  schemeObservable10: () => observable10_default,
  schemeOrRd: () => scheme13,
  schemeOranges: () => scheme27,
  schemePRGn: () => scheme2,
  schemePaired: () => Paired_default,
  schemePastel1: () => Pastel1_default,
  schemePastel2: () => Pastel2_default,
  schemePiYG: () => scheme3,
  schemePuBu: () => scheme15,
  schemePuBuGn: () => scheme14,
  schemePuOr: () => scheme4,
  schemePuRd: () => scheme16,
  schemePurples: () => scheme25,
  schemeRdBu: () => scheme5,
  schemeRdGy: () => scheme6,
  schemeRdPu: () => scheme17,
  schemeRdYlBu: () => scheme7,
  schemeRdYlGn: () => scheme8,
  schemeReds: () => scheme26,
  schemeSet1: () => Set1_default,
  schemeSet2: () => Set2_default,
  schemeSet3: () => Set3_default,
  schemeSpectral: () => scheme9,
  schemeTableau10: () => Tableau10_default,
  schemeYlGn: () => scheme19,
  schemeYlGnBu: () => scheme18,
  schemeYlOrBr: () => scheme20,
  schemeYlOrRd: () => scheme21,
  select: () => select_default2,
  selectAll: () => selectAll_default2,
  selection: () => selection_default,
  selector: () => selector_default,
  selectorAll: () => selectorAll_default,
  shuffle: () => shuffle_default,
  shuffler: () => shuffler,
  some: () => some,
  sort: () => sort,
  stack: () => stack_default,
  stackOffsetDiverging: () => diverging_default,
  stackOffsetExpand: () => expand_default,
  stackOffsetNone: () => none_default,
  stackOffsetSilhouette: () => silhouette_default,
  stackOffsetWiggle: () => wiggle_default,
  stackOrderAppearance: () => appearance_default,
  stackOrderAscending: () => ascending_default2,
  stackOrderDescending: () => descending_default2,
  stackOrderInsideOut: () => insideOut_default,
  stackOrderNone: () => none_default2,
  stackOrderReverse: () => reverse_default,
  stratify: () => stratify_default,
  style: () => styleValue,
  subset: () => subset,
  sum: () => sum,
  superset: () => superset,
  svg: () => svg,
  symbol: () => Symbol2,
  symbolAsterisk: () => asterisk_default,
  symbolCircle: () => circle_default3,
  symbolCross: () => cross_default2,
  symbolDiamond: () => diamond_default,
  symbolDiamond2: () => diamond2_default,
  symbolPlus: () => plus_default,
  symbolSquare: () => square_default,
  symbolSquare2: () => square2_default,
  symbolStar: () => star_default,
  symbolTimes: () => times_default,
  symbolTriangle: () => triangle_default,
  symbolTriangle2: () => triangle2_default,
  symbolWye: () => wye_default,
  symbolX: () => times_default,
  symbols: () => symbolsFill,
  symbolsFill: () => symbolsFill,
  symbolsStroke: () => symbolsStroke,
  text: () => text_default3,
  thresholdFreedmanDiaconis: () => thresholdFreedmanDiaconis,
  thresholdScott: () => thresholdScott,
  thresholdSturges: () => thresholdSturges,
  tickFormat: () => tickFormat,
  tickIncrement: () => tickIncrement,
  tickStep: () => tickStep,
  ticks: () => ticks,
  timeDay: () => timeDay,
  timeDays: () => timeDays,
  timeFormat: () => timeFormat,
  timeFormatDefaultLocale: () => defaultLocale2,
  timeFormatLocale: () => formatLocale,
  timeFriday: () => timeFriday,
  timeFridays: () => timeFridays,
  timeHour: () => timeHour,
  timeHours: () => timeHours,
  timeInterval: () => timeInterval,
  timeMillisecond: () => millisecond,
  timeMilliseconds: () => milliseconds,
  timeMinute: () => timeMinute,
  timeMinutes: () => timeMinutes,
  timeMonday: () => timeMonday,
  timeMondays: () => timeMondays,
  timeMonth: () => timeMonth,
  timeMonths: () => timeMonths,
  timeParse: () => timeParse,
  timeSaturday: () => timeSaturday,
  timeSaturdays: () => timeSaturdays,
  timeSecond: () => second,
  timeSeconds: () => seconds,
  timeSunday: () => timeSunday,
  timeSundays: () => timeSundays,
  timeThursday: () => timeThursday,
  timeThursdays: () => timeThursdays,
  timeTickInterval: () => timeTickInterval,
  timeTicks: () => timeTicks,
  timeTuesday: () => timeTuesday,
  timeTuesdays: () => timeTuesdays,
  timeWednesday: () => timeWednesday,
  timeWednesdays: () => timeWednesdays,
  timeWeek: () => timeSunday,
  timeWeeks: () => timeSundays,
  timeYear: () => timeYear,
  timeYears: () => timeYears,
  timeout: () => timeout_default,
  timer: () => timer,
  timerFlush: () => timerFlush,
  transition: () => transition,
  transpose: () => transpose,
  tree: () => tree_default,
  treemap: () => treemap_default,
  treemapBinary: () => binary_default,
  treemapDice: () => dice_default,
  treemapResquarify: () => resquarify_default,
  treemapSlice: () => slice_default,
  treemapSliceDice: () => sliceDice_default,
  treemapSquarify: () => squarify_default,
  tsv: () => tsv2,
  tsvFormat: () => tsvFormat,
  tsvFormatBody: () => tsvFormatBody,
  tsvFormatRow: () => tsvFormatRow,
  tsvFormatRows: () => tsvFormatRows,
  tsvFormatValue: () => tsvFormatValue,
  tsvParse: () => tsvParse,
  tsvParseRows: () => tsvParseRows,
  union: () => union,
  unixDay: () => unixDay,
  unixDays: () => unixDays,
  utcDay: () => utcDay,
  utcDays: () => utcDays,
  utcFormat: () => utcFormat,
  utcFriday: () => utcFriday,
  utcFridays: () => utcFridays,
  utcHour: () => utcHour,
  utcHours: () => utcHours,
  utcMillisecond: () => millisecond,
  utcMilliseconds: () => milliseconds,
  utcMinute: () => utcMinute,
  utcMinutes: () => utcMinutes,
  utcMonday: () => utcMonday,
  utcMondays: () => utcMondays,
  utcMonth: () => utcMonth,
  utcMonths: () => utcMonths,
  utcParse: () => utcParse,
  utcSaturday: () => utcSaturday,
  utcSaturdays: () => utcSaturdays,
  utcSecond: () => second,
  utcSeconds: () => seconds,
  utcSunday: () => utcSunday,
  utcSundays: () => utcSundays,
  utcThursday: () => utcThursday,
  utcThursdays: () => utcThursdays,
  utcTickInterval: () => utcTickInterval,
  utcTicks: () => utcTicks,
  utcTuesday: () => utcTuesday,
  utcTuesdays: () => utcTuesdays,
  utcWednesday: () => utcWednesday,
  utcWednesdays: () => utcWednesdays,
  utcWeek: () => utcSunday,
  utcWeeks: () => utcSundays,
  utcYear: () => utcYear,
  utcYears: () => utcYears,
  variance: () => variance,
  window: () => window_default,
  xml: () => xml_default,
  zip: () => zip,
  zoom: () => zoom_default2,
  zoomIdentity: () => identity5,
  zoomTransform: () => transform
});
var init_src32 = __esm({
  "../node_modules/.pnpm/d3@7.9.0/node_modules/d3/src/index.js"() {
    init_src2();
    init_src3();
    init_src12();
    init_src14();
    init_src7();
    init_src15();
    init_src16();
    init_src4();
    init_src6();
    init_src17();
    init_src10();
    init_src18();
    init_src20();
    init_src21();
    init_src22();
    init_src23();
    init_src8();
    init_src13();
    init_src24();
    init_src19();
    init_src25();
    init_src28();
    init_src29();
    init_src5();
    init_src30();
    init_src26();
    init_src27();
    init_src9();
    init_src11();
    init_src31();
  }
});

// ../node_modules/.pnpm/moment@2.30.1/node_modules/moment/moment.js
var require_moment = __commonJS({
  "../node_modules/.pnpm/moment@2.30.1/node_modules/moment/moment.js"(exports2, module2) {
    (function(global2, factory) {
      typeof exports2 === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global2.moment = factory();
    })(exports2, (function() {
      "use strict";
      var hookCallback;
      function hooks() {
        return hookCallback.apply(null, arguments);
      }
      function setHookCallback(callback) {
        hookCallback = callback;
      }
      function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
      }
      function isObject(input) {
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
      }
      function hasOwnProp(a4, b) {
        return Object.prototype.hasOwnProperty.call(a4, b);
      }
      function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
          return Object.getOwnPropertyNames(obj).length === 0;
        } else {
          var k2;
          for (k2 in obj) {
            if (hasOwnProp(obj, k2)) {
              return false;
            }
          }
          return true;
        }
      }
      function isUndefined(input) {
        return input === void 0;
      }
      function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
      }
      function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
      }
      function map4(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
          res.push(fn(arr[i], i));
        }
        return res;
      }
      function extend2(a4, b) {
        for (var i in b) {
          if (hasOwnProp(b, i)) {
            a4[i] = b[i];
          }
        }
        if (hasOwnProp(b, "toString")) {
          a4.toString = b.toString;
        }
        if (hasOwnProp(b, "valueOf")) {
          a4.valueOf = b.valueOf;
        }
        return a4;
      }
      function createUTC(input, format3, locale4, strict) {
        return createLocalOrUTC(input, format3, locale4, strict, true).utc();
      }
      function defaultParsingFlags() {
        return {
          empty: false,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: false,
          invalidEra: null,
          invalidMonth: null,
          invalidFormat: false,
          userInvalidated: false,
          iso: false,
          parsedDateParts: [],
          era: null,
          meridiem: null,
          rfc2822: false,
          weekdayMismatch: false
        };
      }
      function getParsingFlags(m3) {
        if (m3._pf == null) {
          m3._pf = defaultParsingFlags();
        }
        return m3._pf;
      }
      var some2;
      if (Array.prototype.some) {
        some2 = Array.prototype.some;
      } else {
        some2 = function(fun) {
          var t = Object(this), len = t.length >>> 0, i;
          for (i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
              return true;
            }
          }
          return false;
        };
      }
      function isValid(m3) {
        var flags = null, parsedParts = false, isNowValid = m3._d && !isNaN(m3._d.getTime());
        if (isNowValid) {
          flags = getParsingFlags(m3);
          parsedParts = some2.call(flags.parsedDateParts, function(i) {
            return i != null;
          });
          isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
          if (m3._strict) {
            isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
          }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m3)) {
          m3._isValid = isNowValid;
        } else {
          return isNowValid;
        }
        return m3._isValid;
      }
      function createInvalid(flags) {
        var m3 = createUTC(NaN);
        if (flags != null) {
          extend2(getParsingFlags(m3), flags);
        } else {
          getParsingFlags(m3).userInvalidated = true;
        }
        return m3;
      }
      var momentProperties = hooks.momentProperties = [], updateInProgress = false;
      function copyConfig(to2, from2) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from2._isAMomentObject)) {
          to2._isAMomentObject = from2._isAMomentObject;
        }
        if (!isUndefined(from2._i)) {
          to2._i = from2._i;
        }
        if (!isUndefined(from2._f)) {
          to2._f = from2._f;
        }
        if (!isUndefined(from2._l)) {
          to2._l = from2._l;
        }
        if (!isUndefined(from2._strict)) {
          to2._strict = from2._strict;
        }
        if (!isUndefined(from2._tzm)) {
          to2._tzm = from2._tzm;
        }
        if (!isUndefined(from2._isUTC)) {
          to2._isUTC = from2._isUTC;
        }
        if (!isUndefined(from2._offset)) {
          to2._offset = from2._offset;
        }
        if (!isUndefined(from2._pf)) {
          to2._pf = getParsingFlags(from2);
        }
        if (!isUndefined(from2._locale)) {
          to2._locale = from2._locale;
        }
        if (momentPropertiesLen > 0) {
          for (i = 0; i < momentPropertiesLen; i++) {
            prop = momentProperties[i];
            val = from2[prop];
            if (!isUndefined(val)) {
              to2[prop] = val;
            }
          }
        }
        return to2;
      }
      function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
          this._d = /* @__PURE__ */ new Date(NaN);
        }
        if (updateInProgress === false) {
          updateInProgress = true;
          hooks.updateOffset(this);
          updateInProgress = false;
        }
      }
      function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
      }
      function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
          console.warn("Deprecation warning: " + msg);
        }
      }
      function deprecate(msg, fn) {
        var firstTime = true;
        return extend2(function() {
          if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
          }
          if (firstTime) {
            var args = [], arg, i, key, argLen = arguments.length;
            for (i = 0; i < argLen; i++) {
              arg = "";
              if (typeof arguments[i] === "object") {
                arg += "\n[" + i + "] ";
                for (key in arguments[0]) {
                  if (hasOwnProp(arguments[0], key)) {
                    arg += key + ": " + arguments[0][key] + ", ";
                  }
                }
                arg = arg.slice(0, -2);
              } else {
                arg = arguments[i];
              }
              args.push(arg);
            }
            warn(
              msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
            );
            firstTime = false;
          }
          return fn.apply(this, arguments);
        }, fn);
      }
      var deprecations = {};
      function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
          warn(msg);
          deprecations[name] = true;
        }
      }
      hooks.suppressDeprecationWarnings = false;
      hooks.deprecationHandler = null;
      function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
      }
      function set4(config) {
        var prop, i;
        for (i in config) {
          if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) {
              this[i] = prop;
            } else {
              this["_" + i] = prop;
            }
          }
        }
        this._config = config;
        this._dayOfMonthOrdinalParseLenient = new RegExp(
          (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
        );
      }
      function mergeConfigs(parentConfig, childConfig) {
        var res = extend2({}, parentConfig), prop;
        for (prop in childConfig) {
          if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
              res[prop] = {};
              extend2(res[prop], parentConfig[prop]);
              extend2(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
              res[prop] = childConfig[prop];
            } else {
              delete res[prop];
            }
          }
        }
        for (prop in parentConfig) {
          if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
            res[prop] = extend2({}, res[prop]);
          }
        }
        return res;
      }
      function Locale(config) {
        if (config != null) {
          this.set(config);
        }
      }
      var keys;
      if (Object.keys) {
        keys = Object.keys;
      } else {
        keys = function(obj) {
          var i, res = [];
          for (i in obj) {
            if (hasOwnProp(obj, i)) {
              res.push(i);
            }
          }
          return res;
        };
      }
      var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      };
      function calendar2(key, mom, now3) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now3) : output;
      }
      function zeroFill(number5, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number5), zerosToFill = targetLength - absNumber.length, sign4 = number5 >= 0;
        return (sign4 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
      }
      var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
      function addFormatToken(token2, padded, ordinal3, callback) {
        var func = callback;
        if (typeof callback === "string") {
          func = function() {
            return this[callback]();
          };
        }
        if (token2) {
          formatTokenFunctions[token2] = func;
        }
        if (padded) {
          formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
          };
        }
        if (ordinal3) {
          formatTokenFunctions[ordinal3] = function() {
            return this.localeData().ordinal(
              func.apply(this, arguments),
              token2
            );
          };
        }
      }
      function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
          return input.replace(/^\[|\]$/g, "");
        }
        return input.replace(/\\/g, "");
      }
      function makeFormatFunction(format3) {
        var array4 = format3.match(formattingTokens), i, length3;
        for (i = 0, length3 = array4.length; i < length3; i++) {
          if (formatTokenFunctions[array4[i]]) {
            array4[i] = formatTokenFunctions[array4[i]];
          } else {
            array4[i] = removeFormattingTokens(array4[i]);
          }
        }
        return function(mom) {
          var output = "", i2;
          for (i2 = 0; i2 < length3; i2++) {
            output += isFunction(array4[i2]) ? array4[i2].call(mom, format3) : array4[i2];
          }
          return output;
        };
      }
      function formatMoment(m3, format3) {
        if (!m3.isValid()) {
          return m3.localeData().invalidDate();
        }
        format3 = expandFormat(format3, m3.localeData());
        formatFunctions[format3] = formatFunctions[format3] || makeFormatFunction(format3);
        return formatFunctions[format3](m3);
      }
      function expandFormat(format3, locale4) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
          return locale4.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format3)) {
          format3 = format3.replace(
            localFormattingTokens,
            replaceLongDateFormatTokens
          );
          localFormattingTokens.lastIndex = 0;
          i -= 1;
        }
        return format3;
      }
      var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      };
      function longDateFormat(key) {
        var format3 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format3 || !formatUpper) {
          return format3;
        }
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
          if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
            return tok.slice(1);
          }
          return tok;
        }).join("");
        return this._longDateFormat[key];
      }
      var defaultInvalidDate = "Invalid date";
      function invalidDate() {
        return this._invalidDate;
      }
      var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
      function ordinal2(number5) {
        return this._ordinal.replace("%d", number5);
      }
      var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      };
      function relativeTime(number5, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number5, withoutSuffix, string, isFuture) : output.replace(/%d/i, number5);
      }
      function pastFuture(diff2, output) {
        var format3 = this._relativeTime[diff2 > 0 ? "future" : "past"];
        return isFunction(format3) ? format3(output) : format3.replace(/%s/i, output);
      }
      var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
      };
      function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
      }
      function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for (prop in inputObject) {
          if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
              normalizedInput[normalizedProp] = inputObject[prop];
            }
          }
        }
        return normalizedInput;
      }
      var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
      };
      function getPrioritizedUnits(unitsObj) {
        var units = [], u4;
        for (u4 in unitsObj) {
          if (hasOwnProp(unitsObj, u4)) {
            units.push({ unit: u4, priority: priorities[u4] });
          }
        }
        units.sort(function(a4, b) {
          return a4.priority - b.priority;
        });
        return units;
      }
      var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
      regexes = {};
      function addRegexToken(token2, regex, strictRegex) {
        regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
          return isStrict && strictRegex ? strictRegex : regex;
        };
      }
      function getParseRegexForToken(token2, config) {
        if (!hasOwnProp(regexes, token2)) {
          return new RegExp(unescapeFormat(token2));
        }
        return regexes[token2](config._strict, config._locale);
      }
      function unescapeFormat(s2) {
        return regexEscape(
          s2.replace("\\", "").replace(
            /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
            function(matched, p1, p2, p3, p4) {
              return p1 || p2 || p3 || p4;
            }
          )
        );
      }
      function regexEscape(s2) {
        return s2.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      function absFloor(number5) {
        if (number5 < 0) {
          return Math.ceil(number5) || 0;
        } else {
          return Math.floor(number5);
        }
      }
      function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
          value = absFloor(coercedNumber);
        }
        return value;
      }
      var tokens = {};
      function addParseToken(token2, callback) {
        var i, func = callback, tokenLen;
        if (typeof token2 === "string") {
          token2 = [token2];
        }
        if (isNumber(callback)) {
          func = function(input, array4) {
            array4[callback] = toInt(input);
          };
        }
        tokenLen = token2.length;
        for (i = 0; i < tokenLen; i++) {
          tokens[token2[i]] = func;
        }
      }
      function addWeekParseToken(token2, callback) {
        addParseToken(token2, function(input, array4, config, token3) {
          config._w = config._w || {};
          callback(input, config._w, config, token3);
        });
      }
      function addTimeToArrayFromToken(token2, input, config) {
        if (input != null && hasOwnProp(tokens, token2)) {
          tokens[token2](input, config._a, config, token2);
        }
      }
      function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
      var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
      addFormatToken("Y", 0, 0, function() {
        var y4 = this.year();
        return y4 <= 9999 ? zeroFill(y4, 4) : "+" + y4;
      });
      addFormatToken(0, ["YY", 2], 0, function() {
        return this.year() % 100;
      });
      addFormatToken(0, ["YYYY", 4], 0, "year");
      addFormatToken(0, ["YYYYY", 5], 0, "year");
      addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
      addRegexToken("Y", matchSigned);
      addRegexToken("YY", match1to2, match2);
      addRegexToken("YYYY", match1to4, match4);
      addRegexToken("YYYYY", match1to6, match6);
      addRegexToken("YYYYYY", match1to6, match6);
      addParseToken(["YYYYY", "YYYYYY"], YEAR);
      addParseToken("YYYY", function(input, array4) {
        array4[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
      });
      addParseToken("YY", function(input, array4) {
        array4[YEAR] = hooks.parseTwoDigitYear(input);
      });
      addParseToken("Y", function(input, array4) {
        array4[YEAR] = parseInt(input, 10);
      });
      function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
      }
      hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
      };
      var getSetYear = makeGetSet("FullYear", true);
      function getIsLeapYear() {
        return isLeapYear(this.year());
      }
      function makeGetSet(unit2, keepTime) {
        return function(value) {
          if (value != null) {
            set$1(this, unit2, value);
            hooks.updateOffset(this, keepTime);
            return this;
          } else {
            return get3(this, unit2);
          }
        };
      }
      function get3(mom, unit2) {
        if (!mom.isValid()) {
          return NaN;
        }
        var d = mom._d, isUTC = mom._isUTC;
        switch (unit2) {
          case "Milliseconds":
            return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
          case "Seconds":
            return isUTC ? d.getUTCSeconds() : d.getSeconds();
          case "Minutes":
            return isUTC ? d.getUTCMinutes() : d.getMinutes();
          case "Hours":
            return isUTC ? d.getUTCHours() : d.getHours();
          case "Date":
            return isUTC ? d.getUTCDate() : d.getDate();
          case "Day":
            return isUTC ? d.getUTCDay() : d.getDay();
          case "Month":
            return isUTC ? d.getUTCMonth() : d.getMonth();
          case "FullYear":
            return isUTC ? d.getUTCFullYear() : d.getFullYear();
          default:
            return NaN;
        }
      }
      function set$1(mom, unit2, value) {
        var d, isUTC, year, month, date2;
        if (!mom.isValid() || isNaN(value)) {
          return;
        }
        d = mom._d;
        isUTC = mom._isUTC;
        switch (unit2) {
          case "Milliseconds":
            return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
          case "Seconds":
            return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
          case "Minutes":
            return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
          case "Hours":
            return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
          case "Date":
            return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
          // case 'Day': // Not real
          //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
          // case 'Month': // Not used because we need to pass two variables
          //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
          case "FullYear":
            break;
          // See below ...
          default:
            return;
        }
        year = value;
        month = mom.month();
        date2 = mom.date();
        date2 = date2 === 29 && month === 1 && !isLeapYear(year) ? 28 : date2;
        void (isUTC ? d.setUTCFullYear(year, month, date2) : d.setFullYear(year, month, date2));
      }
      function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units]();
        }
        return this;
      }
      function stringSet(units, value) {
        if (typeof units === "object") {
          units = normalizeObjectUnits(units);
          var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
          for (i = 0; i < prioritizedLen; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
          }
        } else {
          units = normalizeUnits(units);
          if (isFunction(this[units])) {
            return this[units](value);
          }
        }
        return this;
      }
      function mod(n, x4) {
        return (n % x4 + x4) % x4;
      }
      var indexOf;
      if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(o) {
          var i;
          for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
              return i;
            }
          }
          return -1;
        };
      }
      function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
          return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
      }
      addFormatToken("M", ["MM", 2], "Mo", function() {
        return this.month() + 1;
      });
      addFormatToken("MMM", 0, 0, function(format3) {
        return this.localeData().monthsShort(this, format3);
      });
      addFormatToken("MMMM", 0, 0, function(format3) {
        return this.localeData().months(this, format3);
      });
      addRegexToken("M", match1to2, match1to2NoLeadingZero);
      addRegexToken("MM", match1to2, match2);
      addRegexToken("MMM", function(isStrict, locale4) {
        return locale4.monthsShortRegex(isStrict);
      });
      addRegexToken("MMMM", function(isStrict, locale4) {
        return locale4.monthsRegex(isStrict);
      });
      addParseToken(["M", "MM"], function(input, array4) {
        array4[MONTH] = toInt(input) - 1;
      });
      addParseToken(["MMM", "MMMM"], function(input, array4, config, token2) {
        var month = config._locale.monthsParse(input, token2, config._strict);
        if (month != null) {
          array4[MONTH] = month;
        } else {
          getParsingFlags(config).invalidMonth = input;
        }
      });
      var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
        "_"
      ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
      function localeMonths(m3, format3) {
        if (!m3) {
          return isArray(this._months) ? this._months : this._months["standalone"];
        }
        return isArray(this._months) ? this._months[m3.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format3) ? "format" : "standalone"][m3.month()];
      }
      function localeMonthsShort(m3, format3) {
        if (!m3) {
          return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m3.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format3) ? "format" : "standalone"][m3.month()];
      }
      function handleStrictParse(monthName, format3, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
          this._monthsParse = [];
          this._longMonthsParse = [];
          this._shortMonthsParse = [];
          for (i = 0; i < 12; ++i) {
            mom = createUTC([2e3, i]);
            this._shortMonthsParse[i] = this.monthsShort(
              mom,
              ""
            ).toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
          }
        }
        if (strict) {
          if (format3 === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
          }
        } else {
          if (format3 === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
          }
        }
      }
      function localeMonthsParse(monthName, format3, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) {
          return handleStrictParse.call(this, monthName, format3, strict);
        }
        if (!this._monthsParse) {
          this._monthsParse = [];
          this._longMonthsParse = [];
          this._shortMonthsParse = [];
        }
        for (i = 0; i < 12; i++) {
          mom = createUTC([2e3, i]);
          if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp(
              "^" + this.months(mom, "").replace(".", "") + "$",
              "i"
            );
            this._shortMonthsParse[i] = new RegExp(
              "^" + this.monthsShort(mom, "").replace(".", "") + "$",
              "i"
            );
          }
          if (!strict && !this._monthsParse[i]) {
            regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
            this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
          }
          if (strict && format3 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
            return i;
          } else if (strict && format3 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
            return i;
          } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
          }
        }
      }
      function setMonth(mom, value) {
        if (!mom.isValid()) {
          return mom;
        }
        if (typeof value === "string") {
          if (/^\d+$/.test(value)) {
            value = toInt(value);
          } else {
            value = mom.localeData().monthsParse(value);
            if (!isNumber(value)) {
              return mom;
            }
          }
        }
        var month = value, date2 = mom.date();
        date2 = date2 < 29 ? date2 : Math.min(date2, daysInMonth(mom.year(), month));
        void (mom._isUTC ? mom._d.setUTCMonth(month, date2) : mom._d.setMonth(month, date2));
        return mom;
      }
      function getSetMonth(value) {
        if (value != null) {
          setMonth(this, value);
          hooks.updateOffset(this, true);
          return this;
        } else {
          return get3(this, "Month");
        }
      }
      function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
      }
      function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
          if (!hasOwnProp(this, "_monthsRegex")) {
            computeMonthsParse.call(this);
          }
          if (isStrict) {
            return this._monthsShortStrictRegex;
          } else {
            return this._monthsShortRegex;
          }
        } else {
          if (!hasOwnProp(this, "_monthsShortRegex")) {
            this._monthsShortRegex = defaultMonthsShortRegex;
          }
          return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
      }
      function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
          if (!hasOwnProp(this, "_monthsRegex")) {
            computeMonthsParse.call(this);
          }
          if (isStrict) {
            return this._monthsStrictRegex;
          } else {
            return this._monthsRegex;
          }
        } else {
          if (!hasOwnProp(this, "_monthsRegex")) {
            this._monthsRegex = defaultMonthsRegex;
          }
          return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
      }
      function computeMonthsParse() {
        function cmpLenRev(a4, b) {
          return b.length - a4.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for (i = 0; i < 12; i++) {
          mom = createUTC([2e3, i]);
          shortP = regexEscape(this.monthsShort(mom, ""));
          longP = regexEscape(this.months(mom, ""));
          shortPieces.push(shortP);
          longPieces.push(longP);
          mixedPieces.push(longP);
          mixedPieces.push(shortP);
        }
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
          "^(" + longPieces.join("|") + ")",
          "i"
        );
        this._monthsShortStrictRegex = new RegExp(
          "^(" + shortPieces.join("|") + ")",
          "i"
        );
      }
      function createDate(y4, m3, d, h, M2, s2, ms) {
        var date2;
        if (y4 < 100 && y4 >= 0) {
          date2 = new Date(y4 + 400, m3, d, h, M2, s2, ms);
          if (isFinite(date2.getFullYear())) {
            date2.setFullYear(y4);
          }
        } else {
          date2 = new Date(y4, m3, d, h, M2, s2, ms);
        }
        return date2;
      }
      function createUTCDate(y4) {
        var date2, args;
        if (y4 < 100 && y4 >= 0) {
          args = Array.prototype.slice.call(arguments);
          args[0] = y4 + 400;
          date2 = new Date(Date.UTC.apply(null, args));
          if (isFinite(date2.getUTCFullYear())) {
            date2.setUTCFullYear(y4);
          }
        } else {
          date2 = new Date(Date.UTC.apply(null, arguments));
        }
        return date2;
      }
      function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
      }
      function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
          resYear = year - 1;
          resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
          resYear = year + 1;
          resDayOfYear = dayOfYear - daysInYear(year);
        } else {
          resYear = year;
          resDayOfYear = dayOfYear;
        }
        return {
          year: resYear,
          dayOfYear: resDayOfYear
        };
      }
      function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
          resYear = mom.year() - 1;
          resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
          resWeek = week - weeksInYear(mom.year(), dow, doy);
          resYear = mom.year() + 1;
        } else {
          resYear = mom.year();
          resWeek = week;
        }
        return {
          week: resWeek,
          year: resYear
        };
      }
      function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
      }
      addFormatToken("w", ["ww", 2], "wo", "week");
      addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
      addRegexToken("w", match1to2, match1to2NoLeadingZero);
      addRegexToken("ww", match1to2, match2);
      addRegexToken("W", match1to2, match1to2NoLeadingZero);
      addRegexToken("WW", match1to2, match2);
      addWeekParseToken(
        ["w", "ww", "W", "WW"],
        function(input, week, config, token2) {
          week[token2.substr(0, 1)] = toInt(input);
        }
      );
      function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
      }
      var defaultLocaleWeek = {
        dow: 0,
        // Sunday is the first day of the week.
        doy: 6
        // The week that contains Jan 6th is the first week of the year.
      };
      function localeFirstDayOfWeek() {
        return this._week.dow;
      }
      function localeFirstDayOfYear() {
        return this._week.doy;
      }
      function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
      }
      function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
      }
      addFormatToken("d", 0, "do", "day");
      addFormatToken("dd", 0, 0, function(format3) {
        return this.localeData().weekdaysMin(this, format3);
      });
      addFormatToken("ddd", 0, 0, function(format3) {
        return this.localeData().weekdaysShort(this, format3);
      });
      addFormatToken("dddd", 0, 0, function(format3) {
        return this.localeData().weekdays(this, format3);
      });
      addFormatToken("e", 0, 0, "weekday");
      addFormatToken("E", 0, 0, "isoWeekday");
      addRegexToken("d", match1to2);
      addRegexToken("e", match1to2);
      addRegexToken("E", match1to2);
      addRegexToken("dd", function(isStrict, locale4) {
        return locale4.weekdaysMinRegex(isStrict);
      });
      addRegexToken("ddd", function(isStrict, locale4) {
        return locale4.weekdaysShortRegex(isStrict);
      });
      addRegexToken("dddd", function(isStrict, locale4) {
        return locale4.weekdaysRegex(isStrict);
      });
      addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
        var weekday = config._locale.weekdaysParse(input, token2, config._strict);
        if (weekday != null) {
          week.d = weekday;
        } else {
          getParsingFlags(config).invalidWeekday = input;
        }
      });
      addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
        week[token2] = toInt(input);
      });
      function parseWeekday(input, locale4) {
        if (typeof input !== "string") {
          return input;
        }
        if (!isNaN(input)) {
          return parseInt(input, 10);
        }
        input = locale4.weekdaysParse(input);
        if (typeof input === "number") {
          return input;
        }
        return null;
      }
      function parseIsoWeekday(input, locale4) {
        if (typeof input === "string") {
          return locale4.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
      }
      function shiftWeekdays(ws2, n) {
        return ws2.slice(n, 7).concat(ws2.slice(0, n));
      }
      var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
      function localeWeekdays(m3, format3) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m3 && m3 !== true && this._weekdays.isFormat.test(format3) ? "format" : "standalone"];
        return m3 === true ? shiftWeekdays(weekdays, this._week.dow) : m3 ? weekdays[m3.day()] : weekdays;
      }
      function localeWeekdaysShort(m3) {
        return m3 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m3 ? this._weekdaysShort[m3.day()] : this._weekdaysShort;
      }
      function localeWeekdaysMin(m3) {
        return m3 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m3 ? this._weekdaysMin[m3.day()] : this._weekdaysMin;
      }
      function handleStrictParse$1(weekdayName, format3, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
          this._weekdaysParse = [];
          this._shortWeekdaysParse = [];
          this._minWeekdaysParse = [];
          for (i = 0; i < 7; ++i) {
            mom = createUTC([2e3, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(
              mom,
              ""
            ).toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(
              mom,
              ""
            ).toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
          }
        }
        if (strict) {
          if (format3 === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else if (format3 === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          }
        } else {
          if (format3 === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else if (format3 === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          }
        }
      }
      function localeWeekdaysParse(weekdayName, format3, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) {
          return handleStrictParse$1.call(this, weekdayName, format3, strict);
        }
        if (!this._weekdaysParse) {
          this._weekdaysParse = [];
          this._minWeekdaysParse = [];
          this._shortWeekdaysParse = [];
          this._fullWeekdaysParse = [];
        }
        for (i = 0; i < 7; i++) {
          mom = createUTC([2e3, 1]).day(i);
          if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp(
              "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
            this._shortWeekdaysParse[i] = new RegExp(
              "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
            this._minWeekdaysParse[i] = new RegExp(
              "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
          }
          if (!this._weekdaysParse[i]) {
            regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
            this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
          }
          if (strict && format3 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (strict && format3 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (strict && format3 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
          }
        }
      }
      function getSetDayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        var day = get3(this, "Day");
        if (input != null) {
          input = parseWeekday(input, this.localeData());
          return this.add(input - day, "d");
        } else {
          return day;
        }
      }
      function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
      }
      function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        if (input != null) {
          var weekday = parseIsoWeekday(input, this.localeData());
          return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
          return this.day() || 7;
        }
      }
      function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysStrictRegex;
          } else {
            return this._weekdaysRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            this._weekdaysRegex = defaultWeekdaysRegex;
          }
          return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
      }
      function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysShortStrictRegex;
          } else {
            return this._weekdaysShortRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysShortRegex")) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
          }
          return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
      }
      function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysMinStrictRegex;
          } else {
            return this._weekdaysMinRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysMinRegex")) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
          }
          return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
      }
      function computeWeekdaysParse() {
        function cmpLenRev(a4, b) {
          return b.length - a4.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
          mom = createUTC([2e3, 1]).day(i);
          minp = regexEscape(this.weekdaysMin(mom, ""));
          shortp = regexEscape(this.weekdaysShort(mom, ""));
          longp = regexEscape(this.weekdays(mom, ""));
          minPieces.push(minp);
          shortPieces.push(shortp);
          longPieces.push(longp);
          mixedPieces.push(minp);
          mixedPieces.push(shortp);
          mixedPieces.push(longp);
        }
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp(
          "^(" + longPieces.join("|") + ")",
          "i"
        );
        this._weekdaysShortStrictRegex = new RegExp(
          "^(" + shortPieces.join("|") + ")",
          "i"
        );
        this._weekdaysMinStrictRegex = new RegExp(
          "^(" + minPieces.join("|") + ")",
          "i"
        );
      }
      function hFormat() {
        return this.hours() % 12 || 12;
      }
      function kFormat() {
        return this.hours() || 24;
      }
      addFormatToken("H", ["HH", 2], 0, "hour");
      addFormatToken("h", ["hh", 2], 0, hFormat);
      addFormatToken("k", ["kk", 2], 0, kFormat);
      addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
      });
      addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
      });
      addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
      });
      addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
      });
      function meridiem(token2, lowercase) {
        addFormatToken(token2, 0, 0, function() {
          return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            lowercase
          );
        });
      }
      meridiem("a", true);
      meridiem("A", false);
      function matchMeridiem(isStrict, locale4) {
        return locale4._meridiemParse;
      }
      addRegexToken("a", matchMeridiem);
      addRegexToken("A", matchMeridiem);
      addRegexToken("H", match1to2, match1to2HasZero);
      addRegexToken("h", match1to2, match1to2NoLeadingZero);
      addRegexToken("k", match1to2, match1to2NoLeadingZero);
      addRegexToken("HH", match1to2, match2);
      addRegexToken("hh", match1to2, match2);
      addRegexToken("kk", match1to2, match2);
      addRegexToken("hmm", match3to4);
      addRegexToken("hmmss", match5to6);
      addRegexToken("Hmm", match3to4);
      addRegexToken("Hmmss", match5to6);
      addParseToken(["H", "HH"], HOUR);
      addParseToken(["k", "kk"], function(input, array4, config) {
        var kInput = toInt(input);
        array4[HOUR] = kInput === 24 ? 0 : kInput;
      });
      addParseToken(["a", "A"], function(input, array4, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
      });
      addParseToken(["h", "hh"], function(input, array4, config) {
        array4[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("hmm", function(input, array4, config) {
        var pos = input.length - 2;
        array4[HOUR] = toInt(input.substr(0, pos));
        array4[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("hmmss", function(input, array4, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array4[HOUR] = toInt(input.substr(0, pos1));
        array4[MINUTE] = toInt(input.substr(pos1, 2));
        array4[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("Hmm", function(input, array4, config) {
        var pos = input.length - 2;
        array4[HOUR] = toInt(input.substr(0, pos));
        array4[MINUTE] = toInt(input.substr(pos));
      });
      addParseToken("Hmmss", function(input, array4, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array4[HOUR] = toInt(input.substr(0, pos1));
        array4[MINUTE] = toInt(input.substr(pos1, 2));
        array4[SECOND] = toInt(input.substr(pos2));
      });
      function localeIsPM(input) {
        return (input + "").toLowerCase().charAt(0) === "p";
      }
      var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
      function localeMeridiem(hours2, minutes2, isLower) {
        if (hours2 > 11) {
          return isLower ? "pm" : "PM";
        } else {
          return isLower ? "am" : "AM";
        }
      }
      var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
      };
      var locales = {}, localeFamilies = {}, globalLocale;
      function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
          if (arr1[i] !== arr2[i]) {
            return i;
          }
        }
        return minl;
      }
      function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
      }
      function chooseLocale(names) {
        var i = 0, j, next, locale4, split;
        while (i < names.length) {
          split = normalizeLocale(names[i]).split("-");
          j = split.length;
          next = normalizeLocale(names[i + 1]);
          next = next ? next.split("-") : null;
          while (j > 0) {
            locale4 = loadLocale(split.slice(0, j).join("-"));
            if (locale4) {
              return locale4;
            }
            if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
              break;
            }
            j--;
          }
          i++;
        }
        return globalLocale;
      }
      function isLocaleNameSane(name) {
        return !!(name && name.match("^[^/\\\\]*$"));
      }
      function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        if (locales[name] === void 0 && typeof module2 !== "undefined" && module2 && module2.exports && isLocaleNameSane(name)) {
          try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = require;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
          } catch (e) {
            locales[name] = null;
          }
        }
        return locales[name];
      }
      function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
          if (isUndefined(values)) {
            data = getLocale(key);
          } else {
            data = defineLocale(key, values);
          }
          if (data) {
            globalLocale = data;
          } else {
            if (typeof console !== "undefined" && console.warn) {
              console.warn(
                "Locale " + key + " not found. Did you forget to load it?"
              );
            }
          }
        }
        return globalLocale._abbr;
      }
      function defineLocale(name, config) {
        if (config !== null) {
          var locale4, parentConfig = baseConfig;
          config.abbr = name;
          if (locales[name] != null) {
            deprecateSimple(
              "defineLocaleOverride",
              "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
            );
            parentConfig = locales[name]._config;
          } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
              parentConfig = locales[config.parentLocale]._config;
            } else {
              locale4 = loadLocale(config.parentLocale);
              if (locale4 != null) {
                parentConfig = locale4._config;
              } else {
                if (!localeFamilies[config.parentLocale]) {
                  localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                  name,
                  config
                });
                return null;
              }
            }
          }
          locales[name] = new Locale(mergeConfigs(parentConfig, config));
          if (localeFamilies[name]) {
            localeFamilies[name].forEach(function(x4) {
              defineLocale(x4.name, x4.config);
            });
          }
          getSetGlobalLocale(name);
          return locales[name];
        } else {
          delete locales[name];
          return null;
        }
      }
      function updateLocale(name, config) {
        if (config != null) {
          var locale4, tmpLocale, parentConfig = baseConfig;
          if (locales[name] != null && locales[name].parentLocale != null) {
            locales[name].set(mergeConfigs(locales[name]._config, config));
          } else {
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
              parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            if (tmpLocale == null) {
              config.abbr = name;
            }
            locale4 = new Locale(config);
            locale4.parentLocale = locales[name];
            locales[name] = locale4;
          }
          getSetGlobalLocale(name);
        } else {
          if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
              locales[name] = locales[name].parentLocale;
              if (name === getSetGlobalLocale()) {
                getSetGlobalLocale(name);
              }
            } else if (locales[name] != null) {
              delete locales[name];
            }
          }
        }
        return locales[name];
      }
      function getLocale(key) {
        var locale4;
        if (key && key._locale && key._locale._abbr) {
          key = key._locale._abbr;
        }
        if (!key) {
          return globalLocale;
        }
        if (!isArray(key)) {
          locale4 = loadLocale(key);
          if (locale4) {
            return locale4;
          }
          key = [key];
        }
        return chooseLocale(key);
      }
      function listLocales() {
        return keys(locales);
      }
      function checkOverflow(m3) {
        var overflow, a4 = m3._a;
        if (a4 && getParsingFlags(m3).overflow === -2) {
          overflow = a4[MONTH] < 0 || a4[MONTH] > 11 ? MONTH : a4[DATE] < 1 || a4[DATE] > daysInMonth(a4[YEAR], a4[MONTH]) ? DATE : a4[HOUR] < 0 || a4[HOUR] > 24 || a4[HOUR] === 24 && (a4[MINUTE] !== 0 || a4[SECOND] !== 0 || a4[MILLISECOND] !== 0) ? HOUR : a4[MINUTE] < 0 || a4[MINUTE] > 59 ? MINUTE : a4[SECOND] < 0 || a4[SECOND] > 59 ? SECOND : a4[MILLISECOND] < 0 || a4[MILLISECOND] > 999 ? MILLISECOND : -1;
          if (getParsingFlags(m3)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
          }
          if (getParsingFlags(m3)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
          }
          if (getParsingFlags(m3)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
          }
          getParsingFlags(m3).overflow = overflow;
        }
        return m3;
      }
      var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
        ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
        ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
        ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
        ["YYYY-DDD", /\d{4}-\d{3}/],
        ["YYYY-MM", /\d{4}-\d\d/, false],
        ["YYYYYYMMDD", /[+-]\d{10}/],
        ["YYYYMMDD", /\d{8}/],
        ["GGGG[W]WWE", /\d{4}W\d{3}/],
        ["GGGG[W]WW", /\d{4}W\d{2}/, false],
        ["YYYYDDD", /\d{7}/],
        ["YYYYMM", /\d{6}/, false],
        ["YYYY", /\d{4}/, false]
      ], isoTimes = [
        ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
        ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
        ["HH:mm:ss", /\d\d:\d\d:\d\d/],
        ["HH:mm", /\d\d:\d\d/],
        ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
        ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
        ["HHmmss", /\d\d\d\d\d\d/],
        ["HHmm", /\d\d\d\d/],
        ["HH", /\d\d/]
      ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
      function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat2, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
          getParsingFlags(config).iso = true;
          for (i = 0, l = isoDatesLen; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
              dateFormat = isoDates[i][0];
              allowTime = isoDates[i][2] !== false;
              break;
            }
          }
          if (dateFormat == null) {
            config._isValid = false;
            return;
          }
          if (match[3]) {
            for (i = 0, l = isoTimesLen; i < l; i++) {
              if (isoTimes[i][1].exec(match[3])) {
                timeFormat2 = (match[2] || " ") + isoTimes[i][0];
                break;
              }
            }
            if (timeFormat2 == null) {
              config._isValid = false;
              return;
            }
          }
          if (!allowTime && timeFormat2 != null) {
            config._isValid = false;
            return;
          }
          if (match[4]) {
            if (tzRegex.exec(match[4])) {
              tzFormat = "Z";
            } else {
              config._isValid = false;
              return;
            }
          }
          config._f = dateFormat + (timeFormat2 || "") + (tzFormat || "");
          configFromStringAndFormat(config);
        } else {
          config._isValid = false;
        }
      }
      function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
          untruncateYear(yearStr),
          defaultLocaleMonthsShort.indexOf(monthStr),
          parseInt(dayStr, 10),
          parseInt(hourStr, 10),
          parseInt(minuteStr, 10)
        ];
        if (secondStr) {
          result.push(parseInt(secondStr, 10));
        }
        return result;
      }
      function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
          return 2e3 + year;
        } else if (year <= 999) {
          return 1900 + year;
        }
        return year;
      }
      function preprocessRFC2822(s2) {
        return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
      }
      function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
          var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
            parsedInput[0],
            parsedInput[1],
            parsedInput[2]
          ).getDay();
          if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
          }
        }
        return true;
      }
      function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
          return obsOffsets[obsOffset];
        } else if (militaryOffset) {
          return 0;
        } else {
          var hm = parseInt(numOffset, 10), m3 = hm % 100, h = (hm - m3) / 100;
          return h * 60 + m3;
        }
      }
      function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
          parsedArray = extractFromRFC2822Strings(
            match[4],
            match[3],
            match[2],
            match[5],
            match[6],
            match[7]
          );
          if (!checkWeekday(match[1], parsedArray, config)) {
            return;
          }
          config._a = parsedArray;
          config._tzm = calculateOffset(match[8], match[9], match[10]);
          config._d = createUTCDate.apply(null, config._a);
          config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
          getParsingFlags(config).rfc2822 = true;
        } else {
          config._isValid = false;
        }
      }
      function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
          config._d = /* @__PURE__ */ new Date(+matched[1]);
          return;
        }
        configFromISO(config);
        if (config._isValid === false) {
          delete config._isValid;
        } else {
          return;
        }
        configFromRFC2822(config);
        if (config._isValid === false) {
          delete config._isValid;
        } else {
          return;
        }
        if (config._strict) {
          config._isValid = false;
        } else {
          hooks.createFromInputFallback(config);
        }
      }
      hooks.createFromInputFallback = deprecate(
        "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
        function(config) {
          config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
        }
      );
      function defaults(a4, b, c6) {
        if (a4 != null) {
          return a4;
        }
        if (b != null) {
          return b;
        }
        return c6;
      }
      function currentDateArray(config) {
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
          return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
          ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
      }
      function configFromArray(config) {
        var i, date2, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) {
          return;
        }
        currentDate = currentDateArray(config);
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
          dayOfYearFromWeekInfo(config);
        }
        if (config._dayOfYear != null) {
          yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
          if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
          }
          date2 = createUTCDate(yearToUse, 0, config._dayOfYear);
          config._a[MONTH] = date2.getUTCMonth();
          config._a[DATE] = date2.getUTCDate();
        }
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
          config._a[i] = input[i] = currentDate[i];
        }
        for (; i < 7; i++) {
          config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
          config._nextDay = true;
          config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(
          null,
          input
        );
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        if (config._tzm != null) {
          config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }
        if (config._nextDay) {
          config._a[HOUR] = 24;
        }
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
          getParsingFlags(config).weekdayMismatch = true;
        }
      }
      function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
          dow = 1;
          doy = 4;
          weekYear = defaults(
            w.GG,
            config._a[YEAR],
            weekOfYear(createLocal(), 1, 4).year
          );
          week = defaults(w.W, 1);
          weekday = defaults(w.E, 1);
          if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
          }
        } else {
          dow = config._locale._week.dow;
          doy = config._locale._week.doy;
          curWeek = weekOfYear(createLocal(), dow, doy);
          weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
          week = defaults(w.w, curWeek.week);
          if (w.d != null) {
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
              weekdayOverflow = true;
            }
          } else if (w.e != null) {
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
              weekdayOverflow = true;
            }
          } else {
            weekday = dow;
          }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
          getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
          getParsingFlags(config)._overflowWeekday = true;
        } else {
          temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
          config._a[YEAR] = temp.year;
          config._dayOfYear = temp.dayOfYear;
        }
      }
      hooks.ISO_8601 = function() {
      };
      hooks.RFC_2822 = function() {
      };
      function configFromStringAndFormat(config) {
        if (config._f === hooks.ISO_8601) {
          configFromISO(config);
          return;
        }
        if (config._f === hooks.RFC_2822) {
          configFromRFC2822(config);
          return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens2.length;
        for (i = 0; i < tokenLen; i++) {
          token2 = tokens2[i];
          parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
          if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
              getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(
              string.indexOf(parsedInput) + parsedInput.length
            );
            totalParsedInputLength += parsedInput.length;
          }
          if (formatTokenFunctions[token2]) {
            if (parsedInput) {
              getParsingFlags(config).empty = false;
            } else {
              getParsingFlags(config).unusedTokens.push(token2);
            }
            addTimeToArrayFromToken(token2, parsedInput, config);
          } else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token2);
          }
        }
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
          getParsingFlags(config).unusedInput.push(string);
        }
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
          getParsingFlags(config).bigHour = void 0;
        }
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        config._a[HOUR] = meridiemFixWrap(
          config._locale,
          config._a[HOUR],
          config._meridiem
        );
        era = getParsingFlags(config).era;
        if (era !== null) {
          config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }
        configFromArray(config);
        checkOverflow(config);
      }
      function meridiemFixWrap(locale4, hour, meridiem2) {
        var isPm;
        if (meridiem2 == null) {
          return hour;
        }
        if (locale4.meridiemHour != null) {
          return locale4.meridiemHour(hour, meridiem2);
        } else if (locale4.isPM != null) {
          isPm = locale4.isPM(meridiem2);
          if (isPm && hour < 12) {
            hour += 12;
          }
          if (!isPm && hour === 12) {
            hour = 0;
          }
          return hour;
        } else {
          return hour;
        }
      }
      function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
          getParsingFlags(config).invalidFormat = true;
          config._d = /* @__PURE__ */ new Date(NaN);
          return;
        }
        for (i = 0; i < configfLen; i++) {
          currentScore = 0;
          validFormatFound = false;
          tempConfig = copyConfig({}, config);
          if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
          }
          tempConfig._f = config._f[i];
          configFromStringAndFormat(tempConfig);
          if (isValid(tempConfig)) {
            validFormatFound = true;
          }
          currentScore += getParsingFlags(tempConfig).charsLeftOver;
          currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
          getParsingFlags(tempConfig).score = currentScore;
          if (!bestFormatIsValid) {
            if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
              scoreToBeat = currentScore;
              bestMoment = tempConfig;
              if (validFormatFound) {
                bestFormatIsValid = true;
              }
            }
          } else {
            if (currentScore < scoreToBeat) {
              scoreToBeat = currentScore;
              bestMoment = tempConfig;
            }
          }
        }
        extend2(config, bestMoment || tempConfig);
      }
      function configFromObject(config) {
        if (config._d) {
          return;
        }
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
        config._a = map4(
          [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
          function(obj) {
            return obj && parseInt(obj, 10);
          }
        );
        configFromArray(config);
      }
      function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
          res.add(1, "d");
          res._nextDay = void 0;
        }
        return res;
      }
      function prepareConfig(config) {
        var input = config._i, format3 = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format3 === void 0 && input === "") {
          return createInvalid({ nullInput: true });
        }
        if (typeof input === "string") {
          config._i = input = config._locale.preparse(input);
        }
        if (isMoment(input)) {
          return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
          config._d = input;
        } else if (isArray(format3)) {
          configFromStringAndArray(config);
        } else if (format3) {
          configFromStringAndFormat(config);
        } else {
          configFromInput(config);
        }
        if (!isValid(config)) {
          config._d = null;
        }
        return config;
      }
      function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
          config._d = new Date(hooks.now());
        } else if (isDate(input)) {
          config._d = new Date(input.valueOf());
        } else if (typeof input === "string") {
          configFromString(config);
        } else if (isArray(input)) {
          config._a = map4(input.slice(0), function(obj) {
            return parseInt(obj, 10);
          });
          configFromArray(config);
        } else if (isObject(input)) {
          configFromObject(config);
        } else if (isNumber(input)) {
          config._d = new Date(input);
        } else {
          hooks.createFromInputFallback(config);
        }
      }
      function createLocalOrUTC(input, format3, locale4, strict, isUTC) {
        var c6 = {};
        if (format3 === true || format3 === false) {
          strict = format3;
          format3 = void 0;
        }
        if (locale4 === true || locale4 === false) {
          strict = locale4;
          locale4 = void 0;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
          input = void 0;
        }
        c6._isAMomentObject = true;
        c6._useUTC = c6._isUTC = isUTC;
        c6._l = locale4;
        c6._i = input;
        c6._f = format3;
        c6._strict = strict;
        return createFromConfig(c6);
      }
      function createLocal(input, format3, locale4, strict) {
        return createLocalOrUTC(input, format3, locale4, strict, false);
      }
      var prototypeMin = deprecate(
        "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var other = createLocal.apply(null, arguments);
          if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
          } else {
            return createInvalid();
          }
        }
      ), prototypeMax = deprecate(
        "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var other = createLocal.apply(null, arguments);
          if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
          } else {
            return createInvalid();
          }
        }
      );
      function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
          moments = moments[0];
        }
        if (!moments.length) {
          return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
          if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
          }
        }
        return res;
      }
      function min4() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
      }
      function max5() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
      }
      var now2 = function() {
        return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
      };
      var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
      ];
      function isDurationValid(m3) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for (key in m3) {
          if (hasOwnProp(m3, key) && !(indexOf.call(ordering, key) !== -1 && (m3[key] == null || !isNaN(m3[key])))) {
            return false;
          }
        }
        for (i = 0; i < orderLen; ++i) {
          if (m3[ordering[i]]) {
            if (unitHasDecimal) {
              return false;
            }
            if (parseFloat(m3[ordering[i]]) !== toInt(m3[ordering[i]])) {
              unitHasDecimal = true;
            }
          }
        }
        return true;
      }
      function isValid$1() {
        return this._isValid;
      }
      function createInvalid$1() {
        return createDuration(NaN);
      }
      function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds3 = normalizedInput.second || 0, milliseconds3 = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        this._milliseconds = +milliseconds3 + seconds3 * 1e3 + // 1000
        minutes2 * 6e4 + // 1000 * 60
        hours2 * 1e3 * 60 * 60;
        this._days = +days2 + weeks2 * 7;
        this._months = +months2 + quarters * 3 + years2 * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
      }
      function isDuration(obj) {
        return obj instanceof Duration;
      }
      function absRound(number5) {
        if (number5 < 0) {
          return Math.round(-1 * number5) * -1;
        } else {
          return Math.round(number5);
        }
      }
      function compareArrays(array1, array22, dontConvert) {
        var len = Math.min(array1.length, array22.length), lengthDiff = Math.abs(array1.length - array22.length), diffs = 0, i;
        for (i = 0; i < len; i++) {
          if (dontConvert && array1[i] !== array22[i] || !dontConvert && toInt(array1[i]) !== toInt(array22[i])) {
            diffs++;
          }
        }
        return diffs + lengthDiff;
      }
      function offset(token2, separator) {
        addFormatToken(token2, 0, 0, function() {
          var offset2 = this.utcOffset(), sign4 = "+";
          if (offset2 < 0) {
            offset2 = -offset2;
            sign4 = "-";
          }
          return sign4 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
        });
      }
      offset("Z", ":");
      offset("ZZ", "");
      addRegexToken("Z", matchShortOffset);
      addRegexToken("ZZ", matchShortOffset);
      addParseToken(["Z", "ZZ"], function(input, array4, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
      });
      var chunkOffset = /([\+\-]|\d\d)/gi;
      function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes2;
        if (matches === null) {
          return null;
        }
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
        minutes2 = +(parts[1] * 60) + toInt(parts[2]);
        return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
      }
      function cloneWithOffset(input, model) {
        var res, diff2;
        if (model._isUTC) {
          res = model.clone();
          diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
          res._d.setTime(res._d.valueOf() + diff2);
          hooks.updateOffset(res, false);
          return res;
        } else {
          return createLocal(input).local();
        }
      }
      function getDateOffset(m3) {
        return -Math.round(m3._d.getTimezoneOffset());
      }
      hooks.updateOffset = function() {
      };
      function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset2 = this._offset || 0, localAdjust;
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        if (input != null) {
          if (typeof input === "string") {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
              return this;
            }
          } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
          }
          if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
          }
          this._offset = input;
          this._isUTC = true;
          if (localAdjust != null) {
            this.add(localAdjust, "m");
          }
          if (offset2 !== input) {
            if (!keepLocalTime || this._changeInProgress) {
              addSubtract(
                this,
                createDuration(input - offset2, "m"),
                1,
                false
              );
            } else if (!this._changeInProgress) {
              this._changeInProgress = true;
              hooks.updateOffset(this, true);
              this._changeInProgress = null;
            }
          }
          return this;
        } else {
          return this._isUTC ? offset2 : getDateOffset(this);
        }
      }
      function getSetZone(input, keepLocalTime) {
        if (input != null) {
          if (typeof input !== "string") {
            input = -input;
          }
          this.utcOffset(input, keepLocalTime);
          return this;
        } else {
          return -this.utcOffset();
        }
      }
      function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
      }
      function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
          this.utcOffset(0, keepLocalTime);
          this._isUTC = false;
          if (keepLocalTime) {
            this.subtract(getDateOffset(this), "m");
          }
        }
        return this;
      }
      function setOffsetToParsedOffset() {
        if (this._tzm != null) {
          this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === "string") {
          var tZone = offsetFromString(matchOffset, this._i);
          if (tZone != null) {
            this.utcOffset(tZone);
          } else {
            this.utcOffset(0, true);
          }
        }
        return this;
      }
      function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
          return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
      }
      function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }
      function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
          return this._isDSTShifted;
        }
        var c6 = {}, other;
        copyConfig(c6, this);
        c6 = prepareConfig(c6);
        if (c6._a) {
          other = c6._isUTC ? createUTC(c6._a) : createLocal(c6._a);
          this._isDSTShifted = this.isValid() && compareArrays(c6._a, other.toArray()) > 0;
        } else {
          this._isDSTShifted = false;
        }
        return this._isDSTShifted;
      }
      function isLocal() {
        return this.isValid() ? !this._isUTC : false;
      }
      function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
      }
      function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
      }
      var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
      function createDuration(input, key) {
        var duration = input, match = null, sign4, ret, diffRes;
        if (isDuration(input)) {
          duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
          };
        } else if (isNumber(input) || !isNaN(+input)) {
          duration = {};
          if (key) {
            duration[key] = +input;
          } else {
            duration.milliseconds = +input;
          }
        } else if (match = aspNetRegex.exec(input)) {
          sign4 = match[1] === "-" ? -1 : 1;
          duration = {
            y: 0,
            d: toInt(match[DATE]) * sign4,
            h: toInt(match[HOUR]) * sign4,
            m: toInt(match[MINUTE]) * sign4,
            s: toInt(match[SECOND]) * sign4,
            ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign4
            // the millisecond decimal point is included in the match
          };
        } else if (match = isoRegex.exec(input)) {
          sign4 = match[1] === "-" ? -1 : 1;
          duration = {
            y: parseIso2(match[2], sign4),
            M: parseIso2(match[3], sign4),
            w: parseIso2(match[4], sign4),
            d: parseIso2(match[5], sign4),
            h: parseIso2(match[6], sign4),
            m: parseIso2(match[7], sign4),
            s: parseIso2(match[8], sign4)
          };
        } else if (duration == null) {
          duration = {};
        } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
          diffRes = momentsDifference(
            createLocal(duration.from),
            createLocal(duration.to)
          );
          duration = {};
          duration.ms = diffRes.milliseconds;
          duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) {
          ret._locale = input._locale;
        }
        if (isDuration(input) && hasOwnProp(input, "_isValid")) {
          ret._isValid = input._isValid;
        }
        return ret;
      }
      createDuration.fn = Duration.prototype;
      createDuration.invalid = createInvalid$1;
      function parseIso2(inp, sign4) {
        var res = inp && parseFloat(inp.replace(",", "."));
        return (isNaN(res) ? 0 : res) * sign4;
      }
      function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) {
          --res.months;
        }
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
      }
      function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
          return { milliseconds: 0, months: 0 };
        }
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
          res = positiveMomentsDifference(base, other);
        } else {
          res = positiveMomentsDifference(other, base);
          res.milliseconds = -res.milliseconds;
          res.months = -res.months;
        }
        return res;
      }
      function createAdder(direction, name) {
        return function(val, period2) {
          var dur, tmp;
          if (period2 !== null && !isNaN(+period2)) {
            deprecateSimple(
              name,
              "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
            );
            tmp = val;
            val = period2;
            period2 = tmp;
          }
          dur = createDuration(val, period2);
          addSubtract(this, dur, direction);
          return this;
        };
      }
      function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds3 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
        if (!mom.isValid()) {
          return;
        }
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months2) {
          setMonth(mom, get3(mom, "Month") + months2 * isAdding);
        }
        if (days2) {
          set$1(mom, "Date", get3(mom, "Date") + days2 * isAdding);
        }
        if (milliseconds3) {
          mom._d.setTime(mom._d.valueOf() + milliseconds3 * isAdding);
        }
        if (updateOffset) {
          hooks.updateOffset(mom, days2 || months2);
        }
      }
      var add2 = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
      function isString(input) {
        return typeof input === "string" || input instanceof String;
      }
      function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
      }
      function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
          "years",
          "year",
          "y",
          "months",
          "month",
          "M",
          "days",
          "day",
          "d",
          "dates",
          "date",
          "D",
          "hours",
          "hour",
          "h",
          "minutes",
          "minute",
          "m",
          "seconds",
          "second",
          "s",
          "milliseconds",
          "millisecond",
          "ms"
        ], i, property, propertyLen = properties.length;
        for (i = 0; i < propertyLen; i += 1) {
          property = properties[i];
          propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
      }
      function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) {
          dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
          }).length === 0;
        }
        return arrayTest && dataTypeTest;
      }
      function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
          "sameDay",
          "nextDay",
          "lastDay",
          "nextWeek",
          "lastWeek",
          "sameElse"
        ], i, property;
        for (i = 0; i < properties.length; i += 1) {
          property = properties[i];
          propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
      }
      function getCalendarFormat(myMoment, now3) {
        var diff2 = myMoment.diff(now3, "days", true);
        return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
      }
      function calendar$1(time2, formats) {
        if (arguments.length === 1) {
          if (!arguments[0]) {
            time2 = void 0;
            formats = void 0;
          } else if (isMomentInput(arguments[0])) {
            time2 = arguments[0];
            formats = void 0;
          } else if (isCalendarSpec(arguments[0])) {
            formats = arguments[0];
            time2 = void 0;
          }
        }
        var now3 = time2 || createLocal(), sod = cloneWithOffset(now3, this).startOf("day"), format3 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format3]) ? formats[format3].call(this, now3) : formats[format3]);
        return this.format(
          output || this.localeData().calendar(format3, this, createLocal(now3))
        );
      }
      function clone() {
        return new Moment(this);
      }
      function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() > localInput.valueOf();
        } else {
          return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
      }
      function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() < localInput.valueOf();
        } else {
          return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
      }
      function isBetween(from2, to2, units, inclusivity) {
        var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
          return false;
        }
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
      }
      function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() === localInput.valueOf();
        } else {
          inputMs = localInput.valueOf();
          return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
      }
      function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
      }
      function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
      }
      function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) {
          return NaN;
        }
        that = cloneWithOffset(input, this);
        if (!that.isValid()) {
          return NaN;
        }
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch (units) {
          case "year":
            output = monthDiff(this, that) / 12;
            break;
          case "month":
            output = monthDiff(this, that);
            break;
          case "quarter":
            output = monthDiff(this, that) / 3;
            break;
          case "second":
            output = (this - that) / 1e3;
            break;
          // 1000
          case "minute":
            output = (this - that) / 6e4;
            break;
          // 1000 * 60
          case "hour":
            output = (this - that) / 36e5;
            break;
          // 1000 * 60 * 60
          case "day":
            output = (this - that - zoneDelta) / 864e5;
            break;
          // 1000 * 60 * 60 * 24, negate dst
          case "week":
            output = (this - that - zoneDelta) / 6048e5;
            break;
          // 1000 * 60 * 60 * 24 * 7, negate dst
          default:
            output = this - that;
        }
        return asFloat ? output : absFloor(output);
      }
      function monthDiff(a4, b) {
        if (a4.date() < b.date()) {
          return -monthDiff(b, a4);
        }
        var wholeMonthDiff = (b.year() - a4.year()) * 12 + (b.month() - a4.month()), anchor = a4.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
          anchor2 = a4.clone().add(wholeMonthDiff - 1, "months");
          adjust = (b - anchor) / (anchor - anchor2);
        } else {
          anchor2 = a4.clone().add(wholeMonthDiff + 1, "months");
          adjust = (b - anchor) / (anchor2 - anchor);
        }
        return -(wholeMonthDiff + adjust) || 0;
      }
      hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
      hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }
      function toISOString(keepOffset) {
        if (!this.isValid()) {
          return null;
        }
        var utc = keepOffset !== true, m3 = utc ? this.clone().utc() : this;
        if (m3.year() < 0 || m3.year() > 9999) {
          return formatMoment(
            m3,
            utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
          );
        }
        if (isFunction(Date.prototype.toISOString)) {
          if (utc) {
            return this.toDate().toISOString();
          } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m3, "Z"));
          }
        }
        return formatMoment(
          m3,
          utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      function inspect() {
        if (!this.isValid()) {
          return "moment.invalid(/* " + this._i + " */)";
        }
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
          func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
          zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
      }
      function format2(inputString) {
        if (!inputString) {
          inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
      }
      function from(time2, withoutSuffix) {
        if (this.isValid() && (isMoment(time2) && time2.isValid() || createLocal(time2).isValid())) {
          return createDuration({ to: this, from: time2 }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
          return this.localeData().invalidDate();
        }
      }
      function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
      }
      function to(time2, withoutSuffix) {
        if (this.isValid() && (isMoment(time2) && time2.isValid() || createLocal(time2).isValid())) {
          return createDuration({ from: this, to: time2 }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
          return this.localeData().invalidDate();
        }
      }
      function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
      }
      function locale3(key) {
        var newLocaleData;
        if (key === void 0) {
          return this._locale._abbr;
        } else {
          newLocaleData = getLocale(key);
          if (newLocaleData != null) {
            this._locale = newLocaleData;
          }
          return this;
        }
      }
      var lang = deprecate(
        "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
        function(key) {
          if (key === void 0) {
            return this.localeData();
          } else {
            return this.locale(key);
          }
        }
      );
      function localeData() {
        return this._locale;
      }
      var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
      function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
      }
      function localStartOfDate(y4, m3, d) {
        if (y4 < 100 && y4 >= 0) {
          return new Date(y4 + 400, m3, d) - MS_PER_400_YEARS;
        } else {
          return new Date(y4, m3, d).valueOf();
        }
      }
      function utcStartOfDate(y4, m3, d) {
        if (y4 < 100 && y4 >= 0) {
          return Date.UTC(y4 + 400, m3, d) - MS_PER_400_YEARS;
        } else {
          return Date.UTC(y4, m3, d);
        }
      }
      function startOf(units) {
        var time2, startOfDate;
        units = normalizeUnits(units);
        if (units === void 0 || units === "millisecond" || !this.isValid()) {
          return this;
        }
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch (units) {
          case "year":
            time2 = startOfDate(this.year(), 0, 1);
            break;
          case "quarter":
            time2 = startOfDate(
              this.year(),
              this.month() - this.month() % 3,
              1
            );
            break;
          case "month":
            time2 = startOfDate(this.year(), this.month(), 1);
            break;
          case "week":
            time2 = startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday()
            );
            break;
          case "isoWeek":
            time2 = startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1)
            );
            break;
          case "day":
          case "date":
            time2 = startOfDate(this.year(), this.month(), this.date());
            break;
          case "hour":
            time2 = this._d.valueOf();
            time2 -= mod$1(
              time2 + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            );
            break;
          case "minute":
            time2 = this._d.valueOf();
            time2 -= mod$1(time2, MS_PER_MINUTE);
            break;
          case "second":
            time2 = this._d.valueOf();
            time2 -= mod$1(time2, MS_PER_SECOND);
            break;
        }
        this._d.setTime(time2);
        hooks.updateOffset(this, true);
        return this;
      }
      function endOf(units) {
        var time2, startOfDate;
        units = normalizeUnits(units);
        if (units === void 0 || units === "millisecond" || !this.isValid()) {
          return this;
        }
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch (units) {
          case "year":
            time2 = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
          case "quarter":
            time2 = startOfDate(
              this.year(),
              this.month() - this.month() % 3 + 3,
              1
            ) - 1;
            break;
          case "month":
            time2 = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
          case "week":
            time2 = startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday() + 7
            ) - 1;
            break;
          case "isoWeek":
            time2 = startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1) + 7
            ) - 1;
            break;
          case "day":
          case "date":
            time2 = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
          case "hour":
            time2 = this._d.valueOf();
            time2 += MS_PER_HOUR - mod$1(
              time2 + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            ) - 1;
            break;
          case "minute":
            time2 = this._d.valueOf();
            time2 += MS_PER_MINUTE - mod$1(time2, MS_PER_MINUTE) - 1;
            break;
          case "second":
            time2 = this._d.valueOf();
            time2 += MS_PER_SECOND - mod$1(time2, MS_PER_SECOND) - 1;
            break;
        }
        this._d.setTime(time2);
        hooks.updateOffset(this, true);
        return this;
      }
      function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 6e4;
      }
      function unix() {
        return Math.floor(this.valueOf() / 1e3);
      }
      function toDate() {
        return new Date(this.valueOf());
      }
      function toArray() {
        var m3 = this;
        return [
          m3.year(),
          m3.month(),
          m3.date(),
          m3.hour(),
          m3.minute(),
          m3.second(),
          m3.millisecond()
        ];
      }
      function toObject() {
        var m3 = this;
        return {
          years: m3.year(),
          months: m3.month(),
          date: m3.date(),
          hours: m3.hours(),
          minutes: m3.minutes(),
          seconds: m3.seconds(),
          milliseconds: m3.milliseconds()
        };
      }
      function toJSON() {
        return this.isValid() ? this.toISOString() : null;
      }
      function isValid$2() {
        return isValid(this);
      }
      function parsingFlags() {
        return extend2({}, getParsingFlags(this));
      }
      function invalidAt() {
        return getParsingFlags(this).overflow;
      }
      function creationData() {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }
      addFormatToken("N", 0, 0, "eraAbbr");
      addFormatToken("NN", 0, 0, "eraAbbr");
      addFormatToken("NNN", 0, 0, "eraAbbr");
      addFormatToken("NNNN", 0, 0, "eraName");
      addFormatToken("NNNNN", 0, 0, "eraNarrow");
      addFormatToken("y", ["y", 1], "yo", "eraYear");
      addFormatToken("y", ["yy", 2], 0, "eraYear");
      addFormatToken("y", ["yyy", 3], 0, "eraYear");
      addFormatToken("y", ["yyyy", 4], 0, "eraYear");
      addRegexToken("N", matchEraAbbr);
      addRegexToken("NN", matchEraAbbr);
      addRegexToken("NNN", matchEraAbbr);
      addRegexToken("NNNN", matchEraName);
      addRegexToken("NNNNN", matchEraNarrow);
      addParseToken(
        ["N", "NN", "NNN", "NNNN", "NNNNN"],
        function(input, array4, config, token2) {
          var era = config._locale.erasParse(input, token2, config._strict);
          if (era) {
            getParsingFlags(config).era = era;
          } else {
            getParsingFlags(config).invalidEra = input;
          }
        }
      );
      addRegexToken("y", matchUnsigned);
      addRegexToken("yy", matchUnsigned);
      addRegexToken("yyy", matchUnsigned);
      addRegexToken("yyyy", matchUnsigned);
      addRegexToken("yo", matchEraYearOrdinal);
      addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
      addParseToken(["yo"], function(input, array4, config, token2) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
          match = input.match(config._locale._eraYearOrdinalRegex);
        }
        if (config._locale.eraYearOrdinalParse) {
          array4[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
          array4[YEAR] = parseInt(input, 10);
        }
      });
      function localeEras(m3, format3) {
        var i, l, date2, eras = this._eras || getLocale("en")._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
          switch (typeof eras[i].since) {
            case "string":
              date2 = hooks(eras[i].since).startOf("day");
              eras[i].since = date2.valueOf();
              break;
          }
          switch (typeof eras[i].until) {
            case "undefined":
              eras[i].until = Infinity;
              break;
            case "string":
              date2 = hooks(eras[i].until).startOf("day").valueOf();
              eras[i].until = date2.valueOf();
              break;
          }
        }
        return eras;
      }
      function localeErasParse(eraName, format3, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for (i = 0, l = eras.length; i < l; ++i) {
          name = eras[i].name.toUpperCase();
          abbr = eras[i].abbr.toUpperCase();
          narrow = eras[i].narrow.toUpperCase();
          if (strict) {
            switch (format3) {
              case "N":
              case "NN":
              case "NNN":
                if (abbr === eraName) {
                  return eras[i];
                }
                break;
              case "NNNN":
                if (name === eraName) {
                  return eras[i];
                }
                break;
              case "NNNNN":
                if (narrow === eraName) {
                  return eras[i];
                }
                break;
            }
          } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
            return eras[i];
          }
        }
      }
      function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === void 0) {
          return hooks(era.since).year();
        } else {
          return hooks(era.since).year() + (year - era.offset) * dir;
        }
      }
      function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].name;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].name;
          }
        }
        return "";
      }
      function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].narrow;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].narrow;
          }
        }
        return "";
      }
      function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].abbr;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].abbr;
          }
        }
        return "";
      }
      function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          dir = eras[i].since <= eras[i].until ? 1 : -1;
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
            return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
          }
        }
        return this.year();
      }
      function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
      }
      function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
      }
      function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
      }
      function matchEraAbbr(isStrict, locale4) {
        return locale4.erasAbbrRegex(isStrict);
      }
      function matchEraName(isStrict, locale4) {
        return locale4.erasNameRegex(isStrict);
      }
      function matchEraNarrow(isStrict, locale4) {
        return locale4.erasNarrowRegex(isStrict);
      }
      function matchEraYearOrdinal(isStrict, locale4) {
        return locale4._eraYearOrdinalRegex || matchUnsigned;
      }
      function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          erasName = regexEscape(eras[i].name);
          erasAbbr = regexEscape(eras[i].abbr);
          erasNarrow = regexEscape(eras[i].narrow);
          namePieces.push(erasName);
          abbrPieces.push(erasAbbr);
          narrowPieces.push(erasNarrow);
          mixedPieces.push(erasName);
          mixedPieces.push(erasAbbr);
          mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp(
          "^(" + narrowPieces.join("|") + ")",
          "i"
        );
      }
      addFormatToken(0, ["gg", 2], 0, function() {
        return this.weekYear() % 100;
      });
      addFormatToken(0, ["GG", 2], 0, function() {
        return this.isoWeekYear() % 100;
      });
      function addWeekYearFormatToken(token2, getter) {
        addFormatToken(0, [token2, token2.length], 0, getter);
      }
      addWeekYearFormatToken("gggg", "weekYear");
      addWeekYearFormatToken("ggggg", "weekYear");
      addWeekYearFormatToken("GGGG", "isoWeekYear");
      addWeekYearFormatToken("GGGGG", "isoWeekYear");
      addRegexToken("G", matchSigned);
      addRegexToken("g", matchSigned);
      addRegexToken("GG", match1to2, match2);
      addRegexToken("gg", match1to2, match2);
      addRegexToken("GGGG", match1to4, match4);
      addRegexToken("gggg", match1to4, match4);
      addRegexToken("GGGGG", match1to6, match6);
      addRegexToken("ggggg", match1to6, match6);
      addWeekParseToken(
        ["gggg", "ggggg", "GGGG", "GGGGG"],
        function(input, week, config, token2) {
          week[token2.substr(0, 2)] = toInt(input);
        }
      );
      addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
        week[token2] = hooks.parseTwoDigitYear(input);
      });
      function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
          this,
          input,
          this.week(),
          this.weekday() + this.localeData()._week.dow,
          this.localeData()._week.dow,
          this.localeData()._week.doy
        );
      }
      function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
          this,
          input,
          this.isoWeek(),
          this.isoWeekday(),
          1,
          4
        );
      }
      function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
      }
      function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
      }
      function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
      }
      function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
      }
      function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
          return weekOfYear(this, dow, doy).year;
        } else {
          weeksTarget = weeksInYear(input, dow, doy);
          if (week > weeksTarget) {
            week = weeksTarget;
          }
          return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
      }
      function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date2 = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date2.getUTCFullYear());
        this.month(date2.getUTCMonth());
        this.date(date2.getUTCDate());
        return this;
      }
      addFormatToken("Q", 0, "Qo", "quarter");
      addRegexToken("Q", match1);
      addParseToken("Q", function(input, array4) {
        array4[MONTH] = (toInt(input) - 1) * 3;
      });
      function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
      }
      addFormatToken("D", ["DD", 2], "Do", "date");
      addRegexToken("D", match1to2, match1to2NoLeadingZero);
      addRegexToken("DD", match1to2, match2);
      addRegexToken("Do", function(isStrict, locale4) {
        return isStrict ? locale4._dayOfMonthOrdinalParse || locale4._ordinalParse : locale4._dayOfMonthOrdinalParseLenient;
      });
      addParseToken(["D", "DD"], DATE);
      addParseToken("Do", function(input, array4) {
        array4[DATE] = toInt(input.match(match1to2)[0]);
      });
      var getSetDayOfMonth = makeGetSet("Date", true);
      addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
      addRegexToken("DDD", match1to3);
      addRegexToken("DDDD", match3);
      addParseToken(["DDD", "DDDD"], function(input, array4, config) {
        config._dayOfYear = toInt(input);
      });
      function getSetDayOfYear(input) {
        var dayOfYear = Math.round(
          (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
        ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
      }
      addFormatToken("m", ["mm", 2], 0, "minute");
      addRegexToken("m", match1to2, match1to2HasZero);
      addRegexToken("mm", match1to2, match2);
      addParseToken(["m", "mm"], MINUTE);
      var getSetMinute = makeGetSet("Minutes", false);
      addFormatToken("s", ["ss", 2], 0, "second");
      addRegexToken("s", match1to2, match1to2HasZero);
      addRegexToken("ss", match1to2, match2);
      addParseToken(["s", "ss"], SECOND);
      var getSetSecond = makeGetSet("Seconds", false);
      addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
      });
      addFormatToken(0, ["SS", 2], 0, function() {
        return ~~(this.millisecond() / 10);
      });
      addFormatToken(0, ["SSS", 3], 0, "millisecond");
      addFormatToken(0, ["SSSS", 4], 0, function() {
        return this.millisecond() * 10;
      });
      addFormatToken(0, ["SSSSS", 5], 0, function() {
        return this.millisecond() * 100;
      });
      addFormatToken(0, ["SSSSSS", 6], 0, function() {
        return this.millisecond() * 1e3;
      });
      addFormatToken(0, ["SSSSSSS", 7], 0, function() {
        return this.millisecond() * 1e4;
      });
      addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
        return this.millisecond() * 1e5;
      });
      addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
        return this.millisecond() * 1e6;
      });
      addRegexToken("S", match1to3, match1);
      addRegexToken("SS", match1to3, match2);
      addRegexToken("SSS", match1to3, match3);
      var token, getSetMillisecond;
      for (token = "SSSS"; token.length <= 9; token += "S") {
        addRegexToken(token, matchUnsigned);
      }
      function parseMs(input, array4) {
        array4[MILLISECOND] = toInt(("0." + input) * 1e3);
      }
      for (token = "S"; token.length <= 9; token += "S") {
        addParseToken(token, parseMs);
      }
      getSetMillisecond = makeGetSet("Milliseconds", false);
      addFormatToken("z", 0, 0, "zoneAbbr");
      addFormatToken("zz", 0, 0, "zoneName");
      function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
      }
      function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }
      var proto = Moment.prototype;
      proto.add = add2;
      proto.calendar = calendar$1;
      proto.clone = clone;
      proto.diff = diff;
      proto.endOf = endOf;
      proto.format = format2;
      proto.from = from;
      proto.fromNow = fromNow;
      proto.to = to;
      proto.toNow = toNow;
      proto.get = stringGet;
      proto.invalidAt = invalidAt;
      proto.isAfter = isAfter;
      proto.isBefore = isBefore;
      proto.isBetween = isBetween;
      proto.isSame = isSame;
      proto.isSameOrAfter = isSameOrAfter;
      proto.isSameOrBefore = isSameOrBefore;
      proto.isValid = isValid$2;
      proto.lang = lang;
      proto.locale = locale3;
      proto.localeData = localeData;
      proto.max = prototypeMax;
      proto.min = prototypeMin;
      proto.parsingFlags = parsingFlags;
      proto.set = stringSet;
      proto.startOf = startOf;
      proto.subtract = subtract;
      proto.toArray = toArray;
      proto.toObject = toObject;
      proto.toDate = toDate;
      proto.toISOString = toISOString;
      proto.inspect = inspect;
      if (typeof Symbol !== "undefined" && Symbol.for != null) {
        proto[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
          return "Moment<" + this.format() + ">";
        };
      }
      proto.toJSON = toJSON;
      proto.toString = toString;
      proto.unix = unix;
      proto.valueOf = valueOf;
      proto.creationData = creationData;
      proto.eraName = getEraName;
      proto.eraNarrow = getEraNarrow;
      proto.eraAbbr = getEraAbbr;
      proto.eraYear = getEraYear;
      proto.year = getSetYear;
      proto.isLeapYear = getIsLeapYear;
      proto.weekYear = getSetWeekYear;
      proto.isoWeekYear = getSetISOWeekYear;
      proto.quarter = proto.quarters = getSetQuarter;
      proto.month = getSetMonth;
      proto.daysInMonth = getDaysInMonth;
      proto.week = proto.weeks = getSetWeek;
      proto.isoWeek = proto.isoWeeks = getSetISOWeek;
      proto.weeksInYear = getWeeksInYear;
      proto.weeksInWeekYear = getWeeksInWeekYear;
      proto.isoWeeksInYear = getISOWeeksInYear;
      proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
      proto.date = getSetDayOfMonth;
      proto.day = proto.days = getSetDayOfWeek;
      proto.weekday = getSetLocaleDayOfWeek;
      proto.isoWeekday = getSetISODayOfWeek;
      proto.dayOfYear = getSetDayOfYear;
      proto.hour = proto.hours = getSetHour;
      proto.minute = proto.minutes = getSetMinute;
      proto.second = proto.seconds = getSetSecond;
      proto.millisecond = proto.milliseconds = getSetMillisecond;
      proto.utcOffset = getSetOffset;
      proto.utc = setOffsetToUTC;
      proto.local = setOffsetToLocal;
      proto.parseZone = setOffsetToParsedOffset;
      proto.hasAlignedHourOffset = hasAlignedHourOffset;
      proto.isDST = isDaylightSavingTime;
      proto.isLocal = isLocal;
      proto.isUtcOffset = isUtcOffset;
      proto.isUtc = isUtc;
      proto.isUTC = isUtc;
      proto.zoneAbbr = getZoneAbbr;
      proto.zoneName = getZoneName;
      proto.dates = deprecate(
        "dates accessor is deprecated. Use date instead.",
        getSetDayOfMonth
      );
      proto.months = deprecate(
        "months accessor is deprecated. Use month instead",
        getSetMonth
      );
      proto.years = deprecate(
        "years accessor is deprecated. Use year instead",
        getSetYear
      );
      proto.zone = deprecate(
        "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
        getSetZone
      );
      proto.isDSTShifted = deprecate(
        "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
        isDaylightSavingTimeShifted
      );
      function createUnix(input) {
        return createLocal(input * 1e3);
      }
      function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
      }
      function preParsePostFormat(string) {
        return string;
      }
      var proto$1 = Locale.prototype;
      proto$1.calendar = calendar2;
      proto$1.longDateFormat = longDateFormat;
      proto$1.invalidDate = invalidDate;
      proto$1.ordinal = ordinal2;
      proto$1.preparse = preParsePostFormat;
      proto$1.postformat = preParsePostFormat;
      proto$1.relativeTime = relativeTime;
      proto$1.pastFuture = pastFuture;
      proto$1.set = set4;
      proto$1.eras = localeEras;
      proto$1.erasParse = localeErasParse;
      proto$1.erasConvertYear = localeErasConvertYear;
      proto$1.erasAbbrRegex = erasAbbrRegex;
      proto$1.erasNameRegex = erasNameRegex;
      proto$1.erasNarrowRegex = erasNarrowRegex;
      proto$1.months = localeMonths;
      proto$1.monthsShort = localeMonthsShort;
      proto$1.monthsParse = localeMonthsParse;
      proto$1.monthsRegex = monthsRegex;
      proto$1.monthsShortRegex = monthsShortRegex;
      proto$1.week = localeWeek;
      proto$1.firstDayOfYear = localeFirstDayOfYear;
      proto$1.firstDayOfWeek = localeFirstDayOfWeek;
      proto$1.weekdays = localeWeekdays;
      proto$1.weekdaysMin = localeWeekdaysMin;
      proto$1.weekdaysShort = localeWeekdaysShort;
      proto$1.weekdaysParse = localeWeekdaysParse;
      proto$1.weekdaysRegex = weekdaysRegex;
      proto$1.weekdaysShortRegex = weekdaysShortRegex;
      proto$1.weekdaysMinRegex = weekdaysMinRegex;
      proto$1.isPM = localeIsPM;
      proto$1.meridiem = localeMeridiem;
      function get$1(format3, index3, field, setter) {
        var locale4 = getLocale(), utc = createUTC().set(setter, index3);
        return locale4[field](utc, format3);
      }
      function listMonthsImpl(format3, index3, field) {
        if (isNumber(format3)) {
          index3 = format3;
          format3 = void 0;
        }
        format3 = format3 || "";
        if (index3 != null) {
          return get$1(format3, index3, field, "month");
        }
        var i, out = [];
        for (i = 0; i < 12; i++) {
          out[i] = get$1(format3, i, field, "month");
        }
        return out;
      }
      function listWeekdaysImpl(localeSorted, format3, index3, field) {
        if (typeof localeSorted === "boolean") {
          if (isNumber(format3)) {
            index3 = format3;
            format3 = void 0;
          }
          format3 = format3 || "";
        } else {
          format3 = localeSorted;
          index3 = format3;
          localeSorted = false;
          if (isNumber(format3)) {
            index3 = format3;
            format3 = void 0;
          }
          format3 = format3 || "";
        }
        var locale4 = getLocale(), shift = localeSorted ? locale4._week.dow : 0, i, out = [];
        if (index3 != null) {
          return get$1(format3, (index3 + shift) % 7, field, "day");
        }
        for (i = 0; i < 7; i++) {
          out[i] = get$1(format3, (i + shift) % 7, field, "day");
        }
        return out;
      }
      function listMonths(format3, index3) {
        return listMonthsImpl(format3, index3, "months");
      }
      function listMonthsShort(format3, index3) {
        return listMonthsImpl(format3, index3, "monthsShort");
      }
      function listWeekdays(localeSorted, format3, index3) {
        return listWeekdaysImpl(localeSorted, format3, index3, "weekdays");
      }
      function listWeekdaysShort(localeSorted, format3, index3) {
        return listWeekdaysImpl(localeSorted, format3, index3, "weekdaysShort");
      }
      function listWeekdaysMin(localeSorted, format3, index3) {
        return listWeekdaysImpl(localeSorted, format3, index3, "weekdaysMin");
      }
      getSetGlobalLocale("en", {
        eras: [
          {
            since: "0001-01-01",
            until: Infinity,
            offset: 1,
            name: "Anno Domini",
            narrow: "AD",
            abbr: "AD"
          },
          {
            since: "0000-12-31",
            until: -Infinity,
            offset: 1,
            name: "Before Christ",
            narrow: "BC",
            abbr: "BC"
          }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number5) {
          var b = number5 % 10, output = toInt(number5 % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
          return number5 + output;
        }
      });
      hooks.lang = deprecate(
        "moment.lang is deprecated. Use moment.locale instead.",
        getSetGlobalLocale
      );
      hooks.langData = deprecate(
        "moment.langData is deprecated. Use moment.localeData instead.",
        getLocale
      );
      var mathAbs = Math.abs;
      function abs5() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
      }
      function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
      }
      function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
      }
      function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
      }
      function absCeil(number5) {
        if (number5 < 0) {
          return Math.floor(number5);
        } else {
          return Math.ceil(number5);
        }
      }
      function bubble() {
        var milliseconds3 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds3, minutes2, hours2, years2, monthsFromDays;
        if (!(milliseconds3 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds3 <= 0 && days2 <= 0 && months2 <= 0)) {
          milliseconds3 += absCeil(monthsToDays(months2) + days2) * 864e5;
          days2 = 0;
          months2 = 0;
        }
        data.milliseconds = milliseconds3 % 1e3;
        seconds3 = absFloor(milliseconds3 / 1e3);
        data.seconds = seconds3 % 60;
        minutes2 = absFloor(seconds3 / 60);
        data.minutes = minutes2 % 60;
        hours2 = absFloor(minutes2 / 60);
        data.hours = hours2 % 24;
        days2 += absFloor(hours2 / 24);
        monthsFromDays = absFloor(daysToMonths(days2));
        months2 += monthsFromDays;
        days2 -= absCeil(monthsToDays(monthsFromDays));
        years2 = absFloor(months2 / 12);
        months2 %= 12;
        data.days = days2;
        data.months = months2;
        data.years = years2;
        return this;
      }
      function daysToMonths(days2) {
        return days2 * 4800 / 146097;
      }
      function monthsToDays(months2) {
        return months2 * 146097 / 4800;
      }
      function as(units) {
        if (!this.isValid()) {
          return NaN;
        }
        var days2, months2, milliseconds3 = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
          days2 = this._days + milliseconds3 / 864e5;
          months2 = this._months + daysToMonths(days2);
          switch (units) {
            case "month":
              return months2;
            case "quarter":
              return months2 / 3;
            case "year":
              return months2 / 12;
          }
        } else {
          days2 = this._days + Math.round(monthsToDays(this._months));
          switch (units) {
            case "week":
              return days2 / 7 + milliseconds3 / 6048e5;
            case "day":
              return days2 + milliseconds3 / 864e5;
            case "hour":
              return days2 * 24 + milliseconds3 / 36e5;
            case "minute":
              return days2 * 1440 + milliseconds3 / 6e4;
            case "second":
              return days2 * 86400 + milliseconds3 / 1e3;
            // Math.floor prevents floating point math errors here
            case "millisecond":
              return Math.floor(days2 * 864e5) + milliseconds3;
            default:
              throw new Error("Unknown unit " + units);
          }
        }
      }
      function makeAs(alias) {
        return function() {
          return this.as(alias);
        };
      }
      var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
      function clone$1() {
        return createDuration(this);
      }
      function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
      }
      function makeGetter(name) {
        return function() {
          return this.isValid() ? this._data[name] : NaN;
        };
      }
      var milliseconds2 = makeGetter("milliseconds"), seconds2 = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
      function weeks() {
        return absFloor(this.days() / 7);
      }
      var round = Math.round, thresholds = {
        ss: 44,
        // a few seconds to seconds
        s: 45,
        // seconds to minute
        m: 45,
        // minutes to hour
        h: 22,
        // hours to day
        d: 26,
        // days to month/week
        w: null,
        // weeks to month
        M: 11
        // months to year
      };
      function substituteTimeAgo(string, number5, withoutSuffix, isFuture, locale4) {
        return locale4.relativeTime(number5 || 1, !!withoutSuffix, string, isFuture);
      }
      function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale4) {
        var duration = createDuration(posNegDuration).abs(), seconds3 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a4 = seconds3 <= thresholds2.ss && ["s", seconds3] || seconds3 < thresholds2.s && ["ss", seconds3] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
        if (thresholds2.w != null) {
          a4 = a4 || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
        }
        a4 = a4 || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
        a4[2] = withoutSuffix;
        a4[3] = +posNegDuration > 0;
        a4[4] = locale4;
        return substituteTimeAgo.apply(null, a4);
      }
      function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === void 0) {
          return round;
        }
        if (typeof roundingFunction === "function") {
          round = roundingFunction;
          return true;
        }
        return false;
      }
      function getSetRelativeTimeThreshold(threshold2, limit) {
        if (thresholds[threshold2] === void 0) {
          return false;
        }
        if (limit === void 0) {
          return thresholds[threshold2];
        }
        thresholds[threshold2] = limit;
        if (threshold2 === "s") {
          thresholds.ss = limit - 1;
        }
        return true;
      }
      function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
          return this.localeData().invalidDate();
        }
        var withSuffix = false, th = thresholds, locale4, output;
        if (typeof argWithSuffix === "object") {
          argThresholds = argWithSuffix;
          argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") {
          withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === "object") {
          th = Object.assign({}, thresholds, argThresholds);
          if (argThresholds.s != null && argThresholds.ss == null) {
            th.ss = argThresholds.s - 1;
          }
        }
        locale4 = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale4);
        if (withSuffix) {
          output = locale4.pastFuture(+this, output);
        }
        return locale4.postformat(output);
      }
      var abs$1 = Math.abs;
      function sign3(x4) {
        return (x4 > 0) - (x4 < 0) || +x4;
      }
      function toISOString$1() {
        if (!this.isValid()) {
          return this.localeData().invalidDate();
        }
        var seconds3 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s2, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) {
          return "P0D";
        }
        minutes2 = absFloor(seconds3 / 60);
        hours2 = absFloor(minutes2 / 60);
        seconds3 %= 60;
        minutes2 %= 60;
        years2 = absFloor(months2 / 12);
        months2 %= 12;
        s2 = seconds3 ? seconds3.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign3(this._months) !== sign3(total) ? "-" : "";
        daysSign = sign3(this._days) !== sign3(total) ? "-" : "";
        hmsSign = sign3(this._milliseconds) !== sign3(total) ? "-" : "";
        return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds3 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds3 ? hmsSign + s2 + "S" : "");
      }
      var proto$2 = Duration.prototype;
      proto$2.isValid = isValid$1;
      proto$2.abs = abs5;
      proto$2.add = add$1;
      proto$2.subtract = subtract$1;
      proto$2.as = as;
      proto$2.asMilliseconds = asMilliseconds;
      proto$2.asSeconds = asSeconds;
      proto$2.asMinutes = asMinutes;
      proto$2.asHours = asHours;
      proto$2.asDays = asDays;
      proto$2.asWeeks = asWeeks;
      proto$2.asMonths = asMonths;
      proto$2.asQuarters = asQuarters;
      proto$2.asYears = asYears;
      proto$2.valueOf = valueOf$1;
      proto$2._bubble = bubble;
      proto$2.clone = clone$1;
      proto$2.get = get$2;
      proto$2.milliseconds = milliseconds2;
      proto$2.seconds = seconds2;
      proto$2.minutes = minutes;
      proto$2.hours = hours;
      proto$2.days = days;
      proto$2.weeks = weeks;
      proto$2.months = months;
      proto$2.years = years;
      proto$2.humanize = humanize;
      proto$2.toISOString = toISOString$1;
      proto$2.toString = toISOString$1;
      proto$2.toJSON = toISOString$1;
      proto$2.locale = locale3;
      proto$2.localeData = localeData;
      proto$2.toIsoString = deprecate(
        "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
        toISOString$1
      );
      proto$2.lang = lang;
      addFormatToken("X", 0, 0, "unix");
      addFormatToken("x", 0, 0, "valueOf");
      addRegexToken("x", matchSigned);
      addRegexToken("X", matchTimestamp);
      addParseToken("X", function(input, array4, config) {
        config._d = new Date(parseFloat(input) * 1e3);
      });
      addParseToken("x", function(input, array4, config) {
        config._d = new Date(toInt(input));
      });
      hooks.version = "2.30.1";
      setHookCallback(createLocal);
      hooks.fn = proto;
      hooks.min = min4;
      hooks.max = max5;
      hooks.now = now2;
      hooks.utc = createUTC;
      hooks.unix = createUnix;
      hooks.months = listMonths;
      hooks.isDate = isDate;
      hooks.locale = getSetGlobalLocale;
      hooks.invalid = createInvalid;
      hooks.duration = createDuration;
      hooks.isMoment = isMoment;
      hooks.weekdays = listWeekdays;
      hooks.parseZone = createInZone;
      hooks.localeData = getLocale;
      hooks.isDuration = isDuration;
      hooks.monthsShort = listMonthsShort;
      hooks.weekdaysMin = listWeekdaysMin;
      hooks.defineLocale = defineLocale;
      hooks.updateLocale = updateLocale;
      hooks.locales = listLocales;
      hooks.weekdaysShort = listWeekdaysShort;
      hooks.normalizeUnits = normalizeUnits;
      hooks.relativeTimeRounding = getSetRelativeTimeRounding;
      hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
      hooks.calendarFormat = getCalendarFormat;
      hooks.prototype = proto;
      hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        // <input type="datetime-local" step="0.001" />
        DATE: "YYYY-MM-DD",
        // <input type="date" />
        TIME: "HH:mm",
        // <input type="time" />
        TIME_SECONDS: "HH:mm:ss",
        // <input type="time" step="1" />
        TIME_MS: "HH:mm:ss.SSS",
        // <input type="time" step="0.001" />
        WEEK: "GGGG-[W]WW",
        // <input type="week" />
        MONTH: "YYYY-MM"
        // <input type="month" />
      };
      return hooks;
    }));
  }
});

// ../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/moment-timezone.js
var require_moment_timezone = __commonJS({
  "../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/moment-timezone.js"(exports2, module2) {
    (function(root3, factory) {
      "use strict";
      if (typeof module2 === "object" && module2.exports) {
        module2.exports = factory(require_moment());
      } else if (typeof define === "function" && define.amd) {
        define(["moment"], factory);
      } else {
        factory(root3.moment);
      }
    })(exports2, function(moment) {
      "use strict";
      if (moment.version === void 0 && moment.default) {
        moment = moment.default;
      }
      var VERSION = "0.5.48", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
      if (!moment || typeof moment.version !== "string") {
        logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
      }
      var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
      if (major < 2 || major === 2 && minor < 6) {
        logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
      }
      function charCodeToInt(charCode) {
        if (charCode > 96) {
          return charCode - 87;
        } else if (charCode > 64) {
          return charCode - 29;
        }
        return charCode - 48;
      }
      function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign3 = 1;
        if (string.charCodeAt(0) === 45) {
          i = 1;
          sign3 = -1;
        }
        for (i; i < whole.length; i++) {
          num = charCodeToInt(whole.charCodeAt(i));
          out = 60 * out + num;
        }
        for (i = 0; i < fractional.length; i++) {
          multiplier = multiplier / 60;
          num = charCodeToInt(fractional.charCodeAt(i));
          out += num * multiplier;
        }
        return out * sign3;
      }
      function arrayToInt(array4) {
        for (var i = 0; i < array4.length; i++) {
          array4[i] = unpackBase60(array4[i]);
        }
      }
      function intToUntil(array4, length3) {
        for (var i = 0; i < length3; i++) {
          array4[i] = Math.round((array4[i - 1] || 0) + array4[i] * 6e4);
        }
        array4[length3 - 1] = Infinity;
      }
      function mapIndices(source, indices) {
        var out = [], i;
        for (i = 0; i < indices.length; i++) {
          out[i] = source[indices[i]];
        }
        return out;
      }
      function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
          name: data[0],
          abbrs: mapIndices(data[1].split(" "), indices),
          offsets: mapIndices(offsets, indices),
          untils,
          population: data[5] | 0
        };
      }
      function Zone(packedString) {
        if (packedString) {
          this._set(unpack(packedString));
        }
      }
      function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) {
          return 0;
        } else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
          return len - 1;
        } else if (num >= arr[len - 1]) {
          return -1;
        }
        var mid;
        var lo = 0;
        var hi = len - 1;
        while (hi - lo > 1) {
          mid = Math.floor((lo + hi) / 2);
          if (arr[mid] <= num) {
            lo = mid;
          } else {
            hi = mid;
          }
        }
        return hi;
      }
      Zone.prototype = {
        _set: function(unpacked) {
          this.name = unpacked.name;
          this.abbrs = unpacked.abbrs;
          this.untils = unpacked.untils;
          this.offsets = unpacked.offsets;
          this.population = unpacked.population;
        },
        _index: function(timestamp) {
          var target = +timestamp, untils = this.untils, i;
          i = closest(target, untils);
          if (i >= 0) {
            return i;
          }
        },
        countries: function() {
          var zone_name = this.name;
          return Object.keys(countries).filter(function(country_code) {
            return countries[country_code].zones.indexOf(zone_name) !== -1;
          });
        },
        parse: function(timestamp) {
          var target = +timestamp, offsets = this.offsets, untils = this.untils, max5 = untils.length - 1, offset, offsetNext, offsetPrev, i;
          for (i = 0; i < max5; i++) {
            offset = offsets[i];
            offsetNext = offsets[i + 1];
            offsetPrev = offsets[i ? i - 1 : i];
            if (offset < offsetNext && tz.moveAmbiguousForward) {
              offset = offsetNext;
            } else if (offset > offsetPrev && tz.moveInvalidForward) {
              offset = offsetPrev;
            }
            if (target < untils[i] - offset * 6e4) {
              return offsets[i];
            }
          }
          return offsets[max5];
        },
        abbr: function(mom) {
          return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
          logError("zone.offset has been deprecated in favor of zone.utcOffset");
          return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
          return this.offsets[this._index(mom)];
        }
      };
      function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
      }
      function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
          abbr = abbr[0].match(/[A-Z]/g);
          abbr = abbr ? abbr.join("") : void 0;
        } else {
          abbr = timeString.match(/[A-Z]{3,5}/g);
          abbr = abbr ? abbr[0] : void 0;
        }
        if (abbr === "GMT") {
          abbr = void 0;
        }
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
      }
      function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
      }
      ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) {
          this.abbrScore++;
        }
      };
      function findChange(low, high) {
        var mid, diff;
        while (diff = ((high.at - low.at) / 12e4 | 0) * 6e4) {
          mid = new OffsetAt(new Date(low.at + diff));
          if (mid.offset === low.offset) {
            low = mid;
          } else {
            high = mid;
          }
        }
        return low;
      }
      function userOffsets() {
        var startYear = (/* @__PURE__ */ new Date()).getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [last], change, next, nextOffset, i;
        for (i = 1; i < 48; i++) {
          nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
          if (nextOffset !== lastOffset) {
            next = new OffsetAt(new Date(startYear, i, 1));
            change = findChange(last, next);
            offsets.push(change);
            offsets.push(new OffsetAt(new Date(change.at + 6e4)));
            last = next;
            lastOffset = nextOffset;
          }
        }
        for (i = 0; i < 4; i++) {
          offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
          offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
      }
      function sortZoneScores(a4, b) {
        if (a4.offsetScore !== b.offsetScore) {
          return a4.offsetScore - b.offsetScore;
        }
        if (a4.abbrScore !== b.abbrScore) {
          return a4.abbrScore - b.abbrScore;
        }
        if (a4.zone.population !== b.zone.population) {
          return b.zone.population - a4.zone.population;
        }
        return b.zone.name.localeCompare(a4.zone.name);
      }
      function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for (i = 0; i < offsets.length; i++) {
          offset = offsets[i];
          guesses[offset] = guesses[offset] || {};
          guesses[offset][name] = true;
        }
      }
      function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for (i = 0; i < offsetsLength; i++) {
          offset = offsets[i].offset;
          if (checkedOffsets.hasOwnProperty(offset)) {
            continue;
          }
          guessesOffset = guesses[offset] || {};
          for (j in guessesOffset) {
            if (guessesOffset.hasOwnProperty(j)) {
              filteredGuesses[j] = true;
            }
          }
          checkedOffsets[offset] = true;
        }
        for (i in filteredGuesses) {
          if (filteredGuesses.hasOwnProperty(i)) {
            out.push(names[i]);
          }
        }
        return out;
      }
      function rebuildGuess() {
        try {
          var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (intlName && intlName.length > 3) {
            var name = names[normalizeName(intlName)];
            if (name) {
              return name;
            }
            logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
          }
        } catch (e) {
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses2 = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for (i = 0; i < guesses2.length; i++) {
          zoneScore = new ZoneScore(getZone(guesses2[i]), offsetsLength);
          for (j = 0; j < offsetsLength; j++) {
            zoneScore.scoreOffsetAt(offsets[j]);
          }
          zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : void 0;
      }
      function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) {
          cachedGuess = rebuildGuess();
        }
        return cachedGuess;
      }
      function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
      }
      function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") {
          packed = [packed];
        }
        for (i = 0; i < packed.length; i++) {
          split = packed[i].split("|");
          name = split[0];
          normalized = normalizeName(name);
          zones[normalized] = packed[i];
          names[normalized] = name;
          addToGuesses(normalized, split[2].split(" "));
        }
      }
      function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link3;
        if (zone instanceof Zone) {
          return zone;
        }
        if (typeof zone === "string") {
          zone = new Zone(zone);
          zones[name] = zone;
          return zone;
        }
        if (links[name] && caller !== getZone && (link3 = getZone(links[name], getZone))) {
          zone = zones[name] = new Zone();
          zone._set(link3);
          zone.name = names[name];
          return zone;
        }
        return null;
      }
      function getNames() {
        var i, out = [];
        for (i in names) {
          if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
            out.push(names[i]);
          }
        }
        return out.sort();
      }
      function getCountryNames() {
        return Object.keys(countries);
      }
      function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") {
          aliases = [aliases];
        }
        for (i = 0; i < aliases.length; i++) {
          alias = aliases[i].split("|");
          normal0 = normalizeName(alias[0]);
          normal1 = normalizeName(alias[1]);
          links[normal0] = normal1;
          names[normal0] = alias[0];
          links[normal1] = normal0;
          names[normal1] = alias[1];
        }
      }
      function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for (i = 0; i < data.length; i++) {
          split = data[i].split("|");
          country_code = split[0].toUpperCase();
          country_zones = split[1].split(" ");
          countries[country_code] = new Country(
            country_code,
            country_zones
          );
        }
      }
      function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
      }
      function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones2 = country.zones.sort();
        if (with_offset) {
          return zones2.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
              name: zone_name,
              offset: zone.utcOffset(/* @__PURE__ */ new Date())
            };
          });
        }
        return zones2;
      }
      function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
      }
      function zoneExists(name) {
        if (!zoneExists.didShowError) {
          zoneExists.didShowError = true;
          logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
      }
      function needsOffset(m3) {
        var isUnixTimestamp = m3._f === "X" || m3._f === "x";
        return !!(m3._a && m3._tzm === void 0 && !isUnixTimestamp);
      }
      function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") {
          console.error(message);
        }
      }
      function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
          out.add(zone.parse(out), "minutes");
        }
        out.tz(name);
        return out;
      }
      tz.version = VERSION;
      tz.dataVersion = "";
      tz._zones = zones;
      tz._links = links;
      tz._names = names;
      tz._countries = countries;
      tz.add = addZone;
      tz.link = addLink;
      tz.load = loadData;
      tz.zone = getZone;
      tz.zoneExists = zoneExists;
      tz.guess = guess;
      tz.names = getNames;
      tz.Zone = Zone;
      tz.unpack = unpack;
      tz.unpackBase60 = unpackBase60;
      tz.needsOffset = needsOffset;
      tz.moveInvalidForward = true;
      tz.moveAmbiguousForward = false;
      tz.countries = getCountryNames;
      tz.zonesForCountry = zonesForCountry;
      var fn = moment.fn;
      moment.tz = tz;
      moment.defaultZone = null;
      moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === void 0) {
          if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
            mom._d = moment.utc(mom._a)._d;
            mom.utc().add(zone.parse(mom), "minutes");
          }
          mom._z = zone;
        }
        if (mom._z) {
          offset = mom._z.utcOffset(mom);
          if (Math.abs(offset) < 16) {
            offset = offset / 60;
          }
          if (mom.utcOffset !== void 0) {
            var z = mom._z;
            mom.utcOffset(-offset, keepTime);
            mom._z = z;
          } else {
            mom.zone(offset, keepTime);
          }
        }
      };
      fn.tz = function(name, keepTime) {
        if (name) {
          if (typeof name !== "string") {
            throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
          }
          this._z = getZone(name);
          if (this._z) {
            moment.updateOffset(this, keepTime);
          } else {
            logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
          }
          return this;
        }
        if (this._z) {
          return this._z.name;
        }
      };
      function abbrWrap(old) {
        return function() {
          if (this._z) {
            return this._z.abbr(this);
          }
          return old.call(this);
        };
      }
      function resetZoneWrap(old) {
        return function() {
          this._z = null;
          return old.apply(this, arguments);
        };
      }
      function resetZoneWrap2(old) {
        return function() {
          if (arguments.length > 0) this._z = null;
          return old.apply(this, arguments);
        };
      }
      fn.zoneName = abbrWrap(fn.zoneName);
      fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
      fn.utc = resetZoneWrap(fn.utc);
      fn.local = resetZoneWrap(fn.local);
      fn.utcOffset = resetZoneWrap2(fn.utcOffset);
      moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) {
          logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        }
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
      };
      var momentProperties = moment.momentProperties;
      if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        momentProperties.push("_z");
        momentProperties.push("_a");
      } else if (momentProperties) {
        momentProperties._z = null;
      }
      return moment;
    });
  }
});

// ../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/data/packed/latest.json
var require_latest = __commonJS({
  "../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/data/packed/latest.json"(exports2, module2) {
    module2.exports = {
      version: "2025b",
      zones: [
        "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
        "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
        "Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
        "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
        "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
        "Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5",
        "Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
        "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
        "Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
        "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
        "Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
        "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
        "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
        "Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
        "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
        "Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
        "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
        "Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
        "Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
        "America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
        "America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
        "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
        "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
        "America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
        "America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
        "America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
        "America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
        "America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
        "America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
        "America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
        "America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
        "America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
        "America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5",
        "America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
        "America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
        "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
        "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
        "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
        "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
        "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
        "America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
        "America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
        "America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
        "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
        "America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
        "America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
        "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
        "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
        "America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
        "America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
        "America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|",
        "America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
        "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
        "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
        "America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
        "America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
        "America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
        "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
        "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
        "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
        "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
        "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
        "America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
        "America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
        "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
        "America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
        "America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
        "America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
        "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
        "America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
        "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
        "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
        "America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
        "America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
        "America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
        "America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
        "America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
        "America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
        "America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
        "America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
        "America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
        "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
        "America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
        "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
        "America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
        "America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
        "America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
        "America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
        "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
        "America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
        "America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
        "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
        "America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
        "America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
        "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
        "America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
        "America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
        "America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
        "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
        "America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
        "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
        "America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
        "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
        "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
        "America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
        "America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
        "America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
        "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
        "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
        "America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
        "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
        "America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
        "America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
        "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
        "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
        "America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
        "America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
        "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
        "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
        "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
        "America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
        "America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
        "America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
        "Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
        "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
        "Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
        "Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
        "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
        "Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
        "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
        "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
        "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
        "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
        "Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25",
        "Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
        "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5",
        "Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
        "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
        "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
        "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
        "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
        "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
        "Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
        "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
        "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
        "Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
        "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
        "Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
        "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
        "Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
        "Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
        "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
        "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
        "Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
        "Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
        "Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
        "Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
        "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4",
        "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
        "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
        "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
        "Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
        "Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
        "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5",
        "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
        "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
        "Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
        "Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
        "Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
        "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
        "Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
        "Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
        "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
        "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
        "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
        "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
        "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
        "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
        "Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
        "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
        "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
        "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
        "Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6",
        "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
        "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
        "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
        "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
        "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
        "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
        "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
        "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|",
        "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
        "Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
        "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
        "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
        "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
        "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
        "Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
        "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
        "Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
        "Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
        "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
        "Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
        "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
        "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
        "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
        "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
        "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
        "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
        "Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
        "Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
        "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
        "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
        "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
        "Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
        "Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
        "Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
        "Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
        "Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
        "Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
        "Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
        "Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
        "Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
        "Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
        "Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
        "Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
        "Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
        "Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
        "Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
        "Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
        "Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
        "Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Etc/GMT-0|GMT|0|0||",
        "Etc/GMT-1|+01|-10|0||",
        "Etc/GMT-10|+10|-a0|0||",
        "Etc/GMT-11|+11|-b0|0||",
        "Etc/GMT-12|+12|-c0|0||",
        "Etc/GMT-13|+13|-d0|0||",
        "Etc/GMT-14|+14|-e0|0||",
        "Etc/GMT-2|+02|-20|0||",
        "Etc/GMT-3|+03|-30|0||",
        "Etc/GMT-4|+04|-40|0||",
        "Etc/GMT-5|+05|-50|0||",
        "Etc/GMT-6|+06|-60|0||",
        "Etc/GMT-7|+07|-70|0||",
        "Etc/GMT-8|+08|-80|0||",
        "Etc/GMT-9|+09|-90|0||",
        "Etc/GMT+1|-01|10|0||",
        "Etc/GMT+10|-10|a0|0||",
        "Etc/GMT+11|-11|b0|0||",
        "Etc/GMT+12|-12|c0|0||",
        "Etc/GMT+2|-02|20|0||",
        "Etc/GMT+3|-03|30|0||",
        "Etc/GMT+4|-04|40|0||",
        "Etc/GMT+5|-05|50|0||",
        "Etc/GMT+6|-06|60|0||",
        "Etc/GMT+7|-07|70|0||",
        "Etc/GMT+8|-08|80|0||",
        "Etc/GMT+9|-09|90|0||",
        "Etc/UTC|UTC|0|0||",
        "Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
        "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
        "Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
        "Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
        "Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
        "Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
        "Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
        "Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
        "Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
        "Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
        "Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
        "Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
        "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
        "Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
        "Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
        "Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
        "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
        "Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
        "Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
        "Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
        "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
        "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
        "Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
        "Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
        "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
        "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
        "Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
        "Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
        "Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
        "Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
        "Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
        "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
        "Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
        "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
        "Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
        "Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
        "Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
        "Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
        "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
        "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
        "Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
        "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
        "Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
        "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
        "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
        "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
        "Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
        "Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
        "Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
        "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
        "Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
        "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
        "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
        "Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
        "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
        "Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
        "Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
        "Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
        "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
        "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"
      ],
      links: [
        "Africa/Abidjan|Africa/Accra",
        "Africa/Abidjan|Africa/Bamako",
        "Africa/Abidjan|Africa/Banjul",
        "Africa/Abidjan|Africa/Conakry",
        "Africa/Abidjan|Africa/Dakar",
        "Africa/Abidjan|Africa/Freetown",
        "Africa/Abidjan|Africa/Lome",
        "Africa/Abidjan|Africa/Nouakchott",
        "Africa/Abidjan|Africa/Ouagadougou",
        "Africa/Abidjan|Africa/Timbuktu",
        "Africa/Abidjan|Atlantic/Reykjavik",
        "Africa/Abidjan|Atlantic/St_Helena",
        "Africa/Abidjan|Iceland",
        "Africa/Cairo|Egypt",
        "Africa/Johannesburg|Africa/Maseru",
        "Africa/Johannesburg|Africa/Mbabane",
        "Africa/Lagos|Africa/Bangui",
        "Africa/Lagos|Africa/Brazzaville",
        "Africa/Lagos|Africa/Douala",
        "Africa/Lagos|Africa/Kinshasa",
        "Africa/Lagos|Africa/Libreville",
        "Africa/Lagos|Africa/Luanda",
        "Africa/Lagos|Africa/Malabo",
        "Africa/Lagos|Africa/Niamey",
        "Africa/Lagos|Africa/Porto-Novo",
        "Africa/Maputo|Africa/Blantyre",
        "Africa/Maputo|Africa/Bujumbura",
        "Africa/Maputo|Africa/Gaborone",
        "Africa/Maputo|Africa/Harare",
        "Africa/Maputo|Africa/Kigali",
        "Africa/Maputo|Africa/Lubumbashi",
        "Africa/Maputo|Africa/Lusaka",
        "Africa/Nairobi|Africa/Addis_Ababa",
        "Africa/Nairobi|Africa/Asmara",
        "Africa/Nairobi|Africa/Asmera",
        "Africa/Nairobi|Africa/Dar_es_Salaam",
        "Africa/Nairobi|Africa/Djibouti",
        "Africa/Nairobi|Africa/Kampala",
        "Africa/Nairobi|Africa/Mogadishu",
        "Africa/Nairobi|Indian/Antananarivo",
        "Africa/Nairobi|Indian/Comoro",
        "Africa/Nairobi|Indian/Mayotte",
        "Africa/Tripoli|Libya",
        "America/Adak|America/Atka",
        "America/Adak|US/Aleutian",
        "America/Anchorage|US/Alaska",
        "America/Argentina/Buenos_Aires|America/Buenos_Aires",
        "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
        "America/Argentina/Catamarca|America/Catamarca",
        "America/Argentina/Cordoba|America/Cordoba",
        "America/Argentina/Cordoba|America/Rosario",
        "America/Argentina/Jujuy|America/Jujuy",
        "America/Argentina/Mendoza|America/Mendoza",
        "America/Chicago|CST6CDT",
        "America/Chicago|US/Central",
        "America/Denver|America/Shiprock",
        "America/Denver|MST7MDT",
        "America/Denver|Navajo",
        "America/Denver|US/Mountain",
        "America/Detroit|US/Michigan",
        "America/Edmonton|America/Yellowknife",
        "America/Edmonton|Canada/Mountain",
        "America/Fort_Wayne|America/Indiana/Indianapolis",
        "America/Fort_Wayne|America/Indianapolis",
        "America/Fort_Wayne|US/East-Indiana",
        "America/Godthab|America/Nuuk",
        "America/Halifax|Canada/Atlantic",
        "America/Havana|Cuba",
        "America/Indiana/Knox|America/Knox_IN",
        "America/Indiana/Knox|US/Indiana-Starke",
        "America/Iqaluit|America/Pangnirtung",
        "America/Jamaica|Jamaica",
        "America/Kentucky/Louisville|America/Louisville",
        "America/Los_Angeles|PST8PDT",
        "America/Los_Angeles|US/Pacific",
        "America/Manaus|Brazil/West",
        "America/Mazatlan|Mexico/BajaSur",
        "America/Mexico_City|Mexico/General",
        "America/New_York|EST5EDT",
        "America/New_York|US/Eastern",
        "America/Noronha|Brazil/DeNoronha",
        "America/Panama|America/Atikokan",
        "America/Panama|America/Cayman",
        "America/Panama|America/Coral_Harbour",
        "America/Panama|EST",
        "America/Phoenix|America/Creston",
        "America/Phoenix|MST",
        "America/Phoenix|US/Arizona",
        "America/Puerto_Rico|America/Anguilla",
        "America/Puerto_Rico|America/Antigua",
        "America/Puerto_Rico|America/Aruba",
        "America/Puerto_Rico|America/Blanc-Sablon",
        "America/Puerto_Rico|America/Curacao",
        "America/Puerto_Rico|America/Dominica",
        "America/Puerto_Rico|America/Grenada",
        "America/Puerto_Rico|America/Guadeloupe",
        "America/Puerto_Rico|America/Kralendijk",
        "America/Puerto_Rico|America/Lower_Princes",
        "America/Puerto_Rico|America/Marigot",
        "America/Puerto_Rico|America/Montserrat",
        "America/Puerto_Rico|America/Port_of_Spain",
        "America/Puerto_Rico|America/St_Barthelemy",
        "America/Puerto_Rico|America/St_Kitts",
        "America/Puerto_Rico|America/St_Lucia",
        "America/Puerto_Rico|America/St_Thomas",
        "America/Puerto_Rico|America/St_Vincent",
        "America/Puerto_Rico|America/Tortola",
        "America/Puerto_Rico|America/Virgin",
        "America/Regina|Canada/Saskatchewan",
        "America/Rio_Branco|America/Porto_Acre",
        "America/Rio_Branco|Brazil/Acre",
        "America/Santiago|Chile/Continental",
        "America/Sao_Paulo|Brazil/East",
        "America/St_Johns|Canada/Newfoundland",
        "America/Tijuana|America/Ensenada",
        "America/Tijuana|America/Santa_Isabel",
        "America/Tijuana|Mexico/BajaNorte",
        "America/Toronto|America/Montreal",
        "America/Toronto|America/Nassau",
        "America/Toronto|America/Nipigon",
        "America/Toronto|America/Thunder_Bay",
        "America/Toronto|Canada/Eastern",
        "America/Vancouver|Canada/Pacific",
        "America/Whitehorse|Canada/Yukon",
        "America/Winnipeg|America/Rainy_River",
        "America/Winnipeg|Canada/Central",
        "Asia/Ashgabat|Asia/Ashkhabad",
        "Asia/Bangkok|Asia/Phnom_Penh",
        "Asia/Bangkok|Asia/Vientiane",
        "Asia/Bangkok|Indian/Christmas",
        "Asia/Brunei|Asia/Kuching",
        "Asia/Dhaka|Asia/Dacca",
        "Asia/Dubai|Asia/Muscat",
        "Asia/Dubai|Indian/Mahe",
        "Asia/Dubai|Indian/Reunion",
        "Asia/Ho_Chi_Minh|Asia/Saigon",
        "Asia/Hong_Kong|Hongkong",
        "Asia/Jerusalem|Asia/Tel_Aviv",
        "Asia/Jerusalem|Israel",
        "Asia/Kathmandu|Asia/Katmandu",
        "Asia/Kolkata|Asia/Calcutta",
        "Asia/Kuala_Lumpur|Asia/Singapore",
        "Asia/Kuala_Lumpur|Singapore",
        "Asia/Macau|Asia/Macao",
        "Asia/Makassar|Asia/Ujung_Pandang",
        "Asia/Nicosia|Europe/Nicosia",
        "Asia/Qatar|Asia/Bahrain",
        "Asia/Rangoon|Asia/Yangon",
        "Asia/Rangoon|Indian/Cocos",
        "Asia/Riyadh|Antarctica/Syowa",
        "Asia/Riyadh|Asia/Aden",
        "Asia/Riyadh|Asia/Kuwait",
        "Asia/Seoul|ROK",
        "Asia/Shanghai|Asia/Chongqing",
        "Asia/Shanghai|Asia/Chungking",
        "Asia/Shanghai|Asia/Harbin",
        "Asia/Shanghai|PRC",
        "Asia/Taipei|ROC",
        "Asia/Tehran|Iran",
        "Asia/Thimphu|Asia/Thimbu",
        "Asia/Tokyo|Japan",
        "Asia/Ulaanbaatar|Asia/Choibalsan",
        "Asia/Ulaanbaatar|Asia/Ulan_Bator",
        "Asia/Urumqi|Asia/Kashgar",
        "Atlantic/Faroe|Atlantic/Faeroe",
        "Australia/Adelaide|Australia/South",
        "Australia/Brisbane|Australia/Queensland",
        "Australia/Broken_Hill|Australia/Yancowinna",
        "Australia/Darwin|Australia/North",
        "Australia/Hobart|Australia/Currie",
        "Australia/Hobart|Australia/Tasmania",
        "Australia/Lord_Howe|Australia/LHI",
        "Australia/Melbourne|Australia/Victoria",
        "Australia/Perth|Australia/West",
        "Australia/Sydney|Australia/ACT",
        "Australia/Sydney|Australia/Canberra",
        "Australia/Sydney|Australia/NSW",
        "Etc/GMT-0|Etc/GMT",
        "Etc/GMT-0|Etc/GMT+0",
        "Etc/GMT-0|Etc/GMT0",
        "Etc/GMT-0|Etc/Greenwich",
        "Etc/GMT-0|GMT",
        "Etc/GMT-0|GMT+0",
        "Etc/GMT-0|GMT-0",
        "Etc/GMT-0|GMT0",
        "Etc/GMT-0|Greenwich",
        "Etc/UTC|Etc/UCT",
        "Etc/UTC|Etc/Universal",
        "Etc/UTC|Etc/Zulu",
        "Etc/UTC|UCT",
        "Etc/UTC|UTC",
        "Etc/UTC|Universal",
        "Etc/UTC|Zulu",
        "Europe/Athens|EET",
        "Europe/Belgrade|Europe/Ljubljana",
        "Europe/Belgrade|Europe/Podgorica",
        "Europe/Belgrade|Europe/Sarajevo",
        "Europe/Belgrade|Europe/Skopje",
        "Europe/Belgrade|Europe/Zagreb",
        "Europe/Berlin|Arctic/Longyearbyen",
        "Europe/Berlin|Atlantic/Jan_Mayen",
        "Europe/Berlin|Europe/Copenhagen",
        "Europe/Berlin|Europe/Oslo",
        "Europe/Berlin|Europe/Stockholm",
        "Europe/Brussels|CET",
        "Europe/Brussels|Europe/Amsterdam",
        "Europe/Brussels|Europe/Luxembourg",
        "Europe/Brussels|MET",
        "Europe/Chisinau|Europe/Tiraspol",
        "Europe/Dublin|Eire",
        "Europe/Helsinki|Europe/Mariehamn",
        "Europe/Istanbul|Asia/Istanbul",
        "Europe/Istanbul|Turkey",
        "Europe/Kiev|Europe/Kyiv",
        "Europe/Kiev|Europe/Uzhgorod",
        "Europe/Kiev|Europe/Zaporozhye",
        "Europe/Lisbon|Portugal",
        "Europe/Lisbon|WET",
        "Europe/London|Europe/Belfast",
        "Europe/London|Europe/Guernsey",
        "Europe/London|Europe/Isle_of_Man",
        "Europe/London|Europe/Jersey",
        "Europe/London|GB",
        "Europe/London|GB-Eire",
        "Europe/Moscow|W-SU",
        "Europe/Paris|Europe/Monaco",
        "Europe/Prague|Europe/Bratislava",
        "Europe/Rome|Europe/San_Marino",
        "Europe/Rome|Europe/Vatican",
        "Europe/Warsaw|Poland",
        "Europe/Zurich|Europe/Busingen",
        "Europe/Zurich|Europe/Vaduz",
        "Indian/Maldives|Indian/Kerguelen",
        "Pacific/Auckland|Antarctica/McMurdo",
        "Pacific/Auckland|Antarctica/South_Pole",
        "Pacific/Auckland|NZ",
        "Pacific/Chatham|NZ-CHAT",
        "Pacific/Easter|Chile/EasterIsland",
        "Pacific/Enderbury|Pacific/Kanton",
        "Pacific/Guadalcanal|Pacific/Pohnpei",
        "Pacific/Guadalcanal|Pacific/Ponape",
        "Pacific/Guam|Pacific/Saipan",
        "Pacific/Honolulu|HST",
        "Pacific/Honolulu|Pacific/Johnston",
        "Pacific/Honolulu|US/Hawaii",
        "Pacific/Kwajalein|Kwajalein",
        "Pacific/Pago_Pago|Pacific/Midway",
        "Pacific/Pago_Pago|Pacific/Samoa",
        "Pacific/Pago_Pago|US/Samoa",
        "Pacific/Port_Moresby|Antarctica/DumontDUrville",
        "Pacific/Port_Moresby|Pacific/Chuuk",
        "Pacific/Port_Moresby|Pacific/Truk",
        "Pacific/Port_Moresby|Pacific/Yap",
        "Pacific/Tarawa|Pacific/Funafuti",
        "Pacific/Tarawa|Pacific/Majuro",
        "Pacific/Tarawa|Pacific/Wake",
        "Pacific/Tarawa|Pacific/Wallis"
      ],
      countries: [
        "AD|Europe/Andorra",
        "AE|Asia/Dubai",
        "AF|Asia/Kabul",
        "AG|America/Puerto_Rico America/Antigua",
        "AI|America/Puerto_Rico America/Anguilla",
        "AL|Europe/Tirane",
        "AM|Asia/Yerevan",
        "AO|Africa/Lagos Africa/Luanda",
        "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
        "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
        "AS|Pacific/Pago_Pago",
        "AT|Europe/Vienna",
        "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo",
        "AW|America/Puerto_Rico America/Aruba",
        "AX|Europe/Helsinki Europe/Mariehamn",
        "AZ|Asia/Baku",
        "BA|Europe/Belgrade Europe/Sarajevo",
        "BB|America/Barbados",
        "BD|Asia/Dhaka",
        "BE|Europe/Brussels",
        "BF|Africa/Abidjan Africa/Ouagadougou",
        "BG|Europe/Sofia",
        "BH|Asia/Qatar Asia/Bahrain",
        "BI|Africa/Maputo Africa/Bujumbura",
        "BJ|Africa/Lagos Africa/Porto-Novo",
        "BL|America/Puerto_Rico America/St_Barthelemy",
        "BM|Atlantic/Bermuda",
        "BN|Asia/Kuching Asia/Brunei",
        "BO|America/La_Paz",
        "BQ|America/Puerto_Rico America/Kralendijk",
        "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
        "BS|America/Toronto America/Nassau",
        "BT|Asia/Thimphu",
        "BW|Africa/Maputo Africa/Gaborone",
        "BY|Europe/Minsk",
        "BZ|America/Belize",
        "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
        "CC|Asia/Yangon Indian/Cocos",
        "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
        "CF|Africa/Lagos Africa/Bangui",
        "CG|Africa/Lagos Africa/Brazzaville",
        "CH|Europe/Zurich",
        "CI|Africa/Abidjan",
        "CK|Pacific/Rarotonga",
        "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter",
        "CM|Africa/Lagos Africa/Douala",
        "CN|Asia/Shanghai Asia/Urumqi",
        "CO|America/Bogota",
        "CR|America/Costa_Rica",
        "CU|America/Havana",
        "CV|Atlantic/Cape_Verde",
        "CW|America/Puerto_Rico America/Curacao",
        "CX|Asia/Bangkok Indian/Christmas",
        "CY|Asia/Nicosia Asia/Famagusta",
        "CZ|Europe/Prague",
        "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
        "DJ|Africa/Nairobi Africa/Djibouti",
        "DK|Europe/Berlin Europe/Copenhagen",
        "DM|America/Puerto_Rico America/Dominica",
        "DO|America/Santo_Domingo",
        "DZ|Africa/Algiers",
        "EC|America/Guayaquil Pacific/Galapagos",
        "EE|Europe/Tallinn",
        "EG|Africa/Cairo",
        "EH|Africa/El_Aaiun",
        "ER|Africa/Nairobi Africa/Asmara",
        "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
        "ET|Africa/Nairobi Africa/Addis_Ababa",
        "FI|Europe/Helsinki",
        "FJ|Pacific/Fiji",
        "FK|Atlantic/Stanley",
        "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
        "FO|Atlantic/Faroe",
        "FR|Europe/Paris",
        "GA|Africa/Lagos Africa/Libreville",
        "GB|Europe/London",
        "GD|America/Puerto_Rico America/Grenada",
        "GE|Asia/Tbilisi",
        "GF|America/Cayenne",
        "GG|Europe/London Europe/Guernsey",
        "GH|Africa/Abidjan Africa/Accra",
        "GI|Europe/Gibraltar",
        "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
        "GM|Africa/Abidjan Africa/Banjul",
        "GN|Africa/Abidjan Africa/Conakry",
        "GP|America/Puerto_Rico America/Guadeloupe",
        "GQ|Africa/Lagos Africa/Malabo",
        "GR|Europe/Athens",
        "GS|Atlantic/South_Georgia",
        "GT|America/Guatemala",
        "GU|Pacific/Guam",
        "GW|Africa/Bissau",
        "GY|America/Guyana",
        "HK|Asia/Hong_Kong",
        "HN|America/Tegucigalpa",
        "HR|Europe/Belgrade Europe/Zagreb",
        "HT|America/Port-au-Prince",
        "HU|Europe/Budapest",
        "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
        "IE|Europe/Dublin",
        "IL|Asia/Jerusalem",
        "IM|Europe/London Europe/Isle_of_Man",
        "IN|Asia/Kolkata",
        "IO|Indian/Chagos",
        "IQ|Asia/Baghdad",
        "IR|Asia/Tehran",
        "IS|Africa/Abidjan Atlantic/Reykjavik",
        "IT|Europe/Rome",
        "JE|Europe/London Europe/Jersey",
        "JM|America/Jamaica",
        "JO|Asia/Amman",
        "JP|Asia/Tokyo",
        "KE|Africa/Nairobi",
        "KG|Asia/Bishkek",
        "KH|Asia/Bangkok Asia/Phnom_Penh",
        "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
        "KM|Africa/Nairobi Indian/Comoro",
        "KN|America/Puerto_Rico America/St_Kitts",
        "KP|Asia/Pyongyang",
        "KR|Asia/Seoul",
        "KW|Asia/Riyadh Asia/Kuwait",
        "KY|America/Panama America/Cayman",
        "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
        "LA|Asia/Bangkok Asia/Vientiane",
        "LB|Asia/Beirut",
        "LC|America/Puerto_Rico America/St_Lucia",
        "LI|Europe/Zurich Europe/Vaduz",
        "LK|Asia/Colombo",
        "LR|Africa/Monrovia",
        "LS|Africa/Johannesburg Africa/Maseru",
        "LT|Europe/Vilnius",
        "LU|Europe/Brussels Europe/Luxembourg",
        "LV|Europe/Riga",
        "LY|Africa/Tripoli",
        "MA|Africa/Casablanca",
        "MC|Europe/Paris Europe/Monaco",
        "MD|Europe/Chisinau",
        "ME|Europe/Belgrade Europe/Podgorica",
        "MF|America/Puerto_Rico America/Marigot",
        "MG|Africa/Nairobi Indian/Antananarivo",
        "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
        "MK|Europe/Belgrade Europe/Skopje",
        "ML|Africa/Abidjan Africa/Bamako",
        "MM|Asia/Yangon",
        "MN|Asia/Ulaanbaatar Asia/Hovd",
        "MO|Asia/Macau",
        "MP|Pacific/Guam Pacific/Saipan",
        "MQ|America/Martinique",
        "MR|Africa/Abidjan Africa/Nouakchott",
        "MS|America/Puerto_Rico America/Montserrat",
        "MT|Europe/Malta",
        "MU|Indian/Mauritius",
        "MV|Indian/Maldives",
        "MW|Africa/Maputo Africa/Blantyre",
        "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
        "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
        "MZ|Africa/Maputo",
        "NA|Africa/Windhoek",
        "NC|Pacific/Noumea",
        "NE|Africa/Lagos Africa/Niamey",
        "NF|Pacific/Norfolk",
        "NG|Africa/Lagos",
        "NI|America/Managua",
        "NL|Europe/Brussels Europe/Amsterdam",
        "NO|Europe/Berlin Europe/Oslo",
        "NP|Asia/Kathmandu",
        "NR|Pacific/Nauru",
        "NU|Pacific/Niue",
        "NZ|Pacific/Auckland Pacific/Chatham",
        "OM|Asia/Dubai Asia/Muscat",
        "PA|America/Panama",
        "PE|America/Lima",
        "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
        "PG|Pacific/Port_Moresby Pacific/Bougainville",
        "PH|Asia/Manila",
        "PK|Asia/Karachi",
        "PL|Europe/Warsaw",
        "PM|America/Miquelon",
        "PN|Pacific/Pitcairn",
        "PR|America/Puerto_Rico",
        "PS|Asia/Gaza Asia/Hebron",
        "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
        "PW|Pacific/Palau",
        "PY|America/Asuncion",
        "QA|Asia/Qatar",
        "RE|Asia/Dubai Indian/Reunion",
        "RO|Europe/Bucharest",
        "RS|Europe/Belgrade",
        "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
        "RW|Africa/Maputo Africa/Kigali",
        "SA|Asia/Riyadh",
        "SB|Pacific/Guadalcanal",
        "SC|Asia/Dubai Indian/Mahe",
        "SD|Africa/Khartoum",
        "SE|Europe/Berlin Europe/Stockholm",
        "SG|Asia/Singapore",
        "SH|Africa/Abidjan Atlantic/St_Helena",
        "SI|Europe/Belgrade Europe/Ljubljana",
        "SJ|Europe/Berlin Arctic/Longyearbyen",
        "SK|Europe/Prague Europe/Bratislava",
        "SL|Africa/Abidjan Africa/Freetown",
        "SM|Europe/Rome Europe/San_Marino",
        "SN|Africa/Abidjan Africa/Dakar",
        "SO|Africa/Nairobi Africa/Mogadishu",
        "SR|America/Paramaribo",
        "SS|Africa/Juba",
        "ST|Africa/Sao_Tome",
        "SV|America/El_Salvador",
        "SX|America/Puerto_Rico America/Lower_Princes",
        "SY|Asia/Damascus",
        "SZ|Africa/Johannesburg Africa/Mbabane",
        "TC|America/Grand_Turk",
        "TD|Africa/Ndjamena",
        "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
        "TG|Africa/Abidjan Africa/Lome",
        "TH|Asia/Bangkok",
        "TJ|Asia/Dushanbe",
        "TK|Pacific/Fakaofo",
        "TL|Asia/Dili",
        "TM|Asia/Ashgabat",
        "TN|Africa/Tunis",
        "TO|Pacific/Tongatapu",
        "TR|Europe/Istanbul",
        "TT|America/Puerto_Rico America/Port_of_Spain",
        "TV|Pacific/Tarawa Pacific/Funafuti",
        "TW|Asia/Taipei",
        "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
        "UA|Europe/Simferopol Europe/Kyiv",
        "UG|Africa/Nairobi Africa/Kampala",
        "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
        "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
        "UY|America/Montevideo",
        "UZ|Asia/Samarkand Asia/Tashkent",
        "VA|Europe/Rome Europe/Vatican",
        "VC|America/Puerto_Rico America/St_Vincent",
        "VE|America/Caracas",
        "VG|America/Puerto_Rico America/Tortola",
        "VI|America/Puerto_Rico America/St_Thomas",
        "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
        "VU|Pacific/Efate",
        "WF|Pacific/Tarawa Pacific/Wallis",
        "WS|Pacific/Apia",
        "YE|Asia/Riyadh Asia/Aden",
        "YT|Africa/Nairobi Indian/Mayotte",
        "ZA|Africa/Johannesburg",
        "ZM|Africa/Maputo Africa/Lusaka",
        "ZW|Africa/Maputo Africa/Harare"
      ]
    };
  }
});

// ../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/index.js
var require_moment_timezone2 = __commonJS({
  "../node_modules/.pnpm/moment-timezone@0.5.48/node_modules/moment-timezone/index.js"(exports2, module2) {
    var moment = module2.exports = require_moment_timezone();
    moment.tz.load(require_latest());
  }
});

// ../state-options/dist/StateOptions.js
var require_StateOptions = __commonJS({
  "../state-options/dist/StateOptions.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.defaultModifiers = exports2.Operation = exports2.AbstractDataType = exports2.DataTypeTypes = exports2.influxLoadTypes = exports2.LoadTypes = exports2.DataCategoryTypes = exports2.HubConnections = exports2.Connections = exports2.Units = exports2.DataTypes = exports2.DataCategories = exports2.GatewayOptions = exports2.DeviceOptions = exports2.StateOptions = void 0;
    function createMappingArray(data, lookupProperty) {
      const mapping = /* @__PURE__ */ new Map();
      data.forEach((item) => {
        mapping.set(item[lookupProperty], item);
      });
      return new Proxy(data, {
        get(target, prop, receiver) {
          const value = Reflect.get(target, prop, receiver);
          if (value !== void 0) {
            return value;
          }
          if (typeof prop === "string") {
            return mapping.get(prop);
          }
          return void 0;
        }
      });
    }
    var PythiaObjectType;
    (function(PythiaObjectType2) {
      PythiaObjectType2["ASSET"] = "asset";
      PythiaObjectType2["GATEWAY"] = "gateway";
      PythiaObjectType2["RULE"] = "rule";
    })(PythiaObjectType || (PythiaObjectType = {}));
    var Operation;
    (function(Operation2) {
      Operation2["ADD"] = "add";
      Operation2["SUBTRACT"] = "subtract";
    })(Operation || (exports2.Operation = Operation = {}));
    var AbstractDataType;
    (function(AbstractDataType2) {
      AbstractDataType2["AGGREGATE"] = "aggregate";
      AbstractDataType2["CALCULATED"] = "calculated";
      AbstractDataType2["INSTANTANEOUS"] = "instantaneous";
      AbstractDataType2["TARIFF"] = "tariff";
      AbstractDataType2["EVENT"] = "event";
      AbstractDataType2["MESSAGE"] = "message";
      AbstractDataType2["CATEGORICAL"] = "categorical";
      AbstractDataType2["ONCE"] = "once";
    })(AbstractDataType || (exports2.AbstractDataType = AbstractDataType = {}));
    var HubConnections;
    (function(HubConnections2) {
      HubConnections2["ETHERNET"] = "ethernet";
      HubConnections2["WIFI"] = "wifi";
      HubConnections2["MOBILE"] = "mobile";
    })(HubConnections || (exports2.HubConnections = HubConnections = {}));
    var Connections;
    (function(Connections2) {
      Connections2["NB_IOT"] = "NB-IoT";
      Connections2["BLUETOOTH"] = "Bluetooth";
      Connections2["ZIGBEE"] = "Zigbee";
      Connections2["API"] = "API";
      Connections2["EMLITE"] = "Emlite";
      Connections2["PRESSAC"] = "Pressac";
      Connections2["POWER_RADAR"] = "Power Radar";
      Connections2["SOLAR_EDGE"] = "Solar Edge";
      Connections2["VIRTUAL"] = "Virtual";
      Connections2["MODBUS_RTU"] = "Modbus RTU";
      Connections2["MODBUS_TCP"] = "Modbus TCP";
      Connections2["BACNET_TCP_IP"] = "BACnet/IP";
      Connections2["SENSE_ANYWHERE"] = "Sense Anywhere";
      Connections2["CONSULTUS"] = "Consultus";
      Connections2["DATA_UPLOAD"] = "Manual Data Upload";
    })(Connections || (exports2.Connections = Connections = {}));
    var DataCategoryTypes;
    (function(DataCategoryTypes2) {
      DataCategoryTypes2["ELECTRICITY"] = "ELECTRICITY";
      DataCategoryTypes2["CURRENT"] = "CURRENT";
      DataCategoryTypes2["WATER"] = "WATER";
      DataCategoryTypes2["HOT_WATER"] = "HOT_WATER";
      DataCategoryTypes2["GAS"] = "GAS";
      DataCategoryTypes2["GENERATION"] = "GENERATION";
      DataCategoryTypes2["SIGNAL"] = "SIGNAL";
      DataCategoryTypes2["TEMPERATURE"] = "TEMPERATURE";
      DataCategoryTypes2["INDOOR_AIR_QUALITY"] = "INDOOR_AIR_QUALITY";
      DataCategoryTypes2["CO2"] = "CO2";
      DataCategoryTypes2["PRESSURE"] = "PRESSURE";
      DataCategoryTypes2["HUMIDITY"] = "HUMIDITY";
      DataCategoryTypes2["OCCUPANCY"] = "OCCUPANCY";
      DataCategoryTypes2["OPEN_CLOSED"] = "OPEN_CLOSED";
      DataCategoryTypes2["ENVIRONMENTAL"] = "ENVIRONMENTAL";
      DataCategoryTypes2["SYSTEM"] = "SYSTEM";
      DataCategoryTypes2["LIGHT"] = "LIGHT";
      DataCategoryTypes2["BATTERY"] = "BATTERY";
      DataCategoryTypes2["EXPORTED"] = "EXPORTED";
      DataCategoryTypes2["IMPORTED"] = "IMPORTED";
      DataCategoryTypes2["INTERNAL"] = "INTERNAL";
    })(DataCategoryTypes || (exports2.DataCategoryTypes = DataCategoryTypes = {}));
    var ModifierTypes;
    (function(ModifierTypes2) {
      ModifierTypes2["GAS_ENERGY_CONVERSION"] = "gas_energy_conversion";
    })(ModifierTypes || (ModifierTypes = {}));
    var defaultModifiers = {
      [ModifierTypes.GAS_ENERGY_CONVERSION]: {
        id: ModifierTypes.GAS_ENERGY_CONVERSION,
        "operations": [
          {
            "order": 1,
            "operation": "multiply",
            "parameters": [
              {
                "name": "volume_correction_factor",
                "value": 1.02264,
                "description": "Standard factor to normalize gas volume for temperature and pressure.",
                "unit": "Dimensionless"
              }
            ],
            "description": "Correct the measured gas volume."
          },
          {
            "order": 2,
            "operation": "multiply",
            "parameters": [
              {
                "name": "calorific_value",
                "value": 39.5,
                "description": "Energy content of the gas. CRITICAL: This value varies and should be updated from the gas supplier's bill for accuracy.",
                "unit": "MJ/m\xB3"
              }
            ],
            "description": "Apply the gas's energy content (Calorific Value)."
          },
          {
            "order": 3,
            "operation": "divide",
            "parameters": [
              {
                "name": "mj_to_kwh_conversion",
                "value": 3.6,
                "description": "Fixed constant to convert Megajoules (MJ) to kilowatt-hours (kWh).",
                "unit": "MJ/kW/h"
              }
            ],
            "description": "Convert energy unit from MJ to kWh."
          }
        ],
        "finalUnit": "kW/h",
        "name": "Gas Volume to Energy",
        "description": "Accurate gas to energy conversion based on Ofgem formula."
      }
    };
    exports2.defaultModifiers = defaultModifiers;
    var DataCategories = [
      {
        id: DataCategoryTypes.ELECTRICITY,
        name: "Electricity",
        icon: "FaBolt",
        glyph: "\uF0E7",
        color: "#FFCA00"
      },
      {
        id: DataCategoryTypes.GENERATION,
        name: "Generation",
        icon: "FaSolarPanel",
        glyph: "\uF5BA",
        color: "#3ad56e"
      },
      {
        id: DataCategoryTypes.EXPORTED,
        name: "Export",
        icon: "FaArrowAltCircleUp",
        glyph: "\uF35B",
        color: "#3ad56e"
      },
      {
        id: DataCategoryTypes.IMPORTED,
        name: "Import",
        icon: "FaArrowAltCircleDown",
        glyph: "\uF0AB",
        color: "#FFCA00"
      },
      {
        id: DataCategoryTypes.CURRENT,
        name: "Current",
        icon: "FaWaveSquare",
        glyph: "\uF83E",
        color: "#FFCA00"
      },
      {
        id: DataCategoryTypes.WATER,
        name: "Water",
        icon: "FaTint",
        glyph: "\uF043",
        color: "#00C3EE"
      },
      {
        id: DataCategoryTypes.HOT_WATER,
        name: "Hot Water",
        icon: "FaTint",
        glyph: "\uF043",
        color: "#f52ec0"
      },
      {
        id: DataCategoryTypes.GAS,
        name: "Gas",
        icon: "FaFire",
        glyph: "\uF06D",
        color: "#D768F2"
      },
      {
        id: DataCategoryTypes.ENVIRONMENTAL,
        name: "Environmental",
        icon: "FaBuilding",
        glyph: "\uF1AD"
        // color: '#228B22'
      },
      {
        id: DataCategoryTypes.TEMPERATURE,
        name: "Temperature",
        icon: "FaThermometerThreeQuarters",
        glyph: "\uF2C8",
        color: "#e88a16"
      },
      {
        id: DataCategoryTypes.INDOOR_AIR_QUALITY,
        name: "Indoor Air Quality",
        glyph: "\uF72E",
        icon: "FaWind"
      },
      {
        id: DataCategoryTypes.CO2,
        name: "CO2",
        glyph: "\uF72E",
        icon: "FaWind"
      },
      {
        id: DataCategoryTypes.PRESSURE,
        name: "Pressure",
        icon: "FaWeightHanging",
        glyph: "\uF5CD"
      },
      {
        id: DataCategoryTypes.HUMIDITY,
        name: "Humidity",
        icon: "FaWater",
        glyph: "\uF773"
      },
      {
        id: DataCategoryTypes.OCCUPANCY,
        name: "Occupancy",
        icon: "FaGhost",
        glyph: "\uF6E2"
      },
      {
        id: DataCategoryTypes.OPEN_CLOSED,
        name: "Open/Closed",
        icon: "FaDoorOpen",
        glyph: "\uF52B"
      },
      {
        id: DataCategoryTypes.LIGHT,
        name: "Light",
        icon: "FaLightbulb",
        glyph: "\uF0EB"
      },
      {
        id: DataCategoryTypes.INTERNAL,
        name: "Battery",
        icon: "FaBatteryThreeQuarters",
        glyph: "\uF241"
      },
      {
        id: DataCategoryTypes.SYSTEM,
        name: "System",
        icon: "MdSettings",
        glyph: "\uF013"
      },
      {
        id: DataCategoryTypes.BATTERY,
        name: "Battery",
        icon: "FaBatteryThreeQuarters",
        glyph: "\uF241"
      },
      {
        id: DataCategoryTypes.SIGNAL,
        name: "Signal",
        icon: "FaBroadcastTower",
        glyph: "\uF519"
      }
    ];
    exports2.DataCategories = DataCategories;
    exports2.DataCategories = DataCategories = DataCategories.map((dc, i) => {
      dc.position = i + 1;
      dc.color = dc.color || "#49b9c4";
      return dc;
    });
    var Units = [
      {
        id: "INTERNAL",
        name: "Internal",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "metric",
        metaData: { symbol: "W" },
        unitCategory: "Internal"
      },
      {
        id: "WATT",
        name: "Power",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "metric",
        metaData: { symbol: "W" },
        unitCategory: "Energy"
      },
      {
        id: "WATT_HOUR",
        name: "Energy",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "metric",
        metaData: { symbol: "Wh" },
        unitCategory: "Energy"
      },
      {
        id: "AMPERE",
        name: "Current",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "metric",
        metaData: { symbol: "A" },
        unitCategory: "Electricity"
      },
      {
        id: "VOLT",
        name: "Voltage",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "metric",
        metaData: { symbol: "V" },
        unitCategory: "Electricity"
      },
      {
        id: "LENGTH",
        name: "Length (Metric)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "metric",
        metaData: { symbol: "m" },
        unitCategory: "Length"
      },
      {
        id: "LENGTH_IMPERIAL",
        name: "Length (Imperial)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "nonMetric",
        unitCategory: "Length",
        metaData: {
          symbol: "in",
          rules: [
            {
              "id": "base",
              "scale_of_base": 1,
              "name": "Inch",
              "symbol": "in"
            },
            {
              "id": "1",
              "scale_of_base": 12,
              "name": "Foot",
              "symbol": "ft"
            },
            {
              "id": "2",
              "scale_of_base": 36,
              "name": "Yard",
              "symbol": "yd"
            },
            {
              "id": "3",
              "scale_of_base": 63360,
              "name": "Mile",
              "symbol": "mi"
            }
          ]
        }
      },
      {
        id: "SQUARED_METER",
        name: "Area (Metric)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "metric",
        metaData: { symbol: "m\xB2" },
        unitCategory: "Area"
      },
      {
        id: "AREA_IMPERIAL",
        name: "Area (Imperial)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "nonMetric",
        unitCategory: "Area",
        metaData: {
          symbol: "in\xB2",
          rules: [
            {
              "id": "base",
              "scale_of_base": 1,
              "name": "Square Inch",
              "symbol": "in\xB2"
            },
            {
              "id": "1",
              "scale_of_base": 12,
              "name": "Square Foot",
              "symbol": "ft\xB2"
            },
            {
              "id": "2",
              "scale_of_base": 36,
              "name": "Square Yard",
              "symbol": "yd\xB2"
            },
            {
              "id": "3",
              "scale_of_base": 63360,
              "name": "Square Mile",
              "symbol": "mi\xB2"
            },
            {
              "id": "4",
              "scale_of_base": 627263935e-2,
              "name": "Acre",
              "symbol": "ac\xB2"
            }
          ]
        }
      },
      {
        id: "CUBIC_METER",
        name: "Volume (Metric)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "metric",
        metaData: { symbol: "m\u1D9F" },
        unitCategory: "Volume"
      },
      {
        id: "VOLUME_IMPERIAL",
        name: "Volume (Imperial)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "nonMetric",
        unitCategory: "Volume",
        metaData: {
          symbol: "in\xB2",
          rules: [
            {
              "id": "base",
              "scale_of_base": 1,
              "name": "Fluid Ounce",
              "symbol": "fl oz"
            },
            {
              "id": "1",
              "scale_of_base": 5,
              "name": "Gill",
              "symbol": "gi"
            },
            {
              "id": "2",
              "scale_of_base": 20,
              "name": "Pint",
              "symbol": "pt"
            },
            {
              "id": "3",
              "scale_of_base": 40,
              "name": "Quart",
              "symbol": "qt"
            },
            {
              "id": "4",
              "scale_of_base": 160,
              "name": "Gallon",
              "symbol": "gal"
            }
          ]
        }
      },
      {
        id: "GRAM",
        name: "Weight (Metric)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "metric",
        metaData: { symbol: "g" },
        unitCategory: "Weight"
      },
      {
        id: "WEIGHT_IMPERIAL",
        name: "Weight (Imperial)",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "nonMetric",
        unitCategory: "Weight",
        metaData: {
          symbol: "lb",
          rules: [
            {
              "id": "base",
              "scale_of_base": 1,
              "name": "Pound",
              "symbol": "lb"
            },
            {
              "id": "1",
              "scale_of_base": 0.0625,
              "name": "ounce",
              "symbol": "oz"
            },
            {
              "id": "2",
              "scale_of_base": 14,
              "name": "Stone",
              "symbol": "st"
            },
            {
              "id": "3",
              "scale_of_base": 28,
              "name": "Quarter",
              "symbol": "qr"
            },
            {
              "id": "4",
              "scale_of_base": 112,
              "name": "Hundredweight",
              "symbol": "cwt"
            },
            {
              "id": "5",
              "scale_of_base": 2240,
              "name": "Ton",
              "symbol": "t"
            }
          ]
        }
      },
      {
        id: "TEMPERATURE",
        name: "Temperature",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "\xB0C" },
        unitCategory: "Environmental"
      },
      {
        id: "INDOOR_AIR_QUALITY",
        name: "Indoor Air Quality",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "IAQ" },
        unitCategory: "Environmental"
      },
      {
        id: "CO2",
        name: "Carbon Dioxide",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "ppm" },
        unitCategory: "Environmental"
      },
      {
        id: "PRESSURE",
        name: "Pressure",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "hPa" },
        unitCategory: "Environmental"
      },
      {
        id: "OCCUPANCY",
        name: "Occupied/Unoccupied",
        dataType: AbstractDataType.CATEGORICAL,
        unitType: "boolean",
        metaData: {
          symbol: "0/1",
          categories: [{ "id": "true", "value": 1, "label": "Occupied" }, {
            "id": "false",
            "value": 0,
            "label": "Unoccupied"
          }]
        },
        unitCategory: "Environmental"
      },
      {
        id: "LUMINANCE",
        name: "Luminance",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "metric",
        metaData: { symbol: "lx" },
        unitCategory: "Environmental"
      },
      {
        id: "PERCENTAGE",
        name: "Percentage",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "%" },
        unitCategory: "Special"
      },
      {
        id: "DECIBEL",
        name: "Decibel",
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: "dimensionless",
        metaData: { symbol: "dB" },
        unitCategory: "Special"
      },
      {
        id: "CURRENCY",
        name: "Currency",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "currency",
        metaData: { symbol: "p" },
        unitCategory: "Special"
      },
      {
        id: "TIME",
        name: "Time",
        dataType: AbstractDataType.AGGREGATE,
        unitType: "nonMetric",
        metaData: {
          symbol: "h",
          rules: [{
            "id": "1",
            "scale_of_base": 1e-3,
            "name": "Millisecond",
            "symbol": "ms"
          }, {
            "id": "base",
            "scale_of_base": 1,
            "name": "Second",
            "symbol": "s"
          }, {
            "id": "2",
            "scale_of_base": 60,
            "name": "Minute",
            "symbol": "min"
          }, {
            "id": "3",
            "scale_of_base": 3600,
            "name": "Hour",
            "symbol": "h"
          }, {
            "id": "4",
            "scale_of_base": 604800,
            "name": "Week",
            "symbol": "wk"
          }, {
            "id": "5",
            "scale_of_base": 2629746,
            "name": "Month (Aprox.)",
            "symbol": "mo"
          }, {
            "id": "6",
            "scale_of_base": 31536e3,
            "name": "Year",
            "symbol": "yr"
          }]
        },
        unitCategory: "Special"
      },
      {
        id: "OPEN_CLOSED",
        name: "Open/Closed",
        dataType: AbstractDataType.CATEGORICAL,
        unitType: "boolean",
        metaData: {
          symbol: "0/1",
          categories: [{ "id": "true", "value": 1, "label": "Open" }, {
            "id": "false",
            "value": 0,
            "label": "Closed"
          }]
        },
        unitCategory: "Special"
      },
      {
        id: "TRUE_FALSE",
        name: "True/False",
        dataType: AbstractDataType.CATEGORICAL,
        unitType: "boolean",
        metaData: {
          symbol: "0/1",
          categories: [{ "id": "true", "value": 1, "label": "True" }, {
            "id": "false",
            "value": 0,
            "label": "False"
          }]
        },
        unitCategory: "Special"
      }
    ];
    exports2.Units = Units;
    var LoadTypes;
    (function(LoadTypes2) {
      LoadTypes2[LoadTypes2["CONSUMPTION_ONLY"] = 0] = "CONSUMPTION_ONLY";
      LoadTypes2[LoadTypes2["GENERATION_ONLY"] = 1] = "GENERATION_ONLY";
      LoadTypes2[LoadTypes2["CONSUMPTION_EXPORT"] = 2] = "CONSUMPTION_EXPORT";
    })(LoadTypes || (exports2.LoadTypes = LoadTypes = {}));
    var influxLoadTypes;
    (function(influxLoadTypes2) {
      influxLoadTypes2["DELIVERED"] = "DELIVERED";
      influxLoadTypes2["GENERATED"] = "GENERATED";
      influxLoadTypes2["CONSUMPTION"] = "CONSUMPTION";
      influxLoadTypes2["USAGE_DELIVERED"] = "USAGE_DELIVERED";
      influxLoadTypes2["USAGE_CONSUMPTION"] = "USAGE_CONSUMPTION";
    })(influxLoadTypes || (exports2.influxLoadTypes = influxLoadTypes = {}));
    var DataTypeTypes;
    (function(DataTypeTypes2) {
      DataTypeTypes2["CONSUMPTION"] = "CONSUMPTION";
      DataTypeTypes2["CONSUMPTION_PULSE"] = "CONSUMPTION_PULSE";
      DataTypeTypes2["IMPORTED_DELIVERED"] = "IMPORTED_DELIVERED";
      DataTypeTypes2["USAGE_DELIVERED"] = "USAGE_DELIVERED";
      DataTypeTypes2["USAGE_CONSUMPTION"] = "USAGE_CONSUMPTION";
      DataTypeTypes2["IMPORTED_DELIVERED_SPEND"] = "IMPORTED_DELIVERED_SPEND";
      DataTypeTypes2["IMPORTED_DELIVERED_CARBON"] = "IMPORTED_DELIVERED_CARBON";
      DataTypeTypes2["IMPORTED_CONSUMPTION"] = "IMPORTED_CONSUMPTION";
      DataTypeTypes2["DELIVERED"] = "DELIVERED";
      DataTypeTypes2["ASSET_SIGNAL_STRENGTH"] = "ASSET_SIGNAL_STRENGTH";
      DataTypeTypes2["NB_IOT_ECL"] = "NB_IOT_ECL";
      DataTypeTypes2["ASSET_BATTERY_ALARM"] = "ASSET_BATTERY_ALARM";
      DataTypeTypes2["ASSET_BATTERY_VOLTAGE"] = "ASSET_BATTERY_VOLTAGE";
      DataTypeTypes2["ROOM_TEMPERATURE"] = "ROOM_TEMPERATURE";
      DataTypeTypes2["TEMPERATURE"] = "TEMPERATURE";
      DataTypeTypes2["EXTERNAL_TEMPERATURE"] = "EXTERNAL_TEMPERATURE";
      DataTypeTypes2["VOC"] = "VOC";
      DataTypeTypes2["CO2"] = "CO2";
      DataTypeTypes2["PRESSURE"] = "PRESSURE";
      DataTypeTypes2["HUMIDITY"] = "HUMIDITY";
      DataTypeTypes2["EXTERNAL_HUMIDITY"] = "EXTERNAL_HUMIDITY";
      DataTypeTypes2["OCCUPANCY"] = "OCCUPANCY";
      DataTypeTypes2["OPEN"] = "OPEN";
      DataTypeTypes2["LIGHT"] = "LIGHT";
      DataTypeTypes2["ASSET_BATTERY_PERCENT"] = "ASSET_BATTERY_PERCENT";
      DataTypeTypes2["WATER_PULSE"] = "WATER_PULSE";
      DataTypeTypes2["DELIVERED_WATER"] = "DELIVERED_WATER";
      DataTypeTypes2["WATER_PULSE_HOT"] = "WATER_PULSE_HOT";
      DataTypeTypes2["DELIVERED_WATER_HOT"] = "DELIVERED_WATER_HOT";
      DataTypeTypes2["GAS_PULSE"] = "GAS_PULSE";
      DataTypeTypes2["DELIVERED_GAS"] = "DELIVERED_GAS";
      DataTypeTypes2["GENERATED"] = "GENERATED";
      DataTypeTypes2["CURRENT"] = "CURRENT";
      DataTypeTypes2["EXPORTED_DELIVERED"] = "EXPORTED_DELIVERED";
      DataTypeTypes2["EXPORTED_CONSUMPTION"] = "EXPORTED_CONSUMPTION";
      DataTypeTypes2["EXPORTED_DELIVERED_SPEND"] = "EXPORTED_DELIVERED_SPEND";
      DataTypeTypes2["EXPORTED_DELIVERED_CARBON"] = "EXPORTED_DELIVERED_CARBON";
      DataTypeTypes2["GENERATED_DELIVERED"] = "GENERATED_DELIVERED";
      DataTypeTypes2["GENERATED_CONSUMPTION"] = "GENERATED_CONSUMPTION";
      DataTypeTypes2["GAS_ENERGY_DELIVERED"] = "GAS_ENERGY_DELIVERED";
      DataTypeTypes2["GAS_ENERGY_CONSUMPTION"] = "GAS_ENERGY_CONSUMPTION";
      DataTypeTypes2["GAS_ENERGY_CONVERTED_DELIVERED"] = "GAS_ENERGY_CONVERTED_DELIVERED";
      DataTypeTypes2["GAS_ENERGY_CONVERTED_CONSUMPTION"] = "GAS_ENERGY_CONVERTED_CONSUMPTION";
      DataTypeTypes2["GATEWAY_MOBILE_STRENGTH"] = "GATEWAY_MOBILE_STRENGTH";
      DataTypeTypes2["GATEWAY_WIFI_STRENGTH"] = "GATEWAY_WIFI_STRENGTH";
      DataTypeTypes2["DELIVERED_SPEND"] = "DELIVERED_SPEND";
      DataTypeTypes2["DELIVERED_GAS_SPEND"] = "DELIVERED_GAS_SPEND";
      DataTypeTypes2["DELIVERED_WATER_SPEND"] = "DELIVERED_WATER_SPEND";
      DataTypeTypes2["DELIVERED_WATER_HOT_SPEND"] = "DELIVERED_WATER_HOT_SPEND";
      DataTypeTypes2["GAS_ENERGY_DELIVERED_SPEND"] = "GAS_ENERGY_DELIVERED_SPEND";
      DataTypeTypes2["DELIVERED_CARBON"] = "DELIVERED_CARBON";
      DataTypeTypes2["DELIVERED_WATER_CARBON"] = "DELIVERED_WATER_CARBON";
      DataTypeTypes2["DELIVERED_WATER_HOT_CARBON"] = "DELIVERED_WATER_HOT_CARBON";
      DataTypeTypes2["DELIVERED_GAS_CARBON"] = "DELIVERED_GAS_CARBON";
      DataTypeTypes2["GAS_ENERGY_DELIVERED_CARBON"] = "GAS_ENERGY_DELIVERED_CARBON";
      DataTypeTypes2["GENERATED_DELIVERED_SPEND"] = "GENERATED_DELIVERED_SPEND";
      DataTypeTypes2["GENERATED_DELIVERED_CARBON"] = "GENERATED_DELIVERED_CARBON";
      DataTypeTypes2["ASSET_LAST_CONTACTED"] = "ASSET_LAST_CONTACTED";
      DataTypeTypes2["GATEWAY_LAST_CONTACTED"] = "GATEWAY_LAST_CONTACTED";
      DataTypeTypes2["EVENT"] = "EVENT";
      DataTypeTypes2["ERROR"] = "ERROR";
      DataTypeTypes2["ASSET_FIRMWARE_VERSION"] = "ASSET_FIRMWARE_VERSION";
      DataTypeTypes2["ASSET_FIRMWARE_PROGRESS"] = "ASSET_FIRMWARE_PROGRESS";
      DataTypeTypes2["ASSET_CURRENT_STATE"] = "ASSET_CURRENT_STATE";
      DataTypeTypes2["ASSET_USER_STATE"] = "ASSET_USER_STATE";
      DataTypeTypes2["ASSET_AUTOMATED_STATE"] = "ASSET_AUTOMATED_STATE";
      DataTypeTypes2["ASSET_BOOST_FINISH"] = "ASSET_BOOST_FINISH";
      DataTypeTypes2["ASSET_SNOOZE_FINISH"] = "ASSET_SNOOZE_FINISH";
      DataTypeTypes2["ASSET_SKU"] = "ASSET_SKU";
      DataTypeTypes2["MODBUS_MESSAGE"] = "MODBUS_MESSAGE";
      DataTypeTypes2["ASSET_DISCONNECTED"] = "ASSET_DISCONNECTED";
      DataTypeTypes2["ASSET_INTERMITTENT"] = "ASSET_INTERMITTENT";
      DataTypeTypes2["GATEWAY_UPDATE_STATE"] = "GATEWAY_UPDATE_STATE";
      DataTypeTypes2["GATEWAY_ACTIVE_CONNECTION"] = "GATEWAY_ACTIVE_CONNECTION";
      DataTypeTypes2["GATEWAY_POWER_SOURCE"] = "GATEWAY_POWER_SOURCE";
      DataTypeTypes2["GATEWAY_IMSI"] = "GATEWAY_IMSI";
      DataTypeTypes2["GATEWAY_TRUST_LIST"] = "GATEWAY_TRUST_LIST";
      DataTypeTypes2["GATEWAY_DEVICE_ANALYSIS"] = "GATEWAY_DEVICE_ANALYSIS";
      DataTypeTypes2["GATEWAY_UPDATED"] = "GATEWAY_UPDATED";
      DataTypeTypes2["DEVICE_UPDATED"] = "DEVICE_UPDATED";
      DataTypeTypes2["USER_RESYNC"] = "USER_RESYNC";
      DataTypeTypes2["GATEWAY_REPORTED_VERSION_ID"] = "GATEWAY_REPORTED_VERSION_ID";
      DataTypeTypes2["RULES_UPDATED"] = "RULES_UPDATED";
      DataTypeTypes2["ANOMALIES_UPDATED"] = "ANOMALIES_UPDATED";
      DataTypeTypes2["GATEWAY_IP_ADDRESS"] = "GATEWAY_IP_ADDRESS";
      DataTypeTypes2["GATEWAY_DISCONNECTED"] = "GATEWAY_DISCONNECTED";
      DataTypeTypes2["CLIENT_UPDATE"] = "CLIENT_UPDATE";
      DataTypeTypes2["RULE_CLIENT_UPDATE"] = "RULE_CLIENT_UPDATE";
      DataTypeTypes2["ONLINE_STATE_UPDATE"] = "ONLINE_STATE_UPDATE";
      DataTypeTypes2["RULE_EVENT"] = "RULE_EVENT";
      DataTypeTypes2["DEMAND_PHASE_ONE"] = "DEMAND_PHASE_ONE";
      DataTypeTypes2["DEMAND_PHASE_TWO"] = "DEMAND_PHASE_TWO";
      DataTypeTypes2["DEMAND_PHASE_THREE"] = "DEMAND_PHASE_THREE";
      DataTypeTypes2["PF_PHASE_ONE"] = "PF_PHASE_ONE";
      DataTypeTypes2["PF_PHASE_TWO"] = "PF_PHASE_TWO";
      DataTypeTypes2["PF_PHASE_THREE"] = "PF_PHASE_THREE";
      DataTypeTypes2["GATEWAY_CHARGE"] = "GATEWAY_CHARGE";
    })(DataTypeTypes || (exports2.DataTypeTypes = DataTypeTypes = {}));
    var DataTypesArray = [
      {
        type: DataTypeTypes.DELIVERED,
        label: "Usage",
        dataTypeSibling: DataTypeTypes.CONSUMPTION,
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: influxLoadTypes.DELIVERED,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.USAGE_DELIVERED
        }
      },
      {
        type: DataTypeTypes.CONSUMPTION,
        label: "Rate",
        dataTypeSibling: DataTypeTypes.DELIVERED,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        summary: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: influxLoadTypes.CONSUMPTION,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.USAGE_CONSUMPTION
        }
      },
      {
        type: DataTypeTypes.USAGE_DELIVERED,
        graphType: "line",
        abstractType: AbstractDataType.CALCULATED,
        PythiaCalculation: {
          [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_DELIVERED }, {
            type: DataTypeTypes.GENERATED_DELIVERED,
            fromChildren: true
          }],
          [Operation.SUBTRACT]: [{ type: DataTypeTypes.EXPORTED_DELIVERED }]
        },
        SpendPythiaCalculation: {
          [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_DELIVERED_SPEND }, {
            type: DataTypeTypes.GENERATED_DELIVERED_SPEND,
            fromChildren: true
          }],
          [Operation.SUBTRACT]: [{ type: DataTypeTypes.EXPORTED_DELIVERED_SPEND }]
        }
      },
      {
        type: DataTypeTypes.USAGE_CONSUMPTION,
        graphType: "bar",
        abstractType: AbstractDataType.CALCULATED,
        PythiaCalculation: {
          [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_CONSUMPTION }, {
            type: DataTypeTypes.GENERATED_CONSUMPTION,
            fromChildren: true
          }]
        }
      },
      {
        type: DataTypeTypes.IMPORTED_DELIVERED,
        label: "Import",
        dataTypeSibling: DataTypeTypes.IMPORTED_CONSUMPTION,
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.IMPORTED),
        unsafeToRetrieveWithoutLoadType: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.DELIVERED
        }
      },
      {
        type: DataTypeTypes.IMPORTED_CONSUMPTION,
        label: "Import Rate",
        dataTypeSibling: DataTypeTypes.IMPORTED_DELIVERED,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.IMPORTED),
        removeNegative: true,
        unsafeToRetrieveWithoutLoadType: true,
        summary: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.CONSUMPTION
        }
      },
      {
        type: DataTypeTypes.DELIVERED_WATER_HOT,
        dataTypeSibling: DataTypeTypes.WATER_PULSE_HOT,
        label: "Usage",
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER)
      },
      {
        type: DataTypeTypes.DELIVERED_GAS,
        dataTypeSibling: DataTypeTypes.GAS_PULSE,
        label: "Volume",
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS)
      },
      {
        type: DataTypeTypes.GAS_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED_GAS,
        label: "Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol + "/" + Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        applyRate: true,
        rateUnitDetails: Units.find((u4) => u4.id === "TIME"),
        defaultRateMultiple: 3600,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        summary: true
      },
      {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED,
        dataTypeSibling: DataTypeTypes.GAS_ENERGY_CONSUMPTION,
        label: "Energy",
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS)
      },
      {
        type: DataTypeTypes.GAS_ENERGY_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.GAS_ENERGY_DELIVERED,
        label: "Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        summary: true
      },
      {
        type: DataTypeTypes.GENERATED,
        dataTypeSibling: DataTypeTypes.GENERATED_CONSUMPTION,
        desiredDirection: "up",
        label: "Generation",
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.GENERATION),
        ignoreInReport: true
      },
      {
        type: DataTypeTypes.CONSUMPTION_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED,
        label: "Pulse Rate",
        graphType: "line",
        downloadOnly: true,
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        summary: true
      },
      {
        type: DataTypeTypes.ASSET_SIGNAL_STRENGTH,
        label: "Signal Strength",
        graphType: "line",
        summary: false,
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "DECIBEL").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "DECIBEL"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "signal_strength"
        }
      },
      {
        type: DataTypeTypes.NB_IOT_ECL,
        unit: "",
        label: "NB-IoT Comms Level",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.SIGNAL)
      },
      {
        type: DataTypeTypes.ASSET_BATTERY_ALARM,
        label: "Battery Alarm",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: "",
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.BATTERY),
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "battery_alarm"
        }
      },
      {
        type: DataTypeTypes.ASSET_BATTERY_VOLTAGE,
        label: "Voltage",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "VOLT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "VOLT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM)
      },
      {
        type: DataTypeTypes.ROOM_TEMPERATURE,
        label: "Room Temperature Hive Thermostat",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "TEMPERATURE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TEMPERATURE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.TEMPERATURE),
        summary: true,
        allowNegative: true
      },
      {
        type: DataTypeTypes.TEMPERATURE,
        nonAdditive: true,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: "Temperature",
        factor: 0.01,
        unit: Units.find((u4) => u4.id === "TEMPERATURE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TEMPERATURE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.TEMPERATURE),
        summary: true,
        allowNegative: true
      },
      {
        type: DataTypeTypes.EXTERNAL_TEMPERATURE,
        label: "External Temperature",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "TEMPERATURE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TEMPERATURE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        summary: false,
        isFromLocation: true,
        allowNegative: true
      },
      {
        type: DataTypeTypes.VOC,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: "Air Quality",
        factor: 0.01,
        unit: Units.find((u4) => u4.id === "INDOOR_AIR_QUALITY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "INDOOR_AIR_QUALITY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.INDOOR_AIR_QUALITY),
        summary: true
      },
      {
        type: DataTypeTypes.PRESSURE,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: "Pressure",
        factor: 0.1,
        unit: Units.find((u4) => u4.id === "PRESSURE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "PRESSURE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.PRESSURE),
        summary: true
      },
      {
        type: DataTypeTypes.CO2,
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: "Carbon Dioxide",
        factor: 1,
        unit: Units.find((u4) => u4.id === "CO2").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CO2"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.CO2),
        summary: true
      },
      {
        type: DataTypeTypes.HUMIDITY,
        nonAdditive: true,
        label: "Humidity",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "PERCENTAGE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "PERCENTAGE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.HUMIDITY),
        summary: true
      },
      {
        type: DataTypeTypes.EXTERNAL_HUMIDITY,
        label: "External Humidity",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "PERCENTAGE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "PERCENTAGE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.HUMIDITY),
        summary: false,
        isFromLocation: true,
        allowNegative: false
      },
      {
        type: DataTypeTypes.OCCUPANCY,
        label: "Occupancy",
        graphType: "bar",
        abstractType: AbstractDataType.CATEGORICAL,
        unit: Units.find((u4) => u4.id === "OCCUPANCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "OCCUPANCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.OCCUPANCY),
        summary: true
      },
      {
        type: DataTypeTypes.OPEN,
        label: "Open/Close",
        abstractType: AbstractDataType.CATEGORICAL,
        unit: Units.find((u4) => u4.id === "OPEN_CLOSED").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "OPEN_CLOSED"),
        summary: true,
        graphType: "line",
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.OPEN_CLOSED)
      },
      {
        type: DataTypeTypes.LIGHT,
        label: "Light",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "LUMINANCE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "LUMINANCE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ENVIRONMENTAL),
        modifier: ((v2) => v2 !== null ? Math.round(Math.pow(10, (v2 - 1) / 1e4) * 10) / 10 : null),
        summary: true
      },
      {
        type: DataTypeTypes.ASSET_BATTERY_PERCENT,
        label: "Storage Percent",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "PERCENTAGE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "PERCENTAGE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        summary: true
      },
      {
        type: DataTypeTypes.DELIVERED_WATER,
        dataTypeSibling: DataTypeTypes.WATER_PULSE,
        label: "Usage",
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER)
      },
      {
        type: DataTypeTypes.WATER_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED_WATER,
        label: "Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol + "/" + Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        applyRate: true,
        rateUnitDetails: Units.find((u4) => u4.id === "TIME"),
        defaultRateMultiple: 3600,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER),
        summary: true
      },
      {
        type: DataTypeTypes.WATER_PULSE_HOT,
        dataTypeSibling: DataTypeTypes.DELIVERED_WATER_HOT,
        label: "Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "CUBIC_METER").metaData.symbol + "/" + Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CUBIC_METER"),
        applyRate: true,
        rateUnitDetails: Units.find((u4) => u4.id === "TIME"),
        defaultRateMultiple: 3600,
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER),
        summary: true
      },
      {
        type: DataTypeTypes.CURRENT,
        label: "Current",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        factor: 1e-3,
        unit: Units.find((u4) => u4.id === "AMPERE").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "AMPERE"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.CURRENT)
      },
      {
        type: DataTypeTypes.EXPORTED_DELIVERED,
        dataTypeSibling: DataTypeTypes.EXPORTED_CONSUMPTION,
        label: "Export",
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.EXPORTED),
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.GENERATED
        },
        unsafeToRetrieveWithoutLoadType: true
      },
      {
        type: DataTypeTypes.EXPORTED_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.EXPORTED_DELIVERED,
        desiredDirection: "up",
        label: "Export Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.EXPORTED),
        flipNegative: true,
        removeNegative: true,
        summary: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: null,
          [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.CONSUMPTION
        },
        unsafeToRetrieveWithoutLoadType: true
      },
      {
        type: DataTypeTypes.EXPORTED_DELIVERED_SPEND,
        label: "Export Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.EXPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.EXPORTED_DELIVERED,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.EXPORTED_DELIVERED_CARBON,
        label: "Export Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.EXPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.EXPORTED_DELIVERED,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.IMPORTED_DELIVERED_SPEND,
        label: "Import Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.IMPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.IMPORTED_DELIVERED,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.IMPORTED_DELIVERED_CARBON,
        label: "Import Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.IMPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.IMPORTED_DELIVERED,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.GENERATED_DELIVERED,
        dataTypeSibling: DataTypeTypes.GENERATED_CONSUMPTION,
        desiredDirection: "up",
        label: "Generation",
        graphType: "bar",
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find((u4) => u4.id === "WATT_HOUR").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT_HOUR"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.GENERATION),
        summary: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: influxLoadTypes.GENERATED,
          [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        influxReverseLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: influxLoadTypes.GENERATED,
          [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        unsafeToRetrieveWithoutLoadType: true
      },
      {
        type: DataTypeTypes.GENERATED_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.GENERATED_DELIVERED,
        desiredDirection: "up",
        label: "Generation Rate",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "WATT").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "WATT"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.GENERATION),
        summary: true,
        influxLoadTypes: {
          [LoadTypes.CONSUMPTION_ONLY]: null,
          [LoadTypes.GENERATION_ONLY]: influxLoadTypes.CONSUMPTION,
          [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        influxLegacyLoadTypes: {
          [LoadTypes.GENERATION_ONLY]: influxLoadTypes.DELIVERED
        },
        unsafeToRetrieveWithoutLoadType: true
      },
      {
        type: DataTypeTypes.GATEWAY_MOBILE_STRENGTH,
        desiredDirection: "up",
        label: "Mobile Signal Strength",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "DECIBEL").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "DECIBEL"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
          translatedName: "mobile_strength"
        }
      },
      {
        type: DataTypeTypes.GATEWAY_WIFI_STRENGTH,
        desiredDirection: "up",
        label: "WiFi Signal Strength",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find((u4) => u4.id === "DECIBEL").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "DECIBEL"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
          resolution: 36e5,
          translatedName: "wifi_strength",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.DELIVERED_SPEND,
        label: "Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.GENERATED_DELIVERED_SPEND,
        label: "Generation Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find((u4) => u4.id === DataCategoryTypes.GENERATION),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GENERATED_DELIVERED,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_WATER_SPEND,
        label: "Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_WATER_HOT_SPEND,
        label: "Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER_HOT,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_GAS_SPEND,
        label: "Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_GAS,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND,
        label: "Spend",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "CURRENCY").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "CURRENCY"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GAS_ENERGY_DELIVERED,
        tariffType: "spend",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.GENERATED_DELIVERED_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GENERATED_DELIVERED,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_WATER_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_WATER_HOT_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.HOT_WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER_HOT,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.DELIVERED_GAS_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_GAS,
        tariffType: "carbon",
        tariffable: true
      },
      {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON,
        label: "Carbon",
        graphType: "bar",
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find((u4) => u4.id === "GRAM").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "GRAM"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffable: true,
        tariffType: "carbon",
        tariffComparatorDataType: DataTypeTypes.GAS_ENERGY_DELIVERED
      },
      {
        type: DataTypeTypes.ASSET_LAST_CONTACTED,
        label: "Last contacted",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "INTERNAL").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "INTERNAL"),
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "last_contacted",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.GATEWAY_LAST_CONTACTED,
        label: "Last contacted",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "last_contacted",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.EVENT,
        label: "Event",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true
      },
      {
        type: DataTypeTypes.ERROR,
        label: "Error",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true
      },
      {
        type: DataTypeTypes.ASSET_FIRMWARE_VERSION,
        label: "Firmware version",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_FIRMWARE_PROGRESS,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_USER_STATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "user_state",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_CURRENT_STATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "current_state",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_AUTOMATED_STATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "automated_state",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_BOOST_FINISH,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "boost_finish",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_SNOOZE_FINISH,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "snooze_finish",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_SKU,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "sku",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.MODBUS_MESSAGE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "modbus_message_rec",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.ASSET_DISCONNECTED,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "disconnected",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_INTERMITTENT,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "intermittent",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.ASSET_INTERMITTENT,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "intermittent",
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.GATEWAY_UPDATE_STATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "update_state",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_ACTIVE_CONNECTION,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.CATEGORICAL,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "active_connection",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_CHARGE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.INSTANTANEOUS,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "charge",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_POWER_SOURCE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "power_source",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_IMSI,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "imsi",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_TRUST_LIST,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "trusted_list",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_DEVICE_ANALYSIS,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          translatedName: "analysed_device",
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_UPDATED,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.DEVICE_UPDATED,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET
        }
      },
      {
        type: DataTypeTypes.USER_RESYNC,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.GATEWAY
        }
      },
      {
        type: DataTypeTypes.GATEWAY_REPORTED_VERSION_ID,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.GATEWAY,
          translatedName: "reported_version_id"
        }
      },
      {
        type: DataTypeTypes.RULES_UPDATED,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.RULE,
          translatedName: "reported_version_id",
          channel: "RULES_UPDATED"
        }
      },
      {
        type: DataTypeTypes.ANOMALIES_UPDATED,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.RULE,
          channel: "ANOMALIES_UPDATED"
        }
      },
      {
        type: DataTypeTypes.GATEWAY_IP_ADDRESS,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.GATEWAY,
          translatedName: "ip_address"
        }
      },
      {
        type: DataTypeTypes.CLIENT_UPDATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true
      },
      {
        type: DataTypeTypes.RULE_CLIENT_UPDATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true
      },
      {
        type: DataTypeTypes.ONLINE_STATE_UPDATE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true
      },
      {
        type: DataTypeTypes.RULE_EVENT,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.EVENT,
        factor: 1,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.RULE
        }
      },
      {
        type: DataTypeTypes.DEMAND_PHASE_ONE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "demandPhaseOne"
        }
      },
      {
        type: DataTypeTypes.DEMAND_PHASE_TWO,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "demandPhaseTwo"
        }
      },
      {
        type: DataTypeTypes.DEMAND_PHASE_THREE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "demandPhaseThree"
        }
      },
      {
        type: DataTypeTypes.PF_PHASE_ONE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "pfPhaseOne"
        }
      },
      {
        type: DataTypeTypes.PF_PHASE_TWO,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "pfPhaseTwo"
        }
      },
      {
        type: DataTypeTypes.PF_PHASE_THREE,
        label: "Firmware progress",
        graphType: "line",
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find((u4) => u4.id === "TIME").metaData.symbol,
        unitDetails: Units.find((u4) => u4.id === "TIME"),
        category: DataCategories.find((u4) => u4.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
          object: PythiaObjectType.ASSET,
          translatedName: "pfPhaseThree"
        }
      }
    ];
    DataTypesArray = DataTypesArray.map((dt) => {
      dt.id = dt.type;
      dt.name = dt.label;
      dt.dataType = dt.applyRate ? AbstractDataType.INSTANTANEOUS : dt.unitDetails && dt.unitDetails.dataType ? dt.unitDetails.dataType : dt.graphType === "line" ? AbstractDataType.INSTANTANEOUS : AbstractDataType.AGGREGATE;
      if (dt.unitDetails) {
        dt.unitId = dt.unitDetails.id;
      }
      if (dt.subCategory && dt.categoryDetails) {
        dt.categoryDetails = Object.assign(Object.assign({}, dt.categoryDetails), { position: dt.subCategory.position, color: dt.subCategory.color, icon: dt.subCategory.icon });
      }
      if (dt.categoryDetails) {
        dt.categoryId = dt.categoryDetails.id;
      }
      if (dt.applyRate && dt.rateUnitDetails) {
        dt.rateUnitId = dt.rateUnitDetails.id;
      }
      if (!dt.label) {
        dt.label = "";
      }
      return dt;
    }).sort((a4, b) => {
      var _a, _b;
      return ((_a = a4.categoryDetails) === null || _a === void 0 ? void 0 : _a.position) - ((_b = b.categoryDetails) === null || _b === void 0 ? void 0 : _b.position);
    });
    var DataTypes = createMappingArray(DataTypesArray, "type");
    exports2.DataTypes = DataTypes;
    var Options = [
      {
        label: "On",
        state: "ON",
        default: true,
        color: "#49c570"
      },
      {
        label: "Off",
        state: "OFF",
        color: "#ff5c5c"
      },
      {
        label: "Following Rule",
        state: "AUTOMATED",
        icon: "FaCalculator",
        nonSelectable: true
      },
      {
        state: "BOOST",
        nonSelectable: true
      },
      {
        state: "SNOOZE",
        nonSelectable: true
      },
      {
        label: "None",
        state: "NONE",
        color: "#cccccc"
      },
      {
        label: "Monitoring",
        state: "MONITORING",
        color: "#03a9f4",
        nonSelectable: true
      }
    ];
    var StateOptions = [
      {
        type: "default",
        label: "Default GridDuck Asset",
        hiddenFromDashAddDevice: true,
        resolution: 5 * 60 * 1e3,
        connection: Connections.ZIGBEE,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "ON"),
          Options.find((o) => o.state === "OFF"),
          Options.find((o) => o.state === "AUTOMATED"),
          Options.find((o) => o.state === "BOOST"),
          Options.find((o) => o.state === "SNOOZE"),
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "INITIALISING_SKU",
        label: "Device Initialising...",
        hiddenFromDashAddDevice: true,
        resolution: 5 * 60 * 1e3,
        connection: Connections.ZIGBEE,
        dataTypes: [],
        options: []
      },
      {
        type: "PLU-UK",
        connection: Connections.ZIGBEE,
        label: "UK Plug",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "ON"),
          Options.find((o) => o.state === "OFF"),
          Options.find((o) => o.state === "AUTOMATED"),
          Options.find((o) => o.state === "BOOST"),
          Options.find((o) => o.state === "SNOOZE"),
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SOCKET-DOUBLE-OWON",
        connection: Connections.ZIGBEE,
        label: "UK Double Socket",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "ON"),
          Options.find((o) => o.state === "OFF"),
          Options.find((o) => o.state === "AUTOMATED"),
          Options.find((o) => o.state === "BOOST"),
          Options.find((o) => o.state === "SNOOZE"),
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "INL-SWI",
        connection: Connections.ZIGBEE,
        label: "Inline Switch",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "ON"),
          Options.find((o) => o.state === "OFF"),
          Options.find((o) => o.state === "AUTOMATED"),
          Options.find((o) => o.state === "BOOST"),
          Options.find((o) => o.state === "SNOOZE"),
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "POWERVAULT",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1e3,
        label: "Powervault Secondary Asset",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ],
        allowNegative: true
      },
      {
        type: "CLI-SEN-POW",
        resolution: 5 * 60 * 1e3,
        connection: Connections.ZIGBEE,
        label: "Powered Clamp Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SEN-POW-OWON",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Powered Clamp Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.CURRENT),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED_SPEND)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ],
        allowNegative: true
      },
      {
        type: "SEN-POW-PRE",
        connection: Connections.PRESSAC,
        resolution: 5 * 60 * 1e3,
        label: "Self Powered CT",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.CURRENT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "POWER_RADAR",
        hiddenFromDashAddDevice: true,
        noHub: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1e3,
        noDisconnection: true,
        label: "Power Radar",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.CURRENT)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "LOG_STASH",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 60 * 60 * 1e3,
        noDisconnection: true,
        label: "Log Stash",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "FUDURA",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 60 * 60 * 1e3,
        noDisconnection: true,
        label: "Fudura",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SOLAR_EDGE",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.SOLAR_EDGE,
        resolution: 15 * 60 * 1e3,
        noDisconnection: true,
        label: "Solar Edge",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "POWER_RADAR_METER_GAS",
        hiddenFromDashAddDevice: true,
        noHub: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1e3,
        noDisconnection: true,
        label: "Power Radar Gas Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "POWER_RADAR_METER_WATER",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1e3,
        noDisconnection: true,
        label: "Power Radar Water Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SEN-POW-OWON-OLD",
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Powered Clamp Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.CURRENT),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.EXPORTED_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.IMPORTED_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.GENERATED_DELIVERED_SPEND)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ],
        allowNegative: true
      },
      {
        type: "SEN-POW",
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Battery Clamp Meter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_VOLTAGE)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "MET-REA",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Meter Reader",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "MET-REA_FRIENT",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Meter Reader",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SEN-TEM-PROBE",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Temperature Probe",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SEN-TEM-HUM",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Temperature/Humidity Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "SEN-LIGHT-MOTION",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Light/Occupancy Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.LIGHT),
          DataTypes.find((t) => t.type === DataTypeTypes.OCCUPANCY),
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "VIRTUAL-PARENT",
        icon: "AiOutlineSisternode",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.VIRTUAL,
        virtual: true,
        noDisconnection: true,
        label: "Virtual Parent",
        dataTypes: DataTypes.filter((t) => t.categoryDetails),
        // dataTypes: [],
        options: [
          Options.find((o) => o.state === "NONE")
        ]
      },
      {
        type: "VIRTUAL-PARENT-MERGED",
        icon: "IoMdGitMerge",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.VIRTUAL,
        virtual: true,
        noDisconnection: true,
        label: "Merged Virtual Parent",
        dataTypes: DataTypes.filter((t) => t.categoryDetails),
        // dataTypes: [],
        options: [
          Options.find((o) => o.state === "NONE")
        ]
      },
      {
        type: "POWERVAULT_BATTERY",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1e3,
        label: "Powervault Battery",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_PERCENT)
        ],
        options: [
          Options.find((o) => o.state === "MONITORING"),
          {
            label: "Only Charge",
            state: "ONLY_CHARGE",
            color: "#4dc7d2"
          },
          {
            label: "Force Charge",
            state: "FORCE_CHARGE",
            color: "#4d5fd2"
          },
          {
            label: "Only Discharge",
            state: "ONLY_DISCHARGE",
            color: "#ff87a7"
          },
          {
            label: "Force Discharge",
            state: "FORCE_DISCHARGE",
            color: "#fa2488"
          },
          {
            label: "Normal",
            default: true,
            state: "NORMAL",
            color: "#49c570"
          },
          {
            label: "Disable",
            state: "DISABLE",
            color: "#ff5c5c"
          }
        ],
        allowNegative: true
      },
      {
        type: "REL-DIN",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "16A DIN Relay",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          {
            label: "On",
            state: "ON",
            default: true,
            color: "#49c570"
          },
          {
            label: "Off",
            state: "OFF",
            color: "#ff5c5c"
          },
          {
            label: "Following Rule",
            state: "AUTOMATED",
            icon: "FaCalculator",
            nonSelectable: true
          },
          {
            state: "BOOST",
            nonSelectable: true
          },
          {
            state: "SNOOZE",
            nonSelectable: true
          },
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "REL-DIN-30A",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "30A DIN Relay",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          {
            label: "On",
            state: "ON",
            default: true,
            color: "#49c570"
          },
          {
            label: "Off",
            state: "OFF",
            color: "#ff5c5c"
          },
          {
            label: "Following Rule",
            state: "AUTOMATED",
            icon: "FaCalculator",
            nonSelectable: true
          },
          {
            state: "BOOST",
            nonSelectable: true
          },
          {
            state: "SNOOZE",
            nonSelectable: true
          },
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "REL-DIN-32A-OWON",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "32A DIN Relay",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
          {
            label: "On",
            state: "ON",
            default: true,
            color: "#49c570"
          },
          {
            label: "Off",
            state: "OFF",
            color: "#ff5c5c"
          },
          {
            label: "Following Rule",
            state: "AUTOMATED",
            icon: "FaCalculator",
            nonSelectable: true
          },
          {
            state: "BOOST",
            nonSelectable: true
          },
          {
            state: "SNOOZE",
            nonSelectable: true
          },
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "MODBUS",
        hiddenFromDashAddDevice: false,
        connection: Connections.MODBUS_RTU,
        label: "Modbus Device",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        // Same registers and modbus_model as MODBUS above - only the transport differs,
        // which is why the two share asset.modbus_details rather than having a column each.
        type: "MODBUS_TCP",
        hiddenFromDashAddDevice: false,
        connection: Connections.MODBUS_TCP,
        label: "Modbus TCP Device",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BACNET_IP_ELECTRICITY",
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: "BACnet IP Electricity Meter",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BACNET_IP_TEMPERATURE",
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: "BACnet IP Temperature Sensor",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BACNET_IP_WATER",
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: "BACnet IP Water Meter",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BACNET_IP_GAS",
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: "BACnet IP Gas Meter",
        resolution: 5 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "EMLITE",
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.EMLITE,
        label: "Emlite Meter",
        resolution: 60 * 60 * 1e3,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "EA_GAS",
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1e3,
        label: "EnergyAsset Gas Data",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_PULSE",
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Pulse Counter",
        maxInstances: 3,
        macLength: 12,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_PULSE_DELIVERED",
        hiddenFromDashAddDevice: true,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        maxInstances: 3,
        macLength: 12,
        label: "BLE Pulse Counter (Electricity)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_PULSE_DELIVERED_WATER",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Pulse Counter (Water)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_PULSE_DELIVERED_WATER_HOT",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Pulse Counter (Hot Water)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_PULSE_DELIVERED_GAS",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Pulse Counter (Gas)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "TRV-DANFOSS",
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1e3,
        label: "Radiator TRV",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE)
        ],
        options: [
          Options.find((o) => o.state === "ON"),
          Options.find((o) => o.state === "OFF"),
          Options.find((o) => o.state === "AUTOMATED"),
          Options.find((o) => o.state === "BOOST"),
          Options.find((o) => o.state === "SNOOZE"),
          Options.find((o) => o.state === "MONITORING")
        ]
      },
      {
        type: "NB-IOT-PULSE",
        noHub: true,
        connection: Connections.NB_IOT,
        macLength: 12,
        maxInstances: 3,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Pulse Counter",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-PULSE_DELIVERED",
        connection: Connections.NB_IOT,
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Pulse Counter (Electricity)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-PULSE_DELIVERED_WATER",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Pulse Counter (Water)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-PULSE_DELIVERED_WATER_HOT",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Pulse Counter (Hot Water)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.WATER_PULSE_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-PULSE_DELIVERED_GAS",
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Pulse Counter (Gas)",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_PULSE),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
          [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
            dataType: DataTypeTypes.DELIVERED_GAS,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
            dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
            dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          },
          [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
          }
        },
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_VOC",
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Air Quality Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.VOC),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_TEMP",
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Temperature/Humidity Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-TEMP",
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Temperature Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-VOC",
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT VOC Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.VOC),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-CO2",
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT CO2 Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.CO2),
          DataTypes.find((t) => t.type === DataTypeTypes.PRESSURE),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "NB-IOT-OPEN",
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1e3,
        label: "NB-IoT Open/Close Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.OPEN),
          DataTypes.find((t) => t.type === DataTypeTypes.NB_IOT_ECL),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "BLE_OPEN_CLOSE",
        maxInstances: 1,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1e3,
        label: "BLE Open/Close Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.OPEN),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
          DataTypes.find((t) => t.type === DataTypeTypes.ASSET_BATTERY_ALARM)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "SENSE-ANYWHERE",
        noHub: true,
        maxInstances: 1,
        macLength: 10,
        connection: Connections.SENSE_ANYWHERE,
        resolution: 3 * 60 * 60 * 1e3,
        label: "Sense Anywhere Sensor",
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.TEMPERATURE),
          DataTypes.find((t) => t.type === DataTypeTypes.HUMIDITY),
          DataTypes.find((t) => t.type === DataTypeTypes.CO2)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "CONSULTUS",
        noHub: true,
        maxInstances: 1,
        macLength: 13,
        connection: Connections.CONSULTUS,
        resolution: 30 * 60 * 1e3,
        label: "Consultus Meter",
        hiddenFromDashAddDevice: true,
        dataTypes: [
          DataTypes.find((t) => t.type === DataTypeTypes.DELIVERED),
          DataTypes.find((t) => t.type === DataTypeTypes.CONSUMPTION)
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      },
      {
        type: "MANUAL_IMPORT",
        noHub: true,
        maxInstances: 1,
        macLength: 13,
        connection: Connections.DATA_UPLOAD,
        resolution: 30 * 60 * 1e3,
        label: "Manual Import",
        dataTypes: [
          DataTypes.DELIVERED,
          DataTypes.CONSUMPTION,
          DataTypes.DELIVERED_GAS,
          DataTypes.GAS_PULSE,
          DataTypes.DELIVERED_WATER,
          DataTypes.WATER_PULSE,
          DataTypes.TEMPERATURE,
          DataTypes.HUMIDITY
        ],
        options: [
          {
            label: "Monitoring",
            state: "MONITORING",
            color: "#03a9f4",
            nonSelectable: true
          }
        ]
      }
    ];
    exports2.StateOptions = StateOptions;
    exports2.StateOptions = StateOptions = StateOptions.map((so) => {
      if (!so.macLength && so.connection !== Connections.BACNET_TCP_IP && so.connection !== Connections.MODBUS_RTU && so.connection !== Connections.MODBUS_TCP) {
        so.macLength = 16;
      }
      if (!so.maxInstances) {
        so.maxInstances = 1;
      }
      return so;
    });
    var GatewayOptions = [
      {
        type: "DEVELCO-HUB",
        resolution: 10 * 60 * 1e3
        //10 mins
      },
      {
        type: "ACRIOS-HUB",
        resolution: 60 * 60 * 1e3
        // 1 hour
      }
    ];
    exports2.GatewayOptions = GatewayOptions;
    var DeviceOptions = StateOptions;
    exports2.DeviceOptions = DeviceOptions;
  }
});

// src/util/util.js
var require_util = __commonJS({
  "src/util/util.js"(exports2, module2) {
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var moment = require_moment_timezone2();
    var StateOptions = require_StateOptions();
    var readyPromise = new Promise(function(resolve) {
      if (typeof window !== "undefined") {
        document.addEventListener("DOMContentLoaded", function() {
          resolve();
        });
      } else {
        resolve();
      }
    });
    var showDates = function(startTs, endTs) {
      return endTs - startTs > 2 * 24 * 60 * 60;
    };
    var showTime = function(startTs, endTs) {
      return endTs - startTs < 2 * 24 * 60 * 60;
    };
    var getFormatDateFull = function(startTs, endTs, timezone, granularity) {
      if (timezone) {
        return function(t) {
          let string = moment(t).tz(timezone).format("DD/MM/YYYY H:mm");
          return string;
        };
      } else {
        return d3.timeFormat("%d/%m/%Y %H:%M");
      }
    };
    var getFormatDate = function(startTs, endTs, timezone, granularity) {
      if (granularity === "monthly") {
        return d3.timeFormat("%b %Y ");
      }
      let showDate = showDates(startTs, endTs);
      let showTimes = showTime(startTs, endTs);
      if (showDate && !showTimes) {
        if (timezone) {
          return (t) => moment(t).tz(timezone).format("DD/MM/YYYY");
        } else {
          return d3.timeFormat("%d/%m/%Y ");
        }
      }
      if (!showDate && showTimes) {
        if (timezone) {
          return function(t) {
            let string = moment(t).tz(timezone).format("HH:mm");
            return string;
          };
        } else {
          return d3.timeFormat("%H:%M");
        }
      }
      if (showDate && showTimes) {
        if (timezone) {
          return function(t) {
            let string = moment(t).tz(timezone).format("DD/MM/YYYY H:mm");
            return string;
          };
        } else {
          return d3.timeFormat("%d/%m/%Y %H:%M");
        }
      }
      return d3.timeFormat("%d/%m/%Y %H:%M");
    };
    var getFormatDayOfMonth = function() {
      return d3.timeFormat("%-d");
    };
    var formatDemandOld = function(input) {
      return formatDemand(input);
    };
    var formatTime = function() {
      return function(ms) {
        const seconds2 = Math.floor(ms / 1e3) % 60;
        const minutes = Math.floor(ms / (1e3 * 60)) % 60;
        const hours = Math.floor(ms / (1e3 * 60 * 60)) % 24;
        const days = Math.floor(ms / (1e3 * 60 * 60 * 24));
        const parts = [];
        if (days) parts.push(`${days}d`);
        if (hours) parts.push(`${hours}h`);
        if (minutes) parts.push(`${minutes}m`);
        if (seconds2 || parts.length === 0) parts.push(`${seconds2}s`);
        return parts.join(" ");
      };
    };
    var formatDemand = function(input) {
      return function(input2) {
        if (!input2) {
          return "0W";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["kW", "MW", "GW", "TW", "PW", "EW", "ZW", "YW"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) >= 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return Math.round(input2) + "W";
        }
      };
    };
    var formatCount = function(input) {
      return function(input2) {
        return input2.toLocaleString("en-US");
      };
    };
    var formatConsumption = function(axis2, compact) {
      return function(input) {
        if (!input) {
          return "0Wh";
        }
        if (Math.abs(input) >= 1e3) {
          var i = -1;
          var powerUnits = ["kWh", "MWh", "GWh", "TWh", "PWh", "EWh", "ZWh", "YWh"];
          do {
            input = input / 1e3;
            i++;
          } while (Math.abs(input) >= 1e3);
          return parseFloat(input.toPrecision(3)) + (compact ? "\r\n" : "") + powerUnits[i];
        } else {
          return Math.round(input) + (compact ? "\r\n" : "") + "Wh";
        }
      };
    };
    var formatTemperatureExternal = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return "" + Math.round(input2 / 10) / 10 + "\xB0C";
      };
    };
    var formatTemperature = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return Math.round(input2 / 10) / 10 + "\xB0C";
      };
    };
    var formatHumidity = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return Math.round(input2 / 100) + "%";
      };
    };
    var formatVoc = function(input) {
      return function(input2) {
        return input2.toPrecision(3) + " IAQ";
      };
    };
    var formatLight = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return Math.round(input2) + " Lux";
      };
    };
    var formatOccupancy = function(input) {
      return function(input2) {
        if (input2) {
          return "Occupied";
        } else {
          return "Unoccupied";
        }
      };
    };
    var formatOpen = function(input) {
      return function(input2) {
        if (input2) {
          return "Open";
        } else {
          return "Closed";
        }
      };
    };
    var format2 = function(input, compact, dataType) {
      let unit2 = "";
      let dataTypeObj = StateOptions.DataTypes.find((d) => d.type === dataType.toUpperCase());
      if (dataTypeObj && dataTypeObj.unit) {
        unit2 = dataTypeObj.unit;
      }
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return Number(input2).toLocaleString(void 0, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + unit2;
      };
    };
    var formatSignal = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return input2 + "dB";
      };
    };
    var formatSignalQuality = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return input2 + "dBm";
      };
    };
    var formatPowerSource = function(input) {
      return function(input2) {
        if (input2 === 1) {
          return "Plug";
        } else if (input2 === 0) {
          return "Battery";
        } else {
          return "Unknown";
        }
      };
    };
    var formatGas = function(input) {
      return function(input2) {
        if (!input2) {
          return "0Wh";
        } else {
          return d3.format(".3s")(input2) + "Wh";
        }
      };
    };
    var formatBatteryVoltage = function(input) {
      return function(input2) {
        if (!input2) {
          input2 = 0;
        }
        return input2 / 10 + "V";
      };
    };
    var formatGasDemand = function(input) {
      return function(input2) {
        if (!input2) {
          return "0m\u1D9F/h";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["m\u1D9F/h", "km\u1D9F/h", "Mm\u1D9F/h", "Gm\u1D9F/h", "Tm\u1D9F/h", "Pm\u1D9F/h", "Em\u1D9F/h", "Zm\u1D9F/h", "Ym\u1D9F/h"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) > 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return (input2 / 1e3).toFixed(2) + "m\u1D9F/h";
        }
      };
    };
    var formatGasConsumption = function(input) {
      return function(input2) {
        if (!input2) {
          return "0m\u1D9F";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["m\u1D9F", "km\u1D9F", "Mm\u1D9F", "Gm\u1D9F", "Tm\u1D9F", "Pm\u1D9F", "Em\u1D9F", "Zm\u1D9F", "Ym\u1D9F"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) > 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return (input2 / 1e3).toFixed(2) + "m\u1D9F";
        }
      };
    };
    var formatWaterDemand = function(input) {
      return function(input2) {
        if (!input2) {
          return "0m\u1D9F/h";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["m\u1D9F/h", "km\u1D9F/h", "Mm\u1D9F/h", "Gm\u1D9F/h", "Tm\u1D9F/h", "Pm\u1D9F/h", "Em\u1D9F/h", "Zm\u1D9F/h", "Ym\u1D9F/h"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) > 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return (input2 / 1e3).toFixed(2) + "m\u1D9F/h";
        }
      };
    };
    var formatWaterConsumption = function(input) {
      return function(input2) {
        if (!input2) {
          return "0m\u1D9F";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["m\u1D9F", "km\u1D9F", "Mm\u1D9F", "Gm\u1D9F", "Tm\u1D9F", "Pm\u1D9F", "Em\u1D9F", "Zm\u1D9F", "Ym\u1D9F"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) > 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return (input2 / 1e3).toFixed(2) + "m\u1D9F";
        }
      };
    };
    var parseTime = d3.timeParse("%s");
    var formatCurrent = function(input) {
      return function(input2) {
        if (!input2) {
          return "0A";
        }
        if (Math.abs(input2) >= 1e3) {
          var i = -1;
          var powerUnits = ["A", "kA", "MA", "GA", "TA", "PA", "EA", "ZA", "YA"];
          do {
            input2 = input2 / 1e3;
            i++;
          } while (Math.abs(input2) >= 1e3);
          return parseFloat(input2.toPrecision(3)) + powerUnits[i];
        } else {
          return Math.round(input2) + "mA";
        }
      };
    };
    var getFormat = function(dataType, axis2, compact) {
      switch (dataType) {
        case "count":
          return formatCount(axis2, compact);
        case "time":
          return formatTime(axis2, compact);
          break;
        case "consumption":
          return formatDemand(axis2, compact);
          break;
        case "consumption_pulse":
          return formatDemand(axis2, compact);
          break;
        case "delivered":
          return formatConsumption(axis2, compact);
          break;
        case "gas_energy_delivered":
          return formatConsumption(axis2, compact);
          break;
        case "gas_energy_consumption":
          return formatDemand(axis2, compact);
          break;
        case "generation":
          return formatConsumption(axis2, compact);
          break;
        case "import":
          return formatConsumption(axis2, compact);
          break;
        case "export":
          return formatConsumption(axis2, compact);
          break;
        case "gas_pulse":
          return formatGasDemand(axis2, compact);
          break;
        case "delivered_gas":
          return formatGasConsumption(axis2, compact);
          break;
        case "water_pulse_hot":
          return formatWaterDemand(axis2, compact);
          break;
        case "water_pulse":
          return formatWaterDemand(axis2, compact);
          break;
        case "delivered_water":
          return formatWaterConsumption(axis2, compact);
          break;
        case "delivered_water_hot":
          return formatWaterConsumption(axis2, compact);
          break;
        case "temperature":
          return formatTemperature(axis2, compact);
          break;
        case "temperatureExternal":
          return formatTemperatureExternal(axis2, compact);
          break;
        case "humidity":
          return formatHumidity(axis2, compact);
          break;
        case "external_humidity":
          return formatHumidity(axis2, compact);
          break;
        case "voc":
          return formatVoc(axis2, compact);
          break;
        case "light":
          return formatLight(axis2, compact);
          break;
        case "occupancy":
          return formatOccupancy(axis2, compact);
          break;
        case "open":
          return formatOpen(axis2, compact);
          break;
        case "asset_battery_voltage":
          return formatBatteryVoltage(axis2, compact);
          break;
        case "asset_signal_strength":
          return formatSignal(axis2, compact);
          break;
        case "gateway_wifi_strength":
          return formatSignal(axis2, compact);
          break;
        case "gateway_mobile_strength":
          return formatSignalQuality(axis2, compact);
          break;
        case "gateway_power_source":
          return formatPowerSource(axis2, compact);
          break;
        case "ea_gas":
          return formatGas(axis2, compact);
          break;
        case "current":
          return formatCurrent(axis2, compact);
          break;
        case "exported_delivered":
          return formatConsumption(axis2, compact);
          break;
        case "exported_consumption":
          return formatDemand(axis2, compact);
          break;
        case "imported_delivered":
          return formatConsumption(axis2, compact);
          break;
        case "imported_consumption":
          return formatDemand(axis2, compact);
          break;
        case "generated_delivered":
          return formatConsumption(axis2, compact);
          break;
        case "generated_consumption":
          return formatDemand(axis2, compact);
          break;
        case "generated":
          return formatConsumption(axis2, compact);
          break;
        default:
          return format2(axis2, compact, dataType);
      }
    };
    module2.exports = {
      readyPromise,
      showDates,
      showTime,
      getFormatDate,
      getFormatDateFull,
      getFormatDayOfMonth,
      formatDemand: formatDemandOld,
      getFormat,
      parseTime
    };
  }
});

// src/util/lineTooltip.js
var require_lineTooltip = __commonJS({
  "src/util/lineTooltip.js"(exports2, module2) {
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var { getFormat } = require_util();
    var getFormatDate = require_util().getFormatDateFull;
    var StateOptions = require_StateOptions();
    var bisect = d3.bisector(function(d) {
      return d ? d.date : null;
    }).left;
    var TOOLTIP_LEFT_MARGIN = 20;
    var lockedImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtNDc5LjYgMzE2Ljh2LTE0LjgwMWMwLTM3LjAxMi0xOS43NDYtNzEuMjExLTUxLjc5Ny04OS43MTUtMzIuMDU1LTE4LjUwOC03MS41NDMtMTguNTA4LTEwMy42IDAtMzIuMDUxIDE4LjUwNC01MS43OTcgNTIuNzAzLTUxLjc5NyA4OS43MTV2MTQuODAxYy0xMS43NzcgMC0yMy4wNyA0LjY3NTgtMzEuMzk1IDEzLjAwNC04LjMyODEgOC4zMjQyLTEzLjAwNCAxOS42MTctMTMuMDA0IDMxLjM5NXYxNDcuOTljMCAxMS43NzcgNC42NzU4IDIzLjA3IDEzLjAwNCAzMS4zOTUgOC4zMjQyIDguMzI4MSAxOS42MTcgMTMuMDA0IDMxLjM5NSAxMy4wMDRoMjA3LjE5YzExLjc3MyAwIDIzLjA2Ni00LjY3NTggMzEuMzk1LTEzLjAwNCA4LjMyNDItOC4zMjQyIDEzLjAwNC0xOS42MTcgMTMuMDA0LTMxLjM5NXYtMTQ3Ljk5YzAtMTEuNzc3LTQuNjc5Ny0yMy4wNy0xMy4wMDQtMzEuMzk1LTguMzI4MS04LjMyODEtMTkuNjIxLTEzLjAwNC0zMS4zOTUtMTMuMDA0em0tODguNzk3IDExNC4yNXY0OC41NDNjMCA1LjI4NTItMi44MjAzIDEwLjE3Mi03LjM5ODQgMTIuODE2LTQuNTgyIDIuNjQ0NS0xMC4yMjMgMi42NDQ1LTE0LjgwMSAwLTQuNTc4MS0yLjY0NDUtNy4zOTg0LTcuNTMxMi03LjM5ODQtMTIuODE2di00OC41NDNjLTcuNTc4MS00LjM3NS0xMi44MzItMTEuODc1LTE0LjM1Mi0yMC40OTItMS41MTk1LTguNjE3MiAwLjg1MTU2LTE3LjQ2NSA2LjQ3NjYtMjQuMTY4IDUuNjI1LTYuNjk5MiAxMy45MjYtMTAuNTcgMjIuNjcyLTEwLjU3IDguNzUgMCAxNy4wNTEgMy44NzExIDIyLjY3NiAxMC41NyA1LjYyNSA2LjcwMzEgNy45OTIyIDE1LjU1MSA2LjQ3NjYgMjQuMTY4LTEuNTE5NSA4LjYxNzItNi43NzM0IDE2LjExNy0xNC4zNTIgMjAuNDkyem01OS4xOTktMTE0LjI1aC0xNDh2LTE0LjgwMWMwLTI2LjQzOCAxNC4xMDUtNTAuODYzIDM3LTY0LjA4MiAyMi44OTUtMTMuMjE5IDUxLjEwMi0xMy4yMTkgNzMuOTk2IDBzMzcgMzcuNjQ1IDM3IDY0LjA4MnoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==";
    var lockBgStyle = "url('" + lockedImage + "')";
    var unlockedImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtNDc5LjYgMzE2Ljh2LTE0LjgwMWMtMC4wMTE3MTgtMzIuODQ4LTE1LjU5OC02My43NDItNDIuMDEyLTgzLjI3LTI2LjQxNC0xOS41MjMtNjAuNTItMjUuMzY3LTkxLjkyNi0xNS43NDYtMzEuNDA2IDkuNjIxMS01Ni4zOTEgMzMuNTYyLTY3LjMzNiA2NC41MzUtMS43Njk1IDQuOTk2MS0wLjc0MjE5IDEwLjU1OSAyLjY5OTIgMTQuNTkgMy40NDE0IDQuMDMxMiA4Ljc3MzQgNS45MjE5IDEzLjk4OCA0Ljk1NyA1LjIxMDktMC45NjQ4NCA5LjUxMTctNC42MzY3IDExLjI4NS05LjYzMjggNy44NTU1LTIyLjA1NSAyNS42ODgtMzkuMDkgNDguMDc0LTQ1LjkzNCAyMi4zOTEtNi44NDM4IDQ2LjY5NS0yLjY4NzUgNjUuNTM5IDExLjIwNyAxOC44NDggMTMuODkxIDMwLjAwNCAzNS44ODMgMzAuMDkgNTkuMjkzdjE0LjgwMWgtMTc3LjU5Yy0xMS43NzcgMC0yMy4wNyA0LjY3NTgtMzEuMzk1IDEzLjAwNC04LjMyODEgOC4zMjQyLTEzLjAwNCAxOS42MTctMTMuMDA0IDMxLjM5NXYxNDcuOTljMCAxMS43NzcgNC42NzU4IDIzLjA3IDEzLjAwNCAzMS4zOTUgOC4zMjQyIDguMzI4MSAxOS42MTcgMTMuMDA0IDMxLjM5NSAxMy4wMDRoMjA3LjE5YzExLjc3MyAwIDIzLjA2Ni00LjY3NTggMzEuMzk1LTEzLjAwNCA4LjMyNDItOC4zMjQyIDEzLjAwNC0xOS42MTcgMTMuMDA0LTMxLjM5NXYtMTQ3Ljk5YzAtMTEuNzc3LTQuNjc5Ny0yMy4wNy0xMy4wMDQtMzEuMzk1LTguMzI4MS04LjMyODEtMTkuNjIxLTEzLjAwNC0zMS4zOTUtMTMuMDA0em0tODguNzk3IDExNC4yNXY0OC41NDNjMCA1LjI4NTItMi44MjAzIDEwLjE3Mi03LjM5ODQgMTIuODE2LTQuNTgyIDIuNjQ0NS0xMC4yMjMgMi42NDQ1LTE0LjgwMSAwLTQuNTc4MS0yLjY0NDUtNy4zOTg0LTcuNTMxMi03LjM5ODQtMTIuODE2di00OC41NDNjLTcuNTc4MS00LjM3NS0xMi44MzItMTEuODc1LTE0LjM1Mi0yMC40OTItMS41MTk1LTguNjE3MiAwLjg1MTU2LTE3LjQ2NSA2LjQ3NjYtMjQuMTY4IDUuNjI1LTYuNjk5MiAxMy45MjYtMTAuNTcgMjIuNjcyLTEwLjU3IDguNzUgMCAxNy4wNTEgMy44NzExIDIyLjY3NiAxMC41NyA1LjYyNSA2LjcwMzEgNy45OTIyIDE1LjU1MSA2LjQ3NjYgMjQuMTY4LTEuNTE5NSA4LjYxNzItNi43NzM0IDE2LjExNy0xNC4zNTIgMjAuNDkyeiIvPgo8L3N2Zz4K";
    var unlockBgStyle = "url('" + unlockedImage + "')";
    var LineTooltip = class {
      constructor(params) {
        if (!params.svg) {
          throw Error("No svg given to tooltip");
        }
        this.temperatureData = params.temperatureData;
        this.yScalerTemperature = params.yScalerTemperature;
        if (!params.datas) {
          throw Error("No data given to tooltip");
        }
        if (!params.width) {
          throw Error("No width given to tooltip");
        }
        if (!params.height) {
          throw Error("No height given to tooltip");
        }
        if (!params.xScaler) {
          throw Error("No X Scaler given to tooltip");
        }
        if (!params.yScaler) {
          throw Error("No Y Scaler given to tooltip");
        }
        if (!params.start) {
          throw Error("Start not given");
        }
        if (!params.end) {
          throw Error("End not given");
        }
        if (!params.formats) {
          throw Error("No formats given");
        }
        this.widget = params.widget;
        this.override = params.override;
        this.granularity = params.granularity;
        this.timezone = params.timezone;
        this.element = params.element;
        this.isMobile = params.isMobile;
        this.formats = params.formats;
        this.svg = params.svg;
        this.customOverlayDeviceName = params.customOverlayDeviceName;
        this.datas = params.datas;
        this.compareDatas = params.compareDatas;
        this.width = params.width;
        this.height = params.height;
        this.xScaler = params.xScaler;
        this.xScalerCompare = params.xScalerCompare;
        this.yScaler = params.yScaler;
        this.yScaler2 = params.yScaler2;
        this.dataTypes = params.dataTypes;
        this.start = params.start;
        this.end = params.end;
        this.lockCallback = params.lockCallback;
        this.customOverlayData = params.customOverlayData;
        this.overlayDataType = params.overlayDataType;
        this.yScalerCustomOverlay = params.yScalerCustomOverlay;
        this.createElements();
      }
      render() {
        let self2 = this;
        if (!self2.datas) {
          return;
        }
        let mouseX = self2.lockedMouseX;
        let d = self2.lockedD;
        let x06 = self2.xScaler.invert(mouseX);
        let i = self2.datas.map((d2) => bisect(d2.data, x06, 0));
        let selectedDatum = self2.datas.map((data, index3) => {
          let d0 = data.data[i[index3] - 1];
          let d1 = data.data[i[index3]];
          if (d0 && d1) {
            return Math.abs(d0.date - x06) < Math.abs(d1.date - x06) ? d0 : d1;
          } else {
            return d1 || d0;
          }
        });
        if (!selectedDatum.filter((d2) => d2 !== void 0)[0]) {
          return;
        }
        self2.lastDate = selectedDatum.filter((d2) => d2 !== void 0)[0] ? selectedDatum.filter((d2) => d2 !== void 0)[0].date : null;
        let distances = selectedDatum.filter((d2) => d2 !== void 0).map((d2) => Math.abs(d2.date - x06)).sort((a4, b) => a4 - b);
        let bestDistance = distances[0];
        let setLine = false;
        let tooltipX = null;
        selectedDatum.forEach(function(datum2, index3) {
          if (datum2 !== void 0 && datum2.date && Math.abs(datum2.date - x06) === bestDistance) {
            if (!self2.datas[index3].hidden) {
              if (self2.tooltipMark) {
                self2.tooltipMark[index3].attr("cx", self2.xScaler(datum2.date));
                self2.tooltipMark[index3].attr("cy", self2.yScaler(datum2.value));
                self2.tooltipMark[index3].style("opacity", 1);
              }
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                self2.tooltipMark2[index3].attr("cy", self2.yScaler2(datum2.value2));
                self2.tooltipMark2[index3].style("opacity", 0.2);
              }
              if (self2.temperatureData) {
                let leftItem;
                let rightItem;
                let thisItem;
                let prevItem;
                if (datum2.date) {
                  self2.temperatureData.forEach(function(temperatureDatum) {
                    if (temperatureDatum.time * 1e3 === datum2.date.getTime()) {
                      thisItem = temperatureDatum;
                    }
                    if (!rightItem && temperatureDatum.time * 1e3 > datum2.date.getTime()) {
                      leftItem = prevItem;
                      rightItem = temperatureDatum;
                    }
                    prevItem = temperatureDatum;
                  });
                }
                self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                if (thisItem) {
                  self2.tooltipMark2[index3].attr("cy", self2.yScalerTemperature(thisItem.value));
                } else if (leftItem && rightItem) {
                  let val = (datum2.date.getTime() - leftItem.time * 1e3) / ((rightItem.time - leftItem.time) * 1e3) * (rightItem.value - leftItem.value) + leftItem.value;
                  self2.tooltipMark2[index3].attr("cy", self2.yScalerTemperature(val));
                }
                self2.tooltipMark2[index3].style("opacity", 0.2);
              }
              if (self2.customOverlayData) {
                let leftItem;
                let rightItem;
                let thisItem;
                let prevItem;
                if (datum2.date) {
                  self2.customOverlayData.forEach(function(temperatureDatum) {
                    if (temperatureDatum.time * 1e3 === datum2.date.getTime()) {
                      thisItem = temperatureDatum;
                    }
                    if (!rightItem && temperatureDatum.time * 1e3 > datum2.date.getTime()) {
                      leftItem = prevItem;
                      rightItem = temperatureDatum;
                    }
                    prevItem = temperatureDatum;
                  });
                }
                self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                if (thisItem) {
                  self2.tooltipMark2[index3].attr("cy", self2.yScalerCustomOverlay(thisItem.value));
                } else if (leftItem && rightItem) {
                  let val = (datum2.date.getTime() - leftItem.time * 1e3) / ((rightItem.time - leftItem.time) * 1e3) * (rightItem.value - leftItem.value) + leftItem.value;
                  self2.tooltipMark2[index3].attr("cy", self2.yScalerCustomOverlay(val));
                }
                self2.tooltipMark2[index3].style("opacity", 0.2);
              }
              if (!setLine) {
                self2.verticalLine.attr("x1", self2.xScaler(datum2.date));
                self2.verticalLine.attr("x2", self2.xScaler(datum2.date));
                setLine = true;
                if (!self2.override) {
                  tooltipX = self2.tooltipMark[index3].node().getBoundingClientRect().x + self2.tooltip.node().getBoundingClientRect().width / 2 + TOOLTIP_LEFT_MARGIN;
                }
              }
            } else {
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                self2.tooltipMark2[index3].style("opacity", 0);
              }
              if (self2.temperatureData) {
                self2.tooltipMark2[index3].style("opacity", 0);
              }
              if (self2.customOverlayData) {
                self2.tooltipMark2[index3].style("opacity", 0);
              }
              if (self2.tooltipMark) {
                self2.tooltipMark[index3].style("opacity", 0);
              }
            }
            let name = self2.datas[index3].name;
            if (datum2 && datum2.value !== null && !self2.datas[index3].hidden) {
              if (self2.formats.length > 1) {
                name += " " + self2.dataTypes[0].charAt(0) + self2.dataTypes[0].slice(1).toLowerCase();
              }
            }
            if (datum2 && self2.formats.length > 1 && datum2.value2 !== null) {
              name = self2.datas[index3].name + " " + self2.dataTypes[1].charAt(0) + self2.dataTypes[1].slice(1).toLowerCase();
            }
          } else {
            if (self2.tooltipMark) {
              self2.tooltipMark[index3].style("opacity", 0);
            }
            if (self2.dataTypes && self2.dataTypes.length > 1) {
              self2.tooltipMark2[index3].style("opacity", 0);
            }
          }
        });
        if (self2.lockPrompt && selectedDatum[0]) {
          this.placeLock(self2.lockPrompt);
        }
      }
      placeLock(lockPrompt) {
        if (lockPrompt) {
          let tooltipLine = document.getElementsByClassName("tooltip-line");
          if (tooltipLine.length) {
            let element = tooltipLine[0];
            let rect = element.getBoundingClientRect();
            let xPosition = rect.left + window.scrollX;
            let yPosition = rect.top + window.scrollY;
            lockPrompt.style("left", xPosition + "px").style("top", yPosition + "px");
          }
        }
      }
      createElements() {
        let self2 = this;
        if (!this.widget) {
          this.lockPrompt = this.element.append("div").attr("class", "linegraph-prompt").style("position", "fixed").style("background-image", unlockBgStyle).style("display", "none").style("z-index", 1e3).style("background-color", "white").style("background-size", "contain").style("text-align", "center").style("border-radius", "20px").style("margin-left", "-12.5px").style("height", "25px").style("width", "25px").style("border", "1px solid #000000").style("cursor", "pointer").style("user-select", "none").style("opacity", 1);
        }
        this.verticalLine = this.svg.append("line").attr("class", "tooltip-line").attr("x1", 0).attr("y1", 0).attr("x2", 0).attr("y2", this.height).style("opacity", 0).style("stroke-width", 1).style("stroke", "#575757").style("fill", "none");
        if (!this.widget) {
          this.tooltipMark = self2.datas.map(
            (d) => self2.svg.append("circle").attr("class", "tooltip-circle").attr("r", 5).attr("cx", 0).attr("cy", 0).style("opacity", 0).attr("fill", d.color).attr("fill-opacity", 0.5).style("stroke", d.color).style("stroke-width", "2px")
          );
        }
        if (this.dataTypes && this.dataTypes.length > 1) {
          this.tooltipMark2 = self2.datas.map(
            (d) => self2.svg.append("circle").attr("class", "tooltip-circle").attr("r", 5).attr("cx", 0).attr("cy", 0).style("opacity", 0).attr("fill", d.color)
          );
        }
        if (this.temperatureData) {
          this.tooltipMark2 = self2.datas.map(
            (d) => self2.svg.append("circle").attr("class", "tooltip-circle temperature-circle").attr("r", 5).attr("cx", 0).attr("cy", 0).style("opacity", 0).attr("fill", "#49b9c4")
          );
        }
        if (this.customOverlayData) {
          this.tooltipMark2 = self2.datas.map(
            (d) => self2.svg.append("circle").attr("class", "tooltip-circle temperature-circle").attr("r", 5).attr("cx", 0).attr("cy", 0).style("opacity", 0).attr("fill", "#49b9c4")
          );
        }
        if (!this.override) {
          this.tooltip = d3.select("body").append("div").style("position", "absolute").attr("class", "linegraph-tooltip Card").style("pointer-events", "none").style("display", "none").style("opacity", 0);
          this.tooltipDate = self2.tooltip.append("div").attr("class", "CardHeader");
          this.tooltipValue = self2.tooltip.append("div").attr("class", "CardBody");
        }
        function mousemovelinetooltip(event, d) {
          if (self2.locked) {
            return;
          }
          if (!self2.datas) {
            return;
          }
          let mouseX = d3.pointer(event, this)[0];
          self2.lockedMouseX = mouseX;
          self2.lockedD = d;
          let x06 = self2.xScaler.invert(mouseX);
          let i = self2.datas.map((d2) => bisect(d2.data, x06, 0));
          let selectedDatum = self2.datas.map((data, index3) => {
            let d0 = data.data[i[index3] - 1];
            let d1 = data.data[i[index3]];
            if (d0 && d1) {
              return Math.abs(d0.date - x06) < Math.abs(d1.date - x06) ? d0 : d1;
            } else {
              return d1 || d0;
            }
          });
          if (!selectedDatum) {
            return;
          }
          let x0Compare, iCompare, selectedDatumCompare;
          if (self2.compareDatas) {
            x0Compare = self2.xScalerCompare.invert(mouseX);
            iCompare = self2.compareDatas.map((d2) => bisect(d2.data, x0Compare, 0));
            selectedDatumCompare = self2.compareDatas.map((data, index3) => {
              let d0Compare = data.data[iCompare[index3] - 1];
              let d1Compare = data.data[iCompare[index3]];
              if (d0Compare && d1Compare) {
                return Math.abs(d0Compare.date - x0Compare) < Math.abs(d1Compare.date - x0Compare) ? d0Compare : d1Compare;
              } else {
                return d1Compare || d0Compare;
              }
            });
          }
          let _selectedData = selectedDatum.filter((d2) => d2 !== void 0)[0];
          if (!_selectedData || self2.lastDate && self2.lastDate === _selectedData.date) {
            return;
          }
          self2.lastDate = _selectedData.date;
          let distances = selectedDatum.filter((d2) => d2 !== void 0).map((d2) => Math.abs(d2.date - x06)).sort((a4, b) => a4 - b);
          if (distances.length === 0) {
            return;
          }
          let bestDistance = distances[0];
          let setLine = false;
          if (self2.override) {
            let overrideData = [];
            selectedDatum.forEach(function(datum2, index3) {
              if (datum2 !== void 0 && datum2.date && Math.abs(datum2.date - x06) === bestDistance) {
                if (!self2.datas[index3].hidden) {
                  let name = self2.datas[index3].name;
                  let value;
                  let rawVal;
                  let compareValue2;
                  if (datum2.value !== null && !self2.datas[index3].hidden) {
                    if (self2.formats.length > 1) {
                      name += " " + self2.dataTypes[0].charAt(0) + self2.dataTypes[0].slice(1).toLowerCase();
                    }
                    value = self2.formats[0](datum2.value);
                    if (selectedDatumCompare && selectedDatumCompare[index3]) {
                      compareValue2 = self2.formats[0](selectedDatumCompare[index3].value);
                    }
                    rawVal = datum2.value;
                  }
                  if (self2.formats.length > 1 && datum2.value2 !== null) {
                    name = self2.datas[index3].name + " " + self2.dataTypes[1].charAt(0) + self2.dataTypes[1].slice(1).toLowerCase();
                    value = self2.formats[1](datum2.value2);
                    rawVal = datum2.value2;
                  }
                  overrideData.push({
                    name,
                    value,
                    compareValue: compareValue2,
                    rawVal
                  });
                }
                if (self2.temperatureData) {
                  let leftItem;
                  let rightItem;
                  let thisItem;
                  let prevItem;
                  if (datum2.date) {
                    self2.temperatureData.forEach(function(temperatureDatum) {
                      if (temperatureDatum.time * 1e3 === datum2.date.getTime()) {
                        thisItem = temperatureDatum;
                      }
                      if (!rightItem && temperatureDatum.time * 1e3 > datum2.date.getTime()) {
                        leftItem = prevItem;
                        rightItem = temperatureDatum;
                      }
                      prevItem = temperatureDatum;
                    });
                  }
                  let val;
                  self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                  if (thisItem) {
                    val = thisItem.value;
                  } else if (leftItem && rightItem) {
                    val = (datum2.date.getTime() - leftItem.time * 1e3) / ((rightItem.time - leftItem.time) * 1e3) * (rightItem.value - leftItem.value) + leftItem.value;
                  }
                  overrideData.unshift({
                    name: "External Temperature",
                    value: getFormat("temperatureExternal")(val),
                    rawVal: val
                  });
                }
                if (self2.customOverlayData) {
                  let leftItem;
                  let rightItem;
                  let thisItem;
                  let prevItem;
                  if (datum2.date) {
                    self2.customOverlayData.forEach(function(overlayDatum) {
                      if (overlayDatum.time * 1e3 === datum2.date.getTime()) {
                        thisItem = overlayDatum;
                      }
                      if (!rightItem && overlayDatum.time * 1e3 > datum2.date.getTime()) {
                        leftItem = prevItem;
                        rightItem = overlayDatum;
                      }
                      prevItem = overlayDatum;
                    });
                  }
                  let val;
                  self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                  if (self2.overlayDataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
                    val = leftItem.value;
                  } else {
                    if (thisItem) {
                      val = thisItem.value;
                    } else if (leftItem && rightItem) {
                      val = (datum2.date.getTime() - leftItem.time * 1e3) / ((rightItem.time - leftItem.time) * 1e3) * (rightItem.value - leftItem.value) + leftItem.value;
                    }
                  }
                  overrideData.unshift({
                    name: self2.customOverlayDeviceName,
                    value: getFormat(self2.overlayDataType.type.toLowerCase())(val),
                    rawVal: val
                  });
                }
              }
            });
            self2.blocked = false;
            self2.lastMove = (/* @__PURE__ */ new Date()).getTime();
            self2.tooltipData = {
              date: getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(_selectedData.date),
              data: overrideData,
              locked: self2.locked
            };
            if (self2.compareDatas && selectedDatumCompare.filter((d2) => d2 !== void 0)[0]) {
              self2.tooltipData.compareDate = getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(selectedDatumCompare.filter((d2) => d2 !== void 0)[0].date);
            }
            self2.override(self2.tooltipData);
          }
          if (!self2.override) {
            let tooltip2 = self2.tooltip.node().getBoundingClientRect();
            self2.tooltipDate.html(getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(_selectedData.date));
          }
          let newHtmlValue = "";
          let tooltipX = null;
          selectedDatum.forEach(function(datum2, index3) {
            if (datum2 !== void 0 && datum2.date && Math.abs((datum2 ? datum2.date : 0) - x06) === bestDistance) {
              if (!self2.datas[index3].hidden) {
                if (!self2.widget) {
                  self2.tooltipMark[index3].attr("cx", self2.xScaler(datum2.date));
                  self2.tooltipMark[index3].attr("cy", self2.yScaler(datum2.value));
                  self2.tooltipMark[index3].style("opacity", 1);
                  if (self2.dataTypes && self2.dataTypes.length > 1) {
                    self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                    self2.tooltipMark2[index3].attr("cy", self2.yScaler2(datum2.value2));
                    self2.tooltipMark2[index3].style("opacity", 0.2);
                  }
                  if (self2.temperatureData) {
                    let leftItem;
                    let rightItem;
                    let thisItem;
                    let prevItem;
                    if (datum2.date) {
                      self2.temperatureData.forEach(function(temperatureDatum) {
                        if (temperatureDatum.time * 1e3 === datum2.date.getTime()) {
                          thisItem = temperatureDatum;
                        }
                        if (!rightItem && temperatureDatum.time * 1e3 > datum2.date.getTime()) {
                          leftItem = prevItem;
                          rightItem = temperatureDatum;
                        }
                        prevItem = temperatureDatum;
                      });
                    }
                    self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                    if (thisItem) {
                      self2.tooltipMark2[index3].attr("cy", self2.yScalerTemperature(thisItem.value));
                    } else if (leftItem && rightItem) {
                      let val = (datum2.date.getTime() - leftItem.time * 1e3) / ((rightItem.time - leftItem.time) * 1e3) * (rightItem.value - leftItem.value) + leftItem.value;
                      self2.tooltipMark2[index3].attr("cy", self2.yScalerTemperature(val));
                    }
                    self2.tooltipMark2[index3].style("opacity", 0.2);
                  }
                  if (self2.customOverlayData) {
                    let leftItem;
                    let rightItem;
                    let thisItem;
                    let prevItem;
                    if (datum2.date) {
                      self2.customOverlayData.forEach(function(overlayDatum) {
                        if (overlayDatum.time * 1e3 === datum2.date.getTime()) {
                          thisItem = overlayDatum;
                        }
                        if (!rightItem && overlayDatum.time * 1e3 > datum2.date.getTime()) {
                          leftItem = prevItem;
                          rightItem = overlayDatum;
                        }
                        prevItem = overlayDatum;
                      });
                    }
                    self2.tooltipMark2[index3].attr("cx", self2.xScaler(datum2.date));
                    if (thisItem) {
                      self2.tooltipMark2[index3].attr("cy", self2.yScalerCustomOverlay(thisItem.value));
                    } else if (leftItem && rightItem) {
                      let val = leftItem.value;
                      self2.tooltipMark2[index3].attr("cy", self2.yScalerCustomOverlay(val));
                    }
                    self2.tooltipMark2[index3].style("opacity", 0.2);
                  }
                }
                if (!setLine) {
                  const xPos = self2.xScaler(datum2.date);
                  self2.verticalLine.attr("x1", xPos);
                  self2.verticalLine.attr("x2", xPos);
                  setLine = true;
                  if (!self2.override && !self2.widget) {
                    tooltipX = self2.tooltipMark[index3].node().getBoundingClientRect().x + self2.tooltip.node().getBoundingClientRect().width / 2 + TOOLTIP_LEFT_MARGIN;
                  }
                }
              } else {
                if (self2.dataTypes && self2.dataTypes.length > 1) {
                  self2.tooltipMark2[index3].style("opacity", 0);
                }
                if (self2.tooltipMark) {
                  self2.tooltipMark[index3].style("opacity", 0);
                }
              }
              let name = self2.datas[index3].name;
              if (datum2.value !== null && !self2.datas[index3].hidden) {
                if (self2.formats.length > 1) {
                  name += " " + self2.dataTypes[0].charAt(0) + self2.dataTypes[0].slice(1).toLowerCase();
                }
                newHtmlValue += '<div class="tooltip-row"><div class="tooltip-box-circle" style="border-color: ' + self2.datas[index3].color + '"></div><div class="tooltip-label">' + name + '</div><div class="tooltip-value">' + self2.formats[0](datum2.value) + "</div></div>";
              }
              if (self2.formats.length > 1 && datum2.value2 !== null) {
                name = self2.datas[index3].name + " " + self2.dataTypes[1].charAt(0) + self2.dataTypes[1].slice(1).toLowerCase();
                newHtmlValue += '<div class="tooltip-row"><div class="tooltip-box" style="background-color: ' + self2.datas[index3].color + '"></div><div class="tooltip-label">' + name + '</div><div class="tooltip-value">' + self2.formats[1](datum2.value2) + "</div></div>";
              }
            } else {
              if (self2.tooltipMark) {
                self2.tooltipMark[index3].style("opacity", 0);
              }
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                self2.tooltipMark2[index3].style("opacity", 0);
              }
            }
          });
          if (!self2.override) {
            self2.tooltipValue.html(newHtmlValue);
            let rect = self2.element.node().getBoundingClientRect();
            let topPos = event.pageY - 28;
            if (topPos - rect.y + tooltip.height >= rect.height) {
              topPos = rect.y + rect.height - tooltip.height;
            }
            if (self2.isMobile) {
              topPos = rect.y + rect.height / 2 - tooltip.height / 2;
              tooltipX = rect.x + rect.width / 2;
            }
            if (tooltipX) {
              self2.tooltip.style("left", tooltipX + "px").style("top", topPos + "px");
            }
          }
          self2.placeLock(self2.lockPrompt);
        }
        if (this.lockPrompt) {
          this.lockPrompt.on("click", function() {
            if (self2.locked) {
              self2.locked = false;
              self2.verticalLine.style("stroke", "#575757");
              self2.lockPrompt.style("background-image", unlockBgStyle).style("background-color", "white").style("color", "#575757").style("border", "1px solid #575757");
            } else {
              self2.locked = true;
              self2.verticalLine.style("stroke", "orange");
              self2.lockPrompt.style("background-image", lockBgStyle).style("background-color", "orange").style("color", "white").style("border", "1px solid orange");
            }
            if (self2.override && self2.tooltipData) {
              self2.tooltipData.locked = self2.locked;
              self2.override(self2.tooltipData);
            }
            if (self2.lockCallback) {
              self2.lockCallback(self2.locked);
            }
            self2.placeLock(self2.lockPrompt);
          }).on("mouseover.tooltip", function() {
            self2.lockPrompt.style("display", "block");
            self2.verticalLine.style("opacity", 1);
            if (self2.tooltipMark) {
              self2.tooltipMark.forEach(function(m3, index3) {
                if (!self2.datas[index3].hidden) {
                  if (self2.tooltipMark[index3].attr("cx") > 0) {
                    m3.style("opacity", 1);
                  }
                }
              });
            }
            if (self2.dataTypes && self2.dataTypes.length > 1) {
              self2.tooltipMark2.forEach((m3) => m3.style("opacity", 1));
            }
            if (self2.override) {
              self2.override(self2.tooltipData);
            }
          }).on("mouseout.tooltip", function() {
            if (!self2.locked) {
              if (self2.override) {
                self2.override(null);
              }
              self2.lockPrompt.style("display", "none");
              self2.verticalLine.style("opacity", 0);
              if (self2.tooltipMark) {
                self2.tooltipMark.forEach((m3) => m3.style("opacity", 0));
              }
              if (self2.tooltipMark2 && self2.tooltipMark2.length > 0) {
                self2.tooltipMark2.forEach(function(m3) {
                  m3.style("opacity", 0);
                });
              }
            }
          });
        }
        this.mouseDetector = this.svg.append("rect").attr("class", "overlay").style("fill", "transparent").attr("x", -10).attr("width", this.width + 10).attr("height", this.height).on("mouseover.tooltip", function() {
          if (!self2.override) {
            self2.tooltip.style("opacity", 1);
            self2.tooltip.style("display", "block");
          }
          if (self2.lockPrompt) {
            self2.lockPrompt.style("display", "block");
          }
          self2.verticalLine.style("opacity", 1);
          if (self2.tooltipMark) {
            self2.tooltipMark.forEach(function(m3, index3) {
              if (!self2.datas[index3].hidden) {
                m3.style("opacity", 1);
              }
            });
          }
          if (self2.dataTypes && self2.dataTypes.length > 1) {
            self2.tooltipMark2.forEach((m3) => m3.style("opacity", 1));
          }
        }).on("mouseout.tooltip", function() {
          if (self2.locked) {
            return;
          }
          if (!self2.override) {
            self2.tooltip.style("opacity", 0);
            self2.tooltip.style("display", "none");
          } else {
            self2.override(null);
          }
          if (self2.lockPrompt) {
            self2.lockPrompt.style("display", "none");
          }
          self2.verticalLine.style("opacity", 0);
          if (self2.tooltipMark) {
            self2.tooltipMark.forEach((m3) => m3.style("opacity", 0));
          }
          if (self2.tooltipMark2 && self2.tooltipMark2.length > 0) {
            self2.tooltipMark2.forEach(function(m3) {
              m3.style("opacity", 0);
            });
          }
        }).on("mousemove.tooltip", null).on("mousemove.tooltip", mousemovelinetooltip);
      }
      remove() {
        this.verticalLine.remove();
        this.mouseDetector.on("mousemove.tooltip", null);
        this.mouseDetector.remove();
        if (this.lockPrompt) {
          this.lockPrompt.remove();
        }
        if (!this.override) {
          this.tooltip.remove();
          this.tooltipDate.remove();
          this.tooltipValue.remove();
        }
        if (this.tooltipMark) {
          this.tooltipMark.forEach(function(div) {
            div.remove();
          });
        }
        if (this.dataTypes && this.dataTypes.length > 1) {
          this.tooltipMark2.forEach(function(div) {
            div.remove();
          });
        }
      }
    };
    module2.exports = LineTooltip;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/rng.js
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var getRandomValues, rnds8;
var init_rng = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/rng.js"() {
    rnds8 = new Uint8Array(16);
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/regex.js
var regex_default;
var init_regex = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/regex.js"() {
    regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default;
var init_validate = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/validate.js"() {
    init_regex();
    validate_default = validate;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/stringify.js
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate_default(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var byteToHex, i, stringify_default;
var init_stringify = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/stringify.js"() {
    init_validate();
    byteToHex = [];
    for (i = 0; i < 256; ++i) {
      byteToHex.push((i + 256).toString(16).substr(1));
    }
    stringify_default = stringify;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v1.js
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || rng)();
    if (node == null) {
      node = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b[i++] = tl >>> 24 & 255;
  b[i++] = tl >>> 16 & 255;
  b[i++] = tl >>> 8 & 255;
  b[i++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b[i++] = tmh >>> 8 & 255;
  b[i++] = tmh & 255;
  b[i++] = tmh >>> 24 & 15 | 16;
  b[i++] = tmh >>> 16 & 255;
  b[i++] = clockseq >>> 8 | 128;
  b[i++] = clockseq & 255;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf || stringify_default(b);
}
var _nodeId, _clockseq, _lastMSecs, _lastNSecs, v1_default;
var init_v1 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v1.js"() {
    init_rng();
    init_stringify();
    _lastMSecs = 0;
    _lastNSecs = 0;
    v1_default = v1;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/parse.js
function parse(uuid) {
  if (!validate_default(uuid)) {
    throw TypeError("Invalid UUID");
  }
  var v2;
  var arr = new Uint8Array(16);
  arr[0] = (v2 = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v2 >>> 16 & 255;
  arr[2] = v2 >>> 8 & 255;
  arr[3] = v2 & 255;
  arr[4] = (v2 = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v2 & 255;
  arr[6] = (v2 = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v2 & 255;
  arr[8] = (v2 = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v2 & 255;
  arr[10] = (v2 = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v2 / 4294967296 & 255;
  arr[12] = v2 >>> 24 & 255;
  arr[13] = v2 >>> 16 & 255;
  arr[14] = v2 >>> 8 & 255;
  arr[15] = v2 & 255;
  return arr;
}
var parse_default;
var init_parse2 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/parse.js"() {
    init_validate();
    parse_default = parse;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v35.js
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
function v35_default(name, version2, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace === "string") {
      namespace = parse_default(namespace);
    }
    if (namespace.length !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }
      return buf;
    }
    return stringify_default(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL2;
  return generateUUID;
}
var DNS, URL2;
var init_v35 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v35.js"() {
    init_stringify();
    init_parse2();
    DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
    URL2 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/md5.js
function md5(bytes) {
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg.length);
    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = "0123456789abcdef";
  for (var i = 0; i < length32; i += 8) {
    var x4 = input[i >> 5] >>> i % 32 & 255;
    var hex2 = parseInt(hexTab.charAt(x4 >>> 4 & 15) + hexTab.charAt(x4 & 15), 16);
    output.push(hex2);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x4, len) {
  x4[len >> 5] |= 128 << len % 32;
  x4[getOutputLength(len) - 1] = len;
  var a4 = 1732584193;
  var b = -271733879;
  var c6 = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x4.length; i += 16) {
    var olda = a4;
    var oldb = b;
    var oldc = c6;
    var oldd = d;
    a4 = md5ff(a4, b, c6, d, x4[i], 7, -680876936);
    d = md5ff(d, a4, b, c6, x4[i + 1], 12, -389564586);
    c6 = md5ff(c6, d, a4, b, x4[i + 2], 17, 606105819);
    b = md5ff(b, c6, d, a4, x4[i + 3], 22, -1044525330);
    a4 = md5ff(a4, b, c6, d, x4[i + 4], 7, -176418897);
    d = md5ff(d, a4, b, c6, x4[i + 5], 12, 1200080426);
    c6 = md5ff(c6, d, a4, b, x4[i + 6], 17, -1473231341);
    b = md5ff(b, c6, d, a4, x4[i + 7], 22, -45705983);
    a4 = md5ff(a4, b, c6, d, x4[i + 8], 7, 1770035416);
    d = md5ff(d, a4, b, c6, x4[i + 9], 12, -1958414417);
    c6 = md5ff(c6, d, a4, b, x4[i + 10], 17, -42063);
    b = md5ff(b, c6, d, a4, x4[i + 11], 22, -1990404162);
    a4 = md5ff(a4, b, c6, d, x4[i + 12], 7, 1804603682);
    d = md5ff(d, a4, b, c6, x4[i + 13], 12, -40341101);
    c6 = md5ff(c6, d, a4, b, x4[i + 14], 17, -1502002290);
    b = md5ff(b, c6, d, a4, x4[i + 15], 22, 1236535329);
    a4 = md5gg(a4, b, c6, d, x4[i + 1], 5, -165796510);
    d = md5gg(d, a4, b, c6, x4[i + 6], 9, -1069501632);
    c6 = md5gg(c6, d, a4, b, x4[i + 11], 14, 643717713);
    b = md5gg(b, c6, d, a4, x4[i], 20, -373897302);
    a4 = md5gg(a4, b, c6, d, x4[i + 5], 5, -701558691);
    d = md5gg(d, a4, b, c6, x4[i + 10], 9, 38016083);
    c6 = md5gg(c6, d, a4, b, x4[i + 15], 14, -660478335);
    b = md5gg(b, c6, d, a4, x4[i + 4], 20, -405537848);
    a4 = md5gg(a4, b, c6, d, x4[i + 9], 5, 568446438);
    d = md5gg(d, a4, b, c6, x4[i + 14], 9, -1019803690);
    c6 = md5gg(c6, d, a4, b, x4[i + 3], 14, -187363961);
    b = md5gg(b, c6, d, a4, x4[i + 8], 20, 1163531501);
    a4 = md5gg(a4, b, c6, d, x4[i + 13], 5, -1444681467);
    d = md5gg(d, a4, b, c6, x4[i + 2], 9, -51403784);
    c6 = md5gg(c6, d, a4, b, x4[i + 7], 14, 1735328473);
    b = md5gg(b, c6, d, a4, x4[i + 12], 20, -1926607734);
    a4 = md5hh(a4, b, c6, d, x4[i + 5], 4, -378558);
    d = md5hh(d, a4, b, c6, x4[i + 8], 11, -2022574463);
    c6 = md5hh(c6, d, a4, b, x4[i + 11], 16, 1839030562);
    b = md5hh(b, c6, d, a4, x4[i + 14], 23, -35309556);
    a4 = md5hh(a4, b, c6, d, x4[i + 1], 4, -1530992060);
    d = md5hh(d, a4, b, c6, x4[i + 4], 11, 1272893353);
    c6 = md5hh(c6, d, a4, b, x4[i + 7], 16, -155497632);
    b = md5hh(b, c6, d, a4, x4[i + 10], 23, -1094730640);
    a4 = md5hh(a4, b, c6, d, x4[i + 13], 4, 681279174);
    d = md5hh(d, a4, b, c6, x4[i], 11, -358537222);
    c6 = md5hh(c6, d, a4, b, x4[i + 3], 16, -722521979);
    b = md5hh(b, c6, d, a4, x4[i + 6], 23, 76029189);
    a4 = md5hh(a4, b, c6, d, x4[i + 9], 4, -640364487);
    d = md5hh(d, a4, b, c6, x4[i + 12], 11, -421815835);
    c6 = md5hh(c6, d, a4, b, x4[i + 15], 16, 530742520);
    b = md5hh(b, c6, d, a4, x4[i + 2], 23, -995338651);
    a4 = md5ii(a4, b, c6, d, x4[i], 6, -198630844);
    d = md5ii(d, a4, b, c6, x4[i + 7], 10, 1126891415);
    c6 = md5ii(c6, d, a4, b, x4[i + 14], 15, -1416354905);
    b = md5ii(b, c6, d, a4, x4[i + 5], 21, -57434055);
    a4 = md5ii(a4, b, c6, d, x4[i + 12], 6, 1700485571);
    d = md5ii(d, a4, b, c6, x4[i + 3], 10, -1894986606);
    c6 = md5ii(c6, d, a4, b, x4[i + 10], 15, -1051523);
    b = md5ii(b, c6, d, a4, x4[i + 1], 21, -2054922799);
    a4 = md5ii(a4, b, c6, d, x4[i + 8], 6, 1873313359);
    d = md5ii(d, a4, b, c6, x4[i + 15], 10, -30611744);
    c6 = md5ii(c6, d, a4, b, x4[i + 6], 15, -1560198380);
    b = md5ii(b, c6, d, a4, x4[i + 13], 21, 1309151649);
    a4 = md5ii(a4, b, c6, d, x4[i + 4], 6, -145523070);
    d = md5ii(d, a4, b, c6, x4[i + 11], 10, -1120210379);
    c6 = md5ii(c6, d, a4, b, x4[i + 2], 15, 718787259);
    b = md5ii(b, c6, d, a4, x4[i + 9], 21, -343485551);
    a4 = safeAdd(a4, olda);
    b = safeAdd(b, oldb);
    c6 = safeAdd(c6, oldc);
    d = safeAdd(d, oldd);
  }
  return [a4, b, c6, d];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 255) << i % 32;
  }
  return output;
}
function safeAdd(x4, y4) {
  var lsw = (x4 & 65535) + (y4 & 65535);
  var msw = (x4 >> 16) + (y4 >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q, a4, b, x4, s2, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a4, q), safeAdd(x4, t)), s2), b);
}
function md5ff(a4, b, c6, d, x4, s2, t) {
  return md5cmn(b & c6 | ~b & d, a4, b, x4, s2, t);
}
function md5gg(a4, b, c6, d, x4, s2, t) {
  return md5cmn(b & d | c6 & ~d, a4, b, x4, s2, t);
}
function md5hh(a4, b, c6, d, x4, s2, t) {
  return md5cmn(b ^ c6 ^ d, a4, b, x4, s2, t);
}
function md5ii(a4, b, c6, d, x4, s2, t) {
  return md5cmn(c6 ^ (b | ~d), a4, b, x4, s2, t);
}
var md5_default;
var init_md5 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/md5.js"() {
    md5_default = md5;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v3.js
var v3, v3_default;
var init_v3 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v3.js"() {
    init_v35();
    init_md5();
    v3 = v35_default("v3", 48, md5_default);
    v3_default = v3;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify_default(rnds);
}
var v4_default;
var init_v4 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v4.js"() {
    init_rng();
    init_stringify();
    v4_default = v4;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/sha1.js
function f(s2, x4, y4, z) {
  switch (s2) {
    case 0:
      return x4 & y4 ^ ~x4 & z;
    case 1:
      return x4 ^ y4 ^ z;
    case 2:
      return x4 & y4 ^ x4 & z ^ y4 & z;
    case 3:
      return x4 ^ y4 ^ z;
  }
}
function ROTL(x4, n) {
  return x4 << n | x4 >>> 32 - n;
}
function sha1(bytes) {
  var K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  var H = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M2 = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M2[_i] = arr;
  }
  M2[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M2[N - 1][14] = Math.floor(M2[N - 1][14]);
  M2[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M2[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a4 = H[0];
    var b = H[1];
    var c6 = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s2 = Math.floor(_t2 / 20);
      var T = ROTL(a4, 5) + f(s2, b, c6, d) + e + K2[s2] + W[_t2] >>> 0;
      e = d;
      d = c6;
      c6 = ROTL(b, 30) >>> 0;
      b = a4;
      a4 = T;
    }
    H[0] = H[0] + a4 >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c6 >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 255, H[0] >> 16 & 255, H[0] >> 8 & 255, H[0] & 255, H[1] >> 24 & 255, H[1] >> 16 & 255, H[1] >> 8 & 255, H[1] & 255, H[2] >> 24 & 255, H[2] >> 16 & 255, H[2] >> 8 & 255, H[2] & 255, H[3] >> 24 & 255, H[3] >> 16 & 255, H[3] >> 8 & 255, H[3] & 255, H[4] >> 24 & 255, H[4] >> 16 & 255, H[4] >> 8 & 255, H[4] & 255];
}
var sha1_default;
var init_sha1 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/sha1.js"() {
    sha1_default = sha1;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v5.js
var v5, v5_default;
var init_v5 = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v5.js"() {
    init_v35();
    init_sha1();
    v5 = v35_default("v5", 80, sha1_default);
    v5_default = v5;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/nil.js
var nil_default;
var init_nil = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/nil.js"() {
    nil_default = "00000000-0000-0000-0000-000000000000";
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/version.js
function version(uuid) {
  if (!validate_default(uuid)) {
    throw TypeError("Invalid UUID");
  }
  return parseInt(uuid.substr(14, 1), 16);
}
var version_default;
var init_version = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/version.js"() {
    init_validate();
    version_default = version;
  }
});

// ../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/index.js
var esm_browser_exports = {};
__export(esm_browser_exports, {
  NIL: () => nil_default,
  parse: () => parse_default,
  stringify: () => stringify_default,
  v1: () => v1_default,
  v3: () => v3_default,
  v4: () => v4_default,
  v5: () => v5_default,
  validate: () => validate_default,
  version: () => version_default
});
var init_esm_browser = __esm({
  "../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/index.js"() {
    init_v1();
    init_v3();
    init_v4();
    init_v5();
    init_nil();
    init_version();
    init_validate();
    init_stringify();
    init_parse2();
  }
});

// temp_stylePlugin:src/util/brusher.scss
var init_brusher = __esm({
  "temp_stylePlugin:src/util/brusher.scss"() {
  }
});

// stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/util/brusher.scss
var brusher_exports = {};
var init_brusher2 = __esm({
  "stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/util/brusher.scss"() {
    init_brusher();
  }
});

// src/util/brusher.js
var require_brusher = __commonJS({
  "src/util/brusher.js"(exports2, module2) {
    var d3 = (init_src32(), __toCommonJS(src_exports));
    if (typeof window !== "undefined") {
      init_brusher2();
    }
    var Brusher = class {
      constructor(params) {
        if (!params.svg) {
          throw Error("No svg given to brusher");
        }
        this.svg = params.svg;
        if (!params.width) {
          throw Error("No width given to brusher");
        }
        this.width = params.width;
        if (!params.height) {
          throw Error("No height given to brusher");
        }
        this.height = params.height;
        if (!params.callback) {
          throw Error("No callback given to brusher");
        }
        this.callback = params.callback;
        this.createElements();
      }
      createElements() {
        let self2 = this;
        const mouseMove = function(event) {
          if (self2.brusherActive) {
            let mouseX = d3.pointer(event, this)[0];
            if (mouseX > self2.brusherStart) {
              self2.brushHighlight.attr("x", self2.brusherStart);
              self2.brushHighlight.attr("width", mouseX - self2.brusherStart);
            } else {
              self2.brushHighlight.attr("x", mouseX);
              self2.brushHighlight.attr("width", self2.brusherStart - mouseX);
            }
          }
        };
        self2.brushHighlight = self2.svg.append("rect").attr("class", "brusher").attr("width", 0).style("pointer-events", "none").attr("height", () => self2.height > 0 ? self2.height : 0).style("opacity", 0).style("stroke", "none").style("fill", "black");
        d3.select(".overlay").on("mousedown.brusher", function(event) {
          if (self2.disabled) {
            return;
          }
          self2.brusherActive = true;
          self2.brusherStart = d3.pointer(event, this)[0];
          self2.brushHighlight.style("opacity", 0.5);
        }).on("mouseup.brusher", function(event) {
          if (self2.disabled) {
            return;
          }
          self2.brusherActive = false;
          self2.brusherEnd = d3.pointer(event, this)[0];
          self2.brushHighlight.style("opacity", 0);
          self2.brushHighlight.attr("width", 0);
          if (self2.brusherStart > self2.brusherEnd) {
            self2.callback({ start: self2.brusherEnd, end: self2.brusherStart });
          } else {
            self2.callback({ start: self2.brusherStart, end: self2.brusherEnd });
          }
        }).on("mousemove.brusher", mouseMove);
      }
    };
    module2.exports = Brusher;
  }
});

// src/graphs/lineGraph.js
var require_lineGraph = __commonJS({
  "src/graphs/lineGraph.js"(exports2, module2) {
    var GridDuck2;
    var LineTooltip;
    if (typeof window !== "undefined") {
      init_lineGraph2();
      LineTooltip = require_lineTooltip();
    }
    var getFormat = require_util().getFormat;
    var getFormatDate = require_util().getFormatDate;
    var parseTime = require_util().parseTime;
    var readyPromise = require_util().readyPromise;
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var moment = require_moment_timezone2();
    var ANIMATION_TIME = 300;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var Brusher = require_brusher();
    var MARGIN = { top: 20, right: 20, bottom: 30, left: 70 };
    var StateOptions = require_StateOptions();
    var LineGraph2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        let self2 = this;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        if (params.windowWidth) {
          this.width = params.windowWidth;
          this.height = params.windowHeight;
          this.fixedSize = true;
        }
        this.overlays = params.overlays;
        this.siteId = params.siteId;
        if (params.compareTo && params.compareTo.start && params.compareTo.end) {
          this.compareTo = params.compareTo;
        }
        if (params.start === void 0 && params.startOf === void 0) {
          throw Error("No start defined");
        }
        if (!params.element) {
          throw Error("No element defined");
        }
        if (params.averageType) {
          this.averageType = params.averageType;
        } else {
          this.averageType = "average";
        }
        this.onNoTempData = params.onNoTempData;
        this.color = params.color;
        this.widget = params.widget;
        this.average = params.average;
        if (this.widget) {
          MARGIN.left = 20;
          ANIMATION_TIME = 0;
        } else {
          MARGIN.left = 70;
          ANIMATION_TIME = 300;
        }
        if (!params.assets) {
          if (!params.filterType || !params.filterId) {
            throw Error("No assets or filtering data selected");
          }
          this.filterType = params.filterType;
          this.filterId = params.filterId;
          this.isSensors = true;
          this.assets = params.sensors;
          if (!params.dataTypes) {
            throw Error("No data types defined");
          }
          this.dataTypes = params.dataTypes;
          this.formats = params.dataTypes.map((t) => getFormat(t.toLowerCase()));
        } else {
          this.assets = params.assets;
          if (params.dataTypes) {
            this.isSensors = true;
            this.dataTypes = params.dataTypes;
            this.formats = params.dataTypes.map((t) => getFormat(t.toLowerCase()));
          } else {
            this.formats = [getFormat("demand")];
          }
        }
        this.timezone = params.timezone || "Europe/London";
        this.tooltipOverride = params.tooltipOverride;
        this.error = function(e) {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error(e);
          }
        };
        if (params.showTooltip !== false) {
          this.showTooltip = true;
        }
        if (params.showArea !== false) {
          this.showArea = true;
        }
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        if (params.summaryElement) {
          this.summaryElement = params.summaryElement;
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.hidden) {
          this.hidden = params.hidden;
        }
        if (params.granularity) {
          this.granularity = params.granularity;
        }
        if (params.onVisibleItems) {
          this.onVisibleItems = params.onVisibleItems;
        }
        this.end = params.end;
        if (params.realTime) {
          this.realTime = true;
          this.end = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
        } else if (params.end === void 0) {
          throw Error("No end defined and not real time");
        }
        this.dataType = StateOptions.DataTypes.find((d) => d.type === this.dataTypes[0]);
        this.isMobile = params.isMobile;
        this.startOf = params.startOf;
        this.combined = params.combined;
        this.start = params.start;
        this.isDeleted = false;
        this.element = params.element;
        this.zoomCallback = params.zoomCallback;
        this.curve = d3.curveLinear;
        this.resetZoom = this.resetZoom.bind(this);
        readyPromise.then(function() {
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          self2.init();
        });
      }
      loadData() {
        let self2 = this;
        if (this.dataType && this.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
          this.curve = d3.curveStepAfter;
        } else {
          this.curve = d3.curveLinear;
        }
        if (this.overlays && this.overlays.length > 0) {
          this.overlayDataType = StateOptions.DataTypes.find((d) => d.type === this.overlays[0].dataType);
          if (this.overlayDataType && this.overlayDataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
            this.overlayCurve = d3.curveStepAfter;
          } else {
            this.overlayCurve = d3.curveLinear;
          }
        }
        let dataType = self2.dataTypes[0];
        let promises = [];
        let filters = [
          {
            field: "dataType",
            value: dataType
          },
          {
            field: "start",
            value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
          },
          {
            field: "end",
            value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
          },
          {
            field: "type",
            value: self2.averageType
          }
        ];
        if (!self2.zoom) {
          filters.push({
            field: "granularity",
            value: self2.granularity
          });
        }
        if (self2.assets) {
          if (self2.assets.length === 1 && !self2.widget) {
            self2.combined = false;
          }
          filters.push({
            field: "assetId",
            value: self2.assets.map((a4) => a4.id).join(",")
          });
        } else {
          filters.push({
            field: "assetId",
            value: "filtered"
          });
          filters.push({
            field: self2.filterType,
            value: self2.filterId
          });
        }
        promises.push(GridDuck2.getAssetTelemetryBatchs({
          filters
        }).then(function(res) {
          let validTelemetryArray = res.list.find(function(item) {
            return item.telemetry && item.telemetry.length;
          });
          let blankTelemetryArray = [];
          if (!validTelemetryArray) {
            blankTelemetryArray = [];
          } else {
            blankTelemetryArray = validTelemetryArray.telemetry.map(function(pt) {
              let blank = { time: pt.time };
              for (let key in pt) {
                if (pt.hasOwnProperty(key) && key !== "time") {
                  blank[key] = null;
                }
              }
              return blank;
            });
          }
          res.list.forEach((d) => {
            d._telemetry = d.telemetry && d.telemetry.length ? d.telemetry : blankTelemetryArray;
          });
          self2.assetData = res.list.map((d) => ({
            name: d.assetName,
            id: d.assetId,
            parent: d.parent
          }));
          if (self2.assetData.length === 1) {
            self2.assetData[0].color = self2.color;
          }
          let overlayPromises = [];
          if (self2.overlays) {
            if (self2.overlays.find((o) => o.dataType === "EXTERNAL_TEMPERATURE")) {
              let filters2 = [
                {
                  field: "dataType",
                  value: "EXTERNAL_TEMPERATURE"
                },
                {
                  field: "start",
                  value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
                },
                {
                  field: "end",
                  value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
                },
                {
                  field: "assetId",
                  value: self2.assetData[0].id
                },
                {
                  field: "granularity",
                  value: self2.granularity
                }
              ];
              overlayPromises.push(GridDuck2.getAssetTelemetryBatchs({
                filters: filters2
              }).then(function(resTemp) {
                if (resTemp && resTemp.list && resTemp.list.length > 0 && resTemp.list[0].telemetry) {
                  if (resTemp.list[0].telemetry.filter((tD) => tD.value !== null).length === 0) {
                    self2.temperatureData = void 0;
                    if (self2.onNoTempData) {
                      self2.onNoTempData();
                    }
                  } else {
                    self2.temperatureData = resTemp.list[0].telemetry;
                  }
                } else {
                  if (self2.onNoTempData) {
                    self2.onNoTempData();
                  }
                }
              }));
            } else if (self2.overlays.find((o) => o.dataType === "EXTERNAL_HUMIDITY")) {
              let filters2 = [
                {
                  field: "dataType",
                  value: "EXTERNAL_HUMIDITY"
                },
                {
                  field: "start",
                  value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
                },
                {
                  field: "end",
                  value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
                },
                {
                  field: "assetId",
                  value: self2.assetData[0].id
                },
                {
                  field: "granularity",
                  value: self2.granularity
                }
              ];
              overlayPromises.push(GridDuck2.getAssetTelemetryBatchs({
                filters: filters2
              }).then(function(resTemp) {
                if (resTemp && resTemp.list && resTemp.list.length > 0 && resTemp.list[0].telemetry) {
                  if (resTemp.list[0].telemetry.filter((tD) => tD.value !== null).length === 0) {
                    self2.customOverlayData = void 0;
                  } else {
                    self2.customOverlayData = resTemp.list[0].telemetry;
                    self2.customOverlayDeviceName = "External Humidity";
                  }
                } else {
                  if (self2.onNoCustomOverlayData) {
                    self2.onNoCustomOverlayData();
                  }
                }
              }));
            } else if (self2.overlays.find((o) => o.type === "CUSTOM")) {
              let overlay = self2.overlays.find((o) => o.type === "CUSTOM");
              let filters2 = [
                {
                  field: "dataType",
                  value: overlay.dataType
                },
                {
                  field: "start",
                  value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
                },
                {
                  field: "end",
                  value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
                },
                {
                  field: "assetId",
                  value: overlay.deviceId
                },
                {
                  field: "granularity",
                  value: self2.granularity
                }
              ];
              overlayPromises.push(GridDuck2.getAssetTelemetryBatchs({
                filters: filters2
              }).then(function(resTemp) {
                if (resTemp && resTemp.list && resTemp.list.length > 0 && resTemp.list[0].telemetry) {
                  if (resTemp.list[0].telemetry.filter((tD) => tD.value !== null).length === 0) {
                    self2.customOverlayData = void 0;
                  } else {
                    self2.customOverlayData = resTemp.list[0].telemetry;
                    self2.customOverlayDeviceName = resTemp.list[0].assetName;
                  }
                } else {
                  if (self2.onNoCustomOverlayData) {
                    self2.onNoCustomOverlayData();
                  }
                }
              }));
            }
          }
          if (self2.overlays && self2.overlays.length > 0 && self2.overlays.find((o) => o.dataType === "OCCUPANCY") && self2.siteId) {
            overlayPromises.push(GridDuck2.getSite({ id: self2.siteId }).then(function(site) {
              if (site.occupancySchedule && site.occupancySchedule.length) {
                self2.occupancyHours = site.occupancySchedule;
              } else if (site.defaultOccupancySchedule && site.defaultOccupancySchedule.length) {
                self2.occupancyHours = site.defaultOccupancySchedule;
              }
            }));
          }
          return Promise.all(overlayPromises).then(function() {
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          });
        }).catch(self2.error));
        if (self2.compareTo && self2.compareTo.start && self2.compareTo.end) {
          let compareFilters = [
            {
              field: "dataType",
              value: dataType
            },
            {
              field: "start",
              value: self2.zoom ? Math.round(self2.zoom.startCompare.getTime() / 1e3) - 120 : self2.compareTo.start
            },
            {
              field: "end",
              value: self2.zoom ? Math.round(self2.zoom.endCompare.getTime() / 1e3) + 120 : self2.compareTo.end
            },
            {
              field: "type",
              value: self2.averageType
            }
          ];
          if (!self2.zoom) {
            compareFilters.push({
              field: "granularity",
              value: self2.granularity
            });
          }
          if (self2.assets) {
            compareFilters.push({
              field: "assetId",
              value: self2.assets.map((a4) => a4.id).join(",")
            });
          } else {
            compareFilters.push({
              field: "assetId",
              value: "filtered"
            });
            compareFilters.push({
              field: self2.filterType,
              value: self2.filterId
            });
          }
          promises.push(GridDuck2.getAssetTelemetryBatchs({
            filters: compareFilters
          }).then(function(res) {
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          }).catch(self2.error));
        }
        return Promise.all(promises).then(function(res) {
          if (res && res[0]) {
            return Promise.resolve({
              results: res[0],
              cResults: res[1]
            });
          } else {
            return Promise.reject("Error loading data");
          }
        });
      }
      init(noClear, noAnimateLines) {
        if (this.overlays && this.overlays.length > 0 && this.overlays.find((o) => o.dataType !== "OCCUPANCY")) {
          MARGIN.right = 70;
        } else {
          MARGIN.right = 20;
        }
        if (this.isDeleted) {
          return;
        }
        this.customOverlayData = void 0;
        this.yScalerCustomOverlay = void 0;
        let startTs = (/* @__PURE__ */ new Date()).getTime();
        let uuid = uuidv4();
        this.uuid = uuid;
        if (this.svg && !noClear) {
          this.clearDown();
        }
        let self2 = this;
        self2.dataStart = self2.start ? self2.start : moment().startOf(self2.startOf).unix();
        self2.dataEnd = self2.realTime ? Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) : self2.end;
        return this.loadData().then(function(rez) {
          let results = rez.results.filter((result) => result.list && result.list.length > 0);
          let cResults = rez.cResults;
          if (results.length === 0) {
            if (self2.onVisibleItems) {
              self2.onVisibleItems(results);
            }
            if (self2.onReady) {
              self2.onReady();
            }
            return;
          }
          if (uuid === self2.uuid) {
            if (self2.isDeleted) {
              return;
            }
            let color2 = d3.scaleOrdinal().domain(results.map((r, i) => i * (self2.dataTypes ? self2.dataTypes.length : 1))).range(d3.schemeSet1);
            self2.datas = results.map(function(result, index3) {
              let lineColor = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3);
              let returnResult = {
                name: self2.assetData[index3].name,
                id: self2.assetData[index3].id,
                parent: self2.assetData[index3].parent,
                hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                data: result.list.map((r) => ({
                  date: parseTime(r.time),
                  value: isFinite(self2.isSensors ? r.value : r.demand) ? self2.isSensors ? r.value : r.demand : null
                })),
                color: lineColor
              };
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
              }
              return returnResult;
            });
            if (self2.combined) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (!asset.parent || !self2.datas.find((a4) => a4.id === asset.parent)) {
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  }
                });
                return {
                  value: count3 > 0 ? total : null,
                  date: datum2.date
                };
              });
              self2.datas = [
                {
                  name: "Total",
                  id: "total",
                  data: totalData,
                  hidden: false,
                  color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
                }
              ];
            } else if (self2.average) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                    total += matchedRecord.value;
                    count3++;
                  }
                });
                return {
                  value: count3 > 0 ? total / count3 : null,
                  date: datum2.date
                };
              });
              self2.datas = [
                {
                  name: "Average",
                  id: "average",
                  data: totalData,
                  hidden: false,
                  color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
                }
              ];
            }
            if (cResults) {
              self2.compareDatas = cResults.map(function(result, index3) {
                let returnResult = {
                  name: self2.assetData[index3].name,
                  id: self2.assetData[index3].id,
                  hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                  data: result.list.map((r) => ({
                    date: parseTime(r.time),
                    value: self2.isSensors ? r.value : r.demand
                  })),
                  parent: self2.assetData[index3].parent,
                  color: "#e7e7e7"
                  //self.assetData[index].color ? self.assetData[index].color : color(index)
                };
                if (self2.dataTypes && self2.dataTypes.length > 1) {
                  returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
                }
                return returnResult;
              });
              if (self2.combined) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (!asset.parent) {
                      if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                        total += matchedRecord.value;
                        count3++;
                      }
                    }
                  });
                  return {
                    value: count3 > 0 ? total : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [
                  {
                    name: "Total",
                    id: "total",
                    data: totalData,
                    hidden: false,
                    color: "#e7e7e7"
                  }
                ];
              } else if (self2.average) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  });
                  return {
                    value: count3 > 0 ? total / count3 : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [
                  {
                    name: "Average",
                    id: "average",
                    data: totalData,
                    hidden: false,
                    color: "#e7e7e7"
                  }
                ];
              }
            }
            if (results.length > 0) {
              if (noAnimateLines) {
                if ((/* @__PURE__ */ new Date()).getTime() - startTs < ANIMATION_TIME) {
                  setTimeout(function() {
                    self2.render(false, noAnimateLines);
                  }, ANIMATION_TIME - (/* @__PURE__ */ new Date()).getTime() + startTs);
                } else {
                  self2.createGraph(noAnimateLines);
                }
              } else {
                self2.createGraph(noAnimateLines);
                self2.createGraph(noAnimateLines);
              }
            }
          }
        }).catch(function(e) {
          self2.error(e);
        });
      }
      generateKPIs() {
        let self2 = this;
        let kpiData = {};
        if (this.dataType && this.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
          let options = this.dataType.unitDetails.metaData.categories;
          for (let i = 0; i < options.length; i++) {
            let totalTime = 0;
            let optionLabel = options[i].label;
            let optionValue = options[i].value;
            let periods = [];
            self2.datas.forEach(function(dataSet) {
              if (dataSet.data) {
                for (let d = 0; d < dataSet.data.length - 1; d++) {
                  if (dataSet.data[d].value === optionValue) {
                    let periodTime = dataSet.data[d + 1].date.getTime() - dataSet.data[d].date.getTime();
                    totalTime += periodTime;
                    periods.push(periodTime);
                  }
                }
              }
            });
            let meanTime, maxTime, minTime = 0;
            if (periods.length > 0) {
              maxTime = Math.max.apply(null, periods);
              minTime = Math.min.apply(null, periods);
              meanTime = periods.reduce((sum4, value) => sum4 + value, 0) / periods.length;
            }
            kpiData["Cat_" + optionLabel + "MaxTime"] = {
              value: getFormat("time")(maxTime),
              dataType: optionLabel,
              rawValue: maxTime
            };
            kpiData["Cat_" + optionLabel + "AvgTime"] = {
              value: getFormat("time")(meanTime),
              dataType: optionLabel,
              rawValue: meanTime
            };
          }
        } else {
          let hiddenIds = self2.datas.filter((d) => d.hidden || d.data === null).map((d) => d.id);
          this.dataTypes.forEach(function(dataType, index3) {
            let dataField = index3 === 0 ? "value" : "value2";
            if (self2.averageType === "average") {
              let average = Math.round(self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
                return r + a4.data.map((b, i) => b[dataField]).reduce((v2, m3) => v2 + m3, 0);
              }, 0) / self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
                return r + a4.data.map((b, i) => b[dataField] !== null ? 1 : 0).reduce((v2, m3) => v2 + m3, 0);
              }, 0));
              kpiData[dataType.toLowerCase() + "Avg"] = {
                value: getFormat(dataType.toLowerCase())(average),
                rawValue: average,
                dataType: dataType.toLowerCase()
              };
            } else if (self2.averageType === "max") {
              let max5 = d3.max(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return d[dataField];
              });
              kpiData[dataType.toLowerCase() + "Max"] = {
                value: getFormat(dataType.toLowerCase())(max5),
                rawValue: max5,
                dataType: dataType.toLowerCase()
              };
            } else if (self2.averageType === "min") {
              let min4 = d3.min(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return d[dataField];
              });
              kpiData[dataType.toLowerCase() + "Min"] = {
                value: getFormat(dataType.toLowerCase())(min4),
                rawValue: min4,
                dataType: dataType.toLowerCase()
              };
            }
          });
        }
        if (this.onKPIData) {
          this.onKPIData(kpiData);
        }
      }
      createGraph(noAnimateLines) {
        let self2 = this;
        let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null && a4.value !== void 0 || a4.value2 !== null && a4.value2 !== void 0).length > 0);
        if (this.onVisibleItems) {
          if (this.temperatureData) {
            visibleItems.unshift({
              name: "External Temperature",
              color: "#49b9c4",
              id: "EXTERNAL_TEMP",
              hidden: false
            });
          }
          if (this.customOverlayData) {
            let color2 = "#49b9c4";
            let category = StateOptions.DataCategories.find((c6) => c6.name === this.overlayDataType.category);
            if (category && category.color) {
              color2 = category.color;
            }
            visibleItems.unshift({
              name: `${this.customOverlayDeviceName}`,
              color: color2,
              id: "CUSTOM_OVERLAY",
              hidden: false
            });
          }
          visibleItems.sort(function(a4, b) {
            const aVal = a4.data && a4.data.find((d) => d.value !== null && d.value !== void 0);
            const bVal = b.data && b.data.find((d) => d.value !== null && d.value !== void 0);
            return (bVal ? bVal.value : -Infinity) - (aVal ? aVal.value : -Infinity);
          });
          this.onVisibleItems(visibleItems);
        }
        if (this.onReady && !this.isDeleted) {
          this.onReady();
        }
        if (visibleItems.length > 0) {
          self2.generateKPIs();
        } else {
          this.clearDown();
          return;
        }
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender(false, noAnimateLines);
          });
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender(false, noAnimateLines);
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(
            self2.d3Element.node().parentNode,
            {
              childList: true,
              subtree: true
            }
          );
        }
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((node) => node.parentNode === target);
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      remove() {
        this.clearDown();
        this.deleted();
        if (document.getElementById(this.uuid)) {
          document.getElementById(this.uuid).remove();
        }
      }
      deleted() {
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.avgDiv) {
          this.avgDiv.remove();
        }
        if (this.maxDiv) {
          this.maxDiv.remove();
        }
        if (this.minDiv) {
          this.minDiv.remove();
        }
      }
      clearDown(ignoreLegend) {
        if (this.svg) {
          this.svg.remove();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.svg = null;
        if (!ignoreLegend) {
          if (this.legendDiv) {
            this.legendDiv.remove();
          }
        }
        if (this.tooltip) {
          this.tooltip.remove();
          this.tooltip = null;
        }
      }
      calcSizes() {
        let newWidth = this.d3Element.node().clientWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().clientHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      render(ignoreLegend, noAnimateLines, noAdjustScales) {
        if (this.isDeleted) {
          return;
        }
        let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null || a4.value2 !== null).length > 0);
        if (visibleItems.length === 0) {
          return;
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        let self2 = this;
        self2.lastRendered = (/* @__PURE__ */ new Date()).getTime();
        if (!this.fixedSize) {
          let changed = this.calcSizes();
          if (changed && this.svg) {
            self2.tooltipOverride(null);
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("svg").attr("id", this.uuid).attr("class", "gd-graph gd-graph-line-graph").attr("width", "100%").attr("height", "100%");
          this.svg.append("defs").append("svg:clipPath").attr("id", "clip").append("svg:rect").attr("width", this.width).attr("height", this.height).attr("x", 0).attr("y", 0);
          this.graph = this.svg.append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.graphContentCompare = this.graph.append("g").attr("clip-path", "url(#clip)");
          this.graphContent = this.graph.append("g").attr("clip-path", "url(#clip)");
          this.overlay = this.svg.append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.graph.append("g").attr("transform", "translate(" + this.width + ",0)").attr("class", "axis-right");
          this.graph.append("g").attr("transform", "translate(0," + this.height + ")").attr("class", "axis-bottom");
          this.graph.append("g").attr("class", "axis-left");
          this.graph.append("g").attr("class", "grid").style("stroke-opacity", "0.7").style("stroke", "lightgrey").style("shape-rendering", "crispEdges").style("stroke-dasharray", "3 3");
        }
        let thisData = this.datas.filter((d) => !d.hidden).map((d) => d.data).flat();
        let yMax = d3.max(thisData, function(d) {
          return isFinite(d.value) ? d.value : void 0;
        });
        let yMin = d3.min(thisData, function(d) {
          return isFinite(d.value) ? d.value : void 0;
        });
        let xMax = d3.max(thisData, function(d) {
          return d.date;
        });
        let xMin = d3.min(thisData, function(d) {
          return d.date;
        });
        if (self2.zoom) {
          thisData = thisData.filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.start);
          if (this.compareDatas) {
            thisData = thisData.concat(this.compareDatas.map((d) => d.data).flat().filter((d) => d.date <= self2.zoom.endCompare && d.date >= self2.zoom.startCompare));
          }
          yMax = d3.max(thisData, function(d) {
            return isFinite(d.value) ? d.value : void 0;
          });
          yMin = d3.min(thisData, function(d) {
            return isFinite(d.value) ? d.value : void 0;
          });
          xMax = d3.max(thisData, function(d) {
            return d.date;
          });
          xMin = d3.min(thisData, function(d) {
            return d.date;
          });
        }
        if (!noAdjustScales && (!this.zoom || !noAnimateLines || this.yScaler && (this.yScaler(yMax) < 0 || this.yScaler(yMin) > this.height))) {
          this.xScaler = d3.scaleTime().range([0, this.width]);
          this.yScaler = d3.scaleLinear().range([this.height, 0]);
          this.xScaler.domain(d3.extent(this.datas.map((d) => d.data).flat(), function(d) {
            return d.date;
          }));
          if (this.compareDatas) {
            this.xScalerCompare = d3.scaleTime().range([0, this.width]);
            this.xScalerCompare.domain(d3.extent(this.compareDatas.map((d) => d.data).flat(), function(d) {
              return d.date;
            }));
          }
          let datas = this.datas;
          if (this.compareDatas) {
            datas = datas.concat(this.compareDatas);
          }
          let yMax2 = d3.max(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return isFinite(d.value) ? d.value : void 0;
          });
          let yMin2 = d3.min(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return isFinite(d.value) ? d.value : void 0;
          });
          if (self2.zoom) {
            self2.xScaler.domain([self2.zoom.start, self2.zoom.end]);
            if (self2.xScalerCompare) {
              self2.xScalerCompare.domain([self2.zoom.startCompare, self2.zoom.endCompare]);
            }
            yMax2 = d3.max(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.start && d.date <= self2.zoom.end), function(d) {
              return isFinite(d.value) ? d.value : void 0;
            });
            yMin2 = d3.min(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.start && d.date <= self2.zoom.end), function(d) {
              return isFinite(d.value) ? d.value : void 0;
            });
            if (this.compareDatas) {
              let yMaxCompare = d3.max(this.compareDatas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.startCompare && d.date <= self2.zoom.endCompare), function(d) {
                return isFinite(d.value) ? d.value : void 0;
              });
              let yMinCompare = d3.min(this.compareDatas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.startCompare && d.date <= self2.zoom.endCompare), function(d) {
                return isFinite(d.value) ? d.value : void 0;
              });
              yMax2 = Math.max(yMax2, yMaxCompare);
              yMin2 = Math.min(yMin2, yMinCompare);
            }
          }
          if (this.dataType && this.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
            let max5 = Math.max.apply(null, this.dataType.unitDetails.metaData.categories.map((o) => o.value));
            let min4 = Math.min.apply(null, this.dataType.unitDetails.metaData.categories.map((o) => o.value));
            this.yScaler.domain([min4, max5]);
          } else if (yMax2 <= 0 && yMin2 < 0) {
            self2.completelyNegative = true;
            self2.symmetrical = false;
            this.yScaler.domain([yMin2 * 1.2, yMax2 * 0.8]);
          } else if (yMin2 < 0 && yMax2 > 0) {
            self2.symmetrical = true;
            self2.completelyNegative = false;
            const minValue = Math.min(0, yMin2);
            const maxValue = Math.max(0, yMax2);
            this.yScaler.domain([minValue, maxValue]);
          } else if (yMin2 === yMax2 && yMin2 === 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, 1]);
          } else if (yMin2 > 0 && yMax2 > 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, yMax2 * 1]);
          } else {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([yMin2 * 1, yMax2 * 1]);
          }
          if (this.temperatureData) {
            let temperatureMax = Math.max(...this.temperatureData.map((t) => t.value));
            let temperatureMin = Math.min(...this.temperatureData.map((t) => t.value));
            this.yScalerTemperature = d3.scaleLinear().range([this.height, 0]);
            this.yScalerTemperature.domain([temperatureMin < 0 ? temperatureMin * 1 : temperatureMin / 1, temperatureMax * 1]);
          }
          if (this.customOverlayData) {
            let valueMax = Math.max(...this.customOverlayData.map((t) => t.value));
            let valueMin = Math.min(...this.customOverlayData.map((t) => t.value));
            this.yScalerCustomOverlay = d3.scaleLinear().range([this.height, 0]);
            if (this.overlayDataType && this.overlayDataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
              let max5 = Math.max.apply(null, this.overlayDataType.unitDetails.metaData.categories.map((o) => o.value));
              let min4 = Math.min.apply(null, this.overlayDataType.unitDetails.metaData.categories.map((o) => o.value));
              this.yScalerCustomOverlay.domain([min4, max5]);
            } else if (valueMax <= 0 && valueMin < 0) {
              this.yScalerCustomOverlay.domain([valueMin * 1, 0]);
            } else if (valueMin < 0 && valueMax > 0) {
              const minValue = Math.min(0, valueMin);
              const maxValue = Math.max(0, valueMax);
              this.yScalerCustomOverlay.domain([minValue, maxValue]);
            } else if (valueMin === valueMax && valueMin === 0) {
              this.yScalerCustomOverlay.domain([0, 1]);
            } else {
              this.yScalerCustomOverlay.domain([valueMin * 0.8, valueMax * 1.2]);
            }
          }
          if (this.dataTypes && this.dataTypes.length === 2) {
            if (this.dataTypes[1] === "OCCUPANCY") {
              this.yScaler2 = d3.scaleOrdinal().domain([0, 1]).range([this.height, 0]);
            } else {
              let y2Max = d3.max(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return isFinite(d.value2) ? d.value2 : void 0;
              });
              let y2Min = d3.min(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return isFinite(d.value2) ? d.value2 : void 0;
              });
              this.yScaler2 = d3.scaleLinear().range([this.height, 0]);
              this.yScaler2.domain([y2Min / 1, y2Max * 1]);
            }
          }
        }
        if (!noAnimateLines) {
          self2.oldYScaler = self2.yScaler;
        }
        if (this.occupancyHours) {
          this.createOccupancyBoxes(noAnimateLines);
        }
        this.createValueArea(noAnimateLines);
        if (this.compareDatas) {
          this.createValueAreaComparison(noAnimateLines);
        }
        if (this.temperatureData) {
          this.createValueLineTemperature(noAnimateLines);
        }
        if (this.customOverlayData) {
          this.createValueLineOverlay(noAnimateLines);
        }
        if (this.dataTypes.length === 2) {
          this.createValueLine(noAnimateLines);
        }
        if (this.showTooltip && !this.tooltip) {
          this.tooltip = new LineTooltip({
            granularity: this.granularity,
            svg: this.overlay,
            temperatureData: this.temperatureData,
            customOverlayData: this.customOverlayData,
            customOverlayDeviceName: this.customOverlayDeviceName,
            yScalerTemperature: this.yScalerTemperature,
            yScalerCustomOverlay: this.yScalerCustomOverlay,
            overlayDataType: this.overlayDataType,
            widget: this.widget,
            timezone: this.timezone,
            element: this.d3Element,
            datas: this.datas,
            compareDatas: this.compareDatas,
            formats: this.formats,
            dataTypes: this.dataTypes,
            width: this.width,
            height: this.height,
            xScaler: this.xScaler,
            xScalerCompare: this.xScalerCompare,
            yScaler: this.yScaler,
            yScaler2: this.yScaler2,
            start: this.start,
            end: this.end,
            isMobile: this.isMobile,
            override: this.tooltipOverride,
            lockCallback: function(locked) {
              self2.brusher.disabled = locked;
              self2.brusherLocked = locked;
              self2.throttledRender(false, false, true);
            }
          });
          if (!this.widget) {
            this.brusher = new Brusher({
              svg: this.overlay,
              width: this.width,
              height: this.height,
              callback: function(brushCallback) {
                if (self2.xScaler.invert(brushCallback.end).getTime() - self2.xScaler.invert(brushCallback.start).getTime() < 6e4) {
                  return;
                }
                if (!self2.zoom) {
                  self2.preZoomDatas = self2.datas;
                  self2.preZoomCompareDatas = self2.compareDatas;
                }
                self2.prevZoomData = self2.datas;
                self2.prevZoomCompareData = self2.compareDatas;
                self2.prevZOomTemperatureData = self2.temperatureData;
                self2.prevZoomCustomOverlayData = self2.customOverlayData;
                let start2 = self2.xScaler.invert(brushCallback.start);
                let end = self2.xScaler.invert(brushCallback.end);
                let minTime = 900;
                if (~self2.dataTypes[0].indexOf("PULSE")) {
                  minTime = 48 * 10 * 60;
                }
                if (end.getTime() - start2.getTime() < minTime * 1e3) {
                  end = new Date(start2.getTime() + minTime * 1e3);
                }
                self2.zoom = {
                  start: start2,
                  end
                };
                if (self2.compareTo && self2.compareTo.start && self2.compareTo.end) {
                  let diff = (self2.dataStart - self2.compareTo.start) * 1e3;
                  self2.zoom.startCompare = new Date(self2.zoom.start.getTime() - diff);
                  self2.zoom.endCompare = new Date(self2.zoom.end.getTime() - diff);
                }
                self2.throttledRender();
                let noAnimateLines2 = self2.zoom.end.getTime() / 1e3 - self2.zoom.start.getTime() / 1e3 > (self2.dataEnd - self2.dataStart) / 48;
                self2.init(true, noAnimateLines2);
                if (self2.zoomCallback) {
                  self2.zoomCallback(self2.zoom);
                }
              }
            });
          }
        }
        if (this.tooltip) {
          this.tooltip.widget = this.widget;
          this.tooltip.datas = this.datas;
          this.tooltip.compareDatas = this.compareDatas;
          this.tooltip.yScaler = this.yScaler;
          this.tooltip.granularity = this.granularity;
          this.tooltip.yScaler2 = this.yScaler2;
          this.tooltip.xScaler = this.xScaler;
          this.tooltip.xScalerCompare = this.xScalerCompare;
          this.tooltip.temperatureData = this.temperatureData;
          this.tooltip.customOverlayData = this.customOverlayData;
          this.tooltip.customOverlayDeviceName = this.customOverlayDeviceName;
          this.tooltip.yScalerTemperature = this.yScalerTemperature;
          this.tooltip.overlayDataType = this.overlayDataType;
          this.tooltip.yScalerCustomOverlay = this.yScalerCustomOverlay;
          if (this.tooltip.render) {
            this.tooltip.render();
          }
        }
        this.createAxes();
        self2.generateKPIs();
      }
      createAxes() {
        let axisLeft2 = d3.axisLeft(this.yScaler);
        let gridLinesLeft;
        if (!this.widget) {
          if (this.dataType && this.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
            axisLeft2.tickValues(this.dataType.unitDetails.metaData.categories.map((c6) => c6.value)).tickFormat((d) => this.dataType.unitDetails.metaData.categories.find((c6) => c6.value === d).label);
            gridLinesLeft = d3.axisLeft(this.yScaler).ticks(this.dataType.unitDetails.metaData.categories.length - 1);
          } else {
            axisLeft2.ticks(5);
            axisLeft2.tickFormat(this.formats[0]);
            gridLinesLeft = d3.axisLeft(this.yScaler).ticks(5);
          }
        }
        if (this.widget) {
          axisLeft2.ticks(0);
        }
        if (this.yScalerTemperature) {
          let axisRight2 = d3.axisRight(this.yScalerTemperature);
          axisRight2.tickFormat(getFormat("temperatureExternal"));
          axisRight2.ticks(5);
          this.svg.selectAll(".axis-right").call(axisRight2);
        } else if (this.yScalerCustomOverlay) {
          let axisRight2 = d3.axisRight(this.yScalerCustomOverlay);
          if (this.overlayDataType && this.overlayDataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
            axisRight2.tickValues(this.overlayDataType.unitDetails.metaData.categories.map((c6) => c6.value)).tickFormat((d) => this.overlayDataType.unitDetails.metaData.categories.find((c6) => c6.value === d).label);
          } else {
            axisRight2.tickFormat(getFormat("temperatureExternal"));
            axisRight2.tickFormat(getFormat(this.overlayDataType.type.toLowerCase())).ticks(5);
          }
          this.svg.selectAll(".axis-right").call(axisRight2);
        } else {
          this.svg.selectAll(".axis-right").remove();
        }
        if (this.yScaler2) {
          let axisRight2 = d3.axisRight(this.yScaler2);
          if (this.dataTypes[1] === "OCCUPANCY") {
            axisRight2.ticks(1);
          } else {
            axisRight2.ticks(5);
          }
          axisRight2.tickFormat(this.formats[1]);
          this.svg.selectAll(".axis-right").call(axisRight2);
        }
        let axisBottom2 = d3.axisBottom(this.xScaler);
        if (this.width > 800) {
          axisBottom2.ticks(5);
        } else {
          axisBottom2.ticks(2);
        }
        axisBottom2.tickFormat(getFormatDate(this.zoom ? this.zoom.start.getTime() / 1e3 : this.start, this.zoom ? this.zoom.end.getTime() / 1e3 : this.end, this.timezone));
        let data = this.datas.filter((d) => !d.hidden).map((d) => d.data).flat();
        if (this.widget) {
          axisBottom2.tickSize(0);
          axisBottom2.tickPadding(10);
          axisBottom2.tickValues([d3.min(data, function(d) {
            return d.date;
          }), d3.max(data, function(d) {
            return d.date;
          })]);
        }
        this.svg.selectAll(".axis-bottom").call(axisBottom2);
        this.svg.selectAll(".axis-left").call(axisLeft2);
        if (!this.widget) {
          this.svg.selectAll(".grid").call(
            gridLinesLeft.tickSize(-this.width).tickFormat("")
          );
        }
        this.svg.selectAll(".domain").remove();
        if (this.widget) {
          this.svg.selectAll(".tick text").style("text-anchor", function(d, i) {
            return i === 0 ? "start" : "end";
          });
        }
      }
      createValueArea(noAnimateLines) {
        let self2 = this;
        let anyHighlighted = self2.datas.filter((d) => d.highlighted).length > 0;
        let animateDuration = ANIMATION_TIME;
        let data = self2.datas.map((d) => d.data);
        if (this.dataTypes[1] === "OCCUPANCY") {
          let fixedData = [];
          data.forEach(function(innerData) {
            let innerFixedData = [];
            innerData.forEach(function(datum2, index3) {
              innerFixedData.push(datum2);
              if (index3 + 1 < innerData.length && datum2.value !== innerData[index3 + 1].value) {
                let newDatum = {};
                newDatum.date = innerData[index3 + 1].date;
                newDatum.value = datum2.value;
                innerFixedData.push(newDatum);
              }
            });
            fixedData.push(innerFixedData);
          });
          data = fixedData;
        }
        if (noAnimateLines && self2.zoom) {
          let oldNewData = [];
          self2.datas.map((a4) => a4.data).forEach(function(dataSet, i) {
            oldNewData[i] = dataSet.map((a4) => ({
              date: a4.date,
              value: a4.value + 0
            }));
          });
          oldNewData.forEach(function(dataSet, dataIndex) {
            let toSkip = self2.prevZoomData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).length;
            let toSkipRatio = Math.floor(toSkip / dataSet.length);
            dataSet.forEach(function(datum2, idx) {
              if (idx % toSkipRatio === 0) {
                return;
              }
              let nextDatum = self2.prevZoomData.map((d) => d.data)[dataIndex].find((d) => d.date > datum2.date);
              let prevDatum = self2.prevZoomData.map((d) => d.data)[dataIndex][self2.prevZoomData.map((d) => d.data)[dataIndex].indexOf(nextDatum) - 1];
              if (prevDatum && nextDatum) {
                datum2.value = prevDatum.value + (nextDatum.value - prevDatum.value) * ((datum2.date.getTime() - prevDatum.date.getTime()) / (nextDatum.date.getTime() - prevDatum.date.getTime()));
              } else {
                datum2.value = null;
              }
            });
            self2.prevZoomData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).forEach(function(prevZoomDatum) {
              dataSet.push(prevZoomDatum);
            });
            dataSet.sort((a4, b) => a4.date - b.date);
          });
          let line2 = d3.line().curve(self2.curve).x(function(d) {
            return self2.xScaler(d.date);
          }).defined(function(d) {
            return d.value !== null && isFinite(d.value);
          }).y(function(d) {
            return self2.oldYScaler(d.value);
          });
          if (!self2.widget && !self2.compareTo && !self2.combined) {
            let valueArea2 = d3.area().curve(self2.curve).x(function(d) {
              return self2.xScaler(d.date);
            }).y0(function(d) {
              if (self2.completelyNegative) {
                return 0;
              } else if (self2.symmetrical) {
                return self2.oldYScaler(0);
              } else {
                return self2.height;
              }
            }).y1(function(d) {
              return self2.oldYScaler(d.value);
            }).defined(function(d) {
              return d.value != null && isFinite(d.value);
            });
            let areas2 = self2.graphContent.selectAll(".area").data(oldNewData);
            areas2.transition().duration(0).attr("d", valueArea2);
          }
          let lines2 = self2.graphContent.selectAll(".line").data(oldNewData);
          lines2.transition().duration(0).attr("d", line2);
        }
        if (noAnimateLines && !self2.zoom) {
          animateDuration = 0;
        }
        let lines = self2.graphContent.selectAll(".line").data(self2.datas.map((d) => d.data));
        let line = d3.line().curve(self2.curve).x(function(d) {
          return self2.xScaler(d.date);
        }).defined(function(d) {
          return d.value !== null && isFinite(d.value);
        }).y(function(d) {
          return self2.yScaler(d.value);
        });
        let valueArea = d3.area().curve(self2.curve).x(function(d) {
          return self2.xScaler(d.date);
        }).y0(function(d) {
          if (self2.completelyNegative) {
            return self2.height;
          } else if (self2.symmetrical) {
            return self2.yScaler(0);
          } else {
            return self2.height;
          }
        }).y1(function(d) {
          return self2.yScaler(d.value);
        }).defined(function(d) {
          return d.value != null && isFinite(d.value);
        });
        let areas = self2.graphContent.selectAll(".area").data(data);
        areas.exit().remove();
        areas.enter().append("path").style("fill", function(d, i) {
          return self2.datas[i].color;
        }).style("opacity", function(d, i) {
          if (!self2.datas[i].hidden) {
            return self2.datas[i].highlighted ? 0.1 : anyHighlighted ? 0.025 : 0.05;
          } else {
            return 0;
          }
        }).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "area";
          } else {
            return "area hidden";
          }
        }).attr("d", valueArea);
        areas.transition().duration(animateDuration).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "area";
          } else {
            return "area hidden";
          }
        }).attr("d", valueArea).style("opacity", function(d, i) {
          if (!self2.datas[i].hidden) {
            if (self2.datas[i].highlighted) return 0.1;
            else if (anyHighlighted) return 0;
            else return 0.05;
          } else {
            return 0;
          }
        });
        lines.exit().remove();
        lines.enter().append("path").style("fill", "none").style("stroke", function(d, i) {
          return self2.datas[i].color;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", "2px").attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        }).attr("d", line);
        lines.transition().duration(animateDuration).style("stroke-width", "2px").style("stroke", function(d, i) {
          if (self2.datas[i].highlighted || !anyHighlighted) return self2.datas[i].color;
          else return "grey";
        }).style("stroke-opacity", function(d, i) {
          if (!self2.datas[i].hidden) {
            if (self2.datas[i].highlighted) return 1;
            else if (anyHighlighted) return 0.08;
            else return 1;
          } else {
            return 0;
          }
        }).attr("d", line).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        });
      }
      createValueAreaComparison(noAnimateLines) {
        let self2 = this;
        let anyHighlighted = self2.compareDatas.filter((d) => d.highlighted).length > 0;
        let animateDuration = ANIMATION_TIME;
        let data = self2.compareDatas.map((d) => d.data);
        if (this.dataTypes[1] === "OCCUPANCY") {
          let fixedData = [];
          data.forEach(function(innerData) {
            let innerFixedData = [];
            innerData.forEach(function(datum2, index3) {
              innerFixedData.push(datum2);
              if (index3 + 1 < innerData.length && datum2.value !== innerData[index3 + 1].value) {
                let newDatum = {};
                newDatum.date = innerData[index3 + 1].date;
                newDatum.value = datum2.value;
                innerFixedData.push(newDatum);
              }
            });
            fixedData.push(innerFixedData);
          });
          data = fixedData;
        }
        if (noAnimateLines && self2.zoom) {
          let oldNewData = [];
          self2.compareDatas.map((a4) => a4.data).forEach(function(dataSet, i) {
            oldNewData[i] = dataSet.map((a4) => ({
              date: a4.date,
              value: a4.value + 0
            }));
          });
          oldNewData.forEach(function(dataSet, dataIndex) {
            let toSkip = self2.prevZoomCompareData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).length;
            let toSkipRatio = Math.floor(toSkip / dataSet.length);
            dataSet.forEach(function(datum2, idx) {
              if (idx % toSkipRatio === 0) {
                return;
              }
              let nextDatum = self2.prevZoomCompareData.map((d) => d.data)[dataIndex].find((d) => d.date > datum2.date);
              let prevDatum = self2.prevZoomCompareData.map((d) => d.data)[dataIndex][self2.prevZoomCompareData.map((d) => d.data)[dataIndex].indexOf(nextDatum) - 1];
              if (prevDatum && nextDatum) {
                datum2.value = prevDatum.value + (nextDatum.value - prevDatum.value) * ((datum2.date.getTime() - prevDatum.date.getTime()) / (nextDatum.date.getTime() - prevDatum.date.getTime()));
              } else {
                datum2.value = null;
              }
            });
            self2.prevZoomCompareData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).forEach(function(prevZoomDatum) {
              dataSet.push(prevZoomDatum);
            });
            dataSet.sort((a4, b) => a4.date - b.date);
          });
          let line2 = d3.line().curve(self2.curve).x(function(d) {
            return self2.xScalerCompare(d.date);
          }).defined(function(d) {
            return d.value !== null && isFinite(d.value);
          }).y(function(d) {
            return self2.oldYScaler(d.value);
          });
          let valueArea = d3.area().curve(self2.curve).x(function(d) {
            return self2.xScalerCompare(d.date);
          }).y0(function(d) {
            if (self2.completelyNegative) {
              return 0;
            } else if (self2.symmetrical) {
              return self2.oldYScaler(0);
            } else {
              return self2.height;
            }
          }).y1(function(d) {
            return self2.oldYScaler(d.value);
          }).defined(function(d) {
            return d.value !== null && isFinite(d.value);
          });
          let areas = self2.graphContent.selectAll(".area-compare").data(oldNewData);
          areas.transition().duration(0).attr("d", valueArea);
          let lines2 = self2.graphContent.selectAll(".line-compare").data(oldNewData);
          lines2.transition().duration(0).attr("d", line2);
        }
        if (noAnimateLines && !self2.zoom) {
          animateDuration = 0;
        }
        let lines = self2.graphContentCompare.selectAll(".line-compare").data(self2.compareDatas.map((d) => d.data));
        let line = d3.line().curve(self2.curve).x(function(d) {
          return self2.xScalerCompare(d.date);
        }).defined(function(d) {
          return d.value !== null && isFinite(d.value);
        }).y(function(d) {
          return self2.yScaler(d.value);
        });
        lines.exit().remove();
        lines.enter().append("path").style("fill", "none").style("stroke", function(d, i) {
          return self2.compareDatas[i].color;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "2px" : self2.compareDatas[i].highlighted ? "2px" : "1px";
        }).attr("class", function(d, i) {
          if (!self2.compareDatas[i].hidden) {
            return "line-compare";
          } else {
            return "line-compare hidden";
          }
        }).attr("d", line);
        lines.transition().duration(animateDuration).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "2px" : self2.compareDatas[i].highlighted ? "2px" : "1px";
        }).style("stroke-opacity", function(d, i) {
          if (!self2.compareDatas[i].hidden) {
            if (self2.compareDatas[i].highlighted) return 1;
            else if (anyHighlighted) return 0.08;
            else return 1;
          } else {
            return 0;
          }
        }).attr("d", line).attr("class", function(d, i) {
          if (!self2.compareDatas[i].hidden) {
            return "line-compare";
          } else {
            return "line-compare hidden";
          }
        });
      }
      createValueLineTemperature(noAnimateLines) {
        let animationDuration = ANIMATION_TIME;
        let self2 = this;
        let lines = self2.graphContent.selectAll(".line-temperature").data([self2.temperatureData]);
        lines.exit().remove();
        lines.transition().duration(animationDuration).attr("class", function(d, i) {
          return "line-temperature";
        }).attr(
          "d",
          d3.line().curve(d3.curveLinear).x(function(d) {
            return self2.xScaler(new Date(d.time * 1e3));
          }).defined(function(d) {
            return isFinite(d.value) && d.value !== null;
          }).y(function(d) {
            return self2.yScalerTemperature(d.value);
          })
        );
        lines.enter().append("path").style("fill", "none").style("stroke-dasharray", "3, 3").style("stroke", function(d, i) {
          return "#49b9c4";
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return "2px";
        }).attr("class", function(d, i) {
          return "line-temperature";
        }).attr(
          "d",
          d3.line().curve(d3.curveLinear).x(function(d) {
            return self2.xScaler(new Date(d.time * 1e3));
          }).defined(function(d) {
            return isFinite(d.value) && d.value !== null;
          }).y(function(d) {
            return self2.yScalerTemperature(d.value);
          })
        );
      }
      createValueLineOverlay(noAnimateLines) {
        let animationDuration = ANIMATION_TIME;
        let self2 = this;
        let lines = self2.graphContent.selectAll(".line-temperature").data([self2.customOverlayData]);
        lines.exit().remove();
        let color2 = "#49b9c4";
        let category = StateOptions.DataCategories.find((c6) => c6.name === this.overlayDataType.category);
        if (category && category.color) {
          color2 = category.color;
        }
        lines.transition().duration(animationDuration).attr("class", function(d, i) {
          return "line-temperature";
        }).attr(
          "d",
          d3.line().curve(self2.overlayCurve).x(function(d) {
            return self2.xScaler(new Date(d.time * 1e3));
          }).defined(function(d) {
            return isFinite(d.value) && d.value !== null;
          }).y(function(d) {
            return self2.yScalerCustomOverlay(d.value);
          })
        );
        lines.enter().append("path").style("fill", "none").style("stroke-dasharray", "3, 3").style("stroke", function(d, i) {
          return color2;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return "2px";
        }).attr("class", function(d, i) {
          return "line-temperature";
        }).attr(
          "d",
          d3.line().curve(self2.overlayCurve).x(function(d) {
            return self2.xScaler(new Date(d.time * 1e3));
          }).defined(function(d) {
            return isFinite(d.value) && d.value !== null;
          }).y(function(d) {
            return self2.yScalerCustomOverlay(d.value);
          })
        );
      }
      createOccupancyBoxes(noAnimateLines) {
        let self2 = this;
        let days = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday"
        ];
        let start2 = self2.zoom ? self2.zoom.start.getTime() / 1e3 : self2.start;
        let end = self2.zoom ? self2.zoom.end.getTime() / 1e3 : self2.end;
        let startMoment = moment(start2 * 1e3).tz(self2.timezone).startOf("day");
        let occupancyPeriods = [];
        let lastOccupancy = self2.xScaler(startMoment.unix() * 1e3);
        while (startMoment.unix() < end) {
          let day = days[startMoment.weekday()];
          let validOccupancies = self2.occupancyHours.filter((oH) => oH[day] === true);
          validOccupancies.forEach(function(occupancy) {
            let occupancyStartMoment = moment(startMoment.unix() * 1e3);
            occupancyStartMoment.add(occupancy.startHour, "hours");
            occupancyStartMoment.add(occupancy.startMinute, "minutes");
            let startX = self2.xScaler(occupancyStartMoment.unix() * 1e3);
            occupancyPeriods.push({
              startX: lastOccupancy,
              endX: startX
            });
            let occupancyEndMoment = moment(startMoment.unix() * 1e3);
            occupancyEndMoment.add(occupancy.endHour, "hours");
            occupancyEndMoment.add(occupancy.endMinute, "minutes");
            lastOccupancy = self2.xScaler(occupancyEndMoment.unix() * 1e3);
          });
          startMoment.add(1, "day");
        }
        occupancyPeriods.push({
          startX: lastOccupancy,
          endX: Math.max(self2.xScaler(end * 1e3), lastOccupancy)
        });
        let occupancyRects = self2.graphContent.selectAll(".occupancy-hours").data(occupancyPeriods);
        occupancyRects.exit().remove();
        occupancyRects.enter().append("rect").style("fill", "#181D1E").style("opacity", "0.1").attr("class", function(d, i) {
          return "occupancy-hours";
        }).attr(
          "x",
          function(d) {
            return d.startX;
          }
        ).attr(
          "width",
          function(d) {
            return d.endX - d.startX;
          }
        ).attr("y", function() {
          return 0;
        }).attr("height", function() {
          return self2.height;
        });
        occupancyRects.transition().duration(ANIMATION_TIME).attr(
          "x",
          function(d) {
            return d.startX;
          }
        ).attr(
          "width",
          function(d) {
            return d.endX - d.startX;
          }
        );
      }
      createValueLine(noAnimateLines) {
        let animationDuration = ANIMATION_TIME;
        let self2 = this;
        let lines = self2.graphContent.selectAll(".line").data(self2.datas.map((d) => d.data));
        lines.exit().remove();
        lines.transition().duration(animationDuration).style("stroke-width", function(d, i) {
          return self2.widget ? "2px" : self2.datas[i].highlighted ? "2px" : "1px";
        }).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        }).attr(
          "d",
          d3.line().curve(self2.curve).x(function(d) {
            return self2.xScaler(d.date);
          }).defined(function(d) {
            return d.value !== null && isFinite(d.value);
          }).y(function(d) {
            return self2.yScaler2(d.value2);
          })
        );
        lines.enter().append("path").style("fill", "none").style("stroke", function(d, i) {
          return self2.datas[i].color;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return self2.widget ? "2px" : self2.datas[i].highlighted ? "2px" : "1px";
        }).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        }).attr(
          "d",
          d3.line().curve(self2.curve).x(function(d) {
            return self2.xScaler(d.date);
          }).defined(function(d) {
            return d.value !== null && isFinite(d.value);
          }).y(function(d) {
            return self2.yScaler2(d.value2);
          })
        );
      }
      throttledRender(ignoreLegend, noAnimateLines, noAdjustScales) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (self2.throttled || (self2.throttled[0] !== ignoreLegend || self2.throttled[1] !== noAnimateLines || self2.throttled[2] !== noAdjustScales)) {
            self2.throttled = [ignoreLegend, noAnimateLines, noAdjustScales];
            setTimeout(function() {
              self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
        }
      }
      createLegends() {
        let self2 = this;
        let legendElement = d3Select.select(self2.legendElement);
        if (self2.legendDiv) {
          self2.legendDiv.remove();
        }
        self2.legendDiv = legendElement.append("div").attr("class", "gd-graph-legend");
        let width = legendElement.node().offsetWidth;
        const WIDTH_PER_LEGEND = 150;
        let itemsAllowed = Math.floor(width / WIDTH_PER_LEGEND);
        let showShowMore = false;
        if (itemsAllowed < self2.datas.length) {
          itemsAllowed--;
          showShowMore = self2.datas.length - itemsAllowed;
        }
        let expandedLegendElement;
        if (showShowMore && self2.legendDiv) {
          expandedLegendElement = self2.legendDiv.append("div").attr("class", "expanded-legend").style("height", showShowMore * 30 + "px").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          }).on("mouseout", function() {
            expandedLegendElement.attr("class", "expanded-legend");
          });
        }
        self2.datas.forEach(function(assetDatum, index3) {
          let divToAttach = self2.legendDiv;
          if (index3 >= itemsAllowed) {
            divToAttach = expandedLegendElement;
          }
          if (self2.dataTypes && self2.dataTypes.length > 1) {
            let thisLegendElement1 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement1.attr("class", "legend-element hidden");
              } else {
                thisLegendElement1.attr("class", "legend-element");
              }
            });
            thisLegendElement1.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement1.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[0].charAt(0).toUpperCase() + self2.dataTypes[0].slice(1));
            let thisLegendElement2 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted2 = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted2 = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden2 = assetDatum.hidden2 ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden2) {
                thisLegendElement2.attr("class", "legend-element hidden");
              } else {
                thisLegendElement2.attr("class", "legend-element");
              }
            });
            thisLegendElement2.append("div").attr("class", "legend-box").style("background-color", assetDatum.color2);
            thisLegendElement2.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[1].charAt(0).toUpperCase() + self2.dataTypes[1].slice(1));
          } else {
            let thisLegendElement = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement.attr("class", "legend-element hidden");
              } else {
                thisLegendElement.attr("class", "legend-element");
              }
            });
            thisLegendElement.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement.append("div").attr("class", "legend-label").html(assetDatum.name);
          }
        });
        if (showShowMore && self2.legendDiv) {
          let showMoreElement = self2.legendDiv.append("div").attr("class", "show-more").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          });
          showMoreElement.append("div").attr("class", "show-more-button").html("+");
          showMoreElement.append("div").attr("class", "show-more-text").html(showShowMore + " more");
        }
      }
      resetZoom() {
        let self2 = this;
        if (!self2.zoom) {
          return;
        }
        if (this.brusherLocked) {
          return;
        }
        self2.zoom = null;
        if (self2.overlays && self2.overlays.find((o) => o.dataType === "EXTERNAL_TEMPERATURE") !== -1) {
          if (!self2.prevZOomTemperatureData) {
            self2.init();
          } else {
            self2.temperatureData = self2.prevZOomTemperatureData;
          }
          if (!self2.prevZoomCustomOverlayData) {
            self2.init();
          } else {
            self2.customOverlayData = self2.prevZoomCustomOverlayData;
          }
        }
        let noAnimate = false;
        if (self2.datas[0].data.length < self2.preZoomDatas[0].data.length) {
          noAnimate = true;
        }
        self2.datas = self2.preZoomDatas;
        self2.compareDatas = self2.preZoomCompareDatas;
        self2.throttledRender(false, noAnimate, false);
        if (self2.zoomCallback) {
          self2.zoomCallback(self2.zoom);
        }
        let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null && a4.value !== void 0 || a4.value2 !== null && a4.value2 !== void 0).length > 0);
        if (this.onVisibleItems) {
          if (this.temperatureData) {
            visibleItems.unshift({
              name: "External Temperature",
              color: "#49b9c4",
              id: "EXTERNAL_TEMP",
              hidden: false
            });
          }
          if (this.temperatureData) {
            visibleItems.unshift({
              name: `${this.customOverlayDeviceName}`,
              color: "#49b9c4",
              id: "CUSTOM_OVERLAY",
              hidden: false
            });
          }
          visibleItems.sort(function(a4, b) {
            const aVal = a4.data && a4.data.find((d) => d.value !== null && d.value !== void 0);
            const bVal = b.data && b.data.find((d) => d.value !== null && d.value !== void 0);
            return (bVal ? bVal.value : -Infinity) - (aVal ? aVal.value : -Infinity);
          });
          this.onVisibleItems(visibleItems);
        }
        self2.generateKPIs();
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let undoZoom = false;
        let reRender = false;
        let redoKPI = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
          undoZoom = true;
        }
        if (params.granularity !== void 0) {
          self2.granularity = params.granularity;
          reInit = true;
          undoZoom = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
          undoZoom = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          undoZoom = true;
          reInit = true;
        }
        if (params.compareTo !== void 0) {
          self2.compareTo = params.compareTo;
          self2.compareDatas = null;
          undoZoom = true;
          self2.comparedResults = null;
          reInit = true;
        } else {
          self2.compareTo = null;
          self2.compareDatas = null;
          self2.comparedResults = null;
        }
        if (params.overlays !== void 0) {
          self2.overlays = params.overlays;
          self2.temperatureData = void 0;
          this.customOverlayData = void 0;
          self2.occupancyHours = void 0;
          self2.yScalerTemperature = void 0;
          reInit = true;
        }
        if (params.hidden !== void 0 && params.hidden !== null) {
          self2.hidden = params.hidden;
          self2.datas.forEach(function(datum2) {
            if (params.hidden.indexOf(datum2.id) !== -1) {
              datum2.hidden = true;
            } else {
              datum2.hidden = false;
            }
          });
          if (self2.compareDatas) {
            self2.compareDatas.forEach(function(datum2) {
              if (params.hidden.indexOf(datum2.id) !== -1) {
                datum2.hidden = true;
              } else {
                datum2.hidden = false;
              }
            });
          }
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted !== void 0) {
          self2.highlighted = params.highlighted;
          self2.datas.forEach(function(datum2) {
            if (params.highlighted.indexOf(datum2.id) !== -1) {
              datum2.highlighted = true;
            } else {
              datum2.highlighted = false;
            }
          });
          if (self2.compareDatas) {
            self2.compareDatas.forEach(function(datum2) {
              if (params.highlighted.indexOf(datum2.id) !== -1) {
                datum2.highlighted = true;
              } else {
                datum2.highlighted = false;
              }
            });
          }
          reRender = true;
        }
        if (undoZoom) {
          self2.zoom = null;
        }
        if (reInit) {
          self2.init();
        } else if (reRender) {
          self2.throttledRender(false, false, false);
          if (redoKPI) {
            self2.generateKPIs();
          }
        }
      }
    };
    module2.exports = LineGraph2;
  }
});

// temp_stylePlugin:src/graphs/barChart.scss
var init_barChart = __esm({
  "temp_stylePlugin:src/graphs/barChart.scss"() {
  }
});

// stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/barChart.scss
var barChart_exports = {};
var init_barChart2 = __esm({
  "stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/barChart.scss"() {
    init_barChart();
  }
});

// src/util/barTooltip.js
var require_barTooltip = __commonJS({
  "src/util/barTooltip.js"(exports2, module2) {
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var getFormatDate = require_util().getFormatDateFull;
    var bisect = d3.bisector(function(d) {
      return d.date;
    }).left;
    d3.selection.prototype.moveToFront = function() {
      return this.each(function() {
        this.parentNode.appendChild(this);
      });
    };
    var lockedImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtNDc5LjYgMzE2Ljh2LTE0LjgwMWMwLTM3LjAxMi0xOS43NDYtNzEuMjExLTUxLjc5Ny04OS43MTUtMzIuMDU1LTE4LjUwOC03MS41NDMtMTguNTA4LTEwMy42IDAtMzIuMDUxIDE4LjUwNC01MS43OTcgNTIuNzAzLTUxLjc5NyA4OS43MTV2MTQuODAxYy0xMS43NzcgMC0yMy4wNyA0LjY3NTgtMzEuMzk1IDEzLjAwNC04LjMyODEgOC4zMjQyLTEzLjAwNCAxOS42MTctMTMuMDA0IDMxLjM5NXYxNDcuOTljMCAxMS43NzcgNC42NzU4IDIzLjA3IDEzLjAwNCAzMS4zOTUgOC4zMjQyIDguMzI4MSAxOS42MTcgMTMuMDA0IDMxLjM5NSAxMy4wMDRoMjA3LjE5YzExLjc3MyAwIDIzLjA2Ni00LjY3NTggMzEuMzk1LTEzLjAwNCA4LjMyNDItOC4zMjQyIDEzLjAwNC0xOS42MTcgMTMuMDA0LTMxLjM5NXYtMTQ3Ljk5YzAtMTEuNzc3LTQuNjc5Ny0yMy4wNy0xMy4wMDQtMzEuMzk1LTguMzI4MS04LjMyODEtMTkuNjIxLTEzLjAwNC0zMS4zOTUtMTMuMDA0em0tODguNzk3IDExNC4yNXY0OC41NDNjMCA1LjI4NTItMi44MjAzIDEwLjE3Mi03LjM5ODQgMTIuODE2LTQuNTgyIDIuNjQ0NS0xMC4yMjMgMi42NDQ1LTE0LjgwMSAwLTQuNTc4MS0yLjY0NDUtNy4zOTg0LTcuNTMxMi03LjM5ODQtMTIuODE2di00OC41NDNjLTcuNTc4MS00LjM3NS0xMi44MzItMTEuODc1LTE0LjM1Mi0yMC40OTItMS41MTk1LTguNjE3MiAwLjg1MTU2LTE3LjQ2NSA2LjQ3NjYtMjQuMTY4IDUuNjI1LTYuNjk5MiAxMy45MjYtMTAuNTcgMjIuNjcyLTEwLjU3IDguNzUgMCAxNy4wNTEgMy44NzExIDIyLjY3NiAxMC41NyA1LjYyNSA2LjcwMzEgNy45OTIyIDE1LjU1MSA2LjQ3NjYgMjQuMTY4LTEuNTE5NSA4LjYxNzItNi43NzM0IDE2LjExNy0xNC4zNTIgMjAuNDkyem01OS4xOTktMTE0LjI1aC0xNDh2LTE0LjgwMWMwLTI2LjQzOCAxNC4xMDUtNTAuODYzIDM3LTY0LjA4MiAyMi44OTUtMTMuMjE5IDUxLjEwMi0xMy4yMTkgNzMuOTk2IDBzMzcgMzcuNjQ1IDM3IDY0LjA4MnoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==";
    var lockBgStyle = "url('" + lockedImage + "')";
    var unlockedImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtNDc5LjYgMzE2Ljh2LTE0LjgwMWMtMC4wMTE3MTgtMzIuODQ4LTE1LjU5OC02My43NDItNDIuMDEyLTgzLjI3LTI2LjQxNC0xOS41MjMtNjAuNTItMjUuMzY3LTkxLjkyNi0xNS43NDYtMzEuNDA2IDkuNjIxMS01Ni4zOTEgMzMuNTYyLTY3LjMzNiA2NC41MzUtMS43Njk1IDQuOTk2MS0wLjc0MjE5IDEwLjU1OSAyLjY5OTIgMTQuNTkgMy40NDE0IDQuMDMxMiA4Ljc3MzQgNS45MjE5IDEzLjk4OCA0Ljk1NyA1LjIxMDktMC45NjQ4NCA5LjUxMTctNC42MzY3IDExLjI4NS05LjYzMjggNy44NTU1LTIyLjA1NSAyNS42ODgtMzkuMDkgNDguMDc0LTQ1LjkzNCAyMi4zOTEtNi44NDM4IDQ2LjY5NS0yLjY4NzUgNjUuNTM5IDExLjIwNyAxOC44NDggMTMuODkxIDMwLjAwNCAzNS44ODMgMzAuMDkgNTkuMjkzdjE0LjgwMWgtMTc3LjU5Yy0xMS43NzcgMC0yMy4wNyA0LjY3NTgtMzEuMzk1IDEzLjAwNC04LjMyODEgOC4zMjQyLTEzLjAwNCAxOS42MTctMTMuMDA0IDMxLjM5NXYxNDcuOTljMCAxMS43NzcgNC42NzU4IDIzLjA3IDEzLjAwNCAzMS4zOTUgOC4zMjQyIDguMzI4MSAxOS42MTcgMTMuMDA0IDMxLjM5NSAxMy4wMDRoMjA3LjE5YzExLjc3MyAwIDIzLjA2Ni00LjY3NTggMzEuMzk1LTEzLjAwNCA4LjMyNDItOC4zMjQyIDEzLjAwNC0xOS42MTcgMTMuMDA0LTMxLjM5NXYtMTQ3Ljk5YzAtMTEuNzc3LTQuNjc5Ny0yMy4wNy0xMy4wMDQtMzEuMzk1LTguMzI4MS04LjMyODEtMTkuNjIxLTEzLjAwNC0zMS4zOTUtMTMuMDA0em0tODguNzk3IDExNC4yNXY0OC41NDNjMCA1LjI4NTItMi44MjAzIDEwLjE3Mi03LjM5ODQgMTIuODE2LTQuNTgyIDIuNjQ0NS0xMC4yMjMgMi42NDQ1LTE0LjgwMSAwLTQuNTc4MS0yLjY0NDUtNy4zOTg0LTcuNTMxMi03LjM5ODQtMTIuODE2di00OC41NDNjLTcuNTc4MS00LjM3NS0xMi44MzItMTEuODc1LTE0LjM1Mi0yMC40OTItMS41MTk1LTguNjE3MiAwLjg1MTU2LTE3LjQ2NSA2LjQ3NjYtMjQuMTY4IDUuNjI1LTYuNjk5MiAxMy45MjYtMTAuNTcgMjIuNjcyLTEwLjU3IDguNzUgMCAxNy4wNTEgMy44NzExIDIyLjY3NiAxMC41NyA1LjYyNSA2LjcwMzEgNy45OTIyIDE1LjU1MSA2LjQ3NjYgMjQuMTY4LTEuNTE5NSA4LjYxNzItNi43NzM0IDE2LjExNy0xNC4zNTIgMjAuNDkyeiIvPgo8L3N2Zz4K";
    var unlockBgStyle = "url('" + unlockedImage + "')";
    var TOOLTIP_LEFT_MARGIN = 100;
    var LineTooltip = class {
      constructor(params) {
        if (!params.svg) {
          throw Error("No svg given to tooltip");
        }
        if (!params.data) {
          throw Error("No data given to tooltip");
        }
        if (!params.width) {
          throw Error("No width given to tooltip");
        }
        if (!params.height) {
          throw Error("No height given to tooltip");
        }
        if (!params.xScaler) {
          throw Error("No X Scaler given to tooltip");
        }
        if (!params.yScaler) {
          throw Error("No Y Scaler given to tooltip");
        }
        if (!params.start) {
          throw Error("Start not given");
        }
        if (!params.end) {
          throw Error("End not given");
        }
        this.averageType = params.averageType;
        this.widget = params.widget;
        this.override = params.override;
        this.timezone = params.timezone;
        this.isMobile = params.isMobile;
        this.element = params.element;
        this.aggregateBy = params.aggregateBy;
        this.svg = params.svg;
        this.granularity = params.granularity;
        this.data = params.data;
        this.allData = params.allData;
        this.width = params.width;
        this.height = params.height;
        this.xScaler = params.xScaler;
        this.yScaler = params.yScaler;
        this.compareDatas = params.compareDatas;
        this.xScalerCompare = params.xScalerCompare;
        this.start = params.start;
        this.end = params.end;
        this.override = params.override;
        this.format = params.format;
        this.createElements();
      }
      createElements() {
        let self2 = this;
        if (!this.widget) {
          this.lockPrompt = this.element.append("div").attr("class", "linegraph-prompt").style("position", "absolute").style("background-image", unlockBgStyle).style("display", "none").style("z-index", 1e3).style("background-color", "white").style("background-size", "contain").style("text-align", "center").style("border-radius", "20px").style("margin-left", "57px").style("height", "25px").style("width", "25px").style("border", "1px solid #000000").style("cursor", "pointer").style("user-select", "none").style("opacity", 1);
        }
        self2.lastMove = 0;
        this.verticalLine = this.svg.append("line").attr("class", "tooltip-line").attr("x1", 0).attr("y1", 0).attr("x2", 0).attr("y2", this.height).style("opacity", 0).style("stroke-width", 1).style("stroke", "black").style("fill", "none");
        if (!this.override) {
          this.tooltip = d3.select("body").append("div").style("position", "absolute").attr("class", "bargraph-tooltip Card").style("pointer-events", "none");
          this.tooltipDate = this.tooltip.append("div").attr("class", "CardHeader");
          this.tooltipValue = self2.tooltip.append("div").attr("class", "CardBody");
        }
        function pad3(n, width, z) {
          z = z || "0";
          n = n + "";
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        function scaleBandInvert(scale2) {
          let domain = scale2.domain();
          let paddingOuter = scale2(domain[0]);
          let eachBand = scale2.step();
          return function(value) {
            let index3 = Math.floor((value - paddingOuter) / eachBand);
            return domain[Math.max(0, Math.min(index3, domain.length - 1))];
          };
        }
        function mousemove(event, d) {
          if (self2.locked) {
            return;
          }
          let ts = (/* @__PURE__ */ new Date()).getTime();
          if (!self2.blocked && ts - self2.lastMove > 30) {
            self2.blocked = true;
            let highlightedDate = scaleBandInvert(self2.xScaler)(d3.pointer(event, this)[0]);
            let selectedIndex = self2.data[0].data.indexOf(self2.data[0].data.find((d2) => d2 && d2.date === highlightedDate));
            let overHalf = selectedIndex > self2.data[0].data.length / 2;
            let selectedDatum = self2.data.map((datum2) => datum2.data[selectedIndex]);
            if (!selectedDatum[0]) {
              return;
            }
            let selectedDatumX = self2.xScaler(selectedDatum[0].date);
            self2.verticalLine.attr("x1", selectedDatumX + self2.xScaler.bandwidth() / 2);
            self2.verticalLine.attr("x2", selectedDatumX + self2.xScaler.bandwidth() / 2);
            if (self2.lockPrompt) {
              self2.lockPrompt.style("left", selectedDatumX + self2.xScaler.bandwidth() / 2 + "px").style("top", "10px");
            }
            if (self2.override) {
              let overrideData = [];
              selectedDatum.forEach(function(datum2, index3) {
                if (!self2.data[index3].hidden) {
                  if (datum2 && datum2.value !== null) {
                    let value = self2.format(datum2.value, true);
                    let compareValue2;
                    if (self2.compareDatas) {
                      let cVal = self2.compareDatas[index3].data[selectedIndex].value;
                      compareValue2 = self2.format(cVal, true);
                    }
                    overrideData.push(
                      {
                        name: self2.data[index3].name,
                        value,
                        compareValue: compareValue2,
                        rawVal: datum2.value,
                        disconnected: datum2.disconnected
                      }
                    );
                  }
                }
              });
              self2.blocked = false;
              self2.lastMove = (/* @__PURE__ */ new Date()).getTime();
              let dateStr = getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(selectedDatum[0].date);
              if (self2.aggregateBy === "hourOfDay") {
                let val = selectedDatum[0].date;
                dateStr = pad3(val, 2) + ":00";
              }
              if (self2.aggregateBy === "dayOfWeek") {
                let val = selectedDatum[0].date;
                let weekday = new Array(7);
                weekday[0] = "Sunday";
                weekday[1] = "Monday";
                weekday[2] = "Tuesday";
                weekday[3] = "Wednesday";
                weekday[4] = "Thursday";
                weekday[5] = "Friday";
                weekday[6] = "Saturday";
                dateStr = weekday[val];
              }
              let overrideCallData = {
                date: dateStr,
                data: overrideData,
                locked: self2.locked
              };
              if (self2.compareDatas && !self2.aggregateBy) {
                overrideCallData.compareDate = getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(self2.compareDatas[0].data[selectedIndex].date);
              }
              self2.tooltipData = overrideCallData;
              return self2.override(overrideCallData);
            }
            self2.tooltipDate.html(getFormatDate(self2.start, self2.end, self2.timezone, self2.granularity)(selectedDatum[0].date));
            let newHtmlValue = "";
            selectedDatum.forEach(function(datum2, index3) {
              if (!self2.data[index3].hidden) {
                if (datum2 && datum2.value !== null) {
                  newHtmlValue += '<div class="tooltip-row"><div class="tooltip-box" style="background-color: ' + self2.data[index3].color + '"></div><div class="tooltip-label">' + self2.data[index3].name + '</div><div class="tooltip-value">' + self2.format(datum2.value, true) + "</div></div>";
                }
              }
            });
            self2.tooltipValue.html(newHtmlValue);
            let leftPos;
            if (overHalf) {
              leftPos = selectedDatumX + self2.xScaler.bandwidth() / 2 + TOOLTIP_LEFT_MARGIN;
            } else {
              leftPos = selectedDatumX + self2.xScaler.bandwidth() / 2 + 2 * TOOLTIP_LEFT_MARGIN + self2.tooltip.node().getBoundingClientRect().width;
            }
            let rect = self2.element.node().getBoundingClientRect();
            let tooltip2 = self2.tooltip.node().getBoundingClientRect();
            let topPos = event.pageY - 28;
            if (topPos - rect.y + tooltip2.height >= rect.height) {
              topPos = rect.y + rect.height - tooltip2.height;
            }
            if (self2.isMobile) {
              topPos = rect.y + rect.height / 2 - tooltip2.height / 2;
              leftPos = rect.x + rect.width / 2;
            }
            self2.tooltip.style("left", leftPos + "px").style("top", topPos + "px");
            self2.lastMove = (/* @__PURE__ */ new Date()).getTime();
            self2.blocked = false;
          }
        }
        if (this.lockPrompt) {
          this.lockPrompt.on("click", function() {
            if (self2.locked) {
              self2.locked = false;
              self2.verticalLine.style("stroke", "black");
              self2.lockPrompt.style("background-color", "white").style("background-image", unlockBgStyle).style("color", "black").style("border", "1px solid black");
            } else {
              self2.locked = true;
              self2.verticalLine.style("stroke", "orange");
              self2.lockPrompt.style("background-color", "orange").style("background-image", lockBgStyle).style("color", "white").style("border", "1px solid orange");
            }
            if (self2.override && self2.tooltipData) {
              self2.tooltipData.locked = self2.locked;
              self2.override(self2.tooltipData);
            }
            if (self2.lockCallback) {
              self2.lockCallback(self2.locked);
            }
          }).on("mouseover.tooltip", function() {
            self2.lockPrompt.style("display", "block");
            self2.verticalLine.style("opacity", 1);
            if (self2.override) {
              self2.override(self2.tooltipData);
            }
          }).on("mouseout.tooltip", function() {
            if (!self2.locked) {
              if (self2.override) {
                self2.override(null);
              }
              self2.lockPrompt.style("display", "none");
              self2.verticalLine.style("opacity", 0);
            }
          });
        }
        this.mouseDetector = this.svg.append("rect").attr("class", "overlay").style("fill", "transparent").attr("width", this.width).attr("height", () => this.height > 0 ? this.height : 0).on("mouseover.barTooltip", function() {
          if (!self2.override) {
            self2.tooltip.style("opacity", 1);
          }
          if (self2.lockPrompt) {
            self2.lockPrompt.style("display", "block");
          }
          self2.verticalLine.style("opacity", 1);
        }).on("mouseout.barTooltip", function() {
          if (self2.locked) {
            return;
          }
          if (!self2.override) {
            self2.tooltip.style("opacity", 0);
          } else {
            self2.override(null);
          }
          if (self2.lockPrompt) {
            self2.lockPrompt.style("display", "none");
          }
          self2.verticalLine.style("opacity", 0);
          self2.data.forEach(function(datum2, index3) {
            self2.svg.selectAll(".bar-" + index3).attr("class", function(d, i) {
              return "bar bar-" + index3;
            });
          });
        }).on("mousemove.barTooltip", mousemove);
      }
      remove() {
        this.deleted = true;
        if (!this.override) {
          this.tooltipValue.remove();
          this.tooltipDate.remove();
          this.tooltip.remove();
        }
        this.mouseDetector.remove();
        if (this.lockPrompt) {
          this.lockPrompt.remove();
        }
        this.verticalLine.remove();
      }
    };
    module2.exports = LineTooltip;
  }
});

// src/graphs/barChart.js
var require_barChart = __commonJS({
  "src/graphs/barChart.js"(exports2, module2) {
    var BarTooltip;
    if (typeof window !== "undefined") {
      init_barChart2();
      BarTooltip = require_barTooltip();
    }
    var getFormatDate = require_util().getFormatDate;
    var getFormatDayOfMonth = require_util().getFormatDayOfMonth;
    var parseTime = require_util().parseTime;
    var readyPromise = require_util().readyPromise;
    var getFormat = require_util().getFormat;
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var StateOptions = require_StateOptions();
    var GridDuck2;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var moment = require_moment();
    var UPDATE_INTERVAL = 60 * 1e3;
    var TRANSITION_SPEED = 500;
    var MARGIN = { top: 20, right: 20, bottom: 50, left: 70 };
    var BarChart2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        let self2 = this;
        this.addedIndexes = {};
        this.aggregateBy = params.aggregateBy;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        if (params.margin) {
          MARGIN = params.margin;
        }
        if (params.compareTo && params.compareTo.start && params.compareTo.end) {
          this.compareTo = params.compareTo;
        }
        this.widget = params.widget;
        this.averageType = params.averageType;
        this.labelDataAxis = params.labelDataAxis;
        if (this.widget) {
          MARGIN.left = 20;
          MARGIN.bottom = 30;
        } else {
          MARGIN.left = 70;
          MARGIN.bottom = 50;
        }
        this.color = params.color;
        this.report = params.compareTo !== void 0;
        this.inlineStyle = params.inlineStyle;
        if (params.windowWidth) {
          this.windowWidth = params.windowWidth;
          this.windowHeight = params.windowHeight;
          this.width = params.windowWidth - MARGIN.left - MARGIN.right;
          this.height = params.windowHeight - MARGIN.top - MARGIN.bottom;
          this.fixedSize = true;
        }
        if (params.start === void 0 && params.startOf === void 0) {
          throw Error("No start defined");
        }
        this.combined = params.combined;
        this.isMobile = params.isMobile;
        if (!params.element) {
          throw Error("No element defined");
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.updateInterval) {
          self2.updateInterval = params.updateInterval;
        }
        if (params.currency) {
          this.currency = params.currency;
        }
        if (params.carbonIntensity) {
          this.carbonIntensity = params.carbonIntensity;
        }
        if (params.pricePerKwh) {
          this.pricePerKwh = params.pricePerKwh;
        }
        this.timezone = params.timezone || "Europe/London";
        if (params.showTooltip !== false) {
          this.showTooltip = true;
        }
        if (params.realTime) {
          this.realTime = true;
          this.end = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
          if (params.end) {
          }
        } else if (params.end === void 0) {
          throw Error("No end defined and not real time");
        }
        if (params.granularity === void 0) {
          throw Error("No granularity defined");
        }
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        this.granularity = params.granularity;
        this.tooltipOverride = params.tooltipOverride;
        if (!params.assets) {
          this.isSensors = false;
          this.assets = params.sensors;
          this.filterType = params.filterType;
          this.filterId = params.filterId;
          if (!params.dataTypes) {
            throw Error("No data types defined");
          }
          this.dataTypes = params.dataTypes;
        } else {
          if (params.dataTypes) {
            this.isSensors = false;
            this.dataTypes = params.dataTypes;
            this.formats = params.dataTypes.map((t) => getFormat(t ? t.toLowerCase() : ""));
          } else {
            this.formats = [getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "")];
          }
          this.assets = params.assets;
        }
        this.dataType = StateOptions.DataTypes.find((d) => d.type === this.dataTypes[0]);
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.onVisibleItems) {
          this.onVisibleItems = params.onVisibleItems;
        }
        if (params.onDefaultSelected) {
          this.onDefaultSelected = params.onDefaultSelected;
        }
        this.hidden = [];
        if (params.hidden) {
          this.hidden = params.hidden;
          params.hidden.forEach(function(hiddenId) {
            let hiddenAsset = self2.assets ? self2.assets.find((a4) => a4.id === hiddenId) : {};
            hiddenAsset.hidden = true;
          });
        }
        if (params.data) {
          this.paramsData = params.data;
        }
        if (params.compareData) {
          this.paramsCompareData = params.compareData;
        }
        this.start = params.start;
        this.end = params.end;
        this.startOf = params.startOf;
        this.element = params.element;
        this.transitionSpeed = this.widget ? 0 : TRANSITION_SPEED;
        this.isDeleted = false;
        this.error = function() {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error();
          }
        };
        readyPromise.then(function() {
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          if (!self2.document.getElementById(self2.element.substr(1))) {
            self2.deleted();
            console.error(new Error("Element not on DOM"));
            return;
          }
          self2.init();
        });
      }
      loadData() {
        let self2 = this;
        if (self2.paramsData) {
          self2.assetData = self2.assets;
          if (self2.paramsCompareData) {
            return Promise.resolve({
              results: self2.paramsData,
              cResults: self2.paramsCompareData
            });
          } else {
            return Promise.resolve({
              results: self2.paramsData
            });
          }
        }
        let dataType = self2.dataTypes[0];
        let promises = [];
        let filters = [
          {
            field: "dataType",
            value: dataType
          },
          {
            field: "start",
            value: self2.dataStart
          },
          {
            field: "end",
            value: self2.dataEnd
          },
          {
            field: "granularity",
            value: self2.granularity
          }
        ];
        if (self2.assets) {
          filters.push({
            field: "assetId",
            value: self2.assets.map((a4) => a4.id).join(",")
          });
        } else {
          filters.push({
            field: "assetId",
            value: "filtered"
          });
          filters.push({
            field: self2.filterType,
            value: self2.filterId
          });
        }
        promises.push(GridDuck2.getAssetConsumptionBatchs({
          filters
        }).then(function(res) {
          self2.assetData = res.list.map((d) => ({ name: d.assetName, parent: d.parent, id: d.assetId }));
          return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
        }).catch(self2.error));
        if (self2.compareTo) {
          let compareFilters = [
            {
              field: "dataType",
              value: dataType
            },
            {
              field: "start",
              value: self2.compareTo.start
            },
            {
              field: "end",
              value: self2.compareTo.end
            },
            {
              field: "granularity",
              value: self2.compareTo.granularity || self2.granularity
            }
          ];
          if (self2.assets) {
            compareFilters.push({
              field: "assetId",
              value: self2.assets.map((a4) => a4.id).join(",")
            });
          } else {
            compareFilters.push({
              field: "assetId",
              value: "filtered"
            });
            compareFilters.push({
              field: self2.filterType,
              value: self2.filterId
            });
          }
          promises.push(GridDuck2.getAssetConsumptionBatchs({
            filters: compareFilters
          }).then(function(res) {
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          }).catch(self2.error));
        }
        return Promise.all(promises).then(function(res) {
          if (res && res[0]) {
            return Promise.resolve({
              results: res[0] ? JSON.parse(JSON.stringify(res[0])) : res[0],
              cResults: res[1] ? JSON.parse(JSON.stringify(res[1])) : res[1]
            });
          } else {
            return Promise.reject("Error loading data");
          }
        });
      }
      processCategoricalData(data, isCompare = false) {
        let self2 = this;
        let categories = this.dataType.unitDetails.metaData.categories;
        let start2 = isCompare ? self2.compareTo.start : self2.start;
        let end = isCompare ? self2.compareTo.end : self2.end;
        if (data) {
          data.forEach(function(dataSet) {
            let replacementData = [];
            if (self2.averageType.substr(0, 5) === "count") {
              let recordsWanted = dataSet.list.filter((d) => d.value === parseInt(self2.averageType.substr(6)));
              for (let ts = start2; ts < end; ts += self2.granularity) {
                let startTs = ts;
                let endTs = ts + self2.granularity;
                let count3 = recordsWanted.filter((r) => r.time >= startTs && r.time < endTs).length;
                replacementData.push({
                  time: startTs,
                  value: count3,
                  consumption: count3
                });
              }
            } else if (self2.averageType.substr(0, 8) === "duration") {
              let categoryWanted = parseInt(self2.averageType.substr(9));
              for (let ts = start2; ts < end; ts += self2.granularity) {
                let duration = 0;
                let startTs = ts;
                let endTs = ts + self2.granularity;
                let priorRecord;
                let priorRecords = dataSet.list.filter((r) => r.time <= startTs).sort((a4, b) => b.time - a4.time);
                if (priorRecords.length > 0 && priorRecords[0].value === categoryWanted) {
                  priorRecord = priorRecords[0];
                }
                let postRecord;
                let postRecords = dataSet.list.filter((r) => r.time >= endTs).sort((a4, b) => a4.time - b.time);
                if (postRecords.length > 0 && postRecords[0].value !== categoryWanted) {
                  postRecord = postRecords[0];
                }
                let inWindowRecords = dataSet.list.filter((r) => r.time >= startTs && r.time < endTs);
                if (inWindowRecords.length === 0) {
                  if (postRecord && priorRecord) {
                    duration = endTs - startTs;
                  }
                } else {
                  if (inWindowRecords[0].value !== categoryWanted && priorRecord) {
                    duration += inWindowRecords[0].time - startTs;
                  }
                  if (inWindowRecords[inWindowRecords.length - 1].value === categoryWanted && postRecord) {
                    duration += endTs - inWindowRecords[inWindowRecords.length - 1].time;
                  }
                  for (let i = 0; i < inWindowRecords.length - 1; i++) {
                    let record = inWindowRecords[i];
                    if (record.value === categoryWanted) {
                      duration += inWindowRecords[i + 1].time - record.time;
                    }
                  }
                }
                replacementData.push({
                  time: startTs,
                  value: duration * 1e3,
                  consumption: duration * 1e3
                });
              }
            } else {
              console.error(`Average type ${self2.averageType} not supported`);
            }
            dataSet.list = replacementData;
          });
        }
        return data;
      }
      init() {
        if (this.isDeleted) {
          return;
        }
        let uuid = uuidv4();
        this.uuid = uuid;
        let standardData;
        let self2 = this;
        if (!self2.d3Element) {
          return;
        }
        self2.d3Element.selectAll(".bars").remove();
        self2.d3Element.selectAll(".compare-bars").remove();
        self2.d3Element.selectAll(".bar").remove();
        self2.d3Element.selectAll(".layer").remove();
        self2.d3Element.selectAll(".bar-overlay").remove();
        self2.addedIndexes = {};
        self2.dataStart = self2.start ? self2.start : moment().startOf(self2.startOf).unix();
        self2.dataEnd = self2.realTime ? Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) : self2.end;
        if (self2.assets && self2.assets.length === 1) {
          self2.hidden = [];
          self2.assets[0].hidden = false;
        }
        let promise;
        if (uuid !== self2.uuid) {
          return;
        }
        this.loadData().then(function(res) {
          if (!res) {
            return;
          }
          standardData = res.results;
          let comparedResults = res.cResults;
          if (self2.dataType && self2.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
            standardData = self2.processCategoricalData(standardData);
            if (comparedResults) {
              comparedResults = self2.processCategoricalData(comparedResults, true);
            }
          }
          let colors = [
            "#003f5c",
            "#2f4b7c",
            "#665191",
            "#a05195",
            "#d45087",
            "#f95d6a",
            "#ff7c43",
            "#ffa600"
          ];
          if (uuid === self2.uuid) {
            if (comparedResults) {
              self2.comparedResults = comparedResults;
              self2.compareDatas = comparedResults.map(function(result, index3) {
                return {
                  id: self2.assetData[index3].id,
                  name: self2.assetData[index3].name,
                  parent: self2.assetData[index3].parent,
                  data: result.list.map((r) => ({
                    disconnected: r.disconnected,
                    date: parseTime(r.time),
                    value: r.consumption
                  })),
                  color: self2.color ? self2.color : self2.assetData[index3].color ? self2.assetData[index3].color : self2.report ? "#53bbb7" : colors[index3 % colors.length],
                  highlighted: self2.highlighted ? self2.highlighted.indexOf(self2.assetData[index3].id) !== -1 : false,
                  hidden: self2.hidden ? self2.hidden.indexOf(self2.assetData[index3].id) !== -1 : false
                };
              });
              self2.compareDatas = self2.compareDatas.sort((a4, b) => Math.max(...b.data.map((a5) => a5.value)) - Math.max(...a4.data.map((a5) => a5.value)));
              if (self2.combined) {
                let topLevelAssets = self2.compareDatas.filter(function(asset) {
                  if (!asset.parent) {
                    return true;
                  }
                  if (!self2.compareDatas.find((a4) => a4.id === asset.parent)) {
                    return true;
                  }
                });
                if (topLevelAssets.length === 0) {
                  self2.compareDatas = [];
                } else {
                  self2.compareDatas = [
                    {
                      id: 0,
                      name: "Total",
                      parent: null,
                      hidden: false,
                      data: topLevelAssets[0].data.map(function(datum2, i) {
                        let total = 0;
                        topLevelAssets.forEach(function(asset) {
                          let matchedRecord = asset.data[i];
                          if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString()) {
                            total += matchedRecord.value;
                          }
                        });
                        return {
                          value: total,
                          disconnected: datum2.disconnected,
                          date: datum2.date
                        };
                      }),
                      color: self2.widget ? self2.assetData[0].color : self2.color ? self2.color : "#53bbb7"
                    }
                  ];
                }
              }
              if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                self2.compareDatas.forEach(function(assetData) {
                  let newDataArray = [];
                  assetData.data.forEach(function(datum2) {
                    let fixedDate;
                    if (self2.aggregateBy === "hourOfDay") {
                      fixedDate = moment(datum2.date).tz(self2.timezone).hour();
                    } else {
                      fixedDate = moment(datum2.date).tz(self2.timezone).day();
                    }
                    let existingRecord = newDataArray.find((d) => d.date === fixedDate);
                    if (existingRecord) {
                      existingRecord.value += datum2.value;
                      existingRecord.total += 1;
                    } else {
                      newDataArray.push({
                        date: fixedDate,
                        total: 1,
                        value: datum2.value
                      });
                    }
                  });
                  newDataArray.forEach(function(datum2) {
                    datum2.value = datum2.value / datum2.total;
                  });
                  if (self2.aggregateBy === "dayOfWeek") {
                    newDataArray.sort(function(date1, date2) {
                      if (date1.date === 0) {
                        return 1e3 - date2.date;
                      } else if (date2.date === 0) {
                        return date1.date - 1e3;
                      } else {
                        return date1.date - date2.date;
                      }
                    });
                  }
                  if (self2.aggregateBy === "hourOfDay") {
                    newDataArray.sort((d1, d2) => d1.date - d2.date);
                  }
                  assetData.data = newDataArray;
                });
              }
            }
            self2.processData(standardData);
            if (self2.onReady && !self2.isDeleted) {
              self2.onReady();
            }
            return Promise.resolve();
          }
        });
      }
      unHideChildrenOfNullAssets(assets, allAssets) {
        let self2 = this;
        let shownNullAssets = assets.filter((a4) => this.hidden.indexOf(a4.id) === -1 && !a4.data.some((d) => d.value !== null));
        shownNullAssets.forEach(function(shownNullAsset) {
          self2.hidden.push(shownNullAsset.id);
          shownNullAsset.hidden = true;
          let children2 = allAssets.filter((a4) => a4.parent === shownNullAsset.id);
          children2.forEach(function(child) {
            if (self2.hidden.indexOf(child.id) !== -1) {
              self2.hidden.splice(self2.hidden.indexOf(child.id), 1);
              child.hidden = false;
            }
          });
          if (children2.length > 0) {
            self2.unHideChildrenOfNullAssets(children2, allAssets);
          }
        });
        allAssets.filter((a4) => !a4.data.some((d) => d.value !== null)).forEach(function(assetWithNoData) {
          self2.hidden.push(assetWithNoData.id);
          assetWithNoData.hidden = true;
        });
      }
      processData(results) {
        let self2 = this;
        if (!results) {
          return;
        }
        if (!self2.aggregateBy) {
          let color2 = d3.scaleOrdinal().domain(results.map((r, i) => i)).range(d3.schemeSet1);
        }
        let fixedDataPreSiblings = results.map(function(result, index3) {
          return {
            id: self2.assetData[index3].id,
            name: self2.assetData[index3].name,
            parent: self2.assetData[index3].parent,
            hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
            data: result.list.map((r) => ({
              disconnected: r.disconnected,
              date: parseTime(r.time),
              value: r.consumption
            })),
            color: self2.color ? self2.color : self2.assetData[index3].color ? self2.assetData[index3].color : "#53bbb7"
          };
        });
        this.unHideChildrenOfNullAssets(fixedDataPreSiblings.filter((a4) => !a4.parent), fixedDataPreSiblings);
        let uniqueParents = self2.assetData.filter((a4) => a4.parent).map((a4) => a4.parent).filter(function(value, index3, self3) {
          return self3.indexOf(value) === index3;
        });
        self2.layers = [];
        self2.allDatas = fixedDataPreSiblings.sort((a4, b) => Math.max(...b.data.map((a5) => a5.value)) - Math.max(...a4.data.map((a5) => a5.value)));
        if (self2.onVisibleItems) {
          if (self2.allDatas.filter((a4) => a4.data.some((d) => d.value !== null)).length === 0) {
            self2.onVisibleItems([]);
            self2.clearDown();
            return;
          }
        }
        if (self2.combined) {
          let topLevelAssets = self2.allDatas.filter(function(asset) {
            if (!asset.parent) {
              return true;
            }
            if (!self2.allDatas.find((a4) => a4.id === asset.parent)) {
              return true;
            }
          });
          if (topLevelAssets.length === 0) {
            self2.allDatas = [];
          } else {
            self2.allDatas = [
              {
                id: 0,
                name: "Total",
                parent: null,
                hidden: false,
                data: topLevelAssets[0].data.map(function(datum2, i) {
                  let total = 0;
                  topLevelAssets.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString()) {
                      total += matchedRecord.value;
                    }
                  });
                  return {
                    value: total,
                    date: datum2.date,
                    disconnected: datum2.disconnected
                  };
                }),
                color: self2.color ? self2.color : self2.widget ? self2.assetData[0].color : "#53bbb7"
              }
            ];
          }
        }
        if (this.aggregateBy === "dayOfWeek" || this.aggregateBy === "hourOfDay") {
          self2.allDatas.forEach(function(assetData) {
            let newDataArray = [];
            assetData.data.forEach(function(datum2) {
              let fixedDate;
              if (!datum2.date) return;
              if (self2.aggregateBy === "hourOfDay") {
                fixedDate = moment(datum2.date).tz(self2.timezone).hour();
              } else {
                fixedDate = moment(datum2.date).tz(self2.timezone).day();
              }
              let existingRecord = newDataArray.find((d) => d.date === fixedDate);
              if (existingRecord) {
                existingRecord.value += datum2.value;
                existingRecord.total += 1;
              } else {
                newDataArray.push({
                  date: fixedDate,
                  disconnected: datum2.disconnected,
                  total: 1,
                  value: datum2.value
                });
              }
            });
            newDataArray.forEach(function(datum2) {
              datum2.value = datum2.value / datum2.total;
            });
            if (self2.aggregateBy === "dayOfWeek") {
              newDataArray.sort(function(date1, date2) {
                if (date1.date === 0) {
                  return 1e3 - date2.date;
                } else if (date2.date === 0) {
                  return date1.date - 1e3;
                } else {
                  return date1.date - date2.date;
                }
              });
            }
            if (self2.aggregateBy === "hourOfDay") {
              newDataArray.sort((d1, d2) => d1.date - d2.date);
            }
            assetData.data = newDataArray;
          });
        }
        if (this.onDefaultSelected) {
          this.onDefaultSelected(self2.allDatas.filter((a4) => !a4.hidden));
        }
        if (this.onVisibleItems) {
          this.onVisibleItems(self2.allDatas.filter((a4) => a4.data.some((d) => d.value !== null)));
        }
        if (self2.allDatas.filter((a4) => a4.data.some((d) => d.value !== null)).length > 0) {
          self2.datas = self2.allDatas;
          self2.generateKPIs();
          self2.createGraph();
        } else {
          self2.datas = self2.allDatas;
          this.clearDown();
        }
      }
      remove() {
        this.clearDown();
        this.deleted();
        if (document.getElementById(this.uuid)) {
          document.getElementById(this.uuid).remove();
        }
      }
      createGraph() {
        let self2 = this;
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender();
          });
          self2.throttledRender();
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender();
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(
            self2.d3Element.node().parentNode,
            {
              childList: true,
              subtree: true
            }
          );
        }
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((parent) => parent.contains(target));
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      deleted() {
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        if (this.tooltip) {
          this.tooltip.remove();
        }
      }
      clearDown() {
        if (this.svg) {
          this.svg.remove();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.svg = null;
      }
      calcSizes() {
        let newWidth = this.d3Element.node().clientWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().clientHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      render(ignoreLegend) {
        if (this.compareTo && this.compareTo.show && !this.compareDatas) {
          return;
        }
        if (this.isDeleted) {
          return;
        }
        if (this.allDatas.filter((a4) => a4.data.some((d) => d.value !== null)).length === 0) {
          return;
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        let self2 = this;
        let changed;
        if (!this.fixedSize) {
          changed = this.calcSizes();
          if (changed && this.svg) {
            self2.tooltipOverride(null);
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("svg").attr("id", this.uuid).attr("class", "gd-graph gd-graph-bar-chart").attr("width", this.fixedSize ? this.windowWidth : "100%").attr("height", this.fixedSize ? this.windowHeight : "100%").append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.svg.append("g").attr("class", "axis axis-bottom").attr("transform", "translate(0," + this.height + ")");
          this.svg.append("g").attr("class", "axis axis-left");
          this.svg.append("g").attr("class", "grid");
          this.compareBars = this.svg.append("g").attr("class", "compare-bars");
          this.bars = this.svg.append("g").attr("class", "bars");
        }
        if (self2.d3Element.selectAll(".compare-bars").size() === 0) {
          this.compareBars = this.svg.append("g").attr("class", "compare-bars");
        }
        if (self2.d3Element.selectAll(".bars").size() === 0) {
          this.bars = this.svg.append("g").attr("class", "bars");
        }
        this.xScaler = d3.scaleBand().range([0, this.width]).paddingInner(0.2);
        if (this.compareDatas) {
          this.xScalerCompare = d3.scaleBand().range([0, this.width]).paddingInner(0.2);
          this.xScalerCompare.domain(self2.compareDatas[0].data.filter((d) => !d.hidden).map(function(d) {
            return d.date;
          }));
        }
        this.xScaler.domain(self2.datas[0].data.filter((d) => !d.hidden).map(function(d) {
          return d.date;
        }));
        let values = [];
        this.datas.filter((d) => !d.hidden).forEach(function(datum2) {
          let stackedLayers = self2.layers.find((l) => l.id === datum2.id);
          if (!stackedLayers) {
            values = values.concat(datum2.data.map(function(d) {
              return d.value;
            }));
          } else {
            values = values.concat(datum2.data.map(function(d, idx) {
              let value = d.value;
              let subValue = stackedLayers.layers.reduce(function(accumalator, value2) {
                return accumalator + (value2[idx][1] - value2[idx][0]);
              }, 0);
              return Math.max(subValue, value);
            }));
          }
        });
        if (this.compareDatas) {
          this.compareDatas.filter((d) => !d.hidden).forEach(function(datum2) {
            let stackedLayers = self2.layers.find((l) => l.id === datum2.id);
            if (!stackedLayers) {
              values = values.concat(datum2.data.map(function(d) {
                return d.value;
              }));
            } else {
              values = values.concat(datum2.data.map(function(d, idx) {
                let value = d.value;
                let subValue = stackedLayers.layers.reduce(function(accumalator, value2) {
                  return accumalator + (value2[idx][1] - value2[idx][0]);
                }, 0);
                return Math.max(subValue, value);
              }));
            }
          });
        }
        values.push(1);
        self2.isNegative = d3.min(values) < 0;
        if (self2.isNegative) {
          const minValue = Math.min(0, d3.min(values));
          const maxValue = Math.max(0, d3.max(values));
          const symmetrical = Math.max(Math.abs(minValue), Math.abs(maxValue));
          this.yScaler = d3.scaleLinear().range([0, this.height]).domain([symmetrical, -symmetrical]);
          this.max = symmetrical;
        } else {
          this.yScaler = d3.scaleLinear().range([this.height, 0]).domain([0, d3.max(values)]);
          this.max = d3.max(values);
        }
        if (this.compareTo && this.compareTo.show) {
          this.createValueBarsComparison();
        }
        this.createValueBars();
        this.createAxes();
        if (this.showTooltip) {
          if (changed && this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
          }
          let format2 = getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "", true);
          if (this.averageType && this.averageType.substr(0, 5) === "count") {
            format2 = getFormat("count", true);
          } else if (this.averageType && this.averageType.substr(0, 8) === "duration") {
            format2 = getFormat("time", true);
          }
          if (!this.tooltip) {
            this.tooltip = new BarTooltip({
              widget: this.widget,
              granularity: this.granularity,
              svg: this.svg,
              timezone: this.timezone,
              element: this.d3Element,
              data: this.datas,
              allData: this.allDatas,
              compareDatas: this.compareDatas,
              averageType: this.averageType,
              width: this.width,
              height: this.height,
              xScaler: this.xScaler,
              xScalerCompare: this.xScalerCompare,
              yScaler: this.yScaler,
              start: this.dataStart,
              end: this.dataEnd,
              isMobile: this.isMobile,
              override: this.tooltipOverride,
              aggregateBy: this.aggregateBy,
              format: format2
            });
          } else {
            this.tooltip.data = this.datas;
            this.tooltip.widget = this.widget;
            this.tooltip.averageType = this.averageType;
            this.tooltip.granularity = this.granularity;
            this.tooltip.allData = this.allDatas;
            this.tooltip.compareDatas = this.compareDatas;
            this.tooltip.xScalerCompare = this.xScalerCompare;
            this.tooltip.aggregateBy = this.aggregateBy;
            if (this.tooltip.verticalLine && this.tooltip.verticalLine.moveToFront) {
              this.tooltip.verticalLine.moveToFront();
              this.tooltip.mouseDetector.moveToFront();
            }
          }
        }
      }
      throttledRender(ignoreLegend) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (!self2.throttled) {
            self2.throttled = true;
            setTimeout(function() {
              self2.render(ignoreLegend);
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          self2.render(ignoreLegend);
        }
      }
      createAxes() {
        let self2 = this;
        let axisLeft2 = d3.axisLeft(this.yScaler);
        axisLeft2.ticks(5);
        if (this.averageType && this.averageType.substr(0, 5) === "count") {
          axisLeft2.tickFormat(getFormat("count", true));
        } else if (this.averageType && this.averageType.substr(0, 8) === "duration") {
          const [minValue, maxValue] = this.yScaler.domain();
          const tickInterval = 30 * 60 * 1e3;
          const maxTicks = 5;
          const durationRange = maxValue - minValue;
          const stepCount = Math.ceil(durationRange / tickInterval);
          const intervalMultiplier = Math.ceil(stepCount / maxTicks);
          const adjustedInterval = tickInterval * intervalMultiplier;
          const tickValues = d3.range(
            Math.floor(minValue / adjustedInterval) * adjustedInterval,
            maxValue + adjustedInterval,
            adjustedInterval
          );
          axisLeft2.tickValues(tickValues).tickFormat(getFormat("time", true));
        } else {
          axisLeft2.tickFormat(getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "", true));
        }
        if (this.widget) {
          axisLeft2.ticks(0);
        }
        if (this.labelDataAxis) {
          axisLeft2.tickFormat(getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "", true, true));
          axisLeft2.tickValues([this.max]);
        }
        let axisBottom2 = d3.axisBottom(this.xScaler);
        if (this.aggregateBy) {
          if (this.aggregateBy === "hourOfDay" || this.widget) {
            axisBottom2.tickPadding(10);
          }
          axisLeft2.tickPadding(10);
          if (this.aggregateBy === "dayOfWeek") {
            var weekday = new Array(7);
            weekday[0] = "Sunday";
            weekday[1] = "Monday";
            weekday[2] = "Tuesday";
            weekday[3] = "Wednesday";
            weekday[4] = "Thursday";
            weekday[5] = "Friday";
            weekday[6] = "Saturday";
            if (this.widget) {
              weekday.forEach((f2, i) => weekday[i] = f2.substr(0, 1));
            }
            axisBottom2.tickFormat((d) => weekday[d]);
          } else if (this.aggregateBy === "hourOfDay") {
            let pad4 = function(n, width, z) {
              z = z || "0";
              n = n + "";
              return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            };
            var pad3 = pad4;
            axisBottom2.tickFormat((h) => pad4(h, 2) + ":00");
          } else {
            axisBottom2.tickFormat(getFormatDayOfMonth(this.start, this.end));
          }
          if (this.width < 1e3 && !this.widget) {
            let tickMod = Math.ceil(this.xScaler.domain().length / 2);
            axisBottom2.tickValues(this.xScaler.domain().filter(function(d, i) {
              return !(i % tickMod);
            }));
          } else {
            if (this.aggregateBy === "hourOfDay" && this.widget) {
              axisBottom2.tickValues([0, 12, 23]);
            } else {
              axisBottom2.tickValues(this.xScaler.domain());
            }
          }
        } else {
          axisBottom2.tickFormat(getFormatDate(this.start, this.end, this.timezone, this.granularity));
          let tickMod = Math.ceil(this.xScaler.domain().length / (this.width < 1e3 ? 2 : 6));
          axisBottom2.tickValues(this.xScaler.domain().filter(function(d, i) {
            return !(i % tickMod);
          }));
        }
        let gridLinesLeft = d3.axisLeft(this.yScaler).ticks(5);
        if (this.widget) {
          axisBottom2.tickSize(0);
        }
        this.svg.selectAll(".axis-bottom").call(axisBottom2);
        this.svg.selectAll(".axis-left").call(axisLeft2);
        if (!this.widget) {
          this.svg.selectAll(".grid").call(
            gridLinesLeft.tickSize(-this.width).tickFormat("")
          );
        }
        if (this.inlineStyle && this.inlineStyle["tick"]) {
          Object.keys(this.inlineStyle["tick"]).forEach(function(style) {
            self2.d3Element.selectAll("g.tick").style(style, self2.inlineStyle["tick"][style]);
          });
        }
        this.svg.selectAll(".domain").remove();
        if (this.aggregateBy === "hourOfDay" && !this.widget) {
          self2.d3Element.selectAll(".axis-bottom").selectAll("g.tick").selectAll("text").attr("transform", "translate(-10, 10) rotate(-45)");
        }
        if (this.labelDataAxis) {
          self2.d3Element.selectAll(".axis-left").selectAll("g.tick").selectAll("line").attr("x2", "-3").attr("stroke", "#CCCCCC");
          self2.d3Element.selectAll(".axis-left").selectAll("g.tick").selectAll("text").attr("font-size", "0.8em").attr("transform", "rotate(-90)");
          self2.d3Element.selectAll(".axis-bottom").selectAll("g.tick").selectAll("text").attr("font-size", "0.8em");
          self2.d3Element.selectAll(".axis-left").selectAll("g.tick").selectAll("text").attr("text-anchor", "end").attr("x", "5").attr("y", "-10");
        }
      }
      createValueBars() {
        let insertedHatches = [];
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let addedIndex = -1;
        self2.datas.forEach(function(dataSet, index3) {
          let disconnectedIndexes = [];
          let disconnectedTotals = {};
          dataSet.data.forEach(function(datum2) {
            if (datum2.disconnected && disconnectedIndexes.indexOf(datum2.disconnected) === -1) {
              disconnectedIndexes.push(datum2.disconnected);
            }
          });
          disconnectedIndexes.forEach(function(disconnectedIndex) {
            let relevantData = dataSet.data.filter((d) => d.disconnected === disconnectedIndex);
            let totalConsumption = relevantData.reduce(function(total, datum2) {
              return total + datum2.value;
            }, 0);
            let start2 = relevantData[0].date;
            let end = relevantData[relevantData.length - 1].date;
            let average = totalConsumption / relevantData.length;
            disconnectedTotals[disconnectedIndex] = average;
          });
          if (dataSet.hidden) {
            if (self2.addedIndexes[dataSet.id] !== void 0) {
              let bar = self2.bars.selectAll(".bar-" + index3);
              if (self2.widget) {
                bar.attr("x", function(d) {
                  let x4;
                  if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                    x4 = self2.xScaler(d.date);
                  } else if (self2.report) {
                    x4 = self2.xScaler(d.date);
                  } else {
                    x4 = self2.xScaler(d.date) + self2.xScaler.bandwidth() / (self2.datas.filter((d2) => !d2.hidden).length + 1) * (self2.addedIndexes[dataSet.id] + 1);
                  }
                  return x4;
                }).attr("width", 0).remove();
              } else {
                bar.transition().duration(self2.transitionSpeed).attr("x", function(d) {
                  let x4;
                  if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                    x4 = self2.xScaler(d.date);
                  } else if (self2.report) {
                    x4 = self2.xScaler(d.date);
                  } else {
                    x4 = self2.xScaler(d.date) + self2.xScaler.bandwidth() / (self2.datas.filter((d2) => !d2.hidden).length + 1) * (self2.addedIndexes[dataSet.id] + 1);
                  }
                  return x4;
                }).attr("width", 0).remove();
              }
              delete self2.addedIndexes[dataSet.id];
            }
          } else {
            addedIndex++;
            self2.addedIndexes[dataSet.id] = addedIndex;
            let stackedLayers = self2.layers.find((l) => l.id === dataSet.id);
            let bar = self2.bars.selectAll(".bar-" + index3).data(dataSet.data);
            bar.enter().append("rect").attr("class", function() {
              let classes = "bar bar-" + index3;
              if (dataSet.hidden) {
                return classes + " hidden";
              }
              if (!dataSet.highlighted && anyHighlighted) {
                return classes + " un-highlighted";
              }
              return classes;
            }).attr("x", function(d) {
              let x4;
              if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                x4 = self2.xScaler(d.date);
              } else if (self2.report) {
                x4 = self2.xScaler(d.date);
              } else {
                x4 = self2.xScaler(d.date) + self2.xScaler.bandwidth() / self2.datas.filter((d2) => !d2.hidden).length * (addedIndex + 1);
              }
              return x4;
            }).attr("width", 0).attr("y", function(d) {
              let y4;
              if (self2.isNegative) {
                if (d.value < 0) {
                  y4 = self2.height / 2;
                } else {
                  y4 = self2.yScaler(d.value);
                }
              } else {
                y4 = self2.yScaler(d.value);
              }
              return y4;
            }).attr("height", function(d) {
              let h;
              if (self2.isNegative) {
                let val = self2.height / 2 - self2.yScaler(Math.abs(d.value));
                if (val >= 0) {
                  h = val;
                }
              } else {
                let val = self2.height - self2.yScaler(d.value);
                if (val >= 0) {
                  h = val;
                }
              }
              return h;
            }).style("fill", function(d) {
              let color2 = dataSet.color;
              if (insertedHatches.indexOf(color2) === -1) {
                self2.svg.append("defs").append("pattern").attr("id", "diagonalHatch-" + color2).attr("patternUnits", "userSpaceOnUse").attr("width", 10).attr("height", 10).attr("patternTransform", "rotate(45)").append("rect").attr("width", 5).attr("height", 10).attr("transform", "translate(0,0)").attr("fill", color2);
                insertedHatches.push(color2);
              }
              if (d.disconnected) {
                return "url(#diagonalHatch-" + color2 + ")";
              } else {
                return dataSet.color;
              }
            });
            bar = self2.bars.selectAll(".bar-" + index3).data(dataSet.data);
            let wwidth = stackedLayers ? self2.xScaler.bandwidth() / (self2.datas.filter((d) => !d.hidden).length * 2) * 0.5 : self2.xScaler.bandwidth() / self2.datas.filter((d) => !d.hidden).length * (self2.compareTo ? 0.5 : 1);
            if (self2.widget) {
              bar.attr("x", function(d) {
                let x4;
                if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                  x4 = self2.xScaler(d.date);
                } else if (self2.report) {
                  x4 = self2.xScaler(d.date);
                } else {
                  x4 = self2.xScaler(d.date) + self2.xScaler.bandwidth() / self2.datas.filter((d2) => !d2.hidden).length * addedIndex;
                }
                return x4 + (self2.compareTo ? wwidth / 2 : 1);
              }).attr("width", wwidth).attr("y", function(d) {
                let y4;
                if (self2.isNegative) {
                  if (d.value < 0) {
                    y4 = self2.height / 2;
                  } else {
                    y4 = self2.yScaler(d.value);
                  }
                } else {
                  y4 = self2.yScaler(d.value);
                }
                return y4;
              }).attr("height", function(d) {
                let h;
                if (self2.isNegative) {
                  let val = self2.height / 2 - self2.yScaler(Math.abs(d.value));
                  if (val >= 0) {
                    h = val;
                  }
                } else {
                  let val = self2.height - self2.yScaler(d.value);
                  if (val >= 0) {
                    h = val;
                  }
                }
                return h;
              });
              bar.exit().attr("width", 0).remove();
            } else {
              bar.transition().duration(self2.transitionSpeed).attr("x", function(d) {
                let x4;
                if (self2.aggregateBy === "dayOfWeek" || self2.aggregateBy === "hourOfDay") {
                  x4 = self2.xScaler(d.date);
                } else if (self2.report) {
                  x4 = self2.xScaler(d.date);
                } else {
                  x4 = self2.xScaler(d.date) + self2.xScaler.bandwidth() / self2.datas.filter((d2) => !d2.hidden).length * addedIndex;
                }
                return x4 + (self2.compareTo ? wwidth / 2 : 1);
              }).attr("width", wwidth).attr("y", function(d) {
                let y4;
                if (self2.isNegative) {
                  if (d.value < 0) {
                    y4 = self2.height / 2;
                  } else {
                    y4 = self2.yScaler(d.value);
                  }
                } else {
                  y4 = self2.yScaler(d.value);
                }
                return y4;
              }).attr("height", function(d) {
                let h;
                if (self2.isNegative) {
                  let val = self2.height / 2 - self2.yScaler(Math.abs(d.value));
                  if (val >= 0) {
                    h = val;
                  }
                } else {
                  let val = self2.height - self2.yScaler(d.value);
                  if (val >= 0) {
                    h = val;
                  }
                }
                return h;
              });
              bar.exit().transition().duration(self2.transitionSpeed).attr("width", 0).remove();
            }
          }
        });
      }
      createValueBarsComparison() {
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let addedIndex = -1;
        self2.compareDatas.forEach(function(dataSet, index3) {
          if (!dataSet.hidden) {
            addedIndex++;
            self2.addedIndexes[dataSet.id] = addedIndex;
            let stackedLayers = self2.layers.find((l) => l.id === dataSet.id);
            let bar = self2.compareBars.selectAll(".bar-comparison-" + index3).data(dataSet.data);
            bar.enter().filter((d) => d.value || d.data).append("rect").attr("class", function() {
              let classes = "bar-comparison bar-comparison-" + index3;
              if (dataSet.hidden) {
                return classes + " hidden";
              }
              if (!dataSet.highlighted && anyHighlighted) {
                return classes + " un-highlighted";
              }
              return classes;
            }).attr("x", (d) => self2.xScalerCompare(d.date)).attr("width", (d) => self2.widget ? self2.xScalerCompare.bandwidth() : 0).attr("y", function(d) {
              let y4;
              if (self2.isNegative) {
                if (d.value < 0) {
                  y4 = self2.height / 2;
                } else {
                  y4 = self2.yScaler(d.value);
                }
              } else {
                y4 = self2.yScaler(d.value);
              }
              return y4;
            }).attr("height", function(d) {
              let h;
              if (self2.isNegative) {
                let val = self2.height / 2 - self2.yScaler(Math.abs(d.value));
                if (val >= 0) {
                  h = val;
                }
              } else {
                let val = self2.height - self2.yScaler(d.value);
                if (val >= 0) {
                  h = val;
                }
              }
              return h;
            }).style("fill", "#e7e7e7").attr("stroke-width", "1").style("stroke", function(d) {
              return self2.compareTo.color ? self2.compareTo.color : "#e7e7e7";
            });
            bar = self2.compareBars.selectAll(".bar-comparison-" + index3).data(dataSet.data);
            if (!self2.widget) {
              bar.transition().duration(self2.transitionSpeed).attr("width", (d) => self2.xScalerCompare.bandwidth());
            }
            if (self2.widget) {
              bar.exit().remove();
            } else {
              bar.exit().transition().duration(self2.transitionSpeed).remove();
            }
          }
        });
      }
      generateKPIs() {
        let self2 = this;
        let kpiData = {};
        if (this.dataType && this.dataType.abstractType === StateOptions.AbstractDataType.CATEGORICAL) {
          if (this.averageType.substr(0, 5) === "count") {
            let totalCount = 0;
            self2.datas.forEach(function(dataSet) {
              dataSet.data.forEach(function(column) {
                totalCount += column.value;
              });
            });
            kpiData["TotalCount"] = {
              value: getFormat("count")(totalCount),
              dataType: this.dataType.dataType,
              rawValue: totalCount
            };
          } else if (this.averageType.substr(0, 8) === "duration") {
            let totalDuration = 0;
            self2.datas.forEach(function(dataSet) {
              dataSet.data.forEach(function(column) {
                totalDuration += column.value;
              });
            });
            kpiData["TotalDuration"] = {
              value: getFormat("time")(totalDuration),
              dataType: this.dataType.dataType,
              rawValue: totalDuration
            };
          }
          if (this.onKPIData) {
            this.onKPIData(kpiData);
          }
        } else {
          let dataTypeString = self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "";
          let hiddenIds = self2.datas.filter((d) => d.hidden || d.data === null).map((d) => d.id);
          let total = self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
            return r + a4.data.map((b, i) => b.value).reduce((v2, m3) => v2 + m3, 0);
          }, 0);
          if (!self2.aggregateBy) {
            kpiData = {
              total: {
                value: getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "")(total, true),
                rawValue: total,
                dataType: self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : ""
              }
            };
          } else {
            kpiData = {};
            let averageData = Math.round(self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
              return r + a4.data.map((b, i) => b["value"]).reduce((v2, m3) => v2 + m3, 0);
            }, 0) / self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
              return r + a4.data.map((b, i) => b["value"] !== null ? 1 : 0).reduce((v2, m3) => v2 + m3, 0);
            }, 0));
            kpiData["average"] = {
              value: getFormat(dataTypeString)(averageData),
              rawValue: averageData,
              dataType: dataTypeString
            };
            let maxData = d3.max(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d.value;
            });
            kpiData["max"] = {
              value: getFormat(dataTypeString)(maxData),
              rawValue: maxData,
              dataType: dataTypeString
            };
            let minData = d3.min(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d.value;
            });
            kpiData["min"] = {
              value: getFormat(dataTypeString)(minData),
              rawValue: minData,
              dataType: dataTypeString
            };
          }
          if (this.currency && this.pricePerKwh) {
            kpiData.cost = { value: this.currency + (Math.round(total / 1e3 * parseInt(this.pricePerKwh)) / 100).toFixed(2) };
          }
          if (this.carbonIntensity) {
            let carbonIntensity = Math.round(total / 1e3 * parseInt(this.carbonIntensity));
            kpiData.carbon = {
              value: carbonIntensity + "kg",
              rawValue: carbonIntensity,
              dataType: "percentage"
            };
          }
          if (!self2.aggregateBy) {
            if (self2.comparedResults && self2.compareTo) {
              let comparedData = self2.comparedResults.map(function(result, index3) {
                return {
                  id: self2.assetData[index3].id,
                  name: self2.assetData[index3].name,
                  parent: self2.assetData[index3].parent,
                  data: result.list.reduce((c6, e) => c6 + e.consumption, 0)
                };
              });
              let comparedTotal = comparedData.filter((d, i) => (!d.parent || ~hiddenIds.indexOf(d.parent) || !comparedData.find((c6) => c6.id === d.parent)) && hiddenIds.indexOf(d.id) === -1).reduce((c6, e) => c6 + e.data, 0);
              if (comparedTotal > 0) {
                let comparedChange = Math.round((total - comparedTotal) / comparedTotal * 100);
                kpiData.change = {
                  value: (comparedChange > 0 ? "+" : "") + comparedChange + "%",
                  rawValue: comparedChange,
                  dataType: "percentage",
                  subheading: self2.compareTo.label,
                  subdata: getFormat(dataTypeString)(comparedTotal, true)
                };
              }
            }
          }
          if (this.onKPIData) {
            this.onKPIData(kpiData);
          }
        }
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let redoKPI = false;
        let reRender = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          reInit = true;
        }
        if (params.compareTo !== void 0) {
          self2.compareTo = params.compareTo;
          self2.report = self2.compareTo !== null;
          self2.compareDatas = null;
          self2.comparedResults = null;
          reInit = true;
        }
        if (params.granularity !== void 0 && params.granularity !== null) {
          self2.granularity = params.granularity;
          reInit = true;
        }
        if (params.hidden !== void 0 && params.hidden !== null) {
          self2.hidden = params.hidden;
          self2.datas.forEach(function(datum2) {
            if (params.hidden.indexOf(datum2.id) !== -1 || !datum2.data.some((d) => d.value !== null)) {
              datum2.hidden = true;
            } else {
              datum2.hidden = false;
            }
          });
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted !== void 0) {
          self2.highlighted = params.highlighted;
          self2.datas.forEach(function(datum2) {
            if (params.highlighted.indexOf(datum2.id) !== -1) {
              datum2.highlighted = true;
            } else {
              datum2.highlighted = false;
            }
          });
          reRender = true;
        }
        if (reInit) {
          return self2.init();
        } else if (reRender) {
          self2.throttledRender();
          if (redoKPI) {
            self2.generateKPIs();
          }
          return Promise.resolve();
        }
      }
    };
    module2.exports = BarChart2;
  }
});

// src/util/assetBreakdownTooltip.js
var require_assetBreakdownTooltip = __commonJS({
  "src/util/assetBreakdownTooltip.js"(exports2, module2) {
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var getFormat = require_util().getFormat;
    var formatConsumption = require_util().getFormat("consumption");
    var getFormatDate = require_util().getFormatDate;
    var bisect = d3.bisector(function(d) {
      return d.date;
    }).left;
    var LineTooltip = class {
      constructor(params) {
        if (!params.svg) {
          throw Error("No svg given to tooltip");
        }
        if (!params.data) {
          throw Error("No data given to tooltip");
        }
        if (!params.width) {
          throw Error("No width given to tooltip");
        }
        if (!params.height) {
          throw Error("No height given to tooltip");
        }
        if (!params.xScaler) {
          throw Error("No X Scaler given to tooltip");
        }
        if (!params.yScaler) {
          throw Error("No Y Scaler given to tooltip");
        }
        if (!params.start) {
          throw Error("Start not given");
        }
        if (!params.end) {
          throw Error("End not given");
        }
        if (!params.element) {
          throw Error("No Element given");
        }
        this.onHover = params.onHover;
        this.isMobile = params.isMobile;
        this.svg = params.svg;
        this.data = params.data;
        this.width = params.width;
        this.height = params.height;
        this.xScaler = params.xScaler;
        this.yScaler = params.yScaler;
        this.start = params.start;
        this.dataType = params.dataType;
        this.end = params.end;
        this.widget = params.widget;
        this.element = params.element;
        this.override = params.override;
        this.createElements();
      }
      renderTooltip() {
        let self2 = this;
      }
      createElements() {
        let self2 = this;
        if (this.widget) {
          this.verticalLine = this.svg.append("line").attr("class", "tooltip-line").attr("x1", 0).attr("pointer-events", "none").attr("y1", 0).attr("x2", this.width).attr("y2", 0).style("opacity", 0).style("stroke-width", 1).style("stroke", "black").style("fill", "none");
        } else {
          this.verticalLine = this.svg.append("line").attr("class", "tooltip-line").attr("x1", 0).attr("pointer-events", "none").attr("y1", 0).attr("x2", 0).attr("y2", this.height).style("opacity", 0).style("stroke-width", 1).style("stroke", "black").style("fill", "none");
        }
        function mousemove(event, d) {
          function scaleBandInvert(scale2) {
            let domain = scale2.domain();
            let paddingOuter = scale2(domain[0]);
            let eachBand = scale2.step();
            return function(value) {
              let index3 = Math.floor((value - paddingOuter) / eachBand);
              return domain[Math.max(0, Math.min(index3, domain.length - 1))];
            };
          }
          let highlightedAssetIndex;
          let highlightedAsset;
          let selectedDatumX;
          let selectedDatumY;
          if (self2.widget) {
            highlightedAssetIndex = scaleBandInvert(self2.yScaler)(d3.pointer(event, this)[1]);
            highlightedAsset = self2.data.filter((d2) => !d2.hidden)[highlightedAssetIndex];
            if (highlightedAsset) {
              selectedDatumY = self2.yScaler(highlightedAssetIndex);
              self2.verticalLine.style("opacity", 1);
              self2.verticalLine.attr("y1", selectedDatumY + 5 * self2.yScaler.bandwidth() / 8);
              self2.verticalLine.attr("y2", selectedDatumY + 5 * self2.yScaler.bandwidth() / 8);
              self2.verticalLine.moveToFront();
              self2.onHover(highlightedAsset.id);
            } else {
              highlightedAssetIndex = null;
              highlightedAsset = null;
              self2.verticalLine.style("opacity", 0);
              self2.onHover(null);
            }
          } else {
            highlightedAssetIndex = scaleBandInvert(self2.xScaler)(d3.pointer(event, this)[0]);
            highlightedAsset = self2.data.filter((d2) => !d2.hidden)[highlightedAssetIndex];
            selectedDatumX = self2.xScaler(highlightedAssetIndex);
            self2.verticalLine.attr("x1", selectedDatumX + self2.xScaler.bandwidth() / 2);
            self2.verticalLine.attr("x2", selectedDatumX + self2.xScaler.bandwidth() / 2);
            self2.verticalLine.moveToFront();
          }
          if (self2.onHover && highlightedAsset && highlightedAssetIndex !== self2.lastHighlightedAssetIndex && !self2.widget) {
            self2.onHover(highlightedAsset.id);
          }
          self2.lastHighlightedAsset = highlightedAsset;
          self2.lastHighlightedAssetIndex = highlightedAssetIndex;
          self2.lastY = event.pageY;
          self2.renderTooltip();
        }
        this.mouseDetector = this.svg.append("rect").attr("class", "overlay").style("fill", "transparent").attr("width", this.width).attr("height", this.height).on("mouseover.tooltip", function() {
          if (!self2.widget) {
            self2.verticalLine.style("opacity", 1);
          }
        }).on("mouseout.tooltip", function() {
          if (self2.onHover) {
            self2.onHover(null);
          }
          self2.lastHighlightedAsset = null;
          self2.verticalLine.style("opacity", 0);
        }).on("mousemove.tooltip", mousemove);
      }
      set(params) {
        this.remove();
        this.svg = params.svg;
        this.data = params.data;
        this.width = params.width;
        this.height = params.height;
        this.xScaler = params.xScaler;
        this.yScaler = params.yScaler;
        this.start = params.start;
        this.widget = params.widget;
        this.dataType = params.dataType;
        this.end = params.end;
        this.element = params.element;
        this.createElements();
        this.renderTooltip();
      }
      remove() {
        this.verticalLine.remove();
        this.mouseDetector.remove();
      }
    };
    module2.exports = LineTooltip;
  }
});

// src/graphs/assetBreakdown.js
var require_assetBreakdown = __commonJS({
  "src/graphs/assetBreakdown.js"(exports2, module2) {
    var AssetBreakdownTooltip;
    if (typeof window !== "undefined") {
      init_barChart2();
      AssetBreakdownTooltip = require_assetBreakdownTooltip();
    }
    var GridDuck2;
    var getFormat = require_util().getFormat;
    var readyPromise = require_util().readyPromise;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var moment = require_moment();
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var { getFormatDate } = require_util();
    var MARGIN = { top: 20, right: 20, bottom: 20, left: 70 };
    var AssetBreakdown2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        if (params.start === void 0 && params.startOf === void 0 && !params.realTime) {
          throw Error("No start defined");
        }
        this.showBottomLabels = params.showBottomLabels;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        if (params.margin) {
          MARGIN = params.margin;
        }
        this.report = params.report;
        this.inlineStyle = params.inlineStyle;
        this.color = params.color;
        if (params.windowWidth) {
          this.windowWidth = params.windowWidth;
          this.windowHeight = params.windowHeight;
          this.width = params.windowWidth - MARGIN.left - MARGIN.right;
          this.height = params.windowHeight - MARGIN.top - MARGIN.bottom;
          this.fixedSize = true;
        }
        if (!params.element) {
          throw Error("No element defined");
        }
        this.widget = params.widget;
        if (this.widget) {
          MARGIN.left = 20;
        } else {
          MARGIN.left = 70;
        }
        if (!params.assets) {
          this.filterType = params.filterType;
          this.filterId = params.filterId;
        }
        if (params.showTooltip !== false) {
          this.showTooltip = true;
        }
        this.onHighlight = params.onHighlight;
        if (params.end === void 0 && !params.realTime) {
          throw Error("No end defined");
        }
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        if (params.onVisibleItems) {
          this.onVisibleItems = params.onVisibleItems;
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.compareTo && params.compareTo.start && params.compareTo.end) {
          this.compareTo = params.compareTo;
        }
        if (params.realTime) {
          this.realTime = true;
        }
        if (params.currency) {
          this.currency = params.currency;
        }
        if (params.hidden) {
          this.hidden = params.hidden;
        }
        if (params.pricePerKwh) {
          this.pricePerKwh = params.pricePerKwh;
        }
        if (params.data) {
          this.paramsData = params.data;
        }
        if (params.groupBy) {
          this.groupBy = params.groupBy;
        }
        if (params.compareData) {
          this.paramsCompareData = params.compareData;
        }
        this.assets = params.assets;
        this.isMobile = params.isMobile;
        this.dataTypes = params.dataTypes;
        this.start = params.start;
        this.end = params.end;
        this.startOf = params.startOf;
        this.element = params.element;
        this.tooltipOverride = params.tooltipOverride;
        this.assetUpdated = this.assetUpdated.bind(this);
        let self2 = this;
        this.error = function() {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error();
          }
        };
        readyPromise.then(function() {
          if (!self2.document.getElementById(self2.element.substr(1))) {
            self2.deleted();
            console.error(new Error("Element not on DOM"));
            return;
          }
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          self2.init();
        });
      }
      loadData() {
        let self2 = this;
        let dataType = self2.dataTypes[0];
        let promises = [];
        if (self2.realTime) {
          return GridDuck2.getAssets({
            getAll: true,
            filters: [
              {
                field: "assetId",
                value: "filtered"
              },
              {
                field: self2.filterType,
                value: self2.filterId
              }
            ]
          }).then(function(results) {
            let assets = results.list;
            self2.assetData = assets.map((a4) => ({
              name: a4.name,
              id: a4.id,
              siteId: a4.siteId,
              siteName: a4.siteName
            }));
            return Promise.resolve({
              results: assets
            });
          });
        } else {
          let filters = [
            {
              field: "dataType",
              value: dataType
            },
            {
              field: "start",
              value: self2.dataStart
            },
            {
              field: "end",
              value: self2.dataEnd
            },
            {
              field: "granularity",
              value: self2.dataEnd - self2.dataStart
            }
          ];
          if (self2.assets) {
            filters.push({
              field: "assetId",
              value: self2.assets.map((a4) => a4.id).join(",")
            });
          } else {
            filters.push({
              field: "assetId",
              value: "filtered"
            });
            filters.push({
              field: self2.filterType,
              value: self2.filterId
            });
          }
          promises.push(GridDuck2.getAssetConsumptionBatchs({
            filters
          }).then(function(res) {
            self2.assetData = res.list.map((d) => ({
              name: d.assetName,
              parent: d.parent,
              id: d.assetId,
              siteId: d.siteId,
              siteName: d.siteName,
              deviceCategory: d.deviceCategory,
              deviceCategoryId: d.deviceCategoryId,
              color: d.colour,
              icon: d.icon
            }));
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          }).catch(self2.error));
          if (self2.compareTo) {
            let compareFilters = [
              {
                field: "dataType",
                value: dataType
              },
              {
                field: "start",
                value: self2.compareTo.start
              },
              {
                field: "end",
                value: self2.compareTo.end
              },
              {
                field: "granularity",
                value: self2.compareTo.end - self2.compareTo.start
              }
            ];
            if (self2.assets) {
              compareFilters.push({
                field: "assetId",
                value: self2.assets.map((a4) => a4.id).join(",")
              });
            } else {
              compareFilters.push({
                field: "assetId",
                value: "filtered"
              });
              compareFilters.push({
                field: self2.filterType,
                value: self2.filterId
              });
            }
            promises.push(GridDuck2.getAssetConsumptionBatchs({
              filters: compareFilters
            }).then(function(res) {
              return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
            }).catch(self2.error));
          }
          return Promise.all(promises).then(function(res) {
            if (res && res[0]) {
              return Promise.resolve({
                results: res[0],
                cResults: res[1]
              });
            } else {
              return Promise.reject("Error loading data");
            }
          });
        }
      }
      init() {
        let self2 = this;
        let uuid = uuidv4();
        this.uuid = uuid;
        self2.dataStart = self2.start ? self2.start : moment().startOf(self2.startOf).unix();
        self2.dataEnd = self2.realTime ? Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) : self2.end;
        let standardResults;
        let promise;
        if (self2.paramsData) {
          promise = Promise.resolve({ results: self2.paramsData, cResults: self2.paramsCompareData });
          self2.assetData = self2.assets;
        } else {
          promise = self2.loadData();
        }
        return promise.then(function(res) {
          let results = res.results;
          let comparedResults = res.cResults;
          if (uuid === self2.uuid) {
            standardResults = results;
            if (self2.realTime) {
              results.forEach(function(asset) {
                asset.on("updated", self2.assetUpdated);
              });
            }
            self2.processData(standardResults);
            if (self2.onReady && !self2.isDeleted) {
              self2.onReady();
            }
            if (comparedResults) {
              self2.comparedResults = comparedResults;
              let unknownGroupIndex = void 0;
              self2.compareDatas = comparedResults.map(function(result, index3) {
                let highlighted = self2.highlighted && (self2.highlighted.indexOf(self2.assetData[index3].id) !== -1 || self2.groupBy && self2.highlighted.indexOf(self2.assetData[index3][self2.groupBy.id]) !== -1);
                let hidden = self2.hidden && (self2.hidden.indexOf(self2.assetData[index3].id) !== -1 || self2.groupBy && self2.hidden.indexOf(self2.assetData[index3][self2.groupBy.id]) !== -1);
                let returnObj = {
                  id: self2.assetData[index3].id,
                  name: self2.assetData[index3].name,
                  parent: self2.assetData[index3].parent,
                  groupId: self2.groupBy ? self2.assetData[index3][self2.groupBy.id] : null,
                  groupTitle: self2.groupBy ? self2.assetData[index3][self2.groupBy.title] : null,
                  data: result.list ? result.list.length >= 1 ? result.list[0].consumption : null : self2.dataTypes[0] === "CONSUMPTION" ? result.consumption : null,
                  color: self2.assetData[index3].color ? self2.assetData[index3].color : self2.color ? self2.color : "#e7e7e7",
                  highlighted,
                  hidden
                };
                if (self2.groupBy) {
                  returnObj[self2.groupBy.id] = self2.assetData[index3][self2.groupBy.id];
                  returnObj.groupedId = self2.assetData[index3][self2.groupBy.id];
                  if (!returnObj.groupTitle) {
                    unknownGroupIndex = index3;
                  }
                }
                return returnObj;
              });
              if (unknownGroupIndex !== void 0) {
                self2.compareDatas.splice(unknownGroupIndex, 1);
              }
            }
            self2.processData(standardResults);
            if (self2.onReady && !self2.isDeleted) {
              self2.onReady();
            }
            return Promise.resolve();
          }
        });
      }
      assetUpdated(field, val, asset) {
        if (!this.isDeleted && field === "consumption") {
          let datum2 = this.datas.find((d) => d.id === asset.id);
          datum2.data = val;
          this.throttledRender();
          this.generateKPIs();
        }
      }
      processData(results) {
        if (!results) {
          return;
        }
        let colors = [
          "#7025b5",
          "#9472cb",
          "#ae2ec1",
          "#dc4f83",
          "#ec5252",
          "#ee7351",
          "#efa24a",
          "#ffef00",
          "#85c72f",
          "#a8f184",
          "#61c68f",
          "#5cb4d2",
          "#4d89c5",
          "#444ec3"
        ];
        let self2 = this;
        self2.items = results;
        self2.datas = results.map(function(result, index3) {
          return {
            id: self2.assetData[index3].id,
            name: self2.assetData[index3].name,
            parent: self2.assetData[index3].parent,
            groupId: self2.groupBy ? self2.assetData[index3][self2.groupBy.id] : null,
            groupTitle: self2.groupBy ? self2.assetData[index3][self2.groupBy.title] : null,
            data: result.dataService ? result.consumption : result.list ? result.list.length === 1 ? result.list[0].consumption : null : self2.dataTypes[0] === "CONSUMPTION" ? result.consumption : null,
            color: self2.assetData[index3].color ? self2.assetData[index3].color : self2.color ? self2.color : colors[index3 % colors.length],
            highlighted: self2.highlighted ? self2.highlighted.indexOf(self2.assetData[index3].id) !== -1 : false,
            hidden: self2.hidden ? self2.hidden.indexOf(self2.assetData[index3].id) !== -1 : false
          };
        }).sort((a4, b) => {
          if (a4.name === "Other") return 1;
          if (b.name === "Other") return -1;
          const aData = a4 && a4.data || 0;
          const bData = b && b.data || 0;
          return bData - aData;
        });
        if (self2.groupBy) {
          let unknownGroupIndex = void 0;
          let fixedDatas = [];
          self2.datas.forEach(function(assetDatum, i) {
            if (fixedDatas.find((fD) => fD.id === assetDatum.groupId)) {
              fixedDatas.find((fD) => fD.id === assetDatum.groupId).data = fixedDatas.find((fD) => fD.id === assetDatum.groupId).data + assetDatum.data;
            } else {
              assetDatum.id = assetDatum.groupId;
              assetDatum.name = assetDatum.groupTitle ? assetDatum.groupTitle : "Unknown";
              if (!assetDatum.groupTitle) {
                unknownGroupIndex = i;
              }
              fixedDatas.push(assetDatum);
            }
          });
          self2.datas = fixedDatas;
          if (unknownGroupIndex !== void 0) {
            self2.datas.splice(unknownGroupIndex, 1);
          }
        }
        if (self2.widget && self2.datas.length > 4) {
          self2.fixedDatas = self2.datas.slice(0, 4);
          let remainingData = self2.datas.slice(4);
          let total = 0;
          remainingData.forEach(function(result) {
            if (result.data) {
              total += result.data;
            }
          });
          self2.fixedDatas.push({
            id: "other",
            name: "Other",
            data: total,
            color: self2.color ? self2.color : self2.datas[4].color ? self2.assetData[4].color : colors[4 % colors.length],
            highlighted: self2.highlighted ? self2.highlighted.indexOf("other") !== -1 : false,
            parent: void 0,
            hidden: self2.hidden ? self2.hidden.indexOf("other") !== -1 : false
          });
          self2.datas = self2.fixedDatas;
        }
        self2.datas = self2.datas.sort((a4, b) => {
          if (a4.name === "Other") return 1;
          if (b.name === "Other") return -1;
          const aData = a4 && a4.data || 0;
          const bData = b && b.data || 0;
          return bData - aData;
        });
        if (self2.compareDatas) {
          let newData = [];
          let otherTotal = 0;
          self2.datas.forEach(function(datum2, i) {
            if (self2.groupBy) {
              let groupToAddTo = self2.compareDatas.find((cD) => cD[self2.groupBy.id] === datum2.id);
              if (groupToAddTo) {
                let total = 0;
                let filteredRes = self2.compareDatas.filter((cD) => cD[self2.groupBy.id] === datum2.id);
                filteredRes.forEach(function(comparedDatum) {
                  total += comparedDatum.data;
                  comparedDatum.added = true;
                });
                let thisDatum = self2.compareDatas.filter((cD) => cD[self2.groupBy.id] === datum2.id);
                thisDatum.data = total;
                thisDatum.id = datum2[self2.groupBy.id] || datum2.groupId;
                thisDatum.name = datum2[self2.groupBy.title] || datum2.groupTitle;
                thisDatum.groupedId = datum2.groupId;
                newData.push(thisDatum);
              }
            } else {
              if (self2.compareDatas.find((cD) => cD.id === datum2.id)) {
                self2.compareDatas.find((cD) => cD.id === datum2.id).added = true;
                newData.push(self2.compareDatas.find((cD) => cD.id === datum2.id));
              }
            }
          });
          self2.compareDatas.forEach(function(cD) {
            if (!cD.added && cD.data && (self2.groupBy && cD[self2.groupBy.id] || !self2.groupBy)) {
              otherTotal += cD.data;
            }
          });
          if (self2.widget && self2.datas.length > 4) {
            newData.push({
              id: "other",
              name: "Other",
              data: otherTotal,
              color: self2.color ? self2.color : self2.datas[4].color ? self2.assetData[4].color : colors[4 % colors.length],
              highlighted: self2.highlighted ? self2.highlighted.indexOf("other") !== -1 : false,
              parent: void 0,
              hidden: self2.hidden ? self2.hidden.indexOf("other") !== -1 : false
            });
          }
          self2.compareDatas = newData;
        }
        if (this.onVisibleItems) {
          this.onVisibleItems(self2.datas.filter((d) => d.data !== null));
        }
        if (self2.datas.filter((d) => d.data !== null).length > 0) {
          self2.generateKPIs();
          self2.createGraph();
        } else {
          this.clearDown();
        }
      }
      generateKPIs() {
        let self2 = this;
        let dataTypeString = self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "";
        let hiddenIds = self2.datas.filter((d) => d.hidden || d.data === null).map((d) => d.id);
        let total = self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
          return r + a4.data;
        }, 0);
        let kpiData;
        if (!self2.aggregateBy) {
          kpiData = {
            total: {
              value: getFormat(self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : "")(total, true),
              rawValue: total,
              dataType: self2.dataTypes[0] ? self2.dataTypes[0].toLowerCase() : ""
            }
          };
        } else {
          kpiData = {};
          let averageData = Math.round(self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
            return r + a4.data;
          }, 0) / self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
            return r + a4.data;
          }, 0));
          kpiData["average"] = {
            value: getFormat(dataTypeString)(averageData),
            rawValue: averageData,
            dataType: dataTypeString
          };
          let maxData = d3.max(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return d.value;
          });
          kpiData["max"] = {
            value: getFormat(dataTypeString)(maxData),
            rawValue: maxData,
            dataType: dataTypeString
          };
          let minData = d3.min(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return d.value;
          });
          kpiData["min"] = {
            value: getFormat(dataTypeString)(minData),
            rawValue: minData,
            dataType: dataTypeString
          };
        }
        if (this.currency && this.pricePerKwh) {
          kpiData.cost = { value: this.currency + (Math.round(total / 1e3 * parseInt(this.pricePerKwh)) / 100).toFixed(2) };
        }
        if (this.carbonIntensity) {
          let carbonIntensity = Math.round(total / 1e3 * parseInt(this.carbonIntensity));
          kpiData.carbon = {
            value: carbonIntensity + "kg",
            rawValue: carbonIntensity,
            dataType: "percentage"
          };
        }
        if (!self2.aggregateBy) {
          if (self2.comparedResults && self2.compareTo) {
            let comparedData = self2.comparedResults.map(function(result, index3) {
              return {
                id: self2.assetData[index3].id,
                name: self2.assetData[index3].name,
                parent: self2.assetData[index3].parent,
                data: result.list.reduce((c6, e) => c6 + e.consumption, 0)
              };
            });
            let comparedTotal = comparedData.filter((d, i) => (!d.parent || ~hiddenIds.indexOf(d.parent)) && hiddenIds.indexOf(d.id) === -1).reduce((c6, e) => c6 + e.data, 0);
            if (comparedTotal > 0) {
              let comparedChange = Math.round((total - comparedTotal) / comparedTotal * 100);
              kpiData.change = {
                value: (comparedChange > 0 ? "+" : "") + comparedChange + "%",
                rawValue: comparedChange,
                dataType: "percentage",
                subheading: self2.compareTo.label,
                subdata: getFormat(dataTypeString)(comparedTotal, true)
              };
            }
          }
        }
        if (this.onKPIData) {
          this.onKPIData(kpiData);
        }
      }
      createGraph() {
        let self2 = this;
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender();
          });
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender();
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(
            self2.d3Element.node().parentNode,
            {
              childList: true,
              subtree: true
            }
          );
        }
        self2.throttledRender();
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((parent) => parent.contains(target));
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      deleted() {
        this.clearDown();
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        let self2 = this;
        if (this.items) {
          this.items.forEach(function(item) {
            if (item.off) {
              item.off("updated", self2.assetUpdated);
            }
          });
        }
      }
      remove() {
        this.clearDown();
        this.deleted();
      }
      clearDown() {
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.svg = null;
      }
      calcSizes() {
        let newWidth = this.d3Element.node().offsetWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().offsetHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      render(ignoreLegend, ignoreTooltip) {
        if (this.isDeleted) {
          return;
        }
        if (this.datas.filter((d) => d.data !== null).length === 0) {
          return;
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        this.lastRendered = (/* @__PURE__ */ new Date()).getTime();
        let self2 = this;
        if (!this.fixedSize) {
          let changed = this.calcSizes();
          if (changed && this.svg) {
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("svg").attr("class", "gd-graph gd-graph-bar-chart").attr("width", this.fixedSize ? this.windowWidth : "100%").attr("height", this.fixedSize ? this.windowHeight : "100%").append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.svg.append("g").attr("class", "axis axis-bottom").attr("transform", "translate(0," + this.height + ")");
          this.svg.append("g").attr("class", "axis axis-left");
          this.svg.append("g").attr("class", "grid");
          this.compareBars = this.svg.append("g").attr("class", "compare-bars");
          this.bars = this.svg.append("g").attr("class", "bars");
        }
        if (this.widget) {
          this.yScaler = d3.scaleBand().range([0, this.height]).padding(0.1);
          this.xScaler = d3.scaleLinear().range([this.width, 0]);
          this.yScaler.domain([0, 1, 2, 3, 4]);
          if (this.compareTo && this.compareTo.show && this.compareDatas) {
            this.xScaler.domain([
              0,
              d3.max(
                [
                  d3.max([d3.max(self2.datas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1]),
                  d3.max([d3.max(self2.compareDatas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1])
                ]
              )
            ]);
          } else {
            this.xScaler.domain([0, d3.max([d3.max(self2.datas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1])]);
          }
        } else {
          this.xScaler = d3.scaleBand().range([0, this.width]).padding(0.1);
          this.yScaler = d3.scaleLinear().range([this.height, 0]);
          this.xScaler.domain(self2.datas.filter((d) => !d.hidden && d.data !== null).map(function(d, i) {
            return i;
          }));
          if (this.compareTo && this.compareTo.show && this.compareDatas) {
            this.yScaler.domain([
              0,
              d3.max(
                [
                  d3.max([d3.max(self2.datas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1]),
                  d3.max([d3.max(self2.compareDatas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1])
                ]
              )
            ]);
          } else {
            this.yScaler.domain([0, d3.max([d3.max(self2.datas.filter((d) => !d.hidden && d.data !== null).map((d) => d.data)), 1])]);
          }
        }
        if (self2.compareTo && self2.compareTo.show && self2.compareDatas) {
          if (self2.widget) {
            this.createValueBarsComparisonHorizontal();
          } else {
            this.createValueBarsComparison();
          }
        }
        if (self2.widget) {
          self2.createValueBarsHorizontal();
        } else {
          self2.createValueBars();
        }
        this.createAxes();
        if (this.showTooltip && !ignoreTooltip) {
          if (!this.tooltip) {
            this.tooltip = new AssetBreakdownTooltip({
              svg: this.svg,
              data: this.datas,
              width: this.width,
              height: this.height,
              xScaler: this.xScaler,
              yScaler: this.yScaler,
              widget: this.widget,
              start: this.dataStart,
              end: this.dataEnd,
              onHover: function(hoveredId) {
                if (self2.widget && hoveredId === null) {
                  self2.tooltipOverride();
                }
                self2.datas.filter((d) => !d.hidden && d.data !== null).forEach(function(datum2, idx) {
                  datum2.highlighted = datum2.id === hoveredId;
                });
                if (self2.compareDatas) {
                  self2.compareDatas.filter((d) => !d.hidden && d.data !== null).forEach(function(datum2, idx) {
                    datum2.highlighted = datum2.id === hoveredId;
                  });
                }
                self2.throttledRender(false, true);
                if (self2.onHighlight) {
                  self2.onHighlight(hoveredId);
                }
                if (self2.tooltipOverride && self2.widget) {
                  let format2;
                  if (self2.dataTypes[0] === "DELIVERED_GAS" || self2.dataTypes[0] === "DELIVERED_WATER") {
                    format2 = getFormat("delivered_gas");
                  } else if (self2.dataTypes[0] === "CONSUMPTION") {
                    format2 = getFormat("consumption");
                  } else {
                    format2 = getFormat("delivered", true);
                  }
                  self2.tooltipOverride({
                    data: self2.datas.filter((d) => d.id === hoveredId).map(function(datum2, index3) {
                      if (self2.compareDatas) {
                        let compareDatum = self2.compareDatas.find((cD) => cD.id === hoveredId);
                        return {
                          name: datum2.name,
                          value: format2(datum2.data),
                          color: datum2.color,
                          compareValue: compareDatum ? format2(compareDatum.data) : ""
                        };
                      } else {
                        return {
                          name: datum2.name,
                          color: datum2.color,
                          value: format2(datum2.data)
                        };
                      }
                    }),
                    locked: false
                  });
                }
              },
              dataType: this.dataTypes[0],
              element: this.d3Element,
              isMobile: this.isMobile
            });
          } else if (this.tooltip) {
            this.tooltip.set({
              svg: this.svg,
              data: this.datas,
              width: this.width,
              height: this.height,
              widget: this.widget,
              xScaler: this.xScaler,
              yScaler: this.yScaler,
              start: this.dataStart,
              end: this.dataEnd,
              dataType: this.dataTypes[0],
              element: this.d3Element,
              isMobile: this.isMobile
            });
          }
          if (this.tooltipOverride && !this.widget) {
            let format2;
            if (this.dataTypes[0] === "DELIVERED_GAS" || this.dataTypes[0] === "DELIVERED_WATER") {
              format2 = getFormat("delivered_gas");
            } else if (this.dataTypes[0] === "CONSUMPTION") {
              format2 = getFormat("consumption");
            } else {
              format2 = getFormat("delivered", true);
            }
            this.format = format2;
            this.tooltipOverride({
              data: this.datas.map(function(datum2, index3) {
                if (self2.compareDatas) {
                  let compareDatum = self2.compareDatas[index3];
                  return {
                    name: datum2.name,
                    value: format2(datum2.data),
                    compareValue: format2(compareDatum.data)
                  };
                } else {
                  return {
                    name: datum2.name,
                    value: format2(datum2.data)
                  };
                }
              }),
              locked: false
            });
          }
        }
      }
      throttledRender(ignoreLegend, ignoreTooltip) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (!self2.throttled) {
            self2.throttled = true;
            setTimeout(function() {
              try {
                self2.render(ignoreLegend, ignoreTooltip);
              } catch (e) {
                console.error("Failed to render", e);
              }
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          try {
            self2.render(ignoreLegend, ignoreTooltip);
          } catch (e) {
            console.error("Failed to render", e);
          }
        }
      }
      createAxes() {
        let self2 = this;
        let axisLeft2 = d3.axisLeft(this.yScaler);
        axisLeft2.ticks(5);
        if (this.dataTypes[0] === "DELIVERED_GAS" || this.dataTypes[0] === "DELIVERED_WATER") {
          axisLeft2.tickFormat(getFormat("delivered_gas"));
        } else if (this.dataTypes[0] === "CONSUMPTION") {
          axisLeft2.tickFormat(getFormat("consumption"));
        } else {
          axisLeft2.tickFormat(getFormat("delivered", true));
        }
        if (this.report) {
          axisLeft2.tickPadding(30);
        }
        if (this.widget) {
          axisLeft2.ticks(0);
        }
        let gridLinesLeft = d3.axisLeft(this.yScaler).ticks(5);
        if (!this.widget) {
          this.svg.selectAll(".axis-left").call(axisLeft2);
          this.svg.selectAll(".grid").call(
            gridLinesLeft.tickSize(-this.width).tickFormat("")
          );
        }
        if (this.showBottomLabels) {
          let truncate2 = function(str, n) {
            return str.length > n ? str.substr(0, n - 3) + "..." : str;
          };
          var truncate = truncate2;
          ;
          let axisBottom2 = d3.axisBottom(this.xScaler);
          let items = self2.datas.filter((d) => !d.hidden && d.data !== null).length;
          if (!items) {
            items = 1;
          }
          axisBottom2.tickFormat(function(d) {
            return truncate2(self2.datas[d].name, Math.round(120 / items));
          });
          axisBottom2.tickValues(this.xScaler.domain());
          if (this.report) {
            axisBottom2.tickPadding(30);
          }
          this.svg.selectAll(".axis-bottom").call(axisBottom2);
        }
        if (this.inlineStyle && this.inlineStyle["tick"]) {
          Object.keys(this.inlineStyle["tick"]).forEach(function(style) {
            self2.d3Element.selectAll("g.tick").style(style, self2.inlineStyle["tick"][style]);
          });
        }
        this.svg.selectAll(".domain").remove();
      }
      createValueBarsHorizontal() {
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let hheight = self2.yScaler.bandwidth() * 0.5;
        let barLabel = self2.bars.selectAll(".bar-label").data(self2.datas.filter((d) => !d.hidden));
        barLabel.enter().append("text").attr("class", function(d) {
          return "bar-label";
        }).attr("y", function(d, i) {
          return self2.yScaler(i) + 3 * hheight / 8;
        }).attr("x", function(d) {
          return 0;
        }).style("font-size", "12px").style("font-family", "Asap, sans-serif").style("fill", "grey").text(function(d, i) {
          return d.name;
        });
        barLabel.exit().remove();
        let bar = self2.svg.selectAll(".bar").data(self2.datas.filter((d) => !d.hidden && d.data !== null && self2.width - self2.xScaler(d.data) > 0));
        bar.enter().append("rect").attr("class", function(d) {
          let classes = "bar ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("y", function(d, i) {
          return self2.yScaler(i) + hheight;
        }).attr("x", function(d) {
          return 0;
        }).attr("height", hheight / 2).attr("width", function(d) {
          return self2.width - self2.xScaler(d.data);
        }).style("fill", function(d) {
          return d.color;
        });
        bar = self2.svg.selectAll(".bar").data(self2.datas.filter((d) => !d.hidden && d.data !== null && self2.width - self2.xScaler(d.data) > 0));
        bar.exit().remove();
      }
      createValueBars() {
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let wwidth = self2.xScaler.bandwidth() * 0.5;
        let bar = self2.bars.selectAll(".bar").data(self2.datas.filter((d) => !d.hidden && d.data !== null && self2.height - self2.yScaler(d.data) > 0));
        bar.enter().append("rect").attr("class", function(d) {
          let classes = "bar ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("x", function(d, i) {
          return self2.xScaler(i) + wwidth / 2;
        }).attr("width", 0).attr("height", function(d) {
          return self2.height - self2.yScaler(d.data);
        }).attr("y", function(d) {
          return self2.yScaler(d.data);
        }).style("fill", function(d) {
          return d.color;
        });
        bar = self2.svg.selectAll(".bar").data(self2.datas.filter((d) => !d.hidden && d.data !== null && self2.height - self2.yScaler(d.data) > 0));
        bar.transition().duration(500).attr("class", function(d) {
          let classes = "bar ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("width", wwidth).attr("x", function(d, i) {
          return self2.xScaler(i) + wwidth / 2;
        }).attr("height", function(d) {
          return self2.height - self2.yScaler(d.data);
        }).attr("y", function(d) {
          return self2.yScaler(d.data);
        }).style("fill", function(d) {
          return d.color;
        });
        bar = self2.svg.selectAll(".bar").data(self2.datas.filter((d) => !d.hidden && d.data !== null && self2.height - self2.yScaler(d.data) > 0));
        bar.exit().remove();
      }
      createValueBarsComparisonHorizontal() {
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let path2 = self2.compareBars.selectAll(".bar-comparison").data(self2.compareDatas.filter((d) => !d.hidden && d.data !== null));
        path2.enter().append("rect").attr("class", function(d) {
          let classes = "bar-comparison ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("y", function(d, i) {
          return self2.yScaler(i) + 3 * self2.yScaler.bandwidth() / 8;
        }).attr("x", function(d) {
          return 0;
        }).attr("height", self2.yScaler.bandwidth() / 2).attr("width", function(d) {
          return self2.width - self2.xScaler(d.data);
        }).attr("fill", "#e7e7e7");
        path2.exit().transition().remove();
      }
      createValueBarsComparison() {
        let self2 = this;
        let anyHighlighted = self2.datas.find((d) => d.highlighted) !== void 0;
        let hiddenIds = self2.datas.filter((d) => d.hidden || d.data === null).map((d) => d.id);
        let path2 = self2.compareBars.selectAll(".bar-comparison").data(self2.compareDatas);
        path2.enter().append("path").attr("class", function(d) {
          let classes = "bar-comparison ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("d", function(d, i) {
          return d3.line()([[self2.xScaler(i), self2.height], [self2.xScaler(i), self2.yScaler(d.data)], [self2.xScaler(i), self2.yScaler(d.data)], [self2.xScaler(i), self2.height]]);
        }).attr("fill", "#e7e7e7").attr("stroke-width", "1").style("stroke", function(d) {
          return self2.compareTo.color ? self2.compareTo.color : "#e7e7e7";
        });
        path2 = self2.svg.selectAll(".bar-comparison").data(self2.compareDatas.filter((d) => !d.hidden && d.data !== null && hiddenIds.indexOf(d.groupedId) === -1));
        path2.transition().duration(500).attr("class", function(d) {
          let classes = "bar-comparison ";
          if (!d.highlighted && anyHighlighted) {
            return classes + " un-highlighted";
          }
          return classes;
        }).attr("fill", "#e7e7e7").attr("stroke-width", "1").style("stroke", function(d) {
          return self2.compareTo.color ? self2.compareTo.color : "#e7e7e7";
        }).attr("d", function(d, i) {
          return d3.line()([[self2.xScaler(i), self2.height], [self2.xScaler(i), self2.yScaler(d.data)], [self2.xScaler(i) + self2.xScaler.bandwidth(), self2.yScaler(d.data)], [self2.xScaler(i) + self2.xScaler.bandwidth(), self2.height]]);
        });
        path2 = self2.svg.selectAll(".bar-comparison").data(self2.compareDatas.filter((d) => !d.hidden && d.data !== null && hiddenIds.indexOf(d.groupedId) === -1));
        path2.exit().transition().remove();
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let reRender = false;
        let redoKPI = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          reInit = true;
        }
        if (params.granularity !== void 0) {
          self2.granularity = params.granularity;
          reInit = true;
        }
        if (params.compareTo && params.compareTo.start && params.compareTo.end) {
          self2.compareTo = params.compareTo;
          reInit = true;
        } else if (params.compareTo !== void 0) {
          self2.compareTo = null;
          self2.compareDatas = null;
        }
        if (params.hidden) {
          self2.hidden = params.hidden;
          self2.datas.forEach(function(datum2) {
            if (params.hidden.indexOf(datum2.id) !== -1) {
              datum2.hidden = true;
            } else {
              datum2.hidden = false;
            }
          });
          if (self2.compareDatas) {
            self2.compareDatas.forEach(function(datum2) {
              if (params.hidden.indexOf(datum2.id) !== -1) {
                datum2.hidden = true;
              } else {
                datum2.hidden = false;
              }
            });
          }
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted) {
          self2.highlighted = params.highlighted;
          self2.datas.forEach(function(datum2) {
            if (params.highlighted.indexOf(datum2.id) !== -1) {
              datum2.highlighted = true;
            } else {
              datum2.highlighted = false;
            }
          });
          if (self2.compareDatas) {
            self2.compareDatas.forEach(function(datum2) {
              if (params.highlighted.indexOf(datum2.id) !== -1) {
                datum2.highlighted = true;
              } else {
                datum2.highlighted = false;
              }
            });
          }
          reRender = true;
        }
        if (reInit) {
          return self2.init();
        } else if (reRender) {
          if (self2.datas.filter((d) => d.data !== null).length > 1) {
            self2.throttledRender();
            if (redoKPI) {
              self2.generateKPIs();
            }
          }
          return Promise.resolve();
        }
      }
    };
    module2.exports = AssetBreakdown2;
  }
});

// src/graphs/anomaly.js
var require_anomaly = __commonJS({
  "src/graphs/anomaly.js"(exports2, module2) {
    var getFormat = require_util().getFormat;
    var getFormatDate = require_util().getFormatDate;
    var parseTime = require_util().parseTime;
    var readyPromise = require_util().readyPromise;
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var moment = require_moment();
    var ANIMATION_TIME = 300;
    var GridDuck2;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var Brusher = require_brusher();
    var MARGIN = { top: 0, right: 10, bottom: 0, left: 10 };
    var Anomaly2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        let self2 = this;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        if (params.windowWidth) {
          this.width = params.windowWidth;
          this.height = params.windowHeight;
          this.fixedSize = true;
        }
        if (!params.element) {
          throw Error("No element defined");
        }
        if (params.averageType) {
          this.averageType = params.averageType;
        } else {
          this.averageType = "average";
        }
        this.color = params.color;
        this.widget = params.widget;
        this.average = params.average;
        if (this.widget) {
          MARGIN.left = 20;
          ANIMATION_TIME = 0;
        } else {
          MARGIN.left = 70;
          ANIMATION_TIME = 300;
        }
        this.timezone = params.timezone;
        this.error = function(e) {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error(e);
          }
        };
        if (params.anomalyId) {
          this.anomalyId = params.anomalyId;
        }
        if (params.anomaly) {
          this.anomaly = params.anomaly;
        }
        this.modelData = params.modelData;
        if (params.showArea !== false) {
          this.showArea = true;
        }
        this.invertModelBand = params.invertModelBand;
        this.outerModelBand = params.outerModelBand;
        this.anomalyValue = params.anomalyValue;
        this.anomalyTs = params.anomalyTs;
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        if (params.summaryElement) {
          this.summaryElement = params.summaryElement;
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.hidden) {
          this.hidden = params.hidden;
        } else {
          this.hidden = [];
        }
        if (params.granularity) {
          this.granularity = params.granularity;
        }
        if (params.onVisibleItems) {
          this.onVisibleItems = params.onVisibleItems;
        }
        this.end = params.end;
        this.isMobile = params.isMobile;
        this.startOf = params.startOf;
        this.combined = params.combined;
        this.start = params.start;
        this.modelOnly = params.modelOnly;
        this.isDeleted = false;
        this.element = params.element;
        this.zoomCallback = params.zoomCallback;
        this.resetZoom = this.resetZoom.bind(this);
        readyPromise.then(function() {
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          self2.init();
        });
      }
      async loadData() {
        let self2 = this;
        if (!this.anomaly) {
          this.anomaly = await GridDuck2.getAnomaly({
            id: self2.anomalyId
          });
        }
        let gap = (!this.anomaly.endTs ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : this.anomaly.endTs) - this.anomaly.startTs;
        self2.dataStart = Math.round(this.anomaly.startTs - gap * 1.5);
        self2.anomalyStart = this.anomaly.startTs;
        if (!this.anomaly.endTs) {
          self2.dataEnd = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
          self2.anomalyEnd = (/* @__PURE__ */ new Date()).getTime() / 1e3;
        } else {
          self2.dataEnd = Math.round(Math.min((/* @__PURE__ */ new Date()).getTime() / 1e3, this.anomaly.endTs + gap * 1.5));
          self2.anomalyEnd = this.anomaly.endTs;
        }
        self2.dataTypes = ["CONSUMPTION"];
        self2.assets = [{ id: this.anomaly.deviceId }];
        let dataType = self2.dataTypes[0];
        let promises = [];
        let filters = [{
          field: "dataType",
          value: dataType
        }, {
          field: "start",
          value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
        }, {
          field: "end",
          value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
        }, {
          field: "type",
          value: self2.averageType
        }];
        if (self2.assets) {
          filters.push({
            field: "assetId",
            value: self2.assets.map((a4) => a4.id).join(",")
          });
        } else {
          filters.push({
            field: "assetId",
            value: "filtered"
          });
          filters.push({
            field: self2.filterType,
            value: self2.filterId
          });
        }
        promises.push(GridDuck2.getAssetTelemetryBatchs({
          filters
        }).then(function(res) {
          self2.assetData = res.list.map((d) => ({ name: d.assetName, id: d.assetId, parent: d.parent }));
          return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
        }).catch(self2.error));
        if (self2.compareTo) {
          let compareFilters = [{
            field: "dataType",
            value: dataType
          }, {
            field: "start",
            value: self2.zoom ? Math.round(self2.zoom.startCompare.getTime() / 1e3) - 120 : self2.compareTo.start
          }, {
            field: "end",
            value: self2.zoom ? Math.round(self2.zoom.endCompare.getTime() / 1e3) + 120 : self2.compareTo.end
          }, {
            field: "type",
            value: self2.averageType
          }];
          if (self2.assets) {
            compareFilters.push({
              field: "assetId",
              value: self2.assets.map((a4) => a4.id).join(",")
            });
          } else {
            compareFilters.push({
              field: "assetId",
              value: "filtered"
            });
            compareFilters.push({
              field: self2.filterType,
              value: self2.filterId
            });
          }
          promises.push(GridDuck2.getAssetTelemetryBatchs({
            filters: compareFilters
          }).then(function(res) {
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          }).catch(self2.error));
        }
        return Promise.all(promises).then(function(res) {
          if (res && res[0]) {
            return Promise.resolve({
              results: res[0],
              cResults: res[1]
            });
          } else {
            return Promise.reject("Error loading data");
          }
        });
      }
      init(noClear, noAnimateLines) {
        if (this.isDeleted) {
          return;
        }
        if (this.modelOnly) {
          return this.createGraph(noAnimateLines);
        }
        let startTs = (/* @__PURE__ */ new Date()).getTime();
        let uuid = uuidv4();
        this.uuid = uuid;
        if (this.svg && !noClear) {
          this.clearDown();
        }
        let self2 = this;
        self2.dataStart = self2.start ? self2.start : moment().startOf(self2.startOf).unix();
        self2.dataEnd = self2.realTime ? Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) : self2.end;
        return this.loadData().then(function(rez) {
          let results = rez.results;
          let cResults = rez.cResults;
          if (uuid === self2.uuid) {
            if (self2.isDeleted) {
              return;
            }
            let color2 = d3.scaleOrdinal().domain(results.map((r, i) => i * (self2.dataTypes ? self2.dataTypes.length : 1))).range(d3.schemeSet1);
            self2.datas = results.map(function(result, index3) {
              let returnResult = {
                name: self2.assetData[index3].name,
                id: self2.assetData[index3].id,
                hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                data: result.list.map((r) => ({
                  date: parseTime(r.time),
                  value: r.value
                })),
                color: "#49b9c4"
              };
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
              }
              return returnResult;
            });
            if (self2.combined) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                    total += matchedRecord.value;
                    count3++;
                  }
                });
                return {
                  value: count3 > 0 ? total : null,
                  date: datum2.date
                };
              });
              self2.datas = [{
                name: "Total",
                id: "total",
                data: totalData,
                hidden: false,
                color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
              }];
            } else if (self2.average) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                    total += matchedRecord.value;
                    count3++;
                  }
                });
                return {
                  value: count3 > 0 ? total / count3 : null,
                  date: datum2.date
                };
              });
              self2.datas = [{
                name: "Average",
                id: "average",
                data: totalData,
                hidden: false,
                color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
              }];
            }
            if (cResults) {
              self2.compareDatas = cResults.map(function(result, index3) {
                let returnResult = {
                  name: self2.assetData[index3].name,
                  id: self2.assetData[index3].id,
                  hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                  data: result.list.map((r) => ({
                    date: parseTime(r.time),
                    value: self2.isSensors ? r.value : r.demand
                  })),
                  color: self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3)
                };
                if (self2.dataTypes && self2.dataTypes.length > 1) {
                  returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
                }
                return returnResult;
              });
              if (self2.combined) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  });
                  return {
                    value: count3 > 0 ? total : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [{
                  name: "Total",
                  id: "total",
                  data: totalData,
                  hidden: false,
                  color: "#e7e7e7"
                }];
              } else if (self2.average) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  });
                  return {
                    value: count3 > 0 ? total / count3 : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [{
                  name: "Average",
                  id: "average",
                  data: totalData,
                  hidden: false,
                  color: "#e7e7e7"
                }];
              }
            }
            if (results.length > 0) {
              if (noAnimateLines) {
                if ((/* @__PURE__ */ new Date()).getTime() - startTs < ANIMATION_TIME) {
                  setTimeout(function() {
                    self2.render(false, noAnimateLines);
                  }, ANIMATION_TIME - (/* @__PURE__ */ new Date()).getTime() + startTs);
                } else {
                  self2.createGraph(noAnimateLines);
                }
              } else {
                self2.createGraph(noAnimateLines);
              }
            }
          }
        }).catch(function(e) {
          self2.error(e);
        });
      }
      createGraph(noAnimateLines) {
        let self2 = this;
        let visibleItems;
        if (!self2.modelOnly) {
          visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null && a4.value !== void 0 || a4.value2 !== null && a4.value2 !== void 0).length > 0);
          if (this.onVisibleItems) {
            this.onVisibleItems(visibleItems);
          }
        }
        if (this.onReady && !this.isDeleted) {
          this.onReady();
        }
        if (!self2.modelOnly) {
          if (visibleItems.length === 0) {
            this.clearDown();
            return;
          }
        }
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender(false, noAnimateLines);
          });
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender(false, noAnimateLines);
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(self2.d3Element.node().parentNode, {
            childList: true,
            subtree: true
          });
        }
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((node) => node.parentNode === target);
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      remove() {
        this.clearDown();
        this.deleted();
        if (document.getElementById(this.uuid)) {
          document.getElementById(this.uuid).remove();
        }
      }
      deleted() {
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.avgDiv) {
          this.avgDiv.remove();
        }
        if (this.maxDiv) {
          this.maxDiv.remove();
        }
        if (this.minDiv) {
          this.minDiv.remove();
        }
      }
      clearDown(ignoreLegend) {
        if (this.svg) {
          this.svg.remove();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.svg = null;
        if (!ignoreLegend) {
          if (this.legendDiv) {
            this.legendDiv.remove();
          }
        }
      }
      calcSizes() {
        let newWidth = this.d3Element.node().clientWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().clientHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      render(ignoreLegend, noAnimateLines, noAdjustScales) {
        let self2 = this;
        if (this.isDeleted) {
          return;
        }
        if (!this.modelOnly) {
          let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null || a4.value2 !== null).length > 0);
          if (visibleItems.length === 0) {
            return;
          }
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        self2.lastRendered = (/* @__PURE__ */ new Date()).getTime();
        if (!this.fixedSize) {
          let changed = this.calcSizes();
          if (changed && this.svg) {
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("svg").attr("id", this.uuid).attr("class", "gd-graph gd-graph-line-graph").attr("width", "100%").attr("height", "100%");
          this.svg.append("defs").append("svg:clipPath").attr("id", "clip-" + this.uuid).append("svg:rect").attr("width", "100%").attr("height", "100%").attr("x", 0).attr("y", 0);
          this.graph = this.svg.append("g").attr("transform", "translate(" + MARGIN.left + "," + MARGIN.top + ")");
          this.graphContent = this.graph.append("g").attr("clip-path", "url(#clip-" + this.uuid + ")");
          this.overlay = this.svg.append("g").attr("transform", "translate(" + MARGIN.left + "," + MARGIN.top + ")");
          this.graph.append("g").attr("transform", "translate(" + this.width + ",0)").attr("class", "axis-right");
          this.graph.append("g").attr("transform", "translate(0," + this.height + ")").attr("class", "axis-bottom");
          this.graph.append("g").attr("class", "axis-left");
          this.graph.append("g").attr("class", "grid").style("stroke-opacity", "0.7").style("stroke", "lightgrey").style("shape-rendering", "crispEdges").style("stroke-dasharray", "3 3");
        }
        let yMax = 0;
        let yMin = 0;
        let thisData;
        if (!self2.modelOnly) {
          thisData = this.datas.filter((d) => !d.hidden).map((d) => d.data).flat();
          yMax = d3.max(thisData, function(d) {
            return d.value;
          });
          yMin = d3.min(thisData, function(d) {
            return d.value;
          });
        }
        if (this.modelData && this.modelData.trainingResults) {
          let momentStart = new Date(self2.dataStart * 1e3);
          let momentEnd = new Date(self2.dataEnd * 1e3);
          let convertedDayStart = momentStart.getUTCDay() - 1;
          if (convertedDayStart === -1) {
            convertedDayStart = 6;
          }
          let hourInWeekStart = momentStart.getUTCHours() + convertedDayStart * 24;
          let convertedDayEnd = momentEnd.getUTCDay() - 1;
          if (convertedDayEnd === -1) {
            convertedDayEnd = 6;
          }
          let hourInWeekEnd = momentStart.getUTCHours() + convertedDayStart * 24;
          let upperDataFiltered = this.modelData.trainingResults.upper_data.slice(hourInWeekStart, hourInWeekEnd + 1);
          let lowerDataFiltered = this.modelData.trainingResults.lower_data.slice(hourInWeekStart, hourInWeekEnd + 1);
          let yMaxModel = d3.max(upperDataFiltered);
          let yMinModel = d3.min(lowerDataFiltered);
          if (self2.modelOnly) {
            yMax = Math.max(yMax, yMaxModel);
            yMin = Math.min(yMin, yMinModel);
          }
        }
        if (!self2.modelOnly) {
          let xMax = d3.max(thisData, function(d) {
            return d.date;
          });
          self2.xMax = xMax;
          let xMin = d3.min(thisData, function(d) {
            return d.date;
          });
        }
        if (!noAdjustScales && (!this.zoom || !noAnimateLines || this.yScaler && (this.yScaler(yMax) < 0 || this.yScaler(yMin) > this.height))) {
          this.xScaler = d3.scaleTime().range([0, this.width]);
          this.yScaler = d3.scaleLinear().range([this.height, 0]);
          if (this.modelOnly) {
            this.xScaler.domain([0, 168]);
          } else {
            this.xScaler.domain(d3.extent(this.datas.map((d) => d.data).flat(), function(d) {
              return d.date;
            }));
          }
          if (this.compareDatas) {
            this.xScalerCompare = d3.scaleTime().range([0, this.width]);
            this.xScalerCompare.domain(d3.extent(this.compareDatas.map((d) => d.data).flat(), function(d) {
              return d.date;
            }));
          }
          let yMax2;
          let yMin2;
          if (this.datas) {
            let datas = this.datas;
            if (this.compareDatas) {
              datas = datas.concat(this.compareDatas);
            }
            yMax2 = d3.max(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d.value;
            });
            yMin2 = d3.min(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d.value;
            });
          }
          if (this.modelData && this.modelData.trainingResults) {
            let momentStart = new Date(self2.dataStart * 1e3);
            let momentEnd = new Date(self2.dataEnd * 1e3);
            let convertedDayStart = momentStart.getUTCDay() - 1;
            if (convertedDayStart === -1) {
              convertedDayStart = 6;
            }
            let hourInWeekStart = momentStart.getUTCHours() + convertedDayStart * 24;
            let convertedDayEnd = momentEnd.getUTCDay() - 1;
            if (convertedDayEnd === -1) {
              convertedDayEnd = 6;
            }
            let hourInWeekEnd = momentStart.getUTCHours() + convertedDayStart * 24;
            let upperDataFiltered = this.modelData.trainingResults.upper_data.slice(hourInWeekStart, hourInWeekEnd + 1);
            let lowerDataFiltered = this.modelData.trainingResults.lower_data.slice(hourInWeekStart, hourInWeekEnd + 1);
            let yMaxModel = d3.max(upperDataFiltered);
            let yMinModel = d3.min(lowerDataFiltered);
          }
          if (this.modelOnly) {
            yMin2 = d3.min(this.modelData.trainingResults.lower_data);
            yMax2 = d3.max(this.modelData.trainingResults.upper_data);
          }
          if (yMax2 <= 0 && yMin2 < 0) {
            self2.completelyNegative = true;
            self2.symmetrical = false;
            this.yScaler.domain([yMin2 * 1.2, 0]);
          } else if (yMin2 < 0 && yMax2 > 0) {
            self2.symmetrical = true;
            self2.completelyNegative = false;
            const minValue = Math.min(0, yMin2);
            const maxValue = Math.max(0, yMax2);
            this.yScaler.domain([minValue, maxValue]);
          } else if (yMin2 === yMax2 && yMin2 === 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, 1]);
          } else if (yMin2 > 0 && yMax2 > 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, yMax2 * 1.2]);
          } else {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([yMin2 * 1.2, yMax2 * 1.2]);
          }
        }
        if (!noAnimateLines) {
          self2.oldYScaler = self2.yScaler;
        }
        if (!self2.modelOnly) {
          this.createValueArea(noAnimateLines);
        }
        if (this.modelData && this.modelData.trainingResults) {
          this.createModelThresholds();
        }
      }
      createModelThresholds() {
        let self2 = this;
        if (self2.modelOnly) {
          for (let i = 0; i < 7 * 24; i++) {
            let upperThreshold = this.modelData.trainingResults.upper_data[i];
            let lowerThreshold = this.modelData.trainingResults.lower_data[i];
            let thresholdStartX = self2.xScaler(i);
            let thresholdEndX = self2.xScaler(i + 1);
            let innerThresholdRect = self2.graphContent.append("rect").attr("x", thresholdStartX).attr("y", self2.yScaler(upperThreshold)).attr("width", thresholdEndX - thresholdStartX).attr("height", self2.yScaler(lowerThreshold) - self2.yScaler(upperThreshold)).style("opacity", "0.25").attr("fill", "#32CD32");
          }
          if (self2.anomalyValue !== void 0) {
            let convertedDay = new Date(self2.anomalyTs * 1e3).getUTCDay() - 1;
            if (convertedDay === -1) {
              convertedDay = 6;
            }
            let hourInWeek = new Date(self2.anomalyTs * 1e3).getUTCHours() + convertedDay * 24;
            let upperThreshold = this.modelData.trainingResults.upper_data[hourInWeek];
            let lowerThreshold = this.modelData.trainingResults.lower_data[hourInWeek];
            let x4 = self2.xScaler(hourInWeek) + (self2.xScaler(hourInWeek + 1) - self2.xScaler(hourInWeek)) / 2;
            self2.graphContent.append("circle").attr("cx", x4).attr("cy", self2.yScaler(self2.anomalyValue)).attr("r", (self2.xScaler(hourInWeek + 1) - self2.xScaler(hourInWeek)) / 2).style("opacity", "0.5").attr("fill", "#ff4500");
          }
        } else {
          let curTs = this.dataStart;
          while (curTs <= this.dataEnd) {
            let momentStart = moment(curTs * 1e3).startOf("hour");
            let momentEnd = moment(curTs * 1e3).add(1, "minute").endOf("hour");
            let maxEndUnix = Math.min(this.dataEnd, momentEnd.unix());
            let fixedMomentEnd = moment(maxEndUnix * 1e3);
            let convertedDay = new Date(curTs * 1e3).getUTCDay() - 1;
            if (convertedDay === -1) {
              convertedDay = 6;
            }
            let hourInWeek = new Date(curTs * 1e3).getUTCHours() + convertedDay * 24;
            let upperThreshold = this.modelData.trainingResults.upper_data[hourInWeek];
            let lowerThreshold = this.modelData.trainingResults.lower_data[hourInWeek];
            let thresholdStartX = self2.xScaler(new Date(momentStart.unix() * 1e3));
            let thresholdEndX = self2.xScaler(new Date(fixedMomentEnd.unix() * 1e3));
            if (this.invertModelBand) {
              let innerThresholdRect = self2.graphContent.append("rect").attr("x", thresholdStartX).attr("y", self2.yScaler(upperThreshold)).attr("width", thresholdEndX - thresholdStartX).attr("height", self2.yScaler(lowerThreshold) - self2.yScaler(upperThreshold)).style("opacity", "0.25").attr("fill", "#32CD32");
            }
            if (this.outerModelBand) {
              let upperThresholdRect = self2.graphContent.append("rect").attr("x", thresholdStartX).attr("y", 0).attr("width", thresholdEndX - thresholdStartX).attr("height", self2.yScaler(upperThreshold)).style("opacity", "0.35").attr("fill", "#ff4500");
              let lowerThresholdRect = self2.graphContent.append("rect").attr("x", thresholdStartX).attr("y", self2.yScaler(lowerThreshold)).attr("width", thresholdEndX - thresholdStartX).attr("height", self2.height - self2.yScaler(lowerThreshold)).style("opacity", "0.35").attr("fill", "#ff4500");
            }
            momentEnd.add(1, "hour");
            curTs = momentEnd.startOf("hour").unix();
          }
        }
      }
      createValueArea(noAnimateLines) {
        let self2 = this;
        let anyHighlighted = self2.datas.filter((d) => d.highlighted).length > 0;
        let animateDuration = ANIMATION_TIME;
        let data = self2.datas.map((d) => d.data);
        if (noAnimateLines && !self2.zoom) {
          animateDuration = 0;
        }
        let lines = self2.graphContent.selectAll(".line").data(self2.datas.map((d) => d.data));
        let line = d3.line().curve(d3.curveLinear).x(function(d) {
          return self2.xScaler(d.date);
        }).defined(function(d) {
          return d.value !== null;
        }).y(function(d) {
          return self2.yScaler(d.value);
        });
        lines.exit().remove();
        let anomalyStartX = self2.xScaler(new Date(self2.anomalyStart * 1e3));
        let anomalyEndX = self2.xScaler(new Date(self2.anomalyEnd * 1e3));
        let anomalousRegion = self2.graphContent.append("rect").attr("x", anomalyStartX).attr("y", 0).attr("width", anomalyEndX - anomalyStartX).attr("height", self2.height).style("opacity", "0.18").attr("fill", "#FF7900");
        let leftAnomalousLine = self2.graphContent.append("line").attr("x1", anomalyStartX).attr("y1", 0).attr("x2", anomalyStartX).attr("y2", self2.height).style("stroke", "#FF7900").style("stroke-dasharray", "3, 3").style("stroke-width", 1);
        if (self2.anomaly.endTs) {
          let rightAnomalousLine = self2.graphContent.append("line").attr("x1", anomalyEndX).attr("y1", 0).attr("x2", anomalyEndX).attr("y2", self2.height).style("stroke", "#FF7900").style("stroke-dasharray", "3, 3").style("stroke-width", 1);
        }
        lines.enter().append("path").style("fill", "none").style("stroke", function(d, i) {
          return self2.datas[i].color;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "1px" : self2.datas[i].highlighted ? "1px" : "1px";
        }).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        }).attr("d", line);
        lines.transition().duration(animateDuration).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "2px" : self2.datas[i].highlighted ? "2px" : "1px";
        }).attr("d", line).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        });
      }
      throttledRender(ignoreLegend, noAnimateLines, noAdjustScales) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (self2.throttled || (self2.throttled[0] !== ignoreLegend || self2.throttled[1] !== noAnimateLines || self2.throttled[2] !== noAdjustScales)) {
            self2.throttled = [ignoreLegend, noAnimateLines, noAdjustScales];
            setTimeout(function() {
              self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
        }
      }
      createLegends() {
        let self2 = this;
        let legendElement = d3Select.select(self2.legendElement);
        if (self2.legendDiv) {
          self2.legendDiv.remove();
        }
        self2.legendDiv = legendElement.append("div").attr("class", "gd-graph-legend");
        let width = legendElement.node().offsetWidth;
        const WIDTH_PER_LEGEND = 150;
        let itemsAllowed = Math.floor(width / WIDTH_PER_LEGEND);
        let showShowMore = false;
        if (itemsAllowed < self2.datas.length) {
          itemsAllowed--;
          showShowMore = self2.datas.length - itemsAllowed;
        }
        let expandedLegendElement;
        if (showShowMore && self2.legendDiv) {
          expandedLegendElement = self2.legendDiv.append("div").attr("class", "expanded-legend").style("height", showShowMore * 30 + "px").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          }).on("mouseout", function() {
            expandedLegendElement.attr("class", "expanded-legend");
          });
        }
        self2.datas.forEach(function(assetDatum, index3) {
          let divToAttach = self2.legendDiv;
          if (index3 >= itemsAllowed) {
            divToAttach = expandedLegendElement;
          }
          if (self2.dataTypes && self2.dataTypes.length > 1) {
            let thisLegendElement1 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement1.attr("class", "legend-element hidden");
              } else {
                thisLegendElement1.attr("class", "legend-element");
              }
            });
            thisLegendElement1.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement1.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[0].charAt(0).toUpperCase() + self2.dataTypes[0].slice(1));
            let thisLegendElement2 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted2 = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted2 = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden2 = assetDatum.hidden2 ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden2) {
                thisLegendElement2.attr("class", "legend-element hidden");
              } else {
                thisLegendElement2.attr("class", "legend-element");
              }
            });
            thisLegendElement2.append("div").attr("class", "legend-box").style("background-color", assetDatum.color2);
            thisLegendElement2.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[1].charAt(0).toUpperCase() + self2.dataTypes[1].slice(1));
          } else {
            let thisLegendElement = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement.attr("class", "legend-element hidden");
              } else {
                thisLegendElement.attr("class", "legend-element");
              }
            });
            thisLegendElement.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement.append("div").attr("class", "legend-label").html(assetDatum.name);
          }
        });
        if (showShowMore && self2.legendDiv) {
          let showMoreElement = self2.legendDiv.append("div").attr("class", "show-more").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          });
          showMoreElement.append("div").attr("class", "show-more-button").html("+");
          showMoreElement.append("div").attr("class", "show-more-text").html(showShowMore + " more");
        }
      }
      resetZoom() {
        let self2 = this;
        if (!self2.zoom) {
          return;
        }
        if (this.brusherLocked) {
          return;
        }
        self2.zoom = null;
        let noAnimate = false;
        if (self2.datas[0].data.length < self2.preZoomDatas[0].data.length) {
          noAnimate = true;
        }
        self2.datas = self2.preZoomDatas;
        self2.compareDatas = self2.preZoomCompareDatas;
        self2.throttledRender(false, noAnimate, false);
        if (self2.zoomCallback) {
          self2.zoomCallback(self2.zoom);
        }
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let reRender = false;
        let redoKPI = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.granularity !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          reInit = true;
        }
        if (params.compareTo !== void 0) {
          self2.compareTo = params.compareTo;
          self2.compareDatas = null;
          self2.comparedResults = null;
          reInit = true;
        }
        if (params.hidden !== void 0 && params.hidden !== null) {
          self2.hidden = params.hidden;
          self2.datas.forEach(function(datum2) {
            if (params.hidden.indexOf(datum2.id) !== -1) {
              datum2.hidden = true;
            } else {
              datum2.hidden = false;
            }
          });
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted !== void 0) {
          self2.highlighted = params.highlighted;
          self2.datas.forEach(function(datum2) {
            if (params.highlighted.indexOf(datum2.id) !== -1) {
              datum2.highlighted = true;
            } else {
              datum2.highlighted = false;
            }
          });
          reRender = true;
        }
        if (reInit) {
          self2.zoom = null;
          self2.init();
        } else if (reRender) {
          self2.throttledRender(false, false, false);
        }
      }
    };
    module2.exports = Anomaly2;
  }
});

// src/graphs/anomalyModel.js
var require_anomalyModel = __commonJS({
  "src/graphs/anomalyModel.js"(exports2, module2) {
    var getFormat = require_util().getFormat;
    var getFormatDate = require_util().getFormatDate;
    var parseTime = require_util().parseTime;
    var readyPromise = require_util().readyPromise;
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var moment = require_moment();
    var ANIMATION_TIME = 300;
    var GridDuck2;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var Brusher = require_brusher();
    var MARGIN = { top: 0, right: 10, bottom: 0, left: 10 };
    var AnomalyModel2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        let self2 = this;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        if (params.windowWidth) {
          this.width = params.windowWidth;
          this.height = params.windowHeight;
          this.fixedSize = true;
        }
        if (!params.element) {
          throw Error("No element defined");
        }
        if (params.averageType) {
          this.averageType = params.averageType;
        } else {
          this.averageType = "average";
        }
        this.color = params.color;
        this.widget = params.widget;
        this.average = params.average;
        if (this.widget) {
          MARGIN.left = 20;
          ANIMATION_TIME = 0;
        } else {
          MARGIN.left = 70;
          ANIMATION_TIME = 300;
        }
        this.timezone = params.timezone;
        this.error = function(e) {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error(e);
          }
        };
        if (params.anomalyId) {
          this.anomalyId = params.anomalyId;
        }
        if (params.anomaly) {
          this.anomaly = params.anomaly;
        }
        if (params.showArea !== false) {
          this.showArea = true;
        }
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        if (params.summaryElement) {
          this.summaryElement = params.summaryElement;
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.hidden) {
          this.hidden = params.hidden;
        } else {
          this.hidden = [];
        }
        if (params.granularity) {
          this.granularity = params.granularity;
        }
        if (params.onVisibleItems) {
          this.onVisibleItems = params.onVisibleItems;
        }
        this.end = params.end;
        this.isMobile = params.isMobile;
        this.startOf = params.startOf;
        this.combined = params.combined;
        this.start = params.start;
        this.isDeleted = false;
        this.element = params.element;
        this.zoomCallback = params.zoomCallback;
        this.resetZoom = this.resetZoom.bind(this);
        readyPromise.then(function() {
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          self2.init();
        });
      }
      async loadData() {
        let self2 = this;
        if (!this.anomaly) {
          this.anomaly = await GridDuck2.getAnomaly({
            id: self2.anomalyId
          });
        }
        let gap = (!this.anomaly.endTs ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : this.anomaly.endTs) - this.anomaly.startTs;
        self2.dataStart = Math.round(this.anomaly.startTs - gap * 1.5);
        self2.anomalyStart = this.anomaly.startTs;
        if (!this.anomaly.endTs) {
          self2.dataEnd = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
          self2.anomalyEnd = (/* @__PURE__ */ new Date()).getTime() / 1e3;
        } else {
          self2.dataEnd = Math.round(Math.min((/* @__PURE__ */ new Date()).getTime() / 1e3, this.anomaly.endTs + gap * 1.5));
          self2.anomalyEnd = this.anomaly.endTs;
        }
        self2.dataTypes = ["CONSUMPTION"];
        self2.assets = [{ id: this.anomaly.deviceId }];
        let dataType = self2.dataTypes[0];
        let promises = [];
        let filters = [
          {
            field: "dataType",
            value: dataType
          },
          {
            field: "start",
            value: self2.zoom ? Math.round(self2.zoom.start.getTime() / 1e3) - 120 : self2.dataStart
          },
          {
            field: "end",
            value: self2.zoom ? Math.round(self2.zoom.end.getTime() / 1e3) + 120 : self2.dataEnd
          },
          {
            field: "type",
            value: self2.averageType
          }
        ];
        if (self2.assets) {
          filters.push({
            field: "assetId",
            value: self2.assets.map((a4) => a4.id).join(",")
          });
        } else {
          filters.push({
            field: "assetId",
            value: "filtered"
          });
          filters.push({
            field: self2.filterType,
            value: self2.filterId
          });
        }
        promises.push(GridDuck2.getAssetTelemetryBatchs({
          filters
        }).then(function(res) {
          self2.assetData = res.list.map((d) => ({ name: d.assetName, id: d.assetId, parent: d.parent }));
          return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
        }).catch(self2.error));
        if (self2.compareTo) {
          let compareFilters = [
            {
              field: "dataType",
              value: dataType
            },
            {
              field: "start",
              value: self2.zoom ? Math.round(self2.zoom.startCompare.getTime() / 1e3) - 120 : self2.compareTo.start
            },
            {
              field: "end",
              value: self2.zoom ? Math.round(self2.zoom.endCompare.getTime() / 1e3) + 120 : self2.compareTo.end
            },
            {
              field: "type",
              value: self2.averageType
            }
          ];
          if (self2.assets) {
            compareFilters.push({
              field: "assetId",
              value: self2.assets.map((a4) => a4.id).join(",")
            });
          } else {
            compareFilters.push({
              field: "assetId",
              value: "filtered"
            });
            compareFilters.push({
              field: self2.filterType,
              value: self2.filterId
            });
          }
          promises.push(GridDuck2.getAssetTelemetryBatchs({
            filters: compareFilters
          }).then(function(res) {
            return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
          }).catch(self2.error));
        }
        return Promise.all(promises).then(function(res) {
          if (res && res[0]) {
            return Promise.resolve({
              results: res[0],
              cResults: res[1]
            });
          } else {
            return Promise.reject("Error loading data");
          }
        });
      }
      init(noClear, noAnimateLines) {
        if (this.isDeleted) {
          return;
        }
        let startTs = (/* @__PURE__ */ new Date()).getTime();
        let uuid = uuidv4();
        this.uuid = uuid;
        if (this.svg && !noClear) {
          this.clearDown();
        }
        let self2 = this;
        self2.dataStart = self2.start ? self2.start : moment().startOf(self2.startOf).unix();
        self2.dataEnd = self2.realTime ? Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) : self2.end;
        return this.loadData().then(function(rez) {
          let results = rez.results;
          let cResults = rez.cResults;
          if (uuid === self2.uuid) {
            if (self2.isDeleted) {
              return;
            }
            let color2 = d3.scaleOrdinal().domain(results.map((r, i) => i * (self2.dataTypes ? self2.dataTypes.length : 1))).range(d3.schemeSet1);
            self2.datas = results.map(function(result, index3) {
              let returnResult = {
                name: self2.assetData[index3].name,
                id: self2.assetData[index3].id,
                hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                data: result.list.map((r) => ({
                  date: parseTime(r.time),
                  value: r.value
                })),
                color: "#49b9c4"
              };
              if (self2.dataTypes && self2.dataTypes.length > 1) {
                returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
              }
              return returnResult;
            });
            if (self2.combined) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                    total += matchedRecord.value;
                    count3++;
                  }
                });
                return {
                  value: count3 > 0 ? total : null,
                  date: datum2.date
                };
              });
              self2.datas = [
                {
                  name: "Total",
                  id: "total",
                  data: totalData,
                  hidden: false,
                  color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
                }
              ];
            } else if (self2.average) {
              let totalData = self2.datas[0].data.map(function(datum2, i) {
                let total = 0;
                let count3 = 0;
                self2.datas.forEach(function(asset) {
                  let matchedRecord = asset.data[i];
                  if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                    total += matchedRecord.value;
                    count3++;
                  }
                });
                return {
                  value: count3 > 0 ? total / count3 : null,
                  date: datum2.date
                };
              });
              self2.datas = [
                {
                  name: "Average",
                  id: "average",
                  data: totalData,
                  hidden: false,
                  color: self2.color ? self2.color : self2.assetData[0].color ? self2.assetData[0].color : color2(0)
                }
              ];
            }
            if (cResults) {
              self2.compareDatas = cResults.map(function(result, index3) {
                let returnResult = {
                  name: self2.assetData[index3].name,
                  id: self2.assetData[index3].id,
                  hidden: self2.hidden.indexOf(self2.assetData[index3].id) !== -1,
                  data: result.list.map((r) => ({
                    date: parseTime(r.time),
                    value: self2.isSensors ? r.value : r.demand
                  })),
                  color: self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3)
                };
                if (self2.dataTypes && self2.dataTypes.length > 1) {
                  returnResult.color = self2.assetData[index3].color ? self2.assetData[index3].color : color2(index3 * 2);
                }
                return returnResult;
              });
              if (self2.combined) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== void 0 && matchedRecord.value !== null) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  });
                  return {
                    value: count3 > 0 ? total : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [
                  {
                    name: "Total",
                    id: "total",
                    data: totalData,
                    hidden: false,
                    color: "#e7e7e7"
                  }
                ];
              } else if (self2.average) {
                let totalData = self2.compareDatas[0].data.map(function(datum2, i) {
                  let total = 0;
                  let count3 = 0;
                  self2.compareDatas.forEach(function(asset) {
                    let matchedRecord = asset.data[i];
                    if (matchedRecord && matchedRecord.date.toString() === datum2.date.toString() && matchedRecord.value !== null && matchedRecord.value !== void 0) {
                      total += matchedRecord.value;
                      count3++;
                    }
                  });
                  return {
                    value: count3 > 0 ? total / count3 : null,
                    date: datum2.date
                  };
                });
                self2.compareDatas = [
                  {
                    name: "Average",
                    id: "average",
                    data: totalData,
                    hidden: false,
                    color: "#e7e7e7"
                  }
                ];
              }
            }
            if (results.length > 0) {
              if (noAnimateLines) {
                if ((/* @__PURE__ */ new Date()).getTime() - startTs < ANIMATION_TIME) {
                  setTimeout(function() {
                    self2.render(false, noAnimateLines);
                  }, ANIMATION_TIME - (/* @__PURE__ */ new Date()).getTime() + startTs);
                } else {
                  self2.createGraph(noAnimateLines);
                }
              } else {
                self2.createGraph(noAnimateLines);
              }
            }
          }
        }).catch(function(e) {
          self2.error(e);
        });
      }
      generateKPIs() {
        let self2 = this;
        let hiddenIds = self2.datas.filter((d) => d.hidden || d.data === null).map((d) => d.id);
        let kpiData = {};
        this.dataTypes.forEach(function(dataType, index3) {
          let dataField = index3 === 0 ? "value" : "value2";
          if (self2.averageType === "average") {
            let average = Math.round(self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
              return r + a4.data.map((b, i) => b[dataField]).reduce((v2, m3) => v2 + m3, 0);
            }, 0) / self2.datas.filter((d) => !d.hidden).reduce(function(r, a4) {
              return r + a4.data.map((b, i) => b[dataField] !== null ? 1 : 0).reduce((v2, m3) => v2 + m3, 0);
            }, 0));
            kpiData[dataType.toLowerCase() + "Avg"] = {
              value: getFormat(dataType.toLowerCase())(average),
              rawValue: average,
              dataType: dataType.toLowerCase()
            };
          } else if (self2.averageType === "max") {
            let max5 = d3.max(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d[dataField];
            });
            kpiData[dataType.toLowerCase() + "Max"] = {
              value: getFormat(dataType.toLowerCase())(max5),
              rawValue: max5,
              dataType: dataType.toLowerCase()
            };
          } else if (self2.averageType === "min") {
            let min4 = d3.min(self2.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
              return d[dataField];
            });
            kpiData[dataType.toLowerCase() + "Min"] = {
              value: getFormat(dataType.toLowerCase())(min4),
              rawValue: min4,
              dataType: dataType.toLowerCase()
            };
          }
        });
        if (this.onKPIData) {
          this.onKPIData(kpiData);
        }
      }
      createGraph(noAnimateLines) {
        let self2 = this;
        let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null && a4.value !== void 0 || a4.value2 !== null && a4.value2 !== void 0).length > 0);
        if (this.onVisibleItems) {
          this.onVisibleItems(visibleItems);
        }
        if (this.onReady && !this.isDeleted) {
          this.onReady();
        }
        if (visibleItems.length > 0) {
          self2.generateKPIs();
        } else {
          this.clearDown();
          return;
        }
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender(false, noAnimateLines);
          });
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender(false, noAnimateLines);
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(
            self2.d3Element.node().parentNode,
            {
              childList: true,
              subtree: true
            }
          );
        }
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((node) => node.parentNode === target);
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      remove() {
        this.clearDown();
        this.deleted();
        if (document.getElementById(this.uuid)) {
          document.getElementById(this.uuid).remove();
        }
      }
      deleted() {
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.avgDiv) {
          this.avgDiv.remove();
        }
        if (this.maxDiv) {
          this.maxDiv.remove();
        }
        if (this.minDiv) {
          this.minDiv.remove();
        }
      }
      clearDown(ignoreLegend) {
        if (this.svg) {
          this.svg.remove();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.svg = null;
        if (!ignoreLegend) {
          if (this.legendDiv) {
            this.legendDiv.remove();
          }
        }
      }
      calcSizes() {
        let newWidth = this.d3Element.node().clientWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().clientHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      render(ignoreLegend, noAnimateLines, noAdjustScales) {
        if (this.isDeleted) {
          return;
        }
        let visibleItems = this.datas.filter((d) => d.data !== null && d.data.filter((a4) => a4.value !== null || a4.value2 !== null).length > 0);
        if (visibleItems.length === 0) {
          return;
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        let self2 = this;
        self2.lastRendered = (/* @__PURE__ */ new Date()).getTime();
        if (!this.fixedSize) {
          let changed = this.calcSizes();
          if (changed && this.svg) {
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("svg").attr("id", this.uuid).attr("class", "gd-graph gd-graph-line-graph").attr("width", "100%").attr("height", "100%");
          this.svg.append("defs").append("svg:clipPath").attr("id", "clip").append("svg:rect").attr("width", "100%").attr("height", "100%").attr("x", 0).attr("y", 0);
          this.graph = this.svg.append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.graphContent = this.graph.append("g");
          this.overlay = this.svg.append("g").attr(
            "transform",
            "translate(" + MARGIN.left + "," + MARGIN.top + ")"
          );
          this.graph.append("g").attr("transform", "translate(" + this.width + ",0)").attr("class", "axis-right");
          this.graph.append("g").attr("transform", "translate(0," + this.height + ")").attr("class", "axis-bottom");
          this.graph.append("g").attr("class", "axis-left");
          this.graph.append("g").attr("class", "grid").style("stroke-opacity", "0.7").style("stroke", "lightgrey").style("shape-rendering", "crispEdges").style("stroke-dasharray", "3 3");
        }
        let thisData = this.datas.filter((d) => !d.hidden).map((d) => d.data).flat();
        let yMax = d3.max(thisData, function(d) {
          return d.value;
        });
        let yMin = d3.min(thisData, function(d) {
          return d.value;
        });
        let xMax = d3.max(thisData, function(d) {
          return d.date;
        });
        let xMin = d3.min(thisData, function(d) {
          return d.date;
        });
        if (self2.zoom) {
          thisData = thisData.filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.start);
          if (this.compareDatas) {
            thisData = thisData.concat(this.compareDatas.map((d) => d.data).flat().filter((d) => d.date <= self2.zoom.endCompare && d.date >= self2.zoom.startCompare));
          }
          yMax = d3.max(thisData, function(d) {
            return d.value;
          });
          yMin = d3.min(thisData, function(d) {
            return d.value;
          });
          xMax = d3.max(thisData, function(d) {
            return d.date;
          });
          xMin = d3.min(thisData, function(d) {
            return d.date;
          });
        }
        if (!noAdjustScales && (!this.zoom || !noAnimateLines || this.yScaler && (this.yScaler(yMax) < 0 || this.yScaler(yMin) > this.height))) {
          this.xScaler = d3.scaleTime().range([0, this.width]);
          this.yScaler = d3.scaleLinear().range([this.height, 0]);
          this.xScaler.domain(d3.extent(this.datas.map((d) => d.data).flat(), function(d) {
            return d.date;
          }));
          if (this.compareDatas) {
            this.xScalerCompare = d3.scaleTime().range([0, this.width]);
            this.xScalerCompare.domain(d3.extent(this.compareDatas.map((d) => d.data).flat(), function(d) {
              return d.date;
            }));
          }
          let datas = this.datas;
          if (this.compareDatas) {
            datas = datas.concat(this.compareDatas);
          }
          let yMax2 = d3.max(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return d.value;
          });
          let yMin2 = d3.min(datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
            return d.value;
          });
          if (self2.zoom) {
            self2.xScaler.domain([self2.zoom.start, self2.zoom.end]);
            if (self2.xScalerCompare) {
              self2.xScalerCompare.domain([self2.zoom.startCompare, self2.zoom.endCompare]);
            }
            yMax2 = d3.max(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.start && d.date <= self2.zoom.end), function(d) {
              return d.value;
            });
            yMin2 = d3.min(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.start && d.date <= self2.zoom.end), function(d) {
              return d.value;
            });
            if (this.compareDatas) {
              let yMaxCompare = d3.max(this.compareDatas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.startCompare && d.date <= self2.zoom.endCompare), function(d) {
                return d.value;
              });
              let yMinCompare = d3.min(this.compareDatas.filter((d) => !d.hidden).map((d) => d.data).flat().filter((d) => d.date >= self2.zoom.startCompare && d.date <= self2.zoom.endCompare), function(d) {
                return d.value;
              });
              yMax2 = Math.max(yMax2, yMaxCompare);
              yMin2 = Math.min(yMin2, yMinCompare);
            }
          }
          if (yMax2 <= 0 && yMin2 < 0) {
            self2.completelyNegative = true;
            self2.symmetrical = false;
            this.yScaler.domain([yMin2 * 1.2, 0]);
          } else if (yMin2 < 0 && yMax2 > 0) {
            self2.symmetrical = true;
            self2.completelyNegative = false;
            const minValue = Math.min(0, yMin2);
            const maxValue = Math.max(0, yMax2);
            this.yScaler.domain([minValue, maxValue]);
          } else if (yMin2 === yMax2 && yMin2 === 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, 1]);
          } else if (yMin2 > 0 && yMax2 > 0) {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([0, yMax2 * 1.2]);
          } else {
            self2.symmetrical = false;
            self2.completelyNegative = false;
            this.yScaler.domain([yMin2 * 1.2, yMax2 * 1.2]);
          }
          if (this.dataTypes && this.dataTypes.length === 2) {
            if (this.dataTypes[1] === "OCCUPANCY") {
              this.yScaler2 = d3.scaleOrdinal().domain([0, 1]).range([this.height, 0]);
            } else {
              let y2Max = d3.max(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return d.value2;
              });
              let y2Min = d3.min(this.datas.filter((d) => !d.hidden).map((d) => d.data).flat(), function(d) {
                return d.value2;
              });
              this.yScaler2 = d3.scaleLinear().range([this.height, 0]);
              this.yScaler2.domain([y2Min / 1.2, y2Max * 1.2]);
            }
          }
        }
        if (!noAnimateLines) {
          self2.oldYScaler = self2.yScaler;
        }
        this.createValueArea(noAnimateLines);
        self2.generateKPIs();
      }
      createValueArea(noAnimateLines) {
        let self2 = this;
        let anyHighlighted = self2.datas.filter((d) => d.highlighted).length > 0;
        let animateDuration = ANIMATION_TIME;
        let data = self2.datas.map((d) => d.data);
        if (noAnimateLines && self2.zoom) {
          let oldNewData = [];
          self2.datas.map((a4) => a4.data).forEach(function(dataSet, i) {
            oldNewData[i] = dataSet.map((a4) => ({
              date: a4.date,
              value: a4.value + 0
            }));
          });
          oldNewData.forEach(function(dataSet, dataIndex) {
            let toSkip = self2.prevZoomData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).length;
            let toSkipRatio = Math.floor(toSkip / dataSet.length);
            dataSet.forEach(function(datum2, idx) {
              if (idx % toSkipRatio === 0) {
                return;
              }
              let nextDatum = self2.prevZoomData.map((d) => d.data)[dataIndex].find((d) => d.date > datum2.date);
              let prevDatum = self2.prevZoomData.map((d) => d.data)[dataIndex][self2.prevZoomData.map((d) => d.data)[dataIndex].indexOf(nextDatum) - 1];
              if (prevDatum && nextDatum) {
                datum2.value = prevDatum.value + (nextDatum.value - prevDatum.value) * ((datum2.date.getTime() - prevDatum.date.getTime()) / (nextDatum.date.getTime() - prevDatum.date.getTime()));
              } else {
                datum2.value = null;
              }
            });
            self2.prevZoomData.map((d) => d.data)[dataIndex].filter((d) => d.date <= self2.zoom.end && d.date >= self2.zoom.end).forEach(function(prevZoomDatum) {
              dataSet.push(prevZoomDatum);
            });
            dataSet.sort((a4, b) => a4.date - b.date);
          });
          let line2 = d3.line().x(function(d) {
            return self2.xScaler(d.date);
          }).defined(function(d) {
            return d.value !== null;
          }).y(function(d) {
            return self2.oldYScaler(d.value);
          });
          let lines2 = self2.graphContent.selectAll(".line").data(oldNewData);
          lines2.transition().duration(0).attr("d", line2);
        }
        if (noAnimateLines && !self2.zoom) {
          animateDuration = 0;
        }
        let lines = self2.graphContent.selectAll(".line").data(self2.datas.map((d) => d.data));
        let line = d3.line().curve(d3.curveLinear).x(function(d) {
          return self2.xScaler(d.date);
        }).defined(function(d) {
          return d.value !== null;
        }).y(function(d) {
          return self2.yScaler(d.value);
        });
        lines.exit().remove();
        let anomalyStartX = self2.xScaler(new Date(self2.anomalyStart * 1e3));
        let anomalyEndX = self2.xScaler(new Date(self2.anomalyEnd * 1e3));
        let anomalousRegion = self2.graphContent.append("rect").attr("x", anomalyStartX).attr("y", 0).attr("width", anomalyEndX - anomalyStartX).attr("height", self2.height).style("opacity", "0.18").attr("fill", "#FF7900");
        let leftAnomalousLine = self2.graphContent.append("line").attr("x1", anomalyStartX).attr("y1", 0).attr("x2", anomalyStartX).attr("y2", self2.height).style("stroke", "#FF7900").style("stroke-dasharray", "3, 3").style("stroke-width", 1);
        if (self2.anomaly.endTs) {
          let rightAnomalousLine = self2.graphContent.append("line").attr("x1", anomalyEndX).attr("y1", 0).attr("x2", anomalyEndX).attr("y2", self2.height).style("stroke", "#FF7900").style("stroke-dasharray", "3, 3").style("stroke-width", 1);
        }
        lines.enter().append("path").style("fill", "none").style("stroke", function(d, i) {
          return self2.datas[i].color;
        }).style("stroke-linejoin", function(d, i) {
          return "round";
        }).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "1px" : self2.datas[i].highlighted ? "1px" : "1px";
        }).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        }).attr("d", line);
        lines.transition().duration(animateDuration).style("stroke-width", function(d, i) {
          return self2.widget || self2.compareTo || true ? "2px" : self2.datas[i].highlighted ? "2px" : "1px";
        }).attr("d", line).attr("class", function(d, i) {
          if (!self2.datas[i].hidden) {
            return "line";
          } else {
            return "line hidden";
          }
        });
      }
      throttledRender(ignoreLegend, noAnimateLines, noAdjustScales) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (self2.throttled || (self2.throttled[0] !== ignoreLegend || self2.throttled[1] !== noAnimateLines || self2.throttled[2] !== noAdjustScales)) {
            self2.throttled = [ignoreLegend, noAnimateLines, noAdjustScales];
            setTimeout(function() {
              self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          self2.render(ignoreLegend, noAnimateLines, noAdjustScales);
        }
      }
      createLegends() {
        let self2 = this;
        let legendElement = d3Select.select(self2.legendElement);
        if (self2.legendDiv) {
          self2.legendDiv.remove();
        }
        self2.legendDiv = legendElement.append("div").attr("class", "gd-graph-legend");
        let width = legendElement.node().offsetWidth;
        const WIDTH_PER_LEGEND = 150;
        let itemsAllowed = Math.floor(width / WIDTH_PER_LEGEND);
        let showShowMore = false;
        if (itemsAllowed < self2.datas.length) {
          itemsAllowed--;
          showShowMore = self2.datas.length - itemsAllowed;
        }
        let expandedLegendElement;
        if (showShowMore && self2.legendDiv) {
          expandedLegendElement = self2.legendDiv.append("div").attr("class", "expanded-legend").style("height", showShowMore * 30 + "px").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          }).on("mouseout", function() {
            expandedLegendElement.attr("class", "expanded-legend");
          });
        }
        self2.datas.forEach(function(assetDatum, index3) {
          let divToAttach = self2.legendDiv;
          if (index3 >= itemsAllowed) {
            divToAttach = expandedLegendElement;
          }
          if (self2.dataTypes && self2.dataTypes.length > 1) {
            let thisLegendElement1 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement1.attr("class", "legend-element hidden");
              } else {
                thisLegendElement1.attr("class", "legend-element");
              }
            });
            thisLegendElement1.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement1.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[0].charAt(0).toUpperCase() + self2.dataTypes[0].slice(1));
            let thisLegendElement2 = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted2 = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted2 = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden2 = assetDatum.hidden2 ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden2) {
                thisLegendElement2.attr("class", "legend-element hidden");
              } else {
                thisLegendElement2.attr("class", "legend-element");
              }
            });
            thisLegendElement2.append("div").attr("class", "legend-box").style("background-color", assetDatum.color2);
            thisLegendElement2.append("div").attr("class", "legend-label").html(assetDatum.name + " - " + self2.dataTypes[1].charAt(0).toUpperCase() + self2.dataTypes[1].slice(1));
          } else {
            let thisLegendElement = divToAttach.append("div").attr("class", "legend-element").on("mouseover", function() {
              assetDatum.highlighted = true;
              self2.throttledRender(true);
            }).on("mouseout", function() {
              assetDatum.highlighted = false;
              self2.throttledRender(true);
            }).on("click", function() {
              assetDatum.hidden = assetDatum.hidden ? false : true;
              self2.throttledRender(true);
              if (assetDatum.hidden) {
                thisLegendElement.attr("class", "legend-element hidden");
              } else {
                thisLegendElement.attr("class", "legend-element");
              }
            });
            thisLegendElement.append("div").attr("class", "legend-box").style("background-color", assetDatum.color);
            thisLegendElement.append("div").attr("class", "legend-label").html(assetDatum.name);
          }
        });
        if (showShowMore && self2.legendDiv) {
          let showMoreElement = self2.legendDiv.append("div").attr("class", "show-more").on("mouseover", function() {
            expandedLegendElement.attr("class", "expanded-legend highlighted");
          });
          showMoreElement.append("div").attr("class", "show-more-button").html("+");
          showMoreElement.append("div").attr("class", "show-more-text").html(showShowMore + " more");
        }
      }
      resetZoom() {
        let self2 = this;
        if (!self2.zoom) {
          return;
        }
        if (this.brusherLocked) {
          return;
        }
        self2.zoom = null;
        let noAnimate = false;
        if (self2.datas[0].data.length < self2.preZoomDatas[0].data.length) {
          noAnimate = true;
        }
        self2.datas = self2.preZoomDatas;
        self2.compareDatas = self2.preZoomCompareDatas;
        self2.throttledRender(false, noAnimate, false);
        if (self2.zoomCallback) {
          self2.zoomCallback(self2.zoom);
        }
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let reRender = false;
        let redoKPI = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.granularity !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          reInit = true;
        }
        if (params.compareTo !== void 0) {
          self2.compareTo = params.compareTo;
          self2.compareDatas = null;
          self2.comparedResults = null;
          reInit = true;
        }
        if (params.hidden !== void 0 && params.hidden !== null) {
          self2.hidden = params.hidden;
          self2.datas.forEach(function(datum2) {
            if (params.hidden.indexOf(datum2.id) !== -1) {
              datum2.hidden = true;
            } else {
              datum2.hidden = false;
            }
          });
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted !== void 0) {
          self2.highlighted = params.highlighted;
          self2.datas.forEach(function(datum2) {
            if (params.highlighted.indexOf(datum2.id) !== -1) {
              datum2.highlighted = true;
            } else {
              datum2.highlighted = false;
            }
          });
          reRender = true;
        }
        if (reInit) {
          self2.zoom = null;
          self2.init();
        } else if (reRender) {
          self2.throttledRender(false, false, false);
          if (redoKPI) {
            self2.generateKPIs();
          }
        }
      }
    };
    module2.exports = AnomalyModel2;
  }
});

// temp_stylePlugin:src/graphs/Heatmap.scss
var init_Heatmap = __esm({
  "temp_stylePlugin:src/graphs/Heatmap.scss"() {
  }
});

// stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/Heatmap.scss
var Heatmap_exports = {};
var init_Heatmap2 = __esm({
  "stylePlugin:/home/runner/work/gridduck/gridduck/gd-graphs/src/graphs/Heatmap.scss"() {
    init_Heatmap();
  }
});

// src/graphs/heatmap.js
var require_heatmap = __commonJS({
  "src/graphs/heatmap.js"(exports2, module2) {
    if (typeof window !== "undefined") {
      init_Heatmap2();
    }
    var readyPromise = require_util().readyPromise;
    var { v4: uuidv4 } = (init_esm_browser(), __toCommonJS(esm_browser_exports));
    var GridDuck2;
    var d3 = (init_src32(), __toCommonJS(src_exports));
    var moment = require_moment();
    var { getFormat } = require_util();
    var UPDATE_INTERVAL = 60 * 1e3;
    var MARGIN = { top: 20, right: 20, bottom: 40, left: 70 };
    var Heatmap2 = class {
      constructor(GDInstance, params) {
        GridDuck2 = GDInstance;
        let self2 = this;
        if (params.windowWidth) {
          this.windowWidth = params.windowWidth;
          this.windowHeight = params.windowHeight;
          this.width = params.windowWidth - MARGIN.left - MARGIN.right;
          this.height = params.windowHeight - MARGIN.top - MARGIN.bottom;
          this.fixedSize = true;
        }
        this.legendSelector = params.legendSelector;
        if (params.window) {
          this.document = params.window.document;
        } else {
          this.document = document;
        }
        this.timezone = params.timezone;
        if (params.windowWidth) {
          this.width = params.windowWidth;
          this.height = params.windowHeight;
          this.fixedSize = true;
        }
        this.onClick = params.onClick;
        if (params.start === void 0 && params.startOf === void 0) {
          throw Error("No start defined");
        }
        if (!params.element) {
          throw Error("No element defined");
        }
        this.onVisibleItems = params.onVisibleItems;
        this.dataTypes = params.dataTypes;
        if (!params.assets) {
          if (!params.filterType || !params.filterId) {
            throw Error("No assets or filtering data selected");
          }
          this.filterType = params.filterType;
          this.filterId = params.filterId;
          this.isSensors = true;
          this.assets = params.sensors;
        } else {
          this.assets = params.assets;
        }
        this.tooltipOverride = params.tooltipOverride;
        this.error = function(e) {
          if (document.getElementById(params.element.substr(1))) {
            document.getElementById(params.element.substr(1)).innerHTML = "";
          }
          if (params.error) {
            params.error(e);
          }
        };
        if (params.showTooltip !== false) {
          this.showTooltip = true;
        }
        if (params.legendElement) {
          this.legendElement = params.legendElement;
        }
        if (params.summaryElement) {
          this.summaryElement = params.summaryElement;
        }
        if (params.onKPIData) {
          this.onKPIData = params.onKPIData;
        }
        if (params.onReady) {
          this.onReady = params.onReady;
        }
        if (params.hidden) {
          this.hidden = params.hidden;
        }
        this.end = params.end;
        this.combined = params.combined;
        this.start = params.start;
        this.element = params.element;
        readyPromise.then(function() {
          if (params.window) {
            self2.d3Element = d3.select(params.window.document).select(self2.element);
          } else {
            self2.d3Element = d3.select(self2.element);
          }
          self2.init();
        });
      }
      loadData() {
        let self2 = this;
        if (self2.paramsData) {
          self2.assetData = self2.assets;
          if (self2.paramsCompareData) {
            return Promise.resolve({
              results: self2.paramsData
            });
          } else {
            return Promise.resolve({
              results: self2.paramsData
            });
          }
        }
        let dataType = self2.dataTypes[0] || "DELIVERED";
        let promises = [];
        let filters = [
          {
            field: "dataType",
            value: dataType
          },
          {
            field: "start",
            value: self2.start
          },
          {
            field: "end",
            value: self2.end
          },
          {
            field: "granularity",
            value: 3600
          }
        ];
        if (self2.assets) {
          filters.push({
            field: "assetId",
            value: self2.assets.map((a4) => a4.id).join(",")
          });
        } else {
          filters.push({
            field: "assetId",
            value: "filtered"
          });
          filters.push({
            field: self2.filterType,
            value: self2.filterId
          });
        }
        promises.push(GridDuck2.getAssetConsumptionBatchs({
          filters
        }).then(function(res) {
          if (self2.combined && res.list.length > 1) {
            res.list = res.list.filter((r) => !res.list.find((a4) => a4.asset_id === r.parent));
          }
          self2.assetData = res.list.map((d) => ({ name: d.assetName, parent: d.parent, id: d.assetId }));
          return Promise.resolve(res.list.map((r) => ({ list: r.telemetry })));
        }).catch(self2.error));
        return Promise.all(promises).then(function(res) {
          if (res && res[0]) {
            if (res[0].length === 0) {
              if (self2.onVisibleItems) {
                self2.onVisibleItems([]);
              }
              return;
            }
            return Promise.resolve({
              results: res[0] ? JSON.parse(JSON.stringify(res[0])) : res[0]
            });
          } else {
            return Promise.reject("Error loading data");
          }
        });
      }
      init() {
        if (this.isDeleted) {
          return;
        }
        let uuid = uuidv4();
        this.uuid = uuid;
        let standardData;
        let self2 = this;
        if (!self2.d3Element) {
          return;
        }
        self2.d3Element.selectAll(".cells").remove();
        this.cells = null;
        if (self2.assets && self2.assets.length === 1) {
          self2.hidden = [];
          self2.assets[0].hidden = false;
        }
        let promise;
        if (uuid !== self2.uuid) {
          return;
        }
        this.loadData().then(function(res) {
          if (!res) {
            return;
          }
          standardData = res.results;
          if (uuid === self2.uuid) {
            self2.processData(standardData);
            if (self2.onReady && !self2.isDeleted) {
              self2.onReady();
            }
            return Promise.resolve();
          }
        });
      }
      processData(results) {
        let self2 = this;
        if (!results) {
          return;
        }
        this.data = [];
        results.forEach(function(resultDatum) {
          let data = resultDatum.list;
          data.forEach(function(individualDatum) {
            let day = moment(individualDatum.time * 1e3).tz(self2.timezone).diff(moment(self2.start * 1e3).tz(self2.timezone), "days");
            let hour = moment(individualDatum.time * 1e3).tz(self2.timezone).hour();
            let cellDatum = self2.data.find((d) => d.day === day && d.hour === hour);
            if (!cellDatum) {
              self2.data.push({
                day,
                hour,
                timestamp: individualDatum.time,
                formattedDate: d3.timeFormat("%d/%m/%Y %H:%M")(individualDatum.time * 1e3),
                formattedValue: getFormat(self2.dataTypes[0].toLowerCase())(individualDatum.consumption),
                value: individualDatum.consumption
              });
            } else {
              cellDatum.value += individualDatum.consumption;
              cellDatum.formattedValue = getFormat(self2.dataTypes[0].toLowerCase())(cellDatum.value);
            }
          });
        });
        let values = this.data.map((d) => d.value);
        let maxValue = Math.max(...values);
        let minValue = Math.min(...values);
        this.maxValue = maxValue;
        this.minValue = minValue;
        let basis2 = maxValue - minValue;
        let padding = 0.1;
        this.colorPalette = d3.scaleLinear().domain([
          minValue < 0 ? minValue : 0,
          (maxValue - minValue) / 4 + minValue,
          3 * (maxValue - minValue) / 4 + minValue,
          7 * (maxValue - minValue) / 8 + minValue,
          maxValue
        ]).range(["whitesmoke", "lightgreen", "green", "yellow", "red"]);
        if (this.onVisibleItems) {
          this.onVisibleItems([{ name: self2.combined && self2.assetData && self2.assetData.length > 1 ? "Total" : self2.assetData && self2.assetData.length > 0 ? self2.assetData[0].name : "Unknown" }]);
        }
        self2.generateKPIs();
        self2.createGraph();
      }
      createLegend() {
        let legendElement = this.d3Element;
        if (this.legendSelector) {
          legendElement = d3.select(this.legendSelector);
        }
        legendElement.selectAll(".legend").remove();
        let values = this.data.map((d) => d.value);
        let maxValue = Math.max(...values);
        let minValue = Math.min(...values);
        this.legendWidth = this.width / 4;
        const legendHeight = 20;
        this.legendX = (this.width - this.legendWidth) / 2;
        const legendY = this.height + 30;
        let legend = legendElement.append("div").attr("class", "legend").style("left", this.legendX).style("top", legendY).style("position", "absolute").style("width", this.legendWidth).style("height", legendHeight).style("background", "linear-gradient(to right, whitesmoke 0%, lightgreen 25%, green 75%, yellow 87.5%, red 100%)").style("border-radius", "10px");
        this.legendIndicator = legend.append("div").attr("class", "legend-indicator").style("display", "none").style("position", "absolute").style("left", "0px").style("background-color", "black").style("top", "0px").style("width", "2px").style("height", "100%");
      }
      generateKPIs() {
        let self2 = this;
        if (this.onKPIData) {
          let values = this.data.map((d) => d.value);
          let maxValue = Math.max(...values);
          let minValue = Math.min(...values);
          this.onKPIData({
            "min": {
              value: getFormat(self2.dataTypes[0].toLowerCase())(minValue),
              rawValue: minValue,
              dataType: self2.dataTypes[0].toLowerCase()
            },
            "max": {
              value: getFormat(self2.dataTypes[0].toLowerCase())(maxValue),
              rawValue: maxValue,
              dataType: self2.dataTypes[0].toLowerCase()
            }
          });
        }
      }
      remove() {
        this.clearDown();
        this.deleted();
        if (document.getElementById(this.uuid)) {
          document.getElementById(this.uuid).remove();
        }
      }
      mutationObserved(mutations) {
        let target = this.d3Element.node();
        let self2 = this;
        mutations.forEach(function(mutation) {
          let nodes = Array.from(mutation.removedNodes);
          let directMatch = nodes.indexOf(target) > -1;
          let parentMatch = nodes.some((parent) => parent.contains(target));
          if (directMatch) {
            self2.deleted();
          } else if (parentMatch) {
            self2.deleted();
          }
        });
      }
      deleted() {
        this.isDeleted = true;
        if (this.realTimeInterval) {
          clearInterval(this.realTimeInterval);
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
          this.cells = null;
        }
        if (this.tooltip) {
          this.tooltip.remove();
        }
      }
      clearDown() {
        if (this.svg) {
          this.svg.remove();
        }
        if (this.d3Element) {
          this.d3Element.selectAll("*").remove();
        }
        this.cells = null;
        this.svg = null;
      }
      calcSizes() {
        let newWidth = this.d3Element.node().clientWidth - MARGIN.left - MARGIN.right;
        let newHeight = this.d3Element.node().clientHeight - MARGIN.top - MARGIN.bottom;
        let changed = this.width !== newWidth || this.height !== newHeight;
        this.width = newWidth;
        this.height = newHeight;
        return changed;
      }
      createGraph() {
        let self2 = this;
        if (typeof window !== "undefined" && window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function() {
            self2.throttledRender();
          });
          self2.throttledRender();
          this.resizeObserver.observe(self2.d3Element.node());
        } else {
          self2.throttledRender();
        }
        if (typeof window !== "undefined" && window.MutationObserver) {
          this.mutationObserver = new MutationObserver(self2.mutationObserved.bind(self2));
          this.mutationObserver.observe(
            self2.d3Element.node().parentNode,
            {
              childList: true,
              subtree: true
            }
          );
        }
      }
      throttledRender(ignoreLegend) {
        const THROTTLE_AMOUNT = 1e3 / 60;
        let self2 = this;
        let ts = (/* @__PURE__ */ new Date()).getTime();
        if (ts - this.lastRendered < THROTTLE_AMOUNT) {
          if (!self2.throttled) {
            self2.throttled = true;
            setTimeout(function() {
              self2.render(ignoreLegend);
            }, THROTTLE_AMOUNT);
          }
        } else {
          self2.throttled = false;
          self2.render(ignoreLegend);
        }
      }
      render(ignoreLegend) {
        if (this.isDeleted) {
          return;
        }
        if (!this.document.getElementById(this.element.substr(1))) {
          this.deleted();
          return;
        }
        let self2 = this;
        let changed;
        if (!this.fixedSize) {
          changed = this.calcSizes();
          if (changed && this.svg) {
            self2.tooltipOverride(null);
            this.clearDown();
          }
        }
        if (!this.svg) {
          this.svg = this.d3Element.append("div").attr("id", this.uuid).attr("class", "gd-graph gd-graph-heatmap").style("width", this.fixedSize ? this.windowWidth : "100%").style("height", this.fixedSize ? this.windowHeight : "100%").append("div").style("width", this.width + "px").style("height", this.height + "px").style("left", MARGIN.left + "px").style("top", MARGIN.top + "px").style("position", "absolute");
        }
        if (!this.cells) {
          this.cells = this.svg.append("div").style("position", "absolute").style("width", this.width + "px").style("height", this.height + "px").attr("class", "cells");
        }
        this.days = Math.ceil(moment(this.end * 1e3).diff(moment(this.start * 1e3), "days", true));
        this.hours = 24;
        this.cellWidth = this.width / this.hours;
        this.cellHeight = this.height / this.days;
        this.createAxes();
        this.createCells();
      }
      createAxes() {
        let self2 = this;
        this.svg.selectAll(".axes").remove();
        let axes = this.svg.append("div").attr("class", "axes");
        axes.style("position", "absolute").style("pointer-events", "none").style("left", -1 * MARGIN.left + "px").style("width", "100%").style("height", "100%");
        let leftAxis = axes.append("div").attr("class", "left-axis");
        leftAxis.style("position", "absolute").style("width", "100%").style("height", "100%");
        for (let i = 0; i < this.days; i++) {
          let dateTime = moment(self2.start * 1e3).tz(self2.timezone).add(i, "days");
          let x4 = this.cellWidth / 2;
          let y4 = i * this.cellHeight + this.cellHeight / 10;
          if (i === 0 || i === this.days.length - 1 || i % 3 === 0) {
            leftAxis.append("div").style("position", "absolute").style("left", x4 + "px").style("top", y4 + "px").style("font-size", "12px").style("font-family", "Asap, sans-serif").style("color", "grey").html(dateTime.format("ddd D"));
          }
        }
        let bottomAxis = axes.append("g").attr("class", "bottom-axis");
        bottomAxis.style("position", "absolute").style("width", "100%").style("height", "100%");
        function formatHour(hour) {
          hour = Math.max(0, Math.min(23, hour));
          const formattedHour = hour.toString().padStart(2, "0");
          const formattedTime = `${formattedHour}:00`;
          return formattedTime;
        }
        for (let h = 0; h < 24; h++) {
          let x4 = h * this.cellWidth + this.cellWidth / 2 + this.cellWidth;
          let y4 = this.height + this.cellHeight / 4;
          if (h === 0 || h === 23 || h % 3 === 0) {
            bottomAxis.append("div").style("position", "absolute").style("left", x4 + "px").style("top", y4 + "px").style("font-size", "12px").style("font-family", "Asap, sans-serif").style("color", "grey").html(formatHour(h));
          }
        }
      }
      createCells() {
        let self2 = this;
        let clickable;
        let content;
        let icon;
        let row;
        let clickableBit;
        let cells = this.cells.selectAll(".cell").data(this.data).enter().append("div").attr("class", "cell").attr("originalX", (d) => d.hour * this.cellWidth).attr("originalY", (d) => d.day * this.cellHeight).attr("timestamp", (d) => d.timestamp).attr("breakdown-string", function(d) {
          return moment(d.timestamp * 1e3).tz(self2.timezone).format("YYYY-MM-DD HH:mm") + " - " + moment(d.timestamp * 1e3).tz(self2.timezone).add(1, "hour").format("HH:mm");
        }).style("left", (d) => d.hour * this.cellWidth + "px").style("top", (d) => d.day * this.cellHeight + "px").style("width", this.cellWidth + "px").style("height", this.cellHeight + "px").style("transition", "all 0.2s ease-in-out").style("position", "absolute").attr("date", (d) => d.formattedDate).attr("value", (d) => d.formattedValue).attr("rawValue", (d) => d.value).style("background-color", (d) => this.colorPalette(Math.max(0, d.value))).on("mouseleave", function(e) {
          d3.select(this).attr("id", null);
        });
        cells.on("mouseover", function() {
          let thisElement = d3.select(this);
          thisElement.attr("id", "selectedHeatCell");
          let row2;
          let min4 = self2.minValue > 0 ? 0 : self2.minValue;
          let value = parseFloat(thisElement.attr("rawValue"));
          let percent = 100 * (value - min4) / (self2.maxValue - min4);
          let overrideCallData = {
            date: thisElement.attr("date"),
            data: [{
              value: thisElement.attr("value"),
              name: self2.combined && self2.assetData && self2.assetData.length > 1 ? "Total" : self2.assetData && self2.assetData.length > 0 ? self2.assetData[0].name : "Unknown",
              color: self2.colorPalette(Math.max(0, parseFloat(thisElement.attr("rawValue")))),
              compareValue: null,
              percent,
              rawVal: parseFloat(thisElement.attr("rawValue")),
              disconnected: false
            }]
          };
          if (self2.tooltipOverride) {
            self2.tooltipOverride(overrideCallData);
          }
        });
        clickable = this.cells.append("div").attr("class", "clickable-outer");
        clickableBit = clickable.append("div").attr("class", "clickable-heatmap");
        clickableBit.on("click", function(event) {
          event.preventDefault();
          event.stopPropagation();
        });
        clickableBit.append("div").attr("class", "header").html("Investigate");
        row = clickableBit.append("div").attr("class", "clickable-row");
        row.append("div").attr("class", "subheading").html("View Breakdown");
        content = row.append("div").attr("class", "content");
        icon = row.append("div").attr("class", "icon").html('<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="color: inherit; line-height: 12px; font-size: 14px;"><path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"></path></svg>');
        cells.on("click", function(event) {
          let thisElement = d3.select(this);
          row.on("click", function() {
            self2.onClick({
              timestamp: parseInt(thisElement.attr("timestamp"))
            });
          });
          if (self2.onClick) {
            let mouseX = event.pageX;
            let mouseY = event.pageY;
            if (mouseX + 192 >= window.innerWidth || mouseY + 97 >= window.innerHeight) {
              mouseX = mouseX - 192;
              mouseY = mouseY - 97;
            }
            content.html(thisElement.attr("breakdown-string"));
            clickable.style("display", "block");
            clickableBit.style("left", mouseX + "px").style("top", mouseY + "px");
            setTimeout(function() {
              clickableBit.style("opacity", 1);
            }, 10);
            clickable.on("click", function() {
              clickableBit.style("opacity", 0);
              setTimeout(function() {
                clickable.style("display", "none");
              }, 200);
            });
          }
        });
      }
      set(params) {
        let self2 = this;
        let reInit = false;
        let redoKPI = false;
        let reRender = false;
        if (params.start !== void 0) {
          self2.start = params.start;
          reInit = true;
        }
        if (params.end !== void 0) {
          self2.end = params.end;
          reInit = true;
        }
        if (params.realTime !== void 0) {
          self2.realTime = params.realTime;
          reInit = true;
        }
        if (params.granularity !== void 0 && params.granularity !== null) {
          self2.granularity = params.granularity;
          reInit = true;
        }
        if (params.hidden !== void 0 && params.hidden !== null) {
          self2.hidden = params.hidden;
          redoKPI = true;
          reRender = true;
        }
        if (params.highlighted !== void 0) {
          self2.highlighted = params.highlighted;
          reRender = true;
        }
        if (reInit) {
          return self2.init();
        } else if (reRender) {
          self2.throttledRender();
          if (redoKPI) {
            self2.generateKPIs();
          }
          return Promise.resolve();
        }
      }
    };
    module2.exports = Heatmap2;
  }
});

// ../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js
var require_events = __commonJS({
  "../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js"(exports2, module2) {
    "use strict";
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
      return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") {
      ReflectOwnKeys = R.ownKeys;
    } else if (Object.getOwnPropertySymbols) {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
      };
    } else {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target);
      };
    }
    function ProcessEmitWarning(warning) {
      if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
      return value !== value;
    };
    function EventEmitter() {
      EventEmitter.init.call(this);
    }
    module2.exports = EventEmitter;
    module2.exports.once = once;
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = void 0;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener) {
      if (typeof listener !== "function") {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
    }
    Object.defineProperty(EventEmitter, "defaultMaxListeners", {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        }
        defaultMaxListeners = arg;
      }
    });
    EventEmitter.init = function() {
      if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
      }
      this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
      if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
      }
      this._maxListeners = n;
      return this;
    };
    function _getMaxListeners(that) {
      if (that._maxListeners === void 0)
        return EventEmitter.defaultMaxListeners;
      return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
      return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type2) {
      var args = [];
      for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
      var doError = type2 === "error";
      var events = this._events;
      if (events !== void 0)
        doError = doError && events.error === void 0;
      else if (!doError)
        return false;
      if (doError) {
        var er;
        if (args.length > 0)
          er = args[0];
        if (er instanceof Error) {
          throw er;
        }
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
      }
      var handler = events[type2];
      if (handler === void 0)
        return false;
      if (typeof handler === "function") {
        ReflectApply(handler, this, args);
      } else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          ReflectApply(listeners[i], this, args);
      }
      return true;
    };
    function _addListener(target, type2, listener, prepend) {
      var m3;
      var events;
      var existing;
      checkListener(listener);
      events = target._events;
      if (events === void 0) {
        events = target._events = /* @__PURE__ */ Object.create(null);
        target._eventsCount = 0;
      } else {
        if (events.newListener !== void 0) {
          target.emit(
            "newListener",
            type2,
            listener.listener ? listener.listener : listener
          );
          events = target._events;
        }
        existing = events[type2];
      }
      if (existing === void 0) {
        existing = events[type2] = listener;
        ++target._eventsCount;
      } else {
        if (typeof existing === "function") {
          existing = events[type2] = prepend ? [listener, existing] : [existing, listener];
        } else if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
        m3 = _getMaxListeners(target);
        if (m3 > 0 && existing.length > m3 && !existing.warned) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type2) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target;
          w.type = type2;
          w.count = existing.length;
          ProcessEmitWarning(w);
        }
      }
      return target;
    }
    EventEmitter.prototype.addListener = function addListener(type2, listener) {
      return _addListener(this, type2, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type2, listener) {
      return _addListener(this, type2, listener, true);
    };
    function onceWrapper() {
      if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
          return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
      }
    }
    function _onceWrap(target, type2, listener) {
      var state = { fired: false, wrapFn: void 0, target, type: type2, listener };
      var wrapped = onceWrapper.bind(state);
      wrapped.listener = listener;
      state.wrapFn = wrapped;
      return wrapped;
    }
    EventEmitter.prototype.once = function once2(type2, listener) {
      checkListener(listener);
      this.on(type2, _onceWrap(this, type2, listener));
      return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type2, listener) {
      checkListener(listener);
      this.prependListener(type2, _onceWrap(this, type2, listener));
      return this;
    };
    EventEmitter.prototype.removeListener = function removeListener(type2, listener) {
      var list, events, position, i, originalListener;
      checkListener(listener);
      events = this._events;
      if (events === void 0)
        return this;
      list = events[type2];
      if (list === void 0)
        return this;
      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = /* @__PURE__ */ Object.create(null);
        else {
          delete events[type2];
          if (events.removeListener)
            this.emit("removeListener", type2, list.listener || listener);
        }
      } else if (typeof list !== "function") {
        position = -1;
        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }
        if (position < 0)
          return this;
        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }
        if (list.length === 1)
          events[type2] = list[0];
        if (events.removeListener !== void 0)
          this.emit("removeListener", type2, originalListener || listener);
      }
      return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type2) {
      var listeners, events, i;
      events = this._events;
      if (events === void 0)
        return this;
      if (events.removeListener === void 0) {
        if (arguments.length === 0) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        } else if (events[type2] !== void 0) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else
            delete events[type2];
        }
        return this;
      }
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === "removeListener") continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
      }
      listeners = events[type2];
      if (typeof listeners === "function") {
        this.removeListener(type2, listeners);
      } else if (listeners !== void 0) {
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type2, listeners[i]);
        }
      }
      return this;
    };
    function _listeners(target, type2, unwrap) {
      var events = target._events;
      if (events === void 0)
        return [];
      var evlistener = events[type2];
      if (evlistener === void 0)
        return [];
      if (typeof evlistener === "function")
        return unwrap ? [evlistener.listener || evlistener] : [evlistener];
      return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type2) {
      return _listeners(this, type2, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type2) {
      return _listeners(this, type2, false);
    };
    EventEmitter.listenerCount = function(emitter, type2) {
      if (typeof emitter.listenerCount === "function") {
        return emitter.listenerCount(type2);
      } else {
        return listenerCount.call(emitter, type2);
      }
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type2) {
      var events = this._events;
      if (events !== void 0) {
        var evlistener = events[type2];
        if (typeof evlistener === "function") {
          return 1;
        } else if (evlistener !== void 0) {
          return evlistener.length;
        }
      }
      return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
      var copy3 = new Array(n);
      for (var i = 0; i < n; ++i)
        copy3[i] = arr[i];
      return copy3;
    }
    function spliceOne(list, index3) {
      for (; index3 + 1 < list.length; index3++)
        list[index3] = list[index3 + 1];
      list.pop();
    }
    function unwrapListeners(arr) {
      var ret = new Array(arr.length);
      for (var i = 0; i < ret.length; ++i) {
        ret[i] = arr[i].listener || arr[i];
      }
      return ret;
    }
    function once(emitter, name) {
      return new Promise(function(resolve, reject) {
        function errorListener(err) {
          emitter.removeListener(name, resolver);
          reject(err);
        }
        function resolver() {
          if (typeof emitter.removeListener === "function") {
            emitter.removeListener("error", errorListener);
          }
          resolve([].slice.call(arguments));
        }
        ;
        eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
        if (name !== "error") {
          addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
        }
      });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
      if (typeof emitter.on === "function") {
        eventTargetAgnosticAddListener(emitter, "error", handler, flags);
      }
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
      if (typeof emitter.on === "function") {
        if (flags.once) {
          emitter.once(name, listener);
        } else {
          emitter.on(name, listener);
        }
      } else if (typeof emitter.addEventListener === "function") {
        emitter.addEventListener(name, function wrapListener(arg) {
          if (flags.once) {
            emitter.removeEventListener(name, wrapListener);
          }
          listener(arg);
        });
      } else {
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
      }
    }
  }
});

// ../gridduck/dist/services/util.js
var require_util2 = __commonJS({
  "../gridduck/dist/services/util.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.camelObject = exports2.camelArray = exports2.snakeArray = exports2.snakeObject = exports2.toSnake = exports2.toCamel = void 0;
    var toCamel = (s2) => {
      if (!s2)
        return "";
      return s2.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase().replace("-", "").replace("_", "");
      });
    };
    exports2.toCamel = toCamel;
    var camelArray = function(array4) {
      if (!array4) {
        return [];
      }
      let newArray = [];
      for (let i = 0; i < array4.length; i++) {
        if (typeof array4[i] === "object" && array4[i] !== null) {
          if (!Array.isArray(array4[i])) {
            newArray[i] = camelObject(array4[i]);
          } else {
            newArray[i] = camelArray(array4[i]);
          }
        } else {
          newArray[i] = array4[i];
        }
      }
      return newArray;
    };
    exports2.camelArray = camelArray;
    var camelObject = function(object2) {
      let newObject = {};
      Object.keys(object2).forEach(function(key) {
        let newKey = toCamel(key);
        if (typeof object2[key] === "object" && object2[key] !== null) {
          if (!Array.isArray(object2[key])) {
            newObject[newKey] = camelObject(object2[key]);
          } else {
            newObject[newKey] = camelArray(object2[key]);
          }
        } else {
          newObject[newKey] = object2[key];
        }
      });
      return newObject;
    };
    exports2.camelObject = camelObject;
    var toSnake = (s2) => {
      if (!s2)
        return "";
      let res = s2.replace(/\.?([A-Z]+)/g, function(x4, y4) {
        return "_" + y4.toLowerCase();
      }).replace(/^_/, "");
      if (s2.substr(0, 1) === "_") {
        res = "_" + res;
      }
      return res;
    };
    exports2.toSnake = toSnake;
    var snakeArray = function(array4) {
      let newArray = [];
      for (let i = 0; i < array4.length; i++) {
        if (typeof array4[i] === "object" && array4[i] !== null) {
          if (!Array.isArray(array4[i])) {
            newArray[i] = snakeObject(array4[i]);
          } else {
            newArray[i] = snakeArray(array4[i]);
          }
        } else {
          newArray[i] = array4[i];
        }
      }
      return newArray;
    };
    exports2.snakeArray = snakeArray;
    var snakeObject = function(object2) {
      let newObject = {};
      Object.keys(object2).forEach(function(key) {
        let newKey = toSnake(key);
        if (typeof object2[key] === "object" && object2[key] !== null) {
          if (!Array.isArray(object2[key])) {
            newObject[newKey] = snakeObject(object2[key]);
          } else {
            newObject[newKey] = snakeArray(object2[key]);
          }
        } else {
          newObject[newKey] = object2[key];
        }
      });
      return newObject;
    };
    exports2.snakeObject = snakeObject;
  }
});

// ../gridduck/dist/models/new-item.js
var require_new_item = __commonJS({
  "../gridduck/dist/models/new-item.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var NewItem = class {
      toServer() {
        let result = {};
        let self2 = this;
        const isFileLike = (val) => typeof File !== "undefined" && val instanceof File || typeof Blob !== "undefined" && val instanceof Blob;
        Object.keys(this).forEach(function(key) {
          if (typeof self2[key] === "object" && self2[key] !== null && !isFileLike(self2[key])) {
            if (!Array.isArray(self2[key])) {
              result[(0, util_1.toSnake)(key)] = (0, util_1.snakeObject)(self2[key]);
            } else if (self2[key].some(isFileLike)) {
              result[(0, util_1.toSnake)(key)] = self2[key];
            } else {
              result[(0, util_1.toSnake)(key)] = (0, util_1.snakeArray)(self2[key]);
            }
          } else {
            result[(0, util_1.toSnake)(key)] = self2[key];
          }
        });
        return result;
      }
    };
    exports2.default = NewItem;
  }
});

// ../gridduck/dist/models/new-aggregateTelemetry.js
var require_new_aggregateTelemetry = __commonJS({
  "../gridduck/dist/models/new-aggregateTelemetry.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAggregateTelemetry = class extends new_item_1.default {
      constructor(newAggregateTelemetry) {
        super();
        this.consumption = newAggregateTelemetry.consumption;
        this.siteId = newAggregateTelemetry.siteId;
        this.time = newAggregateTelemetry.time;
      }
    };
    exports2.default = NewAggregateTelemetry;
  }
});

// ../gridduck/dist/models/new-aggregateTelemetryGroupRequest.js
var require_new_aggregateTelemetryGroupRequest = __commonJS({
  "../gridduck/dist/models/new-aggregateTelemetryGroupRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAggregateTelemetryGroupRequest = class extends new_item_1.default {
      constructor(newAggregateTelemetryGroupRequest) {
        super();
        this.groupType = newAggregateTelemetryGroupRequest.groupType;
        this.groupId = newAggregateTelemetryGroupRequest.groupId;
        this.start = newAggregateTelemetryGroupRequest.start;
        this.end = newAggregateTelemetryGroupRequest.end;
        this.status = newAggregateTelemetryGroupRequest.status;
      }
    };
    exports2.default = NewAggregateTelemetryGroupRequest;
  }
});

// ../gridduck/dist/models/new-application.js
var require_new_application = __commonJS({
  "../gridduck/dist/models/new-application.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewApplication = class extends new_item_1.default {
      constructor(newApplication) {
        super();
        this.clientName = newApplication.clientName;
        this.allowedGrants = newApplication.allowedGrants;
        this.scopes = newApplication.scopes;
      }
    };
    exports2.default = NewApplication;
  }
});

// ../gridduck/dist/models/new-asset.js
var require_new_asset = __commonJS({
  "../gridduck/dist/models/new-asset.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAsset = class extends new_item_1.default {
      constructor(newAsset) {
        super();
        this.parentAsset = newAsset.parentAsset;
        this.virtualParentAsset = newAsset.virtualParentAsset;
        this.bacnetTcpIpDetails = newAsset.bacnetTcpIpDetails;
        this.widgetBoardId = newAsset.widgetBoardId;
        this.lastContacted = newAsset.lastContacted;
        this.nbIotEcl = newAsset.nbIotEcl;
        this.groupIds = newAsset.groupIds;
        if (!newAsset.name) {
          throw Error("name required");
        }
        this.name = newAsset.name;
        this.siteName = newAsset.siteName;
        this.siteId = newAsset.siteId;
        this.siteTimezone = newAsset.siteTimezone;
        this.impKwh = newAsset.impKwh;
        this.currentState = newAsset.currentState;
        this.userState = newAsset.userState;
        this.sku = newAsset.sku;
        this.code = newAsset.code;
        this.dataType = newAsset.dataType;
        this.deviceCategory = newAsset.deviceCategory;
        this.deviceCategoryColor = newAsset.deviceCategoryColor;
        this.deviceCategoryIcon = newAsset.deviceCategoryIcon;
        this.deviceCategoryId = newAsset.deviceCategoryId;
        this.generation = newAsset.generation;
        this.assetIndex = newAsset.assetIndex;
        this.ble = newAsset.ble;
        this.boostFinish = newAsset.boostFinish;
        this.snoozeFinish = newAsset.snoozeFinish;
        this.loadType = newAsset.loadType;
        this.gatewayId = newAsset.gatewayId;
        this.gatewayName = newAsset.gatewayName;
        this.applianceType = newAsset.applianceType;
        this._permission = newAsset._permission;
        this.serialNo = newAsset.serialNo;
        this.readOnly = newAsset.readOnly;
        this.locked = newAsset.locked;
        this.children = newAsset.children;
        this.disconnected = newAsset.disconnected;
        this.gatewayDisconnected = newAsset.gatewayDisconnected;
        this.clampNameTwo = newAsset.clampNameTwo;
        this.clampSize = newAsset.clampSize;
        this.climaxClamp = newAsset.climaxClamp;
        this.triggerRules = newAsset.triggerRules;
        this.alertRules = newAsset.alertRules;
        this.advancedRules = newAsset.advancedRules;
        this.consumption = newAsset.consumption;
        this.consumptionPulse = newAsset.consumptionPulse;
        this.gasPulse = newAsset.gasPulse;
        this.waterPulse = newAsset.waterPulse;
        this.voc = newAsset.voc;
        this.open = newAsset.open;
        this.co2 = newAsset.co2;
        this.pressure = newAsset.pressure;
        this.waterPulseHot = newAsset.waterPulseHot;
        this.temperature = newAsset.temperature;
        this.humidity = newAsset.humidity;
        this.light = newAsset.light;
        this.current = newAsset.current;
        this.occupancy = newAsset.occupancy;
        this.assetSignalStrength = newAsset.assetSignalStrength;
        this.assetBatteryVoltage = newAsset.assetBatteryVoltage;
        this.assetBatteryAlarm = newAsset.assetBatteryAlarm;
        this.assetBatteryPercent = newAsset.assetBatteryPercent;
        this.firmwareTarget = newAsset.firmwareTarget;
        this.assetFirmwareVersion = newAsset.assetFirmwareVersion;
        this.assetFirmwareProgress = newAsset.assetFirmwareProgress;
        this.demandPhaseOne = newAsset.demandPhaseOne;
        this.demandPhaseTwo = newAsset.demandPhaseTwo;
        this.demandPhaseThree = newAsset.demandPhaseThree;
        this.pfPhaseOne = newAsset.pfPhaseOne;
        this.pfPhaseTwo = newAsset.pfPhaseTwo;
        this.pfPhaseThree = newAsset.pfPhaseThree;
        this.virtualLink = newAsset.virtualLink;
        this.doReconfigure = newAsset.doReconfigure;
        this.modbusId = newAsset.modbusId;
        this.anomalyDetection = newAsset.anomalyDetection;
        this.lowBattery = newAsset.lowBattery;
        this.lowSignal = newAsset.lowSignal;
        this.fault = newAsset.fault;
        this.intermittent = newAsset.intermittent;
        this.anomaly = newAsset.anomaly;
        this.modbusDetails = newAsset.modbusDetails;
        this.defaultModifiers = newAsset.defaultModifiers;
        this.modifierLevel = newAsset.modifierLevel;
        this.siteDefaultModifiers = newAsset.siteDefaultModifiers;
        this.organisationDefaultModifiers = newAsset.organisationDefaultModifiers;
      }
    };
    exports2.default = NewAsset;
  }
});

// ../gridduck/dist/models/new-assetAggregateDataRequest.js
var require_new_assetAggregateDataRequest = __commonJS({
  "../gridduck/dist/models/new-assetAggregateDataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAssetAggregateDataRequest = class extends new_item_1.default {
      constructor(newAssetAggregateDataRequest) {
        super();
        this.assetId = newAssetAggregateDataRequest.assetId;
        this.start = newAssetAggregateDataRequest.start;
        this.end = newAssetAggregateDataRequest.end;
        this.status = newAssetAggregateDataRequest.status;
      }
    };
    exports2.default = NewAssetAggregateDataRequest;
  }
});

// ../gridduck/dist/models/new-assetGod.js
var require_new_assetGod = __commonJS({
  "../gridduck/dist/models/new-assetGod.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAssetGod = class extends new_item_1.default {
      constructor(newAssetGod) {
        super();
        this.lastContacted = newAssetGod.lastContacted;
        if (!newAssetGod.name) {
          throw Error("name required");
        }
        this.name = newAssetGod.name;
        this.siteName = newAssetGod.siteName;
        this.siteId = newAssetGod.siteId;
        this.siteTimezone = newAssetGod.siteTimezone;
        this.impKwh = newAssetGod.impKwh;
        this.parentAsset = newAssetGod.parentAsset;
        this.virtualParentAsset = newAssetGod.virtualParentAsset;
        this.currentState = newAssetGod.currentState;
        this.userState = newAssetGod.userState;
        this.sku = newAssetGod.sku;
        if (!newAssetGod.code) {
          throw Error("code required");
        }
        this.code = newAssetGod.code;
        this.dataType = newAssetGod.dataType;
        this.generation = newAssetGod.generation;
        this.assetIndex = newAssetGod.assetIndex;
        this.ble = newAssetGod.ble;
        this.boostFinish = newAssetGod.boostFinish;
        this.snoozeFinish = newAssetGod.snoozeFinish;
        this.gatewayId = newAssetGod.gatewayId;
        this.gatewayName = newAssetGod.gatewayName;
        this.applianceType = newAssetGod.applianceType;
        this._permission = newAssetGod._permission;
        this.serialNo = newAssetGod.serialNo;
        this.readOnly = newAssetGod.readOnly;
        this.locked = newAssetGod.locked;
        this.children = newAssetGod.children;
        this.disconnected = newAssetGod.disconnected;
        this.gatewayDisconnected = newAssetGod.gatewayDisconnected;
        this.clampNameTwo = newAssetGod.clampNameTwo;
        this.clampSize = newAssetGod.clampSize;
        this.climaxClamp = newAssetGod.climaxClamp;
        this.triggerRules = newAssetGod.triggerRules;
        this.alertRules = newAssetGod.alertRules;
        this.advancedRules = newAssetGod.advancedRules;
        this.consumption = newAssetGod.consumption;
        this.consumptionPulse = newAssetGod.consumptionPulse;
        this.gasPulse = newAssetGod.gasPulse;
        this.waterPulse = newAssetGod.waterPulse;
        this.waterPulseHot = newAssetGod.waterPulseHot;
        this.temperature = newAssetGod.temperature;
        this.humidity = newAssetGod.humidity;
        this.light = newAssetGod.light;
        this.occupancy = newAssetGod.occupancy;
        this.assetSignalStrength = newAssetGod.assetSignalStrength;
        this.assetBatteryVoltage = newAssetGod.assetBatteryVoltage;
        this.assetBatteryAlarm = newAssetGod.assetBatteryAlarm;
        this.assetBatteryPercent = newAssetGod.assetBatteryPercent;
        this.firmwareTarget = newAssetGod.firmwareTarget;
        this.assetFirmwareVersion = newAssetGod.assetFirmwareVersion;
        this.assetFirmwareProgress = newAssetGod.assetFirmwareProgress;
        this.demandPhaseOne = newAssetGod.demandPhaseOne;
        this.demandPhaseTwo = newAssetGod.demandPhaseTwo;
        this.demandPhaseThree = newAssetGod.demandPhaseThree;
        this.nbIotEcl = newAssetGod.nbIotEcl;
        this.doReconfigure = newAssetGod.doReconfigure;
      }
    };
    exports2.default = NewAssetGod;
  }
});

// ../gridduck/dist/models/new-assetIdentification.js
var require_new_assetIdentification = __commonJS({
  "../gridduck/dist/models/new-assetIdentification.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAssetIdentification = class extends new_item_1.default {
      constructor(newAssetIdentification) {
        super();
        this.assetId = newAssetIdentification.assetId;
      }
    };
    exports2.default = NewAssetIdentification;
  }
});

// ../gridduck/dist/models/new-assetRemoveDataRequest.js
var require_new_assetRemoveDataRequest = __commonJS({
  "../gridduck/dist/models/new-assetRemoveDataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAssetRemoveDataRequest = class extends new_item_1.default {
      constructor(newAssetRemoveDataRequest) {
        super();
        this.assetId = newAssetRemoveDataRequest.assetId;
        this.start = newAssetRemoveDataRequest.start;
        this.end = newAssetRemoveDataRequest.end;
        this.status = newAssetRemoveDataRequest.status;
      }
    };
    exports2.default = NewAssetRemoveDataRequest;
  }
});

// ../gridduck/dist/models/new-assetReset.js
var require_new_assetReset = __commonJS({
  "../gridduck/dist/models/new-assetReset.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAssetReset = class extends new_item_1.default {
      constructor(newAssetReset) {
        super();
        this.assetId = newAssetReset.assetId;
        this.timestamp = newAssetReset.timestamp;
        this.value = newAssetReset.value;
        this.start = newAssetReset.start;
        this.end = newAssetReset.end;
      }
    };
    exports2.default = NewAssetReset;
  }
});

// ../gridduck/dist/models/new-audit.js
var require_new_audit = __commonJS({
  "../gridduck/dist/models/new-audit.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewAudit = class extends new_item_1.default {
      constructor(newAudit) {
        super();
        this.installerAccountId = newAudit.installerAccountId;
        this.installingForId = newAudit.installingForId;
        this.installerName = newAudit.installerName;
        this.installerOrgName = newAudit.installerOrgName;
        this.siteName = newAudit.siteName;
        this.siteId = newAudit.siteId;
        this.issues = newAudit.issues;
        this.warningLevel = newAudit.warningLevel;
        this.createdDate = newAudit.createdDate;
        this.message = newAudit.message;
        this.devices = newAudit.devices;
        this.gateways = newAudit.gateways;
        this.files = newAudit.files;
        this.warningLevelDevices = newAudit.warningLevelDevices;
        this.zeroDemandDevices = newAudit.zeroDemandDevices;
        this.disconnectedDevices = newAudit.disconnectedDevices;
        this.disconnectedGateways = newAudit.disconnectedGateways;
        this.warningLevelGateways = newAudit.warningLevelGateways;
        this.warningLevelFiles = newAudit.warningLevelFiles;
      }
    };
    exports2.default = NewAudit;
  }
});

// ../gridduck/dist/models/new-calculatorInbound.js
var require_new_calculatorInbound = __commonJS({
  "../gridduck/dist/models/new-calculatorInbound.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewCalculatorInbound = class extends new_item_1.default {
      constructor(newCalculatorInbound) {
        super();
        this.emailAddress = newCalculatorInbound.emailAddress;
        this.googlePlacesId = newCalculatorInbound.googlePlacesId;
        this.businessName = newCalculatorInbound.businessName;
      }
    };
    exports2.default = NewCalculatorInbound;
  }
});

// ../gridduck/dist/models/new-calculatorResult.js
var require_new_calculatorResult = __commonJS({
  "../gridduck/dist/models/new-calculatorResult.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewCalculatorResult = class extends new_item_1.default {
      constructor(newCalculatorResult) {
        super();
        this.inboundId = newCalculatorResult.inboundId;
        this.totalSavingData = newCalculatorResult.totalSavingData;
        this.applianceSavingData = newCalculatorResult.applianceSavingData;
        this.hours = newCalculatorResult.hours;
        this.appliances = newCalculatorResult.appliances;
        this.receivedSavingEmail = newCalculatorResult.receivedSavingEmail;
      }
    };
    exports2.default = NewCalculatorResult;
  }
});

// ../gridduck/dist/models/new-confirmOrgInvite.js
var require_new_confirmOrgInvite = __commonJS({
  "../gridduck/dist/models/new-confirmOrgInvite.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewConfirmOrgInvite = class extends new_item_1.default {
      constructor(newConfirmOrgInvite) {
        super();
        this.orgPermission = newConfirmOrgInvite.orgPermission;
        this.emailAddress = newConfirmOrgInvite.emailAddress;
        this.code = newConfirmOrgInvite.code;
        this.name = newConfirmOrgInvite.name;
        this.jobRole = newConfirmOrgInvite.jobRole;
        this.password = newConfirmOrgInvite.password;
      }
    };
    exports2.default = NewConfirmOrgInvite;
  }
});

// ../gridduck/dist/models/new-createReport.js
var require_new_createReport = __commonJS({
  "../gridduck/dist/models/new-createReport.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewCreateReport = class extends new_item_1.default {
      constructor(newCreateReport) {
        super();
        this.all = newCreateReport.all;
        this.testing = newCreateReport.testing;
      }
    };
    exports2.default = NewCreateReport;
  }
});

// ../gridduck/dist/models/new-customField.js
var require_new_customField = __commonJS({
  "../gridduck/dist/models/new-customField.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewCustomField = class extends new_item_1.default {
      constructor(newCustomField) {
        super();
        this.customFieldTypeId = newCustomField.customFieldTypeId;
        this.customFieldType = newCustomField.customFieldType;
        this.customFieldName = newCustomField.customFieldName;
        this.siteIds = newCustomField.siteIds;
        this.icon = newCustomField.icon;
        this.colour = newCustomField.colour;
        this.valueText = newCustomField.valueText;
        this.valueNumber = newCustomField.valueNumber;
        this.valueBoolean = newCustomField.valueBoolean;
        this.valueTimestamp = newCustomField.valueTimestamp;
        this._permission = newCustomField._permission;
      }
    };
    exports2.default = NewCustomField;
  }
});

// ../gridduck/dist/models/new-customFieldType.js
var require_new_customFieldType = __commonJS({
  "../gridduck/dist/models/new-customFieldType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewCustomFieldType = class extends new_item_1.default {
      constructor(newCustomFieldType) {
        super();
        this.name = newCustomFieldType.name;
        this.icon = newCustomFieldType.icon;
        this.fieldType = newCustomFieldType.fieldType;
        this.colour = newCustomFieldType.colour;
        this._permission = newCustomFieldType._permission;
      }
    };
    exports2.default = NewCustomFieldType;
  }
});

// ../gridduck/dist/models/new-dataCategory.js
var require_new_dataCategory = __commonJS({
  "../gridduck/dist/models/new-dataCategory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataCategory = class extends new_item_1.default {
      constructor(newDataCategory) {
        super();
        this.name = newDataCategory.name;
        this.organisationId = newDataCategory.organisationId;
        this.color = newDataCategory.color;
        this.icon = newDataCategory.icon;
        this.global = newDataCategory.global;
        this._permission = newDataCategory._permission;
      }
    };
    exports2.default = NewDataCategory;
  }
});

// ../gridduck/dist/models/new-dataFileImport.js
var require_new_dataFileImport = __commonJS({
  "../gridduck/dist/models/new-dataFileImport.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataFileImport = class extends new_item_1.default {
      constructor(newDataFileImport) {
        super();
        this.name = newDataFileImport.name;
        this.description = newDataFileImport.description;
        this.site_id = newDataFileImport.site_id;
        this.org_id = newDataFileImport.org_id;
        this.format = newDataFileImport.format;
        this.created_at = newDataFileImport.created_at;
        this.updated_at = newDataFileImport.updated_at;
        this.device_config = newDataFileImport.device_config;
        this.key_prefix = newDataFileImport.key_prefix;
        this.asset_id = newDataFileImport.asset_id;
        this.auto_create_asset = newDataFileImport.auto_create_asset;
      }
    };
    exports2.default = NewDataFileImport;
  }
});

// ../gridduck/dist/models/new-dataFileImportUpload.js
var require_new_dataFileImportUpload = __commonJS({
  "../gridduck/dist/models/new-dataFileImportUpload.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataFileImportUpload = class extends new_item_1.default {
      constructor(newDataFileImportUpload) {
        super();
        this.configId = newDataFileImportUpload.configId;
        this.action = newDataFileImportUpload.action;
        this.files = newDataFileImportUpload.files;
        this.previewResult = newDataFileImportUpload.previewResult;
        this.assetIds = newDataFileImportUpload.assetIds;
      }
    };
    exports2.default = NewDataFileImportUpload;
  }
});

// ../gridduck/dist/models/new-dataRequest.js
var require_new_dataRequest = __commonJS({
  "../gridduck/dist/models/new-dataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataRequest = class extends new_item_1.default {
      constructor(newDataRequest) {
        super();
        this.type = newDataRequest.type;
        this.name = newDataRequest.name;
        this.granularity = newDataRequest.granularity;
        this.assetIds = newDataRequest.assetIds;
        this.startDate = newDataRequest.startDate;
        this.endDate = newDataRequest.endDate;
        this.status = newDataRequest.status;
        this.size = newDataRequest.size;
        this.dataType = newDataRequest.dataType;
        this.active = newDataRequest.active;
        this.notificationConfig = newDataRequest.notificationConfig;
        this.lastRunAt = newDataRequest.lastRunAt;
        this.parentRequestId = newDataRequest.parentRequestId;
        this.periodKey = newDataRequest.periodKey;
        this.deliveredAt = newDataRequest.deliveredAt;
        this.deliveryError = newDataRequest.deliveryError;
        this.deliveryAttempts = newDataRequest.deliveryAttempts;
        this.webhookSecret = newDataRequest.webhookSecret;
      }
    };
    exports2.default = NewDataRequest;
  }
});

// ../gridduck/dist/models/new-dataRequestLink.js
var require_new_dataRequestLink = __commonJS({
  "../gridduck/dist/models/new-dataRequestLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataRequestLink = class extends new_item_1.default {
      constructor(newDataRequestLink) {
        super();
        this.dataRequestId = newDataRequestLink.dataRequestId;
        this.expiresTime = newDataRequestLink.expiresTime;
        this.url = newDataRequestLink.url;
        this.expires = newDataRequestLink.expires;
      }
    };
    exports2.default = NewDataRequestLink;
  }
});

// ../gridduck/dist/models/new-dataRequestRun.js
var require_new_dataRequestRun = __commonJS({
  "../gridduck/dist/models/new-dataRequestRun.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataRequestRun = class extends new_item_1.default {
      constructor(newDataRequestRun) {
        super();
        this.dataRequestId = newDataRequestRun.dataRequestId;
        this.triggered = newDataRequestRun.triggered;
      }
    };
    exports2.default = NewDataRequestRun;
  }
});

// ../gridduck/dist/models/new-dataType.js
var require_new_dataType = __commonJS({
  "../gridduck/dist/models/new-dataType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataType = class extends new_item_1.default {
      constructor(newDataType) {
        super();
        this.name = newDataType.name;
        this.dataType = newDataType.dataType;
        this.organisationId = newDataType.organisationId;
        this.unitId = newDataType.unitId;
        this.unitDetails = newDataType.unitDetails;
        this.applyRate = newDataType.applyRate;
        this.rateUnitId = newDataType.rateUnitId;
        this.rateUnitDetails = newDataType.rateUnitDetails;
        this.categoryId = newDataType.categoryId;
        this.categoryDetails = newDataType.categoryDetails;
        this.global = newDataType.global;
        this.defaultRateMultiple = newDataType.defaultRateMultiple;
        this.defaultMultiple = newDataType.defaultMultiple;
        this._permission = newDataType._permission;
      }
    };
    exports2.default = NewDataType;
  }
});

// ../gridduck/dist/models/new-dataUnit.js
var require_new_dataUnit = __commonJS({
  "../gridduck/dist/models/new-dataUnit.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataUnit = class extends new_item_1.default {
      constructor(newDataUnit) {
        super();
        this.dataType = newDataUnit.dataType;
        this.unitCategory = newDataUnit.unitCategory;
        this.name = newDataUnit.name;
        this.unitType = newDataUnit.unitType;
        this.metaData = newDataUnit.metaData;
        this._permission = newDataUnit._permission;
        this.global = newDataUnit.global;
      }
    };
    exports2.default = NewDataUnit;
  }
});

// ../gridduck/dist/models/new-dataUpload.js
var require_new_dataUpload = __commonJS({
  "../gridduck/dist/models/new-dataUpload.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDataUpload = class extends new_item_1.default {
      constructor(newDataUpload) {
        super();
        this.file = newDataUpload.file;
        this.groupName = newDataUpload.groupName;
        this.noHeaders = newDataUpload.noHeaders;
        this.columnData = newDataUpload.columnData;
        this.csvFileNames = newDataUpload.csvFileNames;
        this.uploaded = newDataUpload.uploaded;
        this.dataItemsLayout = newDataUpload.dataItemsLayout;
        this.dataItemsColumn = newDataUpload.dataItemsColumn;
        this.dataItems = newDataUpload.dataItems;
        this.newDevices = newDataUpload.newDevices;
        this.newSites = newDataUpload.newSites;
        this.dataTypes = newDataUpload.dataTypes;
        this.previewSampleData = newDataUpload.previewSampleData;
        this.processedErrors = newDataUpload.processedErrors;
        this.processingStatusDetails = newDataUpload.processingStatusDetails;
        this.uploadingStatusDetails = newDataUpload.uploadingStatusDetails;
        this.status = newDataUpload.status;
      }
    };
    exports2.default = NewDataUpload;
  }
});

// ../gridduck/dist/models/new-dcCreateAccount.js
var require_new_dcCreateAccount = __commonJS({
  "../gridduck/dist/models/new-dcCreateAccount.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDcCreateAccount = class extends new_item_1.default {
      constructor(newDcCreateAccount) {
        super();
        this.emailAddress = newDcCreateAccount.emailAddress;
        this.password = newDcCreateAccount.password;
      }
    };
    exports2.default = NewDcCreateAccount;
  }
});

// ../gridduck/dist/models/new-dcRetryPayment.js
var require_new_dcRetryPayment = __commonJS({
  "../gridduck/dist/models/new-dcRetryPayment.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDcRetryPayment = class extends new_item_1.default {
      constructor(newDcRetryPayment) {
        super();
        this.status = newDcRetryPayment.status;
      }
    };
    exports2.default = NewDcRetryPayment;
  }
});

// ../gridduck/dist/models/new-dcSession.js
var require_new_dcSession = __commonJS({
  "../gridduck/dist/models/new-dcSession.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDcSession = class extends new_item_1.default {
      constructor(newDcSession) {
        super();
        this.startTime = newDcSession.startTime;
        this.endTime = newDcSession.endTime;
        this.priceCap = newDcSession.priceCap;
        this.chargePointId = newDcSession.chargePointId;
        this.status = newDcSession.status;
        this.invoiceDetails = newDcSession.invoiceDetails;
        this.reasonForEnd = newDcSession.reasonForEnd;
        this.totalCost = newDcSession.totalCost;
        this.totalUsage = newDcSession.totalUsage;
        this.priceCapFormatted = newDcSession.priceCapFormatted;
        this.totalCostFormatted = newDcSession.totalCostFormatted;
        this.totalUsageFormatted = newDcSession.totalUsageFormatted;
      }
    };
    exports2.default = NewDcSession;
  }
});

// ../gridduck/dist/models/new-deviceCategory.js
var require_new_deviceCategory = __commonJS({
  "../gridduck/dist/models/new-deviceCategory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewDeviceCategory = class extends new_item_1.default {
      constructor(newDeviceCategory) {
        super();
        this.name = newDeviceCategory.name;
        this.organisationId = newDeviceCategory.organisationId;
        this.colour = newDeviceCategory.colour;
        this.icon = newDeviceCategory.icon;
        this.global = newDeviceCategory.global;
        this.assetIds = newDeviceCategory.assetIds;
        this._permission = newDeviceCategory._permission;
      }
    };
    exports2.default = NewDeviceCategory;
  }
});

// ../gridduck/dist/models/new-file.js
var require_new_file = __commonJS({
  "../gridduck/dist/models/new-file.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewFile = class extends new_item_1.default {
      constructor(newFile) {
        super();
        this.itemType = newFile.itemType;
        this.itemId = newFile.itemId;
        this.name = newFile.name;
        this.type = newFile.type;
        this.size = newFile.size;
        this.file = newFile.file;
        this.ref = newFile.ref;
        this.description = newFile.description;
        this.location = newFile.location;
        this.thumbnail = newFile.thumbnail;
        this.uploadRef = newFile.uploadRef;
        this.uploadedByName = newFile.uploadedByName;
        this.ORN = newFile.ORN;
        this.uploadedStamp = newFile.uploadedStamp;
      }
    };
    exports2.default = NewFile;
  }
});

// ../gridduck/dist/models/new-gaiaMessage.js
var require_new_gaiaMessage = __commonJS({
  "../gridduck/dist/models/new-gaiaMessage.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGaiaMessage = class extends new_item_1.default {
      constructor(newGaiaMessage) {
        super();
        this.role = newGaiaMessage.role;
        this.content = newGaiaMessage.content;
        this.conversationId = newGaiaMessage.conversationId;
        this.createdAt = newGaiaMessage.createdAt;
      }
    };
    exports2.default = NewGaiaMessage;
  }
});

// ../gridduck/dist/models/new-gateway.js
var require_new_gateway = __commonJS({
  "../gridduck/dist/models/new-gateway.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGateway = class extends new_item_1.default {
      constructor(newGateway) {
        super();
        this.virtualFrom = newGateway.virtualFrom;
        this.updateState = newGateway.updateState;
        this.locationId = newGateway.locationId;
        this.locationName = newGateway.locationName;
        this.timezone = newGateway.timezone;
        this.locationMetadata = newGateway.locationMetadata;
        this.targetVersion = newGateway.targetVersion;
        if (!newGateway.name) {
          throw Error("name required");
        }
        this.name = newGateway.name;
        this.scanning = newGateway.scanning;
        this.status = newGateway.status;
        this.physicalGatewayId = newGateway.physicalGatewayId;
        this.ethernetMac = newGateway.ethernetMac;
        this.wlanMac = newGateway.wlanMac;
        this.lastContacted = newGateway.lastContacted;
        this.siteId = newGateway.siteId;
        this.siteName = newGateway.siteName;
        this.connectionType = newGateway.connectionType;
        this.powerSource = newGateway.powerSource;
        this.charge = newGateway.charge;
        this.wifiNetwork = newGateway.wifiNetwork;
        this.activeConnection = newGateway.activeConnection;
        this._permission = newGateway._permission;
        this.wifiStrength = newGateway.wifiStrength;
        this.mobileStrength = newGateway.mobileStrength;
        this.imsi = newGateway.imsi;
        this.ipAddress = newGateway.ipAddress;
        this.serialNumber = newGateway.serialNumber;
        this.modelNumber = newGateway.modelNumber;
        this.disconnected = newGateway.disconnected;
        this.staging = newGateway.staging;
        this.beta = newGateway.beta;
        this.debugMode = newGateway.debugMode;
        this.enhancedLogging = newGateway.enhancedLogging;
        this.zigbeeDisabled = newGateway.zigbeeDisabled;
        this.doReboot = newGateway.doReboot;
        this.doZigbeeReset = newGateway.doZigbeeReset;
        this.getTrustedList = newGateway.getTrustedList;
        this.installationCode = newGateway.installationCode;
        this.version = newGateway.version;
        this.updateSlot = newGateway.updateSlot;
        this.type = newGateway.type;
        this.gatewayType = newGateway.gatewayType;
        this.imei = newGateway.imei;
        this.intermittent = newGateway.intermittent;
        this.lowSignal = newGateway.lowSignal;
        this.fault = newGateway.fault;
        this.anomaly = newGateway.anomaly;
        this.modbusMessageRec = newGateway.modbusMessageRec;
        this.modbusMessage = newGateway.modbusMessage;
        this.modbusParams = newGateway.modbusParams;
        this.modbusSubscribe = newGateway.modbusSubscribe;
        this.staticEthernetSettings = newGateway.staticEthernetSettings;
      }
    };
    exports2.default = NewGateway;
  }
});

// ../gridduck/dist/models/new-gatewayEnhancedLogDownloadRequest.js
var require_new_gatewayEnhancedLogDownloadRequest = __commonJS({
  "../gridduck/dist/models/new-gatewayEnhancedLogDownloadRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGatewayEnhancedLogDownloadRequest = class extends new_item_1.default {
      constructor(newGatewayEnhancedLogDownloadRequest) {
        super();
        this.gatewayId = newGatewayEnhancedLogDownloadRequest.gatewayId;
      }
    };
    exports2.default = NewGatewayEnhancedLogDownloadRequest;
  }
});

// ../gridduck/dist/models/new-gatewayGod.js
var require_new_gatewayGod = __commonJS({
  "../gridduck/dist/models/new-gatewayGod.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGatewayGod = class extends new_item_1.default {
      constructor(newGatewayGod) {
        super();
        this.owner = newGatewayGod.owner;
        this.updateState = newGatewayGod.updateState;
        this.targetVersion = newGatewayGod.targetVersion;
        if (!newGatewayGod.name) {
          throw Error("name required");
        }
        this.name = newGatewayGod.name;
        this.scanning = newGatewayGod.scanning;
        this.status = newGatewayGod.status;
        this.physicalGatewayId = newGatewayGod.physicalGatewayId;
        this.ethernetMac = newGatewayGod.ethernetMac;
        this.wlanMac = newGatewayGod.wlanMac;
        this.lastContacted = newGatewayGod.lastContacted;
        this.siteId = newGatewayGod.siteId;
        this.siteName = newGatewayGod.siteName;
        this.connectionType = newGatewayGod.connectionType;
        this.powerSource = newGatewayGod.powerSource;
        this.totalDevices = newGatewayGod.totalDevices;
        this.connectedDevices = newGatewayGod.connectedDevices;
        this.charge = newGatewayGod.charge;
        this.wifiNetwork = newGatewayGod.wifiNetwork;
        this.activeConnection = newGatewayGod.activeConnection;
        this._permission = newGatewayGod._permission;
        this.wifiStrength = newGatewayGod.wifiStrength;
        this.mobileStrength = newGatewayGod.mobileStrength;
        this.imsi = newGatewayGod.imsi;
        this.ipAddress = newGatewayGod.ipAddress;
        this.serialNumber = newGatewayGod.serialNumber;
        this.modelNumber = newGatewayGod.modelNumber;
        this.disconnected = newGatewayGod.disconnected;
        this.staging = newGatewayGod.staging;
        this.beta = newGatewayGod.beta;
        this.debugMode = newGatewayGod.debugMode;
        this.enhancedLogging = newGatewayGod.enhancedLogging;
        this.zigbeeDisabled = newGatewayGod.zigbeeDisabled;
        this.doReboot = newGatewayGod.doReboot;
        this.doZigbeeReset = newGatewayGod.doZigbeeReset;
        this.getTrustedList = newGatewayGod.getTrustedList;
        this.installationCode = newGatewayGod.installationCode;
        this.version = newGatewayGod.version;
        this.updateSlot = newGatewayGod.updateSlot;
        this.locationName = newGatewayGod.locationName;
      }
    };
    exports2.default = NewGatewayGod;
  }
});

// ../gridduck/dist/models/new-gatewayLogDownloadRequest.js
var require_new_gatewayLogDownloadRequest = __commonJS({
  "../gridduck/dist/models/new-gatewayLogDownloadRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGatewayLogDownloadRequest = class extends new_item_1.default {
      constructor(newGatewayLogDownloadRequest) {
        super();
        this.gatewayId = newGatewayLogDownloadRequest.gatewayId;
      }
    };
    exports2.default = NewGatewayLogDownloadRequest;
  }
});

// ../gridduck/dist/models/new-gatewayTrustedDeviceAnalysis.js
var require_new_gatewayTrustedDeviceAnalysis = __commonJS({
  "../gridduck/dist/models/new-gatewayTrustedDeviceAnalysis.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGatewayTrustedDeviceAnalysis = class extends new_item_1.default {
      constructor(newGatewayTrustedDeviceAnalysis) {
        super();
        this.sku = newGatewayTrustedDeviceAnalysis.sku;
      }
    };
    exports2.default = NewGatewayTrustedDeviceAnalysis;
  }
});

// ../gridduck/dist/models/new-gatewayTrustedDeviceUntrustRequest.js
var require_new_gatewayTrustedDeviceUntrustRequest = __commonJS({
  "../gridduck/dist/models/new-gatewayTrustedDeviceUntrustRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGatewayTrustedDeviceUntrustRequest = class extends new_item_1.default {
      constructor(newGatewayTrustedDeviceUntrustRequest) {
        super();
        this.assetCode = newGatewayTrustedDeviceUntrustRequest.assetCode;
        this.gatewayId = newGatewayTrustedDeviceUntrustRequest.gatewayId;
      }
    };
    exports2.default = NewGatewayTrustedDeviceUntrustRequest;
  }
});

// ../gridduck/dist/models/new-getPhaseBreakdown.js
var require_new_getPhaseBreakdown = __commonJS({
  "../gridduck/dist/models/new-getPhaseBreakdown.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGetPhaseBreakdown = class extends new_item_1.default {
      constructor(newGetPhaseBreakdown) {
        super();
        this.assetId = newGetPhaseBreakdown.assetId;
      }
    };
    exports2.default = NewGetPhaseBreakdown;
  }
});

// ../gridduck/dist/models/new-group.js
var require_new_group = __commonJS({
  "../gridduck/dist/models/new-group.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGroup = class extends new_item_1.default {
      constructor(newGroup) {
        super();
        this.dataTypes = newGroup.dataTypes;
        if (!newGroup.name) {
          throw Error("name required");
        }
        this.name = newGroup.name;
        this.widgetBoardId = newGroup.widgetBoardId;
        this.groupTypeId = newGroup.groupTypeId;
        this.assetIds = newGroup.assetIds;
        this.parentIds = newGroup.parentIds;
        this._permission = newGroup._permission;
      }
    };
    exports2.default = NewGroup;
  }
});

// ../gridduck/dist/models/new-groupType.js
var require_new_groupType = __commonJS({
  "../gridduck/dist/models/new-groupType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewGroupType = class extends new_item_1.default {
      constructor(newGroupType) {
        super();
        this.name = newGroupType.name;
        this.icon = newGroupType.icon;
        this.color = newGroupType.color;
      }
    };
    exports2.default = NewGroupType;
  }
});

// ../gridduck/dist/models/new-inspiredLogin.js
var require_new_inspiredLogin = __commonJS({
  "../gridduck/dist/models/new-inspiredLogin.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewInspiredLogin = class extends new_item_1.default {
      constructor(newInspiredLogin) {
        super();
        this.username = newInspiredLogin.username;
        this.user = newInspiredLogin.user;
        this.token = newInspiredLogin.token;
        this.mfaRequired = newInspiredLogin.mfaRequired;
        this.expires = newInspiredLogin.expires;
        this.scope = newInspiredLogin.scope;
        this.tokenType = newInspiredLogin.tokenType;
      }
    };
    exports2.default = NewInspiredLogin;
  }
});

// ../gridduck/dist/models/new-instantaneousTelemetry.js
var require_new_instantaneousTelemetry = __commonJS({
  "../gridduck/dist/models/new-instantaneousTelemetry.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewInstantaneousTelemetry = class extends new_item_1.default {
      constructor(newInstantaneousTelemetry) {
        super();
        this.value = newInstantaneousTelemetry.value;
        this.time = newInstantaneousTelemetry.time;
      }
    };
    exports2.default = NewInstantaneousTelemetry;
  }
});

// ../gridduck/dist/models/new-invoiceRequest.js
var require_new_invoiceRequest = __commonJS({
  "../gridduck/dist/models/new-invoiceRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewInvoiceRequest = class extends new_item_1.default {
      constructor(newInvoiceRequest) {
        super();
        this.assetIds = newInvoiceRequest.assetIds;
        this.vat = newInvoiceRequest.vat;
        this.memo = newInvoiceRequest.memo;
        this.dueDate = newInvoiceRequest.dueDate;
        this.pdfPer = newInvoiceRequest.pdfPer;
        this.startDate = newInvoiceRequest.startDate;
        this.endDate = newInvoiceRequest.endDate;
        this.status = newInvoiceRequest.status;
        this.size = newInvoiceRequest.size;
        this.customerEmail = newInvoiceRequest.customerEmail;
        this.customerName = newInvoiceRequest.customerName;
        this.includeBranding = newInvoiceRequest.includeBranding;
        this.invoiceNo = newInvoiceRequest.invoiceNo;
        this.vatId = newInvoiceRequest.vatId;
        this.issuingOrgEmail = newInvoiceRequest.issuingOrgEmail;
        this.issuingOrgName = newInvoiceRequest.issuingOrgName;
        this.issuingOrgPhoneNumber = newInvoiceRequest.issuingOrgPhoneNumber;
      }
    };
    exports2.default = NewInvoiceRequest;
  }
});

// ../gridduck/dist/models/new-invoiceRequestLink.js
var require_new_invoiceRequestLink = __commonJS({
  "../gridduck/dist/models/new-invoiceRequestLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewInvoiceRequestLink = class extends new_item_1.default {
      constructor(newInvoiceRequestLink) {
        super();
        this.invoiceRequestId = newInvoiceRequestLink.invoiceRequestId;
        this.expiresTime = newInvoiceRequestLink.expiresTime;
        this.url = newInvoiceRequestLink.url;
        this.expires = newInvoiceRequestLink.expires;
      }
    };
    exports2.default = NewInvoiceRequestLink;
  }
});

// ../gridduck/dist/models/new-location.js
var require_new_location = __commonJS({
  "../gridduck/dist/models/new-location.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewLocation = class extends new_item_1.default {
      constructor(newLocation) {
        super();
        this.name = newLocation.name;
        this.lat = newLocation.lat;
        this.timezone = newLocation.timezone;
        this.lng = newLocation.lng;
        this.metadata = newLocation.metadata;
        this._permission = newLocation._permission;
      }
    };
    exports2.default = NewLocation;
  }
});

// ../gridduck/dist/models/new-loginAs.js
var require_new_loginAs = __commonJS({
  "../gridduck/dist/models/new-loginAs.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewLoginAs = class extends new_item_1.default {
      constructor(newLoginAs) {
        super();
        this.username = newLoginAs.username;
        this.user = newLoginAs.user;
        this.token = newLoginAs.token;
        this.mfaRequired = newLoginAs.mfaRequired;
        this.expires = newLoginAs.expires;
        this.scope = newLoginAs.scope;
        this.tokenType = newLoginAs.tokenType;
      }
    };
    exports2.default = NewLoginAs;
  }
});

// ../gridduck/dist/models/new-loginAsPartner.js
var require_new_loginAsPartner = __commonJS({
  "../gridduck/dist/models/new-loginAsPartner.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewLoginAsPartner = class extends new_item_1.default {
      constructor(newLoginAsPartner) {
        super();
        this.username = newLoginAsPartner.username;
        this.user = newLoginAsPartner.user;
        this.token = newLoginAsPartner.token;
        this.mfaRequired = newLoginAsPartner.mfaRequired;
        this.expires = newLoginAsPartner.expires;
        this.scope = newLoginAsPartner.scope;
        this.tokenType = newLoginAsPartner.tokenType;
        this.partnerOverride = newLoginAsPartner.partnerOverride;
      }
    };
    exports2.default = NewLoginAsPartner;
  }
});

// ../gridduck/dist/models/new-mfaAuthentication.js
var require_new_mfaAuthentication = __commonJS({
  "../gridduck/dist/models/new-mfaAuthentication.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewMfaAuthentication = class extends new_item_1.default {
      constructor(newMfaAuthentication) {
        super();
        this.token = newMfaAuthentication.token;
      }
    };
    exports2.default = NewMfaAuthentication;
  }
});

// ../gridduck/dist/models/new-mfaSecret.js
var require_new_mfaSecret = __commonJS({
  "../gridduck/dist/models/new-mfaSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewMfaSecret = class extends new_item_1.default {
      constructor(newMfaSecret) {
        super();
        this.secretUrl = newMfaSecret.secretUrl;
      }
    };
    exports2.default = NewMfaSecret;
  }
});

// ../gridduck/dist/models/new-mfaVerification.js
var require_new_mfaVerification = __commonJS({
  "../gridduck/dist/models/new-mfaVerification.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewMfaVerification = class extends new_item_1.default {
      constructor(newMfaVerification) {
        super();
        this.token = newMfaVerification.token;
      }
    };
    exports2.default = NewMfaVerification;
  }
});

// ../gridduck/dist/models/new-modbusModel.js
var require_new_modbusModel = __commonJS({
  "../gridduck/dist/models/new-modbusModel.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewModbusModel = class extends new_item_1.default {
      constructor(newModbusModel) {
        super();
        this.displayName = newModbusModel.displayName;
        this.modbusDeviceType = newModbusModel.modbusDeviceType;
        this.modbusManufacturerName = newModbusModel.modbusManufacturerName;
        this.modbusProductName = newModbusModel.modbusProductName;
        this.sku = newModbusModel.sku;
        this.manufacturerSku = newModbusModel.manufacturerSku;
        this.displayImage = newModbusModel.displayImage;
        this.parity = newModbusModel.parity;
        this.baudRate = newModbusModel.baudRate;
        this.stopBits = newModbusModel.stopBits;
        this.dataBits = newModbusModel.dataBits;
        this.rxTimeout = newModbusModel.rxTimeout;
        this.registers = newModbusModel.registers;
        this.readOnly = newModbusModel.readOnly;
        this.organisationId = newModbusModel.organisationId;
        this.global = newModbusModel.global;
        this._permission = newModbusModel._permission;
      }
    };
    exports2.default = NewModbusModel;
  }
});

// ../gridduck/dist/models/new-occupancySchedule.js
var require_new_occupancySchedule = __commonJS({
  "../gridduck/dist/models/new-occupancySchedule.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewOccupancySchedule = class extends new_item_1.default {
      constructor(newOccupancySchedule) {
        super();
        this.name = newOccupancySchedule.name;
        this.schedule = newOccupancySchedule.schedule;
        this.siteIds = newOccupancySchedule.siteIds;
        this._permission = newOccupancySchedule._permission;
      }
    };
    exports2.default = NewOccupancySchedule;
  }
});

// ../gridduck/dist/models/new-order.js
var require_new_order = __commonJS({
  "../gridduck/dist/models/new-order.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewOrder = class extends new_item_1.default {
      constructor(newOrder) {
        super();
        this.vat = newOrder.vat;
        this.discount = newOrder.discount;
        this.shippingCost = newOrder.shippingCost;
        this.orgId = newOrder.orgId;
        this.physicalItems = newOrder.physicalItems;
        this.subscriptionItems = newOrder.subscriptionItems;
        this.sessionId = newOrder.sessionId;
      }
    };
    exports2.default = NewOrder;
  }
});

// ../gridduck/dist/models/new-orgPartner.js
var require_new_orgPartner = __commonJS({
  "../gridduck/dist/models/new-orgPartner.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewOrgPartner = class extends new_item_1.default {
      constructor(newOrgPartner) {
        super();
        this.orgName = newOrgPartner.orgName;
        this.orgToName = newOrgPartner.orgToName;
        this.name = newOrgPartner.name;
        this.orgFromName = newOrgPartner.orgFromName;
        this.orgId = newOrgPartner.orgId;
        this.orgToId = newOrgPartner.orgToId;
        this.dataTypes = newOrgPartner.dataTypes;
        this.deviceList = newOrgPartner.deviceList;
        this.orgFromId = newOrgPartner.orgFromId;
        this.permType = newOrgPartner.permType;
        this.orgEmailAddress = newOrgPartner.orgEmailAddress;
        this.sites = newOrgPartner.sites;
        this.partnerDirection = newOrgPartner.partnerDirection;
        this.whiteLabel = newOrgPartner.whiteLabel;
        this.inheritWhiteLabelFrom = newOrgPartner.inheritWhiteLabelFrom;
        this.whiteLabelTheme = newOrgPartner.whiteLabelTheme;
        this.whiteLabelCustomTheme = newOrgPartner.whiteLabelCustomTheme;
        this.logoImage = newOrgPartner.logoImage;
        this.orgFromLogoImage = newOrgPartner.orgFromLogoImage;
        this.logoImageThumbnail = newOrgPartner.logoImageThumbnail;
        this.squareLogoImage = newOrgPartner.squareLogoImage;
        this.orgFromSquareLogoImage = newOrgPartner.orgFromSquareLogoImage;
        this.squareLogoImageThumbnail = newOrgPartner.squareLogoImageThumbnail;
        this.orgFromWhiteLabel = newOrgPartner.orgFromWhiteLabel;
        this.orgFromInheritWhiteLabelFrom = newOrgPartner.orgFromInheritWhiteLabelFrom;
        this.orgFromWhiteLabelTheme = newOrgPartner.orgFromWhiteLabelTheme;
        this.orgFromWhiteLabelCustomTheme = newOrgPartner.orgFromWhiteLabelCustomTheme;
        this.orgFromContactEmail = newOrgPartner.orgFromContactEmail;
        this.contactEmail = newOrgPartner.contactEmail;
        this.issues = newOrgPartner.issues;
        this.appliances = newOrgPartner.appliances;
        this.lowBatteryAssets = newOrgPartner.lowBatteryAssets;
        this.lowSignalAssets = newOrgPartner.lowSignalAssets;
        this.assetsWithIssues = newOrgPartner.assetsWithIssues;
        this.faultyAssets = newOrgPartner.faultyAssets;
        this.intermittentAssets = newOrgPartner.intermittentAssets;
        this.anomalousAssets = newOrgPartner.anomalousAssets;
        this.widgetBoardId = newOrgPartner.widgetBoardId;
      }
    };
    exports2.default = NewOrgPartner;
  }
});

// ../gridduck/dist/models/new-organisationInvite.js
var require_new_organisationInvite = __commonJS({
  "../gridduck/dist/models/new-organisationInvite.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewOrganisationInvite = class extends new_item_1.default {
      constructor(newOrganisationInvite) {
        super();
        this.orgPermission = newOrganisationInvite.orgPermission;
        this.emailAddress = newOrganisationInvite.emailAddress;
        this.inviteSent = newOrganisationInvite.inviteSent;
        this.linkOpened = newOrganisationInvite.linkOpened;
        this.orgName = newOrganisationInvite.orgName;
        this.orgId = newOrganisationInvite.orgId;
        this.orgOverridePerms = newOrganisationInvite.orgOverridePerms;
        this.sitesLimitedTo = newOrganisationInvite.sitesLimitedTo;
      }
    };
    exports2.default = NewOrganisationInvite;
  }
});

// ../gridduck/dist/models/new-password.js
var require_new_password = __commonJS({
  "../gridduck/dist/models/new-password.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewPassword = class extends new_item_1.default {
      constructor(newPassword) {
        super();
        this.oldPassword = newPassword.oldPassword;
        this.newPassword = newPassword.newPassword;
        this.status = newPassword.status;
      }
    };
    exports2.default = NewPassword;
  }
});

// ../gridduck/dist/models/new-paymentCard.js
var require_new_paymentCard = __commonJS({
  "../gridduck/dist/models/new-paymentCard.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewPaymentCard = class extends new_item_1.default {
      constructor(newPaymentCard) {
        super();
        this.cardId = newPaymentCard.cardId;
        this.card = newPaymentCard.card;
        this.bacs_debit = newPaymentCard.bacs_debit;
      }
    };
    exports2.default = NewPaymentCard;
  }
});

// ../gridduck/dist/models/new-paymentSheet.js
var require_new_paymentSheet = __commonJS({
  "../gridduck/dist/models/new-paymentSheet.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewPaymentSheet = class extends new_item_1.default {
      constructor(newPaymentSheet) {
        super();
        this.setupIntent = newPaymentSheet.setupIntent;
        this.ephemeralKey = newPaymentSheet.ephemeralKey;
        this.customer = newPaymentSheet.customer;
        this.publishableKey = newPaymentSheet.publishableKey;
      }
    };
    exports2.default = NewPaymentSheet;
  }
});

// ../gridduck/dist/models/new-physicalGateway.js
var require_new_physicalGateway = __commonJS({
  "../gridduck/dist/models/new-physicalGateway.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewPhysicalGateway = class extends new_item_1.default {
      constructor(newPhysicalGateway) {
        super();
        this.resetOwners = newPhysicalGateway.resetOwners;
        this.serialNumber = newPhysicalGateway.serialNumber;
        this.installationCode = newPhysicalGateway.installationCode;
        this.owners = newPhysicalGateway.owners;
      }
    };
    exports2.default = NewPhysicalGateway;
  }
});

// ../gridduck/dist/models/new-pubOrg.js
var require_new_pubOrg = __commonJS({
  "../gridduck/dist/models/new-pubOrg.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewPubOrg = class extends new_item_1.default {
      constructor(newPubOrg) {
        super();
        this.orgCurrency = newPubOrg.orgCurrency;
        if (!newPubOrg.name) {
          throw Error("name required");
        }
        this.name = newPubOrg.name;
        this.websiteUrl = newPubOrg.websiteUrl;
        this.cloneFromId = newPubOrg.cloneFromId;
        this.cloneToId = newPubOrg.cloneToId;
        this.contactEmail = newPubOrg.contactEmail;
        this.contactPhone = newPubOrg.contactPhone;
        this.address = newPubOrg.address;
        this.mfaEnforced = newPubOrg.mfaEnforced;
        this.orgEmailAddress = newPubOrg.orgEmailAddress;
        this.emailAddress = newPubOrg.emailAddress;
        this.free = newPubOrg.free;
        this.tour = newPubOrg.tour;
        this.industry = newPubOrg.industry;
        this.goals = newPubOrg.goals;
      }
    };
    exports2.default = NewPubOrg;
  }
});

// ../gridduck/dist/models/new-report.js
var require_new_report = __commonJS({
  "../gridduck/dist/models/new-report.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewReport = class extends new_item_1.default {
      constructor(newReport) {
        super();
        if (!newReport.name) {
          throw Error("name required");
        }
        this.name = newReport.name;
        this.assetIds = newReport.assetIds;
        this.siteIds = newReport.siteIds;
        this.groupIds = newReport.groupIds;
        this.frequency = newReport.frequency;
        this.includeMegaPdf = newReport.includeMegaPdf;
        this.active = newReport.active;
        this.recipients = newReport.recipients;
        this.repeatOn = newReport.repeatOn;
        this.perDevice = newReport.perDevice;
        this._permission = newReport._permission;
      }
    };
    exports2.default = NewReport;
  }
});

// ../gridduck/dist/models/new-reportFileLink.js
var require_new_reportFileLink = __commonJS({
  "../gridduck/dist/models/new-reportFileLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewReportFileLink = class extends new_item_1.default {
      constructor(newReportFileLink) {
        super();
        this.fileId = newReportFileLink.fileId;
        this.expiresTime = newReportFileLink.expiresTime;
        this.url = newReportFileLink.url;
        this.expires = newReportFileLink.expires;
      }
    };
    exports2.default = NewReportFileLink;
  }
});

// ../gridduck/dist/models/new-requestSecret.js
var require_new_requestSecret = __commonJS({
  "../gridduck/dist/models/new-requestSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewRequestSecret = class extends new_item_1.default {
      constructor(newRequestSecret) {
        super();
        this.applicationId = newRequestSecret.applicationId;
        this.password = newRequestSecret.password;
        this.clientSecret = newRequestSecret.clientSecret;
      }
    };
    exports2.default = NewRequestSecret;
  }
});

// ../gridduck/dist/models/new-resetSecret.js
var require_new_resetSecret = __commonJS({
  "../gridduck/dist/models/new-resetSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewResetSecret = class extends new_item_1.default {
      constructor(newResetSecret) {
        super();
        this.applicationId = newResetSecret.applicationId;
        this.password = newResetSecret.password;
        this.clientSecret = newResetSecret.clientSecret;
      }
    };
    exports2.default = NewResetSecret;
  }
});

// ../gridduck/dist/models/new-resetToken.js
var require_new_resetToken = __commonJS({
  "../gridduck/dist/models/new-resetToken.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewResetToken = class extends new_item_1.default {
      constructor(newResetToken) {
        super();
        this.emailAddress = newResetToken.emailAddress;
        this.status = newResetToken.status;
        this.token = newResetToken.token;
        this.password = newResetToken.password;
      }
    };
    exports2.default = NewResetToken;
  }
});

// ../gridduck/dist/models/new-rule.js
var require_new_rule = __commonJS({
  "../gridduck/dist/models/new-rule.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewRule = class extends new_item_1.default {
      constructor(newRule) {
        super();
        if (!newRule.name) {
          throw Error("name required");
        }
        this.name = newRule.name;
        this.description = newRule.description;
        this.triggerLogic = newRule.triggerLogic;
        this.throttleDuration = newRule.throttleDuration;
        this.persistent = newRule.persistent;
        this.assetType = newRule.assetType;
        this.inactiveState = newRule.inactiveState;
        this.alerts = newRule.alerts;
        this.triggers = newRule.triggers;
        this.template = newRule.template;
        this._permission = newRule._permission;
        this.active = newRule.active;
        this.actions = newRule.actions;
      }
    };
    exports2.default = NewRule;
  }
});

// ../gridduck/dist/models/new-searchHistory.js
var require_new_searchHistory = __commonJS({
  "../gridduck/dist/models/new-searchHistory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewSearchHistory = class extends new_item_1.default {
      constructor(newSearchHistory) {
        super();
        this.accountId = newSearchHistory.accountId;
        this.metadata = newSearchHistory.metadata;
        this.name = newSearchHistory.name;
        this.itemId = newSearchHistory.itemId;
        this.itemType = newSearchHistory.itemType;
        this.created = newSearchHistory.created;
      }
    };
    exports2.default = NewSearchHistory;
  }
});

// ../gridduck/dist/models/new-session.js
var require_new_session = __commonJS({
  "../gridduck/dist/models/new-session.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewSession = class extends new_item_1.default {
      constructor(newSession) {
        super();
        this.created = newSession.created;
        this.completed = newSession.completed;
        this.cancelled = newSession.cancelled;
        this.subscriptionItems = newSession.subscriptionItems;
        this.physicalItems = newSession.physicalItems;
      }
    };
    exports2.default = NewSession;
  }
});

// ../gridduck/dist/models/new-site.js
var require_new_site = __commonJS({
  "../gridduck/dist/models/new-site.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewSite = class extends new_item_1.default {
      constructor(newSite) {
        super();
        if (!newSite.name) {
          throw Error("name required");
        }
        this.name = newSite.name;
        this.groupTypeId = newSite.groupTypeId;
        this.timezone = newSite.timezone;
        this.dataTypes = newSite.dataTypes;
        this.organisationId = newSite.organisationId;
        this.tariffIds = newSite.tariffIds;
        this.address = newSite.address;
        this.totalDemand = newSite.totalDemand;
        this.widgetBoardId = newSite.widgetBoardId;
        this.locationId = newSite.locationId;
        this.locationName = newSite.locationName;
        this.lat = newSite.lat;
        this.lng = newSite.lng;
        this.locationMetadata = newSite.locationMetadata;
        this._permission = newSite._permission;
        this.gateways = newSite.gateways;
        this.issues = newSite.issues;
        this.issueIds = newSite.issueIds;
        this.customFields = newSite.customFields;
        this.deviceList = newSite.deviceList;
        this.occupancyScheduleId = newSite.occupancyScheduleId;
        this.occupancyScheduleName = newSite.occupancyScheduleName;
        this.occupancySchedule = newSite.occupancySchedule;
        this.defaultOccupancyScheduleId = newSite.defaultOccupancyScheduleId;
        this.defaultOccupancyScheduleName = newSite.defaultOccupancyScheduleName;
        this.defaultOccupancySchedule = newSite.defaultOccupancySchedule;
        this.disconnectedAssetsViaHub = newSite.disconnectedAssetsViaHub;
        this.lowBatteryAssets = newSite.lowBatteryAssets;
        this.appliances = newSite.appliances;
        this.lowSignalAssets = newSite.lowSignalAssets;
        this.assetsWithIssues = newSite.assetsWithIssues;
        this.faultyAssets = newSite.faultyAssets;
        this.intermittentAssets = newSite.intermittentAssets;
        this.anomalousAssets = newSite.anomalousAssets;
        this.defaultModifiers = newSite.defaultModifiers;
      }
    };
    exports2.default = NewSite;
  }
});

// ../gridduck/dist/models/new-siteGroup.js
var require_new_siteGroup = __commonJS({
  "../gridduck/dist/models/new-siteGroup.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewSiteGroup = class extends new_item_1.default {
      constructor(newSiteGroup) {
        super();
        this.name = newSiteGroup.name;
        this.dataTypes = newSiteGroup.dataTypes;
        this.widgetBoardId = newSiteGroup.widgetBoardId;
        this.totalDemand = newSiteGroup.totalDemand;
        this.issueIds = newSiteGroup.issueIds;
        this.siteIds = newSiteGroup.siteIds;
        this.disconnectedAssetsViaHub = newSiteGroup.disconnectedAssetsViaHub;
        this.issues = newSiteGroup.issues;
        this.appliances = newSiteGroup.appliances;
        this.lowBatteryAssets = newSiteGroup.lowBatteryAssets;
        this.lowSignalAssets = newSiteGroup.lowSignalAssets;
        this.assetsWithIssues = newSiteGroup.assetsWithIssues;
        this.faultyAssets = newSiteGroup.faultyAssets;
        this.intermittentAssets = newSiteGroup.intermittentAssets;
        this.anomalousAssets = newSiteGroup.anomalousAssets;
        this._permission = newSiteGroup._permission;
      }
    };
    exports2.default = NewSiteGroup;
  }
});

// ../gridduck/dist/models/new-sitePermission.js
var require_new_sitePermission = __commonJS({
  "../gridduck/dist/models/new-sitePermission.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewSitePermission = class extends new_item_1.default {
      constructor(newSitePermission) {
        super();
        this.siteId = newSitePermission.siteId;
        this.orgId = newSitePermission.orgId;
        this.orgName = newSitePermission.orgName;
        this.permName = newSitePermission.permName;
      }
    };
    exports2.default = NewSitePermission;
  }
});

// ../gridduck/dist/models/new-stripeSession.js
var require_new_stripeSession = __commonJS({
  "../gridduck/dist/models/new-stripeSession.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewStripeSession = class extends new_item_1.default {
      constructor(newStripeSession) {
        super();
        this.url = newStripeSession.url;
      }
    };
    exports2.default = NewStripeSession;
  }
});

// ../gridduck/dist/models/new-stripeWebhook.js
var require_new_stripeWebhook = __commonJS({
  "../gridduck/dist/models/new-stripeWebhook.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewStripeWebhook = class extends new_item_1.default {
      constructor(newStripeWebhook) {
        super();
        this.body = newStripeWebhook.body;
      }
    };
    exports2.default = NewStripeWebhook;
  }
});

// ../gridduck/dist/models/new-tariff.js
var require_new_tariff = __commonJS({
  "../gridduck/dist/models/new-tariff.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewTariff = class extends new_item_1.default {
      constructor(newTariff) {
        super();
        this.name = newTariff.name;
        this.currency = newTariff.currency;
        this.utilityType = newTariff.utilityType;
        this.organisationId = newTariff.organisationId;
        this.standingCharge = newTariff.standingCharge;
        this.rates = newTariff.rates;
        this.contractStart = newTariff.contractStart;
        this.contractEnd = newTariff.contractEnd;
        this.billingCycleType = newTariff.billingCycleType;
        this.billingCycleStartDay = newTariff.billingCycleStartDay;
        this.applyContractRange = newTariff.applyContractRange;
        this.applyBillingCycle = newTariff.applyBillingCycle;
        this.siteId = newTariff.siteId;
        this.siteIds = newTariff.siteIds;
        this._permission = newTariff._permission;
      }
    };
    exports2.default = NewTariff;
  }
});

// ../gridduck/dist/models/new-thirdPartyIntegration.js
var require_new_thirdPartyIntegration = __commonJS({
  "../gridduck/dist/models/new-thirdPartyIntegration.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewThirdPartyIntegration = class extends new_item_1.default {
      constructor(newThirdPartyIntegration) {
        super();
        this.integrationMetaData = newThirdPartyIntegration.integrationMetaData;
      }
    };
    exports2.default = NewThirdPartyIntegration;
  }
});

// ../gridduck/dist/models/new-widgetBoard.js
var require_new_widgetBoard = __commonJS({
  "../gridduck/dist/models/new-widgetBoard.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewWidgetBoard = class extends new_item_1.default {
      constructor(newWidgetBoard) {
        super();
        this.columnData = newWidgetBoard.columnData;
        this.columnOrder = newWidgetBoard.columnOrder;
        this.dateData = newWidgetBoard.dateData;
        this.itemType = newWidgetBoard.itemType;
        this.itemId = newWidgetBoard.itemId;
      }
    };
    exports2.default = NewWidgetBoard;
  }
});

// ../gridduck/dist/models/new-zapierWebhook.js
var require_new_zapierWebhook = __commonJS({
  "../gridduck/dist/models/new-zapierWebhook.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewZapierWebhook = class extends new_item_1.default {
      constructor(newZapierWebhook) {
        super();
        this.body = newZapierWebhook.body;
      }
    };
    exports2.default = NewZapierWebhook;
  }
});

// ../gridduck/dist/models/new-zip.js
var require_new_zip = __commonJS({
  "../gridduck/dist/models/new-zip.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var new_item_1 = __importDefault(require_new_item());
    var NewZip = class extends new_item_1.default {
      constructor(newZip) {
        super();
        this.siteId = newZip.siteId;
        this.files = newZip.files;
        this.location = newZip.location;
      }
    };
    exports2.default = NewZip;
  }
});

// ../node_modules/.pnpm/axios@1.18.0/node_modules/axios/dist/browser/axios.cjs
var require_axios = __commonJS({
  "../node_modules/.pnpm/axios@1.18.0/node_modules/axios/dist/browser/axios.cjs"(exports2, module2) {
    "use strict";
    function bind(fn, thisArg) {
      return function wrap() {
        return fn.apply(thisArg, arguments);
      };
    }
    var { toString } = Object.prototype;
    var { getPrototypeOf } = Object;
    var { iterator, toStringTag } = Symbol;
    var hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
    var hasOwnInPrototypeChain = (thing, prop) => {
      let obj = thing;
      const seen = [];
      while (obj != null && obj !== Object.prototype) {
        if (seen.indexOf(obj) !== -1) {
          return false;
        }
        seen.push(obj);
        if (hasOwnProperty(obj, prop)) {
          return true;
        }
        obj = getPrototypeOf(obj);
      }
      return false;
    };
    var getSafeProp = (obj, prop) => obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : void 0;
    var kindOf = /* @__PURE__ */ ((cache) => (thing) => {
      const str = toString.call(thing);
      return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(/* @__PURE__ */ Object.create(null));
    var kindOfTest = (type2) => {
      type2 = type2.toLowerCase();
      return (thing) => kindOf(thing) === type2;
    };
    var typeOfTest = (type2) => (thing) => typeof thing === type2;
    var { isArray } = Array;
    var isUndefined = typeOfTest("undefined");
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
    }
    var isArrayBuffer = kindOfTest("ArrayBuffer");
    function isArrayBufferView(val) {
      let result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && isArrayBuffer(val.buffer);
      }
      return result;
    }
    var isString = typeOfTest("string");
    var isFunction$1 = typeOfTest("function");
    var isNumber = typeOfTest("number");
    var isObject = (thing) => thing !== null && typeof thing === "object";
    var isBoolean = (thing) => thing === true || thing === false;
    var isPlainObject = (val) => {
      if (!isObject(val)) {
        return false;
      }
      const prototype2 = getPrototypeOf(val);
      return (prototype2 === null || prototype2 === Object.prototype || getPrototypeOf(prototype2) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
      // Symbol.iterator as evidence the value is a tagged/iterable type rather
      // than a plain object, while ignoring keys injected onto Object.prototype.
      !hasOwnInPrototypeChain(val, toStringTag) && !hasOwnInPrototypeChain(val, iterator);
    };
    var isEmptyObject = (val) => {
      if (!isObject(val) || isBuffer(val)) {
        return false;
      }
      try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
      } catch (e) {
        return false;
      }
    };
    var isDate = kindOfTest("Date");
    var isFile = kindOfTest("File");
    var isReactNativeBlob = (value) => {
      return !!(value && typeof value.uri !== "undefined");
    };
    var isReactNative = (formData) => formData && typeof formData.getParts !== "undefined";
    var isBlob = kindOfTest("Blob");
    var isFileList = kindOfTest("FileList");
    var isStream = (val) => isObject(val) && isFunction$1(val.pipe);
    function getGlobal() {
      if (typeof globalThis !== "undefined") return globalThis;
      if (typeof self !== "undefined") return self;
      if (typeof window !== "undefined") return window;
      if (typeof global !== "undefined") return global;
      return {};
    }
    var G = getGlobal();
    var FormDataCtor = typeof G.FormData !== "undefined" ? G.FormData : void 0;
    var isFormData = (thing) => {
      if (!thing) return false;
      if (FormDataCtor && thing instanceof FormDataCtor) return true;
      const proto = getPrototypeOf(thing);
      if (!proto || proto === Object.prototype) return false;
      if (!isFunction$1(thing.append)) return false;
      const kind = kindOf(thing);
      return kind === "formdata" || // detect form-data instance
      kind === "object" && isFunction$1(thing.toString) && thing.toString() === "[object FormData]";
    };
    var isURLSearchParams = kindOfTest("URLSearchParams");
    var [isReadableStream, isRequest, isResponse, isHeaders] = [
      "ReadableStream",
      "Request",
      "Response",
      "Headers"
    ].map(kindOfTest);
    var trim = (str) => {
      return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
    function forEach(obj, fn, { allOwnKeys = false } = {}) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      let i;
      let l;
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        if (isBuffer(obj)) {
          return;
        }
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for (i = 0; i < len; i++) {
          key = keys[i];
          fn.call(null, obj[key], key, obj);
        }
      }
    }
    function findKey(obj, key) {
      if (isBuffer(obj)) {
        return null;
      }
      key = key.toLowerCase();
      const keys = Object.keys(obj);
      let i = keys.length;
      let _key;
      while (i-- > 0) {
        _key = keys[i];
        if (key === _key.toLowerCase()) {
          return _key;
        }
      }
      return null;
    }
    var _global = (() => {
      if (typeof globalThis !== "undefined") return globalThis;
      return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
    })();
    var isContextDefined = (context) => !isUndefined(context) && context !== _global;
    function merge2(...objs) {
      const { caseless, skipUndefined } = isContextDefined(this) && this || {};
      const result = {};
      const assignValue = (val, key) => {
        if (key === "__proto__" || key === "constructor" || key === "prototype") {
          return;
        }
        const targetKey = caseless && typeof key === "string" && findKey(result, key) || key;
        const existing = hasOwnProperty(result, targetKey) ? result[targetKey] : void 0;
        if (isPlainObject(existing) && isPlainObject(val)) {
          result[targetKey] = merge2(existing, val);
        } else if (isPlainObject(val)) {
          result[targetKey] = merge2({}, val);
        } else if (isArray(val)) {
          result[targetKey] = val.slice();
        } else if (!skipUndefined || !isUndefined(val)) {
          result[targetKey] = val;
        }
      };
      for (let i = 0, l = objs.length; i < l; i++) {
        const source = objs[i];
        if (!source || isBuffer(source)) {
          continue;
        }
        forEach(source, assignValue);
        if (typeof source !== "object" || isArray(source)) {
          continue;
        }
        const symbols = Object.getOwnPropertySymbols(source);
        for (let j = 0; j < symbols.length; j++) {
          const symbol = symbols[j];
          if (propertyIsEnumerable.call(source, symbol)) {
            assignValue(source[symbol], symbol);
          }
        }
      }
      return result;
    }
    var extend2 = (a4, b, thisArg, { allOwnKeys } = {}) => {
      forEach(
        b,
        (val, key) => {
          if (thisArg && isFunction$1(val)) {
            Object.defineProperty(a4, key, {
              // Null-proto descriptor so a polluted Object.prototype.get cannot
              // hijack defineProperty's accessor-vs-data resolution.
              __proto__: null,
              value: bind(val, thisArg),
              writable: true,
              enumerable: true,
              configurable: true
            });
          } else {
            Object.defineProperty(a4, key, {
              __proto__: null,
              value: val,
              writable: true,
              enumerable: true,
              configurable: true
            });
          }
        },
        { allOwnKeys }
      );
      return a4;
    };
    var stripBOM = (content) => {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    };
    var inherits = (constructor, superConstructor, props, descriptors) => {
      constructor.prototype = Object.create(superConstructor.prototype, descriptors);
      Object.defineProperty(constructor.prototype, "constructor", {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(constructor, "super", {
        __proto__: null,
        value: superConstructor.prototype
      });
      props && Object.assign(constructor.prototype, props);
    };
    var toFlatObject = (sourceObj, destObj, filter3, propFilter) => {
      let props;
      let i;
      let prop;
      const merged = {};
      destObj = destObj || {};
      if (sourceObj == null) return destObj;
      do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while (i-- > 0) {
          prop = props[i];
          if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
            destObj[prop] = sourceObj[prop];
            merged[prop] = true;
          }
        }
        sourceObj = filter3 !== false && getPrototypeOf(sourceObj);
      } while (sourceObj && (!filter3 || filter3(sourceObj, destObj)) && sourceObj !== Object.prototype);
      return destObj;
    };
    var endsWith = (str, searchString, position) => {
      str = String(str);
      if (position === void 0 || position > str.length) {
        position = str.length;
      }
      position -= searchString.length;
      const lastIndex = str.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    };
    var toArray = (thing) => {
      if (!thing) return null;
      if (isArray(thing)) return thing;
      let i = thing.length;
      if (!isNumber(i)) return null;
      const arr = new Array(i);
      while (i-- > 0) {
        arr[i] = thing[i];
      }
      return arr;
    };
    var isTypedArray = /* @__PURE__ */ ((TypedArray) => {
      return (thing) => {
        return TypedArray && thing instanceof TypedArray;
      };
    })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
    var forEachEntry = (obj, fn) => {
      const generator = obj && obj[iterator];
      const _iterator = generator.call(obj);
      let result;
      while ((result = _iterator.next()) && !result.done) {
        const pair2 = result.value;
        fn.call(obj, pair2[0], pair2[1]);
      }
    };
    var matchAll = (regExp, str) => {
      let matches;
      const arr = [];
      while ((matches = regExp.exec(str)) !== null) {
        arr.push(matches);
      }
      return arr;
    };
    var isHTMLForm = kindOfTest("HTMLFormElement");
    var toCamelCase = (str) => {
      return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m3, p1, p2) {
        return p1.toUpperCase() + p2;
      });
    };
    var { propertyIsEnumerable } = Object.prototype;
    var isRegExp = kindOfTest("RegExp");
    var reduceDescriptors = (obj, reducer2) => {
      const descriptors = Object.getOwnPropertyDescriptors(obj);
      const reducedDescriptors = {};
      forEach(descriptors, (descriptor, name) => {
        let ret;
        if ((ret = reducer2(descriptor, name, obj)) !== false) {
          reducedDescriptors[name] = ret || descriptor;
        }
      });
      Object.defineProperties(obj, reducedDescriptors);
    };
    var freezeMethods = (obj) => {
      reduceDescriptors(obj, (descriptor, name) => {
        if (isFunction$1(obj) && ["arguments", "caller", "callee"].includes(name)) {
          return false;
        }
        const value = obj[name];
        if (!isFunction$1(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
          descriptor.writable = false;
          return;
        }
        if (!descriptor.set) {
          descriptor.set = () => {
            throw Error("Can not rewrite read-only method '" + name + "'");
          };
        }
      });
    };
    var toObjectSet = (arrayOrString, delimiter) => {
      const obj = {};
      const define2 = (arr) => {
        arr.forEach((value) => {
          obj[value] = true;
        });
      };
      isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
      return obj;
    };
    var noop3 = () => {
    };
    var toFiniteNumber = (value, defaultValue) => {
      return value != null && Number.isFinite(value = +value) ? value : defaultValue;
    };
    function isSpecCompliantForm(thing) {
      return !!(thing && isFunction$1(thing.append) && thing[toStringTag] === "FormData" && thing[iterator]);
    }
    var toJSONObject = (obj) => {
      const visited = /* @__PURE__ */ new WeakSet();
      const visit = (source) => {
        if (isObject(source)) {
          if (visited.has(source)) {
            return;
          }
          if (isBuffer(source)) {
            return source;
          }
          if (!("toJSON" in source)) {
            visited.add(source);
            const target = isArray(source) ? [] : {};
            forEach(source, (value, key) => {
              const reducedValue = visit(value);
              !isUndefined(reducedValue) && (target[key] = reducedValue);
            });
            visited.delete(source);
            return target;
          }
        }
        return source;
      };
      return visit(obj);
    };
    var isAsyncFn = kindOfTest("AsyncFunction");
    var isThenable = (thing) => thing && (isObject(thing) || isFunction$1(thing)) && isFunction$1(thing.then) && isFunction$1(thing.catch);
    var _setImmediate = ((setImmediateSupported, postMessageSupported) => {
      if (setImmediateSupported) {
        return setImmediate;
      }
      return postMessageSupported ? ((token, callbacks) => {
        _global.addEventListener(
          "message",
          ({ source, data }) => {
            if (source === _global && data === token) {
              callbacks.length && callbacks.shift()();
            }
          },
          false
        );
        return (cb) => {
          callbacks.push(cb);
          _global.postMessage(token, "*");
        };
      })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
    })(typeof setImmediate === "function", isFunction$1(_global.postMessage));
    var asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
    var isIterable = (thing) => thing != null && isFunction$1(thing[iterator]);
    var isSafeIterable = (thing) => thing != null && hasOwnInPrototypeChain(thing, iterator) && isIterable(thing);
    var utils$1 = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isBoolean,
      isObject,
      isPlainObject,
      isEmptyObject,
      isReadableStream,
      isRequest,
      isResponse,
      isHeaders,
      isUndefined,
      isDate,
      isFile,
      isReactNativeBlob,
      isReactNative,
      isBlob,
      isRegExp,
      isFunction: isFunction$1,
      isStream,
      isURLSearchParams,
      isTypedArray,
      isFileList,
      forEach,
      merge: merge2,
      extend: extend2,
      trim,
      stripBOM,
      inherits,
      toFlatObject,
      kindOf,
      kindOfTest,
      endsWith,
      toArray,
      forEachEntry,
      matchAll,
      isHTMLForm,
      hasOwnProperty,
      hasOwnProp: hasOwnProperty,
      // an alias to avoid ESLint no-prototype-builtins detection
      hasOwnInPrototypeChain,
      getSafeProp,
      reduceDescriptors,
      freezeMethods,
      toObjectSet,
      toCamelCase,
      noop: noop3,
      toFiniteNumber,
      findKey,
      global: _global,
      isContextDefined,
      isSpecCompliantForm,
      toJSONObject,
      isAsyncFn,
      isThenable,
      setImmediate: _setImmediate,
      asap,
      isIterable,
      isSafeIterable
    };
    var ignoreDuplicateOf = utils$1.toObjectSet([
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ]);
    var parseHeaders = (rawHeaders) => {
      const parsed = {};
      let key;
      let val;
      let i;
      rawHeaders && rawHeaders.split("\n").forEach(function parser2(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) {
          return;
        }
        if (key === "set-cookie") {
          if (parsed[key]) {
            parsed[key].push(val);
          } else {
            parsed[key] = [val];
          }
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      });
      return parsed;
    };
    function trimSPorHTAB(str) {
      let start2 = 0;
      let end = str.length;
      while (start2 < end) {
        const code = str.charCodeAt(start2);
        if (code !== 9 && code !== 32) {
          break;
        }
        start2 += 1;
      }
      while (end > start2) {
        const code = str.charCodeAt(end - 1);
        if (code !== 9 && code !== 32) {
          break;
        }
        end -= 1;
      }
      return start2 === 0 && end === str.length ? str : str.slice(start2, end);
    }
    var INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
    var INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
    function sanitizeValue(value, invalidChars) {
      if (utils$1.isArray(value)) {
        return value.map((item) => sanitizeValue(item, invalidChars));
      }
      return trimSPorHTAB(String(value).replace(invalidChars, ""));
    }
    var sanitizeHeaderValue = (value) => sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
    var sanitizeByteStringHeaderValue = (value) => sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
    function toByteStringHeaderObject(headers) {
      const byteStringHeaders = /* @__PURE__ */ Object.create(null);
      utils$1.forEach(headers.toJSON(), (value, header) => {
        byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
      });
      return byteStringHeaders;
    }
    var $internals = /* @__PURE__ */ Symbol("internals");
    function normalizeHeader(header) {
      return header && String(header).trim().toLowerCase();
    }
    function normalizeValue(value) {
      if (value === false || value == null) {
        return value;
      }
      return utils$1.isArray(value) ? value.map(normalizeValue) : sanitizeHeaderValue(String(value));
    }
    function parseTokens(str) {
      const tokens = /* @__PURE__ */ Object.create(null);
      const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
      let match;
      while (match = tokensRE.exec(str)) {
        tokens[match[1]] = match[2];
      }
      return tokens;
    }
    var isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
    function matchHeaderValue(context, value, header, filter3, isHeaderNameFilter) {
      if (utils$1.isFunction(filter3)) {
        return filter3.call(this, value, header);
      }
      if (isHeaderNameFilter) {
        value = header;
      }
      if (!utils$1.isString(value)) return;
      if (utils$1.isString(filter3)) {
        return value.indexOf(filter3) !== -1;
      }
      if (utils$1.isRegExp(filter3)) {
        return filter3.test(value);
      }
    }
    function formatHeader(header) {
      return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
        return char.toUpperCase() + str;
      });
    }
    function buildAccessors(obj, header) {
      const accessorName = utils$1.toCamelCase(" " + header);
      ["get", "set", "has"].forEach((methodName) => {
        Object.defineProperty(obj, methodName + accessorName, {
          // Null-proto descriptor so a polluted Object.prototype.get cannot turn
          // this data descriptor into an accessor descriptor on the way in.
          __proto__: null,
          value: function(arg1, arg2, arg3) {
            return this[methodName].call(this, header, arg1, arg2, arg3);
          },
          configurable: true
        });
      });
    }
    var AxiosHeaders = class {
      constructor(headers) {
        headers && this.set(headers);
      }
      set(header, valueOrRewrite, rewrite) {
        const self2 = this;
        function setHeader(_value, _header, _rewrite) {
          const lHeader = normalizeHeader(_header);
          if (!lHeader) {
            return;
          }
          const key = utils$1.findKey(self2, lHeader);
          if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
            self2[key || _header] = normalizeValue(_value);
          }
        }
        const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
        if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
          setHeaders(header, valueOrRewrite);
        } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
          setHeaders(parseHeaders(header), valueOrRewrite);
        } else if (utils$1.isObject(header) && utils$1.isSafeIterable(header)) {
          let obj = /* @__PURE__ */ Object.create(null), dest, key;
          for (const entry of header) {
            if (!utils$1.isArray(entry)) {
              throw new TypeError("Object iterator must return a key-value pair");
            }
            key = entry[0];
            if (utils$1.hasOwnProp(obj, key)) {
              dest = obj[key];
              obj[key] = utils$1.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]];
            } else {
              obj[key] = entry[1];
            }
          }
          setHeaders(obj, valueOrRewrite);
        } else {
          header != null && setHeader(valueOrRewrite, header, rewrite);
        }
        return this;
      }
      get(header, parser2) {
        header = normalizeHeader(header);
        if (header) {
          const key = utils$1.findKey(this, header);
          if (key) {
            const value = this[key];
            if (!parser2) {
              return value;
            }
            if (parser2 === true) {
              return parseTokens(value);
            }
            if (utils$1.isFunction(parser2)) {
              return parser2.call(this, value, key);
            }
            if (utils$1.isRegExp(parser2)) {
              return parser2.exec(value);
            }
            throw new TypeError("parser must be boolean|regexp|function");
          }
        }
      }
      has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
          const key = utils$1.findKey(this, header);
          return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
      }
      delete(header, matcher) {
        const self2 = this;
        let deleted = false;
        function deleteHeader(_header) {
          _header = normalizeHeader(_header);
          if (_header) {
            const key = utils$1.findKey(self2, _header);
            if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
              delete self2[key];
              deleted = true;
            }
          }
        }
        if (utils$1.isArray(header)) {
          header.forEach(deleteHeader);
        } else {
          deleteHeader(header);
        }
        return deleted;
      }
      clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while (i--) {
          const key = keys[i];
          if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
            delete this[key];
            deleted = true;
          }
        }
        return deleted;
      }
      normalize(format2) {
        const self2 = this;
        const headers = {};
        utils$1.forEach(this, (value, header) => {
          const key = utils$1.findKey(headers, header);
          if (key) {
            self2[key] = normalizeValue(value);
            delete self2[header];
            return;
          }
          const normalized = format2 ? formatHeader(header) : String(header).trim();
          if (normalized !== header) {
            delete self2[header];
          }
          self2[normalized] = normalizeValue(value);
          headers[normalized] = true;
        });
        return this;
      }
      concat(...targets) {
        return this.constructor.concat(this, ...targets);
      }
      toJSON(asStrings) {
        const obj = /* @__PURE__ */ Object.create(null);
        utils$1.forEach(this, (value, header) => {
          value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
        });
        return obj;
      }
      [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
      }
      toString() {
        return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
      }
      getSetCookie() {
        return this.get("set-cookie") || [];
      }
      get [Symbol.toStringTag]() {
        return "AxiosHeaders";
      }
      static from(thing) {
        return thing instanceof this ? thing : new this(thing);
      }
      static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target) => computed.set(target));
        return computed;
      }
      static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
          accessors: {}
        };
        const accessors = internals.accessors;
        const prototype2 = this.prototype;
        function defineAccessor(_header) {
          const lHeader = normalizeHeader(_header);
          if (!accessors[lHeader]) {
            buildAccessors(prototype2, _header);
            accessors[lHeader] = true;
          }
        }
        utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
      }
    };
    AxiosHeaders.accessor([
      "Content-Type",
      "Content-Length",
      "Accept",
      "Accept-Encoding",
      "User-Agent",
      "Authorization"
    ]);
    utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
      let mapped = key[0].toUpperCase() + key.slice(1);
      return {
        get: () => value,
        set(headerValue) {
          this[mapped] = headerValue;
        }
      };
    });
    utils$1.freezeMethods(AxiosHeaders);
    var REDACTED = "[REDACTED ****]";
    function hasOwnOrPrototypeToJSON(source) {
      if (utils$1.hasOwnProp(source, "toJSON")) {
        return true;
      }
      let prototype2 = Object.getPrototypeOf(source);
      while (prototype2 && prototype2 !== Object.prototype) {
        if (utils$1.hasOwnProp(prototype2, "toJSON")) {
          return true;
        }
        prototype2 = Object.getPrototypeOf(prototype2);
      }
      return false;
    }
    function redactConfig(config, redactKeys) {
      const lowerKeys = new Set(redactKeys.map((k2) => String(k2).toLowerCase()));
      const seen = [];
      const visit = (source) => {
        if (source === null || typeof source !== "object") return source;
        if (utils$1.isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return void 0;
        if (source instanceof AxiosHeaders) {
          source = source.toJSON();
        }
        seen.push(source);
        let result;
        if (utils$1.isArray(source)) {
          result = [];
          source.forEach((v2, i) => {
            const reducedValue = visit(v2);
            if (!utils$1.isUndefined(reducedValue)) {
              result[i] = reducedValue;
            }
          });
        } else {
          if (!utils$1.isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
            seen.pop();
            return source;
          }
          result = /* @__PURE__ */ Object.create(null);
          for (const [key, value] of Object.entries(source)) {
            const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
            if (!utils$1.isUndefined(reducedValue)) {
              result[key] = reducedValue;
            }
          }
        }
        seen.pop();
        return result;
      };
      return visit(config);
    }
    var AxiosError = class _AxiosError extends Error {
      static from(error, code, config, request, response, customProps) {
        const axiosError = new _AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        if (error.status != null && axiosError.status == null) {
          axiosError.status = error.status;
        }
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
      }
      /**
       * Create an Error with the specified message, config, error code, request and response.
       *
       * @param {string} message The error message.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [config] The config.
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       *
       * @returns {Error} The created error.
       */
      constructor(message, code, config, request, response) {
        super(message);
        Object.defineProperty(this, "message", {
          // Null-proto descriptor so a polluted Object.prototype.get cannot turn
          // this data descriptor into an accessor descriptor on the way in.
          __proto__: null,
          value: message,
          enumerable: true,
          writable: true,
          configurable: true
        });
        this.name = "AxiosError";
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
          this.response = response;
          this.status = response.status;
        }
      }
      toJSON() {
        const config = this.config;
        const redactKeys = config && utils$1.hasOwnProp(config, "redact") ? config.redact : void 0;
        const serializedConfig = utils$1.isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : utils$1.toJSONObject(config);
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: serializedConfig,
          code: this.code,
          status: this.status
        };
      }
    };
    AxiosError.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
    AxiosError.ERR_BAD_OPTION = "ERR_BAD_OPTION";
    AxiosError.ECONNABORTED = "ECONNABORTED";
    AxiosError.ETIMEDOUT = "ETIMEDOUT";
    AxiosError.ECONNREFUSED = "ECONNREFUSED";
    AxiosError.ERR_NETWORK = "ERR_NETWORK";
    AxiosError.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
    AxiosError.ERR_DEPRECATED = "ERR_DEPRECATED";
    AxiosError.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
    AxiosError.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
    AxiosError.ERR_CANCELED = "ERR_CANCELED";
    AxiosError.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
    AxiosError.ERR_INVALID_URL = "ERR_INVALID_URL";
    AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
    var httpAdapter = null;
    var DEFAULT_FORM_DATA_MAX_DEPTH = 100;
    function isVisitable(thing) {
      return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
    }
    function removeBrackets(key) {
      return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
    }
    function renderKey(path2, key, dots) {
      if (!path2) return key;
      return path2.concat(key).map(function each(token, i) {
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
      }).join(dots ? "." : "");
    }
    function isFlatArray(arr) {
      return utils$1.isArray(arr) && !arr.some(isVisitable);
    }
    var predicates = utils$1.toFlatObject(utils$1, {}, null, function filter3(prop) {
      return /^is[A-Z]/.test(prop);
    });
    function toFormData(obj, formData, options) {
      if (!utils$1.isObject(obj)) {
        throw new TypeError("target must be an object");
      }
      formData = formData || new FormData();
      options = utils$1.toFlatObject(
        options,
        {
          metaTokens: true,
          dots: false,
          indexes: false
        },
        false,
        function defined(option, source) {
          return !utils$1.isUndefined(source[option]);
        }
      );
      const metaTokens = options.metaTokens;
      const visitor = options.visitor || defaultVisitor;
      const dots = options.dots;
      const indexes2 = options.indexes;
      const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
      const maxDepth2 = options.maxDepth === void 0 ? DEFAULT_FORM_DATA_MAX_DEPTH : options.maxDepth;
      const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
      const stack = [];
      if (!utils$1.isFunction(visitor)) {
        throw new TypeError("visitor must be a function");
      }
      function convertValue(value) {
        if (value === null) return "";
        if (utils$1.isDate(value)) {
          return value.toISOString();
        }
        if (utils$1.isBoolean(value)) {
          return value.toString();
        }
        if (!useBlob && utils$1.isBlob(value)) {
          throw new AxiosError("Blob is not supported. Use a Buffer instead.");
        }
        if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
          return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
        }
        return value;
      }
      function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth2) {
          throw new AxiosError(
            "Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth2,
            AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED
          );
        }
      }
      function stringifyWithDepthLimit(value, depth) {
        if (maxDepth2 === Infinity) {
          return JSON.stringify(value);
        }
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
          if (!utils$1.isObject(currentValue)) {
            return currentValue;
          }
          while (ancestors.length && ancestors[ancestors.length - 1] !== this) {
            ancestors.pop();
          }
          ancestors.push(currentValue);
          throwIfMaxDepthExceeded(depth + ancestors.length - 1);
          return currentValue;
        });
      }
      function defaultVisitor(value, key, path2) {
        let arr = value;
        if (utils$1.isReactNative(formData) && utils$1.isReactNativeBlob(value)) {
          formData.append(renderKey(path2, key, dots), convertValue(value));
          return false;
        }
        if (value && !path2 && typeof value === "object") {
          if (utils$1.endsWith(key, "{}")) {
            key = metaTokens ? key : key.slice(0, -2);
            value = stringifyWithDepthLimit(value, 1);
          } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
            key = removeBrackets(key);
            arr.forEach(function each(el, index3) {
              !(utils$1.isUndefined(el) || el === null) && formData.append(
                // eslint-disable-next-line no-nested-ternary
                indexes2 === true ? renderKey([key], index3, dots) : indexes2 === null ? key : key + "[]",
                convertValue(el)
              );
            });
            return false;
          }
        }
        if (isVisitable(value)) {
          return true;
        }
        formData.append(renderKey(path2, key, dots), convertValue(value));
        return false;
      }
      const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
      });
      function build(value, path2, depth = 0) {
        if (utils$1.isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) {
          throw new Error("Circular reference detected in " + path2.join("."));
        }
        stack.push(value);
        utils$1.forEach(value, function each(el, key) {
          const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, utils$1.isString(key) ? key.trim() : key, path2, exposedHelpers);
          if (result === true) {
            build(el, path2 ? path2.concat(key) : [key], depth + 1);
          }
        });
        stack.pop();
      }
      if (!utils$1.isObject(obj)) {
        throw new TypeError("data must be an object");
      }
      build(obj);
      return formData;
    }
    function encode$1(str) {
      const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
      };
      return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
      });
    }
    function AxiosURLSearchParams(params, options) {
      this._pairs = [];
      params && toFormData(params, this, options);
    }
    var prototype = AxiosURLSearchParams.prototype;
    prototype.append = function append3(name, value) {
      this._pairs.push([name, value]);
    };
    prototype.toString = function toString2(encoder) {
      const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode$1);
      } : encode$1;
      return this._pairs.map(function each(pair2) {
        return _encode(pair2[0]) + "=" + _encode(pair2[1]);
      }, "").join("&");
    };
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
    }
    function buildURL(url, params, options) {
      if (!params) {
        return url;
      }
      const _options = utils$1.isFunction(options) ? {
        serialize: options
      } : options;
      const _encode = utils$1.getSafeProp(_options, "encode") || encode;
      const serializeFn = utils$1.getSafeProp(_options, "serialize");
      let serializedParams;
      if (serializeFn) {
        serializedParams = serializeFn(params, _options);
      } else {
        serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, _options).toString(_encode);
      }
      if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    }
    var InterceptorManager = class {
      constructor() {
        this.handlers = [];
      }
      /**
       * Add a new interceptor to the stack
       *
       * @param {Function} fulfilled The function to handle `then` for a `Promise`
       * @param {Function} rejected The function to handle `reject` for a `Promise`
       * @param {Object} options The options for the interceptor, synchronous and runWhen
       *
       * @return {Number} An ID used to remove interceptor later
       */
      use(fulfilled, rejected, options) {
        this.handlers.push({
          fulfilled,
          rejected,
          synchronous: options ? options.synchronous : false,
          runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
      }
      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       *
       * @returns {void}
       */
      eject(id2) {
        if (this.handlers[id2]) {
          this.handlers[id2] = null;
        }
      }
      /**
       * Clear all interceptors from the stack
       *
       * @returns {void}
       */
      clear() {
        if (this.handlers) {
          this.handlers = [];
        }
      }
      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       *
       * @returns {void}
       */
      forEach(fn) {
        utils$1.forEach(this.handlers, function forEachHandler(h) {
          if (h !== null) {
            fn(h);
          }
        });
      }
    };
    var transitionalDefaults = {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false,
      legacyInterceptorReqResOrdering: true,
      advertiseZstdAcceptEncoding: false,
      validateStatusUndefinedResolves: true
    };
    var URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
    var FormData$1 = typeof FormData !== "undefined" ? FormData : null;
    var Blob$1 = typeof Blob !== "undefined" ? Blob : null;
    var platform$1 = {
      isBrowser: true,
      classes: {
        URLSearchParams: URLSearchParams$1,
        FormData: FormData$1,
        Blob: Blob$1
      },
      protocols: ["http", "https", "file", "blob", "url", "data"]
    };
    var hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
    var _navigator = typeof navigator === "object" && navigator || void 0;
    var hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
    var hasStandardBrowserWebWorkerEnv = (() => {
      return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
      self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
    })();
    var origin = hasBrowserEnv && window.location.href || "http://localhost";
    var utils = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      hasBrowserEnv,
      hasStandardBrowserEnv,
      hasStandardBrowserWebWorkerEnv,
      navigator: _navigator,
      origin
    });
    var platform = {
      ...utils,
      ...platform$1
    };
    function toURLEncodedForm(data, options) {
      return toFormData(data, new platform.classes.URLSearchParams(), {
        visitor: function(value, key, path2, helpers) {
          if (platform.isNode && utils$1.isBuffer(value)) {
            this.append(key, value.toString("base64"));
            return false;
          }
          return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
      });
    }
    var MAX_DEPTH = DEFAULT_FORM_DATA_MAX_DEPTH;
    function throwIfDepthExceeded(index3) {
      if (index3 > MAX_DEPTH) {
        throw new AxiosError(
          "FormData field is too deeply nested (" + index3 + " levels). Max depth: " + MAX_DEPTH,
          AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      }
    }
    function parsePropPath(name) {
      const path2 = [];
      const pattern = /\w+|\[(\w*)]/g;
      let match;
      while ((match = pattern.exec(name)) !== null) {
        throwIfDepthExceeded(path2.length);
        path2.push(match[0] === "[]" ? "" : match[1] || match[0]);
      }
      return path2;
    }
    function arrayToObject(arr) {
      const obj = {};
      const keys = Object.keys(arr);
      let i;
      const len = keys.length;
      let key;
      for (i = 0; i < len; i++) {
        key = keys[i];
        obj[key] = arr[key];
      }
      return obj;
    }
    function formDataToJSON(formData) {
      function buildPath(path2, value, target, index3) {
        throwIfDepthExceeded(index3);
        let name = path2[index3++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index3 >= path2.length;
        name = !name && utils$1.isArray(target) ? target.length : name;
        if (isLast) {
          if (utils$1.hasOwnProp(target, name)) {
            target[name] = utils$1.isArray(target[name]) ? target[name].concat(value) : [target[name], value];
          } else {
            target[name] = value;
          }
          return !isNumericKey;
        }
        if (!utils$1.hasOwnProp(target, name) || !utils$1.isObject(target[name])) {
          target[name] = [];
        }
        const result = buildPath(path2, value, target[name], index3);
        if (result && utils$1.isArray(target[name])) {
          target[name] = arrayToObject(target[name]);
        }
        return !isNumericKey;
      }
      if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
        const obj = {};
        utils$1.forEachEntry(formData, (name, value) => {
          buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
      }
      return null;
    }
    var own = (obj, key) => obj != null && utils$1.hasOwnProp(obj, key) ? obj[key] : void 0;
    function stringifySafely(rawValue, parser2, encoder) {
      if (utils$1.isString(rawValue)) {
        try {
          (parser2 || JSON.parse)(rawValue);
          return utils$1.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: transitionalDefaults,
      adapter: ["xhr", "http", "fetch"],
      transformRequest: [
        function transformRequest(data, headers) {
          const contentType = headers.getContentType() || "";
          const hasJSONContentType = contentType.indexOf("application/json") > -1;
          const isObjectPayload = utils$1.isObject(data);
          if (isObjectPayload && utils$1.isHTMLForm(data)) {
            data = new FormData(data);
          }
          const isFormData2 = utils$1.isFormData(data);
          if (isFormData2) {
            return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
          }
          if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
            return data;
          }
          if (utils$1.isArrayBufferView(data)) {
            return data.buffer;
          }
          if (utils$1.isURLSearchParams(data)) {
            headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
            return data.toString();
          }
          let isFileList2;
          if (isObjectPayload) {
            const formSerializer = own(this, "formSerializer");
            if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
              return toURLEncodedForm(data, formSerializer).toString();
            }
            if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
              const env = own(this, "env");
              const _FormData = env && env.FormData;
              return toFormData(
                isFileList2 ? { "files[]": data } : data,
                _FormData && new _FormData(),
                formSerializer
              );
            }
          }
          if (isObjectPayload || hasJSONContentType) {
            headers.setContentType("application/json", false);
            return stringifySafely(data);
          }
          return data;
        }
      ],
      transformResponse: [
        function transformResponse(data) {
          const transitional = own(this, "transitional") || defaults.transitional;
          const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
          const responseType = own(this, "responseType");
          const JSONRequested = responseType === "json";
          if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
            return data;
          }
          if (data && utils$1.isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
            const silentJSONParsing = transitional && transitional.silentJSONParsing;
            const strictJSONParsing = !silentJSONParsing && JSONRequested;
            try {
              return JSON.parse(data, own(this, "parseReviver"));
            } catch (e) {
              if (strictJSONParsing) {
                if (e.name === "SyntaxError") {
                  throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, own(this, "response"));
                }
                throw e;
              }
            }
          }
          return data;
        }
      ],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: platform.classes.FormData,
        Blob: platform.classes.Blob
      },
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": void 0
        }
      }
    };
    utils$1.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (method) => {
      defaults.headers[method] = {};
    });
    function transformData(fns, response) {
      const config = this || defaults;
      const context = response || config;
      const headers = AxiosHeaders.from(context.headers);
      let data = context.data;
      utils$1.forEach(fns, function transform2(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
      });
      headers.normalize();
      return data;
    }
    function isCancel(value) {
      return !!(value && value.__CANCEL__);
    }
    var CanceledError = class extends AxiosError {
      /**
       * A `CanceledError` is an object that is thrown when an operation is canceled.
       *
       * @param {string=} message The message.
       * @param {Object=} config The config.
       * @param {Object=} request The request.
       *
       * @returns {CanceledError} The created error.
       */
      constructor(message, config, request) {
        super(message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
        this.name = "CanceledError";
        this.__CANCEL__ = true;
      }
    };
    function settle(resolve, reject, response) {
      const validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(new AxiosError(
          "Request failed with status code " + response.status,
          response.status >= 400 && response.status < 500 ? AxiosError.ERR_BAD_REQUEST : AxiosError.ERR_BAD_RESPONSE,
          response.config,
          response.request,
          response
        ));
      }
    }
    function parseProtocol(url) {
      const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
      return match && match[1] || "";
    }
    function speedometer(samplesCount, min4) {
      samplesCount = samplesCount || 10;
      const bytes = new Array(samplesCount);
      const timestamps = new Array(samplesCount);
      let head = 0;
      let tail = 0;
      let firstSampleTS;
      min4 = min4 !== void 0 ? min4 : 1e3;
      return function push(chunkLength) {
        const now2 = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) {
          firstSampleTS = now2;
        }
        bytes[head] = chunkLength;
        timestamps[head] = now2;
        let i = tail;
        let bytesCount = 0;
        while (i !== head) {
          bytesCount += bytes[i++];
          i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) {
          tail = (tail + 1) % samplesCount;
        }
        if (now2 - firstSampleTS < min4) {
          return;
        }
        const passed = startedAt && now2 - startedAt;
        return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
      };
    }
    function throttle(fn, freq) {
      let timestamp = 0;
      let threshold2 = 1e3 / freq;
      let lastArgs;
      let timer2;
      const invoke = (args, now2 = Date.now()) => {
        timestamp = now2;
        lastArgs = null;
        if (timer2) {
          clearTimeout(timer2);
          timer2 = null;
        }
        fn(...args);
      };
      const throttled = (...args) => {
        const now2 = Date.now();
        const passed = now2 - timestamp;
        if (passed >= threshold2) {
          invoke(args, now2);
        } else {
          lastArgs = args;
          if (!timer2) {
            timer2 = setTimeout(() => {
              timer2 = null;
              invoke(lastArgs);
            }, threshold2 - passed);
          }
        }
      };
      const flush = () => lastArgs && invoke(lastArgs);
      return [throttled, flush];
    }
    var progressEventReducer = (listener, isDownloadStream, freq = 3) => {
      let bytesNotified = 0;
      const _speedometer = speedometer(50, 250);
      return throttle((e) => {
        if (!e || typeof e.loaded !== "number") {
          return;
        }
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : void 0;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
          loaded,
          total,
          progress: total ? loaded / total : void 0,
          bytes: progressBytes,
          rate: rate ? rate : void 0,
          estimated: rate && total ? (total - loaded) / rate : void 0,
          event: e,
          lengthComputable: total != null,
          [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
      }, freq);
    };
    var progressEventDecorator = (total, throttled) => {
      const lengthComputable = total != null;
      return [
        (loaded) => throttled[0]({
          lengthComputable,
          total,
          loaded
        }),
        throttled[1]
      ];
    };
    var asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));
    var isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
      url = new URL(url, platform.origin);
      return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
    })(
      new URL(platform.origin),
      platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
    ) : () => true;
    var cookies = platform.hasStandardBrowserEnv ? (
      // Standard browser envs support document.cookie
      {
        write(name, value, expires, path2, domain, secure, sameSite) {
          if (typeof document === "undefined") return;
          const cookie = [`${name}=${encodeURIComponent(value)}`];
          if (utils$1.isNumber(expires)) {
            cookie.push(`expires=${new Date(expires).toUTCString()}`);
          }
          if (utils$1.isString(path2)) {
            cookie.push(`path=${path2}`);
          }
          if (utils$1.isString(domain)) {
            cookie.push(`domain=${domain}`);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          if (utils$1.isString(sameSite)) {
            cookie.push(`SameSite=${sameSite}`);
          }
          document.cookie = cookie.join("; ");
        },
        read(name) {
          if (typeof document === "undefined") return null;
          const cookies2 = document.cookie.split(";");
          for (let i = 0; i < cookies2.length; i++) {
            const cookie = cookies2[i].replace(/^\s+/, "");
            const eq = cookie.indexOf("=");
            if (eq !== -1 && cookie.slice(0, eq) === name) {
              return decodeURIComponent(cookie.slice(eq + 1));
            }
          }
          return null;
        },
        remove(name) {
          this.write(name, "", Date.now() - 864e5, "/");
        }
      }
    ) : (
      // Non-standard browser env (web workers, react-native) lack needed support.
      {
        write() {
        },
        read() {
          return null;
        },
        remove() {
        }
      }
    );
    function isAbsoluteURL(url) {
      if (typeof url !== "string") {
        return false;
      }
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    }
    function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    }
    var malformedHttpProtocol = /^https?:(?!\/\/)/i;
    var httpProtocolControlCharacters = /[\t\n\r]/g;
    function stripLeadingC0ControlOrSpace(url) {
      let i = 0;
      while (i < url.length && url.charCodeAt(i) <= 32) {
        i++;
      }
      return url.slice(i);
    }
    function normalizeURLForProtocolCheck(url) {
      return stripLeadingC0ControlOrSpace(url).replace(httpProtocolControlCharacters, "");
    }
    function assertValidHttpProtocolURL(url, config) {
      if (typeof url === "string" && malformedHttpProtocol.test(normalizeURLForProtocolCheck(url))) {
        throw new AxiosError(
          'Invalid URL: missing "//" after protocol',
          AxiosError.ERR_INVALID_URL,
          config
        );
      }
    }
    function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
      assertValidHttpProtocolURL(requestedURL, config);
      let isRelativeUrl = !isAbsoluteURL(requestedURL);
      if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        assertValidHttpProtocolURL(baseURL, config);
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    }
    var headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;
    function mergeConfig(config1, config2) {
      config2 = config2 || {};
      const config = /* @__PURE__ */ Object.create(null);
      Object.defineProperty(config, "hasOwnProperty", {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
      });
      function getMergedValue(target, source, prop, caseless) {
        if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
          return utils$1.merge.call({ caseless }, target, source);
        } else if (utils$1.isPlainObject(source)) {
          return utils$1.merge({}, source);
        } else if (utils$1.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(a4, b, prop, caseless) {
        if (!utils$1.isUndefined(b)) {
          return getMergedValue(a4, b, prop, caseless);
        } else if (!utils$1.isUndefined(a4)) {
          return getMergedValue(void 0, a4, prop, caseless);
        }
      }
      function valueFromConfig2(a4, b) {
        if (!utils$1.isUndefined(b)) {
          return getMergedValue(void 0, b);
        }
      }
      function defaultToConfig2(a4, b) {
        if (!utils$1.isUndefined(b)) {
          return getMergedValue(void 0, b);
        } else if (!utils$1.isUndefined(a4)) {
          return getMergedValue(void 0, a4);
        }
      }
      function getMergedTransitionalOption(prop) {
        const transitional2 = utils$1.hasOwnProp(config2, "transitional") ? config2.transitional : void 0;
        if (!utils$1.isUndefined(transitional2)) {
          if (utils$1.isPlainObject(transitional2)) {
            if (utils$1.hasOwnProp(transitional2, prop)) {
              return transitional2[prop];
            }
          } else {
            return void 0;
          }
        }
        const transitional1 = utils$1.hasOwnProp(config1, "transitional") ? config1.transitional : void 0;
        if (utils$1.isPlainObject(transitional1) && utils$1.hasOwnProp(transitional1, prop)) {
          return transitional1[prop];
        }
        return void 0;
      }
      function mergeDirectKeys(a4, b, prop) {
        if (utils$1.hasOwnProp(config2, prop)) {
          return getMergedValue(a4, b);
        } else if (utils$1.hasOwnProp(config1, prop)) {
          return getMergedValue(void 0, a4);
        }
      }
      const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a4, b, prop) => mergeDeepProperties(headersToObject(a4), headersToObject(b), prop, true)
      };
      utils$1.forEach(Object.keys({ ...config1, ...config2 }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge3 = utils$1.hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a4 = utils$1.hasOwnProp(config1, prop) ? config1[prop] : void 0;
        const b = utils$1.hasOwnProp(config2, prop) ? config2[prop] : void 0;
        const configValue = merge3(a4, b, prop);
        utils$1.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
      });
      if (utils$1.hasOwnProp(config2, "validateStatus") && utils$1.isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
        if (utils$1.hasOwnProp(config1, "validateStatus")) {
          config.validateStatus = getMergedValue(void 0, config1.validateStatus);
        } else {
          delete config.validateStatus;
        }
      }
      return config;
    }
    var FORM_DATA_CONTENT_HEADERS = ["content-type", "content-length"];
    function setFormDataHeaders(headers, formHeaders, policy) {
      if (policy !== "content-only") {
        headers.set(formHeaders);
        return;
      }
      Object.entries(formHeaders).forEach(([key, val]) => {
        if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) {
          headers.set(key, val);
        }
      });
    }
    var encodeUTF8$1 = (str) => encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/gi,
      (_, hex2) => String.fromCharCode(parseInt(hex2, 16))
    );
    function resolveConfig(config) {
      const newConfig = mergeConfig({}, config);
      const own2 = (key) => utils$1.hasOwnProp(newConfig, key) ? newConfig[key] : void 0;
      const data = own2("data");
      let withXSRFToken = own2("withXSRFToken");
      const xsrfHeaderName = own2("xsrfHeaderName");
      const xsrfCookieName = own2("xsrfCookieName");
      let headers = own2("headers");
      const auth = own2("auth");
      const baseURL = own2("baseURL");
      const allowAbsoluteUrls = own2("allowAbsoluteUrls");
      const url = own2("url");
      newConfig.headers = headers = AxiosHeaders.from(headers);
      newConfig.url = buildURL(
        buildFullPath(baseURL, url, allowAbsoluteUrls, newConfig),
        own2("params"),
        own2("paramsSerializer")
      );
      if (auth) {
        const username = utils$1.getSafeProp(auth, "username") || "";
        const password = utils$1.getSafeProp(auth, "password") || "";
        headers.set(
          "Authorization",
          "Basic " + btoa(username + ":" + (password ? encodeUTF8$1(password) : ""))
        );
      }
      if (utils$1.isFormData(data)) {
        if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv || utils$1.isReactNative(data)) {
          headers.setContentType(void 0);
        } else if (utils$1.isFunction(data.getHeaders)) {
          setFormDataHeaders(headers, data.getHeaders(), own2("formDataHeaderPolicy"));
        }
      }
      if (platform.hasStandardBrowserEnv) {
        if (utils$1.isFunction(withXSRFToken)) {
          withXSRFToken = withXSRFToken(newConfig);
        }
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && isURLSameOrigin(newConfig.url);
        if (shouldSendXSRF) {
          const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
          if (xsrfValue) {
            headers.set(xsrfHeaderName, xsrfValue);
          }
        }
      }
      return newConfig;
    }
    var isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
    var xhrAdapter = isXHRAdapterSupported && function(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = resolveConfig(config);
        let requestData = _config.data;
        const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
          flushUpload && flushUpload();
          flushDownload && flushDownload();
          _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
          _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        request.timeout = _config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          const responseHeaders = AxiosHeaders.from(
            "getAllResponseHeaders" in request && request.getAllResponseHeaders()
          );
          const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          const response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(
            function _resolve(value) {
              resolve(value);
              done();
            },
            function _reject(err) {
              reject(err);
              done();
            },
            response
          );
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
          done();
          request = null;
        };
        request.onerror = function handleError(event) {
          const msg = event && event.message ? event.message : "Network Error";
          const err = new AxiosError(msg, AxiosError.ERR_NETWORK, config, request);
          err.event = event || null;
          reject(err);
          done();
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
          const transitional = _config.transitional || transitionalDefaults;
          if (_config.timeoutErrorMessage) {
            timeoutErrorMessage = _config.timeoutErrorMessage;
          }
          reject(
            new AxiosError(
              timeoutErrorMessage,
              transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
              config,
              request
            )
          );
          done();
          request = null;
        };
        requestData === void 0 && requestHeaders.setContentType(null);
        if ("setRequestHeader" in request) {
          utils$1.forEach(toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
          });
        }
        if (!utils$1.isUndefined(_config.withCredentials)) {
          request.withCredentials = !!_config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = _config.responseType;
        }
        if (onDownloadProgress) {
          [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
          request.addEventListener("progress", downloadThrottled);
        }
        if (onUploadProgress && request.upload) {
          [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
          request.upload.addEventListener("progress", uploadThrottled);
          request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
          onCanceled = (cancel) => {
            if (!request) {
              return;
            }
            reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
            request.abort();
            done();
            request = null;
          };
          _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
          if (_config.signal) {
            _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
          }
        }
        const protocol = parseProtocol(_config.url);
        if (protocol && !platform.protocols.includes(protocol)) {
          reject(
            new AxiosError(
              "Unsupported protocol " + protocol + ":",
              AxiosError.ERR_BAD_REQUEST,
              config
            )
          );
          return;
        }
        request.send(requestData || null);
      });
    };
    var composeSignals = (signals, timeout2) => {
      signals = signals ? signals.filter(Boolean) : [];
      if (!timeout2 && !signals.length) {
        return;
      }
      const controller = new AbortController();
      let aborted = false;
      const onabort = function(reason) {
        if (!aborted) {
          aborted = true;
          unsubscribe();
          const err = reason instanceof Error ? reason : this.reason;
          controller.abort(
            err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err)
          );
        }
      };
      let timer2 = timeout2 && setTimeout(() => {
        timer2 = null;
        onabort(new AxiosError(`timeout of ${timeout2}ms exceeded`, AxiosError.ETIMEDOUT));
      }, timeout2);
      const unsubscribe = () => {
        if (!signals) {
          return;
        }
        timer2 && clearTimeout(timer2);
        timer2 = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      };
      signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
      const { signal } = controller;
      signal.unsubscribe = () => utils$1.asap(unsubscribe);
      return signal;
    };
    var streamChunk = function* (chunk, chunkSize) {
      let len = chunk.byteLength;
      if (len < chunkSize) {
        yield chunk;
        return;
      }
      let pos = 0;
      let end;
      while (pos < len) {
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
      }
    };
    var readBytes = async function* (iterable, chunkSize) {
      for await (const chunk of readStream(iterable)) {
        yield* streamChunk(chunk, chunkSize);
      }
    };
    var readStream = async function* (stream) {
      if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
      }
      const reader = stream.getReader();
      try {
        for (; ; ) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }
          yield value;
        }
      } finally {
        await reader.cancel();
      }
    };
    var trackStream = (stream, chunkSize, onProgress, onFinish) => {
      const iterator2 = readBytes(stream, chunkSize);
      let bytes = 0;
      let done;
      let _onFinish = (e) => {
        if (!done) {
          done = true;
          onFinish && onFinish(e);
        }
      };
      return new ReadableStream(
        {
          async pull(controller) {
            try {
              const { done: done2, value } = await iterator2.next();
              if (done2) {
                _onFinish();
                controller.close();
                return;
              }
              let len = value.byteLength;
              if (onProgress) {
                let loadedBytes = bytes += len;
                onProgress(loadedBytes);
              }
              controller.enqueue(new Uint8Array(value));
            } catch (err) {
              _onFinish(err);
              throw err;
            }
          },
          cancel(reason) {
            _onFinish(reason);
            return iterator2.return();
          }
        },
        {
          highWaterMark: 2
        }
      );
    };
    var isHexDigit = (charCode) => charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
    var isPercentEncodedByte = (str, i, len) => i + 2 < len && isHexDigit(str.charCodeAt(i + 1)) && isHexDigit(str.charCodeAt(i + 2));
    function estimateDataURLDecodedBytes(url) {
      if (!url || typeof url !== "string") return 0;
      if (!url.startsWith("data:")) return 0;
      const comma = url.indexOf(",");
      if (comma < 0) return 0;
      const meta = url.slice(5, comma);
      const body = url.slice(comma + 1);
      const isBase64 = /;base64/i.test(meta);
      if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length;
        for (let i = 0; i < len; i++) {
          if (body.charCodeAt(i) === 37 && i + 2 < len) {
            const a4 = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = isHexDigit(a4) && isHexDigit(b);
            if (isHex) {
              effectiveLen -= 2;
              i += 2;
            }
          }
        }
        let pad3 = 0;
        let idx = len - 1;
        const tailIsPct3D = (j) => j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
        body.charCodeAt(j - 1) === 51 && // '3'
        (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100);
        if (idx >= 0) {
          if (body.charCodeAt(idx) === 61) {
            pad3++;
            idx--;
          } else if (tailIsPct3D(idx)) {
            pad3++;
            idx -= 3;
          }
        }
        if (pad3 === 1 && idx >= 0) {
          if (body.charCodeAt(idx) === 61) {
            pad3++;
          } else if (tailIsPct3D(idx)) {
            pad3++;
          }
        }
        const groups2 = Math.floor(effectiveLen / 4);
        const bytes2 = groups2 * 3 - (pad3 || 0);
        return bytes2 > 0 ? bytes2 : 0;
      }
      let bytes = 0;
      for (let i = 0, len = body.length; i < len; i++) {
        const c6 = body.charCodeAt(i);
        if (c6 === 37 && isPercentEncodedByte(body, i, len)) {
          bytes += 1;
          i += 2;
        } else if (c6 < 128) {
          bytes += 1;
        } else if (c6 < 2048) {
          bytes += 2;
        } else if (c6 >= 55296 && c6 <= 56319 && i + 1 < len) {
          const next = body.charCodeAt(i + 1);
          if (next >= 56320 && next <= 57343) {
            bytes += 4;
            i++;
          } else {
            bytes += 3;
          }
        } else {
          bytes += 3;
        }
      }
      return bytes;
    }
    var VERSION = "1.18.0";
    var DEFAULT_CHUNK_SIZE = 64 * 1024;
    var { isFunction } = utils$1;
    var encodeUTF8 = (str) => encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/gi,
      (_, hex2) => String.fromCharCode(parseInt(hex2, 16))
    );
    var decodeURIComponentSafe = (value) => {
      if (!utils$1.isString(value)) {
        return value;
      }
      try {
        return decodeURIComponent(value);
      } catch (error) {
        return value;
      }
    };
    var test = (fn, ...args) => {
      try {
        return !!fn(...args);
      } catch (e) {
        return false;
      }
    };
    var maybeWithAuthCredentials = (url) => {
      const protocolIndex = url.indexOf("://");
      let urlToCheck = url;
      if (protocolIndex !== -1) {
        urlToCheck = urlToCheck.slice(protocolIndex + 3);
      }
      return urlToCheck.includes("@") || urlToCheck.includes(":");
    };
    var factory = (env) => {
      const globalObject = utils$1.global !== void 0 && utils$1.global !== null ? utils$1.global : globalThis;
      const { ReadableStream: ReadableStream2, TextEncoder } = globalObject;
      env = utils$1.merge.call(
        {
          skipUndefined: true
        },
        {
          Request: globalObject.Request,
          Response: globalObject.Response
        },
        env
      );
      const { fetch: envFetch, Request, Response } = env;
      const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === "function";
      const isRequestSupported = isFunction(Request);
      const isResponseSupported = isFunction(Response);
      if (!isFetchSupported) {
        return false;
      }
      const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream2);
      const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Request(str).arrayBuffer()));
      const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(() => {
        let duplexAccessed = false;
        const request = new Request(platform.origin, {
          body: new ReadableStream2(),
          method: "POST",
          get duplex() {
            duplexAccessed = true;
            return "half";
          }
        });
        const hasContentType = request.headers.has("Content-Type");
        if (request.body != null) {
          request.body.cancel();
        }
        return duplexAccessed && !hasContentType;
      });
      const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
      const resolvers = {
        stream: supportsResponseStream && ((res) => res.body)
      };
      isFetchSupported && (() => {
        ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type2) => {
          !resolvers[type2] && (resolvers[type2] = (res, config) => {
            let method = res && res[type2];
            if (method) {
              return method.call(res);
            }
            throw new AxiosError(
              `Response type '${type2}' is not supported`,
              AxiosError.ERR_NOT_SUPPORT,
              config
            );
          });
        });
      })();
      const getBodyLength = async (body) => {
        if (body == null) {
          return 0;
        }
        if (utils$1.isBlob(body)) {
          return body.size;
        }
        if (utils$1.isSpecCompliantForm(body)) {
          const _request = new Request(platform.origin, {
            method: "POST",
            body
          });
          return (await _request.arrayBuffer()).byteLength;
        }
        if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
          return body.byteLength;
        }
        if (utils$1.isURLSearchParams(body)) {
          body = body + "";
        }
        if (utils$1.isString(body)) {
          return (await encodeText(body)).byteLength;
        }
      };
      const resolveBodyLength = async (headers, body) => {
        const length3 = utils$1.toFiniteNumber(headers.getContentLength());
        return length3 == null ? getBodyLength(body) : length3;
      };
      return async (config) => {
        let {
          url,
          method,
          data,
          signal,
          cancelToken,
          timeout: timeout2,
          onDownloadProgress,
          onUploadProgress,
          responseType,
          headers,
          withCredentials = "same-origin",
          fetchOptions,
          maxContentLength,
          maxBodyLength
        } = resolveConfig(config);
        const hasMaxContentLength = utils$1.isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = utils$1.isNumber(maxBodyLength) && maxBodyLength > -1;
        const own2 = (key) => utils$1.hasOwnProp(config, key) ? config[key] : void 0;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = composeSignals(
          [signal, cancelToken && cancelToken.toAbortSignal()],
          timeout2
        );
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
          composedSignal.unsubscribe();
        });
        let requestContentLength;
        let pendingBodyError = null;
        const maxBodyLengthError = () => new AxiosError(
          "Request body larger than maxBodyLength limit",
          AxiosError.ERR_BAD_REQUEST,
          config,
          request
        );
        try {
          let auth = void 0;
          const configAuth = own2("auth");
          if (configAuth) {
            const username = utils$1.getSafeProp(configAuth, "username") || "";
            const password = utils$1.getSafeProp(configAuth, "password") || "";
            auth = {
              username,
              password
            };
          }
          if (maybeWithAuthCredentials(url)) {
            const parsedURL = new URL(url, platform.origin);
            if (!auth && (parsedURL.username || parsedURL.password)) {
              const urlUsername = decodeURIComponentSafe(parsedURL.username);
              const urlPassword = decodeURIComponentSafe(parsedURL.password);
              auth = {
                username: urlUsername,
                password: urlPassword
              };
            }
            if (parsedURL.username || parsedURL.password) {
              parsedURL.username = "";
              parsedURL.password = "";
              url = parsedURL.href;
            }
          }
          if (auth) {
            headers.delete("authorization");
            headers.set(
              "Authorization",
              "Basic " + btoa(encodeUTF8((auth.username || "") + ":" + (auth.password || "")))
            );
          }
          if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
            const estimated = estimateDataURLDecodedBytes(url);
            if (estimated > maxContentLength) {
              throw new AxiosError(
                "maxContentLength size of " + maxContentLength + " exceeded",
                AxiosError.ERR_BAD_RESPONSE,
                config,
                request
              );
            }
          }
          if (hasMaxBodyLength && method !== "get" && method !== "head") {
            const outboundLength = await getBodyLength(data);
            if (typeof outboundLength === "number" && isFinite(outboundLength)) {
              requestContentLength = outboundLength;
              if (outboundLength > maxBodyLength) {
                throw maxBodyLengthError();
              }
            }
          }
          const mustEnforceStreamBody = hasMaxBodyLength && (utils$1.isReadableStream(data) || utils$1.isStream(data));
          const trackRequestStream = (stream, onProgress, flush) => trackStream(
            stream,
            DEFAULT_CHUNK_SIZE,
            (loadedBytes) => {
              if (hasMaxBodyLength && loadedBytes > maxBodyLength) {
                throw pendingBodyError = maxBodyLengthError();
              }
              onProgress && onProgress(loadedBytes);
            },
            flush
          );
          if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
            requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
            if (requestContentLength !== 0 || mustEnforceStreamBody) {
              let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
              });
              let contentTypeHeader;
              if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
                headers.setContentType(contentTypeHeader);
              }
              if (_request.body) {
                const [onProgress, flush] = onUploadProgress && progressEventDecorator(
                  requestContentLength,
                  progressEventReducer(asyncDecorator(onUploadProgress))
                ) || [];
                data = trackRequestStream(_request.body, onProgress, flush);
              }
            }
          } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") {
            data = trackRequestStream(data);
          } else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") {
            throw new AxiosError(
              "Stream request bodies are not supported by the current fetch implementation",
              AxiosError.ERR_NOT_SUPPORT,
              config,
              request
            );
          }
          if (!utils$1.isString(withCredentials)) {
            withCredentials = withCredentials ? "include" : "omit";
          }
          const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
          if (utils$1.isFormData(data)) {
            const contentType = headers.getContentType();
            if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) {
              headers.delete("content-type");
            }
          }
          headers.set("User-Agent", "axios/" + VERSION, false);
          const resolvedOptions = {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: toByteStringHeaderObject(headers.normalize()),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : void 0
          };
          request = isRequestSupported && new Request(url, resolvedOptions);
          let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
          const responseHeaders = AxiosHeaders.from(response.headers);
          if (hasMaxContentLength) {
            const declaredLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
            if (declaredLength != null && declaredLength > maxContentLength) {
              throw new AxiosError(
                "maxContentLength size of " + maxContentLength + " exceeded",
                AxiosError.ERR_BAD_RESPONSE,
                config,
                request
              );
            }
          }
          const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
          if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
            const options = {};
            ["status", "statusText", "headers"].forEach((prop) => {
              options[prop] = response[prop];
            });
            const responseContentLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
            const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
              responseContentLength,
              progressEventReducer(asyncDecorator(onDownloadProgress), true)
            ) || [];
            let bytesRead = 0;
            const onChunkProgress = (loadedBytes) => {
              if (hasMaxContentLength) {
                bytesRead = loadedBytes;
                if (bytesRead > maxContentLength) {
                  throw new AxiosError(
                    "maxContentLength size of " + maxContentLength + " exceeded",
                    AxiosError.ERR_BAD_RESPONSE,
                    config,
                    request
                  );
                }
              }
              onProgress && onProgress(loadedBytes);
            };
            response = new Response(
              trackStream(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, () => {
                flush && flush();
                unsubscribe && unsubscribe();
              }),
              options
            );
          }
          responseType = responseType || "text";
          let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](
            response,
            config
          );
          if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
            let materializedSize;
            if (responseData != null) {
              if (typeof responseData.byteLength === "number") {
                materializedSize = responseData.byteLength;
              } else if (typeof responseData.size === "number") {
                materializedSize = responseData.size;
              } else if (typeof responseData === "string") {
                materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
              }
            }
            if (typeof materializedSize === "number" && materializedSize > maxContentLength) {
              throw new AxiosError(
                "maxContentLength size of " + maxContentLength + " exceeded",
                AxiosError.ERR_BAD_RESPONSE,
                config,
                request
              );
            }
          }
          !isStreamResponse && unsubscribe && unsubscribe();
          return await new Promise((resolve, reject) => {
            settle(resolve, reject, {
              data: responseData,
              headers: AxiosHeaders.from(response.headers),
              status: response.status,
              statusText: response.statusText,
              config,
              request
            });
          });
        } catch (err) {
          unsubscribe && unsubscribe();
          if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof AxiosError) {
            const canceledError = composedSignal.reason;
            canceledError.config = config;
            request && (canceledError.request = request);
            err !== canceledError && (canceledError.cause = err);
            throw canceledError;
          }
          if (pendingBodyError) {
            request && !pendingBodyError.request && (pendingBodyError.request = request);
            throw pendingBodyError;
          }
          if (err instanceof AxiosError) {
            request && !err.request && (err.request = request);
            throw err;
          }
          if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
            throw Object.assign(
              new AxiosError(
                "Network Error",
                AxiosError.ERR_NETWORK,
                config,
                request,
                err && err.response
              ),
              {
                cause: err.cause || err
              }
            );
          }
          throw AxiosError.from(err, err && err.code, config, request, err && err.response);
        }
      };
    };
    var seedCache = /* @__PURE__ */ new Map();
    var getFetch = (config) => {
      let env = config && config.env || {};
      const { fetch: fetch2, Request, Response } = env;
      const seeds = [Request, Response, fetch2];
      let len = seeds.length, i = len, seed, target, map4 = seedCache;
      while (i--) {
        seed = seeds[i];
        target = map4.get(seed);
        target === void 0 && map4.set(seed, target = i ? /* @__PURE__ */ new Map() : factory(env));
        map4 = target;
      }
      return target;
    };
    getFetch();
    var knownAdapters = {
      http: httpAdapter,
      xhr: xhrAdapter,
      fetch: {
        get: getFetch
      }
    };
    utils$1.forEach(knownAdapters, (fn, value) => {
      if (fn) {
        try {
          Object.defineProperty(fn, "name", { __proto__: null, value });
        } catch (e) {
        }
        Object.defineProperty(fn, "adapterName", { __proto__: null, value });
      }
    });
    var renderReason = (reason) => `- ${reason}`;
    var isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
    function getAdapter(adapters2, config) {
      adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
      const { length: length3 } = adapters2;
      let nameOrAdapter;
      let adapter;
      const rejectedReasons = {};
      for (let i = 0; i < length3; i++) {
        nameOrAdapter = adapters2[i];
        let id2;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
          adapter = knownAdapters[(id2 = String(nameOrAdapter)).toLowerCase()];
          if (adapter === void 0) {
            throw new AxiosError(`Unknown adapter '${id2}'`);
          }
        }
        if (adapter && (utils$1.isFunction(adapter) || (adapter = adapter.get(config)))) {
          break;
        }
        rejectedReasons[id2 || "#" + i] = adapter;
      }
      if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(
          ([id2, state]) => `adapter ${id2} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
        );
        let s2 = length3 ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
        throw new AxiosError(
          `There is no suitable adapter to dispatch the request ` + s2,
          "ERR_NOT_SUPPORT"
        );
      }
      return adapter;
    }
    var adapters = {
      /**
       * Resolve an adapter from a list of adapter names or functions.
       * @type {Function}
       */
      getAdapter,
      /**
       * Exposes all known adapters
       * @type {Object<string, Function|Object>}
       */
      adapters: knownAdapters
    };
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new CanceledError(null, config);
      }
    }
    function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = AxiosHeaders.from(config.headers);
      config.data = transformData.call(config, config.transformRequest);
      if (["post", "put", "patch"].indexOf(config.method) !== -1) {
        config.headers.setContentType("application/x-www-form-urlencoded", false);
      }
      const adapter = adapters.getAdapter(config.adapter || defaults.adapter, config);
      return adapter(config).then(
        function onAdapterResolution(response) {
          throwIfCancellationRequested(config);
          config.response = response;
          try {
            response.data = transformData.call(config, config.transformResponse, response);
          } finally {
            delete config.response;
          }
          response.headers = AxiosHeaders.from(response.headers);
          return response;
        },
        function onAdapterRejection(reason) {
          if (!isCancel(reason)) {
            throwIfCancellationRequested(config);
            if (reason && reason.response) {
              config.response = reason.response;
              try {
                reason.response.data = transformData.call(
                  config,
                  config.transformResponse,
                  reason.response
                );
              } finally {
                delete config.response;
              }
              reason.response.headers = AxiosHeaders.from(reason.response.headers);
            }
          }
          return Promise.reject(reason);
        }
      );
    }
    var validators$1 = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach((type2, i) => {
      validators$1[type2] = function validator2(thing) {
        return typeof thing === type2 || "a" + (i < 1 ? "n " : " ") + type2;
      };
    });
    var deprecatedWarnings = {};
    validators$1.transitional = function transitional(validator2, version2, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return (value, opt, opts) => {
        if (validator2 === false) {
          throw new AxiosError(
            formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
            AxiosError.ERR_DEPRECATED
          );
        }
        if (version2 && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version2 + " and will be removed in the near future"
            )
          );
        }
        return validator2 ? validator2(value, opt, opts) : true;
      };
    };
    validators$1.spelling = function spelling(correctSpelling) {
      return (value, opt) => {
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
      }
      const keys = Object.keys(options);
      let i = keys.length;
      while (i-- > 0) {
        const opt = keys[i];
        const validator2 = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : void 0;
        if (validator2) {
          const value = options[opt];
          const result = value === void 0 || validator2(value, opt, options);
          if (result !== true) {
            throw new AxiosError(
              "option " + opt + " must be " + result,
              AxiosError.ERR_BAD_OPTION_VALUE
            );
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
        }
      }
    }
    var validator = {
      assertOptions,
      validators: validators$1
    };
    var validators = validator.validators;
    var Axios = class {
      constructor(instanceConfig) {
        this.defaults = instanceConfig || {};
        this.interceptors = {
          request: new InterceptorManager(),
          response: new InterceptorManager()
        };
      }
      /**
       * Dispatch a request
       *
       * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
       * @param {?Object} config
       *
       * @returns {Promise} The Promise to be fulfilled
       */
      async request(configOrUrl, config) {
        try {
          return await this._request(configOrUrl, config);
        } catch (err) {
          if (err instanceof Error) {
            let dummy = {};
            Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
            const stack = (() => {
              if (!dummy.stack) {
                return "";
              }
              const firstNewlineIndex = dummy.stack.indexOf("\n");
              return firstNewlineIndex === -1 ? "" : dummy.stack.slice(firstNewlineIndex + 1);
            })();
            try {
              if (!err.stack) {
                err.stack = stack;
              } else if (stack) {
                const firstNewlineIndex = stack.indexOf("\n");
                const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf("\n", firstNewlineIndex + 1);
                const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack.slice(secondNewlineIndex + 1);
                if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) {
                  err.stack += "\n" + stack;
                }
              }
            } catch (e) {
            }
          }
          throw err;
        }
      }
      _request(configOrUrl, config) {
        if (typeof configOrUrl === "string") {
          config = config || {};
          config.url = configOrUrl;
        } else {
          config = configOrUrl || {};
        }
        config = mergeConfig(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== void 0) {
          validator.assertOptions(
            transitional,
            {
              silentJSONParsing: validators.transitional(validators.boolean),
              forcedJSONParsing: validators.transitional(validators.boolean),
              clarifyTimeoutError: validators.transitional(validators.boolean),
              legacyInterceptorReqResOrdering: validators.transitional(validators.boolean),
              advertiseZstdAcceptEncoding: validators.transitional(validators.boolean),
              validateStatusUndefinedResolves: validators.transitional(validators.boolean)
            },
            false
          );
        }
        if (paramsSerializer != null) {
          if (utils$1.isFunction(paramsSerializer)) {
            config.paramsSerializer = {
              serialize: paramsSerializer
            };
          } else {
            validator.assertOptions(
              paramsSerializer,
              {
                encode: validators.function,
                serialize: validators.function
              },
              true
            );
          }
        }
        if (config.allowAbsoluteUrls !== void 0) ;
        else if (this.defaults.allowAbsoluteUrls !== void 0) {
          config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        } else {
          config.allowAbsoluteUrls = true;
        }
        validator.assertOptions(
          config,
          {
            baseUrl: validators.spelling("baseURL"),
            withXsrfToken: validators.spelling("withXSRFToken")
          },
          true
        );
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders = headers && utils$1.merge(headers.common, headers[config.method]);
        headers && utils$1.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (method) => {
          delete headers[method];
        });
        config.headers = AxiosHeaders.concat(contextHeaders, headers);
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
            return;
          }
          synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
          const transitional2 = config.transitional || transitionalDefaults;
          const legacyInterceptorReqResOrdering = transitional2 && transitional2.legacyInterceptorReqResOrdering;
          if (legacyInterceptorReqResOrdering) {
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
          } else {
            requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
          }
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
          const chain = [dispatchRequest.bind(this), void 0];
          chain.unshift(...requestInterceptorChain);
          chain.push(...responseInterceptorChain);
          len = chain.length;
          promise = Promise.resolve(config);
          while (i < len) {
            promise = promise.then(chain[i++], chain[i++]);
          }
          return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while (i < len) {
          const onFulfilled = requestInterceptorChain[i++];
          const onRejected = requestInterceptorChain[i++];
          try {
            newConfig = onFulfilled(newConfig);
          } catch (error) {
            onRejected.call(this, error);
            break;
          }
        }
        try {
          promise = dispatchRequest.call(this, newConfig);
        } catch (error) {
          return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while (i < len) {
          promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        }
        return promise;
      }
      getUri(config) {
        config = mergeConfig(this.defaults, config);
        const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return buildURL(fullPath, config.params, config.paramsSerializer);
      }
    };
    utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(
          mergeConfig(config || {}, {
            method,
            url,
            data: config && utils$1.hasOwnProp(config, "data") ? config.data : void 0
          })
        );
      };
    });
    utils$1.forEach(["post", "put", "patch", "query"], function forEachMethodWithData(method) {
      function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
          return this.request(
            mergeConfig(config || {}, {
              method,
              headers: isForm ? {
                "Content-Type": "multipart/form-data"
              } : {},
              url,
              data
            })
          );
        };
      }
      Axios.prototype[method] = generateHTTPMethod();
      if (method !== "query") {
        Axios.prototype[method + "Form"] = generateHTTPMethod(true);
      }
    });
    var CancelToken = class _CancelToken {
      constructor(executor) {
        if (typeof executor !== "function") {
          throw new TypeError("executor must be a function.");
        }
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
          resolvePromise = resolve;
        });
        const token = this;
        this.promise.then((cancel) => {
          if (!token._listeners) return;
          let i = token._listeners.length;
          while (i-- > 0) {
            token._listeners[i](cancel);
          }
          token._listeners = null;
        });
        this.promise.then = (onfulfilled) => {
          let _resolve;
          const promise = new Promise((resolve) => {
            token.subscribe(resolve);
            _resolve = resolve;
          }).then(onfulfilled);
          promise.cancel = function reject() {
            token.unsubscribe(_resolve);
          };
          return promise;
        };
        executor(function cancel(message, config, request) {
          if (token.reason) {
            return;
          }
          token.reason = new CanceledError(message, config, request);
          resolvePromise(token.reason);
        });
      }
      /**
       * Throws a `CanceledError` if cancellation has been requested.
       */
      throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      }
      /**
       * Subscribe to the cancel signal
       */
      subscribe(listener) {
        if (this.reason) {
          listener(this.reason);
          return;
        }
        if (this._listeners) {
          this._listeners.push(listener);
        } else {
          this._listeners = [listener];
        }
      }
      /**
       * Unsubscribe from the cancel signal
       */
      unsubscribe(listener) {
        if (!this._listeners) {
          return;
        }
        const index3 = this._listeners.indexOf(listener);
        if (index3 !== -1) {
          this._listeners.splice(index3, 1);
        }
      }
      toAbortSignal() {
        const controller = new AbortController();
        const abort = (err) => {
          controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = () => this.unsubscribe(abort);
        return controller.signal;
      }
      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */
      static source() {
        let cancel;
        const token = new _CancelToken(function executor(c6) {
          cancel = c6;
        });
        return {
          token,
          cancel
        };
      }
    };
    function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    }
    function isAxiosError(payload) {
      return utils$1.isObject(payload) && payload.isAxiosError === true;
    }
    var HttpStatusCode = {
      Continue: 100,
      SwitchingProtocols: 101,
      Processing: 102,
      EarlyHints: 103,
      Ok: 200,
      Created: 201,
      Accepted: 202,
      NonAuthoritativeInformation: 203,
      NoContent: 204,
      ResetContent: 205,
      PartialContent: 206,
      MultiStatus: 207,
      AlreadyReported: 208,
      ImUsed: 226,
      MultipleChoices: 300,
      MovedPermanently: 301,
      Found: 302,
      SeeOther: 303,
      NotModified: 304,
      UseProxy: 305,
      Unused: 306,
      TemporaryRedirect: 307,
      PermanentRedirect: 308,
      BadRequest: 400,
      Unauthorized: 401,
      PaymentRequired: 402,
      Forbidden: 403,
      NotFound: 404,
      MethodNotAllowed: 405,
      NotAcceptable: 406,
      ProxyAuthenticationRequired: 407,
      RequestTimeout: 408,
      Conflict: 409,
      Gone: 410,
      LengthRequired: 411,
      PreconditionFailed: 412,
      PayloadTooLarge: 413,
      UriTooLong: 414,
      UnsupportedMediaType: 415,
      RangeNotSatisfiable: 416,
      ExpectationFailed: 417,
      ImATeapot: 418,
      MisdirectedRequest: 421,
      UnprocessableEntity: 422,
      Locked: 423,
      FailedDependency: 424,
      TooEarly: 425,
      UpgradeRequired: 426,
      PreconditionRequired: 428,
      TooManyRequests: 429,
      RequestHeaderFieldsTooLarge: 431,
      UnavailableForLegalReasons: 451,
      InternalServerError: 500,
      NotImplemented: 501,
      BadGateway: 502,
      ServiceUnavailable: 503,
      GatewayTimeout: 504,
      HttpVersionNotSupported: 505,
      VariantAlsoNegotiates: 506,
      InsufficientStorage: 507,
      LoopDetected: 508,
      NotExtended: 510,
      NetworkAuthenticationRequired: 511,
      WebServerIsDown: 521,
      ConnectionTimedOut: 522,
      OriginIsUnreachable: 523,
      TimeoutOccurred: 524,
      SslHandshakeFailed: 525,
      InvalidSslCertificate: 526
    };
    Object.entries(HttpStatusCode).forEach(([key, value]) => {
      HttpStatusCode[value] = key;
    });
    function createInstance(defaultConfig) {
      const context = new Axios(defaultConfig);
      const instance = bind(Axios.prototype.request, context);
      utils$1.extend(instance, Axios.prototype, context, { allOwnKeys: true });
      utils$1.extend(instance, context, null, { allOwnKeys: true });
      instance.create = function create2(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios = createInstance(defaults);
    axios.Axios = Axios;
    axios.CanceledError = CanceledError;
    axios.CancelToken = CancelToken;
    axios.isCancel = isCancel;
    axios.VERSION = VERSION;
    axios.toFormData = toFormData;
    axios.AxiosError = AxiosError;
    axios.Cancel = axios.CanceledError;
    axios.all = function all(promises) {
      return Promise.all(promises);
    };
    axios.spread = spread;
    axios.isAxiosError = isAxiosError;
    axios.mergeConfig = mergeConfig;
    axios.AxiosHeaders = AxiosHeaders;
    axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
    axios.getAdapter = adapters.getAdapter;
    axios.HttpStatusCode = HttpStatusCode;
    axios.default = axios;
    module2.exports = axios;
  }
});

// ../gridduck/dist/models/access-token.js
var require_access_token = __commonJS({
  "../gridduck/dist/models/access-token.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var AccessToken = class {
      constructor(token, tokenType, expiresIn, scope, mfaRequred, user) {
        this.token = token;
        this.tokenType = tokenType;
        this.expires = expiresIn;
        this.scope = scope;
        this.mfaRequired = mfaRequred === true;
        this.user = user;
      }
    };
    exports2.default = AccessToken;
  }
});

// ../node_modules/.pnpm/isomorphic-ws@5.0.0_ws@8.21.0/node_modules/isomorphic-ws/browser.js
var browser_exports = {};
__export(browser_exports, {
  default: () => browser_default
});
var ws, browser_default;
var init_browser = __esm({
  "../node_modules/.pnpm/isomorphic-ws@5.0.0_ws@8.21.0/node_modules/isomorphic-ws/browser.js"() {
    ws = null;
    if (typeof WebSocket !== "undefined") {
      ws = WebSocket;
    } else if (typeof MozWebSocket !== "undefined") {
      ws = MozWebSocket;
    } else if (typeof global !== "undefined") {
      ws = global.WebSocket || global.MozWebSocket;
    } else if (typeof window !== "undefined") {
      ws = window.WebSocket || window.MozWebSocket;
    } else if (typeof self !== "undefined") {
      ws = self.WebSocket || self.MozWebSocket;
    }
    browser_default = ws;
  }
});

// ../gridduck/dist/services/base-api-service.js
var require_base_api_service = __commonJS({
  "../gridduck/dist/services/base-api-service.js"(exports2) {
    "use strict";
    var __awaiter = exports2 && exports2.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var axios_1 = __importDefault(require_axios());
    var CancelToken = axios_1.default.CancelToken;
    var access_token_1 = __importDefault(require_access_token());
    var isomorphic_ws_1 = __importDefault((init_browser(), __toCommonJS(browser_exports)));
    var util_1 = require_util2();
    var BASE_URL = "https://v1.api.gridduck.com/";
    var SOCKET_URL = "wss://v1.api.gridduck.com";
    var SOCKET_PING_INTERVAL = 1e4;
    var formUrlEncoded = function(x4) {
      return Object.keys(x4).reduce((p, c6) => p + `&${c6}=${encodeURIComponent(x4[c6])}`, "");
    };
    var BaseApiService = class {
      set config(value) {
        this._config = value;
        if (this._config.accessToken) {
          this.openSocket();
        }
      }
      constructor(config) {
        this.socket = null;
        this.lastPinged = 0;
        this.visibleObjects = null;
        this.onLoggedOutCallback = [];
        this.onLoggedInCallback = [];
        this.onLostConnectionCallback = [];
        this.onOpenedConnectionCallback = [];
        this.accessTokenPromise = null;
        this.pingSendTimeout = null;
        this.pingedOutTimeout = null;
        const self2 = this;
        this.socketCallback = null;
        this.interval = null;
        this._config = config;
        this.cancelToken = new CancelToken(function executor(c6) {
          self2.cancelQueries = c6;
        });
      }
      closeSocket() {
        return __awaiter(this, void 0, void 0, function* () {
          try {
            if (this.socket) {
              if (this.socket.close) {
                this.socket.close();
              }
              if (this.socket.terminate) {
                this.socket.terminate();
              }
              this.socket = null;
            }
          } catch (e) {
          }
        });
      }
      openSocket(instance) {
        return __awaiter(this, void 0, void 0, function* () {
          let self2 = this;
          if (instance) {
            self2 = instance;
          }
          if (self2.socket) {
            return Promise.resolve();
          }
          if (self2.pingSendTimeout) {
            clearInterval(self2.pingSendTimeout);
          }
          if (self2.pingedOutTimeout) {
            clearInterval(self2.pingedOutTimeout);
          }
          let socketUrl = self2._config.baseUrl ? self2._config.baseUrl.replace("http://", "ws://").replace("https://", "wss://") : SOCKET_URL;
          self2.socket = new isomorphic_ws_1.default(socketUrl);
          function pingedOut() {
            if ((/* @__PURE__ */ new Date()).getTime() - self2.lastPinged > SOCKET_PING_INTERVAL + 2e3) {
              sendPing();
              heartbeat();
            } else {
              if (self2.socket) {
                if (self2.socket.terminate) {
                  self2.socket.terminate();
                }
                if (self2.socket.close) {
                  self2.socket.close();
                }
              }
              self2.onLostConnectionCallback.forEach(function(lostConnectionCallback) {
                lostConnectionCallback();
              });
            }
          }
          function heartbeat() {
            if (self2.pingedOutTimeout) {
              clearTimeout(self2.pingedOutTimeout);
            }
            self2.pingedOutTimeout = setTimeout(pingedOut, SOCKET_PING_INTERVAL * 2 + 2e3);
          }
          function sendPing() {
            self2.lastPinged = (/* @__PURE__ */ new Date()).getTime();
            if (self2.socket) {
              try {
                self2.socket.send("ping");
              } catch (e) {
              }
            }
            if (self2.pingSendTimeout) {
              clearTimeout(self2.pingSendTimeout);
            }
            self2.pingSendTimeout = setTimeout(sendPing, SOCKET_PING_INTERVAL);
          }
          self2.socket.onopen = function() {
            if (!self2._config.accessToken) {
              return self2.closeSocket();
            }
            sendPing();
            heartbeat();
            try {
              self2.socket.send(JSON.stringify({ accessToken: self2._config.accessToken.token }));
              setTimeout(function() {
                self2.onOpenedConnectionCallback.forEach(function(openConnectionCallback) {
                  openConnectionCallback();
                });
              }, 200);
            } catch (e) {
              pingedOut();
            }
          };
          self2.socket.onmessage = function(message) {
            let messageString = message.data.toString();
            if (messageString === "pong") {
              heartbeat();
            } else {
              let messageObj = JSON.parse(messageString);
              if (self2.socketCallback && !document.hidden) {
                self2.socketCallback(messageObj);
              }
            }
          };
          self2.socket.onclose = function(event) {
            self2.onLostConnectionCallback.forEach(function(lostConnectionCallback) {
              lostConnectionCallback();
            });
            setTimeout(() => self2.openSocket(self2), 5e3);
            self2.socket = null;
            if (self2.pingSendTimeout) {
              clearTimeout(self2.pingSendTimeout);
            }
            if (self2.pingedOutTimeout) {
              clearTimeout(self2.pingedOutTimeout);
            }
            self2.pingSendTimeout = null;
            self2.pingedOutTimeout = null;
          };
          self2.socket.onerror = function(err) {
            self2.onLostConnectionCallback.forEach(function(lostConnectionCallback) {
              lostConnectionCallback();
            });
            self2.socket = null;
            setTimeout(() => self2.openSocket(self2), 5e3);
          };
          self2.pingedOutTimeout = setTimeout(pingedOut, SOCKET_PING_INTERVAL + 2e3);
          return Promise.resolve();
        });
      }
      getAccessToken() {
        return __awaiter(this, arguments, void 0, function* (username = void 0, password = void 0) {
          let self2 = this;
          let b64EncodedAuth = Buffer.from(this._config.apiKey + ":" + this._config.apiSecret).toString("base64");
          let formData = {
            "grant_type": this._config.type === "password" ? "password" : "client_credentials",
            "scope": this._config.scopes.join(",")
          };
          if (this._config.type === "password") {
            if (!username) {
              return Promise.reject("No username specified");
            }
            if (!password) {
              return Promise.reject("No password specified");
            }
            formData["username"] = username;
            formData["password"] = password;
          }
          let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
          let config = {
            url: baseUrl + "oauth/token",
            data: formUrlEncoded(formData),
            headers: {
              "Authorization": "Basic " + b64EncodedAuth
            },
            method: "POST"
          };
          return (0, axios_1.default)(config).then(function(res) {
            self2._config.accessToken = new access_token_1.default(res.data.access_token, res.data.token_type, new Date((/* @__PURE__ */ new Date()).getTime() + parseInt(res.data.expires_in)), res.data.scope.split(","), res.data.mfa_required, res.data.user);
            if (res.data.mfa_required) {
              return Promise.reject("MFA_REQUIRED");
            }
            if (res.data.mfa_requires_setup) {
              return Promise.reject("MFA_SETUP_REQUIRED");
            }
            return self2.openSocket().then(function() {
              self2.onLoggedInCallback.forEach(function(loggedInCallback) {
                loggedInCallback();
              });
              return Promise.resolve();
            });
          }).catch(function(err) {
            if (err === "MFA_REQUIRED") {
              return Promise.reject("MFA Required");
            }
            if (err === "MFA_SETUP_REQUIRED") {
              return Promise.reject("MFA Setup Required");
            }
            if (err.response.status === 401) {
              let rejectionMessage = "Incorrect Credentials";
              if (err.response.data === "Account Locked") {
                rejectionMessage = "Account Locked";
              }
              return Promise.reject(rejectionMessage);
            } else {
              return Promise.reject("Unknown Error");
            }
          });
        });
      }
      submitMFA(mfaString) {
        return __awaiter(this, void 0, void 0, function* () {
          let self2 = this;
          if (!this._config.accessToken) {
            return Promise.reject("Not logged in");
          }
          let baseUrl = this._config.baseUrl ? this._config.baseUrl : BASE_URL;
          let config = {
            url: baseUrl + "account/authenticate_token",
            data: { token: mfaString },
            headers: {
              "Authorization": "Bearer " + this._config.accessToken.token
            },
            method: "POST"
          };
          return (0, axios_1.default)(config).then(function(res) {
            if (res.data.success) {
              return self2.openSocket();
            } else {
              return Promise.reject("Incorrect MFA Token");
            }
          }).catch(function(err) {
            if (err.response.status === 401) {
              return Promise.reject("Not Logged In");
            } else {
              return Promise.reject("Unknown Error");
            }
          });
        });
      }
      setSocketCallback(socketCallback) {
        this.socketCallback = socketCallback;
      }
      setVisibleObjects(visibleObjects) {
        this.visibleObjects = visibleObjects;
        if (this.socket) {
          try {
            this.socket.send(JSON.stringify({
              visibleObjects
            }));
          } catch (e) {
          }
        }
      }
      runPostQuery(endpoint_1, body_1, withFormData_1, onUploadProgress_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, body, withFormData, onUploadProgress, isPublic = false, isCompletingMfa = false) {
          let self2 = this;
          let promise = Promise.resolve();
          if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
            promise = this.getAccessToken();
            this.accessTokenPromise = promise;
          } else if (this.accessTokenPromise && !isCompletingMfa && !isPublic) {
            promise = this.accessTokenPromise;
          }
          let headers;
          if (isPublic) {
            headers = {};
          } else {
            headers = {
              "Authorization": "Bearer " + self2._config.accessToken.token
            };
          }
          let bodyFormData;
          if (withFormData) {
            bodyFormData = new FormData();
            const isFileLike = (val) => typeof File !== "undefined" && val instanceof File || typeof Blob !== "undefined" && val instanceof Blob;
            Object.keys(body).forEach(function(key) {
              const value = body[key];
              if (Array.isArray(value) && value.some(isFileLike)) {
                value.forEach(function(file) {
                  if (isFileLike(file))
                    bodyFormData.append(key, file, file.name);
                  else
                    bodyFormData.append(key, file);
                });
              } else {
                bodyFormData.append(key, value);
              }
            });
            headers["Content-Type"] = "multipart/form-data";
          }
          return promise.then(function() {
            let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
            let url = baseUrl + endpoint;
            let promise2;
            if (typeof navigator != "undefined" && navigator.product == "ReactNative" && bodyFormData) {
              let config = {
                method: "POST",
                body: bodyFormData ? bodyFormData : body,
                headers
              };
              if (onUploadProgress) {
                config.onUploadProgress = onUploadProgress;
              }
              return fetch(url, config).then(function(data) {
                return data.json();
              }).then(function(res) {
                let response = body || {};
                Object.keys(body).forEach(function(key) {
                  response[key] = res[key];
                });
                return Promise.resolve(response);
              });
            } else {
              let config = {
                method: "post",
                url,
                data: bodyFormData ? bodyFormData : body,
                headers
              };
              if (onUploadProgress) {
                config.onUploadProgress = onUploadProgress;
              }
              return (0, axios_1.default)(config).then(function(res) {
                let response = body || {};
                Object.keys(res.data).forEach(function(key) {
                  response[key] = res.data[key];
                });
                return Promise.resolve(response);
              });
            }
          });
        });
      }
      runPutQuery(endpoint_1, body_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, body, isPublic = false) {
          let self2 = this;
          let promise = Promise.resolve();
          if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
            promise = this.getAccessToken();
            this.accessTokenPromise = promise;
          } else if (this.accessTokenPromise) {
            promise = this.accessTokenPromise;
          }
          return promise.then(function() {
            let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
            let url = baseUrl + endpoint;
            let config = {
              method: "put",
              url,
              data: body
            };
            if (!isPublic) {
              config.headers = {
                "Authorization": "Bearer " + self2._config.accessToken.token
              };
            }
            return (0, axios_1.default)(config).then(function(res) {
              return Promise.resolve();
            });
          });
        });
      }
      runDeleteQuery(endpoint_1, id_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, id2, isPublic = false) {
          let self2 = this;
          let promise = Promise.resolve();
          if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
            promise = this.getAccessToken();
            this.accessTokenPromise = promise;
          } else if (this.accessTokenPromise) {
            promise = this.accessTokenPromise;
          }
          return promise.then(function() {
            let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
            let url = baseUrl + endpoint + "/" + id2;
            let config = {
              method: "delete",
              url
            };
            if (!isPublic) {
              config.headers = {
                "Authorization": "Bearer " + self2._config.accessToken.token
              };
            }
            return (0, axios_1.default)(config).then(function(res) {
              return Promise.resolve();
            });
          });
        });
      }
      runSingleGetQuery(endpoint_1, id_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, id2, isPublic = false) {
          let promise = Promise.resolve();
          if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
            promise = this.getAccessToken();
            this.accessTokenPromise = promise;
          } else if (this.accessTokenPromise) {
            promise = this.accessTokenPromise;
          }
          let self2 = this;
          return promise.then(function() {
            let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
            let url = baseUrl + endpoint + "/" + id2;
            let config = {
              url
            };
            if (!isPublic) {
              config.headers = {
                "Authorization": "Bearer " + self2._config.accessToken.token
              };
            }
            return (0, axios_1.default)(config);
          }).then(function(res) {
            return res.data;
          });
        });
      }
      runGetQuery(endpoint_1, params_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, params, isPublic = false) {
          let promise = Promise.resolve();
          if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
            promise = this.getAccessToken();
            this.accessTokenPromise = promise;
          } else if (this.accessTokenPromise) {
            promise = this.accessTokenPromise;
          }
          let results = [];
          let self2 = this;
          let baseUrl = self2._config.baseUrl ? self2._config.baseUrl : BASE_URL;
          let paginatedQuery = function(offset, limit) {
            return __awaiter(this, void 0, void 0, function* () {
              let url = baseUrl + endpoint + "?offset=" + offset + "&limit=" + limit;
              params.filters.forEach(function(filter3) {
                let field = (0, util_1.toSnake)(filter3.field);
                let extantFilterStartIndex = url.indexOf("&" + field + "=");
                if (~extantFilterStartIndex) {
                  let insertionPoint = url.substr(extantFilterStartIndex + 1).indexOf("&");
                  if (!~insertionPoint) {
                    insertionPoint = url.length;
                  } else {
                    insertionPoint += extantFilterStartIndex + 1;
                  }
                  url = url.slice(0, insertionPoint) + "," + encodeURIComponent(filter3.value) + url.slice(insertionPoint);
                } else {
                  url += "&" + field + "=" + encodeURIComponent(filter3.value);
                }
              });
              if (params.sortBy) {
                if (~url.indexOf("&")) {
                  url += "&sortByField=" + params.sortBy.field;
                } else {
                  url += "?sortByField=" + params.sortBy.field;
                }
                url += "&sortByType=" + params.sortBy.type;
              }
              ;
              let config = {
                url,
                cancelToken: self2.cancelToken
              };
              if (!isPublic) {
                config.headers = {
                  "Authorization": "Bearer " + self2._config.accessToken.token
                };
              }
              return (0, axios_1.default)(config).then(function(res) {
                results = results.concat({ list: res.data.results, id: res.data.request_id });
                if (res.data.links.next && params.getAll) {
                  return paginatedQuery(offset + limit, limit);
                } else {
                  return { list: results, total: res.data.pagination.total };
                }
              });
            });
          };
          return promise.then(function() {
            return paginatedQuery(params.offset, params.items);
          });
        });
      }
      checkAccessToken() {
        return __awaiter(this, void 0, void 0, function* () {
          let self2 = this;
          if (!this._config.accessToken) {
            return Promise.reject("No access token set");
          }
          let baseUrl = this._config.baseUrl ? this._config.baseUrl : BASE_URL;
          let url = baseUrl + "check";
          let config = {
            url,
            headers: {
              "Authorization": "Bearer " + this._config.accessToken.token
            }
          };
          return (0, axios_1.default)(config).then(function() {
            self2.onLoggedInCallback.forEach(function(loggedInCallback) {
              loggedInCallback();
            });
            return Promise.resolve();
          }).catch(function(err) {
            return Promise.reject("Unknown Error Checking Access Token");
          });
        });
      }
      login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
          if (username && password) {
            let promise = this.getAccessToken(username, password);
            this.accessTokenPromise = promise;
            return promise;
          } else {
            return Promise.reject("No username or password specified");
          }
        });
      }
      onLoggedOut(loggedOutCallback) {
        return __awaiter(this, void 0, void 0, function* () {
          this.onLoggedOutCallback.push(loggedOutCallback);
        });
      }
      onLoggedIn(loggedInCallback) {
        return __awaiter(this, void 0, void 0, function* () {
          this.onLoggedInCallback.push(loggedInCallback);
        });
      }
      onLostConnection(lostConnectionCallback) {
        return __awaiter(this, void 0, void 0, function* () {
          this.onLostConnectionCallback.push(lostConnectionCallback);
        });
      }
      onOpenConnectionCallback(openConnectionCallback) {
        return __awaiter(this, void 0, void 0, function* () {
          this.onOpenedConnectionCallback.push(openConnectionCallback);
        });
      }
      logout() {
        return __awaiter(this, void 0, void 0, function* () {
          this._config.accessToken = void 0;
          this.closeSocket();
          this.onLoggedOutCallback.forEach(function(loggedoutCallback) {
            loggedoutCallback();
          });
        });
      }
      cancel(reason) {
        let self2 = this;
        if (this.cancelQueries) {
          this.cancelQueries(reason);
          this.cancelToken = new CancelToken(function executor(c6) {
            self2.cancelQueries = c6;
          });
        }
      }
    };
    exports2.default = BaseApiService;
  }
});

// ../gridduck/dist/services/api-service.js
var require_api_service = __commonJS({
  "../gridduck/dist/services/api-service.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var base_api_service_1 = __importDefault(require_base_api_service());
    var ApiService = class extends base_api_service_1.default {
      getAssets(params) {
        let endpoint = "asset";
        return this.runGetQuery(endpoint, params);
      }
      getAsset(params) {
        let endpoint = "asset";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createAsset(newAsset) {
        let endpoint = "asset";
        let self2 = this;
        return this.runPostQuery(endpoint, newAsset.toServer(), false, null, false);
      }
      deleteAsset(assetId, item) {
        let endpoint = "asset";
        return this.runDeleteQuery(endpoint, assetId, false);
      }
      updateAsset(assetId, updateObj, item) {
        let endpoint = "asset";
        return this.runPutQuery(endpoint + "/" + assetId, updateObj, false);
      }
      getGateways(params) {
        let endpoint = "gateway";
        return this.runGetQuery(endpoint, params);
      }
      getGateway(params) {
        let endpoint = "gateway";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createGateway(newGateway) {
        let endpoint = "gateway";
        let self2 = this;
        return this.runPostQuery(endpoint, newGateway.toServer(), false, null, false);
      }
      deleteGateway(gatewayId, item) {
        let endpoint = "gateway";
        return this.runDeleteQuery(endpoint, gatewayId, false);
      }
      updateGateway(gatewayId, updateObj, item) {
        let endpoint = "gateway";
        return this.runPutQuery(endpoint + "/" + gatewayId, updateObj, false);
      }
      getGatewaySoftwareVersions(params) {
        let endpoint = "gateway-software-version";
        return this.runGetQuery(endpoint, params);
      }
      getGatewaySoftwareVersion(params) {
        let endpoint = "gateway-software-version";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateGatewaySoftwareVersion(gatewaySoftwareVersionId, updateObj, item) {
        let endpoint = "gateway-software-version";
        return this.runPutQuery(endpoint + "/" + gatewaySoftwareVersionId, updateObj, false);
      }
      getSites(params) {
        let endpoint = "site";
        return this.runGetQuery(endpoint, params);
      }
      getSite(params) {
        let endpoint = "site";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createSite(newSite) {
        let endpoint = "site";
        let self2 = this;
        return this.runPostQuery(endpoint, newSite.toServer(), false, null, false);
      }
      deleteSite(siteId, item) {
        let endpoint = "site";
        return this.runDeleteQuery(endpoint, siteId, false);
      }
      updateSite(siteId, updateObj, item) {
        let endpoint = "site";
        return this.runPutQuery(endpoint + "/" + siteId, updateObj, false);
      }
      getOrders(params) {
        let endpoint = "order";
        return this.runGetQuery(endpoint, params);
      }
      createOrder(newOrder) {
        let endpoint = "order";
        let self2 = this;
        return this.runPostQuery(endpoint, newOrder.toServer(), false, null, false);
      }
      getSessions(params) {
        let endpoint = "session";
        return this.runGetQuery(endpoint, params);
      }
      getSession(params) {
        let endpoint = "session";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createSession(newSession) {
        let endpoint = "session";
        let self2 = this;
        return this.runPostQuery(endpoint, newSession.toServer(), false, null, false);
      }
      deleteSession(sessionId, item) {
        let endpoint = "session";
        return this.runDeleteQuery(endpoint, sessionId, false);
      }
      updateSession(sessionId, updateObj, item) {
        let endpoint = "session";
        return this.runPutQuery(endpoint + "/" + sessionId, updateObj, false);
      }
      getDiscounts(params) {
        let endpoint = "discount";
        return this.runGetQuery(endpoint, params);
      }
      createStripeSession(newStripeSession) {
        let endpoint = "stripe-session";
        let self2 = this;
        return this.runPostQuery(endpoint, newStripeSession.toServer(), false, null, false);
      }
      createStripeWebhook(newStripeWebhook) {
        let endpoint = "stripe-webhook";
        let self2 = this;
        return this.runPostQuery(endpoint, newStripeWebhook.toServer(), false, null, true);
      }
      createZapierWebhook(newZapierWebhook) {
        let endpoint = "zapier-webhook";
        let self2 = this;
        return this.runPostQuery(endpoint, newZapierWebhook.toServer(), false, null, true);
      }
      getPlacess(params) {
        let endpoint = "places";
        return this.runGetQuery(endpoint, params, true);
      }
      getPlaces(params) {
        let endpoint = "places";
        return this.runSingleGetQuery(endpoint, params.id, true);
      }
      getProducts(params) {
        let endpoint = "product";
        return this.runGetQuery(endpoint, params);
      }
      getModbusModels(params) {
        let endpoint = "modbus-model";
        return this.runGetQuery(endpoint, params);
      }
      getModbusModel(params) {
        let endpoint = "modbus-model";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createModbusModel(newModbusModel) {
        let endpoint = "modbus-model";
        let self2 = this;
        return this.runPostQuery(endpoint, newModbusModel.toServer(), false, null, false);
      }
      deleteModbusModel(modbusModelId, item) {
        let endpoint = "modbus-model";
        return this.runDeleteQuery(endpoint, modbusModelId, false);
      }
      updateModbusModel(modbusModelId, updateObj, item) {
        let endpoint = "modbus-model";
        return this.runPutQuery(endpoint + "/" + modbusModelId, updateObj, false);
      }
      getOccupancySchedules(params) {
        let endpoint = "occupancy-schedule";
        return this.runGetQuery(endpoint, params);
      }
      getOccupancySchedule(params) {
        let endpoint = "occupancy-schedule";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createOccupancySchedule(newOccupancySchedule) {
        let endpoint = "occupancy-schedule";
        let self2 = this;
        return this.runPostQuery(endpoint, newOccupancySchedule.toServer(), false, null, false);
      }
      deleteOccupancySchedule(occupancyScheduleId, item) {
        let endpoint = "occupancy-schedule";
        return this.runDeleteQuery(endpoint, occupancyScheduleId, false);
      }
      updateOccupancySchedule(occupancyScheduleId, updateObj, item) {
        let endpoint = "occupancy-schedule";
        return this.runPutQuery(endpoint + "/" + occupancyScheduleId, updateObj, false);
      }
      createPubOrg(newPubOrg) {
        let endpoint = "pub-org";
        let self2 = this;
        return this.runPostQuery(endpoint, newPubOrg.toServer(), false, null, false);
      }
      getOrganisation(params) {
        let endpoint = "org";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateOrganisation(organisationId, updateObj, item) {
        let endpoint = "org";
        return this.runPutQuery(endpoint + "/" + organisationId, updateObj, false);
      }
      getPaymentCards(params) {
        let endpoint = "payment-card";
        return this.runGetQuery(endpoint, params);
      }
      getPaymentCard(params) {
        let endpoint = "payment-card";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createPaymentCard(newPaymentCard) {
        let endpoint = "payment-card";
        let self2 = this;
        return this.runPostQuery(endpoint, newPaymentCard.toServer(), false, null, false);
      }
      deletePaymentCard(paymentCardId, item) {
        let endpoint = "payment-card";
        return this.runDeleteQuery(endpoint, paymentCardId, false);
      }
      updatePaymentCard(paymentCardId, updateObj, item) {
        let endpoint = "payment-card";
        return this.runPutQuery(endpoint + "/" + paymentCardId, updateObj, false);
      }
      getAssetEvents(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!assetIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "assetEvent/:assetId/:start/:end/";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getGatewayEvents(params) {
        let gatewayIdFilter = params.filters.find((f2) => f2.field === "gatewayId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!gatewayIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "gatewayEvent/:gatewayId/:start/:end/";
        endpoint = endpoint.replace(":gatewayId", gatewayIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getAssetTelemetrys(params) {
        let dataTypeFilter = params.filters.find((f2) => f2.field === "dataType");
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!dataTypeFilter || !assetIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "assetTelemetry/:dataType/:assetId/:start/:end/";
        endpoint = endpoint.replace(":dataType", dataTypeFilter.value + "");
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getRules(params) {
        let endpoint = "rule";
        return this.runGetQuery(endpoint, params);
      }
      getRule(params) {
        let endpoint = "rule";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createRule(newRule) {
        let endpoint = "rule";
        let self2 = this;
        return this.runPostQuery(endpoint, newRule.toServer(), false, null, false);
      }
      deleteRule(ruleId, item) {
        let endpoint = "rule";
        return this.runDeleteQuery(endpoint, ruleId, false);
      }
      updateRule(ruleId, updateObj, item) {
        let endpoint = "rule";
        return this.runPutQuery(endpoint + "/" + ruleId, updateObj, false);
      }
      getDataRequests(params) {
        let endpoint = "data-request";
        return this.runGetQuery(endpoint, params);
      }
      getDataRequest(params) {
        let endpoint = "data-request";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataRequest(newDataRequest) {
        let endpoint = "data-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataRequest.toServer(), false, null, false);
      }
      deleteDataRequest(dataRequestId, item) {
        let endpoint = "data-request";
        return this.runDeleteQuery(endpoint, dataRequestId, false);
      }
      updateDataRequest(dataRequestId, updateObj, item) {
        let endpoint = "data-request";
        return this.runPutQuery(endpoint + "/" + dataRequestId, updateObj, false);
      }
      createDataRequestLink(newDataRequestLink) {
        let endpoint = "data-request/:dataRequestId/link";
        let self2 = this;
        endpoint = endpoint.replace(":dataRequestId", (newDataRequestLink.dataRequestId ? newDataRequestLink.dataRequestId : "") + "");
        return this.runPostQuery(endpoint, newDataRequestLink.toServer(), false, null, false);
      }
      createDataRequestRun(newDataRequestRun) {
        let endpoint = "data-request/:dataRequestId/run";
        let self2 = this;
        endpoint = endpoint.replace(":dataRequestId", (newDataRequestRun.dataRequestId ? newDataRequestRun.dataRequestId : "") + "");
        return this.runPostQuery(endpoint, newDataRequestRun.toServer(), false, null, false);
      }
      getInvoiceRequests(params) {
        let endpoint = "invoice-request";
        return this.runGetQuery(endpoint, params);
      }
      getInvoiceRequest(params) {
        let endpoint = "invoice-request";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createInvoiceRequest(newInvoiceRequest) {
        let endpoint = "invoice-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newInvoiceRequest.toServer(), false, null, false);
      }
      deleteInvoiceRequest(invoiceRequestId, item) {
        let endpoint = "invoice-request";
        return this.runDeleteQuery(endpoint, invoiceRequestId, false);
      }
      createInvoiceRequestLink(newInvoiceRequestLink) {
        let endpoint = "invoice-request/:invoiceRequestId/link";
        let self2 = this;
        endpoint = endpoint.replace(":invoiceRequestId", (newInvoiceRequestLink.invoiceRequestId ? newInvoiceRequestLink.invoiceRequestId : "") + "");
        return this.runPostQuery(endpoint, newInvoiceRequestLink.toServer(), false, null, false);
      }
      getSiteGroups(params) {
        let endpoint = "site-group";
        return this.runGetQuery(endpoint, params);
      }
      getSiteGroup(params) {
        let endpoint = "site-group";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createSiteGroup(newSiteGroup) {
        let endpoint = "site-group";
        let self2 = this;
        return this.runPostQuery(endpoint, newSiteGroup.toServer(), false, null, false);
      }
      deleteSiteGroup(siteGroupId, item) {
        let endpoint = "site-group";
        return this.runDeleteQuery(endpoint, siteGroupId, false);
      }
      updateSiteGroup(siteGroupId, updateObj, item) {
        let endpoint = "site-group";
        return this.runPutQuery(endpoint + "/" + siteGroupId, updateObj, false);
      }
      getGroups(params) {
        let endpoint = "group";
        return this.runGetQuery(endpoint, params);
      }
      getGroup(params) {
        let endpoint = "group";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createGroup(newGroup) {
        let endpoint = "group";
        let self2 = this;
        return this.runPostQuery(endpoint, newGroup.toServer(), false, null, false);
      }
      deleteGroup(groupId, item) {
        let endpoint = "group";
        return this.runDeleteQuery(endpoint, groupId, false);
      }
      updateGroup(groupId, updateObj, item) {
        let endpoint = "group";
        return this.runPutQuery(endpoint + "/" + groupId, updateObj, false);
      }
      getDuckChargeAdmins(params) {
        let endpoint = "duck-charge-admin";
        return this.runGetQuery(endpoint, params);
      }
      getCustomFieldTypes(params) {
        let endpoint = "custom-field-type";
        return this.runGetQuery(endpoint, params);
      }
      createCustomFieldType(newCustomFieldType) {
        let endpoint = "custom-field-type";
        let self2 = this;
        return this.runPostQuery(endpoint, newCustomFieldType.toServer(), false, null, false);
      }
      deleteCustomFieldType(customFieldTypeId, item) {
        let endpoint = "custom-field-type";
        return this.runDeleteQuery(endpoint, customFieldTypeId, false);
      }
      updateCustomFieldType(customFieldTypeId, updateObj, item) {
        let endpoint = "custom-field-type";
        return this.runPutQuery(endpoint + "/" + customFieldTypeId, updateObj, false);
      }
      getCustomFields(params) {
        let endpoint = "custom-field";
        return this.runGetQuery(endpoint, params);
      }
      createCustomField(newCustomField) {
        let endpoint = "custom-field";
        let self2 = this;
        return this.runPostQuery(endpoint, newCustomField.toServer(), false, null, false);
      }
      deleteCustomField(customFieldId, item) {
        let endpoint = "custom-field";
        return this.runDeleteQuery(endpoint, customFieldId, false);
      }
      updateCustomField(customFieldId, updateObj, item) {
        let endpoint = "custom-field";
        return this.runPutQuery(endpoint + "/" + customFieldId, updateObj, false);
      }
      getLocations(params) {
        let endpoint = "location";
        return this.runGetQuery(endpoint, params);
      }
      createLocation(newLocation) {
        let endpoint = "location";
        let self2 = this;
        return this.runPostQuery(endpoint, newLocation.toServer(), false, null, false);
      }
      deleteLocation(locationId, item) {
        let endpoint = "location";
        return this.runDeleteQuery(endpoint, locationId, false);
      }
      updateLocation(locationId, updateObj, item) {
        let endpoint = "location";
        return this.runPutQuery(endpoint + "/" + locationId, updateObj, false);
      }
      getSearchHistorys(params) {
        let endpoint = "search-history";
        return this.runGetQuery(endpoint, params);
      }
      createSearchHistory(newSearchHistory) {
        let endpoint = "search-history";
        let self2 = this;
        return this.runPostQuery(endpoint, newSearchHistory.toServer(), false, null, false);
      }
      deleteSearchHistory(searchHistoryId, item) {
        let endpoint = "search-history";
        return this.runDeleteQuery(endpoint, searchHistoryId, false);
      }
      getTariffs(params) {
        let endpoint = "tariff";
        return this.runGetQuery(endpoint, params);
      }
      getTariff(params) {
        let endpoint = "tariff";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createTariff(newTariff) {
        let endpoint = "tariff";
        let self2 = this;
        return this.runPostQuery(endpoint, newTariff.toServer(), false, null, false);
      }
      deleteTariff(tariffId, item) {
        let endpoint = "tariff";
        return this.runDeleteQuery(endpoint, tariffId, false);
      }
      updateTariff(tariffId, updateObj, item) {
        let endpoint = "tariff";
        return this.runPutQuery(endpoint + "/" + tariffId, updateObj, false);
      }
      getGroupTypes(params) {
        let endpoint = "group-type";
        return this.runGetQuery(endpoint, params);
      }
      createGroupType(newGroupType) {
        let endpoint = "group-type";
        let self2 = this;
        return this.runPostQuery(endpoint, newGroupType.toServer(), false, null, false);
      }
      deleteGroupType(groupTypeId, item) {
        let endpoint = "group-type";
        return this.runDeleteQuery(endpoint, groupTypeId, false);
      }
      updateGroupType(groupTypeId, updateObj, item) {
        let endpoint = "group-type";
        return this.runPutQuery(endpoint + "/" + groupTypeId, updateObj, false);
      }
      createCalculatorInbound(newCalculatorInbound) {
        let endpoint = "calculator-inbound";
        let self2 = this;
        return this.runPostQuery(endpoint, newCalculatorInbound.toServer(), false, null, true);
      }
      createCalculatorResult(newCalculatorResult) {
        let endpoint = "calculator-result";
        let self2 = this;
        return this.runPostQuery(endpoint, newCalculatorResult.toServer(), false, null, true);
      }
      createCreateReport(newCreateReport) {
        let endpoint = "create-report";
        let self2 = this;
        return this.runPostQuery(endpoint, newCreateReport.toServer(), false, null, true);
      }
      getReportHistorys(params) {
        let endpoint = "report-history";
        return this.runGetQuery(endpoint, params);
      }
      getReports(params) {
        let endpoint = "report";
        return this.runGetQuery(endpoint, params);
      }
      getReport(params) {
        let endpoint = "report";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createReport(newReport) {
        let endpoint = "report";
        let self2 = this;
        return this.runPostQuery(endpoint, newReport.toServer(), false, null, false);
      }
      deleteReport(reportId, item) {
        let endpoint = "report";
        return this.runDeleteQuery(endpoint, reportId, false);
      }
      updateReport(reportId, updateObj, item) {
        let endpoint = "report";
        return this.runPutQuery(endpoint + "/" + reportId, updateObj, false);
      }
      getReportFiles(params) {
        let endpoint = "report-file";
        return this.runGetQuery(endpoint, params);
      }
      getGaiaConversations(params) {
        let endpoint = "gaia-conversation";
        return this.runGetQuery(endpoint, params);
      }
      getGaiaConversation(params) {
        let endpoint = "gaia-conversation";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      deleteGaiaConversation(gaiaConversationId, item) {
        let endpoint = "gaia-conversation";
        return this.runDeleteQuery(endpoint, gaiaConversationId, false);
      }
      updateGaiaConversation(gaiaConversationId, updateObj, item) {
        let endpoint = "gaia-conversation";
        return this.runPutQuery(endpoint + "/" + gaiaConversationId, updateObj, false);
      }
      getGaiaMessages(params) {
        let endpoint = "gaia-message";
        return this.runGetQuery(endpoint, params);
      }
      createGaiaMessage(newGaiaMessage) {
        let endpoint = "gaia-message";
        let self2 = this;
        return this.runPostQuery(endpoint, newGaiaMessage.toServer(), false, null, false);
      }
      getDataCategorys(params) {
        let endpoint = "data-category";
        return this.runGetQuery(endpoint, params);
      }
      getDataCategory(params) {
        let endpoint = "data-category";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataCategory(newDataCategory) {
        let endpoint = "data-category";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataCategory.toServer(), false, null, false);
      }
      deleteDataCategory(dataCategoryId, item) {
        let endpoint = "data-category";
        return this.runDeleteQuery(endpoint, dataCategoryId, false);
      }
      updateDataCategory(dataCategoryId, updateObj, item) {
        let endpoint = "data-category";
        return this.runPutQuery(endpoint + "/" + dataCategoryId, updateObj, false);
      }
      getDataTypes(params) {
        let endpoint = "data-type";
        return this.runGetQuery(endpoint, params);
      }
      getDataType(params) {
        let endpoint = "data-type";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataType(newDataType) {
        let endpoint = "data-type";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataType.toServer(), false, null, false);
      }
      deleteDataType(dataTypeId, item) {
        let endpoint = "data-type";
        return this.runDeleteQuery(endpoint, dataTypeId, false);
      }
      updateDataType(dataTypeId, updateObj, item) {
        let endpoint = "data-type";
        return this.runPutQuery(endpoint + "/" + dataTypeId, updateObj, false);
      }
      getDeviceCategorys(params) {
        let endpoint = "device-category";
        return this.runGetQuery(endpoint, params);
      }
      createDeviceCategory(newDeviceCategory) {
        let endpoint = "device-category";
        let self2 = this;
        return this.runPostQuery(endpoint, newDeviceCategory.toServer(), false, null, false);
      }
      deleteDeviceCategory(deviceCategoryId, item) {
        let endpoint = "device-category";
        return this.runDeleteQuery(endpoint, deviceCategoryId, false);
      }
      updateDeviceCategory(deviceCategoryId, updateObj, item) {
        let endpoint = "device-category";
        return this.runPutQuery(endpoint + "/" + deviceCategoryId, updateObj, false);
      }
      getWidgetBoard(params) {
        let endpoint = "widget-board";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createWidgetBoard(newWidgetBoard) {
        let endpoint = "widget-board";
        let self2 = this;
        return this.runPostQuery(endpoint, newWidgetBoard.toServer(), false, null, false);
      }
      updateWidgetBoard(widgetBoardId, updateObj, item) {
        let endpoint = "widget-board";
        return this.runPutQuery(endpoint + "/" + widgetBoardId, updateObj, false);
      }
      createReportFileLink(newReportFileLink) {
        let endpoint = "report-file/:fileId/link";
        let self2 = this;
        endpoint = endpoint.replace(":fileId", (newReportFileLink.fileId ? newReportFileLink.fileId : "") + "");
        return this.runPostQuery(endpoint, newReportFileLink.toServer(), false, null, false);
      }
      getRuleEvents(params) {
        let ruleIdFilter = params.filters.find((f2) => f2.field === "ruleId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!ruleIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "rule/:ruleId/event/:start/:end/";
        endpoint = endpoint.replace(":ruleId", ruleIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getAudits(params) {
        let endpoint = "audit";
        return this.runGetQuery(endpoint, params);
      }
      getAudit(params) {
        let endpoint = "audit";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createAudit(newAudit) {
        let endpoint = "audit";
        let self2 = this;
        return this.runPostQuery(endpoint, newAudit.toServer(), false, null, false);
      }
      getApplications(params) {
        let endpoint = "application";
        return this.runGetQuery(endpoint, params);
      }
      getApplication(params) {
        let endpoint = "application";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createApplication(newApplication) {
        let endpoint = "application";
        let self2 = this;
        return this.runPostQuery(endpoint, newApplication.toServer(), false, null, false);
      }
      deleteApplication(applicationId, item) {
        let endpoint = "application";
        return this.runDeleteQuery(endpoint, applicationId, false);
      }
      getAnomalyModels(params) {
        let endpoint = "anomaly-model";
        return this.runGetQuery(endpoint, params);
      }
      getAnomalyModel(params) {
        let endpoint = "anomaly-model";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      getAnomalys(params) {
        let endpoint = "anomaly";
        return this.runGetQuery(endpoint, params);
      }
      getAnomaly(params) {
        let endpoint = "anomaly";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateAnomaly(anomalyId, updateObj, item) {
        let endpoint = "anomaly";
        return this.runPutQuery(endpoint + "/" + anomalyId, updateObj, false);
      }
      getGridduckSubscriptions(params) {
        let endpoint = "gridduck-subscription";
        return this.runGetQuery(endpoint, params);
      }
      getGridduckInvoices(params) {
        let endpoint = "gridduck-invoice";
        return this.runGetQuery(endpoint, params);
      }
      getAccounts(params) {
        let endpoint = "account";
        return this.runGetQuery(endpoint, params);
      }
      getAccount(params) {
        let endpoint = "account";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateAccount(accountId, updateObj, item) {
        let endpoint = "account";
        return this.runPutQuery(endpoint + "/" + accountId, updateObj, false);
      }
      getCustomFieldDatas(params) {
        let endpoint = "custom-field-data";
        return this.runGetQuery(endpoint, params);
      }
      getPreferences(params) {
        let endpoint = "preferences";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updatePreferences(preferencesId, updateObj, item) {
        let endpoint = "preferences";
        return this.runPutQuery(endpoint + "/" + preferencesId, updateObj, false);
      }
      createDcRetryPayment(newDcRetryPayment) {
        let endpoint = "dc-retry-payment";
        let self2 = this;
        return this.runPostQuery(endpoint, newDcRetryPayment.toServer(), false, null, false);
      }
      getIssues(params) {
        let endpoint = "issue";
        return this.runGetQuery(endpoint, params);
      }
      getIgnoredDevices(params) {
        let endpoint = "ignored-device";
        return this.runGetQuery(endpoint, params);
      }
      createResetSecret(newResetSecret) {
        let endpoint = "application/:applicationId/reset_secret";
        let self2 = this;
        endpoint = endpoint.replace(":applicationId", (newResetSecret.applicationId ? newResetSecret.applicationId : "") + "");
        return this.runPostQuery(endpoint, newResetSecret.toServer(), false, null, false);
      }
      createRequestSecret(newRequestSecret) {
        let endpoint = "application/:applicationId/request_secret";
        let self2 = this;
        endpoint = endpoint.replace(":applicationId", (newRequestSecret.applicationId ? newRequestSecret.applicationId : "") + "");
        return this.runPostQuery(endpoint, newRequestSecret.toServer(), false, null, false);
      }
      createAssetIdentification(newAssetIdentification) {
        let endpoint = "asset/:assetId/identification";
        let self2 = this;
        endpoint = endpoint.replace(":assetId", (newAssetIdentification.assetId ? newAssetIdentification.assetId : "") + "");
        return this.runPostQuery(endpoint, newAssetIdentification.toServer(), false, null, false);
      }
      createGetPhaseBreakdown(newGetPhaseBreakdown) {
        let endpoint = "asset/:assetId/getPhaseBreakdown";
        let self2 = this;
        endpoint = endpoint.replace(":assetId", (newGetPhaseBreakdown.assetId ? newGetPhaseBreakdown.assetId : "") + "");
        return this.runPostQuery(endpoint, newGetPhaseBreakdown.toServer(), false, null, false);
      }
      getAvailableGateways(params) {
        let endpoint = "availableGateway";
        return this.runGetQuery(endpoint, params);
      }
      updateAvailableGateway(availableGatewayId, updateObj, item) {
        let endpoint = "availableGateway";
        return this.runPutQuery(endpoint + "/" + availableGatewayId, updateObj, false);
      }
      getAssetDemands(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!assetIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "telemetry/assetDemand/:assetId/:start/:end";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getAssetConsumptions(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        let granularityFilter = params.filters.find((f2) => f2.field === "granularity");
        let dataTypeFilter = params.filters.find((f2) => f2.field === "dataType");
        if (!assetIdFilter || !startFilter || !endFilter || !granularityFilter || !dataTypeFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "telemetry/assetConsumption/:assetId/:start/:end/:granularity";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        endpoint = endpoint.replace(":granularity", granularityFilter.value + "");
        endpoint = endpoint.replace(":dataType", dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getPhysicalGateway(params) {
        let endpoint = "physicalGateway";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createPhysicalGateway(newPhysicalGateway) {
        let endpoint = "physicalGateway";
        let self2 = this;
        return this.runPostQuery(endpoint, newPhysicalGateway.toServer(), false, null, false);
      }
      updatePhysicalGateway(physicalGatewayId, updateObj, item) {
        let endpoint = "physicalGateway";
        return this.runPutQuery(endpoint + "/" + physicalGatewayId, updateObj, false);
      }
      getSitePermissions(params) {
        let siteIdFilter = params.filters.find((f2) => f2.field === "siteId");
        if (!siteIdFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "site/:siteId/permission";
        endpoint = endpoint.replace(":siteId", siteIdFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      createSitePermission(newSitePermission) {
        let endpoint = "site/:siteId/permission";
        let self2 = this;
        endpoint = endpoint.replace(":siteId", (newSitePermission.siteId ? newSitePermission.siteId : "") + "");
        return this.runPostQuery(endpoint, newSitePermission.toServer(), false, null, false);
      }
      deleteSitePermission(sitePermissionId, item) {
        let endpoint = "site/:siteId/permission";
        endpoint = endpoint.replace(":siteId", item.siteId + "");
        return this.runDeleteQuery(endpoint, sitePermissionId, false);
      }
      updateSitePermission(sitePermissionId, updateObj, item) {
        let endpoint = "site/:siteId/permission";
        endpoint = endpoint.replace(":siteId", (item.siteId ? item.siteId : "") + "");
        return this.runPutQuery(endpoint + "/" + sitePermissionId, updateObj, false);
      }
      getApplianceCategorys(params) {
        let endpoint = "applianceCategory";
        return this.runGetQuery(endpoint, params);
      }
      getApplianceTypes(params) {
        let endpoint = "applianceType";
        return this.runGetQuery(endpoint, params);
      }
      getDataUploads(params) {
        let endpoint = "data-upload";
        return this.runGetQuery(endpoint, params);
      }
      getDataUpload(params) {
        let endpoint = "data-upload";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataUpload(newDataUpload, onUploadProgress) {
        let endpoint = "data-upload";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataUpload.toServer(), true, onUploadProgress, false);
      }
      deleteDataUpload(dataUploadId, item) {
        let endpoint = "data-upload";
        return this.runDeleteQuery(endpoint, dataUploadId, false);
      }
      updateDataUpload(dataUploadId, updateObj, item) {
        let endpoint = "data-upload";
        return this.runPutQuery(endpoint + "/" + dataUploadId, updateObj, false);
      }
      getFiles(params) {
        let itemTypeFilter = params.filters.find((f2) => f2.field === "itemType");
        let itemIdFilter = params.filters.find((f2) => f2.field === "itemId");
        if (!itemTypeFilter || !itemIdFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "upload/:itemType/:itemId";
        endpoint = endpoint.replace(":itemType", itemTypeFilter.value + "");
        endpoint = endpoint.replace(":itemId", itemIdFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      createFile(newFile, onUploadProgress) {
        let endpoint = "upload/:itemType/:itemId";
        let self2 = this;
        endpoint = endpoint.replace(":itemType", (newFile.itemType ? newFile.itemType : "") + "");
        endpoint = endpoint.replace(":itemId", (newFile.itemId ? newFile.itemId : "") + "");
        return this.runPostQuery(endpoint, newFile.toServer(), true, onUploadProgress, false);
      }
      deleteFile(fileId, item) {
        let endpoint = "upload/:itemType/:itemId";
        endpoint = endpoint.replace(":itemType", item.itemType + "");
        endpoint = endpoint.replace(":itemId", item.itemId + "");
        return this.runDeleteQuery(endpoint, fileId, false);
      }
      updateFile(fileId, updateObj, item) {
        let endpoint = "upload/:itemType/:itemId";
        endpoint = endpoint.replace(":itemType", (item.itemType ? item.itemType : "") + "");
        endpoint = endpoint.replace(":itemId", (item.itemId ? item.itemId : "") + "");
        return this.runPutQuery(endpoint + "/" + fileId, updateObj, false);
      }
      createZip(newZip) {
        let endpoint = "upload/site/:siteId/zip";
        let self2 = this;
        endpoint = endpoint.replace(":siteId", (newZip.siteId ? newZip.siteId : "") + "");
        return this.runPostQuery(endpoint, newZip.toServer(), false, null, false);
      }
      getSearchs(params) {
        let queryFilter = params.filters.find((f2) => f2.field === "query");
        if (!queryFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "search";
        endpoint = endpoint.replace(":query", queryFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getVerifyOrgInvite(params) {
        let endpoint = "organisation/invite/validate";
        return this.runSingleGetQuery(endpoint, params.id, true);
      }
      createConfirmOrgInvite(newConfirmOrgInvite) {
        let endpoint = "organisation/invite/confirm";
        let self2 = this;
        return this.runPostQuery(endpoint, newConfirmOrgInvite.toServer(), false, null, true);
      }
      createDcCreateAccount(newDcCreateAccount) {
        let endpoint = "dc-create-account";
        let self2 = this;
        return this.runPostQuery(endpoint, newDcCreateAccount.toServer(), false, null, true);
      }
      getDcSessions(params) {
        let endpoint = "dc-session";
        return this.runGetQuery(endpoint, params);
      }
      getDcSession(params) {
        let endpoint = "dc-session";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDcSession(newDcSession) {
        let endpoint = "dc-session";
        let self2 = this;
        return this.runPostQuery(endpoint, newDcSession.toServer(), false, null, false);
      }
      deleteDcSession(dcSessionId, item) {
        let endpoint = "dc-session";
        return this.runDeleteQuery(endpoint, dcSessionId, false);
      }
      createPaymentSheet(newPaymentSheet) {
        let endpoint = "payment-sheet";
        let self2 = this;
        return this.runPostQuery(endpoint, newPaymentSheet.toServer(), false, null, false);
      }
      getDcChargePoint(params) {
        let endpoint = "dc-charge-point";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      getDcChargeStations(params) {
        let endpoint = "dc-charge-station";
        return this.runGetQuery(endpoint, params);
      }
      getOrganisationInvites(params) {
        let endpoint = "orgInvite";
        return this.runGetQuery(endpoint, params);
      }
      createOrganisationInvite(newOrganisationInvite) {
        let endpoint = "orgInvite";
        let self2 = this;
        return this.runPostQuery(endpoint, newOrganisationInvite.toServer(), false, null, false);
      }
      deleteOrganisationInvite(organisationInviteId, item) {
        let endpoint = "orgInvite";
        return this.runDeleteQuery(endpoint, organisationInviteId, false);
      }
      updateOrganisationInvite(organisationInviteId, updateObj, item) {
        let endpoint = "orgInvite";
        return this.runPutQuery(endpoint + "/" + organisationInviteId, updateObj, false);
      }
      getOrganisationMembers(params) {
        let endpoint = "orgMember";
        return this.runGetQuery(endpoint, params);
      }
      deleteOrganisationMember(organisationMemberId, item) {
        let endpoint = "orgMember";
        return this.runDeleteQuery(endpoint, organisationMemberId, false);
      }
      updateOrganisationMember(organisationMemberId, updateObj, item) {
        let endpoint = "orgMember";
        return this.runPutQuery(endpoint + "/" + organisationMemberId, updateObj, false);
      }
      createOrganisationMemberLogout(organisationMemberId, newObject) {
        let endpoint = "orgMember/:organisationMemberId/logout";
        endpoint = endpoint.replace(":organisationMemberId", organisationMemberId);
        return this.runPostQuery(endpoint, newObject, false, null, false);
      }
      getDetectedDevices(params) {
        let endpoint = "potential_device";
        return this.runGetQuery(endpoint, params);
      }
      updateDetectedDevice(detectedDeviceId, updateObj, item) {
        let endpoint = "potential_device";
        return this.runPutQuery(endpoint + "/" + detectedDeviceId, updateObj, false);
      }
      getResetToken(params) {
        let endpoint = "account/reset_token";
        endpoint = endpoint.replace("/:token", "");
        return this.runSingleGetQuery(endpoint, params.id, true);
      }
      createResetToken(newResetToken) {
        let endpoint = "account/reset_token";
        let self2 = this;
        endpoint = endpoint.replace(":token", (newResetToken.token ? newResetToken.token : "") + "");
        return this.runPostQuery(endpoint, newResetToken.toServer(), false, null, true);
      }
      updateResetToken(resetTokenId, updateObj, item) {
        let endpoint = "account/reset_token";
        endpoint = endpoint.replace(":token", (item.token ? item.token : "") + "");
        return this.runPutQuery(endpoint + "/" + resetTokenId, updateObj, true);
      }
      createPassword(newPassword) {
        let endpoint = "account/password";
        let self2 = this;
        return this.runPostQuery(endpoint, newPassword.toServer(), false, null, false);
      }
      getThirdPartyIntegrations(params) {
        let endpoint = "third-party-integration";
        return this.runGetQuery(endpoint, params);
      }
      createThirdPartyIntegration(newThirdPartyIntegration) {
        let endpoint = "third-party-integration";
        let self2 = this;
        return this.runPostQuery(endpoint, newThirdPartyIntegration.toServer(), false, null, false);
      }
      getOrgPartners(params) {
        let endpoint = "org-partner";
        return this.runGetQuery(endpoint, params);
      }
      getOrgPartner(params) {
        let endpoint = "org-partner";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createOrgPartner(newOrgPartner) {
        let endpoint = "org-partner";
        let self2 = this;
        return this.runPostQuery(endpoint, newOrgPartner.toServer(), false, null, false);
      }
      deleteOrgPartner(orgPartnerId, item) {
        let endpoint = "org-partner";
        return this.runDeleteQuery(endpoint, orgPartnerId, false);
      }
      updateOrgPartner(orgPartnerId, updateObj, item) {
        let endpoint = "org-partner";
        return this.runPutQuery(endpoint + "/" + orgPartnerId, updateObj, false);
      }
      createMfaSecret(newMfaSecret) {
        let endpoint = "account/mfa-secret";
        let self2 = this;
        return this.runPostQuery(endpoint, newMfaSecret.toServer(), false, null, false, true).then(function(res) {
          self2.accessTokenPromise = Promise.resolve();
          self2.openSocket().then(function() {
            self2.onLoggedInCallback.forEach(function(loggedInCallback) {
              loggedInCallback();
            });
          });
          return Promise.resolve(res);
        });
      }
      createMfaVerification(newMfaVerification) {
        let endpoint = "account/mfa-verification";
        let self2 = this;
        return this.runPostQuery(endpoint, newMfaVerification.toServer(), false, null, false, true).then(function(res) {
          self2.accessTokenPromise = Promise.resolve();
          self2.openSocket().then(function() {
            self2.onLoggedInCallback.forEach(function(loggedInCallback) {
              loggedInCallback();
            });
          });
          return Promise.resolve(res);
        });
      }
      createMfaAuthentication(newMfaAuthentication) {
        let endpoint = "account/mfa-authentication";
        let self2 = this;
        return this.runPostQuery(endpoint, newMfaAuthentication.toServer(), false, null, false, true).then(function(res) {
          self2.accessTokenPromise = Promise.resolve();
          self2.openSocket().then(function() {
            self2.onLoggedInCallback.forEach(function(loggedInCallback) {
              loggedInCallback();
            });
          });
          return Promise.resolve(res);
        });
      }
      createLoginAs(newLoginAs) {
        let endpoint = "login-as";
        let self2 = this;
        return this.runPostQuery(endpoint, newLoginAs.toServer(), false, null, false);
      }
      createLoginAsPartner(newLoginAsPartner) {
        let endpoint = "login-as-partner";
        let self2 = this;
        return this.runPostQuery(endpoint, newLoginAsPartner.toServer(), false, null, false);
      }
      getOrganisationManagements(params) {
        let endpoint = "organisation-management";
        return this.runGetQuery(endpoint, params);
      }
      getOrganisationManagement(params) {
        let endpoint = "organisation-management";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateOrganisationManagement(organisationManagementId, updateObj, item) {
        let endpoint = "organisation-management";
        return this.runPutQuery(endpoint + "/" + organisationManagementId, updateObj, false);
      }
      getStagingDatabase(params) {
        let endpoint = "staging-database";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      updateStagingDatabase(stagingDatabaseId, updateObj, item) {
        let endpoint = "staging-database";
        return this.runPutQuery(endpoint + "/" + stagingDatabaseId, updateObj, false);
      }
      getNotifications(params) {
        let endpoint = "notification";
        return this.runGetQuery(endpoint, params);
      }
      updateNotification(notificationId, updateObj, item) {
        let endpoint = "notification";
        return this.runPutQuery(endpoint + "/" + notificationId, updateObj, false);
      }
      getZigbeeFirmwares(params) {
        let endpoint = "zigbee-firmware";
        return this.runGetQuery(endpoint, params);
      }
      getZigbeeFirmware(params) {
        let endpoint = "zigbee-firmware";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      getGatewayTrustList(params) {
        let endpoint = "gateway-trust-list";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createGatewayTrustedDeviceUntrustRequest(newGatewayTrustedDeviceUntrustRequest) {
        let endpoint = "gateway-trusted-device-untrust-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newGatewayTrustedDeviceUntrustRequest.toServer(), false, null, false);
      }
      getTelemetryOperations(params) {
        let endpoint = "telemetry-operation";
        return this.runGetQuery(endpoint, params);
      }
      createAggregateTelemetryGroupRequest(newAggregateTelemetryGroupRequest) {
        let endpoint = "aggregate-telemetry-group-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newAggregateTelemetryGroupRequest.toServer(), false, null, false);
      }
      createAssetRemoveDataRequest(newAssetRemoveDataRequest) {
        let endpoint = "asset-remove-data-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newAssetRemoveDataRequest.toServer(), false, null, false);
      }
      createAssetAggregateDataRequest(newAssetAggregateDataRequest) {
        let endpoint = "asset-aggregate-data-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newAssetAggregateDataRequest.toServer(), false, null, false);
      }
      getGatewayTrustedDeviceAnalysiss(params) {
        let endpoint = "gateway-trusted-device-analysis";
        return this.runGetQuery(endpoint, params);
      }
      getGatewayTrustedDeviceAnalysis(params) {
        let endpoint = "gateway-trusted-device-analysis";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createGatewayTrustedDeviceAnalysis(newGatewayTrustedDeviceAnalysis) {
        let endpoint = "gateway-trusted-device-analysis";
        let self2 = this;
        return this.runPostQuery(endpoint, newGatewayTrustedDeviceAnalysis.toServer(), false, null, false);
      }
      deleteGatewayTrustedDeviceAnalysis(gatewayTrustedDeviceAnalysisId, item) {
        let endpoint = "gateway-trusted-device-analysis";
        return this.runDeleteQuery(endpoint, gatewayTrustedDeviceAnalysisId, false);
      }
      updateGatewayTrustedDeviceAnalysis(gatewayTrustedDeviceAnalysisId, updateObj, item) {
        let endpoint = "gateway-trusted-device-analysis";
        return this.runPutQuery(endpoint + "/" + gatewayTrustedDeviceAnalysisId, updateObj, false);
      }
      getAggregateTelemetrys(params) {
        let endpoint = "telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity";
        return this.runGetQuery(endpoint, params);
      }
      getAggregateTelemetry(params) {
        let endpoint = "telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createAggregateTelemetry(newAggregateTelemetry) {
        let endpoint = "telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity";
        let self2 = this;
        return this.runPostQuery(endpoint, newAggregateTelemetry.toServer(), false, null, false);
      }
      deleteAggregateTelemetry(aggregateTelemetryId, item) {
        let endpoint = "telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity";
        return this.runDeleteQuery(endpoint, aggregateTelemetryId, false);
      }
      updateAggregateTelemetry(aggregateTelemetryId, updateObj, item) {
        let endpoint = "telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity";
        return this.runPutQuery(endpoint + "/" + aggregateTelemetryId, updateObj, false);
      }
      getInstantaneousTelemetrys(params) {
        let endpoint = "telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity";
        return this.runGetQuery(endpoint, params);
      }
      getInstantaneousTelemetry(params) {
        let endpoint = "telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createInstantaneousTelemetry(newInstantaneousTelemetry) {
        let endpoint = "telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity";
        let self2 = this;
        return this.runPostQuery(endpoint, newInstantaneousTelemetry.toServer(), false, null, false);
      }
      deleteInstantaneousTelemetry(instantaneousTelemetryId, item) {
        let endpoint = "telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity";
        return this.runDeleteQuery(endpoint, instantaneousTelemetryId, false);
      }
      updateInstantaneousTelemetry(instantaneousTelemetryId, updateObj, item) {
        let endpoint = "telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity";
        return this.runPutQuery(endpoint + "/" + instantaneousTelemetryId, updateObj, false);
      }
      getOrganisationSearchs(params) {
        let endpoint = "organisation/search";
        return this.runGetQuery(endpoint, params);
      }
      createGatewayLogDownloadRequest(newGatewayLogDownloadRequest) {
        let endpoint = "gateway-log-download-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newGatewayLogDownloadRequest.toServer(), false, null, false);
      }
      createGatewayEnhancedLogDownloadRequest(newGatewayEnhancedLogDownloadRequest) {
        let endpoint = "gateway-enhanced-log-download-request";
        let self2 = this;
        return this.runPostQuery(endpoint, newGatewayEnhancedLogDownloadRequest.toServer(), false, null, false);
      }
      getGatewayGods(params) {
        let endpoint = "gateway-god";
        return this.runGetQuery(endpoint, params);
      }
      getGatewayGod(params) {
        let endpoint = "gateway-god";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createGatewayGod(newGatewayGod) {
        let endpoint = "gateway-god";
        let self2 = this;
        return this.runPostQuery(endpoint, newGatewayGod.toServer(), false, null, false);
      }
      deleteGatewayGod(gatewayGodId, item) {
        let endpoint = "gateway-god";
        return this.runDeleteQuery(endpoint, gatewayGodId, false);
      }
      updateGatewayGod(gatewayGodId, updateObj, item) {
        let endpoint = "gateway-god";
        return this.runPutQuery(endpoint + "/" + gatewayGodId, updateObj, false);
      }
      getAssetGods(params) {
        let endpoint = "asset-god";
        return this.runGetQuery(endpoint, params);
      }
      getAssetGod(params) {
        let endpoint = "asset-god";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createAssetGod(newAssetGod) {
        let endpoint = "asset-god";
        let self2 = this;
        return this.runPostQuery(endpoint, newAssetGod.toServer(), false, null, false);
      }
      deleteAssetGod(assetGodId, item) {
        let endpoint = "asset-god";
        return this.runDeleteQuery(endpoint, assetGodId, false);
      }
      updateAssetGod(assetGodId, updateObj, item) {
        let endpoint = "asset-god";
        return this.runPutQuery(endpoint + "/" + assetGodId, updateObj, false);
      }
      getAssetTelemetryBatchs(params) {
        let dataTypeFilter = params.filters.find((f2) => f2.field === "dataType");
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!dataTypeFilter || !assetIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "assetTelemetryBatch/:dataType/:start/:end";
        endpoint = endpoint.replace(":dataType", dataTypeFilter.value + "");
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getAssetConsumptionBatchs(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        let granularityFilter = params.filters.find((f2) => f2.field === "granularity");
        let dataTypeFilter = params.filters.find((f2) => f2.field === "dataType");
        if (!assetIdFilter || !startFilter || !endFilter || !granularityFilter || !dataTypeFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "telemetry/assetConsumptionBatch/:start/:end/:granularity";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        endpoint = endpoint.replace(":granularity", granularityFilter.value + "");
        endpoint = endpoint.replace(":dataType", dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getRawAggregateDatas(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        let dataTypeFilter = params.filters.find((f2) => f2.field === "dataType");
        if (!assetIdFilter || !startFilter || !endFilter || !dataTypeFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "raw-aggregate-data";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        endpoint = endpoint.replace(":dataType", dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      getAssetResets(params) {
        let assetIdFilter = params.filters.find((f2) => f2.field === "assetId");
        let startFilter = params.filters.find((f2) => f2.field === "start");
        let endFilter = params.filters.find((f2) => f2.field === "end");
        if (!assetIdFilter || !startFilter || !endFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "asset-reset";
        endpoint = endpoint.replace(":assetId", assetIdFilter.value + "");
        endpoint = endpoint.replace(":start", startFilter.value + "");
        endpoint = endpoint.replace(":end", endFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      createAssetReset(newAssetReset) {
        let endpoint = "asset-reset";
        let self2 = this;
        endpoint = endpoint.replace(":assetId", (newAssetReset.assetId ? newAssetReset.assetId : "") + "");
        endpoint = endpoint.replace(":start", (newAssetReset.start ? newAssetReset.start : "") + "");
        endpoint = endpoint.replace(":end", (newAssetReset.end ? newAssetReset.end : "") + "");
        return this.runPostQuery(endpoint, newAssetReset.toServer(), false, null, false);
      }
      deleteAssetReset(assetResetId, item) {
        let endpoint = "asset-reset";
        endpoint = endpoint.replace(":assetId", item.assetId + "");
        endpoint = endpoint.replace(":start", item.start + "");
        endpoint = endpoint.replace(":end", item.end + "");
        return this.runDeleteQuery(endpoint, assetResetId, false);
      }
      updateAssetReset(assetResetId, updateObj, item) {
        let endpoint = "asset-reset";
        endpoint = endpoint.replace(":assetId", (item.assetId ? item.assetId : "") + "");
        endpoint = endpoint.replace(":start", (item.start ? item.start : "") + "");
        endpoint = endpoint.replace(":end", (item.end ? item.end : "") + "");
        return this.runPutQuery(endpoint + "/" + assetResetId, updateObj, false);
      }
      createInspiredLogin(newInspiredLogin) {
        let endpoint = "inspired-login";
        let self2 = this;
        return this.runPostQuery(endpoint, newInspiredLogin.toServer(), false, null, true);
      }
      getDataUnits(params) {
        let endpoint = "data-unit";
        return this.runGetQuery(endpoint, params);
      }
      getDataUnit(params) {
        let endpoint = "data-unit";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataUnit(newDataUnit) {
        let endpoint = "data-unit";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataUnit.toServer(), false, null, false);
      }
      deleteDataUnit(dataUnitId, item) {
        let endpoint = "data-unit";
        return this.runDeleteQuery(endpoint, dataUnitId, false);
      }
      updateDataUnit(dataUnitId, updateObj, item) {
        let endpoint = "data-unit";
        return this.runPutQuery(endpoint + "/" + dataUnitId, updateObj, false);
      }
      getItemMetadata(params) {
        let endpoint = "item-metadata";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      getBounceEmails(params) {
        let endpoint = "bounce-email";
        return this.runGetQuery(endpoint, params);
      }
      deleteBounceEmail(bounceEmailId, item) {
        let endpoint = "bounce-email";
        return this.runDeleteQuery(endpoint, bounceEmailId, false);
      }
      getDataFileImports(params) {
        let endpoint = "data-file-import";
        return this.runGetQuery(endpoint, params);
      }
      getDataFileImport(params) {
        let endpoint = "data-file-import";
        return this.runSingleGetQuery(endpoint, params.id);
      }
      createDataFileImport(newDataFileImport) {
        let endpoint = "data-file-import";
        let self2 = this;
        return this.runPostQuery(endpoint, newDataFileImport.toServer(), false, null, false);
      }
      updateDataFileImport(dataFileImportId, updateObj, item) {
        let endpoint = "data-file-import";
        return this.runPutQuery(endpoint + "/" + dataFileImportId, updateObj, false);
      }
      getDataFileImportLogs(params) {
        let data_file_import_idFilter = params.filters.find((f2) => f2.field === "data_file_import_id");
        if (!data_file_import_idFilter) {
          return Promise.reject("Missing required parameter in filters");
        }
        let endpoint = "data-file-import-log";
        endpoint = endpoint.replace(":data_file_import_id", data_file_import_idFilter.value + "");
        return this.runGetQuery(endpoint, params);
      }
      createDataFileImportUpload(newDataFileImportUpload) {
        let endpoint = "data-file-import/:configId/upload";
        let self2 = this;
        endpoint = endpoint.replace(":configId", (newDataFileImportUpload.configId ? newDataFileImportUpload.configId : "") + "");
        return this.runPostQuery(endpoint, newDataFileImportUpload.toServer(), false, null, false);
      }
    };
    exports2.default = ApiService;
  }
});

// ../gridduck/dist/models/subscribable.js
var require_subscribable = __commonJS({
  "../gridduck/dist/models/subscribable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var EventEmitter = require_events();
    var WAIT_TO_UNSUB = 1e3;
    var Subscribable = class extends EventEmitter {
      get id() {
        return this._id;
      }
      set id(value) {
        this._id = value;
      }
      asObject() {
        let returnObj = {};
        let self2 = this;
        Object.keys(this).forEach(function(key) {
          if (key.substr(0, 1) !== "_") {
            returnObj[key] = self2[key];
          }
        });
        return returnObj;
      }
      setDeleted() {
        this.emit("deleted");
      }
      inSet(field, value, noCamel = false) {
        let fixedValue;
        if (!noCamel && typeof value === "object" && value !== null && !(value instanceof File)) {
          if (!Array.isArray(value)) {
            fixedValue = (0, util_1.camelObject)(value);
          } else {
            fixedValue = (0, util_1.camelArray)(value);
          }
        } else {
          fixedValue = value;
        }
        this["_" + field] = fixedValue;
        this.emit("updated", field, fixedValue, this);
      }
      checkForSubscription() {
        let listenerCount = this.listenerCount("updated");
        if (listenerCount > 0 && !this.isListening) {
          this.isListening = true;
          this.dataService.resubscribe();
        } else if (listenerCount === 0 && this.isListening && !this.subscriptionTimeout) {
          let self2 = this;
          this.subscriptionTimeout = setTimeout(function() {
            let listenerCount2 = self2.listenerCount("updated");
            if (listenerCount2 === 0 && self2.isListening) {
              self2.isListening = false;
              self2.dataService.resubscribe();
            }
          }, WAIT_TO_UNSUB);
        }
      }
      constructor(dataService, id2) {
        super();
        this.typeName = "Unknown";
        this.isListening = false;
        this.API_FIELD = null;
        this.subscriptionTimeout = null;
        this._id = id2;
        this.dataService = dataService;
        let self2 = this;
        this.on("newListener", function(event) {
          if (event === "updated") {
            setTimeout(function() {
              self2.checkForSubscription();
            });
          }
        });
        this.on("removeListener", function(event) {
          if (event === "updated") {
            setTimeout(function() {
              self2.checkForSubscription();
            });
          }
        });
      }
    };
    exports2.default = Subscribable;
  }
});

// ../gridduck/dist/models/account.js
var require_account = __commonJS({
  "../gridduck/dist/models/account.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Account = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "account";
        this._username = initParams.username;
        this._billingEmail = initParams.billing_email;
        this._god = initParams.god;
        this._organisationId = initParams.organisation_id;
        this._inDemo = initParams.in_demo;
        this._alertEmail = initParams.alert_email;
        this._alertSms = initParams.alert_sms;
        this._alertToast = initParams.alert_toast;
        this._colour = initParams.colour;
        this._frequency = initParams.frequency;
        this._mfaEnabled = initParams.mfa_enabled;
        this._jobRole = initParams.job_role;
        this._profilePicture = initParams.profile_picture;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._name = initParams.name;
        this._tour = initParams.tour;
        this._tourPreferences = initParams.tour_preferences;
        this._themes = (0, util_1.camelArray)(initParams.themes);
        this._theme = initParams.theme;
        this._customTheme = initParams.custom_theme;
        this._darkLight = initParams.dark_light;
        this._ignoredAssets = (0, util_1.camelArray)(initParams.ignored_assets);
        this._ignoreAll = initParams.ignore_all;
        this._ignoreAssetsWithFilter = initParams.ignore_assets_with_filter;
        this._unignoreAll = initParams.unignore_all;
        this._ignoreAssets = (0, util_1.camelArray)(initParams.ignore_assets);
        this._unignoreAssets = (0, util_1.camelArray)(initParams.unignore_assets);
        this._ignoredSites = (0, util_1.camelArray)(initParams.ignored_sites);
        this._organisationName = initParams.organisation_name;
        this._orgPermission = initParams.org_permission;
        this._orgWebsite = initParams.org_website;
        this._orgPhone = initParams.org_phone;
        this._orgEmail = initParams.org_email;
        this._orgAddress = initParams.org_address;
        this._logoImage = initParams.logo_image;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImage = initParams.square_logo_image;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
        this._orgMfaEnforced = initParams.org_mfa_enforced;
        this._noSites = initParams.no_sites;
        this._noAssets = initParams.no_assets;
        this._receiveAuditEmails = initParams.receive_audit_emails;
        this._sitesCount = initParams.sites_count;
        this._siteGroupsCount = initParams.site_groups_count;
        this._stripeId = initParams.stripe_id;
        this._features = (0, util_1.camelArray)(initParams.features);
        this._customKpiDefaults = (0, util_1.camelArray)(initParams.custom_kpi_defaults);
        this._skusConnected = (0, util_1.camelArray)(initParams.skus_connected);
        this._dcActiveSession = initParams.dc_active_session;
        this._subscriptions = initParams.subscriptions;
        this._invoices = initParams.invoices;
        this._delinquent = initParams.delinquent;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
        this._defaultOccupancySchedule = initParams.default_occupancy_schedule;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._muteNotificationSound = initParams.mute_notification_sound;
        this._dashboardTier = initParams.dashboard_tier;
        this._dashboardTierFrequency = initParams.dashboard_tier_frequency;
        this._tierAvailableFeatures = (0, util_1.camelArray)(initParams.tier_available_features);
        this._allTierFeatures = (0, util_1.camelArray)(initParams.all_tier_features);
        this._subPaymentExempt = initParams.sub_payment_exempt;
        this._globalFeatures = (0, util_1.camelArray)(initParams.global_features);
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      setUsername(value) {
        return this.dataService.updateAccount(this.id, { username: value }, this);
      }
      get username() {
        return this._username;
      }
      set billingEmail(value) {
        console.error("Do not set objects this way");
      }
      setBillingEmail(value) {
        return this.dataService.updateAccount(this.id, { billing_email: value }, this);
      }
      get billingEmail() {
        return this._billingEmail;
      }
      set god(value) {
        console.error("Do not set objects this way");
      }
      setGod(value) {
        return this.dataService.updateAccount(this.id, { god: value }, this);
      }
      get god() {
        return this._god;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateAccount(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set inDemo(value) {
        console.error("Do not set objects this way");
      }
      setInDemo(value) {
        return this.dataService.updateAccount(this.id, { in_demo: value }, this);
      }
      get inDemo() {
        return this._inDemo;
      }
      set alertEmail(value) {
        console.error("Do not set objects this way");
      }
      setAlertEmail(value) {
        return this.dataService.updateAccount(this.id, { alert_email: value }, this);
      }
      get alertEmail() {
        return this._alertEmail;
      }
      set alertSms(value) {
        console.error("Do not set objects this way");
      }
      setAlertSms(value) {
        return this.dataService.updateAccount(this.id, { alert_sms: value }, this);
      }
      get alertSms() {
        return this._alertSms;
      }
      set alertToast(value) {
        console.error("Do not set objects this way");
      }
      setAlertToast(value) {
        return this.dataService.updateAccount(this.id, { alert_toast: value }, this);
      }
      get alertToast() {
        return this._alertToast;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      setColour(value) {
        return this.dataService.updateAccount(this.id, { colour: value }, this);
      }
      get colour() {
        return this._colour;
      }
      set frequency(value) {
        console.error("Do not set objects this way");
      }
      setFrequency(value) {
        return this.dataService.updateAccount(this.id, { frequency: value }, this);
      }
      get frequency() {
        return this._frequency;
      }
      set mfaEnabled(value) {
        console.error("Do not set objects this way");
      }
      setMfaEnabled(value) {
        return this.dataService.updateAccount(this.id, { mfa_enabled: value }, this);
      }
      get mfaEnabled() {
        return this._mfaEnabled;
      }
      set jobRole(value) {
        console.error("Do not set objects this way");
      }
      setJobRole(value) {
        return this.dataService.updateAccount(this.id, { job_role: value }, this);
      }
      get jobRole() {
        return this._jobRole;
      }
      set profilePicture(value) {
        console.error("Do not set objects this way");
      }
      setProfilePicture(value) {
        return this.dataService.updateAccount(this.id, { profile_picture: value }, this);
      }
      get profilePicture() {
        return this._profilePicture;
      }
      set profilePictureThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setProfilePictureThumbnail(value) {
        return this.dataService.updateAccount(this.id, { profile_picture_thumbnail: value }, this);
      }
      get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateAccount(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set tour(value) {
        console.error("Do not set objects this way");
      }
      setTour(value) {
        return this.dataService.updateAccount(this.id, { tour: value }, this);
      }
      get tour() {
        return this._tour;
      }
      set tourPreferences(value) {
        console.error("Do not set objects this way");
      }
      setTourPreferences(value) {
        return this.dataService.updateAccount(this.id, { tour_preferences: value }, this);
      }
      get tourPreferences() {
        return this._tourPreferences;
      }
      set themes(value) {
        console.error("Do not set objects this way");
      }
      setThemes(value) {
        return this.dataService.updateAccount(this.id, { themes: (0, util_1.snakeArray)(value) }, this);
      }
      get themes() {
        return this._themes;
      }
      set theme(value) {
        console.error("Do not set objects this way");
      }
      setTheme(value) {
        return this.dataService.updateAccount(this.id, { theme: value }, this);
      }
      get theme() {
        return this._theme;
      }
      set customTheme(value) {
        console.error("Do not set objects this way");
      }
      setCustomTheme(value) {
        return this.dataService.updateAccount(this.id, { custom_theme: value }, this);
      }
      get customTheme() {
        return this._customTheme;
      }
      set darkLight(value) {
        console.error("Do not set objects this way");
      }
      setDarkLight(value) {
        return this.dataService.updateAccount(this.id, { dark_light: value }, this);
      }
      get darkLight() {
        return this._darkLight;
      }
      set ignoredAssets(value) {
        console.error("Do not set objects this way");
      }
      setIgnoredAssets(value) {
        return this.dataService.updateAccount(this.id, { ignored_assets: (0, util_1.snakeArray)(value) }, this);
      }
      get ignoredAssets() {
        return this._ignoredAssets;
      }
      set ignoreAll(value) {
        console.error("Do not set objects this way");
      }
      setIgnoreAll(value) {
        return this.dataService.updateAccount(this.id, { ignore_all: value }, this);
      }
      get ignoreAll() {
        return this._ignoreAll;
      }
      set ignoreAssetsWithFilter(value) {
        console.error("Do not set objects this way");
      }
      setIgnoreAssetsWithFilter(value) {
        return this.dataService.updateAccount(this.id, { ignore_assets_with_filter: value }, this);
      }
      get ignoreAssetsWithFilter() {
        return this._ignoreAssetsWithFilter;
      }
      set unignoreAll(value) {
        console.error("Do not set objects this way");
      }
      setUnignoreAll(value) {
        return this.dataService.updateAccount(this.id, { unignore_all: value }, this);
      }
      get unignoreAll() {
        return this._unignoreAll;
      }
      set ignoreAssets(value) {
        console.error("Do not set objects this way");
      }
      setIgnoreAssets(value) {
        return this.dataService.updateAccount(this.id, { ignore_assets: (0, util_1.snakeArray)(value) }, this);
      }
      get ignoreAssets() {
        return this._ignoreAssets;
      }
      set unignoreAssets(value) {
        console.error("Do not set objects this way");
      }
      setUnignoreAssets(value) {
        return this.dataService.updateAccount(this.id, { unignore_assets: (0, util_1.snakeArray)(value) }, this);
      }
      get unignoreAssets() {
        return this._unignoreAssets;
      }
      set ignoredSites(value) {
        console.error("Do not set objects this way");
      }
      setIgnoredSites(value) {
        return this.dataService.updateAccount(this.id, { ignored_sites: (0, util_1.snakeArray)(value) }, this);
      }
      get ignoredSites() {
        return this._ignoredSites;
      }
      set organisationName(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationName(value) {
        return this.dataService.updateAccount(this.id, { organisation_name: value }, this);
      }
      get organisationName() {
        return this._organisationName;
      }
      set orgPermission(value) {
        console.error("Do not set objects this way");
      }
      setOrgPermission(value) {
        return this.dataService.updateAccount(this.id, { org_permission: value }, this);
      }
      get orgPermission() {
        return this._orgPermission;
      }
      set orgWebsite(value) {
        console.error("Do not set objects this way");
      }
      setOrgWebsite(value) {
        return this.dataService.updateAccount(this.id, { org_website: value }, this);
      }
      get orgWebsite() {
        return this._orgWebsite;
      }
      set orgPhone(value) {
        console.error("Do not set objects this way");
      }
      setOrgPhone(value) {
        return this.dataService.updateAccount(this.id, { org_phone: value }, this);
      }
      get orgPhone() {
        return this._orgPhone;
      }
      set orgEmail(value) {
        console.error("Do not set objects this way");
      }
      setOrgEmail(value) {
        return this.dataService.updateAccount(this.id, { org_email: value }, this);
      }
      get orgEmail() {
        return this._orgEmail;
      }
      set orgAddress(value) {
        console.error("Do not set objects this way");
      }
      setOrgAddress(value) {
        return this.dataService.updateAccount(this.id, { org_address: value }, this);
      }
      get orgAddress() {
        return this._orgAddress;
      }
      set logoImage(value) {
        console.error("Do not set objects this way");
      }
      setLogoImage(value) {
        return this.dataService.updateAccount(this.id, { logo_image: value }, this);
      }
      get logoImage() {
        return this._logoImage;
      }
      set logoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setLogoImageThumbnail(value) {
        return this.dataService.updateAccount(this.id, { logo_image_thumbnail: value }, this);
      }
      get logoImageThumbnail() {
        return this._logoImageThumbnail;
      }
      set squareLogoImage(value) {
        console.error("Do not set objects this way");
      }
      setSquareLogoImage(value) {
        return this.dataService.updateAccount(this.id, { square_logo_image: value }, this);
      }
      get squareLogoImage() {
        return this._squareLogoImage;
      }
      set squareLogoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setSquareLogoImageThumbnail(value) {
        return this.dataService.updateAccount(this.id, { square_logo_image_thumbnail: value }, this);
      }
      get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
      }
      set orgMfaEnforced(value) {
        console.error("Do not set objects this way");
      }
      setOrgMfaEnforced(value) {
        return this.dataService.updateAccount(this.id, { org_mfa_enforced: value }, this);
      }
      get orgMfaEnforced() {
        return this._orgMfaEnforced;
      }
      set noSites(value) {
        console.error("Do not set objects this way");
      }
      setNoSites(value) {
        return this.dataService.updateAccount(this.id, { no_sites: value }, this);
      }
      get noSites() {
        return this._noSites;
      }
      set noAssets(value) {
        console.error("Do not set objects this way");
      }
      setNoAssets(value) {
        return this.dataService.updateAccount(this.id, { no_assets: value }, this);
      }
      get noAssets() {
        return this._noAssets;
      }
      set receiveAuditEmails(value) {
        console.error("Do not set objects this way");
      }
      setReceiveAuditEmails(value) {
        return this.dataService.updateAccount(this.id, { receive_audit_emails: value }, this);
      }
      get receiveAuditEmails() {
        return this._receiveAuditEmails;
      }
      set sitesCount(value) {
        console.error("Do not set objects this way");
      }
      setSitesCount(value) {
        return this.dataService.updateAccount(this.id, { sites_count: value }, this);
      }
      get sitesCount() {
        return this._sitesCount;
      }
      set siteGroupsCount(value) {
        console.error("Do not set objects this way");
      }
      setSiteGroupsCount(value) {
        return this.dataService.updateAccount(this.id, { site_groups_count: value }, this);
      }
      get siteGroupsCount() {
        return this._siteGroupsCount;
      }
      set stripeId(value) {
        console.error("Do not set objects this way");
      }
      setStripeId(value) {
        return this.dataService.updateAccount(this.id, { stripe_id: value }, this);
      }
      get stripeId() {
        return this._stripeId;
      }
      set features(value) {
        console.error("Do not set objects this way");
      }
      setFeatures(value) {
        return this.dataService.updateAccount(this.id, { features: (0, util_1.snakeArray)(value) }, this);
      }
      get features() {
        return this._features;
      }
      set customKpiDefaults(value) {
        console.error("Do not set objects this way");
      }
      setCustomKpiDefaults(value) {
        return this.dataService.updateAccount(this.id, { custom_kpi_defaults: (0, util_1.snakeArray)(value) }, this);
      }
      get customKpiDefaults() {
        return this._customKpiDefaults;
      }
      set skusConnected(value) {
        console.error("Do not set objects this way");
      }
      setSkusConnected(value) {
        return this.dataService.updateAccount(this.id, { skus_connected: (0, util_1.snakeArray)(value) }, this);
      }
      get skusConnected() {
        return this._skusConnected;
      }
      set dcActiveSession(value) {
        console.error("Do not set objects this way");
      }
      setDcActiveSession(value) {
        return this.dataService.updateAccount(this.id, { dc_active_session: value }, this);
      }
      get dcActiveSession() {
        return this._dcActiveSession;
      }
      set subscriptions(value) {
        console.error("Do not set objects this way");
      }
      setSubscriptions(value) {
        return this.dataService.updateAccount(this.id, { subscriptions: value }, this);
      }
      get subscriptions() {
        return this._subscriptions;
      }
      set invoices(value) {
        console.error("Do not set objects this way");
      }
      setInvoices(value) {
        return this.dataService.updateAccount(this.id, { invoices: value }, this);
      }
      get invoices() {
        return this._invoices;
      }
      set delinquent(value) {
        console.error("Do not set objects this way");
      }
      setDelinquent(value) {
        return this.dataService.updateAccount(this.id, { delinquent: value }, this);
      }
      get delinquent() {
        return this._delinquent;
      }
      set orgOverridePerms(value) {
        console.error("Do not set objects this way");
      }
      setOrgOverridePerms(value) {
        return this.dataService.updateAccount(this.id, { org_override_perms: value }, this);
      }
      get orgOverridePerms() {
        return this._orgOverridePerms;
      }
      set sitesLimitedTo(value) {
        console.error("Do not set objects this way");
      }
      setSitesLimitedTo(value) {
        return this.dataService.updateAccount(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
      }
      get sitesLimitedTo() {
        return this._sitesLimitedTo;
      }
      set defaultOccupancySchedule(value) {
        console.error("Do not set objects this way");
      }
      setDefaultOccupancySchedule(value) {
        return this.dataService.updateAccount(this.id, { default_occupancy_schedule: value }, this);
      }
      get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
      }
      set whiteLabel(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabel(value) {
        return this.dataService.updateAccount(this.id, { white_label: value }, this);
      }
      get whiteLabel() {
        return this._whiteLabel;
      }
      set inheritWhiteLabelFrom(value) {
        console.error("Do not set objects this way");
      }
      setInheritWhiteLabelFrom(value) {
        return this.dataService.updateAccount(this.id, { inherit_white_label_from: value }, this);
      }
      get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
      }
      set whiteLabelTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelTheme(value) {
        return this.dataService.updateAccount(this.id, { white_label_theme: value }, this);
      }
      get whiteLabelTheme() {
        return this._whiteLabelTheme;
      }
      set whiteLabelCustomTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelCustomTheme(value) {
        return this.dataService.updateAccount(this.id, { white_label_custom_theme: value }, this);
      }
      get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
      }
      set muteNotificationSound(value) {
        console.error("Do not set objects this way");
      }
      setMuteNotificationSound(value) {
        return this.dataService.updateAccount(this.id, { mute_notification_sound: value }, this);
      }
      get muteNotificationSound() {
        return this._muteNotificationSound;
      }
      set dashboardTier(value) {
        console.error("Do not set objects this way");
      }
      setDashboardTier(value) {
        return this.dataService.updateAccount(this.id, { dashboard_tier: value }, this);
      }
      get dashboardTier() {
        return this._dashboardTier;
      }
      set dashboardTierFrequency(value) {
        console.error("Do not set objects this way");
      }
      setDashboardTierFrequency(value) {
        return this.dataService.updateAccount(this.id, { dashboard_tier_frequency: value }, this);
      }
      get dashboardTierFrequency() {
        return this._dashboardTierFrequency;
      }
      set tierAvailableFeatures(value) {
        console.error("Do not set objects this way");
      }
      setTierAvailableFeatures(value) {
        return this.dataService.updateAccount(this.id, { tier_available_features: (0, util_1.snakeArray)(value) }, this);
      }
      get tierAvailableFeatures() {
        return this._tierAvailableFeatures;
      }
      set allTierFeatures(value) {
        console.error("Do not set objects this way");
      }
      setAllTierFeatures(value) {
        return this.dataService.updateAccount(this.id, { all_tier_features: (0, util_1.snakeArray)(value) }, this);
      }
      get allTierFeatures() {
        return this._allTierFeatures;
      }
      set subPaymentExempt(value) {
        console.error("Do not set objects this way");
      }
      setSubPaymentExempt(value) {
        return this.dataService.updateAccount(this.id, { sub_payment_exempt: value }, this);
      }
      get subPaymentExempt() {
        return this._subPaymentExempt;
      }
      set globalFeatures(value) {
        console.error("Do not set objects this way");
      }
      setGlobalFeatures(value) {
        return this.dataService.updateAccount(this.id, { global_features: (0, util_1.snakeArray)(value) }, this);
      }
      get globalFeatures() {
        return this._globalFeatures;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAccount(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = Account;
  }
});

// ../gridduck/dist/models/aggregateTelemetry.js
var require_aggregateTelemetry = __commonJS({
  "../gridduck/dist/models/aggregateTelemetry.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AggregateTelemetry = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetConsumption";
        this.isListening = true;
        this._consumption = initParams.consumption;
        this._siteId = initParams.site_id;
        this._time = initParams.time;
      }
      set consumption(value) {
        console.error("Do not set objects this way");
      }
      get consumption() {
        return this._consumption;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = AggregateTelemetry;
  }
});

// ../gridduck/dist/models/aggregateTelemetryGroupRequest.js
var require_aggregateTelemetryGroupRequest = __commonJS({
  "../gridduck/dist/models/aggregateTelemetryGroupRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AggregateTelemetryGroupRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "aggregateTelemetryGroupRequest";
        this._groupType = initParams.group_type;
        this._groupId = initParams.group_id;
        this._start = initParams.start;
        this._end = initParams.end;
        this._status = initParams.status;
      }
      set groupType(value) {
        console.error("Do not set objects this way");
      }
      get groupType() {
        return this._groupType;
      }
      set groupId(value) {
        console.error("Do not set objects this way");
      }
      get groupId() {
        return this._groupId;
      }
      set start(value) {
        console.error("Do not set objects this way");
      }
      get start() {
        return this._start;
      }
      set end(value) {
        console.error("Do not set objects this way");
      }
      get end() {
        return this._end;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
    };
    exports2.default = AggregateTelemetryGroupRequest;
  }
});

// ../gridduck/dist/models/anomaly.js
var require_anomaly2 = __commonJS({
  "../gridduck/dist/models/anomaly.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Anomaly2 = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "anomaly";
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
        this._deviceId = initParams.device_id;
        this._deviceName = initParams.device_name;
        this._siteId = initParams.site_id;
        this._modelId = initParams.model_id;
        this._siteName = initParams.site_name;
        this._explanation = initParams.explanation;
        this._notes = initParams.notes;
        this._userStatus = initParams.user_status;
        this._dismissed = initParams.dismissed;
        this._invalid = initParams.invalid;
        this._modelImageUrl = initParams.model_image_url;
        this._entryValue = initParams.entry_value;
        this._entryLowerThreshold = initParams.entry_lower_threshold;
        this._entryUpperThreshold = initParams.entry_upper_threshold;
        this._exitValue = initParams.exit_value;
        this._exitLowerThreshold = initParams.exit_lower_threshold;
        this._exitUpperThreshold = initParams.exit_upper_threshold;
      }
      set startTs(value) {
        console.error("Do not set objects this way");
      }
      setStartTs(value) {
        return this.dataService.updateAnomaly(this.id, { start_ts: value }, this);
      }
      get startTs() {
        return this._startTs;
      }
      set endTs(value) {
        console.error("Do not set objects this way");
      }
      setEndTs(value) {
        return this.dataService.updateAnomaly(this.id, { end_ts: value }, this);
      }
      get endTs() {
        return this._endTs;
      }
      set deviceId(value) {
        console.error("Do not set objects this way");
      }
      setDeviceId(value) {
        return this.dataService.updateAnomaly(this.id, { device_id: value }, this);
      }
      get deviceId() {
        return this._deviceId;
      }
      set deviceName(value) {
        console.error("Do not set objects this way");
      }
      setDeviceName(value) {
        return this.dataService.updateAnomaly(this.id, { device_name: value }, this);
      }
      get deviceName() {
        return this._deviceName;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateAnomaly(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set modelId(value) {
        console.error("Do not set objects this way");
      }
      setModelId(value) {
        return this.dataService.updateAnomaly(this.id, { model_id: value }, this);
      }
      get modelId() {
        return this._modelId;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      setSiteName(value) {
        return this.dataService.updateAnomaly(this.id, { site_name: value }, this);
      }
      get siteName() {
        return this._siteName;
      }
      set explanation(value) {
        console.error("Do not set objects this way");
      }
      setExplanation(value) {
        return this.dataService.updateAnomaly(this.id, { explanation: value }, this);
      }
      get explanation() {
        return this._explanation;
      }
      set notes(value) {
        console.error("Do not set objects this way");
      }
      setNotes(value) {
        return this.dataService.updateAnomaly(this.id, { notes: value }, this);
      }
      get notes() {
        return this._notes;
      }
      set userStatus(value) {
        console.error("Do not set objects this way");
      }
      setUserStatus(value) {
        return this.dataService.updateAnomaly(this.id, { user_status: value }, this);
      }
      get userStatus() {
        return this._userStatus;
      }
      set dismissed(value) {
        console.error("Do not set objects this way");
      }
      setDismissed(value) {
        return this.dataService.updateAnomaly(this.id, { dismissed: value }, this);
      }
      get dismissed() {
        return this._dismissed;
      }
      set invalid(value) {
        console.error("Do not set objects this way");
      }
      setInvalid(value) {
        return this.dataService.updateAnomaly(this.id, { invalid: value }, this);
      }
      get invalid() {
        return this._invalid;
      }
      set modelImageUrl(value) {
        console.error("Do not set objects this way");
      }
      setModelImageUrl(value) {
        return this.dataService.updateAnomaly(this.id, { model_image_url: value }, this);
      }
      get modelImageUrl() {
        return this._modelImageUrl;
      }
      set entryValue(value) {
        console.error("Do not set objects this way");
      }
      setEntryValue(value) {
        return this.dataService.updateAnomaly(this.id, { entry_value: value }, this);
      }
      get entryValue() {
        return this._entryValue;
      }
      set entryLowerThreshold(value) {
        console.error("Do not set objects this way");
      }
      setEntryLowerThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { entry_lower_threshold: value }, this);
      }
      get entryLowerThreshold() {
        return this._entryLowerThreshold;
      }
      set entryUpperThreshold(value) {
        console.error("Do not set objects this way");
      }
      setEntryUpperThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { entry_upper_threshold: value }, this);
      }
      get entryUpperThreshold() {
        return this._entryUpperThreshold;
      }
      set exitValue(value) {
        console.error("Do not set objects this way");
      }
      setExitValue(value) {
        return this.dataService.updateAnomaly(this.id, { exit_value: value }, this);
      }
      get exitValue() {
        return this._exitValue;
      }
      set exitLowerThreshold(value) {
        console.error("Do not set objects this way");
      }
      setExitLowerThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { exit_lower_threshold: value }, this);
      }
      get exitLowerThreshold() {
        return this._exitLowerThreshold;
      }
      set exitUpperThreshold(value) {
        console.error("Do not set objects this way");
      }
      setExitUpperThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { exit_upper_threshold: value }, this);
      }
      get exitUpperThreshold() {
        return this._exitUpperThreshold;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAnomaly(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = Anomaly2;
  }
});

// ../gridduck/dist/models/anomalyModel.js
var require_anomalyModel2 = __commonJS({
  "../gridduck/dist/models/anomalyModel.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AnomalyModel2 = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "anomalyModel";
        this._behaviourType = initParams.behaviour_type;
        this._status = initParams.status;
        this._deviceId = initParams.device_id;
        this._created = initParams.created;
        this._trained = initParams.trained;
        this._trainingResults = initParams.training_results;
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
      }
      set behaviourType(value) {
        console.error("Do not set objects this way");
      }
      get behaviourType() {
        return this._behaviourType;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set deviceId(value) {
        console.error("Do not set objects this way");
      }
      get deviceId() {
        return this._deviceId;
      }
      set created(value) {
        console.error("Do not set objects this way");
      }
      get created() {
        return this._created;
      }
      set trained(value) {
        console.error("Do not set objects this way");
      }
      get trained() {
        return this._trained;
      }
      set trainingResults(value) {
        console.error("Do not set objects this way");
      }
      get trainingResults() {
        return this._trainingResults;
      }
      set startTs(value) {
        console.error("Do not set objects this way");
      }
      get startTs() {
        return this._startTs;
      }
      set endTs(value) {
        console.error("Do not set objects this way");
      }
      get endTs() {
        return this._endTs;
      }
    };
    exports2.default = AnomalyModel2;
  }
});

// ../gridduck/dist/models/applianceCategory.js
var require_applianceCategory = __commonJS({
  "../gridduck/dist/models/applianceCategory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ApplianceCategory = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "applianceCategory";
        this._name = initParams.name;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
    };
    exports2.default = ApplianceCategory;
  }
});

// ../gridduck/dist/models/applianceType.js
var require_applianceType = __commonJS({
  "../gridduck/dist/models/applianceType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ApplianceType = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "applianceType";
        this._name = initParams.name;
        this._applianceCategory = initParams.appliance_category;
        this._minutesLeadTime = initParams.minutes_lead_time;
        this._averageKwhPerHour = initParams.average_kwh_per_hour;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set applianceCategory(value) {
        console.error("Do not set objects this way");
      }
      get applianceCategory() {
        return this._applianceCategory;
      }
      set minutesLeadTime(value) {
        console.error("Do not set objects this way");
      }
      get minutesLeadTime() {
        return this._minutesLeadTime;
      }
      set averageKwhPerHour(value) {
        console.error("Do not set objects this way");
      }
      get averageKwhPerHour() {
        return this._averageKwhPerHour;
      }
    };
    exports2.default = ApplianceType;
  }
});

// ../gridduck/dist/models/application.js
var require_application = __commonJS({
  "../gridduck/dist/models/application.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Application = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "application";
        this._clientName = initParams.client_name;
        this._allowedGrants = (0, util_1.camelArray)(initParams.allowed_grants);
        this._scopes = (0, util_1.camelArray)(initParams.scopes);
      }
      set clientName(value) {
        console.error("Do not set objects this way");
      }
      get clientName() {
        return this._clientName;
      }
      set allowedGrants(value) {
        console.error("Do not set objects this way");
      }
      get allowedGrants() {
        return this._allowedGrants;
      }
      set scopes(value) {
        console.error("Do not set objects this way");
      }
      get scopes() {
        return this._scopes;
      }
      delete() {
        return this.dataService.deleteApplication(this.id, this);
      }
    };
    exports2.default = Application;
  }
});

// ../gridduck/dist/models/asset.js
var require_asset = __commonJS({
  "../gridduck/dist/models/asset.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Asset = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.gateway = null;
        this.objectTypeName = "asset";
        this._parentAsset = initParams.parent_asset;
        this._virtualParentAsset = initParams.virtual_parent_asset;
        this._bacnetTcpIpDetails = initParams.bacnet_tcp_ip_details;
        this._widgetBoardId = initParams.widget_board_id;
        this._lastContacted = initParams.last_contacted;
        this._nbIotEcl = initParams.nb_iot_ecl;
        this._groupIds = (0, util_1.camelArray)(initParams.group_ids);
        this._name = initParams.name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._siteTimezone = initParams.site_timezone;
        this._impKwh = initParams.imp_kwh;
        this._currentState = initParams.current_state;
        this._userState = initParams.user_state;
        this._sku = initParams.sku;
        this._code = initParams.code;
        this._dataType = initParams.data_type;
        this._deviceCategory = initParams.device_category;
        this._deviceCategoryColor = initParams.device_category_color;
        this._deviceCategoryIcon = initParams.device_category_icon;
        this._deviceCategoryId = initParams.device_category_id;
        this._generation = initParams.generation;
        this._assetIndex = initParams.asset_index;
        this._ble = initParams.ble;
        this._boostFinish = initParams.boost_finish;
        this._snoozeFinish = initParams.snooze_finish;
        this._loadType = initParams.load_type;
        this._gatewayId = initParams.gateway_id;
        this._gatewayName = initParams.gateway_name;
        this._applianceType = initParams.appliance_type;
        this.__permission = initParams._permission;
        this._serialNo = initParams.serial_no;
        this._readOnly = initParams.read_only;
        this._locked = initParams.locked;
        this._children = (0, util_1.camelArray)(initParams.children);
        this._disconnected = initParams.disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._clampNameTwo = initParams.clamp_name_two;
        this._clampSize = initParams.clamp_size;
        this._climaxClamp = initParams.climax_clamp;
        this._triggerRules = (0, util_1.camelArray)(initParams.trigger_rules);
        this._alertRules = (0, util_1.camelArray)(initParams.alert_rules);
        this._advancedRules = (0, util_1.camelArray)(initParams.advanced_rules);
        this._consumption = initParams.consumption;
        this._consumptionPulse = initParams.consumption_pulse;
        this._gasPulse = initParams.gas_pulse;
        this._waterPulse = initParams.water_pulse;
        this._voc = initParams.voc;
        this._open = initParams.open;
        this._co2 = initParams.co2;
        this._pressure = initParams.pressure;
        this._waterPulseHot = initParams.water_pulse_hot;
        this._temperature = initParams.temperature;
        this._humidity = initParams.humidity;
        this._light = initParams.light;
        this._current = initParams.current;
        this._occupancy = initParams.occupancy;
        this._assetSignalStrength = initParams.asset_signal_strength;
        this._assetBatteryVoltage = initParams.asset_battery_voltage;
        this._assetBatteryAlarm = initParams.asset_battery_alarm;
        this._assetBatteryPercent = initParams.asset_battery_percent;
        this._firmwareTarget = initParams.firmware_target;
        this._assetFirmwareVersion = initParams.asset_firmware_version;
        this._assetFirmwareProgress = initParams.asset_firmware_progress;
        this._demandPhaseOne = initParams.demand_phase_one;
        this._demandPhaseTwo = initParams.demand_phase_two;
        this._demandPhaseThree = initParams.demand_phase_three;
        this._pfPhaseOne = initParams.pf_phase_one;
        this._pfPhaseTwo = initParams.pf_phase_two;
        this._pfPhaseThree = initParams.pf_phase_three;
        this._virtualLink = initParams.virtual_link;
        this._doReconfigure = initParams.do_reconfigure;
        this._modbusId = initParams.modbus_id;
        this._anomalyDetection = initParams.anomaly_detection;
        this._lowBattery = initParams.low_battery;
        this._lowSignal = initParams.low_signal;
        this._fault = initParams.fault;
        this._intermittent = initParams.intermittent;
        this._anomaly = initParams.anomaly;
        this._modbusDetails = initParams.modbus_details;
        this._defaultModifiers = initParams.default_modifiers;
        this._modifierLevel = initParams.modifier_level;
        this._siteDefaultModifiers = initParams.site_default_modifiers;
        this._organisationDefaultModifiers = initParams.organisation_default_modifiers;
      }
      set parentAsset(value) {
        console.error("Do not set objects this way");
      }
      setParentAsset(value) {
        return this.dataService.updateAsset(this.id, { parent_asset: value }, this);
      }
      get parentAsset() {
        return this._parentAsset;
      }
      set virtualParentAsset(value) {
        console.error("Do not set objects this way");
      }
      setVirtualParentAsset(value) {
        return this.dataService.updateAsset(this.id, { virtual_parent_asset: value }, this);
      }
      get virtualParentAsset() {
        return this._virtualParentAsset;
      }
      set bacnetTcpIpDetails(value) {
        console.error("Do not set objects this way");
      }
      setBacnetTcpIpDetails(value) {
        return this.dataService.updateAsset(this.id, { bacnet_tcp_ip_details: value }, this);
      }
      get bacnetTcpIpDetails() {
        return this._bacnetTcpIpDetails;
      }
      set widgetBoardId(value) {
        console.error("Do not set objects this way");
      }
      setWidgetBoardId(value) {
        return this.dataService.updateAsset(this.id, { widget_board_id: value }, this);
      }
      get widgetBoardId() {
        return this._widgetBoardId;
      }
      set lastContacted(value) {
        console.error("Do not set objects this way");
      }
      setLastContacted(value) {
        return this.dataService.updateAsset(this.id, { last_contacted: value }, this);
      }
      get lastContacted() {
        return this._lastContacted;
      }
      set nbIotEcl(value) {
        console.error("Do not set objects this way");
      }
      setNbIotEcl(value) {
        return this.dataService.updateAsset(this.id, { nb_iot_ecl: value }, this);
      }
      get nbIotEcl() {
        return this._nbIotEcl;
      }
      set groupIds(value) {
        console.error("Do not set objects this way");
      }
      setGroupIds(value) {
        return this.dataService.updateAsset(this.id, { group_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get groupIds() {
        return this._groupIds;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateAsset(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      setSiteName(value) {
        return this.dataService.updateAsset(this.id, { site_name: value }, this);
      }
      get siteName() {
        return this._siteName;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateAsset(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set siteTimezone(value) {
        console.error("Do not set objects this way");
      }
      setSiteTimezone(value) {
        return this.dataService.updateAsset(this.id, { site_timezone: value }, this);
      }
      get siteTimezone() {
        return this._siteTimezone;
      }
      set impKwh(value) {
        console.error("Do not set objects this way");
      }
      setImpKwh(value) {
        return this.dataService.updateAsset(this.id, { imp_kwh: value }, this);
      }
      get impKwh() {
        return this._impKwh;
      }
      set currentState(value) {
        console.error("Do not set objects this way");
      }
      setCurrentState(value) {
        return this.dataService.updateAsset(this.id, { current_state: value }, this);
      }
      get currentState() {
        return this._currentState;
      }
      set userState(value) {
        console.error("Do not set objects this way");
      }
      setUserState(value) {
        return this.dataService.updateAsset(this.id, { user_state: value }, this);
      }
      get userState() {
        return this._userState;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      setSku(value) {
        return this.dataService.updateAsset(this.id, { sku: value }, this);
      }
      get sku() {
        return this._sku;
      }
      set code(value) {
        console.error("Do not set objects this way");
      }
      setCode(value) {
        return this.dataService.updateAsset(this.id, { code: value }, this);
      }
      get code() {
        return this._code;
      }
      set dataType(value) {
        console.error("Do not set objects this way");
      }
      setDataType(value) {
        return this.dataService.updateAsset(this.id, { data_type: value }, this);
      }
      get dataType() {
        return this._dataType;
      }
      set deviceCategory(value) {
        console.error("Do not set objects this way");
      }
      setDeviceCategory(value) {
        return this.dataService.updateAsset(this.id, { device_category: value }, this);
      }
      get deviceCategory() {
        return this._deviceCategory;
      }
      set deviceCategoryColor(value) {
        console.error("Do not set objects this way");
      }
      setDeviceCategoryColor(value) {
        return this.dataService.updateAsset(this.id, { device_category_color: value }, this);
      }
      get deviceCategoryColor() {
        return this._deviceCategoryColor;
      }
      set deviceCategoryIcon(value) {
        console.error("Do not set objects this way");
      }
      setDeviceCategoryIcon(value) {
        return this.dataService.updateAsset(this.id, { device_category_icon: value }, this);
      }
      get deviceCategoryIcon() {
        return this._deviceCategoryIcon;
      }
      set deviceCategoryId(value) {
        console.error("Do not set objects this way");
      }
      setDeviceCategoryId(value) {
        return this.dataService.updateAsset(this.id, { device_category_id: value }, this);
      }
      get deviceCategoryId() {
        return this._deviceCategoryId;
      }
      set generation(value) {
        console.error("Do not set objects this way");
      }
      setGeneration(value) {
        return this.dataService.updateAsset(this.id, { generation: value }, this);
      }
      get generation() {
        return this._generation;
      }
      set assetIndex(value) {
        console.error("Do not set objects this way");
      }
      setAssetIndex(value) {
        return this.dataService.updateAsset(this.id, { asset_index: value }, this);
      }
      get assetIndex() {
        return this._assetIndex;
      }
      set ble(value) {
        console.error("Do not set objects this way");
      }
      setBle(value) {
        return this.dataService.updateAsset(this.id, { ble: value }, this);
      }
      get ble() {
        return this._ble;
      }
      set boostFinish(value) {
        console.error("Do not set objects this way");
      }
      setBoostFinish(value) {
        return this.dataService.updateAsset(this.id, { boost_finish: value }, this);
      }
      get boostFinish() {
        return this._boostFinish;
      }
      set snoozeFinish(value) {
        console.error("Do not set objects this way");
      }
      setSnoozeFinish(value) {
        return this.dataService.updateAsset(this.id, { snooze_finish: value }, this);
      }
      get snoozeFinish() {
        return this._snoozeFinish;
      }
      set loadType(value) {
        console.error("Do not set objects this way");
      }
      setLoadType(value) {
        return this.dataService.updateAsset(this.id, { load_type: value }, this);
      }
      get loadType() {
        return this._loadType;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      setGatewayId(value) {
        return this.dataService.updateAsset(this.id, { gateway_id: value }, this);
      }
      get gatewayId() {
        return this._gatewayId;
      }
      set gatewayName(value) {
        console.error("Do not set objects this way");
      }
      setGatewayName(value) {
        return this.dataService.updateAsset(this.id, { gateway_name: value }, this);
      }
      get gatewayName() {
        return this._gatewayName;
      }
      set applianceType(value) {
        console.error("Do not set objects this way");
      }
      setApplianceType(value) {
        return this.dataService.updateAsset(this.id, { appliance_type: value }, this);
      }
      get applianceType() {
        return this._applianceType;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateAsset(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set serialNo(value) {
        console.error("Do not set objects this way");
      }
      setSerialNo(value) {
        return this.dataService.updateAsset(this.id, { serial_no: value }, this);
      }
      get serialNo() {
        return this._serialNo;
      }
      set readOnly(value) {
        console.error("Do not set objects this way");
      }
      setReadOnly(value) {
        return this.dataService.updateAsset(this.id, { read_only: value }, this);
      }
      get readOnly() {
        return this._readOnly;
      }
      set locked(value) {
        console.error("Do not set objects this way");
      }
      setLocked(value) {
        return this.dataService.updateAsset(this.id, { locked: value }, this);
      }
      get locked() {
        return this._locked;
      }
      set children(value) {
        console.error("Do not set objects this way");
      }
      setChildren(value) {
        return this.dataService.updateAsset(this.id, { children: (0, util_1.snakeArray)(value) }, this);
      }
      get children() {
        return this._children;
      }
      set disconnected(value) {
        console.error("Do not set objects this way");
      }
      setDisconnected(value) {
        return this.dataService.updateAsset(this.id, { disconnected: value }, this);
      }
      get disconnected() {
        return this._disconnected;
      }
      set gatewayDisconnected(value) {
        console.error("Do not set objects this way");
      }
      setGatewayDisconnected(value) {
        return this.dataService.updateAsset(this.id, { gateway_disconnected: value }, this);
      }
      get gatewayDisconnected() {
        return this._gatewayDisconnected;
      }
      set clampNameTwo(value) {
        console.error("Do not set objects this way");
      }
      setClampNameTwo(value) {
        return this.dataService.updateAsset(this.id, { clamp_name_two: value }, this);
      }
      get clampNameTwo() {
        return this._clampNameTwo;
      }
      set clampSize(value) {
        console.error("Do not set objects this way");
      }
      setClampSize(value) {
        return this.dataService.updateAsset(this.id, { clamp_size: value }, this);
      }
      get clampSize() {
        return this._clampSize;
      }
      set climaxClamp(value) {
        console.error("Do not set objects this way");
      }
      setClimaxClamp(value) {
        return this.dataService.updateAsset(this.id, { climax_clamp: value }, this);
      }
      get climaxClamp() {
        return this._climaxClamp;
      }
      set triggerRules(value) {
        console.error("Do not set objects this way");
      }
      setTriggerRules(value) {
        return this.dataService.updateAsset(this.id, { trigger_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get triggerRules() {
        return this._triggerRules;
      }
      set alertRules(value) {
        console.error("Do not set objects this way");
      }
      setAlertRules(value) {
        return this.dataService.updateAsset(this.id, { alert_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get alertRules() {
        return this._alertRules;
      }
      set advancedRules(value) {
        console.error("Do not set objects this way");
      }
      setAdvancedRules(value) {
        return this.dataService.updateAsset(this.id, { advanced_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get advancedRules() {
        return this._advancedRules;
      }
      set consumption(value) {
        console.error("Do not set objects this way");
      }
      setConsumption(value) {
        return this.dataService.updateAsset(this.id, { consumption: value }, this);
      }
      get consumption() {
        return this._consumption;
      }
      set consumptionPulse(value) {
        console.error("Do not set objects this way");
      }
      setConsumptionPulse(value) {
        return this.dataService.updateAsset(this.id, { consumption_pulse: value }, this);
      }
      get consumptionPulse() {
        return this._consumptionPulse;
      }
      set gasPulse(value) {
        console.error("Do not set objects this way");
      }
      setGasPulse(value) {
        return this.dataService.updateAsset(this.id, { gas_pulse: value }, this);
      }
      get gasPulse() {
        return this._gasPulse;
      }
      set waterPulse(value) {
        console.error("Do not set objects this way");
      }
      setWaterPulse(value) {
        return this.dataService.updateAsset(this.id, { water_pulse: value }, this);
      }
      get waterPulse() {
        return this._waterPulse;
      }
      set voc(value) {
        console.error("Do not set objects this way");
      }
      setVoc(value) {
        return this.dataService.updateAsset(this.id, { voc: value }, this);
      }
      get voc() {
        return this._voc;
      }
      set open(value) {
        console.error("Do not set objects this way");
      }
      setOpen(value) {
        return this.dataService.updateAsset(this.id, { open: value }, this);
      }
      get open() {
        return this._open;
      }
      set co2(value) {
        console.error("Do not set objects this way");
      }
      setCo2(value) {
        return this.dataService.updateAsset(this.id, { co2: value }, this);
      }
      get co2() {
        return this._co2;
      }
      set pressure(value) {
        console.error("Do not set objects this way");
      }
      setPressure(value) {
        return this.dataService.updateAsset(this.id, { pressure: value }, this);
      }
      get pressure() {
        return this._pressure;
      }
      set waterPulseHot(value) {
        console.error("Do not set objects this way");
      }
      setWaterPulseHot(value) {
        return this.dataService.updateAsset(this.id, { water_pulse_hot: value }, this);
      }
      get waterPulseHot() {
        return this._waterPulseHot;
      }
      set temperature(value) {
        console.error("Do not set objects this way");
      }
      setTemperature(value) {
        return this.dataService.updateAsset(this.id, { temperature: value }, this);
      }
      get temperature() {
        return this._temperature;
      }
      set humidity(value) {
        console.error("Do not set objects this way");
      }
      setHumidity(value) {
        return this.dataService.updateAsset(this.id, { humidity: value }, this);
      }
      get humidity() {
        return this._humidity;
      }
      set light(value) {
        console.error("Do not set objects this way");
      }
      setLight(value) {
        return this.dataService.updateAsset(this.id, { light: value }, this);
      }
      get light() {
        return this._light;
      }
      set current(value) {
        console.error("Do not set objects this way");
      }
      setCurrent(value) {
        return this.dataService.updateAsset(this.id, { current: value }, this);
      }
      get current() {
        return this._current;
      }
      set occupancy(value) {
        console.error("Do not set objects this way");
      }
      setOccupancy(value) {
        return this.dataService.updateAsset(this.id, { occupancy: value }, this);
      }
      get occupancy() {
        return this._occupancy;
      }
      set assetSignalStrength(value) {
        console.error("Do not set objects this way");
      }
      setAssetSignalStrength(value) {
        return this.dataService.updateAsset(this.id, { asset_signal_strength: value }, this);
      }
      get assetSignalStrength() {
        return this._assetSignalStrength;
      }
      set assetBatteryVoltage(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryVoltage(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_voltage: value }, this);
      }
      get assetBatteryVoltage() {
        return this._assetBatteryVoltage;
      }
      set assetBatteryAlarm(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryAlarm(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_alarm: value }, this);
      }
      get assetBatteryAlarm() {
        return this._assetBatteryAlarm;
      }
      set assetBatteryPercent(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryPercent(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_percent: value }, this);
      }
      get assetBatteryPercent() {
        return this._assetBatteryPercent;
      }
      set firmwareTarget(value) {
        console.error("Do not set objects this way");
      }
      setFirmwareTarget(value) {
        return this.dataService.updateAsset(this.id, { firmware_target: value }, this);
      }
      get firmwareTarget() {
        return this._firmwareTarget;
      }
      set assetFirmwareVersion(value) {
        console.error("Do not set objects this way");
      }
      setAssetFirmwareVersion(value) {
        return this.dataService.updateAsset(this.id, { asset_firmware_version: value }, this);
      }
      get assetFirmwareVersion() {
        return this._assetFirmwareVersion;
      }
      set assetFirmwareProgress(value) {
        console.error("Do not set objects this way");
      }
      setAssetFirmwareProgress(value) {
        return this.dataService.updateAsset(this.id, { asset_firmware_progress: value }, this);
      }
      get assetFirmwareProgress() {
        return this._assetFirmwareProgress;
      }
      set demandPhaseOne(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseOne(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_one: value }, this);
      }
      get demandPhaseOne() {
        return this._demandPhaseOne;
      }
      set demandPhaseTwo(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseTwo(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_two: value }, this);
      }
      get demandPhaseTwo() {
        return this._demandPhaseTwo;
      }
      set demandPhaseThree(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseThree(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_three: value }, this);
      }
      get demandPhaseThree() {
        return this._demandPhaseThree;
      }
      set pfPhaseOne(value) {
        console.error("Do not set objects this way");
      }
      setPfPhaseOne(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_one: value }, this);
      }
      get pfPhaseOne() {
        return this._pfPhaseOne;
      }
      set pfPhaseTwo(value) {
        console.error("Do not set objects this way");
      }
      setPfPhaseTwo(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_two: value }, this);
      }
      get pfPhaseTwo() {
        return this._pfPhaseTwo;
      }
      set pfPhaseThree(value) {
        console.error("Do not set objects this way");
      }
      setPfPhaseThree(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_three: value }, this);
      }
      get pfPhaseThree() {
        return this._pfPhaseThree;
      }
      set virtualLink(value) {
        console.error("Do not set objects this way");
      }
      setVirtualLink(value) {
        return this.dataService.updateAsset(this.id, { virtual_link: value }, this);
      }
      get virtualLink() {
        return this._virtualLink;
      }
      set doReconfigure(value) {
        console.error("Do not set objects this way");
      }
      setDoReconfigure(value) {
        return this.dataService.updateAsset(this.id, { do_reconfigure: value }, this);
      }
      get doReconfigure() {
        return this._doReconfigure;
      }
      set modbusId(value) {
        console.error("Do not set objects this way");
      }
      setModbusId(value) {
        return this.dataService.updateAsset(this.id, { modbus_id: value }, this);
      }
      get modbusId() {
        return this._modbusId;
      }
      set anomalyDetection(value) {
        console.error("Do not set objects this way");
      }
      setAnomalyDetection(value) {
        return this.dataService.updateAsset(this.id, { anomaly_detection: value }, this);
      }
      get anomalyDetection() {
        return this._anomalyDetection;
      }
      set lowBattery(value) {
        console.error("Do not set objects this way");
      }
      setLowBattery(value) {
        return this.dataService.updateAsset(this.id, { low_battery: value }, this);
      }
      get lowBattery() {
        return this._lowBattery;
      }
      set lowSignal(value) {
        console.error("Do not set objects this way");
      }
      setLowSignal(value) {
        return this.dataService.updateAsset(this.id, { low_signal: value }, this);
      }
      get lowSignal() {
        return this._lowSignal;
      }
      set fault(value) {
        console.error("Do not set objects this way");
      }
      setFault(value) {
        return this.dataService.updateAsset(this.id, { fault: value }, this);
      }
      get fault() {
        return this._fault;
      }
      set intermittent(value) {
        console.error("Do not set objects this way");
      }
      setIntermittent(value) {
        return this.dataService.updateAsset(this.id, { intermittent: value }, this);
      }
      get intermittent() {
        return this._intermittent;
      }
      set anomaly(value) {
        console.error("Do not set objects this way");
      }
      setAnomaly(value) {
        return this.dataService.updateAsset(this.id, { anomaly: value }, this);
      }
      get anomaly() {
        return this._anomaly;
      }
      set modbusDetails(value) {
        console.error("Do not set objects this way");
      }
      setModbusDetails(value) {
        return this.dataService.updateAsset(this.id, { modbus_details: value }, this);
      }
      get modbusDetails() {
        return this._modbusDetails;
      }
      set defaultModifiers(value) {
        console.error("Do not set objects this way");
      }
      setDefaultModifiers(value) {
        return this.dataService.updateAsset(this.id, { default_modifiers: value }, this);
      }
      get defaultModifiers() {
        return this._defaultModifiers;
      }
      set modifierLevel(value) {
        console.error("Do not set objects this way");
      }
      setModifierLevel(value) {
        return this.dataService.updateAsset(this.id, { modifier_level: value }, this);
      }
      get modifierLevel() {
        return this._modifierLevel;
      }
      set siteDefaultModifiers(value) {
        console.error("Do not set objects this way");
      }
      setSiteDefaultModifiers(value) {
        return this.dataService.updateAsset(this.id, { site_default_modifiers: value }, this);
      }
      get siteDefaultModifiers() {
        return this._siteDefaultModifiers;
      }
      set organisationDefaultModifiers(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationDefaultModifiers(value) {
        return this.dataService.updateAsset(this.id, { organisation_default_modifiers: value }, this);
      }
      get organisationDefaultModifiers() {
        return this._organisationDefaultModifiers;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAsset(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteAsset(this.id, this);
      }
    };
    exports2.default = Asset;
  }
});

// ../gridduck/dist/models/assetAggregateDataRequest.js
var require_assetAggregateDataRequest = __commonJS({
  "../gridduck/dist/models/assetAggregateDataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetAggregateDataRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetAggregateDataRequest";
        this._assetId = initParams.asset_id;
        this._start = initParams.start;
        this._end = initParams.end;
        this._status = initParams.status;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
      set start(value) {
        console.error("Do not set objects this way");
      }
      get start() {
        return this._start;
      }
      set end(value) {
        console.error("Do not set objects this way");
      }
      get end() {
        return this._end;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
    };
    exports2.default = AssetAggregateDataRequest;
  }
});

// ../gridduck/dist/models/assetConsumption.js
var require_assetConsumption = __commonJS({
  "../gridduck/dist/models/assetConsumption.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetConsumption = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetConsumption";
        this.isListening = true;
        this._consumption = initParams.consumption;
        this._siteId = initParams.site_id;
        this._time = initParams.time;
      }
      set consumption(value) {
        console.error("Do not set objects this way");
      }
      get consumption() {
        return this._consumption;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = AssetConsumption;
  }
});

// ../gridduck/dist/models/assetConsumptionBatch.js
var require_assetConsumptionBatch = __commonJS({
  "../gridduck/dist/models/assetConsumptionBatch.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetConsumptionBatch = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetConsumptionBatch";
        this.isListening = true;
        this._assetId = initParams.asset_id;
        this._assetName = initParams.asset_name;
        this._siteName = initParams.site_name;
        this._parent = initParams.parent;
        this._siteId = initParams.site_id;
        this._type = initParams.type;
        this._telemetry = (0, util_1.camelArray)(initParams.telemetry);
        this._currency = initParams.currency;
        this._deviceCategory = initParams.device_category;
        this._deviceCategoryId = initParams.device_category_id;
        this._colour = initParams.colour;
        this._loadType = initParams.load_type;
        this._icon = initParams.icon;
        this._noTariff = initParams.no_tariff;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
      set assetName(value) {
        console.error("Do not set objects this way");
      }
      get assetName() {
        return this._assetName;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      get siteName() {
        return this._siteName;
      }
      set parent(value) {
        console.error("Do not set objects this way");
      }
      get parent() {
        return this._parent;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
      set telemetry(value) {
        console.error("Do not set objects this way");
      }
      get telemetry() {
        return this._telemetry;
      }
      set currency(value) {
        console.error("Do not set objects this way");
      }
      get currency() {
        return this._currency;
      }
      set deviceCategory(value) {
        console.error("Do not set objects this way");
      }
      get deviceCategory() {
        return this._deviceCategory;
      }
      set deviceCategoryId(value) {
        console.error("Do not set objects this way");
      }
      get deviceCategoryId() {
        return this._deviceCategoryId;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      get colour() {
        return this._colour;
      }
      set loadType(value) {
        console.error("Do not set objects this way");
      }
      get loadType() {
        return this._loadType;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      get icon() {
        return this._icon;
      }
      set noTariff(value) {
        console.error("Do not set objects this way");
      }
      get noTariff() {
        return this._noTariff;
      }
    };
    exports2.default = AssetConsumptionBatch;
  }
});

// ../gridduck/dist/models/assetDemand.js
var require_assetDemand = __commonJS({
  "../gridduck/dist/models/assetDemand.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetDemand = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetDemand";
        this._demand = initParams.demand;
        this._time = initParams.time;
      }
      set demand(value) {
        console.error("Do not set objects this way");
      }
      get demand() {
        return this._demand;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = AssetDemand;
  }
});

// ../gridduck/dist/models/assetEvent.js
var require_assetEvent = __commonJS({
  "../gridduck/dist/models/assetEvent.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetEvent = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetEvent";
        this._assetId = initParams.asset_id;
        this._type = initParams.type;
        this._event = initParams.event;
        this._state = initParams.state;
        this._time = initParams.time;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
      set event(value) {
        console.error("Do not set objects this way");
      }
      get event() {
        return this._event;
      }
      set state(value) {
        console.error("Do not set objects this way");
      }
      get state() {
        return this._state;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = AssetEvent;
  }
});

// ../gridduck/dist/models/assetGod.js
var require_assetGod = __commonJS({
  "../gridduck/dist/models/assetGod.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetGod = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.gateway = null;
        this.objectTypeName = "assetGod";
        this._lastContacted = initParams.last_contacted;
        this._name = initParams.name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._siteTimezone = initParams.site_timezone;
        this._impKwh = initParams.imp_kwh;
        this._parentAsset = initParams.parent_asset;
        this._virtualParentAsset = initParams.virtual_parent_asset;
        this._currentState = initParams.current_state;
        this._userState = initParams.user_state;
        this._sku = initParams.sku;
        this._code = initParams.code;
        this._dataType = initParams.data_type;
        this._generation = initParams.generation;
        this._assetIndex = initParams.asset_index;
        this._ble = initParams.ble;
        this._boostFinish = initParams.boost_finish;
        this._snoozeFinish = initParams.snooze_finish;
        this._gatewayId = initParams.gateway_id;
        this._gatewayName = initParams.gateway_name;
        this._applianceType = initParams.appliance_type;
        this.__permission = initParams._permission;
        this._serialNo = initParams.serial_no;
        this._readOnly = initParams.read_only;
        this._locked = initParams.locked;
        this._children = (0, util_1.camelArray)(initParams.children);
        this._disconnected = initParams.disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._clampNameTwo = initParams.clamp_name_two;
        this._clampSize = initParams.clamp_size;
        this._climaxClamp = initParams.climax_clamp;
        this._triggerRules = (0, util_1.camelArray)(initParams.trigger_rules);
        this._alertRules = (0, util_1.camelArray)(initParams.alert_rules);
        this._advancedRules = (0, util_1.camelArray)(initParams.advanced_rules);
        this._consumption = initParams.consumption;
        this._consumptionPulse = initParams.consumption_pulse;
        this._gasPulse = initParams.gas_pulse;
        this._waterPulse = initParams.water_pulse;
        this._waterPulseHot = initParams.water_pulse_hot;
        this._temperature = initParams.temperature;
        this._humidity = initParams.humidity;
        this._light = initParams.light;
        this._occupancy = initParams.occupancy;
        this._assetSignalStrength = initParams.asset_signal_strength;
        this._assetBatteryVoltage = initParams.asset_battery_voltage;
        this._assetBatteryAlarm = initParams.asset_battery_alarm;
        this._assetBatteryPercent = initParams.asset_battery_percent;
        this._firmwareTarget = initParams.firmware_target;
        this._assetFirmwareVersion = initParams.asset_firmware_version;
        this._assetFirmwareProgress = initParams.asset_firmware_progress;
        this._demandPhaseOne = initParams.demand_phase_one;
        this._demandPhaseTwo = initParams.demand_phase_two;
        this._demandPhaseThree = initParams.demand_phase_three;
        this._nbIotEcl = initParams.nb_iot_ecl;
        this._doReconfigure = initParams.do_reconfigure;
      }
      set lastContacted(value) {
        console.error("Do not set objects this way");
      }
      setLastContacted(value) {
        return this.dataService.updateAssetGod(this.id, { last_contacted: value }, this);
      }
      get lastContacted() {
        return this._lastContacted;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateAssetGod(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      setSiteName(value) {
        return this.dataService.updateAssetGod(this.id, { site_name: value }, this);
      }
      get siteName() {
        return this._siteName;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateAssetGod(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set siteTimezone(value) {
        console.error("Do not set objects this way");
      }
      setSiteTimezone(value) {
        return this.dataService.updateAssetGod(this.id, { site_timezone: value }, this);
      }
      get siteTimezone() {
        return this._siteTimezone;
      }
      set impKwh(value) {
        console.error("Do not set objects this way");
      }
      setImpKwh(value) {
        return this.dataService.updateAssetGod(this.id, { imp_kwh: value }, this);
      }
      get impKwh() {
        return this._impKwh;
      }
      set parentAsset(value) {
        console.error("Do not set objects this way");
      }
      setParentAsset(value) {
        return this.dataService.updateAssetGod(this.id, { parent_asset: value }, this);
      }
      get parentAsset() {
        return this._parentAsset;
      }
      set virtualParentAsset(value) {
        console.error("Do not set objects this way");
      }
      setVirtualParentAsset(value) {
        return this.dataService.updateAssetGod(this.id, { virtual_parent_asset: value }, this);
      }
      get virtualParentAsset() {
        return this._virtualParentAsset;
      }
      set currentState(value) {
        console.error("Do not set objects this way");
      }
      setCurrentState(value) {
        return this.dataService.updateAssetGod(this.id, { current_state: value }, this);
      }
      get currentState() {
        return this._currentState;
      }
      set userState(value) {
        console.error("Do not set objects this way");
      }
      setUserState(value) {
        return this.dataService.updateAssetGod(this.id, { user_state: value }, this);
      }
      get userState() {
        return this._userState;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      setSku(value) {
        return this.dataService.updateAssetGod(this.id, { sku: value }, this);
      }
      get sku() {
        return this._sku;
      }
      set code(value) {
        console.error("Do not set objects this way");
      }
      setCode(value) {
        return this.dataService.updateAssetGod(this.id, { code: value }, this);
      }
      get code() {
        return this._code;
      }
      set dataType(value) {
        console.error("Do not set objects this way");
      }
      setDataType(value) {
        return this.dataService.updateAssetGod(this.id, { data_type: value }, this);
      }
      get dataType() {
        return this._dataType;
      }
      set generation(value) {
        console.error("Do not set objects this way");
      }
      setGeneration(value) {
        return this.dataService.updateAssetGod(this.id, { generation: value }, this);
      }
      get generation() {
        return this._generation;
      }
      set assetIndex(value) {
        console.error("Do not set objects this way");
      }
      setAssetIndex(value) {
        return this.dataService.updateAssetGod(this.id, { asset_index: value }, this);
      }
      get assetIndex() {
        return this._assetIndex;
      }
      set ble(value) {
        console.error("Do not set objects this way");
      }
      setBle(value) {
        return this.dataService.updateAssetGod(this.id, { ble: value }, this);
      }
      get ble() {
        return this._ble;
      }
      set boostFinish(value) {
        console.error("Do not set objects this way");
      }
      setBoostFinish(value) {
        return this.dataService.updateAssetGod(this.id, { boost_finish: value }, this);
      }
      get boostFinish() {
        return this._boostFinish;
      }
      set snoozeFinish(value) {
        console.error("Do not set objects this way");
      }
      setSnoozeFinish(value) {
        return this.dataService.updateAssetGod(this.id, { snooze_finish: value }, this);
      }
      get snoozeFinish() {
        return this._snoozeFinish;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      setGatewayId(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_id: value }, this);
      }
      get gatewayId() {
        return this._gatewayId;
      }
      set gatewayName(value) {
        console.error("Do not set objects this way");
      }
      setGatewayName(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_name: value }, this);
      }
      get gatewayName() {
        return this._gatewayName;
      }
      set applianceType(value) {
        console.error("Do not set objects this way");
      }
      setApplianceType(value) {
        return this.dataService.updateAssetGod(this.id, { appliance_type: value }, this);
      }
      get applianceType() {
        return this._applianceType;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateAssetGod(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set serialNo(value) {
        console.error("Do not set objects this way");
      }
      setSerialNo(value) {
        return this.dataService.updateAssetGod(this.id, { serial_no: value }, this);
      }
      get serialNo() {
        return this._serialNo;
      }
      set readOnly(value) {
        console.error("Do not set objects this way");
      }
      setReadOnly(value) {
        return this.dataService.updateAssetGod(this.id, { read_only: value }, this);
      }
      get readOnly() {
        return this._readOnly;
      }
      set locked(value) {
        console.error("Do not set objects this way");
      }
      setLocked(value) {
        return this.dataService.updateAssetGod(this.id, { locked: value }, this);
      }
      get locked() {
        return this._locked;
      }
      set children(value) {
        console.error("Do not set objects this way");
      }
      setChildren(value) {
        return this.dataService.updateAssetGod(this.id, { children: (0, util_1.snakeArray)(value) }, this);
      }
      get children() {
        return this._children;
      }
      set disconnected(value) {
        console.error("Do not set objects this way");
      }
      setDisconnected(value) {
        return this.dataService.updateAssetGod(this.id, { disconnected: value }, this);
      }
      get disconnected() {
        return this._disconnected;
      }
      set gatewayDisconnected(value) {
        console.error("Do not set objects this way");
      }
      setGatewayDisconnected(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_disconnected: value }, this);
      }
      get gatewayDisconnected() {
        return this._gatewayDisconnected;
      }
      set clampNameTwo(value) {
        console.error("Do not set objects this way");
      }
      setClampNameTwo(value) {
        return this.dataService.updateAssetGod(this.id, { clamp_name_two: value }, this);
      }
      get clampNameTwo() {
        return this._clampNameTwo;
      }
      set clampSize(value) {
        console.error("Do not set objects this way");
      }
      setClampSize(value) {
        return this.dataService.updateAssetGod(this.id, { clamp_size: value }, this);
      }
      get clampSize() {
        return this._clampSize;
      }
      set climaxClamp(value) {
        console.error("Do not set objects this way");
      }
      setClimaxClamp(value) {
        return this.dataService.updateAssetGod(this.id, { climax_clamp: value }, this);
      }
      get climaxClamp() {
        return this._climaxClamp;
      }
      set triggerRules(value) {
        console.error("Do not set objects this way");
      }
      setTriggerRules(value) {
        return this.dataService.updateAssetGod(this.id, { trigger_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get triggerRules() {
        return this._triggerRules;
      }
      set alertRules(value) {
        console.error("Do not set objects this way");
      }
      setAlertRules(value) {
        return this.dataService.updateAssetGod(this.id, { alert_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get alertRules() {
        return this._alertRules;
      }
      set advancedRules(value) {
        console.error("Do not set objects this way");
      }
      setAdvancedRules(value) {
        return this.dataService.updateAssetGod(this.id, { advanced_rules: (0, util_1.snakeArray)(value) }, this);
      }
      get advancedRules() {
        return this._advancedRules;
      }
      set consumption(value) {
        console.error("Do not set objects this way");
      }
      setConsumption(value) {
        return this.dataService.updateAssetGod(this.id, { consumption: value }, this);
      }
      get consumption() {
        return this._consumption;
      }
      set consumptionPulse(value) {
        console.error("Do not set objects this way");
      }
      setConsumptionPulse(value) {
        return this.dataService.updateAssetGod(this.id, { consumption_pulse: value }, this);
      }
      get consumptionPulse() {
        return this._consumptionPulse;
      }
      set gasPulse(value) {
        console.error("Do not set objects this way");
      }
      setGasPulse(value) {
        return this.dataService.updateAssetGod(this.id, { gas_pulse: value }, this);
      }
      get gasPulse() {
        return this._gasPulse;
      }
      set waterPulse(value) {
        console.error("Do not set objects this way");
      }
      setWaterPulse(value) {
        return this.dataService.updateAssetGod(this.id, { water_pulse: value }, this);
      }
      get waterPulse() {
        return this._waterPulse;
      }
      set waterPulseHot(value) {
        console.error("Do not set objects this way");
      }
      setWaterPulseHot(value) {
        return this.dataService.updateAssetGod(this.id, { water_pulse_hot: value }, this);
      }
      get waterPulseHot() {
        return this._waterPulseHot;
      }
      set temperature(value) {
        console.error("Do not set objects this way");
      }
      setTemperature(value) {
        return this.dataService.updateAssetGod(this.id, { temperature: value }, this);
      }
      get temperature() {
        return this._temperature;
      }
      set humidity(value) {
        console.error("Do not set objects this way");
      }
      setHumidity(value) {
        return this.dataService.updateAssetGod(this.id, { humidity: value }, this);
      }
      get humidity() {
        return this._humidity;
      }
      set light(value) {
        console.error("Do not set objects this way");
      }
      setLight(value) {
        return this.dataService.updateAssetGod(this.id, { light: value }, this);
      }
      get light() {
        return this._light;
      }
      set occupancy(value) {
        console.error("Do not set objects this way");
      }
      setOccupancy(value) {
        return this.dataService.updateAssetGod(this.id, { occupancy: value }, this);
      }
      get occupancy() {
        return this._occupancy;
      }
      set assetSignalStrength(value) {
        console.error("Do not set objects this way");
      }
      setAssetSignalStrength(value) {
        return this.dataService.updateAssetGod(this.id, { asset_signal_strength: value }, this);
      }
      get assetSignalStrength() {
        return this._assetSignalStrength;
      }
      set assetBatteryVoltage(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryVoltage(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_voltage: value }, this);
      }
      get assetBatteryVoltage() {
        return this._assetBatteryVoltage;
      }
      set assetBatteryAlarm(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryAlarm(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_alarm: value }, this);
      }
      get assetBatteryAlarm() {
        return this._assetBatteryAlarm;
      }
      set assetBatteryPercent(value) {
        console.error("Do not set objects this way");
      }
      setAssetBatteryPercent(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_percent: value }, this);
      }
      get assetBatteryPercent() {
        return this._assetBatteryPercent;
      }
      set firmwareTarget(value) {
        console.error("Do not set objects this way");
      }
      setFirmwareTarget(value) {
        return this.dataService.updateAssetGod(this.id, { firmware_target: value }, this);
      }
      get firmwareTarget() {
        return this._firmwareTarget;
      }
      set assetFirmwareVersion(value) {
        console.error("Do not set objects this way");
      }
      setAssetFirmwareVersion(value) {
        return this.dataService.updateAssetGod(this.id, { asset_firmware_version: value }, this);
      }
      get assetFirmwareVersion() {
        return this._assetFirmwareVersion;
      }
      set assetFirmwareProgress(value) {
        console.error("Do not set objects this way");
      }
      setAssetFirmwareProgress(value) {
        return this.dataService.updateAssetGod(this.id, { asset_firmware_progress: value }, this);
      }
      get assetFirmwareProgress() {
        return this._assetFirmwareProgress;
      }
      set demandPhaseOne(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseOne(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_one: value }, this);
      }
      get demandPhaseOne() {
        return this._demandPhaseOne;
      }
      set demandPhaseTwo(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseTwo(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_two: value }, this);
      }
      get demandPhaseTwo() {
        return this._demandPhaseTwo;
      }
      set demandPhaseThree(value) {
        console.error("Do not set objects this way");
      }
      setDemandPhaseThree(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_three: value }, this);
      }
      get demandPhaseThree() {
        return this._demandPhaseThree;
      }
      set nbIotEcl(value) {
        console.error("Do not set objects this way");
      }
      setNbIotEcl(value) {
        return this.dataService.updateAssetGod(this.id, { nb_iot_ecl: value }, this);
      }
      get nbIotEcl() {
        return this._nbIotEcl;
      }
      set doReconfigure(value) {
        console.error("Do not set objects this way");
      }
      setDoReconfigure(value) {
        return this.dataService.updateAssetGod(this.id, { do_reconfigure: value }, this);
      }
      get doReconfigure() {
        return this._doReconfigure;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAssetGod(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteAssetGod(this.id, this);
      }
    };
    exports2.default = AssetGod;
  }
});

// ../gridduck/dist/models/assetIdentification.js
var require_assetIdentification = __commonJS({
  "../gridduck/dist/models/assetIdentification.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetIdentification = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetIdentification";
        this._assetId = initParams.asset_id;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
    };
    exports2.default = AssetIdentification;
  }
});

// ../gridduck/dist/models/assetRemoveDataRequest.js
var require_assetRemoveDataRequest = __commonJS({
  "../gridduck/dist/models/assetRemoveDataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetRemoveDataRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetRemoveDataRequest";
        this._assetId = initParams.asset_id;
        this._start = initParams.start;
        this._end = initParams.end;
        this._status = initParams.status;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
      set start(value) {
        console.error("Do not set objects this way");
      }
      get start() {
        return this._start;
      }
      set end(value) {
        console.error("Do not set objects this way");
      }
      get end() {
        return this._end;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
    };
    exports2.default = AssetRemoveDataRequest;
  }
});

// ../gridduck/dist/models/assetReset.js
var require_assetReset = __commonJS({
  "../gridduck/dist/models/assetReset.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetReset = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetReset";
        this._assetId = initParams.asset_id;
        this._timestamp = initParams.timestamp;
        this._value = initParams.value;
        this._start = initParams.start;
        this._end = initParams.end;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      setAssetId(value) {
        return this.dataService.updateAssetReset(this.id, { asset_id: value }, this);
      }
      get assetId() {
        return this._assetId;
      }
      set timestamp(value) {
        console.error("Do not set objects this way");
      }
      setTimestamp(value) {
        return this.dataService.updateAssetReset(this.id, { timestamp: value }, this);
      }
      get timestamp() {
        return this._timestamp;
      }
      set value(value) {
        console.error("Do not set objects this way");
      }
      setValue(value) {
        return this.dataService.updateAssetReset(this.id, { value }, this);
      }
      get value() {
        return this._value;
      }
      set start(value) {
        console.error("Do not set objects this way");
      }
      setStart(value) {
        return this.dataService.updateAssetReset(this.id, { start: value }, this);
      }
      get start() {
        return this._start;
      }
      set end(value) {
        console.error("Do not set objects this way");
      }
      setEnd(value) {
        return this.dataService.updateAssetReset(this.id, { end: value }, this);
      }
      get end() {
        return this._end;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAssetReset(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteAssetReset(this.id, this);
      }
    };
    exports2.default = AssetReset;
  }
});

// ../gridduck/dist/models/assetTelemetry.js
var require_assetTelemetry = __commonJS({
  "../gridduck/dist/models/assetTelemetry.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetTelemetry = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetTelemetry";
        this.isListening = true;
        this._value = initParams.value;
        this._time = initParams.time;
      }
      set value(value) {
        console.error("Do not set objects this way");
      }
      get value() {
        return this._value;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = AssetTelemetry;
  }
});

// ../gridduck/dist/models/assetTelemetryBatch.js
var require_assetTelemetryBatch = __commonJS({
  "../gridduck/dist/models/assetTelemetryBatch.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var AssetTelemetryBatch = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetConsumptionBatch";
        this.isListening = true;
        this._assetId = initParams.asset_id;
        this._assetName = initParams.asset_name;
        this._siteName = initParams.site_name;
        this._parent = initParams.parent;
        this._siteId = initParams.site_id;
        this._type = initParams.type;
        this._telemetry = (0, util_1.camelArray)(initParams.telemetry);
        this._currency = initParams.currency;
        this._deviceCategory = initParams.device_category;
        this._deviceCategoryId = initParams.device_category_id;
        this._colour = initParams.colour;
        this._loadType = initParams.load_type;
        this._icon = initParams.icon;
        this._noTariff = initParams.no_tariff;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
      set assetName(value) {
        console.error("Do not set objects this way");
      }
      get assetName() {
        return this._assetName;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      get siteName() {
        return this._siteName;
      }
      set parent(value) {
        console.error("Do not set objects this way");
      }
      get parent() {
        return this._parent;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
      set telemetry(value) {
        console.error("Do not set objects this way");
      }
      get telemetry() {
        return this._telemetry;
      }
      set currency(value) {
        console.error("Do not set objects this way");
      }
      get currency() {
        return this._currency;
      }
      set deviceCategory(value) {
        console.error("Do not set objects this way");
      }
      get deviceCategory() {
        return this._deviceCategory;
      }
      set deviceCategoryId(value) {
        console.error("Do not set objects this way");
      }
      get deviceCategoryId() {
        return this._deviceCategoryId;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      get colour() {
        return this._colour;
      }
      set loadType(value) {
        console.error("Do not set objects this way");
      }
      get loadType() {
        return this._loadType;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      get icon() {
        return this._icon;
      }
      set noTariff(value) {
        console.error("Do not set objects this way");
      }
      get noTariff() {
        return this._noTariff;
      }
    };
    exports2.default = AssetTelemetryBatch;
  }
});

// ../gridduck/dist/models/audit.js
var require_audit = __commonJS({
  "../gridduck/dist/models/audit.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Audit = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "audit";
        this._installerAccountId = initParams.installer_account_id;
        this._installingForId = initParams.installing_for_id;
        this._installerName = initParams.installer_name;
        this._installerOrgName = initParams.installer_org_name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._issues = initParams.issues;
        this._warningLevel = initParams.warning_level;
        this._createdDate = initParams.created_date;
        this._message = initParams.message;
        this._devices = (0, util_1.camelArray)(initParams.devices);
        this._gateways = (0, util_1.camelArray)(initParams.gateways);
        this._files = (0, util_1.camelArray)(initParams.files);
        this._warningLevelDevices = initParams.warning_level_devices;
        this._zeroDemandDevices = initParams.zero_demand_devices;
        this._disconnectedDevices = initParams.disconnected_devices;
        this._disconnectedGateways = initParams.disconnected_gateways;
        this._warningLevelGateways = initParams.warning_level_gateways;
        this._warningLevelFiles = initParams.warning_level_files;
      }
      set installerAccountId(value) {
        console.error("Do not set objects this way");
      }
      get installerAccountId() {
        return this._installerAccountId;
      }
      set installingForId(value) {
        console.error("Do not set objects this way");
      }
      get installingForId() {
        return this._installingForId;
      }
      set installerName(value) {
        console.error("Do not set objects this way");
      }
      get installerName() {
        return this._installerName;
      }
      set installerOrgName(value) {
        console.error("Do not set objects this way");
      }
      get installerOrgName() {
        return this._installerOrgName;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      get siteName() {
        return this._siteName;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set issues(value) {
        console.error("Do not set objects this way");
      }
      get issues() {
        return this._issues;
      }
      set warningLevel(value) {
        console.error("Do not set objects this way");
      }
      get warningLevel() {
        return this._warningLevel;
      }
      set createdDate(value) {
        console.error("Do not set objects this way");
      }
      get createdDate() {
        return this._createdDate;
      }
      set message(value) {
        console.error("Do not set objects this way");
      }
      get message() {
        return this._message;
      }
      set devices(value) {
        console.error("Do not set objects this way");
      }
      get devices() {
        return this._devices;
      }
      set gateways(value) {
        console.error("Do not set objects this way");
      }
      get gateways() {
        return this._gateways;
      }
      set files(value) {
        console.error("Do not set objects this way");
      }
      get files() {
        return this._files;
      }
      set warningLevelDevices(value) {
        console.error("Do not set objects this way");
      }
      get warningLevelDevices() {
        return this._warningLevelDevices;
      }
      set zeroDemandDevices(value) {
        console.error("Do not set objects this way");
      }
      get zeroDemandDevices() {
        return this._zeroDemandDevices;
      }
      set disconnectedDevices(value) {
        console.error("Do not set objects this way");
      }
      get disconnectedDevices() {
        return this._disconnectedDevices;
      }
      set disconnectedGateways(value) {
        console.error("Do not set objects this way");
      }
      get disconnectedGateways() {
        return this._disconnectedGateways;
      }
      set warningLevelGateways(value) {
        console.error("Do not set objects this way");
      }
      get warningLevelGateways() {
        return this._warningLevelGateways;
      }
      set warningLevelFiles(value) {
        console.error("Do not set objects this way");
      }
      get warningLevelFiles() {
        return this._warningLevelFiles;
      }
    };
    exports2.default = Audit;
  }
});

// ../gridduck/dist/models/availableGateway.js
var require_availableGateway = __commonJS({
  "../gridduck/dist/models/availableGateway.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var AvailableGateway = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "availableGateway";
        this._serialNumber = initParams.serial_number;
        this._owners = (0, util_1.camelArray)(initParams.owners);
      }
      set serialNumber(value) {
        console.error("Do not set objects this way");
      }
      setSerialNumber(value) {
        return this.dataService.updateAvailableGateway(this.id, { serial_number: value }, this);
      }
      get serialNumber() {
        return this._serialNumber;
      }
      set owners(value) {
        console.error("Do not set objects this way");
      }
      setOwners(value) {
        return this.dataService.updateAvailableGateway(this.id, { owners: (0, util_1.snakeArray)(value) }, this);
      }
      get owners() {
        return this._owners;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateAvailableGateway(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = AvailableGateway;
  }
});

// ../gridduck/dist/models/bounceEmail.js
var require_bounceEmail = __commonJS({
  "../gridduck/dist/models/bounceEmail.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var BounceEmail = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "bounceEmail";
        this._email = initParams.email;
      }
      set email(value) {
        console.error("Do not set objects this way");
      }
      get email() {
        return this._email;
      }
      delete() {
        return this.dataService.deleteBounceEmail(this.id, this);
      }
    };
    exports2.default = BounceEmail;
  }
});

// ../gridduck/dist/models/calculatorInbound.js
var require_calculatorInbound = __commonJS({
  "../gridduck/dist/models/calculatorInbound.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var CalculatorInbound = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "calculatorInbound";
        this._emailAddress = initParams.email_address;
        this._googlePlacesId = initParams.google_places_id;
        this._businessName = initParams.business_name;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set googlePlacesId(value) {
        console.error("Do not set objects this way");
      }
      get googlePlacesId() {
        return this._googlePlacesId;
      }
      set businessName(value) {
        console.error("Do not set objects this way");
      }
      get businessName() {
        return this._businessName;
      }
    };
    exports2.default = CalculatorInbound;
  }
});

// ../gridduck/dist/models/calculatorResult.js
var require_calculatorResult = __commonJS({
  "../gridduck/dist/models/calculatorResult.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var CalculatorResult = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "calculatorResult";
        this._inboundId = initParams.inbound_id;
        this._totalSavingData = initParams.total_saving_data;
        this._applianceSavingData = (0, util_1.camelArray)(initParams.appliance_saving_data);
        this._hours = (0, util_1.camelArray)(initParams.hours);
        this._appliances = (0, util_1.camelArray)(initParams.appliances);
        this._receivedSavingEmail = initParams.received_saving_email;
      }
      set inboundId(value) {
        console.error("Do not set objects this way");
      }
      get inboundId() {
        return this._inboundId;
      }
      set totalSavingData(value) {
        console.error("Do not set objects this way");
      }
      get totalSavingData() {
        return this._totalSavingData;
      }
      set applianceSavingData(value) {
        console.error("Do not set objects this way");
      }
      get applianceSavingData() {
        return this._applianceSavingData;
      }
      set hours(value) {
        console.error("Do not set objects this way");
      }
      get hours() {
        return this._hours;
      }
      set appliances(value) {
        console.error("Do not set objects this way");
      }
      get appliances() {
        return this._appliances;
      }
      set receivedSavingEmail(value) {
        console.error("Do not set objects this way");
      }
      get receivedSavingEmail() {
        return this._receivedSavingEmail;
      }
    };
    exports2.default = CalculatorResult;
  }
});

// ../gridduck/dist/models/confirmOrgInvite.js
var require_confirmOrgInvite = __commonJS({
  "../gridduck/dist/models/confirmOrgInvite.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ConfirmOrgInvite = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "confirmOrgInvite";
        this._orgPermission = initParams.org_permission;
        this._emailAddress = initParams.email_address;
        this._code = initParams.code;
        this._name = initParams.name;
        this._jobRole = initParams.job_role;
        this._password = initParams.password;
      }
      set orgPermission(value) {
        console.error("Do not set objects this way");
      }
      get orgPermission() {
        return this._orgPermission;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set code(value) {
        console.error("Do not set objects this way");
      }
      get code() {
        return this._code;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set jobRole(value) {
        console.error("Do not set objects this way");
      }
      get jobRole() {
        return this._jobRole;
      }
      set password(value) {
        console.error("Do not set objects this way");
      }
      get password() {
        return this._password;
      }
    };
    exports2.default = ConfirmOrgInvite;
  }
});

// ../gridduck/dist/models/createReport.js
var require_createReport = __commonJS({
  "../gridduck/dist/models/createReport.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var CreateReport = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "createReport";
        this._all = initParams.all;
        this._testing = initParams.testing;
      }
      set all(value) {
        console.error("Do not set objects this way");
      }
      get all() {
        return this._all;
      }
      set testing(value) {
        console.error("Do not set objects this way");
      }
      get testing() {
        return this._testing;
      }
    };
    exports2.default = CreateReport;
  }
});

// ../gridduck/dist/models/customField.js
var require_customField = __commonJS({
  "../gridduck/dist/models/customField.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var CustomField = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "customField";
        this._customFieldTypeId = initParams.custom_field_type_id;
        this._customFieldType = initParams.custom_field_type;
        this._customFieldName = initParams.custom_field_name;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._icon = initParams.icon;
        this._colour = initParams.colour;
        this._valueText = initParams.value_text;
        this._valueNumber = initParams.value_number;
        this._valueBoolean = initParams.value_boolean;
        this._valueTimestamp = initParams.value_timestamp;
        this.__permission = initParams._permission;
      }
      set customFieldTypeId(value) {
        console.error("Do not set objects this way");
      }
      setCustomFieldTypeId(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_type_id: value }, this);
      }
      get customFieldTypeId() {
        return this._customFieldTypeId;
      }
      set customFieldType(value) {
        console.error("Do not set objects this way");
      }
      setCustomFieldType(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_type: value }, this);
      }
      get customFieldType() {
        return this._customFieldType;
      }
      set customFieldName(value) {
        console.error("Do not set objects this way");
      }
      setCustomFieldName(value) {
        return this.dataService.updateCustomField(this.id, { custom_field_name: value }, this);
      }
      get customFieldName() {
        return this._customFieldName;
      }
      set siteIds(value) {
        console.error("Do not set objects this way");
      }
      setSiteIds(value) {
        return this.dataService.updateCustomField(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get siteIds() {
        return this._siteIds;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      setIcon(value) {
        return this.dataService.updateCustomField(this.id, { icon: value }, this);
      }
      get icon() {
        return this._icon;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      setColour(value) {
        return this.dataService.updateCustomField(this.id, { colour: value }, this);
      }
      get colour() {
        return this._colour;
      }
      set valueText(value) {
        console.error("Do not set objects this way");
      }
      setValueText(value) {
        return this.dataService.updateCustomField(this.id, { value_text: value }, this);
      }
      get valueText() {
        return this._valueText;
      }
      set valueNumber(value) {
        console.error("Do not set objects this way");
      }
      setValueNumber(value) {
        return this.dataService.updateCustomField(this.id, { value_number: value }, this);
      }
      get valueNumber() {
        return this._valueNumber;
      }
      set valueBoolean(value) {
        console.error("Do not set objects this way");
      }
      setValueBoolean(value) {
        return this.dataService.updateCustomField(this.id, { value_boolean: value }, this);
      }
      get valueBoolean() {
        return this._valueBoolean;
      }
      set valueTimestamp(value) {
        console.error("Do not set objects this way");
      }
      setValueTimestamp(value) {
        return this.dataService.updateCustomField(this.id, { value_timestamp: value }, this);
      }
      get valueTimestamp() {
        return this._valueTimestamp;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateCustomField(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateCustomField(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteCustomField(this.id, this);
      }
    };
    exports2.default = CustomField;
  }
});

// ../gridduck/dist/models/customFieldData.js
var require_customFieldData = __commonJS({
  "../gridduck/dist/models/customFieldData.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var CustomFieldData = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "customFieldData";
        this._customFieldTypeId = initParams.custom_field_type_id;
        this._total = initParams.total;
        this._noSitesHaveFieldType = initParams.no_sites_have_field_type;
        this._sitesWithoutFieldType = (0, util_1.camelArray)(initParams.sites_without_field_type);
      }
      set customFieldTypeId(value) {
        console.error("Do not set objects this way");
      }
      get customFieldTypeId() {
        return this._customFieldTypeId;
      }
      set total(value) {
        console.error("Do not set objects this way");
      }
      get total() {
        return this._total;
      }
      set noSitesHaveFieldType(value) {
        console.error("Do not set objects this way");
      }
      get noSitesHaveFieldType() {
        return this._noSitesHaveFieldType;
      }
      set sitesWithoutFieldType(value) {
        console.error("Do not set objects this way");
      }
      get sitesWithoutFieldType() {
        return this._sitesWithoutFieldType;
      }
    };
    exports2.default = CustomFieldData;
  }
});

// ../gridduck/dist/models/customFieldType.js
var require_customFieldType = __commonJS({
  "../gridduck/dist/models/customFieldType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var CustomFieldType = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "customFieldType";
        this._name = initParams.name;
        this._icon = initParams.icon;
        this._fieldType = initParams.field_type;
        this._colour = initParams.colour;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateCustomFieldType(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      setIcon(value) {
        return this.dataService.updateCustomFieldType(this.id, { icon: value }, this);
      }
      get icon() {
        return this._icon;
      }
      set fieldType(value) {
        console.error("Do not set objects this way");
      }
      setFieldType(value) {
        return this.dataService.updateCustomFieldType(this.id, { field_type: value }, this);
      }
      get fieldType() {
        return this._fieldType;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      setColour(value) {
        return this.dataService.updateCustomFieldType(this.id, { colour: value }, this);
      }
      get colour() {
        return this._colour;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateCustomFieldType(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateCustomFieldType(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteCustomFieldType(this.id, this);
      }
    };
    exports2.default = CustomFieldType;
  }
});

// ../gridduck/dist/models/data-list.js
var require_data_list = __commonJS({
  "../gridduck/dist/models/data-list.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DataList = class extends subscribable_1.default {
      constructor(list, total, params, dataService, type2, isStatic = false) {
        super(dataService, "");
        this._list = list;
        this.params = params;
        this._total = total;
        this.type = type2;
        if (isStatic) {
          this.isListening = true;
        }
      }
      updateList(list, requestId) {
        let wantedList = this._list.find((l) => l.id === requestId);
        if (wantedList) {
          wantedList.list = list;
          this.emit("updated", "list", this._list.map((l) => l.list).flat());
        }
      }
      get requestIds() {
        return this._list.map((lI) => lI.id).flat();
      }
      get list() {
        return this._list.map((lI) => lI.list).flat();
      }
      set list(inList) {
        this._list = [
          {
            id: "",
            list: inList
          }
        ];
      }
      get total() {
        return this._total;
      }
      set total(value) {
        this._total = value;
      }
    };
    exports2.default = DataList;
  }
});

// ../gridduck/dist/models/dataCategory.js
var require_dataCategory = __commonJS({
  "../gridduck/dist/models/dataCategory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataCategory = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataCategory";
        this._name = initParams.name;
        this._organisationId = initParams.organisation_id;
        this._color = initParams.color;
        this._icon = initParams.icon;
        this._global = initParams.global;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDataCategory(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateDataCategory(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set color(value) {
        console.error("Do not set objects this way");
      }
      setColor(value) {
        return this.dataService.updateDataCategory(this.id, { color: value }, this);
      }
      get color() {
        return this._color;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      setIcon(value) {
        return this.dataService.updateDataCategory(this.id, { icon: value }, this);
      }
      get icon() {
        return this._icon;
      }
      set global(value) {
        console.error("Do not set objects this way");
      }
      setGlobal(value) {
        return this.dataService.updateDataCategory(this.id, { global: value }, this);
      }
      get global() {
        return this._global;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateDataCategory(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataCategory(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDataCategory(this.id, this);
      }
    };
    exports2.default = DataCategory;
  }
});

// ../gridduck/dist/models/dataFileImport.js
var require_dataFileImport = __commonJS({
  "../gridduck/dist/models/dataFileImport.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataFileImport = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataFileImport";
        this._name = initParams.name;
        this._description = initParams.description;
        this._site_id = initParams.site_id;
        this._org_id = initParams.org_id;
        this._format = initParams.format;
        this._created_at = initParams.created_at;
        this._updated_at = initParams.updated_at;
        this._device_config = initParams.device_config;
        this._key_prefix = initParams.key_prefix;
        this._asset_id = initParams.asset_id;
        this._auto_create_asset = initParams.auto_create_asset;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDataFileImport(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      setDescription(value) {
        return this.dataService.updateDataFileImport(this.id, { description: value }, this);
      }
      get description() {
        return this._description;
      }
      set site_id(value) {
        console.error("Do not set objects this way");
      }
      setSite_id(value) {
        return this.dataService.updateDataFileImport(this.id, { site_id: value }, this);
      }
      get site_id() {
        return this._site_id;
      }
      set org_id(value) {
        console.error("Do not set objects this way");
      }
      setOrg_id(value) {
        return this.dataService.updateDataFileImport(this.id, { org_id: value }, this);
      }
      get org_id() {
        return this._org_id;
      }
      set format(value) {
        console.error("Do not set objects this way");
      }
      setFormat(value) {
        return this.dataService.updateDataFileImport(this.id, { format: value }, this);
      }
      get format() {
        return this._format;
      }
      set created_at(value) {
        console.error("Do not set objects this way");
      }
      setCreated_at(value) {
        return this.dataService.updateDataFileImport(this.id, { created_at: value }, this);
      }
      get created_at() {
        return this._created_at;
      }
      set updated_at(value) {
        console.error("Do not set objects this way");
      }
      setUpdated_at(value) {
        return this.dataService.updateDataFileImport(this.id, { updated_at: value }, this);
      }
      get updated_at() {
        return this._updated_at;
      }
      set device_config(value) {
        console.error("Do not set objects this way");
      }
      setDevice_config(value) {
        return this.dataService.updateDataFileImport(this.id, { device_config: value }, this);
      }
      get device_config() {
        return this._device_config;
      }
      set key_prefix(value) {
        console.error("Do not set objects this way");
      }
      setKey_prefix(value) {
        return this.dataService.updateDataFileImport(this.id, { key_prefix: value }, this);
      }
      get key_prefix() {
        return this._key_prefix;
      }
      set asset_id(value) {
        console.error("Do not set objects this way");
      }
      setAsset_id(value) {
        return this.dataService.updateDataFileImport(this.id, { asset_id: value }, this);
      }
      get asset_id() {
        return this._asset_id;
      }
      set auto_create_asset(value) {
        console.error("Do not set objects this way");
      }
      setAuto_create_asset(value) {
        return this.dataService.updateDataFileImport(this.id, { auto_create_asset: value }, this);
      }
      get auto_create_asset() {
        return this._auto_create_asset;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataFileImport(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = DataFileImport;
  }
});

// ../gridduck/dist/models/dataFileImportLog.js
var require_dataFileImportLog = __commonJS({
  "../gridduck/dist/models/dataFileImportLog.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DataFileImportLog = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataFileImportLog";
        this._data_file_import_id = initParams.data_file_import_id;
        this._org_id = initParams.org_id;
        this._status = initParams.status;
        this._source_bucket = initParams.source_bucket;
        this._object_key = initParams.object_key;
        this._rows_total = initParams.rows_total;
        this._rows_processed = initParams.rows_processed;
        this._rows_skipped = initParams.rows_skipped;
        this._data_points_saved = initParams.data_points_saved;
        this._assets_created = initParams.assets_created;
        this._error_count = initParams.error_count;
        this._error_message = initParams.error_message;
        this._error_detail = initParams.error_detail;
        this._started_at = initParams.started_at;
        this._finished_at = initParams.finished_at;
        this._duration_ms = initParams.duration_ms;
        this._created_at = initParams.created_at;
      }
      set data_file_import_id(value) {
        console.error("Do not set objects this way");
      }
      get data_file_import_id() {
        return this._data_file_import_id;
      }
      set org_id(value) {
        console.error("Do not set objects this way");
      }
      get org_id() {
        return this._org_id;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set source_bucket(value) {
        console.error("Do not set objects this way");
      }
      get source_bucket() {
        return this._source_bucket;
      }
      set object_key(value) {
        console.error("Do not set objects this way");
      }
      get object_key() {
        return this._object_key;
      }
      set rows_total(value) {
        console.error("Do not set objects this way");
      }
      get rows_total() {
        return this._rows_total;
      }
      set rows_processed(value) {
        console.error("Do not set objects this way");
      }
      get rows_processed() {
        return this._rows_processed;
      }
      set rows_skipped(value) {
        console.error("Do not set objects this way");
      }
      get rows_skipped() {
        return this._rows_skipped;
      }
      set data_points_saved(value) {
        console.error("Do not set objects this way");
      }
      get data_points_saved() {
        return this._data_points_saved;
      }
      set assets_created(value) {
        console.error("Do not set objects this way");
      }
      get assets_created() {
        return this._assets_created;
      }
      set error_count(value) {
        console.error("Do not set objects this way");
      }
      get error_count() {
        return this._error_count;
      }
      set error_message(value) {
        console.error("Do not set objects this way");
      }
      get error_message() {
        return this._error_message;
      }
      set error_detail(value) {
        console.error("Do not set objects this way");
      }
      get error_detail() {
        return this._error_detail;
      }
      set started_at(value) {
        console.error("Do not set objects this way");
      }
      get started_at() {
        return this._started_at;
      }
      set finished_at(value) {
        console.error("Do not set objects this way");
      }
      get finished_at() {
        return this._finished_at;
      }
      set duration_ms(value) {
        console.error("Do not set objects this way");
      }
      get duration_ms() {
        return this._duration_ms;
      }
      set created_at(value) {
        console.error("Do not set objects this way");
      }
      get created_at() {
        return this._created_at;
      }
    };
    exports2.default = DataFileImportLog;
  }
});

// ../gridduck/dist/models/dataFileImportUpload.js
var require_dataFileImportUpload = __commonJS({
  "../gridduck/dist/models/dataFileImportUpload.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataFileImportUpload = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataFileImportUpload";
        this._configId = initParams.config_id;
        this._action = initParams.action;
        this._files = (0, util_1.camelArray)(initParams.files);
        this._previewResult = initParams.preview_result;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
      }
      set configId(value) {
        console.error("Do not set objects this way");
      }
      get configId() {
        return this._configId;
      }
      set action(value) {
        console.error("Do not set objects this way");
      }
      get action() {
        return this._action;
      }
      set files(value) {
        console.error("Do not set objects this way");
      }
      get files() {
        return this._files;
      }
      set previewResult(value) {
        console.error("Do not set objects this way");
      }
      get previewResult() {
        return this._previewResult;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      get assetIds() {
        return this._assetIds;
      }
    };
    exports2.default = DataFileImportUpload;
  }
});

// ../gridduck/dist/models/dataRequest.js
var require_dataRequest = __commonJS({
  "../gridduck/dist/models/dataRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataRequest";
        this._type = initParams.type;
        this._name = initParams.name;
        this._granularity = initParams.granularity;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._startDate = initParams.start_date;
        this._endDate = initParams.end_date;
        this._status = initParams.status;
        this._size = initParams.size;
        this._dataType = initParams.data_type;
        this._active = initParams.active;
        this._notificationConfig = initParams.notification_config;
        this._lastRunAt = initParams.last_run_at;
        this._parentRequestId = initParams.parent_request_id;
        this._periodKey = initParams.period_key;
        this._deliveredAt = initParams.delivered_at;
        this._deliveryError = initParams.delivery_error;
        this._deliveryAttempts = initParams.delivery_attempts;
        this._webhookSecret = initParams.webhook_secret;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      setType(value) {
        return this.dataService.updateDataRequest(this.id, { type: value }, this);
      }
      get type() {
        return this._type;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDataRequest(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set granularity(value) {
        console.error("Do not set objects this way");
      }
      setGranularity(value) {
        return this.dataService.updateDataRequest(this.id, { granularity: value }, this);
      }
      get granularity() {
        return this._granularity;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      setAssetIds(value) {
        return this.dataService.updateDataRequest(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get assetIds() {
        return this._assetIds;
      }
      set startDate(value) {
        console.error("Do not set objects this way");
      }
      setStartDate(value) {
        return this.dataService.updateDataRequest(this.id, { start_date: value }, this);
      }
      get startDate() {
        return this._startDate;
      }
      set endDate(value) {
        console.error("Do not set objects this way");
      }
      setEndDate(value) {
        return this.dataService.updateDataRequest(this.id, { end_date: value }, this);
      }
      get endDate() {
        return this._endDate;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateDataRequest(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set size(value) {
        console.error("Do not set objects this way");
      }
      setSize(value) {
        return this.dataService.updateDataRequest(this.id, { size: value }, this);
      }
      get size() {
        return this._size;
      }
      set dataType(value) {
        console.error("Do not set objects this way");
      }
      setDataType(value) {
        return this.dataService.updateDataRequest(this.id, { data_type: value }, this);
      }
      get dataType() {
        return this._dataType;
      }
      set active(value) {
        console.error("Do not set objects this way");
      }
      setActive(value) {
        return this.dataService.updateDataRequest(this.id, { active: value }, this);
      }
      get active() {
        return this._active;
      }
      set notificationConfig(value) {
        console.error("Do not set objects this way");
      }
      setNotificationConfig(value) {
        return this.dataService.updateDataRequest(this.id, { notification_config: value }, this);
      }
      get notificationConfig() {
        return this._notificationConfig;
      }
      set lastRunAt(value) {
        console.error("Do not set objects this way");
      }
      setLastRunAt(value) {
        return this.dataService.updateDataRequest(this.id, { last_run_at: value }, this);
      }
      get lastRunAt() {
        return this._lastRunAt;
      }
      set parentRequestId(value) {
        console.error("Do not set objects this way");
      }
      setParentRequestId(value) {
        return this.dataService.updateDataRequest(this.id, { parent_request_id: value }, this);
      }
      get parentRequestId() {
        return this._parentRequestId;
      }
      set periodKey(value) {
        console.error("Do not set objects this way");
      }
      setPeriodKey(value) {
        return this.dataService.updateDataRequest(this.id, { period_key: value }, this);
      }
      get periodKey() {
        return this._periodKey;
      }
      set deliveredAt(value) {
        console.error("Do not set objects this way");
      }
      setDeliveredAt(value) {
        return this.dataService.updateDataRequest(this.id, { delivered_at: value }, this);
      }
      get deliveredAt() {
        return this._deliveredAt;
      }
      set deliveryError(value) {
        console.error("Do not set objects this way");
      }
      setDeliveryError(value) {
        return this.dataService.updateDataRequest(this.id, { delivery_error: value }, this);
      }
      get deliveryError() {
        return this._deliveryError;
      }
      set deliveryAttempts(value) {
        console.error("Do not set objects this way");
      }
      setDeliveryAttempts(value) {
        return this.dataService.updateDataRequest(this.id, { delivery_attempts: value }, this);
      }
      get deliveryAttempts() {
        return this._deliveryAttempts;
      }
      set webhookSecret(value) {
        console.error("Do not set objects this way");
      }
      setWebhookSecret(value) {
        return this.dataService.updateDataRequest(this.id, { webhook_secret: value }, this);
      }
      get webhookSecret() {
        return this._webhookSecret;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataRequest(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDataRequest(this.id, this);
      }
    };
    exports2.default = DataRequest;
  }
});

// ../gridduck/dist/models/dataRequestLink.js
var require_dataRequestLink = __commonJS({
  "../gridduck/dist/models/dataRequestLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DataRequestLink = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataRequestLink";
        this._dataRequestId = initParams.data_request_id;
        this._expiresTime = initParams.expires_time;
        this._url = initParams.url;
        this._expires = initParams.expires;
      }
      set dataRequestId(value) {
        console.error("Do not set objects this way");
      }
      get dataRequestId() {
        return this._dataRequestId;
      }
      set expiresTime(value) {
        console.error("Do not set objects this way");
      }
      get expiresTime() {
        return this._expiresTime;
      }
      set url(value) {
        console.error("Do not set objects this way");
      }
      get url() {
        return this._url;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
    };
    exports2.default = DataRequestLink;
  }
});

// ../gridduck/dist/models/dataRequestRun.js
var require_dataRequestRun = __commonJS({
  "../gridduck/dist/models/dataRequestRun.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DataRequestRun = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataRequestRun";
        this._dataRequestId = initParams.data_request_id;
        this._triggered = initParams.triggered;
      }
      set dataRequestId(value) {
        console.error("Do not set objects this way");
      }
      get dataRequestId() {
        return this._dataRequestId;
      }
      set triggered(value) {
        console.error("Do not set objects this way");
      }
      get triggered() {
        return this._triggered;
      }
    };
    exports2.default = DataRequestRun;
  }
});

// ../gridduck/dist/models/dataType.js
var require_dataType = __commonJS({
  "../gridduck/dist/models/dataType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataType = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataType";
        this._name = initParams.name;
        this._dataType = initParams.data_type;
        this._organisationId = initParams.organisation_id;
        this._unitId = initParams.unit_id;
        this._unitDetails = initParams.unit_details;
        this._applyRate = initParams.apply_rate;
        this._rateUnitId = initParams.rate_unit_id;
        this._rateUnitDetails = initParams.rate_unit_details;
        this._categoryId = initParams.category_id;
        this._categoryDetails = initParams.category_details;
        this._global = initParams.global;
        this._defaultRateMultiple = initParams.default_rate_multiple;
        this._defaultMultiple = initParams.default_multiple;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDataType(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set dataType(value) {
        console.error("Do not set objects this way");
      }
      setDataType(value) {
        return this.dataService.updateDataType(this.id, { data_type: value }, this);
      }
      get dataType() {
        return this._dataType;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateDataType(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set unitId(value) {
        console.error("Do not set objects this way");
      }
      setUnitId(value) {
        return this.dataService.updateDataType(this.id, { unit_id: value }, this);
      }
      get unitId() {
        return this._unitId;
      }
      set unitDetails(value) {
        console.error("Do not set objects this way");
      }
      setUnitDetails(value) {
        return this.dataService.updateDataType(this.id, { unit_details: value }, this);
      }
      get unitDetails() {
        return this._unitDetails;
      }
      set applyRate(value) {
        console.error("Do not set objects this way");
      }
      setApplyRate(value) {
        return this.dataService.updateDataType(this.id, { apply_rate: value }, this);
      }
      get applyRate() {
        return this._applyRate;
      }
      set rateUnitId(value) {
        console.error("Do not set objects this way");
      }
      setRateUnitId(value) {
        return this.dataService.updateDataType(this.id, { rate_unit_id: value }, this);
      }
      get rateUnitId() {
        return this._rateUnitId;
      }
      set rateUnitDetails(value) {
        console.error("Do not set objects this way");
      }
      setRateUnitDetails(value) {
        return this.dataService.updateDataType(this.id, { rate_unit_details: value }, this);
      }
      get rateUnitDetails() {
        return this._rateUnitDetails;
      }
      set categoryId(value) {
        console.error("Do not set objects this way");
      }
      setCategoryId(value) {
        return this.dataService.updateDataType(this.id, { category_id: value }, this);
      }
      get categoryId() {
        return this._categoryId;
      }
      set categoryDetails(value) {
        console.error("Do not set objects this way");
      }
      setCategoryDetails(value) {
        return this.dataService.updateDataType(this.id, { category_details: value }, this);
      }
      get categoryDetails() {
        return this._categoryDetails;
      }
      set global(value) {
        console.error("Do not set objects this way");
      }
      setGlobal(value) {
        return this.dataService.updateDataType(this.id, { global: value }, this);
      }
      get global() {
        return this._global;
      }
      set defaultRateMultiple(value) {
        console.error("Do not set objects this way");
      }
      setDefaultRateMultiple(value) {
        return this.dataService.updateDataType(this.id, { default_rate_multiple: value }, this);
      }
      get defaultRateMultiple() {
        return this._defaultRateMultiple;
      }
      set defaultMultiple(value) {
        console.error("Do not set objects this way");
      }
      setDefaultMultiple(value) {
        return this.dataService.updateDataType(this.id, { default_multiple: value }, this);
      }
      get defaultMultiple() {
        return this._defaultMultiple;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateDataType(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataType(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDataType(this.id, this);
      }
    };
    exports2.default = DataType;
  }
});

// ../gridduck/dist/models/dataUnit.js
var require_dataUnit = __commonJS({
  "../gridduck/dist/models/dataUnit.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataUnit = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataUnit";
        this._dataType = initParams.data_type;
        this._unitCategory = initParams.unit_category;
        this._name = initParams.name;
        this._unitType = initParams.unit_type;
        this._metaData = initParams.meta_data;
        this.__permission = initParams._permission;
        this._global = initParams.global;
      }
      set dataType(value) {
        console.error("Do not set objects this way");
      }
      setDataType(value) {
        return this.dataService.updateDataUnit(this.id, { data_type: value }, this);
      }
      get dataType() {
        return this._dataType;
      }
      set unitCategory(value) {
        console.error("Do not set objects this way");
      }
      setUnitCategory(value) {
        return this.dataService.updateDataUnit(this.id, { unit_category: value }, this);
      }
      get unitCategory() {
        return this._unitCategory;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDataUnit(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set unitType(value) {
        console.error("Do not set objects this way");
      }
      setUnitType(value) {
        return this.dataService.updateDataUnit(this.id, { unit_type: value }, this);
      }
      get unitType() {
        return this._unitType;
      }
      set metaData(value) {
        console.error("Do not set objects this way");
      }
      setMetaData(value) {
        return this.dataService.updateDataUnit(this.id, { meta_data: value }, this);
      }
      get metaData() {
        return this._metaData;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateDataUnit(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set global(value) {
        console.error("Do not set objects this way");
      }
      setGlobal(value) {
        return this.dataService.updateDataUnit(this.id, { global: value }, this);
      }
      get global() {
        return this._global;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataUnit(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDataUnit(this.id, this);
      }
    };
    exports2.default = DataUnit;
  }
});

// ../gridduck/dist/models/dataUpload.js
var require_dataUpload = __commonJS({
  "../gridduck/dist/models/dataUpload.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DataUpload = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dataUpload";
        this._file = initParams.file;
        this._groupName = initParams.group_name;
        this._noHeaders = (0, util_1.camelArray)(initParams.no_headers);
        this._columnData = (0, util_1.camelArray)(initParams.column_data);
        this._csvFileNames = (0, util_1.camelArray)(initParams.csv_file_names);
        this._uploaded = initParams.uploaded;
        this._dataItemsLayout = initParams.data_items_layout;
        this._dataItemsColumn = initParams.data_items_column;
        this._dataItems = (0, util_1.camelArray)(initParams.data_items);
        this._newDevices = (0, util_1.camelArray)(initParams.new_devices);
        this._newSites = (0, util_1.camelArray)(initParams.new_sites);
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._previewSampleData = initParams.preview_sample_data;
        this._processedErrors = initParams.processed_errors;
        this._processingStatusDetails = initParams.processing_status_details;
        this._uploadingStatusDetails = initParams.uploading_status_details;
        this._status = initParams.status;
      }
      set file(value) {
        console.error("Do not set objects this way");
      }
      setFile(value) {
        return this.dataService.updateDataUpload(this.id, { file: value }, this);
      }
      get file() {
        return this._file;
      }
      set groupName(value) {
        console.error("Do not set objects this way");
      }
      setGroupName(value) {
        return this.dataService.updateDataUpload(this.id, { group_name: value }, this);
      }
      get groupName() {
        return this._groupName;
      }
      set noHeaders(value) {
        console.error("Do not set objects this way");
      }
      setNoHeaders(value) {
        return this.dataService.updateDataUpload(this.id, { no_headers: (0, util_1.snakeArray)(value) }, this);
      }
      get noHeaders() {
        return this._noHeaders;
      }
      set columnData(value) {
        console.error("Do not set objects this way");
      }
      setColumnData(value) {
        return this.dataService.updateDataUpload(this.id, { column_data: (0, util_1.snakeArray)(value) }, this);
      }
      get columnData() {
        return this._columnData;
      }
      set csvFileNames(value) {
        console.error("Do not set objects this way");
      }
      setCsvFileNames(value) {
        return this.dataService.updateDataUpload(this.id, { csv_file_names: (0, util_1.snakeArray)(value) }, this);
      }
      get csvFileNames() {
        return this._csvFileNames;
      }
      set uploaded(value) {
        console.error("Do not set objects this way");
      }
      setUploaded(value) {
        return this.dataService.updateDataUpload(this.id, { uploaded: value }, this);
      }
      get uploaded() {
        return this._uploaded;
      }
      set dataItemsLayout(value) {
        console.error("Do not set objects this way");
      }
      setDataItemsLayout(value) {
        return this.dataService.updateDataUpload(this.id, { data_items_layout: value }, this);
      }
      get dataItemsLayout() {
        return this._dataItemsLayout;
      }
      set dataItemsColumn(value) {
        console.error("Do not set objects this way");
      }
      setDataItemsColumn(value) {
        return this.dataService.updateDataUpload(this.id, { data_items_column: value }, this);
      }
      get dataItemsColumn() {
        return this._dataItemsColumn;
      }
      set dataItems(value) {
        console.error("Do not set objects this way");
      }
      setDataItems(value) {
        return this.dataService.updateDataUpload(this.id, { data_items: (0, util_1.snakeArray)(value) }, this);
      }
      get dataItems() {
        return this._dataItems;
      }
      set newDevices(value) {
        console.error("Do not set objects this way");
      }
      setNewDevices(value) {
        return this.dataService.updateDataUpload(this.id, { new_devices: (0, util_1.snakeArray)(value) }, this);
      }
      get newDevices() {
        return this._newDevices;
      }
      set newSites(value) {
        console.error("Do not set objects this way");
      }
      setNewSites(value) {
        return this.dataService.updateDataUpload(this.id, { new_sites: (0, util_1.snakeArray)(value) }, this);
      }
      get newSites() {
        return this._newSites;
      }
      set dataTypes(value) {
        console.error("Do not set objects this way");
      }
      setDataTypes(value) {
        return this.dataService.updateDataUpload(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
      }
      get dataTypes() {
        return this._dataTypes;
      }
      set previewSampleData(value) {
        console.error("Do not set objects this way");
      }
      setPreviewSampleData(value) {
        return this.dataService.updateDataUpload(this.id, { preview_sample_data: value }, this);
      }
      get previewSampleData() {
        return this._previewSampleData;
      }
      set processedErrors(value) {
        console.error("Do not set objects this way");
      }
      setProcessedErrors(value) {
        return this.dataService.updateDataUpload(this.id, { processed_errors: value }, this);
      }
      get processedErrors() {
        return this._processedErrors;
      }
      set processingStatusDetails(value) {
        console.error("Do not set objects this way");
      }
      setProcessingStatusDetails(value) {
        return this.dataService.updateDataUpload(this.id, { processing_status_details: value }, this);
      }
      get processingStatusDetails() {
        return this._processingStatusDetails;
      }
      set uploadingStatusDetails(value) {
        console.error("Do not set objects this way");
      }
      setUploadingStatusDetails(value) {
        return this.dataService.updateDataUpload(this.id, { uploading_status_details: value }, this);
      }
      get uploadingStatusDetails() {
        return this._uploadingStatusDetails;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateDataUpload(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDataUpload(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDataUpload(this.id, this);
      }
    };
    exports2.default = DataUpload;
  }
});

// ../gridduck/dist/models/dcChargePoint.js
var require_dcChargePoint = __commonJS({
  "../gridduck/dist/models/dcChargePoint.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DcChargePoint = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dcChargePoint";
        this._available = initParams.available;
        this._chargeStationId = initParams.charge_station_id;
        this._code = initParams.code;
      }
      set available(value) {
        console.error("Do not set objects this way");
      }
      get available() {
        return this._available;
      }
      set chargeStationId(value) {
        console.error("Do not set objects this way");
      }
      get chargeStationId() {
        return this._chargeStationId;
      }
      set code(value) {
        console.error("Do not set objects this way");
      }
      get code() {
        return this._code;
      }
    };
    exports2.default = DcChargePoint;
  }
});

// ../gridduck/dist/models/dcChargeStation.js
var require_dcChargeStation = __commonJS({
  "../gridduck/dist/models/dcChargeStation.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DcChargeStation = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dcChargeStation";
        this._lat = initParams.lat;
        this._lng = initParams.lng;
        this._name = initParams.name;
        this._formattedAddress = initParams.formatted_address;
        this._available = initParams.available;
        this._chargePoints = (0, util_1.camelArray)(initParams.charge_points);
      }
      set lat(value) {
        console.error("Do not set objects this way");
      }
      get lat() {
        return this._lat;
      }
      set lng(value) {
        console.error("Do not set objects this way");
      }
      get lng() {
        return this._lng;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set formattedAddress(value) {
        console.error("Do not set objects this way");
      }
      get formattedAddress() {
        return this._formattedAddress;
      }
      set available(value) {
        console.error("Do not set objects this way");
      }
      get available() {
        return this._available;
      }
      set chargePoints(value) {
        console.error("Do not set objects this way");
      }
      get chargePoints() {
        return this._chargePoints;
      }
    };
    exports2.default = DcChargeStation;
  }
});

// ../gridduck/dist/models/dcCreateAccount.js
var require_dcCreateAccount = __commonJS({
  "../gridduck/dist/models/dcCreateAccount.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DcCreateAccount = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dcCreateAccount";
        this._emailAddress = initParams.email_address;
        this._password = initParams.password;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set password(value) {
        console.error("Do not set objects this way");
      }
      get password() {
        return this._password;
      }
    };
    exports2.default = DcCreateAccount;
  }
});

// ../gridduck/dist/models/dcRetryPayment.js
var require_dcRetryPayment = __commonJS({
  "../gridduck/dist/models/dcRetryPayment.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DcRetryPayment = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dcRetryPayment";
        this._status = initParams.status;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
    };
    exports2.default = DcRetryPayment;
  }
});

// ../gridduck/dist/models/dcSession.js
var require_dcSession = __commonJS({
  "../gridduck/dist/models/dcSession.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var DcSession = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "dcSession";
        this._startTime = initParams.start_time;
        this._endTime = initParams.end_time;
        this._priceCap = initParams.price_cap;
        this._chargePointId = initParams.charge_point_id;
        this._status = initParams.status;
        this._invoiceDetails = initParams.invoice_details;
        this._reasonForEnd = initParams.reason_for_end;
        this._totalCost = initParams.total_cost;
        this._totalUsage = initParams.total_usage;
        this._priceCapFormatted = initParams.price_cap_formatted;
        this._totalCostFormatted = initParams.total_cost_formatted;
        this._totalUsageFormatted = initParams.total_usage_formatted;
      }
      set startTime(value) {
        console.error("Do not set objects this way");
      }
      get startTime() {
        return this._startTime;
      }
      set endTime(value) {
        console.error("Do not set objects this way");
      }
      get endTime() {
        return this._endTime;
      }
      set priceCap(value) {
        console.error("Do not set objects this way");
      }
      get priceCap() {
        return this._priceCap;
      }
      set chargePointId(value) {
        console.error("Do not set objects this way");
      }
      get chargePointId() {
        return this._chargePointId;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set invoiceDetails(value) {
        console.error("Do not set objects this way");
      }
      get invoiceDetails() {
        return this._invoiceDetails;
      }
      set reasonForEnd(value) {
        console.error("Do not set objects this way");
      }
      get reasonForEnd() {
        return this._reasonForEnd;
      }
      set totalCost(value) {
        console.error("Do not set objects this way");
      }
      get totalCost() {
        return this._totalCost;
      }
      set totalUsage(value) {
        console.error("Do not set objects this way");
      }
      get totalUsage() {
        return this._totalUsage;
      }
      set priceCapFormatted(value) {
        console.error("Do not set objects this way");
      }
      get priceCapFormatted() {
        return this._priceCapFormatted;
      }
      set totalCostFormatted(value) {
        console.error("Do not set objects this way");
      }
      get totalCostFormatted() {
        return this._totalCostFormatted;
      }
      set totalUsageFormatted(value) {
        console.error("Do not set objects this way");
      }
      get totalUsageFormatted() {
        return this._totalUsageFormatted;
      }
      delete() {
        return this.dataService.deleteDcSession(this.id, this);
      }
    };
    exports2.default = DcSession;
  }
});

// ../gridduck/dist/models/detectedDevice.js
var require_detectedDevice = __commonJS({
  "../gridduck/dist/models/detectedDevice.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DetectedDevice = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "detectedDevice";
        this._gatewayId = initParams.gateway_id;
        this._deviceType = initParams.device_type;
        this._assetCode = initParams.asset_code;
        this._sku = initParams.sku;
        this._displayName = initParams.display_name;
        this._displayImage = initParams.display_image;
        this._detectingState = initParams.detecting_state;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      setGatewayId(value) {
        return this.dataService.updateDetectedDevice(this.id, { gateway_id: value }, this);
      }
      get gatewayId() {
        return this._gatewayId;
      }
      set deviceType(value) {
        console.error("Do not set objects this way");
      }
      setDeviceType(value) {
        return this.dataService.updateDetectedDevice(this.id, { device_type: value }, this);
      }
      get deviceType() {
        return this._deviceType;
      }
      set assetCode(value) {
        console.error("Do not set objects this way");
      }
      setAssetCode(value) {
        return this.dataService.updateDetectedDevice(this.id, { asset_code: value }, this);
      }
      get assetCode() {
        return this._assetCode;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      setSku(value) {
        return this.dataService.updateDetectedDevice(this.id, { sku: value }, this);
      }
      get sku() {
        return this._sku;
      }
      set displayName(value) {
        console.error("Do not set objects this way");
      }
      setDisplayName(value) {
        return this.dataService.updateDetectedDevice(this.id, { display_name: value }, this);
      }
      get displayName() {
        return this._displayName;
      }
      set displayImage(value) {
        console.error("Do not set objects this way");
      }
      setDisplayImage(value) {
        return this.dataService.updateDetectedDevice(this.id, { display_image: value }, this);
      }
      get displayImage() {
        return this._displayImage;
      }
      set detectingState(value) {
        console.error("Do not set objects this way");
      }
      setDetectingState(value) {
        return this.dataService.updateDetectedDevice(this.id, { detecting_state: value }, this);
      }
      get detectingState() {
        return this._detectingState;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDetectedDevice(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = DetectedDevice;
  }
});

// ../gridduck/dist/models/deviceCategory.js
var require_deviceCategory = __commonJS({
  "../gridduck/dist/models/deviceCategory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DeviceCategory = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "deviceCategory";
        this._name = initParams.name;
        this._organisationId = initParams.organisation_id;
        this._colour = initParams.colour;
        this._icon = initParams.icon;
        this._global = initParams.global;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateDeviceCategory(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateDeviceCategory(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      setColour(value) {
        return this.dataService.updateDeviceCategory(this.id, { colour: value }, this);
      }
      get colour() {
        return this._colour;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      setIcon(value) {
        return this.dataService.updateDeviceCategory(this.id, { icon: value }, this);
      }
      get icon() {
        return this._icon;
      }
      set global(value) {
        console.error("Do not set objects this way");
      }
      setGlobal(value) {
        return this.dataService.updateDeviceCategory(this.id, { global: value }, this);
      }
      get global() {
        return this._global;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      setAssetIds(value) {
        return this.dataService.updateDeviceCategory(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get assetIds() {
        return this._assetIds;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateDeviceCategory(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateDeviceCategory(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteDeviceCategory(this.id, this);
      }
    };
    exports2.default = DeviceCategory;
  }
});

// ../gridduck/dist/models/discount.js
var require_discount = __commonJS({
  "../gridduck/dist/models/discount.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Discount = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "discount";
        this._currency = initParams.currency;
        this._appliesTo = (0, util_1.camelArray)(initParams.applies_to);
        this._name = initParams.name;
        this._metadata = initParams.metadata;
        this._percentOff = initParams.percent_off;
        this._valid = initParams.valid;
      }
      set currency(value) {
        console.error("Do not set objects this way");
      }
      get currency() {
        return this._currency;
      }
      set appliesTo(value) {
        console.error("Do not set objects this way");
      }
      get appliesTo() {
        return this._appliesTo;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set metadata(value) {
        console.error("Do not set objects this way");
      }
      get metadata() {
        return this._metadata;
      }
      set percentOff(value) {
        console.error("Do not set objects this way");
      }
      get percentOff() {
        return this._percentOff;
      }
      set valid(value) {
        console.error("Do not set objects this way");
      }
      get valid() {
        return this._valid;
      }
    };
    exports2.default = Discount;
  }
});

// ../gridduck/dist/models/duckChargeAdmin.js
var require_duckChargeAdmin = __commonJS({
  "../gridduck/dist/models/duckChargeAdmin.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var DuckChargeAdmin = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "duckChargeAdmin";
        this._kpis = initParams.kpis;
        this._users = (0, util_1.camelArray)(initParams.users);
        this._sessions = (0, util_1.camelArray)(initParams.sessions);
        this._chargePoints = (0, util_1.camelArray)(initParams.charge_points);
        this._totalSessions = initParams.total_sessions;
        this._averageSessionsPerDay = initParams.average_sessions_per_day;
      }
      set kpis(value) {
        console.error("Do not set objects this way");
      }
      get kpis() {
        return this._kpis;
      }
      set users(value) {
        console.error("Do not set objects this way");
      }
      get users() {
        return this._users;
      }
      set sessions(value) {
        console.error("Do not set objects this way");
      }
      get sessions() {
        return this._sessions;
      }
      set chargePoints(value) {
        console.error("Do not set objects this way");
      }
      get chargePoints() {
        return this._chargePoints;
      }
      set totalSessions(value) {
        console.error("Do not set objects this way");
      }
      get totalSessions() {
        return this._totalSessions;
      }
      set averageSessionsPerDay(value) {
        console.error("Do not set objects this way");
      }
      get averageSessionsPerDay() {
        return this._averageSessionsPerDay;
      }
    };
    exports2.default = DuckChargeAdmin;
  }
});

// ../gridduck/dist/models/file.js
var require_file = __commonJS({
  "../gridduck/dist/models/file.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var File2 = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "file";
        this._itemType = initParams.item_type;
        this._itemId = initParams.item_id;
        this._name = initParams.name;
        this._type = initParams.type;
        this._size = initParams.size;
        this._file = initParams.file;
        this._ref = initParams.ref;
        this._description = initParams.description;
        this._location = initParams.location;
        this._thumbnail = initParams.thumbnail;
        this._uploadRef = initParams.upload_ref;
        this._uploadedByName = initParams.uploaded_by_name;
        this._ORN = initParams.o_r_n;
        this._uploadedStamp = initParams.uploaded_stamp;
      }
      set itemType(value) {
        console.error("Do not set objects this way");
      }
      setItemType(value) {
        return this.dataService.updateFile(this.id, { item_type: value }, this);
      }
      get itemType() {
        return this._itemType;
      }
      set itemId(value) {
        console.error("Do not set objects this way");
      }
      setItemId(value) {
        return this.dataService.updateFile(this.id, { item_id: value }, this);
      }
      get itemId() {
        return this._itemId;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateFile(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      setType(value) {
        return this.dataService.updateFile(this.id, { type: value }, this);
      }
      get type() {
        return this._type;
      }
      set size(value) {
        console.error("Do not set objects this way");
      }
      setSize(value) {
        return this.dataService.updateFile(this.id, { size: value }, this);
      }
      get size() {
        return this._size;
      }
      set file(value) {
        console.error("Do not set objects this way");
      }
      setFile(value) {
        return this.dataService.updateFile(this.id, { file: value }, this);
      }
      get file() {
        return this._file;
      }
      set ref(value) {
        console.error("Do not set objects this way");
      }
      setRef(value) {
        return this.dataService.updateFile(this.id, { ref: value }, this);
      }
      get ref() {
        return this._ref;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      setDescription(value) {
        return this.dataService.updateFile(this.id, { description: value }, this);
      }
      get description() {
        return this._description;
      }
      set location(value) {
        console.error("Do not set objects this way");
      }
      setLocation(value) {
        return this.dataService.updateFile(this.id, { location: value }, this);
      }
      get location() {
        return this._location;
      }
      set thumbnail(value) {
        console.error("Do not set objects this way");
      }
      setThumbnail(value) {
        return this.dataService.updateFile(this.id, { thumbnail: value }, this);
      }
      get thumbnail() {
        return this._thumbnail;
      }
      set uploadRef(value) {
        console.error("Do not set objects this way");
      }
      setUploadRef(value) {
        return this.dataService.updateFile(this.id, { upload_ref: value }, this);
      }
      get uploadRef() {
        return this._uploadRef;
      }
      set uploadedByName(value) {
        console.error("Do not set objects this way");
      }
      setUploadedByName(value) {
        return this.dataService.updateFile(this.id, { uploaded_by_name: value }, this);
      }
      get uploadedByName() {
        return this._uploadedByName;
      }
      set ORN(value) {
        console.error("Do not set objects this way");
      }
      setORN(value) {
        return this.dataService.updateFile(this.id, { o_r_n: value }, this);
      }
      get ORN() {
        return this._ORN;
      }
      set uploadedStamp(value) {
        console.error("Do not set objects this way");
      }
      setUploadedStamp(value) {
        return this.dataService.updateFile(this.id, { uploaded_stamp: value }, this);
      }
      get uploadedStamp() {
        return this._uploadedStamp;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateFile(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteFile(this.id, this);
      }
    };
    exports2.default = File2;
  }
});

// ../gridduck/dist/models/gaiaConversation.js
var require_gaiaConversation = __commonJS({
  "../gridduck/dist/models/gaiaConversation.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GaiaConversation = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gaiaConversation";
        this._title = initParams.title;
        this._updatedAt = initParams.updated_at;
        this._createdAt = initParams.created_at;
      }
      set title(value) {
        console.error("Do not set objects this way");
      }
      setTitle(value) {
        return this.dataService.updateGaiaConversation(this.id, { title: value }, this);
      }
      get title() {
        return this._title;
      }
      set updatedAt(value) {
        console.error("Do not set objects this way");
      }
      setUpdatedAt(value) {
        return this.dataService.updateGaiaConversation(this.id, { updated_at: value }, this);
      }
      get updatedAt() {
        return this._updatedAt;
      }
      set createdAt(value) {
        console.error("Do not set objects this way");
      }
      setCreatedAt(value) {
        return this.dataService.updateGaiaConversation(this.id, { created_at: value }, this);
      }
      get createdAt() {
        return this._createdAt;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGaiaConversation(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGaiaConversation(this.id, this);
      }
    };
    exports2.default = GaiaConversation;
  }
});

// ../gridduck/dist/models/gaiaMessage.js
var require_gaiaMessage = __commonJS({
  "../gridduck/dist/models/gaiaMessage.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GaiaMessage = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gaiaMessage";
        this._role = initParams.role;
        this._content = initParams.content;
        this._conversationId = initParams.conversation_id;
        this._createdAt = initParams.created_at;
      }
      set role(value) {
        console.error("Do not set objects this way");
      }
      get role() {
        return this._role;
      }
      set content(value) {
        console.error("Do not set objects this way");
      }
      get content() {
        return this._content;
      }
      set conversationId(value) {
        console.error("Do not set objects this way");
      }
      get conversationId() {
        return this._conversationId;
      }
      set createdAt(value) {
        console.error("Do not set objects this way");
      }
      get createdAt() {
        return this._createdAt;
      }
    };
    exports2.default = GaiaMessage;
  }
});

// ../gridduck/dist/models/gateway.js
var require_gateway = __commonJS({
  "../gridduck/dist/models/gateway.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Gateway = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.site = null;
        this.objectTypeName = "gateway";
        this._virtualFrom = initParams.virtual_from;
        this._updateState = initParams.update_state;
        this._locationId = initParams.location_id;
        this._locationName = initParams.location_name;
        this._timezone = initParams.timezone;
        this._locationMetadata = initParams.location_metadata;
        this._targetVersion = initParams.target_version;
        this._name = initParams.name;
        this._scanning = initParams.scanning;
        this._status = initParams.status;
        this._physicalGatewayId = initParams.physical_gateway_id;
        this._ethernetMac = initParams.ethernet_mac;
        this._wlanMac = initParams.wlan_mac;
        this._lastContacted = initParams.last_contacted;
        this._siteId = initParams.site_id;
        this._siteName = initParams.site_name;
        this._connectionType = initParams.connection_type;
        this._powerSource = initParams.power_source;
        this._charge = initParams.charge;
        this._wifiNetwork = initParams.wifi_network;
        this._activeConnection = initParams.active_connection;
        this.__permission = initParams._permission;
        this._wifiStrength = initParams.wifi_strength;
        this._mobileStrength = initParams.mobile_strength;
        this._imsi = initParams.imsi;
        this._ipAddress = initParams.ip_address;
        this._serialNumber = initParams.serial_number;
        this._modelNumber = initParams.model_number;
        this._disconnected = initParams.disconnected;
        this._staging = initParams.staging;
        this._beta = initParams.beta;
        this._debugMode = initParams.debug_mode;
        this._enhancedLogging = initParams.enhanced_logging;
        this._zigbeeDisabled = initParams.zigbee_disabled;
        this._doReboot = initParams.do_reboot;
        this._doZigbeeReset = initParams.do_zigbee_reset;
        this._getTrustedList = initParams.get_trusted_list;
        this._installationCode = initParams.installation_code;
        this._version = initParams.version;
        this._updateSlot = initParams.update_slot;
        this._type = initParams.type;
        this._gatewayType = initParams.gateway_type;
        this._imei = initParams.imei;
        this._intermittent = initParams.intermittent;
        this._lowSignal = initParams.low_signal;
        this._fault = initParams.fault;
        this._anomaly = initParams.anomaly;
        this._modbusMessageRec = initParams.modbus_message_rec;
        this._modbusMessage = initParams.modbus_message;
        this._modbusParams = initParams.modbus_params;
        this._modbusSubscribe = initParams.modbus_subscribe;
        this._staticEthernetSettings = initParams.static_ethernet_settings;
      }
      set virtualFrom(value) {
        console.error("Do not set objects this way");
      }
      setVirtualFrom(value) {
        return this.dataService.updateGateway(this.id, { virtual_from: value }, this);
      }
      get virtualFrom() {
        return this._virtualFrom;
      }
      set updateState(value) {
        console.error("Do not set objects this way");
      }
      setUpdateState(value) {
        return this.dataService.updateGateway(this.id, { update_state: value }, this);
      }
      get updateState() {
        return this._updateState;
      }
      set locationId(value) {
        console.error("Do not set objects this way");
      }
      setLocationId(value) {
        return this.dataService.updateGateway(this.id, { location_id: value }, this);
      }
      get locationId() {
        return this._locationId;
      }
      set locationName(value) {
        console.error("Do not set objects this way");
      }
      setLocationName(value) {
        return this.dataService.updateGateway(this.id, { location_name: value }, this);
      }
      get locationName() {
        return this._locationName;
      }
      set timezone(value) {
        console.error("Do not set objects this way");
      }
      setTimezone(value) {
        return this.dataService.updateGateway(this.id, { timezone: value }, this);
      }
      get timezone() {
        return this._timezone;
      }
      set locationMetadata(value) {
        console.error("Do not set objects this way");
      }
      setLocationMetadata(value) {
        return this.dataService.updateGateway(this.id, { location_metadata: value }, this);
      }
      get locationMetadata() {
        return this._locationMetadata;
      }
      set targetVersion(value) {
        console.error("Do not set objects this way");
      }
      setTargetVersion(value) {
        return this.dataService.updateGateway(this.id, { target_version: value }, this);
      }
      get targetVersion() {
        return this._targetVersion;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateGateway(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set scanning(value) {
        console.error("Do not set objects this way");
      }
      setScanning(value) {
        return this.dataService.updateGateway(this.id, { scanning: value }, this);
      }
      get scanning() {
        return this._scanning;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateGateway(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set physicalGatewayId(value) {
        console.error("Do not set objects this way");
      }
      setPhysicalGatewayId(value) {
        return this.dataService.updateGateway(this.id, { physical_gateway_id: value }, this);
      }
      get physicalGatewayId() {
        return this._physicalGatewayId;
      }
      set ethernetMac(value) {
        console.error("Do not set objects this way");
      }
      setEthernetMac(value) {
        return this.dataService.updateGateway(this.id, { ethernet_mac: value }, this);
      }
      get ethernetMac() {
        return this._ethernetMac;
      }
      set wlanMac(value) {
        console.error("Do not set objects this way");
      }
      setWlanMac(value) {
        return this.dataService.updateGateway(this.id, { wlan_mac: value }, this);
      }
      get wlanMac() {
        return this._wlanMac;
      }
      set lastContacted(value) {
        console.error("Do not set objects this way");
      }
      setLastContacted(value) {
        return this.dataService.updateGateway(this.id, { last_contacted: value }, this);
      }
      get lastContacted() {
        return this._lastContacted;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateGateway(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      setSiteName(value) {
        return this.dataService.updateGateway(this.id, { site_name: value }, this);
      }
      get siteName() {
        return this._siteName;
      }
      set connectionType(value) {
        console.error("Do not set objects this way");
      }
      setConnectionType(value) {
        return this.dataService.updateGateway(this.id, { connection_type: value }, this);
      }
      get connectionType() {
        return this._connectionType;
      }
      set powerSource(value) {
        console.error("Do not set objects this way");
      }
      setPowerSource(value) {
        return this.dataService.updateGateway(this.id, { power_source: value }, this);
      }
      get powerSource() {
        return this._powerSource;
      }
      set charge(value) {
        console.error("Do not set objects this way");
      }
      setCharge(value) {
        return this.dataService.updateGateway(this.id, { charge: value }, this);
      }
      get charge() {
        return this._charge;
      }
      set wifiNetwork(value) {
        console.error("Do not set objects this way");
      }
      setWifiNetwork(value) {
        return this.dataService.updateGateway(this.id, { wifi_network: value }, this);
      }
      get wifiNetwork() {
        return this._wifiNetwork;
      }
      set activeConnection(value) {
        console.error("Do not set objects this way");
      }
      setActiveConnection(value) {
        return this.dataService.updateGateway(this.id, { active_connection: value }, this);
      }
      get activeConnection() {
        return this._activeConnection;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateGateway(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set wifiStrength(value) {
        console.error("Do not set objects this way");
      }
      setWifiStrength(value) {
        return this.dataService.updateGateway(this.id, { wifi_strength: value }, this);
      }
      get wifiStrength() {
        return this._wifiStrength;
      }
      set mobileStrength(value) {
        console.error("Do not set objects this way");
      }
      setMobileStrength(value) {
        return this.dataService.updateGateway(this.id, { mobile_strength: value }, this);
      }
      get mobileStrength() {
        return this._mobileStrength;
      }
      set imsi(value) {
        console.error("Do not set objects this way");
      }
      setImsi(value) {
        return this.dataService.updateGateway(this.id, { imsi: value }, this);
      }
      get imsi() {
        return this._imsi;
      }
      set ipAddress(value) {
        console.error("Do not set objects this way");
      }
      setIpAddress(value) {
        return this.dataService.updateGateway(this.id, { ip_address: value }, this);
      }
      get ipAddress() {
        return this._ipAddress;
      }
      set serialNumber(value) {
        console.error("Do not set objects this way");
      }
      setSerialNumber(value) {
        return this.dataService.updateGateway(this.id, { serial_number: value }, this);
      }
      get serialNumber() {
        return this._serialNumber;
      }
      set modelNumber(value) {
        console.error("Do not set objects this way");
      }
      setModelNumber(value) {
        return this.dataService.updateGateway(this.id, { model_number: value }, this);
      }
      get modelNumber() {
        return this._modelNumber;
      }
      set disconnected(value) {
        console.error("Do not set objects this way");
      }
      setDisconnected(value) {
        return this.dataService.updateGateway(this.id, { disconnected: value }, this);
      }
      get disconnected() {
        return this._disconnected;
      }
      set staging(value) {
        console.error("Do not set objects this way");
      }
      setStaging(value) {
        return this.dataService.updateGateway(this.id, { staging: value }, this);
      }
      get staging() {
        return this._staging;
      }
      set beta(value) {
        console.error("Do not set objects this way");
      }
      setBeta(value) {
        return this.dataService.updateGateway(this.id, { beta: value }, this);
      }
      get beta() {
        return this._beta;
      }
      set debugMode(value) {
        console.error("Do not set objects this way");
      }
      setDebugMode(value) {
        return this.dataService.updateGateway(this.id, { debug_mode: value }, this);
      }
      get debugMode() {
        return this._debugMode;
      }
      set enhancedLogging(value) {
        console.error("Do not set objects this way");
      }
      setEnhancedLogging(value) {
        return this.dataService.updateGateway(this.id, { enhanced_logging: value }, this);
      }
      get enhancedLogging() {
        return this._enhancedLogging;
      }
      set zigbeeDisabled(value) {
        console.error("Do not set objects this way");
      }
      setZigbeeDisabled(value) {
        return this.dataService.updateGateway(this.id, { zigbee_disabled: value }, this);
      }
      get zigbeeDisabled() {
        return this._zigbeeDisabled;
      }
      set doReboot(value) {
        console.error("Do not set objects this way");
      }
      setDoReboot(value) {
        return this.dataService.updateGateway(this.id, { do_reboot: value }, this);
      }
      get doReboot() {
        return this._doReboot;
      }
      set doZigbeeReset(value) {
        console.error("Do not set objects this way");
      }
      setDoZigbeeReset(value) {
        return this.dataService.updateGateway(this.id, { do_zigbee_reset: value }, this);
      }
      get doZigbeeReset() {
        return this._doZigbeeReset;
      }
      set getTrustedList(value) {
        console.error("Do not set objects this way");
      }
      setGetTrustedList(value) {
        return this.dataService.updateGateway(this.id, { get_trusted_list: value }, this);
      }
      get getTrustedList() {
        return this._getTrustedList;
      }
      set installationCode(value) {
        console.error("Do not set objects this way");
      }
      setInstallationCode(value) {
        return this.dataService.updateGateway(this.id, { installation_code: value }, this);
      }
      get installationCode() {
        return this._installationCode;
      }
      set version(value) {
        console.error("Do not set objects this way");
      }
      setVersion(value) {
        return this.dataService.updateGateway(this.id, { version: value }, this);
      }
      get version() {
        return this._version;
      }
      set updateSlot(value) {
        console.error("Do not set objects this way");
      }
      setUpdateSlot(value) {
        return this.dataService.updateGateway(this.id, { update_slot: value }, this);
      }
      get updateSlot() {
        return this._updateSlot;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      setType(value) {
        return this.dataService.updateGateway(this.id, { type: value }, this);
      }
      get type() {
        return this._type;
      }
      set gatewayType(value) {
        console.error("Do not set objects this way");
      }
      setGatewayType(value) {
        return this.dataService.updateGateway(this.id, { gateway_type: value }, this);
      }
      get gatewayType() {
        return this._gatewayType;
      }
      set imei(value) {
        console.error("Do not set objects this way");
      }
      setImei(value) {
        return this.dataService.updateGateway(this.id, { imei: value }, this);
      }
      get imei() {
        return this._imei;
      }
      set intermittent(value) {
        console.error("Do not set objects this way");
      }
      setIntermittent(value) {
        return this.dataService.updateGateway(this.id, { intermittent: value }, this);
      }
      get intermittent() {
        return this._intermittent;
      }
      set lowSignal(value) {
        console.error("Do not set objects this way");
      }
      setLowSignal(value) {
        return this.dataService.updateGateway(this.id, { low_signal: value }, this);
      }
      get lowSignal() {
        return this._lowSignal;
      }
      set fault(value) {
        console.error("Do not set objects this way");
      }
      setFault(value) {
        return this.dataService.updateGateway(this.id, { fault: value }, this);
      }
      get fault() {
        return this._fault;
      }
      set anomaly(value) {
        console.error("Do not set objects this way");
      }
      setAnomaly(value) {
        return this.dataService.updateGateway(this.id, { anomaly: value }, this);
      }
      get anomaly() {
        return this._anomaly;
      }
      set modbusMessageRec(value) {
        console.error("Do not set objects this way");
      }
      setModbusMessageRec(value) {
        return this.dataService.updateGateway(this.id, { modbus_message_rec: value }, this);
      }
      get modbusMessageRec() {
        return this._modbusMessageRec;
      }
      set modbusMessage(value) {
        console.error("Do not set objects this way");
      }
      setModbusMessage(value) {
        return this.dataService.updateGateway(this.id, { modbus_message: value }, this);
      }
      get modbusMessage() {
        return this._modbusMessage;
      }
      set modbusParams(value) {
        console.error("Do not set objects this way");
      }
      setModbusParams(value) {
        return this.dataService.updateGateway(this.id, { modbus_params: value }, this);
      }
      get modbusParams() {
        return this._modbusParams;
      }
      set modbusSubscribe(value) {
        console.error("Do not set objects this way");
      }
      setModbusSubscribe(value) {
        return this.dataService.updateGateway(this.id, { modbus_subscribe: value }, this);
      }
      get modbusSubscribe() {
        return this._modbusSubscribe;
      }
      set staticEthernetSettings(value) {
        console.error("Do not set objects this way");
      }
      setStaticEthernetSettings(value) {
        return this.dataService.updateGateway(this.id, { static_ethernet_settings: value }, this);
      }
      get staticEthernetSettings() {
        return this._staticEthernetSettings;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGateway(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGateway(this.id, this);
      }
    };
    exports2.default = Gateway;
  }
});

// ../gridduck/dist/models/gatewayEnhancedLogDownloadRequest.js
var require_gatewayEnhancedLogDownloadRequest = __commonJS({
  "../gridduck/dist/models/gatewayEnhancedLogDownloadRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayEnhancedLogDownloadRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayEnhancedLogDownloadRequest";
        this._gatewayId = initParams.gateway_id;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      get gatewayId() {
        return this._gatewayId;
      }
    };
    exports2.default = GatewayEnhancedLogDownloadRequest;
  }
});

// ../gridduck/dist/models/gatewayEvent.js
var require_gatewayEvent = __commonJS({
  "../gridduck/dist/models/gatewayEvent.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayEvent = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayEvent";
        this._gatewayId = initParams.gateway_id;
        this._type = initParams.type;
        this._event = initParams.event;
        this._state = initParams.state;
        this._time = initParams.time;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      get gatewayId() {
        return this._gatewayId;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
      set event(value) {
        console.error("Do not set objects this way");
      }
      get event() {
        return this._event;
      }
      set state(value) {
        console.error("Do not set objects this way");
      }
      get state() {
        return this._state;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = GatewayEvent;
  }
});

// ../gridduck/dist/models/gatewayGod.js
var require_gatewayGod = __commonJS({
  "../gridduck/dist/models/gatewayGod.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayGod = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.site = null;
        this.objectTypeName = "gatewayGod";
        this._owner = initParams.owner;
        this._updateState = initParams.update_state;
        this._targetVersion = initParams.target_version;
        this._name = initParams.name;
        this._scanning = initParams.scanning;
        this._status = initParams.status;
        this._physicalGatewayId = initParams.physical_gateway_id;
        this._ethernetMac = initParams.ethernet_mac;
        this._wlanMac = initParams.wlan_mac;
        this._lastContacted = initParams.last_contacted;
        this._siteId = initParams.site_id;
        this._siteName = initParams.site_name;
        this._connectionType = initParams.connection_type;
        this._powerSource = initParams.power_source;
        this._totalDevices = initParams.total_devices;
        this._connectedDevices = initParams.connected_devices;
        this._charge = initParams.charge;
        this._wifiNetwork = initParams.wifi_network;
        this._activeConnection = initParams.active_connection;
        this.__permission = initParams._permission;
        this._wifiStrength = initParams.wifi_strength;
        this._mobileStrength = initParams.mobile_strength;
        this._imsi = initParams.imsi;
        this._ipAddress = initParams.ip_address;
        this._serialNumber = initParams.serial_number;
        this._modelNumber = initParams.model_number;
        this._disconnected = initParams.disconnected;
        this._staging = initParams.staging;
        this._beta = initParams.beta;
        this._debugMode = initParams.debug_mode;
        this._enhancedLogging = initParams.enhanced_logging;
        this._zigbeeDisabled = initParams.zigbee_disabled;
        this._doReboot = initParams.do_reboot;
        this._doZigbeeReset = initParams.do_zigbee_reset;
        this._getTrustedList = initParams.get_trusted_list;
        this._installationCode = initParams.installation_code;
        this._version = initParams.version;
        this._updateSlot = initParams.update_slot;
        this._locationName = initParams.location_name;
      }
      set owner(value) {
        console.error("Do not set objects this way");
      }
      setOwner(value) {
        return this.dataService.updateGatewayGod(this.id, { owner: value }, this);
      }
      get owner() {
        return this._owner;
      }
      set updateState(value) {
        console.error("Do not set objects this way");
      }
      setUpdateState(value) {
        return this.dataService.updateGatewayGod(this.id, { update_state: value }, this);
      }
      get updateState() {
        return this._updateState;
      }
      set targetVersion(value) {
        console.error("Do not set objects this way");
      }
      setTargetVersion(value) {
        return this.dataService.updateGatewayGod(this.id, { target_version: value }, this);
      }
      get targetVersion() {
        return this._targetVersion;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateGatewayGod(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set scanning(value) {
        console.error("Do not set objects this way");
      }
      setScanning(value) {
        return this.dataService.updateGatewayGod(this.id, { scanning: value }, this);
      }
      get scanning() {
        return this._scanning;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateGatewayGod(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set physicalGatewayId(value) {
        console.error("Do not set objects this way");
      }
      setPhysicalGatewayId(value) {
        return this.dataService.updateGatewayGod(this.id, { physical_gateway_id: value }, this);
      }
      get physicalGatewayId() {
        return this._physicalGatewayId;
      }
      set ethernetMac(value) {
        console.error("Do not set objects this way");
      }
      setEthernetMac(value) {
        return this.dataService.updateGatewayGod(this.id, { ethernet_mac: value }, this);
      }
      get ethernetMac() {
        return this._ethernetMac;
      }
      set wlanMac(value) {
        console.error("Do not set objects this way");
      }
      setWlanMac(value) {
        return this.dataService.updateGatewayGod(this.id, { wlan_mac: value }, this);
      }
      get wlanMac() {
        return this._wlanMac;
      }
      set lastContacted(value) {
        console.error("Do not set objects this way");
      }
      setLastContacted(value) {
        return this.dataService.updateGatewayGod(this.id, { last_contacted: value }, this);
      }
      get lastContacted() {
        return this._lastContacted;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateGatewayGod(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      setSiteName(value) {
        return this.dataService.updateGatewayGod(this.id, { site_name: value }, this);
      }
      get siteName() {
        return this._siteName;
      }
      set connectionType(value) {
        console.error("Do not set objects this way");
      }
      setConnectionType(value) {
        return this.dataService.updateGatewayGod(this.id, { connection_type: value }, this);
      }
      get connectionType() {
        return this._connectionType;
      }
      set powerSource(value) {
        console.error("Do not set objects this way");
      }
      setPowerSource(value) {
        return this.dataService.updateGatewayGod(this.id, { power_source: value }, this);
      }
      get powerSource() {
        return this._powerSource;
      }
      set totalDevices(value) {
        console.error("Do not set objects this way");
      }
      setTotalDevices(value) {
        return this.dataService.updateGatewayGod(this.id, { total_devices: value }, this);
      }
      get totalDevices() {
        return this._totalDevices;
      }
      set connectedDevices(value) {
        console.error("Do not set objects this way");
      }
      setConnectedDevices(value) {
        return this.dataService.updateGatewayGod(this.id, { connected_devices: value }, this);
      }
      get connectedDevices() {
        return this._connectedDevices;
      }
      set charge(value) {
        console.error("Do not set objects this way");
      }
      setCharge(value) {
        return this.dataService.updateGatewayGod(this.id, { charge: value }, this);
      }
      get charge() {
        return this._charge;
      }
      set wifiNetwork(value) {
        console.error("Do not set objects this way");
      }
      setWifiNetwork(value) {
        return this.dataService.updateGatewayGod(this.id, { wifi_network: value }, this);
      }
      get wifiNetwork() {
        return this._wifiNetwork;
      }
      set activeConnection(value) {
        console.error("Do not set objects this way");
      }
      setActiveConnection(value) {
        return this.dataService.updateGatewayGod(this.id, { active_connection: value }, this);
      }
      get activeConnection() {
        return this._activeConnection;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateGatewayGod(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set wifiStrength(value) {
        console.error("Do not set objects this way");
      }
      setWifiStrength(value) {
        return this.dataService.updateGatewayGod(this.id, { wifi_strength: value }, this);
      }
      get wifiStrength() {
        return this._wifiStrength;
      }
      set mobileStrength(value) {
        console.error("Do not set objects this way");
      }
      setMobileStrength(value) {
        return this.dataService.updateGatewayGod(this.id, { mobile_strength: value }, this);
      }
      get mobileStrength() {
        return this._mobileStrength;
      }
      set imsi(value) {
        console.error("Do not set objects this way");
      }
      setImsi(value) {
        return this.dataService.updateGatewayGod(this.id, { imsi: value }, this);
      }
      get imsi() {
        return this._imsi;
      }
      set ipAddress(value) {
        console.error("Do not set objects this way");
      }
      setIpAddress(value) {
        return this.dataService.updateGatewayGod(this.id, { ip_address: value }, this);
      }
      get ipAddress() {
        return this._ipAddress;
      }
      set serialNumber(value) {
        console.error("Do not set objects this way");
      }
      setSerialNumber(value) {
        return this.dataService.updateGatewayGod(this.id, { serial_number: value }, this);
      }
      get serialNumber() {
        return this._serialNumber;
      }
      set modelNumber(value) {
        console.error("Do not set objects this way");
      }
      setModelNumber(value) {
        return this.dataService.updateGatewayGod(this.id, { model_number: value }, this);
      }
      get modelNumber() {
        return this._modelNumber;
      }
      set disconnected(value) {
        console.error("Do not set objects this way");
      }
      setDisconnected(value) {
        return this.dataService.updateGatewayGod(this.id, { disconnected: value }, this);
      }
      get disconnected() {
        return this._disconnected;
      }
      set staging(value) {
        console.error("Do not set objects this way");
      }
      setStaging(value) {
        return this.dataService.updateGatewayGod(this.id, { staging: value }, this);
      }
      get staging() {
        return this._staging;
      }
      set beta(value) {
        console.error("Do not set objects this way");
      }
      setBeta(value) {
        return this.dataService.updateGatewayGod(this.id, { beta: value }, this);
      }
      get beta() {
        return this._beta;
      }
      set debugMode(value) {
        console.error("Do not set objects this way");
      }
      setDebugMode(value) {
        return this.dataService.updateGatewayGod(this.id, { debug_mode: value }, this);
      }
      get debugMode() {
        return this._debugMode;
      }
      set enhancedLogging(value) {
        console.error("Do not set objects this way");
      }
      setEnhancedLogging(value) {
        return this.dataService.updateGatewayGod(this.id, { enhanced_logging: value }, this);
      }
      get enhancedLogging() {
        return this._enhancedLogging;
      }
      set zigbeeDisabled(value) {
        console.error("Do not set objects this way");
      }
      setZigbeeDisabled(value) {
        return this.dataService.updateGatewayGod(this.id, { zigbee_disabled: value }, this);
      }
      get zigbeeDisabled() {
        return this._zigbeeDisabled;
      }
      set doReboot(value) {
        console.error("Do not set objects this way");
      }
      setDoReboot(value) {
        return this.dataService.updateGatewayGod(this.id, { do_reboot: value }, this);
      }
      get doReboot() {
        return this._doReboot;
      }
      set doZigbeeReset(value) {
        console.error("Do not set objects this way");
      }
      setDoZigbeeReset(value) {
        return this.dataService.updateGatewayGod(this.id, { do_zigbee_reset: value }, this);
      }
      get doZigbeeReset() {
        return this._doZigbeeReset;
      }
      set getTrustedList(value) {
        console.error("Do not set objects this way");
      }
      setGetTrustedList(value) {
        return this.dataService.updateGatewayGod(this.id, { get_trusted_list: value }, this);
      }
      get getTrustedList() {
        return this._getTrustedList;
      }
      set installationCode(value) {
        console.error("Do not set objects this way");
      }
      setInstallationCode(value) {
        return this.dataService.updateGatewayGod(this.id, { installation_code: value }, this);
      }
      get installationCode() {
        return this._installationCode;
      }
      set version(value) {
        console.error("Do not set objects this way");
      }
      setVersion(value) {
        return this.dataService.updateGatewayGod(this.id, { version: value }, this);
      }
      get version() {
        return this._version;
      }
      set updateSlot(value) {
        console.error("Do not set objects this way");
      }
      setUpdateSlot(value) {
        return this.dataService.updateGatewayGod(this.id, { update_slot: value }, this);
      }
      get updateSlot() {
        return this._updateSlot;
      }
      set locationName(value) {
        console.error("Do not set objects this way");
      }
      setLocationName(value) {
        return this.dataService.updateGatewayGod(this.id, { location_name: value }, this);
      }
      get locationName() {
        return this._locationName;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGatewayGod(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGatewayGod(this.id, this);
      }
    };
    exports2.default = GatewayGod;
  }
});

// ../gridduck/dist/models/gatewayLogDownloadRequest.js
var require_gatewayLogDownloadRequest = __commonJS({
  "../gridduck/dist/models/gatewayLogDownloadRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayLogDownloadRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayLogDownloadRequest";
        this._gatewayId = initParams.gateway_id;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      get gatewayId() {
        return this._gatewayId;
      }
    };
    exports2.default = GatewayLogDownloadRequest;
  }
});

// ../gridduck/dist/models/gatewaySoftwareVersion.js
var require_gatewaySoftwareVersion = __commonJS({
  "../gridduck/dist/models/gatewaySoftwareVersion.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewaySoftwareVersion = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewaySoftwareVersion";
        this._versionString = initParams.version_string;
        this._notes = initParams.notes;
        this._released = initParams.released;
        this._archived = initParams.archived;
        this._rejected = initParams.rejected;
        this._target = initParams.target;
        this._title = initParams.title;
      }
      set versionString(value) {
        console.error("Do not set objects this way");
      }
      setVersionString(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { version_string: value }, this);
      }
      get versionString() {
        return this._versionString;
      }
      set notes(value) {
        console.error("Do not set objects this way");
      }
      setNotes(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { notes: value }, this);
      }
      get notes() {
        return this._notes;
      }
      set released(value) {
        console.error("Do not set objects this way");
      }
      setReleased(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { released: value }, this);
      }
      get released() {
        return this._released;
      }
      set archived(value) {
        console.error("Do not set objects this way");
      }
      setArchived(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { archived: value }, this);
      }
      get archived() {
        return this._archived;
      }
      set rejected(value) {
        console.error("Do not set objects this way");
      }
      setRejected(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { rejected: value }, this);
      }
      get rejected() {
        return this._rejected;
      }
      set target(value) {
        console.error("Do not set objects this way");
      }
      setTarget(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { target: value }, this);
      }
      get target() {
        return this._target;
      }
      set title(value) {
        console.error("Do not set objects this way");
      }
      setTitle(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { title: value }, this);
      }
      get title() {
        return this._title;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGatewaySoftwareVersion(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = GatewaySoftwareVersion;
  }
});

// ../gridduck/dist/models/gatewayTrustList.js
var require_gatewayTrustList = __commonJS({
  "../gridduck/dist/models/gatewayTrustList.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayTrustList = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayTrustList";
        this._trustList = (0, util_1.camelArray)(initParams.trust_list);
      }
      set trustList(value) {
        console.error("Do not set objects this way");
      }
      get trustList() {
        return this._trustList;
      }
    };
    exports2.default = GatewayTrustList;
  }
});

// ../gridduck/dist/models/gatewayTrustedDeviceAnalysis.js
var require_gatewayTrustedDeviceAnalysis = __commonJS({
  "../gridduck/dist/models/gatewayTrustedDeviceAnalysis.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayTrustedDeviceAnalysis = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayTrustedDeviceAnalysis";
        this._sku = initParams.sku;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      setSku(value) {
        return this.dataService.updateGatewayTrustedDeviceAnalysis(this.id, { sku: value }, this);
      }
      get sku() {
        return this._sku;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGatewayTrustedDeviceAnalysis(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGatewayTrustedDeviceAnalysis(this.id, this);
      }
    };
    exports2.default = GatewayTrustedDeviceAnalysis;
  }
});

// ../gridduck/dist/models/gatewayTrustedDeviceUntrustRequest.js
var require_gatewayTrustedDeviceUntrustRequest = __commonJS({
  "../gridduck/dist/models/gatewayTrustedDeviceUntrustRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GatewayTrustedDeviceUntrustRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gatewayTrustedDeviceUntrustRequest";
        this._assetCode = initParams.asset_code;
        this._gatewayId = initParams.gateway_id;
      }
      set assetCode(value) {
        console.error("Do not set objects this way");
      }
      get assetCode() {
        return this._assetCode;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      get gatewayId() {
        return this._gatewayId;
      }
    };
    exports2.default = GatewayTrustedDeviceUntrustRequest;
  }
});

// ../gridduck/dist/models/getPhaseBreakdown.js
var require_getPhaseBreakdown = __commonJS({
  "../gridduck/dist/models/getPhaseBreakdown.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var GetPhaseBreakdown = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "getPhaseBreakdown";
        this._assetId = initParams.asset_id;
      }
      set assetId(value) {
        console.error("Do not set objects this way");
      }
      get assetId() {
        return this._assetId;
      }
    };
    exports2.default = GetPhaseBreakdown;
  }
});

// ../gridduck/dist/models/gridduckInvoice.js
var require_gridduckInvoice = __commonJS({
  "../gridduck/dist/models/gridduckInvoice.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GridduckInvoice = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gridduckInvoice";
        this._total = initParams.total;
        this._totalDiscountAmounts = (0, util_1.camelArray)(initParams.total_discount_amounts);
        this._description = initParams.description;
        this._status = initParams.status;
        this._number = initParams.number;
        this._created = initParams.created;
        this._hostedInvoiceUrl = initParams.hosted_invoice_url;
      }
      set total(value) {
        console.error("Do not set objects this way");
      }
      get total() {
        return this._total;
      }
      set totalDiscountAmounts(value) {
        console.error("Do not set objects this way");
      }
      get totalDiscountAmounts() {
        return this._totalDiscountAmounts;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      get description() {
        return this._description;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set number(value) {
        console.error("Do not set objects this way");
      }
      get number() {
        return this._number;
      }
      set created(value) {
        console.error("Do not set objects this way");
      }
      get created() {
        return this._created;
      }
      set hostedInvoiceUrl(value) {
        console.error("Do not set objects this way");
      }
      get hostedInvoiceUrl() {
        return this._hostedInvoiceUrl;
      }
    };
    exports2.default = GridduckInvoice;
  }
});

// ../gridduck/dist/models/gridduckSubscription.js
var require_gridduckSubscription = __commonJS({
  "../gridduck/dist/models/gridduckSubscription.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GridduckSubscription = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "gridduckSubscription";
        this._billingCycleAnchor = initParams.billing_cycle_anchor;
        this._items = (0, util_1.camelArray)(initParams.items);
      }
      set billingCycleAnchor(value) {
        console.error("Do not set objects this way");
      }
      get billingCycleAnchor() {
        return this._billingCycleAnchor;
      }
      set items(value) {
        console.error("Do not set objects this way");
      }
      get items() {
        return this._items;
      }
    };
    exports2.default = GridduckSubscription;
  }
});

// ../gridduck/dist/models/group.js
var require_group = __commonJS({
  "../gridduck/dist/models/group.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Group = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "group";
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._name = initParams.name;
        this._widgetBoardId = initParams.widget_board_id;
        this._groupTypeId = initParams.group_type_id;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._parentIds = (0, util_1.camelArray)(initParams.parent_ids);
        this.__permission = initParams._permission;
      }
      set dataTypes(value) {
        console.error("Do not set objects this way");
      }
      setDataTypes(value) {
        return this.dataService.updateGroup(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
      }
      get dataTypes() {
        return this._dataTypes;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateGroup(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set widgetBoardId(value) {
        console.error("Do not set objects this way");
      }
      setWidgetBoardId(value) {
        return this.dataService.updateGroup(this.id, { widget_board_id: value }, this);
      }
      get widgetBoardId() {
        return this._widgetBoardId;
      }
      set groupTypeId(value) {
        console.error("Do not set objects this way");
      }
      setGroupTypeId(value) {
        return this.dataService.updateGroup(this.id, { group_type_id: value }, this);
      }
      get groupTypeId() {
        return this._groupTypeId;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      setAssetIds(value) {
        return this.dataService.updateGroup(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get assetIds() {
        return this._assetIds;
      }
      set parentIds(value) {
        console.error("Do not set objects this way");
      }
      setParentIds(value) {
        return this.dataService.updateGroup(this.id, { parent_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get parentIds() {
        return this._parentIds;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateGroup(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGroup(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGroup(this.id, this);
      }
    };
    exports2.default = Group;
  }
});

// ../gridduck/dist/models/groupType.js
var require_groupType = __commonJS({
  "../gridduck/dist/models/groupType.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var GroupType = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "groupType";
        this._name = initParams.name;
        this._icon = initParams.icon;
        this._color = initParams.color;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateGroupType(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set icon(value) {
        console.error("Do not set objects this way");
      }
      setIcon(value) {
        return this.dataService.updateGroupType(this.id, { icon: value }, this);
      }
      get icon() {
        return this._icon;
      }
      set color(value) {
        console.error("Do not set objects this way");
      }
      setColor(value) {
        return this.dataService.updateGroupType(this.id, { color: value }, this);
      }
      get color() {
        return this._color;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateGroupType(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteGroupType(this.id, this);
      }
    };
    exports2.default = GroupType;
  }
});

// ../gridduck/dist/models/ignoredDevice.js
var require_ignoredDevice = __commonJS({
  "../gridduck/dist/models/ignoredDevice.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var IgnoredDevice = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "ignoredDevice";
        this._type = initParams.type;
        this._name = initParams.name;
        this._siteName = initParams.site_name;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      get siteName() {
        return this._siteName;
      }
    };
    exports2.default = IgnoredDevice;
  }
});

// ../gridduck/dist/models/inspiredLogin.js
var require_inspiredLogin = __commonJS({
  "../gridduck/dist/models/inspiredLogin.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var InspiredLogin = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "inspiredLogin";
        this._username = initParams.username;
        this._user = initParams.user;
        this._token = initParams.token;
        this._mfaRequired = initParams.mfa_required;
        this._expires = initParams.expires;
        this._scope = (0, util_1.camelArray)(initParams.scope);
        this._tokenType = initParams.token_type;
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      get username() {
        return this._username;
      }
      set user(value) {
        console.error("Do not set objects this way");
      }
      get user() {
        return this._user;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      get token() {
        return this._token;
      }
      set mfaRequired(value) {
        console.error("Do not set objects this way");
      }
      get mfaRequired() {
        return this._mfaRequired;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
      set scope(value) {
        console.error("Do not set objects this way");
      }
      get scope() {
        return this._scope;
      }
      set tokenType(value) {
        console.error("Do not set objects this way");
      }
      get tokenType() {
        return this._tokenType;
      }
    };
    exports2.default = InspiredLogin;
  }
});

// ../gridduck/dist/models/instantaneousTelemetry.js
var require_instantaneousTelemetry = __commonJS({
  "../gridduck/dist/models/instantaneousTelemetry.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var InstantaneousTelemetry = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "assetTelemetry";
        this.isListening = true;
        this._value = initParams.value;
        this._time = initParams.time;
      }
      set value(value) {
        console.error("Do not set objects this way");
      }
      get value() {
        return this._value;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = InstantaneousTelemetry;
  }
});

// ../gridduck/dist/models/invoiceRequest.js
var require_invoiceRequest = __commonJS({
  "../gridduck/dist/models/invoiceRequest.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var InvoiceRequest = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "invoiceRequest";
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._vat = initParams.vat;
        this._memo = initParams.memo;
        this._dueDate = initParams.due_date;
        this._pdfPer = initParams.pdf_per;
        this._startDate = initParams.start_date;
        this._endDate = initParams.end_date;
        this._status = initParams.status;
        this._size = initParams.size;
        this._customerEmail = initParams.customer_email;
        this._customerName = initParams.customer_name;
        this._includeBranding = initParams.include_branding;
        this._invoiceNo = initParams.invoice_no;
        this._vatId = initParams.vat_id;
        this._issuingOrgEmail = initParams.issuing_org_email;
        this._issuingOrgName = initParams.issuing_org_name;
        this._issuingOrgPhoneNumber = initParams.issuing_org_phone_number;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      get assetIds() {
        return this._assetIds;
      }
      set vat(value) {
        console.error("Do not set objects this way");
      }
      get vat() {
        return this._vat;
      }
      set memo(value) {
        console.error("Do not set objects this way");
      }
      get memo() {
        return this._memo;
      }
      set dueDate(value) {
        console.error("Do not set objects this way");
      }
      get dueDate() {
        return this._dueDate;
      }
      set pdfPer(value) {
        console.error("Do not set objects this way");
      }
      get pdfPer() {
        return this._pdfPer;
      }
      set startDate(value) {
        console.error("Do not set objects this way");
      }
      get startDate() {
        return this._startDate;
      }
      set endDate(value) {
        console.error("Do not set objects this way");
      }
      get endDate() {
        return this._endDate;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set size(value) {
        console.error("Do not set objects this way");
      }
      get size() {
        return this._size;
      }
      set customerEmail(value) {
        console.error("Do not set objects this way");
      }
      get customerEmail() {
        return this._customerEmail;
      }
      set customerName(value) {
        console.error("Do not set objects this way");
      }
      get customerName() {
        return this._customerName;
      }
      set includeBranding(value) {
        console.error("Do not set objects this way");
      }
      get includeBranding() {
        return this._includeBranding;
      }
      set invoiceNo(value) {
        console.error("Do not set objects this way");
      }
      get invoiceNo() {
        return this._invoiceNo;
      }
      set vatId(value) {
        console.error("Do not set objects this way");
      }
      get vatId() {
        return this._vatId;
      }
      set issuingOrgEmail(value) {
        console.error("Do not set objects this way");
      }
      get issuingOrgEmail() {
        return this._issuingOrgEmail;
      }
      set issuingOrgName(value) {
        console.error("Do not set objects this way");
      }
      get issuingOrgName() {
        return this._issuingOrgName;
      }
      set issuingOrgPhoneNumber(value) {
        console.error("Do not set objects this way");
      }
      get issuingOrgPhoneNumber() {
        return this._issuingOrgPhoneNumber;
      }
      delete() {
        return this.dataService.deleteInvoiceRequest(this.id, this);
      }
    };
    exports2.default = InvoiceRequest;
  }
});

// ../gridduck/dist/models/invoiceRequestLink.js
var require_invoiceRequestLink = __commonJS({
  "../gridduck/dist/models/invoiceRequestLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var InvoiceRequestLink = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "invoiceRequestLink";
        this._invoiceRequestId = initParams.invoice_request_id;
        this._expiresTime = initParams.expires_time;
        this._url = initParams.url;
        this._expires = initParams.expires;
      }
      set invoiceRequestId(value) {
        console.error("Do not set objects this way");
      }
      get invoiceRequestId() {
        return this._invoiceRequestId;
      }
      set expiresTime(value) {
        console.error("Do not set objects this way");
      }
      get expiresTime() {
        return this._expiresTime;
      }
      set url(value) {
        console.error("Do not set objects this way");
      }
      get url() {
        return this._url;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
    };
    exports2.default = InvoiceRequestLink;
  }
});

// ../gridduck/dist/models/issue.js
var require_issue = __commonJS({
  "../gridduck/dist/models/issue.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var Issue = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "issue";
        this._gatewayId = initParams.gateway_id;
        this._siteId = initParams.site_id;
        this._assetName = initParams.asset_name;
        this._gatewayName = initParams.gateway_name;
        this._siteName = initParams.site_name;
        this._name = initParams.name;
        this._assetDisconnected = initParams.asset_disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._assetDisconnectedTs = initParams.asset_disconnected_ts;
        this._gatewayDisconnectedTs = initParams.gateway_disconnected_ts;
        this._assetIntermittent = initParams.asset_intermittent;
        this._gatewayIntermittent = initParams.gateway_intermittent;
        this._assetLowSignal = initParams.asset_low_signal;
        this._gatewayLowSignal = initParams.gateway_low_signal;
        this._assetLowBattery = initParams.asset_low_battery;
        this._assetFault = initParams.asset_fault;
        this._gatewayFault = initParams.gateway_fault;
        this._assetAnomaly = initParams.asset_anomaly;
      }
      set gatewayId(value) {
        console.error("Do not set objects this way");
      }
      get gatewayId() {
        return this._gatewayId;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set assetName(value) {
        console.error("Do not set objects this way");
      }
      get assetName() {
        return this._assetName;
      }
      set gatewayName(value) {
        console.error("Do not set objects this way");
      }
      get gatewayName() {
        return this._gatewayName;
      }
      set siteName(value) {
        console.error("Do not set objects this way");
      }
      get siteName() {
        return this._siteName;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set assetDisconnected(value) {
        console.error("Do not set objects this way");
      }
      get assetDisconnected() {
        return this._assetDisconnected;
      }
      set gatewayDisconnected(value) {
        console.error("Do not set objects this way");
      }
      get gatewayDisconnected() {
        return this._gatewayDisconnected;
      }
      set assetDisconnectedTs(value) {
        console.error("Do not set objects this way");
      }
      get assetDisconnectedTs() {
        return this._assetDisconnectedTs;
      }
      set gatewayDisconnectedTs(value) {
        console.error("Do not set objects this way");
      }
      get gatewayDisconnectedTs() {
        return this._gatewayDisconnectedTs;
      }
      set assetIntermittent(value) {
        console.error("Do not set objects this way");
      }
      get assetIntermittent() {
        return this._assetIntermittent;
      }
      set gatewayIntermittent(value) {
        console.error("Do not set objects this way");
      }
      get gatewayIntermittent() {
        return this._gatewayIntermittent;
      }
      set assetLowSignal(value) {
        console.error("Do not set objects this way");
      }
      get assetLowSignal() {
        return this._assetLowSignal;
      }
      set gatewayLowSignal(value) {
        console.error("Do not set objects this way");
      }
      get gatewayLowSignal() {
        return this._gatewayLowSignal;
      }
      set assetLowBattery(value) {
        console.error("Do not set objects this way");
      }
      get assetLowBattery() {
        return this._assetLowBattery;
      }
      set assetFault(value) {
        console.error("Do not set objects this way");
      }
      get assetFault() {
        return this._assetFault;
      }
      set gatewayFault(value) {
        console.error("Do not set objects this way");
      }
      get gatewayFault() {
        return this._gatewayFault;
      }
      set assetAnomaly(value) {
        console.error("Do not set objects this way");
      }
      get assetAnomaly() {
        return this._assetAnomaly;
      }
    };
    exports2.default = Issue;
  }
});

// ../gridduck/dist/models/itemMetadata.js
var require_itemMetadata = __commonJS({
  "../gridduck/dist/models/itemMetadata.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ItemMetadata = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "itemMetadata";
        this._itemType = initParams.item_type;
        this._totalIssueCount = initParams.total_issue_count;
        this._deviceCount = initParams.device_count;
        this._deviceDisconnectedCount = initParams.device_disconnected_count;
        this._deviceIntermittentCount = initParams.device_intermittent_count;
        this._deviceLowSignalCount = initParams.device_low_signal_count;
        this._hubCount = initParams.hub_count;
        this._hubDisconnectedCount = initParams.hub_disconnected_count;
        this._hubIntermittentCount = initParams.hub_intermittent_count;
        this._hubLowSignalCount = initParams.hub_low_signal_count;
        this._sitesCount = initParams.sites_count;
      }
      set itemType(value) {
        console.error("Do not set objects this way");
      }
      get itemType() {
        return this._itemType;
      }
      set totalIssueCount(value) {
        console.error("Do not set objects this way");
      }
      get totalIssueCount() {
        return this._totalIssueCount;
      }
      set deviceCount(value) {
        console.error("Do not set objects this way");
      }
      get deviceCount() {
        return this._deviceCount;
      }
      set deviceDisconnectedCount(value) {
        console.error("Do not set objects this way");
      }
      get deviceDisconnectedCount() {
        return this._deviceDisconnectedCount;
      }
      set deviceIntermittentCount(value) {
        console.error("Do not set objects this way");
      }
      get deviceIntermittentCount() {
        return this._deviceIntermittentCount;
      }
      set deviceLowSignalCount(value) {
        console.error("Do not set objects this way");
      }
      get deviceLowSignalCount() {
        return this._deviceLowSignalCount;
      }
      set hubCount(value) {
        console.error("Do not set objects this way");
      }
      get hubCount() {
        return this._hubCount;
      }
      set hubDisconnectedCount(value) {
        console.error("Do not set objects this way");
      }
      get hubDisconnectedCount() {
        return this._hubDisconnectedCount;
      }
      set hubIntermittentCount(value) {
        console.error("Do not set objects this way");
      }
      get hubIntermittentCount() {
        return this._hubIntermittentCount;
      }
      set hubLowSignalCount(value) {
        console.error("Do not set objects this way");
      }
      get hubLowSignalCount() {
        return this._hubLowSignalCount;
      }
      set sitesCount(value) {
        console.error("Do not set objects this way");
      }
      get sitesCount() {
        return this._sitesCount;
      }
    };
    exports2.default = ItemMetadata;
  }
});

// ../gridduck/dist/models/location.js
var require_location = __commonJS({
  "../gridduck/dist/models/location.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Location = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "location";
        this._name = initParams.name;
        this._lat = initParams.lat;
        this._timezone = initParams.timezone;
        this._lng = initParams.lng;
        this._metadata = initParams.metadata;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateLocation(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set lat(value) {
        console.error("Do not set objects this way");
      }
      setLat(value) {
        return this.dataService.updateLocation(this.id, { lat: value }, this);
      }
      get lat() {
        return this._lat;
      }
      set timezone(value) {
        console.error("Do not set objects this way");
      }
      setTimezone(value) {
        return this.dataService.updateLocation(this.id, { timezone: value }, this);
      }
      get timezone() {
        return this._timezone;
      }
      set lng(value) {
        console.error("Do not set objects this way");
      }
      setLng(value) {
        return this.dataService.updateLocation(this.id, { lng: value }, this);
      }
      get lng() {
        return this._lng;
      }
      set metadata(value) {
        console.error("Do not set objects this way");
      }
      setMetadata(value) {
        return this.dataService.updateLocation(this.id, { metadata: value }, this);
      }
      get metadata() {
        return this._metadata;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateLocation(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateLocation(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteLocation(this.id, this);
      }
    };
    exports2.default = Location;
  }
});

// ../gridduck/dist/models/loginAs.js
var require_loginAs = __commonJS({
  "../gridduck/dist/models/loginAs.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var LoginAs = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "loginAs";
        this._username = initParams.username;
        this._user = initParams.user;
        this._token = initParams.token;
        this._mfaRequired = initParams.mfa_required;
        this._expires = initParams.expires;
        this._scope = (0, util_1.camelArray)(initParams.scope);
        this._tokenType = initParams.token_type;
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      get username() {
        return this._username;
      }
      set user(value) {
        console.error("Do not set objects this way");
      }
      get user() {
        return this._user;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      get token() {
        return this._token;
      }
      set mfaRequired(value) {
        console.error("Do not set objects this way");
      }
      get mfaRequired() {
        return this._mfaRequired;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
      set scope(value) {
        console.error("Do not set objects this way");
      }
      get scope() {
        return this._scope;
      }
      set tokenType(value) {
        console.error("Do not set objects this way");
      }
      get tokenType() {
        return this._tokenType;
      }
    };
    exports2.default = LoginAs;
  }
});

// ../gridduck/dist/models/loginAsPartner.js
var require_loginAsPartner = __commonJS({
  "../gridduck/dist/models/loginAsPartner.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var LoginAsPartner = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "loginAsPartner";
        this._username = initParams.username;
        this._user = initParams.user;
        this._token = initParams.token;
        this._mfaRequired = initParams.mfa_required;
        this._expires = initParams.expires;
        this._scope = (0, util_1.camelArray)(initParams.scope);
        this._tokenType = initParams.token_type;
        this._partnerOverride = initParams.partner_override;
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      get username() {
        return this._username;
      }
      set user(value) {
        console.error("Do not set objects this way");
      }
      get user() {
        return this._user;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      get token() {
        return this._token;
      }
      set mfaRequired(value) {
        console.error("Do not set objects this way");
      }
      get mfaRequired() {
        return this._mfaRequired;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
      set scope(value) {
        console.error("Do not set objects this way");
      }
      get scope() {
        return this._scope;
      }
      set tokenType(value) {
        console.error("Do not set objects this way");
      }
      get tokenType() {
        return this._tokenType;
      }
      set partnerOverride(value) {
        console.error("Do not set objects this way");
      }
      get partnerOverride() {
        return this._partnerOverride;
      }
    };
    exports2.default = LoginAsPartner;
  }
});

// ../gridduck/dist/models/mfaAuthentication.js
var require_mfaAuthentication = __commonJS({
  "../gridduck/dist/models/mfaAuthentication.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var MfaAuthentication = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "mfaAuthentication";
        this._token = initParams.token;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      get token() {
        return this._token;
      }
    };
    exports2.default = MfaAuthentication;
  }
});

// ../gridduck/dist/models/mfaSecret.js
var require_mfaSecret = __commonJS({
  "../gridduck/dist/models/mfaSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var MfaSecret = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "mfaSecret";
        this._secretUrl = initParams.secret_url;
      }
      set secretUrl(value) {
        console.error("Do not set objects this way");
      }
      get secretUrl() {
        return this._secretUrl;
      }
    };
    exports2.default = MfaSecret;
  }
});

// ../gridduck/dist/models/mfaVerification.js
var require_mfaVerification = __commonJS({
  "../gridduck/dist/models/mfaVerification.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var MfaVerification = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "mfaVerification";
        this._token = initParams.token;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      get token() {
        return this._token;
      }
    };
    exports2.default = MfaVerification;
  }
});

// ../gridduck/dist/models/modbusModel.js
var require_modbusModel = __commonJS({
  "../gridduck/dist/models/modbusModel.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var ModbusModel = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "modbusModel";
        this._displayName = initParams.display_name;
        this._modbusDeviceType = initParams.modbus_device_type;
        this._modbusManufacturerName = initParams.modbus_manufacturer_name;
        this._modbusProductName = initParams.modbus_product_name;
        this._sku = initParams.sku;
        this._manufacturerSku = initParams.manufacturer_sku;
        this._displayImage = initParams.display_image;
        this._parity = initParams.parity;
        this._baudRate = initParams.baud_rate;
        this._stopBits = initParams.stop_bits;
        this._dataBits = initParams.data_bits;
        this._rxTimeout = initParams.rx_timeout;
        this._registers = (0, util_1.camelArray)(initParams.registers);
        this._readOnly = initParams.read_only;
        this._organisationId = initParams.organisation_id;
        this._global = initParams.global;
        this.__permission = initParams._permission;
      }
      set displayName(value) {
        console.error("Do not set objects this way");
      }
      setDisplayName(value) {
        return this.dataService.updateModbusModel(this.id, { display_name: value }, this);
      }
      get displayName() {
        return this._displayName;
      }
      set modbusDeviceType(value) {
        console.error("Do not set objects this way");
      }
      setModbusDeviceType(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_device_type: value }, this);
      }
      get modbusDeviceType() {
        return this._modbusDeviceType;
      }
      set modbusManufacturerName(value) {
        console.error("Do not set objects this way");
      }
      setModbusManufacturerName(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_manufacturer_name: value }, this);
      }
      get modbusManufacturerName() {
        return this._modbusManufacturerName;
      }
      set modbusProductName(value) {
        console.error("Do not set objects this way");
      }
      setModbusProductName(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_product_name: value }, this);
      }
      get modbusProductName() {
        return this._modbusProductName;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      setSku(value) {
        return this.dataService.updateModbusModel(this.id, { sku: value }, this);
      }
      get sku() {
        return this._sku;
      }
      set manufacturerSku(value) {
        console.error("Do not set objects this way");
      }
      setManufacturerSku(value) {
        return this.dataService.updateModbusModel(this.id, { manufacturer_sku: value }, this);
      }
      get manufacturerSku() {
        return this._manufacturerSku;
      }
      set displayImage(value) {
        console.error("Do not set objects this way");
      }
      setDisplayImage(value) {
        return this.dataService.updateModbusModel(this.id, { display_image: value }, this);
      }
      get displayImage() {
        return this._displayImage;
      }
      set parity(value) {
        console.error("Do not set objects this way");
      }
      setParity(value) {
        return this.dataService.updateModbusModel(this.id, { parity: value }, this);
      }
      get parity() {
        return this._parity;
      }
      set baudRate(value) {
        console.error("Do not set objects this way");
      }
      setBaudRate(value) {
        return this.dataService.updateModbusModel(this.id, { baud_rate: value }, this);
      }
      get baudRate() {
        return this._baudRate;
      }
      set stopBits(value) {
        console.error("Do not set objects this way");
      }
      setStopBits(value) {
        return this.dataService.updateModbusModel(this.id, { stop_bits: value }, this);
      }
      get stopBits() {
        return this._stopBits;
      }
      set dataBits(value) {
        console.error("Do not set objects this way");
      }
      setDataBits(value) {
        return this.dataService.updateModbusModel(this.id, { data_bits: value }, this);
      }
      get dataBits() {
        return this._dataBits;
      }
      set rxTimeout(value) {
        console.error("Do not set objects this way");
      }
      setRxTimeout(value) {
        return this.dataService.updateModbusModel(this.id, { rx_timeout: value }, this);
      }
      get rxTimeout() {
        return this._rxTimeout;
      }
      set registers(value) {
        console.error("Do not set objects this way");
      }
      setRegisters(value) {
        return this.dataService.updateModbusModel(this.id, { registers: (0, util_1.snakeArray)(value) }, this);
      }
      get registers() {
        return this._registers;
      }
      set readOnly(value) {
        console.error("Do not set objects this way");
      }
      setReadOnly(value) {
        return this.dataService.updateModbusModel(this.id, { read_only: value }, this);
      }
      get readOnly() {
        return this._readOnly;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateModbusModel(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set global(value) {
        console.error("Do not set objects this way");
      }
      setGlobal(value) {
        return this.dataService.updateModbusModel(this.id, { global: value }, this);
      }
      get global() {
        return this._global;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateModbusModel(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateModbusModel(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteModbusModel(this.id, this);
      }
    };
    exports2.default = ModbusModel;
  }
});

// ../gridduck/dist/models/notification.js
var require_notification = __commonJS({
  "../gridduck/dist/models/notification.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Notification = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "notification";
        this._org_id = initParams.org_id;
        this._seen = initParams.seen;
        this._created = initParams.created;
        this._category = initParams.category;
        this._objectType = initParams.object_type;
        this._type = initParams.type;
        this._objectId = initParams.object_id;
        this._metadata = initParams.metadata;
        this._message = initParams.message;
        this._description = initParams.description;
      }
      set org_id(value) {
        console.error("Do not set objects this way");
      }
      setOrg_id(value) {
        return this.dataService.updateNotification(this.id, { org_id: value }, this);
      }
      get org_id() {
        return this._org_id;
      }
      set seen(value) {
        console.error("Do not set objects this way");
      }
      setSeen(value) {
        return this.dataService.updateNotification(this.id, { seen: value }, this);
      }
      get seen() {
        return this._seen;
      }
      set created(value) {
        console.error("Do not set objects this way");
      }
      setCreated(value) {
        return this.dataService.updateNotification(this.id, { created: value }, this);
      }
      get created() {
        return this._created;
      }
      set category(value) {
        console.error("Do not set objects this way");
      }
      setCategory(value) {
        return this.dataService.updateNotification(this.id, { category: value }, this);
      }
      get category() {
        return this._category;
      }
      set objectType(value) {
        console.error("Do not set objects this way");
      }
      setObjectType(value) {
        return this.dataService.updateNotification(this.id, { object_type: value }, this);
      }
      get objectType() {
        return this._objectType;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      setType(value) {
        return this.dataService.updateNotification(this.id, { type: value }, this);
      }
      get type() {
        return this._type;
      }
      set objectId(value) {
        console.error("Do not set objects this way");
      }
      setObjectId(value) {
        return this.dataService.updateNotification(this.id, { object_id: value }, this);
      }
      get objectId() {
        return this._objectId;
      }
      set metadata(value) {
        console.error("Do not set objects this way");
      }
      setMetadata(value) {
        return this.dataService.updateNotification(this.id, { metadata: value }, this);
      }
      get metadata() {
        return this._metadata;
      }
      set message(value) {
        console.error("Do not set objects this way");
      }
      setMessage(value) {
        return this.dataService.updateNotification(this.id, { message: value }, this);
      }
      get message() {
        return this._message;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      setDescription(value) {
        return this.dataService.updateNotification(this.id, { description: value }, this);
      }
      get description() {
        return this._description;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateNotification(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = Notification;
  }
});

// ../gridduck/dist/models/occupancySchedule.js
var require_occupancySchedule = __commonJS({
  "../gridduck/dist/models/occupancySchedule.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var OccupancySchedule = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "occupancySchedule";
        this._name = initParams.name;
        this._schedule = initParams.schedule;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateOccupancySchedule(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set schedule(value) {
        console.error("Do not set objects this way");
      }
      setSchedule(value) {
        return this.dataService.updateOccupancySchedule(this.id, { schedule: value }, this);
      }
      get schedule() {
        return this._schedule;
      }
      set siteIds(value) {
        console.error("Do not set objects this way");
      }
      setSiteIds(value) {
        return this.dataService.updateOccupancySchedule(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get siteIds() {
        return this._siteIds;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateOccupancySchedule(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOccupancySchedule(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteOccupancySchedule(this.id, this);
      }
    };
    exports2.default = OccupancySchedule;
  }
});

// ../gridduck/dist/models/order.js
var require_order = __commonJS({
  "../gridduck/dist/models/order.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Order = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "order";
        this._vat = initParams.vat;
        this._discount = initParams.discount;
        this._shippingCost = initParams.shipping_cost;
        this._orgId = initParams.org_id;
        this._physicalItems = (0, util_1.camelArray)(initParams.physical_items);
        this._subscriptionItems = (0, util_1.camelArray)(initParams.subscription_items);
        this._sessionId = initParams.session_id;
      }
      set vat(value) {
        console.error("Do not set objects this way");
      }
      get vat() {
        return this._vat;
      }
      set discount(value) {
        console.error("Do not set objects this way");
      }
      get discount() {
        return this._discount;
      }
      set shippingCost(value) {
        console.error("Do not set objects this way");
      }
      get shippingCost() {
        return this._shippingCost;
      }
      set orgId(value) {
        console.error("Do not set objects this way");
      }
      get orgId() {
        return this._orgId;
      }
      set physicalItems(value) {
        console.error("Do not set objects this way");
      }
      get physicalItems() {
        return this._physicalItems;
      }
      set subscriptionItems(value) {
        console.error("Do not set objects this way");
      }
      get subscriptionItems() {
        return this._subscriptionItems;
      }
      set sessionId(value) {
        console.error("Do not set objects this way");
      }
      get sessionId() {
        return this._sessionId;
      }
    };
    exports2.default = Order;
  }
});

// ../gridduck/dist/models/orgPartner.js
var require_orgPartner = __commonJS({
  "../gridduck/dist/models/orgPartner.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var OrgPartner = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "orgPartner";
        this._orgName = initParams.org_name;
        this._orgToName = initParams.org_to_name;
        this._name = initParams.name;
        this._orgFromName = initParams.org_from_name;
        this._orgId = initParams.org_id;
        this._orgToId = initParams.org_to_id;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._deviceList = (0, util_1.camelArray)(initParams.device_list);
        this._orgFromId = initParams.org_from_id;
        this._permType = initParams.perm_type;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._sites = (0, util_1.camelArray)(initParams.sites);
        this._partnerDirection = initParams.partner_direction;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._logoImage = initParams.logo_image;
        this._orgFromLogoImage = initParams.org_from_logo_image;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImage = initParams.square_logo_image;
        this._orgFromSquareLogoImage = initParams.org_from_square_logo_image;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
        this._orgFromWhiteLabel = initParams.org_from_white_label;
        this._orgFromInheritWhiteLabelFrom = initParams.org_from_inherit_white_label_from;
        this._orgFromWhiteLabelTheme = initParams.org_from_white_label_theme;
        this._orgFromWhiteLabelCustomTheme = initParams.org_from_white_label_custom_theme;
        this._orgFromContactEmail = initParams.org_from_contact_email;
        this._contactEmail = initParams.contact_email;
        this._issues = initParams.issues;
        this._appliances = initParams.appliances;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
        this._widgetBoardId = initParams.widget_board_id;
      }
      set orgName(value) {
        console.error("Do not set objects this way");
      }
      setOrgName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_name: value }, this);
      }
      get orgName() {
        return this._orgName;
      }
      set orgToName(value) {
        console.error("Do not set objects this way");
      }
      setOrgToName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_to_name: value }, this);
      }
      get orgToName() {
        return this._orgToName;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateOrgPartner(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set orgFromName(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_name: value }, this);
      }
      get orgFromName() {
        return this._orgFromName;
      }
      set orgId(value) {
        console.error("Do not set objects this way");
      }
      setOrgId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_id: value }, this);
      }
      get orgId() {
        return this._orgId;
      }
      set orgToId(value) {
        console.error("Do not set objects this way");
      }
      setOrgToId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_to_id: value }, this);
      }
      get orgToId() {
        return this._orgToId;
      }
      set dataTypes(value) {
        console.error("Do not set objects this way");
      }
      setDataTypes(value) {
        return this.dataService.updateOrgPartner(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
      }
      get dataTypes() {
        return this._dataTypes;
      }
      set deviceList(value) {
        console.error("Do not set objects this way");
      }
      setDeviceList(value) {
        return this.dataService.updateOrgPartner(this.id, { device_list: (0, util_1.snakeArray)(value) }, this);
      }
      get deviceList() {
        return this._deviceList;
      }
      set orgFromId(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_id: value }, this);
      }
      get orgFromId() {
        return this._orgFromId;
      }
      set permType(value) {
        console.error("Do not set objects this way");
      }
      setPermType(value) {
        return this.dataService.updateOrgPartner(this.id, { perm_type: value }, this);
      }
      get permType() {
        return this._permType;
      }
      set orgEmailAddress(value) {
        console.error("Do not set objects this way");
      }
      setOrgEmailAddress(value) {
        return this.dataService.updateOrgPartner(this.id, { org_email_address: (0, util_1.snakeArray)(value) }, this);
      }
      get orgEmailAddress() {
        return this._orgEmailAddress;
      }
      set sites(value) {
        console.error("Do not set objects this way");
      }
      setSites(value) {
        return this.dataService.updateOrgPartner(this.id, { sites: (0, util_1.snakeArray)(value) }, this);
      }
      get sites() {
        return this._sites;
      }
      set partnerDirection(value) {
        console.error("Do not set objects this way");
      }
      setPartnerDirection(value) {
        return this.dataService.updateOrgPartner(this.id, { partner_direction: value }, this);
      }
      get partnerDirection() {
        return this._partnerDirection;
      }
      set whiteLabel(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabel(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label: value }, this);
      }
      get whiteLabel() {
        return this._whiteLabel;
      }
      set inheritWhiteLabelFrom(value) {
        console.error("Do not set objects this way");
      }
      setInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrgPartner(this.id, { inherit_white_label_from: value }, this);
      }
      get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
      }
      set whiteLabelTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label_theme: value }, this);
      }
      get whiteLabelTheme() {
        return this._whiteLabelTheme;
      }
      set whiteLabelCustomTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label_custom_theme: value }, this);
      }
      get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
      }
      set logoImage(value) {
        console.error("Do not set objects this way");
      }
      setLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { logo_image: value }, this);
      }
      get logoImage() {
        return this._logoImage;
      }
      set orgFromLogoImage(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_logo_image: value }, this);
      }
      get orgFromLogoImage() {
        return this._orgFromLogoImage;
      }
      set logoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setLogoImageThumbnail(value) {
        return this.dataService.updateOrgPartner(this.id, { logo_image_thumbnail: value }, this);
      }
      get logoImageThumbnail() {
        return this._logoImageThumbnail;
      }
      set squareLogoImage(value) {
        console.error("Do not set objects this way");
      }
      setSquareLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { square_logo_image: value }, this);
      }
      get squareLogoImage() {
        return this._squareLogoImage;
      }
      set orgFromSquareLogoImage(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromSquareLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_square_logo_image: value }, this);
      }
      get orgFromSquareLogoImage() {
        return this._orgFromSquareLogoImage;
      }
      set squareLogoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setSquareLogoImageThumbnail(value) {
        return this.dataService.updateOrgPartner(this.id, { square_logo_image_thumbnail: value }, this);
      }
      get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
      }
      set orgFromWhiteLabel(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromWhiteLabel(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label: value }, this);
      }
      get orgFromWhiteLabel() {
        return this._orgFromWhiteLabel;
      }
      set orgFromInheritWhiteLabelFrom(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_inherit_white_label_from: value }, this);
      }
      get orgFromInheritWhiteLabelFrom() {
        return this._orgFromInheritWhiteLabelFrom;
      }
      set orgFromWhiteLabelTheme(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromWhiteLabelTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label_theme: value }, this);
      }
      get orgFromWhiteLabelTheme() {
        return this._orgFromWhiteLabelTheme;
      }
      set orgFromWhiteLabelCustomTheme(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label_custom_theme: value }, this);
      }
      get orgFromWhiteLabelCustomTheme() {
        return this._orgFromWhiteLabelCustomTheme;
      }
      set orgFromContactEmail(value) {
        console.error("Do not set objects this way");
      }
      setOrgFromContactEmail(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_contact_email: value }, this);
      }
      get orgFromContactEmail() {
        return this._orgFromContactEmail;
      }
      set contactEmail(value) {
        console.error("Do not set objects this way");
      }
      setContactEmail(value) {
        return this.dataService.updateOrgPartner(this.id, { contact_email: value }, this);
      }
      get contactEmail() {
        return this._contactEmail;
      }
      set issues(value) {
        console.error("Do not set objects this way");
      }
      setIssues(value) {
        return this.dataService.updateOrgPartner(this.id, { issues: value }, this);
      }
      get issues() {
        return this._issues;
      }
      set appliances(value) {
        console.error("Do not set objects this way");
      }
      setAppliances(value) {
        return this.dataService.updateOrgPartner(this.id, { appliances: value }, this);
      }
      get appliances() {
        return this._appliances;
      }
      set lowBatteryAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowBatteryAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { low_battery_assets: value }, this);
      }
      get lowBatteryAssets() {
        return this._lowBatteryAssets;
      }
      set lowSignalAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowSignalAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { low_signal_assets: value }, this);
      }
      get lowSignalAssets() {
        return this._lowSignalAssets;
      }
      set assetsWithIssues(value) {
        console.error("Do not set objects this way");
      }
      setAssetsWithIssues(value) {
        return this.dataService.updateOrgPartner(this.id, { assets_with_issues: value }, this);
      }
      get assetsWithIssues() {
        return this._assetsWithIssues;
      }
      set faultyAssets(value) {
        console.error("Do not set objects this way");
      }
      setFaultyAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { faulty_assets: value }, this);
      }
      get faultyAssets() {
        return this._faultyAssets;
      }
      set intermittentAssets(value) {
        console.error("Do not set objects this way");
      }
      setIntermittentAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { intermittent_assets: value }, this);
      }
      get intermittentAssets() {
        return this._intermittentAssets;
      }
      set anomalousAssets(value) {
        console.error("Do not set objects this way");
      }
      setAnomalousAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { anomalous_assets: value }, this);
      }
      get anomalousAssets() {
        return this._anomalousAssets;
      }
      set widgetBoardId(value) {
        console.error("Do not set objects this way");
      }
      setWidgetBoardId(value) {
        return this.dataService.updateOrgPartner(this.id, { widget_board_id: value }, this);
      }
      get widgetBoardId() {
        return this._widgetBoardId;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOrgPartner(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteOrgPartner(this.id, this);
      }
    };
    exports2.default = OrgPartner;
  }
});

// ../gridduck/dist/models/organisation.js
var require_organisation = __commonJS({
  "../gridduck/dist/models/organisation.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Organisation = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "organisation";
        this._orgCurrency = initParams.org_currency;
        this._name = initParams.name;
        this._websiteUrl = initParams.website_url;
        this._contactEmail = initParams.contact_email;
        this._contactPhone = initParams.contact_phone;
        this._address = initParams.address;
        this._mfaEnforced = initParams.mfa_enforced;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._emailAddress = initParams.email_address;
        this._vatId = initParams.vat_id;
        this._tour = initParams.tour;
        this._free = initParams.free;
        this._acceptedTerms = initParams.accepted_terms;
        this._defaultOccupancySchedule = initParams.default_occupancy_schedule;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._customDomainUrl = initParams.custom_domain_url;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._defaultModifiers = initParams.default_modifiers;
      }
      set orgCurrency(value) {
        console.error("Do not set objects this way");
      }
      setOrgCurrency(value) {
        return this.dataService.updateOrganisation(this.id, { org_currency: value }, this);
      }
      get orgCurrency() {
        return this._orgCurrency;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateOrganisation(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set websiteUrl(value) {
        console.error("Do not set objects this way");
      }
      setWebsiteUrl(value) {
        return this.dataService.updateOrganisation(this.id, { website_url: value }, this);
      }
      get websiteUrl() {
        return this._websiteUrl;
      }
      set contactEmail(value) {
        console.error("Do not set objects this way");
      }
      setContactEmail(value) {
        return this.dataService.updateOrganisation(this.id, { contact_email: value }, this);
      }
      get contactEmail() {
        return this._contactEmail;
      }
      set contactPhone(value) {
        console.error("Do not set objects this way");
      }
      setContactPhone(value) {
        return this.dataService.updateOrganisation(this.id, { contact_phone: value }, this);
      }
      get contactPhone() {
        return this._contactPhone;
      }
      set address(value) {
        console.error("Do not set objects this way");
      }
      setAddress(value) {
        return this.dataService.updateOrganisation(this.id, { address: value }, this);
      }
      get address() {
        return this._address;
      }
      set mfaEnforced(value) {
        console.error("Do not set objects this way");
      }
      setMfaEnforced(value) {
        return this.dataService.updateOrganisation(this.id, { mfa_enforced: value }, this);
      }
      get mfaEnforced() {
        return this._mfaEnforced;
      }
      set orgEmailAddress(value) {
        console.error("Do not set objects this way");
      }
      setOrgEmailAddress(value) {
        return this.dataService.updateOrganisation(this.id, { org_email_address: (0, util_1.snakeArray)(value) }, this);
      }
      get orgEmailAddress() {
        return this._orgEmailAddress;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      setEmailAddress(value) {
        return this.dataService.updateOrganisation(this.id, { email_address: value }, this);
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set vatId(value) {
        console.error("Do not set objects this way");
      }
      setVatId(value) {
        return this.dataService.updateOrganisation(this.id, { vat_id: value }, this);
      }
      get vatId() {
        return this._vatId;
      }
      set tour(value) {
        console.error("Do not set objects this way");
      }
      setTour(value) {
        return this.dataService.updateOrganisation(this.id, { tour: value }, this);
      }
      get tour() {
        return this._tour;
      }
      set free(value) {
        console.error("Do not set objects this way");
      }
      setFree(value) {
        return this.dataService.updateOrganisation(this.id, { free: value }, this);
      }
      get free() {
        return this._free;
      }
      set acceptedTerms(value) {
        console.error("Do not set objects this way");
      }
      setAcceptedTerms(value) {
        return this.dataService.updateOrganisation(this.id, { accepted_terms: value }, this);
      }
      get acceptedTerms() {
        return this._acceptedTerms;
      }
      set defaultOccupancySchedule(value) {
        console.error("Do not set objects this way");
      }
      setDefaultOccupancySchedule(value) {
        return this.dataService.updateOrganisation(this.id, { default_occupancy_schedule: value }, this);
      }
      get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
      }
      set whiteLabel(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabel(value) {
        return this.dataService.updateOrganisation(this.id, { white_label: value }, this);
      }
      get whiteLabel() {
        return this._whiteLabel;
      }
      set inheritWhiteLabelFrom(value) {
        console.error("Do not set objects this way");
      }
      setInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrganisation(this.id, { inherit_white_label_from: value }, this);
      }
      get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
      }
      set whiteLabelTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelTheme(value) {
        return this.dataService.updateOrganisation(this.id, { white_label_theme: value }, this);
      }
      get whiteLabelTheme() {
        return this._whiteLabelTheme;
      }
      set customDomainUrl(value) {
        console.error("Do not set objects this way");
      }
      setCustomDomainUrl(value) {
        return this.dataService.updateOrganisation(this.id, { custom_domain_url: value }, this);
      }
      get customDomainUrl() {
        return this._customDomainUrl;
      }
      set whiteLabelCustomTheme(value) {
        console.error("Do not set objects this way");
      }
      setWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrganisation(this.id, { white_label_custom_theme: value }, this);
      }
      get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
      }
      set defaultModifiers(value) {
        console.error("Do not set objects this way");
      }
      setDefaultModifiers(value) {
        return this.dataService.updateOrganisation(this.id, { default_modifiers: value }, this);
      }
      get defaultModifiers() {
        return this._defaultModifiers;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOrganisation(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = Organisation;
  }
});

// ../gridduck/dist/models/organisationInvite.js
var require_organisationInvite = __commonJS({
  "../gridduck/dist/models/organisationInvite.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var OrganisationInvite = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "organisationInvite";
        this._orgPermission = initParams.org_permission;
        this._emailAddress = initParams.email_address;
        this._inviteSent = initParams.invite_sent;
        this._linkOpened = initParams.link_opened;
        this._orgName = initParams.org_name;
        this._orgId = initParams.org_id;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
      }
      set orgPermission(value) {
        console.error("Do not set objects this way");
      }
      setOrgPermission(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_permission: value }, this);
      }
      get orgPermission() {
        return this._orgPermission;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      setEmailAddress(value) {
        return this.dataService.updateOrganisationInvite(this.id, { email_address: value }, this);
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set inviteSent(value) {
        console.error("Do not set objects this way");
      }
      setInviteSent(value) {
        return this.dataService.updateOrganisationInvite(this.id, { invite_sent: value }, this);
      }
      get inviteSent() {
        return this._inviteSent;
      }
      set linkOpened(value) {
        console.error("Do not set objects this way");
      }
      setLinkOpened(value) {
        return this.dataService.updateOrganisationInvite(this.id, { link_opened: value }, this);
      }
      get linkOpened() {
        return this._linkOpened;
      }
      set orgName(value) {
        console.error("Do not set objects this way");
      }
      setOrgName(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_name: value }, this);
      }
      get orgName() {
        return this._orgName;
      }
      set orgId(value) {
        console.error("Do not set objects this way");
      }
      setOrgId(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_id: value }, this);
      }
      get orgId() {
        return this._orgId;
      }
      set orgOverridePerms(value) {
        console.error("Do not set objects this way");
      }
      setOrgOverridePerms(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_override_perms: value }, this);
      }
      get orgOverridePerms() {
        return this._orgOverridePerms;
      }
      set sitesLimitedTo(value) {
        console.error("Do not set objects this way");
      }
      setSitesLimitedTo(value) {
        return this.dataService.updateOrganisationInvite(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
      }
      get sitesLimitedTo() {
        return this._sitesLimitedTo;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOrganisationInvite(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteOrganisationInvite(this.id, this);
      }
    };
    exports2.default = OrganisationInvite;
  }
});

// ../gridduck/dist/models/organisationManagement.js
var require_organisationManagement = __commonJS({
  "../gridduck/dist/models/organisationManagement.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var OrganisationManagement = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "organisationManagement";
        this._currency = initParams.currency;
        this._name = initParams.name;
        this._orgCurrency = initParams.org_currency;
        this._stripeId = initParams.stripe_id;
        this._address = initParams.address;
        this._ownerEmail = initParams.owner_email;
        this._dashboardTier = initParams.dashboard_tier;
        this._dashboardTierFrequency = initParams.dashboard_tier_frequency;
        this._paymentMethods = (0, util_1.camelArray)(initParams.payment_methods);
        this._subscriptions = (0, util_1.camelArray)(initParams.subscriptions);
        this._invoices = (0, util_1.camelArray)(initParams.invoices);
        this._acceptedTerms = initParams.accepted_terms;
        this._free = initParams.free;
        this._accountLocked = initParams.account_locked;
        this._subPaymentExempt = initParams.sub_payment_exempt;
        this._lastActive = initParams.last_active;
        this._users = (0, util_1.camelArray)(initParams.users);
        this._deviceCount = initParams.device_count;
        this._appliances = initParams.appliances;
        this._issues = initParams.issues;
        this._sites = initParams.sites;
        this._seats = initParams.seats;
        this._hubCount = initParams.hub_count;
        this._simCount = initParams.sim_count;
      }
      set currency(value) {
        console.error("Do not set objects this way");
      }
      setCurrency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { currency: value }, this);
      }
      get currency() {
        return this._currency;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateOrganisationManagement(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set orgCurrency(value) {
        console.error("Do not set objects this way");
      }
      setOrgCurrency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { org_currency: value }, this);
      }
      get orgCurrency() {
        return this._orgCurrency;
      }
      set stripeId(value) {
        console.error("Do not set objects this way");
      }
      setStripeId(value) {
        return this.dataService.updateOrganisationManagement(this.id, { stripe_id: value }, this);
      }
      get stripeId() {
        return this._stripeId;
      }
      set address(value) {
        console.error("Do not set objects this way");
      }
      setAddress(value) {
        return this.dataService.updateOrganisationManagement(this.id, { address: value }, this);
      }
      get address() {
        return this._address;
      }
      set ownerEmail(value) {
        console.error("Do not set objects this way");
      }
      setOwnerEmail(value) {
        return this.dataService.updateOrganisationManagement(this.id, { owner_email: value }, this);
      }
      get ownerEmail() {
        return this._ownerEmail;
      }
      set dashboardTier(value) {
        console.error("Do not set objects this way");
      }
      setDashboardTier(value) {
        return this.dataService.updateOrganisationManagement(this.id, { dashboard_tier: value }, this);
      }
      get dashboardTier() {
        return this._dashboardTier;
      }
      set dashboardTierFrequency(value) {
        console.error("Do not set objects this way");
      }
      setDashboardTierFrequency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { dashboard_tier_frequency: value }, this);
      }
      get dashboardTierFrequency() {
        return this._dashboardTierFrequency;
      }
      set paymentMethods(value) {
        console.error("Do not set objects this way");
      }
      setPaymentMethods(value) {
        return this.dataService.updateOrganisationManagement(this.id, { payment_methods: (0, util_1.snakeArray)(value) }, this);
      }
      get paymentMethods() {
        return this._paymentMethods;
      }
      set subscriptions(value) {
        console.error("Do not set objects this way");
      }
      setSubscriptions(value) {
        return this.dataService.updateOrganisationManagement(this.id, { subscriptions: (0, util_1.snakeArray)(value) }, this);
      }
      get subscriptions() {
        return this._subscriptions;
      }
      set invoices(value) {
        console.error("Do not set objects this way");
      }
      setInvoices(value) {
        return this.dataService.updateOrganisationManagement(this.id, { invoices: (0, util_1.snakeArray)(value) }, this);
      }
      get invoices() {
        return this._invoices;
      }
      set acceptedTerms(value) {
        console.error("Do not set objects this way");
      }
      setAcceptedTerms(value) {
        return this.dataService.updateOrganisationManagement(this.id, { accepted_terms: value }, this);
      }
      get acceptedTerms() {
        return this._acceptedTerms;
      }
      set free(value) {
        console.error("Do not set objects this way");
      }
      setFree(value) {
        return this.dataService.updateOrganisationManagement(this.id, { free: value }, this);
      }
      get free() {
        return this._free;
      }
      set accountLocked(value) {
        console.error("Do not set objects this way");
      }
      setAccountLocked(value) {
        return this.dataService.updateOrganisationManagement(this.id, { account_locked: value }, this);
      }
      get accountLocked() {
        return this._accountLocked;
      }
      set subPaymentExempt(value) {
        console.error("Do not set objects this way");
      }
      setSubPaymentExempt(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sub_payment_exempt: value }, this);
      }
      get subPaymentExempt() {
        return this._subPaymentExempt;
      }
      set lastActive(value) {
        console.error("Do not set objects this way");
      }
      setLastActive(value) {
        return this.dataService.updateOrganisationManagement(this.id, { last_active: value }, this);
      }
      get lastActive() {
        return this._lastActive;
      }
      set users(value) {
        console.error("Do not set objects this way");
      }
      setUsers(value) {
        return this.dataService.updateOrganisationManagement(this.id, { users: (0, util_1.snakeArray)(value) }, this);
      }
      get users() {
        return this._users;
      }
      set deviceCount(value) {
        console.error("Do not set objects this way");
      }
      setDeviceCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { device_count: value }, this);
      }
      get deviceCount() {
        return this._deviceCount;
      }
      set appliances(value) {
        console.error("Do not set objects this way");
      }
      setAppliances(value) {
        return this.dataService.updateOrganisationManagement(this.id, { appliances: value }, this);
      }
      get appliances() {
        return this._appliances;
      }
      set issues(value) {
        console.error("Do not set objects this way");
      }
      setIssues(value) {
        return this.dataService.updateOrganisationManagement(this.id, { issues: value }, this);
      }
      get issues() {
        return this._issues;
      }
      set sites(value) {
        console.error("Do not set objects this way");
      }
      setSites(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sites: value }, this);
      }
      get sites() {
        return this._sites;
      }
      set seats(value) {
        console.error("Do not set objects this way");
      }
      setSeats(value) {
        return this.dataService.updateOrganisationManagement(this.id, { seats: value }, this);
      }
      get seats() {
        return this._seats;
      }
      set hubCount(value) {
        console.error("Do not set objects this way");
      }
      setHubCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { hub_count: value }, this);
      }
      get hubCount() {
        return this._hubCount;
      }
      set simCount(value) {
        console.error("Do not set objects this way");
      }
      setSimCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sim_count: value }, this);
      }
      get simCount() {
        return this._simCount;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOrganisationManagement(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = OrganisationManagement;
  }
});

// ../gridduck/dist/models/organisationMember.js
var require_organisationMember = __commonJS({
  "../gridduck/dist/models/organisationMember.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var OrganisationMember = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "organisationMember";
        this._name = initParams.name;
        this._username = initParams.username;
        this._clients = (0, util_1.camelArray)(initParams.clients);
        this._currentlyConnected = initParams.currently_connected;
        this._orgPermission = initParams.org_permission;
        this._colour = initParams.colour;
        this.__permission = initParams._permission;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._profilePicture = initParams.profile_picture;
        this._jobRole = initParams.job_role;
        this._alertsEnabled = initParams.alerts_enabled;
        this._lastActive = initParams.last_active;
        this._mfaEnabled = initParams.mfa_enabled;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateOrganisationMember(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      setUsername(value) {
        return this.dataService.updateOrganisationMember(this.id, { username: value }, this);
      }
      get username() {
        return this._username;
      }
      set clients(value) {
        console.error("Do not set objects this way");
      }
      setClients(value) {
        return this.dataService.updateOrganisationMember(this.id, { clients: (0, util_1.snakeArray)(value) }, this);
      }
      get clients() {
        return this._clients;
      }
      set currentlyConnected(value) {
        console.error("Do not set objects this way");
      }
      setCurrentlyConnected(value) {
        return this.dataService.updateOrganisationMember(this.id, { currently_connected: value }, this);
      }
      get currentlyConnected() {
        return this._currentlyConnected;
      }
      set orgPermission(value) {
        console.error("Do not set objects this way");
      }
      setOrgPermission(value) {
        return this.dataService.updateOrganisationMember(this.id, { org_permission: value }, this);
      }
      get orgPermission() {
        return this._orgPermission;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      setColour(value) {
        return this.dataService.updateOrganisationMember(this.id, { colour: value }, this);
      }
      get colour() {
        return this._colour;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateOrganisationMember(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set profilePictureThumbnail(value) {
        console.error("Do not set objects this way");
      }
      setProfilePictureThumbnail(value) {
        return this.dataService.updateOrganisationMember(this.id, { profile_picture_thumbnail: value }, this);
      }
      get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
      }
      set profilePicture(value) {
        console.error("Do not set objects this way");
      }
      setProfilePicture(value) {
        return this.dataService.updateOrganisationMember(this.id, { profile_picture: value }, this);
      }
      get profilePicture() {
        return this._profilePicture;
      }
      set jobRole(value) {
        console.error("Do not set objects this way");
      }
      setJobRole(value) {
        return this.dataService.updateOrganisationMember(this.id, { job_role: value }, this);
      }
      get jobRole() {
        return this._jobRole;
      }
      set alertsEnabled(value) {
        console.error("Do not set objects this way");
      }
      setAlertsEnabled(value) {
        return this.dataService.updateOrganisationMember(this.id, { alerts_enabled: value }, this);
      }
      get alertsEnabled() {
        return this._alertsEnabled;
      }
      set lastActive(value) {
        console.error("Do not set objects this way");
      }
      setLastActive(value) {
        return this.dataService.updateOrganisationMember(this.id, { last_active: value }, this);
      }
      get lastActive() {
        return this._lastActive;
      }
      set mfaEnabled(value) {
        console.error("Do not set objects this way");
      }
      setMfaEnabled(value) {
        return this.dataService.updateOrganisationMember(this.id, { mfa_enabled: value }, this);
      }
      get mfaEnabled() {
        return this._mfaEnabled;
      }
      set orgOverridePerms(value) {
        console.error("Do not set objects this way");
      }
      setOrgOverridePerms(value) {
        return this.dataService.updateOrganisationMember(this.id, { org_override_perms: value }, this);
      }
      get orgOverridePerms() {
        return this._orgOverridePerms;
      }
      set sitesLimitedTo(value) {
        console.error("Do not set objects this way");
      }
      setSitesLimitedTo(value) {
        return this.dataService.updateOrganisationMember(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
      }
      get sitesLimitedTo() {
        return this._sitesLimitedTo;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateOrganisationMember(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteOrganisationMember(this.id, this);
      }
      createLogout(object2) {
        return this.dataService.apiService.createOrganisationMemberLogout(this.id, object2);
      }
    };
    exports2.default = OrganisationMember;
  }
});

// ../gridduck/dist/models/organisationSearch.js
var require_organisationSearch = __commonJS({
  "../gridduck/dist/models/organisationSearch.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var OrganisationSearch = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "organisationSearch";
        this._name = initParams.name;
        this._username = initParams.username;
        this._orgName = initParams.org_name;
        this._orgId = initParams.org_id;
        this._profilePicture = initParams.profile_picture;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._colour = initParams.colour;
        this._imageUrl = initParams.image_url;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set username(value) {
        console.error("Do not set objects this way");
      }
      get username() {
        return this._username;
      }
      set orgName(value) {
        console.error("Do not set objects this way");
      }
      get orgName() {
        return this._orgName;
      }
      set orgId(value) {
        console.error("Do not set objects this way");
      }
      get orgId() {
        return this._orgId;
      }
      set profilePicture(value) {
        console.error("Do not set objects this way");
      }
      get profilePicture() {
        return this._profilePicture;
      }
      set profilePictureThumbnail(value) {
        console.error("Do not set objects this way");
      }
      get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
      }
      set colour(value) {
        console.error("Do not set objects this way");
      }
      get colour() {
        return this._colour;
      }
      set imageUrl(value) {
        console.error("Do not set objects this way");
      }
      get imageUrl() {
        return this._imageUrl;
      }
    };
    exports2.default = OrganisationSearch;
  }
});

// ../gridduck/dist/models/password.js
var require_password = __commonJS({
  "../gridduck/dist/models/password.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var Password = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "password";
        this._oldPassword = initParams.old_password;
        this._newPassword = initParams.new_password;
        this._status = initParams.status;
      }
      set oldPassword(value) {
        console.error("Do not set objects this way");
      }
      get oldPassword() {
        return this._oldPassword;
      }
      set newPassword(value) {
        console.error("Do not set objects this way");
      }
      get newPassword() {
        return this._newPassword;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
    };
    exports2.default = Password;
  }
});

// ../gridduck/dist/models/paymentCard.js
var require_paymentCard = __commonJS({
  "../gridduck/dist/models/paymentCard.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var PaymentCard = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "paymentCard";
        this._cardId = initParams.card_id;
        this._card = initParams.card;
        this._bacs_debit = initParams.bacs_debit;
      }
      set cardId(value) {
        console.error("Do not set objects this way");
      }
      setCardId(value) {
        return this.dataService.updatePaymentCard(this.id, { card_id: value }, this);
      }
      get cardId() {
        return this._cardId;
      }
      set card(value) {
        console.error("Do not set objects this way");
      }
      setCard(value) {
        return this.dataService.updatePaymentCard(this.id, { card: value }, this);
      }
      get card() {
        return this._card;
      }
      set bacs_debit(value) {
        console.error("Do not set objects this way");
      }
      setBacs_debit(value) {
        return this.dataService.updatePaymentCard(this.id, { bacs_debit: value }, this);
      }
      get bacs_debit() {
        return this._bacs_debit;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updatePaymentCard(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deletePaymentCard(this.id, this);
      }
    };
    exports2.default = PaymentCard;
  }
});

// ../gridduck/dist/models/paymentSheet.js
var require_paymentSheet = __commonJS({
  "../gridduck/dist/models/paymentSheet.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var PaymentSheet = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "paymentSheet";
        this._setupIntent = initParams.setup_intent;
        this._ephemeralKey = initParams.ephemeral_key;
        this._customer = initParams.customer;
        this._publishableKey = initParams.publishable_key;
      }
      set setupIntent(value) {
        console.error("Do not set objects this way");
      }
      get setupIntent() {
        return this._setupIntent;
      }
      set ephemeralKey(value) {
        console.error("Do not set objects this way");
      }
      get ephemeralKey() {
        return this._ephemeralKey;
      }
      set customer(value) {
        console.error("Do not set objects this way");
      }
      get customer() {
        return this._customer;
      }
      set publishableKey(value) {
        console.error("Do not set objects this way");
      }
      get publishableKey() {
        return this._publishableKey;
      }
    };
    exports2.default = PaymentSheet;
  }
});

// ../gridduck/dist/models/physicalGateway.js
var require_physicalGateway = __commonJS({
  "../gridduck/dist/models/physicalGateway.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var PhysicalGateway = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "physicalGateway";
        this._resetOwners = initParams.reset_owners;
        this._serialNumber = initParams.serial_number;
        this._installationCode = initParams.installation_code;
        this._owners = (0, util_1.camelArray)(initParams.owners);
      }
      set resetOwners(value) {
        console.error("Do not set objects this way");
      }
      setResetOwners(value) {
        return this.dataService.updatePhysicalGateway(this.id, { reset_owners: value }, this);
      }
      get resetOwners() {
        return this._resetOwners;
      }
      set serialNumber(value) {
        console.error("Do not set objects this way");
      }
      setSerialNumber(value) {
        return this.dataService.updatePhysicalGateway(this.id, { serial_number: value }, this);
      }
      get serialNumber() {
        return this._serialNumber;
      }
      set installationCode(value) {
        console.error("Do not set objects this way");
      }
      setInstallationCode(value) {
        return this.dataService.updatePhysicalGateway(this.id, { installation_code: value }, this);
      }
      get installationCode() {
        return this._installationCode;
      }
      set owners(value) {
        console.error("Do not set objects this way");
      }
      setOwners(value) {
        return this.dataService.updatePhysicalGateway(this.id, { owners: (0, util_1.snakeArray)(value) }, this);
      }
      get owners() {
        return this._owners;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updatePhysicalGateway(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = PhysicalGateway;
  }
});

// ../gridduck/dist/models/places.js
var require_places = __commonJS({
  "../gridduck/dist/models/places.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Places = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "places";
        this._businessDetails = initParams.business_details;
        this._locations = (0, util_1.camelArray)(initParams.locations);
        this._input = initParams.input;
      }
      set businessDetails(value) {
        console.error("Do not set objects this way");
      }
      get businessDetails() {
        return this._businessDetails;
      }
      set locations(value) {
        console.error("Do not set objects this way");
      }
      get locations() {
        return this._locations;
      }
      set input(value) {
        console.error("Do not set objects this way");
      }
      get input() {
        return this._input;
      }
    };
    exports2.default = Places;
  }
});

// ../gridduck/dist/models/preferences.js
var require_preferences = __commonJS({
  "../gridduck/dist/models/preferences.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Preferences = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "preferences";
        this._customKpiDefaults = (0, util_1.camelArray)(initParams.custom_kpi_defaults);
      }
      set customKpiDefaults(value) {
        console.error("Do not set objects this way");
      }
      setCustomKpiDefaults(value) {
        return this.dataService.updatePreferences(this.id, { custom_kpi_defaults: (0, util_1.snakeArray)(value) }, this);
      }
      get customKpiDefaults() {
        return this._customKpiDefaults;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updatePreferences(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = Preferences;
  }
});

// ../gridduck/dist/models/product.js
var require_product = __commonJS({
  "../gridduck/dist/models/product.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Product = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "product";
        this._name = initParams.name;
        this._description = initParams.description;
        this._images = (0, util_1.camelArray)(initParams.images);
        this._prices = (0, util_1.camelArray)(initParams.prices);
        this._metadata = initParams.metadata;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      get description() {
        return this._description;
      }
      set images(value) {
        console.error("Do not set objects this way");
      }
      get images() {
        return this._images;
      }
      set prices(value) {
        console.error("Do not set objects this way");
      }
      get prices() {
        return this._prices;
      }
      set metadata(value) {
        console.error("Do not set objects this way");
      }
      get metadata() {
        return this._metadata;
      }
    };
    exports2.default = Product;
  }
});

// ../gridduck/dist/models/pubOrg.js
var require_pubOrg = __commonJS({
  "../gridduck/dist/models/pubOrg.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var PubOrg = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "pubOrg";
        this._orgCurrency = initParams.org_currency;
        this._name = initParams.name;
        this._websiteUrl = initParams.website_url;
        this._cloneFromId = initParams.clone_from_id;
        this._cloneToId = initParams.clone_to_id;
        this._contactEmail = initParams.contact_email;
        this._contactPhone = initParams.contact_phone;
        this._address = initParams.address;
        this._mfaEnforced = initParams.mfa_enforced;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._emailAddress = initParams.email_address;
        this._free = initParams.free;
        this._tour = initParams.tour;
        this._industry = initParams.industry;
        this._goals = (0, util_1.camelArray)(initParams.goals);
      }
      set orgCurrency(value) {
        console.error("Do not set objects this way");
      }
      get orgCurrency() {
        return this._orgCurrency;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set websiteUrl(value) {
        console.error("Do not set objects this way");
      }
      get websiteUrl() {
        return this._websiteUrl;
      }
      set cloneFromId(value) {
        console.error("Do not set objects this way");
      }
      get cloneFromId() {
        return this._cloneFromId;
      }
      set cloneToId(value) {
        console.error("Do not set objects this way");
      }
      get cloneToId() {
        return this._cloneToId;
      }
      set contactEmail(value) {
        console.error("Do not set objects this way");
      }
      get contactEmail() {
        return this._contactEmail;
      }
      set contactPhone(value) {
        console.error("Do not set objects this way");
      }
      get contactPhone() {
        return this._contactPhone;
      }
      set address(value) {
        console.error("Do not set objects this way");
      }
      get address() {
        return this._address;
      }
      set mfaEnforced(value) {
        console.error("Do not set objects this way");
      }
      get mfaEnforced() {
        return this._mfaEnforced;
      }
      set orgEmailAddress(value) {
        console.error("Do not set objects this way");
      }
      get orgEmailAddress() {
        return this._orgEmailAddress;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set free(value) {
        console.error("Do not set objects this way");
      }
      get free() {
        return this._free;
      }
      set tour(value) {
        console.error("Do not set objects this way");
      }
      get tour() {
        return this._tour;
      }
      set industry(value) {
        console.error("Do not set objects this way");
      }
      get industry() {
        return this._industry;
      }
      set goals(value) {
        console.error("Do not set objects this way");
      }
      get goals() {
        return this._goals;
      }
    };
    exports2.default = PubOrg;
  }
});

// ../gridduck/dist/models/rawAggregateData.js
var require_rawAggregateData = __commonJS({
  "../gridduck/dist/models/rawAggregateData.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var RawAggregateData = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "rawAggregateData";
        this._records = (0, util_1.camelArray)(initParams.records);
        this._time = initParams.time;
        this._value = initParams.value;
      }
      set records(value) {
        console.error("Do not set objects this way");
      }
      get records() {
        return this._records;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
      set value(value) {
        console.error("Do not set objects this way");
      }
      get value() {
        return this._value;
      }
    };
    exports2.default = RawAggregateData;
  }
});

// ../gridduck/dist/models/report.js
var require_report = __commonJS({
  "../gridduck/dist/models/report.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Report = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "report";
        this._name = initParams.name;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._groupIds = (0, util_1.camelArray)(initParams.group_ids);
        this._frequency = initParams.frequency;
        this._includeMegaPdf = initParams.include_mega_pdf;
        this._active = initParams.active;
        this._recipients = (0, util_1.camelArray)(initParams.recipients);
        this._repeatOn = initParams.repeat_on;
        this._perDevice = initParams.per_device;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateReport(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set assetIds(value) {
        console.error("Do not set objects this way");
      }
      setAssetIds(value) {
        return this.dataService.updateReport(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get assetIds() {
        return this._assetIds;
      }
      set siteIds(value) {
        console.error("Do not set objects this way");
      }
      setSiteIds(value) {
        return this.dataService.updateReport(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get siteIds() {
        return this._siteIds;
      }
      set groupIds(value) {
        console.error("Do not set objects this way");
      }
      setGroupIds(value) {
        return this.dataService.updateReport(this.id, { group_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get groupIds() {
        return this._groupIds;
      }
      set frequency(value) {
        console.error("Do not set objects this way");
      }
      setFrequency(value) {
        return this.dataService.updateReport(this.id, { frequency: value }, this);
      }
      get frequency() {
        return this._frequency;
      }
      set includeMegaPdf(value) {
        console.error("Do not set objects this way");
      }
      setIncludeMegaPdf(value) {
        return this.dataService.updateReport(this.id, { include_mega_pdf: value }, this);
      }
      get includeMegaPdf() {
        return this._includeMegaPdf;
      }
      set active(value) {
        console.error("Do not set objects this way");
      }
      setActive(value) {
        return this.dataService.updateReport(this.id, { active: value }, this);
      }
      get active() {
        return this._active;
      }
      set recipients(value) {
        console.error("Do not set objects this way");
      }
      setRecipients(value) {
        return this.dataService.updateReport(this.id, { recipients: (0, util_1.snakeArray)(value) }, this);
      }
      get recipients() {
        return this._recipients;
      }
      set repeatOn(value) {
        console.error("Do not set objects this way");
      }
      setRepeatOn(value) {
        return this.dataService.updateReport(this.id, { repeat_on: value }, this);
      }
      get repeatOn() {
        return this._repeatOn;
      }
      set perDevice(value) {
        console.error("Do not set objects this way");
      }
      setPerDevice(value) {
        return this.dataService.updateReport(this.id, { per_device: value }, this);
      }
      get perDevice() {
        return this._perDevice;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateReport(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateReport(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteReport(this.id, this);
      }
    };
    exports2.default = Report;
  }
});

// ../gridduck/dist/models/reportFile.js
var require_reportFile = __commonJS({
  "../gridduck/dist/models/reportFile.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ReportFile = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "reportFile";
        this._name = initParams.name;
        this._type = initParams.type;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
    };
    exports2.default = ReportFile;
  }
});

// ../gridduck/dist/models/reportFileLink.js
var require_reportFileLink = __commonJS({
  "../gridduck/dist/models/reportFileLink.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ReportFileLink = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "reportFileLink";
        this._fileId = initParams.file_id;
        this._expiresTime = initParams.expires_time;
        this._url = initParams.url;
        this._expires = initParams.expires;
      }
      set fileId(value) {
        console.error("Do not set objects this way");
      }
      get fileId() {
        return this._fileId;
      }
      set expiresTime(value) {
        console.error("Do not set objects this way");
      }
      get expiresTime() {
        return this._expiresTime;
      }
      set url(value) {
        console.error("Do not set objects this way");
      }
      get url() {
        return this._url;
      }
      set expires(value) {
        console.error("Do not set objects this way");
      }
      get expires() {
        return this._expires;
      }
    };
    exports2.default = ReportFileLink;
  }
});

// ../gridduck/dist/models/reportHistory.js
var require_reportHistory = __commonJS({
  "../gridduck/dist/models/reportHistory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ReportHistory = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "reportHistory";
        this._rangeName = initParams.range_name;
        this._startTime = initParams.start_time;
      }
      set rangeName(value) {
        console.error("Do not set objects this way");
      }
      get rangeName() {
        return this._rangeName;
      }
      set startTime(value) {
        console.error("Do not set objects this way");
      }
      get startTime() {
        return this._startTime;
      }
    };
    exports2.default = ReportHistory;
  }
});

// ../gridduck/dist/models/requestSecret.js
var require_requestSecret = __commonJS({
  "../gridduck/dist/models/requestSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var RequestSecret = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "requestSecret";
        this._applicationId = initParams.application_id;
        this._password = initParams.password;
        this._clientSecret = initParams.client_secret;
      }
      set applicationId(value) {
        console.error("Do not set objects this way");
      }
      get applicationId() {
        return this._applicationId;
      }
      set password(value) {
        console.error("Do not set objects this way");
      }
      get password() {
        return this._password;
      }
      set clientSecret(value) {
        console.error("Do not set objects this way");
      }
      get clientSecret() {
        return this._clientSecret;
      }
    };
    exports2.default = RequestSecret;
  }
});

// ../gridduck/dist/models/resetSecret.js
var require_resetSecret = __commonJS({
  "../gridduck/dist/models/resetSecret.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ResetSecret = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "resetSecret";
        this._applicationId = initParams.application_id;
        this._password = initParams.password;
        this._clientSecret = initParams.client_secret;
      }
      set applicationId(value) {
        console.error("Do not set objects this way");
      }
      get applicationId() {
        return this._applicationId;
      }
      set password(value) {
        console.error("Do not set objects this way");
      }
      get password() {
        return this._password;
      }
      set clientSecret(value) {
        console.error("Do not set objects this way");
      }
      get clientSecret() {
        return this._clientSecret;
      }
    };
    exports2.default = ResetSecret;
  }
});

// ../gridduck/dist/models/resetToken.js
var require_resetToken = __commonJS({
  "../gridduck/dist/models/resetToken.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var ResetToken = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "resetToken";
        this._emailAddress = initParams.email_address;
        this._status = initParams.status;
        this._token = initParams.token;
        this._password = initParams.password;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      setEmailAddress(value) {
        return this.dataService.updateResetToken(this.id, { email_address: value }, this);
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateResetToken(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set token(value) {
        console.error("Do not set objects this way");
      }
      setToken(value) {
        return this.dataService.updateResetToken(this.id, { token: value }, this);
      }
      get token() {
        return this._token;
      }
      set password(value) {
        console.error("Do not set objects this way");
      }
      setPassword(value) {
        return this.dataService.updateResetToken(this.id, { password: value }, this);
      }
      get password() {
        return this._password;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateResetToken(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = ResetToken;
  }
});

// ../gridduck/dist/models/retrieval-params.js
var require_retrieval_params = __commonJS({
  "../gridduck/dist/models/retrieval-params.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var RetrievalParams = class {
      constructor(params) {
        this._getAll = params ? params.getAll ? true : false : false;
        this._items = params ? params.items ? params.items : 25 : 25;
        this._offset = this._getAll ? 0 : params ? params.offset ? params.offset : 0 : 0;
        this._filters = params.filters ? params.filters : [];
        this._sortBy = params.sortBy ? params.sortBy : null;
      }
      get filters() {
        return this._filters;
      }
      get items() {
        return this._items;
      }
      get offset() {
        return this._offset;
      }
      get getAll() {
        return this._getAll;
      }
      get sortBy() {
        return this._sortBy;
      }
    };
    exports2.default = RetrievalParams;
  }
});

// ../gridduck/dist/models/rule.js
var require_rule = __commonJS({
  "../gridduck/dist/models/rule.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Rule = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "rule";
        this._name = initParams.name;
        this._description = initParams.description;
        this._triggerLogic = initParams.trigger_logic;
        this._throttleDuration = initParams.throttle_duration;
        this._persistent = initParams.persistent;
        this._assetType = initParams.asset_type;
        this._inactiveState = initParams.inactive_state;
        this._alerts = (0, util_1.camelArray)(initParams.alerts);
        this._triggers = (0, util_1.camelArray)(initParams.triggers);
        this._template = initParams.template;
        this.__permission = initParams._permission;
        this._active = initParams.active;
        this._actions = (0, util_1.camelArray)(initParams.actions);
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateRule(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set description(value) {
        console.error("Do not set objects this way");
      }
      setDescription(value) {
        return this.dataService.updateRule(this.id, { description: value }, this);
      }
      get description() {
        return this._description;
      }
      set triggerLogic(value) {
        console.error("Do not set objects this way");
      }
      setTriggerLogic(value) {
        return this.dataService.updateRule(this.id, { trigger_logic: value }, this);
      }
      get triggerLogic() {
        return this._triggerLogic;
      }
      set throttleDuration(value) {
        console.error("Do not set objects this way");
      }
      setThrottleDuration(value) {
        return this.dataService.updateRule(this.id, { throttle_duration: value }, this);
      }
      get throttleDuration() {
        return this._throttleDuration;
      }
      set persistent(value) {
        console.error("Do not set objects this way");
      }
      setPersistent(value) {
        return this.dataService.updateRule(this.id, { persistent: value }, this);
      }
      get persistent() {
        return this._persistent;
      }
      set assetType(value) {
        console.error("Do not set objects this way");
      }
      setAssetType(value) {
        return this.dataService.updateRule(this.id, { asset_type: value }, this);
      }
      get assetType() {
        return this._assetType;
      }
      set inactiveState(value) {
        console.error("Do not set objects this way");
      }
      setInactiveState(value) {
        return this.dataService.updateRule(this.id, { inactive_state: value }, this);
      }
      get inactiveState() {
        return this._inactiveState;
      }
      set alerts(value) {
        console.error("Do not set objects this way");
      }
      setAlerts(value) {
        return this.dataService.updateRule(this.id, { alerts: (0, util_1.snakeArray)(value) }, this);
      }
      get alerts() {
        return this._alerts;
      }
      set triggers(value) {
        console.error("Do not set objects this way");
      }
      setTriggers(value) {
        return this.dataService.updateRule(this.id, { triggers: (0, util_1.snakeArray)(value) }, this);
      }
      get triggers() {
        return this._triggers;
      }
      set template(value) {
        console.error("Do not set objects this way");
      }
      setTemplate(value) {
        return this.dataService.updateRule(this.id, { template: value }, this);
      }
      get template() {
        return this._template;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateRule(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set active(value) {
        console.error("Do not set objects this way");
      }
      setActive(value) {
        return this.dataService.updateRule(this.id, { active: value }, this);
      }
      get active() {
        return this._active;
      }
      set actions(value) {
        console.error("Do not set objects this way");
      }
      setActions(value) {
        return this.dataService.updateRule(this.id, { actions: (0, util_1.snakeArray)(value) }, this);
      }
      get actions() {
        return this._actions;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateRule(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteRule(this.id, this);
      }
    };
    exports2.default = Rule;
  }
});

// ../gridduck/dist/models/ruleEvent.js
var require_ruleEvent = __commonJS({
  "../gridduck/dist/models/ruleEvent.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var RuleEvent = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "ruleEvent";
        this._event = initParams.event;
        this._time = initParams.time;
      }
      set event(value) {
        console.error("Do not set objects this way");
      }
      get event() {
        return this._event;
      }
      set time(value) {
        console.error("Do not set objects this way");
      }
      get time() {
        return this._time;
      }
    };
    exports2.default = RuleEvent;
  }
});

// ../gridduck/dist/models/search.js
var require_search = __commonJS({
  "../gridduck/dist/models/search.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var Search = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "search";
        this._query = initParams.query;
        this._name = initParams.name;
        this._type = initParams.type;
      }
      set query(value) {
        console.error("Do not set objects this way");
      }
      get query() {
        return this._query;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set type(value) {
        console.error("Do not set objects this way");
      }
      get type() {
        return this._type;
      }
    };
    exports2.default = Search;
  }
});

// ../gridduck/dist/models/searchHistory.js
var require_searchHistory = __commonJS({
  "../gridduck/dist/models/searchHistory.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var SearchHistory = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "searchHistory";
        this._accountId = initParams.account_id;
        this._metadata = initParams.metadata;
        this._name = initParams.name;
        this._itemId = initParams.item_id;
        this._itemType = initParams.item_type;
        this._created = initParams.created;
      }
      set accountId(value) {
        console.error("Do not set objects this way");
      }
      get accountId() {
        return this._accountId;
      }
      set metadata(value) {
        console.error("Do not set objects this way");
      }
      get metadata() {
        return this._metadata;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      get name() {
        return this._name;
      }
      set itemId(value) {
        console.error("Do not set objects this way");
      }
      get itemId() {
        return this._itemId;
      }
      set itemType(value) {
        console.error("Do not set objects this way");
      }
      get itemType() {
        return this._itemType;
      }
      set created(value) {
        console.error("Do not set objects this way");
      }
      get created() {
        return this._created;
      }
      delete() {
        return this.dataService.deleteSearchHistory(this.id, this);
      }
    };
    exports2.default = SearchHistory;
  }
});

// ../gridduck/dist/models/session.js
var require_session = __commonJS({
  "../gridduck/dist/models/session.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Session = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "session";
        this._created = initParams.created;
        this._completed = initParams.completed;
        this._cancelled = initParams.cancelled;
        this._subscriptionItems = (0, util_1.camelArray)(initParams.subscription_items);
        this._physicalItems = (0, util_1.camelArray)(initParams.physical_items);
      }
      set created(value) {
        console.error("Do not set objects this way");
      }
      setCreated(value) {
        return this.dataService.updateSession(this.id, { created: value }, this);
      }
      get created() {
        return this._created;
      }
      set completed(value) {
        console.error("Do not set objects this way");
      }
      setCompleted(value) {
        return this.dataService.updateSession(this.id, { completed: value }, this);
      }
      get completed() {
        return this._completed;
      }
      set cancelled(value) {
        console.error("Do not set objects this way");
      }
      setCancelled(value) {
        return this.dataService.updateSession(this.id, { cancelled: value }, this);
      }
      get cancelled() {
        return this._cancelled;
      }
      set subscriptionItems(value) {
        console.error("Do not set objects this way");
      }
      setSubscriptionItems(value) {
        return this.dataService.updateSession(this.id, { subscription_items: (0, util_1.snakeArray)(value) }, this);
      }
      get subscriptionItems() {
        return this._subscriptionItems;
      }
      set physicalItems(value) {
        console.error("Do not set objects this way");
      }
      setPhysicalItems(value) {
        return this.dataService.updateSession(this.id, { physical_items: (0, util_1.snakeArray)(value) }, this);
      }
      get physicalItems() {
        return this._physicalItems;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateSession(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteSession(this.id, this);
      }
    };
    exports2.default = Session;
  }
});

// ../gridduck/dist/models/site.js
var require_site = __commonJS({
  "../gridduck/dist/models/site.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Site = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.organisation = null;
        this.objectTypeName = "site";
        this._name = initParams.name;
        this._groupTypeId = initParams.group_type_id;
        this._timezone = initParams.timezone;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._organisationId = initParams.organisation_id;
        this._tariffIds = (0, util_1.camelArray)(initParams.tariff_ids);
        this._address = initParams.address;
        this._totalDemand = initParams.total_demand;
        this._widgetBoardId = initParams.widget_board_id;
        this._locationId = initParams.location_id;
        this._locationName = initParams.location_name;
        this._lat = initParams.lat;
        this._lng = initParams.lng;
        this._locationMetadata = initParams.location_metadata;
        this.__permission = initParams._permission;
        this._gateways = (0, util_1.camelArray)(initParams.gateways);
        this._issues = initParams.issues;
        this._issueIds = (0, util_1.camelArray)(initParams.issue_ids);
        this._customFields = (0, util_1.camelArray)(initParams.custom_fields);
        this._deviceList = (0, util_1.camelArray)(initParams.device_list);
        this._occupancyScheduleId = initParams.occupancy_schedule_id;
        this._occupancyScheduleName = initParams.occupancy_schedule_name;
        this._occupancySchedule = (0, util_1.camelArray)(initParams.occupancy_schedule);
        this._defaultOccupancyScheduleId = initParams.default_occupancy_schedule_id;
        this._defaultOccupancyScheduleName = initParams.default_occupancy_schedule_name;
        this._defaultOccupancySchedule = (0, util_1.camelArray)(initParams.default_occupancy_schedule);
        this._disconnectedAssetsViaHub = initParams.disconnected_assets_via_hub;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._appliances = initParams.appliances;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
        this._defaultModifiers = initParams.default_modifiers;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateSite(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set groupTypeId(value) {
        console.error("Do not set objects this way");
      }
      setGroupTypeId(value) {
        return this.dataService.updateSite(this.id, { group_type_id: value }, this);
      }
      get groupTypeId() {
        return this._groupTypeId;
      }
      set timezone(value) {
        console.error("Do not set objects this way");
      }
      setTimezone(value) {
        return this.dataService.updateSite(this.id, { timezone: value }, this);
      }
      get timezone() {
        return this._timezone;
      }
      set dataTypes(value) {
        console.error("Do not set objects this way");
      }
      setDataTypes(value) {
        return this.dataService.updateSite(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
      }
      get dataTypes() {
        return this._dataTypes;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateSite(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set tariffIds(value) {
        console.error("Do not set objects this way");
      }
      setTariffIds(value) {
        return this.dataService.updateSite(this.id, { tariff_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get tariffIds() {
        return this._tariffIds;
      }
      set address(value) {
        console.error("Do not set objects this way");
      }
      setAddress(value) {
        return this.dataService.updateSite(this.id, { address: value }, this);
      }
      get address() {
        return this._address;
      }
      set totalDemand(value) {
        console.error("Do not set objects this way");
      }
      setTotalDemand(value) {
        return this.dataService.updateSite(this.id, { total_demand: value }, this);
      }
      get totalDemand() {
        return this._totalDemand;
      }
      set widgetBoardId(value) {
        console.error("Do not set objects this way");
      }
      setWidgetBoardId(value) {
        return this.dataService.updateSite(this.id, { widget_board_id: value }, this);
      }
      get widgetBoardId() {
        return this._widgetBoardId;
      }
      set locationId(value) {
        console.error("Do not set objects this way");
      }
      setLocationId(value) {
        return this.dataService.updateSite(this.id, { location_id: value }, this);
      }
      get locationId() {
        return this._locationId;
      }
      set locationName(value) {
        console.error("Do not set objects this way");
      }
      setLocationName(value) {
        return this.dataService.updateSite(this.id, { location_name: value }, this);
      }
      get locationName() {
        return this._locationName;
      }
      set lat(value) {
        console.error("Do not set objects this way");
      }
      setLat(value) {
        return this.dataService.updateSite(this.id, { lat: value }, this);
      }
      get lat() {
        return this._lat;
      }
      set lng(value) {
        console.error("Do not set objects this way");
      }
      setLng(value) {
        return this.dataService.updateSite(this.id, { lng: value }, this);
      }
      get lng() {
        return this._lng;
      }
      set locationMetadata(value) {
        console.error("Do not set objects this way");
      }
      setLocationMetadata(value) {
        return this.dataService.updateSite(this.id, { location_metadata: value }, this);
      }
      get locationMetadata() {
        return this._locationMetadata;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateSite(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set gateways(value) {
        console.error("Do not set objects this way");
      }
      setGateways(value) {
        return this.dataService.updateSite(this.id, { gateways: (0, util_1.snakeArray)(value) }, this);
      }
      get gateways() {
        return this._gateways;
      }
      set issues(value) {
        console.error("Do not set objects this way");
      }
      setIssues(value) {
        return this.dataService.updateSite(this.id, { issues: value }, this);
      }
      get issues() {
        return this._issues;
      }
      set issueIds(value) {
        console.error("Do not set objects this way");
      }
      setIssueIds(value) {
        return this.dataService.updateSite(this.id, { issue_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get issueIds() {
        return this._issueIds;
      }
      set customFields(value) {
        console.error("Do not set objects this way");
      }
      setCustomFields(value) {
        return this.dataService.updateSite(this.id, { custom_fields: (0, util_1.snakeArray)(value) }, this);
      }
      get customFields() {
        return this._customFields;
      }
      set deviceList(value) {
        console.error("Do not set objects this way");
      }
      setDeviceList(value) {
        return this.dataService.updateSite(this.id, { device_list: (0, util_1.snakeArray)(value) }, this);
      }
      get deviceList() {
        return this._deviceList;
      }
      set occupancyScheduleId(value) {
        console.error("Do not set objects this way");
      }
      setOccupancyScheduleId(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule_id: value }, this);
      }
      get occupancyScheduleId() {
        return this._occupancyScheduleId;
      }
      set occupancyScheduleName(value) {
        console.error("Do not set objects this way");
      }
      setOccupancyScheduleName(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule_name: value }, this);
      }
      get occupancyScheduleName() {
        return this._occupancyScheduleName;
      }
      set occupancySchedule(value) {
        console.error("Do not set objects this way");
      }
      setOccupancySchedule(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule: (0, util_1.snakeArray)(value) }, this);
      }
      get occupancySchedule() {
        return this._occupancySchedule;
      }
      set defaultOccupancyScheduleId(value) {
        console.error("Do not set objects this way");
      }
      setDefaultOccupancyScheduleId(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule_id: value }, this);
      }
      get defaultOccupancyScheduleId() {
        return this._defaultOccupancyScheduleId;
      }
      set defaultOccupancyScheduleName(value) {
        console.error("Do not set objects this way");
      }
      setDefaultOccupancyScheduleName(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule_name: value }, this);
      }
      get defaultOccupancyScheduleName() {
        return this._defaultOccupancyScheduleName;
      }
      set defaultOccupancySchedule(value) {
        console.error("Do not set objects this way");
      }
      setDefaultOccupancySchedule(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule: (0, util_1.snakeArray)(value) }, this);
      }
      get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
      }
      set disconnectedAssetsViaHub(value) {
        console.error("Do not set objects this way");
      }
      setDisconnectedAssetsViaHub(value) {
        return this.dataService.updateSite(this.id, { disconnected_assets_via_hub: value }, this);
      }
      get disconnectedAssetsViaHub() {
        return this._disconnectedAssetsViaHub;
      }
      set lowBatteryAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowBatteryAssets(value) {
        return this.dataService.updateSite(this.id, { low_battery_assets: value }, this);
      }
      get lowBatteryAssets() {
        return this._lowBatteryAssets;
      }
      set appliances(value) {
        console.error("Do not set objects this way");
      }
      setAppliances(value) {
        return this.dataService.updateSite(this.id, { appliances: value }, this);
      }
      get appliances() {
        return this._appliances;
      }
      set lowSignalAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowSignalAssets(value) {
        return this.dataService.updateSite(this.id, { low_signal_assets: value }, this);
      }
      get lowSignalAssets() {
        return this._lowSignalAssets;
      }
      set assetsWithIssues(value) {
        console.error("Do not set objects this way");
      }
      setAssetsWithIssues(value) {
        return this.dataService.updateSite(this.id, { assets_with_issues: value }, this);
      }
      get assetsWithIssues() {
        return this._assetsWithIssues;
      }
      set faultyAssets(value) {
        console.error("Do not set objects this way");
      }
      setFaultyAssets(value) {
        return this.dataService.updateSite(this.id, { faulty_assets: value }, this);
      }
      get faultyAssets() {
        return this._faultyAssets;
      }
      set intermittentAssets(value) {
        console.error("Do not set objects this way");
      }
      setIntermittentAssets(value) {
        return this.dataService.updateSite(this.id, { intermittent_assets: value }, this);
      }
      get intermittentAssets() {
        return this._intermittentAssets;
      }
      set anomalousAssets(value) {
        console.error("Do not set objects this way");
      }
      setAnomalousAssets(value) {
        return this.dataService.updateSite(this.id, { anomalous_assets: value }, this);
      }
      get anomalousAssets() {
        return this._anomalousAssets;
      }
      set defaultModifiers(value) {
        console.error("Do not set objects this way");
      }
      setDefaultModifiers(value) {
        return this.dataService.updateSite(this.id, { default_modifiers: value }, this);
      }
      get defaultModifiers() {
        return this._defaultModifiers;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateSite(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteSite(this.id, this);
      }
    };
    exports2.default = Site;
  }
});

// ../gridduck/dist/models/siteGroup.js
var require_siteGroup = __commonJS({
  "../gridduck/dist/models/siteGroup.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var SiteGroup = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.sites = null;
        this.objectTypeName = "siteGroup";
        this._name = initParams.name;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._widgetBoardId = initParams.widget_board_id;
        this._totalDemand = initParams.total_demand;
        this._issueIds = (0, util_1.camelArray)(initParams.issue_ids);
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._disconnectedAssetsViaHub = initParams.disconnected_assets_via_hub;
        this._issues = initParams.issues;
        this._appliances = initParams.appliances;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateSiteGroup(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set dataTypes(value) {
        console.error("Do not set objects this way");
      }
      setDataTypes(value) {
        return this.dataService.updateSiteGroup(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
      }
      get dataTypes() {
        return this._dataTypes;
      }
      set widgetBoardId(value) {
        console.error("Do not set objects this way");
      }
      setWidgetBoardId(value) {
        return this.dataService.updateSiteGroup(this.id, { widget_board_id: value }, this);
      }
      get widgetBoardId() {
        return this._widgetBoardId;
      }
      set totalDemand(value) {
        console.error("Do not set objects this way");
      }
      setTotalDemand(value) {
        return this.dataService.updateSiteGroup(this.id, { total_demand: value }, this);
      }
      get totalDemand() {
        return this._totalDemand;
      }
      set issueIds(value) {
        console.error("Do not set objects this way");
      }
      setIssueIds(value) {
        return this.dataService.updateSiteGroup(this.id, { issue_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get issueIds() {
        return this._issueIds;
      }
      set siteIds(value) {
        console.error("Do not set objects this way");
      }
      setSiteIds(value) {
        return this.dataService.updateSiteGroup(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get siteIds() {
        return this._siteIds;
      }
      set disconnectedAssetsViaHub(value) {
        console.error("Do not set objects this way");
      }
      setDisconnectedAssetsViaHub(value) {
        return this.dataService.updateSiteGroup(this.id, { disconnected_assets_via_hub: value }, this);
      }
      get disconnectedAssetsViaHub() {
        return this._disconnectedAssetsViaHub;
      }
      set issues(value) {
        console.error("Do not set objects this way");
      }
      setIssues(value) {
        return this.dataService.updateSiteGroup(this.id, { issues: value }, this);
      }
      get issues() {
        return this._issues;
      }
      set appliances(value) {
        console.error("Do not set objects this way");
      }
      setAppliances(value) {
        return this.dataService.updateSiteGroup(this.id, { appliances: value }, this);
      }
      get appliances() {
        return this._appliances;
      }
      set lowBatteryAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowBatteryAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { low_battery_assets: value }, this);
      }
      get lowBatteryAssets() {
        return this._lowBatteryAssets;
      }
      set lowSignalAssets(value) {
        console.error("Do not set objects this way");
      }
      setLowSignalAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { low_signal_assets: value }, this);
      }
      get lowSignalAssets() {
        return this._lowSignalAssets;
      }
      set assetsWithIssues(value) {
        console.error("Do not set objects this way");
      }
      setAssetsWithIssues(value) {
        return this.dataService.updateSiteGroup(this.id, { assets_with_issues: value }, this);
      }
      get assetsWithIssues() {
        return this._assetsWithIssues;
      }
      set faultyAssets(value) {
        console.error("Do not set objects this way");
      }
      setFaultyAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { faulty_assets: value }, this);
      }
      get faultyAssets() {
        return this._faultyAssets;
      }
      set intermittentAssets(value) {
        console.error("Do not set objects this way");
      }
      setIntermittentAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { intermittent_assets: value }, this);
      }
      get intermittentAssets() {
        return this._intermittentAssets;
      }
      set anomalousAssets(value) {
        console.error("Do not set objects this way");
      }
      setAnomalousAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { anomalous_assets: value }, this);
      }
      get anomalousAssets() {
        return this._anomalousAssets;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateSiteGroup(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateSiteGroup(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteSiteGroup(this.id, this);
      }
    };
    exports2.default = SiteGroup;
  }
});

// ../gridduck/dist/models/sitePermission.js
var require_sitePermission = __commonJS({
  "../gridduck/dist/models/sitePermission.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var SitePermission = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "sitePermission";
        this._siteId = initParams.site_id;
        this._orgId = initParams.org_id;
        this._orgName = initParams.org_name;
        this._permName = initParams.perm_name;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateSitePermission(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set orgId(value) {
        console.error("Do not set objects this way");
      }
      setOrgId(value) {
        return this.dataService.updateSitePermission(this.id, { org_id: value }, this);
      }
      get orgId() {
        return this._orgId;
      }
      set orgName(value) {
        console.error("Do not set objects this way");
      }
      setOrgName(value) {
        return this.dataService.updateSitePermission(this.id, { org_name: value }, this);
      }
      get orgName() {
        return this._orgName;
      }
      set permName(value) {
        console.error("Do not set objects this way");
      }
      setPermName(value) {
        return this.dataService.updateSitePermission(this.id, { perm_name: value }, this);
      }
      get permName() {
        return this._permName;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateSitePermission(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteSitePermission(this.id, this);
      }
    };
    exports2.default = SitePermission;
  }
});

// ../gridduck/dist/models/stagingDatabase.js
var require_stagingDatabase = __commonJS({
  "../gridduck/dist/models/stagingDatabase.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var StagingDatabase = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "stagingDatabase";
        this._status = initParams.status;
        this._date = initParams.date;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      setStatus(value) {
        return this.dataService.updateStagingDatabase(this.id, { status: value }, this);
      }
      get status() {
        return this._status;
      }
      set date(value) {
        console.error("Do not set objects this way");
      }
      setDate(value) {
        return this.dataService.updateStagingDatabase(this.id, { date: value }, this);
      }
      get date() {
        return this._date;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateStagingDatabase(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = StagingDatabase;
  }
});

// ../gridduck/dist/models/stripeSession.js
var require_stripeSession = __commonJS({
  "../gridduck/dist/models/stripeSession.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var StripeSession = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "stripeSession";
        this._url = initParams.url;
      }
      set url(value) {
        console.error("Do not set objects this way");
      }
      get url() {
        return this._url;
      }
    };
    exports2.default = StripeSession;
  }
});

// ../gridduck/dist/models/stripeWebhook.js
var require_stripeWebhook = __commonJS({
  "../gridduck/dist/models/stripeWebhook.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var StripeWebhook = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "stripeWebhook";
        this._body = initParams.body;
      }
      set body(value) {
        console.error("Do not set objects this way");
      }
      get body() {
        return this._body;
      }
    };
    exports2.default = StripeWebhook;
  }
});

// ../gridduck/dist/models/tariff.js
var require_tariff = __commonJS({
  "../gridduck/dist/models/tariff.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Tariff = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "tariff";
        this._name = initParams.name;
        this._currency = initParams.currency;
        this._utilityType = initParams.utility_type;
        this._organisationId = initParams.organisation_id;
        this._standingCharge = initParams.standing_charge;
        this._rates = (0, util_1.camelArray)(initParams.rates);
        this._contractStart = initParams.contract_start;
        this._contractEnd = initParams.contract_end;
        this._billingCycleType = initParams.billing_cycle_type;
        this._billingCycleStartDay = initParams.billing_cycle_start_day;
        this._applyContractRange = initParams.apply_contract_range;
        this._applyBillingCycle = initParams.apply_billing_cycle;
        this._siteId = initParams.site_id;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this.__permission = initParams._permission;
      }
      set name(value) {
        console.error("Do not set objects this way");
      }
      setName(value) {
        return this.dataService.updateTariff(this.id, { name: value }, this);
      }
      get name() {
        return this._name;
      }
      set currency(value) {
        console.error("Do not set objects this way");
      }
      setCurrency(value) {
        return this.dataService.updateTariff(this.id, { currency: value }, this);
      }
      get currency() {
        return this._currency;
      }
      set utilityType(value) {
        console.error("Do not set objects this way");
      }
      setUtilityType(value) {
        return this.dataService.updateTariff(this.id, { utility_type: value }, this);
      }
      get utilityType() {
        return this._utilityType;
      }
      set organisationId(value) {
        console.error("Do not set objects this way");
      }
      setOrganisationId(value) {
        return this.dataService.updateTariff(this.id, { organisation_id: value }, this);
      }
      get organisationId() {
        return this._organisationId;
      }
      set standingCharge(value) {
        console.error("Do not set objects this way");
      }
      setStandingCharge(value) {
        return this.dataService.updateTariff(this.id, { standing_charge: value }, this);
      }
      get standingCharge() {
        return this._standingCharge;
      }
      set rates(value) {
        console.error("Do not set objects this way");
      }
      setRates(value) {
        return this.dataService.updateTariff(this.id, { rates: (0, util_1.snakeArray)(value) }, this);
      }
      get rates() {
        return this._rates;
      }
      set contractStart(value) {
        console.error("Do not set objects this way");
      }
      setContractStart(value) {
        return this.dataService.updateTariff(this.id, { contract_start: value }, this);
      }
      get contractStart() {
        return this._contractStart;
      }
      set contractEnd(value) {
        console.error("Do not set objects this way");
      }
      setContractEnd(value) {
        return this.dataService.updateTariff(this.id, { contract_end: value }, this);
      }
      get contractEnd() {
        return this._contractEnd;
      }
      set billingCycleType(value) {
        console.error("Do not set objects this way");
      }
      setBillingCycleType(value) {
        return this.dataService.updateTariff(this.id, { billing_cycle_type: value }, this);
      }
      get billingCycleType() {
        return this._billingCycleType;
      }
      set billingCycleStartDay(value) {
        console.error("Do not set objects this way");
      }
      setBillingCycleStartDay(value) {
        return this.dataService.updateTariff(this.id, { billing_cycle_start_day: value }, this);
      }
      get billingCycleStartDay() {
        return this._billingCycleStartDay;
      }
      set applyContractRange(value) {
        console.error("Do not set objects this way");
      }
      setApplyContractRange(value) {
        return this.dataService.updateTariff(this.id, { apply_contract_range: value }, this);
      }
      get applyContractRange() {
        return this._applyContractRange;
      }
      set applyBillingCycle(value) {
        console.error("Do not set objects this way");
      }
      setApplyBillingCycle(value) {
        return this.dataService.updateTariff(this.id, { apply_billing_cycle: value }, this);
      }
      get applyBillingCycle() {
        return this._applyBillingCycle;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      setSiteId(value) {
        return this.dataService.updateTariff(this.id, { site_id: value }, this);
      }
      get siteId() {
        return this._siteId;
      }
      set siteIds(value) {
        console.error("Do not set objects this way");
      }
      setSiteIds(value) {
        return this.dataService.updateTariff(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
      }
      get siteIds() {
        return this._siteIds;
      }
      set _permission(value) {
        console.error("Do not set objects this way");
      }
      set_permission(value) {
        return this.dataService.updateTariff(this.id, { _permission: value }, this);
      }
      get _permission() {
        return this.__permission;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateTariff(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
      delete() {
        return this.dataService.deleteTariff(this.id, this);
      }
    };
    exports2.default = Tariff;
  }
});

// ../gridduck/dist/models/telemetryOperation.js
var require_telemetryOperation = __commonJS({
  "../gridduck/dist/models/telemetryOperation.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var TelemetryOperation = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "telemetryOperation";
        this._operationType = initParams.operation_type;
        this._parameters = initParams.parameters;
        this._status = initParams.status;
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
      }
      set operationType(value) {
        console.error("Do not set objects this way");
      }
      get operationType() {
        return this._operationType;
      }
      set parameters(value) {
        console.error("Do not set objects this way");
      }
      get parameters() {
        return this._parameters;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set startTs(value) {
        console.error("Do not set objects this way");
      }
      get startTs() {
        return this._startTs;
      }
      set endTs(value) {
        console.error("Do not set objects this way");
      }
      get endTs() {
        return this._endTs;
      }
    };
    exports2.default = TelemetryOperation;
  }
});

// ../gridduck/dist/models/thirdPartyIntegration.js
var require_thirdPartyIntegration = __commonJS({
  "../gridduck/dist/models/thirdPartyIntegration.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ThirdPartyIntegration = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "thirdPartyIntegration";
        this._integrationMetaData = initParams.integration_meta_data;
      }
      set integrationMetaData(value) {
        console.error("Do not set objects this way");
      }
      get integrationMetaData() {
        return this._integrationMetaData;
      }
    };
    exports2.default = ThirdPartyIntegration;
  }
});

// ../gridduck/dist/models/verifyOrgInvite.js
var require_verifyOrgInvite = __commonJS({
  "../gridduck/dist/models/verifyOrgInvite.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var VerifyOrgInvite = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "verifyOrgInvite";
        this._code = initParams.code;
        this._organisationName = initParams.organisation_name;
        this._emailAddress = initParams.email_address;
        this._status = initParams.status;
        this._orgPermission = initParams.org_permission;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
      }
      set code(value) {
        console.error("Do not set objects this way");
      }
      get code() {
        return this._code;
      }
      set organisationName(value) {
        console.error("Do not set objects this way");
      }
      get organisationName() {
        return this._organisationName;
      }
      set emailAddress(value) {
        console.error("Do not set objects this way");
      }
      get emailAddress() {
        return this._emailAddress;
      }
      set status(value) {
        console.error("Do not set objects this way");
      }
      get status() {
        return this._status;
      }
      set orgPermission(value) {
        console.error("Do not set objects this way");
      }
      get orgPermission() {
        return this._orgPermission;
      }
      set logoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      get logoImageThumbnail() {
        return this._logoImageThumbnail;
      }
      set squareLogoImageThumbnail(value) {
        console.error("Do not set objects this way");
      }
      get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
      }
    };
    exports2.default = VerifyOrgInvite;
  }
});

// ../gridduck/dist/models/widgetBoard.js
var require_widgetBoard = __commonJS({
  "../gridduck/dist/models/widgetBoard.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var WidgetBoard = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "widgetBoard";
        this._columnData = initParams.column_data;
        this._columnOrder = (0, util_1.camelArray)(initParams.column_order);
        this._dateData = initParams.date_data;
        this._itemType = initParams.item_type;
        this._itemId = initParams.item_id;
      }
      set columnData(value) {
        console.error("Do not set objects this way");
      }
      setColumnData(value) {
        return this.dataService.updateWidgetBoard(this.id, { column_data: value }, this);
      }
      get columnData() {
        return this._columnData;
      }
      set columnOrder(value) {
        console.error("Do not set objects this way");
      }
      setColumnOrder(value) {
        return this.dataService.updateWidgetBoard(this.id, { column_order: (0, util_1.snakeArray)(value) }, this);
      }
      get columnOrder() {
        return this._columnOrder;
      }
      set dateData(value) {
        console.error("Do not set objects this way");
      }
      setDateData(value) {
        return this.dataService.updateWidgetBoard(this.id, { date_data: value }, this);
      }
      get dateData() {
        return this._dateData;
      }
      set itemType(value) {
        console.error("Do not set objects this way");
      }
      setItemType(value) {
        return this.dataService.updateWidgetBoard(this.id, { item_type: value }, this);
      }
      get itemType() {
        return this._itemType;
      }
      set itemId(value) {
        console.error("Do not set objects this way");
      }
      setItemId(value) {
        return this.dataService.updateWidgetBoard(this.id, { item_id: value }, this);
      }
      get itemId() {
        return this._itemId;
      }
      set(object2) {
        let updateObject = (0, util_1.snakeObject)(object2);
        let self2 = this;
        return this.dataService.updateWidgetBoard(this.id, updateObject, this).then(function(res) {
          Object.keys(object2).forEach(function(key) {
            self2["_" + key] = object2[key];
          });
          return Promise.resolve(res);
        });
      }
    };
    exports2.default = WidgetBoard;
  }
});

// ../gridduck/dist/models/zapierWebhook.js
var require_zapierWebhook = __commonJS({
  "../gridduck/dist/models/zapierWebhook.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ZapierWebhook = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "zapierWebhook";
        this._body = initParams.body;
      }
      set body(value) {
        console.error("Do not set objects this way");
      }
      get body() {
        return this._body;
      }
    };
    exports2.default = ZapierWebhook;
  }
});

// ../gridduck/dist/models/zigbeeFirmware.js
var require_zigbeeFirmware = __commonJS({
  "../gridduck/dist/models/zigbeeFirmware.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var subscribable_1 = __importDefault(require_subscribable());
    var ZigbeeFirmware = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "zigbeeFirmware";
        this._sku = initParams.sku;
        this._version = initParams.version;
      }
      set sku(value) {
        console.error("Do not set objects this way");
      }
      get sku() {
        return this._sku;
      }
      set version(value) {
        console.error("Do not set objects this way");
      }
      get version() {
        return this._version;
      }
    };
    exports2.default = ZigbeeFirmware;
  }
});

// ../gridduck/dist/models/zip.js
var require_zip = __commonJS({
  "../gridduck/dist/models/zip.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var subscribable_1 = __importDefault(require_subscribable());
    var Zip = class extends subscribable_1.default {
      constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = "zip";
        this._siteId = initParams.site_id;
        this._files = (0, util_1.camelArray)(initParams.files);
        this._location = initParams.location;
      }
      set siteId(value) {
        console.error("Do not set objects this way");
      }
      get siteId() {
        return this._siteId;
      }
      set files(value) {
        console.error("Do not set objects this way");
      }
      get files() {
        return this._files;
      }
      set location(value) {
        console.error("Do not set objects this way");
      }
      get location() {
        return this._location;
      }
    };
    exports2.default = Zip;
  }
});

// ../gridduck/dist/services/base-data-service.js
var require_base_data_service = __commonJS({
  "../gridduck/dist/services/base-data-service.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var RESUBSCRIBE_THROTTLE = 100;
    var BaseDataService = class {
      constructor(apiService) {
        this.lastResubscribed = null;
        this.resubscribeTimeout = null;
        this.lists = [];
        this.listPromises = {};
        this.apiService = apiService;
      }
      getVisibleObjects() {
        return [];
      }
      sendResubRequest() {
        if (this.resubscribeTimeout) {
          clearTimeout(this.resubscribeTimeout);
          this.resubscribeTimeout = null;
        }
        this.lastResubscribed = (/* @__PURE__ */ new Date()).getTime();
        this.apiService.setVisibleObjects(this.getVisibleObjects());
      }
      mergeIntoList(array4, object2) {
        let oldObject = object2.id ? array4.find((o) => o.id === object2.id) : null;
        if (oldObject) {
          Object.keys(object2).forEach(function(newKey) {
            if (newKey.substr(0, 1) === "_" && newKey !== "_events" && newKey !== "_eventsCount") {
              oldObject[newKey] = object2[newKey];
            }
          });
          return oldObject;
        } else {
          array4.push(object2);
          return object2;
        }
      }
      resubscribe() {
        let thisDate = (/* @__PURE__ */ new Date()).getTime();
        if (this.resubscribeTimeout === null) {
          if (this.lastResubscribed === null || thisDate - this.lastResubscribed > RESUBSCRIBE_THROTTLE) {
            this.sendResubRequest();
          } else {
            let toWait = RESUBSCRIBE_THROTTLE - (thisDate - this.lastResubscribed);
            let self2 = this;
            this.resubscribeTimeout = setTimeout(function() {
              self2.sendResubRequest();
            }, toWait);
          }
        }
      }
    };
    exports2.default = BaseDataService;
  }
});

// ../gridduck/dist/services/data-service.js
var require_data_service = __commonJS({
  "../gridduck/dist/services/data-service.js"(exports2) {
    "use strict";
    var __awaiter = exports2 && exports2.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var account_1 = __importDefault(require_account());
    var aggregateTelemetry_1 = __importDefault(require_aggregateTelemetry());
    var aggregateTelemetryGroupRequest_1 = __importDefault(require_aggregateTelemetryGroupRequest());
    var anomaly_1 = __importDefault(require_anomaly2());
    var anomalyModel_1 = __importDefault(require_anomalyModel2());
    var applianceCategory_1 = __importDefault(require_applianceCategory());
    var applianceType_1 = __importDefault(require_applianceType());
    var application_1 = __importDefault(require_application());
    var asset_1 = __importDefault(require_asset());
    var assetAggregateDataRequest_1 = __importDefault(require_assetAggregateDataRequest());
    var assetConsumption_1 = __importDefault(require_assetConsumption());
    var assetConsumptionBatch_1 = __importDefault(require_assetConsumptionBatch());
    var assetDemand_1 = __importDefault(require_assetDemand());
    var assetEvent_1 = __importDefault(require_assetEvent());
    var assetGod_1 = __importDefault(require_assetGod());
    var assetIdentification_1 = __importDefault(require_assetIdentification());
    var assetRemoveDataRequest_1 = __importDefault(require_assetRemoveDataRequest());
    var assetReset_1 = __importDefault(require_assetReset());
    var assetTelemetry_1 = __importDefault(require_assetTelemetry());
    var assetTelemetryBatch_1 = __importDefault(require_assetTelemetryBatch());
    var audit_1 = __importDefault(require_audit());
    var availableGateway_1 = __importDefault(require_availableGateway());
    var bounceEmail_1 = __importDefault(require_bounceEmail());
    var calculatorInbound_1 = __importDefault(require_calculatorInbound());
    var calculatorResult_1 = __importDefault(require_calculatorResult());
    var confirmOrgInvite_1 = __importDefault(require_confirmOrgInvite());
    var createReport_1 = __importDefault(require_createReport());
    var customField_1 = __importDefault(require_customField());
    var customFieldData_1 = __importDefault(require_customFieldData());
    var customFieldType_1 = __importDefault(require_customFieldType());
    var data_list_1 = __importDefault(require_data_list());
    var dataCategory_1 = __importDefault(require_dataCategory());
    var dataFileImport_1 = __importDefault(require_dataFileImport());
    var dataFileImportLog_1 = __importDefault(require_dataFileImportLog());
    var dataFileImportUpload_1 = __importDefault(require_dataFileImportUpload());
    var dataRequest_1 = __importDefault(require_dataRequest());
    var dataRequestLink_1 = __importDefault(require_dataRequestLink());
    var dataRequestRun_1 = __importDefault(require_dataRequestRun());
    var dataType_1 = __importDefault(require_dataType());
    var dataUnit_1 = __importDefault(require_dataUnit());
    var dataUpload_1 = __importDefault(require_dataUpload());
    var dcChargePoint_1 = __importDefault(require_dcChargePoint());
    var dcChargeStation_1 = __importDefault(require_dcChargeStation());
    var dcCreateAccount_1 = __importDefault(require_dcCreateAccount());
    var dcRetryPayment_1 = __importDefault(require_dcRetryPayment());
    var dcSession_1 = __importDefault(require_dcSession());
    var detectedDevice_1 = __importDefault(require_detectedDevice());
    var deviceCategory_1 = __importDefault(require_deviceCategory());
    var discount_1 = __importDefault(require_discount());
    var duckChargeAdmin_1 = __importDefault(require_duckChargeAdmin());
    var file_1 = __importDefault(require_file());
    var gaiaConversation_1 = __importDefault(require_gaiaConversation());
    var gaiaMessage_1 = __importDefault(require_gaiaMessage());
    var gateway_1 = __importDefault(require_gateway());
    var gatewayEnhancedLogDownloadRequest_1 = __importDefault(require_gatewayEnhancedLogDownloadRequest());
    var gatewayEvent_1 = __importDefault(require_gatewayEvent());
    var gatewayGod_1 = __importDefault(require_gatewayGod());
    var gatewayLogDownloadRequest_1 = __importDefault(require_gatewayLogDownloadRequest());
    var gatewaySoftwareVersion_1 = __importDefault(require_gatewaySoftwareVersion());
    var gatewayTrustList_1 = __importDefault(require_gatewayTrustList());
    var gatewayTrustedDeviceAnalysis_1 = __importDefault(require_gatewayTrustedDeviceAnalysis());
    var gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require_gatewayTrustedDeviceUntrustRequest());
    var getPhaseBreakdown_1 = __importDefault(require_getPhaseBreakdown());
    var gridduckInvoice_1 = __importDefault(require_gridduckInvoice());
    var gridduckSubscription_1 = __importDefault(require_gridduckSubscription());
    var group_1 = __importDefault(require_group());
    var groupType_1 = __importDefault(require_groupType());
    var ignoredDevice_1 = __importDefault(require_ignoredDevice());
    var inspiredLogin_1 = __importDefault(require_inspiredLogin());
    var instantaneousTelemetry_1 = __importDefault(require_instantaneousTelemetry());
    var invoiceRequest_1 = __importDefault(require_invoiceRequest());
    var invoiceRequestLink_1 = __importDefault(require_invoiceRequestLink());
    var issue_1 = __importDefault(require_issue());
    var itemMetadata_1 = __importDefault(require_itemMetadata());
    var location_1 = __importDefault(require_location());
    var loginAs_1 = __importDefault(require_loginAs());
    var loginAsPartner_1 = __importDefault(require_loginAsPartner());
    var mfaAuthentication_1 = __importDefault(require_mfaAuthentication());
    var mfaSecret_1 = __importDefault(require_mfaSecret());
    var mfaVerification_1 = __importDefault(require_mfaVerification());
    var modbusModel_1 = __importDefault(require_modbusModel());
    var notification_1 = __importDefault(require_notification());
    var occupancySchedule_1 = __importDefault(require_occupancySchedule());
    var order_1 = __importDefault(require_order());
    var orgPartner_1 = __importDefault(require_orgPartner());
    var organisation_1 = __importDefault(require_organisation());
    var organisationInvite_1 = __importDefault(require_organisationInvite());
    var organisationManagement_1 = __importDefault(require_organisationManagement());
    var organisationMember_1 = __importDefault(require_organisationMember());
    var organisationSearch_1 = __importDefault(require_organisationSearch());
    var password_1 = __importDefault(require_password());
    var paymentCard_1 = __importDefault(require_paymentCard());
    var paymentSheet_1 = __importDefault(require_paymentSheet());
    var physicalGateway_1 = __importDefault(require_physicalGateway());
    var places_1 = __importDefault(require_places());
    var preferences_1 = __importDefault(require_preferences());
    var product_1 = __importDefault(require_product());
    var pubOrg_1 = __importDefault(require_pubOrg());
    var rawAggregateData_1 = __importDefault(require_rawAggregateData());
    var report_1 = __importDefault(require_report());
    var reportFile_1 = __importDefault(require_reportFile());
    var reportFileLink_1 = __importDefault(require_reportFileLink());
    var reportHistory_1 = __importDefault(require_reportHistory());
    var requestSecret_1 = __importDefault(require_requestSecret());
    var resetSecret_1 = __importDefault(require_resetSecret());
    var resetToken_1 = __importDefault(require_resetToken());
    var retrieval_params_1 = __importDefault(require_retrieval_params());
    var rule_1 = __importDefault(require_rule());
    var ruleEvent_1 = __importDefault(require_ruleEvent());
    var search_1 = __importDefault(require_search());
    var searchHistory_1 = __importDefault(require_searchHistory());
    var session_1 = __importDefault(require_session());
    var site_1 = __importDefault(require_site());
    var siteGroup_1 = __importDefault(require_siteGroup());
    var sitePermission_1 = __importDefault(require_sitePermission());
    var stagingDatabase_1 = __importDefault(require_stagingDatabase());
    var stripeSession_1 = __importDefault(require_stripeSession());
    var stripeWebhook_1 = __importDefault(require_stripeWebhook());
    var tariff_1 = __importDefault(require_tariff());
    var telemetryOperation_1 = __importDefault(require_telemetryOperation());
    var thirdPartyIntegration_1 = __importDefault(require_thirdPartyIntegration());
    var verifyOrgInvite_1 = __importDefault(require_verifyOrgInvite());
    var widgetBoard_1 = __importDefault(require_widgetBoard());
    var zapierWebhook_1 = __importDefault(require_zapierWebhook());
    var zigbeeFirmware_1 = __importDefault(require_zigbeeFirmware());
    var zip_1 = __importDefault(require_zip());
    var base_data_service_1 = __importDefault(require_base_data_service());
    var util_1 = require_util2();
    var DataService = class extends base_data_service_1.default {
      constructor(apiService, emitter) {
        super(apiService);
        this.assets = [];
        this.assetGetters = {};
        this.gateways = [];
        this.gatewayGetters = {};
        this.gatewaySoftwareVersions = [];
        this.gatewaySoftwareVersionGetters = {};
        this.sites = [];
        this.siteGetters = {};
        this.orders = [];
        this.orderGetters = {};
        this.sessions = [];
        this.sessionGetters = {};
        this.discounts = [];
        this.discountGetters = {};
        this.stripeSessions = [];
        this.stripeSessionGetters = {};
        this.stripeWebhooks = [];
        this.stripeWebhookGetters = {};
        this.zapierWebhooks = [];
        this.zapierWebhookGetters = {};
        this.placess = [];
        this.placesGetters = {};
        this.products = [];
        this.productGetters = {};
        this.modbusModels = [];
        this.modbusModelGetters = {};
        this.occupancySchedules = [];
        this.occupancyScheduleGetters = {};
        this.pubOrgs = [];
        this.pubOrgGetters = {};
        this.organisations = [];
        this.organisationGetters = {};
        this.paymentCards = [];
        this.paymentCardGetters = {};
        this.assetEvents = [];
        this.assetEventGetters = {};
        this.gatewayEvents = [];
        this.gatewayEventGetters = {};
        this.assetTelemetrys = [];
        this.assetTelemetryGetters = {};
        this.rules = [];
        this.ruleGetters = {};
        this.dataRequests = [];
        this.dataRequestGetters = {};
        this.dataRequestLinks = [];
        this.dataRequestLinkGetters = {};
        this.dataRequestRuns = [];
        this.dataRequestRunGetters = {};
        this.invoiceRequests = [];
        this.invoiceRequestGetters = {};
        this.invoiceRequestLinks = [];
        this.invoiceRequestLinkGetters = {};
        this.siteGroups = [];
        this.siteGroupGetters = {};
        this.groups = [];
        this.groupGetters = {};
        this.duckChargeAdmins = [];
        this.duckChargeAdminGetters = {};
        this.customFieldTypes = [];
        this.customFieldTypeGetters = {};
        this.customFields = [];
        this.customFieldGetters = {};
        this.locations = [];
        this.locationGetters = {};
        this.searchHistorys = [];
        this.searchHistoryGetters = {};
        this.tariffs = [];
        this.tariffGetters = {};
        this.groupTypes = [];
        this.groupTypeGetters = {};
        this.calculatorInbounds = [];
        this.calculatorInboundGetters = {};
        this.calculatorResults = [];
        this.calculatorResultGetters = {};
        this.createReports = [];
        this.createReportGetters = {};
        this.reportHistorys = [];
        this.reportHistoryGetters = {};
        this.reports = [];
        this.reportGetters = {};
        this.reportFiles = [];
        this.reportFileGetters = {};
        this.gaiaConversations = [];
        this.gaiaConversationGetters = {};
        this.gaiaMessages = [];
        this.gaiaMessageGetters = {};
        this.dataCategorys = [];
        this.dataCategoryGetters = {};
        this.dataTypes = [];
        this.dataTypeGetters = {};
        this.deviceCategorys = [];
        this.deviceCategoryGetters = {};
        this.widgetBoards = [];
        this.widgetBoardGetters = {};
        this.reportFileLinks = [];
        this.reportFileLinkGetters = {};
        this.ruleEvents = [];
        this.ruleEventGetters = {};
        this.audits = [];
        this.auditGetters = {};
        this.applications = [];
        this.applicationGetters = {};
        this.anomalyModels = [];
        this.anomalyModelGetters = {};
        this.anomalys = [];
        this.anomalyGetters = {};
        this.gridduckSubscriptions = [];
        this.gridduckSubscriptionGetters = {};
        this.gridduckInvoices = [];
        this.gridduckInvoiceGetters = {};
        this.accounts = [];
        this.accountGetters = {};
        this.customFieldDatas = [];
        this.customFieldDataGetters = {};
        this.preferencess = [];
        this.preferencesGetters = {};
        this.dcRetryPayments = [];
        this.dcRetryPaymentGetters = {};
        this.issues = [];
        this.issueGetters = {};
        this.ignoredDevices = [];
        this.ignoredDeviceGetters = {};
        this.resetSecrets = [];
        this.resetSecretGetters = {};
        this.requestSecrets = [];
        this.requestSecretGetters = {};
        this.assetIdentifications = [];
        this.assetIdentificationGetters = {};
        this.getPhaseBreakdowns = [];
        this.getPhaseBreakdownGetters = {};
        this.availableGateways = [];
        this.availableGatewayGetters = {};
        this.assetDemands = [];
        this.assetDemandGetters = {};
        this.assetConsumptions = [];
        this.assetConsumptionGetters = {};
        this.physicalGateways = [];
        this.physicalGatewayGetters = {};
        this.sitePermissions = [];
        this.sitePermissionGetters = {};
        this.applianceCategorys = [];
        this.applianceCategoryGetters = {};
        this.applianceTypes = [];
        this.applianceTypeGetters = {};
        this.dataUploads = [];
        this.dataUploadGetters = {};
        this.files = [];
        this.fileGetters = {};
        this.zips = [];
        this.zipGetters = {};
        this.searchs = [];
        this.searchGetters = {};
        this.verifyOrgInvites = [];
        this.verifyOrgInviteGetters = {};
        this.confirmOrgInvites = [];
        this.confirmOrgInviteGetters = {};
        this.dcCreateAccounts = [];
        this.dcCreateAccountGetters = {};
        this.dcSessions = [];
        this.dcSessionGetters = {};
        this.paymentSheets = [];
        this.paymentSheetGetters = {};
        this.dcChargePoints = [];
        this.dcChargePointGetters = {};
        this.dcChargeStations = [];
        this.dcChargeStationGetters = {};
        this.organisationInvites = [];
        this.organisationInviteGetters = {};
        this.organisationMembers = [];
        this.organisationMemberGetters = {};
        this.detectedDevices = [];
        this.detectedDeviceGetters = {};
        this.resetTokens = [];
        this.resetTokenGetters = {};
        this.passwords = [];
        this.passwordGetters = {};
        this.thirdPartyIntegrations = [];
        this.thirdPartyIntegrationGetters = {};
        this.orgPartners = [];
        this.orgPartnerGetters = {};
        this.mfaSecrets = [];
        this.mfaSecretGetters = {};
        this.mfaVerifications = [];
        this.mfaVerificationGetters = {};
        this.mfaAuthentications = [];
        this.mfaAuthenticationGetters = {};
        this.loginAss = [];
        this.loginAsGetters = {};
        this.loginAsPartners = [];
        this.loginAsPartnerGetters = {};
        this.organisationManagements = [];
        this.organisationManagementGetters = {};
        this.stagingDatabases = [];
        this.stagingDatabaseGetters = {};
        this.notifications = [];
        this.notificationGetters = {};
        this.zigbeeFirmwares = [];
        this.zigbeeFirmwareGetters = {};
        this.gatewayTrustLists = [];
        this.gatewayTrustListGetters = {};
        this.gatewayTrustedDeviceUntrustRequests = [];
        this.gatewayTrustedDeviceUntrustRequestGetters = {};
        this.telemetryOperations = [];
        this.telemetryOperationGetters = {};
        this.aggregateTelemetryGroupRequests = [];
        this.aggregateTelemetryGroupRequestGetters = {};
        this.assetRemoveDataRequests = [];
        this.assetRemoveDataRequestGetters = {};
        this.assetAggregateDataRequests = [];
        this.assetAggregateDataRequestGetters = {};
        this.gatewayTrustedDeviceAnalysiss = [];
        this.gatewayTrustedDeviceAnalysisGetters = {};
        this.aggregateTelemetrys = [];
        this.aggregateTelemetryGetters = {};
        this.instantaneousTelemetrys = [];
        this.instantaneousTelemetryGetters = {};
        this.organisationSearchs = [];
        this.organisationSearchGetters = {};
        this.gatewayLogDownloadRequests = [];
        this.gatewayLogDownloadRequestGetters = {};
        this.gatewayEnhancedLogDownloadRequests = [];
        this.gatewayEnhancedLogDownloadRequestGetters = {};
        this.gatewayGods = [];
        this.gatewayGodGetters = {};
        this.assetGods = [];
        this.assetGodGetters = {};
        this.assetTelemetryBatchs = [];
        this.assetTelemetryBatchGetters = {};
        this.assetConsumptionBatchs = [];
        this.assetConsumptionBatchGetters = {};
        this.rawAggregateDatas = [];
        this.rawAggregateDataGetters = {};
        this.assetResets = [];
        this.assetResetGetters = {};
        this.inspiredLogins = [];
        this.inspiredLoginGetters = {};
        this.dataUnits = [];
        this.dataUnitGetters = {};
        this.itemMetadatas = [];
        this.itemMetadataGetters = {};
        this.bounceEmails = [];
        this.bounceEmailGetters = {};
        this.dataFileImports = [];
        this.dataFileImportGetters = {};
        this.dataFileImportLogs = [];
        this.dataFileImportLogGetters = {};
        this.dataFileImportUploads = [];
        this.dataFileImportUploadGetters = {};
        this.emitter = emitter;
        let self2 = this;
        this.apiService.onLoggedIn(this.clearLists.bind(this));
        this.apiService.onOpenConnectionCallback(this.resync.bind(this));
      }
      getAssets(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "asset" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssets(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new asset_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assets, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "asset", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAsset(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.assets.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.assetGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAsset(paramsIn).then(function(object2) {
            return new asset_1.default(self2, object2);
          });
        } else {
          this.assetGetters[paramsIn.id] = this.apiService.getAsset(paramsIn).then(function(object2) {
            delete self2.assetGetters[paramsIn.id];
            let newItem = new asset_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.assets, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.assetGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.assetGetters[paramsIn.id];
        }
      }
      createAsset(newItem) {
        let self2 = this;
        return this.apiService.createAsset(newItem).then(function(newObj) {
          let item = new asset_1.default(self2, newObj);
          self2.assets.push(item);
          return Promise.resolve(item);
        });
      }
      deleteAsset(itemId, item) {
        let self2 = this;
        return this.apiService.deleteAsset(itemId, item).then(function() {
          let existingModel = self2.assets.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.assets.splice(self2.assets.indexOf(existingModel), 1);
          }
        });
      }
      updateAsset(itemId, updateObj, item) {
        return this.apiService.updateAsset(itemId, updateObj, item);
      }
      getGateways(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gateway" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGateways(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gateway_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gateways, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gateway", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGateway(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gateways.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gatewayGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGateway(paramsIn).then(function(object2) {
            return new gateway_1.default(self2, object2);
          });
        } else {
          this.gatewayGetters[paramsIn.id] = this.apiService.getGateway(paramsIn).then(function(object2) {
            delete self2.gatewayGetters[paramsIn.id];
            let newItem = new gateway_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gateways, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gatewayGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gatewayGetters[paramsIn.id];
        }
      }
      createGateway(newItem) {
        let self2 = this;
        return this.apiService.createGateway(newItem).then(function(newObj) {
          let item = new gateway_1.default(self2, newObj);
          self2.gateways.push(item);
          return Promise.resolve(item);
        });
      }
      deleteGateway(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGateway(itemId, item).then(function() {
          let existingModel = self2.gateways.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.gateways.splice(self2.gateways.indexOf(existingModel), 1);
          }
        });
      }
      updateGateway(itemId, updateObj, item) {
        return this.apiService.updateGateway(itemId, updateObj, item);
      }
      getGatewaySoftwareVersions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gatewaySoftwareVersion" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGatewaySoftwareVersions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gatewaySoftwareVersion_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gatewaySoftwareVersions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gatewaySoftwareVersion", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGatewaySoftwareVersion(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gatewaySoftwareVersions.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gatewaySoftwareVersionGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGatewaySoftwareVersion(paramsIn).then(function(object2) {
            return new gatewaySoftwareVersion_1.default(self2, object2);
          });
        } else {
          this.gatewaySoftwareVersionGetters[paramsIn.id] = this.apiService.getGatewaySoftwareVersion(paramsIn).then(function(object2) {
            delete self2.gatewaySoftwareVersionGetters[paramsIn.id];
            let newItem = new gatewaySoftwareVersion_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gatewaySoftwareVersions, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gatewaySoftwareVersionGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gatewaySoftwareVersionGetters[paramsIn.id];
        }
      }
      updateGatewaySoftwareVersion(itemId, updateObj, item) {
        return this.apiService.updateGatewaySoftwareVersion(itemId, updateObj, item);
      }
      getSites(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "site" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSites(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new site_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.sites, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "site", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getSite(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.sites.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.siteGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getSite(paramsIn).then(function(object2) {
            return new site_1.default(self2, object2);
          });
        } else {
          this.siteGetters[paramsIn.id] = this.apiService.getSite(paramsIn).then(function(object2) {
            delete self2.siteGetters[paramsIn.id];
            let newItem = new site_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.sites, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.siteGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.siteGetters[paramsIn.id];
        }
      }
      createSite(newItem) {
        let self2 = this;
        return this.apiService.createSite(newItem).then(function(newObj) {
          let item = new site_1.default(self2, newObj);
          self2.sites.push(item);
          return Promise.resolve(item);
        });
      }
      deleteSite(itemId, item) {
        let self2 = this;
        return this.apiService.deleteSite(itemId, item).then(function() {
          let existingModel = self2.sites.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.sites.splice(self2.sites.indexOf(existingModel), 1);
          }
        });
      }
      updateSite(itemId, updateObj, item) {
        return this.apiService.updateSite(itemId, updateObj, item);
      }
      getOrders(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "order" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrders(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new order_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.orders, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "order", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createOrder(newItem) {
        let self2 = this;
        return this.apiService.createOrder(newItem).then(function(newObj) {
          let item = new order_1.default(self2, newObj);
          self2.orders.push(item);
          return Promise.resolve(item);
        });
      }
      getSessions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "session" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSessions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new session_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.sessions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "session", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getSession(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.sessions.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.sessionGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getSession(paramsIn).then(function(object2) {
            return new session_1.default(self2, object2);
          });
        } else {
          this.sessionGetters[paramsIn.id] = this.apiService.getSession(paramsIn).then(function(object2) {
            delete self2.sessionGetters[paramsIn.id];
            let newItem = new session_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.sessions, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.sessionGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.sessionGetters[paramsIn.id];
        }
      }
      createSession(newItem) {
        let self2 = this;
        return this.apiService.createSession(newItem).then(function(newObj) {
          let item = new session_1.default(self2, newObj);
          self2.sessions.push(item);
          return Promise.resolve(item);
        });
      }
      deleteSession(itemId, item) {
        let self2 = this;
        return this.apiService.deleteSession(itemId, item).then(function() {
          let existingModel = self2.sessions.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.sessions.splice(self2.sessions.indexOf(existingModel), 1);
          }
        });
      }
      updateSession(itemId, updateObj, item) {
        return this.apiService.updateSession(itemId, updateObj, item);
      }
      getDiscounts(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "discount" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDiscounts(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new discount_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.discounts, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "discount", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createStripeSession(newItem) {
        let self2 = this;
        return this.apiService.createStripeSession(newItem).then(function(newObj) {
          let item = new stripeSession_1.default(self2, newObj);
          self2.stripeSessions.push(item);
          return Promise.resolve(item);
        });
      }
      createStripeWebhook(newItem) {
        let self2 = this;
        return this.apiService.createStripeWebhook(newItem).then(function(newObj) {
          let item = new stripeWebhook_1.default(self2, newObj);
          self2.stripeWebhooks.push(item);
          return Promise.resolve(item);
        });
      }
      createZapierWebhook(newItem) {
        let self2 = this;
        return this.apiService.createZapierWebhook(newItem).then(function(newObj) {
          let item = new zapierWebhook_1.default(self2, newObj);
          self2.zapierWebhooks.push(item);
          return Promise.resolve(item);
        });
      }
      getPlacess(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "places" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getPlacess(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new places_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.placess, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "places", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getPlaces(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.placess.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.placesGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getPlaces(paramsIn).then(function(object2) {
            return new places_1.default(self2, object2);
          });
        } else {
          this.placesGetters[paramsIn.id] = this.apiService.getPlaces(paramsIn).then(function(object2) {
            delete self2.placesGetters[paramsIn.id];
            let newItem = new places_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.placess, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.placesGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.placesGetters[paramsIn.id];
        }
      }
      getProducts(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "product" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getProducts(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new product_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.products, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "product", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getModbusModels(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "modbusModel" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getModbusModels(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new modbusModel_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.modbusModels, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "modbusModel", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getModbusModel(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.modbusModels.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.modbusModelGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getModbusModel(paramsIn).then(function(object2) {
            return new modbusModel_1.default(self2, object2);
          });
        } else {
          this.modbusModelGetters[paramsIn.id] = this.apiService.getModbusModel(paramsIn).then(function(object2) {
            delete self2.modbusModelGetters[paramsIn.id];
            let newItem = new modbusModel_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.modbusModels, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.modbusModelGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.modbusModelGetters[paramsIn.id];
        }
      }
      createModbusModel(newItem) {
        let self2 = this;
        return this.apiService.createModbusModel(newItem).then(function(newObj) {
          let item = new modbusModel_1.default(self2, newObj);
          self2.modbusModels.push(item);
          return Promise.resolve(item);
        });
      }
      deleteModbusModel(itemId, item) {
        let self2 = this;
        return this.apiService.deleteModbusModel(itemId, item).then(function() {
          let existingModel = self2.modbusModels.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.modbusModels.splice(self2.modbusModels.indexOf(existingModel), 1);
          }
        });
      }
      updateModbusModel(itemId, updateObj, item) {
        return this.apiService.updateModbusModel(itemId, updateObj, item);
      }
      getOccupancySchedules(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "occupancySchedule" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOccupancySchedules(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new occupancySchedule_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.occupancySchedules, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "occupancySchedule", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getOccupancySchedule(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.occupancySchedules.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.occupancyScheduleGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getOccupancySchedule(paramsIn).then(function(object2) {
            return new occupancySchedule_1.default(self2, object2);
          });
        } else {
          this.occupancyScheduleGetters[paramsIn.id] = this.apiService.getOccupancySchedule(paramsIn).then(function(object2) {
            delete self2.occupancyScheduleGetters[paramsIn.id];
            let newItem = new occupancySchedule_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.occupancySchedules, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.occupancyScheduleGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.occupancyScheduleGetters[paramsIn.id];
        }
      }
      createOccupancySchedule(newItem) {
        let self2 = this;
        return this.apiService.createOccupancySchedule(newItem).then(function(newObj) {
          let item = new occupancySchedule_1.default(self2, newObj);
          self2.occupancySchedules.push(item);
          return Promise.resolve(item);
        });
      }
      deleteOccupancySchedule(itemId, item) {
        let self2 = this;
        return this.apiService.deleteOccupancySchedule(itemId, item).then(function() {
          let existingModel = self2.occupancySchedules.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.occupancySchedules.splice(self2.occupancySchedules.indexOf(existingModel), 1);
          }
        });
      }
      updateOccupancySchedule(itemId, updateObj, item) {
        return this.apiService.updateOccupancySchedule(itemId, updateObj, item);
      }
      createPubOrg(newItem) {
        let self2 = this;
        return this.apiService.createPubOrg(newItem).then(function(newObj) {
          let item = new pubOrg_1.default(self2, newObj);
          self2.pubOrgs.push(item);
          return Promise.resolve(item);
        });
      }
      getOrganisation(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.organisations.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.organisationGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getOrganisation(paramsIn).then(function(object2) {
            return new organisation_1.default(self2, object2);
          });
        } else {
          this.organisationGetters[paramsIn.id] = this.apiService.getOrganisation(paramsIn).then(function(object2) {
            delete self2.organisationGetters[paramsIn.id];
            let newItem = new organisation_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.organisations, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.organisationGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.organisationGetters[paramsIn.id];
        }
      }
      updateOrganisation(itemId, updateObj, item) {
        return this.apiService.updateOrganisation(itemId, updateObj, item);
      }
      getPaymentCards(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "paymentCard" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getPaymentCards(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new paymentCard_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.paymentCards, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "paymentCard", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getPaymentCard(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.paymentCards.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.paymentCardGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getPaymentCard(paramsIn).then(function(object2) {
            return new paymentCard_1.default(self2, object2);
          });
        } else {
          this.paymentCardGetters[paramsIn.id] = this.apiService.getPaymentCard(paramsIn).then(function(object2) {
            delete self2.paymentCardGetters[paramsIn.id];
            let newItem = new paymentCard_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.paymentCards, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.paymentCardGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.paymentCardGetters[paramsIn.id];
        }
      }
      createPaymentCard(newItem) {
        let self2 = this;
        return this.apiService.createPaymentCard(newItem).then(function(newObj) {
          let item = new paymentCard_1.default(self2, newObj);
          self2.paymentCards.push(item);
          return Promise.resolve(item);
        });
      }
      deletePaymentCard(itemId, item) {
        let self2 = this;
        return this.apiService.deletePaymentCard(itemId, item).then(function() {
          let existingModel = self2.paymentCards.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.paymentCards.splice(self2.paymentCards.indexOf(existingModel), 1);
          }
        });
      }
      updatePaymentCard(itemId, updateObj, item) {
        return this.apiService.updatePaymentCard(itemId, updateObj, item);
      }
      getAssetEvents(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetEvent" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetEvents(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetEvent_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetEvents, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetEvent", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGatewayEvents(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gatewayEvent" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGatewayEvents(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gatewayEvent_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gatewayEvents, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gatewayEvent", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAssetTelemetrys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetTelemetry" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetTelemetrys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetTelemetry_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetTelemetrys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetTelemetry", true);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getRules(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "rule" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getRules(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new rule_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.rules, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "rule", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getRule(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.rules.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.ruleGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getRule(paramsIn).then(function(object2) {
            return new rule_1.default(self2, object2);
          });
        } else {
          this.ruleGetters[paramsIn.id] = this.apiService.getRule(paramsIn).then(function(object2) {
            delete self2.ruleGetters[paramsIn.id];
            let newItem = new rule_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.rules, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.ruleGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.ruleGetters[paramsIn.id];
        }
      }
      createRule(newItem) {
        let self2 = this;
        return this.apiService.createRule(newItem).then(function(newObj) {
          let item = new rule_1.default(self2, newObj);
          self2.rules.push(item);
          return Promise.resolve(item);
        });
      }
      deleteRule(itemId, item) {
        let self2 = this;
        return this.apiService.deleteRule(itemId, item).then(function() {
          let existingModel = self2.rules.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.rules.splice(self2.rules.indexOf(existingModel), 1);
          }
        });
      }
      updateRule(itemId, updateObj, item) {
        return this.apiService.updateRule(itemId, updateObj, item);
      }
      getDataRequests(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataRequest" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataRequests(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataRequest_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataRequests, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataRequest", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataRequest(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataRequests.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataRequestGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataRequest(paramsIn).then(function(object2) {
            return new dataRequest_1.default(self2, object2);
          });
        } else {
          this.dataRequestGetters[paramsIn.id] = this.apiService.getDataRequest(paramsIn).then(function(object2) {
            delete self2.dataRequestGetters[paramsIn.id];
            let newItem = new dataRequest_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataRequests, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataRequestGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataRequestGetters[paramsIn.id];
        }
      }
      createDataRequest(newItem) {
        let self2 = this;
        return this.apiService.createDataRequest(newItem).then(function(newObj) {
          let item = new dataRequest_1.default(self2, newObj);
          self2.dataRequests.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDataRequest(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDataRequest(itemId, item).then(function() {
          let existingModel = self2.dataRequests.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dataRequests.splice(self2.dataRequests.indexOf(existingModel), 1);
          }
        });
      }
      updateDataRequest(itemId, updateObj, item) {
        return this.apiService.updateDataRequest(itemId, updateObj, item);
      }
      createDataRequestLink(newItem) {
        let self2 = this;
        return this.apiService.createDataRequestLink(newItem).then(function(newObj) {
          let item = new dataRequestLink_1.default(self2, newObj);
          self2.dataRequestLinks.push(item);
          return Promise.resolve(item);
        });
      }
      createDataRequestRun(newItem) {
        let self2 = this;
        return this.apiService.createDataRequestRun(newItem).then(function(newObj) {
          let item = new dataRequestRun_1.default(self2, newObj);
          self2.dataRequestRuns.push(item);
          return Promise.resolve(item);
        });
      }
      getInvoiceRequests(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "invoiceRequest" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getInvoiceRequests(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new invoiceRequest_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.invoiceRequests, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "invoiceRequest", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getInvoiceRequest(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.invoiceRequests.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.invoiceRequestGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getInvoiceRequest(paramsIn).then(function(object2) {
            return new invoiceRequest_1.default(self2, object2);
          });
        } else {
          this.invoiceRequestGetters[paramsIn.id] = this.apiService.getInvoiceRequest(paramsIn).then(function(object2) {
            delete self2.invoiceRequestGetters[paramsIn.id];
            let newItem = new invoiceRequest_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.invoiceRequests, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.invoiceRequestGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.invoiceRequestGetters[paramsIn.id];
        }
      }
      createInvoiceRequest(newItem) {
        let self2 = this;
        return this.apiService.createInvoiceRequest(newItem).then(function(newObj) {
          let item = new invoiceRequest_1.default(self2, newObj);
          self2.invoiceRequests.push(item);
          return Promise.resolve(item);
        });
      }
      deleteInvoiceRequest(itemId, item) {
        let self2 = this;
        return this.apiService.deleteInvoiceRequest(itemId, item).then(function() {
          let existingModel = self2.invoiceRequests.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.invoiceRequests.splice(self2.invoiceRequests.indexOf(existingModel), 1);
          }
        });
      }
      createInvoiceRequestLink(newItem) {
        let self2 = this;
        return this.apiService.createInvoiceRequestLink(newItem).then(function(newObj) {
          let item = new invoiceRequestLink_1.default(self2, newObj);
          self2.invoiceRequestLinks.push(item);
          return Promise.resolve(item);
        });
      }
      getSiteGroups(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "siteGroup" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSiteGroups(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new siteGroup_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.siteGroups, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "siteGroup", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getSiteGroup(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.siteGroups.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.siteGroupGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getSiteGroup(paramsIn).then(function(object2) {
            return new siteGroup_1.default(self2, object2);
          });
        } else {
          this.siteGroupGetters[paramsIn.id] = this.apiService.getSiteGroup(paramsIn).then(function(object2) {
            delete self2.siteGroupGetters[paramsIn.id];
            let newItem = new siteGroup_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.siteGroups, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.siteGroupGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.siteGroupGetters[paramsIn.id];
        }
      }
      createSiteGroup(newItem) {
        let self2 = this;
        return this.apiService.createSiteGroup(newItem).then(function(newObj) {
          let item = new siteGroup_1.default(self2, newObj);
          self2.siteGroups.push(item);
          return Promise.resolve(item);
        });
      }
      deleteSiteGroup(itemId, item) {
        let self2 = this;
        return this.apiService.deleteSiteGroup(itemId, item).then(function() {
          let existingModel = self2.siteGroups.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.siteGroups.splice(self2.siteGroups.indexOf(existingModel), 1);
          }
        });
      }
      updateSiteGroup(itemId, updateObj, item) {
        return this.apiService.updateSiteGroup(itemId, updateObj, item);
      }
      getGroups(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "group" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGroups(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new group_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.groups, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "group", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGroup(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.groups.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.groupGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGroup(paramsIn).then(function(object2) {
            return new group_1.default(self2, object2);
          });
        } else {
          this.groupGetters[paramsIn.id] = this.apiService.getGroup(paramsIn).then(function(object2) {
            delete self2.groupGetters[paramsIn.id];
            let newItem = new group_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.groups, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.groupGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.groupGetters[paramsIn.id];
        }
      }
      createGroup(newItem) {
        let self2 = this;
        return this.apiService.createGroup(newItem).then(function(newObj) {
          let item = new group_1.default(self2, newObj);
          self2.groups.push(item);
          return Promise.resolve(item);
        });
      }
      deleteGroup(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGroup(itemId, item).then(function() {
          let existingModel = self2.groups.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.groups.splice(self2.groups.indexOf(existingModel), 1);
          }
        });
      }
      updateGroup(itemId, updateObj, item) {
        return this.apiService.updateGroup(itemId, updateObj, item);
      }
      getDuckChargeAdmins(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "duckChargeAdmin" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDuckChargeAdmins(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new duckChargeAdmin_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.duckChargeAdmins, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "duckChargeAdmin", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getCustomFieldTypes(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "customFieldType" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getCustomFieldTypes(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new customFieldType_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.customFieldTypes, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "customFieldType", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createCustomFieldType(newItem) {
        let self2 = this;
        return this.apiService.createCustomFieldType(newItem).then(function(newObj) {
          let item = new customFieldType_1.default(self2, newObj);
          self2.customFieldTypes.push(item);
          return Promise.resolve(item);
        });
      }
      deleteCustomFieldType(itemId, item) {
        let self2 = this;
        return this.apiService.deleteCustomFieldType(itemId, item).then(function() {
          let existingModel = self2.customFieldTypes.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.customFieldTypes.splice(self2.customFieldTypes.indexOf(existingModel), 1);
          }
        });
      }
      updateCustomFieldType(itemId, updateObj, item) {
        return this.apiService.updateCustomFieldType(itemId, updateObj, item);
      }
      getCustomFields(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "customField" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getCustomFields(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new customField_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.customFields, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "customField", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createCustomField(newItem) {
        let self2 = this;
        return this.apiService.createCustomField(newItem).then(function(newObj) {
          let item = new customField_1.default(self2, newObj);
          self2.customFields.push(item);
          return Promise.resolve(item);
        });
      }
      deleteCustomField(itemId, item) {
        let self2 = this;
        return this.apiService.deleteCustomField(itemId, item).then(function() {
          let existingModel = self2.customFields.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.customFields.splice(self2.customFields.indexOf(existingModel), 1);
          }
        });
      }
      updateCustomField(itemId, updateObj, item) {
        return this.apiService.updateCustomField(itemId, updateObj, item);
      }
      getLocations(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "location" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getLocations(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new location_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.locations, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "location", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createLocation(newItem) {
        let self2 = this;
        return this.apiService.createLocation(newItem).then(function(newObj) {
          let item = new location_1.default(self2, newObj);
          self2.locations.push(item);
          return Promise.resolve(item);
        });
      }
      deleteLocation(itemId, item) {
        let self2 = this;
        return this.apiService.deleteLocation(itemId, item).then(function() {
          let existingModel = self2.locations.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.locations.splice(self2.locations.indexOf(existingModel), 1);
          }
        });
      }
      updateLocation(itemId, updateObj, item) {
        return this.apiService.updateLocation(itemId, updateObj, item);
      }
      getSearchHistorys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "searchHistory" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSearchHistorys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new searchHistory_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.searchHistorys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "searchHistory", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createSearchHistory(newItem) {
        let self2 = this;
        return this.apiService.createSearchHistory(newItem).then(function(newObj) {
          let item = new searchHistory_1.default(self2, newObj);
          self2.searchHistorys.push(item);
          return Promise.resolve(item);
        });
      }
      deleteSearchHistory(itemId, item) {
        let self2 = this;
        return this.apiService.deleteSearchHistory(itemId, item).then(function() {
          let existingModel = self2.searchHistorys.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.searchHistorys.splice(self2.searchHistorys.indexOf(existingModel), 1);
          }
        });
      }
      getTariffs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "tariff" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getTariffs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new tariff_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.tariffs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "tariff", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getTariff(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.tariffs.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.tariffGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getTariff(paramsIn).then(function(object2) {
            return new tariff_1.default(self2, object2);
          });
        } else {
          this.tariffGetters[paramsIn.id] = this.apiService.getTariff(paramsIn).then(function(object2) {
            delete self2.tariffGetters[paramsIn.id];
            let newItem = new tariff_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.tariffs, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.tariffGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.tariffGetters[paramsIn.id];
        }
      }
      createTariff(newItem) {
        let self2 = this;
        return this.apiService.createTariff(newItem).then(function(newObj) {
          let item = new tariff_1.default(self2, newObj);
          self2.tariffs.push(item);
          return Promise.resolve(item);
        });
      }
      deleteTariff(itemId, item) {
        let self2 = this;
        return this.apiService.deleteTariff(itemId, item).then(function() {
          let existingModel = self2.tariffs.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.tariffs.splice(self2.tariffs.indexOf(existingModel), 1);
          }
        });
      }
      updateTariff(itemId, updateObj, item) {
        return this.apiService.updateTariff(itemId, updateObj, item);
      }
      getGroupTypes(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "groupType" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGroupTypes(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new groupType_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.groupTypes, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "groupType", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createGroupType(newItem) {
        let self2 = this;
        return this.apiService.createGroupType(newItem).then(function(newObj) {
          let item = new groupType_1.default(self2, newObj);
          self2.groupTypes.push(item);
          return Promise.resolve(item);
        });
      }
      deleteGroupType(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGroupType(itemId, item).then(function() {
          let existingModel = self2.groupTypes.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.groupTypes.splice(self2.groupTypes.indexOf(existingModel), 1);
          }
        });
      }
      updateGroupType(itemId, updateObj, item) {
        return this.apiService.updateGroupType(itemId, updateObj, item);
      }
      createCalculatorInbound(newItem) {
        let self2 = this;
        return this.apiService.createCalculatorInbound(newItem).then(function(newObj) {
          let item = new calculatorInbound_1.default(self2, newObj);
          self2.calculatorInbounds.push(item);
          return Promise.resolve(item);
        });
      }
      createCalculatorResult(newItem) {
        let self2 = this;
        return this.apiService.createCalculatorResult(newItem).then(function(newObj) {
          let item = new calculatorResult_1.default(self2, newObj);
          self2.calculatorResults.push(item);
          return Promise.resolve(item);
        });
      }
      createCreateReport(newItem) {
        let self2 = this;
        return this.apiService.createCreateReport(newItem).then(function(newObj) {
          let item = new createReport_1.default(self2, newObj);
          self2.createReports.push(item);
          return Promise.resolve(item);
        });
      }
      getReportHistorys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "reportHistory" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getReportHistorys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new reportHistory_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.reportHistorys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "reportHistory", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getReports(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "report" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getReports(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new report_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.reports, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "report", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getReport(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.reports.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.reportGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getReport(paramsIn).then(function(object2) {
            return new report_1.default(self2, object2);
          });
        } else {
          this.reportGetters[paramsIn.id] = this.apiService.getReport(paramsIn).then(function(object2) {
            delete self2.reportGetters[paramsIn.id];
            let newItem = new report_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.reports, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.reportGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.reportGetters[paramsIn.id];
        }
      }
      createReport(newItem) {
        let self2 = this;
        return this.apiService.createReport(newItem).then(function(newObj) {
          let item = new report_1.default(self2, newObj);
          self2.reports.push(item);
          return Promise.resolve(item);
        });
      }
      deleteReport(itemId, item) {
        let self2 = this;
        return this.apiService.deleteReport(itemId, item).then(function() {
          let existingModel = self2.reports.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.reports.splice(self2.reports.indexOf(existingModel), 1);
          }
        });
      }
      updateReport(itemId, updateObj, item) {
        return this.apiService.updateReport(itemId, updateObj, item);
      }
      getReportFiles(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "reportFile" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getReportFiles(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new reportFile_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.reportFiles, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "reportFile", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGaiaConversations(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gaiaConversation" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGaiaConversations(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gaiaConversation_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gaiaConversations, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gaiaConversation", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGaiaConversation(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gaiaConversations.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gaiaConversationGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGaiaConversation(paramsIn).then(function(object2) {
            return new gaiaConversation_1.default(self2, object2);
          });
        } else {
          this.gaiaConversationGetters[paramsIn.id] = this.apiService.getGaiaConversation(paramsIn).then(function(object2) {
            delete self2.gaiaConversationGetters[paramsIn.id];
            let newItem = new gaiaConversation_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gaiaConversations, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gaiaConversationGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gaiaConversationGetters[paramsIn.id];
        }
      }
      deleteGaiaConversation(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGaiaConversation(itemId, item).then(function() {
          let existingModel = self2.gaiaConversations.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.gaiaConversations.splice(self2.gaiaConversations.indexOf(existingModel), 1);
          }
        });
      }
      updateGaiaConversation(itemId, updateObj, item) {
        return this.apiService.updateGaiaConversation(itemId, updateObj, item);
      }
      getGaiaMessages(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gaiaMessage" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGaiaMessages(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gaiaMessage_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gaiaMessages, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gaiaMessage", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createGaiaMessage(newItem) {
        let self2 = this;
        return this.apiService.createGaiaMessage(newItem).then(function(newObj) {
          let item = new gaiaMessage_1.default(self2, newObj);
          self2.gaiaMessages.push(item);
          return Promise.resolve(item);
        });
      }
      getDataCategorys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataCategory" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataCategorys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataCategory_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataCategorys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataCategory", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataCategory(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataCategorys.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataCategoryGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataCategory(paramsIn).then(function(object2) {
            return new dataCategory_1.default(self2, object2);
          });
        } else {
          this.dataCategoryGetters[paramsIn.id] = this.apiService.getDataCategory(paramsIn).then(function(object2) {
            delete self2.dataCategoryGetters[paramsIn.id];
            let newItem = new dataCategory_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataCategorys, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataCategoryGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataCategoryGetters[paramsIn.id];
        }
      }
      createDataCategory(newItem) {
        let self2 = this;
        return this.apiService.createDataCategory(newItem).then(function(newObj) {
          let item = new dataCategory_1.default(self2, newObj);
          self2.dataCategorys.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDataCategory(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDataCategory(itemId, item).then(function() {
          let existingModel = self2.dataCategorys.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dataCategorys.splice(self2.dataCategorys.indexOf(existingModel), 1);
          }
        });
      }
      updateDataCategory(itemId, updateObj, item) {
        return this.apiService.updateDataCategory(itemId, updateObj, item);
      }
      getDataTypes(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataType" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataTypes(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataType_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataTypes, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataType", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataType(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataTypes.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataTypeGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataType(paramsIn).then(function(object2) {
            return new dataType_1.default(self2, object2);
          });
        } else {
          this.dataTypeGetters[paramsIn.id] = this.apiService.getDataType(paramsIn).then(function(object2) {
            delete self2.dataTypeGetters[paramsIn.id];
            let newItem = new dataType_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataTypes, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataTypeGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataTypeGetters[paramsIn.id];
        }
      }
      createDataType(newItem) {
        let self2 = this;
        return this.apiService.createDataType(newItem).then(function(newObj) {
          let item = new dataType_1.default(self2, newObj);
          self2.dataTypes.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDataType(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDataType(itemId, item).then(function() {
          let existingModel = self2.dataTypes.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dataTypes.splice(self2.dataTypes.indexOf(existingModel), 1);
          }
        });
      }
      updateDataType(itemId, updateObj, item) {
        return this.apiService.updateDataType(itemId, updateObj, item);
      }
      getDeviceCategorys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "deviceCategory" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDeviceCategorys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new deviceCategory_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.deviceCategorys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "deviceCategory", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createDeviceCategory(newItem) {
        let self2 = this;
        return this.apiService.createDeviceCategory(newItem).then(function(newObj) {
          let item = new deviceCategory_1.default(self2, newObj);
          self2.deviceCategorys.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDeviceCategory(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDeviceCategory(itemId, item).then(function() {
          let existingModel = self2.deviceCategorys.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.deviceCategorys.splice(self2.deviceCategorys.indexOf(existingModel), 1);
          }
        });
      }
      updateDeviceCategory(itemId, updateObj, item) {
        return this.apiService.updateDeviceCategory(itemId, updateObj, item);
      }
      getWidgetBoard(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.widgetBoards.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.widgetBoardGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getWidgetBoard(paramsIn).then(function(object2) {
            return new widgetBoard_1.default(self2, object2);
          });
        } else {
          this.widgetBoardGetters[paramsIn.id] = this.apiService.getWidgetBoard(paramsIn).then(function(object2) {
            delete self2.widgetBoardGetters[paramsIn.id];
            let newItem = new widgetBoard_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.widgetBoards, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.widgetBoardGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.widgetBoardGetters[paramsIn.id];
        }
      }
      createWidgetBoard(newItem) {
        let self2 = this;
        return this.apiService.createWidgetBoard(newItem).then(function(newObj) {
          let item = new widgetBoard_1.default(self2, newObj);
          self2.widgetBoards.push(item);
          return Promise.resolve(item);
        });
      }
      updateWidgetBoard(itemId, updateObj, item) {
        return this.apiService.updateWidgetBoard(itemId, updateObj, item);
      }
      createReportFileLink(newItem) {
        let self2 = this;
        return this.apiService.createReportFileLink(newItem).then(function(newObj) {
          let item = new reportFileLink_1.default(self2, newObj);
          self2.reportFileLinks.push(item);
          return Promise.resolve(item);
        });
      }
      getRuleEvents(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "ruleEvent" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getRuleEvents(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new ruleEvent_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.ruleEvents, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "ruleEvent", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAudits(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "audit" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAudits(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new audit_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.audits, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "audit", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAudit(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.audits.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.auditGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAudit(paramsIn).then(function(object2) {
            return new audit_1.default(self2, object2);
          });
        } else {
          this.auditGetters[paramsIn.id] = this.apiService.getAudit(paramsIn).then(function(object2) {
            delete self2.auditGetters[paramsIn.id];
            let newItem = new audit_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.audits, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.auditGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.auditGetters[paramsIn.id];
        }
      }
      createAudit(newItem) {
        let self2 = this;
        return this.apiService.createAudit(newItem).then(function(newObj) {
          let item = new audit_1.default(self2, newObj);
          self2.audits.push(item);
          return Promise.resolve(item);
        });
      }
      getApplications(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "application" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getApplications(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new application_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.applications, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "application", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getApplication(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.applications.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.applicationGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getApplication(paramsIn).then(function(object2) {
            return new application_1.default(self2, object2);
          });
        } else {
          this.applicationGetters[paramsIn.id] = this.apiService.getApplication(paramsIn).then(function(object2) {
            delete self2.applicationGetters[paramsIn.id];
            let newItem = new application_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.applications, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.applicationGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.applicationGetters[paramsIn.id];
        }
      }
      createApplication(newItem) {
        let self2 = this;
        return this.apiService.createApplication(newItem).then(function(newObj) {
          let item = new application_1.default(self2, newObj);
          self2.applications.push(item);
          return Promise.resolve(item);
        });
      }
      deleteApplication(itemId, item) {
        let self2 = this;
        return this.apiService.deleteApplication(itemId, item).then(function() {
          let existingModel = self2.applications.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.applications.splice(self2.applications.indexOf(existingModel), 1);
          }
        });
      }
      getAnomalyModels(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "anomalyModel" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAnomalyModels(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new anomalyModel_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.anomalyModels, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "anomalyModel", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAnomalyModel(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.anomalyModels.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.anomalyModelGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAnomalyModel(paramsIn).then(function(object2) {
            return new anomalyModel_1.default(self2, object2);
          });
        } else {
          this.anomalyModelGetters[paramsIn.id] = this.apiService.getAnomalyModel(paramsIn).then(function(object2) {
            delete self2.anomalyModelGetters[paramsIn.id];
            let newItem = new anomalyModel_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.anomalyModels, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.anomalyModelGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.anomalyModelGetters[paramsIn.id];
        }
      }
      getAnomalys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "anomaly" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAnomalys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new anomaly_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.anomalys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "anomaly", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAnomaly(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.anomalys.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.anomalyGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAnomaly(paramsIn).then(function(object2) {
            return new anomaly_1.default(self2, object2);
          });
        } else {
          this.anomalyGetters[paramsIn.id] = this.apiService.getAnomaly(paramsIn).then(function(object2) {
            delete self2.anomalyGetters[paramsIn.id];
            let newItem = new anomaly_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.anomalys, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.anomalyGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.anomalyGetters[paramsIn.id];
        }
      }
      updateAnomaly(itemId, updateObj, item) {
        return this.apiService.updateAnomaly(itemId, updateObj, item);
      }
      getGridduckSubscriptions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gridduckSubscription" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGridduckSubscriptions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gridduckSubscription_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gridduckSubscriptions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gridduckSubscription", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGridduckInvoices(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gridduckInvoice" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGridduckInvoices(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gridduckInvoice_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gridduckInvoices, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gridduckInvoice", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAccounts(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "account" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAccounts(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new account_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.accounts, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "account", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAccount(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.accounts.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.accountGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAccount(paramsIn).then(function(object2) {
            return new account_1.default(self2, object2);
          });
        } else {
          this.accountGetters[paramsIn.id] = this.apiService.getAccount(paramsIn).then(function(object2) {
            delete self2.accountGetters[paramsIn.id];
            let newItem = new account_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.accounts, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.accountGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.accountGetters[paramsIn.id];
        }
      }
      updateAccount(itemId, updateObj, item) {
        return this.apiService.updateAccount(itemId, updateObj, item);
      }
      getCustomFieldDatas(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "customFieldData" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getCustomFieldDatas(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new customFieldData_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.customFieldDatas, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "customFieldData", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getPreferences(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.preferencess.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.preferencesGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getPreferences(paramsIn).then(function(object2) {
            return new preferences_1.default(self2, object2);
          });
        } else {
          this.preferencesGetters[paramsIn.id] = this.apiService.getPreferences(paramsIn).then(function(object2) {
            delete self2.preferencesGetters[paramsIn.id];
            let newItem = new preferences_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.preferencess, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.preferencesGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.preferencesGetters[paramsIn.id];
        }
      }
      updatePreferences(itemId, updateObj, item) {
        return this.apiService.updatePreferences(itemId, updateObj, item);
      }
      createDcRetryPayment(newItem) {
        let self2 = this;
        return this.apiService.createDcRetryPayment(newItem).then(function(newObj) {
          let item = new dcRetryPayment_1.default(self2, newObj);
          self2.dcRetryPayments.push(item);
          return Promise.resolve(item);
        });
      }
      getIssues(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "issue" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getIssues(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new issue_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.issues, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "issue", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getIgnoredDevices(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "ignoredDevice" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getIgnoredDevices(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new ignoredDevice_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.ignoredDevices, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "ignoredDevice", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createResetSecret(newItem) {
        let self2 = this;
        return this.apiService.createResetSecret(newItem).then(function(newObj) {
          let item = new resetSecret_1.default(self2, newObj);
          self2.resetSecrets.push(item);
          return Promise.resolve(item);
        });
      }
      createRequestSecret(newItem) {
        let self2 = this;
        return this.apiService.createRequestSecret(newItem).then(function(newObj) {
          let item = new requestSecret_1.default(self2, newObj);
          self2.requestSecrets.push(item);
          return Promise.resolve(item);
        });
      }
      createAssetIdentification(newItem) {
        let self2 = this;
        return this.apiService.createAssetIdentification(newItem).then(function(newObj) {
          let item = new assetIdentification_1.default(self2, newObj);
          self2.assetIdentifications.push(item);
          return Promise.resolve(item);
        });
      }
      createGetPhaseBreakdown(newItem) {
        let self2 = this;
        return this.apiService.createGetPhaseBreakdown(newItem).then(function(newObj) {
          let item = new getPhaseBreakdown_1.default(self2, newObj);
          self2.getPhaseBreakdowns.push(item);
          return Promise.resolve(item);
        });
      }
      getAvailableGateways(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "availableGateway" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAvailableGateways(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new availableGateway_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.availableGateways, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "availableGateway", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      updateAvailableGateway(itemId, updateObj, item) {
        return this.apiService.updateAvailableGateway(itemId, updateObj, item);
      }
      getAssetDemands(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetDemand" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetDemands(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetDemand_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetDemands, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetDemand", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAssetConsumptions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetConsumption" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetConsumptions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetConsumption_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetConsumptions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetConsumption", true);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getPhysicalGateway(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.physicalGateways.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.physicalGatewayGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getPhysicalGateway(paramsIn).then(function(object2) {
            return new physicalGateway_1.default(self2, object2);
          });
        } else {
          this.physicalGatewayGetters[paramsIn.id] = this.apiService.getPhysicalGateway(paramsIn).then(function(object2) {
            delete self2.physicalGatewayGetters[paramsIn.id];
            let newItem = new physicalGateway_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.physicalGateways, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.physicalGatewayGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.physicalGatewayGetters[paramsIn.id];
        }
      }
      createPhysicalGateway(newItem) {
        let self2 = this;
        return this.apiService.createPhysicalGateway(newItem).then(function(newObj) {
          let item = new physicalGateway_1.default(self2, newObj);
          self2.physicalGateways.push(item);
          return Promise.resolve(item);
        });
      }
      updatePhysicalGateway(itemId, updateObj, item) {
        return this.apiService.updatePhysicalGateway(itemId, updateObj, item);
      }
      getSitePermissions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "sitePermission" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSitePermissions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new sitePermission_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.sitePermissions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "sitePermission", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createSitePermission(newItem) {
        let self2 = this;
        return this.apiService.createSitePermission(newItem).then(function(newObj) {
          let item = new sitePermission_1.default(self2, newObj);
          self2.sitePermissions.push(item);
          return Promise.resolve(item);
        });
      }
      deleteSitePermission(itemId, item) {
        let self2 = this;
        return this.apiService.deleteSitePermission(itemId, item).then(function() {
          let existingModel = self2.sitePermissions.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.sitePermissions.splice(self2.sitePermissions.indexOf(existingModel), 1);
          }
        });
      }
      updateSitePermission(itemId, updateObj, item) {
        return this.apiService.updateSitePermission(itemId, updateObj, item);
      }
      getApplianceCategorys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "applianceCategory" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getApplianceCategorys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new applianceCategory_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.applianceCategorys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "applianceCategory", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getApplianceTypes(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "applianceType" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getApplianceTypes(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new applianceType_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.applianceTypes, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "applianceType", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataUploads(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataUpload" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataUploads(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataUpload_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataUploads, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataUpload", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataUpload(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataUploads.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataUploadGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataUpload(paramsIn).then(function(object2) {
            return new dataUpload_1.default(self2, object2);
          });
        } else {
          this.dataUploadGetters[paramsIn.id] = this.apiService.getDataUpload(paramsIn).then(function(object2) {
            delete self2.dataUploadGetters[paramsIn.id];
            let newItem = new dataUpload_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataUploads, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataUploadGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataUploadGetters[paramsIn.id];
        }
      }
      createDataUpload(newItem, onUploadProgress) {
        let self2 = this;
        return this.apiService.createDataUpload(newItem, onUploadProgress).then(function(newObj) {
          let item = new dataUpload_1.default(self2, newObj);
          self2.dataUploads.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDataUpload(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDataUpload(itemId, item).then(function() {
          let existingModel = self2.dataUploads.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dataUploads.splice(self2.dataUploads.indexOf(existingModel), 1);
          }
        });
      }
      updateDataUpload(itemId, updateObj, item) {
        return this.apiService.updateDataUpload(itemId, updateObj, item);
      }
      getFiles(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "file" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getFiles(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new file_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.files, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "file", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createFile(newItem, onUploadProgress) {
        let self2 = this;
        return this.apiService.createFile(newItem, onUploadProgress).then(function(newObj) {
          let item = new file_1.default(self2, newObj);
          self2.files.push(item);
          return Promise.resolve(item);
        });
      }
      deleteFile(itemId, item) {
        let self2 = this;
        return this.apiService.deleteFile(itemId, item).then(function() {
          let existingModel = self2.files.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.files.splice(self2.files.indexOf(existingModel), 1);
          }
        });
      }
      updateFile(itemId, updateObj, item) {
        return this.apiService.updateFile(itemId, updateObj, item);
      }
      createZip(newItem) {
        let self2 = this;
        return this.apiService.createZip(newItem).then(function(newObj) {
          let item = new zip_1.default(self2, newObj);
          self2.zips.push(item);
          return Promise.resolve(item);
        });
      }
      getSearchs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "search" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getSearchs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new search_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.searchs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "search", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getVerifyOrgInvite(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.verifyOrgInvites.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.verifyOrgInviteGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getVerifyOrgInvite(paramsIn).then(function(object2) {
            return new verifyOrgInvite_1.default(self2, object2);
          });
        } else {
          this.verifyOrgInviteGetters[paramsIn.id] = this.apiService.getVerifyOrgInvite(paramsIn).then(function(object2) {
            delete self2.verifyOrgInviteGetters[paramsIn.id];
            let newItem = new verifyOrgInvite_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.verifyOrgInvites, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.verifyOrgInviteGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.verifyOrgInviteGetters[paramsIn.id];
        }
      }
      createConfirmOrgInvite(newItem) {
        let self2 = this;
        return this.apiService.createConfirmOrgInvite(newItem).then(function(newObj) {
          let item = new confirmOrgInvite_1.default(self2, newObj);
          self2.confirmOrgInvites.push(item);
          return Promise.resolve(item);
        });
      }
      createDcCreateAccount(newItem) {
        let self2 = this;
        return this.apiService.createDcCreateAccount(newItem).then(function(newObj) {
          let item = new dcCreateAccount_1.default(self2, newObj);
          self2.dcCreateAccounts.push(item);
          return Promise.resolve(item);
        });
      }
      getDcSessions(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dcSession" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDcSessions(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dcSession_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dcSessions, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dcSession", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDcSession(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dcSessions.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dcSessionGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDcSession(paramsIn).then(function(object2) {
            return new dcSession_1.default(self2, object2);
          });
        } else {
          this.dcSessionGetters[paramsIn.id] = this.apiService.getDcSession(paramsIn).then(function(object2) {
            delete self2.dcSessionGetters[paramsIn.id];
            let newItem = new dcSession_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dcSessions, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dcSessionGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dcSessionGetters[paramsIn.id];
        }
      }
      createDcSession(newItem) {
        let self2 = this;
        return this.apiService.createDcSession(newItem).then(function(newObj) {
          let item = new dcSession_1.default(self2, newObj);
          self2.dcSessions.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDcSession(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDcSession(itemId, item).then(function() {
          let existingModel = self2.dcSessions.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dcSessions.splice(self2.dcSessions.indexOf(existingModel), 1);
          }
        });
      }
      createPaymentSheet(newItem) {
        let self2 = this;
        return this.apiService.createPaymentSheet(newItem).then(function(newObj) {
          let item = new paymentSheet_1.default(self2, newObj);
          self2.paymentSheets.push(item);
          return Promise.resolve(item);
        });
      }
      getDcChargePoint(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dcChargePoints.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dcChargePointGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDcChargePoint(paramsIn).then(function(object2) {
            return new dcChargePoint_1.default(self2, object2);
          });
        } else {
          this.dcChargePointGetters[paramsIn.id] = this.apiService.getDcChargePoint(paramsIn).then(function(object2) {
            delete self2.dcChargePointGetters[paramsIn.id];
            let newItem = new dcChargePoint_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dcChargePoints, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dcChargePointGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dcChargePointGetters[paramsIn.id];
        }
      }
      getDcChargeStations(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dcChargeStation" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDcChargeStations(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dcChargeStation_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dcChargeStations, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dcChargeStation", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getOrganisationInvites(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "organisationInvite" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrganisationInvites(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new organisationInvite_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.organisationInvites, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "organisationInvite", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createOrganisationInvite(newItem) {
        let self2 = this;
        return this.apiService.createOrganisationInvite(newItem).then(function(newObj) {
          let item = new organisationInvite_1.default(self2, newObj);
          self2.organisationInvites.push(item);
          return Promise.resolve(item);
        });
      }
      deleteOrganisationInvite(itemId, item) {
        let self2 = this;
        return this.apiService.deleteOrganisationInvite(itemId, item).then(function() {
          let existingModel = self2.organisationInvites.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.organisationInvites.splice(self2.organisationInvites.indexOf(existingModel), 1);
          }
        });
      }
      updateOrganisationInvite(itemId, updateObj, item) {
        return this.apiService.updateOrganisationInvite(itemId, updateObj, item);
      }
      getOrganisationMembers(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "organisationMember" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrganisationMembers(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new organisationMember_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.organisationMembers, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "organisationMember", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      deleteOrganisationMember(itemId, item) {
        let self2 = this;
        return this.apiService.deleteOrganisationMember(itemId, item).then(function() {
          let existingModel = self2.organisationMembers.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.organisationMembers.splice(self2.organisationMembers.indexOf(existingModel), 1);
          }
        });
      }
      updateOrganisationMember(itemId, updateObj, item) {
        return this.apiService.updateOrganisationMember(itemId, updateObj, item);
      }
      getDetectedDevices(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "detectedDevice" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDetectedDevices(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new detectedDevice_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.detectedDevices, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "detectedDevice", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      updateDetectedDevice(itemId, updateObj, item) {
        return this.apiService.updateDetectedDevice(itemId, updateObj, item);
      }
      getResetToken(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.resetTokens.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.resetTokenGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getResetToken(paramsIn).then(function(object2) {
            return new resetToken_1.default(self2, object2);
          });
        } else {
          this.resetTokenGetters[paramsIn.id] = this.apiService.getResetToken(paramsIn).then(function(object2) {
            delete self2.resetTokenGetters[paramsIn.id];
            let newItem = new resetToken_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.resetTokens, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.resetTokenGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.resetTokenGetters[paramsIn.id];
        }
      }
      createResetToken(newItem) {
        let self2 = this;
        return this.apiService.createResetToken(newItem).then(function(newObj) {
          let item = new resetToken_1.default(self2, newObj);
          self2.resetTokens.push(item);
          return Promise.resolve(item);
        });
      }
      updateResetToken(itemId, updateObj, item) {
        return this.apiService.updateResetToken(itemId, updateObj, item);
      }
      createPassword(newItem) {
        let self2 = this;
        return this.apiService.createPassword(newItem).then(function(newObj) {
          let item = new password_1.default(self2, newObj);
          self2.passwords.push(item);
          return Promise.resolve(item);
        });
      }
      getThirdPartyIntegrations(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "thirdPartyIntegration" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getThirdPartyIntegrations(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new thirdPartyIntegration_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.thirdPartyIntegrations, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "thirdPartyIntegration", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createThirdPartyIntegration(newItem) {
        let self2 = this;
        return this.apiService.createThirdPartyIntegration(newItem).then(function(newObj) {
          let item = new thirdPartyIntegration_1.default(self2, newObj);
          self2.thirdPartyIntegrations.push(item);
          return Promise.resolve(item);
        });
      }
      getOrgPartners(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "orgPartner" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrgPartners(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new orgPartner_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.orgPartners, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "orgPartner", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getOrgPartner(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.orgPartners.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.orgPartnerGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getOrgPartner(paramsIn).then(function(object2) {
            return new orgPartner_1.default(self2, object2);
          });
        } else {
          this.orgPartnerGetters[paramsIn.id] = this.apiService.getOrgPartner(paramsIn).then(function(object2) {
            delete self2.orgPartnerGetters[paramsIn.id];
            let newItem = new orgPartner_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.orgPartners, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.orgPartnerGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.orgPartnerGetters[paramsIn.id];
        }
      }
      createOrgPartner(newItem) {
        let self2 = this;
        return this.apiService.createOrgPartner(newItem).then(function(newObj) {
          let item = new orgPartner_1.default(self2, newObj);
          self2.orgPartners.push(item);
          return Promise.resolve(item);
        });
      }
      deleteOrgPartner(itemId, item) {
        let self2 = this;
        return this.apiService.deleteOrgPartner(itemId, item).then(function() {
          let existingModel = self2.orgPartners.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.orgPartners.splice(self2.orgPartners.indexOf(existingModel), 1);
          }
        });
      }
      updateOrgPartner(itemId, updateObj, item) {
        return this.apiService.updateOrgPartner(itemId, updateObj, item);
      }
      createMfaSecret(newItem) {
        let self2 = this;
        return this.apiService.createMfaSecret(newItem).then(function(newObj) {
          let item = new mfaSecret_1.default(self2, newObj);
          self2.mfaSecrets.push(item);
          return Promise.resolve(item);
        });
      }
      createMfaVerification(newItem) {
        let self2 = this;
        return this.apiService.createMfaVerification(newItem).then(function(newObj) {
          let item = new mfaVerification_1.default(self2, newObj);
          self2.mfaVerifications.push(item);
          return Promise.resolve(item);
        });
      }
      createMfaAuthentication(newItem) {
        let self2 = this;
        return this.apiService.createMfaAuthentication(newItem).then(function(newObj) {
          let item = new mfaAuthentication_1.default(self2, newObj);
          self2.mfaAuthentications.push(item);
          return Promise.resolve(item);
        });
      }
      createLoginAs(newItem) {
        let self2 = this;
        return this.apiService.createLoginAs(newItem).then(function(newObj) {
          let item = new loginAs_1.default(self2, newObj);
          self2.loginAss.push(item);
          return Promise.resolve(item);
        });
      }
      createLoginAsPartner(newItem) {
        let self2 = this;
        return this.apiService.createLoginAsPartner(newItem).then(function(newObj) {
          let item = new loginAsPartner_1.default(self2, newObj);
          self2.loginAsPartners.push(item);
          return Promise.resolve(item);
        });
      }
      getOrganisationManagements(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "organisationManagement" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrganisationManagements(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new organisationManagement_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.organisationManagements, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "organisationManagement", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getOrganisationManagement(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.organisationManagements.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.organisationManagementGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getOrganisationManagement(paramsIn).then(function(object2) {
            return new organisationManagement_1.default(self2, object2);
          });
        } else {
          this.organisationManagementGetters[paramsIn.id] = this.apiService.getOrganisationManagement(paramsIn).then(function(object2) {
            delete self2.organisationManagementGetters[paramsIn.id];
            let newItem = new organisationManagement_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.organisationManagements, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.organisationManagementGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.organisationManagementGetters[paramsIn.id];
        }
      }
      updateOrganisationManagement(itemId, updateObj, item) {
        return this.apiService.updateOrganisationManagement(itemId, updateObj, item);
      }
      getStagingDatabase(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.stagingDatabases.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.stagingDatabaseGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getStagingDatabase(paramsIn).then(function(object2) {
            return new stagingDatabase_1.default(self2, object2);
          });
        } else {
          this.stagingDatabaseGetters[paramsIn.id] = this.apiService.getStagingDatabase(paramsIn).then(function(object2) {
            delete self2.stagingDatabaseGetters[paramsIn.id];
            let newItem = new stagingDatabase_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.stagingDatabases, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.stagingDatabaseGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.stagingDatabaseGetters[paramsIn.id];
        }
      }
      updateStagingDatabase(itemId, updateObj, item) {
        return this.apiService.updateStagingDatabase(itemId, updateObj, item);
      }
      getNotifications(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "notification" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getNotifications(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new notification_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.notifications, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "notification", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      updateNotification(itemId, updateObj, item) {
        return this.apiService.updateNotification(itemId, updateObj, item);
      }
      getZigbeeFirmwares(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "zigbeeFirmware" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getZigbeeFirmwares(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new zigbeeFirmware_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.zigbeeFirmwares, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "zigbeeFirmware", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getZigbeeFirmware(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.zigbeeFirmwares.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.zigbeeFirmwareGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getZigbeeFirmware(paramsIn).then(function(object2) {
            return new zigbeeFirmware_1.default(self2, object2);
          });
        } else {
          this.zigbeeFirmwareGetters[paramsIn.id] = this.apiService.getZigbeeFirmware(paramsIn).then(function(object2) {
            delete self2.zigbeeFirmwareGetters[paramsIn.id];
            let newItem = new zigbeeFirmware_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.zigbeeFirmwares, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.zigbeeFirmwareGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.zigbeeFirmwareGetters[paramsIn.id];
        }
      }
      getGatewayTrustList(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gatewayTrustLists.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gatewayTrustListGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGatewayTrustList(paramsIn).then(function(object2) {
            return new gatewayTrustList_1.default(self2, object2);
          });
        } else {
          this.gatewayTrustListGetters[paramsIn.id] = this.apiService.getGatewayTrustList(paramsIn).then(function(object2) {
            delete self2.gatewayTrustListGetters[paramsIn.id];
            let newItem = new gatewayTrustList_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gatewayTrustLists, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gatewayTrustListGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gatewayTrustListGetters[paramsIn.id];
        }
      }
      createGatewayTrustedDeviceUntrustRequest(newItem) {
        let self2 = this;
        return this.apiService.createGatewayTrustedDeviceUntrustRequest(newItem).then(function(newObj) {
          let item = new gatewayTrustedDeviceUntrustRequest_1.default(self2, newObj);
          self2.gatewayTrustedDeviceUntrustRequests.push(item);
          return Promise.resolve(item);
        });
      }
      getTelemetryOperations(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "telemetryOperation" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getTelemetryOperations(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new telemetryOperation_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.telemetryOperations, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "telemetryOperation", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createAggregateTelemetryGroupRequest(newItem) {
        let self2 = this;
        return this.apiService.createAggregateTelemetryGroupRequest(newItem).then(function(newObj) {
          let item = new aggregateTelemetryGroupRequest_1.default(self2, newObj);
          self2.aggregateTelemetryGroupRequests.push(item);
          return Promise.resolve(item);
        });
      }
      createAssetRemoveDataRequest(newItem) {
        let self2 = this;
        return this.apiService.createAssetRemoveDataRequest(newItem).then(function(newObj) {
          let item = new assetRemoveDataRequest_1.default(self2, newObj);
          self2.assetRemoveDataRequests.push(item);
          return Promise.resolve(item);
        });
      }
      createAssetAggregateDataRequest(newItem) {
        let self2 = this;
        return this.apiService.createAssetAggregateDataRequest(newItem).then(function(newObj) {
          let item = new assetAggregateDataRequest_1.default(self2, newObj);
          self2.assetAggregateDataRequests.push(item);
          return Promise.resolve(item);
        });
      }
      getGatewayTrustedDeviceAnalysiss(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gatewayTrustedDeviceAnalysis" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGatewayTrustedDeviceAnalysiss(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gatewayTrustedDeviceAnalysis_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gatewayTrustedDeviceAnalysiss, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gatewayTrustedDeviceAnalysis", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGatewayTrustedDeviceAnalysis(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gatewayTrustedDeviceAnalysiss.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGatewayTrustedDeviceAnalysis(paramsIn).then(function(object2) {
            return new gatewayTrustedDeviceAnalysis_1.default(self2, object2);
          });
        } else {
          this.gatewayTrustedDeviceAnalysisGetters[paramsIn.id] = this.apiService.getGatewayTrustedDeviceAnalysis(paramsIn).then(function(object2) {
            delete self2.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
            let newItem = new gatewayTrustedDeviceAnalysis_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gatewayTrustedDeviceAnalysiss, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
        }
      }
      createGatewayTrustedDeviceAnalysis(newItem) {
        let self2 = this;
        return this.apiService.createGatewayTrustedDeviceAnalysis(newItem).then(function(newObj) {
          let item = new gatewayTrustedDeviceAnalysis_1.default(self2, newObj);
          self2.gatewayTrustedDeviceAnalysiss.push(item);
          return Promise.resolve(item);
        });
      }
      deleteGatewayTrustedDeviceAnalysis(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGatewayTrustedDeviceAnalysis(itemId, item).then(function() {
          let existingModel = self2.gatewayTrustedDeviceAnalysiss.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.gatewayTrustedDeviceAnalysiss.splice(self2.gatewayTrustedDeviceAnalysiss.indexOf(existingModel), 1);
          }
        });
      }
      updateGatewayTrustedDeviceAnalysis(itemId, updateObj, item) {
        return this.apiService.updateGatewayTrustedDeviceAnalysis(itemId, updateObj, item);
      }
      getAggregateTelemetrys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "aggregateTelemetry" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAggregateTelemetrys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new aggregateTelemetry_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.aggregateTelemetrys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "aggregateTelemetry", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAggregateTelemetry(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.aggregateTelemetrys.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.aggregateTelemetryGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAggregateTelemetry(paramsIn).then(function(object2) {
            return new aggregateTelemetry_1.default(self2, object2);
          });
        } else {
          this.aggregateTelemetryGetters[paramsIn.id] = this.apiService.getAggregateTelemetry(paramsIn).then(function(object2) {
            delete self2.aggregateTelemetryGetters[paramsIn.id];
            let newItem = new aggregateTelemetry_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.aggregateTelemetrys, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.aggregateTelemetryGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.aggregateTelemetryGetters[paramsIn.id];
        }
      }
      createAggregateTelemetry(newItem) {
        let self2 = this;
        return this.apiService.createAggregateTelemetry(newItem).then(function(newObj) {
          let item = new aggregateTelemetry_1.default(self2, newObj);
          self2.aggregateTelemetrys.push(item);
          return Promise.resolve(item);
        });
      }
      deleteAggregateTelemetry(itemId, item) {
        let self2 = this;
        return this.apiService.deleteAggregateTelemetry(itemId, item).then(function() {
          let existingModel = self2.aggregateTelemetrys.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.aggregateTelemetrys.splice(self2.aggregateTelemetrys.indexOf(existingModel), 1);
          }
        });
      }
      updateAggregateTelemetry(itemId, updateObj, item) {
        return this.apiService.updateAggregateTelemetry(itemId, updateObj, item);
      }
      getInstantaneousTelemetrys(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "instantaneousTelemetry" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getInstantaneousTelemetrys(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new instantaneousTelemetry_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.instantaneousTelemetrys, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "instantaneousTelemetry", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getInstantaneousTelemetry(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.instantaneousTelemetrys.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.instantaneousTelemetryGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getInstantaneousTelemetry(paramsIn).then(function(object2) {
            return new instantaneousTelemetry_1.default(self2, object2);
          });
        } else {
          this.instantaneousTelemetryGetters[paramsIn.id] = this.apiService.getInstantaneousTelemetry(paramsIn).then(function(object2) {
            delete self2.instantaneousTelemetryGetters[paramsIn.id];
            let newItem = new instantaneousTelemetry_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.instantaneousTelemetrys, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.instantaneousTelemetryGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.instantaneousTelemetryGetters[paramsIn.id];
        }
      }
      createInstantaneousTelemetry(newItem) {
        let self2 = this;
        return this.apiService.createInstantaneousTelemetry(newItem).then(function(newObj) {
          let item = new instantaneousTelemetry_1.default(self2, newObj);
          self2.instantaneousTelemetrys.push(item);
          return Promise.resolve(item);
        });
      }
      deleteInstantaneousTelemetry(itemId, item) {
        let self2 = this;
        return this.apiService.deleteInstantaneousTelemetry(itemId, item).then(function() {
          let existingModel = self2.instantaneousTelemetrys.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.instantaneousTelemetrys.splice(self2.instantaneousTelemetrys.indexOf(existingModel), 1);
          }
        });
      }
      updateInstantaneousTelemetry(itemId, updateObj, item) {
        return this.apiService.updateInstantaneousTelemetry(itemId, updateObj, item);
      }
      getOrganisationSearchs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "organisationSearch" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getOrganisationSearchs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new organisationSearch_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.organisationSearchs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "organisationSearch", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createGatewayLogDownloadRequest(newItem) {
        let self2 = this;
        return this.apiService.createGatewayLogDownloadRequest(newItem).then(function(newObj) {
          let item = new gatewayLogDownloadRequest_1.default(self2, newObj);
          self2.gatewayLogDownloadRequests.push(item);
          return Promise.resolve(item);
        });
      }
      createGatewayEnhancedLogDownloadRequest(newItem) {
        let self2 = this;
        return this.apiService.createGatewayEnhancedLogDownloadRequest(newItem).then(function(newObj) {
          let item = new gatewayEnhancedLogDownloadRequest_1.default(self2, newObj);
          self2.gatewayEnhancedLogDownloadRequests.push(item);
          return Promise.resolve(item);
        });
      }
      getGatewayGods(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "gatewayGod" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getGatewayGods(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new gatewayGod_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.gatewayGods, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "gatewayGod", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getGatewayGod(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.gatewayGods.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.gatewayGodGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getGatewayGod(paramsIn).then(function(object2) {
            return new gatewayGod_1.default(self2, object2);
          });
        } else {
          this.gatewayGodGetters[paramsIn.id] = this.apiService.getGatewayGod(paramsIn).then(function(object2) {
            delete self2.gatewayGodGetters[paramsIn.id];
            let newItem = new gatewayGod_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.gatewayGods, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.gatewayGodGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.gatewayGodGetters[paramsIn.id];
        }
      }
      createGatewayGod(newItem) {
        let self2 = this;
        return this.apiService.createGatewayGod(newItem).then(function(newObj) {
          let item = new gatewayGod_1.default(self2, newObj);
          self2.gatewayGods.push(item);
          return Promise.resolve(item);
        });
      }
      deleteGatewayGod(itemId, item) {
        let self2 = this;
        return this.apiService.deleteGatewayGod(itemId, item).then(function() {
          let existingModel = self2.gatewayGods.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.gatewayGods.splice(self2.gatewayGods.indexOf(existingModel), 1);
          }
        });
      }
      updateGatewayGod(itemId, updateObj, item) {
        return this.apiService.updateGatewayGod(itemId, updateObj, item);
      }
      getAssetGods(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetGod" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetGods(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetGod_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetGods, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetGod", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAssetGod(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.assetGods.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.assetGodGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getAssetGod(paramsIn).then(function(object2) {
            return new assetGod_1.default(self2, object2);
          });
        } else {
          this.assetGodGetters[paramsIn.id] = this.apiService.getAssetGod(paramsIn).then(function(object2) {
            delete self2.assetGodGetters[paramsIn.id];
            let newItem = new assetGod_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.assetGods, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.assetGodGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.assetGodGetters[paramsIn.id];
        }
      }
      createAssetGod(newItem) {
        let self2 = this;
        return this.apiService.createAssetGod(newItem).then(function(newObj) {
          let item = new assetGod_1.default(self2, newObj);
          self2.assetGods.push(item);
          return Promise.resolve(item);
        });
      }
      deleteAssetGod(itemId, item) {
        let self2 = this;
        return this.apiService.deleteAssetGod(itemId, item).then(function() {
          let existingModel = self2.assetGods.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.assetGods.splice(self2.assetGods.indexOf(existingModel), 1);
          }
        });
      }
      updateAssetGod(itemId, updateObj, item) {
        return this.apiService.updateAssetGod(itemId, updateObj, item);
      }
      getAssetTelemetryBatchs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetTelemetryBatch" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetTelemetryBatchs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetTelemetryBatch_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetTelemetryBatchs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetTelemetryBatch", true);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAssetConsumptionBatchs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetConsumptionBatch" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetConsumptionBatchs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetConsumptionBatch_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetConsumptionBatchs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetConsumptionBatch", true);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getRawAggregateDatas(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "rawAggregateData" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getRawAggregateDatas(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new rawAggregateData_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.rawAggregateDatas, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "rawAggregateData", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getAssetResets(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "assetReset" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getAssetResets(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new assetReset_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.assetResets, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "assetReset", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createAssetReset(newItem) {
        let self2 = this;
        return this.apiService.createAssetReset(newItem).then(function(newObj) {
          let item = new assetReset_1.default(self2, newObj);
          self2.assetResets.push(item);
          return Promise.resolve(item);
        });
      }
      deleteAssetReset(itemId, item) {
        let self2 = this;
        return this.apiService.deleteAssetReset(itemId, item).then(function() {
          let existingModel = self2.assetResets.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.assetResets.splice(self2.assetResets.indexOf(existingModel), 1);
          }
        });
      }
      updateAssetReset(itemId, updateObj, item) {
        return this.apiService.updateAssetReset(itemId, updateObj, item);
      }
      createInspiredLogin(newItem) {
        let self2 = this;
        return this.apiService.createInspiredLogin(newItem).then(function(newObj) {
          let item = new inspiredLogin_1.default(self2, newObj);
          self2.inspiredLogins.push(item);
          return Promise.resolve(item);
        });
      }
      getDataUnits(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataUnit" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataUnits(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataUnit_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataUnits, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataUnit", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataUnit(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataUnits.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataUnitGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataUnit(paramsIn).then(function(object2) {
            return new dataUnit_1.default(self2, object2);
          });
        } else {
          this.dataUnitGetters[paramsIn.id] = this.apiService.getDataUnit(paramsIn).then(function(object2) {
            delete self2.dataUnitGetters[paramsIn.id];
            let newItem = new dataUnit_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataUnits, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataUnitGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataUnitGetters[paramsIn.id];
        }
      }
      createDataUnit(newItem) {
        let self2 = this;
        return this.apiService.createDataUnit(newItem).then(function(newObj) {
          let item = new dataUnit_1.default(self2, newObj);
          self2.dataUnits.push(item);
          return Promise.resolve(item);
        });
      }
      deleteDataUnit(itemId, item) {
        let self2 = this;
        return this.apiService.deleteDataUnit(itemId, item).then(function() {
          let existingModel = self2.dataUnits.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.dataUnits.splice(self2.dataUnits.indexOf(existingModel), 1);
          }
        });
      }
      updateDataUnit(itemId, updateObj, item) {
        return this.apiService.updateDataUnit(itemId, updateObj, item);
      }
      getItemMetadata(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.itemMetadatas.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.itemMetadataGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getItemMetadata(paramsIn).then(function(object2) {
            return new itemMetadata_1.default(self2, object2);
          });
        } else {
          this.itemMetadataGetters[paramsIn.id] = this.apiService.getItemMetadata(paramsIn).then(function(object2) {
            delete self2.itemMetadataGetters[paramsIn.id];
            let newItem = new itemMetadata_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.itemMetadatas, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.itemMetadataGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.itemMetadataGetters[paramsIn.id];
        }
      }
      getBounceEmails(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "bounceEmail" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getBounceEmails(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new bounceEmail_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.bounceEmails, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "bounceEmail", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      deleteBounceEmail(itemId, item) {
        let self2 = this;
        return this.apiService.deleteBounceEmail(itemId, item).then(function() {
          let existingModel = self2.bounceEmails.find((m3) => m3.id === itemId);
          if (existingModel) {
            self2.bounceEmails.splice(self2.bounceEmails.indexOf(existingModel), 1);
          }
        });
      }
      getDataFileImports(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataFileImport" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataFileImports(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataFileImport_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataFileImports, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataFileImport", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      getDataFileImport(paramsIn) {
        let self2 = this;
        let presentObject = paramsIn.noCache ? void 0 : self2.dataFileImports.find((o) => (o.id === paramsIn.id || paramsIn.id === "") && o.isListening);
        if (presentObject) {
          return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? void 0 : self2.dataFileImportGetters[paramsIn.id];
        if (presentObjectPromise) {
          return presentObjectPromise;
        }
        if (paramsIn.noCache) {
          return this.apiService.getDataFileImport(paramsIn).then(function(object2) {
            return new dataFileImport_1.default(self2, object2);
          });
        } else {
          this.dataFileImportGetters[paramsIn.id] = this.apiService.getDataFileImport(paramsIn).then(function(object2) {
            delete self2.dataFileImportGetters[paramsIn.id];
            let newItem = new dataFileImport_1.default(self2, object2);
            newItem = self2.mergeIntoList(self2.dataFileImports, newItem);
            return newItem;
          }).catch(function(err) {
            delete self2.dataFileImportGetters[paramsIn.id];
            return Promise.reject(err);
          });
          return this.dataFileImportGetters[paramsIn.id];
        }
      }
      createDataFileImport(newItem) {
        let self2 = this;
        return this.apiService.createDataFileImport(newItem).then(function(newObj) {
          let item = new dataFileImport_1.default(self2, newObj);
          self2.dataFileImports.push(item);
          return Promise.resolve(item);
        });
      }
      updateDataFileImport(itemId, updateObj, item) {
        return this.apiService.updateDataFileImport(itemId, updateObj, item);
      }
      getDataFileImportLogs(paramsIn) {
        let self2 = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index3 = "dataFileImportLog" + JSON.stringify(params);
        let existingList = this.lists.filter((l) => l.isListening === true).find((l) => l.type + JSON.stringify(l.params) === index3);
        if (existingList) {
          return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index3];
        if (existingListPromise) {
          return existingListPromise;
        }
        this.listPromises[index3] = this.apiService.getDataFileImportLogs(params).then(function(results) {
          delete self2.listPromises[index3];
          let total = results.total;
          let dataListList = [];
          results.list.forEach(function(listObj) {
            let items = listObj.list.map(function(itemObj) {
              let newItem = new dataFileImportLog_1.default(self2, itemObj);
              newItem = self2.mergeIntoList(self2.dataFileImportLogs, newItem);
              return newItem;
            });
            dataListList.push({ list: items, id: listObj.id });
          });
          let list = new data_list_1.default(dataListList, total, params, self2, "dataFileImportLog", void 0);
          self2.lists.push(list);
          return list;
        }).catch(function(err) {
          delete self2.listPromises[index3];
          return Promise.reject(err);
        });
        return this.listPromises[index3];
      }
      createDataFileImportUpload(newItem) {
        let self2 = this;
        return this.apiService.createDataFileImportUpload(newItem).then(function(newObj) {
          let item = new dataFileImportUpload_1.default(self2, newObj);
          self2.dataFileImportUploads.push(item);
          return Promise.resolve(item);
        });
      }
      clearLists() {
        this.lists = [];
        this.listPromises = {};
        this.assetGetters = {};
        this.assets = [];
        this.gatewayGetters = {};
        this.gateways = [];
        this.gatewaySoftwareVersionGetters = {};
        this.gatewaySoftwareVersions = [];
        this.siteGetters = {};
        this.sites = [];
        this.orderGetters = {};
        this.orders = [];
        this.sessionGetters = {};
        this.sessions = [];
        this.discountGetters = {};
        this.discounts = [];
        this.stripeSessionGetters = {};
        this.stripeSessions = [];
        this.stripeWebhookGetters = {};
        this.stripeWebhooks = [];
        this.zapierWebhookGetters = {};
        this.zapierWebhooks = [];
        this.placesGetters = {};
        this.placess = [];
        this.productGetters = {};
        this.products = [];
        this.modbusModelGetters = {};
        this.modbusModels = [];
        this.occupancyScheduleGetters = {};
        this.occupancySchedules = [];
        this.pubOrgGetters = {};
        this.pubOrgs = [];
        this.organisationGetters = {};
        this.organisations = [];
        this.paymentCardGetters = {};
        this.paymentCards = [];
        this.assetEventGetters = {};
        this.assetEvents = [];
        this.gatewayEventGetters = {};
        this.gatewayEvents = [];
        this.assetTelemetryGetters = {};
        this.assetTelemetrys = [];
        this.ruleGetters = {};
        this.rules = [];
        this.dataRequestGetters = {};
        this.dataRequests = [];
        this.dataRequestLinkGetters = {};
        this.dataRequestLinks = [];
        this.dataRequestRunGetters = {};
        this.dataRequestRuns = [];
        this.invoiceRequestGetters = {};
        this.invoiceRequests = [];
        this.invoiceRequestLinkGetters = {};
        this.invoiceRequestLinks = [];
        this.siteGroupGetters = {};
        this.siteGroups = [];
        this.groupGetters = {};
        this.groups = [];
        this.duckChargeAdminGetters = {};
        this.duckChargeAdmins = [];
        this.customFieldTypeGetters = {};
        this.customFieldTypes = [];
        this.customFieldGetters = {};
        this.customFields = [];
        this.locationGetters = {};
        this.locations = [];
        this.searchHistoryGetters = {};
        this.searchHistorys = [];
        this.tariffGetters = {};
        this.tariffs = [];
        this.groupTypeGetters = {};
        this.groupTypes = [];
        this.calculatorInboundGetters = {};
        this.calculatorInbounds = [];
        this.calculatorResultGetters = {};
        this.calculatorResults = [];
        this.createReportGetters = {};
        this.createReports = [];
        this.reportHistoryGetters = {};
        this.reportHistorys = [];
        this.reportGetters = {};
        this.reports = [];
        this.reportFileGetters = {};
        this.reportFiles = [];
        this.gaiaConversationGetters = {};
        this.gaiaConversations = [];
        this.gaiaMessageGetters = {};
        this.gaiaMessages = [];
        this.dataCategoryGetters = {};
        this.dataCategorys = [];
        this.dataTypeGetters = {};
        this.dataTypes = [];
        this.deviceCategoryGetters = {};
        this.deviceCategorys = [];
        this.widgetBoardGetters = {};
        this.widgetBoards = [];
        this.reportFileLinkGetters = {};
        this.reportFileLinks = [];
        this.ruleEventGetters = {};
        this.ruleEvents = [];
        this.auditGetters = {};
        this.audits = [];
        this.applicationGetters = {};
        this.applications = [];
        this.anomalyModelGetters = {};
        this.anomalyModels = [];
        this.anomalyGetters = {};
        this.anomalys = [];
        this.gridduckSubscriptionGetters = {};
        this.gridduckSubscriptions = [];
        this.gridduckInvoiceGetters = {};
        this.gridduckInvoices = [];
        this.accountGetters = {};
        this.accounts = [];
        this.customFieldDataGetters = {};
        this.customFieldDatas = [];
        this.preferencesGetters = {};
        this.preferencess = [];
        this.dcRetryPaymentGetters = {};
        this.dcRetryPayments = [];
        this.issueGetters = {};
        this.issues = [];
        this.ignoredDeviceGetters = {};
        this.ignoredDevices = [];
        this.resetSecretGetters = {};
        this.resetSecrets = [];
        this.requestSecretGetters = {};
        this.requestSecrets = [];
        this.assetIdentificationGetters = {};
        this.assetIdentifications = [];
        this.getPhaseBreakdownGetters = {};
        this.getPhaseBreakdowns = [];
        this.availableGatewayGetters = {};
        this.availableGateways = [];
        this.assetDemandGetters = {};
        this.assetDemands = [];
        this.assetConsumptionGetters = {};
        this.assetConsumptions = [];
        this.physicalGatewayGetters = {};
        this.physicalGateways = [];
        this.sitePermissionGetters = {};
        this.sitePermissions = [];
        this.applianceCategoryGetters = {};
        this.applianceCategorys = [];
        this.applianceTypeGetters = {};
        this.applianceTypes = [];
        this.dataUploadGetters = {};
        this.dataUploads = [];
        this.fileGetters = {};
        this.files = [];
        this.zipGetters = {};
        this.zips = [];
        this.searchGetters = {};
        this.searchs = [];
        this.verifyOrgInviteGetters = {};
        this.verifyOrgInvites = [];
        this.confirmOrgInviteGetters = {};
        this.confirmOrgInvites = [];
        this.dcCreateAccountGetters = {};
        this.dcCreateAccounts = [];
        this.dcSessionGetters = {};
        this.dcSessions = [];
        this.paymentSheetGetters = {};
        this.paymentSheets = [];
        this.dcChargePointGetters = {};
        this.dcChargePoints = [];
        this.dcChargeStationGetters = {};
        this.dcChargeStations = [];
        this.organisationInviteGetters = {};
        this.organisationInvites = [];
        this.organisationMemberGetters = {};
        this.organisationMembers = [];
        this.detectedDeviceGetters = {};
        this.detectedDevices = [];
        this.resetTokenGetters = {};
        this.resetTokens = [];
        this.passwordGetters = {};
        this.passwords = [];
        this.thirdPartyIntegrationGetters = {};
        this.thirdPartyIntegrations = [];
        this.orgPartnerGetters = {};
        this.orgPartners = [];
        this.mfaSecretGetters = {};
        this.mfaSecrets = [];
        this.mfaVerificationGetters = {};
        this.mfaVerifications = [];
        this.mfaAuthenticationGetters = {};
        this.mfaAuthentications = [];
        this.loginAsGetters = {};
        this.loginAss = [];
        this.loginAsPartnerGetters = {};
        this.loginAsPartners = [];
        this.organisationManagementGetters = {};
        this.organisationManagements = [];
        this.stagingDatabaseGetters = {};
        this.stagingDatabases = [];
        this.notificationGetters = {};
        this.notifications = [];
        this.zigbeeFirmwareGetters = {};
        this.zigbeeFirmwares = [];
        this.gatewayTrustListGetters = {};
        this.gatewayTrustLists = [];
        this.gatewayTrustedDeviceUntrustRequestGetters = {};
        this.gatewayTrustedDeviceUntrustRequests = [];
        this.telemetryOperationGetters = {};
        this.telemetryOperations = [];
        this.aggregateTelemetryGroupRequestGetters = {};
        this.aggregateTelemetryGroupRequests = [];
        this.assetRemoveDataRequestGetters = {};
        this.assetRemoveDataRequests = [];
        this.assetAggregateDataRequestGetters = {};
        this.assetAggregateDataRequests = [];
        this.gatewayTrustedDeviceAnalysisGetters = {};
        this.gatewayTrustedDeviceAnalysiss = [];
        this.aggregateTelemetryGetters = {};
        this.aggregateTelemetrys = [];
        this.instantaneousTelemetryGetters = {};
        this.instantaneousTelemetrys = [];
        this.organisationSearchGetters = {};
        this.organisationSearchs = [];
        this.gatewayLogDownloadRequestGetters = {};
        this.gatewayLogDownloadRequests = [];
        this.gatewayEnhancedLogDownloadRequestGetters = {};
        this.gatewayEnhancedLogDownloadRequests = [];
        this.gatewayGodGetters = {};
        this.gatewayGods = [];
        this.assetGodGetters = {};
        this.assetGods = [];
        this.assetTelemetryBatchGetters = {};
        this.assetTelemetryBatchs = [];
        this.assetConsumptionBatchGetters = {};
        this.assetConsumptionBatchs = [];
        this.rawAggregateDataGetters = {};
        this.rawAggregateDatas = [];
        this.assetResetGetters = {};
        this.assetResets = [];
        this.inspiredLoginGetters = {};
        this.inspiredLogins = [];
        this.dataUnitGetters = {};
        this.dataUnits = [];
        this.itemMetadataGetters = {};
        this.itemMetadatas = [];
        this.bounceEmailGetters = {};
        this.bounceEmails = [];
        this.dataFileImportGetters = {};
        this.dataFileImports = [];
        this.dataFileImportLogGetters = {};
        this.dataFileImportLogs = [];
        this.dataFileImportUploadGetters = {};
        this.dataFileImportUploads = [];
      }
      resync() {
        let self2 = this;
        this.sendResubRequest();
        let visibleAssets = this.assets.filter((i) => i.isListening === true);
        visibleAssets.forEach(function(visibleAsset) {
          return __awaiter(this, void 0, void 0, function* () {
            let assetData = yield self2.apiService.getAsset({ id: visibleAsset.id });
            Object.keys(visibleAsset).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAsset[fixedKey] !== assetData[(0, util_1.toSnake)(fixedKey)] && assetData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAsset.inSet(fixedKey, assetData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGateways = this.gateways.filter((i) => i.isListening === true);
        visibleGateways.forEach(function(visibleGateway) {
          return __awaiter(this, void 0, void 0, function* () {
            let gatewayData = yield self2.apiService.getGateway({ id: visibleGateway.id });
            Object.keys(visibleGateway).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGateway[fixedKey] !== gatewayData[(0, util_1.toSnake)(fixedKey)] && gatewayData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGateway.inSet(fixedKey, gatewayData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGatewaySoftwareVersions = this.gatewaySoftwareVersions.filter((i) => i.isListening === true);
        visibleGatewaySoftwareVersions.forEach(function(visibleGatewaySoftwareVersion) {
          return __awaiter(this, void 0, void 0, function* () {
            let gatewaySoftwareVersionData = yield self2.apiService.getGatewaySoftwareVersion({
              id: visibleGatewaySoftwareVersion.id
            });
            Object.keys(visibleGatewaySoftwareVersion).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGatewaySoftwareVersion[fixedKey] !== gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)] && gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGatewaySoftwareVersion.inSet(fixedKey, gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleSites = this.sites.filter((i) => i.isListening === true);
        visibleSites.forEach(function(visibleSite) {
          return __awaiter(this, void 0, void 0, function* () {
            let siteData = yield self2.apiService.getSite({ id: visibleSite.id });
            Object.keys(visibleSite).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleSite[fixedKey] !== siteData[(0, util_1.toSnake)(fixedKey)] && siteData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleSite.inSet(fixedKey, siteData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleSessions = this.sessions.filter((i) => i.isListening === true);
        visibleSessions.forEach(function(visibleSession) {
          return __awaiter(this, void 0, void 0, function* () {
            let sessionData = yield self2.apiService.getSession({ id: visibleSession.id });
            Object.keys(visibleSession).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleSession[fixedKey] !== sessionData[(0, util_1.toSnake)(fixedKey)] && sessionData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleSession.inSet(fixedKey, sessionData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visiblePlacess = this.placess.filter((i) => i.isListening === true);
        visiblePlacess.forEach(function(visiblePlaces) {
          return __awaiter(this, void 0, void 0, function* () {
            let placesData = yield self2.apiService.getPlaces({ id: visiblePlaces.id });
            Object.keys(visiblePlaces).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visiblePlaces[fixedKey] !== placesData[(0, util_1.toSnake)(fixedKey)] && placesData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visiblePlaces.inSet(fixedKey, placesData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleModbusModels = this.modbusModels.filter((i) => i.isListening === true);
        visibleModbusModels.forEach(function(visibleModbusModel) {
          return __awaiter(this, void 0, void 0, function* () {
            let modbusModelData = yield self2.apiService.getModbusModel({ id: visibleModbusModel.id });
            Object.keys(visibleModbusModel).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleModbusModel[fixedKey] !== modbusModelData[(0, util_1.toSnake)(fixedKey)] && modbusModelData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleModbusModel.inSet(fixedKey, modbusModelData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleOccupancySchedules = this.occupancySchedules.filter((i) => i.isListening === true);
        visibleOccupancySchedules.forEach(function(visibleOccupancySchedule) {
          return __awaiter(this, void 0, void 0, function* () {
            let occupancyScheduleData = yield self2.apiService.getOccupancySchedule({ id: visibleOccupancySchedule.id });
            Object.keys(visibleOccupancySchedule).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleOccupancySchedule[fixedKey] !== occupancyScheduleData[(0, util_1.toSnake)(fixedKey)] && occupancyScheduleData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleOccupancySchedule.inSet(fixedKey, occupancyScheduleData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleOrganisations = this.organisations.filter((i) => i.isListening === true);
        visibleOrganisations.forEach(function(visibleOrganisation) {
          return __awaiter(this, void 0, void 0, function* () {
            let organisationData = yield self2.apiService.getOrganisation({ id: visibleOrganisation.id });
            Object.keys(visibleOrganisation).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleOrganisation[fixedKey] !== organisationData[(0, util_1.toSnake)(fixedKey)] && organisationData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleOrganisation.inSet(fixedKey, organisationData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visiblePaymentCards = this.paymentCards.filter((i) => i.isListening === true);
        visiblePaymentCards.forEach(function(visiblePaymentCard) {
          return __awaiter(this, void 0, void 0, function* () {
            let paymentCardData = yield self2.apiService.getPaymentCard({ id: visiblePaymentCard.id });
            Object.keys(visiblePaymentCard).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visiblePaymentCard[fixedKey] !== paymentCardData[(0, util_1.toSnake)(fixedKey)] && paymentCardData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visiblePaymentCard.inSet(fixedKey, paymentCardData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleRules = this.rules.filter((i) => i.isListening === true);
        visibleRules.forEach(function(visibleRule) {
          return __awaiter(this, void 0, void 0, function* () {
            let ruleData = yield self2.apiService.getRule({ id: visibleRule.id });
            Object.keys(visibleRule).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleRule[fixedKey] !== ruleData[(0, util_1.toSnake)(fixedKey)] && ruleData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleRule.inSet(fixedKey, ruleData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataRequests = this.dataRequests.filter((i) => i.isListening === true);
        visibleDataRequests.forEach(function(visibleDataRequest) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataRequestData = yield self2.apiService.getDataRequest({ id: visibleDataRequest.id });
            Object.keys(visibleDataRequest).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataRequest[fixedKey] !== dataRequestData[(0, util_1.toSnake)(fixedKey)] && dataRequestData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataRequest.inSet(fixedKey, dataRequestData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleInvoiceRequests = this.invoiceRequests.filter((i) => i.isListening === true);
        visibleInvoiceRequests.forEach(function(visibleInvoiceRequest) {
          return __awaiter(this, void 0, void 0, function* () {
            let invoiceRequestData = yield self2.apiService.getInvoiceRequest({ id: visibleInvoiceRequest.id });
            Object.keys(visibleInvoiceRequest).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleInvoiceRequest[fixedKey] !== invoiceRequestData[(0, util_1.toSnake)(fixedKey)] && invoiceRequestData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleInvoiceRequest.inSet(fixedKey, invoiceRequestData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleSiteGroups = this.siteGroups.filter((i) => i.isListening === true);
        visibleSiteGroups.forEach(function(visibleSiteGroup) {
          return __awaiter(this, void 0, void 0, function* () {
            let siteGroupData = yield self2.apiService.getSiteGroup({ id: visibleSiteGroup.id });
            Object.keys(visibleSiteGroup).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleSiteGroup[fixedKey] !== siteGroupData[(0, util_1.toSnake)(fixedKey)] && siteGroupData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleSiteGroup.inSet(fixedKey, siteGroupData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGroups = this.groups.filter((i) => i.isListening === true);
        visibleGroups.forEach(function(visibleGroup) {
          return __awaiter(this, void 0, void 0, function* () {
            let groupData = yield self2.apiService.getGroup({ id: visibleGroup.id });
            Object.keys(visibleGroup).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGroup[fixedKey] !== groupData[(0, util_1.toSnake)(fixedKey)] && groupData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGroup.inSet(fixedKey, groupData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleTariffs = this.tariffs.filter((i) => i.isListening === true);
        visibleTariffs.forEach(function(visibleTariff) {
          return __awaiter(this, void 0, void 0, function* () {
            let tariffData = yield self2.apiService.getTariff({ id: visibleTariff.id });
            Object.keys(visibleTariff).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleTariff[fixedKey] !== tariffData[(0, util_1.toSnake)(fixedKey)] && tariffData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleTariff.inSet(fixedKey, tariffData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleReports = this.reports.filter((i) => i.isListening === true);
        visibleReports.forEach(function(visibleReport) {
          return __awaiter(this, void 0, void 0, function* () {
            let reportData = yield self2.apiService.getReport({ id: visibleReport.id });
            Object.keys(visibleReport).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleReport[fixedKey] !== reportData[(0, util_1.toSnake)(fixedKey)] && reportData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleReport.inSet(fixedKey, reportData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGaiaConversations = this.gaiaConversations.filter((i) => i.isListening === true);
        visibleGaiaConversations.forEach(function(visibleGaiaConversation) {
          return __awaiter(this, void 0, void 0, function* () {
            let gaiaConversationData = yield self2.apiService.getGaiaConversation({ id: visibleGaiaConversation.id });
            Object.keys(visibleGaiaConversation).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGaiaConversation[fixedKey] !== gaiaConversationData[(0, util_1.toSnake)(fixedKey)] && gaiaConversationData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGaiaConversation.inSet(fixedKey, gaiaConversationData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataCategorys = this.dataCategorys.filter((i) => i.isListening === true);
        visibleDataCategorys.forEach(function(visibleDataCategory) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataCategoryData = yield self2.apiService.getDataCategory({ id: visibleDataCategory.id });
            Object.keys(visibleDataCategory).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataCategory[fixedKey] !== dataCategoryData[(0, util_1.toSnake)(fixedKey)] && dataCategoryData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataCategory.inSet(fixedKey, dataCategoryData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataTypes = this.dataTypes.filter((i) => i.isListening === true);
        visibleDataTypes.forEach(function(visibleDataType) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataTypeData = yield self2.apiService.getDataType({ id: visibleDataType.id });
            Object.keys(visibleDataType).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataType[fixedKey] !== dataTypeData[(0, util_1.toSnake)(fixedKey)] && dataTypeData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataType.inSet(fixedKey, dataTypeData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleWidgetBoards = this.widgetBoards.filter((i) => i.isListening === true);
        visibleWidgetBoards.forEach(function(visibleWidgetBoard) {
          return __awaiter(this, void 0, void 0, function* () {
            let widgetBoardData = yield self2.apiService.getWidgetBoard({ id: visibleWidgetBoard.id });
            Object.keys(visibleWidgetBoard).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleWidgetBoard[fixedKey] !== widgetBoardData[(0, util_1.toSnake)(fixedKey)] && widgetBoardData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleWidgetBoard.inSet(fixedKey, widgetBoardData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAudits = this.audits.filter((i) => i.isListening === true);
        visibleAudits.forEach(function(visibleAudit) {
          return __awaiter(this, void 0, void 0, function* () {
            let auditData = yield self2.apiService.getAudit({ id: visibleAudit.id });
            Object.keys(visibleAudit).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAudit[fixedKey] !== auditData[(0, util_1.toSnake)(fixedKey)] && auditData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAudit.inSet(fixedKey, auditData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleApplications = this.applications.filter((i) => i.isListening === true);
        visibleApplications.forEach(function(visibleApplication) {
          return __awaiter(this, void 0, void 0, function* () {
            let applicationData = yield self2.apiService.getApplication({ id: visibleApplication.id });
            Object.keys(visibleApplication).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleApplication[fixedKey] !== applicationData[(0, util_1.toSnake)(fixedKey)] && applicationData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleApplication.inSet(fixedKey, applicationData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAnomalyModels = this.anomalyModels.filter((i) => i.isListening === true);
        visibleAnomalyModels.forEach(function(visibleAnomalyModel) {
          return __awaiter(this, void 0, void 0, function* () {
            let anomalyModelData = yield self2.apiService.getAnomalyModel({ id: visibleAnomalyModel.id });
            Object.keys(visibleAnomalyModel).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAnomalyModel[fixedKey] !== anomalyModelData[(0, util_1.toSnake)(fixedKey)] && anomalyModelData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAnomalyModel.inSet(fixedKey, anomalyModelData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAnomalys = this.anomalys.filter((i) => i.isListening === true);
        visibleAnomalys.forEach(function(visibleAnomaly) {
          return __awaiter(this, void 0, void 0, function* () {
            let anomalyData = yield self2.apiService.getAnomaly({ id: visibleAnomaly.id });
            Object.keys(visibleAnomaly).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAnomaly[fixedKey] !== anomalyData[(0, util_1.toSnake)(fixedKey)] && anomalyData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAnomaly.inSet(fixedKey, anomalyData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAccounts = this.accounts.filter((i) => i.isListening === true);
        visibleAccounts.forEach(function(visibleAccount) {
          return __awaiter(this, void 0, void 0, function* () {
            let accountData = yield self2.apiService.getAccount({ id: visibleAccount.id });
            Object.keys(visibleAccount).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAccount[fixedKey] !== accountData[(0, util_1.toSnake)(fixedKey)] && accountData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAccount.inSet(fixedKey, accountData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visiblePreferencess = this.preferencess.filter((i) => i.isListening === true);
        visiblePreferencess.forEach(function(visiblePreferences) {
          return __awaiter(this, void 0, void 0, function* () {
            let preferencesData = yield self2.apiService.getPreferences({ id: visiblePreferences.id });
            Object.keys(visiblePreferences).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visiblePreferences[fixedKey] !== preferencesData[(0, util_1.toSnake)(fixedKey)] && preferencesData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visiblePreferences.inSet(fixedKey, preferencesData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visiblePhysicalGateways = this.physicalGateways.filter((i) => i.isListening === true);
        visiblePhysicalGateways.forEach(function(visiblePhysicalGateway) {
          return __awaiter(this, void 0, void 0, function* () {
            let physicalGatewayData = yield self2.apiService.getPhysicalGateway({ id: visiblePhysicalGateway.id });
            Object.keys(visiblePhysicalGateway).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visiblePhysicalGateway[fixedKey] !== physicalGatewayData[(0, util_1.toSnake)(fixedKey)] && physicalGatewayData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visiblePhysicalGateway.inSet(fixedKey, physicalGatewayData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataUploads = this.dataUploads.filter((i) => i.isListening === true);
        visibleDataUploads.forEach(function(visibleDataUpload) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataUploadData = yield self2.apiService.getDataUpload({ id: visibleDataUpload.id });
            Object.keys(visibleDataUpload).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataUpload[fixedKey] !== dataUploadData[(0, util_1.toSnake)(fixedKey)] && dataUploadData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataUpload.inSet(fixedKey, dataUploadData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleVerifyOrgInvites = this.verifyOrgInvites.filter((i) => i.isListening === true);
        visibleVerifyOrgInvites.forEach(function(visibleVerifyOrgInvite) {
          return __awaiter(this, void 0, void 0, function* () {
            let verifyOrgInviteData = yield self2.apiService.getVerifyOrgInvite({ id: visibleVerifyOrgInvite.id });
            Object.keys(visibleVerifyOrgInvite).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleVerifyOrgInvite[fixedKey] !== verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)] && verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleVerifyOrgInvite.inSet(fixedKey, verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDcSessions = this.dcSessions.filter((i) => i.isListening === true);
        visibleDcSessions.forEach(function(visibleDcSession) {
          return __awaiter(this, void 0, void 0, function* () {
            let dcSessionData = yield self2.apiService.getDcSession({ id: visibleDcSession.id });
            Object.keys(visibleDcSession).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDcSession[fixedKey] !== dcSessionData[(0, util_1.toSnake)(fixedKey)] && dcSessionData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDcSession.inSet(fixedKey, dcSessionData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDcChargePoints = this.dcChargePoints.filter((i) => i.isListening === true);
        visibleDcChargePoints.forEach(function(visibleDcChargePoint) {
          return __awaiter(this, void 0, void 0, function* () {
            let dcChargePointData = yield self2.apiService.getDcChargePoint({ id: visibleDcChargePoint.id });
            Object.keys(visibleDcChargePoint).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDcChargePoint[fixedKey] !== dcChargePointData[(0, util_1.toSnake)(fixedKey)] && dcChargePointData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDcChargePoint.inSet(fixedKey, dcChargePointData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleResetTokens = this.resetTokens.filter((i) => i.isListening === true);
        visibleResetTokens.forEach(function(visibleResetToken) {
          return __awaiter(this, void 0, void 0, function* () {
            let resetTokenData = yield self2.apiService.getResetToken({ id: visibleResetToken.id });
            Object.keys(visibleResetToken).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleResetToken[fixedKey] !== resetTokenData[(0, util_1.toSnake)(fixedKey)] && resetTokenData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleResetToken.inSet(fixedKey, resetTokenData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleOrgPartners = this.orgPartners.filter((i) => i.isListening === true);
        visibleOrgPartners.forEach(function(visibleOrgPartner) {
          return __awaiter(this, void 0, void 0, function* () {
            let orgPartnerData = yield self2.apiService.getOrgPartner({ id: visibleOrgPartner.id });
            Object.keys(visibleOrgPartner).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleOrgPartner[fixedKey] !== orgPartnerData[(0, util_1.toSnake)(fixedKey)] && orgPartnerData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleOrgPartner.inSet(fixedKey, orgPartnerData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleOrganisationManagements = this.organisationManagements.filter((i) => i.isListening === true);
        visibleOrganisationManagements.forEach(function(visibleOrganisationManagement) {
          return __awaiter(this, void 0, void 0, function* () {
            let organisationManagementData = yield self2.apiService.getOrganisationManagement({
              id: visibleOrganisationManagement.id
            });
            Object.keys(visibleOrganisationManagement).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleOrganisationManagement[fixedKey] !== organisationManagementData[(0, util_1.toSnake)(fixedKey)] && organisationManagementData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleOrganisationManagement.inSet(fixedKey, organisationManagementData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleStagingDatabases = this.stagingDatabases.filter((i) => i.isListening === true);
        visibleStagingDatabases.forEach(function(visibleStagingDatabase) {
          return __awaiter(this, void 0, void 0, function* () {
            let stagingDatabaseData = yield self2.apiService.getStagingDatabase({ id: visibleStagingDatabase.id });
            Object.keys(visibleStagingDatabase).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleStagingDatabase[fixedKey] !== stagingDatabaseData[(0, util_1.toSnake)(fixedKey)] && stagingDatabaseData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleStagingDatabase.inSet(fixedKey, stagingDatabaseData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleZigbeeFirmwares = this.zigbeeFirmwares.filter((i) => i.isListening === true);
        visibleZigbeeFirmwares.forEach(function(visibleZigbeeFirmware) {
          return __awaiter(this, void 0, void 0, function* () {
            let zigbeeFirmwareData = yield self2.apiService.getZigbeeFirmware({ id: visibleZigbeeFirmware.id });
            Object.keys(visibleZigbeeFirmware).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleZigbeeFirmware[fixedKey] !== zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)] && zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleZigbeeFirmware.inSet(fixedKey, zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGatewayTrustLists = this.gatewayTrustLists.filter((i) => i.isListening === true);
        visibleGatewayTrustLists.forEach(function(visibleGatewayTrustList) {
          return __awaiter(this, void 0, void 0, function* () {
            let gatewayTrustListData = yield self2.apiService.getGatewayTrustList({ id: visibleGatewayTrustList.id });
            Object.keys(visibleGatewayTrustList).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGatewayTrustList[fixedKey] !== gatewayTrustListData[(0, util_1.toSnake)(fixedKey)] && gatewayTrustListData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGatewayTrustList.inSet(fixedKey, gatewayTrustListData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGatewayTrustedDeviceAnalysiss = this.gatewayTrustedDeviceAnalysiss.filter((i) => i.isListening === true);
        visibleGatewayTrustedDeviceAnalysiss.forEach(function(visibleGatewayTrustedDeviceAnalysis) {
          return __awaiter(this, void 0, void 0, function* () {
            let gatewayTrustedDeviceAnalysisData = yield self2.apiService.getGatewayTrustedDeviceAnalysis({
              id: visibleGatewayTrustedDeviceAnalysis.id
            });
            Object.keys(visibleGatewayTrustedDeviceAnalysis).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGatewayTrustedDeviceAnalysis[fixedKey] !== gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)] && gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGatewayTrustedDeviceAnalysis.inSet(fixedKey, gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAggregateTelemetrys = this.aggregateTelemetrys.filter((i) => i.isListening === true);
        visibleAggregateTelemetrys.forEach(function(visibleAggregateTelemetry) {
          return __awaiter(this, void 0, void 0, function* () {
            let aggregateTelemetryData = yield self2.apiService.getAggregateTelemetry({ id: visibleAggregateTelemetry.id });
            Object.keys(visibleAggregateTelemetry).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAggregateTelemetry[fixedKey] !== aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)] && aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAggregateTelemetry.inSet(fixedKey, aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleInstantaneousTelemetrys = this.instantaneousTelemetrys.filter((i) => i.isListening === true);
        visibleInstantaneousTelemetrys.forEach(function(visibleInstantaneousTelemetry) {
          return __awaiter(this, void 0, void 0, function* () {
            let instantaneousTelemetryData = yield self2.apiService.getInstantaneousTelemetry({
              id: visibleInstantaneousTelemetry.id
            });
            Object.keys(visibleInstantaneousTelemetry).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleInstantaneousTelemetry[fixedKey] !== instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)] && instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleInstantaneousTelemetry.inSet(fixedKey, instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleGatewayGods = this.gatewayGods.filter((i) => i.isListening === true);
        visibleGatewayGods.forEach(function(visibleGatewayGod) {
          return __awaiter(this, void 0, void 0, function* () {
            let gatewayGodData = yield self2.apiService.getGatewayGod({ id: visibleGatewayGod.id });
            Object.keys(visibleGatewayGod).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleGatewayGod[fixedKey] !== gatewayGodData[(0, util_1.toSnake)(fixedKey)] && gatewayGodData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleGatewayGod.inSet(fixedKey, gatewayGodData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleAssetGods = this.assetGods.filter((i) => i.isListening === true);
        visibleAssetGods.forEach(function(visibleAssetGod) {
          return __awaiter(this, void 0, void 0, function* () {
            let assetGodData = yield self2.apiService.getAssetGod({ id: visibleAssetGod.id });
            Object.keys(visibleAssetGod).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleAssetGod[fixedKey] !== assetGodData[(0, util_1.toSnake)(fixedKey)] && assetGodData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleAssetGod.inSet(fixedKey, assetGodData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataUnits = this.dataUnits.filter((i) => i.isListening === true);
        visibleDataUnits.forEach(function(visibleDataUnit) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataUnitData = yield self2.apiService.getDataUnit({ id: visibleDataUnit.id });
            Object.keys(visibleDataUnit).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataUnit[fixedKey] !== dataUnitData[(0, util_1.toSnake)(fixedKey)] && dataUnitData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataUnit.inSet(fixedKey, dataUnitData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleItemMetadatas = this.itemMetadatas.filter((i) => i.isListening === true);
        visibleItemMetadatas.forEach(function(visibleItemMetadata) {
          return __awaiter(this, void 0, void 0, function* () {
            let itemMetadataData = yield self2.apiService.getItemMetadata({ id: visibleItemMetadata.id });
            Object.keys(visibleItemMetadata).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleItemMetadata[fixedKey] !== itemMetadataData[(0, util_1.toSnake)(fixedKey)] && itemMetadataData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleItemMetadata.inSet(fixedKey, itemMetadataData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
        let visibleDataFileImports = this.dataFileImports.filter((i) => i.isListening === true);
        visibleDataFileImports.forEach(function(visibleDataFileImport) {
          return __awaiter(this, void 0, void 0, function* () {
            let dataFileImportData = yield self2.apiService.getDataFileImport({ id: visibleDataFileImport.id });
            Object.keys(visibleDataFileImport).forEach(function(key) {
              let fixedKey = key.substr(1);
              if (visibleDataFileImport[fixedKey] !== dataFileImportData[(0, util_1.toSnake)(fixedKey)] && dataFileImportData[(0, util_1.toSnake)(fixedKey)] !== void 0) {
                visibleDataFileImport.inSet(fixedKey, dataFileImportData[(0, util_1.toSnake)(fixedKey)]);
              }
            });
          });
        });
      }
      getVisibleObjects() {
        let visibleObjectList = [];
        visibleObjectList.push({
          type: "list",
          list: this.lists.filter((i) => i.isListening === true).map((i) => i.requestIds.map((rId) => ({ id: rId, type: i.type }))).flat()
        });
        visibleObjectList.push({ type: "asset", list: this.assets.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "gateway",
          list: this.gateways.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewaySoftwareVersion",
          list: this.gatewaySoftwareVersions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "site", list: this.sites.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({ type: "order", list: this.orders.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "session",
          list: this.sessions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "discount",
          list: this.discounts.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "stripeSession",
          list: this.stripeSessions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "stripeWebhook",
          list: this.stripeWebhooks.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "zapierWebhook",
          list: this.zapierWebhooks.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "places",
          list: this.placess.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "product",
          list: this.products.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "modbusModel",
          list: this.modbusModels.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "occupancySchedule",
          list: this.occupancySchedules.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "pubOrg",
          list: this.pubOrgs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "organisation",
          list: this.organisations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "paymentCard",
          list: this.paymentCards.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetEvent",
          list: this.assetEvents.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayEvent",
          list: this.gatewayEvents.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetTelemetry",
          list: this.assetTelemetrys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "rule", list: this.rules.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "dataRequest",
          list: this.dataRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataRequestLink",
          list: this.dataRequestLinks.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataRequestRun",
          list: this.dataRequestRuns.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "invoiceRequest",
          list: this.invoiceRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "invoiceRequestLink",
          list: this.invoiceRequestLinks.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "siteGroup",
          list: this.siteGroups.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "group", list: this.groups.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "duckChargeAdmin",
          list: this.duckChargeAdmins.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "customFieldType",
          list: this.customFieldTypes.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "customField",
          list: this.customFields.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "location",
          list: this.locations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "searchHistory",
          list: this.searchHistorys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "tariff",
          list: this.tariffs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "groupType",
          list: this.groupTypes.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "calculatorInbound",
          list: this.calculatorInbounds.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "calculatorResult",
          list: this.calculatorResults.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "createReport",
          list: this.createReports.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "reportHistory",
          list: this.reportHistorys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "report",
          list: this.reports.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "reportFile",
          list: this.reportFiles.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gaiaConversation",
          list: this.gaiaConversations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gaiaMessage",
          list: this.gaiaMessages.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataCategory",
          list: this.dataCategorys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataType",
          list: this.dataTypes.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "deviceCategory",
          list: this.deviceCategorys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "widgetBoard",
          list: this.widgetBoards.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "reportFileLink",
          list: this.reportFileLinks.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "ruleEvent",
          list: this.ruleEvents.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "audit", list: this.audits.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "application",
          list: this.applications.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "anomalyModel",
          list: this.anomalyModels.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "anomaly",
          list: this.anomalys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gridduckSubscription",
          list: this.gridduckSubscriptions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gridduckInvoice",
          list: this.gridduckInvoices.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "account",
          list: this.accounts.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "customFieldData",
          list: this.customFieldDatas.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "preferences",
          list: this.preferencess.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dcRetryPayment",
          list: this.dcRetryPayments.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "issue", list: this.issues.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "ignoredDevice",
          list: this.ignoredDevices.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "resetSecret",
          list: this.resetSecrets.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "requestSecret",
          list: this.requestSecrets.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetIdentification",
          list: this.assetIdentifications.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "getPhaseBreakdown",
          list: this.getPhaseBreakdowns.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "availableGateway",
          list: this.availableGateways.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetDemand",
          list: this.assetDemands.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetConsumption",
          list: this.assetConsumptions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "physicalGateway",
          list: this.physicalGateways.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "sitePermission",
          list: this.sitePermissions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "applianceCategory",
          list: this.applianceCategorys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "applianceType",
          list: this.applianceTypes.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataUpload",
          list: this.dataUploads.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({ type: "file", list: this.files.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({ type: "zip", list: this.zips.filter((i) => i.isListening === true).map((i) => i.id) });
        visibleObjectList.push({
          type: "search",
          list: this.searchs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "verifyOrgInvite",
          list: this.verifyOrgInvites.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "confirmOrgInvite",
          list: this.confirmOrgInvites.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dcCreateAccount",
          list: this.dcCreateAccounts.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dcSession",
          list: this.dcSessions.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "paymentSheet",
          list: this.paymentSheets.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dcChargePoint",
          list: this.dcChargePoints.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dcChargeStation",
          list: this.dcChargeStations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "organisationInvite",
          list: this.organisationInvites.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "organisationMember",
          list: this.organisationMembers.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "detectedDevice",
          list: this.detectedDevices.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "resetToken",
          list: this.resetTokens.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "password",
          list: this.passwords.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "thirdPartyIntegration",
          list: this.thirdPartyIntegrations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "orgPartner",
          list: this.orgPartners.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "mfaSecret",
          list: this.mfaSecrets.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "mfaVerification",
          list: this.mfaVerifications.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "mfaAuthentication",
          list: this.mfaAuthentications.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "loginAs",
          list: this.loginAss.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "loginAsPartner",
          list: this.loginAsPartners.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "organisationManagement",
          list: this.organisationManagements.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "stagingDatabase",
          list: this.stagingDatabases.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "notification",
          list: this.notifications.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "zigbeeFirmware",
          list: this.zigbeeFirmwares.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayTrustList",
          list: this.gatewayTrustLists.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayTrustedDeviceUntrustRequest",
          list: this.gatewayTrustedDeviceUntrustRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "telemetryOperation",
          list: this.telemetryOperations.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "aggregateTelemetryGroupRequest",
          list: this.aggregateTelemetryGroupRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetRemoveDataRequest",
          list: this.assetRemoveDataRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetAggregateDataRequest",
          list: this.assetAggregateDataRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayTrustedDeviceAnalysis",
          list: this.gatewayTrustedDeviceAnalysiss.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "aggregateTelemetry",
          list: this.aggregateTelemetrys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "instantaneousTelemetry",
          list: this.instantaneousTelemetrys.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "organisationSearch",
          list: this.organisationSearchs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayLogDownloadRequest",
          list: this.gatewayLogDownloadRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayEnhancedLogDownloadRequest",
          list: this.gatewayEnhancedLogDownloadRequests.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "gatewayGod",
          list: this.gatewayGods.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetGod",
          list: this.assetGods.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetTelemetryBatch",
          list: this.assetTelemetryBatchs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetConsumptionBatch",
          list: this.assetConsumptionBatchs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "rawAggregateData",
          list: this.rawAggregateDatas.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "assetReset",
          list: this.assetResets.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "inspiredLogin",
          list: this.inspiredLogins.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataUnit",
          list: this.dataUnits.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "itemMetadata",
          list: this.itemMetadatas.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "bounceEmail",
          list: this.bounceEmails.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataFileImport",
          list: this.dataFileImports.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataFileImportLog",
          list: this.dataFileImportLogs.filter((i) => i.isListening === true).map((i) => i.id)
        });
        visibleObjectList.push({
          type: "dataFileImportUpload",
          list: this.dataFileImportUploads.filter((i) => i.isListening === true).map((i) => i.id)
        });
        return visibleObjectList;
      }
    };
    exports2.default = DataService;
  }
});

// ../gridduck/dist/services/base-socket-service.js
var require_base_socket_service = __commonJS({
  "../gridduck/dist/services/base-socket-service.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var util_1 = require_util2();
    var BaseSocketService = class {
      constructor(dataService, apiService) {
        this.dataService = dataService;
        this.apiService = apiService;
        let self2 = this;
        this.apiService.setSocketCallback(function(message) {
          self2.socketCallback(message);
        });
      }
      socketCallback(message) {
        let self2 = this;
        let keys = Object.keys(message);
        keys.forEach(function(operation) {
          if (operation === "update") {
            let updates = message[operation];
            updates.forEach(function(update) {
              let type2 = Object.keys(update)[0];
              let updateObj = update[type2];
              if (type2) {
                if (self2.dataService[(0, util_1.toCamel)(type2) + "s"]) {
                  if (type2 === "list") {
                    let item = self2.dataService.lists.find((l) => ~l.requestIds.indexOf(updateObj.id));
                    if (item) {
                      let listType = updateObj.type;
                      item.inSet("total", updateObj.content.pagination.total);
                      item.updateList(updateObj.content.results.map((i) => self2.createObject(listType, i)), updateObj.id);
                    }
                  } else {
                    let item = self2.dataService[(0, util_1.toCamel)(type2) + "s"].find((a4) => a4.id === updateObj.id);
                    if (item) {
                      Object.keys(updateObj).forEach(function(field) {
                        if (field !== "id") {
                          item.inSet((0, util_1.toCamel)(field), updateObj[field]);
                        }
                      });
                    }
                  }
                }
                if (type2 === "type" && update["type"] === "resync") {
                  self2.dataService.clearLists();
                  self2.dataService.emitter.emit("resync");
                }
              }
            });
          }
          if (operation === "delete") {
            let deletes = message[operation];
            deletes.forEach(function(update) {
              let type2 = Object.keys(update)[0];
              let deleteObj = update[type2];
              if (self2.dataService[type2 + "s"]) {
                let item = self2.dataService[type2 + "s"].find((a4) => a4.id === deleteObj.id);
                if (item) {
                  item.setDeleted();
                  self2.dataService[type2 + "s"].splice(self2.dataService[type2 + "s"].indexOf(item), 1);
                }
              }
            });
          }
        });
      }
      createObject(type2, createObject) {
        return null;
      }
    };
    exports2.default = BaseSocketService;
  }
});

// ../gridduck/dist/services/socket-service.js
var require_socket_service = __commonJS({
  "../gridduck/dist/services/socket-service.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var account_1 = __importDefault(require_account());
    var aggregateTelemetry_1 = __importDefault(require_aggregateTelemetry());
    var aggregateTelemetryGroupRequest_1 = __importDefault(require_aggregateTelemetryGroupRequest());
    var anomaly_1 = __importDefault(require_anomaly2());
    var anomalyModel_1 = __importDefault(require_anomalyModel2());
    var applianceCategory_1 = __importDefault(require_applianceCategory());
    var applianceType_1 = __importDefault(require_applianceType());
    var application_1 = __importDefault(require_application());
    var asset_1 = __importDefault(require_asset());
    var assetAggregateDataRequest_1 = __importDefault(require_assetAggregateDataRequest());
    var assetConsumption_1 = __importDefault(require_assetConsumption());
    var assetConsumptionBatch_1 = __importDefault(require_assetConsumptionBatch());
    var assetDemand_1 = __importDefault(require_assetDemand());
    var assetEvent_1 = __importDefault(require_assetEvent());
    var assetGod_1 = __importDefault(require_assetGod());
    var assetIdentification_1 = __importDefault(require_assetIdentification());
    var assetRemoveDataRequest_1 = __importDefault(require_assetRemoveDataRequest());
    var assetReset_1 = __importDefault(require_assetReset());
    var assetTelemetry_1 = __importDefault(require_assetTelemetry());
    var assetTelemetryBatch_1 = __importDefault(require_assetTelemetryBatch());
    var audit_1 = __importDefault(require_audit());
    var availableGateway_1 = __importDefault(require_availableGateway());
    var bounceEmail_1 = __importDefault(require_bounceEmail());
    var calculatorInbound_1 = __importDefault(require_calculatorInbound());
    var calculatorResult_1 = __importDefault(require_calculatorResult());
    var confirmOrgInvite_1 = __importDefault(require_confirmOrgInvite());
    var createReport_1 = __importDefault(require_createReport());
    var customField_1 = __importDefault(require_customField());
    var customFieldData_1 = __importDefault(require_customFieldData());
    var customFieldType_1 = __importDefault(require_customFieldType());
    var dataCategory_1 = __importDefault(require_dataCategory());
    var dataFileImport_1 = __importDefault(require_dataFileImport());
    var dataFileImportLog_1 = __importDefault(require_dataFileImportLog());
    var dataFileImportUpload_1 = __importDefault(require_dataFileImportUpload());
    var dataRequest_1 = __importDefault(require_dataRequest());
    var dataRequestLink_1 = __importDefault(require_dataRequestLink());
    var dataRequestRun_1 = __importDefault(require_dataRequestRun());
    var dataType_1 = __importDefault(require_dataType());
    var dataUnit_1 = __importDefault(require_dataUnit());
    var dataUpload_1 = __importDefault(require_dataUpload());
    var dcChargePoint_1 = __importDefault(require_dcChargePoint());
    var dcChargeStation_1 = __importDefault(require_dcChargeStation());
    var dcCreateAccount_1 = __importDefault(require_dcCreateAccount());
    var dcRetryPayment_1 = __importDefault(require_dcRetryPayment());
    var dcSession_1 = __importDefault(require_dcSession());
    var detectedDevice_1 = __importDefault(require_detectedDevice());
    var deviceCategory_1 = __importDefault(require_deviceCategory());
    var discount_1 = __importDefault(require_discount());
    var duckChargeAdmin_1 = __importDefault(require_duckChargeAdmin());
    var file_1 = __importDefault(require_file());
    var gaiaConversation_1 = __importDefault(require_gaiaConversation());
    var gaiaMessage_1 = __importDefault(require_gaiaMessage());
    var gateway_1 = __importDefault(require_gateway());
    var gatewayEnhancedLogDownloadRequest_1 = __importDefault(require_gatewayEnhancedLogDownloadRequest());
    var gatewayEvent_1 = __importDefault(require_gatewayEvent());
    var gatewayGod_1 = __importDefault(require_gatewayGod());
    var gatewayLogDownloadRequest_1 = __importDefault(require_gatewayLogDownloadRequest());
    var gatewaySoftwareVersion_1 = __importDefault(require_gatewaySoftwareVersion());
    var gatewayTrustList_1 = __importDefault(require_gatewayTrustList());
    var gatewayTrustedDeviceAnalysis_1 = __importDefault(require_gatewayTrustedDeviceAnalysis());
    var gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require_gatewayTrustedDeviceUntrustRequest());
    var getPhaseBreakdown_1 = __importDefault(require_getPhaseBreakdown());
    var gridduckInvoice_1 = __importDefault(require_gridduckInvoice());
    var gridduckSubscription_1 = __importDefault(require_gridduckSubscription());
    var group_1 = __importDefault(require_group());
    var groupType_1 = __importDefault(require_groupType());
    var ignoredDevice_1 = __importDefault(require_ignoredDevice());
    var inspiredLogin_1 = __importDefault(require_inspiredLogin());
    var instantaneousTelemetry_1 = __importDefault(require_instantaneousTelemetry());
    var invoiceRequest_1 = __importDefault(require_invoiceRequest());
    var invoiceRequestLink_1 = __importDefault(require_invoiceRequestLink());
    var issue_1 = __importDefault(require_issue());
    var itemMetadata_1 = __importDefault(require_itemMetadata());
    var location_1 = __importDefault(require_location());
    var loginAs_1 = __importDefault(require_loginAs());
    var loginAsPartner_1 = __importDefault(require_loginAsPartner());
    var mfaAuthentication_1 = __importDefault(require_mfaAuthentication());
    var mfaSecret_1 = __importDefault(require_mfaSecret());
    var mfaVerification_1 = __importDefault(require_mfaVerification());
    var modbusModel_1 = __importDefault(require_modbusModel());
    var notification_1 = __importDefault(require_notification());
    var occupancySchedule_1 = __importDefault(require_occupancySchedule());
    var order_1 = __importDefault(require_order());
    var orgPartner_1 = __importDefault(require_orgPartner());
    var organisation_1 = __importDefault(require_organisation());
    var organisationInvite_1 = __importDefault(require_organisationInvite());
    var organisationManagement_1 = __importDefault(require_organisationManagement());
    var organisationMember_1 = __importDefault(require_organisationMember());
    var organisationSearch_1 = __importDefault(require_organisationSearch());
    var password_1 = __importDefault(require_password());
    var paymentCard_1 = __importDefault(require_paymentCard());
    var paymentSheet_1 = __importDefault(require_paymentSheet());
    var physicalGateway_1 = __importDefault(require_physicalGateway());
    var places_1 = __importDefault(require_places());
    var preferences_1 = __importDefault(require_preferences());
    var product_1 = __importDefault(require_product());
    var pubOrg_1 = __importDefault(require_pubOrg());
    var rawAggregateData_1 = __importDefault(require_rawAggregateData());
    var report_1 = __importDefault(require_report());
    var reportFile_1 = __importDefault(require_reportFile());
    var reportFileLink_1 = __importDefault(require_reportFileLink());
    var reportHistory_1 = __importDefault(require_reportHistory());
    var requestSecret_1 = __importDefault(require_requestSecret());
    var resetSecret_1 = __importDefault(require_resetSecret());
    var resetToken_1 = __importDefault(require_resetToken());
    var rule_1 = __importDefault(require_rule());
    var ruleEvent_1 = __importDefault(require_ruleEvent());
    var search_1 = __importDefault(require_search());
    var searchHistory_1 = __importDefault(require_searchHistory());
    var session_1 = __importDefault(require_session());
    var site_1 = __importDefault(require_site());
    var siteGroup_1 = __importDefault(require_siteGroup());
    var sitePermission_1 = __importDefault(require_sitePermission());
    var stagingDatabase_1 = __importDefault(require_stagingDatabase());
    var stripeSession_1 = __importDefault(require_stripeSession());
    var stripeWebhook_1 = __importDefault(require_stripeWebhook());
    var tariff_1 = __importDefault(require_tariff());
    var telemetryOperation_1 = __importDefault(require_telemetryOperation());
    var thirdPartyIntegration_1 = __importDefault(require_thirdPartyIntegration());
    var verifyOrgInvite_1 = __importDefault(require_verifyOrgInvite());
    var widgetBoard_1 = __importDefault(require_widgetBoard());
    var zapierWebhook_1 = __importDefault(require_zapierWebhook());
    var zigbeeFirmware_1 = __importDefault(require_zigbeeFirmware());
    var zip_1 = __importDefault(require_zip());
    var base_socket_service_1 = __importDefault(require_base_socket_service());
    var SocketService = class extends base_socket_service_1.default {
      createObject(type2, createObject) {
        let object2;
        switch (type2) {
          case "asset":
            object2 = new asset_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assets, object2);
            return object2;
          case "gateway":
            object2 = new gateway_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gateways, object2);
            return object2;
          case "gatewaySoftwareVersion":
            object2 = new gatewaySoftwareVersion_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewaySoftwareVersions, object2);
            return object2;
          case "site":
            object2 = new site_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.sites, object2);
            return object2;
          case "order":
            object2 = new order_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.orders, object2);
            return object2;
          case "session":
            object2 = new session_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.sessions, object2);
            return object2;
          case "discount":
            object2 = new discount_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.discounts, object2);
            return object2;
          case "stripeSession":
            object2 = new stripeSession_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.stripeSessions, object2);
            return object2;
          case "stripeWebhook":
            object2 = new stripeWebhook_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.stripeWebhooks, object2);
            return object2;
          case "zapierWebhook":
            object2 = new zapierWebhook_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.zapierWebhooks, object2);
            return object2;
          case "places":
            object2 = new places_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.placess, object2);
            return object2;
          case "product":
            object2 = new product_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.products, object2);
            return object2;
          case "modbusModel":
            object2 = new modbusModel_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.modbusModels, object2);
            return object2;
          case "occupancySchedule":
            object2 = new occupancySchedule_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.occupancySchedules, object2);
            return object2;
          case "pubOrg":
            object2 = new pubOrg_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.pubOrgs, object2);
            return object2;
          case "organisation":
            object2 = new organisation_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.organisations, object2);
            return object2;
          case "paymentCard":
            object2 = new paymentCard_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.paymentCards, object2);
            return object2;
          case "assetEvent":
            object2 = new assetEvent_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetEvents, object2);
            return object2;
          case "gatewayEvent":
            object2 = new gatewayEvent_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayEvents, object2);
            return object2;
          case "assetTelemetry":
            object2 = new assetTelemetry_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetTelemetrys, object2);
            return object2;
          case "rule":
            object2 = new rule_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.rules, object2);
            return object2;
          case "dataRequest":
            object2 = new dataRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataRequests, object2);
            return object2;
          case "dataRequestLink":
            object2 = new dataRequestLink_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataRequestLinks, object2);
            return object2;
          case "dataRequestRun":
            object2 = new dataRequestRun_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataRequestRuns, object2);
            return object2;
          case "invoiceRequest":
            object2 = new invoiceRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.invoiceRequests, object2);
            return object2;
          case "invoiceRequestLink":
            object2 = new invoiceRequestLink_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.invoiceRequestLinks, object2);
            return object2;
          case "siteGroup":
            object2 = new siteGroup_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.siteGroups, object2);
            return object2;
          case "group":
            object2 = new group_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.groups, object2);
            return object2;
          case "duckChargeAdmin":
            object2 = new duckChargeAdmin_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.duckChargeAdmins, object2);
            return object2;
          case "customFieldType":
            object2 = new customFieldType_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.customFieldTypes, object2);
            return object2;
          case "customField":
            object2 = new customField_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.customFields, object2);
            return object2;
          case "location":
            object2 = new location_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.locations, object2);
            return object2;
          case "searchHistory":
            object2 = new searchHistory_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.searchHistorys, object2);
            return object2;
          case "tariff":
            object2 = new tariff_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.tariffs, object2);
            return object2;
          case "groupType":
            object2 = new groupType_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.groupTypes, object2);
            return object2;
          case "calculatorInbound":
            object2 = new calculatorInbound_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.calculatorInbounds, object2);
            return object2;
          case "calculatorResult":
            object2 = new calculatorResult_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.calculatorResults, object2);
            return object2;
          case "createReport":
            object2 = new createReport_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.createReports, object2);
            return object2;
          case "reportHistory":
            object2 = new reportHistory_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.reportHistorys, object2);
            return object2;
          case "report":
            object2 = new report_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.reports, object2);
            return object2;
          case "reportFile":
            object2 = new reportFile_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.reportFiles, object2);
            return object2;
          case "gaiaConversation":
            object2 = new gaiaConversation_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gaiaConversations, object2);
            return object2;
          case "gaiaMessage":
            object2 = new gaiaMessage_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gaiaMessages, object2);
            return object2;
          case "dataCategory":
            object2 = new dataCategory_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataCategorys, object2);
            return object2;
          case "dataType":
            object2 = new dataType_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataTypes, object2);
            return object2;
          case "deviceCategory":
            object2 = new deviceCategory_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.deviceCategorys, object2);
            return object2;
          case "widgetBoard":
            object2 = new widgetBoard_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.widgetBoards, object2);
            return object2;
          case "reportFileLink":
            object2 = new reportFileLink_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.reportFileLinks, object2);
            return object2;
          case "ruleEvent":
            object2 = new ruleEvent_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.ruleEvents, object2);
            return object2;
          case "audit":
            object2 = new audit_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.audits, object2);
            return object2;
          case "application":
            object2 = new application_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.applications, object2);
            return object2;
          case "anomalyModel":
            object2 = new anomalyModel_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.anomalyModels, object2);
            return object2;
          case "anomaly":
            object2 = new anomaly_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.anomalys, object2);
            return object2;
          case "gridduckSubscription":
            object2 = new gridduckSubscription_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gridduckSubscriptions, object2);
            return object2;
          case "gridduckInvoice":
            object2 = new gridduckInvoice_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gridduckInvoices, object2);
            return object2;
          case "account":
            object2 = new account_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.accounts, object2);
            return object2;
          case "customFieldData":
            object2 = new customFieldData_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.customFieldDatas, object2);
            return object2;
          case "preferences":
            object2 = new preferences_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.preferencess, object2);
            return object2;
          case "dcRetryPayment":
            object2 = new dcRetryPayment_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dcRetryPayments, object2);
            return object2;
          case "issue":
            object2 = new issue_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.issues, object2);
            return object2;
          case "ignoredDevice":
            object2 = new ignoredDevice_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.ignoredDevices, object2);
            return object2;
          case "resetSecret":
            object2 = new resetSecret_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.resetSecrets, object2);
            return object2;
          case "requestSecret":
            object2 = new requestSecret_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.requestSecrets, object2);
            return object2;
          case "assetIdentification":
            object2 = new assetIdentification_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetIdentifications, object2);
            return object2;
          case "getPhaseBreakdown":
            object2 = new getPhaseBreakdown_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.getPhaseBreakdowns, object2);
            return object2;
          case "availableGateway":
            object2 = new availableGateway_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.availableGateways, object2);
            return object2;
          case "assetDemand":
            object2 = new assetDemand_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetDemands, object2);
            return object2;
          case "assetConsumption":
            object2 = new assetConsumption_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetConsumptions, object2);
            return object2;
          case "physicalGateway":
            object2 = new physicalGateway_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.physicalGateways, object2);
            return object2;
          case "sitePermission":
            object2 = new sitePermission_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.sitePermissions, object2);
            return object2;
          case "applianceCategory":
            object2 = new applianceCategory_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.applianceCategorys, object2);
            return object2;
          case "applianceType":
            object2 = new applianceType_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.applianceTypes, object2);
            return object2;
          case "dataUpload":
            object2 = new dataUpload_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataUploads, object2);
            return object2;
          case "file":
            object2 = new file_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.files, object2);
            return object2;
          case "zip":
            object2 = new zip_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.zips, object2);
            return object2;
          case "search":
            object2 = new search_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.searchs, object2);
            return object2;
          case "verifyOrgInvite":
            object2 = new verifyOrgInvite_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.verifyOrgInvites, object2);
            return object2;
          case "confirmOrgInvite":
            object2 = new confirmOrgInvite_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.confirmOrgInvites, object2);
            return object2;
          case "dcCreateAccount":
            object2 = new dcCreateAccount_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dcCreateAccounts, object2);
            return object2;
          case "dcSession":
            object2 = new dcSession_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dcSessions, object2);
            return object2;
          case "paymentSheet":
            object2 = new paymentSheet_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.paymentSheets, object2);
            return object2;
          case "dcChargePoint":
            object2 = new dcChargePoint_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dcChargePoints, object2);
            return object2;
          case "dcChargeStation":
            object2 = new dcChargeStation_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dcChargeStations, object2);
            return object2;
          case "organisationInvite":
            object2 = new organisationInvite_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.organisationInvites, object2);
            return object2;
          case "organisationMember":
            object2 = new organisationMember_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.organisationMembers, object2);
            return object2;
          case "detectedDevice":
            object2 = new detectedDevice_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.detectedDevices, object2);
            return object2;
          case "resetToken":
            object2 = new resetToken_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.resetTokens, object2);
            return object2;
          case "password":
            object2 = new password_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.passwords, object2);
            return object2;
          case "thirdPartyIntegration":
            object2 = new thirdPartyIntegration_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.thirdPartyIntegrations, object2);
            return object2;
          case "orgPartner":
            object2 = new orgPartner_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.orgPartners, object2);
            return object2;
          case "mfaSecret":
            object2 = new mfaSecret_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.mfaSecrets, object2);
            return object2;
          case "mfaVerification":
            object2 = new mfaVerification_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.mfaVerifications, object2);
            return object2;
          case "mfaAuthentication":
            object2 = new mfaAuthentication_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.mfaAuthentications, object2);
            return object2;
          case "loginAs":
            object2 = new loginAs_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.loginAss, object2);
            return object2;
          case "loginAsPartner":
            object2 = new loginAsPartner_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.loginAsPartners, object2);
            return object2;
          case "organisationManagement":
            object2 = new organisationManagement_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.organisationManagements, object2);
            return object2;
          case "stagingDatabase":
            object2 = new stagingDatabase_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.stagingDatabases, object2);
            return object2;
          case "notification":
            object2 = new notification_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.notifications, object2);
            return object2;
          case "zigbeeFirmware":
            object2 = new zigbeeFirmware_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.zigbeeFirmwares, object2);
            return object2;
          case "gatewayTrustList":
            object2 = new gatewayTrustList_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayTrustLists, object2);
            return object2;
          case "gatewayTrustedDeviceUntrustRequest":
            object2 = new gatewayTrustedDeviceUntrustRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayTrustedDeviceUntrustRequests, object2);
            return object2;
          case "telemetryOperation":
            object2 = new telemetryOperation_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.telemetryOperations, object2);
            return object2;
          case "aggregateTelemetryGroupRequest":
            object2 = new aggregateTelemetryGroupRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.aggregateTelemetryGroupRequests, object2);
            return object2;
          case "assetRemoveDataRequest":
            object2 = new assetRemoveDataRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetRemoveDataRequests, object2);
            return object2;
          case "assetAggregateDataRequest":
            object2 = new assetAggregateDataRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetAggregateDataRequests, object2);
            return object2;
          case "gatewayTrustedDeviceAnalysis":
            object2 = new gatewayTrustedDeviceAnalysis_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayTrustedDeviceAnalysiss, object2);
            return object2;
          case "aggregateTelemetry":
            object2 = new aggregateTelemetry_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.aggregateTelemetrys, object2);
            return object2;
          case "instantaneousTelemetry":
            object2 = new instantaneousTelemetry_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.instantaneousTelemetrys, object2);
            return object2;
          case "organisationSearch":
            object2 = new organisationSearch_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.organisationSearchs, object2);
            return object2;
          case "gatewayLogDownloadRequest":
            object2 = new gatewayLogDownloadRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayLogDownloadRequests, object2);
            return object2;
          case "gatewayEnhancedLogDownloadRequest":
            object2 = new gatewayEnhancedLogDownloadRequest_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayEnhancedLogDownloadRequests, object2);
            return object2;
          case "gatewayGod":
            object2 = new gatewayGod_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.gatewayGods, object2);
            return object2;
          case "assetGod":
            object2 = new assetGod_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetGods, object2);
            return object2;
          case "assetTelemetryBatch":
            object2 = new assetTelemetryBatch_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetTelemetryBatchs, object2);
            return object2;
          case "assetConsumptionBatch":
            object2 = new assetConsumptionBatch_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetConsumptionBatchs, object2);
            return object2;
          case "rawAggregateData":
            object2 = new rawAggregateData_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.rawAggregateDatas, object2);
            return object2;
          case "assetReset":
            object2 = new assetReset_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.assetResets, object2);
            return object2;
          case "inspiredLogin":
            object2 = new inspiredLogin_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.inspiredLogins, object2);
            return object2;
          case "dataUnit":
            object2 = new dataUnit_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataUnits, object2);
            return object2;
          case "itemMetadata":
            object2 = new itemMetadata_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.itemMetadatas, object2);
            return object2;
          case "bounceEmail":
            object2 = new bounceEmail_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.bounceEmails, object2);
            return object2;
          case "dataFileImport":
            object2 = new dataFileImport_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataFileImports, object2);
            return object2;
          case "dataFileImportLog":
            object2 = new dataFileImportLog_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataFileImportLogs, object2);
            return object2;
          case "dataFileImportUpload":
            object2 = new dataFileImportUpload_1.default(this.dataService, createObject);
            object2 = this.dataService.mergeIntoList(this.dataService.dataFileImportUploads, object2);
            return object2;
          default:
            return null;
        }
      }
    };
    exports2.default = SocketService;
  }
});

// ../gridduck/dist/gridduck.js
var require_gridduck = __commonJS({
  "../gridduck/dist/gridduck.js"(exports2, module2) {
    "use strict";
    var __awaiter = exports2 && exports2.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    var events_1 = __importDefault(require_events());
    var new_aggregateTelemetry_1 = __importDefault(require_new_aggregateTelemetry());
    var new_aggregateTelemetryGroupRequest_1 = __importDefault(require_new_aggregateTelemetryGroupRequest());
    var new_application_1 = __importDefault(require_new_application());
    var new_asset_1 = __importDefault(require_new_asset());
    var new_assetAggregateDataRequest_1 = __importDefault(require_new_assetAggregateDataRequest());
    var new_assetGod_1 = __importDefault(require_new_assetGod());
    var new_assetIdentification_1 = __importDefault(require_new_assetIdentification());
    var new_assetRemoveDataRequest_1 = __importDefault(require_new_assetRemoveDataRequest());
    var new_assetReset_1 = __importDefault(require_new_assetReset());
    var new_audit_1 = __importDefault(require_new_audit());
    var new_calculatorInbound_1 = __importDefault(require_new_calculatorInbound());
    var new_calculatorResult_1 = __importDefault(require_new_calculatorResult());
    var new_confirmOrgInvite_1 = __importDefault(require_new_confirmOrgInvite());
    var new_createReport_1 = __importDefault(require_new_createReport());
    var new_customField_1 = __importDefault(require_new_customField());
    var new_customFieldType_1 = __importDefault(require_new_customFieldType());
    var new_dataCategory_1 = __importDefault(require_new_dataCategory());
    var new_dataFileImport_1 = __importDefault(require_new_dataFileImport());
    var new_dataFileImportUpload_1 = __importDefault(require_new_dataFileImportUpload());
    var new_dataRequest_1 = __importDefault(require_new_dataRequest());
    var new_dataRequestLink_1 = __importDefault(require_new_dataRequestLink());
    var new_dataRequestRun_1 = __importDefault(require_new_dataRequestRun());
    var new_dataType_1 = __importDefault(require_new_dataType());
    var new_dataUnit_1 = __importDefault(require_new_dataUnit());
    var new_dataUpload_1 = __importDefault(require_new_dataUpload());
    var new_dcCreateAccount_1 = __importDefault(require_new_dcCreateAccount());
    var new_dcRetryPayment_1 = __importDefault(require_new_dcRetryPayment());
    var new_dcSession_1 = __importDefault(require_new_dcSession());
    var new_deviceCategory_1 = __importDefault(require_new_deviceCategory());
    var new_file_1 = __importDefault(require_new_file());
    var new_gaiaMessage_1 = __importDefault(require_new_gaiaMessage());
    var new_gateway_1 = __importDefault(require_new_gateway());
    var new_gatewayEnhancedLogDownloadRequest_1 = __importDefault(require_new_gatewayEnhancedLogDownloadRequest());
    var new_gatewayGod_1 = __importDefault(require_new_gatewayGod());
    var new_gatewayLogDownloadRequest_1 = __importDefault(require_new_gatewayLogDownloadRequest());
    var new_gatewayTrustedDeviceAnalysis_1 = __importDefault(require_new_gatewayTrustedDeviceAnalysis());
    var new_gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require_new_gatewayTrustedDeviceUntrustRequest());
    var new_getPhaseBreakdown_1 = __importDefault(require_new_getPhaseBreakdown());
    var new_group_1 = __importDefault(require_new_group());
    var new_groupType_1 = __importDefault(require_new_groupType());
    var new_inspiredLogin_1 = __importDefault(require_new_inspiredLogin());
    var new_instantaneousTelemetry_1 = __importDefault(require_new_instantaneousTelemetry());
    var new_invoiceRequest_1 = __importDefault(require_new_invoiceRequest());
    var new_invoiceRequestLink_1 = __importDefault(require_new_invoiceRequestLink());
    var new_location_1 = __importDefault(require_new_location());
    var new_loginAs_1 = __importDefault(require_new_loginAs());
    var new_loginAsPartner_1 = __importDefault(require_new_loginAsPartner());
    var new_mfaAuthentication_1 = __importDefault(require_new_mfaAuthentication());
    var new_mfaSecret_1 = __importDefault(require_new_mfaSecret());
    var new_mfaVerification_1 = __importDefault(require_new_mfaVerification());
    var new_modbusModel_1 = __importDefault(require_new_modbusModel());
    var new_occupancySchedule_1 = __importDefault(require_new_occupancySchedule());
    var new_order_1 = __importDefault(require_new_order());
    var new_orgPartner_1 = __importDefault(require_new_orgPartner());
    var new_organisationInvite_1 = __importDefault(require_new_organisationInvite());
    var new_password_1 = __importDefault(require_new_password());
    var new_paymentCard_1 = __importDefault(require_new_paymentCard());
    var new_paymentSheet_1 = __importDefault(require_new_paymentSheet());
    var new_physicalGateway_1 = __importDefault(require_new_physicalGateway());
    var new_pubOrg_1 = __importDefault(require_new_pubOrg());
    var new_report_1 = __importDefault(require_new_report());
    var new_reportFileLink_1 = __importDefault(require_new_reportFileLink());
    var new_requestSecret_1 = __importDefault(require_new_requestSecret());
    var new_resetSecret_1 = __importDefault(require_new_resetSecret());
    var new_resetToken_1 = __importDefault(require_new_resetToken());
    var new_rule_1 = __importDefault(require_new_rule());
    var new_searchHistory_1 = __importDefault(require_new_searchHistory());
    var new_session_1 = __importDefault(require_new_session());
    var new_site_1 = __importDefault(require_new_site());
    var new_siteGroup_1 = __importDefault(require_new_siteGroup());
    var new_sitePermission_1 = __importDefault(require_new_sitePermission());
    var new_stripeSession_1 = __importDefault(require_new_stripeSession());
    var new_stripeWebhook_1 = __importDefault(require_new_stripeWebhook());
    var new_tariff_1 = __importDefault(require_new_tariff());
    var new_thirdPartyIntegration_1 = __importDefault(require_new_thirdPartyIntegration());
    var new_widgetBoard_1 = __importDefault(require_new_widgetBoard());
    var new_zapierWebhook_1 = __importDefault(require_new_zapierWebhook());
    var new_zip_1 = __importDefault(require_new_zip());
    var api_service_1 = __importDefault(require_api_service());
    var data_service_1 = __importDefault(require_data_service());
    var socket_service_1 = __importDefault(require_socket_service());
    var Gridduck = class extends events_1.default.EventEmitter {
      constructor() {
        super();
        this._config = { apiKey: "", apiSecret: "", type: "", scopes: [] };
        this.apiService = new api_service_1.default(this._config);
        this.dataService = new data_service_1.default(this.apiService, this);
        this.socketService = new socket_service_1.default(this.dataService, this.apiService);
      }
      set config(value) {
        this._config = value;
        this.apiService.config = value;
      }
      get config() {
        return this._config;
      }
      get userId() {
        if (this._config && this._config.accessToken && this._config.accessToken.user) {
          return this._config.accessToken.user.id;
        }
        return null;
      }
      login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
          return this.apiService.login(username, password);
        });
      }
      logout() {
        return this.apiService.logout();
      }
      abortAllRequests(reason) {
        this.apiService.cancel(reason);
      }
      submitMFA(mfaString) {
        return __awaiter(this, void 0, void 0, function* () {
          return this.apiService.submitMFA(mfaString);
        });
      }
      getAccessToken() {
        return this._config.accessToken;
      }
      setAccessToken(accessToken) {
        this._config.accessToken = accessToken;
        this.apiService.config = this._config;
        return this.apiService.checkAccessToken();
      }
      onLoggedOut(callback) {
        this.apiService.onLoggedOut(callback);
      }
      onLostConnection(callback) {
        this.apiService.onLostConnection(callback);
      }
      onOpenConnectionCallback(callback) {
        this.apiService.onOpenConnectionCallback(callback);
      }
      deleteAccessToken() {
        this._config.accessToken = void 0;
        this.apiService.config = this._config;
      }
      getAssets(params) {
        return this.dataService.getAssets(params);
      }
      getAsset(params) {
        return this.dataService.getAsset(params);
      }
      createAsset(newItem) {
        return this.dataService.createAsset(new new_asset_1.default(newItem));
      }
      getGateways(params) {
        return this.dataService.getGateways(params);
      }
      getGateway(params) {
        return this.dataService.getGateway(params);
      }
      createGateway(newItem) {
        return this.dataService.createGateway(new new_gateway_1.default(newItem));
      }
      getGatewaySoftwareVersions(params) {
        return this.dataService.getGatewaySoftwareVersions(params);
      }
      getGatewaySoftwareVersion(params) {
        return this.dataService.getGatewaySoftwareVersion(params);
      }
      getSites(params) {
        return this.dataService.getSites(params);
      }
      getSite(params) {
        return this.dataService.getSite(params);
      }
      createSite(newItem) {
        return this.dataService.createSite(new new_site_1.default(newItem));
      }
      getOrders(params) {
        return this.dataService.getOrders(params);
      }
      createOrder(newItem) {
        return this.dataService.createOrder(new new_order_1.default(newItem));
      }
      getSessions(params) {
        return this.dataService.getSessions(params);
      }
      getSession(params) {
        return this.dataService.getSession(params);
      }
      createSession(newItem) {
        return this.dataService.createSession(new new_session_1.default(newItem));
      }
      getDiscounts(params) {
        return this.dataService.getDiscounts(params);
      }
      createStripeSession(newItem) {
        return this.dataService.createStripeSession(new new_stripeSession_1.default(newItem));
      }
      createStripeWebhook(newItem) {
        return this.dataService.createStripeWebhook(new new_stripeWebhook_1.default(newItem));
      }
      createZapierWebhook(newItem) {
        return this.dataService.createZapierWebhook(new new_zapierWebhook_1.default(newItem));
      }
      getPlacess(params) {
        return this.dataService.getPlacess(params);
      }
      getPlaces(params) {
        return this.dataService.getPlaces(params);
      }
      getProducts(params) {
        return this.dataService.getProducts(params);
      }
      getModbusModels(params) {
        return this.dataService.getModbusModels(params);
      }
      getModbusModel(params) {
        return this.dataService.getModbusModel(params);
      }
      createModbusModel(newItem) {
        return this.dataService.createModbusModel(new new_modbusModel_1.default(newItem));
      }
      getOccupancySchedules(params) {
        return this.dataService.getOccupancySchedules(params);
      }
      getOccupancySchedule(params) {
        return this.dataService.getOccupancySchedule(params);
      }
      createOccupancySchedule(newItem) {
        return this.dataService.createOccupancySchedule(new new_occupancySchedule_1.default(newItem));
      }
      createPubOrg(newItem) {
        return this.dataService.createPubOrg(new new_pubOrg_1.default(newItem));
      }
      getOrganisation(params) {
        return this.dataService.getOrganisation(params);
      }
      getPaymentCards(params) {
        return this.dataService.getPaymentCards(params);
      }
      getPaymentCard(params) {
        return this.dataService.getPaymentCard(params);
      }
      createPaymentCard(newItem) {
        return this.dataService.createPaymentCard(new new_paymentCard_1.default(newItem));
      }
      getAssetEvents(params) {
        return this.dataService.getAssetEvents(params);
      }
      getGatewayEvents(params) {
        return this.dataService.getGatewayEvents(params);
      }
      getAssetTelemetrys(params) {
        return this.dataService.getAssetTelemetrys(params);
      }
      getRules(params) {
        return this.dataService.getRules(params);
      }
      getRule(params) {
        return this.dataService.getRule(params);
      }
      createRule(newItem) {
        return this.dataService.createRule(new new_rule_1.default(newItem));
      }
      getDataRequests(params) {
        return this.dataService.getDataRequests(params);
      }
      getDataRequest(params) {
        return this.dataService.getDataRequest(params);
      }
      createDataRequest(newItem) {
        return this.dataService.createDataRequest(new new_dataRequest_1.default(newItem));
      }
      createDataRequestLink(newItem) {
        return this.dataService.createDataRequestLink(new new_dataRequestLink_1.default(newItem));
      }
      createDataRequestRun(newItem) {
        return this.dataService.createDataRequestRun(new new_dataRequestRun_1.default(newItem));
      }
      getInvoiceRequests(params) {
        return this.dataService.getInvoiceRequests(params);
      }
      getInvoiceRequest(params) {
        return this.dataService.getInvoiceRequest(params);
      }
      createInvoiceRequest(newItem) {
        return this.dataService.createInvoiceRequest(new new_invoiceRequest_1.default(newItem));
      }
      createInvoiceRequestLink(newItem) {
        return this.dataService.createInvoiceRequestLink(new new_invoiceRequestLink_1.default(newItem));
      }
      getSiteGroups(params) {
        return this.dataService.getSiteGroups(params);
      }
      getSiteGroup(params) {
        return this.dataService.getSiteGroup(params);
      }
      createSiteGroup(newItem) {
        return this.dataService.createSiteGroup(new new_siteGroup_1.default(newItem));
      }
      getGroups(params) {
        return this.dataService.getGroups(params);
      }
      getGroup(params) {
        return this.dataService.getGroup(params);
      }
      createGroup(newItem) {
        return this.dataService.createGroup(new new_group_1.default(newItem));
      }
      getDuckChargeAdmins(params) {
        return this.dataService.getDuckChargeAdmins(params);
      }
      getCustomFieldTypes(params) {
        return this.dataService.getCustomFieldTypes(params);
      }
      createCustomFieldType(newItem) {
        return this.dataService.createCustomFieldType(new new_customFieldType_1.default(newItem));
      }
      getCustomFields(params) {
        return this.dataService.getCustomFields(params);
      }
      createCustomField(newItem) {
        return this.dataService.createCustomField(new new_customField_1.default(newItem));
      }
      getLocations(params) {
        return this.dataService.getLocations(params);
      }
      createLocation(newItem) {
        return this.dataService.createLocation(new new_location_1.default(newItem));
      }
      getSearchHistorys(params) {
        return this.dataService.getSearchHistorys(params);
      }
      createSearchHistory(newItem) {
        return this.dataService.createSearchHistory(new new_searchHistory_1.default(newItem));
      }
      getTariffs(params) {
        return this.dataService.getTariffs(params);
      }
      getTariff(params) {
        return this.dataService.getTariff(params);
      }
      createTariff(newItem) {
        return this.dataService.createTariff(new new_tariff_1.default(newItem));
      }
      getGroupTypes(params) {
        return this.dataService.getGroupTypes(params);
      }
      createGroupType(newItem) {
        return this.dataService.createGroupType(new new_groupType_1.default(newItem));
      }
      createCalculatorInbound(newItem) {
        return this.dataService.createCalculatorInbound(new new_calculatorInbound_1.default(newItem));
      }
      createCalculatorResult(newItem) {
        return this.dataService.createCalculatorResult(new new_calculatorResult_1.default(newItem));
      }
      createCreateReport(newItem) {
        return this.dataService.createCreateReport(new new_createReport_1.default(newItem));
      }
      getReportHistorys(params) {
        return this.dataService.getReportHistorys(params);
      }
      getReports(params) {
        return this.dataService.getReports(params);
      }
      getReport(params) {
        return this.dataService.getReport(params);
      }
      createReport(newItem) {
        return this.dataService.createReport(new new_report_1.default(newItem));
      }
      getReportFiles(params) {
        return this.dataService.getReportFiles(params);
      }
      getGaiaConversations(params) {
        return this.dataService.getGaiaConversations(params);
      }
      getGaiaConversation(params) {
        return this.dataService.getGaiaConversation(params);
      }
      getGaiaMessages(params) {
        return this.dataService.getGaiaMessages(params);
      }
      createGaiaMessage(newItem) {
        return this.dataService.createGaiaMessage(new new_gaiaMessage_1.default(newItem));
      }
      getDataCategorys(params) {
        return this.dataService.getDataCategorys(params);
      }
      getDataCategory(params) {
        return this.dataService.getDataCategory(params);
      }
      createDataCategory(newItem) {
        return this.dataService.createDataCategory(new new_dataCategory_1.default(newItem));
      }
      getDataTypes(params) {
        return this.dataService.getDataTypes(params);
      }
      getDataType(params) {
        return this.dataService.getDataType(params);
      }
      createDataType(newItem) {
        return this.dataService.createDataType(new new_dataType_1.default(newItem));
      }
      getDeviceCategorys(params) {
        return this.dataService.getDeviceCategorys(params);
      }
      createDeviceCategory(newItem) {
        return this.dataService.createDeviceCategory(new new_deviceCategory_1.default(newItem));
      }
      getWidgetBoard(params) {
        return this.dataService.getWidgetBoard(params);
      }
      createWidgetBoard(newItem) {
        return this.dataService.createWidgetBoard(new new_widgetBoard_1.default(newItem));
      }
      createReportFileLink(newItem) {
        return this.dataService.createReportFileLink(new new_reportFileLink_1.default(newItem));
      }
      getRuleEvents(params) {
        return this.dataService.getRuleEvents(params);
      }
      getAudits(params) {
        return this.dataService.getAudits(params);
      }
      getAudit(params) {
        return this.dataService.getAudit(params);
      }
      createAudit(newItem) {
        return this.dataService.createAudit(new new_audit_1.default(newItem));
      }
      getApplications(params) {
        return this.dataService.getApplications(params);
      }
      getApplication(params) {
        return this.dataService.getApplication(params);
      }
      createApplication(newItem) {
        return this.dataService.createApplication(new new_application_1.default(newItem));
      }
      getAnomalyModels(params) {
        return this.dataService.getAnomalyModels(params);
      }
      getAnomalyModel(params) {
        return this.dataService.getAnomalyModel(params);
      }
      getAnomalys(params) {
        return this.dataService.getAnomalys(params);
      }
      getAnomaly(params) {
        return this.dataService.getAnomaly(params);
      }
      getGridduckSubscriptions(params) {
        return this.dataService.getGridduckSubscriptions(params);
      }
      getGridduckInvoices(params) {
        return this.dataService.getGridduckInvoices(params);
      }
      getAccounts(params) {
        return this.dataService.getAccounts(params);
      }
      getAccount(params) {
        return this.dataService.getAccount(params);
      }
      getCustomFieldDatas(params) {
        return this.dataService.getCustomFieldDatas(params);
      }
      getPreferences(params) {
        return this.dataService.getPreferences(params);
      }
      createDcRetryPayment(newItem) {
        return this.dataService.createDcRetryPayment(new new_dcRetryPayment_1.default(newItem));
      }
      getIssues(params) {
        return this.dataService.getIssues(params);
      }
      getIgnoredDevices(params) {
        return this.dataService.getIgnoredDevices(params);
      }
      createResetSecret(newItem) {
        return this.dataService.createResetSecret(new new_resetSecret_1.default(newItem));
      }
      createRequestSecret(newItem) {
        return this.dataService.createRequestSecret(new new_requestSecret_1.default(newItem));
      }
      createAssetIdentification(newItem) {
        return this.dataService.createAssetIdentification(new new_assetIdentification_1.default(newItem));
      }
      createGetPhaseBreakdown(newItem) {
        return this.dataService.createGetPhaseBreakdown(new new_getPhaseBreakdown_1.default(newItem));
      }
      getAvailableGateways(params) {
        return this.dataService.getAvailableGateways(params);
      }
      getAssetDemands(params) {
        return this.dataService.getAssetDemands(params);
      }
      getAssetConsumptions(params) {
        return this.dataService.getAssetConsumptions(params);
      }
      getPhysicalGateway(params) {
        return this.dataService.getPhysicalGateway(params);
      }
      createPhysicalGateway(newItem) {
        return this.dataService.createPhysicalGateway(new new_physicalGateway_1.default(newItem));
      }
      getSitePermissions(params) {
        return this.dataService.getSitePermissions(params);
      }
      createSitePermission(newItem) {
        return this.dataService.createSitePermission(new new_sitePermission_1.default(newItem));
      }
      getApplianceCategorys(params) {
        return this.dataService.getApplianceCategorys(params);
      }
      getApplianceTypes(params) {
        return this.dataService.getApplianceTypes(params);
      }
      getDataUploads(params) {
        return this.dataService.getDataUploads(params);
      }
      getDataUpload(params) {
        return this.dataService.getDataUpload(params);
      }
      createDataUpload(newItem, onUploadProgress) {
        return this.dataService.createDataUpload(new new_dataUpload_1.default(newItem), onUploadProgress);
      }
      getFiles(params) {
        return this.dataService.getFiles(params);
      }
      createFile(newItem, onUploadProgress) {
        return this.dataService.createFile(new new_file_1.default(newItem), onUploadProgress);
      }
      createZip(newItem) {
        return this.dataService.createZip(new new_zip_1.default(newItem));
      }
      getSearchs(params) {
        return this.dataService.getSearchs(params);
      }
      getVerifyOrgInvite(params) {
        return this.dataService.getVerifyOrgInvite(params);
      }
      createConfirmOrgInvite(newItem) {
        return this.dataService.createConfirmOrgInvite(new new_confirmOrgInvite_1.default(newItem));
      }
      createDcCreateAccount(newItem) {
        return this.dataService.createDcCreateAccount(new new_dcCreateAccount_1.default(newItem));
      }
      getDcSessions(params) {
        return this.dataService.getDcSessions(params);
      }
      getDcSession(params) {
        return this.dataService.getDcSession(params);
      }
      createDcSession(newItem) {
        return this.dataService.createDcSession(new new_dcSession_1.default(newItem));
      }
      createPaymentSheet(newItem) {
        return this.dataService.createPaymentSheet(new new_paymentSheet_1.default(newItem));
      }
      getDcChargePoint(params) {
        return this.dataService.getDcChargePoint(params);
      }
      getDcChargeStations(params) {
        return this.dataService.getDcChargeStations(params);
      }
      getOrganisationInvites(params) {
        return this.dataService.getOrganisationInvites(params);
      }
      createOrganisationInvite(newItem) {
        return this.dataService.createOrganisationInvite(new new_organisationInvite_1.default(newItem));
      }
      getOrganisationMembers(params) {
        return this.dataService.getOrganisationMembers(params);
      }
      getDetectedDevices(params) {
        return this.dataService.getDetectedDevices(params);
      }
      getResetToken(params) {
        return this.dataService.getResetToken(params);
      }
      createResetToken(newItem) {
        return this.dataService.createResetToken(new new_resetToken_1.default(newItem));
      }
      createPassword(newItem) {
        return this.dataService.createPassword(new new_password_1.default(newItem));
      }
      getThirdPartyIntegrations(params) {
        return this.dataService.getThirdPartyIntegrations(params);
      }
      createThirdPartyIntegration(newItem) {
        return this.dataService.createThirdPartyIntegration(new new_thirdPartyIntegration_1.default(newItem));
      }
      getOrgPartners(params) {
        return this.dataService.getOrgPartners(params);
      }
      getOrgPartner(params) {
        return this.dataService.getOrgPartner(params);
      }
      createOrgPartner(newItem) {
        return this.dataService.createOrgPartner(new new_orgPartner_1.default(newItem));
      }
      createMfaSecret(newItem) {
        return this.dataService.createMfaSecret(new new_mfaSecret_1.default(newItem));
      }
      createMfaVerification(newItem) {
        return this.dataService.createMfaVerification(new new_mfaVerification_1.default(newItem));
      }
      createMfaAuthentication(newItem) {
        return this.dataService.createMfaAuthentication(new new_mfaAuthentication_1.default(newItem));
      }
      createLoginAs(newItem) {
        return this.dataService.createLoginAs(new new_loginAs_1.default(newItem));
      }
      createLoginAsPartner(newItem) {
        return this.dataService.createLoginAsPartner(new new_loginAsPartner_1.default(newItem));
      }
      getOrganisationManagements(params) {
        return this.dataService.getOrganisationManagements(params);
      }
      getOrganisationManagement(params) {
        return this.dataService.getOrganisationManagement(params);
      }
      getStagingDatabase(params) {
        return this.dataService.getStagingDatabase(params);
      }
      getNotifications(params) {
        return this.dataService.getNotifications(params);
      }
      getZigbeeFirmwares(params) {
        return this.dataService.getZigbeeFirmwares(params);
      }
      getZigbeeFirmware(params) {
        return this.dataService.getZigbeeFirmware(params);
      }
      getGatewayTrustList(params) {
        return this.dataService.getGatewayTrustList(params);
      }
      createGatewayTrustedDeviceUntrustRequest(newItem) {
        return this.dataService.createGatewayTrustedDeviceUntrustRequest(new new_gatewayTrustedDeviceUntrustRequest_1.default(newItem));
      }
      getTelemetryOperations(params) {
        return this.dataService.getTelemetryOperations(params);
      }
      createAggregateTelemetryGroupRequest(newItem) {
        return this.dataService.createAggregateTelemetryGroupRequest(new new_aggregateTelemetryGroupRequest_1.default(newItem));
      }
      createAssetRemoveDataRequest(newItem) {
        return this.dataService.createAssetRemoveDataRequest(new new_assetRemoveDataRequest_1.default(newItem));
      }
      createAssetAggregateDataRequest(newItem) {
        return this.dataService.createAssetAggregateDataRequest(new new_assetAggregateDataRequest_1.default(newItem));
      }
      getGatewayTrustedDeviceAnalysiss(params) {
        return this.dataService.getGatewayTrustedDeviceAnalysiss(params);
      }
      getGatewayTrustedDeviceAnalysis(params) {
        return this.dataService.getGatewayTrustedDeviceAnalysis(params);
      }
      createGatewayTrustedDeviceAnalysis(newItem) {
        return this.dataService.createGatewayTrustedDeviceAnalysis(new new_gatewayTrustedDeviceAnalysis_1.default(newItem));
      }
      getAggregateTelemetrys(params) {
        return this.dataService.getAggregateTelemetrys(params);
      }
      getAggregateTelemetry(params) {
        return this.dataService.getAggregateTelemetry(params);
      }
      createAggregateTelemetry(newItem) {
        return this.dataService.createAggregateTelemetry(new new_aggregateTelemetry_1.default(newItem));
      }
      getInstantaneousTelemetrys(params) {
        return this.dataService.getInstantaneousTelemetrys(params);
      }
      getInstantaneousTelemetry(params) {
        return this.dataService.getInstantaneousTelemetry(params);
      }
      createInstantaneousTelemetry(newItem) {
        return this.dataService.createInstantaneousTelemetry(new new_instantaneousTelemetry_1.default(newItem));
      }
      getOrganisationSearchs(params) {
        return this.dataService.getOrganisationSearchs(params);
      }
      createGatewayLogDownloadRequest(newItem) {
        return this.dataService.createGatewayLogDownloadRequest(new new_gatewayLogDownloadRequest_1.default(newItem));
      }
      createGatewayEnhancedLogDownloadRequest(newItem) {
        return this.dataService.createGatewayEnhancedLogDownloadRequest(new new_gatewayEnhancedLogDownloadRequest_1.default(newItem));
      }
      getGatewayGods(params) {
        return this.dataService.getGatewayGods(params);
      }
      getGatewayGod(params) {
        return this.dataService.getGatewayGod(params);
      }
      createGatewayGod(newItem) {
        return this.dataService.createGatewayGod(new new_gatewayGod_1.default(newItem));
      }
      getAssetGods(params) {
        return this.dataService.getAssetGods(params);
      }
      getAssetGod(params) {
        return this.dataService.getAssetGod(params);
      }
      createAssetGod(newItem) {
        return this.dataService.createAssetGod(new new_assetGod_1.default(newItem));
      }
      getAssetTelemetryBatchs(params) {
        return this.dataService.getAssetTelemetryBatchs(params);
      }
      getAssetConsumptionBatchs(params) {
        return this.dataService.getAssetConsumptionBatchs(params);
      }
      getRawAggregateDatas(params) {
        return this.dataService.getRawAggregateDatas(params);
      }
      getAssetResets(params) {
        return this.dataService.getAssetResets(params);
      }
      createAssetReset(newItem) {
        return this.dataService.createAssetReset(new new_assetReset_1.default(newItem));
      }
      createInspiredLogin(newItem) {
        return this.dataService.createInspiredLogin(new new_inspiredLogin_1.default(newItem));
      }
      getDataUnits(params) {
        return this.dataService.getDataUnits(params);
      }
      getDataUnit(params) {
        return this.dataService.getDataUnit(params);
      }
      createDataUnit(newItem) {
        return this.dataService.createDataUnit(new new_dataUnit_1.default(newItem));
      }
      getItemMetadata(params) {
        return this.dataService.getItemMetadata(params);
      }
      getBounceEmails(params) {
        return this.dataService.getBounceEmails(params);
      }
      getDataFileImports(params) {
        return this.dataService.getDataFileImports(params);
      }
      getDataFileImport(params) {
        return this.dataService.getDataFileImport(params);
      }
      createDataFileImport(newItem) {
        return this.dataService.createDataFileImport(new new_dataFileImport_1.default(newItem));
      }
      getDataFileImportLogs(params) {
        return this.dataService.getDataFileImportLogs(params);
      }
      createDataFileImportUpload(newItem) {
        return this.dataService.createDataFileImportUpload(new new_dataFileImportUpload_1.default(newItem));
      }
      getAvailableScopes() {
        return [
          "god",
          "asset:view",
          "asset:admin",
          "asset:edit",
          "gateway:view",
          "gateway:admin",
          "gateway:edit",
          "gateway-software-version:view",
          "gateway-software-version:edit",
          "site:view",
          "site:admin",
          "site:edit",
          "order:view",
          "order:admin",
          "session:view",
          "session:admin",
          "session:edit",
          "discount:view",
          "stripe-session:admin",
          "stripe-webhook:admin",
          "zapier-webhook:admin",
          "places:view",
          "product:view",
          "modbus-model:view",
          "modbus-model:admin",
          "modbus-model:edit",
          "occupancy-schedule:view",
          "occupancy-schedule:admin",
          "occupancy-schedule:edit",
          "pub-org:admin",
          "organisation:view",
          "organisation:edit",
          "payment-card:view",
          "payment-card:admin",
          "payment-card:edit",
          "asset-event:view",
          "gateway-event:view",
          "asset-telemetry:view",
          "rule:view",
          "rule:admin",
          "rule:edit",
          "data-request:view",
          "data-request:admin",
          "data-request:edit",
          "data-request-link:admin",
          "data-request-run:admin",
          "invoice-request:view",
          "invoice-request:admin",
          "invoice-request-link:admin",
          "site-group:view",
          "site-group:admin",
          "site-group:edit",
          "group:view",
          "group:admin",
          "group:edit",
          "duck-charge-admin:view",
          "custom-field-type:view",
          "custom-field-type:admin",
          "custom-field-type:edit",
          "custom-field:view",
          "custom-field:admin",
          "custom-field:edit",
          "location:view",
          "location:admin",
          "location:edit",
          "search-history:view",
          "search-history:admin",
          "tariff:view",
          "tariff:admin",
          "tariff:edit",
          "group-type:view",
          "group-type:admin",
          "group-type:edit",
          "calculator-inbound:admin",
          "calculator-result:admin",
          "create-report:admin",
          "report-history:view",
          "report:view",
          "report:admin",
          "report:edit",
          "report-file:view",
          "gaia-conversation:view",
          "gaia-conversation:admin",
          "gaia-conversation:edit",
          "gaia-message:view",
          "gaia-message:admin",
          "data-category:view",
          "data-category:admin",
          "data-category:edit",
          "data-type:view",
          "data-type:admin",
          "data-type:edit",
          "device-category:view",
          "device-category:admin",
          "device-category:edit",
          "widget-board:view",
          "widget-board:admin",
          "widget-board:edit",
          "report-file-link:admin",
          "rule-event:view",
          "audit:view",
          "audit:admin",
          "application:view",
          "application:admin",
          "anomaly-model:view",
          "anomaly:view",
          "anomaly:edit",
          "gridduck-subscription:view",
          "gridduck-invoice:view",
          "account:view",
          "account:edit",
          "custom-field-data:view",
          "preferences:view",
          "preferences:edit",
          "dc-retry-payment:admin",
          "issue:view",
          "ignored-device:view",
          "reset-secret:admin",
          "request-secret:admin",
          "asset-identification:admin",
          "get-phase-breakdown:admin",
          "available-gateway:view",
          "available-gateway:edit",
          "asset-demand:view",
          "asset-consumption:view",
          "physical-gateway:view",
          "physical-gateway:admin",
          "physical-gateway:edit",
          "site-permission:view",
          "site-permission:admin",
          "site-permission:edit",
          "appliance-category:view",
          "appliance-type:view",
          "data-upload:view",
          "data-upload:admin",
          "data-upload:edit",
          "file:view",
          "file:admin",
          "file:edit",
          "zip:admin",
          "search:view",
          "verify-org-invite:view",
          "confirm-org-invite:admin",
          "dc-create-account:admin",
          "dc-session:view",
          "dc-session:admin",
          "payment-sheet:admin",
          "dc-charge-point:view",
          "dc-charge-station:view",
          "organisation-invite:view",
          "organisation-invite:admin",
          "organisation-invite:edit",
          "organisation-member:view",
          "organisation-member:admin",
          "organisation-member:edit",
          "organisation-member-logout:admin",
          "detected-device:view",
          "detected-device:edit",
          "reset-token:view",
          "reset-token:admin",
          "reset-token:edit",
          "password:admin",
          "third-party-integration:view",
          "third-party-integration:admin",
          "org-partner:view",
          "org-partner:admin",
          "org-partner:edit",
          "mfa-secret:admin",
          "mfa-verification:admin",
          "mfa-authentication:admin",
          "login-as:admin",
          "login-as-partner:admin",
          "organisation-management:view",
          "organisation-management:edit",
          "staging-database:view",
          "staging-database:edit",
          "notification:view",
          "notification:edit",
          "zigbee-firmware:view",
          "gateway-trust-list:view",
          "gateway-trusted-device-untrust-request:admin",
          "telemetry-operation:view",
          "aggregate-telemetry-group-request:admin",
          "asset-remove-data-request:admin",
          "asset-aggregate-data-request:admin",
          "gateway-trusted-device-analysis:view",
          "gateway-trusted-device-analysis:admin",
          "gateway-trusted-device-analysis:edit",
          "aggregate-telemetry:view",
          "aggregate-telemetry:admin",
          "aggregate-telemetry:edit",
          "instantaneous-telemetry:view",
          "instantaneous-telemetry:admin",
          "instantaneous-telemetry:edit",
          "organisation-search:view",
          "gateway-log-download-request:admin",
          "gateway-enhanced-log-download-request:admin",
          "gateway-god:view",
          "gateway-god:admin",
          "gateway-god:edit",
          "asset-god:view",
          "asset-god:admin",
          "asset-god:edit",
          "asset-telemetry-batch:view",
          "asset-consumption-batch:view",
          "raw-aggregate-data:view",
          "asset-reset:view",
          "asset-reset:admin",
          "asset-reset:edit",
          "inspired-login:admin",
          "data-unit:view",
          "data-unit:admin",
          "data-unit:edit",
          "item-metadata:view",
          "bounce-email:view",
          "bounce-email:admin",
          "data-file-import:view",
          "data-file-import:admin",
          "data-file-import:edit",
          "data-file-import-log:view",
          "data-file-import-upload:admin"
        ];
      }
      getPublicAvailableScopes() {
        return [
          "asset:view",
          "asset:admin",
          "asset:edit",
          "gateway:view",
          "gateway:admin",
          "gateway:edit",
          "site:view",
          "site:admin",
          "site:edit",
          "data-request:view",
          "data-request:admin",
          "data-request:edit",
          "data-request-link:admin",
          "data-request-run:admin",
          "group:view",
          "group:admin",
          "group:edit",
          "duck-charge-admin:view",
          "location:view",
          "location:admin",
          "location:edit",
          "group-type:view",
          "group-type:admin",
          "group-type:edit",
          "gridduck-invoice:view",
          "aggregate-telemetry:view",
          "aggregate-telemetry:admin",
          "aggregate-telemetry:edit",
          "instantaneous-telemetry:view",
          "instantaneous-telemetry:admin",
          "instantaneous-telemetry:edit",
          "asset-telemetry-batch:view",
          "data-file-import:view",
          "data-file-import:admin",
          "data-file-import:edit",
          "data-file-import-log:view",
          "data-file-import-upload:admin"
        ];
      }
    };
    module2.exports = new Gridduck();
  }
});

// src/index.js
var LineGraph = require_lineGraph();
var BarChart = require_barChart();
var AssetBreakdown = require_assetBreakdown();
var Anomaly = require_anomaly();
var AnomalyModel = require_anomalyModel();
var Heatmap = require_heatmap();
var GridDuck;
var scopesWanted = [
  "site:view",
  "site:edit",
  "site:admin",
  "asset:view",
  "asset:boost_snooze",
  "asset:edit",
  "asset:admin",
  "timeswitch:view",
  "timeswitch:edit",
  "timeswitch:admin",
  "group:view",
  "group:edit",
  "group:admin",
  "sensor:view",
  "sensor:edit",
  "sensor:admin",
  "gateway:view",
  "gateway:edit",
  "gateway:admin",
  "organisation:view",
  "organisation:edit",
  "organisation:admin",
  "god"
];
var GDGraphs = class {
  constructor() {
  }
  config(params) {
    if (!params.accessToken && !params.gridduckJS) {
      return console.error("No access token or GridDuckJS Instance");
    }
    if (params.gridduckJS) {
      GridDuck = params.gridduckJS;
      return;
    } else {
      GridDuck = require_gridduck();
    }
    const CLIENT_ID = "da0741d3-a163-4d32-bea7-93c177bdaf61";
    const CLIENT_SECRET = "gridduck";
    let GDConfig = {
      apiKey: CLIENT_ID,
      apiSecret: CLIENT_SECRET,
      type: "password",
      scopes: scopesWanted,
      baseUrl: params.baseUrl ? params.baseUrl : "https://v2.api.gridduck.com/"
    };
    GridDuck.config = GDConfig;
    GridDuck.setAccessToken({ token: params.accessToken }).catch(function(err) {
      console.error("set access token error", err);
    });
  }
  lineGraph(params) {
    return new LineGraph(GridDuck, params);
  }
  barChart(params) {
    return new BarChart(GridDuck, params);
  }
  assetBreakdown(params) {
    return new AssetBreakdown(GridDuck, params);
  }
  anomaly(params) {
    return new Anomaly(GridDuck, params);
  }
  anomalyModel(params) {
    return new AnomalyModel(GridDuck, params);
  }
  heatmap(params) {
    return new Heatmap(GridDuck, params);
  }
};
module.exports = new GDGraphs();
/*! Bundled license information:

moment/moment.js:
  (*! moment.js *)
  (*! version : 2.30.1 *)
  (*! authors : Tim Wood, Iskren Chernev, Moment.js contributors *)
  (*! license : MIT *)
  (*! momentjs.com *)

moment-timezone/moment-timezone.js:
  (*! moment-timezone.js *)
  (*! version : 0.5.48 *)
  (*! Copyright (c) JS Foundation and other contributors *)
  (*! license : MIT *)
  (*! github.com/moment/moment-timezone *)

axios/dist/browser/axios.cjs:
  (*! Axios v1.18.0 Copyright (c) 2026 Matt Zabriskie and contributors *)
*/
